// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lHxdD":[function(require,module,exports,__globalThis) {
//Entry file into all index
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _vue = require("vue");
var _loginFormVue = require("./components/LoginForm.vue");
var _loginFormVueDefault = parcelHelpers.interopDefault(_loginFormVue);
var _passwordResetFormVue = require("./components/PasswordResetForm.vue");
var _passwordResetFormVueDefault = parcelHelpers.interopDefault(_passwordResetFormVue);
var _dispatchDashboardVue = require("./components/DispatchDashboard.vue");
var _dispatchDashboardVueDefault = parcelHelpers.interopDefault(_dispatchDashboardVue);
var _adminDashboardVue = require("./components/AdminDashboard.vue");
var _adminDashboardVueDefault = parcelHelpers.interopDefault(_adminDashboardVue);
var _serviceProviderDetailVue = require("./components/ServiceProviderDetail.vue");
var _serviceProviderDetailVueDefault = parcelHelpers.interopDefault(_serviceProviderDetailVue);
var _serviceConfigurationVue = require("./components/ServiceConfiguration.vue");
var _serviceConfigurationVueDefault = parcelHelpers.interopDefault(_serviceConfigurationVue);
var _userProfileVue = require("./components/UserProfile.vue");
var _userProfileVueDefault = parcelHelpers.interopDefault(_userProfileVue);
var _dispatchCallHandlerVue = require("./components/DispatchCallHandler.vue");
var _dispatchCallHandlerVueDefault = parcelHelpers.interopDefault(_dispatchCallHandlerVue);
var _callHistoryNotificationVue = require("./components/CallHistoryNotification.vue");
var _callHistoryNotificationVueDefault = parcelHelpers.interopDefault(_callHistoryNotificationVue);
var _allServiceProviderRidesVue = require("./components/AllServiceProviderRides.vue");
var _allServiceProviderRidesVueDefault = parcelHelpers.interopDefault(_allServiceProviderRidesVue);
var _rideDetailVue = require("./components/RideDetail.vue");
var _rideDetailVueDefault = parcelHelpers.interopDefault(_rideDetailVue);
var _driverDetailVue = require("./components/DriverDetail.vue");
var _driverDetailVueDefault = parcelHelpers.interopDefault(_driverDetailVue);
var _dispatchUserDetailVue = require("./components/DispatchUserDetail.vue");
var _dispatchUserDetailVueDefault = parcelHelpers.interopDefault(_dispatchUserDetailVue);
var _allServiceProviderDriversVue = require("./components/AllServiceProviderDrivers.vue");
var _allServiceProviderDriversVueDefault = parcelHelpers.interopDefault(_allServiceProviderDriversVue);
var _allServiceProviderDispatchUsersVue = require("./components/AllServiceProviderDispatchUsers.vue");
var _allServiceProviderDispatchUsersVueDefault = parcelHelpers.interopDefault(_allServiceProviderDispatchUsersVue);
var _dispatchUserOnboardingFormVue = require("./components/DispatchUserOnboardingForm.vue");
var _dispatchUserOnboardingFormVueDefault = parcelHelpers.interopDefault(_dispatchUserOnboardingFormVue);
var _driverUserOnboardingFormVue = require("./components/DriverUserOnboardingForm.vue");
var _driverUserOnboardingFormVueDefault = parcelHelpers.interopDefault(_driverUserOnboardingFormVue);
var _geoZonesVue = require("./components/GeoZones.vue");
var _geoZonesVueDefault = parcelHelpers.interopDefault(_geoZonesVue);
var _geoZoneDetailVue = require("./components/GeoZoneDetail.vue");
var _geoZoneDetailVueDefault = parcelHelpers.interopDefault(_geoZoneDetailVue);
var _driverPublicProfileVue = require("./components/DriverPublicProfile.vue");
var _driverPublicProfileVueDefault = parcelHelpers.interopDefault(_driverPublicProfileVue);
var _driverVehicleLicenseManagementVue = require("./components/DriverVehicleLicenseManagement.vue");
var _driverVehicleLicenseManagementVueDefault = parcelHelpers.interopDefault(_driverVehicleLicenseManagementVue);
var _driverSubscriptionManagementVue = require("./components/DriverSubscriptionManagement.vue");
var _driverSubscriptionManagementVueDefault = parcelHelpers.interopDefault(_driverSubscriptionManagementVue);
var _dashboardMetricsVue = require("./components/DashboardMetrics.vue");
var _dashboardMetricsVueDefault = parcelHelpers.interopDefault(_dashboardMetricsVue);
var _accountsListVue = require("./components/AccountsList.vue");
var _accountsListVueDefault = parcelHelpers.interopDefault(_accountsListVue);
var _accountDetailVue = require("./components/AccountDetail.vue");
var _accountDetailVueDefault = parcelHelpers.interopDefault(_accountDetailVue);
var _allIndependentDriversVue = require("./components/AllIndependentDrivers.vue");
var _allIndependentDriversVueDefault = parcelHelpers.interopDefault(_allIndependentDriversVue);
var _independentDriverSignupFormVue = require("./components/IndependentDriverSignupForm.vue");
var _independentDriverSignupFormVueDefault = parcelHelpers.interopDefault(_independentDriverSignupFormVue);
var _serviceJurisdictionsVue = require("./components/ServiceJurisdictions.vue");
var _serviceJurisdictionsVueDefault = parcelHelpers.interopDefault(_serviceJurisdictionsVue);
var _serviceJurisdictionDetailVue = require("./components/ServiceJurisdictionDetail.vue");
var _serviceJurisdictionDetailVueDefault = parcelHelpers.interopDefault(_serviceJurisdictionDetailVue);
var _driverApplicationStatusVue = require("./components/DriverApplicationStatus.vue");
var _driverApplicationStatusVueDefault = parcelHelpers.interopDefault(_driverApplicationStatusVue);
var _sharedRideStatusVue = require("./components/SharedRideStatus.vue");
var _sharedRideStatusVueDefault = parcelHelpers.interopDefault(_sharedRideStatusVue);
var _portalChooserVue = require("./components/PortalChooser.vue");
var _portalChooserVueDefault = parcelHelpers.interopDefault(_portalChooserVue);
var _riderWaitlistPortalVue = require("./components/RiderWaitlistPortal.vue");
var _riderWaitlistPortalVueDefault = parcelHelpers.interopDefault(_riderWaitlistPortalVue);
var _riderWaitlistStatusVue = require("./components/RiderWaitlistStatus.vue");
var _riderWaitlistStatusVueDefault = parcelHelpers.interopDefault(_riderWaitlistStatusVue);
var _driverLoginVue = require("./components/DriverLogin.vue");
var _driverLoginVueDefault = parcelHelpers.interopDefault(_driverLoginVue);
var _shiftsVue = require("./components/Shifts.vue");
var _shiftsVueDefault = parcelHelpers.interopDefault(_shiftsVue);
var _shiftDetailVue = require("./components/ShiftDetail.vue");
var _shiftDetailVueDefault = parcelHelpers.interopDefault(_shiftDetailVue);
var _shiftsCalendarVue = require("./components/ShiftsCalendar.vue");
var _shiftsCalendarVueDefault = parcelHelpers.interopDefault(_shiftsCalendarVue);
var _taxReserveVue = require("./components/TaxReserve.vue");
var _taxReserveVueDefault = parcelHelpers.interopDefault(_taxReserveVue);
var _driverTaxRegistrationsVue = require("./components/DriverTaxRegistrations.vue");
var _driverTaxRegistrationsVueDefault = parcelHelpers.interopDefault(_driverTaxRegistrationsVue);
var _insuranceExposureReportVue = require("./components/InsuranceExposureReport.vue");
var _insuranceExposureReportVueDefault = parcelHelpers.interopDefault(_insuranceExposureReportVue);
var _reserveDashboardVue = require("./components/ReserveDashboard.vue");
var _reserveDashboardVueDefault = parcelHelpers.interopDefault(_reserveDashboardVue);
var _walletsVue = require("./components/Wallets.vue");
var _walletsVueDefault = parcelHelpers.interopDefault(_walletsVue);
var _walletDetailVue = require("./components/WalletDetail.vue");
var _walletDetailVueDefault = parcelHelpers.interopDefault(_walletDetailVue);
var _walletApprovalQueueVue = require("./components/WalletApprovalQueue.vue");
var _walletApprovalQueueVueDefault = parcelHelpers.interopDefault(_walletApprovalQueueVue);
// Sidebar script
var _sidebarJs = require("../extras/js/sidebar.js");
var _sidebarScrollJs = require("../extras/js/scrollbar/sidebar-scroll.js");
var _heightEqualJs = require("../extras/js/height-equal.js");
var _password = require("../extras/js/password");
// Custom script
var _scriptJs = require("../extras/js/script.js");
window.Vue = {
    createApp: (0, _vue.createApp),
    LoginForm: (0, _loginFormVueDefault.default),
    PasswordResetForm: (0, _passwordResetFormVueDefault.default),
    DispatchDashboard: (0, _dispatchDashboardVueDefault.default),
    AdminDashboard: (0, _adminDashboardVueDefault.default),
    ServiceProviderDetail: (0, _serviceProviderDetailVueDefault.default),
    ServiceConfiguration: (0, _serviceConfigurationVueDefault.default),
    UserProfile: (0, _userProfileVueDefault.default),
    DispatchCallHandler: (0, _dispatchCallHandlerVueDefault.default),
    CallHistoryNotification: (0, _callHistoryNotificationVueDefault.default),
    AllServiceProviderRides: (0, _allServiceProviderRidesVueDefault.default),
    RideDetail: (0, _rideDetailVueDefault.default),
    DispatchUserDetail: (0, _dispatchUserDetailVueDefault.default),
    DriverDetail: (0, _driverDetailVueDefault.default),
    AllServiceProviderDrivers: (0, _allServiceProviderDriversVueDefault.default),
    AllServiceProviderDispatchUsers: (0, _allServiceProviderDispatchUsersVueDefault.default),
    DispatchUserOnboardingForm: (0, _dispatchUserOnboardingFormVueDefault.default),
    DriverUserOnboardingForm: (0, _driverUserOnboardingFormVueDefault.default),
    GeoZones: (0, _geoZonesVueDefault.default),
    GeoZoneDetail: (0, _geoZoneDetailVueDefault.default),
    DriverPublicProfile: (0, _driverPublicProfileVueDefault.default),
    DriverVehicleLicenseManagement: (0, _driverVehicleLicenseManagementVueDefault.default),
    DriverSubscriptionManagement: (0, _driverSubscriptionManagementVueDefault.default),
    DashboardMetrics: (0, _dashboardMetricsVueDefault.default),
    AccountsList: (0, _accountsListVueDefault.default),
    AccountDetail: (0, _accountDetailVueDefault.default),
    AllIndependentDrivers: (0, _allIndependentDriversVueDefault.default),
    IndependentDriverSignupForm: (0, _independentDriverSignupFormVueDefault.default),
    ServiceJurisdictions: (0, _serviceJurisdictionsVueDefault.default),
    ServiceJurisdictionDetail: (0, _serviceJurisdictionDetailVueDefault.default),
    DriverApplicationStatus: (0, _driverApplicationStatusVueDefault.default),
    SharedRideStatus: (0, _sharedRideStatusVueDefault.default),
    PortalChooser: (0, _portalChooserVueDefault.default),
    RiderWaitlistPortal: (0, _riderWaitlistPortalVueDefault.default),
    RiderWaitlistStatus: (0, _riderWaitlistStatusVueDefault.default),
    DriverLogin: (0, _driverLoginVueDefault.default),
    Shifts: (0, _shiftsVueDefault.default),
    ShiftDetail: (0, _shiftDetailVueDefault.default),
    ShiftsCalendar: (0, _shiftsCalendarVueDefault.default),
    TaxReserve: (0, _taxReserveVueDefault.default),
    DriverTaxRegistrations: (0, _driverTaxRegistrationsVueDefault.default),
    InsuranceExposureReport: (0, _insuranceExposureReportVueDefault.default),
    ReserveDashboard: (0, _reserveDashboardVueDefault.default),
    Wallets: (0, _walletsVueDefault.default),
    WalletDetail: (0, _walletDetailVueDefault.default),
    WalletApprovalQueue: (0, _walletApprovalQueueVueDefault.default)
};
// Auto-mount any component declared via data-vue-component / data-vue-props attributes
document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('[data-vue-component]').forEach((el)=>{
        const name = el.dataset.vueComponent;
        const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {};
        const component = window.Vue[name];
        if (!component) return;
        (0, _vue.createApp)(component, props).mount(el);
    });
});

},{"vue":"dylud","./components/LoginForm.vue":"gWi60","./components/PasswordResetForm.vue":"inYgz","./components/DispatchDashboard.vue":"fZPUT","./components/AdminDashboard.vue":"7o6Mk","./components/ServiceProviderDetail.vue":"26UnC","./components/ServiceConfiguration.vue":"ey6IG","./components/UserProfile.vue":"4kVbo","./components/DispatchCallHandler.vue":"8NEYM","./components/CallHistoryNotification.vue":"eZvZc","./components/AllServiceProviderRides.vue":"3zxDP","./components/RideDetail.vue":"1PEuf","./components/DriverDetail.vue":"5drVj","./components/DispatchUserDetail.vue":"fhi3i","./components/AllServiceProviderDrivers.vue":"fRtVP","./components/AllServiceProviderDispatchUsers.vue":"lSIUZ","./components/DispatchUserOnboardingForm.vue":"gsZUY","./components/DriverUserOnboardingForm.vue":"dMfZc","./components/GeoZones.vue":"dzLSH","./components/GeoZoneDetail.vue":"52RNz","./components/DriverPublicProfile.vue":"l3gS7","./components/DriverVehicleLicenseManagement.vue":"fqqaS","./components/DriverSubscriptionManagement.vue":"k8Iiy","./components/DashboardMetrics.vue":"dd26H","./components/AccountsList.vue":"hs2HS","./components/AccountDetail.vue":"1mi4U","./components/AllIndependentDrivers.vue":"k2lKK","./components/IndependentDriverSignupForm.vue":"2ZU4T","./components/ServiceJurisdictions.vue":"gkajR","./components/ServiceJurisdictionDetail.vue":"27YIX","./components/DriverApplicationStatus.vue":"ggjkB","./components/SharedRideStatus.vue":"fDOP1","./components/PortalChooser.vue":"3o4wU","./components/RiderWaitlistPortal.vue":"6c9b0","./components/RiderWaitlistStatus.vue":"eRS4z","./components/DriverLogin.vue":"4jN94","./components/Shifts.vue":"cNKxK","./components/ShiftDetail.vue":"f8hgJ","./components/ShiftsCalendar.vue":"h6LoC","./components/TaxReserve.vue":"3zL5K","./components/DriverTaxRegistrations.vue":"aku6Y","./components/InsuranceExposureReport.vue":"6KLVS","./components/ReserveDashboard.vue":"jPc6l","./components/Wallets.vue":"2tYXX","./components/WalletDetail.vue":"2ki5u","./components/WalletApprovalQueue.vue":"ft7SA","../extras/js/sidebar.js":"7DQpv","../extras/js/scrollbar/sidebar-scroll.js":"8MCnn","../extras/js/height-equal.js":"9UxPA","../extras/js/password":"ck5pf","../extras/js/script.js":"s6sMc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dylud":[function(require,module,exports,__globalThis) {
/**
* vue v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>compileToFunction);
var _runtimeDom = require("@vue/runtime-dom");
parcelHelpers.exportAll(_runtimeDom, exports);
var _compilerDom = require("@vue/compiler-dom");
var _shared = require("@vue/shared");
function initDev() {
    (0, _runtimeDom.initCustomFormatter)();
}
const compileCache = /* @__PURE__ */ new WeakMap();
function getCache(options) {
    let c = compileCache.get(options != null ? options : (0, _shared.EMPTY_OBJ));
    if (!c) {
        c = /* @__PURE__ */ Object.create(null);
        compileCache.set(options != null ? options : (0, _shared.EMPTY_OBJ), c);
    }
    return c;
}
function compileToFunction(template, options) {
    if (!(0, _shared.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, _shared.NOOP;
    }
    const key = template;
    const cache = getCache(options);
    const cached = cache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, _shared.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, _shared.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code } = (0, _compilerDom.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, _shared.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, _runtimeDom.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)(_runtimeDom);
    render._rc = true;
    return cache[key] = render;
}
(0, _runtimeDom.registerRuntimeCompiler)(compileToFunction);

},{"@vue/runtime-dom":"lgHax","@vue/compiler-dom":"OsNOm","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgHax":[function(require,module,exports,__globalThis) {
/**
* @vue/runtime-dom v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "TransitionGroup", ()=>TransitionGroup);
parcelHelpers.export(exports, "VueElement", ()=>VueElement);
parcelHelpers.export(exports, "createApp", ()=>createApp);
parcelHelpers.export(exports, "createSSRApp", ()=>createSSRApp);
parcelHelpers.export(exports, "defineCustomElement", ()=>defineCustomElement);
parcelHelpers.export(exports, "defineSSRCustomElement", ()=>defineSSRCustomElement);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "initDirectivesForSSR", ()=>initDirectivesForSSR);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "useCssModule", ()=>useCssModule);
parcelHelpers.export(exports, "useCssVars", ()=>useCssVars);
parcelHelpers.export(exports, "useHost", ()=>useHost);
parcelHelpers.export(exports, "useShadowRoot", ()=>useShadowRoot);
parcelHelpers.export(exports, "vModelCheckbox", ()=>vModelCheckbox);
parcelHelpers.export(exports, "vModelDynamic", ()=>vModelDynamic);
parcelHelpers.export(exports, "vModelRadio", ()=>vModelRadio);
parcelHelpers.export(exports, "vModelSelect", ()=>vModelSelect);
parcelHelpers.export(exports, "vModelText", ()=>vModelText);
parcelHelpers.export(exports, "vShow", ()=>vShow);
parcelHelpers.export(exports, "withKeys", ()=>withKeys);
parcelHelpers.export(exports, "withModifiers", ()=>withModifiers);
var _runtimeCore = require("@vue/runtime-core");
parcelHelpers.exportAll(_runtimeCore, exports);
var _shared = require("@vue/shared");
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const unsafeToTrustedHTML = policy ? (val)=>policy.createHTML(val) : (val)=>val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, {
            is
        }) : doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>doc.createTextNode(text),
    createComment: (text)=>doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            templateContainer.innerHTML = unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = Symbol("_vtc");
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = /* @__PURE__ */ (0, _shared.extend)({}, (0, _runtimeCore.BaseTransitionPropsValidators), DOMTransitionPropsValidators);
const decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
};
const Transition = /* @__PURE__ */ decorate$1((props, { slots })=>(0, _runtimeCore.h)((0, _runtimeCore.BaseTransition), resolveTransitionProps(props), slots));
const callHook = (hook, args = [])=>{
    if ((0, _shared.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const hasExplicitCallback = (hook)=>{
    return hook ? (0, _shared.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            callHook(hook, [
                el,
                resolve
            ]);
            nextFrame(()=>{
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, _shared.extend)(baseProps, {
        onBeforeEnter (el) {
            callHook(onBeforeEnter, [
                el
            ]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            callHook(onBeforeAppear, [
                el
            ]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            addTransitionClass(el, leaveActiveClass);
            forceReflow();
            nextFrame(()=>{
                if (!el._isLeaving) return;
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, _shared.isObject)(duration)) return [
        NumberOf(duration.enter),
        NumberOf(duration.leave)
    ];
    else {
        const n = NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function NumberOf(val) {
    const res = (0, _shared.toNumber)(val);
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[vtcKey] = void 0;
    }
}
function nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${TRANSITION}Property`).toString());
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>toMs(d) + toMs(delays[i])));
}
function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
    return document.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
    beforeMount (el, { value }, { transition }) {
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else setDisplay(el, value);
    },
    mounted (el, { value }, { transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value, oldValue }, { transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                setDisplay(el, false);
            });
        } else setDisplay(el, value);
    },
    beforeUnmount (el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = ({ value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const CSS_VAR_TEXT = Symbol("");
function useCssVars(getter) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) setVarsOnNode(instance.ce, vars);
        else setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, _runtimeCore.onBeforeMount)(()=>{
        (0, _runtimeCore.watchPostEffect)(setVars);
    });
    (0, _runtimeCore.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, _runtimeCore.onUnmounted)(()=>ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, _runtimeCore.Fragment)) vnode.children.forEach((c)=>setVarsOnVNode(c, vars));
    else if (vnode.type === (0, _runtimeCore.Static)) {
        let { el, anchor } = vnode;
        while(el){
            setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, _shared.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, _shared.isString)(prev)) {
                for(const key in prev)if (next[key] == null) setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) style.display = "none";
    }
}
const semicolonRE = /[^\\];\s*$/;
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0, _shared.isArray)(val)) val.forEach((v)=>setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) style.setProperty((0, _shared.hyphenate)(prefixed), val.replace(importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) return cached;
    let name = (0, _runtimeCore.camelize)(rawName);
    if (name !== "filter" && name in style) return prefixCache[rawName] = name;
    name = (0, _shared.capitalize)(name);
    for(let i = 0; i < prefixes.length; i++){
        const prefixed = prefixes[i] + name;
        if (prefixed in style) return prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = (0, _shared.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS(xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, _shared.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, _shared.isSymbol)(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, _shared.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = createInvoker(nextValue, instance);
            addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match(optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, _shared.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = ()=>cachedNow || (p.then(()=>cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, _runtimeCore.callWithAsyncErrorHandling)(patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if ((0, _shared.isFunction)(value) || (0, _shared.isArray)(value)) return value;
    (0, _runtimeCore.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, _shared.NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if ((0, _shared.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") patchClass(el, nextValue, isSVG);
    else if (key === "style") patchStyle(el, prevValue, nextValue);
    else if ((0, _shared.isOn)(key)) {
        if (!(0, _shared.isModelListener)(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && isNativeOn(key) && (0, _shared.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if (isNativeOn(key) && (0, _shared.isString)(value)) return false;
    if (key in el) return true;
    if (el._isVueCE && (/[A-Z]/.test(key) || !(0, _shared.isString)(value))) return true;
    return false;
}
const REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineCustomElement(options, extraOptions, _createApp) {
    const Comp = (0, _runtimeCore.defineComponent)(options, extraOptions);
    if ((0, _shared.isPlainObject)(Comp)) (0, _shared.extend)(Comp, extraOptions);
    class VueCustomElement extends VueElement {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ defineCustomElement(options, extraOptions, createSSRApp);
};
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
    constructor(_def, _props = {}, _createApp = createApp){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== createApp) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, _runtimeCore.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props, styles } = def;
            let numberProps;
            if (props && !(0, _shared.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, _shared.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, _shared.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, _shared.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, _runtimeCore.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props } = def;
        const declaredPropKeys = (0, _shared.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, _shared.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : REMOVAL;
        const camelKey = (0, _shared.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, _shared.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, _shared.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, _shared.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, _shared.hyphenate)(key));
            }
        }
    }
    _update() {
        render(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, _runtimeCore.createVNode)(this._def, (0, _shared.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, _shared.isPlainObject)(args[0]) ? (0, _shared.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, _shared.hyphenate)(event) !== event) dispatch((0, _shared.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function useHost(caller) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, _runtimeCore.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, _runtimeCore.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function useShadowRoot() {
    const el = useHost();
    return el && el.shadowRoot;
}
function useCssModule(name = "$style") {
    {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        if (!instance) return 0, _shared.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, _shared.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, _shared.EMPTY_OBJ;
        return mod;
    }
}
const positionMap = /* @__PURE__ */ new WeakMap();
const newPositionMap = /* @__PURE__ */ new WeakMap();
const moveCbKey = Symbol("_moveCb");
const enterCbKey = Symbol("_enterCb");
const decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const TransitionGroupImpl = /* @__PURE__ */ decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, _shared.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots }) {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        const state = (0, _runtimeCore.useTransitionState)();
        let prevChildren;
        let children;
        (0, _runtimeCore.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, _runtimeCore.toRaw)(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, _runtimeCore.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, _runtimeCore.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, _runtimeCore.createVNode)(tag, null, children);
        };
    }
});
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) el[moveCbKey]();
    if (el[enterCbKey]) el[enterCbKey]();
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, _shared.isArray)(fn) ? (value)=>(0, _shared.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const assignKey = Symbol("_assign");
const vModelText = {
    created (el, { modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, _shared.looseToNumber)(domValue);
            el[assignKey](domValue);
        });
        if (trim) addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, _shared.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if ((0, _shared.isArray)(modelValue)) {
                const index = (0, _shared.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, _shared.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign(getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, _shared.isArray)(value)) checked = (0, _shared.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, _shared.isSet)(value)) checked = value.has(vnode.props.value);
    else checked = (0, _shared.looseEqual)(value, getCheckboxValue(el, true));
    if (el.checked !== checked) el.checked = checked;
}
const vModelRadio = {
    created (el, { value }, vnode) {
        el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate (el, { value, oldValue }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0, _shared.isSet)(value);
        addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, _shared.looseToNumber)(getValue(o)) : getValue(o));
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, _runtimeCore.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value, modifiers: { number } }) {
        setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated (el, { value, modifiers: { number } }) {
        if (!el._assigning) setSelected(el, value);
    }
};
function setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, _shared.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, _shared.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, _shared.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, _shared.looseEqual)(getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch(type){
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value })=>({
            value
        });
    vModelRadio.getSSRProps = ({ value }, vnode)=>{
        if (vnode.props && (0, _shared.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode)=>{
        if ((0, _shared.isArray)(value)) {
            if (vnode.props && (0, _shared.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, _shared.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    vModelDynamic.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const withKeys = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, _shared.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || keyNames[k] === eventKey)) return fn(event);
    });
};
const rendererOptions = /* @__PURE__ */ (0, _shared.extend)({
    patchProp
}, nodeOps);
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = (0, _runtimeCore.createRenderer)(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : (0, _runtimeCore.createHydrationRenderer)(rendererOptions);
    enabledHydration = true;
    return renderer;
}
const render = (...args)=>{
    ensureRenderer().render(...args);
};
const hydrate = (...args)=>{
    ensureHydrationRenderer().hydrate(...args);
};
const createApp = (...args)=>{
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, _shared.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const createSSRApp = (...args)=>{
    const app = ensureHydrationRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, resolveRootNamespace(container));
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if ((0, _runtimeCore.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, _runtimeCore.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, _runtimeCore.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, _runtimeCore.warn)(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0, _shared.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let ssrDirectiveInitialized = false;
const initDirectivesForSSR = ()=>{
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};

},{"@vue/runtime-core":"jG196","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jG196":[function(require,module,exports,__globalThis) {
/**
* @vue/runtime-core v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>(0, _reactivity.EffectScope));
parcelHelpers.export(exports, "ReactiveEffect", ()=>(0, _reactivity.ReactiveEffect));
parcelHelpers.export(exports, "TrackOpTypes", ()=>(0, _reactivity.TrackOpTypes));
parcelHelpers.export(exports, "TriggerOpTypes", ()=>(0, _reactivity.TriggerOpTypes));
parcelHelpers.export(exports, "customRef", ()=>(0, _reactivity.customRef));
parcelHelpers.export(exports, "effect", ()=>(0, _reactivity.effect));
parcelHelpers.export(exports, "effectScope", ()=>(0, _reactivity.effectScope));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _reactivity.getCurrentScope));
parcelHelpers.export(exports, "getCurrentWatcher", ()=>(0, _reactivity.getCurrentWatcher));
parcelHelpers.export(exports, "isProxy", ()=>(0, _reactivity.isProxy));
parcelHelpers.export(exports, "isReactive", ()=>(0, _reactivity.isReactive));
parcelHelpers.export(exports, "isReadonly", ()=>(0, _reactivity.isReadonly));
parcelHelpers.export(exports, "isRef", ()=>(0, _reactivity.isRef));
parcelHelpers.export(exports, "isShallow", ()=>(0, _reactivity.isShallow));
parcelHelpers.export(exports, "markRaw", ()=>(0, _reactivity.markRaw));
parcelHelpers.export(exports, "onScopeDispose", ()=>(0, _reactivity.onScopeDispose));
parcelHelpers.export(exports, "onWatcherCleanup", ()=>(0, _reactivity.onWatcherCleanup));
parcelHelpers.export(exports, "proxyRefs", ()=>(0, _reactivity.proxyRefs));
parcelHelpers.export(exports, "reactive", ()=>(0, _reactivity.reactive));
parcelHelpers.export(exports, "readonly", ()=>(0, _reactivity.readonly));
parcelHelpers.export(exports, "ref", ()=>(0, _reactivity.ref));
parcelHelpers.export(exports, "shallowReactive", ()=>(0, _reactivity.shallowReactive));
parcelHelpers.export(exports, "shallowReadonly", ()=>(0, _reactivity.shallowReadonly));
parcelHelpers.export(exports, "shallowRef", ()=>(0, _reactivity.shallowRef));
parcelHelpers.export(exports, "stop", ()=>(0, _reactivity.stop));
parcelHelpers.export(exports, "toRaw", ()=>(0, _reactivity.toRaw));
parcelHelpers.export(exports, "toRef", ()=>(0, _reactivity.toRef));
parcelHelpers.export(exports, "toRefs", ()=>(0, _reactivity.toRefs));
parcelHelpers.export(exports, "toValue", ()=>(0, _reactivity.toValue));
parcelHelpers.export(exports, "triggerRef", ()=>(0, _reactivity.triggerRef));
parcelHelpers.export(exports, "unref", ()=>(0, _reactivity.unref));
parcelHelpers.export(exports, "camelize", ()=>(0, _shared.camelize));
parcelHelpers.export(exports, "capitalize", ()=>(0, _shared.capitalize));
parcelHelpers.export(exports, "normalizeClass", ()=>(0, _shared.normalizeClass));
parcelHelpers.export(exports, "normalizeProps", ()=>(0, _shared.normalizeProps));
parcelHelpers.export(exports, "normalizeStyle", ()=>(0, _shared.normalizeStyle));
parcelHelpers.export(exports, "toDisplayString", ()=>(0, _shared.toDisplayString));
parcelHelpers.export(exports, "toHandlerKey", ()=>(0, _shared.toHandlerKey));
parcelHelpers.export(exports, "BaseTransition", ()=>BaseTransition);
parcelHelpers.export(exports, "BaseTransitionPropsValidators", ()=>BaseTransitionPropsValidators);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "DeprecationTypes", ()=>DeprecationTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "ErrorTypeStrings", ()=>ErrorTypeStrings);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "KeepAlive", ()=>KeepAlive);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "Suspense", ()=>Suspense);
parcelHelpers.export(exports, "Teleport", ()=>Teleport);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "assertNumber", ()=>assertNumber);
parcelHelpers.export(exports, "callWithAsyncErrorHandling", ()=>callWithAsyncErrorHandling);
parcelHelpers.export(exports, "callWithErrorHandling", ()=>callWithErrorHandling);
parcelHelpers.export(exports, "cloneVNode", ()=>cloneVNode);
parcelHelpers.export(exports, "compatUtils", ()=>compatUtils);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "createBlock", ()=>createBlock);
parcelHelpers.export(exports, "createCommentVNode", ()=>createCommentVNode);
parcelHelpers.export(exports, "createElementBlock", ()=>createElementBlock);
parcelHelpers.export(exports, "createElementVNode", ()=>createBaseVNode);
parcelHelpers.export(exports, "createHydrationRenderer", ()=>createHydrationRenderer);
parcelHelpers.export(exports, "createPropsRestProxy", ()=>createPropsRestProxy);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "createSlots", ()=>createSlots);
parcelHelpers.export(exports, "createStaticVNode", ()=>createStaticVNode);
parcelHelpers.export(exports, "createTextVNode", ()=>createTextVNode);
parcelHelpers.export(exports, "createVNode", ()=>createVNode);
parcelHelpers.export(exports, "defineAsyncComponent", ()=>defineAsyncComponent);
parcelHelpers.export(exports, "defineComponent", ()=>defineComponent);
parcelHelpers.export(exports, "defineEmits", ()=>defineEmits);
parcelHelpers.export(exports, "defineExpose", ()=>defineExpose);
parcelHelpers.export(exports, "defineModel", ()=>defineModel);
parcelHelpers.export(exports, "defineOptions", ()=>defineOptions);
parcelHelpers.export(exports, "defineProps", ()=>defineProps);
parcelHelpers.export(exports, "defineSlots", ()=>defineSlots);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "getCurrentInstance", ()=>getCurrentInstance);
parcelHelpers.export(exports, "getTransitionRawChildren", ()=>getTransitionRawChildren);
parcelHelpers.export(exports, "guardReactiveProps", ()=>guardReactiveProps);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "hasInjectionContext", ()=>hasInjectionContext);
parcelHelpers.export(exports, "hydrateOnIdle", ()=>hydrateOnIdle);
parcelHelpers.export(exports, "hydrateOnInteraction", ()=>hydrateOnInteraction);
parcelHelpers.export(exports, "hydrateOnMediaQuery", ()=>hydrateOnMediaQuery);
parcelHelpers.export(exports, "hydrateOnVisible", ()=>hydrateOnVisible);
parcelHelpers.export(exports, "initCustomFormatter", ()=>initCustomFormatter);
parcelHelpers.export(exports, "inject", ()=>inject);
parcelHelpers.export(exports, "isMemoSame", ()=>isMemoSame);
parcelHelpers.export(exports, "isRuntimeOnly", ()=>isRuntimeOnly);
parcelHelpers.export(exports, "isVNode", ()=>isVNode);
parcelHelpers.export(exports, "mergeDefaults", ()=>mergeDefaults);
parcelHelpers.export(exports, "mergeModels", ()=>mergeModels);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "onActivated", ()=>onActivated);
parcelHelpers.export(exports, "onBeforeMount", ()=>onBeforeMount);
parcelHelpers.export(exports, "onBeforeUnmount", ()=>onBeforeUnmount);
parcelHelpers.export(exports, "onBeforeUpdate", ()=>onBeforeUpdate);
parcelHelpers.export(exports, "onDeactivated", ()=>onDeactivated);
parcelHelpers.export(exports, "onErrorCaptured", ()=>onErrorCaptured);
parcelHelpers.export(exports, "onMounted", ()=>onMounted);
parcelHelpers.export(exports, "onRenderTracked", ()=>onRenderTracked);
parcelHelpers.export(exports, "onRenderTriggered", ()=>onRenderTriggered);
parcelHelpers.export(exports, "onServerPrefetch", ()=>onServerPrefetch);
parcelHelpers.export(exports, "onUnmounted", ()=>onUnmounted);
parcelHelpers.export(exports, "onUpdated", ()=>onUpdated);
parcelHelpers.export(exports, "openBlock", ()=>openBlock);
parcelHelpers.export(exports, "popScopeId", ()=>popScopeId);
parcelHelpers.export(exports, "provide", ()=>provide);
parcelHelpers.export(exports, "pushScopeId", ()=>pushScopeId);
parcelHelpers.export(exports, "queuePostFlushCb", ()=>queuePostFlushCb);
parcelHelpers.export(exports, "registerRuntimeCompiler", ()=>registerRuntimeCompiler);
parcelHelpers.export(exports, "renderList", ()=>renderList);
parcelHelpers.export(exports, "renderSlot", ()=>renderSlot);
parcelHelpers.export(exports, "resolveComponent", ()=>resolveComponent);
parcelHelpers.export(exports, "resolveDirective", ()=>resolveDirective);
parcelHelpers.export(exports, "resolveDynamicComponent", ()=>resolveDynamicComponent);
parcelHelpers.export(exports, "resolveFilter", ()=>resolveFilter);
parcelHelpers.export(exports, "resolveTransitionHooks", ()=>resolveTransitionHooks);
parcelHelpers.export(exports, "setBlockTracking", ()=>setBlockTracking);
parcelHelpers.export(exports, "setDevtoolsHook", ()=>setDevtoolsHook);
parcelHelpers.export(exports, "setTransitionHooks", ()=>setTransitionHooks);
parcelHelpers.export(exports, "ssrContextKey", ()=>ssrContextKey);
parcelHelpers.export(exports, "ssrUtils", ()=>ssrUtils);
parcelHelpers.export(exports, "toHandlers", ()=>toHandlers);
parcelHelpers.export(exports, "transformVNodeArgs", ()=>transformVNodeArgs);
parcelHelpers.export(exports, "useAttrs", ()=>useAttrs);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useModel", ()=>useModel);
parcelHelpers.export(exports, "useSSRContext", ()=>useSSRContext);
parcelHelpers.export(exports, "useSlots", ()=>useSlots);
parcelHelpers.export(exports, "useTemplateRef", ()=>useTemplateRef);
parcelHelpers.export(exports, "useTransitionState", ()=>useTransitionState);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "watch", ()=>watch);
parcelHelpers.export(exports, "watchEffect", ()=>watchEffect);
parcelHelpers.export(exports, "watchPostEffect", ()=>watchPostEffect);
parcelHelpers.export(exports, "watchSyncEffect", ()=>watchSyncEffect);
parcelHelpers.export(exports, "withAsyncContext", ()=>withAsyncContext);
parcelHelpers.export(exports, "withCtx", ()=>withCtx);
parcelHelpers.export(exports, "withDefaults", ()=>withDefaults);
parcelHelpers.export(exports, "withDirectives", ()=>withDirectives);
parcelHelpers.export(exports, "withMemo", ()=>withMemo);
parcelHelpers.export(exports, "withScopeId", ()=>withScopeId);
var _reactivity = require("@vue/reactivity");
var _shared = require("@vue/shared");
const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    (0, _reactivity.pauseTracking)();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) callWithErrorHandling(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode })=>`at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, _reactivity.resetTracking)();
    isWarning = false;
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function formatProp(key, value, raw) {
    if ((0, _shared.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, _reactivity.isRef)(value)) {
        value = formatProp(key, (0, _reactivity.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, _shared.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, _reactivity.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function assertNumber(val, type) {
    return;
}
const ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0, _shared.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0, _shared.isPromise)(res)) res.catch((err)=>{
            handleError(err, instance, type);
        });
        return res;
    }
    if ((0, _shared.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        return values;
    }
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, _shared.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, _reactivity.pauseTracking)();
            callWithErrorHandling(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, _reactivity.resetTracking)();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
let isFlushing = false;
let isFlushPending = false;
const queue = [];
let flushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    let start = isFlushing ? flushIndex + 1 : 0;
    let end = queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = queue[middle];
        const middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = getId(job);
        const lastJob = queue[queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= getId(lastJob)) queue.push(job);
        else queue.splice(findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        queueFlush();
    }
}
function queueFlush() {
    if (!isFlushing && !isFlushPending) {
        isFlushPending = true;
        currentFlushPromise = resolvedPromise.then(flushJobs);
    }
}
function queuePostFlushCb(cb) {
    if (!(0, _shared.isArray)(cb)) {
        if (activePostFlushCbs && cb.id === -1) activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else pendingPostFlushCbs.push(...cb);
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i = isFlushing ? flushIndex + 1 : 0) {
    for(; i < queue.length; i++){
        const cb = queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            cb.flags &= -2;
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set(pendingPostFlushCbs)
        ].sort((a, b)=>getId(a) - getId(b));
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        for(postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++){
            const cb = activePostFlushCbs[postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
    isFlushPending = false;
    isFlushing = true;
    const check = (0, _shared.NOOP);
    try {
        for(flushIndex = 0; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                callWithErrorHandling(job, job.i, job.i ? 15 : 14);
                job.flags &= -2;
            }
        }
    } finally{
        for(; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job) job.flags &= -2;
        }
        flushIndex = 0;
        queue.length = 0;
        flushPostFlushCbs(seen);
        isFlushing = false;
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
    }
}
function checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && getComponentName(instance.type);
        handleError(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Map();
const map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) return false;
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = normalizeClassComponent(instance.type);
        let dirtyInstances = hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) updateComponentDef(oldComp, newComp);
            hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) queueJob(()=>{
            isHmrUpdating = true;
            instance.parent.update();
            isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    queuePostFlushCb(()=>{
        hmrDirtyComponents.clear();
    });
}
function updateComponentDef(oldComp, newComp) {
    (0, _shared.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event, ...args) {
    if (devtools$1) devtools$1.emit(event, ...args);
    else if (!devtoolsNotInstalled) buffer.push({
        event,
        args
    });
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(({ event, args })=>devtools$1.emit(event, ...args));
        buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    } else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const devtoolsComponentRemoved = (component)=>{
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return (component)=>{
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
const withScopeId = (_id)=>withCtx;
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) setBlockTracking(-1);
        const prevInstance = setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) setBlockTracking(1);
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function validateDirectiveName(name) {
    if ((0, _shared.isBuiltInDirective)(name)) warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) return vnode;
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, _shared.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, _shared.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, _reactivity.traverse)(value);
            bindings.push({
                dir,
                instance,
                value,
                oldValue: void 0,
                arg,
                modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, _reactivity.pauseTracking)();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, _reactivity.resetTracking)();
        }
    }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type)=>type.__isTeleport;
const isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, _shared.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { shapeFlag, children, dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = resolveTarget(n2.props, querySelector);
                const targetAnchor = prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        updateCssVars(n2);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                updateCssVars(n2);
            }
            if (isTeleportDeferred(n2.props)) queuePostRenderEffect(mountToTarget, parentSuspense);
            else mountToTarget();
        } else {
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            updateCssVars(n2);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetStart, targetAnchor, target, props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector, insert, createText } }, hydrateChildren) {
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.targetStart;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const leaveCbKey = Symbol("_leaveCb");
const enterCbKey = Symbol("_enterCb");
function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(()=>{
        state.isMounted = true;
    });
    onBeforeUnmount(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [
    Function,
    Array
];
const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        return ()=>{
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) return;
            const child = findNonCommentChild(children);
            const rawProps = (0, _reactivity.toRaw)(props);
            const { mode } = rawProps;
            if (state.isLeaving) return emptyPlaceholder(child);
            const innerChild = getInnerChild$1(child);
            if (!innerChild) return emptyPlaceholder(child);
            let enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== Comment) setTransitionHooks(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && getInnerChild$1(oldChild);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild) && recursiveGetSubtree(instance).type !== Comment) {
                const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                    };
                    return emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== Comment) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[leaveCbKey] = ()=>{
                        earlyRemove();
                        el[leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== Comment) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, _shared.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[leaveCbKey]) el[leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) leavingVNode.el[leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[enterCbKey]) el[enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = resolveTransitionHooks(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
        if (isTeleport(vnode.type) && vnode.children) return findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, _shared.isFunction)(children.default)) return children.default();
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        } else if (keepComment || child.type !== Comment) ret.push(key != null ? cloneVNode(child, {
            key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return (0, _shared.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, _shared.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function useId() {
    const i = getCurrentInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
}
function markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function useTemplateRef(key) {
    const i = getCurrentInstance();
    const r = (0, _reactivity.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, _shared.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, _shared.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>setRef(r, oldRawRef && ((0, _shared.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, _shared.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, _reactivity.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, _shared.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, _shared.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, _shared.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, _reactivity.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, _shared.isFunction)(ref)) callWithErrorHandling(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, _shared.isString)(ref);
        const _isRef = (0, _reactivity.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, _shared.isArray)(existing) && (0, _shared.remove)(existing, refValue);
                    else {
                        if (!(0, _shared.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let hasLoggedMismatchError = false;
const logMismatchError = ()=>{
    if (hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
};
const isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
};
const isComment = (node)=>node.nodeType === 8;
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, createText, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag, patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(node, "__vnode", vnode, true);
            (0, _shared.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case Text:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case Fragment:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if (isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, _shared.isOn)(key) && !(0, _shared.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, _reactivity.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) queueEffectWithSuspense(()=>{
                vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            const isText = vnode.type === Text;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && normalizeVNode(children[i + 1]).type === Text) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, _shared.normalizeClass)(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, _shared.isString)(clientValue) ? clientValue : (0, _shared.stringifyStyle)((0, _shared.normalizeStyle)(clientValue));
        const actualMap = toStyleMap(actual);
        const expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir, value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) resolveCssVars(instance, vnode, expectedMap);
        if (!isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, _shared.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, _shared.isBooleanAttr)(key) || (0, _shared.isKnownHtmlAttr)(key))) {
        if ((0, _shared.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, _shared.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, _shared.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, _shared.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const allowMismatchAttr = "data-allow-mismatch";
const MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute(allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute(allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes(MismatchTypeString[allowedType]);
    }
}
const hydrateOnIdle = (timeout = 1e4)=>(hydrate)=>{
        const id = requestIdleCallback(hydrate, {
            timeout
        });
        return ()=>cancelIdleCallback(id);
    };
const hydrateOnVisible = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>ob.observe(el));
        return ()=>ob.disconnect();
    };
const hydrateOnMediaQuery = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const hydrateOnInteraction = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, _shared.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) cb(next);
            else if (isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if ((0, _shared.isFunction)(source)) source = {
        loader: source
    };
    const { loader, loadingComponent, errorComponent, delay = 200, hydrate: hydrateStrategy, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = currentInstance;
            markAsyncBoundary(instance);
            if (resolvedComp) return ()=>createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, _reactivity.ref)(false);
            const error = (0, _reactivity.ref)();
            const delayed = (0, _reactivity.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return createVNode(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return createVNode(loadingComponent);
            };
        }
    });
}
function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, _shared.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(()=>{
                if (instance2.da) (0, _shared.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) unmount(cached);
            else if (current) resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        watch(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>matches(include, name));
            exclude && pruneCache((name)=>!matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if (isSuspense(instance.subTree.type)) queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(()=>{
            cache.forEach((cached)=>{
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) setTransitionHooks(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0, _shared.isArray)(pattern)) return pattern.some((p)=>matches(p, name));
    else if ((0, _shared.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, _shared.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(()=>{
        (0, _shared.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, _reactivity.pauseTracking)();
            const reset = setCurrentInstance(target);
            const res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            (0, _reactivity.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const createHook = (lifecycle)=>(hook, target = currentInstance)=>{
        if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
}
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if ((0, _shared.isString)(component)) return resolveAsset(COMPONENTS, component, false) || component;
    else return component || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, _shared.camelize)(name) || selfName === (0, _shared.capitalize)((0, _shared.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[(0, _shared.camelize)(name)] || registry[(0, _shared.capitalize)((0, _shared.camelize)(name))]);
}
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, _shared.isArray)(source);
    if (sourceIsArray || (0, _shared.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, _reactivity.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, _reactivity.isShallow)(source);
            source = (0, _reactivity.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, _reactivity.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, _shared.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function createSlots(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, _shared.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return openBlock(), createBlock(Fragment, null, [
            createVNode("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const rendered = createBlock(Fragment, {
        key: (props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!isVNode(child)) return true;
        if (child.type === Comment) return false;
        if (child.type === Fragment && !ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, _shared.toHandlerKey)(key)] = obj[key];
    return ret;
}
const getPublicInstance = (i)=>{
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, _shared.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>getPublicInstance(i.parent),
    $root: (i)=>getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : (0, _shared.NOOP)
});
const isReservedPrefix = (key)=>key === "_" || key === "$";
const hasSetupBinding = (state, key)=>state !== (0, _shared.EMPTY_OBJ) && !state.__isScriptSetup && (0, _shared.hasOwn)(state, key);
const PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, _reactivity.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, _shared.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, _shared.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key) || (0, _shared.hasOwn)(ctx, key) || (0, _shared.hasOwn)(publicPropertiesMap, key) || (0, _shared.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, _shared.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var target;
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, _shared.extend)({}, PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, _shared.isGloballyAllowed)(key);
        return has;
    }
});
function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys(publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, _shared.NOOP)
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, _shared.NOOP)
        });
    });
}
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys((0, _reactivity.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, _shared.NOOP)
            });
        }
    });
}
const warnRuntimeUsage = (method)=>warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function defineProps() {
    return null;
}
function defineEmits() {
    return null;
}
function defineExpose(exposed) {}
function defineOptions(options) {}
function defineSlots() {
    return null;
}
function defineModel() {}
function withDefaults(props, defaults) {
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    const i = getCurrentInstance();
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return (0, _shared.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function mergeDefaults(raw, defaults) {
    const props = normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if ((0, _shared.isArray)(a) && (0, _shared.isArray)(b)) return a.concat(b);
    return (0, _shared.extend)({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if ((0, _shared.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>setCurrentInstance(ctx)
    ];
}
function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, // public API
    expose, inheritAttrs, // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, _shared.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, _shared.isObject)(data)) ;
        else instance.data = (0, _reactivity.reactive)(data);
    }
    shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, _shared.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, _shared.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, _shared.NOOP);
        const set = !(0, _shared.isFunction)(opt) && (0, _shared.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, _shared.NOOP);
        const c = computed({
            get,
            set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, _shared.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            provide(key, provides[key]);
        });
    }
    if (created) callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, _shared.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0, _shared.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, _shared.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) markAsyncBoundary(instance);
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, _shared.NOOP)) {
    if ((0, _shared.isArray)(injectOptions)) injectOptions = normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, _shared.isObject)(opt)) {
            if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
            else injected = inject(opt.from || key);
        } else injected = inject(opt);
        if ((0, _reactivity.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0, _shared.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, _shared.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, _shared.isFunction)(handler)) watch(getter, handler);
    } else if ((0, _shared.isFunction)(raw)) watch(getter, raw.bind(publicThis));
    else if ((0, _shared.isObject)(raw)) {
        if ((0, _shared.isArray)(raw)) raw.forEach((r)=>createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, _shared.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, _shared.isFunction)(handler)) watch(getter, handler, raw);
        }
    } else ;
}
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>mergeOptions(resolved, m, optionMergeStrategies, true));
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, _shared.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, _shared.extend)((0, _shared.isFunction)(to) ? to.call(this, this) : to, (0, _shared.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0, _shared.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, _shared.isArray)(to) && (0, _shared.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, _shared.extend)(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = mergeAsArray(to[key], from[key]);
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, _shared.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, _shared.isFunction)(rootComponent)) rootComponent = (0, _shared.extend)({}, rootComponent);
        if (rootProps != null && !(0, _shared.isObject)(rootProps)) rootProps = null;
        const context = createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, _shared.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, _shared.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    callWithAsyncErrorHandling(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                } finally{
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let currentApp = null;
function provide(key, value) {
    if (!currentInstance) ;
    else {
        let provides = currentInstance.provides;
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
        const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, _shared.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
}
const internalObjectProto = {};
const createInternalObject = ()=>Object.create(internalObjectProto);
const isInternalObject = (obj)=>Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, _reactivity.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = (0, _reactivity.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, _shared.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, _shared.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, _shared.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, _shared.hyphenate)(key)) === key || !(0, _shared.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, _shared.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, _reactivity.trigger)(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, _shared.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, _shared.hasOwn)(options, camelKey = (0, _shared.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, _reactivity.toRaw)(props);
        const castValues = rawCastValues || (0, _shared.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, _shared.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, _shared.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, _shared.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, _shared.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw2, appContext, true);
            (0, _shared.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, (0, _shared.EMPTY_ARR));
        return 0, _shared.EMPTY_ARR;
    }
    if ((0, _shared.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, _shared.camelize)(raw[i]);
        if (validatePropName(normalizedKey)) normalized[normalizedKey] = (0, _shared.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, _shared.camelize)(key);
        if (validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt) ? {
                type: opt
            } : (0, _shared.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, _shared.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, _shared.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, _shared.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, _shared.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, _shared.isObject)(comp)) cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !(0, _shared.isReservedProp)(key)) return true;
    return false;
}
function getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function validateProps(rawProps, props, instance) {
    const resolvedValues = (0, _reactivity.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, _shared.hasOwn)(rawProps, key) && !(0, _shared.hasOwn)(rawProps, (0, _shared.hyphenate)(key)));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    const { type, required, validator, skipCheck } = prop;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, _shared.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const isSimpleType = /* @__PURE__ */ (0, _shared.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") valid = value === null;
    else if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, _shared.isObject)(value);
    else if (expectedType === "Array") valid = (0, _shared.isArray)(value);
    else valid = value instanceof type;
    return {
        valid,
        expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, _shared.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, _shared.toRawType)(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value)=>(0, _shared.isArray)(value) ? value.map(normalizeVNode) : [
        normalizeVNode(value)
    ];
const normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = withCtx((...args)=>{
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if (isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, _shared.isFunction)(value)) slots[key] = normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children)=>{
    const normalized = normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) (0, _shared.def)(slots, "_", type, true);
        } else normalizeObjectSlots(children, slots);
    } else if (children) normalizeVNodeSlots(instance, children);
};
const updateSlots = (instance, children, optimized)=>{
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, _shared.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        perf.mark(endTag);
        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
}
function isSupported() {
    if (supported !== void 0) return supported;
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    } else supported = false;
    return supported;
}
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    initFeatureFlags();
    const target = (0, _shared.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, _shared.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch(type){
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props, shapeFlag, transition, dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, _shared.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(el, "__vnode", vnode, true);
            (0, _shared.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag, dynamicChildren, dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, _shared.EMPTY_OBJ);
        const newProps = n2.props || (0, _shared.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, _shared.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, _shared.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, _shared.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent, root, type } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) (0, _shared.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next, bu, u, parent, vnode } = instance;
                {
                    const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, _shared.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
                toggleRecurse(instance, true);
                const nextTree = renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) updateHOCHostEl(instance, nextTree.el);
                if (u) queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, _reactivity.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>queueJob(job);
        toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        (0, _reactivity.pauseTracking)();
        flushPreFlushCbs(instance);
        (0, _reactivity.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, _shared.EMPTY_ARR);
        c2 = c2 || (0, _shared.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : (0, _shared.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum, scope, job, subTree, um, m, a } = instance;
        invalidateMount(m);
        invalidateMount(a);
        if (bum) (0, _shared.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) queuePostRenderEffect(um, parentSuspense);
        queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs();
            flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, _shared.isArray)(ch1) && (0, _shared.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) c2.el = c1.el;
    }
}
function getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return locateNonHydratedAsyncRoot(subComponent);
    }
}
function invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = ()=>{
    {
        const ctx = inject(ssrContextKey);
        ctx;
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "post"
    });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "sync"
    });
}
function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, flush, once } = options;
    const baseWatchOptions = (0, _shared.extend)({}, options);
    let ssrCleanup;
    if (isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!cb || immediate) baseWatchOptions.once = true;
        else return {
            stop: (0, _shared.NOOP),
            resume: (0, _shared.NOOP),
            pause: (0, _shared.NOOP)
        };
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args)=>callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, _reactivity.watch)(source, cb, baseWatchOptions);
    if (ssrCleanup) ssrCleanup.push(watchHandle);
    return watchHandle;
}
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, _shared.isString)(source) ? source.includes(".") ? createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, _shared.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function useModel(props, name, options = (0, _shared.EMPTY_OBJ)) {
    const i = getCurrentInstance();
    const camelizedName = (0, _shared.camelize)(name);
    const hyphenatedName = (0, _shared.hyphenate)(name);
    const modifiers = getModelModifiers(props, name);
    const res = (0, _reactivity.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, _shared.EMPTY_OBJ);
        let prevEmittedValue;
        watchSyncEffect(()=>{
            const propValue = props[name];
            if ((0, _shared.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, _shared.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, _shared.hasChanged)(value, emittedValue) && (0, _shared.hasChanged)(value, prevSetValue) && !(0, _shared.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, _shared.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, _shared.camelize)(modelName)}Modifiers`] || props[`${(0, _shared.hyphenate)(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, _shared.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, _shared.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, _shared.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, _shared.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, _shared.toHandlerKey)((0, _shared.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, _shared.toHandlerKey)((0, _shared.hyphenate)(event))];
    if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, _shared.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, _shared.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, _shared.extend)(normalized, raw);
    if ((0, _shared.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !(0, _shared.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, _shared.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, _shared.hasOwn)(options, (0, _shared.hyphenate)(key)) || (0, _shared.hasOwn)(options, key);
}
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = normalizeVNode(render2.length > 1 ? render2(props, {
                attrs,
                slots,
                emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, _shared.isModelListener))) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) setTransitionHooks(root, vnode.transition);
    result = root;
    setCurrentRenderingInstance(prev);
    return result;
}
const getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        normalizeVNode(childRoot),
        setRoot
    ];
};
function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, _shared.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, _shared.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const isSuspense = (type)=>type.__isSuspense;
let suspenseId = 0;
const SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
};
const Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, _shared.isFunction)(eventListener)) eventListener();
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        setActiveBranch(suspense, newBranch);
    } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout, pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, _shared.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode,
        parent: parentSuspense,
        parentComponent,
        namespace,
        container,
        hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch, pendingBranch, pendingId, effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        queuePostFlushCb(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) queuePostFlushCb(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                handleError(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0, _shared.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0, _shared.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, _shared.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else queuePostFlushCb(fn);
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || (0, _shared.EMPTY_ARR) : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args)=>{
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
};
const normalizeKey = ({ key })=>key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, _shared.isString)(ref) || (0, _reactivity.isRef)(ref) || (0, _shared.isFunction)(ref) ? {
        i: currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, _shared.isString)(children) ? 8 : 16;
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) currentBlock.push(vnode);
    return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
    if (isVNode(type)) {
        const cloned = cloneVNode(type, props, true);
        if (children) normalizeChildren(cloned, children);
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
            else currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if (isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0, _shared.isString)(klass)) props.class = (0, _shared.normalizeClass)(klass);
        if ((0, _shared.isObject)(style)) {
            if ((0, _reactivity.isProxy)(style) && !(0, _shared.isArray)(style)) style = (0, _shared.extend)({}, style);
            props.style = (0, _shared.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, _shared.isString)(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : (0, _shared.isObject)(type) ? 4 : (0, _shared.isFunction)(type) ? 2 : 0;
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props) return null;
    return (0, _reactivity.isProxy)(props) || isInternalObject(props) ? (0, _shared.extend)({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, _shared.isArray)(ref) ? ref.concat(normalizeRef(extraProps)) : [
            ref,
            normalizeRef(extraProps)
        ] : normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
    return cloned;
}
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if ((0, _shared.isArray)(vnode.children)) cloned.children = vnode.children.map(deepCloneVNode);
    return cloned;
}
function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return createVNode(Comment);
    else if ((0, _shared.isArray)(child)) return createVNode(Fragment, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return cloneIfMounted(child);
    else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, _shared.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, _shared.isFunction)(children)) {
        children = {
            default: children,
            _ctx: currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                createTextVNode(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, _shared.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, _shared.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, _shared.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, _shared.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, _reactivity.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, _shared.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, _shared.EMPTY_OBJ),
        data: (0, _shared.EMPTY_OBJ),
        props: (0, _shared.EMPTY_OBJ),
        attrs: (0, _shared.EMPTY_OBJ),
        slots: (0, _shared.EMPTY_OBJ),
        refs: (0, _shared.EMPTY_OBJ),
        setupState: (0, _shared.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let currentInstance = null;
const getCurrentInstance = ()=>currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
    const g = (0, _shared.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>currentInstance = v1);
    setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>isInSSRComponentSetup = v1);
}const setCurrentInstance = (instance)=>{
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
const unsetCurrentInstance = ()=>{
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
const isBuiltInTag = /* @__PURE__ */ (0, _shared.makeMap)("slot,component");
function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        const setupResult = callWithErrorHandling(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, _reactivity.resetTracking)();
        reset();
        if ((0, _shared.isPromise)(setupResult)) {
            if (!isAsyncWrapper(instance)) markAsyncBoundary(instance);
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                handleError(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else handleSetupResult(instance, setupResult, isSSR);
    } else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0, _shared.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, _shared.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, _reactivity.proxyRefs)(setupResult);
    }
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const isRuntimeOnly = ()=>!compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            const template = Component.template || resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, _shared.extend)((0, _shared.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, _shared.NOOP);
        if (installWithProxy) installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        try {
            applyOptions(instance);
        } finally{
            (0, _reactivity.resetTracking)();
            reset();
        }
    }
}
const attrsProxyHandlers = {
    get (target, key) {
        (0, _reactivity.track)(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, _reactivity.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
    };
}
function getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, _reactivity.proxyRefs)((0, _reactivity.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
    return (0, _shared.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0, _shared.isFunction)(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions)=>{
    const c = (0, _reactivity.computed)(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
};
function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, _shared.isObject)(propsOrChildren) && !(0, _shared.isArray)(propsOrChildren)) {
            if (isVNode(propsOrChildren)) return createVNode(type, null, [
                propsOrChildren
            ]);
            return createVNode(type, propsOrChildren);
        } else return createVNode(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && isVNode(children)) children = [
            children
        ];
        return createVNode(type, propsOrChildren, children);
    }
}
function initCustomFormatter() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, _reactivity.toRaw)(instance.props)));
        if (instance.setupState !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, _reactivity.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, _shared.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, _shared.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, _reactivity.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, _shared.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, _shared.isArray)(opts) && opts.includes(key) || (0, _shared.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, _reactivity.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, _shared.hasChanged)(prev[i], memo[i])) return false;
    }
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(cached);
    return true;
}
const version = "3.5.5";
const warn = (0, _shared.NOOP);
const ErrorTypeStrings = ErrorTypeStrings$1;
const devtools = devtools$1;
const setDevtoolsHook = setDevtoolsHook$1;
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode,
    pushWarningContext,
    popWarningContext
};
const ssrUtils = _ssrUtils;
const resolveFilter = null;
const compatUtils = null;
const DeprecationTypes = null;

},{"@vue/reactivity":"7Rc3Y","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Rc3Y":[function(require,module,exports,__globalThis) {
/**
* @vue/reactivity v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ITERATE_KEY", ()=>ARRAY_ITERATE_KEY);
parcelHelpers.export(exports, "EffectFlags", ()=>EffectFlags);
parcelHelpers.export(exports, "EffectScope", ()=>EffectScope);
parcelHelpers.export(exports, "ITERATE_KEY", ()=>ITERATE_KEY);
parcelHelpers.export(exports, "MAP_KEY_ITERATE_KEY", ()=>MAP_KEY_ITERATE_KEY);
parcelHelpers.export(exports, "ReactiveEffect", ()=>ReactiveEffect);
parcelHelpers.export(exports, "ReactiveFlags", ()=>ReactiveFlags);
parcelHelpers.export(exports, "TrackOpTypes", ()=>TrackOpTypes);
parcelHelpers.export(exports, "TriggerOpTypes", ()=>TriggerOpTypes);
parcelHelpers.export(exports, "WatchErrorCodes", ()=>WatchErrorCodes);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "customRef", ()=>customRef);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "effectScope", ()=>effectScope);
parcelHelpers.export(exports, "enableTracking", ()=>enableTracking);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "getCurrentWatcher", ()=>getCurrentWatcher);
parcelHelpers.export(exports, "isProxy", ()=>isProxy);
parcelHelpers.export(exports, "isReactive", ()=>isReactive);
parcelHelpers.export(exports, "isReadonly", ()=>isReadonly);
parcelHelpers.export(exports, "isRef", ()=>isRef);
parcelHelpers.export(exports, "isShallow", ()=>isShallow);
parcelHelpers.export(exports, "markRaw", ()=>markRaw);
parcelHelpers.export(exports, "onEffectCleanup", ()=>onEffectCleanup);
parcelHelpers.export(exports, "onScopeDispose", ()=>onScopeDispose);
parcelHelpers.export(exports, "onWatcherCleanup", ()=>onWatcherCleanup);
parcelHelpers.export(exports, "pauseTracking", ()=>pauseTracking);
parcelHelpers.export(exports, "proxyRefs", ()=>proxyRefs);
parcelHelpers.export(exports, "reactive", ()=>reactive);
parcelHelpers.export(exports, "reactiveReadArray", ()=>reactiveReadArray);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "resetTracking", ()=>resetTracking);
parcelHelpers.export(exports, "shallowReactive", ()=>shallowReactive);
parcelHelpers.export(exports, "shallowReadArray", ()=>shallowReadArray);
parcelHelpers.export(exports, "shallowReadonly", ()=>shallowReadonly);
parcelHelpers.export(exports, "shallowRef", ()=>shallowRef);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toRaw", ()=>toRaw);
parcelHelpers.export(exports, "toReactive", ()=>toReactive);
parcelHelpers.export(exports, "toReadonly", ()=>toReadonly);
parcelHelpers.export(exports, "toRef", ()=>toRef);
parcelHelpers.export(exports, "toRefs", ()=>toRefs);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "traverse", ()=>traverse);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "triggerRef", ()=>triggerRef);
parcelHelpers.export(exports, "unref", ()=>unref);
parcelHelpers.export(exports, "watch", ()=>watch);
var _shared = require("@vue/shared");
function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally{
                activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
let activeSub;
const EffectFlags = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.nextEffect = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope && activeEffectScope.active) activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if (pausedQueueEffects.has(this)) {
                pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) {
            this.flags |= 8;
            this.nextEffect = batchedEffect;
            batchedEffect = this;
        }
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        cleanupEffect(this);
        prepareDeps(this);
        const prevEffect = activeSub;
        const prevShouldTrack = shouldTrack;
        activeSub = this;
        shouldTrack = true;
        try {
            return this.fn();
        } finally{
            cleanupDeps(this);
            activeSub = prevEffect;
            shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)removeSub(link);
            this.deps = this.depsTail = void 0;
            cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if (isDirty(this)) this.run();
    }
    get dirty() {
        return isDirty(this);
    }
}
let batchDepth = 0;
let batchedEffect;
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    let error;
    while(batchedEffect){
        let e = batchedEffect;
        batchedEffect = void 0;
        while(e){
            const next = e.nextEffect;
            e.nextEffect = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && refreshComputed(link.dep.computed) || link.dep.version !== link.version) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && !isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, _shared.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) dep.subs = prevSub;
    if (!dep.subs && dep.computed) {
        dep.computed.flags &= -5;
        for(let l = dep.computed.deps; l; l = l.nextDep)removeSub(l);
    }
}
function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    const e = new ReactiveEffect(fn);
    if (options) (0, _shared.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn, failSilently = false) {
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
let globalVersion = 0;
class Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
    }
    track(debugInfo) {
        if (!activeSub || !shouldTrack || activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== activeSub) {
            link = this.activeLink = new Link(activeSub, this);
            if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
            else {
                link.prevDep = activeSub.depsTail;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
            }
            if (activeSub.flags & 4) addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = activeSub.depsTail;
                link.nextDep = void 0;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
                if (activeSub.deps === link) activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)link.sub.notify();
        } finally{
            endBatch();
        }
    }
}
function addSub(link) {
    const computed = link.dep.computed;
    if (computed && !link.dep.subs) {
        computed.flags |= 20;
        for(let l = computed.deps; l; l = l.nextDep)addSub(l);
    }
    const currentTail = link.dep.subs;
    if (currentTail !== link) {
        link.prevSub = currentTail;
        if (currentTail) currentTail.nextSub = link;
    }
    link.dep.subs = link;
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
const ARRAY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        let depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = new Dep());
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, _shared.isArray)(target);
        const isArrayIndex = targetIsArray && (0, _shared.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, _shared.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, _shared.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    var _a;
    return (_a = targetMap.get(object)) == null ? void 0 : _a.get(key);
}
function reactiveReadArray(array) {
    const raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
const arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return iterator(this, Symbol.iterator, toReactive);
    },
    concat (...args) {
        return reactiveReadArray(this).concat(...args.map((x)=>(0, _shared.isArray)(x) ? reactiveReadArray(x) : x));
    },
    entries () {
        return iterator(this, "entries", (value)=>{
            value[1] = toReactive(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return apply(this, "filter", fn, thisArg, (v)=>v.map(toReactive), arguments);
    },
    find (fn, thisArg) {
        return apply(this, "find", fn, thisArg, toReactive, arguments);
    },
    findIndex (fn, thisArg) {
        return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return apply(this, "findLast", fn, thisArg, toReactive, arguments);
    },
    findLastIndex (fn, thisArg) {
        return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return noTracking(this, "pop");
    },
    push (...args) {
        return noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return noTracking(this, "splice", args);
    },
    toReversed () {
        return reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return noTracking(this, "unshift", args);
    },
    values () {
        return iterator(this, "values", toReactive);
    }
};
function iterator(self, method, wrapValue) {
    const arr = shallowReadArray(self);
    const iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self);
    const needsWrap = arr !== self && !isShallow(self);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, toReactive(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    const arr = shallowReadArray(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!isShallow(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, toReactive(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function searchProxy(self, method, args) {
    const arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && isProxy(args[0])) {
        args[0] = toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function noTracking(self, method, args = []) {
    pauseTracking();
    startBatch();
    const res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
const isNonTrackableKeys = /* @__PURE__ */ (0, _shared.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, _shared.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, _shared.isSymbol)(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, _shared.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        isRef(target) ? target : receiver);
        if ((0, _shared.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly2) track(target, "get", key);
        if (isShallow2) return res;
        if (isRef(res)) return targetIsArray && (0, _shared.isIntegerKey)(key) ? res : res.value;
        if ((0, _shared.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
        return res;
    }
}
class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = isReadonly(oldValue);
            if (!isShallow(value) && !isReadonly(value)) {
                oldValue = toRaw(oldValue);
                value = toRaw(value);
            }
            if (!(0, _shared.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, _shared.isArray)(target) && (0, _shared.isIntegerKey)(key) ? Number(key) < target.length : (0, _shared.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, _shared.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, _shared.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        track(target, "iterate", (0, _shared.isArray)(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value)=>value;
const getProto = (v)=>Reflect.getPrototypeOf(v);
function get(target, key, isReadonly2 = false, isShallow2 = false) {
    target = target["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (!isReadonly2) {
        if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
        track(rawTarget, "get", rawKey);
    }
    const { has: has2 } = getProto(rawTarget);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function has(key, isReadonly2 = false) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (!isReadonly2) {
        if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
        track(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly2 = false) {
    target = target["__v_raw"];
    !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function add(value, _isShallow = false) {
    if (!_isShallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
    const target = toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        trigger(target, "add", value, value);
    }
    return this;
}
function set(key, value, _isShallow = false) {
    if (!_isShallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
    const target = toRaw(this);
    const { has: has2, get: get2 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) trigger(target, "add", key, value);
    else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
    return this;
}
function deleteEntry(key) {
    const target = toRaw(this);
    const { has: has2, get: get2 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function clear() {
    const target = toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function createForEach(isReadonly2, isShallow2) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = toRaw(target);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = toRaw(target);
        const targetIsMap = (0, _shared.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value, done } = innerIterator.next();
                return done ? {
                    value,
                    done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return get(this, key);
        },
        get size () {
            return size(this);
        },
        has,
        add,
        set,
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return get(this, key, false, true);
        },
        get size () {
            return size(this);
        },
        has,
        add (value) {
            return add.call(this, value, true);
        },
        set (key, value) {
            return set.call(this, key, value, true);
        },
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return get(this, key, true);
        },
        get size () {
            return size(this, true);
        },
        has (key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return get(this, key, true, true);
        },
        get size () {
            return size(this, true);
        },
        has (key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, _shared.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has2, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, _shared.toRawType)(target);
        warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, _shared.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, _shared.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, _shared.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, _shared.def)(value, "__v_skip", true);
    return value;
}
const toReactive = (value)=>(0, _shared.isObject)(value) ? reactive(value) : value;
const toReadonly = (value)=>(0, _shared.isObject)(value) ? readonly(value) : value;
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, isShallow2){
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
        newValue = useDirectValue ? newValue : toRaw(newValue);
        if ((0, _shared.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : toReactive(newValue);
            this.dep.trigger();
        }
    }
}
function triggerRef(ref2) {
    ref2.dep.trigger();
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, _shared.isFunction)(source) ? source() : unref(source);
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new Dep();
        const { get, set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    const ret = (0, _shared.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
class ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return getDepFromReactive(toRaw(this._object), this._key);
    }
}
class GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, _shared.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, _shared.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (activeSub !== this) this.dep.notify();
    }
    get value() {
        const link = this.dep.track();
        refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, _shared.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const WatchErrorCodes = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
        let cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef(source)) {
        getter = ()=>source.value;
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, _shared.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>isReactive(s) || isShallow(s));
        getter = ()=>source.map((s)=>{
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, _shared.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, _shared.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            const currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, _shared.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = ()=>{
        effect.stop();
        if (scope) (0, _shared.remove)(scope.effects, effect);
    };
    if (once) {
        if (cb) {
            const _cb = cb;
            cb = (...args)=>{
                _cb(...args);
                watchHandle();
            };
        } else {
            const _getter = getter;
            getter = ()=>{
                _getter();
                watchHandle();
            };
        }
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, _shared.hasChanged)(v, oldValue[i])) : (0, _shared.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>onWatcherCleanup(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, _shared.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, _shared.isArray)(value)) for(let i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, _shared.isSet)(value) || (0, _shared.isMap)(value)) value.forEach((v)=>{
        traverse(v, depth, seen);
    });
    else if ((0, _shared.isPlainObject)(value)) {
        for(const key in value)traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
    }
    return value;
}

},{"@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqBjR":[function(require,module,exports,__globalThis) {
/**
* @vue/shared v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_ARR", ()=>EMPTY_ARR);
parcelHelpers.export(exports, "EMPTY_OBJ", ()=>EMPTY_OBJ);
parcelHelpers.export(exports, "NO", ()=>NO);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
parcelHelpers.export(exports, "PatchFlagNames", ()=>PatchFlagNames);
parcelHelpers.export(exports, "PatchFlags", ()=>PatchFlags);
parcelHelpers.export(exports, "ShapeFlags", ()=>ShapeFlags);
parcelHelpers.export(exports, "SlotFlags", ()=>SlotFlags);
parcelHelpers.export(exports, "camelize", ()=>camelize);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "cssVarNameEscapeSymbolsRE", ()=>cssVarNameEscapeSymbolsRE);
parcelHelpers.export(exports, "def", ()=>def);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "escapeHtmlComment", ()=>escapeHtmlComment);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "genPropsAccessExp", ()=>genPropsAccessExp);
parcelHelpers.export(exports, "generateCodeFrame", ()=>generateCodeFrame);
parcelHelpers.export(exports, "getEscapedCssVarName", ()=>getEscapedCssVarName);
parcelHelpers.export(exports, "getGlobalThis", ()=>getGlobalThis);
parcelHelpers.export(exports, "hasChanged", ()=>hasChanged);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "hyphenate", ()=>hyphenate);
parcelHelpers.export(exports, "includeBooleanAttr", ()=>includeBooleanAttr);
parcelHelpers.export(exports, "invokeArrayFns", ()=>invokeArrayFns);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBooleanAttr", ()=>isBooleanAttr);
parcelHelpers.export(exports, "isBuiltInDirective", ()=>isBuiltInDirective);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isGloballyAllowed", ()=>isGloballyAllowed);
parcelHelpers.export(exports, "isGloballyWhitelisted", ()=>isGloballyWhitelisted);
parcelHelpers.export(exports, "isHTMLTag", ()=>isHTMLTag);
parcelHelpers.export(exports, "isIntegerKey", ()=>isIntegerKey);
parcelHelpers.export(exports, "isKnownHtmlAttr", ()=>isKnownHtmlAttr);
parcelHelpers.export(exports, "isKnownSvgAttr", ()=>isKnownSvgAttr);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isMathMLTag", ()=>isMathMLTag);
parcelHelpers.export(exports, "isModelListener", ()=>isModelListener);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isOn", ()=>isOn);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRenderableAttrValue", ()=>isRenderableAttrValue);
parcelHelpers.export(exports, "isReservedProp", ()=>isReservedProp);
parcelHelpers.export(exports, "isSSRSafeAttrName", ()=>isSSRSafeAttrName);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSpecialBooleanAttr", ()=>isSpecialBooleanAttr);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isVoidTag", ()=>isVoidTag);
parcelHelpers.export(exports, "looseEqual", ()=>looseEqual);
parcelHelpers.export(exports, "looseIndexOf", ()=>looseIndexOf);
parcelHelpers.export(exports, "looseToNumber", ()=>looseToNumber);
parcelHelpers.export(exports, "makeMap", ()=>makeMap);
parcelHelpers.export(exports, "normalizeClass", ()=>normalizeClass);
parcelHelpers.export(exports, "normalizeProps", ()=>normalizeProps);
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "objectToString", ()=>objectToString);
parcelHelpers.export(exports, "parseStringStyle", ()=>parseStringStyle);
parcelHelpers.export(exports, "propsToAttrMap", ()=>propsToAttrMap);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "slotFlagsText", ()=>slotFlagsText);
parcelHelpers.export(exports, "stringifyStyle", ()=>stringifyStyle);
parcelHelpers.export(exports, "toDisplayString", ()=>toDisplayString);
parcelHelpers.export(exports, "toHandlerKey", ()=>toHandlerKey);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toRawType", ()=>toRawType);
parcelHelpers.export(exports, "toTypeString", ()=>toTypeString);
var global = arguments[3];
function makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = ()=>{};
const NO = ()=>false;
const isOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key)=>key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key)=>hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val)=>toTypeString(val) === "[object Map]";
const isSet = (val)=>toTypeString(val) === "[object Set]";
const isDate = (val)=>toTypeString(val) === "[object Date]";
const isRegExp = (val)=>toTypeString(val) === "[object RegExp]";
const isFunction = (val)=>typeof val === "function";
const isString = (val)=>typeof val === "string";
const isSymbol = (val)=>typeof val === "symbol";
const isObject = (val)=>val !== null && typeof val === "object";
const isPromise = (val)=>{
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value)=>objectToString.call(value);
const toRawType = (value)=>{
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val)=>toTypeString(val) === "[object Object]";
const isIntegerKey = (key)=>isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str)=>{
    return str.replace(camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str)=>str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction((str)=>{
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
});
const hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const def = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
};
const looseToNumber = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const toNumber = (val)=>{
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = ()=>{
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
const identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function genPropsAccessExp(name) {
    return identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const PatchFlags = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const ShapeFlags = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const SlotFlags = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
const isGloballyWhitelisted = isGloballyAllowed;
const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - range; j <= i + range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if (isString(value) || isObject(value)) return value;
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    let ret = "";
    if (!styles || isString(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if (isString(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = "";
    if (isString(value)) res = value;
    else if (isArray(value)) for(let i = 0; i < value.length; i++){
        const normalized = normalizeClass(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if (isObject(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) props.class = normalizeClass(klass);
    if (style) props.style = normalizeStyle(style);
    return props;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
const isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
const isBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function includeBooleanAttr(value) {
    return !!value || value === "";
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) return attrValidationCache[name];
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return attrValidationCache[name] = !isUnsafe;
}
const propsToAttrMap = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const isKnownHtmlAttr = /* @__PURE__ */ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const isKnownSvgAttr = /* @__PURE__ */ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function isRenderableAttrValue(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = "" + string;
    const match = escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, "");
}
const cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(cssVarNameEscapeSymbolsRE, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = looseEqual(a[i], b[i]);
    return equal;
}
function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) return a === b;
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex((item)=>looseEqual(item, val));
}
const isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val)=>{
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val)=>{
    if (isRef(val)) return replacer(_key, val.value);
    else if (isMap(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if (isSet(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>stringifySymbol(v))
    };
    else if (isSymbol(val)) return stringifySymbol(val);
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
    return val;
};
const stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"OsNOm":[function(require,module,exports,__globalThis) {
/**
* @vue/compiler-dom v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMDirectiveTransforms", ()=>DOMDirectiveTransforms);
parcelHelpers.export(exports, "DOMErrorCodes", ()=>DOMErrorCodes);
parcelHelpers.export(exports, "DOMErrorMessages", ()=>DOMErrorMessages);
parcelHelpers.export(exports, "DOMNodeTransforms", ()=>DOMNodeTransforms);
parcelHelpers.export(exports, "TRANSITION", ()=>TRANSITION);
parcelHelpers.export(exports, "TRANSITION_GROUP", ()=>TRANSITION_GROUP);
parcelHelpers.export(exports, "V_MODEL_CHECKBOX", ()=>V_MODEL_CHECKBOX);
parcelHelpers.export(exports, "V_MODEL_DYNAMIC", ()=>V_MODEL_DYNAMIC);
parcelHelpers.export(exports, "V_MODEL_RADIO", ()=>V_MODEL_RADIO);
parcelHelpers.export(exports, "V_MODEL_SELECT", ()=>V_MODEL_SELECT);
parcelHelpers.export(exports, "V_MODEL_TEXT", ()=>V_MODEL_TEXT);
parcelHelpers.export(exports, "V_ON_WITH_KEYS", ()=>V_ON_WITH_KEYS);
parcelHelpers.export(exports, "V_ON_WITH_MODIFIERS", ()=>V_ON_WITH_MODIFIERS);
parcelHelpers.export(exports, "V_SHOW", ()=>V_SHOW);
parcelHelpers.export(exports, "compile", ()=>compile);
parcelHelpers.export(exports, "createDOMCompilerError", ()=>createDOMCompilerError);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parserOptions", ()=>parserOptions);
parcelHelpers.export(exports, "transformStyle", ()=>transformStyle);
var _compilerCore = require("@vue/compiler-core");
parcelHelpers.exportAll(_compilerCore, exports);
var _shared = require("@vue/shared");
const V_MODEL_RADIO = Symbol(``);
const V_MODEL_CHECKBOX = Symbol(``);
const V_MODEL_TEXT = Symbol(``);
const V_MODEL_SELECT = Symbol(``);
const V_MODEL_DYNAMIC = Symbol(``);
const V_ON_WITH_MODIFIERS = Symbol(``);
const V_ON_WITH_KEYS = Symbol(``);
const V_SHOW = Symbol(``);
const TRANSITION = Symbol(``);
const TRANSITION_GROUP = Symbol(``);
(0, _compilerCore.registerRuntimeHelpers)({
    [V_MODEL_RADIO]: `vModelRadio`,
    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
    [V_MODEL_TEXT]: `vModelText`,
    [V_MODEL_SELECT]: `vModelSelect`,
    [V_MODEL_DYNAMIC]: `vModelDynamic`,
    [V_ON_WITH_MODIFIERS]: `withModifiers`,
    [V_ON_WITH_KEYS]: `withKeys`,
    [V_SHOW]: `vShow`,
    [TRANSITION]: `Transition`,
    [TRANSITION_GROUP]: `TransitionGroup`
});
let decoder;
function decodeHtmlBrowser(raw, asAttr = false) {
    if (!decoder) decoder = document.createElement("div");
    if (asAttr) {
        decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return decoder.children[0].getAttribute("foo");
    } else {
        decoder.innerHTML = raw;
        return decoder.textContent;
    }
}
const parserOptions = {
    parseMode: "html",
    isVoidTag: (0, _shared.isVoidTag),
    isNativeTag: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    isIgnoreNewlineTag: (tag)=>tag === "pre" || tag === "textarea",
    decodeEntities: decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return TRANSITION;
        else if (tag === "TransitionGroup" || tag === "transition-group") return TRANSITION_GROUP;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const transformStyle = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, _compilerCore.createSimpleExpression)(`style`, true, p.loc),
            exp: parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, _shared.parseStringStyle)(cssText);
    return (0, _compilerCore.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function createDOMCompilerError(code, loc) {
    return (0, _compilerCore.createCompilerError)(code, loc, void 0);
}
const DOMErrorCodes = {
    "X_V_HTML_NO_EXPRESSION": 53,
    "53": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 54,
    "54": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 55,
    "55": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 56,
    "56": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 57,
    "57": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 58,
    "58": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 59,
    "59": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 60,
    "60": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 61,
    "61": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 62,
    "62": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 63,
    "63": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 64,
    "64": "__EXTEND_POINT__"
};
const DOMErrorMessages = {
    [53]: `v-html is missing expression.`,
    [54]: `v-html will override element children.`,
    [55]: `v-text is missing expression.`,
    [56]: `v-text will override element children.`,
    [57]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [58]: `v-model argument is not supported on plain elements.`,
    [59]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [60]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [61]: `v-show is missing expression.`,
    [62]: `<Transition> expects exactly one child element or component.`,
    [63]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const transformVHtml = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(53, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(54, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformVText = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(55, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(56, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`textContent`, true), exp ? (0, _compilerCore.getConstantType)(exp, context) > 0 ? exp : (0, _compilerCore.createCallExpression)(context.helperString((0, _compilerCore.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformModel = (dir, node, context)=>{
    const baseResult = (0, _compilerCore.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError(createDOMCompilerError(58, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, _compilerCore.findDir)(node, "bind");
        if (value && (0, _compilerCore.isStaticArgOf)(value.arg, "value")) context.onError(createDOMCompilerError(60, value.loc));
    }
    const { tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = V_MODEL_TEXT;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, _compilerCore.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = V_MODEL_DYNAMIC;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = V_MODEL_RADIO;
                        break;
                    case "checkbox":
                        directiveToUse = V_MODEL_CHECKBOX;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError(createDOMCompilerError(59, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, _compilerCore.hasDynamicKeyVBind)(node)) directiveToUse = V_MODEL_DYNAMIC;
        } else if (tag === "select") directiveToUse = V_MODEL_SELECT;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError(createDOMCompilerError(57, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const isEventOptionModifier = /* @__PURE__ */ (0, _shared.makeMap)(`passive,once,capture`);
const isNonKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const maybeKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)("left,right");
const isKeyboardEvent = /* @__PURE__ */ (0, _shared.makeMap)(`onkeyup,onkeydown,onkeypress`);
const resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i].content;
        if (modifier === "native" && (0, _compilerCore.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if (isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if (maybeKeyModifier(modifier)) {
                if ((0, _compilerCore.isStaticExp)(key)) {
                    if (isKeyboardEvent(key.content.toLowerCase())) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if (isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers,
        nonKeyModifiers,
        eventOptionModifiers
    };
};
const transformClick = (key, event)=>{
    const isStaticClick = (0, _compilerCore.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, _compilerCore.createSimpleExpression)(event, true) : key.type !== 4 ? (0, _compilerCore.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const transformOn = (dir, node, context)=>{
    return (0, _compilerCore.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_MODIFIERS), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, _compilerCore.isStaticExp)(key) || isKeyboardEvent(key.content.toLowerCase()))) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_KEYS), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, _shared.capitalize)).join("");
            key = (0, _compilerCore.isStaticExp)(key) ? (0, _compilerCore.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, _compilerCore.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, _compilerCore.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const transformShow = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(61, loc));
    return {
        props: [],
        needRuntime: context.helper(V_SHOW)
    };
};
const transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === TRANSITION) return ()=>{
            if (!node.children.length) return;
            if (hasMultipleChildren(node)) context.onError(createDOMCompilerError(62, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>c.type !== 3 && !(c.type === 2 && !c.content.trim()));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some(hasMultipleChildren);
}
const ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
function isValidHTMLNesting(parent, child) {
    if (parent in onlyValidChildren) return onlyValidChildren[parent].has(child);
    if (child in onlyValidParents) return onlyValidParents[child].has(parent);
    if (parent in knownInvalidChildren) {
        if (knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in knownInvalidParents) {
        if (knownInvalidParents[child].has(parent)) return false;
    }
    return true;
}
const headings = /* @__PURE__ */ new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const emptySet = /* @__PURE__ */ new Set([]);
const onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
        "base",
        "basefront",
        "bgsound",
        "link",
        "meta",
        "title",
        "noscript",
        "noframes",
        "style",
        "script",
        "template"
    ]),
    optgroup: /* @__PURE__ */ new Set([
        "option"
    ]),
    select: /* @__PURE__ */ new Set([
        "optgroup",
        "option",
        "hr"
    ]),
    // table
    table: /* @__PURE__ */ new Set([
        "caption",
        "colgroup",
        "tbody",
        "tfoot",
        "thead"
    ]),
    tr: /* @__PURE__ */ new Set([
        "td",
        "th"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "col"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "tr"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "tr"
    ]),
    // these elements can not have any children elements
    script: emptySet,
    iframe: emptySet,
    option: emptySet,
    textarea: emptySet,
    style: emptySet,
    title: emptySet
};
const onlyValidParents = {
    // sections
    html: emptySet,
    body: /* @__PURE__ */ new Set([
        "html"
    ]),
    head: /* @__PURE__ */ new Set([
        "html"
    ]),
    // table
    td: /* @__PURE__ */ new Set([
        "tr"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "table"
    ]),
    caption: /* @__PURE__ */ new Set([
        "table"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "table"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "table"
    ]),
    col: /* @__PURE__ */ new Set([
        "colgroup"
    ]),
    th: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "table"
    ]),
    tr: /* @__PURE__ */ new Set([
        "tbody",
        "thead",
        "tfoot"
    ]),
    // data list
    dd: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    // other
    figcaption: /* @__PURE__ */ new Set([
        "figure"
    ]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set([
        "details"
    ]),
    area: /* @__PURE__ */ new Set([
        "map"
    ])
};
const knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
        "address",
        "article",
        "aside",
        "blockquote",
        "center",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "fieldset",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "menu",
        "ol",
        "p",
        "pre",
        "section",
        "table",
        "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "li",
        "menu",
        "meta",
        "ol",
        "p",
        "pre",
        "ruby",
        "s",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "u",
        "ul",
        "var"
    ])
};
const knownInvalidParents = {
    a: /* @__PURE__ */ new Set([
        "a"
    ]),
    button: /* @__PURE__ */ new Set([
        "button"
    ]),
    dd: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    form: /* @__PURE__ */ new Set([
        "form"
    ]),
    li: /* @__PURE__ */ new Set([
        "li"
    ]),
    h1: headings,
    h2: headings,
    h3: headings,
    h4: headings,
    h5: headings,
    h6: headings
};
const validateHtmlNesting = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !isValidHTMLNesting(context.parent.tag, node.tag)) {
        const error = new SyntaxError(`<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`);
        error.loc = node.loc;
        context.onWarn(error);
    }
};
const DOMNodeTransforms = [
    transformStyle
];
const DOMDirectiveTransforms = {
    cloak: (0, _compilerCore.noopDirectiveTransform),
    html: transformVHtml,
    text: transformVText,
    model: transformModel,
    // override compiler-core
    on: transformOn,
    // override compiler-core
    show: transformShow
};
function compile(src, options = {}) {
    return (0, _compilerCore.baseCompile)(src, (0, _shared.extend)({}, parserOptions, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            ignoreSideEffectTags,
            ...DOMNodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, DOMDirectiveTransforms, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function parse(template, options = {}) {
    return (0, _compilerCore.baseParse)(template, (0, _shared.extend)({}, parserOptions, options));
}

},{"@vue/compiler-core":"kZqdU","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZqdU":[function(require,module,exports,__globalThis) {
/**
* @vue/compiler-core v3.5.5
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCodeFrame", ()=>(0, _shared.generateCodeFrame));
parcelHelpers.export(exports, "BASE_TRANSITION", ()=>BASE_TRANSITION);
parcelHelpers.export(exports, "BindingTypes", ()=>BindingTypes);
parcelHelpers.export(exports, "CAMELIZE", ()=>CAMELIZE);
parcelHelpers.export(exports, "CAPITALIZE", ()=>CAPITALIZE);
parcelHelpers.export(exports, "CREATE_BLOCK", ()=>CREATE_BLOCK);
parcelHelpers.export(exports, "CREATE_COMMENT", ()=>CREATE_COMMENT);
parcelHelpers.export(exports, "CREATE_ELEMENT_BLOCK", ()=>CREATE_ELEMENT_BLOCK);
parcelHelpers.export(exports, "CREATE_ELEMENT_VNODE", ()=>CREATE_ELEMENT_VNODE);
parcelHelpers.export(exports, "CREATE_SLOTS", ()=>CREATE_SLOTS);
parcelHelpers.export(exports, "CREATE_STATIC", ()=>CREATE_STATIC);
parcelHelpers.export(exports, "CREATE_TEXT", ()=>CREATE_TEXT);
parcelHelpers.export(exports, "CREATE_VNODE", ()=>CREATE_VNODE);
parcelHelpers.export(exports, "CompilerDeprecationTypes", ()=>CompilerDeprecationTypes);
parcelHelpers.export(exports, "ConstantTypes", ()=>ConstantTypes);
parcelHelpers.export(exports, "ElementTypes", ()=>ElementTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "FRAGMENT", ()=>FRAGMENT);
parcelHelpers.export(exports, "GUARD_REACTIVE_PROPS", ()=>GUARD_REACTIVE_PROPS);
parcelHelpers.export(exports, "IS_MEMO_SAME", ()=>IS_MEMO_SAME);
parcelHelpers.export(exports, "IS_REF", ()=>IS_REF);
parcelHelpers.export(exports, "KEEP_ALIVE", ()=>KEEP_ALIVE);
parcelHelpers.export(exports, "MERGE_PROPS", ()=>MERGE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_CLASS", ()=>NORMALIZE_CLASS);
parcelHelpers.export(exports, "NORMALIZE_PROPS", ()=>NORMALIZE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_STYLE", ()=>NORMALIZE_STYLE);
parcelHelpers.export(exports, "Namespaces", ()=>Namespaces);
parcelHelpers.export(exports, "NodeTypes", ()=>NodeTypes);
parcelHelpers.export(exports, "OPEN_BLOCK", ()=>OPEN_BLOCK);
parcelHelpers.export(exports, "POP_SCOPE_ID", ()=>POP_SCOPE_ID);
parcelHelpers.export(exports, "PUSH_SCOPE_ID", ()=>PUSH_SCOPE_ID);
parcelHelpers.export(exports, "RENDER_LIST", ()=>RENDER_LIST);
parcelHelpers.export(exports, "RENDER_SLOT", ()=>RENDER_SLOT);
parcelHelpers.export(exports, "RESOLVE_COMPONENT", ()=>RESOLVE_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_DIRECTIVE", ()=>RESOLVE_DIRECTIVE);
parcelHelpers.export(exports, "RESOLVE_DYNAMIC_COMPONENT", ()=>RESOLVE_DYNAMIC_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_FILTER", ()=>RESOLVE_FILTER);
parcelHelpers.export(exports, "SET_BLOCK_TRACKING", ()=>SET_BLOCK_TRACKING);
parcelHelpers.export(exports, "SUSPENSE", ()=>SUSPENSE);
parcelHelpers.export(exports, "TELEPORT", ()=>TELEPORT);
parcelHelpers.export(exports, "TO_DISPLAY_STRING", ()=>TO_DISPLAY_STRING);
parcelHelpers.export(exports, "TO_HANDLERS", ()=>TO_HANDLERS);
parcelHelpers.export(exports, "TO_HANDLER_KEY", ()=>TO_HANDLER_KEY);
parcelHelpers.export(exports, "TS_NODE_TYPES", ()=>TS_NODE_TYPES);
parcelHelpers.export(exports, "UNREF", ()=>UNREF);
parcelHelpers.export(exports, "WITH_CTX", ()=>WITH_CTX);
parcelHelpers.export(exports, "WITH_DIRECTIVES", ()=>WITH_DIRECTIVES);
parcelHelpers.export(exports, "WITH_MEMO", ()=>WITH_MEMO);
parcelHelpers.export(exports, "advancePositionWithClone", ()=>advancePositionWithClone);
parcelHelpers.export(exports, "advancePositionWithMutation", ()=>advancePositionWithMutation);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "baseCompile", ()=>baseCompile);
parcelHelpers.export(exports, "baseParse", ()=>baseParse);
parcelHelpers.export(exports, "buildDirectiveArgs", ()=>buildDirectiveArgs);
parcelHelpers.export(exports, "buildProps", ()=>buildProps);
parcelHelpers.export(exports, "buildSlots", ()=>buildSlots);
parcelHelpers.export(exports, "checkCompatEnabled", ()=>checkCompatEnabled);
parcelHelpers.export(exports, "convertToBlock", ()=>convertToBlock);
parcelHelpers.export(exports, "createArrayExpression", ()=>createArrayExpression);
parcelHelpers.export(exports, "createAssignmentExpression", ()=>createAssignmentExpression);
parcelHelpers.export(exports, "createBlockStatement", ()=>createBlockStatement);
parcelHelpers.export(exports, "createCacheExpression", ()=>createCacheExpression);
parcelHelpers.export(exports, "createCallExpression", ()=>createCallExpression);
parcelHelpers.export(exports, "createCompilerError", ()=>createCompilerError);
parcelHelpers.export(exports, "createCompoundExpression", ()=>createCompoundExpression);
parcelHelpers.export(exports, "createConditionalExpression", ()=>createConditionalExpression);
parcelHelpers.export(exports, "createForLoopParams", ()=>createForLoopParams);
parcelHelpers.export(exports, "createFunctionExpression", ()=>createFunctionExpression);
parcelHelpers.export(exports, "createIfStatement", ()=>createIfStatement);
parcelHelpers.export(exports, "createInterpolation", ()=>createInterpolation);
parcelHelpers.export(exports, "createObjectExpression", ()=>createObjectExpression);
parcelHelpers.export(exports, "createObjectProperty", ()=>createObjectProperty);
parcelHelpers.export(exports, "createReturnStatement", ()=>createReturnStatement);
parcelHelpers.export(exports, "createRoot", ()=>createRoot);
parcelHelpers.export(exports, "createSequenceExpression", ()=>createSequenceExpression);
parcelHelpers.export(exports, "createSimpleExpression", ()=>createSimpleExpression);
parcelHelpers.export(exports, "createStructuralDirectiveTransform", ()=>createStructuralDirectiveTransform);
parcelHelpers.export(exports, "createTemplateLiteral", ()=>createTemplateLiteral);
parcelHelpers.export(exports, "createTransformContext", ()=>createTransformContext);
parcelHelpers.export(exports, "createVNodeCall", ()=>createVNodeCall);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
parcelHelpers.export(exports, "extractIdentifiers", ()=>extractIdentifiers);
parcelHelpers.export(exports, "findDir", ()=>findDir);
parcelHelpers.export(exports, "findProp", ()=>findProp);
parcelHelpers.export(exports, "forAliasRE", ()=>forAliasRE);
parcelHelpers.export(exports, "generate", ()=>generate);
parcelHelpers.export(exports, "getBaseTransformPreset", ()=>getBaseTransformPreset);
parcelHelpers.export(exports, "getConstantType", ()=>getConstantType);
parcelHelpers.export(exports, "getMemoedVNodeCall", ()=>getMemoedVNodeCall);
parcelHelpers.export(exports, "getVNodeBlockHelper", ()=>getVNodeBlockHelper);
parcelHelpers.export(exports, "getVNodeHelper", ()=>getVNodeHelper);
parcelHelpers.export(exports, "hasDynamicKeyVBind", ()=>hasDynamicKeyVBind);
parcelHelpers.export(exports, "hasScopeRef", ()=>hasScopeRef);
parcelHelpers.export(exports, "helperNameMap", ()=>helperNameMap);
parcelHelpers.export(exports, "injectProp", ()=>injectProp);
parcelHelpers.export(exports, "isCoreComponent", ()=>isCoreComponent);
parcelHelpers.export(exports, "isFnExpression", ()=>isFnExpression);
parcelHelpers.export(exports, "isFnExpressionBrowser", ()=>isFnExpressionBrowser);
parcelHelpers.export(exports, "isFnExpressionNode", ()=>isFnExpressionNode);
parcelHelpers.export(exports, "isFunctionType", ()=>isFunctionType);
parcelHelpers.export(exports, "isInDestructureAssignment", ()=>isInDestructureAssignment);
parcelHelpers.export(exports, "isInNewExpression", ()=>isInNewExpression);
parcelHelpers.export(exports, "isMemberExpression", ()=>isMemberExpression);
parcelHelpers.export(exports, "isMemberExpressionBrowser", ()=>isMemberExpressionBrowser);
parcelHelpers.export(exports, "isMemberExpressionNode", ()=>isMemberExpressionNode);
parcelHelpers.export(exports, "isReferencedIdentifier", ()=>isReferencedIdentifier);
parcelHelpers.export(exports, "isSimpleIdentifier", ()=>isSimpleIdentifier);
parcelHelpers.export(exports, "isSlotOutlet", ()=>isSlotOutlet);
parcelHelpers.export(exports, "isStaticArgOf", ()=>isStaticArgOf);
parcelHelpers.export(exports, "isStaticExp", ()=>isStaticExp);
parcelHelpers.export(exports, "isStaticProperty", ()=>isStaticProperty);
parcelHelpers.export(exports, "isStaticPropertyKey", ()=>isStaticPropertyKey);
parcelHelpers.export(exports, "isTemplateNode", ()=>isTemplateNode);
parcelHelpers.export(exports, "isText", ()=>isText$1);
parcelHelpers.export(exports, "isVSlot", ()=>isVSlot);
parcelHelpers.export(exports, "locStub", ()=>locStub);
parcelHelpers.export(exports, "noopDirectiveTransform", ()=>noopDirectiveTransform);
parcelHelpers.export(exports, "processExpression", ()=>processExpression);
parcelHelpers.export(exports, "processFor", ()=>processFor);
parcelHelpers.export(exports, "processIf", ()=>processIf);
parcelHelpers.export(exports, "processSlotOutlet", ()=>processSlotOutlet);
parcelHelpers.export(exports, "registerRuntimeHelpers", ()=>registerRuntimeHelpers);
parcelHelpers.export(exports, "resolveComponentType", ()=>resolveComponentType);
parcelHelpers.export(exports, "stringifyExpression", ()=>stringifyExpression);
parcelHelpers.export(exports, "toValidAssetId", ()=>toValidAssetId);
parcelHelpers.export(exports, "trackSlotScopes", ()=>trackSlotScopes);
parcelHelpers.export(exports, "trackVForSlotScopes", ()=>trackVForSlotScopes);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transformBind", ()=>transformBind);
parcelHelpers.export(exports, "transformElement", ()=>transformElement);
parcelHelpers.export(exports, "transformExpression", ()=>transformExpression);
parcelHelpers.export(exports, "transformModel", ()=>transformModel);
parcelHelpers.export(exports, "transformOn", ()=>transformOn);
parcelHelpers.export(exports, "traverseNode", ()=>traverseNode);
parcelHelpers.export(exports, "unwrapTSNode", ()=>unwrapTSNode);
parcelHelpers.export(exports, "walkBlockDeclarations", ()=>walkBlockDeclarations);
parcelHelpers.export(exports, "walkFunctionParams", ()=>walkFunctionParams);
parcelHelpers.export(exports, "walkIdentifiers", ()=>walkIdentifiers);
parcelHelpers.export(exports, "warnDeprecation", ()=>warnDeprecation);
var _shared = require("@vue/shared");
const FRAGMENT = Symbol(``);
const TELEPORT = Symbol(``);
const SUSPENSE = Symbol(``);
const KEEP_ALIVE = Symbol(``);
const BASE_TRANSITION = Symbol(``);
const OPEN_BLOCK = Symbol(``);
const CREATE_BLOCK = Symbol(``);
const CREATE_ELEMENT_BLOCK = Symbol(``);
const CREATE_VNODE = Symbol(``);
const CREATE_ELEMENT_VNODE = Symbol(``);
const CREATE_COMMENT = Symbol(``);
const CREATE_TEXT = Symbol(``);
const CREATE_STATIC = Symbol(``);
const RESOLVE_COMPONENT = Symbol(``);
const RESOLVE_DYNAMIC_COMPONENT = Symbol(``);
const RESOLVE_DIRECTIVE = Symbol(``);
const RESOLVE_FILTER = Symbol(``);
const WITH_DIRECTIVES = Symbol(``);
const RENDER_LIST = Symbol(``);
const RENDER_SLOT = Symbol(``);
const CREATE_SLOTS = Symbol(``);
const TO_DISPLAY_STRING = Symbol(``);
const MERGE_PROPS = Symbol(``);
const NORMALIZE_CLASS = Symbol(``);
const NORMALIZE_STYLE = Symbol(``);
const NORMALIZE_PROPS = Symbol(``);
const GUARD_REACTIVE_PROPS = Symbol(``);
const TO_HANDLERS = Symbol(``);
const CAMELIZE = Symbol(``);
const CAPITALIZE = Symbol(``);
const TO_HANDLER_KEY = Symbol(``);
const SET_BLOCK_TRACKING = Symbol(``);
const PUSH_SCOPE_ID = Symbol(``);
const POP_SCOPE_ID = Symbol(``);
const WITH_CTX = Symbol(``);
const UNREF = Symbol(``);
const IS_REF = Symbol(``);
const WITH_MEMO = Symbol(``);
const IS_MEMO_SAME = Symbol(``);
const helperNameMap = {
    [FRAGMENT]: `Fragment`,
    [TELEPORT]: `Teleport`,
    [SUSPENSE]: `Suspense`,
    [KEEP_ALIVE]: `KeepAlive`,
    [BASE_TRANSITION]: `BaseTransition`,
    [OPEN_BLOCK]: `openBlock`,
    [CREATE_BLOCK]: `createBlock`,
    [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
    [CREATE_VNODE]: `createVNode`,
    [CREATE_ELEMENT_VNODE]: `createElementVNode`,
    [CREATE_COMMENT]: `createCommentVNode`,
    [CREATE_TEXT]: `createTextVNode`,
    [CREATE_STATIC]: `createStaticVNode`,
    [RESOLVE_COMPONENT]: `resolveComponent`,
    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
    [RESOLVE_DIRECTIVE]: `resolveDirective`,
    [RESOLVE_FILTER]: `resolveFilter`,
    [WITH_DIRECTIVES]: `withDirectives`,
    [RENDER_LIST]: `renderList`,
    [RENDER_SLOT]: `renderSlot`,
    [CREATE_SLOTS]: `createSlots`,
    [TO_DISPLAY_STRING]: `toDisplayString`,
    [MERGE_PROPS]: `mergeProps`,
    [NORMALIZE_CLASS]: `normalizeClass`,
    [NORMALIZE_STYLE]: `normalizeStyle`,
    [NORMALIZE_PROPS]: `normalizeProps`,
    [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
    [TO_HANDLERS]: `toHandlers`,
    [CAMELIZE]: `camelize`,
    [CAPITALIZE]: `capitalize`,
    [TO_HANDLER_KEY]: `toHandlerKey`,
    [SET_BLOCK_TRACKING]: `setBlockTracking`,
    [PUSH_SCOPE_ID]: `pushScopeId`,
    [POP_SCOPE_ID]: `popScopeId`,
    [WITH_CTX]: `withCtx`,
    [UNREF]: `unref`,
    [IS_REF]: `isRef`,
    [WITH_MEMO]: `withMemo`,
    [IS_MEMO_SAME]: `isMemoSame`
};
function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        helperNameMap[s] = helpers[s];
    });
}
const Namespaces = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const NodeTypes = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const ElementTypes = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const ConstantTypes = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_CACHE": 2,
    "2": "CAN_CACHE",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const locStub = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function createRoot(children, source = "") {
    return {
        type: 0,
        source,
        children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: [],
        temps: 0,
        codegenNode: void 0,
        loc: locStub
    };
}
function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = locStub) {
    if (context) {
        if (isBlock) {
            context.helper(OPEN_BLOCK);
            context.helper(getVNodeBlockHelper(context.inSSR, isComponent));
        } else context.helper(getVNodeHelper(context.inSSR, isComponent));
        if (directives) context.helper(WITH_DIRECTIVES);
    }
    return {
        type: 13,
        tag,
        props,
        children,
        patchFlag,
        dynamicProps,
        directives,
        isBlock,
        disableTracking,
        isComponent,
        loc
    };
}
function createArrayExpression(elements, loc = locStub) {
    return {
        type: 17,
        loc,
        elements
    };
}
function createObjectExpression(properties, loc = locStub) {
    return {
        type: 15,
        loc,
        properties
    };
}
function createObjectProperty(key, value) {
    return {
        type: 16,
        loc: locStub,
        key: (0, _shared.isString)(key) ? createSimpleExpression(key, true) : key,
        value
    };
}
function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0) {
    return {
        type: 4,
        loc,
        content,
        isStatic,
        constType: isStatic ? 3 : constType
    };
}
function createInterpolation(content, loc) {
    return {
        type: 5,
        loc,
        content: (0, _shared.isString)(content) ? createSimpleExpression(content, false, loc) : content
    };
}
function createCompoundExpression(children, loc = locStub) {
    return {
        type: 8,
        loc,
        children
    };
}
function createCallExpression(callee, args = [], loc = locStub) {
    return {
        type: 14,
        loc,
        callee,
        arguments: args
    };
}
function createFunctionExpression(params, returns, newline = false, isSlot = false, loc = locStub) {
    return {
        type: 18,
        params,
        returns,
        newline,
        isSlot,
        loc
    };
}
function createConditionalExpression(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test,
        consequent,
        alternate,
        newline,
        loc: locStub
    };
}
function createCacheExpression(index, value, needPauseTracking = false) {
    return {
        type: 20,
        index,
        value,
        needPauseTracking,
        needArraySpread: false,
        loc: locStub
    };
}
function createBlockStatement(body) {
    return {
        type: 21,
        body,
        loc: locStub
    };
}
function createTemplateLiteral(elements) {
    return {
        type: 22,
        elements,
        loc: locStub
    };
}
function createIfStatement(test, consequent, alternate) {
    return {
        type: 23,
        test,
        consequent,
        alternate,
        loc: locStub
    };
}
function createAssignmentExpression(left, right) {
    return {
        type: 24,
        left,
        right,
        loc: locStub
    };
}
function createSequenceExpression(expressions) {
    return {
        type: 25,
        expressions,
        loc: locStub
    };
}
function createReturnStatement(returns) {
    return {
        type: 26,
        returns,
        loc: locStub
    };
}
function getVNodeHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
}
function getVNodeBlockHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
}
function convertToBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper(getVNodeHelper(inSSR, node.isComponent));
        helper(OPEN_BLOCK);
        helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
}
const defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function isEndOfTagSection(c) {
    return c === 47 || c === 62 || isWhitespace(c);
}
function toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        for(let i = this.newlines.length - 1; i >= 0; i--){
            const newlineIndex = this.newlines[i];
            if (index > newlineIndex) {
                line = i + 2;
                column = index - newlineIndex;
                break;
            }
        }
        return {
            column,
            line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd || this.currentSequence === Sequences.TextareaEnd && !this.inSFCRoot) {
                if (!this.inVPre && c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if (isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if (isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if (isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA(toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if (isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if (isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === Sequences.ScriptEnd[3]) this.startSpecial(Sequences.ScriptEnd, 4);
        else if (c === Sequences.StyleEnd[3]) this.startSpecial(Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === Sequences.TitleEnd[3]) this.startSpecial(Sequences.TitleEnd, 4);
        else if (c === Sequences.TextareaEnd[3]) this.startSpecial(Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const CompilerDeprecationTypes = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function getCompatValue(key, { compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function isCompatEnabled(key, context) {
    const mode = getCompatValue("MODE", context);
    const value = getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function checkCompatEnabled(key, context, loc, ...args) {
    const enabled = isCompatEnabled(key, context);
    return enabled;
}
function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function defaultOnError(error) {
    throw error;
}
function defaultOnWarn(msg) {}
function createCompilerError(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const ErrorCodes = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_INVALID_EXPRESSION": 45,
    "45": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 46,
    "46": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 47,
    "47": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 48,
    "48": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 49,
    "49": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 50,
    "50": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 51,
    "51": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 52,
    "52": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 53,
    "53": "__EXTEND_POINT__"
};
const errorMessages = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [52]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `Error parsing JavaScript expression: `,
    [46]: `<KeepAlive> expects exactly one child component.`,
    [51]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [47]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [48]: `ES module mode is not supported in this build of compiler.`,
    [49]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [50]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [53]: ``
};
function walkIdentifiers(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function isReferencedIdentifier(id, parent, parentStack) {
    return false;
}
function isInDestructureAssignment(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function isInNewExpression(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function walkFunctionParams(node, onIdent) {
    for (const p of node.params)for (const id of extractIdentifiers(p))onIdent(id);
}
function walkBlockDeclarations(block, onIdent) {
    for (const stmt of block.body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if (isForStatement(stmt)) walkForStatement(stmt, true, onIdent);
    }
}
function isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
    }
}
function extractIdentifiers(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") extractIdentifiers(prop.argument, nodes);
            else extractIdentifiers(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) extractIdentifiers(element, nodes);
            });
            break;
        case "RestElement":
            extractIdentifiers(param.argument, nodes);
            break;
        case "AssignmentPattern":
            extractIdentifiers(param.left, nodes);
            break;
    }
    return nodes;
}
const isFunctionType = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const isStaticProperty = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const isStaticPropertyKey = (node, parent)=>isStaticProperty(parent) && parent.key === node;
const TS_NODE_TYPES = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function unwrapTSNode(node) {
    if (TS_NODE_TYPES.includes(node.type)) return unwrapTSNode(node.expression);
    else return node;
}
const isStaticExp = (p)=>p.type === 4 && p.isStatic;
function isCoreComponent(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return TELEPORT;
        case "Suspense":
        case "suspense":
            return SUSPENSE;
        case "KeepAlive":
        case "keep-alive":
            return KEEP_ALIVE;
        case "BaseTransition":
        case "base-transition":
            return BASE_TRANSITION;
    }
}
const nonIdentifierRE = /^\d|[^\$\w\xA0-\uFFFF]/;
const isSimpleIdentifier = (name)=>!nonIdentifierRE.test(name);
const validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const isMemberExpressionBrowser = (exp)=>{
    const path = getExpSource(exp).trim().replace(whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const isMemberExpressionNode = (0, _shared.NOOP);
const isMemberExpression = isMemberExpressionBrowser;
const fnExpRE = /^\s*(async\s*)?(\([^)]*?\)|[\w$_]+)\s*(:[^=]+)?=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const isFnExpressionBrowser = (exp)=>fnExpRE.test(getExpSource(exp));
const isFnExpressionNode = (0, _shared.NOOP);
const isFnExpression = isFnExpressionBrowser;
function advancePositionWithClone(pos, source, numberOfCharacters = source.length) {
    return advancePositionWithMutation({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function advancePositionWithMutation(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function assert(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function findDir(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, _shared.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && isStaticArgOf(p.arg, name)) return p;
    }
}
function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
}
function hasDynamicKeyVBind(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function isText$1(node) {
    return node.type === 5 || node.type === 2;
}
function isVSlot(p) {
    return p.type === 7 && p.name === "slot";
}
function isTemplateNode(node) {
    return node.type === 1 && node.tagType === 3;
}
function isSlotOutlet(node) {
    return node.type === 1 && node.tagType === 2;
}
const propsHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, _shared.isString)(callee) && propsHelperSet.has(callee)) return getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function injectProp(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const ret = getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, _shared.isString)(props)) propsWithInjection = createObjectExpression([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, _shared.isString)(first) && first.type === 15) {
            if (!hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === TO_HANDLERS) propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift(createObjectExpression([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function toValidAssetId(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function hasScopeRef(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && (hasScopeRef(p.arg, ids) || hasScopeRef(p.exp, ids))) return true;
            }
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 11:
            if (hasScopeRef(node.source, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 9:
            return node.branches.some((b)=>hasScopeRef(b, ids));
        case 10:
            if (hasScopeRef(node.condition, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 4:
            return !node.isStatic && isSimpleIdentifier(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, _shared.isObject)(c) && hasScopeRef(c, ids));
        case 5:
        case 12:
            return hasScopeRef(node.content, ids);
        case 2:
        case 3:
        case 20:
            return false;
        default:
            return false;
    }
}
function getMemoedVNodeCall(node) {
    if (node.type === 14 && node.callee === WITH_MEMO) return node.arguments[1].returns;
    else return node;
}
const forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
const defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, _shared.NO),
    isPreTag: (0, _shared.NO),
    isIgnoreNewlineTag: (0, _shared.NO),
    isCustomElement: (0, _shared.NO),
    onError: defaultOnError,
    onWarn: defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let currentOptions = defaultParserOptions;
let currentRoot = null;
let currentInput = "";
let currentOpenTag = null;
let currentProp = null;
let currentAttrValue = "";
let currentAttrStartIndex = -1;
let currentAttrEndIndex = -1;
let inPre = 0;
let inVPre = false;
let currentVPreBoundary = null;
const stack = [];
const tokenizer = new Tokenizer(stack, {
    onerr: emitError,
    ontext (start, end) {
        onText(getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        onText(char, start, end);
    },
    oninterpolation (start, end) {
        if (inVPre) return onText(getSlice(start, end), start, end);
        let innerStart = start + tokenizer.delimiterOpen.length;
        let innerEnd = end - tokenizer.delimiterClose.length;
        while(isWhitespace(currentInput.charCodeAt(innerStart)))innerStart++;
        while(isWhitespace(currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = currentOptions.decodeEntities(exp, false);
        addNode({
            type: 5,
            content: createExp(exp, false, getLoc(innerStart, innerEnd)),
            loc: getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = getSlice(start, end);
        currentOpenTag = {
            type: 1,
            tag: name,
            ns: currentOptions.getNamespace(name, stack[0], currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = getSlice(start, end);
        if (!currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < stack.length; i++){
                const e = stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) emitError(24, stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = stack.shift();
                        onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) emitError(23, backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = currentOpenTag.tag;
        currentOpenTag.isSelfClosing = true;
        endOpenTag(end);
        if (stack[0] && stack[0].tag === name) onCloseTag(stack.shift(), end);
    },
    onattribname (start, end) {
        currentProp = {
            type: 6,
            name: getSlice(start, end),
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!inVPre && name === "") emitError(26, start);
        if (inVPre || name === "") currentProp = {
            type: 6,
            name: raw,
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
        else {
            currentProp = {
                type: 7,
                name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    createSimpleExpression("prop")
                ] : [],
                loc: getLoc(start)
            };
            if (name === "pre") {
                inVPre = tokenizer.inVPre = true;
                currentVPreBoundary = currentOpenTag;
                const props = currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = getSlice(start, end);
        if (inVPre) {
            currentProp.name += arg;
            setLocEnd(currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            currentProp.arg = createExp(isStatic ? arg : arg.slice(1, -1), isStatic, getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = getSlice(start, end);
        if (inVPre) {
            currentProp.name += "." + mod;
            setLocEnd(currentProp.nameLoc, end);
        } else if (currentProp.name === "slot") {
            const arg = currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                setLocEnd(arg.loc, end);
            }
        } else {
            const exp = createSimpleExpression(mod, true, getLoc(start, end));
            currentProp.modifiers.push(exp);
        }
    },
    onattribdata (start, end) {
        currentAttrValue += getSlice(start, end);
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        currentAttrValue += char;
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = currentProp.loc.start.offset;
        const name = getSlice(start, end);
        if (currentProp.type === 7) currentProp.rawName = name;
        if (currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) emitError(2, start);
    },
    onattribend (quote, end) {
        if (currentOpenTag && currentProp) {
            setLocEnd(currentProp.loc, end);
            if (quote !== 0) {
                if (currentAttrValue.includes("&")) currentAttrValue = currentOptions.decodeEntities(currentAttrValue, true);
                if (currentProp.type === 6) {
                    if (currentProp.name === "class") currentAttrValue = condense(currentAttrValue).trim();
                    if (quote === 1 && !currentAttrValue) emitError(13, end);
                    currentProp.value = {
                        type: 2,
                        content: currentAttrValue,
                        loc: quote === 1 ? getLoc(currentAttrStartIndex, currentAttrEndIndex) : getLoc(currentAttrStartIndex - 1, currentAttrEndIndex + 1)
                    };
                    if (tokenizer.inSFCRoot && currentOpenTag.tag === "template" && currentProp.name === "lang" && currentAttrValue && currentAttrValue !== "html") tokenizer.enterRCDATA(toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    currentProp.exp = createExp(currentAttrValue, false, getLoc(currentAttrStartIndex, currentAttrEndIndex), 0, expParseMode);
                    if (currentProp.name === "for") currentProp.forParseResult = parseForExpression(currentProp.exp);
                    let syncIndex = -1;
                    if (currentProp.name === "bind" && (syncIndex = currentProp.modifiers.findIndex((mod)=>mod.content === "sync")) > -1 && checkCompatEnabled("COMPILER_V_BIND_SYNC", currentOptions, currentProp.loc, currentProp.rawName)) {
                        currentProp.name = "model";
                        currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if (currentProp.type !== 7 || currentProp.name !== "pre") currentOpenTag.props.push(currentProp);
        }
        currentAttrValue = "";
        currentAttrStartIndex = currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if (currentOptions.comments) addNode({
            type: 3,
            content: getSlice(start, end),
            loc: getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = currentInput.length;
        for(let index = 0; index < stack.length; index++){
            onCloseTag(stack[index], end - 1);
            emitError(24, stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if (stack[0].ns !== 0) onText(getSlice(start, end), start, end);
        else emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if ((stack[0] ? stack[0].ns : currentOptions.ns) === 0) emitError(21, start - 1);
    }
});
const forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const stripParensRE = /^\(|\)$/g;
function parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return createExp(content, false, getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace(stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace(forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function getSlice(start, end) {
    return currentInput.slice(start, end);
}
function endOpenTag(end) {
    if (tokenizer.inSFCRoot) currentOpenTag.innerLoc = getLoc(end + 1, end + 1);
    addNode(currentOpenTag);
    const { tag, ns } = currentOpenTag;
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre++;
    if (currentOptions.isVoidTag(tag)) onCloseTag(currentOpenTag, end);
    else {
        stack.unshift(currentOpenTag);
        if (ns === 1 || ns === 2) tokenizer.inXML = true;
    }
    currentOpenTag = null;
}
function onText(content, start, end) {
    {
        const tag = stack[0] && stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = currentOptions.decodeEntities(content, false);
    }
    const parent = stack[0] || currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content,
        loc: getLoc(start, end)
    });
}
function onCloseTag(el, end, isImplied = false) {
    if (isImplied) setLocEnd(el.loc, backTrack(end, 60));
    else setLocEnd(el.loc, lookAhead(end, 62) + 1);
    if (tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, _shared.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, _shared.extend)({}, el.innerLoc.start);
        el.innerLoc.source = getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag, ns, children } = el;
    if (!inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if (isFragmentTemplate(el)) el.tagType = 3;
        else if (isComponent(el)) el.tagType = 1;
    }
    if (!tokenizer.inRCDATA) el.children = condenseWhitespace(children);
    if (ns === 0 && currentOptions.isIgnoreNewlineTag(tag)) {
        const first = children[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre--;
    if (currentVPreBoundary === el) {
        inVPre = tokenizer.inVPre = false;
        currentVPreBoundary = null;
    }
    if (tokenizer.inXML && (stack[0] ? stack[0].ns : currentOptions.ns) === 0) tokenizer.inXML = false;
    {
        const props = el.props;
        if (!tokenizer.inSFCRoot && isCompatEnabled("COMPILER_NATIVE_TEMPLATE", currentOptions) && el.tag === "template" && !isFragmentTemplate(el)) {
            const parent = stack[0] || currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && checkCompatEnabled("COMPILER_INLINE_TEMPLATE", currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function lookAhead(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i < currentInput.length - 1)i++;
    return i;
}
function backTrack(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function isFragmentTemplate({ tag, props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function isComponent({ tag, props }) {
    if (currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || isUpperCase(tag.charCodeAt(0)) || isCoreComponent(tag) || currentOptions.isBuiltInComponent && currentOptions.isBuiltInComponent(tag) || currentOptions.isNativeTag && !currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if (checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "is") && checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
    }
    return false;
}
function isUpperCase(c) {
    return c > 64 && c < 91;
}
const windowsNewlineRE = /\r\n/g;
function condenseWhitespace(nodes, tag) {
    const shouldCondense = currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!inPre) {
                if (isAllWhitespace(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = condense(node.content);
            } else node.content = node.content.replace(windowsNewlineRE, "\n");
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function isAllWhitespace(str) {
    for(let i = 0; i < str.length; i++){
        if (!isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if (isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function addNode(node) {
    (stack[0] || currentRoot).children.push(node);
}
function getLoc(start, end) {
    return {
        start: tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : getSlice(start, end)
    };
}
function setLocEnd(loc, end) {
    loc.end = tokenizer.getPos(end);
    loc.source = getSlice(loc.start.offset, end);
}
function dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc
        };
    }
    return attr;
}
function createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = createSimpleExpression(content, isStatic, loc, constType);
    return exp;
}
function emitError(code, index, message) {
    currentOptions.onError(createCompilerError(code, getLoc(index, index), void 0, message));
}
function reset() {
    tokenizer.reset();
    currentOpenTag = null;
    currentProp = null;
    currentAttrValue = "";
    currentAttrStartIndex = -1;
    currentAttrEndIndex = -1;
    stack.length = 0;
}
function baseParse(input, options) {
    reset();
    currentInput = input;
    currentOptions = (0, _shared.extend)({}, defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) currentOptions[key] = options[key];
    }
    tokenizer.mode = currentOptions.parseMode === "html" ? 1 : currentOptions.parseMode === "sfc" ? 2 : 0;
    tokenizer.inXML = currentOptions.ns === 1 || currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        tokenizer.delimiterOpen = toCharCodes(delimiters[0]);
        tokenizer.delimiterClose = toCharCodes(delimiters[1]);
    }
    const root = currentRoot = createRoot([], input);
    tokenizer.parse(currentInput);
    root.loc = getLoc(0, input.length);
    root.children = condenseWhitespace(root.children);
    currentRoot = null;
    return root;
}
function cacheStatic(root, context) {
    walk(root, void 0, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    isSingleElementRoot(root, root.children[0]));
}
function isSingleElementRoot(root, child) {
    const { children } = root;
    return children.length === 1 && child.type === 1 && !isSlotOutlet(child);
}
function walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children } = node;
    const toCache = [];
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    toCache.push(child);
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12) {
            const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
            if (constantType >= 2) {
                toCache.push(child);
                continue;
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            walk(child, node, context, false, inFor);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) walk(child, node, context, child.children.length === 1, true);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)walk(child.branches[i2], node, context, child.branches[i2].children.length === 1, inFor);
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
        if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, _shared.isArray)(node.codegenNode.children)) {
            node.codegenNode.children = getCacheExpression(createArrayExpression(node.codegenNode.children));
            cachedAsArray = true;
        } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !(0, _shared.isArray)(node.codegenNode.children) && node.codegenNode.children.type === 15) {
            const slot = getSlotNode(node.codegenNode, "default");
            if (slot) {
                slot.returns = getCacheExpression(createArrayExpression(slot.returns));
                cachedAsArray = true;
            }
        } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !(0, _shared.isArray)(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
            const slotName = findDir(node, "slot", true);
            const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
            if (slot) {
                slot.returns = getCacheExpression(createArrayExpression(slot.returns));
                cachedAsArray = true;
            }
        }
    }
    if (!cachedAsArray) for (const child of toCache)child.codegenNode = context.cache(child.codegenNode);
    function getCacheExpression(value) {
        const exp = context.cache(value);
        if (inFor && context.hmr) exp.needArraySpread = true;
        return exp;
    }
    function getSlotNode(node2, name) {
        if (node2.children && !(0, _shared.isArray)(node2.children) && node2.children.type === 15) {
            const slot = node2.children.properties.find((p)=>p.key === name || p.key.content === name);
            return slot && slot.value;
        }
    }
    if (toCache.length && context.transformHoist) context.transformHoist(children, context, node);
}
function getConstantType(node, context) {
    const { constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = getConstantType(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = getConstantType(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper(OPEN_BLOCK);
                    context.removeHelper(getVNodeBlockHelper(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return getConstantType(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, _shared.isString)(child) || (0, _shared.isSymbol)(child)) continue;
                const childType = getConstantType(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        case 20:
            return 2;
        default:
            return 0;
    }
}
const allowHoistedHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_CLASS,
    NORMALIZE_STYLE,
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, _shared.isString)(value.callee) && allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return getConstantType(arg, context);
        else if (arg.type === 14) return getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = getNodeProps(node);
    if (props && props.type === 15) {
        const { properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key, value } = properties[i];
            const keyType = getConstantType(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = getConstantType(value, context);
            else if (value.type === 14) valueType = getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function createTransformContext(root, { filename = "", prefixIdentifiers = false, hoistStatic = false, hmr = false, cacheHandlers = false, nodeTransforms = [], directiveTransforms = {}, transformHoist = null, isBuiltInComponent = (0, _shared.NOOP), isCustomElement = (0, _shared.NOOP), expressionPlugins = [], scopeId = null, slotted = true, ssr = false, inSSR = false, ssrCssVars = ``, bindingMetadata = (0, _shared.EMPTY_OBJ), inline = false, isTS = false, onError = defaultOnError, onWarn = defaultOnWarn, compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        // options
        filename,
        selfName: nameMatch && (0, _shared.capitalize)((0, _shared.camelize)(nameMatch[1])),
        prefixIdentifiers,
        hoistStatic,
        hmr,
        cacheHandlers,
        nodeTransforms,
        directiveTransforms,
        transformHoist,
        isBuiltInComponent,
        isCustomElement,
        expressionPlugins,
        scopeId,
        slotted,
        ssr,
        inSSR,
        ssrCssVars,
        bindingMetadata,
        inline,
        isTS,
        onError,
        onWarn,
        compatConfig,
        // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        cached: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        temps: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${helperNameMap[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, _shared.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, _shared.isString)(exp)) exp = createSimpleExpression(exp);
            context.hoists.push(exp);
            const identifier = createSimpleExpression(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false) {
            const cacheExp = createCacheExpression(context.cached.length, exp, isVNode);
            context.cached.push(cacheExp);
            return cacheExp;
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function transform(root, options) {
    const context = createTransformContext(root, options);
    traverseNode(root, context);
    if (options.hoistStatic) cacheStatic(root, context);
    if (!options.ssr) createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function createRootCodegen(root, context) {
    const { helper } = context;
    const { children } = root;
    if (children.length === 1) {
        const child = children[0];
        if (isSingleElementRoot(root, child) && child.codegenNode) {
            const codegenNode = child.codegenNode;
            if (codegenNode.type === 13) convertToBlock(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = child;
    } else if (children.length > 1) {
        let patchFlag = 64;
        root.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, _shared.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        traverseNode(child, context);
    }
}
function traverseNode(node, context) {
    context.currentNode = node;
    const { nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, _shared.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper(CREATE_COMMENT);
            break;
        case 5:
            if (!context.ssr) context.helper(TO_DISPLAY_STRING);
            break;
        // for container types, further traverse downwards
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)traverseNode(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function createStructuralDirectiveTransform(name, fn) {
    const matches = (0, _shared.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props } = node;
            if (node.tagType === 3 && props.some(isVSlot)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const PURE_ANNOTATION = `/*@__PURE__*/`;
const aliasHelper = (s)=>`${helperNameMap[s]}: _${helperNameMap[s]}`;
function createCodegenContext(ast, { mode = "function", prefixIdentifiers = mode === "module", sourceMap = false, filename = `template.vue.html`, scopeId = null, optimizeImports = false, runtimeGlobalName = `Vue`, runtimeModuleName = `vue`, ssrRuntimeModuleName = "vue/server-renderer", ssr = false, isTS = false, inSSR = false }) {
    const context = {
        mode,
        prefixIdentifiers,
        sourceMap,
        filename,
        scopeId,
        optimizeImports,
        runtimeGlobalName,
        runtimeModuleName,
        ssrRuntimeModuleName,
        ssr,
        isTS,
        inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${helperNameMap[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function generate(ast, options = {}) {
    const context = createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode, push, prefixIdentifiers, indent, deindent, newline, scopeId, ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map(aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function genFunctionPreamble(ast, context) {
    const { ssr, prefixIdentifiers, push, newline, runtimeModuleName, runtimeGlobalName, ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                CREATE_VNODE,
                CREATE_ELEMENT_VNODE,
                CREATE_COMMENT,
                CREATE_TEXT,
                CREATE_STATIC
            ].filter((helper)=>helpers.includes(helper)).map(aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(type === "filter" ? RESOLVE_FILTER : type === "component" ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push, newline } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = `);
            genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function isText(n) {
    return (0, _shared.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, _shared.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, _shared.isArray)(node)) genNodeListAsArray(node, context);
        else genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function genNode(node, context) {
    if ((0, _shared.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, _shared.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            genNode(node.codegenNode, context);
            break;
        case 2:
            genText(node, context);
            break;
        case 4:
            genExpression(node, context);
            break;
        case 5:
            genInterpolation(node, context);
            break;
        case 12:
            genNode(node.codegenNode, context);
            break;
        case 8:
            genCompoundExpression(node, context);
            break;
        case 3:
            genComment(node, context);
            break;
        case 13:
            genVNodeCall(node, context);
            break;
        case 14:
            genCallExpression(node, context);
            break;
        case 15:
            genObjectExpression(node, context);
            break;
        case 17:
            genArrayExpression(node, context);
            break;
        case 18:
            genFunctionExpression(node, context);
            break;
        case 19:
            genConditionalExpression(node, context);
            break;
        case 20:
            genCacheExpression(node, context);
            break;
        case 21:
            genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        /* v8 ignore start */ case 10:
            break;
        default:
    }
}
function genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
}
function genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, _shared.isString)(child)) context.push(child, -3 /* Unknown */ );
        else genNode(child, context);
    }
}
function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8) {
        push(`[`);
        genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = isSimpleIdentifier(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const { tag, props, children, patchFlag, dynamicProps, directives, isBlock, disableTracking, isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper(WITH_DIRECTIVES) + `(`);
    if (isBlock) push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    if (pure) push(PURE_ANNOTATION);
    const callHelper = isBlock ? getVNodeBlockHelper(context.inSSR, isComponent) : getVNodeHelper(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    genNodeList(genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        genNode(directives, context);
        push(`)`);
    }
}
function genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = (0, _shared.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push(PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    genNodeList(node.arguments, context);
    push(`)`);
}
function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key, value } = properties[i];
        genExpressionAsPropertyKey(key, context);
        push(`: `);
        genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
}
function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) push(`_${helperNameMap[WITH_CTX]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, _shared.isArray)(params)) genNodeList(params, context);
    else if (params) genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, _shared.isArray)(returns)) genNodeListAsArray(returns, context);
        else genNode(returns, context);
    } else if (body) genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function genConditionalExpression(node, context) {
    const { test, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test.type === 4) {
        const needsParens = !isSimpleIdentifier(test.content);
        needsParens && push(`(`);
        genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    const { needPauseTracking, needArraySpread } = node;
    if (needArraySpread) push(`[...(`);
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
        indent();
        push(`${helper(SET_BLOCK_TRACKING)}(-1),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (needPauseTracking) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper(SET_BLOCK_TRACKING)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
    if (needArraySpread) push(`)]`);
}
const prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError(createCompilerError(45, node.loc, void 0, message));
    }
}
const transformExpression = (node, context)=>{
    if (node.type === 5) node.content = processExpression(node.content, context);
    else if (node.type === 1) for(let i = 0; i < node.props.length; i++){
        const dir = node.props[i];
        if (dir.type === 7 && dir.name !== "for") {
            const exp = dir.exp;
            const arg = dir.arg;
            if (exp && exp.type === 4 && !(dir.name === "on" && arg)) dir.exp = processExpression(exp, context, // slot args must be processed as function params
            dir.name === "slot");
            if (arg && arg.type === 4 && !arg.isStatic) dir.arg = processExpression(arg, context);
        }
    }
};
function processExpression(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function stringifyExpression(exp) {
    if ((0, _shared.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map(stringifyExpression).join("");
}
const transformIf = createStructuralDirectiveTransform(/^(if|else|else-if)$/, (node, dir, context)=>{
    return processIf(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function processIf(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError(createCompilerError(28, dir.loc));
        dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: node.loc,
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && sibling.type === 3) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 2 && !sibling.content.trim().length) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if (dir.name === "else-if" && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError(createCompilerError(30, node.loc));
                context.removeNode();
                const branch = createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                traverseNode(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError(createCompilerError(30, node.loc));
            break;
        }
    }
}
function createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !findDir(node, "for") ? node.children : [
            node
        ],
        userKey: findProp(node, `key`),
        isTemplateIf
    };
}
function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return createConditionalExpression(branch.condition, createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    createCallExpression(context.helper(CREATE_COMMENT), [
        '""',
        "true"
    ]));
    else return createChildrenCodegenNode(branch, keyIndex, context);
}
function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(`key`, createSimpleExpression(`${keyIndex}`, false, locStub, 2));
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            injectProp(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            return createVNodeCall(context, helper(FRAGMENT), createObjectExpression([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = getMemoedVNodeCall(ret);
        if (vnodeCall.type === 13) convertToBlock(vnodeCall, context);
        injectProp(vnodeCall, keyProperty, context);
        return ret;
    }
}
function isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const transformBind = (dir, _node, context)=>{
    const { modifiers, loc } = dir;
    const arg = dir.arg;
    let { exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (!exp) {
        if (arg.type !== 4 || !arg.isStatic) {
            context.onError(createCompilerError(52, arg.loc));
            return {
                props: [
                    createObjectProperty(arg, createSimpleExpression("", true, loc))
                ]
            };
        }
        transformBindShorthand(dir);
        exp = dir.exp;
    }
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = `${arg.content} || ""`;
    if (modifiers.some((mod)=>mod.content === "camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, _shared.camelize)(arg.content);
            else arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.some((mod)=>mod.content === "prop")) injectPrefix(arg, ".");
        if (modifiers.some((mod)=>mod.content === "attr")) injectPrefix(arg, "^");
    }
    return {
        props: [
            createObjectProperty(arg, exp)
        ]
    };
};
const transformBindShorthand = (dir, context)=>{
    const arg = dir.arg;
    const propName = (0, _shared.camelize)(arg.content);
    dir.exp = createSimpleExpression(propName, false, arg.loc);
};
const injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const transformFor = createStructuralDirectiveTransform("for", (node, dir, context)=>{
    const { helper, removeHelper } = context;
    return processFor(node, dir, context, (forNode)=>{
        const renderExp = createCallExpression(helper(RENDER_LIST), [
            forNode.source
        ]);
        const isTemplate = isTemplateNode(node);
        const memo = findDir(node, "memo");
        const keyProp = findProp(node, `key`, false, true);
        if (keyProp && keyProp.type === 7 && !keyProp.exp) transformBindShorthand(keyProp);
        const keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? createSimpleExpression(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? createObjectProperty(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            let childBlock;
            const { children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = isSlotOutlet(node) ? node : isTemplate && node.children.length === 1 && isSlotOutlet(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = createVNodeCall(context, helper(FRAGMENT), keyProperty ? createObjectExpression([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        removeHelper(OPEN_BLOCK);
                        removeHelper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                    } else removeHelper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper(OPEN_BLOCK);
                    helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                } else helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = createFunctionExpression(createForLoopParams(forNode.parseResult, [
                    createSimpleExpression(`_cached`)
                ]));
                loop.body = createBlockStatement([
                    createCompoundExpression([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    createCompoundExpression([
                        `if (_cached`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString(IS_MEMO_SAME)}(_cached, _memo)) return _cached`
                    ]),
                    createCompoundExpression([
                        `const _item = `,
                        childBlock
                    ]),
                    createSimpleExpression(`_item.memo = _memo`),
                    createSimpleExpression(`return _item`)
                ]);
                renderExp.arguments.push(loop, createSimpleExpression(`_cache`), createSimpleExpression(String(context.cached.length)));
                context.cached.push(null);
            } else renderExp.arguments.push(createFunctionExpression(createForLoopParams(forNode.parseResult), childBlock, true));
        };
    });
});
function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError(createCompilerError(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError(createCompilerError(32, dir.loc));
        return;
    }
    finalizeForParseResult(parseResult, context);
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult,
        children: isTemplateNode(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || createSimpleExpression(`_`.repeat(i2 + 1), false));
}
const defaultFallback = createSimpleExpression(`undefined`, false);
const trackSlotScopes = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = findDir(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const trackVForSlotScopes = (node, context)=>{
    let vFor;
    if (isTemplateNode(node) && node.props.some(isVSlot) && (vFor = findDir(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            finalizeForParseResult(result, context);
            const { value, key, index } = result;
            const { addIdentifiers, removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const buildClientSlotFn = (props, _vForExp, children, loc)=>createFunctionExpression(props, children, false, true, children.length ? children[0].loc : loc);
function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = findDir(node, "slot", true);
    if (onComponentSlot) {
        const { arg, exp } = onComponentSlot;
        if (arg && !isStaticExp(arg)) hasDynamicSlots = true;
        slotsProperties.push(createObjectProperty(arg || createSimpleExpression("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!isTemplateNode(slotElement) || !(slotDir = findDir(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError(createCompilerError(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = createSimpleExpression(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if (isStaticExp(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = findDir(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = findDir(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push(createConditionalExpression(vIf.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback));
        } else if (vElse = findDir(slotElement, /^else(-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (prev.type !== 3) break;
            }
            if (prev && isTemplateNode(prev) && findDir(prev, /^(else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? createConditionalExpression(vElse.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback) : buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError(createCompilerError(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                finalizeForParseResult(parseResult, context);
                dynamicSlots.push(createCallExpression(context.helper(RENDER_LIST), [
                    parseResult.source,
                    createFunctionExpression(createForLoopParams(parseResult), buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError(createCompilerError(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError(createCompilerError(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push(createObjectProperty(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return createObjectProperty(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        implicitDefaultChildren.some((node2)=>isNonWhitespaceContent(node2))) {
            if (hasNamedDefaultSlot) context.onError(createCompilerError(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : hasForwardedSlots(node.children) ? 3 : 1;
    let slots = createObjectExpression(slotsProperties.concat(createObjectProperty(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    createSimpleExpression(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = createCallExpression(context.helper(CREATE_SLOTS), [
        slots,
        createArrayExpression(dynamicSlots)
    ]);
    return {
        slots,
        hasDynamicSlots
    };
}
function buildDynamicSlot(name, fn, index) {
    const props = [
        createObjectProperty(`name`, name),
        createObjectProperty(`fn`, fn)
    ];
    if (index != null) props.push(createObjectProperty(`key`, createSimpleExpression(String(index), true)));
    return createObjectExpression(props);
}
function hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if (hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if (hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
function isNonWhitespaceContent(node) {
    if (node.type !== 2 && node.type !== 12) return true;
    return node.type === 2 ? !!node.content.trim() : isNonWhitespaceContent(node.content);
}
const directiveImportMap = /* @__PURE__ */ new WeakMap();
const transformElement = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag, props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? resolveComponentType(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, _shared.isObject)(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === TELEPORT || vnodeTag === SUSPENSE || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = buildProps(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? createArrayExpression(directives.map((dir)=>buildDirectiveArgs(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === KEEP_ALIVE) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== TELEPORT && // explained above.
            vnodeTag !== KEEP_ALIVE;
            if (shouldBuildAsSlots) {
                const { slots, hasDynamicSlots } = buildSlots(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && getConstantType(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
        node.codegenNode = createVNodeCall(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && createSimpleExpression(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = createSimpleExpression(`is`, false, isProp.arg.loc);
            }
            if (exp) return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
}
function buildProps(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push(createObjectProperty(createSimpleExpression("ref_for", true), createSimpleExpression("true")));
    };
    const analyzePatchFlag = ({ key, value })=>{
        if (isStaticExp(key)) {
            const name = key.content;
            const isEventHandler = (0, _shared.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, _shared.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, _shared.isReservedProp)(name)) hasVnodeHook = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && getConstantType(value, context) > 0) return;
            if (name === "ref") hasRef = true;
            else if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc, name, nameLoc, value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && (isComponentTag(tag) || value && value.content.startsWith("vue:") || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push(createObjectProperty(createSimpleExpression(name, true, nameLoc), createSimpleExpression(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name, arg, exp, loc, modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError(createCompilerError(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && isStaticArgOf(arg, "is") && (isComponentTag(tag) || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && isStaticArgOf(arg, "key") || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && isStaticArgOf(arg, "vue:before-update")) shouldUseBlock = true;
            if (isVBind && isStaticArgOf(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushRefVForMarker();
                        pushMergeArg();
                        if (isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc,
                        callee: context.helper(TO_HANDLERS),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError(createCompilerError(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.some((mod)=>mod.content === "prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !isStaticExp(arg)) pushMergeArg(createObjectExpression(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, _shared.isSymbol)(needRuntime)) directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, _shared.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = createCallExpression(context.helper(MERGE_PROPS), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = createObjectExpression(dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if (isStaticExp(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !isStaticExp(classProp.value)) classProp.value = createCallExpression(context.helper(NORMALIZE_CLASS), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = createCallExpression(context.helper(NORMALIZE_STYLE), [
                    styleProp.value
                ]);
            } else propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag,
        dynamicPropNames,
        shouldUseBlock
    };
}
function dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, _shared.isOn)(name)) mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = createArrayExpression([
        existing.value,
        incoming.value
    ], existing.loc);
}
function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper(RESOLVE_DIRECTIVE);
        context.directives.add(dir.name);
        dirArgs.push(toValidAssetId(dir.name, `directive`));
    }
    const { loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = createSimpleExpression(`true`, false, loc);
        dirArgs.push(createObjectExpression(dir.modifiers.map((modifier)=>createObjectProperty(modifier, trueExpression)), loc));
    }
    return createArrayExpression(dirArgs, dir.loc);
}
function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const transformSlotOutlet = (node, context)=>{
    if (isSlotOutlet(node)) {
        const { children, loc } = node;
        const { slotName, slotProps } = processSlotOutlet(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = createFunctionExpression([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = createCallExpression(context.helper(RENDER_SLOT), slotArgs, loc);
    }
};
function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, _shared.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, _shared.camelize)(p.arg.content);
                slotName = p.exp = createSimpleExpression(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && isStaticExp(p.arg)) p.arg.content = (0, _shared.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props, directives } = buildProps(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError(createCompilerError(36, directives[0].loc));
    }
    return {
        slotName,
        slotProps
    };
}
const transformOn = (dir, node, context, augmentor)=>{
    const { loc, modifiers, arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError(createCompilerError(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, _shared.toHandlerKey)((0, _shared.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = createSimpleExpression(eventString, true, arg.loc);
        } else eventName = createCompoundExpression([
            `${context.helperString(TO_HANDLER_KEY)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = isMemberExpression(exp);
        const isInlineStatement = !(isMemberExp || isFnExpression(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = createCompoundExpression([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            createObjectProperty(eventName, exp || createSimpleExpression(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if (isText$1(next)) {
                        if (!currentContainer) currentContainer = children[i] = createCompoundExpression([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && getConstantType(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: createCallExpression(context.helper(CREATE_TEXT), callArgs)
                };
            }
        }
    };
};
const seen$1 = /* @__PURE__ */ new WeakSet();
const transformOnce = (node, context)=>{
    if (node.type === 1 && findDir(node, "once", true)) {
        if (seen$1.has(node) || context.inVOnce || context.inSSR) return;
        seen$1.add(node);
        context.inVOnce = true;
        context.helper(SET_BLOCK_TRACKING);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true);
        };
    }
};
const transformModel = (dir, node, context)=>{
    const { exp, arg } = dir;
    if (!exp) {
        context.onError(createCompilerError(41, dir.loc));
        return createTransformProps();
    }
    const rawExp = exp.loc.source;
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError(createCompilerError(44, exp.loc));
        return createTransformProps();
    }
    const maybeRef = false;
    if (!expString.trim() || !isMemberExpression(exp) && !maybeRef) {
        context.onError(createCompilerError(42, exp.loc));
        return createTransformProps();
    }
    const propName = arg ? arg : createSimpleExpression("modelValue", true);
    const eventName = arg ? isStaticExp(arg) ? `onUpdate:${(0, _shared.camelize)(arg.content)}` : createCompoundExpression([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = createCompoundExpression([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        createObjectProperty(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        createObjectProperty(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>m.content).map((m)=>(isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? isStaticExp(arg) ? `${arg.content}Modifiers` : createCompoundExpression([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push(createObjectProperty(modifiersKey, createSimpleExpression(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return createTransformProps(props);
};
function createTransformProps(props = []) {
    return {
        props
    };
}
const validDivisionCharRE = /[\w).+\-_$\]]/;
const transformFilter = (node, context)=>{
    if (!isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) rewriteFilter(prop.exp, context);
    });
};
function rewriteFilter(node, context) {
    if (node.type === 4) parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) parseFilter(child, context);
        else if (child.type === 8) rewriteFilter(node, context);
        else if (child.type === 5) rewriteFilter(child.content, context);
    }
}
function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                // "
                case 39:
                    inSingle = true;
                    break;
                // '
                case 96:
                    inTemplateString = true;
                    break;
                // `
                case 40:
                    paren++;
                    break;
                // (
                case 41:
                    paren--;
                    break;
                // )
                case 91:
                    square++;
                    break;
                // [
                case 93:
                    square--;
                    break;
                // ]
                case 123:
                    curly++;
                    break;
                // {
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function wrapFilter(exp, filter, context) {
    context.helper(RESOLVE_FILTER);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${toValidAssetId(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${toValidAssetId(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const seen = /* @__PURE__ */ new WeakSet();
const transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = findDir(node, "memo");
        if (!dir || seen.has(node)) return;
        seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) convertToBlock(codegenNode, context);
                node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
                    dir.exp,
                    createFunctionExpression(void 0, codegenNode),
                    `_cache`,
                    String(context.cached.length)
                ]);
                context.cached.push(null);
            }
        };
    }
};
function getBaseTransformPreset(prefixIdentifiers) {
    return [
        [
            transformOnce,
            transformIf,
            transformMemo,
            transformFor,
            transformFilter,
            transformSlotOutlet,
            transformElement,
            trackSlotScopes,
            transformText
        ],
        {
            on: transformOn,
            bind: transformBind,
            model: transformModel
        }
    ];
}
function baseCompile(source, options = {}) {
    const onError = options.onError || defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError(createCompilerError(47));
    else if (isModuleMode) onError(createCompilerError(48));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError(createCompilerError(49));
    if (options.scopeId && !isModuleMode) onError(createCompilerError(50));
    const resolvedOptions = (0, _shared.extend)({}, options, {
        prefixIdentifiers
    });
    const ast = (0, _shared.isString)(source) ? baseParse(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(ast, (0, _shared.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return generate(ast, resolvedOptions);
}
const BindingTypes = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const noopDirectiveTransform = ()=>({
        props: []
    });

},{"@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWi60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("e1990f4550e09573");
    if (script.__esModule) script = script.default;
    script.render = require("ca31cee8a8f13827").render;
    require("4b0d243d054aa291").default(script);
    script.__scopeId = 'data-v-e54e4f';
    script.__file = "LoginForm.vue";
};
initialize();
exports.default = script;

},{"e1990f4550e09573":"6A7qH","ca31cee8a8f13827":"IkNSh","4b0d243d054aa291":"fkVXI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6A7qH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
// Reactive state
exports.default = {
    __name: 'LoginForm',
    setup (__props, { expose: __expose }) {
        __expose();
        const username = (0, _vue.ref)('');
        const password = (0, _vue.ref)('');
        const errorMessage = (0, _vue.ref)(null);
        const loading = (0, _vue.ref)(false);
        const showPassword = (0, _vue.ref)(false);
        const isLocked = (0, _vue.ref)(false);
        const cooldownSecondsRemaining = (0, _vue.ref)(0);
        let cooldownInterval = null;
        // Clears only the transient wrong-password error when the user edits their credentials.
        // Cooldown and locked states are server-driven and must not be cleared by typing.
        const clearGenericError = ()=>{
            if (!isLocked.value && cooldownSecondsRemaining.value === 0) errorMessage.value = null;
        };
        const toggleShowPassword = ()=>{
            showPassword.value = !showPassword.value;
        };
        const formatCooldown = (seconds)=>{
            if (seconds <= 0) return '0s';
            if (seconds < 60) return `${seconds}s`;
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return secs === 0 ? `${mins}m` : `${mins}m ${secs}s`;
        };
        const startCooldownCountdown = (seconds)=>{
            clearInterval(cooldownInterval);
            cooldownSecondsRemaining.value = seconds;
            cooldownInterval = setInterval(()=>{
                if (cooldownSecondsRemaining.value <= 1) {
                    cooldownSecondsRemaining.value = 0;
                    clearInterval(cooldownInterval);
                    cooldownInterval = null;
                } else cooldownSecondsRemaining.value--;
            }, 1000);
        };
        const handleLogin = async ()=>{
            if (loading.value || isLocked.value || cooldownSecondsRemaining.value > 0) return;
            loading.value = true;
            errorMessage.value = null;
            try {
                const response = await fetch('/api/authenticate/login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: username.value,
                        password: password.value
                    })
                });
                if (response.redirected) // Successful login — follow the server redirect
                window.location.href = response.url;
                else if (response.status === 403) {
                    // Account is hard-locked; requires admin to unlock
                    isLocked.value = true;
                    const text = await response.text();
                    errorMessage.value = text || 'Your account has been locked. Please contact support to regain access.';
                } else if (response.status === 429) {
                    // Cooldown window active — read Retry-After header for precise duration
                    const retryAfter = parseInt(response.headers.get('Retry-After'), 10);
                    if (retryAfter > 0) startCooldownCountdown(retryAfter);
                    else // Fallback if header is missing
                    startCooldownCountdown(30);
                    // Consume response body (not shown — countdown handles the UX)
                    await response.text();
                } else {
                    const errorText = await response.text();
                    errorMessage.value = errorText || 'Invalid username or password.';
                }
            } catch (error) {
                errorMessage.value = 'An error occurred. Please try again later.';
            } finally{
                loading.value = false;
            }
        };
        // Clean up the interval if the component is ever torn down
        (0, _vue.onUnmounted)(()=>{
            clearInterval(cooldownInterval);
        });
        const __returned__ = {
            username,
            password,
            errorMessage,
            loading,
            showPassword,
            isLocked,
            cooldownSecondsRemaining,
            get cooldownInterval () {
                return cooldownInterval;
            },
            set cooldownInterval (v){
                cooldownInterval = v;
            },
            clearGenericError,
            toggleShowPassword,
            formatCooldown,
            startCooldownCountdown,
            handleLogin,
            ref: (0, _vue.ref),
            onUnmounted: (0, _vue.onUnmounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IkNSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card login-dark"
};
const _hoisted_5 = {
    class: "login-main"
};
const _hoisted_6 = {
    key: 0,
    class: "alert alert-danger d-flex align-items-start gap-2 py-3",
    role: "alert"
};
const _hoisted_7 = {
    style: {
        "font-size": "0.9rem"
    }
};
const _hoisted_8 = {
    key: 1,
    class: "alert alert-warning d-flex align-items-start gap-2 py-3",
    role: "alert"
};
const _hoisted_9 = {
    style: {
        "font-size": "0.9rem"
    }
};
const _hoisted_10 = {
    key: 2,
    class: "text-danger"
};
const _hoisted_11 = {
    class: "form-group"
};
const _hoisted_12 = {
    class: "form-group"
};
const _hoisted_13 = {
    class: "form-input position-relative"
};
const _hoisted_14 = [
    "type"
];
const _hoisted_15 = {
    class: "form-group mb-0 checkbox-checked"
};
const _hoisted_16 = {
    class: "text-end mt-3"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    key: 0
};
const _hoisted_19 = {
    key: 1
};
const _hoisted_20 = {
    key: 2
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("a", {
                                class: "logo",
                                href: "#"
                            }, [
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-light m-auto",
                                    src: "assets/images/logo.svg",
                                    alt: "loginpage"
                                }),
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-dark",
                                    src: "assets/images/logo.svg",
                                    alt: "logo"
                                })
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            (0, _vue.createElementVNode)("form", {
                                class: "theme-form",
                                onSubmit: (0, _vue.withModifiers)($setup.handleLogin, [
                                    "prevent"
                                ])
                            }, [
                                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("h2", {
                                    class: "text-center"
                                }, "Sign In", -1)),
                                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("p", {
                                    class: "text-center"
                                }, "Enter your email & password to login", -1)),
                                $setup.isLocked ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, [
                                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("span", {
                                        style: {
                                            "font-size": "1.1rem"
                                        }
                                    }, "\uD83D\uDD12", -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("strong", null, "Account locked", -1)),
                                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("br", null, null, -1)),
                                        (0, _vue.createElementVNode)("span", _hoisted_7, (0, _vue.toDisplayString)($setup.errorMessage), 1)
                                    ])
                                ])) : $setup.cooldownSecondsRemaining > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("span", {
                                        style: {
                                            "font-size": "1.1rem"
                                        }
                                    }, "\u23F1", -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("strong", null, "Too many failed attempts", -1)),
                                        _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("br", null, null, -1)),
                                        (0, _vue.createElementVNode)("span", _hoisted_9, [
                                            _cache[5] || (_cache[5] = (0, _vue.createTextVNode)(" Please wait ")),
                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatCooldown($setup.cooldownSecondsRemaining)), 1),
                                            _cache[6] || (_cache[6] = (0, _vue.createTextVNode)(" before trying again. "))
                                        ])
                                    ])
                                ])) : $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_10, (0, _vue.toDisplayString)($setup.errorMessage), 1)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createElementVNode)("div", _hoisted_11, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Email Address", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "email",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.username = $event),
                                        required: "",
                                        placeholder: "email@address.com",
                                        onInput: $setup.clearGenericError
                                    }, null, 544), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.username
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_12, [
                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: $setup.showPassword ? 'text' : 'password',
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event),
                                            required: "",
                                            placeholder: "*********",
                                            autocomplete: "current-password",
                                            onInput: $setup.clearGenericError
                                        }, null, 40, _hoisted_14), [
                                            [
                                                (0, _vue.vModelDynamic),
                                                $setup.password
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "show-hide",
                                            onClick: $setup.toggleShowPassword
                                        }, _cache[11] || (_cache[11] = [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "show"
                                            }, null, -1)
                                        ]))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_15, [
                                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                                        (0, _vue.createElementVNode)("button", {
                                            class: "btn btn-primary btn-block w-100",
                                            type: "submit",
                                            disabled: $setup.loading || $setup.isLocked || $setup.cooldownSecondsRemaining > 0
                                        }, [
                                            $setup.isLocked ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_18, "Account Locked")) : $setup.cooldownSecondsRemaining > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_19, " Try again in " + (0, _vue.toDisplayString)($setup.formatCooldown($setup.cooldownSecondsRemaining)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_20, "Sign in"))
                                        ], 8, _hoisted_17)
                                    ])
                                ])
                            ], 32)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fkVXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"inYgz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("2fdc809b1128eee3");
    if (script.__esModule) script = script.default;
    script.render = require("9c5523d0d4121dcc").render;
    require("4d11df82a6e51e37").default(script);
    script.__scopeId = 'data-v-26a22d';
    script.__file = "PasswordResetForm.vue";
};
initialize();
exports.default = script;

},{"2fdc809b1128eee3":"hOlkX","9c5523d0d4121dcc":"8LBTe","4d11df82a6e51e37":"gD1ml","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOlkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'PasswordResetForm',
    props: {
        token: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Reactive state
        const newPassword = (0, _vue.ref)('');
        const confirmPassword = (0, _vue.ref)('');
        const loading = (0, _vue.ref)(false);
        const showPassword = (0, _vue.ref)(false);
        const errorMessage = (0, _vue.ref)(null);
        const togglePassword = ()=>{
            showPassword.value = !showPassword.value;
        };
        const handleResetPassword = async ()=>{
            if (loading.value) return;
            // Validate passwords match
            if (newPassword.value !== confirmPassword.value) {
                errorMessage.value = 'Passwords do not match!';
                return;
            }
            loading.value = true;
            errorMessage.value = null;
            try {
                const response = await fetch('/api/authenticate/reset-password', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        newPassword: newPassword.value,
                        token: props.token
                    })
                });
                if (response.redirected) // Redirect to login page upon success
                window.location.href = '/';
                else {
                    // If response is not OK, show error message
                    const errorText = await response.text();
                    errorMessage.value = errorText || 'Failed to reset password. Please try again.';
                }
            } catch (error) {
                errorMessage.value = 'An error occurred. Please try again later.';
                console.error('Error resetting password:', error);
            } finally{
                loading.value = false;
            }
        };
        const __returned__ = {
            props,
            newPassword,
            confirmPassword,
            loading,
            showPassword,
            errorMessage,
            togglePassword,
            handleResetPassword,
            ref: (0, _vue.ref)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LBTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card login-dark"
};
const _hoisted_5 = {
    class: "login-main"
};
const _hoisted_6 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_7 = {
    class: "form-group"
};
const _hoisted_8 = {
    class: "form-input position-relative"
};
const _hoisted_9 = [
    "type"
];
const _hoisted_10 = {
    class: "form-group"
};
const _hoisted_11 = {
    class: "form-group mb-0 checkbox-checked"
};
const _hoisted_12 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("a", {
                                class: "logo",
                                href: "#"
                            }, [
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-light m-auto",
                                    src: "assets/images/logo-light.png",
                                    alt: "resetpage"
                                }),
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-dark",
                                    src: "assets/images/logo-dark.png",
                                    alt: "logo"
                                })
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            (0, _vue.createElementVNode)("form", {
                                class: "theme-form",
                                onSubmit: (0, _vue.withModifiers)($setup.handleResetPassword, [
                                    "prevent"
                                ])
                            }, [
                                _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("h2", null, "Reset Your Password", -1)),
                                $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_6, (0, _vue.toDisplayString)($setup.errorMessage), 1)) : (0, _vue.createCommentVNode)("", true),
                                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("h6", {
                                    class: "mt-4 f-w-700"
                                }, "Create Your Password", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "New Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: $setup.showPassword ? 'text' : 'password',
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.newPassword = $event),
                                            required: "",
                                            placeholder: "*********"
                                        }, null, 8, _hoisted_9), [
                                            [
                                                (0, _vue.vModelDynamic),
                                                $setup.newPassword
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "show-hide",
                                            onClick: $setup.togglePassword
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: (0, _vue.normalizeClass)($setup.showPassword ? 'hide' : 'show')
                                            }, null, 2)
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_10, [
                                    _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Retype Password", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "password",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.confirmPassword = $event),
                                        required: "",
                                        placeholder: "*********"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.confirmPassword
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_11, [
                                    (0, _vue.createElementVNode)("button", {
                                        class: "btn btn-primary btn-block w-100 mt-3",
                                        type: "submit",
                                        disabled: $setup.loading
                                    }, (0, _vue.toDisplayString)($setup.loading ? 'Resetting...' : 'Reset Password'), 9, _hoisted_12)
                                ])
                            ], 32)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gD1ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZPUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("9d9cfa2f295e4b3b");
    if (script.__esModule) script = script.default;
    script.render = require("51021d538e74fa4a").render;
    require("4a6f45ac435baa45").default(script);
    script.__scopeId = 'data-v-5aba5d';
    script.__file = "DispatchDashboard.vue";
};
initialize();
exports.default = script;

},{"9d9cfa2f295e4b3b":"7UOJJ","51021d538e74fa4a":"3qOgF","4a6f45ac435baa45":"fxYIz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7UOJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _dispatchFormVue = require("./DispatchForm.vue");
var _dispatchFormVueDefault = parcelHelpers.interopDefault(_dispatchFormVue);
var _dispatchDriverListsVue = require("./DispatchDriverLists.vue");
var _dispatchDriverListsVueDefault = parcelHelpers.interopDefault(_dispatchDriverListsVue);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _ellipsisMjs = require("datatables.net-plugins/dataRender/ellipsis.mjs");
const zoomLevel = 11;
const dispatchHistoryUrl = '/api/datatable/dispatch-history';
exports.default = {
    __name: 'DispatchDashboard',
    props: {
        googleMapsApiKey: {
            type: String,
            required: true
        },
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        // Google Maps API is loaded via script tag
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const pickUpData = (0, _vue.ref)('');
        const dropOffData = (0, _vue.ref)('');
        const pickUpCoordinates = (0, _vue.ref)(null);
        const dropOffCoordinates = (0, _vue.ref)(null);
        const markers = (0, _vue.ref)([]);
        const formReseter = (0, _vue.ref)(true);
        const initialCoordinates = {
            lat: 46.255803,
            lng: -63.136968
        };
        let map = null;
        let googleMaps = null; // Google Maps API reference
        let pickUpMarker = null;
        let dropOffMarker = null;
        const dispatchHistory = (0, _vue.ref)(null);
        const dispatchColumn = [
            {
                data: "driver.fullName",
                title: 'Driver',
                render: (0, _datatableRenderer.potentialUndefinedColumn)
            },
            {
                data: "originLocationData.address",
                title: 'Pickup',
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(20, false)
            },
            {
                data: "rideStatus",
                title: 'Status',
                render: (0, _datatableRenderer.rideStatus)
            },
            {
                data: "orderDateTime",
                title: 'Dispatch Time',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: '',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return `<a class="btn btn-sm btn-outline-primary" target="blank" href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i></a>`;
                }
            }
        ];
        //reload table every 10 seconds
        setInterval(function() {
            dispatchHistory.value.dt.ajax.reload();
        }, 10000);
        const initMap = ()=>{
            // Load Google Maps API
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${props.googleMapsApiKey}&loading=async&libraries=marker&callback=initGoogleMap`;
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
                // Define the callback function globally
                window.initGoogleMap = ()=>{
                    createMap();
                };
            } else createMap();
        };
        const createMap = ()=>{
            googleMaps = google.maps;
            map = new googleMaps.Map(document.getElementById("map"), {
                center: initialCoordinates,
                zoom: zoomLevel,
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
                mapId: 'f5f337b511d9a28bc10fc480'
            });
        };
        const drawPickupMarker = (geoResponse)=>{
            //clear previous markers
            if (pickUpMarker) {
                pickUpMarker.map = null;
                pickUpMarker = null;
            }
            if (geoResponse?.geometry?.location) {
                // Handle response from geocodeByPlaceId
                const coordinates = {
                    lat: geoResponse.geometry.location.lat,
                    lng: geoResponse.geometry.location.lng
                };
                // Store coordinates for route calculation
                pickUpCoordinates.value = coordinates;
                const passengerIcon = document.createElement('img');
                passengerIcon.src = '/assets/images/man.png';
                passengerIcon.style.width = '30px';
                passengerIcon.style.height = '30px';
                pickUpMarker = new googleMaps.marker.AdvancedMarkerElement({
                    position: coordinates,
                    map: map,
                    content: passengerIcon
                });
                map.panTo(coordinates);
                map.setZoom(15);
            }
        };
        const drawDropOffMarker = (geoResponse)=>{
            //clear previous markers
            if (dropOffMarker) {
                dropOffMarker.map = null;
                dropOffMarker = null;
            }
            if (geoResponse?.geometry?.location) {
                // Handle response from geocodeByPlaceId
                const coordinates = {
                    lat: geoResponse.geometry.location.lat,
                    lng: geoResponse.geometry.location.lng
                };
                // Store coordinates for route calculation
                dropOffCoordinates.value = coordinates;
                const destinationIcon = document.createElement('img');
                destinationIcon.src = '/assets/images/img.png';
                destinationIcon.style.width = '30px';
                destinationIcon.style.height = '30px';
                dropOffMarker = new googleMaps.marker.AdvancedMarkerElement({
                    position: coordinates,
                    map: map,
                    content: destinationIcon
                });
            }
        };
        const calculateRoute = async (origin, destination)=>{
            try {
                const response = await fetch(`/api/dispatch-ride/calculate-route?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                return await response.json();
            } catch (error) {
                console.error("Error calculating route:", error);
            }
        };
        let directionsRenderer = null;
        const drawRoute = async ()=>{
            if (pickUpCoordinates.value && dropOffCoordinates.value) {
                // Clear previous route if exists
                if (directionsRenderer) directionsRenderer.setMap(null);
                // Create new DirectionsRenderer
                directionsRenderer = new googleMaps.DirectionsRenderer({
                    map: map,
                    suppressMarkers: true,
                    polylineOptions: {
                        strokeColor: '#4a90e2',
                        strokeWeight: 6
                    }
                });
                // Get route from backend
                const geojson = await calculateRoute(`${pickUpCoordinates.value.lat},${pickUpCoordinates.value.lng}`, `${dropOffCoordinates.value.lat},${dropOffCoordinates.value.lng}`);
                // If we have a valid GeoJSON response, convert it to Google Maps format
                if (geojson && geojson.geometry && geojson.geometry.coordinates) {
                    const path = geojson.geometry.coordinates.map((coord)=>{
                        return new googleMaps.LatLng(coord[1], coord[0]); // Convert [lng, lat] to LatLng
                    });
                    // Create a minimal DirectionsResult object
                    const directionsResult = {
                        request: {
                            origin: new googleMaps.LatLng(pickUpCoordinates.value.lat, pickUpCoordinates.value.lng),
                            destination: new googleMaps.LatLng(dropOffCoordinates.value.lat, dropOffCoordinates.value.lng),
                            travelMode: googleMaps.TravelMode.DRIVING // Use enum
                        },
                        routes: [
                            {
                                legs: [
                                    {
                                        steps: [
                                            {
                                                path: path,
                                                travel_mode: googleMaps.TravelMode.DRIVING // Use enum
                                            }
                                        ],
                                        start_location: path[0],
                                        end_location: path[path.length - 1],
                                        distance: {
                                            text: "0 km",
                                            value: 0
                                        },
                                        duration: {
                                            text: "0 mins",
                                            value: 0
                                        },
                                        travel_mode: googleMaps.TravelMode.DRIVING
                                    }
                                ],
                                overview_path: path,
                                bounds: new googleMaps.LatLngBounds().extend(path[0]).extend(path[path.length - 1])
                            }
                        ]
                    };
                    try {
                        directionsRenderer.setDirections(directionsResult);
                    } catch (error) {
                        console.error("Error setting directions:", error);
                        // Fallback to drawing a polyline
                        const polyline = new googleMaps.Polyline({
                            path: path,
                            strokeColor: '#4a90e2',
                            strokeWeight: 6,
                            map: map
                        });
                    }
                    // Fit bounds to show the entire route
                    const bounds = new googleMaps.LatLngBounds();
                    path.forEach((point)=>bounds.extend(point));
                    map.fitBounds(bounds);
                }
            }
        };
        const getGeocodeByPlaceId = async (placeId)=>{
            try {
                const response = await fetch(`/api/dispatch-ride/geocode-by-place-id?placeId=${placeId}`);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                return await response.json();
            } catch (error) {
                console.error("Error fetching geocode by place ID:", error);
            }
        };
        const drawDriver = (driver)=>{
            console.log(driver);
            const position = {
                lat: driver.latitude,
                lng: driver.longitude
            };
            const carIcon = document.createElement('img');
            carIcon.src = '/assets/images/car.png';
            carIcon.style.width = '30px';
            carIcon.style.height = '30px';
            // Create marker
            const marker = new googleMaps.marker.AdvancedMarkerElement({
                position: position,
                map: map,
                content: carIcon
            });
            marker.id = `driver-${driver.id}`; // Store ID for later reference
            // Create info window (popup)
            const popupHtml = `
    <div style="text-align: left;">
      <h4>Driver Details</h4>
      <p><strong>Name:</strong> ${driver.name}</p>
      <p><strong>Vehicle:</strong> ${driver.vehicleType}</p>
      <p><strong>ETA:</strong> ${driver.eta || "N/A"}</p>
      <p><strong>Cab Size:</strong> ${driver.cabSize || "N/A"}</p>
      <p><strong>Status:</strong> ${driver.driverStatus}</p>
    </div>`;
            const infoWindow = new googleMaps.InfoWindow({
                content: popupHtml
            });
            // Add click event to open info window
            marker.addListener('click', ()=>{
                infoWindow.open({
                    anchor: marker,
                    map
                });
            });
            markers.value.push(marker);
        };
        const drawAllDrivers = async ()=>{
            try {
                //todo use proper endpoint
                const response = await fetch("/api/datatable/driver-list");
                if (!response.ok) throw new Error(`Failed to fetch drivers: ${response.status}`);
                const drivers = await response.json();
                // Clear existing markers
                markers.value.forEach((marker)=>{
                    marker.map = null;
                });
                markers.value = [];
                drivers.data.forEach((driver)=>{
                    if (driver.latitude && driver.longitude) drawDriver(driver);
                });
            } catch (error) {
                console.error("Error fetching or drawing drivers:", error);
            }
        };
        const findDriver = (driver)=>{
            console.log("Finding driver:", driver);
            // Find the marker for this driver
            const driverMarker = markers.value.find((marker)=>marker.id === `driver-${driver.id}`);
            if (driverMarker) {
                const mapElement = document.querySelector('#map');
                if (mapElement) mapElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                else console.warn("Map element not found!");
                const position = {
                    lat: driver.latitude,
                    lng: driver.longitude
                };
                // Center the map on the driver
                map.panTo(position);
                map.setZoom(15);
                // Trigger a click on the marker to open the info window
                googleMaps.event.trigger(driverMarker, 'click');
            }
        };
        const resetDispatchForm = ()=>{
            formReseter.value = false;
            (0, _vue.nextTick)(()=>{
                formReseter.value = true;
            });
        };
        (0, _vue.onMounted)(async ()=>{
            initMap();
            await drawAllDrivers();
        });
        // Watchers
        (0, _vue.watch)(pickUpData, (newVal)=>{
            if (newVal.result && newVal.result.id) getGeocodeByPlaceId(newVal.result.id).then((response)=>{
                drawPickupMarker(response.results[0]);
                drawRoute();
            });
        });
        (0, _vue.watch)(dropOffData, (newVal)=>{
            if (newVal.result && newVal.result.id) getGeocodeByPlaceId(newVal.result.id).then((response)=>{
                drawDropOffMarker(response.results[0]);
                drawRoute();
            });
        });
        const __returned__ = {
            props,
            pickUpData,
            dropOffData,
            pickUpCoordinates,
            dropOffCoordinates,
            markers,
            formReseter,
            initialCoordinates,
            zoomLevel,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get googleMaps () {
                return googleMaps;
            },
            set googleMaps (v){
                googleMaps = v;
            },
            get pickUpMarker () {
                return pickUpMarker;
            },
            set pickUpMarker (v){
                pickUpMarker = v;
            },
            get dropOffMarker () {
                return dropOffMarker;
            },
            set dropOffMarker (v){
                dropOffMarker = v;
            },
            dispatchHistory,
            dispatchHistoryUrl,
            dispatchColumn,
            initMap,
            createMap,
            drawPickupMarker,
            drawDropOffMarker,
            calculateRoute,
            get directionsRenderer () {
                return directionsRenderer;
            },
            set directionsRenderer (v){
                directionsRenderer = v;
            },
            drawRoute,
            getGeocodeByPlaceId,
            drawDriver,
            drawAllDrivers,
            findDriver,
            resetDispatchForm,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            nextTick: (0, _vue.nextTick),
            DispatchForm: (0, _dispatchFormVueDefault.default),
            DispatchDriverLists: (0, _dispatchDriverListsVueDefault.default),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get potentialUndefinedColumn () {
                return 0, _datatableRenderer.potentialUndefinedColumn;
            },
            get rideStatus () {
                return 0, _datatableRenderer.rideStatus;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./DispatchForm.vue":"2DnYC","./DispatchDriverLists.vue":"cqcdS","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","datatables.net-plugins/dataRender/ellipsis.mjs":"hN9e8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2DnYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("a4f2e2d449fc6836");
    if (script.__esModule) script = script.default;
    script.render = require("dbac84da83209e44").render;
    require("9b807a27a990fb95").default(script);
    script.__scopeId = 'data-v-33715d';
    script.__file = "DispatchForm.vue";
};
initialize();
exports.default = script;

},{"a4f2e2d449fc6836":"j9Oao","dbac84da83209e44":"cRLz3","9b807a27a990fb95":"lApHE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j9Oao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _jqueryWizard = require("./../../extras/js/jquery-wizard");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _eventBus = require("../utility/eventBus");
var _addressHelper = require("../utility/addressHelper");
// Props
exports.default = {
    __name: 'DispatchForm',
    props: {
        pickUpData: {
            type: [
                Object,
                String
            ],
            default: '',
            required: true
        },
        dropOffData: {
            type: [
                Object,
                String
            ],
            default: '',
            required: true
        },
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    emits: [
        'update:pickUpData',
        'update:dropOffData',
        'drawDriverOnMap',
        'resetForm'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        // Emits
        const emit = __emit;
        // Reactive state
        const pickUpInfo = (0, _vue.ref)('');
        const dropOffInfo = (0, _vue.ref)('');
        const skipDropOffLocation = (0, _vue.ref)(false);
        const skipPassengerInfo = (0, _vue.ref)(false);
        const passengerName = (0, _vue.ref)('');
        const passengerContact = (0, _vue.ref)('');
        const numPassengers = (0, _vue.ref)(1);
        const selectedAccount = (0, _vue.ref)(null);
        const accounts = (0, _vue.ref)([]);
        const estimatedCost = (0, _vue.ref)(0.0);
        const estimatedTimeOfArrival = (0, _vue.ref)('');
        const estimatedTripTime = (0, _vue.ref)('');
        const isDriverAvailable = (0, _vue.ref)(true);
        const isLoadingEstimates = (0, _vue.ref)(false);
        const autoAssignCheck = (0, _vue.ref)(true);
        const driverInfo = (0, _vue.ref)('');
        const driverNotes = (0, _vue.ref)('');
        // Refs for DOM elements. They will be automatically bound to their respective refs in the dom
        let pickupInput = null;
        let dropOffInput = null;
        let driverInput = null;
        // Methods
        const addressAutoCompleteInit = (refElement, updateEvent)=>{
            $(refElement).autocomplete({
                source: (request, response)=>{
                    fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(request.term)}`).then((res)=>{
                        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                        return res.json();
                    }).then((data)=>{
                        const suggestions = data.results.map((result)=>({
                                label: (0, _addressHelper.renderWithPoi)(result),
                                value: result.name,
                                result
                            }));
                        response(suggestions);
                    }).catch((error)=>{
                        console.error('Error fetching suggestions:', error);
                        response([]);
                    });
                },
                minLength: 3
            }).on('autocompleteselect', (event, ui)=>{
                if (updateEvent === 'pickUp') {
                    pickUpInfo.value = ui.item;
                    emit('update:pickUpData', ui.item);
                } else if (updateEvent === 'dropOff') {
                    dropOffInfo.value = ui.item;
                    emit('update:dropOffData', ui.item);
                }
            }).autocomplete('instance')._renderItem = (ul, item)=>{
                return $('<li>').append(item.label).appendTo(ul);
            };
        };
        const driverSelectionAutoCompleteInit = ()=>{
            $(driverInput).autocomplete({
                source: (request, response)=>{
                    fetch(`/api/dispatch-ride/query-available-drivers?query=${request.term}`).then((res)=>{
                        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                        return res.json();
                    }).then((data)=>{
                        const suggestions = data.map((driver)=>({
                                label: `
              <div>
                <strong>${driver.name}</strong> <small>(${driver.vehicleType})</small>
              </div>`,
                                value: driver.name,
                                driver
                            }));
                        response(suggestions);
                    });
                },
                minLength: 2,
                select: (event, ui)=>{
                    driverInfo.value = ui.item.value;
                    emit('drawDriverOnMap', ui.item.driver);
                }
            }).autocomplete('instance')._renderItem = (ul, item)=>{
                return $('<li>').append(item.label).appendTo(ul);
            };
        };
        const fetchEstimates = async ()=>{
            if (pickUpInfo.value.result && (dropOffInfo.value.result || skipDropOffLocation.value)) {
                const originPlaceId = pickUpInfo.value.result.id;
                const destinationPlaceId = skipDropOffLocation.value ? '' : dropOffInfo.value.result.id;
                try {
                    isLoadingEstimates.value = true;
                    const response = await fetch(`/api/dispatch-ride/get-estimates?originPlaceId=${encodeURIComponent(originPlaceId)}&destinationPlaceId=${encodeURIComponent(destinationPlaceId)}`);
                    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                    const data = await response.json();
                    // Update values based on the response
                    estimatedCost.value = data.estimatedFare || 0.0;
                    estimatedTimeOfArrival.value = data.timeToPickupString || 'N/A';
                    estimatedTripTime.value = data.timeToDestinationString || 'N/A';
                    isDriverAvailable.value = data.driverAvailable !== false; // Default to true if not specified
                } catch (error) {
                    console.error('Error fetching estimates:', error);
                    // Reset values on error
                    estimatedCost.value = 0.0;
                    estimatedTimeOfArrival.value = 'Error fetching data';
                    estimatedTripTime.value = '';
                    isDriverAvailable.value = false;
                } finally{
                    isLoadingEstimates.value = false;
                }
            } else console.error('Pickup and Drop-off data must be provided to fetch estimates.');
        };
        const completeBooking = async ()=>{
            // Assemble Ride object
            const rideObject = {
                pickupLocation: pickUpInfo.value.result || null,
                dropOffLocation: skipDropOffLocation.value ? null : dropOffInfo.value.result || null,
                passengerDetails: skipPassengerInfo.value ? null : {
                    name: passengerName.value,
                    contact: passengerContact.value,
                    numPassengers: numPassengers.value
                },
                autoAssign: autoAssignCheck.value,
                driverId: autoAssignCheck.value ? null : driverInfo.value.id,
                driverNotes: driverNotes.value,
                accountId: selectedAccount.value
            };
            try {
                // Post the ride object to the backend
                const response = await fetch('/api/dispatch-ride/create-ride', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(rideObject)
                });
                if (!response.ok) (0, _toastNotificationUtility.showToast)({
                    title: "Error",
                    body: await response.text(),
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 6000
                });
                else {
                    // Reset the form fields
                    emit('resetForm', {});
                    (0, _toastNotificationUtility.showToast)({
                        title: "Booking Completed!",
                        body: `Ride successfully booked.`,
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS,
                        delay: 6000
                    });
                }
            } catch (error) {
                console.error('Error completing booking:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: "Error",
                    body: "Failed to complete booking. Please try again later.",
                    type: "error",
                    delay: 6000
                });
            }
        };
        const incrementPassengers = ()=>{
            numPassengers.value++;
        };
        const decrementPassengers = ()=>{
            if (numPassengers.value > 1) numPassengers.value--;
        };
        //validations
        const tripDetailIsValid = ()=>{
            let valid = true;
            if (!pickUpInfo.value.label) {
                valid = false;
                $('#pickup-location-input').addClass('is-invalid');
                $('#pickup-location-error').removeClass('d-none');
            } else {
                $('#pickup-location-input').removeClass('is-invalid');
                $('#pickup-location-error').addClass('d-none');
            }
            if (!skipDropOffLocation.value) {
                if (!dropOffInfo.value.label) {
                    valid = false;
                    $('#drop-off-location-input').addClass('is-invalid');
                    $('#drop-off-location-error').removeClass('d-none');
                } else {
                    $('#drop-off-location-input').removeClass('is-invalid');
                    $('#drop-off-location-error').addClass('d-none');
                }
            } else {
                $('#drop-off-location-input').removeClass('is-invalid');
                $('#drop-off-location-error').addClass('d-none');
            }
            return valid;
        };
        const passengerDetailIsValid = ()=>{
            let valid = true;
            skipPassengerInfo.value;
            return valid;
        };
        const dispatchDetailIsValid = ()=>{
            let valid = true;
            if (!autoAssignCheck.value) {
                if (!driverInfo.value) {
                    valid = false;
                    $('#select-driver').addClass('is-invalid');
                    $('#select-driver-error').removeClass('d-none');
                } else {
                    $('#select-driver').removeClass('is-invalid');
                    $('#select-driver-error').addClass('d-none');
                }
            }
            return valid;
        };
        // Watchers
        (0, _vue.watch)(autoAssignCheck, async (newVal)=>{
            if (!newVal) {
                //when the auto-assign is unchecked we have to wait for the dom to init autocomplete
                await (0, _vue.nextTick)();
                driverSelectionAutoCompleteInit();
            } else {
                // Clear driver info when auto-assign is enabled
                driverInfo.value = '';
                if (driverInput) $(driverInput).autocomplete('close');
            }
        });
        const setupWizard = ()=>{
            $('#wizard').wizard({
                step: '.nav-pills > a',
                classes: {
                    step: {
                        active: 'active'
                    },
                    pane: {
                        active: 'active show'
                    },
                    button: {
                        hide: 'd-none',
                        disabled: 'd-none'
                    }
                },
                buttonsAppendTo: '#navigation-button-container',
                templates: {
                    buttons: function() {
                        return `<div class="pull-left">
                        <a role="button" class="btn btn-outline-secondary mb-3" href="#wizard" data-wizard="back">Back</a>
                    </div>

                    <div class="pull-right">
                      <a role="button" class="btn btn-outline-primary mb-3" href="#wizard" data-wizard="next">Next</a>
                      <a role="button" class="btn btn-outline-success mb-3" href="#wizard" data-wizard="finish">Dispatch</a>
                    </div>`;
                    }
                },
                validator: function(step) {
                    if (step.index === 0) return tripDetailIsValid();
                    if (step.index === 1) return passengerDetailIsValid();
                    if (step.index === 2) return dispatchDetailIsValid();
                    return false;
                },
                onAfterChange: function(currentStep, nextStep) {
                    if (nextStep.index === 2) // Fetch estimates when moving to the dispatch step (final step)
                    fetchEstimates();
                },
                onFinish: function() {
                    completeBooking();
                }
            });
        };
        const insertPassengerPhoneNumber = async (data)=>{
            passengerContact.value = data;
        };
        const insertPickUpInfoFromCall = async (data)=>{
            pickUpInfo.value = data;
            emit('update:pickUpData', pickUpInfo.value);
        };
        const insertDropOffInfoFromCall = (data)=>{
            skipDropOffLocation.value = false;
            dropOffInfo.value = data;
            emit('update:dropOffData', dropOffInfo.value);
        };
        async function fetchActiveAccounts() {
            try {
                const response = await fetch(`/api/service-providers/${props.serviceProviderId}/accounts/active`);
                if (response.ok) accounts.value = await response.json();
            } catch (error) {
                console.error('Error fetching active accounts:', error);
            }
        }
        // Lifecycle Hooks
        (0, _vue.onMounted)(()=>{
            fetchActiveAccounts();
            (0, _vue.nextTick)(()=>{
                setupWizard();
                addressAutoCompleteInit(pickupInput, 'pickUp');
                addressAutoCompleteInit(dropOffInput, 'dropOff');
                (0, _eventBus.eventBus).on('emitPickupSuggestionToForm', insertPickUpInfoFromCall);
                (0, _eventBus.eventBus).on('emitDropOffSuggestionToForm', insertDropOffInfoFromCall);
                (0, _eventBus.eventBus).on('emitCallerPhoneNumber', insertPassengerPhoneNumber);
            });
        });
        (0, _vue.onUnmounted)(()=>{
            (0, _eventBus.eventBus).off('emitPickupSuggestionToForm', insertPickUpInfoFromCall);
            (0, _eventBus.eventBus).off('emitDropOffSuggestionToForm', insertDropOffInfoFromCall);
            (0, _eventBus.eventBus).off('emitCallerPhoneNumber', insertPassengerPhoneNumber);
        });
        const __returned__ = {
            props,
            emit,
            pickUpInfo,
            dropOffInfo,
            skipDropOffLocation,
            skipPassengerInfo,
            passengerName,
            passengerContact,
            numPassengers,
            selectedAccount,
            accounts,
            estimatedCost,
            estimatedTimeOfArrival,
            estimatedTripTime,
            isDriverAvailable,
            isLoadingEstimates,
            autoAssignCheck,
            driverInfo,
            driverNotes,
            get pickupInput () {
                return pickupInput;
            },
            set pickupInput (v){
                pickupInput = v;
            },
            get dropOffInput () {
                return dropOffInput;
            },
            set dropOffInput (v){
                dropOffInput = v;
            },
            get driverInput () {
                return driverInput;
            },
            set driverInput (v){
                driverInput = v;
            },
            addressAutoCompleteInit,
            driverSelectionAutoCompleteInit,
            fetchEstimates,
            completeBooking,
            incrementPassengers,
            decrementPassengers,
            tripDetailIsValid,
            passengerDetailIsValid,
            dispatchDetailIsValid,
            setupWizard,
            insertPassengerPhoneNumber,
            insertPickUpInfoFromCall,
            insertDropOffInfoFromCall,
            fetchActiveAccounts,
            ref: (0, _vue.ref),
            watch: (0, _vue.watch),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            nextTick: (0, _vue.nextTick),
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get eventBus () {
                return 0, _eventBus.eventBus;
            },
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","./../../extras/js/jquery-wizard":"16izs","../utility/toastNotificationUtility":"krOtg","../utility/eventBus":"1OAlE","../utility/addressHelper":"3Hmtq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6clbD":[function(require,module,exports,__globalThis) {
/*!
 * jQuery UI Widget 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var widgetUuid = 0;
    var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
    var widgetSlice = Array.prototype.slice;
    $.cleanData = function(orig) {
        return function(elems) {
            var events, elem, i;
            for(i = 0; (elem = elems[i]) != null; i++){
                // Only trigger remove when necessary to save time
                events = $._data(elem, "events");
                if (events && events.remove) $(elem).triggerHandler("remove");
            }
            orig(elems);
        };
    }($.cleanData);
    $.widget = function(name, base, prototype) {
        var existingConstructor, constructor, basePrototype;
        // ProxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        var proxiedPrototype = {};
        var namespace = name.split(".")[0];
        name = name.split(".")[1];
        if (name === "__proto__" || name === "constructor") return $.error("Invalid widget name: " + name);
        var fullName = namespace + "-" + name;
        if (!prototype) {
            prototype = base;
            base = $.Widget;
        }
        if (Array.isArray(prototype)) prototype = $.extend.apply(null, [
            {}
        ].concat(prototype));
        // Create selector for plugin
        $.expr.pseudos[fullName.toLowerCase()] = function(elem) {
            return !!$.data(elem, fullName);
        };
        $[namespace] = $[namespace] || {};
        existingConstructor = $[namespace][name];
        constructor = $[namespace][name] = function(options, element) {
            // Allow instantiation without "new" keyword
            if (!this || !this._createWidget) return new constructor(options, element);
            // Allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if (arguments.length) this._createWidget(options, element);
        };
        // Extend with the existing constructor to carry over any static properties
        $.extend(constructor, existingConstructor, {
            version: prototype.version,
            // Copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend({}, prototype),
            // Track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });
        basePrototype = new base();
        // We need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend({}, basePrototype.options);
        $.each(prototype, function(prop, value) {
            if (typeof value !== "function") {
                proxiedPrototype[prop] = value;
                return;
            }
            proxiedPrototype[prop] = function() {
                function _super() {
                    return base.prototype[prop].apply(this, arguments);
                }
                function _superApply(args) {
                    return base.prototype[prop].apply(this, args);
                }
                return function() {
                    var __super = this._super;
                    var __superApply = this._superApply;
                    var returnValue;
                    this._super = _super;
                    this._superApply = _superApply;
                    returnValue = value.apply(this, arguments);
                    this._super = __super;
                    this._superApply = __superApply;
                    return returnValue;
                };
            }();
        });
        constructor.prototype = $.widget.extend(basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });
        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if (existingConstructor) {
            $.each(existingConstructor._childConstructors, function(i, child) {
                var childPrototype = child.prototype;
                // Redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
            });
            // Remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else base._childConstructors.push(constructor);
        $.widget.bridge(name, constructor);
        return constructor;
    };
    $.widget.extend = function(target) {
        var input = widgetSlice.call(arguments, 1);
        var inputIndex = 0;
        var inputLength = input.length;
        var key;
        var value;
        for(; inputIndex < inputLength; inputIndex++)for(key in input[inputIndex]){
            value = input[inputIndex][key];
            if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== undefined) {
                // Clone objects
                if ($.isPlainObject(value)) target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
                else target[key] = value;
            }
        }
        return target;
    };
    $.widget.bridge = function(name, object) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[name] = function(options) {
            var isMethodCall = typeof options === "string";
            var args = widgetSlice.call(arguments, 1);
            var returnValue = this;
            if (isMethodCall) {
                // If this is an empty collection, we need to have the instance method
                // return undefined instead of the jQuery instance
                if (!this.length && options === "instance") returnValue = undefined;
                else this.each(function() {
                    var methodValue;
                    var instance = $.data(this, fullName);
                    if (options === "instance") {
                        returnValue = instance;
                        return false;
                    }
                    if (!instance) return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
                    if (typeof instance[options] !== "function" || options.charAt(0) === "_") return $.error("no such method '" + options + "' for " + name + " widget instance");
                    methodValue = instance[options].apply(instance, args);
                    if (methodValue !== instance && methodValue !== undefined) {
                        returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                        return false;
                    }
                });
            } else {
                // Allow multiple hashes to be passed on init
                if (args.length) options = $.widget.extend.apply(null, [
                    options
                ].concat(args));
                this.each(function() {
                    var instance = $.data(this, fullName);
                    if (instance) {
                        instance.option(options || {});
                        if (instance._init) instance._init();
                    } else $.data(this, fullName, new object(options, this));
                });
            }
            return returnValue;
        };
    };
    $.Widget = function() {};
    $.Widget._childConstructors = [];
    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            classes: {},
            disabled: false,
            // Callbacks
            create: null
        },
        _createWidget: function(options, element) {
            element = $(element || this.defaultElement || this)[0];
            this.element = $(element);
            this.uuid = widgetUuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            this.classesElementLookup = {};
            if (element !== this) {
                $.data(element, this.widgetFullName, this);
                this._on(true, this.element, {
                    remove: function(event) {
                        if (event.target === element) this.destroy();
                    }
                });
                this.document = $(element.style ? // Element within the document
                element.ownerDocument : // Element is window or document
                element.document || element);
                this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
            }
            this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
            this._create();
            if (this.options.disabled) this._setOptionDisabled(this.options.disabled);
            this._trigger("create", null, this._getCreateEventData());
            this._init();
        },
        _getCreateOptions: function() {
            return {};
        },
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,
        destroy: function() {
            var that = this;
            this._destroy();
            $.each(this.classesElementLookup, function(key, value) {
                that._removeClass(value, key);
            });
            // We can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element.off(this.eventNamespace).removeData(this.widgetFullName);
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled");
            // Clean up events and states
            this.bindings.off(this.eventNamespace);
        },
        _destroy: $.noop,
        widget: function() {
            return this.element;
        },
        option: function(key, value) {
            var options = key;
            var parts;
            var curOption;
            var i;
            if (arguments.length === 0) // Don't return a reference to the internal hash
            return $.widget.extend({}, this.options);
            if (typeof key === "string") {
                // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split(".");
                key = parts.shift();
                if (parts.length) {
                    curOption = options[key] = $.widget.extend({}, this.options[key]);
                    for(i = 0; i < parts.length - 1; i++){
                        curOption[parts[i]] = curOption[parts[i]] || {};
                        curOption = curOption[parts[i]];
                    }
                    key = parts.pop();
                    if (arguments.length === 1) return curOption[key] === undefined ? null : curOption[key];
                    curOption[key] = value;
                } else {
                    if (arguments.length === 1) return this.options[key] === undefined ? null : this.options[key];
                    options[key] = value;
                }
            }
            this._setOptions(options);
            return this;
        },
        _setOptions: function(options) {
            var key;
            for(key in options)this._setOption(key, options[key]);
            return this;
        },
        _setOption: function(key, value) {
            if (key === "classes") this._setOptionClasses(value);
            this.options[key] = value;
            if (key === "disabled") this._setOptionDisabled(value);
            return this;
        },
        _setOptionClasses: function(value) {
            var classKey, elements, currentElements;
            for(classKey in value){
                currentElements = this.classesElementLookup[classKey];
                if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) continue;
                // We are doing this to create a new jQuery object because the _removeClass() call
                // on the next line is going to destroy the reference to the current elements being
                // tracked. We need to save a copy of this collection so that we can add the new classes
                // below.
                elements = $(currentElements.get());
                this._removeClass(currentElements, classKey);
                // We don't use _addClass() here, because that uses this.options.classes
                // for generating the string of classes. We want to use the value passed in from
                // _setOption(), this is the new value of the classes option which was passed to
                // _setOption(). We pass this value directly to _classes().
                elements.addClass(this._classes({
                    element: elements,
                    keys: classKey,
                    classes: value,
                    add: true
                }));
            }
        },
        _setOptionDisabled: function(value) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!value);
            // If the widget is becoming disabled, then nothing is interactive
            if (value) {
                this._removeClass(this.hoverable, null, "ui-state-hover");
                this._removeClass(this.focusable, null, "ui-state-focus");
            }
        },
        enable: function() {
            return this._setOptions({
                disabled: false
            });
        },
        disable: function() {
            return this._setOptions({
                disabled: true
            });
        },
        _classes: function(options) {
            var full = [];
            var that = this;
            options = $.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, options);
            function bindRemoveEvent() {
                var nodesToBind = [];
                options.element.each(function(_, element) {
                    var isTracked = $.map(that.classesElementLookup, function(elements) {
                        return elements;
                    }).some(function(elements) {
                        return elements.is(element);
                    });
                    if (!isTracked) nodesToBind.push(element);
                });
                that._on($(nodesToBind), {
                    remove: "_untrackClassesElement"
                });
            }
            function processClassString(classes, checkOption) {
                var current, i;
                for(i = 0; i < classes.length; i++){
                    current = that.classesElementLookup[classes[i]] || $();
                    if (options.add) {
                        bindRemoveEvent();
                        current = $($.uniqueSort(current.get().concat(options.element.get())));
                    } else current = $(current.not(options.element).get());
                    that.classesElementLookup[classes[i]] = current;
                    full.push(classes[i]);
                    if (checkOption && options.classes[classes[i]]) full.push(options.classes[classes[i]]);
                }
            }
            if (options.keys) processClassString(options.keys.match(/\S+/g) || [], true);
            if (options.extra) processClassString(options.extra.match(/\S+/g) || []);
            return full.join(" ");
        },
        _untrackClassesElement: function(event) {
            var that = this;
            $.each(that.classesElementLookup, function(key, value) {
                if ($.inArray(event.target, value) !== -1) that.classesElementLookup[key] = $(value.not(event.target).get());
            });
            this._off($(event.target));
        },
        _removeClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, false);
        },
        _addClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, true);
        },
        _toggleClass: function(element, keys, extra, add) {
            add = typeof add === "boolean" ? add : extra;
            var shift = typeof element === "string" || element === null, options = {
                extra: shift ? keys : extra,
                keys: shift ? element : keys,
                element: shift ? this.element : element,
                add: add
            };
            options.element.toggleClass(this._classes(options), add);
            return this;
        },
        _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement;
            var instance = this;
            // No suppressDisabledCheck flag, shuffle arguments
            if (typeof suppressDisabledCheck !== "boolean") {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }
            // No element argument, shuffle and use this.element
            if (!handlers) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $(element);
                this.bindings = this.bindings.add(element);
            }
            $.each(handlers, function(event, handler) {
                function handlerProxy() {
                    // Allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) return;
                    return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
                }
                // Copy the guid so direct unbinding works
                if (typeof handler !== "string") handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
                var match = event.match(/^([\w:-]*)\s*(.*)$/);
                var eventName = match[1] + instance.eventNamespace;
                var selector = match[2];
                if (selector) delegateElement.on(eventName, selector, handlerProxy);
                else element.on(eventName, handlerProxy);
            });
        },
        _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.off(eventName);
            // Clear the stack to avoid memory leaks (#10056)
            this.bindings = $(this.bindings.not(element).get());
            this.focusable = $(this.focusable.not(element).get());
            this.hoverable = $(this.hoverable.not(element).get());
        },
        _delay: function(handler, delay) {
            function handlerProxy() {
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            var instance = this;
            return setTimeout(handlerProxy, delay || 0);
        },
        _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
                mouseenter: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-hover");
                },
                mouseleave: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-hover");
                }
            });
        },
        _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
                focusin: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-focus");
                },
                focusout: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-focus");
                }
            });
        },
        _trigger: function(type, event, data) {
            var prop, orig;
            var callback = this.options[type];
            data = data || {};
            event = $.Event(event);
            event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            // The original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[0];
            // Copy original event properties over to the new event
            orig = event.originalEvent;
            if (orig) {
                for(prop in orig)if (!(prop in event)) event[prop] = orig[prop];
            }
            this.element.trigger(event, data);
            return !(typeof callback === "function" && callback.apply(this.element[0], [
                event
            ].concat(data)) === false || event.isDefaultPrevented());
        }
    };
    $.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(method, defaultEffect) {
        $.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") options = {
                effect: options
            };
            var hasOptions;
            var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") options = {
                duration: options
            };
            else if (options === true) options = {};
            hasOptions = !$.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) element.delay(options.delay);
            if (hasOptions && $.effects && $.effects.effect[effectName]) element[method](options);
            else if (effectName !== method && element[effectName]) element[effectName](options.duration, options.easing, callback);
            else element.queue(function(next) {
                $(this)[method]();
                if (callback) callback.call(element[0]);
                next();
            });
        };
    });
    return $.widget;
});

},{}],"16izs":[function(require,module,exports,__globalThis) {
/**
 * jQuery wizard v0.4.4
 * https://github.com/amazingSurge/jquery-wizard
 *
 * Copyright (c) amazingSurge
 * Released under the LGPL-3.0 license
 */ /*eslint no-unused-vars: "off"*/ /*eslint no-empty-function: "off"*/ var DEFAULTS = {
    step: '.wizard-steps > li',
    getPane: function(index, step) {
        return this.$element.find('.wizard-content').children().eq(index);
    },
    buttonsAppendTo: 'this',
    templates: {
        buttons: function() {
            const options = this.options;
            return `<div class="wizard-buttons"><a class="wizard-back" href="#${this.id}" data-wizard="back" role="button">${options.buttonLabels.back}</a><a class="wizard-next" href="#${this.id}" data-wizard="next" role="button">${options.buttonLabels.next}</a><a class="wizard-finish" href="#${this.id}" data-wizard="finish" role="button">${options.buttonLabels.finish}</a></div>`;
        }
    },
    classes: {
        step: {
            done: 'done',
            error: 'error',
            active: 'current',
            disabled: 'disabled',
            activing: 'activing',
            loading: 'loading'
        },
        pane: {
            active: 'active',
            activing: 'activing'
        },
        button: {
            hide: 'hide',
            disabled: 'disabled'
        }
    },
    autoFocus: true,
    keyboard: true,
    enableWhenVisited: false,
    buttonLabels: {
        next: 'Next',
        back: 'Back',
        finish: 'Finish'
    },
    loading: {
        show: function(step) {},
        hide: function(step) {},
        fail: function(step) {}
    },
    cacheContent: false,
    validator: function(step) {
        return true;
    },
    onInit: null,
    onNext: null,
    onBack: null,
    onReset: null,
    onBeforeShow: null,
    onAfterShow: null,
    onBeforeHide: null,
    onAfterHide: null,
    onBeforeLoad: null,
    onAfterLoad: null,
    onBeforeChange: null,
    onAfterChange: null,
    onStateChange: null,
    onFinish: null
};
/**
 * Css features detect
 **/ let support = {};
((support)=>{
    /**
     * Borrowed from Owl carousel
     **/ const events = {
        transition: {
            end: {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd',
                transition: 'transitionend'
            }
        },
        animation: {
            end: {
                WebkitAnimation: 'webkitAnimationEnd',
                MozAnimation: 'animationend',
                OAnimation: 'oAnimationEnd',
                animation: 'animationend'
            }
        }
    }, prefixes = [
        'webkit',
        'Moz',
        'O',
        'ms'
    ], style = $('<support>').get(0).style, tests = {
        csstransitions () {
            return Boolean(test('transition'));
        },
        cssanimations () {
            return Boolean(test('animation'));
        }
    };
    const test = (property, prefixed)=>{
        let result = false, upper = property.charAt(0).toUpperCase() + property.slice(1);
        if (style[property] !== undefined) result = property;
        if (!result) $.each(prefixes, (i, prefix)=>{
            if (style[prefix + upper] !== undefined) {
                result = `-${prefix.toLowerCase()}-${upper}`;
                return false;
            }
            return true;
        });
        if (prefixed) return result;
        if (result) return true;
        return false;
    };
    const prefixed = (property)=>{
        return test(property, true);
    };
    if (tests.csstransitions()) {
        /*eslint no-new-wrappers: "off"*/ support.transition = new String(prefixed('transition'));
        support.transition.end = events.transition.end[support.transition];
    }
    if (tests.cssanimations()) {
        /*eslint no-new-wrappers: "off"*/ support.animation = new String(prefixed('animation'));
        support.animation.end = events.animation.end[support.animation];
    }
})(support);
function emulateTransitionEnd($el, duration) {
    'use strict';
    let called = false;
    $el.one(support.transition.end, ()=>{
        called = true;
    });
    const callback = ()=>{
        if (!called) $el.trigger(support.transition.end);
    };
    setTimeout(callback, duration);
}
class Step {
    constructor(element, wizard, index){
        this.TRANSITION_DURATION = 200;
        this.initialize(element, wizard, index);
    }
    initialize(element, wizard, index) {
        this.$element = $(element);
        this.wizard = wizard;
        this.events = {};
        this.loader = null;
        this.loaded = false;
        this.validator = this.wizard.options.validator;
        this.states = {
            done: false,
            error: false,
            active: false,
            disabled: false,
            activing: false
        };
        this.index = index;
        this.$element.data('wizard-index', index);
        this.$pane = this.getPaneFromTarget();
        if (!this.$pane) this.$pane = this.wizard.options.getPane.call(this.wizard, index, element);
        this.setValidatorFromData();
        this.setLoaderFromData();
    }
    getPaneFromTarget() {
        let selector = this.$element.data('target');
        if (!selector) {
            selector = this.$element.attr('href');
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
        }
        if (selector) return $(selector);
        return null;
    }
    setup() {
        const current = this.wizard.currentIndex();
        if (this.index === current) {
            this.enter('active');
            if (this.loader) this.load();
        } else if (this.index > current) this.enter('disabled');
        this.$element.attr('aria-expanded', this.is('active'));
        this.$pane.attr('aria-expanded', this.is('active'));
        const classes = this.wizard.options.classes;
        if (this.is('active')) this.$pane.addClass(classes.pane.active);
        else this.$pane.removeClass(classes.pane.active);
    }
    show(callback) {
        if (this.is('activing') || this.is('active')) return;
        this.trigger('beforeShow');
        this.enter('activing');
        const classes = this.wizard.options.classes;
        this.$element.attr('aria-expanded', true);
        this.$pane.addClass(classes.pane.activing).addClass(classes.pane.active).attr('aria-expanded', true);
        const complete = function() {
            this.$pane.removeClass(classes.pane.activing);
            this.leave('activing');
            this.enter('active');
            this.trigger('afterShow');
            if (typeof callback === "function") callback.call(this);
        };
        if (!support.transition) {
            complete.call(this);
            return;
        }
        this.$pane.one(support.transition.end, $.proxy(complete, this));
        emulateTransitionEnd(this.$pane, this.TRANSITION_DURATION);
    }
    hide(callback) {
        if (this.is('activing') || !this.is('active')) return;
        this.trigger('beforeHide');
        this.enter('activing');
        const classes = this.wizard.options.classes;
        this.$element.attr('aria-expanded', false);
        this.$pane.addClass(classes.pane.activing).removeClass(classes.pane.active).attr('aria-expanded', false);
        const complete = function() {
            this.$pane.removeClass(classes.pane.activing);
            this.leave('activing');
            this.leave('active');
            this.trigger('afterHide');
            if (typeof callback === "function") callback.call(this);
        };
        if (!support.transition) {
            complete.call(this);
            return;
        }
        this.$pane.one(support.transition.end, $.proxy(complete, this));
        emulateTransitionEnd(this.$pane, this.TRANSITION_DURATION);
    }
    empty() {
        this.$pane.empty();
    }
    load(callback) {
        const that = this;
        let loader = this.loader;
        if (typeof loader === "function") loader = loader.call(this.wizard, this);
        if (this.wizard.options.cacheContent && this.loaded) {
            if (typeof callback === "function") callback.call(this);
            return;
        }
        this.trigger('beforeLoad');
        this.enter('loading');
        function setContent(content) {
            that.$pane.html(content);
            that.leave('loading');
            that.loaded = true;
            that.trigger('afterLoad');
            if (typeof callback === "function") callback.call(that);
        }
        if (typeof loader === 'string') setContent(loader);
        else if (typeof loader === 'object' && loader.hasOwnProperty('url')) {
            that.wizard.options.loading.show.call(that.wizard, that);
            $.ajax(loader.url, loader.settings || {}).done((data)=>{
                setContent(data);
                that.wizard.options.loading.hide.call(that.wizard, that);
            }).fail(()=>{
                that.wizard.options.loading.fail.call(that.wizard, that);
            });
        } else setContent('');
    }
    trigger(event, ...args) {
        if (Array.isArray(this.events[event])) {
            for(const i in this.events[event])if (({}).hasOwnProperty.call(this.events[event], i)) this.events[event][i](...args);
        }
        this.wizard.trigger(...[
            event,
            this
        ].concat(args));
    }
    enter(state) {
        this.states[state] = true;
        const classes = this.wizard.options.classes;
        this.$element.addClass(classes.step[state]);
        this.trigger('stateChange', true, state);
    }
    leave(state) {
        if (this.states[state]) {
            this.states[state] = false;
            const classes = this.wizard.options.classes;
            this.$element.removeClass(classes.step[state]);
            this.trigger('stateChange', false, state);
        }
    }
    setValidatorFromData() {
        const validator = this.$pane.data('validator');
        if (validator && typeof window[validator] === "function") this.validator = window[validator];
    }
    setLoaderFromData() {
        const loader = this.$pane.data('loader');
        if (loader) {
            if (typeof window[loader] === "function") this.loader = window[loader];
        } else {
            const url = this.$pane.data('loader-url');
            if (url) this.loader = {
                url,
                settings: this.$pane.data('settings') || {}
            };
        }
    }
    /*
     * Public methods below
     */ active() {
        return this.wizard.goTo(this.index);
    }
    on(event, handler) {
        if (typeof handler === "function") {
            if (Array.isArray(this.events[event])) this.events[event].push(handler);
            else this.events[event] = [
                handler
            ];
        }
        return this;
    }
    off(event, handler) {
        if (typeof handler === "function" && Array.isArray(this.events[event])) $.each(this.events[event], function(i, f) {
            /*eslint consistent-return: "off"*/ if (f === handler) {
                delete this.events[event][i];
                return false;
            }
        });
        return this;
    }
    is(state) {
        return this.states[state] && this.states[state] === true;
    }
    reset() {
        for(const state in this.states)if (({}).hasOwnProperty.call(this.states, state)) this.leave(state);
        this.setup();
        return this;
    }
    setLoader(loader) {
        this.loader = loader;
        if (this.is('active')) this.load();
        return this;
    }
    setValidator(validator) {
        if (typeof validator === "function") this.validator = validator;
        return this;
    }
    validate() {
        return this.validator.call(this.$pane.get(0), this);
    }
}
let counter = 0;
const NAMESPACE$1 = 'wizard';
class wizard {
    constructor(element, options = {}){
        this.$element = $(element);
        this.options = $.extend(true, {}, DEFAULTS, options);
        this.$steps = this.$element.find(this.options.step);
        this.id = this.$element.attr('id');
        if (!this.id) {
            this.id = `wizard-${++counter}`;
            this.$element.attr('id', this.id);
        }
        this.trigger('init');
        this.initialize();
    }
    initialize() {
        this.steps = [];
        const that = this;
        this.$steps.each(function(index) {
            that.steps.push(new Step(this, that, index));
        });
        this._current = 0;
        this.transitioning = null;
        $.each(this.steps, (i, step)=>{
            step.setup();
        });
        this.setup();
        this.$element.on('click', this.options.step, function(e) {
            const index = $(this).data('wizard-index');
            if (!that.get(index).is('disabled')) that.goTo(index);
            e.preventDefault();
            e.stopPropagation();
        });
        if (this.options.keyboard) $(document).on('keyup', $.proxy(this.keydown, this));
        this.trigger('ready');
    }
    setup() {
        this.$buttons = $(this.options.templates.buttons.call(this));
        this.updateButtons();
        const buttonsAppendTo = this.options.buttonsAppendTo;
        let $to;
        if (buttonsAppendTo === 'this') $to = this.$element;
        else if (typeof buttonsAppendTo === "function") $to = buttonsAppendTo.call(this);
        else $to = this.$element.find(buttonsAppendTo);
        this.$buttons = this.$buttons.appendTo($to);
    }
    updateButtons() {
        const classes = this.options.classes.button;
        const $back = this.$buttons.find('[data-wizard="back"]');
        const $next = this.$buttons.find('[data-wizard="next"]');
        const $finish = this.$buttons.find('[data-wizard="finish"]');
        if (this._current === 0) $back.addClass(classes.disabled);
        else $back.removeClass(classes.disabled);
        if (this._current === this.lastIndex()) {
            $next.addClass(classes.hide);
            $finish.removeClass(classes.hide);
        } else {
            $next.removeClass(classes.hide);
            $finish.addClass(classes.hide);
        }
    }
    updateSteps() {
        $.each(this.steps, (i, step)=>{
            if (i > this._current) {
                step.leave('error');
                step.leave('active');
                step.leave('done');
                if (!this.options.enableWhenVisited) step.enter('disabled');
            }
        });
    }
    keydown(e) {
        if (/input|textarea/i.test(e.target.tagName)) return;
        switch(e.which){
            case 37:
                this.back();
                break;
            case 39:
                this.next();
                break;
            default:
                return;
        }
        e.preventDefault();
    }
    trigger(eventType, ...params) {
        let data = [
            this
        ].concat(params);
        // event
        this.$element.trigger(`${NAMESPACE$1}::${eventType}`, data);
        // callback
        eventType = eventType.replace(/\b\w+\b/g, (word)=>{
            return word.substring(0, 1).toUpperCase() + word.substring(1);
        });
        let onFunction = `on${eventType}`;
        if (typeof this.options[onFunction] === 'function') this.options[onFunction].apply(this, params);
    }
    get(index) {
        if (typeof index === 'string' && index.substring(0, 1) === '#') {
            const id = index.substring(1);
            for(const i in this.steps){
                if (this.steps[i].$pane.attr('id') === id) return this.steps[i];
            }
        }
        if (index < this.length() && this.steps[index]) return this.steps[index];
        return null;
    }
    goTo(index, callback) {
        if (index === this._current || this.transitioning === true) return false;
        const current = this.current();
        const to = this.get(index);
        if (index > this._current) {
            if (!current.validate()) {
                current.leave('done');
                current.enter('error');
                return -1;
            }
            current.leave('error');
            if (index > this._current) current.enter('done');
        }
        const that = this;
        const process = ()=>{
            that.trigger('beforeChange', current, to);
            that.transitioning = true;
            current.hide();
            to.show(function() {
                that._current = index;
                that.transitioning = false;
                this.leave('disabled');
                that.updateButtons();
                that.updateSteps();
                if (that.options.autoFocus) {
                    const $input = this.$pane.find(':input');
                    if ($input.length > 0) $input.eq(0).focus();
                    else this.$pane.focus();
                }
                if (typeof callback === "function") callback.call(that);
                that.trigger('afterChange', current, to);
            });
        };
        if (to.loader) to.load(()=>{
            process();
        });
        else process();
        return true;
    }
    length() {
        return this.steps.length;
    }
    current() {
        return this.get(this._current);
    }
    currentIndex() {
        return this._current;
    }
    lastIndex() {
        return this.length() - 1;
    }
    next() {
        if (this._current < this.lastIndex()) {
            const from = this._current, to = this._current + 1;
            this.goTo(to, function() {
                this.trigger('next', this.get(from), this.get(to));
            });
        }
        return false;
    }
    back() {
        if (this._current > 0) {
            const from = this._current, to = this._current - 1;
            this.goTo(to, function() {
                this.trigger('back', this.get(from), this.get(to));
            });
        }
        return false;
    }
    first() {
        return this.goTo(0);
    }
    finish() {
        if (this._current === this.lastIndex()) {
            const current = this.current();
            if (current.validate()) {
                this.trigger('finish');
                current.leave('error');
                current.enter('done');
            } else current.enter('error');
        }
    }
    reset() {
        this._current = 0;
        $.each(this.steps, (i, step)=>{
            step.reset();
        });
        this.trigger('reset');
    }
    static setDefaults(options) {
        $.extend(true, DEFAULTS, $.isPlainObject(options) && options);
    }
}
$(document).on('click', '[data-wizard]', function(e) {
    'use strict';
    let href;
    const $this = $(this);
    const $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''));
    const wizard = $target.data(NAMESPACE$1);
    if (!wizard) return;
    const method = $this.data(NAMESPACE$1);
    if (/^(back|next|first|finish|reset)$/.test(method)) wizard[method]();
    e.preventDefault();
});
var info = {
    version: '0.4.4'
};
const NAMESPACE = 'wizard';
const OtherWizard = $.fn.wizard;
const jQueryWizard = function(options, ...args) {
    if (typeof options === 'string') {
        const method = options;
        if (/^_/.test(method)) return false;
        else if (/^(get)/.test(method)) {
            const instance = this.first().data(NAMESPACE);
            if (instance && typeof instance[method] === 'function') return instance[method](...args);
        } else return this.each(function() {
            const instance = $.data(this, NAMESPACE);
            if (instance && typeof instance[method] === 'function') instance[method](...args);
        });
    }
    return this.each(function() {
        if (!$(this).data(NAMESPACE)) $(this).data(NAMESPACE, new wizard(this, options));
    });
};
$.fn.wizard = jQueryWizard;
$.wizard = $.extend({
    setDefaults: wizard.setDefaults,
    noConflict: function() {
        $.fn.wizard = OtherWizard;
        return jQueryWizard;
    }
}, info);

},{}],"krOtg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "showToast", ()=>showToast);
parcelHelpers.export(exports, "notificationType", ()=>notificationType);
var _bootstrap = require("bootstrap");
function showToast({ title = "Notification", body = "", type = "default", delay = 5000 } = {}) {
    // Ensure Bootstrap toast container exists
    let toastContainer = document.getElementById("global-toast-container");
    if (!toastContainer) {
        console.debug("[Toast] Toast container is missing.");
        return;
    }
    // Create the toast element
    const toast = document.createElement("div");
    toast.className = `toast hide toast fade`;
    toast.setAttribute("role", "alert");
    toast.setAttribute("aria-live", "assertive");
    toast.setAttribute("aria-atomic", "true");
    const iconType = ()=>{
        if (type === "success") return "toast-success fa-solid fa-check-double";
        else if (type === "warn") return "toast-warning fa-solid fa-circle-exclamation";
        else if (type === "error") return "toast-danger fa-solid fa-circle-exclamation";
        //default
        return "toast-primary fa-regular fa-bell";
    };
    // Toast content
    toast.innerHTML = `
        <div class="toast-header">
          <i class="toast-icons ${iconType()}" ></i>
          <strong class="me-auto">${title}</strong>
          <button class="btn-close" type="button" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body toast-dark">
          ${body}
        </div>
    `;
    // Prepend the toast to the container for newest-to-oldest stacking
    toastContainer.prepend(toast);
    // Initialize and show the toast using Bootstrap's Toast class
    const bootstrapToast = new (0, _bootstrap.Toast)(toast);
    bootstrapToast.show();
    // Remove the toast from DOM after it's hidden
    toast.addEventListener("hidden.bs.toast", ()=>{
        toast.remove();
    });
}
const notificationType = {
    SUCCESS: "success",
    WARN: "warn",
    ERROR: "error",
    DEFAULT: "default"
};

},{"bootstrap":"900Wv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"900Wv":[function(require,module,exports,__globalThis) {
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>Alert);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "Carousel", ()=>Carousel);
parcelHelpers.export(exports, "Collapse", ()=>Collapse);
parcelHelpers.export(exports, "Dropdown", ()=>Dropdown);
parcelHelpers.export(exports, "Modal", ()=>Modal);
parcelHelpers.export(exports, "Offcanvas", ()=>Offcanvas);
parcelHelpers.export(exports, "Popover", ()=>Popover);
parcelHelpers.export(exports, "ScrollSpy", ()=>ScrollSpy);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "Toast", ()=>Toast);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _core = require("@popperjs/core");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const elementMap = new Map();
const Data = {
    set (element, key, instance) {
        if (!elementMap.has(element)) elementMap.set(element, new Map());
        const instanceMap = elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!elementMap.has(element)) return;
        const instanceMap = elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const MAX_UID = 1000000;
const MILLISECONDS_MULTIPLIER = 1000;
const TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration, transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};
const triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event(TRANSITION_END));
};
const isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const getElement = (object)=>{
    // it's a jQuery object or a node element
    if (isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector(parseSelector(object));
    return null;
};
const isVisible = (element)=>{
    if (!isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return findShadowRoot(element.parentNode);
};
const noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const DOMContentLoadedCallbacks = [];
const onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of DOMContentLoadedCallbacks)callback();
        });
        DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const isRTL = ()=>document.documentElement.dir === 'rtl';
const defineJQueryPlugin = (plugin)=>{
    onDOMContentLoaded(()=>{
        const $ = getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue;
};
const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener(TRANSITION_END, handler);
        execute(callback);
    };
    transitionElement.addEventListener(TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const stripNameRegex = /\..*/;
const stripUidRegex = /::\d+$/;
const eventRegistry = {}; // Events storage
let uidEvent = 1;
const customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function makeEventUid(element, uid) {
    return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
}
function getElementEvents(element) {
    const uid = makeEventUid(element);
    element.uidEvent = uid;
    eventRegistry[uid] = eventRegistry[uid] || {};
    return eventRegistry[uid];
}
function bootstrapHandler(element, fn) {
    return function handler(event) {
        hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = getTypeEvent(originalTypeEvent);
    if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ''));
    const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace(stripNameRegex, '');
    return customEvents[event] || event;
}
const EventHandler = {
    on (element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace(stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = getjQuery();
        const typeEvent = getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = hydrateObj(new Event(event, {
            bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = isElement(element) ? Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...isElement(element) ? Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = isElement(value) ? 'element' : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const VERSION = '5.3.3';
/**
 * Class definition
 */ class BaseComponent extends Config {
    constructor(element, config){
        super();
        element = getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        Data.remove(this._element, this.constructor.DATA_KEY);
        EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return Data.get(getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>parseSelector(sel)).join(',') : null;
};
const SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = getSelector(element);
        if (selector) return SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = getSelector(element);
        return selector ? SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if (isDisabled(this)) return;
        const target = SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$f = 'alert';
const DATA_KEY$a = 'bs.alert';
const EVENT_KEY$b = `.${DATA_KEY$a}`;
const EVENT_CLOSE = `close${EVENT_KEY$b}`;
const EVENT_CLOSED = `closed${EVENT_KEY$b}`;
const CLASS_NAME_FADE$5 = 'fade';
const CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class Alert extends BaseComponent {
    // Getters
    static get NAME() {
        return NAME$f;
    }
    // Public
    close() {
        const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove(CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        EventHandler.trigger(this._element, EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Alert.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ enableDismissTrigger(Alert, 'close');
/**
 * jQuery
 */ defineJQueryPlugin(Alert);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$e = 'button';
const DATA_KEY$9 = 'bs.button';
const EVENT_KEY$a = `.${DATA_KEY$9}`;
const DATA_API_KEY$6 = '.data-api';
const CLASS_NAME_ACTIVE$3 = 'active';
const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
/**
 * Class definition
 */ class Button extends BaseComponent {
    // Getters
    static get NAME() {
        return NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Button.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
    const data = Button.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Button);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$d = 'swipe';
const EVENT_KEY$9 = '.bs.swipe';
const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$9}`;
const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$9}`;
const EVENT_TOUCHEND = `touchend${EVENT_KEY$9}`;
const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$9}`;
const EVENT_POINTERUP = `pointerup${EVENT_KEY$9}`;
const POINTER_TYPE_TOUCH = 'touch';
const POINTER_TYPE_PEN = 'pen';
const CLASS_NAME_POINTER_EVENT = 'pointer-event';
const SWIPE_THRESHOLD = 40;
const Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class Swipe extends Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return Default$c;
    }
    static get DefaultType() {
        return DefaultType$c;
    }
    static get NAME() {
        return NAME$d;
    }
    // Public
    dispose() {
        EventHandler.off(this._element, EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            EventHandler.on(this._element, EVENT_POINTERDOWN, (event)=>this._start(event));
            EventHandler.on(this._element, EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add(CLASS_NAME_POINTER_EVENT);
        } else {
            EventHandler.on(this._element, EVENT_TOUCHSTART, (event)=>this._start(event));
            EventHandler.on(this._element, EVENT_TOUCHMOVE, (event)=>this._move(event));
            EventHandler.on(this._element, EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$c = 'carousel';
const DATA_KEY$8 = 'bs.carousel';
const EVENT_KEY$8 = `.${DATA_KEY$8}`;
const DATA_API_KEY$5 = '.data-api';
const ARROW_LEFT_KEY$1 = 'ArrowLeft';
const ARROW_RIGHT_KEY$1 = 'ArrowRight';
const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const ORDER_NEXT = 'next';
const ORDER_PREV = 'prev';
const DIRECTION_LEFT = 'left';
const DIRECTION_RIGHT = 'right';
const EVENT_SLIDE = `slide${EVENT_KEY$8}`;
const EVENT_SLID = `slid${EVENT_KEY$8}`;
const EVENT_KEYDOWN$1 = `keydown${EVENT_KEY$8}`;
const EVENT_MOUSEENTER$1 = `mouseenter${EVENT_KEY$8}`;
const EVENT_MOUSELEAVE$1 = `mouseleave${EVENT_KEY$8}`;
const EVENT_DRAG_START = `dragstart${EVENT_KEY$8}`;
const EVENT_LOAD_DATA_API$3 = `load${EVENT_KEY$8}${DATA_API_KEY$5}`;
const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$8}${DATA_API_KEY$5}`;
const CLASS_NAME_CAROUSEL = 'carousel';
const CLASS_NAME_ACTIVE$2 = 'active';
const CLASS_NAME_SLIDE = 'slide';
const CLASS_NAME_END = 'carousel-item-end';
const CLASS_NAME_START = 'carousel-item-start';
const CLASS_NAME_NEXT = 'carousel-item-next';
const CLASS_NAME_PREV = 'carousel-item-prev';
const SELECTOR_ACTIVE = '.active';
const SELECTOR_ITEM = '.carousel-item';
const SELECTOR_ACTIVE_ITEM = SELECTOR_ACTIVE + SELECTOR_ITEM;
const SELECTOR_ITEM_IMG = '.carousel-item img';
const SELECTOR_INDICATORS = '.carousel-indicators';
const SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const KEY_TO_DIRECTION = {
    [ARROW_LEFT_KEY$1]: DIRECTION_RIGHT,
    [ARROW_RIGHT_KEY$1]: DIRECTION_LEFT
};
const Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class Carousel extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return Default$b;
    }
    static get DefaultType() {
        return DefaultType$b;
    }
    static get NAME() {
        return NAME$c;
    }
    // Public
    next() {
        this._slide(ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && isVisible(this._element)) this.next();
    }
    prev() {
        this._slide(ORDER_PREV);
    }
    pause() {
        if (this._isSliding) triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            EventHandler.one(this._element, EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            EventHandler.one(this._element, EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) EventHandler.on(this._element, EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            EventHandler.on(this._element, EVENT_MOUSEENTER$1, ()=>this.pause());
            EventHandler.on(this._element, EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of SelectorEngine.find(SELECTOR_ITEM_IMG, this._element))EventHandler.on(img, EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder(DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder(DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add(CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === ORDER_NEXT;
        const nextElement = element || getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent(EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
        const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add(CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent(EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_SLIDE);
    }
    _getActive() {
        return SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return SelectorEngine.find(SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if (isRTL()) return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
        return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
    }
    _orderToDirection(order) {
        if (isRTL()) return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Carousel.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = Carousel.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if (Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
EventHandler.on(window, EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);
    for (const carousel of carousels)Carousel.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ defineJQueryPlugin(Carousel);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$b = 'collapse';
const DATA_KEY$7 = 'bs.collapse';
const EVENT_KEY$7 = `.${DATA_KEY$7}`;
const DATA_API_KEY$4 = '.data-api';
const EVENT_SHOW$6 = `show${EVENT_KEY$7}`;
const EVENT_SHOWN$6 = `shown${EVENT_KEY$7}`;
const EVENT_HIDE$6 = `hide${EVENT_KEY$7}`;
const EVENT_HIDDEN$6 = `hidden${EVENT_KEY$7}`;
const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$7}${DATA_API_KEY$4}`;
const CLASS_NAME_SHOW$7 = 'show';
const CLASS_NAME_COLLAPSE = 'collapse';
const CLASS_NAME_COLLAPSING = 'collapsing';
const CLASS_NAME_COLLAPSED = 'collapsed';
const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const WIDTH = 'width';
const HEIGHT = 'height';
const SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const Default$a = {
    parent: null,
    toggle: true
};
const DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class Collapse extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = SelectorEngine.getSelectorFromElement(elem);
            const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return Default$a;
    }
    static get DefaultType() {
        return DefaultType$a;
    }
    static get NAME() {
        return NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove(CLASS_NAME_COLLAPSE);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove(CLASS_NAME_COLLAPSING);
            this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            EventHandler.trigger(this._element, EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_COLLAPSING);
        this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove(CLASS_NAME_COLLAPSING);
            this._element.classList.add(CLASS_NAME_COLLAPSE);
            EventHandler.trigger(this._element, EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains(CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = Collapse.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Collapse);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$a = 'dropdown';
const DATA_KEY$6 = 'bs.dropdown';
const EVENT_KEY$6 = `.${DATA_KEY$6}`;
const DATA_API_KEY$3 = '.data-api';
const ESCAPE_KEY$2 = 'Escape';
const TAB_KEY$1 = 'Tab';
const ARROW_UP_KEY$1 = 'ArrowUp';
const ARROW_DOWN_KEY$1 = 'ArrowDown';
const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const EVENT_HIDE$5 = `hide${EVENT_KEY$6}`;
const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$6}`;
const EVENT_SHOW$5 = `show${EVENT_KEY$6}`;
const EVENT_SHOWN$5 = `shown${EVENT_KEY$6}`;
const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$6}${DATA_API_KEY$3}`;
const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$6}${DATA_API_KEY$3}`;
const CLASS_NAME_SHOW$6 = 'show';
const CLASS_NAME_DROPUP = 'dropup';
const CLASS_NAME_DROPEND = 'dropend';
const CLASS_NAME_DROPSTART = 'dropstart';
const CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const SELECTOR_DATA_TOGGLE_SHOWN = `${SELECTOR_DATA_TOGGLE$3}.${CLASS_NAME_SHOW$6}`;
const SELECTOR_MENU = '.dropdown-menu';
const SELECTOR_NAVBAR = '.navbar';
const SELECTOR_NAVBAR_NAV = '.navbar-nav';
const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
const PLACEMENT_TOPCENTER = 'top';
const PLACEMENT_BOTTOMCENTER = 'bottom';
const Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class Dropdown extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = SelectorEngine.next(this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return Default$9;
    }
    static get DefaultType() {
        return DefaultType$9;
    }
    static get NAME() {
        return NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if (isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add(CLASS_NAME_SHOW$6);
        this._element.classList.add(CLASS_NAME_SHOW$6);
        EventHandler.trigger(this._element, EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if (isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove(CLASS_NAME_SHOW$6);
        this._element.classList.remove(CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        Manipulator.removeDataAttribute(this._menu, 'popper');
        EventHandler.trigger(this._element, EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof _core === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = _core.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains(CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
        return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest(SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key, target }) {
        const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        getNextActiveElement(items, target, key === ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Dropdown.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1) return;
        const openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = Dropdown.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            ARROW_UP_KEY$1,
            ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE$3)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = Dropdown.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    Dropdown.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ defineJQueryPlugin(Dropdown);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$9 = 'backdrop';
const CLASS_NAME_FADE$4 = 'fade';
const CLASS_NAME_SHOW$5 = 'show';
const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$9}`;
const Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class Backdrop extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return Default$8;
    }
    static get DefaultType() {
        return DefaultType$8;
    }
    static get NAME() {
        return NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) reflow(element);
        element.classList.add(CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            execute(callback);
            return;
        }
        this._getElement().classList.remove(CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        EventHandler.off(this._element, EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add(CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        EventHandler.on(element, EVENT_MOUSEDOWN, ()=>{
            execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$8 = 'focustrap';
const DATA_KEY$5 = 'bs.focustrap';
const EVENT_KEY$5 = `.${DATA_KEY$5}`;
const EVENT_FOCUSIN$2 = `focusin${EVENT_KEY$5}`;
const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
const TAB_KEY = 'Tab';
const TAB_NAV_FORWARD = 'forward';
const TAB_NAV_BACKWARD = 'backward';
const Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class FocusTrap extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return Default$7;
    }
    static get DefaultType() {
        return DefaultType$7;
    }
    static get NAME() {
        return NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop
        EventHandler.on(document, EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        EventHandler.on(document, EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        EventHandler.off(document, EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const SELECTOR_STICKY_CONTENT = '.sticky-top';
const PROPERTY_PADDING = 'padding-right';
const PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_FIXED_CONTENT, PROPERTY_PADDING);
        this._resetElementAttributes(SELECTOR_STICKY_CONTENT, PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if (isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$7 = 'modal';
const DATA_KEY$4 = 'bs.modal';
const EVENT_KEY$4 = `.${DATA_KEY$4}`;
const DATA_API_KEY$2 = '.data-api';
const ESCAPE_KEY$1 = 'Escape';
const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
const EVENT_HIDE_PREVENTED$1 = `hidePrevented${EVENT_KEY$4}`;
const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
const EVENT_RESIZE$1 = `resize${EVENT_KEY$4}`;
const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$4}`;
const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$4}`;
const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$4}${DATA_API_KEY$2}`;
const CLASS_NAME_OPEN = 'modal-open';
const CLASS_NAME_FADE$3 = 'fade';
const CLASS_NAME_SHOW$4 = 'show';
const CLASS_NAME_STATIC = 'modal-static';
const OPEN_SELECTOR$1 = '.modal.show';
const SELECTOR_DIALOG = '.modal-dialog';
const SELECTOR_MODAL_BODY = '.modal-body';
const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class Modal extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return Default$6;
    }
    static get DefaultType() {
        return DefaultType$6;
    }
    static get NAME() {
        return NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
            relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add(CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove(CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        EventHandler.off(window, EVENT_KEY$4);
        EventHandler.off(this._dialog, EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            EventHandler.trigger(this._element, EVENT_SHOWN$4, {
                relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        EventHandler.on(window, EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        EventHandler.on(this._element, EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            EventHandler.one(this._element, EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove(CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            EventHandler.trigger(this._element, EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains(CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains(CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add(CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove(CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = Modal.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    EventHandler.one(target, EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        EventHandler.one(target, EVENT_HIDDEN$4, ()=>{
            if (isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);
    if (alreadyOpen) Modal.getInstance(alreadyOpen).hide();
    const data = Modal.getOrCreateInstance(target);
    data.toggle(this);
});
enableDismissTrigger(Modal);
/**
 * jQuery
 */ defineJQueryPlugin(Modal);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$6 = 'offcanvas';
const DATA_KEY$3 = 'bs.offcanvas';
const EVENT_KEY$3 = `.${DATA_KEY$3}`;
const DATA_API_KEY$1 = '.data-api';
const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$3}${DATA_API_KEY$1}`;
const ESCAPE_KEY = 'Escape';
const CLASS_NAME_SHOW$3 = 'show';
const CLASS_NAME_SHOWING$1 = 'showing';
const CLASS_NAME_HIDING = 'hiding';
const CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const OPEN_SELECTOR = '.offcanvas.show';
const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$3}${DATA_API_KEY$1}`;
const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class Offcanvas extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return Default$5;
    }
    static get DefaultType() {
        return DefaultType$5;
    }
    static get NAME() {
        return NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
            relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add(CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add(CLASS_NAME_SHOW$3);
            this._element.classList.remove(CLASS_NAME_SHOWING$1);
            EventHandler.trigger(this._element, EVENT_SHOWN$3, {
                relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add(CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove(CLASS_NAME_SHOW$3, CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new ScrollBarHelper().reset();
            EventHandler.trigger(this._element, EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new Backdrop({
            className: CLASS_NAME_BACKDROP,
            isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Offcanvas.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if (isDisabled(this)) return;
    EventHandler.one(target, EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if (isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
    const data = Offcanvas.getOrCreateInstance(target);
    data.toggle(this);
});
EventHandler.on(window, EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of SelectorEngine.find(OPEN_SELECTOR))Offcanvas.getOrCreateInstance(selector).show();
});
EventHandler.on(window, EVENT_RESIZE, ()=>{
    for (const element of SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') Offcanvas.getOrCreateInstance(element).hide();
});
enableDismissTrigger(Offcanvas);
/**
 * jQuery
 */ defineJQueryPlugin(Offcanvas);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if (uriAttributes.has(attributeName)) return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$5 = 'TemplateFactory';
const Default$4 = {
    allowList: DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class TemplateFactory extends Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return Default$4;
    }
    static get DefaultType() {
        return DefaultType$4;
    }
    static get NAME() {
        return NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector,
            entry: content
        }, DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if (isElement(content)) {
            this._putElementInTemplate(getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$4 = 'tooltip';
const DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const CLASS_NAME_FADE$2 = 'fade';
const CLASS_NAME_MODAL = 'modal';
const CLASS_NAME_SHOW$2 = 'show';
const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
const EVENT_MODAL_HIDE = 'hide.bs.modal';
const TRIGGER_HOVER = 'hover';
const TRIGGER_FOCUS = 'focus';
const TRIGGER_CLICK = 'click';
const TRIGGER_MANUAL = 'manual';
const EVENT_HIDE$2 = 'hide';
const EVENT_HIDDEN$2 = 'hidden';
const EVENT_SHOW$2 = 'show';
const EVENT_SHOWN$2 = 'shown';
const EVENT_INSERTED = 'inserted';
const EVENT_CLICK$1 = 'click';
const EVENT_FOCUSIN$1 = 'focusin';
const EVENT_FOCUSOUT$1 = 'focusout';
const EVENT_MOUSEENTER = 'mouseenter';
const EVENT_MOUSELEAVE = 'mouseleave';
const AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: isRTL() ? 'right' : 'left'
};
const Default$3 = {
    allowList: DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class Tooltip extends BaseComponent {
    constructor(element, config){
        if (typeof _core === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return Default$3;
    }
    static get DefaultType() {
        return DefaultType$3;
    }
    static get NAME() {
        return NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOW$2));
        const shadowRoot = findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add(CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.on(element, 'mouseover', noop);
        const complete = ()=>{
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove(CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))EventHandler.off(element, 'mouseover', noop);
        this._activeTrigger[TRIGGER_CLICK] = false;
        this._activeTrigger[TRIGGER_FOCUS] = false;
        this._activeTrigger[TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            EventHandler.trigger(this._element, this.constructor.eventName(EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add(CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new TemplateFactory({
            ...this._config,
            // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains(CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = AttachmentMap[placement.toUpperCase()];
        return _core.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') EventHandler.on(this._element, this.constructor.eventName(EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== TRIGGER_MANUAL) {
                const eventIn = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSEENTER) : this.constructor.eventName(EVENT_FOCUSIN$1);
                const eventOut = trigger === TRIGGER_HOVER ? this.constructor.eventName(EVENT_MOUSELEAVE) : this.constructor.eventName(EVENT_FOCUSOUT$1);
                EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
                    context._enter();
                });
                EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if (DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tooltip.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ defineJQueryPlugin(Tooltip);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$3 = 'popover';
const SELECTOR_TITLE = '.popover-header';
const SELECTOR_CONTENT = '.popover-body';
const Default$2 = {
    ...Tooltip.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const DefaultType$2 = {
    ...Tooltip.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class Popover extends Tooltip {
    // Getters
    static get Default() {
        return Default$2;
    }
    static get DefaultType() {
        return DefaultType$2;
    }
    static get NAME() {
        return NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [SELECTOR_TITLE]: this._getTitle(),
            [SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Popover.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ defineJQueryPlugin(Popover);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$2 = 'scrollspy';
const DATA_KEY$2 = 'bs.scrollspy';
const EVENT_KEY$2 = `.${DATA_KEY$2}`;
const DATA_API_KEY = '.data-api';
const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
const EVENT_CLICK = `click${EVENT_KEY$2}`;
const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$2}${DATA_API_KEY}`;
const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const CLASS_NAME_ACTIVE$1 = 'active';
const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const SELECTOR_TARGET_LINKS = '[href]';
const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const SELECTOR_NAV_LINKS = '.nav-link';
const SELECTOR_NAV_ITEMS = '.nav-item';
const SELECTOR_LIST_ITEMS = '.list-group-item';
const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_NAV_ITEMS} > ${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`;
const SELECTOR_DROPDOWN = '.dropdown';
const SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class ScrollSpy extends BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return Default$1;
    }
    static get DefaultType() {
        return DefaultType$1;
    }
    static get NAME() {
        return NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        EventHandler.off(this._config.target, EVENT_CLICK);
        EventHandler.on(this._config.target, EVENT_CLICK, SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = SelectorEngine.find(SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || isDisabled(anchor)) continue;
            const observableSection = SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if (isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add(CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        EventHandler.trigger(this._element, EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
            SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, target.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of SelectorEngine.parents(target, SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of SelectorEngine.prev(listGroup, SELECTOR_LINK_ITEMS))item.classList.add(CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove(CLASS_NAME_ACTIVE$1);
        const activeNodes = SelectorEngine.find(`${SELECTOR_TARGET_LINKS}.${CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove(CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = ScrollSpy.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(window, EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY))ScrollSpy.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ defineJQueryPlugin(ScrollSpy);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME$1 = 'tab';
const DATA_KEY$1 = 'bs.tab';
const EVENT_KEY$1 = `.${DATA_KEY$1}`;
const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}`;
const EVENT_KEYDOWN = `keydown${EVENT_KEY$1}`;
const EVENT_LOAD_DATA_API = `load${EVENT_KEY$1}`;
const ARROW_LEFT_KEY = 'ArrowLeft';
const ARROW_RIGHT_KEY = 'ArrowRight';
const ARROW_UP_KEY = 'ArrowUp';
const ARROW_DOWN_KEY = 'ArrowDown';
const HOME_KEY = 'Home';
const END_KEY = 'End';
const CLASS_NAME_ACTIVE = 'active';
const CLASS_NAME_FADE$1 = 'fade';
const CLASS_NAME_SHOW$1 = 'show';
const CLASS_DROPDOWN = 'dropdown';
const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${SELECTOR_DROPDOWN_TOGGLE})`;
const SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const SELECTOR_OUTER = '.nav-item, .list-group-item';
const SELECTOR_INNER = `.nav-link${NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const SELECTOR_INNER_ELEM = `${SELECTOR_INNER}, ${SELECTOR_DATA_TOGGLE}`;
const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class Tab extends BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest(SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        EventHandler.on(this._element, EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = EventHandler.trigger(innerElem, EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add(CLASS_NAME_ACTIVE);
        this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add(CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            EventHandler.trigger(element, EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove(CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove(CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            EventHandler.trigger(element, EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            ARROW_LEFT_KEY,
            ARROW_RIGHT_KEY,
            ARROW_UP_KEY,
            ARROW_DOWN_KEY,
            HOME_KEY,
            END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!isDisabled(element));
        let nextActiveElement;
        if ([
            HOME_KEY,
            END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                ARROW_RIGHT_KEY,
                ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            Tab.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
        toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains(CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest(SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tab.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if (isDisabled(this)) return;
    Tab.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ EventHandler.on(window, EVENT_LOAD_DATA_API, ()=>{
    for (const element of SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE))Tab.getOrCreateInstance(element);
});
/**
 * jQuery
 */ defineJQueryPlugin(Tab);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const NAME = 'toast';
const DATA_KEY = 'bs.toast';
const EVENT_KEY = `.${DATA_KEY}`;
const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
const EVENT_HIDE = `hide${EVENT_KEY}`;
const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
const EVENT_SHOW = `show${EVENT_KEY}`;
const EVENT_SHOWN = `shown${EVENT_KEY}`;
const CLASS_NAME_FADE = 'fade';
const CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const CLASS_NAME_SHOW = 'show';
const CLASS_NAME_SHOWING = 'showing';
const DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class Toast extends BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return Default;
    }
    static get DefaultType() {
        return DefaultType;
    }
    static get NAME() {
        return NAME;
    }
    // Public
    show() {
        const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove(CLASS_NAME_SHOWING);
            EventHandler.trigger(this._element, EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
        reflow(this._element);
        this._element.classList.add(CLASS_NAME_SHOW, CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove(CLASS_NAME_SHOWING, CLASS_NAME_SHOW);
            EventHandler.trigger(this._element, EVENT_HIDDEN);
        };
        this._element.classList.add(CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove(CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains(CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        EventHandler.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        EventHandler.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        EventHandler.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Toast.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ enableDismissTrigger(Toast);
/**
 * jQuery
 */ defineJQueryPlugin(Toast);

},{"@popperjs/core":"lJ8zG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJ8zG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":"aVHEw","./modifiers/index.js":"cTWLz","./createPopper.js":"5bix2","./popper.js":"9PKmn","./popper-lite.js":"jbutu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVHEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTWLz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", ()=>(0, _applyStylesJsDefault.default));
parcelHelpers.export(exports, "arrow", ()=>(0, _arrowJsDefault.default));
parcelHelpers.export(exports, "computeStyles", ()=>(0, _computeStylesJsDefault.default));
parcelHelpers.export(exports, "eventListeners", ()=>(0, _eventListenersJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "hide", ()=>(0, _hideJsDefault.default));
parcelHelpers.export(exports, "offset", ()=>(0, _offsetJsDefault.default));
parcelHelpers.export(exports, "popperOffsets", ()=>(0, _popperOffsetsJsDefault.default));
parcelHelpers.export(exports, "preventOverflow", ()=>(0, _preventOverflowJsDefault.default));
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"axnJn","./arrow.js":"013Ka","./computeStyles.js":"cicmq","./eventListeners.js":"jlw8n","./flip.js":"d52GI","./hide.js":"04i94","./offset.js":"4U7Nh","./popperOffsets.js":"c9hkC","./preventOverflow.js":"e2LIN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axnJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"ieVOk","../dom-utils/instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ieVOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2T0o5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfve1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"013Ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"9MJkV","../dom-utils/getLayoutRect.js":"kG7jY","../dom-utils/contains.js":"7L99u","../dom-utils/getOffsetParent.js":"bwrIe","../utils/getMainAxisFromPlacement.js":"g9UdY","../utils/within.js":"jZfhy","../utils/mergePaddingObject.js":"5ChzK","../utils/expandToHashMap.js":"cjMxw","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MJkV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kG7jY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"7Xusb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Xusb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"2T0o5","../utils/math.js":"dciKy","./getWindow.js":"dfve1","./isLayoutViewport.js":"eFy6F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dciKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eFy6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"dJQYM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJQYM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7L99u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwrIe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"dfve1","./getNodeName.js":"ieVOk","./getComputedStyle.js":"e5Z6G","./instanceOf.js":"2T0o5","./isTableElement.js":"hdQlE","./getParentNode.js":"3lnhM","../utils/userAgent.js":"dJQYM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5Z6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdQlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"ieVOk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3lnhM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"ieVOk","./getDocumentElement.js":"6Q5T4","./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Q5T4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9UdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZfhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ChzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"fSN4P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSN4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjMxw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cicmq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"aVHEw","../dom-utils/getOffsetParent.js":"bwrIe","../dom-utils/getWindow.js":"dfve1","../dom-utils/getDocumentElement.js":"6Q5T4","../dom-utils/getComputedStyle.js":"e5Z6G","../utils/getBasePlacement.js":"9MJkV","../utils/getVariation.js":"ffjaD","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ffjaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlw8n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d52GI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"6YTF4","../utils/getBasePlacement.js":"9MJkV","../utils/getOppositeVariationPlacement.js":"geQZR","../utils/detectOverflow.js":"b9d7D","../utils/computeAutoPlacement.js":"1nCo5","../enums.js":"aVHEw","../utils/getVariation.js":"ffjaD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YTF4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"geQZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9d7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"co3QM","../dom-utils/getDocumentElement.js":"6Q5T4","../dom-utils/getBoundingClientRect.js":"7Xusb","./computeOffsets.js":"avGZq","./rectToClientRect.js":"dTyTB","../enums.js":"aVHEw","../dom-utils/instanceOf.js":"2T0o5","./mergePaddingObject.js":"5ChzK","./expandToHashMap.js":"cjMxw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"co3QM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"aVHEw","./getViewportRect.js":"hGVzr","./getDocumentRect.js":"6IHKV","./listScrollParents.js":"hfcbR","./getOffsetParent.js":"bwrIe","./getDocumentElement.js":"6Q5T4","./getComputedStyle.js":"e5Z6G","./instanceOf.js":"2T0o5","./getBoundingClientRect.js":"7Xusb","./getParentNode.js":"3lnhM","./contains.js":"7L99u","./getNodeName.js":"ieVOk","../utils/rectToClientRect.js":"dTyTB","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGVzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"dfve1","./getDocumentElement.js":"6Q5T4","./getWindowScrollBarX.js":"lXicm","./isLayoutViewport.js":"eFy6F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lXicm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"7Xusb","./getDocumentElement.js":"6Q5T4","./getWindowScroll.js":"7Wym7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Wym7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"dfve1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IHKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"6Q5T4","./getComputedStyle.js":"e5Z6G","./getWindowScrollBarX.js":"lXicm","./getWindowScroll.js":"7Wym7","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfcbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"2cf06","./getParentNode.js":"3lnhM","./getWindow.js":"dfve1","./isScrollParent.js":"fFR6W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cf06":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"3lnhM","./isScrollParent.js":"fFR6W","./getNodeName.js":"ieVOk","./instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFR6W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"e5Z6G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTyTB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avGZq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"9MJkV","./getVariation.js":"ffjaD","./getMainAxisFromPlacement.js":"g9UdY","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nCo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"ffjaD","../enums.js":"aVHEw","./detectOverflow.js":"b9d7D","./getBasePlacement.js":"9MJkV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04i94":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"aVHEw","../utils/detectOverflow.js":"b9d7D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4U7Nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"9MJkV","../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9hkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"avGZq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e2LIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"aVHEw","../utils/getBasePlacement.js":"9MJkV","../utils/getMainAxisFromPlacement.js":"g9UdY","../utils/getAltAxis.js":"7EpoZ","../utils/within.js":"jZfhy","../dom-utils/getLayoutRect.js":"kG7jY","../dom-utils/getOffsetParent.js":"bwrIe","../utils/detectOverflow.js":"b9d7D","../utils/getVariation.js":"ffjaD","../utils/getFreshSideObject.js":"fSN4P","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EpoZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bix2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"j9xOu","./dom-utils/getLayoutRect.js":"kG7jY","./dom-utils/listScrollParents.js":"hfcbR","./dom-utils/getOffsetParent.js":"bwrIe","./utils/orderModifiers.js":"djBhV","./utils/debounce.js":"7uJdm","./utils/mergeByName.js":"3LgOA","./utils/detectOverflow.js":"b9d7D","./dom-utils/instanceOf.js":"2T0o5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j9xOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"7Xusb","./getNodeScroll.js":"FfOIL","./getNodeName.js":"ieVOk","./instanceOf.js":"2T0o5","./getWindowScrollBarX.js":"lXicm","./getDocumentElement.js":"6Q5T4","./isScrollParent.js":"fFR6W","../utils/math.js":"dciKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FfOIL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7Wym7","./getWindow.js":"dfve1","./instanceOf.js":"2T0o5","./getHTMLElementScroll.js":"fgxlE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fgxlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djBhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"aVHEw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7uJdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3LgOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PKmn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"5bix2","./modifiers/eventListeners.js":"jlw8n","./modifiers/popperOffsets.js":"c9hkC","./modifiers/computeStyles.js":"cicmq","./modifiers/applyStyles.js":"axnJn","./modifiers/offset.js":"4U7Nh","./modifiers/flip.js":"d52GI","./modifiers/preventOverflow.js":"e2LIN","./modifiers/arrow.js":"013Ka","./modifiers/hide.js":"04i94","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbutu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"5bix2","./modifiers/eventListeners.js":"jlw8n","./modifiers/popperOffsets.js":"c9hkC","./modifiers/computeStyles.js":"cicmq","./modifiers/applyStyles.js":"axnJn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1OAlE":[function(require,module,exports,__globalThis) {
// eventBus.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventBus", ()=>eventBus);
var _mitt = require("mitt");
var _mittDefault = parcelHelpers.interopDefault(_mitt);
const eventBus = (0, _mittDefault.default)();

},{"mitt":"9VktN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VktN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i ? i.push(e) : n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
            },
            emit: function(t, e) {
                var i = n.get(t);
                i && i.slice().map(function(n) {
                    n(e);
                }), (i = n.get("*")) && i.slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Hmtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderWithPoi", ()=>renderWithPoi);
const renderWithPoi = (data)=>{
    let label = '';
    if (data.type === 'POI' && data.poi.name) label = `
           <div>
              <strong>${data.poi.name}</strong> 
                <br/>
              <span title="${data.name}">
                ${data.name}
              </span>
           </div>`;
    else label = `<span title="${data.name}">${data.name}</span`;
    return label;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRLz3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal"
};
const _hoisted_2 = {
    id: "wizard"
};
const _hoisted_3 = {
    class: "card-body"
};
const _hoisted_4 = {
    class: "horizontal-wizard-wrapper"
};
const _hoisted_5 = {
    class: "row"
};
const _hoisted_6 = {
    class: "col-12 tab-content dark-field",
    id: "wizard-tab-content"
};
const _hoisted_7 = {
    class: "tab-pane fade active show wizard-content",
    id: "trip-details",
    role: "tabpanel",
    "aria-labelledby": "trip-details-tab"
};
const _hoisted_8 = {
    class: "row"
};
const _hoisted_9 = {
    class: "col-sm-6 mb-3"
};
const _hoisted_10 = [
    "value"
];
const _hoisted_11 = {
    class: "row"
};
const _hoisted_12 = {
    class: "col"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = {
    class: "row mb-3"
};
const _hoisted_15 = {
    class: "col-12"
};
const _hoisted_16 = {
    class: "form-check checkbox"
};
const _hoisted_17 = {
    class: "row"
};
const _hoisted_18 = {
    class: "col-12"
};
const _hoisted_19 = {
    class: "mb-3"
};
const _hoisted_20 = [
    "disabled"
];
const _hoisted_21 = {
    class: "tab-pane fade wizard-content",
    id: "passenger-details",
    role: "tabpanel"
};
const _hoisted_22 = {
    class: "row mb-3"
};
const _hoisted_23 = {
    class: "col-12"
};
const _hoisted_24 = {
    class: "form-check checkbox"
};
const _hoisted_25 = {
    class: "row"
};
const _hoisted_26 = {
    class: "col-sm-7 mb-3"
};
const _hoisted_27 = [
    "disabled"
];
const _hoisted_28 = {
    class: "col-sm-5 mb-3"
};
const _hoisted_29 = [
    "disabled"
];
const _hoisted_30 = {
    class: "row"
};
const _hoisted_31 = {
    class: "col-sm-6 mb-3"
};
const _hoisted_32 = {
    class: "touchspin-wrapper"
};
const _hoisted_33 = [
    "disabled"
];
const _hoisted_34 = [
    "disabled"
];
const _hoisted_35 = [
    "disabled"
];
const _hoisted_36 = {
    class: "tab-pane fade wizard-content",
    id: "dispatch",
    role: "tabpanel",
    "aria-labelledby": "dispatch"
};
const _hoisted_37 = {
    key: 0,
    class: "row mb-3"
};
const _hoisted_38 = {
    key: 1
};
const _hoisted_39 = {
    key: 0,
    class: "row mb-3"
};
const _hoisted_40 = {
    key: 1,
    class: "row"
};
const _hoisted_41 = {
    class: "col-sm-6 mb-3"
};
const _hoisted_42 = {
    class: "form-control-static"
};
const _hoisted_43 = {
    key: 0,
    class: "col-sm-6 mb-3"
};
const _hoisted_44 = {
    class: "form-control-static"
};
const _hoisted_45 = {
    class: "col-sm-6 mb-3"
};
const _hoisted_46 = {
    key: 0,
    class: "form-control-static"
};
const _hoisted_47 = {
    key: 1,
    class: "form-control-static"
};
const _hoisted_48 = {
    class: "row"
};
const _hoisted_49 = {
    class: "col-sm-6 mb-3"
};
const _hoisted_50 = {
    class: "form-check-size"
};
const _hoisted_51 = {
    class: "form-check form-switch form-check-inline"
};
const _hoisted_52 = {
    key: 0,
    class: "col-sm-6 mb-3"
};
const _hoisted_53 = {
    class: "row"
};
const _hoisted_54 = {
    class: "col-12 mb-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h2", null, " Book a Ride ")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("div", {
                            class: "col-12 main-horizontal-header mb-3 border-1",
                            id: "booking-wizard"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "nav nav-pills horizontal-options",
                                id: "vertical-wizard-tab",
                                role: "tablist",
                                "aria-orientation": "vertical"
                            }, [
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    id: "wizard-v-info-tab",
                                    "data-bs-toggle": "pill",
                                    href: "#trip-details",
                                    role: "tab",
                                    "aria-controls": "wizard-v-info",
                                    "aria-selected": "true"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-map-location-dot"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Trip Details")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    id: "inquiry-v-wizard-tab",
                                    "data-bs-toggle": "pill",
                                    href: "#passenger-details",
                                    role: "tab",
                                    "aria-controls": "inquiry-v-wizard",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-user-group"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Passenger Details")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    id: "successful-v-wizard-tab",
                                    "data-bs-toggle": "pill",
                                    href: "#dispatch",
                                    role: "tab",
                                    "aria-controls": "successful-v-wizard",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-taxi"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Dispatch")
                                        ])
                                    ])
                                ])
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            (0, _vue.createElementVNode)("div", _hoisted_7, [
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    (0, _vue.createElementVNode)("div", _hoisted_9, [
                                        _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "account-select"
                                        }, "Account", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                            id: "account-select",
                                            class: "form-select",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.selectedAccount = $event)
                                        }, [
                                            _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("option", {
                                                value: null
                                            }, "No Account", -1)),
                                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.accounts, (account)=>{
                                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                    key: account.id,
                                                    value: account.id
                                                }, (0, _vue.toDisplayString)(account.companyName) + " (" + (0, _vue.toDisplayString)(account.accountCode) + ") ", 9, _hoisted_10);
                                            }), 128))
                                        ], 512), [
                                            [
                                                (0, _vue.vModelSelect),
                                                $setup.selectedAccount
                                            ]
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_11, [
                                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                                            _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "pickup-location-input"
                                            }, "Pickup Location", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "pickup-location-input",
                                                class: "form-control",
                                                ref: "pickupInput",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.pickUpInfo.value = $event),
                                                type: "text",
                                                placeholder: "Start typing..."
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.pickUpInfo.value
                                                ]
                                            ]),
                                            _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                                                id: "pickup-location-error",
                                                class: "invalid-feedback d-none"
                                            }, "Please enter an address ", -1))
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_14, [
                                    (0, _vue.createElementVNode)("div", _hoisted_15, [
                                        (0, _vue.createElementVNode)("div", _hoisted_16, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "checkbox",
                                                id: "skip-drop-off-location",
                                                class: "form-check-input",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.skipDropOffLocation = $event)
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelCheckbox),
                                                    $setup.skipDropOffLocation
                                                ]
                                            ]),
                                            _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                                                class: "form-check-label f-w-600",
                                                for: "skip-drop-off-location"
                                            }, " Skip Drop-Off Location ", -1))
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_17, [
                                    (0, _vue.createElementVNode)("div", _hoisted_18, [
                                        (0, _vue.createElementVNode)("div", _hoisted_19, [
                                            _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "drop-off-location-input"
                                            }, "Drop-Off Location", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "drop-off-location-input",
                                                class: "form-control",
                                                ref: "dropOffInput",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.dropOffInfo.value = $event),
                                                disabled: $setup.skipDropOffLocation,
                                                type: "text",
                                                placeholder: "Start typing..."
                                            }, null, 8, _hoisted_20), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.dropOffInfo.value
                                                ]
                                            ]),
                                            _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                                id: "drop-off-location-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter an address ", -1))
                                        ])
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_21, [
                                (0, _vue.createElementVNode)("div", _hoisted_22, [
                                    (0, _vue.createElementVNode)("div", _hoisted_23, [
                                        (0, _vue.createElementVNode)("div", _hoisted_24, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "checkbox",
                                                id: "skip-passenger-info",
                                                class: "form-check-input",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.skipPassengerInfo = $event)
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelCheckbox),
                                                    $setup.skipPassengerInfo
                                                ]
                                            ]),
                                            _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                                class: "form-check-label f-w-600",
                                                for: "skip-passenger-info"
                                            }, " Skip Passenger Details ", -1))
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_25, [
                                    (0, _vue.createElementVNode)("div", _hoisted_26, [
                                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "passenger-name-input"
                                        }, "Passenger Name (Optional)", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            id: "passenger-name-input",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.passengerName = $event),
                                            disabled: $setup.skipPassengerInfo,
                                            type: "text",
                                            placeholder: "Johnny Smith"
                                        }, null, 8, _hoisted_27), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.passengerName
                                            ]
                                        ]),
                                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("div", {
                                            id: "passenger-name-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter the passenger name ", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_28, [
                                        _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "passenger-contact-input"
                                        }, "Contact Number (Optional)", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            id: "passenger-contact-input",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.passengerContact = $event),
                                            disabled: $setup.skipPassengerInfo,
                                            type: "tel",
                                            placeholder: "123-456-7890"
                                        }, null, 8, _hoisted_29), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.passengerContact
                                            ]
                                        ]),
                                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("div", {
                                            id: "passenger-contact-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a valid contact number ", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_30, [
                                    (0, _vue.createElementVNode)("div", _hoisted_31, [
                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "passenger-number-input"
                                        }, "Number of Passengers", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_32, [
                                            (0, _vue.createElementVNode)("button", {
                                                type: "button",
                                                class: "decrement-touchspin btn-touchspin spin-border-primary",
                                                disabled: $setup.skipPassengerInfo,
                                                onClick: $setup.decrementPassengers
                                            }, _cache[23] || (_cache[23] = [
                                                (0, _vue.createElementVNode)("i", {
                                                    class: "fa-solid fa-minus"
                                                }, null, -1)
                                            ]), 8, _hoisted_33),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                class: "input-touchspin spin-outline-primary me-1 ms-1",
                                                type: "number",
                                                id: "passenger-number-input",
                                                disabled: $setup.skipPassengerInfo,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.numPassengers = $event),
                                                min: "1"
                                            }, null, 8, _hoisted_34), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.numPassengers
                                                ]
                                            ]),
                                            (0, _vue.createElementVNode)("button", {
                                                type: "button",
                                                class: "increment-touchspin btn-touchspin spin-border-primary",
                                                disabled: $setup.skipPassengerInfo,
                                                onClick: $setup.incrementPassengers
                                            }, _cache[24] || (_cache[24] = [
                                                (0, _vue.createElementVNode)("i", {
                                                    class: "fa-solid fa-plus"
                                                }, null, -1)
                                            ]), 8, _hoisted_35)
                                        ])
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_36, [
                                $setup.isLoadingEstimates ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_37, _cache[26] || (_cache[26] = [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "col-12 text-center"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "spinner-border text-primary",
                                            role: "status"
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "visually-hidden"
                                            }, "Loading...")
                                        ]),
                                        (0, _vue.createElementVNode)("p", {
                                            class: "mt-2"
                                        }, "Fetching estimates...")
                                    ], -1)
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_38, [
                                    !$setup.isDriverAvailable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_39, _cache[27] || (_cache[27] = [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "col-12"
                                        }, [
                                            (0, _vue.createElementVNode)("div", {
                                                class: "alert alert-warning",
                                                role: "alert"
                                            }, " No drivers available at this time. ")
                                        ], -1)
                                    ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_40, [
                                        (0, _vue.createElementVNode)("div", _hoisted_41, [
                                            _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600"
                                            }, "Time to Pickup", -1)),
                                            (0, _vue.createElementVNode)("p", _hoisted_42, (0, _vue.toDisplayString)($setup.estimatedTimeOfArrival), 1)
                                        ]),
                                        !$setup.skipDropOffLocation ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_43, [
                                            _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600"
                                            }, "Time for Trip", -1)),
                                            (0, _vue.createElementVNode)("p", _hoisted_44, (0, _vue.toDisplayString)($setup.estimatedTripTime), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true),
                                        (0, _vue.createElementVNode)("div", _hoisted_45, [
                                            _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600"
                                            }, "Estimated Fare", -1)),
                                            $setup.estimatedCost > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_46, "$" + (0, _vue.toDisplayString)($setup.estimatedCost), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_47, "Not available"))
                                        ])
                                    ]))
                                ])),
                                (0, _vue.createElementVNode)("div", _hoisted_48, [
                                    (0, _vue.createElementVNode)("div", _hoisted_49, [
                                        _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "auto-assign-check"
                                        }, "Auto Assign", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_50, [
                                            (0, _vue.createElementVNode)("div", _hoisted_51, [
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.autoAssignCheck = $event),
                                                    class: "form-check-input check-size",
                                                    id: "auto-assign-check",
                                                    type: "checkbox",
                                                    role: "switch"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelCheckbox),
                                                        $setup.autoAssignCheck
                                                    ]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    !$setup.autoAssignCheck ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_52, [
                                        _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "select-driver"
                                        }, "Select Driver", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            id: "select-driver",
                                            class: "form-control",
                                            ref: "driverInput",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.driverInfo = $event),
                                            type: "text",
                                            placeholder: "Start typing to search for drivers..."
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.driverInfo
                                            ]
                                        ]),
                                        _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                                            id: "select-driver-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please select a driver or else enable auto-assign. ", -1))
                                    ])) : (0, _vue.createCommentVNode)("", true)
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_53, [
                                    (0, _vue.createElementVNode)("div", _hoisted_54, [
                                        _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("label", {
                                            class: "form-label f-w-600",
                                            for: "driver-notes"
                                        }, "Driver Notes", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                            id: "driver-notes",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.driverNotes = $event),
                                            rows: "3",
                                            placeholder: "Enter notes for driver..."
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.driverNotes
                                            ]
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("div", {
                class: "card-footer"
            }, [
                (0, _vue.createElementVNode)("div", {
                    id: "navigation-button-container"
                })
            ], -1))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lApHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cqcdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("fd83da62be6344bc");
    if (script.__esModule) script = script.default;
    script.render = require("e251ef3bc582c6a1").render;
    require("1f5b958bafd29ad2").default(script);
    script.__scopeId = 'data-v-9f519c';
    script.__file = "DispatchDriverLists.vue";
};
initialize();
exports.default = script;

},{"fd83da62be6344bc":"htHNg","e251ef3bc582c6a1":"12wBj","1f5b958bafd29ad2":"jRF0d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"htHNg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'DispatchDriverLists',
    props: {
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    emits: [
        'drawDriverOnMap'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const emit = __emit;
        //Url params for datatables
        const allDriversUrl = `/api/datatable/sp-all-drivers/${props.serviceProviderId}`;
        const availableDriversUrl = `${allDriversUrl}?status=AVAILABLE`;
        const onRideDriversUrl = `${allDriversUrl}?status=ON_RIDE`;
        const unavailableDriversUrl = `${allDriversUrl}?status=OFFLINE`;
        //refs
        const availableDriversTable = (0, _vue.ref)(null);
        const inProgressDriversTable = (0, _vue.ref)(null);
        const unavailableDriversTable = (0, _vue.ref)(null);
        const allDriversTable = (0, _vue.ref)(null);
        const findOnMapAction = (row)=>{
            emit('drawDriverOnMap', row);
        };
        // Define columns
        const availableColumns = [
            {
                data: "name",
                title: 'Driver Name'
            },
            {
                data: "vehicleType",
                title: 'Vehicle'
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return (0, _datatableRenderer.findDriverOnMapCTA)(data, type, row, meta, findOnMapAction);
                }
            }
        ];
        const onRideColumns = [
            {
                data: "name",
                title: 'Driver Name'
            },
            {
                data: "vehicleType",
                title: 'Vehicle Details'
            }
        ];
        const unavailableColumns = [
            {
                data: "name",
                title: 'Driver Name'
            },
            {
                data: "statusChangedOn",
                title: 'Last Active',
                render: (0, _datatableRenderer.zonedDateTime)
            }
        ];
        const allColumns = [
            {
                data: "name",
                title: 'Driver Name'
            },
            {
                data: "vehicleType",
                title: 'Vehicle'
            },
            {
                data: "driverStatus",
                title: 'Status'
            }
        ];
        const __returned__ = {
            props,
            emit,
            allDriversUrl,
            availableDriversUrl,
            onRideDriversUrl,
            unavailableDriversUrl,
            availableDriversTable,
            inProgressDriversTable,
            unavailableDriversTable,
            allDriversTable,
            findOnMapAction,
            availableColumns,
            onRideColumns,
            unavailableColumns,
            allColumns,
            ref: (0, _vue.ref),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get findDriverOnMapCTA () {
                return 0, _datatableRenderer.findDriverOnMapCTA;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cWw4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataTable", ()=>C);
parcelHelpers.export(exports, "default", ()=>P);
var _vue = require("vue");
const g = [
    "childRow",
    "column-sizing",
    "column-visibility",
    "destroy",
    "draw",
    "error",
    "init",
    "length",
    "order",
    "page",
    "preDraw",
    "preInit",
    "preXhr",
    "processing",
    "requestChild",
    "search",
    "stateLoadParams",
    "stateLoaded",
    "stateSaveParams",
    "xhr",
    "autoFill",
    "preAutoFill",
    "buttons-action",
    "buttons-processing",
    "column-reorder",
    "key",
    "key-blur",
    "key-focus",
    "key-refocus",
    "key-return-submit",
    "responsive-display",
    "responsive-resize",
    "rowgroup-datasrc",
    "pre-row-reorder",
    "row-reorder",
    "row-reordered",
    "dtsb-inserted",
    "deselect",
    "select",
    "select-blur",
    "selectItems",
    "selectStyle",
    "user-select",
    "stateRestore-change"
];
let p;
const _ = {
    name: "Datatables.netVue",
    inheritAttrs: !1,
    use (i) {
        p = i;
    }
}, C = /* @__PURE__ */ (0, _vue.defineComponent)({
    ..._,
    props: {
        ajax: null,
        columns: null,
        data: null,
        options: null
    },
    emits: g,
    setup (i, { expose: d }) {
        const s = i, m = (0, _vue.ref)(null), o = {}, c = (0, _vue.ref)(), w = (0, _vue.ref)([]);
        (0, _vue.watch)(()=>s.data, (r)=>{
            let e = c.value;
            if (e) {
                for(var n = Object.keys(o), a = 0; a < n.length; a++)delete o[n[a]];
                e.clear(), e.rows.add(r).draw(!1);
            }
        }, {
            deep: !0
        }), (0, _vue.onMounted)(()=>{
            var n;
            const r = (0, _vue.getCurrentInstance)();
            let e = s.options || {};
            if (s.data && (e.data = s.data, k(e.data)), s.columns && (e.columns = s.columns), e.columns && v(e.columns, r), s.ajax && (e.ajax = s.ajax), e.columnDefs || (e.columnDefs = []), r) {
                let a = Object.keys(r.slots);
                for(let t = 0; t < a.length; t++){
                    let l = a[t];
                    if (l.match(/^column\-/)) {
                        let u = l.replace("column-", "");
                        e.columnDefs.push({
                            target: u.match(/^\d+$/) ? parseInt(u) : u + ":name",
                            render: "#" + l
                        });
                    }
                }
                v(e.columnDefs, r);
            }
            if (!p) throw new Error("DataTables library not set. See https://datatables.net/tn/19 for details.");
            c.value = new p((0, _vue.unref)(m), e), (n = c.value) == null || n.on("preXhr", function() {
                let a = Object.keys(o);
                for(var t = 0; t < a.length; t++)delete o[a[t]];
            });
            for (let a of g)c.value && r && c.value.on(a, function() {
                var t = Array.from(arguments), l = t.shift();
                t.unshift({
                    event: l,
                    dt: c
                }), t.unshift(a), r.emit.apply(r, t);
            });
        }), (0, _vue.onBeforeUnmount)(()=>{
            var r;
            (r = c.value) == null || r.destroy(!0);
        });
        function k(r) {
            w.value = r.value ? r.value.slice() : r.slice();
        }
        function y(r) {
            return function(e, n, a, t) {
                let l = t.row + "," + t.col;
                if (!o[l]) {
                    let u = (0, _vue.h)("div", r({
                        cellData: e,
                        colIndex: t.col,
                        rowData: a,
                        rowIndex: t.row,
                        type: n
                    }));
                    o[l] = document.createElement("div"), (0, _vue.render)(u, o[l]);
                }
                return o[l];
            };
        }
        function v(r, e) {
            if (e) for(let a = 0; a < r.length; a++){
                let t = r[a];
                if (typeof t.render == "string" && t.render.charAt(0) === "#") {
                    var n = t.render.replace("#", "");
                    e.slots[n] && (t.render = y(e.slots[n]));
                } else if (typeof t.render == "object" && typeof t.render.display == "string" && t.render.display.charAt(0) === "#") {
                    var n = t.render.display.replace("#", "");
                    e.slots[n] && (t.render.display = y(e.slots[n]));
                }
            }
        }
        return d({
            dt: c
        }), (r, e)=>e[0] || ((0, _vue.setBlockTracking)(-1), e[0] = (0, _vue.createElementVNode)("div", {
                class: "datatable"
            }, [
                (0, _vue.createElementVNode)("table", (0, _vue.mergeProps)({
                    ref_key: "table",
                    ref: m
                }, r.$attrs, {
                    style: {
                        width: "100%"
                    }
                }), [
                    (0, _vue.renderSlot)(r.$slots, "default")
                ], 16)
            ]), (0, _vue.setBlockTracking)(1), e[0]);
    }
}), P = /* @__PURE__ */ (()=>{
    const i = C;
    return i.install = (d)=>{
        d.component("Datatables.netVue", i);
    }, i;
})();

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvcko":[function(require,module,exports,__globalThis) {
/*! DataTables Bootstrap 5 integration
 * © SpryMedia Ltd - datatables.net/license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _datatablesNet = require("datatables.net");
var _datatablesNetDefault = parcelHelpers.interopDefault(_datatablesNet);
// Allow reassignment of the $ variable
let $ = (0, _jqueryDefault.default);
/**
 * DataTables integration for Bootstrap 5.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See https://datatables.net/manual/styling/bootstrap
 * for further information.
 */ /* Set the defaults for DataTables initialisation */ $.extend(true, (0, _datatablesNetDefault.default).defaults, {
    renderer: 'bootstrap'
});
/* Default class modification */ $.extend(true, (0, _datatablesNetDefault.default).ext.classes, {
    container: "dt-container dt-bootstrap5",
    search: {
        input: "form-control form-control-sm"
    },
    length: {
        select: "form-select form-select-sm"
    },
    processing: {
        container: "dt-processing card"
    },
    layout: {
        row: 'row mt-2 justify-content-between',
        cell: 'd-md-flex justify-content-between align-items-center',
        tableCell: 'col-12',
        start: 'dt-layout-start col-md-auto me-auto',
        end: 'dt-layout-end col-md-auto ms-auto',
        full: 'dt-layout-full col-md'
    }
});
/* Bootstrap paging button renderer */ (0, _datatablesNetDefault.default).ext.renderer.pagingButton.bootstrap = function(settings, buttonType, content, active, disabled) {
    var btnClasses = [
        'dt-paging-button',
        'page-item'
    ];
    if (active) btnClasses.push('active');
    if (disabled) btnClasses.push('disabled');
    var li = $('<li>').addClass(btnClasses.join(' '));
    var a = $('<button>', {
        'class': 'page-link',
        role: 'link',
        type: 'button'
    }).html(content).appendTo(li);
    return {
        display: li,
        clicker: a
    };
};
(0, _datatablesNetDefault.default).ext.renderer.pagingContainer.bootstrap = function(settings, buttonEls) {
    return $('<ul/>').addClass('pagination').append(buttonEls);
};
// DataTable.ext.renderer.layout.bootstrap = function ( settings, container, items ) {
// 	var row = $( '<div/>', {
// 			"class": items.full ?
// 				'row mt-2 justify-content-md-center' :
// 				'row mt-2 justify-content-between'
// 		} )
// 		.appendTo( container );
// 	$.each( items, function (key, val) {
// 		var klass;
// 		var cellClass = '';
// 		// Apply start / end (left / right when ltr) margins
// 		if (val.table) {
// 			klass = 'col-12';
// 		}
// 		else if (key === 'start') {
// 			klass = '' + cellClass;
// 		}
// 		else if (key === 'end') {
// 			klass = '' + cellClass;
// 		}
// 		else {
// 			klass = ' ' + cellClass;
// 		}
// 		$( '<div/>', {
// 				id: val.id || null,
// 				"class": klass + ' ' + (val.className || '')
// 			} )
// 			.append( val.contents )
// 			.appendTo( row );
// 	} );
// };
exports.default = (0, _datatablesNetDefault.default);

},{"jquery":"11TDa","datatables.net":"kqLbm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11TDa":[function(require,module,exports,__globalThis) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{}],"kqLbm":[function(require,module,exports,__globalThis) {
/*! DataTables 2.1.8
 * © SpryMedia Ltd - datatables.net/license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $ = (0, _jqueryDefault.default);
var DataTable = function(selector, options) {
    // Check if called with a window or jQuery object for DOM less applications
    // This is for backwards compatibility
    if (DataTable.factory(selector, options)) return DataTable;
    // When creating with `new`, create a new DataTable, returning the API instance
    if (this instanceof DataTable) return $(selector).DataTable(options);
    else // Argument switching
    options = selector;
    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;
    if (emptyInit) options = {};
    // Method to get DT API instance from jQuery object
    this.api = function() {
        return new _Api(this);
    };
    this.each(function() {
        // For each initialisation we want to give it a clean initialisation
        // object that can be bashed around
        var o = {};
        var oInit = len > 1 ? _fnExtend(o, options, true) : options;
        var i = 0, iLen;
        var sId = this.getAttribute('id');
        var defaults = DataTable.defaults;
        var $this = $(this);
        /* Sanity check */ if (this.nodeName.toLowerCase() != 'table') {
            _fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
            return;
        }
        $(this).trigger('options.dt', oInit);
        /* Backwards compatibility for the defaults */ _fnCompatOpts(defaults);
        _fnCompatCols(defaults.column);
        /* Convert the camel-case defaults to Hungarian */ _fnCamelToHungarian(defaults, defaults, true);
        _fnCamelToHungarian(defaults.column, defaults.column, true);
        /* Setting up the initialisation object */ _fnCamelToHungarian(defaults, $.extend(oInit, $this.data()), true);
        /* Check to see if we are re-initialising a table */ var allSettings = DataTable.settings;
        for(i = 0, iLen = allSettings.length; i < iLen; i++){
            var s = allSettings[i];
            /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                if (emptyInit || bRetrieve) return s.oInstance;
                else if (bDestroy) {
                    new DataTable.Api(s).destroy();
                    break;
                } else {
                    _fnLog(s, 0, 'Cannot reinitialise DataTable', 3);
                    return;
                }
            }
            /* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */ if (s.sTableId == this.id) {
                allSettings.splice(i, 1);
                break;
            }
        }
        /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
            sId = "DataTables_Table_" + DataTable.ext._unique++;
            this.id = sId;
        }
        /* Create the settings object for this table and set some of the default parameters */ var oSettings = $.extend(true, {}, DataTable.models.oSettings, {
            "sDestroyWidth": $this[0].style.width,
            "sInstance": sId,
            "sTableId": sId,
            colgroup: $('<colgroup>').prependTo(this),
            fastData: function(row, column, type) {
                return _fnGetCellData(oSettings, row, column, type);
            }
        });
        oSettings.nTable = this;
        oSettings.oInit = oInit;
        allSettings.push(oSettings);
        // Make a single API instance available for internal handling
        oSettings.api = new _Api(oSettings);
        // Need to add the instance after the instance after the settings object has been added
        // to the settings array, so we can self reference the table instance if more than one
        oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
        // Backwards compatibility, before we apply all the defaults
        _fnCompatOpts(oInit);
        // If the length menu is given, but the init display length is not, use the length menu
        if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : $.isPlainObject(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0].value : oInit.aLengthMenu[0];
        // Apply the defaults and init options to make a single init object will all
        // options defined from defaults and instance options.
        oInit = _fnExtend($.extend(true, {}, defaults), oInit);
        // Map the initialisation options onto the settings object
        _fnMap(oSettings.oFeatures, oInit, [
            "bPaginate",
            "bLengthChange",
            "bFilter",
            "bSort",
            "bSortMulti",
            "bInfo",
            "bProcessing",
            "bAutoWidth",
            "bSortClasses",
            "bServerSide",
            "bDeferRender"
        ]);
        _fnMap(oSettings, oInit, [
            "ajax",
            "fnFormatNumber",
            "sServerMethod",
            "aaSorting",
            "aaSortingFixed",
            "aLengthMenu",
            "sPaginationType",
            "iStateDuration",
            "bSortCellsTop",
            "iTabIndex",
            "sDom",
            "fnStateLoadCallback",
            "fnStateSaveCallback",
            "renderer",
            "searchDelay",
            "rowId",
            "caption",
            "layout",
            "orderDescReverse",
            "typeDetect",
            [
                "iCookieDuration",
                "iStateDuration"
            ],
            [
                "oSearch",
                "oPreviousSearch"
            ],
            [
                "aoSearchCols",
                "aoPreSearchCols"
            ],
            [
                "iDisplayLength",
                "_iDisplayLength"
            ]
        ]);
        _fnMap(oSettings.oScroll, oInit, [
            [
                "sScrollX",
                "sX"
            ],
            [
                "sScrollXInner",
                "sXInner"
            ],
            [
                "sScrollY",
                "sY"
            ],
            [
                "bScrollCollapse",
                "bCollapse"
            ]
        ]);
        _fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
        /* Callback functions which are array driven */ _fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback);
        _fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams);
        _fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams);
        _fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded);
        _fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback);
        _fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow);
        _fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback);
        _fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback);
        _fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete);
        _fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback);
        oSettings.rowIdFn = _fnGetObjectDataFn(oInit.rowId);
        /* Browser support detection */ _fnBrowserDetect(oSettings);
        var oClasses = oSettings.oClasses;
        $.extend(oClasses, DataTable.ext.classes, oInit.oClasses);
        $this.addClass(oClasses.table);
        if (!oSettings.oFeatures.bPaginate) oInit.iDisplayStart = 0;
        if (oSettings.iInitDisplayStart === undefined) {
            /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
            oSettings._iDisplayStart = oInit.iDisplayStart;
        }
        var defer = oInit.iDeferLoading;
        if (defer !== null) {
            oSettings.deferLoading = true;
            var tmp = Array.isArray(defer);
            oSettings._iRecordsDisplay = tmp ? defer[0] : defer;
            oSettings._iRecordsTotal = tmp ? defer[1] : defer;
        }
        /*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */ var columnsInit = [];
        var thead = this.getElementsByTagName('thead');
        var initHeaderLayout = _fnDetectHeader(oSettings, thead[0]);
        // If we don't have a columns array, then generate one with nulls
        if (oInit.aoColumns) columnsInit = oInit.aoColumns;
        else if (initHeaderLayout.length) for(i = 0, iLen = initHeaderLayout[0].length; i < iLen; i++)columnsInit.push(null);
        // Add the columns
        for(i = 0, iLen = columnsInit.length; i < iLen; i++)_fnAddColumn(oSettings);
        // Apply the column definitions
        _fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, columnsInit, initHeaderLayout, function(iCol, oDef) {
            _fnColumnOptions(oSettings, iCol, oDef);
        });
        /* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */ var rowOne = $this.children('tbody').find('tr').eq(0);
        if (rowOne.length) {
            var a = function(cell, name) {
                return cell.getAttribute('data-' + name) !== null ? name : null;
            };
            $(rowOne[0]).children('th, td').each(function(i, cell) {
                var col = oSettings.aoColumns[i];
                if (!col) _fnLog(oSettings, 0, 'Incorrect column count', 18);
                if (col.mData === i) {
                    var sort = a(cell, 'sort') || a(cell, 'order');
                    var filter = a(cell, 'filter') || a(cell, 'search');
                    if (sort !== null || filter !== null) {
                        col.mData = {
                            _: i + '.display',
                            sort: sort !== null ? i + '.@data-' + sort : undefined,
                            type: sort !== null ? i + '.@data-' + sort : undefined,
                            filter: filter !== null ? i + '.@data-' + filter : undefined
                        };
                        col._isArrayHost = true;
                        _fnColumnOptions(oSettings, i);
                    }
                }
            });
        }
        // Must be done after everything which can be overridden by the state saving!
        _fnCallbackReg(oSettings, 'aoDrawCallback', _fnSaveState);
        var features = oSettings.oFeatures;
        if (oInit.bStateSave) features.bStateSave = true;
        // If aaSorting is not defined, then we use the first indicator in asSorting
        // in case that has been altered, so the default sort reflects that option
        if (oInit.aaSorting === undefined) {
            var sorting = oSettings.aaSorting;
            for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
        }
        // Do a first pass on the sorting classes (allows any size changes to be taken into
        // account, and also will apply sorting disabled classes if disabled
        _fnSortingClasses(oSettings);
        _fnCallbackReg(oSettings, 'aoDrawCallback', function() {
            if (oSettings.bSorted || _fnDataSource(oSettings) === 'ssp' || features.bDeferRender) _fnSortingClasses(oSettings);
        });
        /*
		 * Table HTML init
		 * Cache the header, body and footer as required, creating them if needed
		 */ var caption = $this.children('caption');
        if (oSettings.caption) {
            if (caption.length === 0) caption = $('<caption/>').appendTo($this);
            caption.html(oSettings.caption);
        }
        // Store the caption side, so we can remove the element from the document
        // when creating the element
        if (caption.length) {
            caption[0]._captionSide = caption.css('caption-side');
            oSettings.captionNode = caption[0];
        }
        if (thead.length === 0) thead = $('<thead/>').appendTo($this);
        oSettings.nTHead = thead[0];
        $('tr', thead).addClass(oClasses.thead.row);
        var tbody = $this.children('tbody');
        if (tbody.length === 0) tbody = $('<tbody/>').insertAfter(thead);
        oSettings.nTBody = tbody[0];
        var tfoot = $this.children('tfoot');
        if (tfoot.length === 0) // If we are a scrolling table, and no footer has been given, then we need to create
        // a tfoot element for the caption element to be appended to
        tfoot = $('<tfoot/>').appendTo($this);
        oSettings.nTFoot = tfoot[0];
        $('tr', tfoot).addClass(oClasses.tfoot.row);
        // Copy the data index array
        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
        // Initialisation complete - table can be drawn
        oSettings.bInitialised = true;
        // Language definitions
        var oLanguage = oSettings.oLanguage;
        $.extend(true, oLanguage, oInit.oLanguage);
        if (oLanguage.sUrl) // Get the language definitions from a file
        $.ajax({
            dataType: 'json',
            url: oLanguage.sUrl,
            success: function(json) {
                _fnCamelToHungarian(defaults.oLanguage, json);
                $.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                _fnCallbackFire(oSettings, null, 'i18n', [
                    oSettings
                ], true);
                _fnInitialise(oSettings);
            },
            error: function() {
                // Error occurred loading language file
                _fnLog(oSettings, 0, 'i18n file loading error', 21);
                // Continue on as best we can
                _fnInitialise(oSettings);
            }
        });
        else {
            _fnCallbackFire(oSettings, null, 'i18n', [
                oSettings
            ], true);
            _fnInitialise(oSettings);
        }
    });
    _that = null;
    return this;
};
/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */ DataTable.ext = _ext = {
    /**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */ buttons: {},
    /**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */ classes: {},
    /**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */ builder: "-source-",
    /**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */ errMode: "alert",
    /**
	 * Legacy so v1 plug-ins don't throw js errors on load
	 */ feature: [],
    /**
	 * Feature plug-ins.
	 * 
	 * This is an object of callbacks which provide the features for DataTables
	 * to be initialised via the `layout` option.
	 */ features: {},
    /**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */ search: [],
    /**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */ selector: {
        cell: [],
        column: [],
        row: []
    },
    /**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */ legacy: {
        /**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */ ajax: null
    },
    /**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */ pager: {},
    renderer: {
        pageButton: {},
        header: {}
    },
    /**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */ order: {},
    /**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */ type: {
        /**
		 * Automatic column class assignment
		 */ className: {},
        /**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */ detect: [],
        /**
		 * Automatic renderer assignment
		 */ render: {},
        /**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */ search: {},
        /**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing Javascript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */ order: {}
    },
    /**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */ _unique: 0,
    //
    // Depreciated
    // The following properties are retained for backwards compatibility only.
    // The should not be used in new projects and will be removed in a future
    // version
    //
    /**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */ fnVersionCheck: DataTable.fnVersionCheck,
    /**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */ iApiIndex: 0,
    /**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */ sVersion: DataTable.version
};
//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$.extend(_ext, {
    afnFiltering: _ext.search,
    aTypes: _ext.type.detect,
    ofnSearch: _ext.type.search,
    oSort: _ext.type.order,
    afnSortData: _ext.order,
    aoFeatures: _ext.feature,
    oStdClasses: _ext.classes,
    oPagination: _ext.pager
});
$.extend(DataTable.ext.classes, {
    container: 'dt-container',
    empty: {
        row: 'dt-empty'
    },
    info: {
        container: 'dt-info'
    },
    layout: {
        row: 'dt-layout-row',
        cell: 'dt-layout-cell',
        tableRow: 'dt-layout-table',
        tableCell: '',
        start: 'dt-layout-start',
        end: 'dt-layout-end',
        full: 'dt-layout-full'
    },
    length: {
        container: 'dt-length',
        select: 'dt-input'
    },
    order: {
        canAsc: 'dt-orderable-asc',
        canDesc: 'dt-orderable-desc',
        isAsc: 'dt-ordering-asc',
        isDesc: 'dt-ordering-desc',
        none: 'dt-orderable-none',
        position: 'sorting_'
    },
    processing: {
        container: 'dt-processing'
    },
    scrolling: {
        body: 'dt-scroll-body',
        container: 'dt-scroll',
        footer: {
            self: 'dt-scroll-foot',
            inner: 'dt-scroll-footInner'
        },
        header: {
            self: 'dt-scroll-head',
            inner: 'dt-scroll-headInner'
        }
    },
    search: {
        container: 'dt-search',
        input: 'dt-input'
    },
    table: 'dataTable',
    tbody: {
        cell: '',
        row: ''
    },
    thead: {
        cell: '',
        row: ''
    },
    tfoot: {
        cell: '',
        row: ''
    },
    paging: {
        active: 'current',
        button: 'dt-paging-button',
        container: 'dt-paging',
        disabled: 'disabled',
        nav: ''
    }
});
/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */ // Defined else where
//  _selector_run
//  _selector_opts
//  _selector_row_indexes
var _ext; // DataTable.ext
var _Api; // DataTable.Api
var _api_register; // DataTable.Api.register
var _api_registerPlural; // DataTable.Api.registerPlural
var _re_dic = {};
var _re_new_lines = /[\r\n\u2028]/g;
var _re_html = /<([^>]*>)/g;
var _max_str_len = Math.pow(2, 28);
// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var _re_date = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/;
// Escape regular expression special characters
var _re_escape_regex = new RegExp('(\\' + [
    '/',
    '.',
    '*',
    '+',
    '?',
    '|',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\\',
    '$',
    '^',
    '-'
].join('|\\') + ')', 'g');
// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var _re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
var _empty = function(d) {
    return !d || d === true || d === '-' ? true : false;
};
var _intVal = function(s) {
    var integer = parseInt(s, 10);
    return !isNaN(integer) && isFinite(s) ? integer : null;
};
// Convert from a formatted number with characters other than `.` as the
// decimal place, to a Javascript number
var _numToDecimal = function(num, decimalPoint) {
    // Cache created regular expressions for speed as this function is called often
    if (!_re_dic[decimalPoint]) _re_dic[decimalPoint] = new RegExp(_fnEscapeRegex(decimalPoint), 'g');
    return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace(_re_dic[decimalPoint], '.') : num;
};
var _isNumber = function(d, decimalPoint, formatted, allowEmpty) {
    var type = typeof d;
    var strType = type === 'string';
    if (type === 'number' || type === 'bigint') return true;
    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if (allowEmpty && _empty(d)) return true;
    if (decimalPoint && strType) d = _numToDecimal(d, decimalPoint);
    if (formatted && strType) d = d.replace(_re_formatted_numeric, '');
    return !isNaN(parseFloat(d)) && isFinite(d);
};
// A string without HTML in it can be considered to be HTML still
var _isHtml = function(d) {
    return _empty(d) || typeof d === 'string';
};
// Is a string a number surrounded by HTML?
var _htmlNumeric = function(d, decimalPoint, formatted, allowEmpty) {
    if (allowEmpty && _empty(d)) return true;
    // input and select strings mean that this isn't just a number
    if (typeof d === 'string' && d.match(/<(input|select)/i)) return null;
    var html = _isHtml(d);
    return !html ? null : _isNumber(_stripHtml(d), decimalPoint, formatted, allowEmpty) ? true : null;
};
var _pluck = function(a, prop, prop2) {
    var out = [];
    var i = 0, ien = a.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[i]) out.push(a[i][prop]);
    }
    return out;
};
// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var _pluck_order = function(a, order, prop, prop2) {
    var out = [];
    var i = 0, ien = order.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[order[i]] && a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[order[i]]) out.push(a[order[i]][prop]);
    }
    return out;
};
var _range = function(len, start) {
    var out = [];
    var end;
    if (start === undefined) {
        start = 0;
        end = len;
    } else {
        end = start;
        start = len;
    }
    for(var i = start; i < end; i++)out.push(i);
    return out;
};
var _removeEmpty = function(a) {
    var out = [];
    for(var i = 0, ien = a.length; i < ien; i++)if (a[i]) out.push(a[i]);
    return out;
};
// Replaceable function in api.util
var _stripHtml = function(input) {
    if (!input || typeof input !== 'string') return input;
    // Irrelevant check to workaround CodeQL's false positive on the regex
    if (input.length > _max_str_len) throw new Error('Exceeded max str len');
    var previous;
    input = input.replace(_re_html, ''); // Complete tags
    // Safety for incomplete script tag - use do / while to ensure that
    // we get all instances
    do {
        previous = input;
        input = input.replace(/<script/i, '');
    }while (input !== previous);
    return previous;
};
// Replaceable function in api.util
var _escapeHtml = function(d) {
    if (Array.isArray(d)) d = d.join(',');
    return typeof d === 'string' ? d.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : d;
};
// Remove diacritics from a string by decomposing it and then removing
// non-ascii characters
var _normalize = function(str, both) {
    if (typeof str !== 'string') return str;
    // It is faster to just run `normalize` than it is to check if
    // we need to with a regex! (Check as it isn't available in old
    // Safari)
    var res = str.normalize ? str.normalize("NFD") : str;
    // Equally, here we check if a regex is needed or not
    return res.length !== str.length ? (both === true ? str + ' ' : '') + res.replace(/[\u0300-\u036f]/g, "") : res;
};
/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */ var _areAllUnique = function(src) {
    if (src.length < 2) return true;
    var sorted = src.slice().sort();
    var last = sorted[0];
    for(var i = 1, ien = sorted.length; i < ien; i++){
        if (sorted[i] === last) return false;
        last = sorted[i];
    }
    return true;
};
/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */ var _unique = function(src) {
    if (Array.from && Set) return Array.from(new Set(src));
    if (_areAllUnique(src)) return src.slice();
    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.app/compare-array-unique-versions/4 for more
    // information.
    var out = [], val, i, ien = src.length, j, k = 0;
    again: for(i = 0; i < ien; i++){
        val = src[i];
        for(j = 0; j < k; j++){
            if (out[j] === val) continue again;
        }
        out.push(val);
        k++;
    }
    return out;
};
// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var _flatten = function(out, val) {
    if (Array.isArray(val)) for(var i = 0; i < val.length; i++)_flatten(out, val[i]);
    else out.push(val);
    return out;
};
// Similar to jQuery's addClass, but use classList.add
function _addClass(el, name) {
    if (name) name.split(' ').forEach(function(n) {
        if (n) // `add` does deduplication, so no need to check `contains`
        el.classList.add(n);
    });
}
/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */ DataTable.util = {
    /**
	 * Return a string with diacritic characters decomposed
	 * @param {*} mixed Function or string to normalize
	 * @param {*} both Return original string and the normalized string
	 * @returns String or undefined
	 */ diacritics: function(mixed, both) {
        var type = typeof mixed;
        if (type !== 'function') return _normalize(mixed, both);
        _normalize = mixed;
    },
    /**
	 * Debounce a function
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ debounce: function(fn, timeout) {
        var timer;
        return function() {
            var that = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(that, args);
            }, timeout || 250);
        };
    },
    /**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ throttle: function(fn, freq) {
        var frequency = freq !== undefined ? freq : 200, last, timer;
        return function() {
            var that = this, now = +new Date(), args = arguments;
            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    },
    /**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */ escapeRegex: function(val) {
        return val.replace(_re_escape_regex, '\\$1');
    },
    /**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */ set: function(source) {
        if ($.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */ return DataTable.util.set(source._);
        else if (source === null) // Nothing to do when the data source is null
        return function() {};
        else if (typeof source === 'function') return function(data, val, meta) {
            source(data, 'set', val, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            // Like the get, we need to get data from a nested object
            var setData = function(data, val, src) {
                var a = _fnSplitObjNotation(src), b;
                var aLast = a[a.length - 1];
                var arrayNotation, funcNotation, o, innerSrc;
                for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                    // Protect against prototype pollution
                    if (a[i] === '__proto__' || a[i] === 'constructor') throw new Error('Cannot set prototype values');
                    // Check if we are dealing with an array notation request
                    arrayNotation = a[i].match(__reArray);
                    funcNotation = a[i].match(__reFn);
                    if (arrayNotation) {
                        a[i] = a[i].replace(__reArray, '');
                        data[a[i]] = [];
                        // Get the remainder of the nested object to set so we can recurse
                        b = a.slice();
                        b.splice(0, i + 1);
                        innerSrc = b.join('.');
                        // Traverse each entry in the array setting the properties requested
                        if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                            o = {};
                            setData(o, val[j], innerSrc);
                            data[a[i]].push(o);
                        }
                        else // We've been asked to save data to an array, but it
                        // isn't array data to be saved. Best that can be done
                        // is to just save the value.
                        data[a[i]] = val;
                        // The inner call to setData has already traversed through the remainder
                        // of the source and has set the data, thus we can exit here
                        return;
                    } else if (funcNotation) {
                        // Function call
                        a[i] = a[i].replace(__reFn, '');
                        data = data[a[i]](val);
                    }
                    // If the nested object doesn't currently exist - since we are
                    // trying to set the value - create it
                    if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                    data = data[a[i]];
                }
                // Last item in the input - i.e, the actual set
                if (aLast.match(__reFn)) // Function call
                data = data[aLast.replace(__reFn, '')](val);
                else // If array notation is used, we just want to strip it and use the property name
                // and assign the value. If it isn't used, then we get the result we want anyway
                data[aLast.replace(__reArray, '')] = val;
            };
            return function(data, val) {
                return setData(data, val, source);
            };
        } else // Array or flat object mapping
        return function(data, val) {
            data[source] = val;
        };
    },
    /**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */ get: function(source) {
        if ($.isPlainObject(source)) {
            // Build an object of get functions, and wrap them in a single call
            var o = {};
            $.each(source, function(key, val) {
                if (val) o[key] = DataTable.util.get(val);
            });
            return function(data, type, row, meta) {
                var t = o[type] || o._;
                return t !== undefined ? t(data, type, row, meta) : data;
            };
        } else if (source === null) // Give an empty string for rendering / sorting etc
        return function(data) {
            return data;
        };
        else if (typeof source === 'function') return function(data, type, row, meta) {
            return source(data, type, row, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */ var fetchData = function(data, type, src) {
                var arrayNotation, funcNotation, out, innerSrc;
                if (src !== "") {
                    var a = _fnSplitObjNotation(src);
                    for(var i = 0, iLen = a.length; i < iLen; i++){
                        // Check if we are dealing with special notation
                        arrayNotation = a[i].match(__reArray);
                        funcNotation = a[i].match(__reFn);
                        if (arrayNotation) {
                            // Array notation
                            a[i] = a[i].replace(__reArray, '');
                            // Condition allows simply [] to be passed in
                            if (a[i] !== "") data = data[a[i]];
                            out = [];
                            // Get the remainder of the nested object to get
                            a.splice(0, i + 1);
                            innerSrc = a.join('.');
                            // Traverse each entry in the array getting the properties requested
                            if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                            // If a string is given in between the array notation indicators, that
                            // is used to join the strings together, otherwise an array is returned
                            var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                            data = join === "" ? out : out.join(join);
                            break;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace(__reFn, '');
                            data = data[a[i]]();
                            continue;
                        }
                        if (data === null || data[a[i]] === null) return null;
                        else if (data === undefined || data[a[i]] === undefined) return undefined;
                        data = data[a[i]];
                    }
                }
                return data;
            };
            return function(data, type) {
                return fetchData(data, type, source);
            };
        } else // Array or flat object mapping
        return function(data) {
            return data[source];
        };
    },
    stripHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            _stripHtml = mixed;
            return;
        } else if (type === 'string') return _stripHtml(mixed);
        return mixed;
    },
    escapeHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            _escapeHtml = mixed;
            return;
        } else if (type === 'string' || Array.isArray(mixed)) return _escapeHtml(mixed);
        return mixed;
    },
    unique: _unique
};
/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */ function _fnHungarianMap(o) {
    var hungarian = 'a aa ai ao as b fn i m o s ', match, newKey, map = {};
    $.each(o, function(key) {
        match = key.match(/^([^A-Z]+?)([A-Z])/);
        if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
            newKey = key.replace(match[0], match[2].toLowerCase());
            map[newKey] = key;
            if (match[1] === 'o') _fnHungarianMap(o[key]);
        }
    });
    o._hungarianMap = map;
}
/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */ function _fnCamelToHungarian(src, user, force) {
    if (!src._hungarianMap) _fnHungarianMap(src);
    var hungarianKey;
    $.each(user, function(key) {
        hungarianKey = src._hungarianMap[key];
        if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
            // For objects, we need to buzz down into the object to copy parameters
            if (hungarianKey.charAt(0) === 'o') {
                // Copy the camelCase options over to the hungarian
                if (!user[hungarianKey]) user[hungarianKey] = {};
                $.extend(true, user[hungarianKey], user[key]);
                _fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
            } else user[hungarianKey] = user[key];
        }
    });
}
/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */ var _fnCompatMap = function(o, knew, old) {
    if (o[knew] !== undefined) o[old] = o[knew];
};
/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */ function _fnCompatOpts(init) {
    _fnCompatMap(init, 'ordering', 'bSort');
    _fnCompatMap(init, 'orderMulti', 'bSortMulti');
    _fnCompatMap(init, 'orderClasses', 'bSortClasses');
    _fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
    _fnCompatMap(init, 'order', 'aaSorting');
    _fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
    _fnCompatMap(init, 'paging', 'bPaginate');
    _fnCompatMap(init, 'pagingType', 'sPaginationType');
    _fnCompatMap(init, 'pageLength', 'iDisplayLength');
    _fnCompatMap(init, 'searching', 'bFilter');
    // Boolean initialisation of x-scrolling
    if (typeof init.sScrollX === 'boolean') init.sScrollX = init.sScrollX ? '100%' : '';
    if (typeof init.scrollX === 'boolean') init.scrollX = init.scrollX ? '100%' : '';
    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;
    if (searchCols) {
        for(var i = 0, ien = searchCols.length; i < ien; i++)if (searchCols[i]) _fnCamelToHungarian(DataTable.models.oSearch, searchCols[i]);
    }
    // Enable search delay if server-side processing is enabled
    if (init.serverSide && !init.searchDelay) init.searchDelay = 400;
}
/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */ function _fnCompatCols(init) {
    _fnCompatMap(init, 'orderable', 'bSortable');
    _fnCompatMap(init, 'orderData', 'aDataSort');
    _fnCompatMap(init, 'orderSequence', 'asSorting');
    _fnCompatMap(init, 'orderDataType', 'sortDataType');
    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if (typeof dataSort === 'number' && !Array.isArray(dataSort)) init.aDataSort = [
        dataSort
    ];
}
/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnBrowserDetect(settings) {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if (!DataTable.__browser) {
        var browser = {};
        DataTable.__browser = browser;
        // Scrolling feature / quirks detection
        var n = $('<div/>').css({
            position: 'fixed',
            top: 0,
            left: -1 * window.pageXOffset,
            height: 1,
            width: 1,
            overflow: 'hidden'
        }).append($('<div/>').css({
            position: 'absolute',
            top: 1,
            left: 1,
            width: 100,
            overflow: 'scroll'
        }).append($('<div/>').css({
            width: '100%',
            height: 10
        }))).appendTo('body');
        var outer = n.children();
        var inner = outer.children();
        // Get scrollbar width
        browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
        // In rtl text layout, some browsers (most, but not all) will place the
        // scrollbar on the left, rather than the right.
        browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
        n.remove();
    }
    $.extend(settings.oBrowser, DataTable.__browser);
    settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
}
/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnAddColumn(oSettings) {
    // Add column to aoColumns array
    var oDefaults = DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $.extend({}, DataTable.models.oColumn, oDefaults, {
        "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
            iCol
        ],
        "mData": oDefaults.mData ? oDefaults.mData : iCol,
        idx: iCol,
        searchFixed: {},
        colEl: $('<col>').attr('data-dt-column', iCol)
    });
    oSettings.aoColumns.push(oCol);
    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[iCol] = $.extend({}, DataTable.models.oSearch, searchCols[iCol]);
}
/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */ function _fnColumnOptions(oSettings, iCol, oOptions) {
    var oCol = oSettings.aoColumns[iCol];
    /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
        // Backwards compatibility
        _fnCompatCols(oOptions);
        // Map camel case parameters to their Hungarian counterparts
        _fnCamelToHungarian(DataTable.defaults.column, oOptions, true);
        /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
        if (oOptions.sType) oCol._sManualType = oOptions.sType;
        // `class` is a reserved word in Javascript, so we need to provide
        // the ability to use a valid name for the camel case input
        if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
        var origClass = oCol.sClass;
        $.extend(oCol, oOptions);
        _fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
        // Merge class from previously defined classes with this one, rather than just
        // overwriting it in the extend above
        if (origClass !== oCol.sClass) oCol.sClass = origClass + ' ' + oCol.sClass;
        /* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
            oOptions.iDataSort
        ];
        _fnMap(oCol, oOptions, "aDataSort");
    }
    /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
    var mData = _fnGetObjectDataFn(mDataSrc);
    // The `render` option can be given as an array to access the helper rendering methods.
    // The first element is the rendering method to use, the rest are the parameters to pass
    if (oCol.mRender && Array.isArray(oCol.mRender)) {
        var copy = oCol.mRender.slice();
        var name = copy.shift();
        oCol.mRender = DataTable.render[name].apply(window, copy);
    }
    oCol._render = oCol.mRender ? _fnGetObjectDataFn(oCol.mRender) : null;
    var attrTest = function(src) {
        return typeof src === 'string' && src.indexOf('@') !== -1;
    };
    oCol._bAttrSrc = $.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
    oCol._setter = null;
    oCol.fnGetData = function(rowData, type, meta) {
        var innerData = mData(rowData, type, undefined, meta);
        return oCol._render && type ? oCol._render(innerData, type, rowData, meta) : innerData;
    };
    oCol.fnSetData = function(rowData, val, meta) {
        return _fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
    };
    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if (typeof mDataSrc !== 'number' && !oCol._isArrayHost) oSettings._rowReadObject = true;
    /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) oCol.bSortable = false;
}
/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnAdjustColumnSizing(settings) {
    _fnCalculateColumnWidths(settings);
    _fnColumnSizes(settings);
    var scroll = settings.oScroll;
    if (scroll.sY !== '' || scroll.sX !== '') _fnScrollDraw(settings);
    _fnCallbackFire(settings, null, 'column-sizing', [
        settings
    ]);
}
/**
 * Apply column sizes
 *
 * @param {*} settings DataTables settings object
 */ function _fnColumnSizes(settings) {
    var cols = settings.aoColumns;
    for(var i = 0; i < cols.length; i++){
        var width = _fnColumnsSumWidth(settings, [
            i
        ], false, false);
        cols[i].colEl.css('width', width);
    }
}
/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function _fnVisibleToColumnIndex(oSettings, iMatch) {
    var aiVis = _fnGetColumns(oSettings, 'bVisible');
    return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
}
/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function _fnColumnIndexToVisible(oSettings, iMatch) {
    var aiVis = _fnGetColumns(oSettings, 'bVisible');
    var iPos = aiVis.indexOf(iMatch);
    return iPos !== -1 ? iPos : null;
}
/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */ function _fnVisbleColumns(settings) {
    var layout = settings.aoHeader;
    var columns = settings.aoColumns;
    var vis = 0;
    if (layout.length) {
        for(var i = 0, ien = layout[0].length; i < ien; i++)if (columns[i].bVisible && $(layout[0][i].cell).css('display') !== 'none') vis++;
    }
    return vis;
}
/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */ function _fnGetColumns(oSettings, sParam) {
    var a = [];
    oSettings.aoColumns.map(function(val, i) {
        if (val[sParam]) a.push(i);
    });
    return a;
}
/**
 * Allow the result from a type detection function to be `true` while
 * translating that into a string. Old type detection functions will
 * return the type name if it passes. An obect store would be better,
 * but not backwards compatible.
 *
 * @param {*} typeDetect Object or function for type detection
 * @param {*} res Result from the type detection function
 * @returns Type name or false
 */ function _typeResult(typeDetect, res) {
    return res === true ? typeDetect._name : res;
}
/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnColumnTypes(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = DataTable.ext.type.detect;
    var i, ien, j, jen, k, ken;
    var col, detectedType, cache;
    // For each column, spin over the data type detection functions, seeing if one matches
    for(i = 0, ien = columns.length; i < ien; i++){
        col = columns[i];
        cache = [];
        if (!col.sType && col._sManualType) col.sType = col._sManualType;
        else if (!col.sType) {
            // With SSP type detection can be unreliable and error prone, so we provide a way
            // to turn it off.
            if (!settings.typeDetect) return;
            for(j = 0, jen = types.length; j < jen; j++){
                var typeDetect = types[j];
                // There can be either one, or three type detection functions
                var oneOf = typeDetect.oneOf;
                var allOf = typeDetect.allOf || typeDetect;
                var init = typeDetect.init;
                var one = false;
                detectedType = null;
                // Fast detect based on column assignment
                if (init) {
                    detectedType = _typeResult(typeDetect, init(settings, col, i));
                    if (detectedType) {
                        col.sType = detectedType;
                        break;
                    }
                }
                for(k = 0, ken = data.length; k < ken; k++){
                    if (!data[k]) continue;
                    // Use a cache array so we only need to get the type data
                    // from the formatter once (when using multiple detectors)
                    if (cache[k] === undefined) cache[k] = _fnGetCellData(settings, k, i, 'type');
                    // Only one data point in the column needs to match this function
                    if (oneOf && !one) one = _typeResult(typeDetect, oneOf(cache[k], settings));
                    // All data points need to match this function
                    detectedType = _typeResult(typeDetect, allOf(cache[k], settings));
                    // If null, then this type can't apply to this column, so
                    // rather than testing all cells, break out. There is an
                    // exception for the last type which is `html`. We need to
                    // scan all rows since it is possible to mix string and HTML
                    // types
                    if (!detectedType && j !== types.length - 3) break;
                    // Only a single match is needed for html type since it is
                    // bottom of the pile and very similar to string - but it
                    // must not be empty
                    if (detectedType === 'html' && !_empty(cache[k])) break;
                }
                // Type is valid for all data points in the column - use this
                // type
                if (oneOf && one && detectedType || !oneOf && detectedType) {
                    col.sType = detectedType;
                    break;
                }
            }
            // Fall back - if no type was detected, always use string
            if (!col.sType) col.sType = 'string';
        }
        // Set class names for header / footer for auto type classes
        var autoClass = _ext.type.className[col.sType];
        if (autoClass) {
            _columnAutoClass(settings.aoHeader, i, autoClass);
            _columnAutoClass(settings.aoFooter, i, autoClass);
        }
        var renderer = _ext.type.render[col.sType];
        // This can only happen once! There is no way to remove
        // a renderer. After the first time the renderer has
        // already been set so createTr will run the renderer itself.
        if (renderer && !col._render) {
            col._render = DataTable.util.get(renderer);
            _columnAutoRender(settings, i);
        }
    }
}
/**
 * Apply an auto detected renderer to data which doesn't yet have
 * a renderer
 */ function _columnAutoRender(settings, colIdx) {
    var data = settings.aoData;
    for(var i = 0; i < data.length; i++)if (data[i].nTr) {
        // We have to update the display here since there is no
        // invalidation check for the data
        var display = _fnGetCellData(settings, i, colIdx, 'display');
        data[i].displayData[colIdx] = display;
        _fnWriteCell(data[i].anCells[colIdx], display);
    // No need to update sort / filter data since it has
    // been invalidated and will be re-read with the
    // renderer now applied
    }
}
/**
 * Apply a class name to a column's header cells
 */ function _columnAutoClass(container, colIdx, className) {
    container.forEach(function(row) {
        if (row[colIdx] && row[colIdx].unique) _addClass(row[colIdx].cell, className);
    });
}
/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {array} headerLayout Layout for header as it was loaded
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */ function _fnApplyColumnDefs(oSettings, aoColDefs, aoCols, headerLayout, fn) {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;
    if (aoCols) {
        for(i = 0, iLen = aoCols.length; i < iLen; i++)if (aoCols[i] && aoCols[i].name) columns[i].sName = aoCols[i].name;
    }
    // Column definitions with aTargets
    if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
        def = aoColDefs[i];
        /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
        if (!Array.isArray(aTargets)) aTargets = [
            aTargets
        ];
        for(j = 0, jLen = aTargets.length; j < jLen; j++){
            var target = aTargets[j];
            if (typeof target === 'number' && target >= 0) {
                /* Add columns that we don't yet know about */ while(columns.length <= target)_fnAddColumn(oSettings);
                /* Integer, basic index */ fn(target, def);
            } else if (typeof target === 'number' && target < 0) /* Negative integer, right to left column counting */ fn(columns.length + target, def);
            else if (typeof target === 'string') for(k = 0, kLen = columns.length; k < kLen; k++){
                if (target === '_all') // Apply to all columns
                fn(k, def);
                else if (target.indexOf(':name') !== -1) // Column selector
                {
                    if (columns[k].sName === target.replace(':name', '')) fn(k, def);
                } else // Cell selector
                headerLayout.forEach(function(row) {
                    if (row[k]) {
                        var cell = $(row[k].cell);
                        // Legacy support. Note that it means that we don't support
                        // an element name selector only, since they are treated as
                        // class names for 1.x compat.
                        if (target.match(/^[a-z][\w-]*$/i)) target = '.' + target;
                        if (cell.is(target)) fn(k, def);
                    }
                });
            }
        }
    }
    // Statically defined columns array
    if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
}
/**
 * Get the width for a given set of columns
 *
 * @param {*} settings DataTables settings object
 * @param {*} targets Columns - comma separated string or array of numbers
 * @param {*} original Use the original width (true) or calculated (false)
 * @param {*} incVisible Include visible columns (true) or not (false)
 * @returns Combined CSS value
 */ function _fnColumnsSumWidth(settings, targets, original, incVisible) {
    if (!Array.isArray(targets)) targets = _fnColumnsFromHeader(targets);
    var sum = 0;
    var unit;
    var columns = settings.aoColumns;
    for(var i = 0, ien = targets.length; i < ien; i++){
        var column = columns[targets[i]];
        var definedWidth = original ? column.sWidthOrig : column.sWidth;
        if (!incVisible && column.bVisible === false) continue;
        if (definedWidth === null || definedWidth === undefined) return null; // can't determine a defined width - browser defined
        else if (typeof definedWidth === 'number') {
            unit = 'px';
            sum += definedWidth;
        } else {
            var matched = definedWidth.match(/([\d\.]+)([^\d]*)/);
            if (matched) {
                sum += matched[1] * 1;
                unit = matched.length === 3 ? matched[2] : 'px';
            }
        }
    }
    return sum + unit;
}
function _fnColumnsFromHeader(cell) {
    var attr = $(cell).closest('[data-dt-column]').attr('data-dt-column');
    if (!attr) return [];
    return attr.split(',').map(function(val) {
        return val * 1;
    });
}
/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a Javascript source, rather than a
 * DOM source.
 *  @param {object} settings dataTables settings object
 *  @param {array} data data array to be added
 *  @param {node} [tr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [tds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */ function _fnAddData(settings, dataIn, tr, tds) {
    /* Create the object for storing information about this new row */ var rowIdx = settings.aoData.length;
    var rowModel = $.extend(true, {}, DataTable.models.oRow, {
        src: tr ? 'dom' : 'data',
        idx: rowIdx
    });
    rowModel._aData = dataIn;
    settings.aoData.push(rowModel);
    var columns = settings.aoColumns;
    for(var i = 0, iLen = columns.length; i < iLen; i++)// Invalidate the column types as the new data needs to be revalidated
    columns[i].sType = null;
    /* Add to the display array */ settings.aiDisplayMaster.push(rowIdx);
    var id = settings.rowIdFn(dataIn);
    if (id !== undefined) settings.aIds[id] = rowModel;
    /* Create the DOM information, or register it if already present */ if (tr || !settings.oFeatures.bDeferRender) _fnCreateTr(settings, rowIdx, tr, tds);
    return rowIdx;
}
/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */ function _fnAddTr(settings, trs) {
    var row;
    // Allow an individual node to be passed in
    if (!(trs instanceof $)) trs = $(trs);
    return trs.map(function(i, el) {
        row = _fnGetRowElements(settings, el);
        return _fnAddData(settings, row.data, el, row.cells);
    });
}
/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */ function _fnGetCellData(settings, rowIdx, colIdx, type) {
    if (type === 'search') type = 'filter';
    else if (type === 'order') type = 'sort';
    var row = settings.aoData[rowIdx];
    if (!row) return undefined;
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = row._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData(rowData, type, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
    // Allow for a node being returned for non-display types
    if (type !== 'display' && cellData && typeof cellData === 'object' && cellData.nodeName) cellData = cellData.innerHTML;
    if (cellData === undefined) {
        if (settings.iDrawError != draw && defaultContent === null) {
            _fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
            settings.iDrawError = draw;
        }
        return defaultContent;
    }
    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
    else if (typeof cellData === 'function') // If the data source is a function, then we run it and use the return,
    // executing in the scope of the data object (for instances)
    return cellData.call(rowData);
    if (cellData === null && type === 'display') return '';
    if (type === 'filter') {
        var fomatters = DataTable.ext.type.search;
        if (fomatters[col.sType]) cellData = fomatters[col.sType](cellData);
    }
    return cellData;
}
/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */ function _fnSetCellData(settings, rowIdx, colIdx, val) {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    col.fnSetData(rowData, val, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
}
/**
 * Write a value to a cell
 * @param {*} td Cell
 * @param {*} val Value
 */ function _fnWriteCell(td, val) {
    if (val && typeof val === 'object' && val.nodeName) $(td).empty().append(val);
    else td.innerHTML = val;
}
// Private variable that is used to match action syntax in the data property object
var __reArray = /\[.*?\]$/;
var __reFn = /\(\)$/;
/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */ function _fnSplitObjNotation(str) {
    var parts = str.match(/(\\.|[^.])+/g) || [
        ''
    ];
    return parts.map(function(s) {
        return s.replace(/\\\./g, '.');
    });
}
/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */ var _fnGetObjectDataFn = DataTable.util.get;
/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */ var _fnSetObjectDataFn = DataTable.util.set;
/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */ function _fnGetDataMaster(settings) {
    return _pluck(settings.aoData, '_aData');
}
/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnClearTable(settings) {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
}
/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */ function _fnInvalidate(settings, rowIdx, src, colIdx) {
    var row = settings.aoData[rowIdx];
    var i, ien;
    // Remove the cached data for the row
    row._aSortData = null;
    row._aFilterData = null;
    row.displayData = null;
    // Are we reading last data from DOM or the data object?
    if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') // Read the data from the DOM
    row._aData = _fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
    else {
        // Reading from data object, update the DOM
        var cells = row.anCells;
        var display = _fnGetRowDisplay(settings, rowIdx);
        if (cells) {
            if (colIdx !== undefined) _fnWriteCell(cells[colIdx], display[colIdx]);
            else for(i = 0, ien = cells.length; i < ien; i++)_fnWriteCell(cells[i], display[i]);
        }
    }
    // Column specific invalidation
    var cols = settings.aoColumns;
    if (colIdx !== undefined) {
        // Type - the data might have changed
        cols[colIdx].sType = null;
        // Max length string. Its a fairly cheep recalculation, so not worth
        // something more complicated
        cols[colIdx].maxLenString = null;
    } else {
        for(i = 0, ien = cols.length; i < ien; i++){
            cols[i].sType = null;
            cols[i].maxLenString = null;
        }
        // Update DataTables special `DT_*` attributes for the row
        _fnRowAttributes(settings, row);
    }
}
/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */ function _fnGetRowElements(settings, row, colIdx, d) {
    var tds = [], td = row.firstChild, name, col, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
    // Allow the data object to be passed in, or construct
    d = d !== undefined ? d : objectRead ? {} : [];
    var attr = function(str, td) {
        if (typeof str === 'string') {
            var idx = str.indexOf('@');
            if (idx !== -1) {
                var attr = str.substring(idx + 1);
                var setter = _fnSetObjectDataFn(str);
                setter(d, td.getAttribute(attr));
            }
        }
    };
    // Read data from a cell and store into the data object
    var cellProcess = function(cell) {
        if (colIdx === undefined || colIdx === i) {
            col = columns[i];
            contents = cell.innerHTML.trim();
            if (col && col._bAttrSrc) {
                var setter = _fnSetObjectDataFn(col.mData._);
                setter(d, contents);
                attr(col.mData.sort, cell);
                attr(col.mData.type, cell);
                attr(col.mData.filter, cell);
            } else // Depending on the `data` option for the columns the data can
            // be read to either an object or an array.
            if (objectRead) {
                if (!col._setter) // Cache the setter function
                col._setter = _fnSetObjectDataFn(col.mData);
                col._setter(d, contents);
            } else d[i] = contents;
        }
        i++;
    };
    if (td) // `tr` element was passed in
    while(td){
        name = td.nodeName.toUpperCase();
        if (name == "TD" || name == "TH") {
            cellProcess(td);
            tds.push(td);
        }
        td = td.nextSibling;
    }
    else {
        // Existing row object passed in
        tds = row.anCells;
        for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
    }
    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;
    if (rowNode) {
        var id = rowNode.getAttribute('id');
        if (id) _fnSetObjectDataFn(settings.rowId)(d, id);
    }
    return {
        data: d,
        cells: tds
    };
}
/**
 * Render and cache a row's display data for the columns, if required
 * @returns 
 */ function _fnGetRowDisplay(settings, rowIdx) {
    var rowModal = settings.aoData[rowIdx];
    var columns = settings.aoColumns;
    if (!rowModal.displayData) {
        // Need to render and cache
        rowModal.displayData = [];
        for(var colIdx = 0, len = columns.length; colIdx < len; colIdx++)rowModal.displayData.push(_fnGetCellData(settings, rowIdx, colIdx, 'display'));
    }
    return rowModal.displayData;
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */ function _fnCreateTr(oSettings, iRow, nTrIn, anTds) {
    var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create, trClass = oSettings.oClasses.tbody.row;
    if (row.nTr === null) {
        nTr = nTrIn || document.createElement('tr');
        row.nTr = nTr;
        row.anCells = cells;
        _addClass(nTr, trClass);
        /* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */ nTr._DT_RowIndex = iRow;
        /* Special parameters can be given by the data source to be used on the row */ _fnRowAttributes(oSettings, row);
        /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
            oCol = oSettings.aoColumns[i];
            create = nTrIn && anTds[i] ? false : true;
            nTd = create ? document.createElement(oCol.sCellType) : anTds[i];
            if (!nTd) _fnLog(oSettings, 0, 'Incorrect column count', 18);
            nTd._DT_CellIndex = {
                row: iRow,
                column: i
            };
            cells.push(nTd);
            var display = _fnGetRowDisplay(oSettings, iRow);
            // Need to create the HTML if new, or if a rendering function is defined
            if (create || (oCol.mRender || oCol.mData !== i) && (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i + '.display')) _fnWriteCell(nTd, display[i]);
            // column class
            _addClass(nTd, oCol.sClass);
            // Visibility - add or remove as required
            if (oCol.bVisible && create) nTr.appendChild(nTd);
            else if (!oCol.bVisible && !create) nTd.parentNode.removeChild(nTd);
            if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, _fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
        }
        _fnCallbackFire(oSettings, 'aoRowCreatedCallback', 'row-created', [
            nTr,
            rowData,
            iRow,
            cells
        ]);
    } else _addClass(row.nTr, trClass);
}
/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */ function _fnRowAttributes(settings, row) {
    var tr = row.nTr;
    var data = row._aData;
    if (tr) {
        var id = settings.rowIdFn(data);
        if (id) tr.id = id;
        if (data.DT_RowClass) {
            // Remove any classes added by DT_RowClass before
            var a = data.DT_RowClass.split(' ');
            row.__rowc = row.__rowc ? _unique(row.__rowc.concat(a)) : a;
            $(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
        }
        if (data.DT_RowAttr) $(tr).attr(data.DT_RowAttr);
        if (data.DT_RowData) $(tr).data(data.DT_RowData);
    }
}
/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnBuildHead(settings, side) {
    var classes = settings.oClasses;
    var columns = settings.aoColumns;
    var i, ien, row;
    var target = side === 'header' ? settings.nTHead : settings.nTFoot;
    var titleProp = side === 'header' ? 'sTitle' : side;
    // Footer might be defined
    if (!target) return;
    // If no cells yet and we have content for them, then create
    if (side === 'header' || _pluck(settings.aoColumns, titleProp).join('')) {
        row = $('tr', target);
        // Add a row if needed
        if (!row.length) row = $('<tr/>').appendTo(target);
        // Add the number of cells needed to make up to the number of columns
        if (row.length === 1) {
            var cells = $('td, th', row);
            for(i = cells.length, ien = columns.length; i < ien; i++)$('<th/>').html(columns[i][titleProp] || '').appendTo(row);
        }
    }
    var detected = _fnDetectHeader(settings, target, true);
    if (side === 'header') settings.aoHeader = detected;
    else settings.aoFooter = detected;
    // Every cell needs to be passed through the renderer
    $(target).children('tr').children('th, td').each(function() {
        _fnRenderer(settings, side)(settings, $(this), classes);
    });
}
/**
 * Build a layout structure for a header or footer
 *
 * @param {*} settings DataTables settings
 * @param {*} source Source layout array
 * @param {*} incColumns What columns should be included
 * @returns Layout array
 */ function _fnHeaderLayout(settings, source, incColumns) {
    var row, column, cell;
    var local = [];
    var structure = [];
    var columns = settings.aoColumns;
    var columnCount = columns.length;
    var rowspan, colspan;
    if (!source) return;
    // Default is to work on only visible columns
    if (!incColumns) incColumns = _range(columnCount).filter(function(idx) {
        return columns[idx].bVisible;
    });
    // Make a copy of the master layout array, but with only the columns we want
    for(row = 0; row < source.length; row++){
        // Remove any columns we haven't selected
        local[row] = source[row].slice().filter(function(cell, i) {
            return incColumns.includes(i);
        });
        // Prep the structure array - it needs an element for each row
        structure.push([]);
    }
    for(row = 0; row < local.length; row++)for(column = 0; column < local[row].length; column++){
        rowspan = 1;
        colspan = 1;
        // Check to see if there is already a cell (row/colspan) covering our target
        // insert point. If there is, then there is nothing to do.
        if (structure[row][column] === undefined) {
            cell = local[row][column].cell;
            // Expand for rowspan
            while(local[row + rowspan] !== undefined && local[row][column].cell == local[row + rowspan][column].cell){
                structure[row + rowspan][column] = null;
                rowspan++;
            }
            // And for colspan
            while(local[row][column + colspan] !== undefined && local[row][column].cell == local[row][column + colspan].cell){
                // Which also needs to go over rows
                for(var k = 0; k < rowspan; k++)structure[row + k][column + colspan] = null;
                colspan++;
            }
            var titleSpan = $('span.dt-column-title', cell);
            structure[row][column] = {
                cell: cell,
                colspan: colspan,
                rowspan: rowspan,
                title: titleSpan.length ? titleSpan.html() : $(cell).html()
            };
        }
    }
    return structure;
}
/**
 * Draw the header (or footer) element based on the column visibility states.
 *
 *  @param object oSettings dataTables settings object
 *  @param array aoSource Layout array from _fnDetectHeader
 *  @memberof DataTable#oApi
 */ function _fnDrawHead(settings, source) {
    var layout = _fnHeaderLayout(settings, source);
    var tr, n;
    for(var row = 0; row < source.length; row++){
        tr = source[row].row;
        // All cells are going to be replaced, so empty out the row
        // Can't use $().empty() as that kills event handlers
        if (tr) while(n = tr.firstChild)tr.removeChild(n);
        for(var column = 0; column < layout[row].length; column++){
            var point = layout[row][column];
            if (point) $(point.cell).appendTo(tr).attr('rowspan', point.rowspan).attr('colspan', point.colspan);
        }
    }
}
/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */ function _fnDraw(oSettings, ajaxComplete) {
    // Allow for state saving and a custom start position
    _fnStart(oSettings);
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = _fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [
        oSettings
    ]);
    if (aPreDraw.indexOf(false) !== -1) {
        _fnProcessingDisplay(oSettings, false);
        return;
    }
    var anRows = [];
    var iRowCount = 0;
    var bServerSide = _fnDataSource(oSettings) == 'ssp';
    var aiDisplay = oSettings.aiDisplay;
    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();
    var columns = oSettings.aoColumns;
    var body = $(oSettings.nTBody);
    oSettings.bDrawing = true;
    /* Server-side processing draw intercept */ if (oSettings.deferLoading) {
        oSettings.deferLoading = false;
        oSettings.iDraw++;
        _fnProcessingDisplay(oSettings, false);
    } else if (!bServerSide) oSettings.iDraw++;
    else if (!oSettings.bDestroying && !ajaxComplete) {
        // Show loading message for server-side processing
        if (oSettings.iDraw === 0) body.empty().append(_emptyRow(oSettings));
        _fnAjaxUpdate(oSettings);
        return;
    }
    if (aiDisplay.length !== 0) {
        var iStart = bServerSide ? 0 : iDisplayStart;
        var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
        for(var j = iStart; j < iEnd; j++){
            var iDataIndex = aiDisplay[j];
            var aoData = oSettings.aoData[iDataIndex];
            if (aoData.nTr === null) _fnCreateTr(oSettings, iDataIndex);
            var nRow = aoData.nTr;
            // Add various classes as needed
            for(var i = 0; i < columns.length; i++){
                var col = columns[i];
                var td = aoData.anCells[i];
                _addClass(td, _ext.type.className[col.sType]); // auto class
                _addClass(td, oSettings.oClasses.tbody.cell); // all cells
            }
            // Row callback functions - might want to manipulate the row
            // iRowCount and j are not currently documented. Are they at all
            // useful?
            _fnCallbackFire(oSettings, 'aoRowCallback', null, [
                nRow,
                aoData._aData,
                iRowCount,
                j,
                iDataIndex
            ]);
            anRows.push(nRow);
            iRowCount++;
        }
    } else anRows[0] = _emptyRow(oSettings);
    /* Header and footer callbacks */ _fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [
        $(oSettings.nTHead).children('tr')[0],
        _fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    _fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [
        $(oSettings.nTFoot).children('tr')[0],
        _fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    // replaceChildren is faster, but only became widespread in 2020,
    // so a fall back in jQuery is provided for older browsers.
    if (body[0].replaceChildren) body[0].replaceChildren.apply(body[0], anRows);
    else {
        body.children().detach();
        body.append($(anRows));
    }
    // Empty table needs a specific class
    $(oSettings.nTableWrapper).toggleClass('dt-empty-footer', $('tr', oSettings.nTFoot).length === 0);
    /* Call all required callback functions for the end of a draw */ _fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [
        oSettings
    ], true);
    /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
}
/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */ function _fnReDraw(settings, holdPosition, recompute) {
    var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
    if (recompute === undefined || recompute === true) {
        // Resolve any column types that are unknown due to addition or invalidation
        _fnColumnTypes(settings);
        if (sort) _fnSort(settings);
        if (filter) _fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
    }
    if (holdPosition !== true) settings._iDisplayStart = 0;
    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;
    _fnDraw(settings);
    settings._drawHold = false;
}
/*
 * Table is empty - create a row with an empty message in it
 */ function _emptyRow(settings) {
    var oLang = settings.oLanguage;
    var zero = oLang.sZeroRecords;
    var dataSrc = _fnDataSource(settings);
    if (settings.iDraw < 1 && dataSrc === 'ssp' || settings.iDraw <= 1 && dataSrc === 'ajax') zero = oLang.sLoadingRecords;
    else if (oLang.sEmptyTable && settings.fnRecordsTotal() === 0) zero = oLang.sEmptyTable;
    return $('<tr/>').append($('<td />', {
        'colSpan': _fnVisbleColumns(settings),
        'class': settings.oClasses.empty.row
    }).html(zero))[0];
}
/**
 * Expand the layout items into an object for the rendering function
 */ function _layoutItems(row, align, items) {
    if (Array.isArray(items)) {
        for(var i = 0; i < items.length; i++)_layoutItems(row, align, items[i]);
        return;
    }
    var rowCell = row[align];
    // If it is an object, then there can be multiple features contained in it
    if ($.isPlainObject(items)) {
        // A feature plugin cannot be named "features" due to this check
        if (items.features) {
            if (items.rowId) row.id = items.rowId;
            if (items.rowClass) row.className = items.rowClass;
            rowCell.id = items.id;
            rowCell.className = items.className;
            _layoutItems(row, align, items.features);
        } else Object.keys(items).map(function(key) {
            rowCell.contents.push({
                feature: key,
                opts: items[key]
            });
        });
    } else rowCell.contents.push(items);
}
/**
 * Find, or create a layout row
 */ function _layoutGetRow(rows, rowNum, align) {
    var row;
    // Find existing rows
    for(var i = 0; i < rows.length; i++){
        row = rows[i];
        if (row.rowNum === rowNum) // full is on its own, but start and end share a row
        {
            if (align === 'full' && row.full || (align === 'start' || align === 'end') && (row.start || row.end)) {
                if (!row[align]) row[align] = {
                    contents: []
                };
                return row;
            }
        }
    }
    // If we get this far, then there was no match, create a new row
    row = {
        rowNum: rowNum
    };
    row[align] = {
        contents: []
    };
    rows.push(row);
    return row;
}
/**
 * Convert a `layout` object given by a user to the object structure needed
 * for the renderer. This is done twice, once for above and once for below
 * the table. Ordering must also be considered.
 *
 * @param {*} settings DataTables settings object
 * @param {*} layout Layout object to convert
 * @param {string} side `top` or `bottom`
 * @returns Converted array structure - one item for each row.
 */ function _layoutArray(settings, layout, side) {
    var rows = [];
    // Split out into an array
    $.each(layout, function(pos, items) {
        if (items === null) return;
        var parts = pos.match(/^([a-z]+)([0-9]*)([A-Za-z]*)$/);
        var rowNum = parts[2] ? parts[2] * 1 : 0;
        var align = parts[3] ? parts[3].toLowerCase() : 'full';
        // Filter out the side we aren't interested in
        if (parts[1] !== side) return;
        // Get or create the row we should attach to
        var row = _layoutGetRow(rows, rowNum, align);
        _layoutItems(row, align, items);
    });
    // Order by item identifier
    rows.sort(function(a, b) {
        var order1 = a.rowNum;
        var order2 = b.rowNum;
        // If both in the same row, then the row with `full` comes first
        if (order1 === order2) {
            var ret = a.full && !b.full ? -1 : 1;
            return side === 'bottom' ? ret * -1 : ret;
        }
        return order2 - order1;
    });
    // Invert for below the table
    if (side === 'bottom') rows.reverse();
    for(var row = 0; row < rows.length; row++){
        delete rows[row].rowNum;
        _layoutResolve(settings, rows[row]);
    }
    return rows;
}
/**
 * Convert the contents of a row's layout object to nodes that can be inserted
 * into the document by a renderer. Execute functions, look up plug-ins, etc.
 *
 * @param {*} settings DataTables settings object
 * @param {*} row Layout object for this row
 */ function _layoutResolve(settings, row) {
    var getFeature = function(feature, opts) {
        if (!_ext.features[feature]) _fnLog(settings, 0, 'Unknown feature: ' + feature);
        return _ext.features[feature].apply(this, [
            settings,
            opts
        ]);
    };
    var resolve = function(item) {
        if (!row[item]) return;
        var line = row[item].contents;
        for(var i = 0, ien = line.length; i < ien; i++){
            if (!line[i]) continue;
            else if (typeof line[i] === 'string') line[i] = getFeature(line[i], null);
            else if ($.isPlainObject(line[i])) // If it's an object, it just has feature and opts properties from
            // the transform in _layoutArray
            line[i] = getFeature(line[i].feature, line[i].opts);
            else if (typeof line[i].node === 'function') line[i] = line[i].node(settings);
            else if (typeof line[i] === 'function') {
                var inst = line[i](settings);
                line[i] = typeof inst.node === 'function' ? inst.node() : inst;
            }
        }
    };
    resolve('start');
    resolve('end');
    resolve('full');
}
/**
 * Add the options to the page HTML for the table
 *  @param {object} settings DataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnAddOptionsHtml(settings) {
    var classes = settings.oClasses;
    var table = $(settings.nTable);
    // Wrapper div around everything DataTables controls
    var insert = $('<div/>').attr({
        id: settings.sTableId + '_wrapper',
        'class': classes.container
    }).insertBefore(table);
    settings.nTableWrapper = insert[0];
    if (settings.sDom) // Legacy
    _fnLayoutDom(settings, settings.sDom, insert);
    else {
        var top = _layoutArray(settings, settings.layout, 'top');
        var bottom = _layoutArray(settings, settings.layout, 'bottom');
        var renderer = _fnRenderer(settings, 'layout');
        // Everything above - the renderer will actually insert the contents into the document
        top.forEach(function(item) {
            renderer(settings, insert, item);
        });
        // The table - always the center of attention
        renderer(settings, insert, {
            full: {
                table: true,
                contents: [
                    _fnFeatureHtmlTable(settings)
                ]
            }
        });
        // Everything below
        bottom.forEach(function(item) {
            renderer(settings, insert, item);
        });
    }
    // Processing floats on top, so it isn't an inserted feature
    _processingHtml(settings);
}
/**
 * Draw the table with the legacy DOM property
 * @param {*} settings DT settings object
 * @param {*} dom DOM string
 * @param {*} insert Insert point
 */ function _fnLayoutDom(settings, dom, insert) {
    var parts = dom.match(/(".*?")|('.*?')|./g);
    var featureNode, option, newNode, next, attr;
    for(var i = 0; i < parts.length; i++){
        featureNode = null;
        option = parts[i];
        if (option == '<') {
            // New container div
            newNode = $('<div/>');
            // Check to see if we should append an id and/or a class name to the container
            next = parts[i + 1];
            if (next[0] == "'" || next[0] == '"') {
                attr = next.replace(/['"]/g, '');
                var id = '', className;
                /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */ if (attr.indexOf('.') != -1) {
                    var split = attr.split('.');
                    id = split[0];
                    className = split[1];
                } else if (attr[0] == "#") id = attr;
                else className = attr;
                newNode.attr('id', id.substring(1)).addClass(className);
                i++; // Move along the position array
            }
            insert.append(newNode);
            insert = newNode;
        } else if (option == '>') // End container div
        insert = insert.parent();
        else if (option == 't') // Table
        featureNode = _fnFeatureHtmlTable(settings);
        else DataTable.ext.feature.forEach(function(feature) {
            if (option == feature.cFeature) featureNode = feature.fnInit(settings);
        });
        // Add to the display
        if (featureNode) insert.append(featureNode);
    }
}
/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell that that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param {node} thead The header/footer element for the table
 *  @returns {array} Calculated layout array
 *  @memberof DataTable#oApi
 */ function _fnDetectHeader(settings, thead, write) {
    var columns = settings.aoColumns;
    var rows = $(thead).children('tr');
    var row, cell;
    var i, k, l, iLen, shifted, column, colspan, rowspan;
    var isHeader = thead && thead.nodeName.toLowerCase() === 'thead';
    var layout = [];
    var unique;
    var shift = function(a, i, j) {
        var k = a[i];
        while(k[j])j++;
        return j;
    };
    // We know how many rows there are in the layout - so prep it
    for(i = 0, iLen = rows.length; i < iLen; i++)layout.push([]);
    for(i = 0, iLen = rows.length; i < iLen; i++){
        row = rows[i];
        column = 0;
        // For every cell in the row..
        cell = row.firstChild;
        while(cell){
            if (cell.nodeName.toUpperCase() == 'TD' || cell.nodeName.toUpperCase() == 'TH') {
                var cols = [];
                // Get the col and rowspan attributes from the DOM and sanitise them
                colspan = cell.getAttribute('colspan') * 1;
                rowspan = cell.getAttribute('rowspan') * 1;
                colspan = !colspan || colspan === 0 || colspan === 1 ? 1 : colspan;
                rowspan = !rowspan || rowspan === 0 || rowspan === 1 ? 1 : rowspan;
                // There might be colspan cells already in this row, so shift our target
                // accordingly
                shifted = shift(layout, i, column);
                // Cache calculation for unique columns
                unique = colspan === 1 ? true : false;
                // Perform header setup
                if (write) {
                    if (unique) {
                        // Allow column options to be set from HTML attributes
                        _fnColumnOptions(settings, shifted, $(cell).data());
                        // Get the width for the column. This can be defined from the
                        // width attribute, style attribute or `columns.width` option
                        var columnDef = columns[shifted];
                        var width = cell.getAttribute('width') || null;
                        var t = cell.style.width.match(/width:\s*(\d+[pxem%]+)/);
                        if (t) width = t[1];
                        columnDef.sWidthOrig = columnDef.sWidth || width;
                        if (isHeader) {
                            // Column title handling - can be user set, or read from the DOM
                            // This happens before the render, so the original is still in place
                            if (columnDef.sTitle !== null && !columnDef.autoTitle) cell.innerHTML = columnDef.sTitle;
                            if (!columnDef.sTitle && unique) {
                                columnDef.sTitle = _stripHtml(cell.innerHTML);
                                columnDef.autoTitle = true;
                            }
                        } else // Footer specific operations
                        if (columnDef.footer) cell.innerHTML = columnDef.footer;
                        // Fall back to the aria-label attribute on the table header if no ariaTitle is
                        // provided.
                        if (!columnDef.ariaTitle) columnDef.ariaTitle = $(cell).attr("aria-label") || columnDef.sTitle;
                        // Column specific class names
                        if (columnDef.className) $(cell).addClass(columnDef.className);
                    }
                    // Wrap the column title so we can write to it in future
                    if ($('span.dt-column-title', cell).length === 0) $('<span>').addClass('dt-column-title').append(cell.childNodes).appendTo(cell);
                    if (isHeader && $('span.dt-column-order', cell).length === 0) $('<span>').addClass('dt-column-order').appendTo(cell);
                }
                // If there is col / rowspan, copy the information into the layout grid
                for(l = 0; l < colspan; l++){
                    for(k = 0; k < rowspan; k++){
                        layout[i + k][shifted + l] = {
                            cell: cell,
                            unique: unique
                        };
                        layout[i + k].row = row;
                    }
                    cols.push(shifted + l);
                }
                // Assign an attribute so spanning cells can still be identified
                // as belonging to a column
                cell.setAttribute('data-dt-column', _unique(cols).join(','));
            }
            cell = cell.nextSibling;
        }
    }
    return layout;
}
/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */ function _fnStart(oSettings) {
    var bServerSide = _fnDataSource(oSettings) == 'ssp';
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    // Check and see if we have an initial draw position from state saving
    if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
        oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
        oSettings.iInitDisplayStart = -1;
    }
}
/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */ function _fnBuildAjax(oSettings, data, fn) {
    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function(json) {
        var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
        if (json === null || typeof status === 'number' && status == 204) {
            json = {};
            _fnAjaxDataSrc(oSettings, json, []);
        }
        var error = json.error || json.sError;
        if (error) _fnLog(oSettings, 0, error);
        // Microsoft often wrap JSON as a string in another JSON object
        // Let's handle that automatically
        if (json.d && typeof json.d === 'string') try {
            json = JSON.parse(json.d);
        } catch (e) {
        // noop
        }
        oSettings.json = json;
        _fnCallbackFire(oSettings, null, 'xhr', [
            oSettings,
            json,
            oSettings.jqXHR
        ], true);
        fn(json);
    };
    if ($.isPlainObject(ajax) && ajax.data) {
        ajaxData = ajax.data;
        var newData = typeof ajaxData === 'function' ? ajaxData(data, oSettings) : ajaxData; // an object object or array to merge
        // If the function returned something, use that alone
        data = typeof ajaxData === 'function' && newData ? newData : $.extend(true, data, newData);
        // Remove the data property as we've resolved it already and don't want
        // jQuery to do it again (it is restored at the end of the function)
        delete ajax.data;
    }
    var baseAjax = {
        "url": typeof ajax === 'string' ? ajax : '',
        "data": data,
        "success": callback,
        "dataType": "json",
        "cache": false,
        "type": oSettings.sServerMethod,
        "error": function(xhr, error) {
            var ret = _fnCallbackFire(oSettings, null, 'xhr', [
                oSettings,
                null,
                oSettings.jqXHR
            ], true);
            if (ret.indexOf(true) === -1) {
                if (error == "parsererror") _fnLog(oSettings, 0, 'Invalid JSON response', 1);
                else if (xhr.readyState === 4) _fnLog(oSettings, 0, 'Ajax error', 7);
            }
            _fnProcessingDisplay(oSettings, false);
        }
    };
    // If `ajax` option is an object, extend and override our default base
    if ($.isPlainObject(ajax)) $.extend(baseAjax, ajax);
    // Store the data submitted for the API
    oSettings.oAjaxData = data;
    // Allow plug-ins and external processes to modify the data
    _fnCallbackFire(oSettings, null, 'preXhr', [
        oSettings,
        data,
        baseAjax
    ], true);
    if (typeof ajax === 'function') // Is a function - let the caller define what needs to be done
    oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
    else if (ajax.url === '') {
        // No url, so don't load any data. Just apply an empty data array
        // to the object for the callback.
        var empty = {};
        DataTable.util.set(ajax.dataSrc)(empty, []);
        callback(empty);
    } else // Object to extend the base settings
    oSettings.jqXHR = $.ajax(baseAjax);
    // Restore for next time around
    if (ajaxData) ajax.data = ajaxData;
}
/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */ function _fnAjaxUpdate(settings) {
    settings.iDraw++;
    _fnProcessingDisplay(settings, true);
    _fnBuildAjax(settings, _fnAjaxParameters(settings), function(json) {
        _fnAjaxUpdateDraw(settings, json);
    });
}
/**
 * Build up the parameters in an object needed for a server-side processing
 * request.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */ function _fnAjaxParameters(settings) {
    var columns = settings.aoColumns, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, colData = function(idx, prop) {
        return typeof columns[idx][prop] === 'function' ? 'function' : columns[idx][prop];
    };
    return {
        draw: settings.iDraw,
        columns: columns.map(function(column, i) {
            return {
                data: colData(i, 'mData'),
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: preColSearch[i].search,
                    regex: preColSearch[i].regex,
                    fixed: Object.keys(column.searchFixed).map(function(name) {
                        return {
                            name: name,
                            term: column.searchFixed[name].toString()
                        };
                    })
                }
            };
        }),
        order: _fnSortFlatten(settings).map(function(val) {
            return {
                column: val.col,
                dir: val.dir,
                name: colData(val.col, 'sName')
            };
        }),
        start: settings._iDisplayStart,
        length: features.bPaginate ? settings._iDisplayLength : -1,
        search: {
            value: preSearch.search,
            regex: preSearch.regex,
            fixed: Object.keys(settings.searchFixed).map(function(name) {
                return {
                    name: name,
                    term: settings.searchFixed[name].toString()
                };
            })
        }
    };
}
/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */ function _fnAjaxUpdateDraw(settings, json) {
    var data = _fnAjaxDataSrc(settings, json);
    var draw = _fnAjaxDataSrcParam(settings, 'draw', json);
    var recordsTotal = _fnAjaxDataSrcParam(settings, 'recordsTotal', json);
    var recordsFiltered = _fnAjaxDataSrcParam(settings, 'recordsFiltered', json);
    if (draw !== undefined) {
        // Protect against out of sequence returns
        if (draw * 1 < settings.iDraw) return;
        settings.iDraw = draw * 1;
    }
    // No data in returned object, so rather than an array, we show an empty table
    if (!data) data = [];
    _fnClearTable(settings);
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
    for(var i = 0, ien = data.length; i < ien; i++)_fnAddData(settings, data[i]);
    settings.aiDisplay = settings.aiDisplayMaster.slice();
    _fnColumnTypes(settings);
    _fnDraw(settings, true);
    _fnInitComplete(settings);
    _fnProcessingDisplay(settings, false);
}
/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} settings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */ function _fnAjaxDataSrc(settings, json, write) {
    var dataProp = 'data';
    if ($.isPlainObject(settings.ajax) && settings.ajax.dataSrc !== undefined) {
        // Could in inside a `dataSrc` object, or not!
        var dataSrc = settings.ajax.dataSrc;
        // string, function and object are valid types
        if (typeof dataSrc === 'string' || typeof dataSrc === 'function') dataProp = dataSrc;
        else if (dataSrc.data !== undefined) dataProp = dataSrc.data;
    }
    if (!write) {
        if (dataProp === 'data') // If the default, then we still want to support the old style, and safely ignore
        // it if possible
        return json.aaData || json[dataProp];
        return dataProp !== "" ? _fnGetObjectDataFn(dataProp)(json) : json;
    }
    // set
    _fnSetObjectDataFn(dataProp)(json, write);
}
/**
 * Very similar to _fnAjaxDataSrc, but for the other SSP properties
 * @param {*} settings DataTables settings object
 * @param {*} param Target parameter
 * @param {*} json JSON data
 * @returns Resolved value
 */ function _fnAjaxDataSrcParam(settings, param, json) {
    var dataSrc = $.isPlainObject(settings.ajax) ? settings.ajax.dataSrc : null;
    if (dataSrc && dataSrc[param]) // Get from custom location
    return _fnGetObjectDataFn(dataSrc[param])(json);
    // else - Default behaviour
    var old = '';
    // Legacy support
    if (param === 'draw') old = 'sEcho';
    else if (param === 'recordsTotal') old = 'iTotalRecords';
    else if (param === 'recordsFiltered') old = 'iTotalDisplayRecords';
    return json[old] !== undefined ? json[old] : json[param];
}
/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} settings dataTables settings object
 *  @param {object} input search information
 *  @memberof DataTable#oApi
 */ function _fnFilterComplete(settings, input) {
    var columnsSearch = settings.aoPreSearchCols;
    // In server-side processing all filtering is done by the server, so no point hanging around here
    if (_fnDataSource(settings) != 'ssp') {
        // Check if any of the rows were invalidated
        _fnFilterData(settings);
        // Start from the full data set
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Global filter first
        _fnFilter(settings.aiDisplay, settings, input.search, input);
        $.each(settings.searchFixed, function(name, term) {
            _fnFilter(settings.aiDisplay, settings, term, {});
        });
        // Then individual column filters
        for(var i = 0; i < columnsSearch.length; i++){
            var col = columnsSearch[i];
            _fnFilter(settings.aiDisplay, settings, col.search, col, i);
            $.each(settings.aoColumns[i].searchFixed, function(name, term) {
                _fnFilter(settings.aiDisplay, settings, term, {}, i);
            });
        }
        // And finally global filtering
        _fnFilterCustom(settings);
    }
    // Tell the draw function we have been filtering
    settings.bFiltered = true;
    _fnCallbackFire(settings, null, 'search', [
        settings
    ]);
}
/**
 * Apply custom filtering functions
 * 
 * This is legacy now that we have named functions, but it is widely used
 * from 1.x, so it is not yet deprecated.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnFilterCustom(settings) {
    var filters = DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;
    for(var i = 0, ien = filters.length; i < ien; i++){
        var rows = [];
        // Loop over each row and see if it should be included
        for(var j = 0, jen = displayRows.length; j < jen; j++){
            rowIdx = displayRows[j];
            row = settings.aoData[rowIdx];
            if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
        }
        // So the array reference doesn't break set the results into the
        // existing array
        displayRows.length = 0;
        displayRows.push.apply(displayRows, rows);
    }
}
/**
 * Filter the data table based on user input and draw the table
 */ function _fnFilter(searchRows, settings, input, options, column) {
    if (input === '') return;
    var i = 0;
    var matched = [];
    // Search term can be a function, regex or string - if a string we apply our
    // smart filtering regex (assuming the options require that)
    var searchFunc = typeof input === 'function' ? input : null;
    var rpSearch = input instanceof RegExp ? input : searchFunc ? null : _fnFilterCreateSearch(input, options);
    // Then for each row, does the test pass. If not, lop the row from the array
    for(i = 0; i < searchRows.length; i++){
        var row = settings.aoData[searchRows[i]];
        var data = column === undefined ? row._sFilterRow : row._aFilterData[column];
        if (searchFunc && searchFunc(data, row._aData, searchRows[i], column) || rpSearch && rpSearch.test(data)) matched.push(searchRows[i]);
    }
    // Mutate the searchRows array
    searchRows.length = matched.length;
    for(i = 0; i < matched.length; i++)searchRows[i] = matched[i];
}
/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */ function _fnFilterCreateSearch(search, inOpts) {
    var not = [];
    var options = $.extend({}, {
        boundary: false,
        caseInsensitive: true,
        exact: false,
        regex: false,
        smart: true
    }, inOpts);
    if (typeof search !== 'string') search = search.toString();
    // Remove diacritics if normalize is set up to do so
    search = _normalize(search);
    if (options.exact) return new RegExp('^' + _fnEscapeRegex(search) + '$', options.caseInsensitive ? 'i' : '');
    search = options.regex ? search : _fnEscapeRegex(search);
    if (options.smart) {
        /* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. And a negative look around for
		 * finding rows which don't contain a given string.
		 * 
		 * So this is the sort of thing we want to generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */ var parts = search.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [
            ''
        ];
        var a = parts.map(function(word) {
            var negative = false;
            var m;
            // Determine if it is a "does not include"
            if (word.charAt(0) === '!') {
                negative = true;
                word = word.substring(1);
            }
            // Strip the quotes from around matched phrases
            if (word.charAt(0) === '"') {
                m = word.match(/^"(.*)"$/);
                word = m ? m[1] : word;
            } else if (word.charAt(0) === '\u201C') {
                // Smart quote match (iPhone users)
                m = word.match(/^\u201C(.*)\u201D$/);
                word = m ? m[1] : word;
            }
            // For our "not" case, we need to modify the string that is
            // allowed to match at the end of the expression.
            if (negative) {
                if (word.length > 1) not.push('(?!' + word + ')');
                word = '';
            }
            return word.replace(/"/g, '');
        });
        var match = not.length ? not.join('') : '';
        var boundary = options.boundary ? '\\b' : '';
        search = '^(?=.*?' + boundary + a.join(')(?=.*?' + boundary) + ')(' + match + '.)*$';
    }
    return new RegExp(search, options.caseInsensitive ? 'i' : '');
}
/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */ var _fnEscapeRegex = DataTable.util.escapeRegex;
var __filter_div = $('<div>')[0];
var __filter_div_textContent = __filter_div.textContent !== undefined;
// Update the filtering data for each row if needed (by invalidation or first run)
function _fnFilterData(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var column;
    var j, jen, filterData, cellData, row;
    var wasInvalidated = false;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aFilterData) {
            filterData = [];
            for(j = 0, jen = columns.length; j < jen; j++){
                column = columns[j];
                if (column.bSearchable) {
                    cellData = _fnGetCellData(settings, rowIdx, j, 'filter');
                    // Search in DataTables is string based
                    if (cellData === null) cellData = '';
                    if (typeof cellData !== 'string' && cellData.toString) cellData = cellData.toString();
                } else cellData = '';
                // If it looks like there is an HTML entity in the string,
                // attempt to decode it so sorting works as expected. Note that
                // we could use a single line of jQuery to do this, but the DOM
                // method used here is much faster https://jsperf.com/html-decode
                if (cellData.indexOf && cellData.indexOf('&') !== -1) {
                    __filter_div.innerHTML = cellData;
                    cellData = __filter_div_textContent ? __filter_div.textContent : __filter_div.innerText;
                }
                if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, '');
                filterData.push(cellData);
            }
            row._aFilterData = filterData;
            row._sFilterRow = filterData.join('  ');
            wasInvalidated = true;
        }
    }
    return wasInvalidated;
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnInitialise(settings) {
    var i;
    var init = settings.oInit;
    var deferLoading = settings.deferLoading;
    var dataSrc = _fnDataSource(settings);
    // Ensure that the table data is fully initialised
    if (!settings.bInitialised) {
        setTimeout(function() {
            _fnInitialise(settings);
        }, 200);
        return;
    }
    // Build the header / footer for the table
    _fnBuildHead(settings, 'header');
    _fnBuildHead(settings, 'footer');
    // Load the table's state (if needed) and then render around it and draw
    _fnLoadState(settings, init, function() {
        // Then draw the header / footer
        _fnDrawHead(settings, settings.aoHeader);
        _fnDrawHead(settings, settings.aoFooter);
        // Cache the paging start point, as the first redraw will reset it
        var iAjaxStart = settings.iInitDisplayStart;
        // Local data load
        // Check if there is data passing into the constructor
        if (init.aaData) for(i = 0; i < init.aaData.length; i++)_fnAddData(settings, init.aaData[i]);
        else if (deferLoading || dataSrc == 'dom') // Grab the data from the page
        _fnAddTr(settings, $(settings.nTBody).children('tr'));
        // Filter not yet applied - copy the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Enable features
        _fnAddOptionsHtml(settings);
        _fnSortInit(settings);
        _colGroup(settings);
        /* Okay to show that something is going on now */ _fnProcessingDisplay(settings, true);
        _fnCallbackFire(settings, null, 'preInit', [
            settings
        ], true);
        // If there is default sorting required - let's do it. The sort function
        // will do the drawing for us. Otherwise we draw the table regardless of the
        // Ajax source - this allows the table to look initialised for Ajax sourcing
        // data (show 'loading' message possibly)
        _fnReDraw(settings);
        // Server-side processing init complete is done by _fnAjaxUpdateDraw
        if (dataSrc != 'ssp' || deferLoading) {
            // if there is an ajax source load the data
            if (dataSrc == 'ajax') _fnBuildAjax(settings, {}, function(json) {
                var aData = _fnAjaxDataSrc(settings, json);
                // Got the data - add it to the table
                for(i = 0; i < aData.length; i++)_fnAddData(settings, aData[i]);
                // Reset the init display for cookie saving. We've already done
                // a filter, and therefore cleared it before. So we need to make
                // it appear 'fresh'
                settings.iInitDisplayStart = iAjaxStart;
                _fnReDraw(settings);
                _fnProcessingDisplay(settings, false);
                _fnInitComplete(settings);
            }, settings);
            else {
                _fnInitComplete(settings);
                _fnProcessingDisplay(settings, false);
            }
        }
    });
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnInitComplete(settings) {
    if (settings._bInitComplete) return;
    var args = [
        settings,
        settings.json
    ];
    settings._bInitComplete = true;
    // Table is fully set up and we have data, so calculate the
    // column widths
    _fnAdjustColumnSizing(settings);
    _fnCallbackFire(settings, null, 'plugin-init', args, true);
    _fnCallbackFire(settings, 'aoInitComplete', 'init', args, true);
}
function _fnLengthChange(settings, val) {
    var len = parseInt(val, 10);
    settings._iDisplayLength = len;
    _fnLengthOverflow(settings);
    // Fire length change event
    _fnCallbackFire(settings, null, 'length', [
        settings,
        len
    ]);
}
/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */ function _fnPageChange(settings, action, redraw) {
    var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
    if (records === 0 || len === -1) start = 0;
    else if (typeof action === "number") {
        start = action * len;
        if (start > records) start = 0;
    } else if (action == "first") start = 0;
    else if (action == "previous") {
        start = len >= 0 ? start - len : 0;
        if (start < 0) start = 0;
    } else if (action == "next") {
        if (start + len < records) start += len;
    } else if (action == "last") start = Math.floor((records - 1) / len) * len;
    else if (action === 'ellipsis') return;
    else _fnLog(settings, 0, "Unknown paging action: " + action, 5);
    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;
    _fnCallbackFire(settings, null, changed ? 'page' : 'page-nc', [
        settings
    ]);
    if (changed && redraw) _fnDraw(settings);
    return changed;
}
/**
 * Generate the node required for the processing node
 *  @param {object} settings DataTables settings object
 */ function _processingHtml(settings) {
    var table = settings.nTable;
    var scrolling = settings.oScroll.sX !== '' || settings.oScroll.sY !== '';
    if (settings.oFeatures.bProcessing) {
        var n = $('<div/>', {
            'id': settings.sTableId + '_processing',
            'class': settings.oClasses.processing.container,
            'role': 'status'
        }).html(settings.oLanguage.sProcessing).append('<div><div></div><div></div><div></div><div></div></div>');
        // Different positioning depending on if scrolling is enabled or not
        if (scrolling) n.prependTo($('div.dt-scroll', settings.nTableWrapper));
        else n.insertBefore(table);
        $(table).on('processing.dt.DT', function(e, s, show) {
            n.css('display', show ? 'block' : 'none');
        });
    }
}
/**
 * Display or hide the processing indicator
 *  @param {object} settings DataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 */ function _fnProcessingDisplay(settings, show) {
    // Ignore cases when we are still redrawing
    if (settings.bDrawing && show === false) return;
    _fnCallbackFire(settings, null, 'processing', [
        settings,
        show
    ]);
}
/**
 * Show the processing element if an action takes longer than a given time
 *
 * @param {*} settings DataTables settings object
 * @param {*} enable Do (true) or not (false) async processing (local feature enablement)
 * @param {*} run Function to run
 */ function _fnProcessingRun(settings, enable, run) {
    if (!enable) // Immediate execution, synchronous
    run();
    else {
        _fnProcessingDisplay(settings, true);
        // Allow the processing display to show if needed
        setTimeout(function() {
            run();
            _fnProcessingDisplay(settings, false);
        }, 0);
    }
}
/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */ function _fnFeatureHtmlTable(settings) {
    var table = $(settings.nTable);
    // Scrolling from here on in
    var scroll = settings.oScroll;
    if (scroll.sX === '' && scroll.sY === '') return settings.nTable;
    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses.scrolling;
    var caption = settings.captionNode;
    var captionSide = caption ? caption._captionSide : null;
    var headerClone = $(table[0].cloneNode(false));
    var footerClone = $(table[0].cloneNode(false));
    var footer = table.children('tfoot');
    var _div = '<div/>';
    var size = function(s) {
        return !s ? null : _fnStringToCss(s);
    };
    if (!footer.length) footer = null;
    /*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */ var scroller = $(_div, {
        'class': classes.container
    }).append($(_div, {
        'class': classes.header.self
    }).css({
        overflow: 'hidden',
        position: 'relative',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($(_div, {
        'class': classes.header.inner
    }).css({
        'box-sizing': 'content-box',
        width: scroll.sXInner || '100%'
    }).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($(_div, {
        'class': classes.body
    }).css({
        position: 'relative',
        overflow: 'auto',
        width: size(scrollX)
    }).append(table));
    if (footer) scroller.append($(_div, {
        'class': classes.footer.self
    }).css({
        overflow: 'hidden',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($(_div, {
        'class': classes.footer.inner
    }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;
    // When the body is scrolled, then we also want to scroll the headers
    $(scrollBody).on('scroll.DT', function() {
        var scrollLeft = this.scrollLeft;
        scrollHead.scrollLeft = scrollLeft;
        if (footer) scrollFoot.scrollLeft = scrollLeft;
    });
    // When focus is put on the header cells, we might need to scroll the body
    $('th, td', scrollHead).on('focus', function() {
        var scrollLeft = scrollHead.scrollLeft;
        scrollBody.scrollLeft = scrollLeft;
        if (footer) scrollBody.scrollLeft = scrollLeft;
    });
    $(scrollBody).css('max-height', scrollY);
    if (!scroll.bCollapse) $(scrollBody).css('height', scrollY);
    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;
    // On redraw - align columns
    settings.aoDrawCallback.push(_fnScrollDraw);
    return scroller[0];
}
/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Correct colgroup > col values if needed
 *   3. Copy colgroup > col over to header and footer
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnScrollDraw(settings) {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var scroll = settings.oScroll, barWidth = scroll.iBarWidth, divHeader = $(settings.nScrollHead), divHeaderInner = divHeader.children('div'), divHeaderTable = divHeaderInner.children('table'), divBodyEl = settings.nScrollBody, divBody = $(divBodyEl), divFooter = $(settings.nScrollFoot), divFooterInner = divFooter.children('div'), divFooterTable = divFooterInner.children('table'), header = $(settings.nTHead), table = $(settings.nTable), footer = settings.nTFoot && $('th, td', settings.nTFoot).length ? $(settings.nTFoot) : null, browser = settings.oBrowser, headerCopy, footerCopy;
    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
    if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
        settings.scrollBarVis = scrollBarVis;
        _fnAdjustColumnSizing(settings);
        return; // adjust column sizing will call this function again
    } else settings.scrollBarVis = scrollBarVis;
    // 1. Re-create the table inside the scrolling div
    // Remove the old minimised thead and tfoot elements in the inner table
    table.children('thead, tfoot').remove();
    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo(table);
    headerCopy.find('th, td').removeAttr('tabindex');
    headerCopy.find('[id]').removeAttr('id');
    if (footer) {
        footerCopy = footer.clone().prependTo(table);
        footerCopy.find('[id]').removeAttr('id');
    }
    // 2. Correct colgroup > col values if needed
    // It is possible that the cell sizes are smaller than the content, so we need to
    // correct colgroup>col for such cases. This can happen if the auto width detection
    // uses a cell which has a longer string, but isn't the widest! For example 
    // "Chief Executive Officer (CEO)" is the longest string in the demo, but
    // "Systems Administrator" is actually the widest string since it doesn't collapse.
    // Note the use of translating into a column index to get the `col` element. This
    // is because of Responsive which might remove `col` elements, knocking the alignment
    // of the indexes out.
    if (settings.aiDisplay.length) {
        // Get the column sizes from the first row in the table. This should really be a
        // [].find, but it wasn't supported in Chrome until Sept 2015, and DT has 10 year
        // browser support
        var firstTr = null;
        for(i = settings._iDisplayStart; i < settings.aiDisplay.length; i++){
            var idx = settings.aiDisplay[i];
            var tr = settings.aoData[idx].nTr;
            if (tr) {
                firstTr = tr;
                break;
            }
        }
        if (firstTr) {
            var colSizes = $(firstTr).children('th, td').map(function(vis) {
                return {
                    idx: _fnVisibleToColumnIndex(settings, vis),
                    width: $(this).outerWidth()
                };
            });
            // Check against what the colgroup > col is set to and correct if needed
            for(var i = 0; i < colSizes.length; i++){
                var colEl = settings.aoColumns[colSizes[i].idx].colEl[0];
                var colWidth = colEl.style.width.replace('px', '');
                if (colWidth !== colSizes[i].width) colEl.style.width = colSizes[i].width + 'px';
            }
        }
    }
    // 3. Copy the colgroup over to the header and footer
    divHeaderTable.find('colgroup').remove();
    divHeaderTable.append(settings.colgroup.clone());
    if (footer) {
        divFooterTable.find('colgroup').remove();
        divFooterTable.append(settings.colgroup.clone());
    }
    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely.
    $('th, td', headerCopy).each(function() {
        $(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    if (footer) $('th, td', footerCopy).each(function() {
        $(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    // 4. Clean up
    // Figure out if there are scrollbar present - if so then we need a the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var isScrolling = Math.floor(table.height()) > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
    var paddingSide = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
    // Set the width's of the header and footer tables
    var outerWidth = table.outerWidth();
    divHeaderTable.css('width', _fnStringToCss(outerWidth));
    divHeaderInner.css('width', _fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    if (footer) {
        divFooterTable.css('width', _fnStringToCss(outerWidth));
        divFooterInner.css('width', _fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    }
    // Correct DOM ordering for colgroup - comes before the thead
    table.children('colgroup').prependTo(table);
    // Adjust the position of the header in case we loose the y-scrollbar
    divBody.trigger('scroll');
    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
}
/**
 * Calculate the width of columns for the table
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnCalculateColumnWidths(settings) {
    // Not interested in doing column width calculation if auto-width is disabled
    if (!settings.oFeatures.bAutoWidth) return;
    var table = settings.nTable, columns = settings.aoColumns, scroll = settings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, visibleColumns = _fnGetColumns(settings, 'bVisible'), tableWidthAttr = table.getAttribute('width'), tableContainer = table.parentNode, i, column, columnIdx;
    var styleWidth = table.style.width;
    // If there is no width applied as a CSS style or as an attribute, we assume that
    // the width is intended to be 100%, which is usually is in CSS, but it is very
    // difficult to correctly parse the rules to get the final result.
    if (!styleWidth && !tableWidthAttr) {
        table.style.width = '100%';
        styleWidth = '100%';
    }
    if (styleWidth && styleWidth.indexOf('%') !== -1) tableWidthAttr = styleWidth;
    // Let plug-ins know that we are doing a recalc, in case they have changed any of the
    // visible columns their own way (e.g. Responsive uses display:none).
    _fnCallbackFire(settings, null, 'column-calc', {
        visible: visibleColumns
    }, false);
    // Construct a single row, worst case, table with the widest
    // node in the data, assign any user defined widths, then insert it into
    // the DOM and allow the browser to do all the hard work of calculating
    // table widths
    var tmpTable = $(table.cloneNode()).css('visibility', 'hidden').removeAttr('id');
    // Clean up the table body
    tmpTable.append('<tbody>');
    var tr = $('<tr/>').appendTo(tmpTable.find('tbody'));
    // Clone the table header and footer - we can't use the header / footer
    // from the cloned table, since if scrolling is active, the table's
    // real header and footer are contained in different table tags
    tmpTable.append($(settings.nTHead).clone()).append($(settings.nTFoot).clone());
    // Remove any assigned widths from the footer (from scrolling)
    tmpTable.find('tfoot th, tfoot td').css('width', '');
    // Apply custom sizing to the cloned header
    tmpTable.find('thead th, thead td').each(function() {
        // Get the `width` from the header layout
        var width = _fnColumnsSumWidth(settings, this, true, false);
        if (width) {
            this.style.width = width;
            // For scrollX we need to force the column width otherwise the
            // browser will collapse it. If this width is smaller than the
            // width the column requires, then it will have no effect
            if (scrollX) $(this).append($('<div/>').css({
                width: width,
                margin: 0,
                padding: 0,
                border: 0,
                height: 1
            }));
        } else this.style.width = '';
    });
    // Find the widest piece of data for each column and put it into the table
    for(i = 0; i < visibleColumns.length; i++){
        columnIdx = visibleColumns[i];
        column = columns[columnIdx];
        var longest = _fnGetMaxLenString(settings, columnIdx);
        var autoClass = _ext.type.className[column.sType];
        var text = longest + column.sContentPadding;
        var insert = longest.indexOf('<') === -1 ? document.createTextNode(text) : text;
        $('<td/>').addClass(autoClass).addClass(column.sClass).append(insert).appendTo(tr);
    }
    // Tidy the temporary table - remove name attributes so there aren't
    // duplicated in the dom (radio elements for example)
    $('[name]', tmpTable).removeAttr('name');
    // Table has been built, attach to the document so we can work with it.
    // A holding element is used, positioned at the top of the container
    // with minimal height, so it has no effect on if the container scrolls
    // or not. Otherwise it might trigger scrolling when it actually isn't
    // needed
    var holder = $('<div/>').css(scrollX || scrollY ? {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: 'hidden'
    } : {}).append(tmpTable).appendTo(tableContainer);
    // When scrolling (X or Y) we want to set the width of the table as 
    // appropriate. However, when not scrolling leave the table width as it
    // is. This results in slightly different, but I think correct behaviour
    if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
    else if (scrollX) {
        tmpTable.css('width', 'auto');
        tmpTable.removeAttr('width');
        // If there is no width attribute or style, then allow the table to
        // collapse
        if (tmpTable.width() < tableContainer.clientWidth && tableWidthAttr) tmpTable.width(tableContainer.clientWidth);
    } else if (scrollY) tmpTable.width(tableContainer.clientWidth);
    else if (tableWidthAttr) tmpTable.width(tableWidthAttr);
    // Get the width of each column in the constructed table
    var total = 0;
    var bodyCells = tmpTable.find('tbody tr').eq(0).children();
    for(i = 0; i < visibleColumns.length; i++){
        // Use getBounding for sub-pixel accuracy, which we then want to round up!
        var bounding = bodyCells[i].getBoundingClientRect().width;
        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here
        total += bounding;
        // Width for each column to use
        columns[visibleColumns[i]].sWidth = _fnStringToCss(bounding);
    }
    table.style.width = _fnStringToCss(total);
    // Finished with the table - ditch it
    holder.remove();
    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if (tableWidthAttr) table.style.width = _fnStringToCss(tableWidthAttr);
    if ((tableWidthAttr || scrollX) && !settings._reszEvt) {
        var bindResize = function() {
            $(window).on('resize.DT-' + settings.sInstance, DataTable.util.throttle(function() {
                if (!settings.bDestroying) _fnAdjustColumnSizing(settings);
            }));
        };
        bindResize();
        settings._reszEvt = true;
    }
}
/**
 * Get the maximum strlen for each data column
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string} string of the max length
 *  @memberof DataTable#oApi
 */ function _fnGetMaxLenString(settings, colIdx) {
    var column = settings.aoColumns[colIdx];
    if (!column.maxLenString) {
        var s, max = '', maxLen = -1;
        for(var i = 0, ien = settings.aiDisplayMaster.length; i < ien; i++){
            var rowIdx = settings.aiDisplayMaster[i];
            var data = _fnGetRowDisplay(settings, rowIdx)[colIdx];
            var cellString = data && typeof data === 'object' && data.nodeType ? data.innerHTML : data + '';
            // Remove id / name attributes from elements so they
            // don't interfere with existing elements
            cellString = cellString.replace(/id=".*?"/g, '').replace(/name=".*?"/g, '');
            s = _stripHtml(cellString).replace(/&nbsp;/g, ' ');
            if (s.length > maxLen) {
                // We want the HTML in the string, but the length that
                // is important is the stripped string
                max = cellString;
                maxLen = s.length;
            }
        }
        column.maxLenString = max;
    }
    return column.maxLenString;
}
/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */ function _fnStringToCss(s) {
    if (s === null) return '0px';
    if (typeof s == 'number') return s < 0 ? '0px' : s + 'px';
    // Check it has a unit character already
    return s.match(/\d$/) ? s + 'px' : s;
}
/**
 * Re-insert the `col` elements for current visibility
 *
 * @param {*} settings DT settings
 */ function _colGroup(settings) {
    var cols = settings.aoColumns;
    settings.colgroup.empty();
    for(i = 0; i < cols.length; i++)if (cols[i].bVisible) settings.colgroup.append(cols[i].colEl);
}
function _fnSortInit(settings) {
    var target = settings.nTHead;
    var headerRows = target.querySelectorAll('tr');
    var legacyTop = settings.bSortCellsTop;
    var notSelector = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
    // Legacy support for `orderCellsTop`
    if (legacyTop === true) target = headerRows[0];
    else if (legacyTop === false) target = headerRows[headerRows.length - 1];
    _fnSortAttachListener(settings, target, target === settings.nTHead ? 'tr' + notSelector + ' th' + notSelector + ', tr' + notSelector + ' td' + notSelector : 'th' + notSelector + ', td' + notSelector);
    // Need to resolve the user input array into our internal structure
    var order = [];
    _fnSortResolve(settings, order, settings.aaSorting);
    settings.aaSorting = order;
}
function _fnSortAttachListener(settings, node, selector, column, callback) {
    _fnBindAction(node, selector, function(e) {
        var run = false;
        var columns = column === undefined ? _fnColumnsFromHeader(e.target) : [
            column
        ];
        if (columns.length) {
            for(var i = 0, ien = columns.length; i < ien; i++){
                var ret = _fnSortAdd(settings, columns[i], i, e.shiftKey);
                if (ret !== false) run = true;
                // If the first entry is no sort, then subsequent
                // sort columns are ignored
                if (settings.aaSorting.length === 1 && settings.aaSorting[0][1] === '') break;
            }
            if (run) _fnProcessingRun(settings, true, function() {
                _fnSort(settings);
                _fnSortDisplay(settings, settings.aiDisplay);
                _fnReDraw(settings, false, false);
                if (callback) callback();
            });
        }
    });
}
/**
 * Sort the display array to match the master's order
 * @param {*} settings
 */ function _fnSortDisplay(settings, display) {
    if (display.length < 2) return;
    var master = settings.aiDisplayMaster;
    var masterMap = {};
    var map = {};
    var i;
    // Rather than needing an `indexOf` on master array, we can create a map
    for(i = 0; i < master.length; i++)masterMap[master[i]] = i;
    // And then cache what would be the indexOf fom the display
    for(i = 0; i < display.length; i++)map[display[i]] = masterMap[display[i]];
    display.sort(function(a, b) {
        // Short version of this function is simply `master.indexOf(a) - master.indexOf(b);`
        return map[a] - map[b];
    });
}
function _fnSortResolve(settings, nestedSort, sort) {
    var push = function(a) {
        if ($.isPlainObject(a)) {
            if (a.idx !== undefined) // Index based ordering
            nestedSort.push([
                a.idx,
                a.dir
            ]);
            else if (a.name) {
                // Name based ordering
                var cols = _pluck(settings.aoColumns, 'sName');
                var idx = cols.indexOf(a.name);
                if (idx !== -1) nestedSort.push([
                    idx,
                    a.dir
                ]);
            }
        } else // Plain column index and direction pair
        nestedSort.push(a);
    };
    if ($.isPlainObject(sort)) // Object
    push(sort);
    else if (sort.length && typeof sort[0] === 'number') // 1D array
    push(sort);
    else if (sort.length) // 2D array
    for(var z = 0; z < sort.length; z++)push(sort[z]); // Object or array
}
function _fnSortFlatten(settings) {
    var i, k, kLen, aSort = [], extSort = DataTable.ext.type.order, aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $.isPlainObject(fixed), nestedSort = [];
    if (!settings.oFeatures.bSort) return aSort;
    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if (Array.isArray(fixed)) _fnSortResolve(settings, nestedSort, fixed);
    if (fixedObj && fixed.pre) _fnSortResolve(settings, nestedSort, fixed.pre);
    _fnSortResolve(settings, nestedSort, settings.aaSorting);
    if (fixedObj && fixed.post) _fnSortResolve(settings, nestedSort, fixed.post);
    for(i = 0; i < nestedSort.length; i++){
        srcCol = nestedSort[i][0];
        if (aoColumns[srcCol]) {
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || 'string';
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = aoColumns[iCol].asSorting.indexOf(nestedSort[i][1]);
                if (nestedSort[i][1]) aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: extSort[sType + "-pre"],
                    sorter: extSort[sType + "-" + nestedSort[i][1]]
                });
            }
        }
    }
    return aSort;
}
/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnSort(oSettings, col, dir) {
    var i, ien, iLen, aiOrig = [], extSort = DataTable.ext.type.order, aoData = oSettings.aoData, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
    // Allow a specific column to be sorted, which will _not_ alter the display
    // master
    if (col !== undefined) {
        var srcCol = oSettings.aoColumns[col];
        aSort = [
            {
                src: col,
                col: col,
                dir: dir,
                index: 0,
                type: srcCol.sType,
                formatter: extSort[srcCol.sType + "-pre"],
                sorter: extSort[srcCol.sType + "-" + dir]
            }
        ];
        displayMaster = displayMaster.slice();
    } else aSort = _fnSortFlatten(oSettings);
    for(i = 0, ien = aSort.length; i < ien; i++){
        sortCol = aSort[i];
        // Load the data needed for the sort, for each cell
        _fnSortData(oSettings, sortCol.col);
    }
    /* No sorting required if server-side or no sorting array */ if (_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
        // Reset the initial positions on each pass so we get a stable sort
        for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[i] = i;
        // If the first sort is desc, then reverse the array to preserve original
        // order, just in reverse
        if (aSort.length && aSort[0].dir === 'desc' && oSettings.orderDescReverse) aiOrig.reverse();
        /* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on it's own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var test;
		 *    test = oSort['string-asc']('data11', 'data12');
		 *      if (test !== 0)
		 *        return test;
		 *    test = oSort['numeric-desc']('data21', 'data22');
		 *    if (test !== 0)
		 *      return test;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 */ displayMaster.sort(function(a, b) {
            var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
            for(k = 0; k < len; k++){
                sort = aSort[k];
                // Data, which may have already been through a `-pre` function
                x = dataA[sort.col];
                y = dataB[sort.col];
                if (sort.sorter) {
                    // If there is a custom sorter (`-asc` or `-desc`) for this
                    // data type, use it
                    test = sort.sorter(x, y);
                    if (test !== 0) return test;
                } else {
                    // Otherwise, use generic sorting
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === 'asc' ? test : -test;
                }
            }
            x = aiOrig[a];
            y = aiOrig[b];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    } else if (aSort.length === 0) // Apply index order
    displayMaster.sort(function(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    });
    if (col === undefined) {
        // Tell the draw function that we have sorted the data
        oSettings.bSorted = true;
        oSettings.sortDetails = aSort;
        _fnCallbackFire(oSettings, null, 'order', [
            oSettings,
            aSort
        ]);
    }
    return displayMaster;
}
/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {int} addIndex Counter
 *  @param {boolean} [shift=false] Shift click add
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */ function _fnSortAdd(settings, colIdx, addIndex, shift) {
    var col = settings.aoColumns[colIdx];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function(a, overflow) {
        var idx = a._idx;
        if (idx === undefined) idx = asSorting.indexOf(a[1]);
        return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
    };
    if (!col.bSortable) return false;
    // Convert to 2D array if needed
    if (typeof sorting[0] === 'number') sorting = settings.aaSorting = [
        sorting
    ];
    // If appending the sort then we are multi-column sorting
    if ((shift || addIndex) && settings.oFeatures.bSortMulti) {
        // Are we already doing some kind of sort on this column?
        var sortIdx = _pluck(sorting, '0').indexOf(colIdx);
        if (sortIdx !== -1) {
            // Yes, modify the sort
            nextSortIdx = next(sorting[sortIdx], true);
            if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
            if (nextSortIdx === null) sorting.splice(sortIdx, 1);
            else {
                sorting[sortIdx][1] = asSorting[nextSortIdx];
                sorting[sortIdx]._idx = nextSortIdx;
            }
        } else if (shift) {
            // No sort on this column yet, being added by shift click
            // add it as itself
            sorting.push([
                colIdx,
                asSorting[0],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        } else {
            // No sort on this column yet, being added from a colspan
            // so add with same direction as first column
            sorting.push([
                colIdx,
                sorting[0][1],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        }
    } else if (sorting.length && sorting[0][0] == colIdx) {
        // Single column - already sorting on this column, modify the sort
        nextSortIdx = next(sorting[0]);
        sorting.length = 1;
        sorting[0][1] = asSorting[nextSortIdx];
        sorting[0]._idx = nextSortIdx;
    } else {
        // Single column - sort only on this column
        sorting.length = 0;
        sorting.push([
            colIdx,
            asSorting[0]
        ]);
        sorting[0]._idx = 0;
    }
}
/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnSortingClasses(settings) {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.order.position;
    var sort = _fnSortFlatten(settings);
    var features = settings.oFeatures;
    var i, ien, colIdx;
    if (features.bSort && features.bSortClasses) {
        // Remove old sorting classes
        for(i = 0, ien = oldSort.length; i < ien; i++){
            colIdx = oldSort[i].src;
            // Remove column sorting
            $(_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
        }
        // Add new column sorting
        for(i = 0, ien = sort.length; i < ien; i++){
            colIdx = sort[i].src;
            $(_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
        }
    }
    settings.aLastSort = sort;
}
// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function _fnSortData(settings, colIdx) {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[colIdx];
    var customSort = DataTable.ext.order[column.sSortDataType];
    var customData;
    if (customSort) customData = customSort.call(settings.oInstance, settings, colIdx, _fnColumnIndexToVisible(settings, colIdx));
    // Use / populate cache
    var row, cellData;
    var formatter = DataTable.ext.type.order[column.sType + "-pre"];
    var data = settings.aoData;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        // Sparse array
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aSortData) row._aSortData = [];
        if (!row._aSortData[colIdx] || customSort) {
            cellData = customSort ? customData[rowIdx] : _fnGetCellData(settings, rowIdx, colIdx, 'sort');
            row._aSortData[colIdx] = formatter ? formatter(cellData, settings) : cellData;
        }
    }
}
/**
 * State information for a table
 *
 * @param {*} settings
 * @returns State object
 */ function _fnSaveState(settings) {
    if (settings._bLoadingState) return;
    /* Store the interesting variables */ var state = {
        time: +new Date(),
        start: settings._iDisplayStart,
        length: settings._iDisplayLength,
        order: $.extend(true, [], settings.aaSorting),
        search: $.extend({}, settings.oPreviousSearch),
        columns: settings.aoColumns.map(function(col, i) {
            return {
                visible: col.bVisible,
                search: $.extend({}, settings.aoPreSearchCols[i])
            };
        })
    };
    settings.oSavedState = state;
    _fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [
        settings,
        state
    ]);
    if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
}
/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */ function _fnLoadState(settings, init, callback) {
    if (!settings.oFeatures.bStateSave) {
        callback();
        return;
    }
    var loaded = function(state) {
        _fnImplementState(settings, state, callback);
    };
    var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
    if (state !== undefined) _fnImplementState(settings, state, callback);
    // otherwise, wait for the loaded callback to be executed
    return true;
}
function _fnImplementState(settings, s, callback) {
    var i, ien;
    var columns = settings.aoColumns;
    settings._bLoadingState = true;
    // When StateRestore was introduced the state could now be implemented at any time
    // Not just initialisation. To do this an api instance is required in some places
    var api = settings._bInitComplete ? new DataTable.Api(settings) : null;
    if (!s || !s.time) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Reject old data
    var duration = settings.iStateDuration;
    if (duration > 0 && s.time < +new Date() - duration * 1000) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Allow custom and plug-in manipulation functions to alter the saved data set and
    // cancelling of loading by returning false
    var abStateLoad = _fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [
        settings,
        s
    ]);
    if (abStateLoad.indexOf(false) !== -1) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Number of columns have changed - all bets are off, no restore of settings
    if (s.columns && columns.length !== s.columns.length) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Store the saved state so it might be accessed at any time
    settings.oLoadedState = $.extend(true, {}, s);
    // This is needed for ColReorder, which has to happen first to allow all
    // the stored indexes to be usable. It is not publicly documented.
    _fnCallbackFire(settings, null, 'stateLoadInit', [
        settings,
        s
    ], true);
    // Page Length
    if (s.length !== undefined) {
        // If already initialised just set the value directly so that the select element is also updated
        if (api) api.page.len(s.length);
        else settings._iDisplayLength = s.length;
    }
    // Restore key features
    if (s.start !== undefined) {
        if (api === null) {
            settings._iDisplayStart = s.start;
            settings.iInitDisplayStart = s.start;
        } else _fnPageChange(settings, s.start / settings._iDisplayLength);
    }
    // Order
    if (s.order !== undefined) {
        settings.aaSorting = [];
        $.each(s.order, function(i, col) {
            settings.aaSorting.push(col[0] >= columns.length ? [
                0,
                col[1]
            ] : col);
        });
    }
    // Search
    if (s.search !== undefined) $.extend(settings.oPreviousSearch, s.search);
    // Columns
    if (s.columns) {
        for(i = 0, ien = s.columns.length; i < ien; i++){
            var col = s.columns[i];
            // Visibility
            if (col.visible !== undefined) {
                // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                api.column(i).visible(col.visible, false);
                else columns[i].bVisible = col.visible;
            }
            // Search
            if (col.search !== undefined) $.extend(settings.aoPreSearchCols[i], col.search);
        }
        // If the api is defined then we need to adjust the columns once the visibility has been changed
        if (api) api.columns.adjust();
    }
    settings._bLoadingState = false;
    _fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [
        settings,
        s
    ]);
    callback();
}
/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */ function _fnLog(settings, level, msg, tn) {
    msg = 'DataTables warning: ' + (settings ? 'table id=' + settings.sTableId + ' - ' : '') + msg;
    if (tn) msg += ". For more information about this error, please see https://datatables.net/tn/" + tn;
    if (!level) {
        // Backwards compatibility pre 1.10
        var ext = DataTable.ext;
        var type = ext.sErrMode || ext.errMode;
        if (settings) _fnCallbackFire(settings, null, 'dt-error', [
            settings,
            tn,
            msg
        ], true);
        if (type == 'alert') alert(msg);
        else if (type == 'throw') throw new Error(msg);
        else if (typeof type == 'function') type(settings, tn, msg);
    } else if (window.console && console.log) console.log(msg);
}
/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */ function _fnMap(ret, src, name, mappedName) {
    if (Array.isArray(name)) {
        $.each(name, function(i, val) {
            if (Array.isArray(val)) _fnMap(ret, src, val[0], val[1]);
            else _fnMap(ret, src, val);
        });
        return;
    }
    if (mappedName === undefined) mappedName = name;
    if (src[name] !== undefined) ret[mappedName] = src[name];
}
/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */ function _fnExtend(out, extender, breakRefs) {
    var val;
    for(var prop in extender)if (Object.prototype.hasOwnProperty.call(extender, prop)) {
        val = extender[prop];
        if ($.isPlainObject(val)) {
            if (!$.isPlainObject(out[prop])) out[prop] = {};
            $.extend(true, out[prop], val);
        } else if (breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val)) out[prop] = val.slice();
        else out[prop] = val;
    }
    return out;
}
/**
 * Bind an event handers to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object|string} selector Selector (for delegated events) or data object
 *   to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */ function _fnBindAction(n, selector, fn) {
    $(n).on('click.DT', selector, function(e) {
        fn(e);
    }).on('keypress.DT', selector, function(e) {
        if (e.which === 13) {
            e.preventDefault();
            fn(e);
        }
    }).on('selectstart.DT', selector, function() {
        // Don't want a double click resulting in text selection
        return false;
    });
}
/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} settings dataTables settings object
 *  @param {string} store Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @memberof DataTable#oApi
 */ function _fnCallbackReg(settings, store, fn) {
    if (fn) settings[store].push(fn);
}
/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @param {boolean} [bubbles] True if the event should bubble
 *  @memberof DataTable#oApi
 */ function _fnCallbackFire(settings, callbackArr, eventName, args, bubbles) {
    var ret = [];
    if (callbackArr) ret = settings[callbackArr].slice().reverse().map(function(val) {
        return val.apply(settings.oInstance, args);
    });
    if (eventName !== null) {
        var e = $.Event(eventName + '.dt');
        var table = $(settings.nTable);
        // Expose the DataTables API on the event object for easy access
        e.dt = settings.api;
        table[bubbles ? 'trigger' : 'triggerHandler'](e, args);
        // If not yet attached to the document, trigger the event
        // on the body directly to sort of simulate the bubble
        if (bubbles && table.parents('body').length === 0) $('body').trigger(e, args);
        ret.push(e.result);
    }
    return ret;
}
function _fnLengthOverflow(settings) {
    var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
    /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
    // Keep the start record on the current page
    start -= start % len;
    if (len === -1 || start < 0) start = 0;
    settings._iDisplayStart = start;
}
function _fnRenderer(settings, type) {
    var renderer = settings.renderer;
    var host = DataTable.ext.renderer[type];
    if ($.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
    // the default.
    return host[renderer[type]] || host._;
    else if (typeof renderer === 'string') // Common renderer - if there is one available for this type use it,
    // otherwise use the default
    return host[renderer] || host._;
    // Use the default
    return host._;
}
/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */ function _fnDataSource(settings) {
    if (settings.oFeatures.bServerSide) return 'ssp';
    else if (settings.ajax) return 'ajax';
    return 'dom';
}
/**
 * Common replacement for language strings
 *
 * @param {*} settings DT settings object
 * @param {*} str String with values to replace
 * @param {*} entries Plural number for _ENTRIES_ - can be undefined
 * @returns String
 */ function _fnMacros(settings, str, entries) {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is
    // used only internally
    var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), max = settings.fnRecordsTotal(), all = len === -1;
    return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, max)).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len))).replace(/_ENTRIES_/g, settings.api.i18n('entries', '', entries)).replace(/_ENTRIES-MAX_/g, settings.api.i18n('entries', '', max)).replace(/_ENTRIES-TOTAL_/g, settings.api.i18n('entries', '', vis));
}
/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */ var __apiStruct = [];
/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */ var __arrayProto = Array.prototype;
/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */ var _toSettings = function(mixed) {
    var idx, jq;
    var settings = DataTable.settings;
    var tables = _pluck(settings, 'nTable');
    if (!mixed) return [];
    else if (mixed.nTable && mixed.oFeatures) // DataTables settings object
    return [
        mixed
    ];
    else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
        // Table node
        idx = tables.indexOf(mixed);
        return idx !== -1 ? [
            settings[idx]
        ] : null;
    } else if (mixed && typeof mixed.settings === 'function') return mixed.settings().toArray();
    else if (typeof mixed === 'string') // jQuery selector
    jq = $(mixed).get();
    else if (mixed instanceof $) // jQuery object (also DataTables instance)
    jq = mixed.get();
    if (jq) return settings.filter(function(v, idx) {
        return jq.includes(tables[idx]);
    });
};
/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new DataTable.Api( 'table.dataTable' );
 */ _Api = function(context, data) {
    if (!(this instanceof _Api)) return new _Api(context, data);
    var i;
    var settings = [];
    var ctxSettings = function(o) {
        var a = _toSettings(o);
        if (a) settings.push.apply(settings, a);
    };
    if (Array.isArray(context)) for(i = 0; i < context.length; i++)ctxSettings(context[i]);
    else ctxSettings(context);
    // Remove duplicates
    this.context = settings.length > 1 ? _unique(settings) : settings;
    // Initial data
    if (data) {
        // Chrome can throw a max stack error if apply is called with
        // too large an array, but apply is faster.
        if (data.length < 10000) this.push.apply(this, data);
        else for(i = 0; i < data.length; i++)this.push(data[i]);
    }
    // selector
    this.selector = {
        rows: null,
        cols: null,
        opts: null
    };
    _Api.extend(this, this, __apiStruct);
};
DataTable.Api = _Api;
// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$.extend(_Api.prototype, {
    any: function() {
        return this.count() !== 0;
    },
    context: [],
    count: function() {
        return this.flatten().length;
    },
    each: function(fn) {
        for(var i = 0, ien = this.length; i < ien; i++)fn.call(this, this[i], i, this);
        return this;
    },
    eq: function(idx) {
        var ctx = this.context;
        return ctx.length > idx ? new _Api(ctx[idx], this[idx]) : null;
    },
    filter: function(fn) {
        var a = __arrayProto.filter.call(this, fn, this);
        return new _Api(this.context, a);
    },
    flatten: function() {
        var a = [];
        return new _Api(this.context, a.concat.apply(a, this.toArray()));
    },
    get: function(idx) {
        return this[idx];
    },
    join: __arrayProto.join,
    includes: function(find) {
        return this.indexOf(find) === -1 ? false : true;
    },
    indexOf: __arrayProto.indexOf,
    iterator: function(flatten, type, fn, alwaysNew) {
        var a = [], ret, i, ien, j, jen, context = this.context, rows, items, item, selector = this.selector;
        // Argument shifting
        if (typeof flatten === 'string') {
            alwaysNew = fn;
            fn = type;
            type = flatten;
            flatten = false;
        }
        for(i = 0, ien = context.length; i < ien; i++){
            var apiInst = new _Api(context[i]);
            if (type === 'table') {
                ret = fn.call(apiInst, context[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'columns' || type === 'rows') {
                // this has same length as context - one entry for each table
                ret = fn.call(apiInst, context[i], this[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'every' || type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
                // columns and rows share the same structure.
                // 'this' is an array of column indexes for each context
                items = this[i];
                if (type === 'column-rows') rows = _selector_row_indexes(context[i], selector.opts);
                for(j = 0, jen = items.length; j < jen; j++){
                    item = items[j];
                    if (type === 'cell') ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                    else ret = fn.call(apiInst, context[i], item, i, j, rows);
                    if (ret !== undefined) a.push(ret);
                }
            }
        }
        if (a.length || alwaysNew) {
            var api = new _Api(context, flatten ? a.concat.apply([], a) : a);
            var apiSelector = api.selector;
            apiSelector.rows = selector.rows;
            apiSelector.cols = selector.cols;
            apiSelector.opts = selector.opts;
            return api;
        }
        return this;
    },
    lastIndexOf: __arrayProto.lastIndexOf,
    length: 0,
    map: function(fn) {
        var a = __arrayProto.map.call(this, fn, this);
        return new _Api(this.context, a);
    },
    pluck: function(prop) {
        var fn = DataTable.util.get(prop);
        return this.map(function(el) {
            return fn(el);
        });
    },
    pop: __arrayProto.pop,
    push: __arrayProto.push,
    reduce: __arrayProto.reduce,
    reduceRight: __arrayProto.reduceRight,
    reverse: __arrayProto.reverse,
    // Object with rows, columns and opts
    selector: null,
    shift: __arrayProto.shift,
    slice: function() {
        return new _Api(this.context, this);
    },
    sort: __arrayProto.sort,
    splice: __arrayProto.splice,
    toArray: function() {
        return __arrayProto.slice.call(this);
    },
    to$: function() {
        return $(this);
    },
    toJQuery: function() {
        return $(this);
    },
    unique: function() {
        return new _Api(this.context, _unique(this.toArray()));
    },
    unshift: __arrayProto.unshift
});
function _api_scope(scope, fn, struc) {
    return function() {
        var ret = fn.apply(scope || this, arguments);
        // Method extension
        _Api.extend(ret, ret, struc.methodExt);
        return ret;
    };
}
function _api_find(src, name) {
    for(var i = 0, ien = src.length; i < ien; i++){
        if (src[i].name === name) return src[i];
    }
    return null;
}
window.__apiStruct = __apiStruct;
_Api.extend = function(scope, obj, ext) {
    // Only extend API instances and static properties of the API
    if (!ext.length || !obj || !(obj instanceof _Api) && !obj.__dt_wrapper) return;
    var i, ien, struct;
    for(i = 0, ien = ext.length; i < ien; i++){
        struct = ext[i];
        if (struct.name === '__proto__') continue;
        // Value
        obj[struct.name] = struct.type === 'function' ? _api_scope(scope, struct.val, struct) : struct.type === 'object' ? {} : struct.val;
        obj[struct.name].__dt_wrapper = true;
        // Property extension
        _Api.extend(scope, obj[struct.name], struct.propExt);
    }
};
//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]
_Api.register = _api_register = function(name, val) {
    if (Array.isArray(name)) {
        for(var j = 0, jen = name.length; j < jen; j++)_Api.register(name[j], val);
        return;
    }
    var i, ien, heir = name.split('.'), struct = __apiStruct, key, method;
    for(i = 0, ien = heir.length; i < ien; i++){
        method = heir[i].indexOf('()') !== -1;
        key = method ? heir[i].replace('()', '') : heir[i];
        var src = _api_find(struct, key);
        if (!src) {
            src = {
                name: key,
                val: {},
                methodExt: [],
                propExt: [],
                type: 'object'
            };
            struct.push(src);
        }
        if (i === ien - 1) {
            src.val = val;
            src.type = typeof val === 'function' ? 'function' : $.isPlainObject(val) ? 'object' : 'other';
        } else struct = method ? src.methodExt : src.propExt;
    }
};
_Api.registerPlural = _api_registerPlural = function(pluralName, singularName, val) {
    _Api.register(pluralName, val);
    _Api.register(singularName, function() {
        var ret = val.apply(this, arguments);
        if (ret === this) // Returned item is the API instance that was passed in, return it
        return this;
        else if (ret instanceof _Api) // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ? Array.isArray(ret[0]) ? new _Api(ret.context, ret[0]) : ret[0] : undefined;
        // Non-API return - just fire it back
        return ret;
    });
};
/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */ var __table_selector = function(selector, a) {
    if (Array.isArray(selector)) {
        var result = [];
        selector.forEach(function(sel) {
            var inner = __table_selector(sel, a);
            result.push.apply(result, inner);
        });
        return result.filter(function(item) {
            return item;
        });
    }
    // Integer is used to pick out a table by index
    if (typeof selector === 'number') return [
        a[selector]
    ];
    // Perform a jQuery selector on the table nodes
    var nodes = a.map(function(el) {
        return el.nTable;
    });
    return $(nodes).filter(selector).map(function() {
        // Need to translate back from the table node to the settings
        var idx = nodes.indexOf(this);
        return a[idx];
    }).toArray();
};
/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */ _api_register('tables()', function(selector) {
    // A new instance is created if there was a selector specified
    return selector !== undefined && selector !== null ? new _Api(__table_selector(selector, this.context)) : this;
});
_api_register('table()', function(selector) {
    var tables = this.tables(selector);
    var ctx = tables.context;
    // Truncate to the first matched table
    return ctx.length ? new _Api(ctx[0]) : tables;
});
// Common methods, combined to reduce size
[
    [
        'nodes',
        'node',
        'nTable'
    ],
    [
        'body',
        'body',
        'nTBody'
    ],
    [
        'header',
        'header',
        'nTHead'
    ],
    [
        'footer',
        'footer',
        'nTFoot'
    ]
].forEach(function(item) {
    _api_registerPlural('tables().' + item[0] + '()', 'table().' + item[1] + '()', function() {
        return this.iterator('table', function(ctx) {
            return ctx[item[2]];
        }, 1);
    });
});
// Structure methods
[
    [
        'header',
        'aoHeader'
    ],
    [
        'footer',
        'aoFooter'
    ]
].forEach(function(item) {
    _api_register('table().' + item[0] + '.structure()', function(selector) {
        var indexes = this.columns(selector).indexes().flatten();
        var ctx = this.context[0];
        return _fnHeaderLayout(ctx, ctx[item[1]], indexes);
    });
});
_api_registerPlural('tables().containers()', 'table().container()', function() {
    return this.iterator('table', function(ctx) {
        return ctx.nTableWrapper;
    }, 1);
});
_api_register('tables().every()', function(fn) {
    var that = this;
    return this.iterator('table', function(s, i) {
        fn.call(that.table(i), i);
    });
});
_api_register('caption()', function(value, side) {
    var context = this.context;
    // Getter - return existing node's content
    if (value === undefined) {
        var caption = context[0].captionNode;
        return caption && context.length ? caption.innerHTML : null;
    }
    return this.iterator('table', function(ctx) {
        var table = $(ctx.nTable);
        var caption = $(ctx.captionNode);
        var container = $(ctx.nTableWrapper);
        // Create the node if it doesn't exist yet
        if (!caption.length) {
            caption = $('<caption/>').html(value);
            ctx.captionNode = caption[0];
            // If side isn't set, we need to insert into the document to let the
            // CSS decide so we can read it back, otherwise there is no way to
            // know if the CSS would put it top or bottom for scrolling
            if (!side) {
                table.prepend(caption);
                side = caption.css('caption-side');
            }
        }
        caption.html(value);
        if (side) {
            caption.css('caption-side', side);
            caption[0]._captionSide = side;
        }
        if (container.find('div.dataTables_scroll').length) {
            var selector = side === 'top' ? 'Head' : 'Foot';
            container.find('div.dataTables_scroll' + selector + ' table').prepend(caption);
        } else table.prepend(caption);
    }, 1);
});
_api_register('caption.node()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].captionNode : null;
});
/**
 * Redraw the tables in the current context.
 */ _api_register('draw()', function(paging) {
    return this.iterator('table', function(settings) {
        if (paging === 'page') _fnDraw(settings);
        else {
            if (typeof paging === 'string') paging = paging === 'full-hold' ? false : true;
            _fnReDraw(settings, paging === false);
        }
    });
});
/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 */ /**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */ _api_register('page()', function(action) {
    if (action === undefined) return this.page.info().page; // not an expensive call
    // else, have an action to take on all tables
    return this.iterator('table', function(settings) {
        _fnPageChange(settings, action);
    });
});
/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */ _api_register('page.info()', function() {
    if (this.context.length === 0) return undefined;
    var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
    return {
        "page": all ? 0 : Math.floor(start / len),
        "pages": all ? 1 : Math.ceil(visRecords / len),
        "start": start,
        "end": settings.fnDisplayEnd(),
        "length": len,
        "recordsTotal": settings.fnRecordsTotal(),
        "recordsDisplay": visRecords,
        "serverSide": _fnDataSource(settings) === 'ssp'
    };
});
/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 */ /**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */ _api_register('page.len()', function(len) {
    // Note that we can't call this function 'length()' because `length`
    // is a Javascript property of functions which defines how many arguments
    // the function expects.
    if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
    // else, set the page length
    return this.iterator('table', function(settings) {
        _fnLengthChange(settings, len);
    });
});
var __reload = function(settings, holdPosition, callback) {
    // Use the draw event to trigger a callback
    if (callback) {
        var api = new _Api(settings);
        api.one('draw', function() {
            callback(api.ajax.json());
        });
    }
    if (_fnDataSource(settings) == 'ssp') _fnReDraw(settings, holdPosition);
    else {
        _fnProcessingDisplay(settings, true);
        // Cancel an existing request
        var xhr = settings.jqXHR;
        if (xhr && xhr.readyState !== 4) xhr.abort();
        // Trigger xhr
        _fnBuildAjax(settings, {}, function(json) {
            _fnClearTable(settings);
            var data = _fnAjaxDataSrc(settings, json);
            for(var i = 0, ien = data.length; i < ien; i++)_fnAddData(settings, data[i]);
            _fnReDraw(settings, holdPosition);
            _fnInitComplete(settings);
            _fnProcessingDisplay(settings, false);
        });
    }
};
/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */ _api_register('ajax.json()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].json;
// else return undefined;
});
/**
 * Get the data submitted in the last Ajax request
 */ _api_register('ajax.params()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].oAjaxData;
// else return undefined;
});
/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */ _api_register('ajax.reload()', function(callback, resetPaging) {
    return this.iterator('table', function(settings) {
        __reload(settings, resetPaging === false, callback);
    });
});
/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 */ /**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */ _api_register('ajax.url()', function(url) {
    var ctx = this.context;
    if (url === undefined) {
        // get
        if (ctx.length === 0) return undefined;
        ctx = ctx[0];
        return $.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax;
    }
    // set
    return this.iterator('table', function(settings) {
        if ($.isPlainObject(settings.ajax)) settings.ajax.url = url;
        else settings.ajax = url;
    });
});
/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */ _api_register('ajax.url().load()', function(callback, resetPaging) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator('table', function(ctx) {
        __reload(ctx, resetPaging === false, callback);
    });
});
var _selector_run = function(type, selector, selectFn, settings, opts) {
    var out = [], res, a, i, ien, j, jen, selectorType = typeof selector;
    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) selector = [
        selector
    ];
    for(i = 0, ien = selector.length; i < ien; i++){
        // Only split on simple strings - complex expressions will be jQuery selectors
        a = selector[i] && selector[i].split && !selector[i].match(/[[(:]/) ? selector[i].split(',') : [
            selector[i]
        ];
        for(j = 0, jen = a.length; j < jen; j++){
            res = selectFn(typeof a[j] === 'string' ? a[j].trim() : a[j]);
            // Remove empty items
            res = res.filter(function(item) {
                return item !== null && item !== undefined;
            });
            if (res && res.length) out = out.concat(res);
        }
    }
    // selector extensions
    var ext = _ext.selector[type];
    if (ext.length) for(i = 0, ien = ext.length; i < ien; i++)out = ext[i](settings, opts, out);
    return _unique(out);
};
var _selector_opts = function(opts) {
    if (!opts) opts = {};
    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if (opts.filter && opts.search === undefined) opts.search = opts.filter;
    return $.extend({
        search: 'none',
        order: 'current',
        page: 'all'
    }, opts);
};
// Reduce the API instance to the first item found
var _selector_first = function(old) {
    var inst = new _Api(old.context[0]);
    // Use a push rather than passing to the constructor, since it will
    // merge arrays down automatically, which isn't what is wanted here
    if (old.length) inst.push(old[0]);
    inst.selector = old.selector;
    // Limit to a single row / column / cell
    if (inst.length && inst[0].length > 1) inst[0].splice(1);
    return inst;
};
var _selector_row_indexes = function(settings, opts) {
    var i, ien, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
    var search = opts.search, order = opts.order, page = opts.page; // all, current
    if (_fnDataSource(settings) == 'ssp') // In server-side processing mode, most options are irrelevant since
    // rows not shown don't exist and the index order is the applied order
    // Removed is a special case - for consistency just return an empty
    // array
    return search === 'removed' ? [] : _range(0, displayMaster.length);
    if (page == 'current') // Current page implies that order=current and filter=applied, since it is
    // fairly senseless otherwise, regardless of what order and search actually
    // are
    for(i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++)a.push(displayFiltered[i]);
    else if (order == 'current' || order == 'applied') {
        if (search == 'none') a = displayMaster.slice();
        else if (search == 'applied') a = displayFiltered.slice();
        else if (search == 'removed') {
            // O(n+m) solution by creating a hash map
            var displayFilteredMap = {};
            for(i = 0, ien = displayFiltered.length; i < ien; i++)displayFilteredMap[displayFiltered[i]] = null;
            displayMaster.forEach(function(item) {
                if (!Object.prototype.hasOwnProperty.call(displayFilteredMap, item)) a.push(item);
            });
        }
    } else if (order == 'index' || order == 'original') for(i = 0, ien = settings.aoData.length; i < ien; i++){
        if (!settings.aoData[i]) continue;
        if (search == 'none') a.push(i);
        else {
            tmp = displayFiltered.indexOf(i);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(i);
        }
    }
    else if (typeof order === 'number') {
        // Order the rows by the given column
        var ordered = _fnSort(settings, order, 'asc');
        if (search === 'none') a = ordered;
        else for(i = 0; i < ordered.length; i++){
            tmp = displayFiltered.indexOf(ordered[i]);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(ordered[i]);
        }
    }
    return a;
};
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */ var __row_selector = function(settings, selector, opts) {
    var rows;
    var run = function(sel) {
        var selInt = _intVal(sel);
        var aoData = settings.aoData;
        // Short cut - selector is a number and no options provided (default is
        // all records, so no need to check if the index is in there, since it
        // must be - dev error if the index doesn't exist).
        if (selInt !== null && !opts) return [
            selInt
        ];
        if (!rows) rows = _selector_row_indexes(settings, opts);
        if (selInt !== null && rows.indexOf(selInt) !== -1) // Selector - integer
        return [
            selInt
        ];
        else if (sel === null || sel === undefined || sel === '') // Selector - none
        return rows;
        // Selector - function
        if (typeof sel === 'function') return rows.map(function(idx) {
            var row = aoData[idx];
            return sel(idx, row._aData, row.nTr) ? idx : null;
        });
        // Selector - node
        if (sel.nodeName) {
            var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
            var cellIdx = sel._DT_CellIndex;
            if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
            return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                rowIdx
            ] : [];
            else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                cellIdx.row
            ] : [];
            else {
                var host = $(sel).closest('*[data-dt-row]');
                return host.length ? [
                    host.data('dt-row')
                ] : [];
            }
        }
        // ID selector. Want to always be able to select rows by id, regardless
        // of if the tr element has been created or not, so can't rely upon
        // jQuery here - hence a custom implementation. This does not match
        // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
        // but to select it using a CSS selector engine (like Sizzle or
        // querySelect) it would need to need to be escaped for some characters.
        // DataTables simplifies this for row selectors since you can select
        // only a row. A # indicates an id any anything that follows is the id -
        // unescaped.
        if (typeof sel === 'string' && sel.charAt(0) === '#') {
            // get row index from id
            var rowObj = settings.aIds[sel.replace(/^#/, '')];
            if (rowObj !== undefined) return [
                rowObj.idx
            ];
        // need to fall through to jQuery in case there is DOM id that
        // matches
        }
        // Get nodes in the order from the `rows` array with null values removed
        var nodes = _removeEmpty(_pluck_order(settings.aoData, rows, 'nTr'));
        // Selector - jQuery selector string, array of nodes or jQuery object/
        // As jQuery's .filter() allows jQuery objects to be passed in filter,
        // it also allows arrays, so this will cope with all three options
        return $(nodes).filter(sel).map(function() {
            return this._DT_RowIndex;
        }).toArray();
    };
    var matched = _selector_run('row', selector, run, settings, opts);
    if (opts.order === 'current' || opts.order === 'applied') _fnSortDisplay(settings, matched);
    return matched;
};
_api_register('rows()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = _selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return __row_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;
    return inst;
});
_api_register('rows().nodes()', function() {
    return this.iterator('row', function(settings, row) {
        return settings.aoData[row].nTr || undefined;
    }, 1);
});
_api_register('rows().data()', function() {
    return this.iterator(true, 'rows', function(settings, rows) {
        return _pluck_order(settings.aoData, rows, '_aData');
    }, 1);
});
_api_registerPlural('rows().cache()', 'row().cache()', function(type) {
    return this.iterator('row', function(settings, row) {
        var r = settings.aoData[row];
        return type === 'search' ? r._aFilterData : r._aSortData;
    }, 1);
});
_api_registerPlural('rows().invalidate()', 'row().invalidate()', function(src) {
    return this.iterator('row', function(settings, row) {
        _fnInvalidate(settings, row, src);
    });
});
_api_registerPlural('rows().indexes()', 'row().index()', function() {
    return this.iterator('row', function(settings, row) {
        return row;
    }, 1);
});
_api_registerPlural('rows().ids()', 'row().id()', function(hash) {
    var a = [];
    var context = this.context;
    // `iterator` will drop undefined values, but in this case we want them
    for(var i = 0, ien = context.length; i < ien; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
        var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
        a.push((hash === true ? '#' : '') + id);
    }
    return new _Api(context, a);
});
_api_registerPlural('rows().remove()', 'row().remove()', function() {
    this.iterator('row', function(settings, row) {
        var data = settings.aoData;
        var rowData = data[row];
        // Delete from the display arrays
        var idx = settings.aiDisplayMaster.indexOf(row);
        if (idx !== -1) settings.aiDisplayMaster.splice(idx, 1);
        // For server-side processing tables - subtract the deleted row from the count
        if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
        // Check for an 'overflow' they case for displaying the table
        _fnLengthOverflow(settings);
        // Remove the row's ID reference if there is one
        var id = settings.rowIdFn(rowData._aData);
        if (id !== undefined) delete settings.aIds[id];
        data[row] = null;
    });
    return this;
});
_api_register('rows.add()', function(rows) {
    var newRows = this.iterator('table', function(settings) {
        var row, i, ien;
        var out = [];
        for(i = 0, ien = rows.length; i < ien; i++){
            row = rows[i];
            if (row.nodeName && row.nodeName.toUpperCase() === 'TR') out.push(_fnAddTr(settings, row)[0]);
            else out.push(_fnAddData(settings, row));
        }
        return out;
    }, 1);
    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows(-1);
    modRows.pop();
    modRows.push.apply(modRows, newRows);
    return modRows;
});
/**
 *
 */ _api_register('row()', function(selector, opts) {
    return _selector_first(this.rows(selector, opts));
});
_api_register('row().data()', function(data) {
    var ctx = this.context;
    if (data === undefined) // Get
    return ctx.length && this.length && this[0].length ? ctx[0].aoData[this[0]]._aData : undefined;
    // Set
    var row = ctx[0].aoData[this[0]];
    row._aData = data;
    // If the DOM has an id, and the data source is an array
    if (Array.isArray(data) && row.nTr && row.nTr.id) _fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
    // Automatically invalidate
    _fnInvalidate(ctx[0], this[0], 'data');
    return this;
});
_api_register('row().node()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && this[0].length) {
        var row = ctx[0].aoData[this[0]];
        if (row && row.nTr) return row.nTr;
    }
    return null;
});
_api_register('row.add()', function(row) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if (row instanceof $ && row.length) row = row[0];
    var rows = this.iterator('table', function(settings) {
        if (row.nodeName && row.nodeName.toUpperCase() === 'TR') return _fnAddTr(settings, row)[0];
        return _fnAddData(settings, row);
    });
    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row(rows[0]);
});
$(document).on('plugin-init.dt', function(e, context) {
    var api = new _Api(context);
    api.on('stateSaveParams.DT', function(e, settings, d) {
        // This could be more compact with the API, but it is a lot faster as a simple
        // internal loop
        var idFn = settings.rowIdFn;
        var rows = settings.aiDisplayMaster;
        var ids = [];
        for(var i = 0; i < rows.length; i++){
            var rowIdx = rows[i];
            var data = settings.aoData[rowIdx];
            if (data._detailsShow) ids.push('#' + idFn(data._aData));
        }
        d.childRows = ids;
    });
    // For future state loads (e.g. with StateRestore)
    api.on('stateLoaded.DT', function(e, settings, state) {
        __details_state_load(api, state);
    });
    // And the initial load state
    __details_state_load(api, api.state.loaded());
});
var __details_state_load = function(api, state) {
    if (state && state.childRows) api.rows(state.childRows.map(function(id) {
        // Escape any `:` characters from the row id. Accounts for
        // already escaped characters.
        return id.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
    })).every(function() {
        _fnCallbackFire(api.settings()[0], null, 'requestChild', [
            this
        ]);
    });
};
var __details_add = function(ctx, row, data, klass) {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function(r, k) {
        // Recursion to allow for arrays of jQuery objects
        if (Array.isArray(r) || r instanceof $) {
            for(var i = 0, ien = r.length; i < ien; i++)addRow(r[i], k);
            return;
        }
        // If we get a TR element, then just add it directly - up to the dev
        // to add the correct number of columns etc
        if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
            r.setAttribute('data-dt-row', row.idx);
            rows.push(r);
        } else {
            // Otherwise create a row with a wrapper
            var created = $('<tr><td></td></tr>').attr('data-dt-row', row.idx).addClass(k);
            $('td', created).addClass(k).html(r)[0].colSpan = _fnVisbleColumns(ctx);
            rows.push(created[0]);
        }
    };
    addRow(data, klass);
    if (row._details) row._details.detach();
    row._details = $(rows);
    // If the children were already shown, that state should be retained
    if (row._detailsShow) row._details.insertAfter(row.nTr);
};
// Make state saving of child row details async to allow them to be batch processed
var __details_state = DataTable.util.throttle(function(ctx) {
    _fnSaveState(ctx[0]);
}, 500);
var __details_remove = function(api, idx) {
    var ctx = api.context;
    if (ctx.length) {
        var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
        if (row && row._details) {
            row._details.remove();
            row._detailsShow = undefined;
            row._details = undefined;
            $(row.nTr).removeClass('dt-hasChild');
            __details_state(ctx);
        }
    }
};
var __details_display = function(api, show) {
    var ctx = api.context;
    if (ctx.length && api.length) {
        var row = ctx[0].aoData[api[0]];
        if (row._details) {
            row._detailsShow = show;
            if (show) {
                row._details.insertAfter(row.nTr);
                $(row.nTr).addClass('dt-hasChild');
            } else {
                row._details.detach();
                $(row.nTr).removeClass('dt-hasChild');
            }
            _fnCallbackFire(ctx[0], null, 'childRow', [
                show,
                api.row(api[0])
            ]);
            __details_events(ctx[0]);
            __details_state(ctx);
        }
    }
};
var __details_events = function(settings) {
    var api = new _Api(settings);
    var namespace = '.dt.DT_details';
    var drawEvent = 'draw' + namespace;
    var colvisEvent = 'column-sizing' + namespace;
    var destroyEvent = 'destroy' + namespace;
    var data = settings.aoData;
    api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);
    if (_pluck(data, '_details').length > 0) {
        // On each draw, insert the required elements into the document
        api.on(drawEvent, function(e, ctx) {
            if (settings !== ctx) return;
            api.rows({
                page: 'current'
            }).eq(0).each(function(idx) {
                // Internal data grab
                var row = data[idx];
                if (row._detailsShow) row._details.insertAfter(row.nTr);
            });
        });
        // Column visibility change - update the colspan
        api.on(colvisEvent, function(e, ctx) {
            if (settings !== ctx) return;
            // Update the colspan for the details rows (note, only if it already has
            // a colspan)
            var row, visible = _fnVisbleColumns(ctx);
            for(var i = 0, ien = data.length; i < ien; i++){
                row = data[i];
                if (row && row._details) row._details.each(function() {
                    var el = $(this).children('td');
                    if (el.length == 1) el.attr('colspan', visible);
                });
            }
        });
        // Table destroyed - nuke any child rows
        api.on(destroyEvent, function(e, ctx) {
            if (settings !== ctx) return;
            for(var i = 0, ien = data.length; i < ien; i++)if (data[i] && data[i]._details) __details_remove(api, i);
        });
    }
};
// Strings for the method names to help minification
var _emp = '';
var _child_obj = _emp + 'row().child';
var _child_mth = _child_obj + '()';
// data can be:
//  tr
//  string
//  jQuery or array of any of the above
_api_register(_child_mth, function(data, klass) {
    var ctx = this.context;
    if (data === undefined) // get
    return ctx.length && this.length && ctx[0].aoData[this[0]] ? ctx[0].aoData[this[0]]._details : undefined;
    else if (data === true) // show
    this.child.show();
    else if (data === false) // remove
    __details_remove(this);
    else if (ctx.length && this.length) // set
    __details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
    return this;
});
_api_register([
    _child_obj + '.show()',
    _child_mth + '.show()' // only when `child()` was called with parameters (without
], function() {
    __details_display(this, true);
    return this;
});
_api_register([
    _child_obj + '.hide()',
    _child_mth + '.hide()' // only when `child()` was called with parameters (without
], function() {
    __details_display(this, false);
    return this;
});
_api_register([
    _child_obj + '.remove()',
    _child_mth + '.remove()' // only when `child()` was called with parameters (without
], function() {
    __details_remove(this);
    return this;
});
_api_register(_child_obj + '.isShown()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && ctx[0].aoData[this[0]]) // _detailsShown as false or undefined will fall through to return false
    return ctx[0].aoData[this[0]]._detailsShow || false;
    return false;
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */ // can be an array of these items, comma separated list, or an array of comma
// separated lists
var __re_column_selector = /^([^:]+)?:(name|title|visIdx|visible)$/;
// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var __columnData = function(settings, column, r1, r2, rows, type) {
    var a = [];
    for(var row = 0, ien = rows.length; row < ien; row++)a.push(_fnGetCellData(settings, rows[row], column, type));
    return a;
};
var __column_header = function(settings, column, row) {
    var header = settings.aoHeader;
    var target = row !== undefined ? row : settings.bSortCellsTop // legacy support
     ? 0 : header.length - 1;
    return header[target][column].cell;
};
var __column_selector = function(settings, selector, opts) {
    var columns = settings.aoColumns, names = _pluck(columns, 'sName'), titles = _pluck(columns, 'sTitle'), cells = DataTable.util.get('[].[].cell')(settings.aoHeader), nodes = _unique(_flatten([], cells));
    var run = function(s) {
        var selInt = _intVal(s);
        // Selector - all
        if (s === '') return _range(columns.length);
        // Selector - index
        if (selInt !== null) return [
            selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
        ];
        // Selector = function
        if (typeof s === 'function') {
            var rows = _selector_row_indexes(settings, opts);
            return columns.map(function(col, idx) {
                return s(idx, __columnData(settings, idx, 0, 0, rows), __column_header(settings, idx)) ? idx : null;
            });
        }
        // jQuery or string selector
        var match = typeof s === 'string' ? s.match(__re_column_selector) : '';
        if (match) switch(match[2]){
            case 'visIdx':
            case 'visible':
                // Selector is a column index
                if (match[1] && match[1].match(/^\d+$/)) {
                    var idx = parseInt(match[1], 10);
                    // Visible index given, convert to column index
                    if (idx < 0) {
                        // Counting from the right
                        var visColumns = columns.map(function(col, i) {
                            return col.bVisible ? i : null;
                        });
                        return [
                            visColumns[visColumns.length + idx]
                        ];
                    }
                    // Counting from the left
                    return [
                        _fnVisibleToColumnIndex(settings, idx)
                    ];
                }
                return columns.map(function(col, idx) {
                    // Not visible, can't match
                    if (!col.bVisible) return null;
                    // Selector
                    if (match[1]) return $(nodes[idx]).filter(match[1]).length > 0 ? idx : null;
                    // `:visible` on its own
                    return idx;
                });
            case 'name':
                // match by name. `names` is column index complete and in order
                return names.map(function(name, i) {
                    return name === match[1] ? i : null;
                });
            case 'title':
                // match by column title
                return titles.map(function(title, i) {
                    return title === match[1] ? i : null;
                });
            default:
                return [];
        }
        // Cell in the table body
        if (s.nodeName && s._DT_CellIndex) return [
            s._DT_CellIndex.column
        ];
        // jQuery selector on the TH elements for the columns
        var jqResult = $(nodes).filter(s).map(function() {
            return _fnColumnsFromHeader(this); // `nodes` is column index complete and in order
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise a node which might have a `dt-column` data attribute, or be
        // a child or such an element
        var host = $(s).closest('*[data-dt-column]');
        return host.length ? [
            host.data('dt-column')
        ] : [];
    };
    return _selector_run('column', selector, run, settings, opts);
};
var __setColumnVis = function(settings, column, vis) {
    var cols = settings.aoColumns, col = cols[column], data = settings.aoData, cells, i, ien, tr;
    // Get
    if (vis === undefined) return col.bVisible;
    // Set
    // No change
    if (col.bVisible === vis) return false;
    if (vis) {
        // Insert column
        // Need to decide if we should use appendChild or insertBefore
        var insertBefore = _pluck(cols, 'bVisible').indexOf(true, column + 1);
        for(i = 0, ien = data.length; i < ien; i++)if (data[i]) {
            tr = data[i].nTr;
            cells = data[i].anCells;
            if (tr) // insertBefore can act like appendChild if 2nd arg is null
            tr.insertBefore(cells[column], cells[insertBefore] || null);
        }
    } else // Remove column
    $(_pluck(settings.aoData, 'anCells', column)).detach();
    // Common actions
    col.bVisible = vis;
    _colGroup(settings);
    return true;
};
_api_register('columns()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = _selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return __column_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;
    return inst;
});
_api_registerPlural('columns().header()', 'column().header()', function(row) {
    return this.iterator('column', function(settings, column) {
        return __column_header(settings, column, row);
    }, 1);
});
_api_registerPlural('columns().footer()', 'column().footer()', function(row) {
    return this.iterator('column', function(settings, column) {
        var footer = settings.aoFooter;
        if (!footer.length) return null;
        return settings.aoFooter[row !== undefined ? row : 0][column].cell;
    }, 1);
});
_api_registerPlural('columns().data()', 'column().data()', function() {
    return this.iterator('column-rows', __columnData, 1);
});
_api_registerPlural('columns().render()', 'column().render()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return __columnData(settings, column, i, j, rows, type);
    }, 1);
});
_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].mData;
    }, 1);
});
_api_registerPlural('columns().cache()', 'column().cache()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return _pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
    }, 1);
});
_api_registerPlural('columns().init()', 'column().init()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column];
    }, 1);
});
_api_registerPlural('columns().nodes()', 'column().nodes()', function() {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return _pluck_order(settings.aoData, rows, 'anCells', column);
    }, 1);
});
_api_registerPlural('columns().titles()', 'column().title()', function(title, row) {
    return this.iterator('column', function(settings, column) {
        // Argument shifting
        if (typeof title === 'number') {
            row = title;
            title = undefined;
        }
        var span = $('span.dt-column-title', this.column(column).header(row));
        if (title !== undefined) {
            span.html(title);
            return this;
        }
        return span.html();
    }, 1);
});
_api_registerPlural('columns().types()', 'column().type()', function() {
    return this.iterator('column', function(settings, column) {
        var type = settings.aoColumns[column].sType;
        // If the type was invalidated, then resolve it. This actually does
        // all columns at the moment. Would only happen once if getting all
        // column's data types.
        if (!type) _fnColumnTypes(settings);
        return type;
    }, 1);
});
_api_registerPlural('columns().visible()', 'column().visible()', function(vis, calc) {
    var that = this;
    var changed = [];
    var ret = this.iterator('column', function(settings, column) {
        if (vis === undefined) return settings.aoColumns[column].bVisible;
         // else
        if (__setColumnVis(settings, column, vis)) changed.push(column);
    });
    // Group the column visibility changes
    if (vis !== undefined) this.iterator('table', function(settings) {
        // Redraw the header after changes
        _fnDrawHead(settings, settings.aoHeader);
        _fnDrawHead(settings, settings.aoFooter);
        // Update colspan for no records display. Child rows and extensions will use their own
        // listeners to do this - only need to update the empty table item here
        if (!settings.aiDisplay.length) $(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
        _fnSaveState(settings);
        // Second loop once the first is done for events
        that.iterator('column', function(settings, column) {
            if (changed.includes(column)) _fnCallbackFire(settings, null, 'column-visibility', [
                settings,
                column,
                vis,
                calc
            ]);
        });
        if (changed.length && (calc === undefined || calc)) that.columns.adjust();
    });
    return ret;
});
_api_registerPlural('columns().widths()', 'column().width()', function() {
    // Injects a fake row into the table for just a moment so the widths can
    // be read, regardless of colspan in the header and rows being present in
    // the body
    var columns = this.columns(':visible').count();
    var row = $('<tr>').html('<td>' + Array(columns).join('</td><td>') + '</td>');
    $(this.table().body()).append(row);
    var widths = row.children().map(function() {
        return $(this).outerWidth();
    });
    row.remove();
    return this.iterator('column', function(settings, column) {
        var visIdx = _fnColumnIndexToVisible(settings, column);
        return visIdx !== null ? widths[visIdx] : 0;
    }, 1);
});
_api_registerPlural('columns().indexes()', 'column().index()', function(type) {
    return this.iterator('column', function(settings, column) {
        return type === 'visible' ? _fnColumnIndexToVisible(settings, column) : column;
    }, 1);
});
_api_register('columns.adjust()', function() {
    return this.iterator('table', function(settings) {
        _fnAdjustColumnSizing(settings);
    }, 1);
});
_api_register('column.index()', function(type, idx) {
    if (this.context.length !== 0) {
        var ctx = this.context[0];
        if (type === 'fromVisible' || type === 'toData') return _fnVisibleToColumnIndex(ctx, idx);
        else if (type === 'fromData' || type === 'toVisible') return _fnColumnIndexToVisible(ctx, idx);
    }
});
_api_register('column()', function(selector, opts) {
    return _selector_first(this.columns(selector, opts));
});
var __cell_selector = function(settings, selector, opts) {
    var data = settings.aoData;
    var rows = _selector_row_indexes(settings, opts);
    var cells = _removeEmpty(_pluck_order(data, rows, 'anCells'));
    var allCells = $(_flatten([], cells));
    var row;
    var columns = settings.aoColumns.length;
    var a, i, ien, j, o, host;
    var run = function(s) {
        var fnSelector = typeof s === 'function';
        if (s === null || s === undefined || fnSelector) {
            // All cells and function selectors
            a = [];
            for(i = 0, ien = rows.length; i < ien; i++){
                row = rows[i];
                for(j = 0; j < columns; j++){
                    o = {
                        row: row,
                        column: j
                    };
                    if (fnSelector) {
                        // Selector - function
                        host = data[row];
                        if (s(o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                    } else // Selector - all
                    a.push(o);
                }
            }
            return a;
        }
        // Selector - index
        if ($.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
        return s.column !== undefined && s.row !== undefined && rows.indexOf(s.row) !== -1 ? [
            s
        ] : [];
        // Selector - jQuery filtered cells
        var jqResult = allCells.filter(s).map(function(i, el) {
            return {
                row: el._DT_CellIndex.row,
                column: el._DT_CellIndex.column
            };
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise the selector is a node, and there is one last option - the
        // element might be a child of an element which has dt-row and dt-column
        // data attributes
        host = $(s).closest('*[data-dt-row]');
        return host.length ? [
            {
                row: host.data('dt-row'),
                column: host.data('dt-column')
            }
        ] : [];
    };
    return _selector_run('cell', selector, run, settings, opts);
};
_api_register('cells()', function(rowSelector, columnSelector, opts) {
    // Argument shifting
    if ($.isPlainObject(rowSelector)) {
        // Indexes
        if (rowSelector.row === undefined) {
            // Selector options in first parameter
            opts = rowSelector;
            rowSelector = null;
        } else {
            // Cell index objects in first parameter
            opts = columnSelector;
            columnSelector = null;
        }
    }
    if ($.isPlainObject(columnSelector)) {
        opts = columnSelector;
        columnSelector = null;
    }
    // Cell selector
    if (columnSelector === null || columnSelector === undefined) return this.iterator('table', function(settings) {
        return __cell_selector(settings, rowSelector, _selector_opts(opts));
    });
    // The default built in options need to apply to row and columns
    var internalOpts = opts ? {
        page: opts.page,
        order: opts.order,
        search: opts.search
    } : {};
    // Row + column selector
    var columns = this.columns(columnSelector, internalOpts);
    var rows = this.rows(rowSelector, internalOpts);
    var i, ien, j, jen;
    var cellsNoOpts = this.iterator('table', function(settings, idx) {
        var a = [];
        for(i = 0, ien = rows[idx].length; i < ien; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
            row: rows[idx][i],
            column: columns[idx][j]
        });
        return a;
    }, 1);
    // There is currently only one extension which uses a cell selector extension
    // It is a _major_ performance drag to run this if it isn't needed, so this is
    // an extension specific check at the moment
    var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
    $.extend(cells.selector, {
        cols: columnSelector,
        rows: rowSelector,
        opts: opts
    });
    return cells;
});
_api_registerPlural('cells().nodes()', 'cell().node()', function() {
    return this.iterator('cell', function(settings, row, column) {
        var data = settings.aoData[row];
        return data && data.anCells ? data.anCells[column] : undefined;
    }, 1);
});
_api_register('cells().data()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return _fnGetCellData(settings, row, column);
    }, 1);
});
_api_registerPlural('cells().cache()', 'cell().cache()', function(type) {
    type = type === 'search' ? '_aFilterData' : '_aSortData';
    return this.iterator('cell', function(settings, row, column) {
        return settings.aoData[row][type][column];
    }, 1);
});
_api_registerPlural('cells().render()', 'cell().render()', function(type) {
    return this.iterator('cell', function(settings, row, column) {
        return _fnGetCellData(settings, row, column, type);
    }, 1);
});
_api_registerPlural('cells().indexes()', 'cell().index()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return {
            row: row,
            column: column,
            columnVisible: _fnColumnIndexToVisible(settings, column)
        };
    }, 1);
});
_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function(src) {
    return this.iterator('cell', function(settings, row, column) {
        _fnInvalidate(settings, row, src, column);
    });
});
_api_register('cell()', function(rowSelector, columnSelector, opts) {
    return _selector_first(this.cells(rowSelector, columnSelector, opts));
});
_api_register('cell().data()', function(data) {
    var ctx = this.context;
    var cell = this[0];
    if (data === undefined) // Get
    return ctx.length && cell.length ? _fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
    // Set
    _fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
    _fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);
    return this;
});
/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 */ /**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */ _api_register('order()', function(order, dir) {
    var ctx = this.context;
    var args = Array.prototype.slice.call(arguments);
    if (order === undefined) // get
    return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
    // set
    if (typeof order === 'number') // Simple column / direction passed in
    order = [
        [
            order,
            dir
        ]
    ];
    else if (args.length > 1) // Arguments passed in (list of 1D arrays)
    order = args;
    // otherwise a 2D array was passed in
    return this.iterator('table', function(settings) {
        settings.aaSorting = Array.isArray(order) ? order.slice() : order;
    });
});
/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */ _api_register('order.listener()', function(node, column, callback) {
    return this.iterator('table', function(settings) {
        _fnSortAttachListener(settings, node, {}, column, callback);
    });
});
_api_register('order.fixed()', function(set) {
    if (!set) {
        var ctx = this.context;
        var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
        return Array.isArray(fixed) ? {
            pre: fixed
        } : fixed;
    }
    return this.iterator('table', function(settings) {
        settings.aaSortingFixed = $.extend(true, {}, set);
    });
});
// Order by the selected column(s)
_api_register([
    'columns().order()',
    'column().order()'
], function(dir) {
    var that = this;
    if (!dir) return this.iterator('column', function(settings, idx) {
        var sort = _fnSortFlatten(settings);
        for(var i = 0, ien = sort.length; i < ien; i++){
            if (sort[i].col === idx) return sort[i].dir;
        }
        return null;
    }, 1);
    else return this.iterator('table', function(settings, i) {
        settings.aaSorting = that[i].map(function(col) {
            return [
                col,
                dir
            ];
        });
    });
});
_api_registerPlural('columns().orderable()', 'column().orderable()', function(directions) {
    return this.iterator('column', function(settings, idx) {
        var col = settings.aoColumns[idx];
        return directions ? col.asSorting : col.bSortable;
    }, 1);
});
_api_register('processing()', function(show) {
    return this.iterator('table', function(ctx) {
        _fnProcessingDisplay(ctx, show);
    });
});
_api_register('search()', function(input, regex, smart, caseInsen) {
    var ctx = this.context;
    if (input === undefined) // get
    return ctx.length !== 0 ? ctx[0].oPreviousSearch.search : undefined;
    // set
    return this.iterator('table', function(settings) {
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        _fnFilterComplete(settings, $.extend(settings.oPreviousSearch, regex, {
            search: input
        }));
        else // Compat for the old options
        _fnFilterComplete(settings, $.extend(settings.oPreviousSearch, {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        }));
    });
});
_api_register('search.fixed()', function(name, search) {
    var ret = this.iterator(true, 'table', function(settings) {
        var fixed = settings.searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
_api_registerPlural('columns().search()', 'column().search()', function(input, regex, smart, caseInsen) {
    return this.iterator('column', function(settings, column) {
        var preSearch = settings.aoPreSearchCols;
        if (input === undefined) // get
        return preSearch[column].search;
        // set
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $.extend(preSearch[column], regex, {
            search: input
        });
        else // Old style (with not all options available)
        $.extend(preSearch[column], {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        });
        _fnFilterComplete(settings, settings.oPreviousSearch);
    });
});
_api_register([
    'columns().search.fixed()',
    'column().search.fixed()'
], function(name, search) {
    var ret = this.iterator(true, 'column', function(settings, colIdx) {
        var fixed = settings.aoColumns[colIdx].searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
/*
 * State API methods
 */ _api_register('state()', function(set, ignoreTime) {
    // getter
    if (!set) return this.context.length ? this.context[0].oSavedState : null;
    var setMutate = $.extend(true, {}, set);
    // setter
    return this.iterator('table', function(settings) {
        if (ignoreTime !== false) setMutate.time = +new Date() + 100;
        _fnImplementState(settings, setMutate, function() {});
    });
});
_api_register('state.clear()', function() {
    return this.iterator('table', function(settings) {
        // Save an empty object
        settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
    });
});
_api_register('state.loaded()', function() {
    return this.context.length ? this.context[0].oLoadedState : null;
});
_api_register('state.save()', function() {
    return this.iterator('table', function(settings) {
        _fnSaveState(settings);
    });
});
/**
 * Set the libraries that DataTables uses, or the global objects.
 * Note that the arguments can be either way around (legacy support)
 * and the second is optional. See docs.
 */ DataTable.use = function(arg1, arg2) {
    // Reverse arguments for legacy support
    var module = typeof arg1 === 'string' ? arg2 : arg1;
    var type = typeof arg2 === 'string' ? arg2 : arg1;
    // Getter
    if (module === undefined && typeof type === 'string') switch(type){
        case 'lib':
        case 'jq':
            return $;
        case 'win':
            return window;
        case 'datetime':
            return DataTable.DateTime;
        case 'luxon':
            return __luxon;
        case 'moment':
            return __moment;
        default:
            return null;
    }
    // Setter
    if (type === 'lib' || type === 'jq' || module && module.fn && module.fn.jquery) $ = module;
    else if (type == 'win' || module && module.document) {
        window = module;
        document = module.document;
    } else if (type === 'datetime' || module && module.type === 'DateTime') DataTable.DateTime = module;
    else if (type === 'luxon' || module && module.FixedOffsetZone) __luxon = module;
    else if (type === 'moment' || module && module.isMoment) __moment = module;
};
/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */ DataTable.factory = function(root, jq) {
    var is = false;
    // Test if the first parameter is a window object
    if (root && root.document) {
        window = root;
        document = root.document;
    }
    // Test if the second parameter is a jQuery object
    if (jq && jq.fn && jq.fn.jquery) {
        $ = jq;
        is = true;
    }
    return is;
};
/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @param {string} [version2=current DataTables version] As above, but optional.
 *   If not given the current DataTables version will be used.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */ DataTable.versionCheck = function(version, version2) {
    var aThis = version2 ? version2.split('.') : DataTable.version.split('.');
    var aThat = version.split('.');
    var iThis, iThat;
    for(var i = 0, iLen = aThat.length; i < iLen; i++){
        iThis = parseInt(aThis[i], 10) || 0;
        iThat = parseInt(aThat[i], 10) || 0;
        // Parts are the same, keep comparing
        if (iThis === iThat) continue;
        // Parts are different, return immediately
        return iThis > iThat;
    }
    return true;
};
/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */ DataTable.isDataTable = function(table) {
    var t = $(table).get(0);
    var is = false;
    if (table instanceof DataTable.Api) return true;
    $.each(DataTable.settings, function(i, o) {
        var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
        var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
        if (o.nTable === t || head === t || foot === t) is = true;
    });
    return is;
};
/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */ DataTable.tables = function(visible) {
    var api = false;
    if ($.isPlainObject(visible)) {
        api = visible.api;
        visible = visible.visible;
    }
    var a = DataTable.settings.filter(function(o) {
        return !visible || visible && $(o.nTable).is(':visible') ? true : false;
    }).map(function(o) {
        return o.nTable;
    });
    return api ? new _Api(a) : a;
};
/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */ DataTable.camelToHungarian = _fnCamelToHungarian;
/**
 *
 */ _api_register('$()', function(selector, opts) {
    var rows = this.rows(opts).nodes(), jqRows = $(rows);
    return $([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
});
// jQuery functions to operate on the tables
$.each([
    'on',
    'one',
    'off'
], function(i, key) {
    _api_register(key + '()', function() {
        var args = Array.prototype.slice.call(arguments);
        // Add the `dt` namespace automatically if it isn't already present
        args[0] = args[0].split(/\s/).map(function(e) {
            return !e.match(/\.dt\b/) ? e + '.dt' : e;
        }).join(' ');
        var inst = $(this.tables().nodes());
        inst[key].apply(inst, args);
        return this;
    });
});
_api_register('clear()', function() {
    return this.iterator('table', function(settings) {
        _fnClearTable(settings);
    });
});
_api_register('error()', function(msg) {
    return this.iterator('table', function(settings) {
        _fnLog(settings, 0, msg);
    });
});
_api_register('settings()', function() {
    return new _Api(this.context, this.context);
});
_api_register('init()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
});
_api_register('data()', function() {
    return this.iterator('table', function(settings) {
        return _pluck(settings.aoData, '_aData');
    }).flatten();
});
_api_register('trigger()', function(name, args, bubbles) {
    return this.iterator('table', function(settings) {
        return _fnCallbackFire(settings, null, name, args, bubbles);
    }).flatten();
});
_api_register('ready()', function(fn) {
    var ctx = this.context;
    // Get status of first table
    if (!fn) return ctx.length ? ctx[0]._bInitComplete || false : null;
    // Function to run either once the table becomes ready or
    // immediately if it is already ready.
    return this.tables().every(function() {
        if (this.context[0]._bInitComplete) fn.call(this);
        else this.on('init.dt.DT', function() {
            fn.call(this);
        });
    });
});
_api_register('destroy()', function(remove) {
    remove = remove || false;
    return this.iterator('table', function(settings) {
        var classes = settings.oClasses;
        var table = settings.nTable;
        var tbody = settings.nTBody;
        var thead = settings.nTHead;
        var tfoot = settings.nTFoot;
        var jqTable = $(table);
        var jqTbody = $(tbody);
        var jqWrapper = $(settings.nTableWrapper);
        var rows = settings.aoData.map(function(r) {
            return r ? r.nTr : null;
        });
        var orderClasses = classes.order;
        // Flag to note that the table is currently being destroyed - no action
        // should be taken
        settings.bDestroying = true;
        // Fire off the destroy callbacks for plug-ins etc
        _fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
            settings
        ], true);
        // If not being removed from the document, make all columns visible
        if (!remove) new _Api(settings).columns().visible(true);
        // Blitz all `DT` namespaced events (these are internal events, the
        // lowercase, `dt` events are user subscribed and they are responsible
        // for removing them
        jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
        $(window).off('.DT-' + settings.sInstance);
        // When scrolling we had to break the table up - restore it
        if (table != thead.parentNode) {
            jqTable.children('thead').detach();
            jqTable.append(thead);
        }
        if (tfoot && table != tfoot.parentNode) {
            jqTable.children('tfoot').detach();
            jqTable.append(tfoot);
        }
        settings.colgroup.remove();
        settings.aaSorting = [];
        settings.aaSortingFixed = [];
        _fnSortingClasses(settings);
        $('th, td', thead).removeClass(orderClasses.canAsc + ' ' + orderClasses.canDesc + ' ' + orderClasses.isAsc + ' ' + orderClasses.isDesc).css('width', '');
        // Add the TR elements back into the table in their original order
        jqTbody.children().detach();
        jqTbody.append(rows);
        var orig = settings.nTableWrapper.parentNode;
        var insertBefore = settings.nTableWrapper.nextSibling;
        // Remove the DataTables generated nodes, events and classes
        var removedMethod = remove ? 'remove' : 'detach';
        jqTable[removedMethod]();
        jqWrapper[removedMethod]();
        // If we need to reattach the table to the document
        if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            orig.insertBefore(table, insertBefore);
            // Restore the width of the original table - was read from the style property,
            // so we can restore directly to that
            jqTable.css('width', settings.sDestroyWidth).removeClass(classes.table);
        }
        /* Remove the settings object from the settings array */ var idx = DataTable.settings.indexOf(settings);
        if (idx !== -1) DataTable.settings.splice(idx, 1);
    });
});
// Add the `every()` method for rows, columns and cells in a compact form
$.each([
    'column',
    'row',
    'cell'
], function(i, type) {
    _api_register(type + 's().every()', function(fn) {
        var opts = this.selector.opts;
        var api = this;
        var inst;
        var counter = 0;
        return this.iterator('every', function(settings, selectedIdx, tableIdx) {
            inst = api[type](selectedIdx, opts);
            if (type === 'cell') fn.call(inst, inst[0][0].row, inst[0][0].column, tableIdx, counter);
            else fn.call(inst, selectedIdx, tableIdx, counter);
            counter++;
        });
    });
});
// i18n method for extensions to be able to use the language object from the
// DataTable
_api_register('i18n()', function(token, def, plural) {
    var ctx = this.context[0];
    var resolved = _fnGetObjectDataFn(token)(ctx.oLanguage);
    if (resolved === undefined) resolved = def;
    if ($.isPlainObject(resolved)) resolved = plural !== undefined && resolved[plural] !== undefined ? resolved[plural] : resolved._;
    return typeof resolved === 'string' ? resolved.replace('%d', plural) // nb: plural might be undefined,
     : resolved;
});
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */ DataTable.version = "2.1.8";
/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */ DataTable.settings = [];
/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */ DataTable.models = {};
/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */ DataTable.models.oSearch = {
    /**
	 * Flag to indicate if the filtering should be case insensitive or not
	 */ "caseInsensitive": true,
    /**
	 * Applied search term
	 */ "search": "",
    /**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 */ "regex": false,
    /**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 */ "smart": true,
    /**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 */ "return": false
};
/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */ DataTable.models.oRow = {
    /**
	 * TR element for the row
	 */ "nTr": null,
    /**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 */ "anCells": null,
    /**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 */ "_aData": [],
    /**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 */ "_aSortData": null,
    /**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 */ "_aFilterData": null,
    /**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 */ "_sFilterRow": null,
    /**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 */ "src": null,
    /**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 */ "idx": -1,
    /**
	 * Cached display value
	 */ displayData: null
};
/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */ DataTable.models.oColumn = {
    /**
	 * Column index.
	 */ "idx": null,
    /**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 */ "aDataSort": null,
    /**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 */ "asSorting": null,
    /**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 */ "bSearchable": null,
    /**
	 * Flag to indicate if the column is sortable or not.
	 */ "bSortable": null,
    /**
	 * Flag to indicate if the column is currently visible in the table or not
	 */ "bVisible": null,
    /**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 */ "_sManualType": null,
    /**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 */ "_bAttrSrc": false,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 */ "fnGetData": null,
    /**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 */ "fnSetData": null,
    /**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 */ "mData": null,
    /**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 */ "mRender": null,
    /**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 */ "sClass": null,
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 */ "sContentPadding": null,
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 */ "sName": null,
    /**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 */ "sSortDataType": 'std',
    /**
	 * Class to be applied to the header element when sorting on this column
	 */ "sSortingClass": null,
    /**
	 * Title of the column - what is seen in the TH element (nTh).
	 */ "sTitle": null,
    /**
	 * Column sorting and filtering type
	 */ "sType": null,
    /**
	 * Width of the column
	 */ "sWidth": null,
    /**
	 * Width of the column when it was first "encountered"
	 */ "sWidthOrig": null,
    /** Cached string which is the longest in the column */ maxLenString: null,
    /**
	 * Store for named searches
	 */ searchFixed: null
};
/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a Javascript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */ /**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */ DataTable.defaults = {
    /**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in Javascript, for
	 * example with a custom Ajax call.
	 */ "aaData": null,
    /**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 */ "aaSorting": [
        [
            0,
            'asc'
        ]
    ],
    /**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 */ "aaSortingFixed": [],
    /**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use Javascript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 */ "ajax": null,
    /**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 */ "aLengthMenu": [
        10,
        25,
        50,
        100
    ],
    /**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 */ "aoColumns": null,
    /**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 */ "aoColumnDefs": null,
    /**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 */ "aoSearchCols": [],
    /**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 */ "bAutoWidth": true,
    /**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 */ "bDeferRender": true,
    /**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 */ "bDestroy": false,
    /**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 */ "bFilter": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bInfo": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bLengthChange": true,
    /**
	 * Enable or disable pagination.
	 */ "bPaginate": true,
    /**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 */ "bProcessing": false,
    /**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 */ "bRetrieve": false,
    /**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 */ "bScrollCollapse": false,
    /**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 */ "bServerSide": false,
    /**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 */ "bSort": true,
    /**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 */ "bSortMulti": true,
    /**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 */ "bSortCellsTop": null,
    /**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 */ "bSortClasses": true,
    /**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display display will match what thy had previously set up.
	 */ "bStateSave": false,
    /**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 */ "fnCreatedRow": null,
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 */ "fnDrawCallback": null,
    /**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 */ "fnFooterCallback": null,
    /**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 */ "fnFormatNumber": function(toFormat) {
        return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
    },
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 */ "fnHeaderCallback": null,
    /**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 */ "fnInfoCallback": null,
    /**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 */ "fnInitComplete": null,
    /**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 */ "fnPreDrawCallback": null,
    /**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 */ "fnRowCallback": null,
    /**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateLoadCallback": function(settings) {
        try {
            return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
        } catch (e) {
            return {};
        }
    },
    /**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 */ "fnStateLoadParams": null,
    /**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 */ "fnStateLoaded": null,
    /**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateSaveCallback": function(settings, data) {
        try {
            (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
        } catch (e) {
        // noop
        }
    },
    /**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 */ "fnStateSaveParams": null,
    /**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 */ "iStateDuration": 7200,
    /**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 */ "iDisplayLength": 10,
    /**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 */ "iDisplayStart": 0,
    /**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 */ "iTabIndex": 0,
    /**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 */ "oClasses": {},
    /**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 */ "oLanguage": {
        /**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 */ "oAria": {
            /**
			 * ARIA label that is added to the table headers when the column may be sorted
			 */ "orderable": ": Activate to sort",
            /**
			 * ARIA label that is added to the table headers when the column is currently being sorted
			 */ "orderableReverse": ": Activate to invert sorting",
            /**
			 * ARIA label that is added to the table headers when the column is currently being 
			 * sorted and next step is to remove sorting
			 */ "orderableRemove": ": Activate to remove sorting",
            paginate: {
                first: 'First',
                last: 'Last',
                next: 'Next',
                previous: 'Previous',
                number: ''
            }
        },
        /**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 */ "oPaginate": {
            /**
			 * Label and character for first page button («)
			 */ "sFirst": "\u00AB",
            /**
			 * Last page button (»)
			 */ "sLast": "\u00BB",
            /**
			 * Next page button (›)
			 */ "sNext": "\u203A",
            /**
			 * Previous page button (‹)
			 */ "sPrevious": "\u2039"
        },
        /**
		 * Plural object for the data type the table is showing
		 */ entries: {
            _: "entries",
            1: "entry"
        },
        /**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 */ "sEmptyTable": "No data available in table",
        /**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
        /**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 */ "sInfoEmpty": "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
        /**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 */ "sInfoFiltered": "(filtered from _MAX_ total _ENTRIES-MAX_)",
        /**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 */ "sInfoPostFix": "",
        /**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 */ "sDecimal": "",
        /**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 */ "sThousands": ",",
        /**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 */ "sLengthMenu": "_MENU_ _ENTRIES_ per page",
        /**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 */ "sLoadingRecords": "Loading...",
        /**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 */ "sProcessing": "",
        /**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 */ "sSearch": "Search:",
        /**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */ "sSearchPlaceholder": "",
        /**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 */ "sUrl": "",
        /**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 */ "sZeroRecords": "No matching records found"
    },
    /** The initial data order is reversed when `desc` ordering */ orderDescReverse: true,
    /**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 */ "oSearch": $.extend({}, DataTable.models.oSearch),
    /**
	 * Table and control layout. This replaces the legacy `dom` option.
	 */ layout: {
        topStart: 'pageLength',
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
    },
    /**
	 * Legacy DOM layout option
	 */ "sDom": null,
    /**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 */ "searchDelay": null,
    /**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 */ "sPaginationType": "",
    /**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 */ "sScrollX": "",
    /**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 */ "sScrollXInner": "",
    /**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 */ "sScrollY": "",
    /**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 */ "sServerMethod": "GET",
    /**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 */ "renderer": null,
    /**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 */ "rowId": "DT_RowId",
    /**
	 * Caption value
	 */ "caption": null,
    /**
	 * For server-side processing - use the data from the DOM for the first draw
	 */ iDeferLoading: null
};
_fnHungarianMap(DataTable.defaults);
/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */ /**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */ DataTable.defaults.column = {
    /**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 */ "aDataSort": null,
    "iDataSort": -1,
    ariaTitle: '',
    /**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 */ "asSorting": [
        'asc',
        'desc',
        ''
    ],
    /**
	 * Enable or disable filtering on the data in this column.
	 */ "bSearchable": true,
    /**
	 * Enable or disable ordering on this column.
	 */ "bSortable": true,
    /**
	 * Enable or disable the display of this column.
	 */ "bVisible": true,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 */ "mData": null,
    /**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 */ "mRender": null,
    /**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 */ "sCellType": "td",
    /**
	 * Class to give to each cell in this column.
	 */ "sClass": "",
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 */ "sContentPadding": "",
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 */ "sName": "",
    /**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 */ "sSortDataType": "std",
    /**
	 * The title of this column.
	 */ "sTitle": null,
    /**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by Javascript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 */ "sType": null,
    /**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 */ "sWidth": null
};
_fnHungarianMap(DataTable.defaults.column);
/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 */ DataTable.models.oSettings = {
    /**
	 * Primary features of DataTables and their enablement state.
	 */ "oFeatures": {
        /**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bAutoWidth": null,
        /**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and Javascript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bDeferRender": null,
        /**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bFilter": null,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bInfo": true,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bLengthChange": true,
        /**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bPaginate": null,
        /**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bProcessing": null,
        /**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bServerSide": null,
        /**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSort": null,
        /**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortMulti": null,
        /**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortClasses": null,
        /**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bStateSave": null
    },
    /**
	 * Scrolling settings for a table.
	 */ "oScroll": {
        /**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bCollapse": null,
        /**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 */ "iBarWidth": 0,
        /**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sX": null,
        /**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @deprecated
		 */ "sXInner": null,
        /**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sY": null
    },
    /**
	 * Language information for the table.
	 */ "oLanguage": {
        /**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 */ "fnInfoCallback": null
    },
    /**
	 * Browser support parameters
	 */ "oBrowser": {
        /**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 */ "bScrollbarLeft": false,
        /**
		 * Browser scrollbar width
		 */ "barWidth": 0
    },
    "ajax": null,
    /**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 */ "aanFeatures": [],
    /**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 */ "aoData": [],
    /**
	 * Array of indexes which are in the current display (after filtering etc)
	 */ "aiDisplay": [],
    /**
	 * Array of indexes for display - no filtering
	 */ "aiDisplayMaster": [],
    /**
	 * Map of row ids to data indexes
	 */ "aIds": {},
    /**
	 * Store information about each column that is in use
	 */ "aoColumns": [],
    /**
	 * Store information about the table's header
	 */ "aoHeader": [],
    /**
	 * Store information about the table's footer
	 */ "aoFooter": [],
    /**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "oPreviousSearch": {},
    /**
	 * Store for named searches
	 */ searchFixed: {},
    /**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 */ "aoPreSearchCols": [],
    /**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSorting": null,
    /**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSortingFixed": [],
    /**
	 * If restoring a table - we should restore its width
	 */ "sDestroyWidth": 0,
    /**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 */ "aoRowCallback": [],
    /**
	 * Callback functions for the header on each draw.
	 */ "aoHeaderCallback": [],
    /**
	 * Callback function for the footer on each draw.
	 */ "aoFooterCallback": [],
    /**
	 * Array of callback functions for draw callback functions
	 */ "aoDrawCallback": [],
    /**
	 * Array of callback functions for row created function
	 */ "aoRowCreatedCallback": [],
    /**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 */ "aoPreDrawCallback": [],
    /**
	 * Callback functions for when the table has been initialised.
	 */ "aoInitComplete": [],
    /**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 */ "aoStateSaveParams": [],
    /**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 */ "aoStateLoadParams": [],
    /**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 */ "aoStateLoaded": [],
    /**
	 * Cache the table ID for quick access
	 */ "sTableId": "",
    /**
	 * The TABLE node for the main table
	 */ "nTable": null,
    /**
	 * Permanent ref to the thead element
	 */ "nTHead": null,
    /**
	 * Permanent ref to the tfoot element - if it exists
	 */ "nTFoot": null,
    /**
	 * Permanent ref to the tbody element
	 */ "nTBody": null,
    /**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 */ "nTableWrapper": null,
    /**
	 * Indicate if all required information has been read in
	 */ "bInitialised": false,
    /**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 */ "aoOpenRows": [],
    /**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sDom": null,
    /**
	 * Search delay (in mS)
	 */ "searchDelay": null,
    /**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sPaginationType": "two_button",
    /**
	 * Number of paging controls on the page. Only used for backwards compatibility
	 */ pagingControls: 0,
    /**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "iStateDuration": 0,
    /**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateSave": [],
    /**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateLoad": [],
    /**
	 * State that was saved. Useful for back reference
	 */ "oSavedState": null,
    /**
	 * State that was loaded. Useful for back reference
	 */ "oLoadedState": null,
    /**
	 * Note if draw should be blocked while getting data
	 */ "bAjaxDataGet": true,
    /**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 */ "jqXHR": null,
    /**
	 * JSON returned from the server in the last Ajax request
	 */ "json": undefined,
    /**
	 * Data submitted as part of the last Ajax request
	 */ "oAjaxData": undefined,
    /**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sServerMethod": null,
    /**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "fnFormatNumber": null,
    /**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aLengthMenu": null,
    /**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 */ "iDraw": 0,
    /**
	 * Indicate if a redraw is being done - useful for Ajax
	 */ "bDrawing": false,
    /**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 */ "iDrawError": -1,
    /**
	 * Paging display length
	 */ "_iDisplayLength": 10,
    /**
	 * Paging start point - aiDisplay index
	 */ "_iDisplayStart": 0,
    /**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsTotal": 0,
    /**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsDisplay": 0,
    /**
	 * The classes to use for the table
	 */ "oClasses": {},
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bFiltered": false,
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bSorted": false,
    /**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column, if the top one (true) or bottom one (false)
	 * should be used for sorting / title by DataTables.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "bSortCellsTop": null,
    /**
	 * Initialisation object that is used for the table
	 */ "oInit": null,
    /**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 */ "aoDestroyCallback": [],
    /**
	 * Get the number of records in the current record set, before filtering
	 */ "fnRecordsTotal": function() {
        return _fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
    },
    /**
	 * Get the number of records in the current record set, after filtering
	 */ "fnRecordsDisplay": function() {
        return _fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
    },
    /**
	 * Get the display end point - aiDisplay index
	 */ "fnDisplayEnd": function() {
        var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
        if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
        else return !paginate || calc > records || len === -1 ? records : calc;
    },
    /**
	 * The DataTables object for this table
	 */ "oInstance": null,
    /**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 */ "sInstance": null,
    /**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */ "iTabIndex": 0,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollHead": null,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollFoot": null,
    /**
	 * Last applied sort
	 */ "aLastSort": [],
    /**
	 * Stored plug-in instances
	 */ "oPlugins": {},
    /**
	 * Function used to get a row's id from the row's data
	 */ "rowIdFn": null,
    /**
	 * Data location where to store a row's id
	 */ "rowId": null,
    caption: '',
    captionNode: null,
    colgroup: null,
    /** Delay loading of data */ deferLoading: null,
    /** Allow auto type detection */ typeDetect: true
};
/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */ var extPagination = DataTable.ext.pager;
// Paging buttons configuration
$.extend(extPagination, {
    simple: function() {
        return [
            'previous',
            'next'
        ];
    },
    full: function() {
        return [
            'first',
            'previous',
            'next',
            'last'
        ];
    },
    numbers: function() {
        return [
            'numbers'
        ];
    },
    simple_numbers: function() {
        return [
            'previous',
            'numbers',
            'next'
        ];
    },
    full_numbers: function() {
        return [
            'first',
            'previous',
            'numbers',
            'next',
            'last'
        ];
    },
    first_last: function() {
        return [
            'first',
            'last'
        ];
    },
    first_last_numbers: function() {
        return [
            'first',
            'numbers',
            'last'
        ];
    },
    // For testing and plug-ins to use
    _numbers: _pagingNumbers,
    // Number of number buttons - legacy, use `numbers` option for paging feature
    numbers_length: 7
});
$.extend(true, DataTable.ext.renderer, {
    pagingButton: {
        _: function(settings, buttonType, content, active, disabled) {
            var classes = settings.oClasses.paging;
            var btnClasses = [
                classes.button
            ];
            var btn;
            if (active) btnClasses.push(classes.active);
            if (disabled) btnClasses.push(classes.disabled);
            if (buttonType === 'ellipsis') btn = $('<span class="ellipsis"></span>').html(content)[0];
            else btn = $('<button>', {
                class: btnClasses.join(' '),
                role: 'link',
                type: 'button'
            }).html(content);
            return {
                display: btn,
                clicker: btn
            };
        }
    },
    pagingContainer: {
        _: function(settings, buttons) {
            // No wrapping element - just append directly to the host
            return buttons;
        }
    }
});
// Common function to remove new lines, strip HTML and diacritic control
var _filterString = function(stripHtml, normalize) {
    return function(str) {
        if (_empty(str) || typeof str !== 'string') return str;
        str = str.replace(_re_new_lines, " ");
        if (stripHtml) str = _stripHtml(str);
        if (normalize) str = _normalize(str, false);
        return str;
    };
};
/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */ /**
 * Common logic for moment, luxon or a date action.
 *
 * Happens after __mldObj, so don't need to call `resolveWindowsLibs` again
 */ function __mld(dtLib, momentFn, luxonFn, dateFn, arg1) {
    if (__moment) return dtLib[momentFn](arg1);
    else if (__luxon) return dtLib[luxonFn](arg1);
    return dateFn ? dtLib[dateFn](arg1) : dtLib;
}
var __mlWarning = false;
var __luxon; // Can be assigned in DateTeble.use()
var __moment; // Can be assigned in DateTeble.use()
/**
 * 
 */ function resolveWindowLibs() {
    if (window.luxon && !__luxon) __luxon = window.luxon;
    if (window.moment && !__moment) __moment = window.moment;
}
function __mldObj(d, format, locale) {
    var dt;
    resolveWindowLibs();
    if (__moment) {
        dt = __moment.utc(d, format, locale, true);
        if (!dt.isValid()) return null;
    } else if (__luxon) {
        dt = format && typeof d === 'string' ? __luxon.DateTime.fromFormat(d, format) : __luxon.DateTime.fromISO(d);
        if (!dt.isValid) return null;
        dt.setLocale(locale);
    } else if (!format) // No format given, must be ISO
    dt = new Date(d);
    else {
        if (!__mlWarning) alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
        __mlWarning = true;
    }
    return dt;
}
// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function __mlHelper(localeString) {
    return function(from, to, locale, def) {
        // Luxon and Moment support
        // Argument shifting
        if (arguments.length === 0) {
            locale = 'en';
            to = null; // means toLocaleString
            from = null; // means iso8601
        } else if (arguments.length === 1) {
            locale = 'en';
            to = from;
            from = null;
        } else if (arguments.length === 2) {
            locale = to;
            to = from;
            from = null;
        }
        var typeName = 'datetime' + (to ? '-' + to : '');
        // Add type detection and sorting specific to this date format - we need to be able to identify
        // date type columns as such, rather than as numbers in extensions. Hence the need for this.
        if (!DataTable.ext.type.order[typeName + '-pre']) DataTable.type(typeName, {
            detect: function(d) {
                // The renderer will give the value to type detect as the type!
                return d === typeName ? typeName : false;
            },
            order: {
                pre: function(d) {
                    // The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
                    // `valueOf` which gives milliseconds epoch
                    return d.valueOf();
                }
            },
            className: 'dt-right'
        });
        return function(d, type) {
            // Allow for a default value
            if (d === null || d === undefined) {
                if (def === '--now') {
                    // We treat everything as UTC further down, so no changes are
                    // made, as such need to get the local date / time as if it were
                    // UTC
                    var local = new Date();
                    d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                } else d = '';
            }
            if (type === 'type') // Typing uses the type name for fast matching
            return typeName;
            if (d === '') return type !== 'sort' ? '' : __mldObj('0000-01-01 00:00:00', null, locale);
            // Shortcut. If `from` and `to` are the same, we are using the renderer to
            // format for ordering, not display - its already in the display format.
            if (to !== null && from === to && type !== 'sort' && type !== 'type' && !(d instanceof Date)) return d;
            var dt = __mldObj(d, from, locale);
            if (dt === null) return d;
            if (type === 'sort') return dt;
            var formatted = to === null ? __mld(dt, 'toDate', 'toJSDate', '')[localeString]() : __mld(dt, 'format', 'toFormat', 'toISOString', to);
            // XSS protection
            return type === 'display' ? _escapeHtml(formatted) : formatted;
        };
    };
}
// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var __thousands = ',';
var __decimal = '.';
if (window.Intl !== undefined) try {
    var num = new Intl.NumberFormat().formatToParts(100000.1);
    for(var i = 0; i < num.length; i++){
        if (num[i].type === 'group') __thousands = num[i].value;
        else if (num[i].type === 'decimal') __decimal = num[i].value;
    }
} catch (e) {
// noop
}
// Formatted date time detection - use by declaring the formats you are going to use
DataTable.datetime = function(format, locale) {
    var typeName = 'datetime-' + format;
    if (!locale) locale = 'en';
    if (!DataTable.ext.type.order[typeName]) DataTable.type(typeName, {
        detect: function(d) {
            var dt = __mldObj(d, format, locale);
            return d === '' || dt ? typeName : false;
        },
        order: {
            pre: function(d) {
                return __mldObj(d, format, locale) || 0;
            }
        },
        className: 'dt-right'
    });
};
/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `moment` - Uses the MomentJS library to convert from a given format into another.
 * This renderer has three overloads:
 *   * 1 parameter:
 *     * `string` - Format to convert to (assumes input is ISO8601 and locale is `en`)
 *   * 2 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to. Assumes `en` locale
 *   * 3 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to
 *     * `string` - Locale
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */ DataTable.render = {
    date: __mlHelper('toLocaleDateString'),
    datetime: __mlHelper('toLocaleString'),
    time: __mlHelper('toLocaleTimeString'),
    number: function(thousands, decimal, precision, prefix, postfix) {
        // Auto locale detection
        if (thousands === null || thousands === undefined) thousands = __thousands;
        if (decimal === null || decimal === undefined) decimal = __decimal;
        return {
            display: function(d) {
                if (typeof d !== 'number' && typeof d !== 'string') return d;
                if (d === '' || d === null) return d;
                var negative = d < 0 ? '-' : '';
                var flo = parseFloat(d);
                var abs = Math.abs(flo);
                // Scientific notation for large and small numbers
                if (abs >= 100000000000 || abs < 0.0001 && abs !== 0) {
                    var exp = flo.toExponential(precision).split(/e\+?/);
                    return exp[0] + ' x 10<sup>' + exp[1] + '</sup>';
                }
                // If NaN then there isn't much formatting that we can do - just
                // return immediately, escaping any HTML (this was supposed to
                // be a number after all)
                if (isNaN(flo)) return _escapeHtml(d);
                flo = flo.toFixed(precision);
                d = Math.abs(flo);
                var intPart = parseInt(d, 10);
                var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';
                // If zero, then can't have a negative prefix
                if (intPart === 0 && parseFloat(floatPart) === 0) negative = '';
                return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || '');
            }
        };
    },
    text: function() {
        return {
            display: _escapeHtml,
            filter: _escapeHtml
        };
    }
};
var _extTypes = DataTable.ext.type;
// Get / set type
DataTable.type = function(name, prop, val) {
    if (!prop) return {
        className: _extTypes.className[name],
        detect: _extTypes.detect.find(function(fn) {
            return fn._name === name;
        }),
        order: {
            pre: _extTypes.order[name + '-pre'],
            asc: _extTypes.order[name + '-asc'],
            desc: _extTypes.order[name + '-desc']
        },
        render: _extTypes.render[name],
        search: _extTypes.search[name]
    };
    var setProp = function(prop, propVal) {
        _extTypes[prop][name] = propVal;
    };
    var setDetect = function(detect) {
        // `detect` can be a function or an object - we set a name
        // property for either - that is used for the detection
        Object.defineProperty(detect, "_name", {
            value: name
        });
        var idx = _extTypes.detect.findIndex(function(item) {
            return item._name === name;
        });
        if (idx === -1) _extTypes.detect.unshift(detect);
        else _extTypes.detect.splice(idx, 1, detect);
    };
    var setOrder = function(obj) {
        _extTypes.order[name + '-pre'] = obj.pre; // can be undefined
        _extTypes.order[name + '-asc'] = obj.asc; // can be undefined
        _extTypes.order[name + '-desc'] = obj.desc; // can be undefined
    };
    // prop is optional
    if (val === undefined) {
        val = prop;
        prop = null;
    }
    if (prop === 'className') setProp('className', val);
    else if (prop === 'detect') setDetect(val);
    else if (prop === 'order') setOrder(val);
    else if (prop === 'render') setProp('render', val);
    else if (prop === 'search') setProp('search', val);
    else if (!prop) {
        if (val.className) setProp('className', val.className);
        if (val.detect !== undefined) setDetect(val.detect);
        if (val.order) setOrder(val.order);
        if (val.render !== undefined) setProp('render', val.render);
        if (val.search !== undefined) setProp('search', val.search);
    }
};
// Get a list of types
DataTable.types = function() {
    return _extTypes.detect.map(function(fn) {
        return fn._name;
    });
};
var __diacriticSort = function(a, b) {
    a = a !== null && a !== undefined ? a.toString().toLowerCase() : '';
    b = b !== null && b !== undefined ? b.toString().toLowerCase() : '';
    // Checked for `navigator.languages` support in `oneOf` so this code can't execute in old
    // Safari and thus can disable this check
    // eslint-disable-next-line compat/compat
    return a.localeCompare(b, navigator.languages[0] || navigator.language, {
        numeric: true,
        ignorePunctuation: true
    });
};
//
// Built in data types
//
DataTable.type('string', {
    detect: function() {
        return 'string';
    },
    order: {
        pre: function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return _empty(a) && typeof a !== 'boolean' ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
        }
    },
    search: _filterString(false, true)
});
DataTable.type('string-utf8', {
    detect: {
        allOf: function(d) {
            return true;
        },
        oneOf: function(d) {
            // At least one data point must contain a non-ASCII character
            // This line will also check if navigator.languages is supported or not. If not (Safari 10.0-)
            // this data type won't be supported.
            // eslint-disable-next-line compat/compat
            return !_empty(d) && navigator.languages && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: __diacriticSort,
        desc: function(a, b) {
            return __diacriticSort(a, b) * -1;
        }
    },
    search: _filterString(false, true)
});
DataTable.type('html', {
    detect: {
        allOf: function(d) {
            return _empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<`
            return !_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1;
        }
    },
    order: {
        pre: function(a) {
            return _empty(a) ? '' : a.replace ? _stripHtml(a).trim().toLowerCase() : a + '';
        }
    },
    search: _filterString(true, true)
});
DataTable.type('date', {
    className: 'dt-type-date',
    detect: {
        allOf: function(d) {
            // V8 tries _very_ hard to make a string passed into `Date.parse()`
            // valid, so we need to use a regex to restrict date formats. Use a
            // plug-in for anything other than ISO8601 style strings
            if (d && !(d instanceof Date) && !_re_date.test(d)) return null;
            var parsed = Date.parse(d);
            return parsed !== null && !isNaN(parsed) || _empty(d);
        },
        oneOf: function(d) {
            // At least one entry must be a date or a string with a date
            return d instanceof Date || typeof d === 'string' && _re_date.test(d);
        }
    },
    order: {
        pre: function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        }
    }
});
DataTable.type('html-num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal, true, false);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return __numericReplace(d, dp, _re_html, _re_formatted_numeric);
        }
    },
    search: _filterString(true, true)
});
DataTable.type('html-num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return _htmlNumeric(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return __numericReplace(d, dp, _re_html);
        }
    },
    search: _filterString(true, true)
});
DataTable.type('num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal, true, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return __numericReplace(d, dp, _re_formatted_numeric);
        }
    }
});
DataTable.type('num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return _isNumber(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return __numericReplace(d, dp);
        }
    }
});
var __numericReplace = function(d, decimalPlace, re1, re2) {
    if (d !== 0 && (!d || d === '-')) return -Infinity;
    var type = typeof d;
    if (type === 'number' || type === 'bigint') return d;
    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place Javascript recognises - it is not locale aware.
    if (decimalPlace) d = _numToDecimal(d, decimalPlace);
    if (d.replace) {
        if (re1) d = d.replace(re1, '');
        if (re2) d = d.replace(re2, '');
    }
    return d * 1;
};
$.extend(true, DataTable.ext.renderer, {
    footer: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.tfoot.cell);
        }
    },
    header: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.thead.cell);
            if (!settings.oFeatures.bSort) cell.addClass(classes.order.none);
            var legacyTop = settings.bSortCellsTop;
            var headerRows = cell.closest('thead').find('tr');
            var rowIdx = cell.parent().index();
            // Conditions to not apply the ordering icons
            if (// Cells and rows which have the attribute to disable the icons
            cell.attr('data-dt-order') === 'disable' || cell.parent().attr('data-dt-order') === 'disable' || // Legacy support for `orderCellsTop`. If it is set, then cells
            // which are not in the top or bottom row of the header (depending
            // on the value) do not get the sorting classes applied to them
            legacyTop === true && rowIdx !== 0 || legacyTop === false && rowIdx !== headerRows.length - 1) return;
            // No additional mark-up required
            // Attach a sort listener to update on sort - note that using the
            // `DT` namespace will allow the event to be removed automatically
            // on destroy, while the `dt` namespaced event is the one we are
            // listening for
            $(settings.nTable).on('order.dt.DT column-visibility.dt.DT', function(e, ctx) {
                if (settings !== ctx) return; // table, not a nested one
                var sorting = ctx.sortDetails;
                if (!sorting) return;
                var i;
                var orderClasses = classes.order;
                var columns = ctx.api.columns(cell);
                var col = settings.aoColumns[columns.flatten()[0]];
                var orderable = columns.orderable().includes(true);
                var ariaType = '';
                var indexes = columns.indexes();
                var sortDirs = columns.orderable(true).flatten();
                var orderedColumns = _pluck(sorting, 'col');
                cell.removeClass(orderClasses.isAsc + ' ' + orderClasses.isDesc).toggleClass(orderClasses.none, !orderable).toggleClass(orderClasses.canAsc, orderable && sortDirs.includes('asc')).toggleClass(orderClasses.canDesc, orderable && sortDirs.includes('desc'));
                // Determine if all of the columns that this cell covers are included in the
                // current ordering
                var isOrdering = true;
                for(i = 0; i < indexes.length; i++)if (!orderedColumns.includes(indexes[i])) isOrdering = false;
                if (isOrdering) {
                    // Get the ordering direction for the columns under this cell
                    // Note that it is possible for a cell to be asc and desc sorting
                    // (column spanning cells)
                    var orderDirs = columns.order();
                    cell.addClass(orderDirs.includes('asc') ? orderClasses.isAsc : '' + orderDirs.includes('desc') ? orderClasses.isDesc : '');
                }
                // Find the first visible column that has ordering applied to it - it get's
                // the aria information, as the ARIA spec says that only one column should
                // be marked with aria-sort
                var firstVis = -1; // column index
                for(i = 0; i < orderedColumns.length; i++)if (settings.aoColumns[orderedColumns[i]].bVisible) {
                    firstVis = orderedColumns[i];
                    break;
                }
                if (indexes[0] == firstVis) {
                    var firstSort = sorting[0];
                    var sortOrder = col.asSorting;
                    cell.attr('aria-sort', firstSort.dir === 'asc' ? 'ascending' : 'descending');
                    // Determine if the next click will remove sorting or change the sort
                    ariaType = !sortOrder[firstSort.index + 1] ? 'Remove' : 'Reverse';
                } else cell.removeAttr('aria-sort');
                cell.attr('aria-label', orderable ? col.ariaTitle + ctx.api.i18n('oAria.orderable' + ariaType) : col.ariaTitle);
                // Make the headers tab-able for keyboard navigation
                if (orderable) {
                    cell.find('.dt-column-title').attr('role', 'button');
                    cell.attr('tabindex', 0);
                }
            });
        }
    },
    layout: {
        _: function(settings, container, items) {
            var classes = settings.oClasses.layout;
            var row = $('<div/>').attr('id', items.id || null).addClass(items.className || classes.row).appendTo(container);
            $.each(items, function(key, val) {
                if (key === 'id' || key === 'className') return;
                var klass = '';
                if (val.table) {
                    row.addClass(classes.tableRow);
                    klass += classes.tableCell + ' ';
                }
                if (key === 'start') klass += classes.start;
                else if (key === 'end') klass += classes.end;
                else klass += classes.full;
                $('<div/>').attr({
                    id: val.id || null,
                    "class": val.className ? val.className : classes.cell + ' ' + klass
                }).append(val.contents).appendTo(row);
            });
        }
    }
});
DataTable.feature = {};
// Third parameter is internal only!
DataTable.feature.register = function(name, cb, legacy) {
    DataTable.ext.features[name] = cb;
    if (legacy) _ext.feature.push({
        cFeature: legacy,
        fnInit: cb
    });
};
function _divProp(el, prop, val) {
    if (val) el[prop] = val;
}
DataTable.feature.register('div', function(settings, opts) {
    var n = $('<div>')[0];
    if (opts) {
        _divProp(n, 'className', opts.className);
        _divProp(n, 'id', opts.id);
        _divProp(n, 'innerHTML', opts.html);
        _divProp(n, 'textContent', opts.text);
    }
    return n;
});
DataTable.feature.register('info', function(settings, opts) {
    // For compatibility with the legacy `info` top level option
    if (!settings.oFeatures.bInfo) return null;
    var lang = settings.oLanguage, tid = settings.sTableId, n = $('<div/>', {
        'class': settings.oClasses.info.container
    });
    opts = $.extend({
        callback: lang.fnInfoCallback,
        empty: lang.sInfoEmpty,
        postfix: lang.sInfoPostFix,
        search: lang.sInfoFiltered,
        text: lang.sInfo
    }, opts);
    // Update display on each draw
    settings.aoDrawCallback.push(function(s) {
        _fnUpdateInfo(s, opts, n);
    });
    // For the first info display in the table, we add a callback and aria information.
    if (!settings._infoEl) {
        n.attr({
            'aria-live': 'polite',
            id: tid + '_info',
            role: 'status'
        });
        // Table is described by our info div
        $(settings.nTable).attr('aria-describedby', tid + '_info');
        settings._infoEl = n;
    }
    return n;
}, 'i');
/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function _fnUpdateInfo(settings, opts, node) {
    var start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? opts.text : opts.empty;
    if (total !== max) // Record set after filtering
    out += ' ' + opts.search;
    // Convert the macros
    out += opts.postfix;
    out = _fnMacros(settings, out);
    if (opts.callback) out = opts.callback.call(settings.oInstance, settings, start, end, max, total, out);
    node.html(out);
    _fnCallbackFire(settings, null, 'info', [
        settings,
        node[0],
        out
    ]);
}
var __searchCounter = 0;
// opts
// - text
// - placeholder
DataTable.feature.register('search', function(settings, opts) {
    // Don't show the input if filtering isn't available on the table
    if (!settings.oFeatures.bFilter) return null;
    var classes = settings.oClasses.search;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var input = '<input type="search" class="' + classes.input + '"/>';
    opts = $.extend({
        placeholder: language.sSearchPlaceholder,
        processing: false,
        text: language.sSearch
    }, opts);
    // The _INPUT_ is optional - is appended if not present
    if (opts.text.indexOf('_INPUT_') === -1) opts.text += '_INPUT_';
    opts.text = _fnMacros(settings, opts.text);
    // We can put the <input> outside of the label if it is at the start or end
    // which helps improve accessability (not all screen readers like implicit
    // for elements).
    var end = opts.text.match(/_INPUT_$/);
    var start = opts.text.match(/^_INPUT_/);
    var removed = opts.text.replace(/_INPUT_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_INPUT_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_INPUT_';
    var filter = $('<div>').addClass(classes.container).append(str.replace(/_INPUT_/, input));
    // add for and id to label and input
    filter.find('label').attr('for', 'dt-search-' + __searchCounter);
    filter.find('input').attr('id', 'dt-search-' + __searchCounter);
    __searchCounter++;
    var searchFn = function(event) {
        var val = this.value;
        if (previousSearch.return && event.key !== "Enter") return;
        /* Now do the filter */ if (val != previousSearch.search) _fnProcessingRun(settings, opts.processing, function() {
            previousSearch.search = val;
            _fnFilterComplete(settings, previousSearch);
            // Need to redraw, without resorting
            settings._iDisplayStart = 0;
            _fnDraw(settings);
        });
    };
    var searchDelay = settings.searchDelay !== null ? settings.searchDelay : 0;
    var jqFilter = $('input', filter).val(previousSearch.search).attr('placeholder', opts.placeholder).on('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? DataTable.util.debounce(searchFn, searchDelay) : searchFn).on('mouseup.DT', function(e) {
        // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
        // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
        // checks the value to see if it has changed. In other browsers it won't have.
        setTimeout(function() {
            searchFn.call(jqFilter[0], e);
        }, 10);
    }).on('keypress.DT', function(e) {
        /* Prevent form submission */ if (e.keyCode == 13) return false;
    }).attr('aria-controls', tableId);
    // Update the input elements whenever the table is filtered
    $(settings.nTable).on('search.dt.DT', function(ev, s) {
        if (settings === s && jqFilter[0] !== document.activeElement) jqFilter.val(typeof previousSearch.search !== 'function' ? previousSearch.search : '');
    });
    return filter;
}, 'f');
// opts
// - type - button configuration
// - buttons - number of buttons to show - must be odd
DataTable.feature.register('paging', function(settings, opts) {
    // Don't show the paging input if the table doesn't have paging enabled
    if (!settings.oFeatures.bPaginate) return null;
    opts = $.extend({
        buttons: DataTable.ext.pager.numbers_length,
        type: settings.sPaginationType,
        boundaryNumbers: true,
        firstLast: true,
        previousNext: true,
        numbers: true
    }, opts);
    var host = $('<div/>').addClass(settings.oClasses.paging.container + (opts.type ? ' paging_' + opts.type : '')).append($('<nav>').attr('aria-label', 'pagination').addClass(settings.oClasses.paging.nav));
    var draw = function() {
        _pagingDraw(settings, host.children(), opts);
    };
    settings.aoDrawCallback.push(draw);
    // Responsive redraw of paging control
    $(settings.nTable).on('column-sizing.dt.DT', draw);
    return host;
}, 'p');
/**
 * Dynamically create the button type array based on the configuration options.
 * This will only happen if the paging type is not defined.
 */ function _pagingDynamic(opts) {
    var out = [];
    if (opts.numbers) out.push('numbers');
    if (opts.previousNext) {
        out.unshift('previous');
        out.push('next');
    }
    if (opts.firstLast) {
        out.unshift('first');
        out.push('last');
    }
    return out;
}
function _pagingDraw(settings, host, opts) {
    if (!settings._bInitComplete) return;
    var plugin = opts.type ? DataTable.ext.pager[opts.type] : _pagingDynamic, aria = settings.oLanguage.oAria.paginate || {}, start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = [], buttonEls = [], buttonsNested = plugin(opts).map(function(val) {
        return val === 'numbers' ? _pagingNumbers(page, pages, opts.buttons, opts.boundaryNumbers) : val;
    });
    // .flat() would be better, but not supported in old Safari
    buttons = buttons.concat.apply(buttons, buttonsNested);
    for(var i = 0; i < buttons.length; i++){
        var button = buttons[i];
        var btnInfo = _pagingButtonInfo(settings, button, page, pages);
        var btn = _fnRenderer(settings, 'pagingButton')(settings, button, btnInfo.display, btnInfo.active, btnInfo.disabled);
        var ariaLabel = typeof button === 'string' ? aria[button] : aria.number ? aria.number + (button + 1) : null;
        // Common attributes
        $(btn.clicker).attr({
            'aria-controls': settings.sTableId,
            'aria-disabled': btnInfo.disabled ? 'true' : null,
            'aria-current': btnInfo.active ? 'page' : null,
            'aria-label': ariaLabel,
            'data-dt-idx': button,
            'tabIndex': btnInfo.disabled ? -1 : settings.iTabIndex ? settings.iTabIndex : null
        });
        if (typeof button !== 'number') $(btn.clicker).addClass(button);
        _fnBindAction(btn.clicker, {
            action: button
        }, function(e) {
            e.preventDefault();
            _fnPageChange(settings, e.data.action, true);
        });
        buttonEls.push(btn.display);
    }
    var wrapped = _fnRenderer(settings, 'pagingContainer')(settings, buttonEls);
    var activeEl = host.find(document.activeElement).data('dt-idx');
    host.empty().append(wrapped);
    if (activeEl !== undefined) host.find('[data-dt-idx=' + activeEl + ']').trigger('focus');
    // Responsive - check if the buttons are over two lines based on the
    // height of the buttons and the container.
    if (buttonEls.length && // any buttons
    opts.buttons > 1 && // prevent infinite
    $(host).height() >= $(buttonEls[0]).outerHeight() * 2 - 10) _pagingDraw(settings, host, $.extend({}, opts, {
        buttons: opts.buttons - 2
    }));
}
/**
 * Get properties for a button based on the current paging state of the table
 *
 * @param {*} settings DT settings object
 * @param {*} button The button type in question
 * @param {*} page Table's current page
 * @param {*} pages Number of pages
 * @returns Info object
 */ function _pagingButtonInfo(settings, button, page, pages) {
    var lang = settings.oLanguage.oPaginate;
    var o = {
        display: '',
        active: false,
        disabled: false
    };
    switch(button){
        case 'ellipsis':
            o.display = '&#x2026;';
            o.disabled = true;
            break;
        case 'first':
            o.display = lang.sFirst;
            if (page === 0) o.disabled = true;
            break;
        case 'previous':
            o.display = lang.sPrevious;
            if (page === 0) o.disabled = true;
            break;
        case 'next':
            o.display = lang.sNext;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        case 'last':
            o.display = lang.sLast;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        default:
            if (typeof button === 'number') {
                o.display = settings.fnFormatNumber(button + 1);
                if (page === button) o.active = true;
            }
            break;
    }
    return o;
}
/**
 * Compute what number buttons to show in the paging control
 *
 * @param {*} page Current page
 * @param {*} pages Total number of pages
 * @param {*} buttons Target number of number buttons
 * @param {boolean} addFirstLast Indicate if page 1 and end should be included
 * @returns Buttons to show
 */ function _pagingNumbers(page, pages, buttons, addFirstLast) {
    var numbers = [], half = Math.floor(buttons / 2), before = addFirstLast ? 2 : 1, after = addFirstLast ? 1 : 0;
    if (pages <= buttons) numbers = _range(0, pages);
    else if (buttons === 1) // Single button - current page only
    numbers = [
        page
    ];
    else if (buttons === 3) {
        // Special logic for just three buttons
        if (page <= 1) numbers = [
            0,
            1,
            'ellipsis'
        ];
        else if (page >= pages - 2) {
            numbers = _range(pages - 2, pages);
            numbers.unshift('ellipsis');
        } else numbers = [
            'ellipsis',
            page,
            'ellipsis'
        ];
    } else if (page <= half) {
        numbers = _range(0, buttons - before);
        numbers.push('ellipsis');
        if (addFirstLast) numbers.push(pages - 1);
    } else if (page >= pages - 1 - half) {
        numbers = _range(pages - (buttons - before), pages);
        numbers.unshift('ellipsis');
        if (addFirstLast) numbers.unshift(0);
    } else {
        numbers = _range(page - half + before, page + half - after);
        numbers.push('ellipsis');
        numbers.unshift('ellipsis');
        if (addFirstLast) {
            numbers.push(pages - 1);
            numbers.unshift(0);
        }
    }
    return numbers;
}
var __lengthCounter = 0;
// opts
// - menu
// - text
DataTable.feature.register('pageLength', function(settings, opts) {
    var features = settings.oFeatures;
    // For compatibility with the legacy `pageLength` top level option
    if (!features.bPaginate || !features.bLengthChange) return null;
    opts = $.extend({
        menu: settings.aLengthMenu,
        text: settings.oLanguage.sLengthMenu
    }, opts);
    var classes = settings.oClasses.length, tableId = settings.sTableId, menu = opts.menu, lengths = [], language = [], i;
    // Options can be given in a number of ways
    if (Array.isArray(menu[0])) {
        // Old 1.x style - 2D array
        lengths = menu[0];
        language = menu[1];
    } else {
        for(i = 0; i < menu.length; i++)// An object with different label and value
        if ($.isPlainObject(menu[i])) {
            lengths.push(menu[i].value);
            language.push(menu[i].label);
        } else {
            // Or just a number to display and use
            lengths.push(menu[i]);
            language.push(menu[i]);
        }
    }
    // We can put the <select> outside of the label if it is at the start or
    // end which helps improve accessability (not all screen readers like
    // implicit for elements).
    var end = opts.text.match(/_MENU_$/);
    var start = opts.text.match(/^_MENU_/);
    var removed = opts.text.replace(/_MENU_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_MENU_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_MENU_';
    // Wrapper element - use a span as a holder for where the select will go
    var tmpId = 'tmp-' + +new Date();
    var div = $('<div/>').addClass(classes.container).append(str.replace('_MENU_', '<span id="' + tmpId + '"></span>'));
    // Save text node content for macro updating
    var textNodes = [];
    Array.from(div.find('label')[0].childNodes).forEach(function(el) {
        if (el.nodeType === Node.TEXT_NODE) textNodes.push({
            el: el,
            text: el.textContent
        });
    });
    // Update the label text in case it has an entries value
    var updateEntries = function(len) {
        textNodes.forEach(function(node) {
            node.el.textContent = _fnMacros(settings, node.text, len);
        });
    };
    // Next, the select itself, along with the options
    var select = $('<select/>', {
        'name': tableId + '_length',
        'aria-controls': tableId,
        'class': classes.select
    });
    for(i = 0; i < lengths.length; i++)select[0][i] = new Option(typeof language[i] === 'number' ? settings.fnFormatNumber(language[i]) : language[i], lengths[i]);
    // add for and id to label and input
    div.find('label').attr('for', 'dt-length-' + __lengthCounter);
    select.attr('id', 'dt-length-' + __lengthCounter);
    __lengthCounter++;
    // Swap in the select list
    div.find('#' + tmpId).replaceWith(select);
    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $('select', div).val(settings._iDisplayLength).on('change.DT', function() {
        _fnLengthChange(settings, $(this).val());
        _fnDraw(settings);
    });
    // Update node value whenever anything changes the table's length
    $(settings.nTable).on('length.dt.DT', function(e, s, len) {
        if (settings === s) {
            $('select', div).val(len);
            // Resolve plurals in the text for the new length
            updateEntries(len);
        }
    });
    updateEntries(settings._iDisplayLength);
    return div;
}, 'l');
// jQuery access
$.fn.dataTable = DataTable;
// Provide access to the host jQuery object (circular reference)
DataTable.$ = $;
// Legacy aliases
$.fn.dataTableSettings = DataTable.settings;
$.fn.dataTableExt = DataTable.ext;
// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$.fn.DataTable = function(opts) {
    return $(this).dataTable(opts).api();
};
// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$.each(DataTable, function(prop, val) {
    $.fn.DataTable[prop] = val;
});
exports.default = DataTable;

},{"jquery":"11TDa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gfmyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rideStatus", ()=>rideStatus);
parcelHelpers.export(exports, "rideType", ()=>rideType);
parcelHelpers.export(exports, "driverStatus", ()=>driverStatus);
parcelHelpers.export(exports, "geoZoneType", ()=>geoZoneType);
parcelHelpers.export(exports, "userDetailsWithThumbnail", ()=>userDetailsWithThumbnail);
parcelHelpers.export(exports, "zonedDateTime", ()=>zonedDateTime);
parcelHelpers.export(exports, "booleanBadgeRender", ()=>booleanBadgeRender);
parcelHelpers.export(exports, "activeBadgeRender", ()=>activeBadgeRender);
parcelHelpers.export(exports, "potentialUndefinedColumn", ()=>potentialUndefinedColumn);
parcelHelpers.export(exports, "editAndDeleteCTA", ()=>editAndDeleteCTA);
parcelHelpers.export(exports, "findDriverOnMapCTA", ()=>findDriverOnMapCTA);
// Account-related renderers
parcelHelpers.export(exports, "accountStatus", ()=>accountStatus);
parcelHelpers.export(exports, "invoiceStatus", ()=>invoiceStatus);
parcelHelpers.export(exports, "currency", ()=>currency);
parcelHelpers.export(exports, "ledgerEntryType", ()=>ledgerEntryType);
parcelHelpers.export(exports, "shiftStatus", ()=>shiftStatus);
parcelHelpers.export(exports, "shiftSignupStatus", ()=>shiftSignupStatus);
parcelHelpers.export(exports, "earningTransferStatus", ()=>earningTransferStatus);
/**
 * Money that may legitimately be absent, rendered as a dash rather than $0.00.
 *
 * `currency()` maps null to "$0.00", which on a settlement column would assert the driver earned or was
 * credited nothing — a false statement, and precisely the one issue #136 exists to stop the product
 * making. An unsettled sign-up, and one settled before the snapshot columns shipped, both carry nulls.
 */ parcelHelpers.export(exports, "optionalCurrency", ()=>optionalCurrency);
// Wallet admin renderers (epic #173, issue #169).
/**
 * Money already in minor units (BIGINT cents, per D1) rendered as a dollar figure — `currency()`
 * assumes its input is already dollars, which every wallet admin DTO deliberately is not on the wire
 * (amount*Minor fields), to keep the server the only place a minor/major conversion happens.
 */ parcelHelpers.export(exports, "minorCurrency", ()=>minorCurrency);
parcelHelpers.export(exports, "walletStatus", ()=>walletStatus);
parcelHelpers.export(exports, "walletTransactionType", ()=>walletTransactionType);
parcelHelpers.export(exports, "walletAdjustmentRequestStatus", ()=>walletAdjustmentRequestStatus);
parcelHelpers.export(exports, "walletTopUpRefundState", ()=>walletTopUpRefundState);
parcelHelpers.export(exports, "subscriptionStatus", ()=>subscriptionStatus);
var _timeagoJs = require("timeago.js");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
function rideStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'COMPLETED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Completed';
            break;
        case 'PENDING':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Pending';
            break;
        case 'ACCEPTED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Accepted';
            break;
        case 'TO_PICKUP':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Transit to Pickup';
            break;
        case 'WAITING_PICKUP':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Waiting for Pickup';
            break;
        case 'STOPPED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Stopped';
            break;
        case 'IN_PROGRESS':
            className = 'bg-light-warning border-light-warning text-warning';
            displayValue = 'In-progress';
            break;
        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Canceled';
            break;
        case 'DRIVER_NOT_FOUND':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Driver not found';
            break;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function rideType(value) {
    let className;
    let displayValue;
    switch(value){
        case 'DISPATCHED':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Dispatched';
            break;
        case 'ORDERED':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Ordered';
            break;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function driverStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'AVAILABLE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Available';
            break;
        case 'ON_RIDE':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'On ride';
            break;
        case 'OFFLINE':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Offline';
            break;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function geoZoneType(value) {
    let className;
    let displayValue;
    switch(value){
        case 'SERVICE_AREA':
            className = 'bg-primary border-light-primary text-primary';
            displayValue = 'Service Area';
            break;
        case 'FARE_CONFIG_ZONE':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Fare Config Zone';
            break;
        case 'RESTRICTED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Restricted';
            break;
        case 'PROMOTIONAL':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Promotional';
            break;
        case 'CUSTOM':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Custom';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Unknown';
            break;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function userDetailsWithThumbnail(data, row, url) {
    if ((0, _lodashDefault.default).isEmpty(data)) return 'N/A';
    return `<div class="d-flex align-items-center gap-2">
              <span class="table-thumb d-none d-lg-block">
                <span class="name-short-form">
                    ${data.match(/(^\S\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()}
                </span>
              </span>
              
              <div>
                <a class="fs-13" href="${url}">${data}</a>
               </div>
          </div>`;
}
function zonedDateTime(value) {
    if ((0, _lodashDefault.default).isEmpty(value) || isNaN(new Date(value))) return "N/A";
    return `<span title="${(0, _momentDefault.default)(value).format('MMM DD, YYYY')}"> ${(0, _timeagoJs.format)(new Date(value))}</span>`;
}
function booleanBadgeRender(value) {
    return value ? `<span class="badge badge-success">Yes</span>` : `<span class="badge badge-danger">No</span>`;
}
function activeBadgeRender(value) {
    return value ? '<span class="badge bg-success">Active</span>' : '<span class="badge bg-danger">Inactive</span>';
}
function potentialUndefinedColumn(value) {
    return value ? value : `N/A`;
}
function editAndDeleteCTA(data, type, row, meta, editCallback, deleteCallback) {
    const hash = hashCode(row).toString();
    setupEditAndDeleteEventListeners(editCallback, deleteCallback, row, meta, hash);
    return `
    <button class="btn btn-lg btn-link p-0 edit-btn-${hash}" data-id="${row.id ? row.id : meta.row}">
      <i class="icon-pencil-alt"></i>
    </button>
    <button class="btn btn-lg btn-link p-0 del-btn-${hash}" data-id="${row.id ? row.id : meta.row}">
      <i class="icon-trash text-danger"></i>
    </button>`;
}
function findDriverOnMapCTA(data, type, row, meta, findDriverCallback) {
    setupFindDriverOnMapCTAEventListeners(findDriverCallback, row, meta);
    return `
  <button class="btn btn-link p-0 find-btn-${row.id}" data-id="${row.id ? row.id : meta.row} title="Find driver on map.">
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>`;
}
/**
 *
 *Event listeners
 */ function setupEditAndDeleteEventListeners(editCallback, deleteCallback, row, meta, hash) {
    $(document).on('click', `.edit-btn-${hash}`, function() {
        editCallback(row, meta);
    });
    $(document).on('click', `.del-btn-${hash}`, function() {
        deleteCallback(row, meta);
    });
}
function setupFindDriverOnMapCTAEventListeners(findDriverCallback, row) {
    $(document).on('click', `.find-btn-${row.driverId}`, function() {
        findDriverCallback(row);
    });
}
function hashCode(obj) {
    let str = "";
    Object.keys(obj).forEach((key)=>{
        str += obj[key];
    });
    let hash = 0;
    if (str.length === 0) return hash;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return hash;
}
function accountStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'SUSPENDED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Suspended';
            break;
        case 'CLOSED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Closed';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function invoiceStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'DRAFT':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Draft';
            break;
        case 'SENT':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Sent';
            break;
        case 'PAID':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Paid';
            break;
        case 'OVERDUE':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Overdue';
            break;
        case 'CANCELLED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-light border-light text-dark';
            displayValue = value;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function currency(value) {
    if (value === null || value === undefined) return '$0.00';
    const formatted = parseFloat(value).toFixed(2);
    return `$${formatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}
function ledgerEntryType(value) {
    let icon;
    let className;
    let displayValue;
    switch(value){
        case 'CHARGE':
            icon = 'fa-arrow-up';
            className = 'text-danger';
            displayValue = 'Charge';
            break;
        case 'PAYMENT':
            icon = 'fa-arrow-down';
            className = 'text-success';
            displayValue = 'Payment';
            break;
        case 'CREDIT':
            icon = 'fa-gift';
            className = 'text-info';
            displayValue = 'Credit';
            break;
        case 'ADJUSTMENT':
            icon = 'fa-exchange-alt';
            className = 'text-warning';
            displayValue = 'Adjustment';
            break;
        default:
            icon = 'fa-circle';
            className = 'text-secondary';
            displayValue = value;
    }
    return `<i class="fa ${icon} ${className}"></i> ${displayValue}`;
}
function shiftStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'DRAFT':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Draft';
            break;
        case 'PUBLISHED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Published';
            break;
        case 'IN_PROGRESS':
            className = 'bg-info border-light-info text-info';
            displayValue = 'In progress';
            break;
        case 'CLOSED':
            className = 'bg-dark border-light-dark text-dark';
            displayValue = 'Closed';
            break;
        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function shiftSignupStatus(value) {
    let className;
    let displayValue;
    // A lookup with a fallback rather than an exhaustive switch: settlement outcomes are expected to
    // grow (#135), and a status this build doesn't know must render as itself rather than blank.
    switch(value){
        case 'SIGNED_UP':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Signed up';
            break;
        case 'WITHDRAWN':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Withdrawn';
            break;
        case 'COMPLETED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Completed';
            break;
        case 'NO_SHOW':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'No show';
            break;
        case 'SHIFT_CANCELLED':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Shift cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value;
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function earningTransferStatus(value) {
    let className;
    switch(value){
        case 'COMPLETED':
            className = 'bg-success border-light-success text-success';
            break;
        case 'PENDING':
        case 'PROCESSING':
            className = 'bg-info border-light-info text-info';
            break;
        case 'FAILED':
            className = 'bg-danger border-light-danger text-danger';
            break;
        case 'SKIPPED':
            className = 'bg-warning border-light-warning text-warning';
            break;
        default:
            // No transfer row at all — e.g. a driver who out-earned their shift guarantee, so nothing
            // was ever owed. That is not a fault and must not render as one.
            return `<span class="text-muted">&mdash;</span>`;
    }
    return `<span class="btn-sm ${className}"> ${value} </span>`;
}
function optionalCurrency(value) {
    return value === null || value === undefined ? `<span class="text-muted">&mdash;</span>` : currency(value);
}
function minorCurrency(value) {
    if (value === null || value === undefined) return '$0.00';
    return currency(value / 100);
}
function walletStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'FROZEN':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Frozen';
            break;
        case 'SUSPENDED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Suspended';
            break;
        case 'CLOSED':
            className = 'bg-dark border-light-dark text-dark';
            displayValue = 'Closed';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function walletTransactionType(value) {
    let className;
    switch(value){
        case 'TOP_UP':
        case 'PROMOTIONAL_CREDIT':
        case 'SUPPORT_CREDIT':
        case 'REFERRAL_CREDIT':
        case 'CHARGEBACK_REVERSAL':
        case 'REVERSAL':
            className = 'text-success';
            break;
        case 'RIDE_PAYMENT':
        case 'CHARGEBACK':
        case 'EXPIRY':
            className = 'text-danger';
            break;
        case 'RIDE_REFUND':
        case 'TOP_UP_REFUND':
            className = 'text-info';
            break;
        case 'MANUAL_ADJUSTMENT':
            className = 'text-warning';
            break;
        default:
            className = 'text-secondary';
    }
    const label = (value || '').replaceAll('_', ' ');
    return `<span class="${className}">${label}</span>`;
}
function walletAdjustmentRequestStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'PENDING_APPROVAL':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending approval';
            break;
        case 'APPROVED':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Approved';
            break;
        case 'EXECUTING':
            className = 'bg-info border-light-info text-info';
            displayValue = 'Executing';
            break;
        case 'EXECUTED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Executed';
            break;
        case 'EXECUTION_PENDING':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Refund in progress';
            break;
        case 'ESCALATED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Escalated';
            break;
        case 'FAILED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Failed';
            break;
        case 'REJECTED':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Rejected';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function walletTopUpRefundState(value) {
    let className;
    let displayValue;
    switch(value){
        case 'NONE':
            return `<span class="text-muted">&mdash;</span>`;
        case 'PENDING_UNKNOWN':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending';
            break;
        case 'REFUNDED':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Refunded';
            break;
        case 'UNRECONCILED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Unreconciled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'Unknown';
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}
function subscriptionStatus(value) {
    let className;
    let displayValue;
    switch(value){
        case 'ACTIVE':
            className = 'bg-success border-light-success text-success';
            displayValue = 'Active';
            break;
        case 'INACTIVE':
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = 'Inactive';
            break;
        case 'PENDING':
            className = 'bg-warning border-light-warning text-warning';
            displayValue = 'Pending';
            break;
        case 'EXPIRED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Expired';
            break;
        case 'CANCELLED':
            className = 'bg-danger border-light-danger text-danger';
            displayValue = 'Cancelled';
            break;
        default:
            className = 'bg-secondary border-light-secondary text-secondary';
            displayValue = value || 'None';
    }
    return `<span class="btn-sm ${className}"> ${displayValue} </span>`;
}

},{"timeago.js":"aPiEQ","lodash":"3hMBK","moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aPiEQ":[function(require,module,exports,__globalThis) {
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>(0, _format.format));
parcelHelpers.export(exports, "render", ()=>(0, _realtime.render));
parcelHelpers.export(exports, "cancel", ()=>(0, _realtime.cancel));
parcelHelpers.export(exports, "register", ()=>(0, _register.register));
var _enUS = require("./lang/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _zhCN = require("./lang/zh_CN");
var _zhCNDefault = parcelHelpers.interopDefault(_zhCN);
var _register = require("./register");
var _format = require("./format");
var _realtime = require("./realtime");
(0, _register.register)('en_US', (0, _enUSDefault.default));
(0, _register.register)('zh_CN', (0, _zhCNDefault.default));

},{"./lang/en_US":"gyuwp","./lang/zh_CN":"lSmYi","./register":"knreT","./format":"hQR2m","./realtime":"4OTYq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyuwp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(diff, idx) {
        if (idx === 0) return [
            'just now',
            'right now'
        ];
        var unit = EN_US[Math.floor(idx / 2)];
        if (diff > 1) unit += 's';
        return [
            diff + " " + unit + " ago",
            "in " + diff + " " + unit
        ];
    });
var EN_US = [
    'second',
    'minute',
    'hour',
    'day',
    'week',
    'month',
    'year'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSmYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(diff, idx) {
        if (idx === 0) return [
            "\u521A\u521A",
            "\u7247\u523B\u540E"
        ];
        var unit = ZH_CN[~~(idx / 2)];
        return [
            diff + " " + unit + "\u524D",
            diff + " " + unit + "\u540E"
        ];
    });
var ZH_CN = [
    "\u79D2",
    "\u5206\u949F",
    "\u5C0F\u65F6",
    "\u5929",
    "\u5468",
    "\u4E2A\u6708",
    "\u5E74"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knreT":[function(require,module,exports,__globalThis) {
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ /**
 * All supported locales
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "getLocale", ()=>getLocale);
var Locales = {};
var register = function(locale, func) {
    Locales[locale] = func;
};
var getLocale = function(locale) {
    return Locales[locale] || Locales['en_US'];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQR2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
var _date = require("./utils/date");
var _register = require("./register");
var format = function(date, locale, opts) {
    // diff seconds
    var sec = (0, _date.diffSec)(date, opts && opts.relativeDate);
    // format it with locale
    return (0, _date.formatDiff)(sec, (0, _register.getLocale)(locale));
};

},{"./utils/date":"lKThP","./register":"knreT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lKThP":[function(require,module,exports,__globalThis) {
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * format Date / string / timestamp to timestamp
 * @param input
 * @returns {*}
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
/**
 * format the diff second to *** time ago, with setting locale
 * @param diff
 * @param localeFunc
 * @returns
 */ parcelHelpers.export(exports, "formatDiff", ()=>formatDiff);
/**
 * calculate the diff second between date to be formatted an now date.
 * @param date
 * @param relativeDate
 * @returns {number}
 */ parcelHelpers.export(exports, "diffSec", ()=>diffSec);
/**
 * nextInterval: calculate the next interval time.
 * - diff: the diff sec between now and date to be formatted.
 *
 * What's the meaning?
 * diff = 61 then return 59
 * diff = 3601 (an hour + 1 second), then return 3599
 * make the interval with high performance.
 **/ parcelHelpers.export(exports, "nextInterval", ()=>nextInterval);
var SEC_ARRAY = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12
];
function toDate(input) {
    if (input instanceof Date) return input;
    // @ts-ignore
    if (!isNaN(input) || /^\d+$/.test(input)) return new Date(parseInt(input));
    input = (input || '')// @ts-ignore
    .trim().replace(/\.\d+/, '') // remove milliseconds
    .replace(/-/, '/').replace(/-/, '/').replace(/(\d)T(\d)/, '$1 $2').replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
    .replace(/([+-]\d\d):?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
}
function formatDiff(diff, localeFunc) {
    /**
     * if locale is not exist, use defaultLocale.
     * if defaultLocale is not exist, use build-in `en`.
     * be sure of no error when locale is not exist.
     *
     * If `time in`, then 1
     * If `time ago`, then 0
     */ var agoIn = diff < 0 ? 1 : 0;
    /**
     * Get absolute value of number (|diff| is non-negative) value of x
     * |diff| = diff if diff is positive
     * |diff| = -diff if diff is negative
     * |0| = 0
     */ diff = Math.abs(diff);
    /**
     * Time in seconds
     */ var totalSec = diff;
    /**
     * Unit of time
     */ var idx = 0;
    for(; diff >= SEC_ARRAY[idx] && idx < SEC_ARRAY.length; idx++)diff /= SEC_ARRAY[idx];
    /**
     * Math.floor() is alternative of ~~
     *
     * The differences and bugs:
     * Math.floor(3.7) -> 4 but ~~3.7 -> 3
     * Math.floor(1559125440000.6) -> 1559125440000 but ~~1559125440000.6 -> 52311552
     *
     * More information about the performance of algebraic:
     * https://www.youtube.com/watch?v=65-RbBwZQdU
     */ diff = Math.floor(diff);
    idx *= 2;
    if (diff > (idx === 0 ? 9 : 1)) idx += 1;
    return localeFunc(diff, idx, totalSec)[agoIn].replace('%s', diff.toString());
}
function diffSec(date, relativeDate) {
    var relDate = relativeDate ? toDate(relativeDate) : new Date();
    return (+relDate - +toDate(date)) / 1000;
}
function nextInterval(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for(; diff >= SEC_ARRAY[i] && i < SEC_ARRAY.length; i++){
        diff /= SEC_ARRAY[i];
        rst *= SEC_ARRAY[i];
    }
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4OTYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * cancel a timer or all timers
 * @param node - node hosting the time string
 */ parcelHelpers.export(exports, "cancel", ()=>cancel);
/**
 * render a dom realtime
 * @param nodes
 * @param locale
 * @param opts
 */ parcelHelpers.export(exports, "render", ()=>render);
var _dom = require("./utils/dom");
var _date = require("./utils/date");
var _register = require("./register");
// all realtime timer
var TIMER_POOL = {};
/**
 * clear a timer from pool
 * @param tid
 */ var clear = function(tid) {
    clearTimeout(tid);
    delete TIMER_POOL[tid];
};
// run with timer(setTimeout)
function run(node, date, localeFunc, opts) {
    // clear the node's exist timer
    clear((0, _dom.getTimerId)(node));
    var relativeDate = opts.relativeDate, minInterval = opts.minInterval;
    // get diff seconds
    var diff = (0, _date.diffSec)(date, relativeDate);
    // render
    node.innerText = (0, _date.formatDiff)(diff, localeFunc);
    var tid = setTimeout(function() {
        run(node, date, localeFunc, opts);
    }, Math.min(Math.max((0, _date.nextInterval)(diff), minInterval || 1) * 1000, 0x7fffffff));
    // there is no need to save node in object. Just save the key
    TIMER_POOL[tid] = 0;
    (0, _dom.setTimerId)(node, tid);
}
function cancel(node) {
    // cancel one
    if (node) clear((0, _dom.getTimerId)(node));
    else Object.keys(TIMER_POOL).forEach(clear);
}
function render(nodes, locale, opts) {
    // by .length
    // @ts-ignore
    var nodeList = nodes.length ? nodes : [
        nodes
    ];
    nodeList.forEach(function(node) {
        run(node, (0, _dom.getDateAttribute)(node), (0, _register.getLocale)(locale), opts || {});
    });
    return nodeList;
}

},{"./utils/dom":"k58UD","./utils/date":"lKThP","./register":"knreT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k58UD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * get the datetime attribute, `datetime` are supported.
 * @param node
 * @returns {*}
 */ parcelHelpers.export(exports, "getDateAttribute", ()=>getDateAttribute);
/**
 * set the node attribute, native DOM
 * @param node
 * @param timerId
 * @returns {*}
 */ parcelHelpers.export(exports, "setTimerId", ()=>setTimerId);
/**
 * get the timer id
 * @param node
 */ parcelHelpers.export(exports, "getTimerId", ()=>getTimerId);
var ATTR_TIMEAGO_TID = 'timeago-id';
function getDateAttribute(node) {
    return node.getAttribute('datetime');
}
function setTimerId(node, timerId) {
    // @ts-ignore
    node.setAttribute(ATTR_TIMEAGO_TID, timerId);
}
function getTimerId(node) {
    return parseInt(node.getAttribute(ATTR_TIMEAGO_TID));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3hMBK":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"2meyw":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"12wBj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal-2"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    class: "tab-content",
    id: "icon-tabContent"
};
const _hoisted_4 = {
    class: "tab-pane fade show active",
    id: "available-drivers",
    role: "tabpanel",
    "aria-labelledby": "icon-home-tab"
};
const _hoisted_5 = {
    class: "tab-pane fade",
    id: "in-progress-drivers",
    role: "tabpanel",
    "aria-labelledby": "profile-icon-tabs"
};
const _hoisted_6 = {
    class: "tab-pane fade",
    id: "unavailable-drivers",
    role: "tabpanel",
    "aria-labelledby": "contact-icon-tab"
};
const _hoisted_7 = {
    class: "tab-pane fade",
    id: "all-drivers",
    role: "tabpanel",
    "aria-labelledby": "contact-icon-tab"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
            class: "card-header card-no-border pb-0"
        }, [
            (0, _vue.createElementVNode)("h3", {
                class: "mb-3"
            }, "Drivers"),
            (0, _vue.createElementVNode)("ul", {
                class: "nav nav-tabs justify-content-evenly",
                id: "icon-tab",
                role: "tablist"
            }, [
                (0, _vue.createElementVNode)("li", {
                    class: "nav-item"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        class: "nav-link active text-success",
                        id: "available-drivers-tab",
                        "data-bs-toggle": "tab",
                        href: "#available-drivers",
                        role: "tab",
                        "aria-controls": "available-drivers",
                        "aria-selected": "true"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-regular fa-circle-check"
                        }),
                        (0, _vue.createTextVNode)(" Available ")
                    ])
                ]),
                (0, _vue.createElementVNode)("li", {
                    class: "nav-item"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        class: "nav-link text-warning",
                        id: "in-progress-drivers-tab",
                        "data-bs-toggle": "tab",
                        href: "#in-progress-drivers",
                        role: "tab",
                        "aria-controls": "in-progress-drivers",
                        "aria-selected": "false"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-spinner"
                        }),
                        (0, _vue.createTextVNode)(" In Progress ")
                    ])
                ]),
                (0, _vue.createElementVNode)("li", {
                    class: "nav-item"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        class: "nav-link text-danger",
                        id: "unavailable-drivers-tab",
                        "data-bs-toggle": "tab",
                        href: "#unavailable-drivers",
                        role: "tab",
                        "aria-controls": "unavailable-drivers",
                        "aria-selected": "false"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-ban"
                        }),
                        (0, _vue.createTextVNode)(" Unavailable ")
                    ])
                ]),
                (0, _vue.createElementVNode)("li", {
                    class: "nav-item"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        class: "nav-link text-primary",
                        id: "all-drivers-tab",
                        "data-bs-toggle": "tab",
                        href: "#all-drivers",
                        role: "tab",
                        "aria-controls": "all-drivers",
                        "aria-selected": "false"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-list"
                        }),
                        (0, _vue.createTextVNode)(" All ")
                    ])
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: $setup.availableDriversUrl
                        },
                        ref: "availableDriversTable",
                        class: "table-responsive display",
                        columns: $setup.availableColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_5, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: $setup.onRideDriversUrl
                        },
                        ref: "inProgressDriversTable",
                        class: "table-responsive display",
                        columns: $setup.onRideColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_6, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: $setup.unavailableDriversUrl
                        },
                        ref: "unavailableDriversTable",
                        class: "table-responsive display",
                        columns: $setup.unavailableColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_7, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: $setup.allDriversUrl
                        },
                        ref: "allDriversTable",
                        class: "table-responsive display",
                        columns: $setup.allColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jRF0d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hN9e8":[function(require,module,exports,__globalThis) {
/*! © SpryMedia Ltd - datatables.net/license */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _datatablesNet = require("datatables.net");
var _datatablesNetDefault = parcelHelpers.interopDefault(_datatablesNet);
// Allow reassignment of the $ variable
let $ = (0, _jqueryDefault.default);
/**
 * This data rendering helper method can be useful for cases where you have
 * potentially large data strings to be shown in a column that is restricted by
 * width. The data for the column is still fully searchable and sortable, but if
 * it is longer than a give number of characters, it will be truncated and
 * shown with ellipsis. A browser provided tooltip will show the full string
 * to the end user on mouse hover of the cell.
 *
 * This function should be used with the `dt-init columns.render` configuration
 * option of DataTables.
 *
 * It accepts three parameters:
 *
 * 1. `-type integer` - The number of characters to restrict the displayed data
 *    to.
 * 2. `-type boolean` (optional - default `false`) - Indicate if the truncation
 *    of the string should not occur in the middle of a word (`true`) or if it
 *    can (`false`). This can allow the display of strings to look nicer, at the
 *    expense of showing less characters.
 * 2. `-type boolean` (optional - default `false`) - Escape HTML entities
 *    (`true`) or not (`false` - default).
 *
 *  @name ellipsis
 *  @summary Restrict output data to a particular length, showing anything
 *      longer with ellipsis and a browser provided tooltip on hover.
 *  @author [Allan Jardine](http://datatables.net)
 *  @requires DataTables 1.10+
 *
 * @returns {Number} Calculated average
 *
 *  @example
 *    // Restrict a column to 17 characters, don't split words
 *    $('#example').DataTable( {
 *      columnDefs: [ {
 *        targets: 1,
 *        render: DataTable.render.ellipsis( 17, true )
 *      } ]
 *    } );
 *
 *  @example
 *    // Restrict a column to 10 characters, do split words
 *    $('#example').DataTable( {
 *      columnDefs: [ {
 *        targets: 2,
 *        render: DataTable.render.ellipsis( 10 )
 *      } ]
 *    } );
 */ (0, _datatablesNetDefault.default).render.ellipsis = function(cutoff, wordbreak, escapeHtml) {
    var esc = function(t) {
        return ('' + t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    return function(d, type, row) {
        // Order, search and type get the original data
        if (type !== 'display') return d;
        if (typeof d !== 'number' && typeof d !== 'string') {
            if (escapeHtml) return esc(d);
            return d;
        }
        d = d.toString(); // cast numbers
        if (d.length <= cutoff) {
            if (escapeHtml) return esc(d);
            return d;
        }
        var shortened = d.substr(0, cutoff - 1);
        // Find the last white space character in the string
        if (wordbreak) shortened = shortened.replace(/\s([^\s]*)$/, '');
        // Protect against uncontrolled HTML input
        if (escapeHtml) shortened = esc(shortened);
        return '<span class="ellipsis" title="' + esc(d) + '">' + shortened + '&#8230;</span>';
    };
};
exports.default = (0, _datatablesNetDefault.default);

},{"jquery":"11TDa","datatables.net":"kqLbm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qOgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-sm-6"
};
const _hoisted_3 = {
    class: "col-12"
};
const _hoisted_4 = {
    class: "col-sm-6"
};
const _hoisted_5 = {
    class: "col-12"
};
const _hoisted_6 = {
    class: "card height-equal-2"
};
const _hoisted_7 = {
    class: "card-body"
};
const _hoisted_8 = {
    class: "col-sm-6"
};
const _hoisted_9 = {
    class: "col-12"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                $setup.formReseter ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["DispatchForm"], {
                    key: 0,
                    onDrawDriverOnMap: $setup.findDriver,
                    "drop-off-data": $setup.dropOffData,
                    "onUpdate:dropOffData": _cache[0] || (_cache[0] = ($event)=>$setup.dropOffData = $event),
                    onResetForm: $setup.resetDispatchForm,
                    "pick-up-data": $setup.pickUpData,
                    "onUpdate:pickUpData": _cache[1] || (_cache[1] = ($event)=>$setup.pickUpData = $event),
                    "service-provider-id": $props.serviceProviderId
                }, null, 8, [
                    "drop-off-data",
                    "pick-up-data",
                    "service-provider-id"
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("div", {
            class: "col-sm-6"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "card height-equal"
                }, [
                    (0, _vue.createElementVNode)("div", {
                        id: "map",
                        style: {
                            "min-height": "inherit",
                            "width": "100%"
                        }
                    })
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_4, [
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h2", null, " Dispatch History ")
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_7, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.dispatchHistoryUrl
                            },
                            ref: "dispatchHistory",
                            class: "table-responsive display table-borderless",
                            columns: $setup.dispatchColumn
                        }, null, 8, [
                            "ajax"
                        ])
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_8, [
            (0, _vue.createElementVNode)("div", _hoisted_9, [
                (0, _vue.createVNode)($setup["DispatchDriverLists"], {
                    "service-provider-id": $props.serviceProviderId,
                    onDrawDriverOnMap: $setup.findDriver
                }, null, 8, [
                    "service-provider-id"
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxYIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7o6Mk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("15baf928eb2499a1");
    if (script.__esModule) script = script.default;
    script.render = require("53ccb494119ed20e").render;
    require("a041d95bea22faed").default(script);
    script.__scopeId = 'data-v-01edcc';
    script.__file = "AdminDashboard.vue";
};
initialize();
exports.default = script;

},{"15baf928eb2499a1":"6ZONM","53ccb494119ed20e":"1HhKw","a041d95bea22faed":"5vziA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZONM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
// Reactive state to store the service providers
exports.default = {
    __name: 'AdminDashboard',
    setup (__props, { expose: __expose }) {
        __expose();
        const serviceProviders = (0, _vue.ref)([]);
        // Fetch service providers when the component is mounted
        (0, _vue.onMounted)(async ()=>{
            try {
                const response = await fetch('/api/service-providers'); // Replace with your actual API endpoint
                if (response.ok) serviceProviders.value = await response.json();
                else console.error('Failed to fetch service providers:', response.statusText);
            } catch (error) {
                console.error('Error fetching service providers:', error);
            }
        });
        const __returned__ = {
            serviceProviders,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HhKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "page-title"
};
const _hoisted_2 = {
    class: "row"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body"
};
const _hoisted_5 = {
    class: "d-flex"
};
const _hoisted_6 = [
    "src"
];
const _hoisted_7 = {
    class: "flex-grow-1 w-100"
};
const _hoisted_8 = {
    class: "f-w-700"
};
const _hoisted_9 = [
    "href"
];
const _hoisted_10 = {
    class: "badge badge-light-success"
};
const _hoisted_11 = {
    style: {
        "margin-top": "8px"
    }
};
const _hoisted_12 = {
    class: "d-flex align-items-center gap-2"
};
const _hoisted_13 = {
    class: "recent-text"
};
const _hoisted_14 = {
    class: "d-flex align-items-center gap-2"
};
const _hoisted_15 = {
    class: "recent-text"
};
const _hoisted_16 = {
    class: "d-flex align-items-center gap-2"
};
const _hoisted_17 = {
    class: "recent-text"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[5] || (_cache[5] = (0, _vue.createStaticVNode)("<div class=\"col-md-12 project-list\"><div class=\"card\"><div class=\"row\"><div class=\"col-sm-6\"><h3>Service Provider Overview</h3></div><div class=\"col-sm-6 d-md-block\"><a class=\"btn btn-primary align-items-center\" href=\"/admin/service-provider/new\"><i class=\"fa-regular fa-square-plus\"></i> Add Service Provider </a></div></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.serviceProviders, (provider)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: provider.id,
                    class: "col-sm-6 xl-50"
                }, [
                    (0, _vue.createElementVNode)("div", _hoisted_3, [
                        (0, _vue.createElementVNode)("div", _hoisted_4, [
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-70 img-fluid m-r-20",
                                    src: `/api/service-provider/${provider.id}/logo`,
                                    alt: ""
                                }, null, 8, _hoisted_6),
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    (0, _vue.createElementVNode)("h5", _hoisted_8, [
                                        (0, _vue.createElementVNode)("a", {
                                            class: "text-primary",
                                            href: `/admin/service-provider/${provider.id}`
                                        }, (0, _vue.toDisplayString)(provider.name), 9, _hoisted_9)
                                    ]),
                                    (0, _vue.createElementVNode)("span", _hoisted_10, (0, _vue.toDisplayString)(provider.status || 'Active'), 1)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_11, [
                                (0, _vue.createElementVNode)("ul", null, [
                                    (0, _vue.createElementVNode)("li", _hoisted_12, [
                                        _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h6", null, "Available Drivers")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)(provider.availableDrivers || '0'), 1)
                                        ])
                                    ]),
                                    _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                                    (0, _vue.createElementVNode)("li", _hoisted_14, [
                                        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h6", null, "Total Rides")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)(provider.totalRides || '0'), 1)
                                        ])
                                    ]),
                                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                                    (0, _vue.createElementVNode)("li", _hoisted_16, [
                                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h6", null, "Other Statistic")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_17, [
                                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)(provider.otherStatistic || 'N/A'), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]);
            }), 128))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5vziA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26UnC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("525c0d5fd9ea031d");
    if (script.__esModule) script = script.default;
    script.render = require("5ada27a982975654").render;
    require("6f3f15407edb92c4").default(script);
    script.__scopeId = 'data-v-007e44';
    script.__file = "ServiceProviderDetail.vue";
};
initialize();
exports.default = script;

},{"525c0d5fd9ea031d":"dpV7v","5ada27a982975654":"d08Qr","6f3f15407edb92c4":"cbB2z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dpV7v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _fareConfigurationComponentVue = require("./FareConfigurationComponent.vue");
var _fareConfigurationComponentVueDefault = parcelHelpers.interopDefault(_fareConfigurationComponentVue);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _tagify = require("../../extras/js/vendors/@yaireo/tagify/dist/tagify");
var _tagifyDefault = parcelHelpers.interopDefault(_tagify);
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'ServiceProviderDetail',
    props: {
        serviceProviderId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const dispatcherDataTable = (0, _vue.ref)(null);
        const driverDataTable = (0, _vue.ref)(null);
        // Reactive variables for Service Provider
        const isNewServiceProvider = (0, _vue.ref)(props.serviceProviderId === (0, _globalsJs.newEntityId));
        const serviceProvider = (0, _vue.ref)({});
        const isEditingServiceProvider = (0, _vue.ref)(false);
        const fileUploadMap = (0, _vue.ref)({});
        const tagifyServiceAreaList = (0, _vue.ref)([]);
        const tagifyInstance = (0, _vue.ref)(null);
        const tagifyServiceAreasRef = (0, _vue.ref)(null);
        // Fetch available service areas
        const fetchServiceAreas = async ()=>{
            try {
                const response = await fetch('/api/service-area-zones');
                if (response.ok) {
                    const data = await response.json();
                    tagifyServiceAreaList.value = data.map((area)=>({
                            id: area.id,
                            value: area.name,
                            name: area.name,
                            description: area.description,
                            zoneType: area.zoneType
                        }));
                } else console.error('Failed to fetch service areas:', response.status);
            } catch (error) {
                console.error('Error fetching service areas:', error);
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Failed to load service areas',
                    icon: 'error'
                });
            }
        };
        const initializeTagify = async ()=>{
            await (0, _vue.nextTick)();
            // If Tagify is already initialized, destroy it first
            if (tagifyInstance.value) {
                tagifyInstance.value.destroy();
                tagifyInstance.value = null;
            }
            // Initialize Tagify on the service areas input
            tagifyInstance.value = new (0, _tagifyDefault.default)(tagifyServiceAreasRef.value, {
                readOnly: true,
                delimiters: null,
                templates: {
                    tag: function(tagData) {
                        try {
                            return `<tag title='${tagData.value}' contenteditable='false' spellcheck="false" class='tagify__tag ${tagData.class ? tagData.class : ""}' ${this.getAttributes(tagData)}>
                      <x title='remove tag' class='tagify__tag__removeBtn'></x>
                      <div>
                          <span class='tagify__tag-text'>${tagData.value}</span>
                      </div>
                  </tag>`;
                        } catch (err) {}
                    },
                    dropdownItem: function(tagData) {
                        try {
                            return `<div ${this.getAttributes(tagData)} class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'>
                    <span>${tagData.value}</span>
                  </div>`;
                        } catch (err) {
                            console.error(err);
                        }
                    }
                },
                maxTags: 10,
                enforceWhitelist: true,
                whitelist: tagifyServiceAreaList.value,
                dropdown: {
                    closeOnSelect: false,
                    highlightFirst: true,
                    enabled: 0,
                    classname: "extra-properties"
                }
            });
            // Set initial value if serviceProvider has serviceAreas
            if (serviceProvider.value?.state?.serviceAreas?.length) {
                const initialTags = serviceProvider.value.state.serviceAreas.map((area)=>{
                    const foundArea = tagifyServiceAreaList.value.find((a)=>a.id === area.id);
                    return foundArea ? {
                        value: foundArea.name.toString(),
                        name: foundArea.name,
                        id: foundArea.id,
                        description: foundArea.description,
                        zoneType: foundArea.zoneType
                    } : null;
                }).filter(Boolean);
                if (initialTags.length > 0) tagifyInstance.value.addTags(initialTags);
            }
            tagifyInstance.value.setReadonly(true);
            tagifyInstance.value.on("remove", updateServiceAreas);
            tagifyInstance.value.on("add", updateServiceAreas);
        };
        // Update serviceProvider.state.serviceAreas when tags change
        const updateServiceAreas = ()=>{
            if (!tagifyInstance.value || !serviceProvider.value?.state) return;
            try {
                const tags = tagifyInstance.value.value || [];
                serviceProvider.value.state.serviceAreas = tags.map((tag)=>{
                    const area = tagifyServiceAreaList.value.find((a)=>a.value.toString() === tag.value.toString());
                    return area ? {
                        id: area.id,
                        name: area.name,
                        description: area.description,
                        zoneType: area.zoneType
                    } : null;
                }).filter(Boolean);
            } catch (error) {
                console.error('Error updating service areas:', error);
            }
        };
        // Watch for changes in isEditingServiceProvider
        (0, _vue.watch)(()=>isEditingServiceProvider.value, (newVal)=>{
            if (tagifyInstance.value) tagifyInstance.value.setReadonly(!newVal);
            try {
                if (!newVal && serviceProviderAddressInput.value) $(serviceProviderAddressInput.value).autocomplete('close');
            } catch (e) {
            // ignore
            }
        });
        // Initialize everything when component is mounted
        (0, _vue.onMounted)(async ()=>{
            await fetchServiceAreas();
            // Wait a bit more for the DOM to be ready
            setTimeout(()=>{
                if (tagifyServiceAreaList.value.length > 0) initializeTagify();
            }, 100);
        });
        // Cleanup when component is unmounted
        (0, _vue.onUnmounted)(()=>{
            if (tagifyInstance.value) {
                tagifyInstance.value.destroy();
                tagifyInstance.value = null;
            }
            try {
                if (serviceProviderAddressInput.value) $(serviceProviderAddressInput.value).autocomplete('destroy');
            } catch (e) {
            // ignore
            }
        });
        // Handle logo upload
        const handleLogoUpload = async (event)=>{
            const file = event.target.files[0];
            if (!file) return;
            // Check file type
            if (!file.type.match('image.*')) {
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Please select an image file',
                    icon: 'error'
                });
                return;
            }
            // Check file size (max 5MB)
            if (file.size > 5242880) {
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'File size should not exceed 5MB',
                    icon: 'error'
                });
                return;
            }
            fileUploadMap.value["logo"] = file;
        };
        // Add a new Dispatch User
        const addDispatchUser = ()=>{
            //open in new tab
            window.open(`/service-provider/${props.serviceProviderId}/dispatch-user/new`, '_blank');
        };
        // Add a new Driver
        const addDriver = ()=>{
            //open in new tab
            window.open(`/service-provider/${props.serviceProviderId}/driver/new`, '_blank');
        };
        // Datatable columns
        const dispatcherColumns = [
            {
                data: 'fullName',
                title: 'Name'
            },
            {
                data: 'email',
                title: 'Email'
            },
            {
                data: 'isAdminUser',
                title: 'Admin User',
                render: (0, _datatableRenderer.booleanBadgeRender)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
                href="/service-provider/${props.serviceProviderId}/dispatch-user/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i> </a>`;
                }
            }
        ];
        // Driver datatable columns
        const driverColumns = [
            {
                title: "Driver",
                data: "name",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
                }
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "phoneNumber",
                title: 'Phone Number'
            },
            {
                data: "driverStatus",
                title: 'Status',
                render: (0, _datatableRenderer.driverStatus)
            },
            {
                data: "joinedOn",
                title: 'Joined At',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
              href="/service-provider/${props.serviceProviderId}/driver/${row.id}">
              Details <i class="fa-solid fa-arrow-up-right-from-square"></i> </a>`;
                }
            }
        ];
        const __returned__ = {
            props,
            dispatcherDataTable,
            driverDataTable,
            isNewServiceProvider,
            serviceProvider,
            isEditingServiceProvider,
            fileUploadMap,
            tagifyServiceAreaList,
            tagifyInstance,
            tagifyServiceAreasRef,
            fetchServiceAreas,
            initializeTagify,
            updateServiceAreas,
            handleLogoUpload,
            addDispatchUser,
            addDriver,
            dispatcherColumns,
            driverColumns,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            nextTick: (0, _vue.nextTick),
            watch: (0, _vue.watch),
            onUnmounted: (0, _vue.onUnmounted),
            EntityForm: (0, _entityFormVueDefault.default),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            FareConfigurationComponent: (0, _fareConfigurationComponentVueDefault.default),
            get booleanBadgeRender () {
                return 0, _datatableRenderer.booleanBadgeRender;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            },
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get Tagify () {
                return 0, _tagifyDefault.default;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","./EntityForm.vue":"i0zng","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","./FareConfigurationComponent.vue":"eDuJk","../utility/DatatableRenderer":"gfmyC","../../extras/js/vendors/@yaireo/tagify/dist/tagify":"j5wdA","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i0zng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("13bfac788602bd7b");
    if (script.__esModule) script = script.default;
    script.render = require("f871bcd79b5ff509").render;
    require("7a32df5e32ae4008").default(script);
    script.__scopeId = 'data-v-1b616f';
    script.__file = "EntityForm.vue";
};
initialize();
exports.default = script;

},{"13bfac788602bd7b":"ll2ET","f871bcd79b5ff509":"4BIKL","7a32df5e32ae4008":"8n9XF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ll2ET":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _modelTemplates = require("../modelTemplates/modelTemplates");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _globalsJs = require("../globals.js");
// Props
exports.default = {
    __name: 'EntityForm',
    props: {
        entityId: {
            type: String,
            required: true
        },
        apiUrl: {
            type: String,
            required: true
        },
        entity: {
            type: Object,
            required: true,
            default: null
        },
        modelConstructor: {
            type: String,
            required: true
        },
        formName: {
            type: String,
            required: true
        },
        editState: {
            type: Boolean,
            default: false
        },
        startInEdit: {
            type: Boolean,
            default: false,
            required: false
        },
        showTitle: {
            type: Boolean,
            default: false,
            required: false
        },
        redirectUrl: {
            type: String,
            required: false
        },
        onCancelCallback: {
            type: Function,
            default: null
        },
        preSave: {
            type: Function,
            default: null
        },
        postSave: {
            type: Function,
            default: null
        },
        fileUploadMap: {
            type: Object,
            default: ()=>({}),
            required: false
        },
        lockEditing: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'update:entity',
        'update:editState',
        'update:entityId'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        // Emitters
        const emit = __emit;
        // Reactive state
        const isEditMode = (0, _vue.ref)(false);
        const isReadOnly = (0, _vue.ref)(false);
        const internalEntityId = (0, _vue.ref)(props.entityId);
        const isNew = (0, _vue.ref)(props.entityId === (0, _globalsJs.newEntityId));
        const originalState = (0, _vue.ref)({});
        // Methods
        const fetchEntity = async ()=>{
            try {
                const response = await fetch(`${props.apiUrl}/${internalEntityId.value}`);
                if (!response.ok) throw new Error(`Failed to fetch ${props.formName}: ${response.statusText}`);
                const data = await response.json();
                Object.keys(data).forEach((key)=>{
                    if (key in props.entity.state) props.entity.state[key] = data[key];
                });
                originalState.value = JSON.parse(JSON.stringify(props.entity.state));
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: `Encountered an error loading ${props.formName}.`,
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
                console.error(`Failed to fetch ${props.formName}`, error);
            }
        };
        const handleSubmit = async ()=>{
            try {
                if (props.preSave) props.preSave();
                const payload = {
                    ...props.entity.state
                };
                if (props.entity.isValid()) {
                    let response;
                    const url = isNew.value ? `${props.apiUrl}` : `${props.apiUrl}/${internalEntityId.value}`;
                    // Check if we have files to upload
                    if (props.fileUploadMap && Object.keys(props.fileUploadMap).length > 0) {
                        // Use FormData for file uploads
                        const formData = new FormData();
                        // Add the entity data as a JSON string in a field called 'data'
                        formData.append('data', JSON.stringify(payload));
                        // Add each file to the form data
                        for (const [key, file] of Object.entries(props.fileUploadMap))formData.append(key, file);
                        // Send the request with FormData
                        const requestOptions = {
                            method: isNew.value ? 'POST' : 'PUT',
                            body: formData
                        };
                        response = await fetch(url, requestOptions);
                    } else {
                        // No files, use JSON
                        const requestOptions = {
                            method: isNew.value ? 'POST' : 'PUT',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        };
                        response = await fetch(url, requestOptions);
                    }
                    if (!response.ok) {
                        let message = '';
                        if (response.text) message = await response.text();
                        else message = `Encountered an error saving ${props.formName}. Please try again.`;
                        (0, _toastNotificationUtility.showToast)({
                            title: 'Submission Error',
                            body: message,
                            type: 'error',
                            delay: 5000
                        });
                        return;
                    }
                    const responseData = await response.json();
                    isReadOnly.value = true;
                    isEditMode.value = false;
                    emit("update:editState", false);
                    //notify
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: `Successfully saved ${props.formName}.`,
                        type: 'success'
                    });
                    await fetchEntity(); // Refresh the entity data
                    if (isNew.value) {
                        internalEntityId.value = responseData.id;
                        emit('update:entityId', internalEntityId.value);
                        if (props.postSave) props.postSave(responseData);
                        if (props.redirectUrl) window.location.href = `${props.redirectUrl}/${internalEntityId.value}`;
                    } else if (props.postSave) props.postSave(responseData);
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: `Encountered an internal error. Please contact support.`,
                    type: 'error',
                    delay: 7000
                });
                console.error(`Failed to submit ${props.formName}`, error);
            }
        };
        const enableEditMode = ()=>{
            isEditMode.value = true;
            isReadOnly.value = false;
            emit("update:editState", true);
        };
        const cancelEdit = ()=>{
            props.entity.state = JSON.parse(JSON.stringify(originalState.value));
            isReadOnly.value = true;
            isEditMode.value = false;
            emit("update:editState", false);
            if (props.onCancelCallback) props.onCancelCallback();
        };
        // Initialization
        (0, _vue.onBeforeMount)(async ()=>{
            emit('update:entity', (0, _modelTemplates.Model)(props.modelConstructor).call({}));
            if (!isNew.value) {
                await fetchEntity();
                isReadOnly.value = true;
            } else isEditMode.value = true;
            if (props.startInEdit) {
                isEditMode.value = props.startInEdit;
                isReadOnly.value = !props.startInEdit;
            }
            emit("update:editState", isEditMode.value);
            if (!isNew.value) originalState.value = JSON.parse(JSON.stringify(props.entity.state));
        });
        const __returned__ = {
            props,
            emit,
            isEditMode,
            isReadOnly,
            internalEntityId,
            isNew,
            originalState,
            fetchEntity,
            handleSubmit,
            enableEditMode,
            cancelEdit,
            ref: (0, _vue.ref),
            onBeforeMount: (0, _vue.onBeforeMount),
            get Model () {
                return 0, _modelTemplates.Model;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../modelTemplates/modelTemplates":"dN207","../utility/toastNotificationUtility":"krOtg","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dN207":[function(require,module,exports,__globalThis) {
// Import all model templates
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A function to return a model based on the model name
parcelHelpers.export(exports, "Model", ()=>Model);
var _serviceProvider = require("./ServiceProvider");
var _serviceProviderDefault = parcelHelpers.interopDefault(_serviceProvider);
var _dispatchUser = require("./DispatchUser");
var _dispatchUserDefault = parcelHelpers.interopDefault(_dispatchUser);
var _myProfile = require("./MyProfile");
var _myProfileDefault = parcelHelpers.interopDefault(_myProfile);
var _driver = require("./Driver");
var _driverDefault = parcelHelpers.interopDefault(_driver);
var _fareConfiguration = require("./FareConfiguration");
var _fareConfigurationDefault = parcelHelpers.interopDefault(_fareConfiguration);
var _geoZone = require("./GeoZone");
var _geoZoneDefault = parcelHelpers.interopDefault(_geoZone);
var _account = require("./Account");
var _accountDefault = parcelHelpers.interopDefault(_account);
var _serviceJurisdiction = require("./ServiceJurisdiction");
var _serviceJurisdictionDefault = parcelHelpers.interopDefault(_serviceJurisdiction);
var _shift = require("./Shift");
var _shiftDefault = parcelHelpers.interopDefault(_shift);
function Model(modelName) {
    switch(modelName){
        case 'ServiceProvider':
            return 0, _serviceProviderDefault.default;
        case 'DispatchUser':
            return 0, _dispatchUserDefault.default;
        case 'MyProfile':
            return 0, _myProfileDefault.default;
        case 'Driver':
            return 0, _driverDefault.default;
        case 'FareConfiguration':
            return 0, _fareConfigurationDefault.default;
        case 'GeoZone':
            return 0, _geoZoneDefault.default;
        case 'Account':
            return 0, _accountDefault.default;
        case 'ServiceJurisdiction':
            return 0, _serviceJurisdictionDefault.default;
        case 'Shift':
            return 0, _shiftDefault.default;
        default:
            throw new Error(`Unknown model name: ${modelName}`);
    }
}

},{"./ServiceProvider":"4DsIF","./DispatchUser":"gzDmY","./MyProfile":"3A8a7","./Driver":"jvaPp","./FareConfiguration":"3RcKz","./GeoZone":"jsOyO","./Account":"juvFT","./ServiceJurisdiction":"cUpxQ","./Shift":"bfl9A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4DsIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ServiceProvider);
var _vue = require("vue");
function ServiceProvider(data = {}) {
    // Reactive state for service provider fields
    const state = (0, _vue.reactive)({
        id: data.id || '',
        name: data.name || '',
        address: data.address || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || '',
        dispatchEnabled: data.dispatchEnabled || false,
        contactPersonName: data.contactPersonName || '',
        contactPersonPhone: data.contactPersonPhone || '',
        contactPersonEmail: data.contactPersonEmail || '',
        operatingHours: data.operatingHours || '',
        logoUrl: data.logoUrl || '',
        serviceAreas: data.serviceAreas || [],
        serviceAreaAllowance: data.serviceAreaAllowance || 5.0
    });
    // Computed properties for validations
    const validations = {
        isNameValid: (0, _vue.computed)(()=>!!state.name.trim()),
        isAddressValid: (0, _vue.computed)(()=>!!state.address.trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)),
        isPhoneNumberValid: (0, _vue.computed)(()=>/^\+?[0-9\s-]{7,15}$/.test(state.phoneNumber)),
        isContactPersonNameValid: (0, _vue.computed)(()=>!!state.contactPersonName.trim()),
        isContactPersonPhoneValid: (0, _vue.computed)(()=>/^\+?[0-9\s-]{7,15}$/.test(state.contactPersonPhone)),
        isContactPersonEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.contactPersonEmail)),
        isServiceAreaAllowanceValid: (0, _vue.computed)(()=>{
            const allowance = parseFloat(state.serviceAreaAllowance);
            return !isNaN(allowance) && allowance > 0 && allowance <= 10;
        })
    };
    // Individual field validation functions
    const validateName = ()=>{
        if (validations.isNameValid.value) {
            $('#service-provider-name-input').removeClass('is-invalid');
            $('#service-provider-name-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-name-input').addClass('is-invalid');
            $('#service-provider-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateAddress = ()=>{
        if (validations.isAddressValid.value) {
            $('#service-provider-address-input').removeClass('is-invalid');
            $('#service-provider-address-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-address-input').addClass('is-invalid');
            $('#service-provider-address-error').removeClass('d-none');
            return false;
        }
    };
    const validateEmail = ()=>{
        if (validations.isEmailValid.value) {
            $('#service-provider-email-input').removeClass('is-invalid');
            $('#service-provider-email-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-email-input').addClass('is-invalid');
            $('#service-provider-email-error').removeClass('d-none');
            return false;
        }
    };
    const validatePhoneNumber = ()=>{
        if (validations.isPhoneNumberValid.value) {
            $('#service-provider-phone-number-input').removeClass('is-invalid');
            $('#service-provider-phone-number-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-phone-number-input').addClass('is-invalid');
            $('#service-provider-phone-number-error').removeClass('d-none');
            return false;
        }
    };
    const validateContactPersonName = ()=>{
        if (validations.isContactPersonNameValid.value) {
            $('#service-provider-contact-name-input').removeClass('is-invalid');
            $('#service-provider-contact-name-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-contact-name-input').addClass('is-invalid');
            $('#service-provider-contact-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateContactPersonPhone = ()=>{
        if (validations.isContactPersonPhoneValid.value) {
            $('#service-provider-contact-phone-input').removeClass('is-invalid');
            $('#service-provider-contact-phone-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-contact-phone-input').addClass('is-invalid');
            $('#service-provider-contact-phone-error').removeClass('d-none');
            return false;
        }
    };
    const validateContactPersonEmail = ()=>{
        if (validations.isContactPersonEmailValid.value) {
            $('#service-provider-contact-email-input').removeClass('is-invalid');
            $('#service-provider-contact-email-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-contact-email-input').addClass('is-invalid');
            $('#service-provider-contact-email-error').removeClass('d-none');
            return false;
        }
    };
    const validateServiceAreaAllowance = ()=>{
        if (validations.isServiceAreaAllowanceValid.value) {
            $('#service-provider-service-area-allowance-input').removeClass('is-invalid');
            $('#service-provider-service-area-allowance-error').addClass('d-none');
            return true;
        } else {
            $('#service-provider-service-area-allowance-input').addClass('is-invalid');
            $('#service-provider-service-area-allowance-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.name, validateName);
    (0, _vue.watch)(()=>state.address, validateAddress);
    (0, _vue.watch)(()=>state.email, validateEmail);
    (0, _vue.watch)(()=>state.phoneNumber, validatePhoneNumber);
    (0, _vue.watch)(()=>state.contactPersonName, validateContactPersonName);
    (0, _vue.watch)(()=>state.contactPersonPhone, validateContactPersonPhone);
    (0, _vue.watch)(()=>state.contactPersonEmail, validateContactPersonEmail);
    (0, _vue.watch)(()=>state.serviceAreaAllowance, validateServiceAreaAllowance);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isNameValid = validateName();
        let isAddressValid = validateAddress();
        let isEmailValid = validateEmail();
        let isPhoneNumberValid = validatePhoneNumber();
        let isContactPersonNameValid = validateContactPersonName();
        let isContactPersonPhoneValid = validateContactPersonPhone();
        let isContactPersonEmailValid = validateContactPersonEmail();
        let isServiceAreaAllowanceValid = validateServiceAreaAllowance();
        return isNameValid && isAddressValid && isEmailValid && isPhoneNumberValid && isContactPersonNameValid && isContactPersonPhoneValid && isContactPersonEmailValid && isServiceAreaAllowanceValid;
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.name) validateName();
        if (state.address) validateAddress();
        if (state.email) validateEmail();
        if (state.phoneNumber) validatePhoneNumber();
        if (state.contactPersonName) validateContactPersonName();
        if (state.contactPersonPhone) validateContactPersonPhone();
        if (state.contactPersonEmail) validateContactPersonEmail();
        if (state.serviceAreaAllowance) validateServiceAreaAllowance();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzDmY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DispatchUser);
var _vue = require("vue");
function DispatchUser(data = {}) {
    // Reactive state for dispatch user fields
    const state = (0, _vue.reactive)({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || '',
        isAdminUser: data.isAdminUser || false
    });
    // Computed properties for validations
    const validations = {
        isLastNameValid: (0, _vue.computed)(()=>!!state.lastName.trim()),
        isFirstNameValid: (0, _vue.computed)(()=>!!state.firstName.trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)),
        isPhoneNumberValid: (0, _vue.computed)(()=>!state.phoneNumber || /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(state.phoneNumber))
    };
    // Individual field validation functions
    const validateLastName = ()=>{
        if (validations.isLastNameValid.value) {
            $('#dispatch-user-last-name-input').removeClass('is-invalid');
            $('#dispatch-user-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-last-name-input').addClass('is-invalid');
            $('#dispatch-user-last-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateFirstName = ()=>{
        if (validations.isFirstNameValid.value) {
            $('#dispatch-user-first-name-input').removeClass('is-invalid');
            $('#dispatch-user-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-first-name-input').addClass('is-invalid');
            $('#dispatch-user-first-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateEmail = ()=>{
        if (validations.isEmailValid.value) {
            $('#dispatch-user-email-input').removeClass('is-invalid');
            $('#dispatch-user-email-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-email-input').addClass('is-invalid');
            $('#dispatch-user-email-error').removeClass('d-none');
            return false;
        }
    };
    const validatePhoneNumber = ()=>{
        if (validations.isPhoneNumberValid.value) {
            $('#dispatch-user-phone-number-input').removeClass('is-invalid');
            $('#dispatch-user-phone-number-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-phone-number-input').addClass('is-invalid');
            $('#dispatch-user-phone-number-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.lastName, validateLastName);
    (0, _vue.watch)(()=>state.firstName, validateFirstName);
    (0, _vue.watch)(()=>state.email, validateEmail);
    (0, _vue.watch)(()=>state.phoneNumber, validatePhoneNumber);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();
        let isPhoneNumberValid = validatePhoneNumber();
        return isLastNameValid && isFirstNameValid && isEmailValid && isPhoneNumberValid;
    };
    const clearFields = ()=>{
        state.lastName = '';
        state.firstName = '';
        state.id = '';
        state.email = '';
        state.phoneNumber = '';
        state.serviceProvider = undefined;
        state.isAdminUser = false;
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
        if (state.phoneNumber) validatePhoneNumber();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        clearFields,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3A8a7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MyProfile);
var _vue = require("vue");
function MyProfile(data = {}) {
    // Reactive state for dispatch user fields
    const state = (0, _vue.reactive)({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || ''
    });
    // Computed properties for validations
    const validations = {
        isLastNameValid: (0, _vue.computed)(()=>!!state.lastName.trim()),
        isFirstNameValid: (0, _vue.computed)(()=>!!state.firstName.trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email))
    };
    // Individual field validation functions
    const validateLastName = ()=>{
        if (validations.isLastNameValid.value) {
            $('#profile-last-name-input').removeClass('is-invalid');
            $('#profile-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#profile-last-name-input').addClass('is-invalid');
            $('#profile-last-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateFirstName = ()=>{
        if (validations.isFirstNameValid.value) {
            $('#profile-first-name-input').removeClass('is-invalid');
            $('#profile-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#profile-first-name-input').addClass('is-invalid');
            $('#profile-first-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateEmail = ()=>{
        if (validations.isEmailValid.value) {
            $('#profile-email-input').removeClass('is-invalid');
            $('#profile-email-error').addClass('d-none');
            return true;
        } else {
            $('#profile-email-input').addClass('is-invalid');
            $('#profile-email-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.lastName, validateLastName);
    (0, _vue.watch)(()=>state.firstName, validateFirstName);
    (0, _vue.watch)(()=>state.email, validateEmail);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();
        return isLastNameValid && isFirstNameValid && isEmailValid;
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jvaPp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Driver);
var _vue = require("vue");
function Driver(data = {}) {
    const state = (0, _vue.reactive)({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || '',
        address: data.address || '',
        city: data.city || '',
        state: data.state || '',
        zipCode: data.zipCode || '',
        country: data.country || ''
    });
    // Computed properties for validations
    const validations = {
        isLastNameValid: (0, _vue.computed)(()=>!!state.lastName.trim()),
        isFirstNameValid: (0, _vue.computed)(()=>!!state.firstName.trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)),
        isPhoneNumberValid: (0, _vue.computed)(()=>/^\+?[0-9]{10,15}$/.test(state.phoneNumber))
    };
    // Individual field validation functions
    const validateLastName = ()=>{
        if (validations.isLastNameValid.value) {
            $('#driver-last-name-input').removeClass('is-invalid');
            $('#driver-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#driver-last-name-input').addClass('is-invalid');
            $('#driver-last-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateFirstName = ()=>{
        if (validations.isFirstNameValid.value) {
            $('#driver-first-name-input').removeClass('is-invalid');
            $('#driver-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#driver-first-name-input').addClass('is-invalid');
            $('#driver-first-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateEmail = ()=>{
        if (validations.isEmailValid.value) {
            $('#driver-email-input').removeClass('is-invalid');
            $('#driver-email-error').addClass('d-none');
            return true;
        } else {
            $('#driver-email-input').addClass('is-invalid');
            $('#driver-email-error').removeClass('d-none');
            return false;
        }
    };
    const validatePhoneNumber = ()=>{
        if (validations.isPhoneNumberValid.value) {
            $('#driver-phone-number-input').removeClass('is-invalid');
            $('#driver-phone-number-error').addClass('d-none');
            return true;
        } else {
            $('#driver-phone-number-input').addClass('is-invalid');
            $('#driver-phone-number-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.lastName, validateLastName);
    (0, _vue.watch)(()=>state.firstName, validateFirstName);
    (0, _vue.watch)(()=>state.email, validateEmail);
    (0, _vue.watch)(()=>state.phoneNumber, validatePhoneNumber);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();
        let isPhoneNumberValid = validatePhoneNumber();
        return isLastNameValid && isFirstNameValid && isEmailValid && isPhoneNumberValid;
    };
    const clearFields = ()=>{
        state.lastName = '';
        state.firstName = '';
        state.id = '';
        state.email = '';
        state.phoneNumber = '';
        state.address = '';
        state.city = '';
        state.state = '';
        state.zipCode = '';
        state.country = '';
        state.serviceProvider = undefined;
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
        if (state.phoneNumber) validatePhoneNumber();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        clearFields,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3RcKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FareConfiguration);
var _vue = require("vue");
var _globalsJs = require("../globals.js");
/**
 * Whether a numeric form field holds a usable non-negative number.
 *
 * A cleared `<input type="number">` yields '' rather than null, and `'' >= 0` coerces to true — so a
 * plain comparison marks an emptied money field as valid and lets it be saved as nothing at all.
 */ const isNonNegativeNumber = (value)=>value !== '' && value !== null && value !== undefined && !Number.isNaN(Number(value)) && Number(value) >= 0;
function FareConfiguration(data = {}) {
    const state = (0, _vue.reactive)({
        id: data.id || '',
        currency: data.currency || 'CAD',
        isActive: data.isActive !== undefined ? data.isActive : true,
        serviceProviderId: data.serviceProviderId || '',
        freeStopWaitingMinutes: data.freeStopWaitingMinutes || 0,
        stopPerMinuteCharge: data.stopPerMinuteCharge || 0,
        perStopCharge: data.perStopCharge || 0,
        platformFee: data.platformFee !== undefined ? data.platformFee : 0.69,
        platformFeePerKm: data.platformFeePerKm !== undefined && data.platformFeePerKm !== null ? data.platformFeePerKm : 0,
        platformFeeMinimum: data.platformFeeMinimum !== undefined && data.platformFeeMinimum !== null ? data.platformFeeMinimum : 0,
        platformFeeMaximum: data.platformFeeMaximum !== undefined ? data.platformFeeMaximum : null,
        scheduledRideFee: data.scheduledRideFee !== undefined ? data.scheduledRideFee : 0,
        perMinuteFare: data.perMinuteFare !== undefined ? data.perMinuteFare : 0,
        minimumFare: data.minimumFare !== undefined ? data.minimumFare : 0,
        // Null is the corrected behaviour, not the old one: a row written before the column existed
        // reads back null, and the server reads null the same way.
        minimumAppliesToFareOnly: data.minimumAppliesToFareOnly !== undefined && data.minimumAppliesToFareOnly !== null ? data.minimumAppliesToFareOnly : true,
        perAdditionalPassengerCharge: data.perAdditionalPassengerCharge !== undefined ? data.perAdditionalPassengerCharge : 0,
        additionalPassengerMaxCharge: data.additionalPassengerMaxCharge !== undefined ? data.additionalPassengerMaxCharge : 0,
        additionalPassengerFreeUnderAge: data.additionalPassengerFreeUnderAge !== undefined ? data.additionalPassengerFreeUnderAge : null,
        vehicleBaseFareConfigs: data.vehicleBaseFareConfigs || [],
        distanceFareConfigs: data.distanceFareConfigs || [],
        geoZoneFareConfigs: data.geoZoneFareConfigs || []
    });
    const validations = {
        isCurrencyValid: (0, _vue.computed)(()=>!!state.currency.trim()),
        isVehicleBaseFareConfigValid: (0, _vue.computed)(()=>{
            if (state.vehicleBaseFareConfigs.length === 0) return true;
            return state.vehicleBaseFareConfigs.every((pricing)=>pricing.vehicleType && pricing.baseFare >= 0);
        }),
        isDistanceFareConfigValid: (0, _vue.computed)(()=>{
            if (state.distanceFareConfigs.length === 0) return true;
            return state.distanceFareConfigs.every((range)=>{
                const basicValid = range.startDistanceMeters >= 0 && range.rateAmount >= 0;
                if (range.isOpenEnded) return basicValid;
                return basicValid && range.endDistanceMeters > range.startDistanceMeters;
            });
        }),
        areGeoZoneFareConfigValid: (0, _vue.computed)(()=>{
            if (state.geoZoneFareConfigs.length === 0) return true;
            return state.geoZoneFareConfigs.every((zone)=>zone.geoZone && zone.applicationType);
        }),
        isFreeStopWaitingMinutesValid: (0, _vue.computed)(()=>state.freeStopWaitingMinutes >= 0),
        isStopPerMinuteChargeValid: (0, _vue.computed)(()=>state.stopPerMinuteCharge >= 0),
        isPerStopChargeValid: (0, _vue.computed)(()=>state.perStopCharge >= 0),
        isPlatformFeeValid: (0, _vue.computed)(()=>state.platformFee >= 0),
        // Cleared fields are invalid rather than silently zero: emptying the rate switches the
        // distance-scaled fee off entirely, which is too consequential to happen by accident.
        isPlatformFeePerKmValid: (0, _vue.computed)(()=>isNonNegativeNumber(state.platformFeePerKm)),
        isPlatformFeeMinimumValid: (0, _vue.computed)(()=>isNonNegativeNumber(state.platformFeeMinimum)),
        isPlatformFeeMaximumValid: (0, _vue.computed)(()=>{
            // An empty maximum is the one legitimate blank: it means uncapped.
            if (state.platformFeeMaximum === null || state.platformFeeMaximum === '' || state.platformFeeMaximum === undefined) return true;
            if (Number.isNaN(Number(state.platformFeeMaximum))) return false;
            if (Number(state.platformFeeMaximum) < 0) return false;
            // A maximum of 0 means uncapped, so only a positive cap is compared to the minimum.
            if (Number(state.platformFeeMaximum) === 0) return true;
            return Number(state.platformFeeMaximum) >= Number(state.platformFeeMinimum || 0);
        }),
        // Advisory only: deliberately excluded from isValid() so a below-floor rate still saves.
        isPlatformFeePerKmBelowFloor: (0, _vue.computed)(()=>Number(state.platformFeePerKm) > 0 && Number(state.platformFeePerKm) < (0, _globalsJs.PLATFORM_FEE_PER_KM_FLOOR)),
        isScheduledRideFeeValid: (0, _vue.computed)(()=>state.scheduledRideFee >= 0),
        isPerMinuteFareValid: (0, _vue.computed)(()=>state.perMinuteFare >= 0),
        isMinimumFareValid: (0, _vue.computed)(()=>state.minimumFare >= 0),
        isPerAdditionalPassengerChargeValid: (0, _vue.computed)(()=>state.perAdditionalPassengerCharge >= 0),
        isAdditionalPassengerMaxChargeValid: (0, _vue.computed)(()=>state.additionalPassengerMaxCharge >= 0),
        isAdditionalPassengerFreeUnderAgeValid: (0, _vue.computed)(()=>state.additionalPassengerFreeUnderAge === null || state.additionalPassengerFreeUnderAge === '' || Number.isInteger(Number(state.additionalPassengerFreeUnderAge)) && Number(state.additionalPassengerFreeUnderAge) >= 0)
    };
    const validateCurrency = ()=>{
        if (validations.isCurrencyValid.value) {
            $('#fare-config-currency').removeClass('is-invalid');
            $('#fare-config-currency-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-currency').addClass('is-invalid');
            $('#fare-config-currency-error').removeClass('d-none');
            return false;
        }
    };
    const validateFreeStopWaitingMinutes = ()=>{
        if (validations.isFreeStopWaitingMinutesValid.value) {
            $('#fare-config-free-waiting-minutes').removeClass('is-invalid');
            $('#fare-config-free-waiting-minutes-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-free-waiting-minutes').addClass('is-invalid');
            $('#fare-config-free-waiting-minutes-error').removeClass('d-none');
            return false;
        }
    };
    const validateStopPerMinuteCharge = ()=>{
        if (validations.isStopPerMinuteChargeValid.value) {
            $('#fare-config-per-minute-charge').removeClass('is-invalid');
            $('#fare-config-per-minute-charge-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-per-minute-charge').addClass('is-invalid');
            $('#fare-config-per-minute-charge-error').removeClass('d-none');
            return false;
        }
    };
    const validatePerStopCharge = ()=>{
        if (validations.isPerStopChargeValid.value) {
            $('#fare-config-per-stop-charge').removeClass('is-invalid');
            $('#fare-config-per-stop-charge-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-per-stop-charge').addClass('is-invalid');
            $('#fare-config-per-stop-charge-error').removeClass('d-none');
            return false;
        }
    };
    const validatePlatformFee = ()=>{
        if (validations.isPlatformFeeValid.value) {
            $('#fare-config-platform-fee').removeClass('is-invalid');
            $('#fare-config-platform-fee-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-platform-fee').addClass('is-invalid');
            $('#fare-config-platform-fee-error').removeClass('d-none');
            return false;
        }
    };
    /**
     * Whether the configured per-km platform fee sits below the policy floor.
     *
     * Exposed as a function rather than only as the computed above because consumers hold this model
     * inside a `ref()`, and a reactive proxy silently unwraps a nested computed — so reading
     * `validations.isPlatformFeePerKmBelowFloor.value` through the proxy yields undefined.
     */ const isPlatformFeePerKmBelowFloor = ()=>validations.isPlatformFeePerKmBelowFloor.value;
    const validatePlatformFeePerKm = ()=>{
        if (validations.isPlatformFeePerKmValid.value) {
            $('#fare-config-platform-fee-per-km').removeClass('is-invalid');
            $('#fare-config-platform-fee-per-km-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-platform-fee-per-km').addClass('is-invalid');
            $('#fare-config-platform-fee-per-km-error').removeClass('d-none');
            return false;
        }
    };
    const validatePlatformFeeMinimum = ()=>{
        if (validations.isPlatformFeeMinimumValid.value) {
            $('#fare-config-platform-fee-minimum').removeClass('is-invalid');
            $('#fare-config-platform-fee-minimum-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-platform-fee-minimum').addClass('is-invalid');
            $('#fare-config-platform-fee-minimum-error').removeClass('d-none');
            return false;
        }
    };
    const validatePlatformFeeMaximum = ()=>{
        if (validations.isPlatformFeeMaximumValid.value) {
            $('#fare-config-platform-fee-maximum').removeClass('is-invalid');
            $('#fare-config-platform-fee-maximum-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-platform-fee-maximum').addClass('is-invalid');
            $('#fare-config-platform-fee-maximum-error').removeClass('d-none');
            return false;
        }
    };
    const validateScheduledRideFee = ()=>{
        if (validations.isScheduledRideFeeValid.value) {
            $('#fare-config-scheduled-ride-fee').removeClass('is-invalid');
            $('#fare-config-scheduled-ride-fee-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-scheduled-ride-fee').addClass('is-invalid');
            $('#fare-config-scheduled-ride-fee-error').removeClass('d-none');
            return false;
        }
    };
    const validatePerMinuteFare = ()=>{
        if (validations.isPerMinuteFareValid.value) {
            $('#fare-config-per-minute-fare').removeClass('is-invalid');
            $('#fare-config-per-minute-fare-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-per-minute-fare').addClass('is-invalid');
            $('#fare-config-per-minute-fare-error').removeClass('d-none');
            return false;
        }
    };
    const validateMinimumFare = ()=>{
        if (validations.isMinimumFareValid.value) {
            $('#fare-config-minimum-fare').removeClass('is-invalid');
            $('#fare-config-minimum-fare-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-minimum-fare').addClass('is-invalid');
            $('#fare-config-minimum-fare-error').removeClass('d-none');
            return false;
        }
    };
    const validatePerAdditionalPassengerCharge = ()=>{
        if (validations.isPerAdditionalPassengerChargeValid.value) {
            $('#fare-config-per-additional-passenger-charge').removeClass('is-invalid');
            $('#fare-config-per-additional-passenger-charge-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-per-additional-passenger-charge').addClass('is-invalid');
            $('#fare-config-per-additional-passenger-charge-error').removeClass('d-none');
            return false;
        }
    };
    const validateAdditionalPassengerMaxCharge = ()=>{
        if (validations.isAdditionalPassengerMaxChargeValid.value) {
            $('#fare-config-additional-passenger-max-charge').removeClass('is-invalid');
            $('#fare-config-additional-passenger-max-charge-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-additional-passenger-max-charge').addClass('is-invalid');
            $('#fare-config-additional-passenger-max-charge-error').removeClass('d-none');
            return false;
        }
    };
    const validateAdditionalPassengerFreeUnderAge = ()=>{
        if (validations.isAdditionalPassengerFreeUnderAgeValid.value) {
            $('#fare-config-additional-passenger-free-under-age').removeClass('is-invalid');
            $('#fare-config-additional-passenger-free-under-age-error').addClass('d-none');
            return true;
        } else {
            $('#fare-config-additional-passenger-free-under-age').addClass('is-invalid');
            $('#fare-config-additional-passenger-free-under-age-error').removeClass('d-none');
            return false;
        }
    };
    const validateVehicleBaseFareConfig = (basePrice)=>{
        if (!basePrice.vehicleType) return {
            isValid: false,
            message: 'Please select a vehicle type.'
        };
        if (basePrice.baseFare < 0 || basePrice.minimumFare < 0 || basePrice.maximumFare < 0) return {
            isValid: false,
            message: 'Fare values cannot be negative.'
        };
        if (parseFloat(basePrice.minimumFare) > parseFloat(basePrice.maximumFare) && parseFloat(basePrice.maximumFare) > 0) return {
            isValid: false,
            message: 'Minimum fare cannot be greater than maximum fare.'
        };
        return {
            isValid: true
        };
    };
    const checkDuplicateVehicleType = (vehicleType, currentIndex = -1)=>{
        const existingIndex = state.vehicleBaseFareConfigs.findIndex((pricing, index)=>index !== currentIndex && pricing.vehicleType === vehicleType);
        if (existingIndex !== -1) return {
            isDuplicate: true,
            message: `A base price for ${vehicleType} already exists.`
        };
        return {
            isDuplicate: false
        };
    };
    const validateDistancePricing = (distancePricing)=>{
        if (!distancePricing.rateType) return {
            isValid: false,
            message: 'Please select a rate type.'
        };
        if (distancePricing.startDistanceMeters < 0 || distancePricing.endDistanceMeters < 0 || distancePricing.rateAmount < 0) return {
            isValid: false,
            message: 'Values cannot be negative.'
        };
        if (!distancePricing.isOpenEnded) {
            if (parseInt(distancePricing.startDistanceMeters) >= parseInt(distancePricing.endDistanceMeters)) return {
                isValid: false,
                message: 'Start distance must be less than end distance.'
            };
        }
        if (distancePricing.isStartingRange && distancePricing.startDistanceMeters !== 0) return {
            isValid: false,
            message: 'A starting range must start at 0 meters.'
        };
        return {
            isValid: true
        };
    };
    const checkOverlappingDistanceFareConfig = (distancePricing, currentIndex = -1)=>{
        if (distancePricing.isStartingRange) {
            const existingStartingRangeIndex = state.distanceFareConfigs.findIndex((range, index)=>index !== currentIndex && range.isStartingRange);
            if (existingStartingRangeIndex !== -1) return {
                isOverlapping: true,
                message: 'A starting range already exists. Only one starting range is allowed.'
            };
        }
        if (distancePricing.isOpenEnded) {
            const existingOpenEndedIndex = state.distanceFareConfigs.findIndex((range, index)=>index !== currentIndex && range.isOpenEnded);
            if (existingOpenEndedIndex !== -1) return {
                isOverlapping: true,
                message: 'An open-ended range already exists. Only one open-ended range is allowed.'
            };
            const overlappingStartIndex = state.distanceFareConfigs.findIndex((range, index)=>index !== currentIndex && distancePricing.startDistanceMeters >= range.startDistanceMeters && distancePricing.startDistanceMeters < range.endDistanceMeters);
            if (overlappingStartIndex !== -1) return {
                isOverlapping: true,
                message: 'The starting point of this open-ended range overlaps with an existing range.'
            };
        } else {
            const existingIndex = state.distanceFareConfigs.findIndex((range, index)=>index !== currentIndex && !range.isOpenEnded && (distancePricing.startDistanceMeters >= range.startDistanceMeters && distancePricing.startDistanceMeters < range.endDistanceMeters || distancePricing.endDistanceMeters > range.startDistanceMeters && distancePricing.endDistanceMeters <= range.endDistanceMeters || distancePricing.startDistanceMeters <= range.startDistanceMeters && distancePricing.endDistanceMeters >= range.endDistanceMeters));
            if (existingIndex !== -1) return {
                isOverlapping: true,
                message: `A distance range overlapping with ${distancePricing.startDistanceMeters}-${distancePricing.endDistanceMeters} meters already exists.`
            };
            const openEndedIndex = state.distanceFareConfigs.findIndex((range, index)=>index !== currentIndex && range.isOpenEnded && distancePricing.startDistanceMeters >= range.startDistanceMeters);
            if (openEndedIndex !== -1) return {
                isOverlapping: true,
                message: 'This range overlaps with an existing open-ended range.'
            };
        }
        return {
            isOverlapping: false
        };
    };
    const validateGeoZone = (geoZone)=>{
        if (!geoZone.geoZone) return {
            isValid: false,
            message: 'Please select a geo zone.'
        };
        if (!geoZone.applicationType) return {
            isValid: false,
            message: 'Please select an application type.'
        };
        if (!geoZone.zoneRateType) return {
            isValid: false,
            message: 'Please select a zone rate type.'
        };
        if (geoZone.zoneRateType === 'SURCHARGE' && (geoZone.surcharge === null || geoZone.surcharge < 0)) return {
            isValid: false,
            message: 'Surcharge cannot be negative.'
        };
        if (geoZone.zoneRateType === 'PERCENTAGE' && (geoZone.percentage === null || geoZone.percentage < 0)) return {
            isValid: false,
            message: 'Percentage cannot be negative.'
        };
        if (geoZone.zoneRateType === 'FLAT_FARE' && (geoZone.flatFare === null || geoZone.flatFare < 0)) return {
            isValid: false,
            message: 'Flat fare cannot be negative.'
        };
        if (geoZone.zoneRateType === 'PER_KM' && (geoZone.zonePerKmRate === null || geoZone.zonePerKmRate < 0)) return {
            isValid: false,
            message: 'Per-km rate cannot be negative.'
        };
        if (geoZone.fareMaximum !== null && geoZone.fareMaximum !== '' && geoZone.fareMaximum < 0) return {
            isValid: false,
            message: 'Fare maximum cannot be negative.'
        };
        if (geoZone.fareMaximumUpToMeters !== null && geoZone.fareMaximumUpToMeters !== '' && geoZone.fareMaximumUpToMeters < 0) return {
            isValid: false,
            message: 'Fare maximum distance bound cannot be negative.'
        };
        if (geoZone.fareMinimum !== null && geoZone.fareMinimum !== '' && geoZone.fareMinimum < 0) return {
            isValid: false,
            message: 'Fare minimum cannot be negative.'
        };
        if (geoZone.fareMinimumUpToMeters !== null && geoZone.fareMinimumUpToMeters !== '' && geoZone.fareMinimumUpToMeters < 0) return {
            isValid: false,
            message: 'Fare minimum distance bound cannot be negative.'
        };
        // The Asher-side fee is subtracted from the total before the driver is paid, so a negative one
        // would pay the driver out of the platform's margin rather than out of the fare.
        if (geoZone.zonePlatformFee !== null && geoZone.zonePlatformFee !== '' && geoZone.zonePlatformFee < 0) return {
            isValid: false,
            message: 'Zone platform fee cannot be negative.'
        };
        if (geoZone.zonePlatformFeePerKm !== null && geoZone.zonePlatformFeePerKm !== '' && geoZone.zonePlatformFeePerKm < 0) return {
            isValid: false,
            message: 'Zone platform fee per km cannot be negative.'
        };
        return {
            isValid: true
        };
    };
    const checkDuplicateGeoZone = (geoZone, currentIndex = -1)=>{
        const existingIndex = state.geoZoneFareConfigs.findIndex((zone, index)=>index !== currentIndex && zone.geoZone && geoZone.geoZone && zone.geoZone.id === geoZone.geoZone.id && zone.applicationType === geoZone.applicationType);
        if (existingIndex !== -1) return {
            isDuplicate: true,
            message: 'A geo zone pricing for this zone and application type already exists.'
        };
        return {
            isDuplicate: false
        };
    };
    (0, _vue.watch)(()=>state.currency, validateCurrency);
    (0, _vue.watch)(()=>state.freeStopWaitingMinutes, validateFreeStopWaitingMinutes);
    (0, _vue.watch)(()=>state.stopPerMinuteCharge, validateStopPerMinuteCharge);
    (0, _vue.watch)(()=>state.perStopCharge, validatePerStopCharge);
    (0, _vue.watch)(()=>state.platformFee, validatePlatformFee);
    (0, _vue.watch)(()=>state.platformFeePerKm, validatePlatformFeePerKm);
    (0, _vue.watch)(()=>state.platformFeeMinimum, ()=>{
        validatePlatformFeeMinimum();
        validatePlatformFeeMaximum();
    });
    (0, _vue.watch)(()=>state.platformFeeMaximum, validatePlatformFeeMaximum);
    (0, _vue.watch)(()=>state.scheduledRideFee, validateScheduledRideFee);
    (0, _vue.watch)(()=>state.perMinuteFare, validatePerMinuteFare);
    (0, _vue.watch)(()=>state.minimumFare, validateMinimumFare);
    (0, _vue.watch)(()=>state.perAdditionalPassengerCharge, validatePerAdditionalPassengerCharge);
    (0, _vue.watch)(()=>state.additionalPassengerMaxCharge, validateAdditionalPassengerMaxCharge);
    (0, _vue.watch)(()=>state.additionalPassengerFreeUnderAge, validateAdditionalPassengerFreeUnderAge);
    const isValid = ()=>{
        let isCurrencyValid = validateCurrency();
        let isFreeStopWaitingMinutesValid = validateFreeStopWaitingMinutes();
        let isStopPerMinuteChargeValid = validateStopPerMinuteCharge();
        let isPerStopChargeValid = validatePerStopCharge();
        let isPlatformFeeValid = validatePlatformFee();
        let isPlatformFeePerKmValid = validatePlatformFeePerKm();
        let isPlatformFeeMinimumValid = validatePlatformFeeMinimum();
        let isPlatformFeeMaximumValid = validatePlatformFeeMaximum();
        let isScheduledRideFeeValid = validateScheduledRideFee();
        let isPerMinuteFareValid = validatePerMinuteFare();
        let isMinimumFareValid = validateMinimumFare();
        let isPerAdditionalPassengerChargeValid = validatePerAdditionalPassengerCharge();
        let isAdditionalPassengerMaxChargeValid = validateAdditionalPassengerMaxCharge();
        let isAdditionalPassengerFreeUnderAgeValid = validateAdditionalPassengerFreeUnderAge();
        let isVehicleBaseFareConfigValid = validations.isVehicleBaseFareConfigValid.value;
        let isDistanceFareConfigValid = validations.isDistanceFareConfigValid.value;
        let areGeoZoneFareConfigValid = validations.areGeoZoneFareConfigValid.value;
        return isCurrencyValid && isFreeStopWaitingMinutesValid && isStopPerMinuteChargeValid && isPerStopChargeValid && isPlatformFeeValid && isPlatformFeePerKmValid && isPlatformFeeMinimumValid && isPlatformFeeMaximumValid && isScheduledRideFeeValid && isPerMinuteFareValid && isMinimumFareValid && isPerAdditionalPassengerChargeValid && isAdditionalPassengerMaxChargeValid && isAdditionalPassengerFreeUnderAgeValid && isVehicleBaseFareConfigValid && isDistanceFareConfigValid && areGeoZoneFareConfigValid;
    };
    const initializeValidation = ()=>{
        if (state.currency) validateCurrency();
        if (state.freeStopWaitingMinutes !== undefined) validateFreeStopWaitingMinutes();
        if (state.stopPerMinuteCharge !== undefined) validateStopPerMinuteCharge();
        if (state.perStopCharge !== undefined) validatePerStopCharge();
        if (state.platformFee !== undefined) validatePlatformFee();
        if (state.platformFeePerKm !== undefined) validatePlatformFeePerKm();
        if (state.platformFeeMinimum !== undefined) validatePlatformFeeMinimum();
        if (state.platformFeeMaximum !== undefined) validatePlatformFeeMaximum();
        if (state.scheduledRideFee !== undefined) validateScheduledRideFee();
        if (state.perMinuteFare !== undefined) validatePerMinuteFare();
        if (state.minimumFare !== undefined) validateMinimumFare();
        if (state.perAdditionalPassengerCharge !== undefined) validatePerAdditionalPassengerCharge();
        if (state.additionalPassengerMaxCharge !== undefined) validateAdditionalPassengerMaxCharge();
        if (state.additionalPassengerFreeUnderAge !== undefined) validateAdditionalPassengerFreeUnderAge();
    };
    const addVehicleBaseFareConfig = ()=>{
        state.vehicleBaseFareConfigs.push({
            vehicleType: '',
            baseFare: 0.00
        });
    };
    const removeVehicleBaseFareConfig = (index)=>{
        state.vehicleBaseFareConfigs.splice(index, 1);
    };
    const addDistanceFareConfig = ()=>{
        state.distanceFareConfigs.push({
            startDistanceMeters: 0,
            endDistanceMeters: 0,
            isStartingRange: false,
            isOpenEnded: false,
            rateType: '',
            rateAmount: 0.00
        });
    };
    const removeDistanceFareConfig = (index)=>{
        state.distanceFareConfigs.splice(index, 1);
    };
    const addGeoZoneFareConfig = ()=>{
        state.geoZoneFareConfigs.push({
            geoZone: null,
            applicationType: '',
            zoneRateType: 'SURCHARGE',
            surcharge: 0.00,
            percentage: 0.00,
            flatFare: 0.00,
            zonePerKmRate: 0.00,
            fareMaximum: null,
            fareMaximumUpToMeters: null,
            fareMinimum: null,
            fareMinimumUpToMeters: null,
            zonePlatformFee: null,
            zonePlatformFeePerKm: null
        });
    };
    const removeGeoZoneFareConfig = (index)=>{
        state.geoZoneFareConfigs.splice(index, 1);
    };
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        initializeValidation,
        addVehicleBaseFareConfig,
        removeVehicleBaseFareConfig,
        validateVehicleBaseFareConfig,
        checkDuplicateVehicleType,
        addDistanceFareConfig,
        removeDistanceFareConfig,
        validateDistancePricing,
        checkOverlappingDistanceFareConfig,
        addGeoZoneFareConfig,
        removeGeoZoneFareConfig,
        validateGeoZone,
        checkDuplicateGeoZone,
        validateFreeStopWaitingMinutes,
        validateStopPerMinuteCharge,
        validatePerStopCharge,
        validatePlatformFee,
        isPlatformFeePerKmBelowFloor,
        validatePlatformFeePerKm,
        validatePlatformFeeMinimum,
        validatePlatformFeeMaximum,
        validateScheduledRideFee,
        validatePerMinuteFare,
        validateMinimumFare,
        validatePerAdditionalPassengerCharge,
        validateAdditionalPassengerMaxCharge,
        validateAdditionalPassengerFreeUnderAge
    };
}

},{"vue":"dylud","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5gM7V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newEntityId", ()=>newEntityId);
parcelHelpers.export(exports, "PLATFORM_FEE_PER_KM_FLOOR", ()=>PLATFORM_FEE_PER_KM_FLOOR);
const newEntityId = '00000000-0000-0000-0000-000000000000';
const PLATFORM_FEE_PER_KM_FLOOR = 0.32;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsOyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GeoZone);
var _vue = require("vue");
function GeoZone(data = {}) {
    // Reactive state for geo zone fields
    const state = (0, _vue.reactive)({
        id: data.id || '',
        name: data.name || '',
        description: data.description || '',
        zoneType: data.zoneType || 'SERVICE_AREA',
        priority: data.priority || 0,
        active: data.active !== undefined ? data.active : true,
        boundaryWkt: data.boundaryWkt || '',
        createdAt: data.createdAt || null,
        updatedAt: data.updatedAt || null
    });
    // Computed properties for validations
    const validations = {
        isNameValid: (0, _vue.computed)(()=>!!state.name.trim()),
        isZoneTypeValid: (0, _vue.computed)(()=>!!state.zoneType),
        isBoundaryWktValid: (0, _vue.computed)(()=>!!state.boundaryWkt.trim())
    };
    // Individual field validation functions
    const validateName = ()=>{
        if (validations.isNameValid.value) {
            $('#name').removeClass('is-invalid');
            $('#name-error').addClass('d-none');
            return true;
        } else {
            $('#name').addClass('is-invalid');
            $('#name-error').removeClass('d-none');
            return false;
        }
    };
    const validateZoneType = ()=>{
        if (validations.isZoneTypeValid.value) {
            $('#zoneType').removeClass('is-invalid');
            $('#zoneType-error').addClass('d-none');
            return true;
        } else {
            $('#zoneType').addClass('is-invalid');
            $('#zoneType-error').removeClass('d-none');
            return false;
        }
    };
    const validateBoundaryWkt = ()=>{
        if (validations.isBoundaryWktValid.value) {
            $('#boundaryWkt').removeClass('is-invalid');
            $('#boundaryWkt-error').addClass('d-none');
            return true;
        } else {
            $('#boundaryWkt').addClass('is-invalid');
            $('#boundaryWkt-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.name, validateName);
    (0, _vue.watch)(()=>state.zoneType, validateZoneType);
    (0, _vue.watch)(()=>state.boundaryWkt, validateBoundaryWkt);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isNameValid = validateName();
        let isZoneTypeValid = validateZoneType();
        let isBoundaryWktValid = validateBoundaryWkt();
        return isNameValid && isZoneTypeValid && isBoundaryWktValid;
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.name) validateName();
        if (state.zoneType) validateZoneType();
        if (state.boundaryWkt) validateBoundaryWkt();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"juvFT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Account);
var _vue = require("vue");
function Account(data = {}) {
    // Reactive state for account fields
    const state = (0, _vue.reactive)({
        id: data.id || '',
        companyName: data.companyName || '',
        accountCode: data.accountCode || '',
        status: data.status || 'ACTIVE',
        billingCycle: data.billingCycle || 'MONTHLY',
        billingEmail: data.billingEmail || '',
        billingAddress: data.billingAddress || '',
        creditLimit: data.creditLimit || 0,
        paymentTermsDays: data.paymentTermsDays || 30,
        contactPersonName: data.contactPersonName || '',
        contactPersonEmail: data.contactPersonEmail || '',
        contactPersonPhone: data.contactPersonPhone || '',
        notes: data.notes || '',
        autoInvoice: data.autoInvoice || false,
        autoSendInvoice: data.autoSendInvoice || false,
        taxRate: data.taxRate || 0,
        startDate: data.startDate || new Date().toISOString().split('T')[0],
        billingAnchorDate: data.billingAnchorDate || new Date().toISOString().split('T')[0]
    });
    // Computed properties for validations
    const validations = {
        isCompanyNameValid: (0, _vue.computed)(()=>!!state.companyName.trim()),
        isBillingEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.billingEmail)),
        isBillingCycleValid: (0, _vue.computed)(()=>!!state.billingCycle),
        isContactEmailValid: (0, _vue.computed)(()=>!state.contactPersonEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.contactPersonEmail)),
        isContactPhoneValid: (0, _vue.computed)(()=>!state.contactPersonPhone || /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(state.contactPersonPhone))
    };
    // Individual field validation functions
    const validateCompanyName = ()=>{
        if (validations.isCompanyNameValid.value) {
            $('#account-company-name-input').removeClass('is-invalid');
            $('#account-company-name-error').addClass('d-none');
            return true;
        } else {
            $('#account-company-name-input').addClass('is-invalid');
            $('#account-company-name-error').removeClass('d-none');
            return false;
        }
    };
    const validateBillingEmail = ()=>{
        if (validations.isBillingEmailValid.value) {
            $('#account-billing-email-input').removeClass('is-invalid');
            $('#account-billing-email-error').addClass('d-none');
            return true;
        } else {
            $('#account-billing-email-input').addClass('is-invalid');
            $('#account-billing-email-error').removeClass('d-none');
            return false;
        }
    };
    const validateContactEmail = ()=>{
        if (validations.isContactEmailValid.value) {
            $('#account-contact-email-input').removeClass('is-invalid');
            $('#account-contact-email-error').addClass('d-none');
            return true;
        } else {
            $('#account-contact-email-input').addClass('is-invalid');
            $('#account-contact-email-error').removeClass('d-none');
            return false;
        }
    };
    const validateContactPhone = ()=>{
        if (validations.isContactPhoneValid.value) {
            $('#account-contact-phone-input').removeClass('is-invalid');
            $('#account-contact-phone-error').addClass('d-none');
            return true;
        } else {
            $('#account-contact-phone-input').addClass('is-invalid');
            $('#account-contact-phone-error').removeClass('d-none');
            return false;
        }
    };
    // Set up watchers for real-time validation
    (0, _vue.watch)(()=>state.companyName, validateCompanyName);
    (0, _vue.watch)(()=>state.billingEmail, validateBillingEmail);
    (0, _vue.watch)(()=>state.contactPersonEmail, validateContactEmail);
    (0, _vue.watch)(()=>state.contactPersonPhone, validateContactPhone);
    // Validation logic for the entire form
    const isValid = ()=>{
        let isCompanyNameValid = validateCompanyName();
        let isBillingEmailValid = validateBillingEmail();
        let isContactEmailValid = validateContactEmail();
        let isContactPhoneValid = validateContactPhone();
        return isCompanyNameValid && isBillingEmailValid && isContactEmailValid && isContactPhoneValid;
    };
    const clearFields = ()=>{
        state.companyName = '';
        state.accountCode = '';
        state.status = 'ACTIVE';
        state.billingCycle = 'MONTHLY';
        state.billingEmail = '';
        state.billingAddress = '';
        state.creditLimit = 0;
        state.paymentTermsDays = 30;
        state.contactPersonName = '';
        state.contactPersonEmail = '';
        state.contactPersonPhone = '';
        state.notes = '';
        state.autoInvoice = false;
        state.autoSendInvoice = false;
        state.taxRate = 0;
        state.startDate = new Date().toISOString().split('T')[0];
        state.billingAnchorDate = new Date().toISOString().split('T')[0];
    };
    // Initialize validation
    const initializeValidation = ()=>{
        // Only validate fields that have values
        if (state.companyName) validateCompanyName();
        if (state.billingEmail) validateBillingEmail();
        if (state.contactPersonEmail) validateContactEmail();
        if (state.contactPersonPhone) validateContactPhone();
    };
    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        clearFields,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cUpxQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SIGNUP_BONUS_POINTS", ()=>DEFAULT_SIGNUP_BONUS_POINTS);
parcelHelpers.export(exports, "MAX_SIGNUP_BONUS_POINTS", ()=>MAX_SIGNUP_BONUS_POINTS);
parcelHelpers.export(exports, "DEFAULT_IDLE_WARNING_MINUTES", ()=>DEFAULT_IDLE_WARNING_MINUTES);
parcelHelpers.export(exports, "DEFAULT_IDLE_AUTO_OFFLINE_MINUTES", ()=>DEFAULT_IDLE_AUTO_OFFLINE_MINUTES);
parcelHelpers.export(exports, "MAX_IDLE_MINUTES", ()=>MAX_IDLE_MINUTES);
parcelHelpers.export(exports, "MIN_IDLE_GAP_SECONDS", ()=>MIN_IDLE_GAP_SECONDS);
parcelHelpers.export(exports, "DEFAULT_MAX_PICKUP_DISTANCE_METERS", ()=>DEFAULT_MAX_PICKUP_DISTANCE_METERS);
parcelHelpers.export(exports, "MIN_MAX_PICKUP_DISTANCE_METERS", ()=>MIN_MAX_PICKUP_DISTANCE_METERS);
parcelHelpers.export(exports, "MAX_MAX_PICKUP_DISTANCE_METERS", ()=>MAX_MAX_PICKUP_DISTANCE_METERS);
parcelHelpers.export(exports, "WARN_ABOVE_PICKUP_DISTANCE_METERS", ()=>WARN_ABOVE_PICKUP_DISTANCE_METERS);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_DRIVER_DISCOUNT_PERCENT", ()=>DEFAULT_REFERRAL_DRIVER_DISCOUNT_PERCENT);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_DRIVER_MAX_REDEMPTIONS", ()=>DEFAULT_REFERRAL_DRIVER_MAX_REDEMPTIONS);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRER_POINTS", ()=>DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRER_POINTS);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRED_POINTS", ()=>DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRED_POINTS);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_RIDER_FIVE_RIDES_REFERRER_POINTS", ()=>DEFAULT_REFERRAL_RIDER_FIVE_RIDES_REFERRER_POINTS);
parcelHelpers.export(exports, "DEFAULT_REFERRAL_RIDER_MAX_REWARDED_REFERRALS", ()=>DEFAULT_REFERRAL_RIDER_MAX_REWARDED_REFERRALS);
parcelHelpers.export(exports, "MIN_REFERRAL_DISCOUNT_PERCENT", ()=>MIN_REFERRAL_DISCOUNT_PERCENT);
parcelHelpers.export(exports, "MAX_REFERRAL_DISCOUNT_PERCENT", ()=>MAX_REFERRAL_DISCOUNT_PERCENT);
parcelHelpers.export(exports, "MAX_REFERRAL_REWARD_CAP", ()=>MAX_REFERRAL_REWARD_CAP);
parcelHelpers.export(exports, "MAX_REFERRAL_RIDER_POINTS", ()=>MAX_REFERRAL_RIDER_POINTS);
parcelHelpers.export(exports, "default", ()=>ServiceJurisdiction);
var _vue = require("vue");
const DEFAULT_SIGNUP_BONUS_POINTS = 250;
const MAX_SIGNUP_BONUS_POINTS = 1000;
const DEFAULT_IDLE_WARNING_MINUTES = 30;
const DEFAULT_IDLE_AUTO_OFFLINE_MINUTES = 45;
const MAX_IDLE_MINUTES = 720;
const MIN_IDLE_GAP_SECONDS = 60;
const DEFAULT_MAX_PICKUP_DISTANCE_METERS = 5000;
const MIN_MAX_PICKUP_DISTANCE_METERS = 500;
const MAX_MAX_PICKUP_DISTANCE_METERS = 15000;
const WARN_ABOVE_PICKUP_DISTANCE_METERS = 8000;
const DEFAULT_REFERRAL_DRIVER_DISCOUNT_PERCENT = 50;
const DEFAULT_REFERRAL_DRIVER_MAX_REDEMPTIONS = 4;
const DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRER_POINTS = 100;
const DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRED_POINTS = 300;
const DEFAULT_REFERRAL_RIDER_FIVE_RIDES_REFERRER_POINTS = 400;
const DEFAULT_REFERRAL_RIDER_MAX_REWARDED_REFERRALS = 10;
const MIN_REFERRAL_DISCOUNT_PERCENT = 1;
const MAX_REFERRAL_DISCOUNT_PERCENT = 100;
const MAX_REFERRAL_REWARD_CAP = 100;
const MAX_REFERRAL_RIDER_POINTS = 2000;
// Same emptiness-before-comparison rule as isWholeMinute above: '' >= 0 is true in JS.
const isWholeInRange = (value, min, max)=>value !== '' && value !== null && value !== undefined && Number.isInteger(Number(value)) && Number(value) >= min && Number(value) <= max;
// A blank number input yields '' rather than a number, '' >= 1 is true in JS, and v-model.number
// passes '' straight through, so the emptiness check has to come before any comparison. isInteger
// rather than isFinite because Jackson's ACCEPT_FLOAT_AS_INT truncates 30.7 to 30 server-side, which
// would report success for a value the admin never typed.
const isWholeMinute = (value)=>value !== '' && value !== null && value !== undefined && Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= MAX_IDLE_MINUTES;
function ServiceJurisdiction(data = {}) {
    const state = (0, _vue.reactive)({
        id: data.id || '',
        name: data.name || '',
        description: data.description || '',
        active: data.active !== undefined ? data.active : true,
        serviceArea: data.serviceArea || null,
        geoZoneId: data.serviceArea?.id || data.geoZoneId || null,
        serviceAreaAllowance: data.serviceAreaAllowance || 10.0,
        commissionPercentage: data.commissionPercentage !== undefined ? data.commissionPercentage : 0.0,
        maxDrivers: data.maxDrivers !== undefined ? data.maxDrivers : null,
        pointsPerDollar: data.pointsPerDollar !== undefined ? data.pointsPerDollar : 1.00,
        signupBonusPoints: data.signupBonusPoints !== undefined ? data.signupBonusPoints : DEFAULT_SIGNUP_BONUS_POINTS,
        // Held as the API's own ISO-8601 (or null), because EntityForm.fetchEntity writes fetched
        // values straight into this state and PUTs it back verbatim. The datetime-local input format
        // is a display concern, converted in ServiceJurisdictionDetail.vue.
        signupBonusStartsOn: data.signupBonusStartsOn || '',
        signupBonusEndsOn: data.signupBonusEndsOn || '',
        idleWarningMinutes: data.idleWarningMinutes !== undefined ? data.idleWarningMinutes : DEFAULT_IDLE_WARNING_MINUTES,
        idleAutoOfflineMinutes: data.idleAutoOfflineMinutes !== undefined ? data.idleAutoOfflineMinutes : DEFAULT_IDLE_AUTO_OFFLINE_MINUTES,
        maxPickupDistanceMeters: data.maxPickupDistanceMeters !== undefined ? data.maxPickupDistanceMeters : DEFAULT_MAX_PICKUP_DISTANCE_METERS,
        referralDriverDiscountPercent: data.referralDriverDiscountPercent !== undefined ? data.referralDriverDiscountPercent : DEFAULT_REFERRAL_DRIVER_DISCOUNT_PERCENT,
        referralDriverMaxRedemptions: data.referralDriverMaxRedemptions !== undefined ? data.referralDriverMaxRedemptions : DEFAULT_REFERRAL_DRIVER_MAX_REDEMPTIONS,
        referralRiderFirstRideReferrerPoints: data.referralRiderFirstRideReferrerPoints !== undefined ? data.referralRiderFirstRideReferrerPoints : DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRER_POINTS,
        referralRiderFirstRideReferredPoints: data.referralRiderFirstRideReferredPoints !== undefined ? data.referralRiderFirstRideReferredPoints : DEFAULT_REFERRAL_RIDER_FIRST_RIDE_REFERRED_POINTS,
        referralRiderFiveRidesReferrerPoints: data.referralRiderFiveRidesReferrerPoints !== undefined ? data.referralRiderFiveRidesReferrerPoints : DEFAULT_REFERRAL_RIDER_FIVE_RIDES_REFERRER_POINTS,
        referralRiderMaxRewardedReferrals: data.referralRiderMaxRewardedReferrals !== undefined ? data.referralRiderMaxRewardedReferrals : DEFAULT_REFERRAL_RIDER_MAX_REWARDED_REFERRALS,
        createdAt: data.createdAt || null,
        updatedAt: data.updatedAt || null
    });
    const validations = {
        isNameValid: (0, _vue.computed)(()=>!!state.name && state.name.trim().length > 0),
        isCommissionPercentageValid: (0, _vue.computed)(()=>state.commissionPercentage >= 0 && state.commissionPercentage <= 100),
        // Mirrors the server-side margin assertion: rate x the 2x promo ceiling x $0.01 per point must
        // stay within $0.02 of reward cost per eligible dollar, so the rate itself caps at 1.00.
        // The emptiness check is load-bearing for the same reason as isSignupBonusPointsValid below:
        // clearing the input yields '', and '' >= 0 && '' <= 1.00 are both true in JS, so without it a
        // blank rate validates, Jackson coerces '' to null, and the service's "null means leave
        // unchanged" keeps the old rate while the admin sees a success toast.
        isPointsPerDollarValid: (0, _vue.computed)(()=>{
            const rate = Number(state.pointsPerDollar);
            return state.pointsPerDollar !== '' && state.pointsPerDollar !== null && Number.isFinite(rate) && rate >= 0 && rate <= 1.00;
        }),
        // Mirrors LoyaltyValidator.validateSignupBonus and the promo-window ordering rule.
        // The emptiness check is load-bearing, not defensive: clearing a number input yields '',
        // v-model.number passes '' straight through (parseFloat('') is NaN, so Vue keeps the string),
        // and '' >= 0 is true in JS. Without it the form would accept a blank bonus, Jackson would
        // coerce '' to null, and the service's "null means leave unchanged" would silently keep the
        // old value while the save reported success.
        isSignupBonusPointsValid: (0, _vue.computed)(()=>{
            const points = Number(state.signupBonusPoints);
            // isInteger, not isFinite: 250.7 passes every other check here, and Jackson's
            // ACCEPT_FLOAT_AS_INT (on by default) then truncates it to 250 server-side, so the admin
            // gets a success toast for an amount they did not type. The server cannot catch this --
            // by the time the DTO holds an Integer the fraction is already gone.
            return state.signupBonusPoints !== '' && state.signupBonusPoints !== null && state.signupBonusPoints !== undefined && Number.isInteger(points) && points >= 0 && points <= MAX_SIGNUP_BONUS_POINTS;
        }),
        isSignupBonusWindowValid: (0, _vue.computed)(()=>!state.signupBonusStartsOn || !state.signupBonusEndsOn || new Date(state.signupBonusEndsOn) > new Date(state.signupBonusStartsOn)),
        // Same emptiness and isInteger guards as the signup bonus above, for the same two reasons:
        // '' >= 1 is true in JS, and Jackson's ACCEPT_FLOAT_AS_INT would silently truncate 30.7 to 30.
        isMaxPickupDistanceValid: (0, _vue.computed)(()=>{
            const value = state.maxPickupDistanceMeters;
            return value !== '' && value !== null && value !== undefined && Number.isInteger(Number(value)) && Number(value) >= MIN_MAX_PICKUP_DISTANCE_METERS && Number(value) <= MAX_MAX_PICKUP_DISTANCE_METERS;
        }),
        // Advisory, never a validity check: this must not feed isValid().
        isMaxPickupDistanceAboveAdvisory: (0, _vue.computed)(()=>Number(state.maxPickupDistanceMeters) > WARN_ABOVE_PICKUP_DISTANCE_METERS),
        isReferralDriverDiscountPercentValid: (0, _vue.computed)(()=>isWholeInRange(state.referralDriverDiscountPercent, MIN_REFERRAL_DISCOUNT_PERCENT, MAX_REFERRAL_DISCOUNT_PERCENT)),
        isReferralDriverMaxRedemptionsValid: (0, _vue.computed)(()=>isWholeInRange(state.referralDriverMaxRedemptions, 0, MAX_REFERRAL_REWARD_CAP)),
        isReferralRiderMaxRewardedReferralsValid: (0, _vue.computed)(()=>isWholeInRange(state.referralRiderMaxRewardedReferrals, 0, MAX_REFERRAL_REWARD_CAP)),
        isReferralRiderFirstRideReferrerPointsValid: (0, _vue.computed)(()=>isWholeInRange(state.referralRiderFirstRideReferrerPoints, 0, MAX_REFERRAL_RIDER_POINTS)),
        isReferralRiderFirstRideReferredPointsValid: (0, _vue.computed)(()=>isWholeInRange(state.referralRiderFirstRideReferredPoints, 0, MAX_REFERRAL_RIDER_POINTS)),
        isReferralRiderFiveRidesReferrerPointsValid: (0, _vue.computed)(()=>isWholeInRange(state.referralRiderFiveRidesReferrerPoints, 0, MAX_REFERRAL_RIDER_POINTS)),
        isIdleWarningMinutesValid: (0, _vue.computed)(()=>isWholeMinute(state.idleWarningMinutes)),
        isIdleAutoOfflineMinutesValid: (0, _vue.computed)(()=>isWholeMinute(state.idleAutoOfflineMinutes)),
        // Mirrors ServiceJurisdictionValidator.validateIdleWindow, and it is not a nicety: ordering
        // alone is not enough, because the sweep skips a prompt with under MIN_IDLE_GAP_SECONDS left,
        // so a window one minute wide is ordered correctly and still never prompts anybody — every
        // driver in this jurisdiction set offline without warning.
        isIdleWindowValid: (0, _vue.computed)(()=>isWholeMinute(state.idleWarningMinutes) && isWholeMinute(state.idleAutoOfflineMinutes) && (Number(state.idleAutoOfflineMinutes) - Number(state.idleWarningMinutes)) * 60 > MIN_IDLE_GAP_SECONDS)
    };
    const validateName = ()=>{
        if (validations.isNameValid.value) {
            $('#name').removeClass('is-invalid');
            $('#name-error').addClass('d-none');
            return true;
        } else {
            $('#name').addClass('is-invalid');
            $('#name-error').removeClass('d-none');
            return false;
        }
    };
    const validateCommissionPercentage = ()=>{
        if (validations.isCommissionPercentageValid.value) {
            $('#commissionPercentage').removeClass('is-invalid');
            $('#commissionPercentage-error').addClass('d-none');
            return true;
        } else {
            $('#commissionPercentage').addClass('is-invalid');
            $('#commissionPercentage-error').removeClass('d-none');
            return false;
        }
    };
    const validatePointsPerDollar = ()=>{
        if (validations.isPointsPerDollarValid.value) {
            $('#pointsPerDollar').removeClass('is-invalid');
            $('#pointsPerDollar-error').addClass('d-none');
            return true;
        } else {
            $('#pointsPerDollar').addClass('is-invalid');
            $('#pointsPerDollar-error').removeClass('d-none');
            return false;
        }
    };
    const validateSignupBonusPoints = ()=>{
        if (validations.isSignupBonusPointsValid.value) {
            $('#signupBonusPoints').removeClass('is-invalid');
            $('#signupBonusPoints-error').addClass('d-none');
            return true;
        } else {
            $('#signupBonusPoints').addClass('is-invalid');
            $('#signupBonusPoints-error').removeClass('d-none');
            return false;
        }
    };
    const validateIdleWarningMinutes = ()=>{
        if (validations.isIdleWarningMinutesValid.value) {
            $('#idleWarningMinutes').removeClass('is-invalid');
            $('#idleWarningMinutes-error').addClass('d-none');
            return true;
        } else {
            $('#idleWarningMinutes').addClass('is-invalid');
            $('#idleWarningMinutes-error').removeClass('d-none');
            return false;
        }
    };
    const validateMaxPickupDistance = ()=>{
        if (validations.isMaxPickupDistanceValid.value) {
            $('#maxPickupDistanceMeters').removeClass('is-invalid');
            $('#maxPickupDistanceMeters-error').addClass('d-none');
            return true;
        } else {
            $('#maxPickupDistanceMeters').addClass('is-invalid');
            $('#maxPickupDistanceMeters-error').removeClass('d-none');
            return false;
        }
    };
    const validateIdleWindow = ()=>{
        if (validations.isIdleWindowValid.value) {
            $('#idleAutoOfflineMinutes').removeClass('is-invalid');
            $('#idleAutoOfflineMinutes-error').addClass('d-none');
            return true;
        } else {
            $('#idleAutoOfflineMinutes').addClass('is-invalid');
            $('#idleAutoOfflineMinutes-error').removeClass('d-none');
            return false;
        }
    };
    const validateSignupBonusWindow = ()=>{
        if (validations.isSignupBonusWindowValid.value) {
            $('#signupBonusEndsOn').removeClass('is-invalid');
            $('#signupBonusEndsOn-error').addClass('d-none');
            return true;
        } else {
            $('#signupBonusEndsOn').addClass('is-invalid');
            $('#signupBonusEndsOn-error').removeClass('d-none');
            return false;
        }
    };
    const validateReferralDriverDiscountPercent = ()=>{
        if (validations.isReferralDriverDiscountPercentValid.value) {
            $('#referralDriverDiscountPercent').removeClass('is-invalid');
            $('#referralDriverDiscountPercent-error').addClass('d-none');
            return true;
        }
        $('#referralDriverDiscountPercent').addClass('is-invalid');
        $('#referralDriverDiscountPercent-error').removeClass('d-none');
        return false;
    };
    const validateReferralDriverMaxRedemptions = ()=>{
        if (validations.isReferralDriverMaxRedemptionsValid.value) {
            $('#referralDriverMaxRedemptions').removeClass('is-invalid');
            $('#referralDriverMaxRedemptions-error').addClass('d-none');
            return true;
        }
        $('#referralDriverMaxRedemptions').addClass('is-invalid');
        $('#referralDriverMaxRedemptions-error').removeClass('d-none');
        return false;
    };
    const validateReferralRiderFirstRideReferrerPoints = ()=>{
        if (validations.isReferralRiderFirstRideReferrerPointsValid.value) {
            $('#referralRiderFirstRideReferrerPoints').removeClass('is-invalid');
            $('#referralRiderFirstRideReferrerPoints-error').addClass('d-none');
            return true;
        }
        $('#referralRiderFirstRideReferrerPoints').addClass('is-invalid');
        $('#referralRiderFirstRideReferrerPoints-error').removeClass('d-none');
        return false;
    };
    const validateReferralRiderFirstRideReferredPoints = ()=>{
        if (validations.isReferralRiderFirstRideReferredPointsValid.value) {
            $('#referralRiderFirstRideReferredPoints').removeClass('is-invalid');
            $('#referralRiderFirstRideReferredPoints-error').addClass('d-none');
            return true;
        }
        $('#referralRiderFirstRideReferredPoints').addClass('is-invalid');
        $('#referralRiderFirstRideReferredPoints-error').removeClass('d-none');
        return false;
    };
    const validateReferralRiderFiveRidesReferrerPoints = ()=>{
        if (validations.isReferralRiderFiveRidesReferrerPointsValid.value) {
            $('#referralRiderFiveRidesReferrerPoints').removeClass('is-invalid');
            $('#referralRiderFiveRidesReferrerPoints-error').addClass('d-none');
            return true;
        }
        $('#referralRiderFiveRidesReferrerPoints').addClass('is-invalid');
        $('#referralRiderFiveRidesReferrerPoints-error').removeClass('d-none');
        return false;
    };
    const validateReferralRiderMaxRewardedReferrals = ()=>{
        if (validations.isReferralRiderMaxRewardedReferralsValid.value) {
            $('#referralRiderMaxRewardedReferrals').removeClass('is-invalid');
            $('#referralRiderMaxRewardedReferrals-error').addClass('d-none');
            return true;
        }
        $('#referralRiderMaxRewardedReferrals').addClass('is-invalid');
        $('#referralRiderMaxRewardedReferrals-error').removeClass('d-none');
        return false;
    };
    (0, _vue.watch)(()=>state.name, validateName);
    (0, _vue.watch)(()=>state.signupBonusPoints, validateSignupBonusPoints);
    (0, _vue.watch)(()=>state.signupBonusStartsOn, validateSignupBonusWindow);
    (0, _vue.watch)(()=>state.signupBonusEndsOn, validateSignupBonusWindow);
    (0, _vue.watch)(()=>state.pointsPerDollar, validatePointsPerDollar);
    (0, _vue.watch)(()=>state.idleWarningMinutes, ()=>{
        validateIdleWarningMinutes();
        validateIdleWindow();
    });
    (0, _vue.watch)(()=>state.idleAutoOfflineMinutes, validateIdleWindow);
    (0, _vue.watch)(()=>state.maxPickupDistanceMeters, validateMaxPickupDistance);
    (0, _vue.watch)(()=>state.commissionPercentage, validateCommissionPercentage);
    (0, _vue.watch)(()=>state.referralDriverDiscountPercent, validateReferralDriverDiscountPercent);
    (0, _vue.watch)(()=>state.referralDriverMaxRedemptions, validateReferralDriverMaxRedemptions);
    (0, _vue.watch)(()=>state.referralRiderFirstRideReferrerPoints, validateReferralRiderFirstRideReferrerPoints);
    (0, _vue.watch)(()=>state.referralRiderFirstRideReferredPoints, validateReferralRiderFirstRideReferredPoints);
    (0, _vue.watch)(()=>state.referralRiderFiveRidesReferrerPoints, validateReferralRiderFiveRidesReferrerPoints);
    (0, _vue.watch)(()=>state.referralRiderMaxRewardedReferrals, validateReferralRiderMaxRewardedReferrals);
    (0, _vue.watch)(()=>state.serviceArea, (newValue)=>{
        if (newValue && newValue.id) state.geoZoneId = newValue.id;
        else state.geoZoneId = null;
    });
    const isValid = ()=>{
        let isNameValid = validateName();
        let isCommissionValid = validateCommissionPercentage();
        let isRateValid = validatePointsPerDollar();
        let isBonusValid = validateSignupBonusPoints();
        let isWindowValid = validateSignupBonusWindow();
        let isIdleWarningValid = validateIdleWarningMinutes();
        let isIdleWindowValid = validateIdleWindow();
        // isMaxPickupDistanceAboveAdvisory is deliberately absent: it is a warning, and folding it in
        // here would turn it into a save-blocking rejection.
        let isPickupDistanceValid = validateMaxPickupDistance();
        // Every validator runs before the && chain: short-circuiting would leave later fields
        // un-marked, so an admin fixing the first error would discover the next only on resubmit.
        let referralResults = [
            validateReferralDriverDiscountPercent(),
            validateReferralDriverMaxRedemptions(),
            validateReferralRiderFirstRideReferrerPoints(),
            validateReferralRiderFirstRideReferredPoints(),
            validateReferralRiderFiveRidesReferrerPoints(),
            validateReferralRiderMaxRewardedReferrals()
        ];
        return isNameValid && isCommissionValid && isRateValid && isBonusValid && isWindowValid && isIdleWarningValid && isIdleWindowValid && isPickupDistanceValid && referralResults.every(Boolean);
    };
    const initializeValidation = ()=>{
        if (state.name) validateName();
        if (state.commissionPercentage !== undefined) validateCommissionPercentage();
        if (state.pointsPerDollar !== undefined) validatePointsPerDollar();
        if (state.signupBonusPoints !== undefined) validateSignupBonusPoints();
        validateSignupBonusWindow();
        if (state.idleWarningMinutes !== undefined) validateIdleWarningMinutes();
        validateIdleWindow();
        if (state.maxPickupDistanceMeters !== undefined) validateMaxPickupDistance();
        if (state.referralDriverDiscountPercent !== undefined) validateReferralDriverDiscountPercent();
        if (state.referralDriverMaxRedemptions !== undefined) validateReferralDriverMaxRedemptions();
        if (state.referralRiderFirstRideReferrerPoints !== undefined) validateReferralRiderFirstRideReferrerPoints();
        if (state.referralRiderFirstRideReferredPoints !== undefined) validateReferralRiderFirstRideReferredPoints();
        if (state.referralRiderFiveRidesReferrerPoints !== undefined) validateReferralRiderFiveRidesReferrerPoints();
        if (state.referralRiderMaxRewardedReferrals !== undefined) validateReferralRiderMaxRewardedReferrals();
    };
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        validateReferralDriverDiscountPercent,
        validateReferralDriverMaxRedemptions,
        validateReferralRiderFirstRideReferrerPoints,
        validateReferralRiderFirstRideReferredPoints,
        validateReferralRiderFiveRidesReferrerPoints,
        validateReferralRiderMaxRewardedReferrals,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfl9A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Shift);
var _vue = require("vue");
function Shift(data = {}) {
    const state = (0, _vue.reactive)({
        id: data.id || '',
        startsAt: data.startsAt || null,
        endsAt: data.endsAt || null,
        durationHours: data.durationHours !== undefined ? data.durationHours : null,
        guaranteedEarnings: data.guaranteedEarnings !== undefined ? data.guaranteedEarnings : null,
        maxDrivers: data.maxDrivers !== undefined ? data.maxDrivers : null,
        status: data.status || 'DRAFT',
        serviceJurisdictionId: data.serviceJurisdictionId || null,
        geoZoneId: data.geoZoneId || null,
        createdOn: data.createdOn || null,
        modifiedOn: data.modifiedOn || null
    });
    const validations = {
        isTimeRangeValid: (0, _vue.computed)(()=>{
            if (!state.startsAt || !state.endsAt) return false;
            return new Date(state.endsAt) > new Date(state.startsAt);
        }),
        // A cleared <input type="number"> yields '' (Vue's number-casting leaves an unparseable
        // empty string as-is, not null) — durationHours is optional, so '' must count as unset,
        // same as null, or an admin could never clear it once set (#73 pre-commit review fix).
        isDurationHoursValid: (0, _vue.computed)(()=>{
            const value = state.durationHours;
            return value === null || value === '' || value === undefined || value > 0;
        }),
        isGuaranteedEarningsValid: (0, _vue.computed)(()=>state.guaranteedEarnings !== null && state.guaranteedEarnings > 0),
        isMaxDriversValid: (0, _vue.computed)(()=>state.maxDrivers !== null && state.maxDrivers > 0)
    };
    const validateTimeRange = ()=>{
        if (validations.isTimeRangeValid.value) {
            $('#endsAt').removeClass('is-invalid');
            $('#endsAt-error').addClass('d-none');
            return true;
        } else {
            $('#endsAt').addClass('is-invalid');
            $('#endsAt-error').removeClass('d-none');
            return false;
        }
    };
    const validateDurationHours = ()=>{
        if (validations.isDurationHoursValid.value) {
            $('#durationHours').removeClass('is-invalid');
            $('#durationHours-error').addClass('d-none');
            return true;
        } else {
            $('#durationHours').addClass('is-invalid');
            $('#durationHours-error').removeClass('d-none');
            return false;
        }
    };
    const validateGuaranteedEarnings = ()=>{
        if (validations.isGuaranteedEarningsValid.value) {
            $('#guaranteedEarnings').removeClass('is-invalid');
            $('#guaranteedEarnings-error').addClass('d-none');
            return true;
        } else {
            $('#guaranteedEarnings').addClass('is-invalid');
            $('#guaranteedEarnings-error').removeClass('d-none');
            return false;
        }
    };
    const validateMaxDrivers = ()=>{
        if (validations.isMaxDriversValid.value) {
            $('#maxDrivers').removeClass('is-invalid');
            $('#maxDrivers-error').addClass('d-none');
            return true;
        } else {
            $('#maxDrivers').addClass('is-invalid');
            $('#maxDrivers-error').removeClass('d-none');
            return false;
        }
    };
    (0, _vue.watch)(()=>state.startsAt, validateTimeRange);
    (0, _vue.watch)(()=>state.endsAt, validateTimeRange);
    (0, _vue.watch)(()=>state.durationHours, validateDurationHours);
    (0, _vue.watch)(()=>state.guaranteedEarnings, validateGuaranteedEarnings);
    (0, _vue.watch)(()=>state.maxDrivers, validateMaxDrivers);
    const isValid = ()=>{
        let isTimeRangeValid = validateTimeRange();
        let isDurationHoursValid = validateDurationHours();
        let isGuaranteedEarningsValid = validateGuaranteedEarnings();
        let isMaxDriversValid = validateMaxDrivers();
        return isTimeRangeValid && isDurationHoursValid && isGuaranteedEarningsValid && isMaxDriversValid;
    };
    const initializeValidation = ()=>{
        if (state.startsAt && state.endsAt) validateTimeRange();
        if (state.durationHours !== null) validateDurationHours();
        if (state.guaranteedEarnings !== null) validateGuaranteedEarnings();
        if (state.maxDrivers !== null) validateMaxDrivers();
    };
    setTimeout(initializeValidation, 100);
    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BIKL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "page-title"
};
const _hoisted_2 = {
    class: "row"
};
const _hoisted_3 = {
    class: "col-sm-6 col-12"
};
const _hoisted_4 = {
    key: 0
};
const _hoisted_5 = {
    key: 1
};
const _hoisted_6 = {
    key: 2
};
const _hoisted_7 = {
    class: "col-sm-12"
};
const _hoisted_8 = {
    class: "card"
};
const _hoisted_9 = {
    class: "card-body"
};
const _hoisted_10 = {
    class: "card-footer pt-0"
};
const _hoisted_11 = {
    class: "pull-right"
};
const _hoisted_12 = {
    key: 3,
    class: "text-muted fst-italic"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        $props.showTitle ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                (0, _vue.createElementVNode)("div", _hoisted_3, [
                    $setup.isNew ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_4, (0, _vue.toDisplayString)(`Create ${$props.formName}`), 1)) : $setup.isEditMode ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_5, (0, _vue.toDisplayString)(`Edit ${$props.formName}`), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_6, (0, _vue.toDisplayString)(`View ${$props.formName}`), 1))
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_7, [
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                (0, _vue.createElementVNode)("div", _hoisted_9, [
                    (0, _vue.createElementVNode)("form", {
                        onSubmit: (0, _vue.withModifiers)($setup.handleSubmit, [
                            "prevent"
                        ])
                    }, [
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ], 32)
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_10, [
                    (0, _vue.createElementVNode)("div", _hoisted_11, [
                        $setup.isEditMode ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            class: "btn btn-primary me-3",
                            type: "submit",
                            onClick: $setup.handleSubmit
                        }, (0, _vue.toDisplayString)($setup.isNew ? 'Create' : 'Update'), 1)) : (0, _vue.createCommentVNode)("", true),
                        $setup.isEditMode ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 1,
                            class: "btn btn-danger",
                            type: "button",
                            onClick: $setup.cancelEdit
                        }, " Cancel ")) : (0, _vue.createCommentVNode)("", true),
                        $setup.isReadOnly && !$setup.isNew && !$props.lockEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 2,
                            class: "btn btn-primary",
                            onClick: (0, _vue.withModifiers)($setup.enableEditMode, [
                                "prevent"
                            ])
                        }, " Edit ")) : (0, _vue.createCommentVNode)("", true),
                        $setup.isReadOnly && !$setup.isNew && $props.lockEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_12, " This record cannot be edited. ")) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8n9XF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltJ5f":[function(require,module,exports,__globalThis) {
/*!
* sweetalert2 v11.7.7
* Released under the MIT License.
*/ !function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    const e = {}, t = (t)=>new Promise((o)=>{
            if (!t) return o();
            const n = window.scrollX, i = window.scrollY;
            e.restoreFocusTimeout = setTimeout(()=>{
                e.previousActiveElement instanceof HTMLElement ? (e.previousActiveElement.focus(), e.previousActiveElement = null) : document.body && document.body.focus(), o();
            }, 100), window.scrollTo(n, i);
        });
    var o = {
        promise: new WeakMap,
        innerParams: new WeakMap,
        domCache: new WeakMap
    };
    const n = (e)=>{
        const t = {};
        for(const o in e)t[e[o]] = "swal2-" + e[o];
        return t;
    }, i = n([
        "container",
        "shown",
        "height-auto",
        "iosfix",
        "popup",
        "modal",
        "no-backdrop",
        "no-transition",
        "toast",
        "toast-shown",
        "show",
        "hide",
        "close",
        "title",
        "html-container",
        "actions",
        "confirm",
        "deny",
        "cancel",
        "default-outline",
        "footer",
        "icon",
        "icon-content",
        "image",
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "label",
        "textarea",
        "inputerror",
        "input-label",
        "validation-message",
        "progress-steps",
        "active-progress-step",
        "progress-step",
        "progress-step-line",
        "loader",
        "loading",
        "styled",
        "top",
        "top-start",
        "top-end",
        "top-left",
        "top-right",
        "center",
        "center-start",
        "center-end",
        "center-left",
        "center-right",
        "bottom",
        "bottom-start",
        "bottom-end",
        "bottom-left",
        "bottom-right",
        "grow-row",
        "grow-column",
        "grow-fullscreen",
        "rtl",
        "timer-progress-bar",
        "timer-progress-bar-container",
        "scrollbar-measure",
        "icon-success",
        "icon-warning",
        "icon-info",
        "icon-question",
        "icon-error"
    ]), s = n([
        "success",
        "warning",
        "info",
        "question",
        "error"
    ]), r = "SweetAlert2:", a = (e)=>e.charAt(0).toUpperCase() + e.slice(1), l = (e)=>{
        console.warn(`${r} ${"object" == typeof e ? e.join(" ") : e}`);
    }, c = (e)=>{
        console.error(`${r} ${e}`);
    }, u = [], d = (e, t)=>{
        var o;
        o = `"${e}" is deprecated and will be removed in the next major release. Please use "${t}" instead.`, u.includes(o) || (u.push(o), l(o));
    }, p = (e)=>"function" == typeof e ? e() : e, m = (e)=>e && "function" == typeof e.toPromise, g = (e)=>m(e) ? e.toPromise() : Promise.resolve(e), h = (e)=>e && Promise.resolve(e) === e, f = ()=>document.body.querySelector(`.${i.container}`), b = (e)=>{
        const t = f();
        return t ? t.querySelector(e) : null;
    }, y = (e)=>b(`.${e}`), w = ()=>y(i.popup), v = ()=>y(i.icon), C = ()=>y(i.title), A = ()=>y(i["html-container"]), k = ()=>y(i.image), B = ()=>y(i["progress-steps"]), P = ()=>y(i["validation-message"]), x = ()=>b(`.${i.actions} .${i.confirm}`), E = ()=>b(`.${i.actions} .${i.cancel}`), $ = ()=>b(`.${i.actions} .${i.deny}`), T = ()=>b(`.${i.loader}`), L = ()=>y(i.actions), S = ()=>y(i.footer), O = ()=>y(i["timer-progress-bar"]), M = ()=>y(i.close), j = ()=>{
        const e = Array.from(w().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')).sort((e, t)=>{
            const o = parseInt(e.getAttribute("tabindex")), n = parseInt(t.getAttribute("tabindex"));
            return o > n ? 1 : o < n ? -1 : 0;
        }), t = Array.from(w().querySelectorAll('\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n')).filter((e)=>"-1" !== e.getAttribute("tabindex"));
        return ((e)=>{
            const t = [];
            for(let o = 0; o < e.length; o++)-1 === t.indexOf(e[o]) && t.push(e[o]);
            return t;
        })(e.concat(t)).filter((e)=>G(e));
    }, I = ()=>V(document.body, i.shown) && !V(document.body, i["toast-shown"]) && !V(document.body, i["no-backdrop"]), H = ()=>w() && V(w(), i.toast), D = {
        previousBodyPadding: null
    }, q = (e, t)=>{
        if (e.textContent = "", t) {
            const o = (new DOMParser).parseFromString(t, "text/html");
            Array.from(o.querySelector("head").childNodes).forEach((t)=>{
                e.appendChild(t);
            }), Array.from(o.querySelector("body").childNodes).forEach((t)=>{
                t instanceof HTMLVideoElement || t instanceof HTMLAudioElement ? e.appendChild(t.cloneNode(!0)) : e.appendChild(t);
            });
        }
    }, V = (e, t)=>{
        if (!t) return !1;
        const o = t.split(/\s+/);
        for(let t = 0; t < o.length; t++)if (!e.classList.contains(o[t])) return !1;
        return !0;
    }, N = (e, t, o)=>{
        if (((e, t)=>{
            Array.from(e.classList).forEach((o)=>{
                Object.values(i).includes(o) || Object.values(s).includes(o) || Object.values(t.showClass).includes(o) || e.classList.remove(o);
            });
        })(e, t), t.customClass && t.customClass[o]) {
            if ("string" != typeof t.customClass[o] && !t.customClass[o].forEach) return void l(`Invalid type of customClass.${o}! Expected string or iterable object, got "${typeof t.customClass[o]}"`);
            U(e, t.customClass[o]);
        }
    }, F = (e, t)=>{
        if (!t) return null;
        switch(t){
            case "select":
            case "textarea":
            case "file":
                return e.querySelector(`.${i.popup} > .${i[t]}`);
            case "checkbox":
                return e.querySelector(`.${i.popup} > .${i.checkbox} input`);
            case "radio":
                return e.querySelector(`.${i.popup} > .${i.radio} input:checked`) || e.querySelector(`.${i.popup} > .${i.radio} input:first-child`);
            case "range":
                return e.querySelector(`.${i.popup} > .${i.range} input`);
            default:
                return e.querySelector(`.${i.popup} > .${i.input}`);
        }
    }, _ = (e)=>{
        if (e.focus(), "file" !== e.type) {
            const t = e.value;
            e.value = "", e.value = t;
        }
    }, R = (e, t, o)=>{
        e && t && ("string" == typeof t && (t = t.split(/\s+/).filter(Boolean)), t.forEach((t)=>{
            Array.isArray(e) ? e.forEach((e)=>{
                o ? e.classList.add(t) : e.classList.remove(t);
            }) : o ? e.classList.add(t) : e.classList.remove(t);
        }));
    }, U = (e, t)=>{
        R(e, t, !0);
    }, z = (e, t)=>{
        R(e, t, !1);
    }, W = (e, t)=>{
        const o = Array.from(e.children);
        for(let e = 0; e < o.length; e++){
            const n = o[e];
            if (n instanceof HTMLElement && V(n, t)) return n;
        }
    }, K = (e, t, o)=>{
        o === `${parseInt(o)}` && (o = parseInt(o)), o || 0 === parseInt(o) ? e.style[t] = "number" == typeof o ? `${o}px` : o : e.style.removeProperty(t);
    }, Y = function(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "flex";
        e.style.display = t;
    }, Z = (e)=>{
        e.style.display = "none";
    }, J = (e, t, o, n)=>{
        const i = e.querySelector(t);
        i && (i.style[o] = n);
    }, X = function(e, t) {
        t ? Y(e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "flex") : Z(e);
    }, G = (e)=>!(!e || !(e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Q = (e)=>!!(e.scrollHeight > e.clientHeight), ee = (e)=>{
        const t = window.getComputedStyle(e), o = parseFloat(t.getPropertyValue("animation-duration") || "0"), n = parseFloat(t.getPropertyValue("transition-duration") || "0");
        return o > 0 || n > 0;
    }, te = function(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        const o = O();
        G(o) && (t && (o.style.transition = "none", o.style.width = "100%"), setTimeout(()=>{
            o.style.transition = `width ${e / 1e3}s linear`, o.style.width = "0%";
        }, 10));
    }, oe = ()=>"undefined" == typeof window || "undefined" == typeof document, ne = `\n <div aria-labelledby="${i.title}" aria-describedby="${i["html-container"]}" class="${i.popup}" tabindex="-1">\n   <button type="button" class="${i.close}"></button>\n   <ul class="${i["progress-steps"]}"></ul>\n   <div class="${i.icon}"></div>\n   <img class="${i.image}" />\n   <h2 class="${i.title}" id="${i.title}"></h2>\n   <div class="${i["html-container"]}" id="${i["html-container"]}"></div>\n   <input class="${i.input}" />\n   <input type="file" class="${i.file}" />\n   <div class="${i.range}">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="${i.select}"></select>\n   <div class="${i.radio}"></div>\n   <label for="${i.checkbox}" class="${i.checkbox}">\n     <input type="checkbox" />\n     <span class="${i.label}"></span>\n   </label>\n   <textarea class="${i.textarea}"></textarea>\n   <div class="${i["validation-message"]}" id="${i["validation-message"]}"></div>\n   <div class="${i.actions}">\n     <div class="${i.loader}"></div>\n     <button type="button" class="${i.confirm}"></button>\n     <button type="button" class="${i.deny}"></button>\n     <button type="button" class="${i.cancel}"></button>\n   </div>\n   <div class="${i.footer}"></div>\n   <div class="${i["timer-progress-bar-container"]}">\n     <div class="${i["timer-progress-bar"]}"></div>\n   </div>\n </div>\n`.replace(/(^|\n)\s*/g, ""), ie = ()=>{
        e.currentInstance.resetValidationMessage();
    }, se = (e)=>{
        const t = (()=>{
            const e = f();
            return !!e && (e.remove(), z([
                document.documentElement,
                document.body
            ], [
                i["no-backdrop"],
                i["toast-shown"],
                i["has-column"]
            ]), !0);
        })();
        if (oe()) return void c("SweetAlert2 requires document to initialize");
        const o = document.createElement("div");
        o.className = i.container, t && U(o, i["no-transition"]), q(o, ne);
        const n = "string" == typeof (s = e.target) ? document.querySelector(s) : s;
        var s;
        n.appendChild(o), ((e)=>{
            const t = w();
            t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
        })(e), ((e)=>{
            "rtl" === window.getComputedStyle(e).direction && U(f(), i.rtl);
        })(n), (()=>{
            const e = w(), t = W(e, i.input), o = W(e, i.file), n = e.querySelector(`.${i.range} input`), s = e.querySelector(`.${i.range} output`), r = W(e, i.select), a = e.querySelector(`.${i.checkbox} input`), l = W(e, i.textarea);
            t.oninput = ie, o.onchange = ie, r.onchange = ie, a.onchange = ie, l.oninput = ie, n.oninput = ()=>{
                ie(), s.value = n.value;
            }, n.onchange = ()=>{
                ie(), s.value = n.value;
            };
        })();
    }, re = (e, t)=>{
        e instanceof HTMLElement ? t.appendChild(e) : "object" == typeof e ? ae(e, t) : e && q(t, e);
    }, ae = (e, t)=>{
        e.jquery ? le(t, e) : q(t, e.toString());
    }, le = (e, t)=>{
        if (e.textContent = "", 0 in t) for(let o = 0; o in t; o++)e.appendChild(t[o].cloneNode(!0));
        else e.appendChild(t.cloneNode(!0));
    }, ce = (()=>{
        if (oe()) return !1;
        const e = document.createElement("div"), t = {
            WebkitAnimation: "webkitAnimationEnd",
            animation: "animationend"
        };
        for(const o in t)if (Object.prototype.hasOwnProperty.call(t, o) && void 0 !== e.style[o]) return t[o];
        return !1;
    })(), ue = (e, t)=>{
        const o = L(), n = T();
        t.showConfirmButton || t.showDenyButton || t.showCancelButton ? Y(o) : Z(o), N(o, t, "actions"), function(e, t, o) {
            const n = x(), s = $(), r = E();
            de(n, "confirm", o), de(s, "deny", o), de(r, "cancel", o), function(e, t, o, n) {
                if (!n.buttonsStyling) return void z([
                    e,
                    t,
                    o
                ], i.styled);
                U([
                    e,
                    t,
                    o
                ], i.styled), n.confirmButtonColor && (e.style.backgroundColor = n.confirmButtonColor, U(e, i["default-outline"]));
                n.denyButtonColor && (t.style.backgroundColor = n.denyButtonColor, U(t, i["default-outline"]));
                n.cancelButtonColor && (o.style.backgroundColor = n.cancelButtonColor, U(o, i["default-outline"]));
            }(n, s, r, o), o.reverseButtons && (o.toast ? (e.insertBefore(r, n), e.insertBefore(s, n)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(n, t)));
        }(o, n, t), q(n, t.loaderHtml), N(n, t, "loader");
    };
    function de(e, t, o) {
        X(e, o[`show${a(t)}Button`], "inline-block"), q(e, o[`${t}ButtonText`]), e.setAttribute("aria-label", o[`${t}ButtonAriaLabel`]), e.className = i[t], N(e, o, `${t}Button`), U(e, o[`${t}ButtonClass`]);
    }
    const pe = (e, t)=>{
        const o = f();
        o && (!function(e, t) {
            "string" == typeof t ? e.style.background = t : t || U([
                document.documentElement,
                document.body
            ], i["no-backdrop"]);
        }(o, t.backdrop), function(e, t) {
            t in i ? U(e, i[t]) : (l('The "position" parameter is not valid, defaulting to "center"'), U(e, i.center));
        }(o, t.position), function(e, t) {
            if (t && "string" == typeof t) {
                const o = `grow-${t}`;
                o in i && U(e, i[o]);
            }
        }(o, t.grow), N(o, t, "container"));
    };
    const me = [
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "textarea"
    ], ge = (e)=>{
        if (!Ce[e.input]) return void c(`Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "${e.input}"`);
        const t = we(e.input), o = Ce[e.input](t, e);
        Y(t), e.inputAutoFocus && setTimeout(()=>{
            _(o);
        });
    }, he = (e, t)=>{
        const o = F(w(), e);
        if (o) {
            ((e)=>{
                for(let t = 0; t < e.attributes.length; t++){
                    const o = e.attributes[t].name;
                    [
                        "type",
                        "value",
                        "style"
                    ].includes(o) || e.removeAttribute(o);
                }
            })(o);
            for(const e in t)o.setAttribute(e, t[e]);
        }
    }, fe = (e)=>{
        const t = we(e.input);
        "object" == typeof e.customClass && U(t, e.customClass.input);
    }, be = (e, t)=>{
        e.placeholder && !t.inputPlaceholder || (e.placeholder = t.inputPlaceholder);
    }, ye = (e, t, o)=>{
        if (o.inputLabel) {
            e.id = i.input;
            const n = document.createElement("label"), s = i["input-label"];
            n.setAttribute("for", e.id), n.className = s, "object" == typeof o.customClass && U(n, o.customClass.inputLabel), n.innerText = o.inputLabel, t.insertAdjacentElement("beforebegin", n);
        }
    }, we = (e)=>W(w(), i[e] || i.input), ve = (e, t)=>{
        [
            "string",
            "number"
        ].includes(typeof t) ? e.value = `${t}` : h(t) || l(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
    }, Ce = {};
    Ce.text = Ce.email = Ce.password = Ce.number = Ce.tel = Ce.url = (e, t)=>(ve(e, t.inputValue), ye(e, e, t), be(e, t), e.type = t.input, e), Ce.file = (e, t)=>(ye(e, e, t), be(e, t), e), Ce.range = (e, t)=>{
        const o = e.querySelector("input"), n = e.querySelector("output");
        return ve(o, t.inputValue), o.type = t.input, ve(n, t.inputValue), ye(o, e, t), e;
    }, Ce.select = (e, t)=>{
        if (e.textContent = "", t.inputPlaceholder) {
            const o = document.createElement("option");
            q(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, e.appendChild(o);
        }
        return ye(e, e, t), e;
    }, Ce.radio = (e)=>(e.textContent = "", e), Ce.checkbox = (e, t)=>{
        const o = F(w(), "checkbox");
        o.value = "1", o.id = i.checkbox, o.checked = Boolean(t.inputValue);
        const n = e.querySelector("span");
        return q(n, t.inputPlaceholder), o;
    }, Ce.textarea = (e, t)=>{
        ve(e, t.inputValue), be(e, t), ye(e, e, t);
        return setTimeout(()=>{
            if ("MutationObserver" in window) {
                const t = parseInt(window.getComputedStyle(w()).width);
                new MutationObserver(()=>{
                    const o = e.offsetWidth + (n = e, parseInt(window.getComputedStyle(n).marginLeft) + parseInt(window.getComputedStyle(n).marginRight));
                    var n;
                    w().style.width = o > t ? `${o}px` : null;
                }).observe(e, {
                    attributes: !0,
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        }), e;
    };
    const Ae = (e, t)=>{
        const n = A();
        N(n, t, "htmlContainer"), t.html ? (re(t.html, n), Y(n, "block")) : t.text ? (n.textContent = t.text, Y(n, "block")) : Z(n), ((e, t)=>{
            const n = w(), s = o.innerParams.get(e), r = !s || t.input !== s.input;
            me.forEach((e)=>{
                const o = W(n, i[e]);
                he(e, t.inputAttributes), o.className = i[e], r && Z(o);
            }), t.input && (r && ge(t), fe(t));
        })(e, t);
    }, ke = (e, t)=>{
        for(const o in s)t.icon !== o && z(e, s[o]);
        U(e, s[t.icon]), xe(e, t), Be(), N(e, t, "icon");
    }, Be = ()=>{
        const e = w(), t = window.getComputedStyle(e).getPropertyValue("background-color"), o = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
        for(let e = 0; e < o.length; e++)o[e].style.backgroundColor = t;
    }, Pe = (e, t)=>{
        let o, n = e.innerHTML;
        if (t.iconHtml) o = Ee(t.iconHtml);
        else if ("success" === t.icon) o = '\n  <div class="swal2-success-circular-line-left"></div>\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n  <div class="swal2-success-circular-line-right"></div>\n', n = n.replace(/ style=".*?"/g, "");
        else if ("error" === t.icon) o = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';
        else o = Ee({
            question: "?",
            warning: "!",
            info: "i"
        }[t.icon]);
        n.trim() !== o.trim() && q(e, o);
    }, xe = (e, t)=>{
        if (t.iconColor) {
            e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
            for (const o of [
                ".swal2-success-line-tip",
                ".swal2-success-line-long",
                ".swal2-x-mark-line-left",
                ".swal2-x-mark-line-right"
            ])J(e, o, "backgroundColor", t.iconColor);
            J(e, ".swal2-success-ring", "borderColor", t.iconColor);
        }
    }, Ee = (e)=>`<div class="${i["icon-content"]}">${e}</div>`, $e = (e, t)=>{
        e.className = `${i.popup} ${G(e) ? t.showClass.popup : ""}`, t.toast ? (U([
            document.documentElement,
            document.body
        ], i["toast-shown"]), U(e, i.toast)) : U(e, i.modal), N(e, t, "popup"), "string" == typeof t.customClass && U(e, t.customClass), t.icon && U(e, i[`icon-${t.icon}`]);
    }, Te = (e)=>{
        const t = document.createElement("li");
        return U(t, i["progress-step"]), q(t, e), t;
    }, Le = (e)=>{
        const t = document.createElement("li");
        return U(t, i["progress-step-line"]), e.progressStepsDistance && K(t, "width", e.progressStepsDistance), t;
    }, Se = (e, t)=>{
        ((e, t)=>{
            const o = f(), n = w();
            t.toast ? (K(o, "width", t.width), n.style.width = "100%", n.insertBefore(T(), v())) : K(n, "width", t.width), K(n, "padding", t.padding), t.color && (n.style.color = t.color), t.background && (n.style.background = t.background), Z(P()), $e(n, t);
        })(0, t), pe(0, t), ((e, t)=>{
            const o = B();
            t.progressSteps && 0 !== t.progressSteps.length ? (Y(o), o.textContent = "", t.currentProgressStep >= t.progressSteps.length && l("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), t.progressSteps.forEach((e, n)=>{
                const s = Te(e);
                if (o.appendChild(s), n === t.currentProgressStep && U(s, i["active-progress-step"]), n !== t.progressSteps.length - 1) {
                    const e = Le(t);
                    o.appendChild(e);
                }
            })) : Z(o);
        })(0, t), ((e, t)=>{
            const n = o.innerParams.get(e), i = v();
            if (n && t.icon === n.icon) return Pe(i, t), void ke(i, t);
            if (t.icon || t.iconHtml) {
                if (t.icon && -1 === Object.keys(s).indexOf(t.icon)) return c(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), void Z(i);
                Y(i), Pe(i, t), ke(i, t), U(i, t.showClass.icon);
            } else Z(i);
        })(e, t), ((e, t)=>{
            const o = k();
            t.imageUrl ? (Y(o, ""), o.setAttribute("src", t.imageUrl), o.setAttribute("alt", t.imageAlt), K(o, "width", t.imageWidth), K(o, "height", t.imageHeight), o.className = i.image, N(o, t, "image")) : Z(o);
        })(0, t), ((e, t)=>{
            const o = C();
            X(o, t.title || t.titleText, "block"), t.title && re(t.title, o), t.titleText && (o.innerText = t.titleText), N(o, t, "title");
        })(0, t), ((e, t)=>{
            const o = M();
            q(o, t.closeButtonHtml), N(o, t, "closeButton"), X(o, t.showCloseButton), o.setAttribute("aria-label", t.closeButtonAriaLabel);
        })(0, t), Ae(e, t), ue(0, t), ((e, t)=>{
            const o = S();
            X(o, t.footer), t.footer && re(t.footer, o), N(o, t, "footer");
        })(0, t), "function" == typeof t.didRender && t.didRender(w());
    }, Oe = ()=>x() && x().click(), Me = Object.freeze({
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer"
    }), je = (e)=>{
        e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
            capture: e.keydownListenerCapture
        }), e.keydownHandlerAdded = !1);
    }, Ie = (e, t)=>{
        const o = j();
        if (o.length) return (e += t) === o.length ? e = 0 : -1 === e && (e = o.length - 1), void o[e].focus();
        w().focus();
    }, He = [
        "ArrowRight",
        "ArrowDown"
    ], De = [
        "ArrowLeft",
        "ArrowUp"
    ], qe = (e, t, n)=>{
        const i = o.innerParams.get(e);
        i && (t.isComposing || 229 === t.keyCode || (i.stopKeydownPropagation && t.stopPropagation(), "Enter" === t.key ? Ve(e, t, i) : "Tab" === t.key ? Ne(t) : [
            ...He,
            ...De
        ].includes(t.key) ? Fe(t.key) : "Escape" === t.key && _e(t, i, n)));
    }, Ve = (e, t, o)=>{
        if (p(o.allowEnterKey) && t.target && e.getInput() && t.target instanceof HTMLElement && t.target.outerHTML === e.getInput().outerHTML) {
            if ([
                "textarea",
                "file"
            ].includes(o.input)) return;
            Oe(), t.preventDefault();
        }
    }, Ne = (e)=>{
        const t = e.target, o = j();
        let n = -1;
        for(let e = 0; e < o.length; e++)if (t === o[e]) {
            n = e;
            break;
        }
        e.shiftKey ? Ie(n, -1) : Ie(n, 1), e.stopPropagation(), e.preventDefault();
    }, Fe = (e)=>{
        const t = [
            x(),
            $(),
            E()
        ];
        if (document.activeElement instanceof HTMLElement && !t.includes(document.activeElement)) return;
        const o = He.includes(e) ? "nextElementSibling" : "previousElementSibling";
        let n = document.activeElement;
        for(let e = 0; e < L().children.length; e++){
            if (n = n[o], !n) return;
            if (n instanceof HTMLButtonElement && G(n)) break;
        }
        n instanceof HTMLButtonElement && n.focus();
    }, _e = (e, t, o)=>{
        p(t.allowEscapeKey) && (e.preventDefault(), o(Me.esc));
    };
    var Re = {
        swalPromiseResolve: new WeakMap,
        swalPromiseReject: new WeakMap
    };
    const Ue = ()=>{
        Array.from(document.body.children).forEach((e)=>{
            e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden")), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
        });
    }, ze = ()=>{
        const e = navigator.userAgent, t = !!e.match(/iPad/i) || !!e.match(/iPhone/i), o = !!e.match(/WebKit/i);
        if (t && o && !e.match(/CriOS/i)) {
            const e = 44;
            w().scrollHeight > window.innerHeight - e && (f().style.paddingBottom = `${e}px`);
        }
    }, We = ()=>{
        const e = f();
        let t;
        e.ontouchstart = (e)=>{
            t = Ke(e);
        }, e.ontouchmove = (e)=>{
            t && (e.preventDefault(), e.stopPropagation());
        };
    }, Ke = (e)=>{
        const t = e.target, o = f();
        return !Ye(e) && !Ze(e) && (t === o || !Q(o) && t instanceof HTMLElement && "INPUT" !== t.tagName && "TEXTAREA" !== t.tagName && (!Q(A()) || !A().contains(t)));
    }, Ye = (e)=>e.touches && e.touches.length && "stylus" === e.touches[0].touchType, Ze = (e)=>e.touches && e.touches.length > 1, Je = ()=>{
        null === D.previousBodyPadding && document.body.scrollHeight > window.innerHeight && (D.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${D.previousBodyPadding + (()=>{
            const e = document.createElement("div");
            e.className = i["scrollbar-measure"], document.body.appendChild(e);
            const t = e.getBoundingClientRect().width - e.clientWidth;
            return document.body.removeChild(e), t;
        })()}px`);
    };
    function Xe(o, n, s, r) {
        H() ? st(o, r) : (t(s).then(()=>st(o, r)), je(e));
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (n.setAttribute("style", "display:none !important"), n.removeAttribute("class"), n.innerHTML = "") : n.remove(), I() && (null !== D.previousBodyPadding && (document.body.style.paddingRight = `${D.previousBodyPadding}px`, D.previousBodyPadding = null), (()=>{
            if (V(document.body, i.iosfix)) {
                const e = parseInt(document.body.style.top, 10);
                z(document.body, i.iosfix), document.body.style.top = "", document.body.scrollTop = -1 * e;
            }
        })(), Ue()), z([
            document.documentElement,
            document.body
        ], [
            i.shown,
            i["height-auto"],
            i["no-backdrop"],
            i["toast-shown"]
        ]);
    }
    function Ge(e) {
        e = ot(e);
        const t = Re.swalPromiseResolve.get(this), o = Qe(this);
        this.isAwaitingPromise ? e.isDismissed || (tt(this), t(e)) : o && t(e);
    }
    const Qe = (e)=>{
        const t = w();
        if (!t) return !1;
        const n = o.innerParams.get(e);
        if (!n || V(t, n.hideClass.popup)) return !1;
        z(t, n.showClass.popup), U(t, n.hideClass.popup);
        const i = f();
        return z(i, n.showClass.backdrop), U(i, n.hideClass.backdrop), nt(e, t, n), !0;
    };
    function et(e) {
        const t = Re.swalPromiseReject.get(this);
        tt(this), t && t(e);
    }
    const tt = (e)=>{
        e.isAwaitingPromise && (delete e.isAwaitingPromise, o.innerParams.get(e) || e._destroy());
    }, ot = (e)=>void 0 === e ? {
            isConfirmed: !1,
            isDenied: !1,
            isDismissed: !0
        } : Object.assign({
            isConfirmed: !1,
            isDenied: !1,
            isDismissed: !1
        }, e), nt = (e, t, o)=>{
        const n = f(), i = ce && ee(t);
        "function" == typeof o.willClose && o.willClose(t), i ? it(e, t, n, o.returnFocus, o.didClose) : Xe(e, n, o.returnFocus, o.didClose);
    }, it = (t, o, n, i, s)=>{
        e.swalCloseEventFinishedCallback = Xe.bind(null, t, n, i, s), o.addEventListener(ce, function(t) {
            t.target === o && (e.swalCloseEventFinishedCallback(), delete e.swalCloseEventFinishedCallback);
        });
    }, st = (e, t)=>{
        setTimeout(()=>{
            "function" == typeof t && t.bind(e.params)(), e._destroy && e._destroy();
        });
    }, rt = (e)=>{
        let t = w();
        t || new Do, t = w();
        const o = T();
        H() ? Z(v()) : at(t, e), Y(o), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
    }, at = (e, t)=>{
        const o = L(), n = T();
        !t && G(x()) && (t = x()), Y(o), t && (Z(t), n.setAttribute("data-button-to-replace", t.className)), n.parentNode.insertBefore(n, t), U([
            e,
            o
        ], i.loading);
    }, lt = (e)=>e.checked ? 1 : 0, ct = (e)=>e.checked ? e.value : null, ut = (e)=>e.files.length ? null !== e.getAttribute("multiple") ? e.files : e.files[0] : null, dt = (e, t)=>{
        const o = w(), n = (e)=>{
            mt[t.input](o, gt(e), t);
        };
        m(t.inputOptions) || h(t.inputOptions) ? (rt(x()), g(t.inputOptions).then((t)=>{
            e.hideLoading(), n(t);
        })) : "object" == typeof t.inputOptions ? n(t.inputOptions) : c("Unexpected type of inputOptions! Expected object, Map or Promise, got " + typeof t.inputOptions);
    }, pt = (e, t)=>{
        const o = e.getInput();
        Z(o), g(t.inputValue).then((n)=>{
            o.value = "number" === t.input ? `${parseFloat(n) || 0}` : `${n}`, Y(o), o.focus(), e.hideLoading();
        }).catch((t)=>{
            c(`Error in inputValue promise: ${t}`), o.value = "", Y(o), o.focus(), e.hideLoading();
        });
    }, mt = {
        select: (e, t, o)=>{
            const n = W(e, i.select), s = (e, t, n)=>{
                const i = document.createElement("option");
                i.value = n, q(i, t), i.selected = ht(n, o.inputValue), e.appendChild(i);
            };
            t.forEach((e)=>{
                const t = e[0], o = e[1];
                if (Array.isArray(o)) {
                    const e = document.createElement("optgroup");
                    e.label = t, e.disabled = !1, n.appendChild(e), o.forEach((t)=>s(e, t[1], t[0]));
                } else s(n, o, t);
            }), n.focus();
        },
        radio: (e, t, o)=>{
            const n = W(e, i.radio);
            t.forEach((e)=>{
                const t = e[0], s = e[1], r = document.createElement("input"), a = document.createElement("label");
                r.type = "radio", r.name = i.radio, r.value = t, ht(t, o.inputValue) && (r.checked = !0);
                const l = document.createElement("span");
                q(l, s), l.className = i.label, a.appendChild(r), a.appendChild(l), n.appendChild(a);
            });
            const s = n.querySelectorAll("input");
            s.length && s[0].focus();
        }
    }, gt = (e)=>{
        const t = [];
        return "undefined" != typeof Map && e instanceof Map ? e.forEach((e, o)=>{
            let n = e;
            "object" == typeof n && (n = gt(n)), t.push([
                o,
                n
            ]);
        }) : Object.keys(e).forEach((o)=>{
            let n = e[o];
            "object" == typeof n && (n = gt(n)), t.push([
                o,
                n
            ]);
        }), t;
    }, ht = (e, t)=>t && t.toString() === e.toString(), ft = (e, t)=>{
        const n = o.innerParams.get(e);
        if (!n.input) return void c(`The "input" parameter is needed to be set when using returnInputValueOn${a(t)}`);
        const i = ((e, t)=>{
            const o = e.getInput();
            if (!o) return null;
            switch(t.input){
                case "checkbox":
                    return lt(o);
                case "radio":
                    return ct(o);
                case "file":
                    return ut(o);
                default:
                    return t.inputAutoTrim ? o.value.trim() : o.value;
            }
        })(e, n);
        n.inputValidator ? bt(e, i, t) : e.getInput().checkValidity() ? "deny" === t ? yt(e, i) : Ct(e, i) : (e.enableButtons(), e.showValidationMessage(n.validationMessage));
    }, bt = (e, t, n)=>{
        const i = o.innerParams.get(e);
        e.disableInput();
        Promise.resolve().then(()=>g(i.inputValidator(t, i.validationMessage))).then((o)=>{
            e.enableButtons(), e.enableInput(), o ? e.showValidationMessage(o) : "deny" === n ? yt(e, t) : Ct(e, t);
        });
    }, yt = (e, t)=>{
        const n = o.innerParams.get(e || void 0);
        if (n.showLoaderOnDeny && rt($()), n.preDeny) {
            e.isAwaitingPromise = !0;
            Promise.resolve().then(()=>g(n.preDeny(t, n.validationMessage))).then((o)=>{
                !1 === o ? (e.hideLoading(), tt(e)) : e.close({
                    isDenied: !0,
                    value: void 0 === o ? t : o
                });
            }).catch((t)=>vt(e || void 0, t));
        } else e.close({
            isDenied: !0,
            value: t
        });
    }, wt = (e, t)=>{
        e.close({
            isConfirmed: !0,
            value: t
        });
    }, vt = (e, t)=>{
        e.rejectPromise(t);
    }, Ct = (e, t)=>{
        const n = o.innerParams.get(e || void 0);
        if (n.showLoaderOnConfirm && rt(), n.preConfirm) {
            e.resetValidationMessage(), e.isAwaitingPromise = !0;
            Promise.resolve().then(()=>g(n.preConfirm(t, n.validationMessage))).then((o)=>{
                G(P()) || !1 === o ? (e.hideLoading(), tt(e)) : wt(e, void 0 === o ? t : o);
            }).catch((t)=>vt(e || void 0, t));
        } else wt(e, t);
    };
    function At() {
        const e = o.innerParams.get(this);
        if (!e) return;
        const t = o.domCache.get(this);
        Z(t.loader), H() ? e.icon && Y(v()) : kt(t), z([
            t.popup,
            t.actions
        ], i.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
    }
    const kt = (e)=>{
        const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
        t.length ? Y(t[0], "inline-block") : G(x()) || G($()) || G(E()) || Z(e.actions);
    };
    function Bt() {
        const e = o.innerParams.get(this), t = o.domCache.get(this);
        return t ? F(t.popup, e.input) : null;
    }
    function Pt(e, t, n) {
        const i = o.domCache.get(e);
        t.forEach((e)=>{
            i[e].disabled = n;
        });
    }
    function xt(e, t) {
        if (e) {
            if ("radio" === e.type) {
                const o = e.parentNode.parentNode.querySelectorAll("input");
                for(let e = 0; e < o.length; e++)o[e].disabled = t;
            } else e.disabled = t;
        }
    }
    function Et() {
        Pt(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], !1);
    }
    function $t() {
        Pt(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], !0);
    }
    function Tt() {
        xt(this.getInput(), !1);
    }
    function Lt() {
        xt(this.getInput(), !0);
    }
    function St(e) {
        const t = o.domCache.get(this), n = o.innerParams.get(this);
        q(t.validationMessage, e), t.validationMessage.className = i["validation-message"], n.customClass && n.customClass.validationMessage && U(t.validationMessage, n.customClass.validationMessage), Y(t.validationMessage);
        const s = this.getInput();
        s && (s.setAttribute("aria-invalid", !0), s.setAttribute("aria-describedby", i["validation-message"]), _(s), U(s, i.inputerror));
    }
    function Ot() {
        const e = o.domCache.get(this);
        e.validationMessage && Z(e.validationMessage);
        const t = this.getInput();
        t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), z(t, i.inputerror));
    }
    const Mt = {
        title: "",
        titleText: "",
        text: "",
        html: "",
        footer: "",
        icon: void 0,
        iconColor: void 0,
        iconHtml: void 0,
        template: void 0,
        toast: !1,
        showClass: {
            popup: "swal2-show",
            backdrop: "swal2-backdrop-show",
            icon: "swal2-icon-show"
        },
        hideClass: {
            popup: "swal2-hide",
            backdrop: "swal2-backdrop-hide",
            icon: "swal2-icon-hide"
        },
        customClass: {},
        target: "body",
        color: void 0,
        backdrop: !0,
        heightAuto: !0,
        allowOutsideClick: !0,
        allowEscapeKey: !0,
        allowEnterKey: !0,
        stopKeydownPropagation: !0,
        keydownListenerCapture: !1,
        showConfirmButton: !0,
        showDenyButton: !1,
        showCancelButton: !1,
        preConfirm: void 0,
        preDeny: void 0,
        confirmButtonText: "OK",
        confirmButtonAriaLabel: "",
        confirmButtonColor: void 0,
        denyButtonText: "No",
        denyButtonAriaLabel: "",
        denyButtonColor: void 0,
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "",
        cancelButtonColor: void 0,
        buttonsStyling: !0,
        reverseButtons: !1,
        focusConfirm: !0,
        focusDeny: !1,
        focusCancel: !1,
        returnFocus: !0,
        showCloseButton: !1,
        closeButtonHtml: "&times;",
        closeButtonAriaLabel: "Close this dialog",
        loaderHtml: "",
        showLoaderOnConfirm: !1,
        showLoaderOnDeny: !1,
        imageUrl: void 0,
        imageWidth: void 0,
        imageHeight: void 0,
        imageAlt: "",
        timer: void 0,
        timerProgressBar: !1,
        width: void 0,
        padding: void 0,
        background: void 0,
        input: void 0,
        inputPlaceholder: "",
        inputLabel: "",
        inputValue: "",
        inputOptions: {},
        inputAutoFocus: !0,
        inputAutoTrim: !0,
        inputAttributes: {},
        inputValidator: void 0,
        returnInputValueOnDeny: !1,
        validationMessage: void 0,
        grow: !1,
        position: "center",
        progressSteps: [],
        currentProgressStep: void 0,
        progressStepsDistance: void 0,
        willOpen: void 0,
        didOpen: void 0,
        didRender: void 0,
        willClose: void 0,
        didClose: void 0,
        didDestroy: void 0,
        scrollbarPadding: !0
    }, jt = [
        "allowEscapeKey",
        "allowOutsideClick",
        "background",
        "buttonsStyling",
        "cancelButtonAriaLabel",
        "cancelButtonColor",
        "cancelButtonText",
        "closeButtonAriaLabel",
        "closeButtonHtml",
        "color",
        "confirmButtonAriaLabel",
        "confirmButtonColor",
        "confirmButtonText",
        "currentProgressStep",
        "customClass",
        "denyButtonAriaLabel",
        "denyButtonColor",
        "denyButtonText",
        "didClose",
        "didDestroy",
        "footer",
        "hideClass",
        "html",
        "icon",
        "iconColor",
        "iconHtml",
        "imageAlt",
        "imageHeight",
        "imageUrl",
        "imageWidth",
        "preConfirm",
        "preDeny",
        "progressSteps",
        "returnFocus",
        "reverseButtons",
        "showCancelButton",
        "showCloseButton",
        "showConfirmButton",
        "showDenyButton",
        "text",
        "title",
        "titleText",
        "willClose"
    ], It = {}, Ht = [
        "allowOutsideClick",
        "allowEnterKey",
        "backdrop",
        "focusConfirm",
        "focusDeny",
        "focusCancel",
        "returnFocus",
        "heightAuto",
        "keydownListenerCapture"
    ], Dt = (e)=>Object.prototype.hasOwnProperty.call(Mt, e), qt = (e)=>-1 !== jt.indexOf(e), Vt = (e)=>It[e], Nt = (e)=>{
        Dt(e) || l(`Unknown parameter "${e}"`);
    }, Ft = (e)=>{
        Ht.includes(e) && l(`The parameter "${e}" is incompatible with toasts`);
    }, _t = (e)=>{
        Vt(e) && d(e, Vt(e));
    };
    function Rt(e) {
        const t = w(), n = o.innerParams.get(this);
        if (!t || V(t, n.hideClass.popup)) return void l("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
        const i = Ut(e), s = Object.assign({}, n, i);
        Se(this, s), o.innerParams.set(this, s), Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, e),
                writable: !1,
                enumerable: !0
            }
        });
    }
    const Ut = (e)=>{
        const t = {};
        return Object.keys(e).forEach((o)=>{
            qt(o) ? t[o] = e[o] : l(`Invalid parameter to update: ${o}`);
        }), t;
    };
    function zt() {
        const t = o.domCache.get(this), n = o.innerParams.get(this);
        n ? (t.popup && e.swalCloseEventFinishedCallback && (e.swalCloseEventFinishedCallback(), delete e.swalCloseEventFinishedCallback), "function" == typeof n.didDestroy && n.didDestroy(), Wt(this)) : Kt(this);
    }
    const Wt = (t)=>{
        Kt(t), delete t.params, delete e.keydownHandler, delete e.keydownTarget, delete e.currentInstance;
    }, Kt = (e)=>{
        e.isAwaitingPromise ? (Yt(o, e), e.isAwaitingPromise = !0) : (Yt(Re, e), Yt(o, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
    }, Yt = (e, t)=>{
        for(const o in e)e[o].delete(t);
    };
    var Zt = Object.freeze({
        __proto__: null,
        _destroy: zt,
        close: Ge,
        closeModal: Ge,
        closePopup: Ge,
        closeToast: Ge,
        disableButtons: $t,
        disableInput: Lt,
        disableLoading: At,
        enableButtons: Et,
        enableInput: Tt,
        getInput: Bt,
        handleAwaitingPromise: tt,
        hideLoading: At,
        rejectPromise: et,
        resetValidationMessage: Ot,
        showValidationMessage: St,
        update: Rt
    });
    const Jt = (e, t, n)=>{
        t.popup.onclick = ()=>{
            const t = o.innerParams.get(e);
            t && (Xt(t) || t.timer || t.input) || n(Me.close);
        };
    }, Xt = (e)=>e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton;
    let Gt = !1;
    const Qt = (e)=>{
        e.popup.onmousedown = ()=>{
            e.container.onmouseup = function(t) {
                e.container.onmouseup = void 0, t.target === e.container && (Gt = !0);
            };
        };
    }, eo = (e)=>{
        e.container.onmousedown = ()=>{
            e.popup.onmouseup = function(t) {
                e.popup.onmouseup = void 0, (t.target === e.popup || e.popup.contains(t.target)) && (Gt = !0);
            };
        };
    }, to = (e, t, n)=>{
        t.container.onclick = (i)=>{
            const s = o.innerParams.get(e);
            Gt ? Gt = !1 : i.target === t.container && p(s.allowOutsideClick) && n(Me.backdrop);
        };
    }, oo = (e)=>e instanceof Element || ((e)=>"object" == typeof e && e.jquery)(e);
    const no = ()=>{
        if (e.timeout) return (()=>{
            const e = O(), t = parseInt(window.getComputedStyle(e).width);
            e.style.removeProperty("transition"), e.style.width = "100%";
            const o = t / parseInt(window.getComputedStyle(e).width) * 100;
            e.style.width = `${o}%`;
        })(), e.timeout.stop();
    }, io = ()=>{
        if (e.timeout) {
            const t = e.timeout.start();
            return te(t), t;
        }
    };
    let so = !1;
    const ro = {};
    const ao = (e)=>{
        for(let t = e.target; t && t !== document; t = t.parentNode)for(const e in ro){
            const o = t.getAttribute(e);
            if (o) return void ro[e].fire({
                template: o
            });
        }
    };
    var lo = Object.freeze({
        __proto__: null,
        argsToParams: (e)=>{
            const t = {};
            return "object" != typeof e[0] || oo(e[0]) ? [
                "title",
                "html",
                "icon"
            ].forEach((o, n)=>{
                const i = e[n];
                "string" == typeof i || oo(i) ? t[o] = i : void 0 !== i && c(`Unexpected type of ${o}! Expected "string" or "Element", got ${typeof i}`);
            }) : Object.assign(t, e[0]), t;
        },
        bindClickHandler: function() {
            ro[arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "data-swal-template"] = this, so || (document.body.addEventListener("click", ao), so = !0);
        },
        clickCancel: ()=>E() && E().click(),
        clickConfirm: Oe,
        clickDeny: ()=>$() && $().click(),
        enableLoading: rt,
        fire: function() {
            for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
            return new this(...t);
        },
        getActions: L,
        getCancelButton: E,
        getCloseButton: M,
        getConfirmButton: x,
        getContainer: f,
        getDenyButton: $,
        getFocusableElements: j,
        getFooter: S,
        getHtmlContainer: A,
        getIcon: v,
        getIconContent: ()=>y(i["icon-content"]),
        getImage: k,
        getInputLabel: ()=>y(i["input-label"]),
        getLoader: T,
        getPopup: w,
        getProgressSteps: B,
        getTimerLeft: ()=>e.timeout && e.timeout.getTimerLeft(),
        getTimerProgressBar: O,
        getTitle: C,
        getValidationMessage: P,
        increaseTimer: (t)=>{
            if (e.timeout) {
                const o = e.timeout.increase(t);
                return te(o, !0), o;
            }
        },
        isDeprecatedParameter: Vt,
        isLoading: ()=>w().hasAttribute("data-loading"),
        isTimerRunning: ()=>e.timeout && e.timeout.isRunning(),
        isUpdatableParameter: qt,
        isValidParameter: Dt,
        isVisible: ()=>G(w()),
        mixin: function(e) {
            return class extends this {
                _main(t, o) {
                    return super._main(t, Object.assign({}, e, o));
                }
            };
        },
        resumeTimer: io,
        showLoading: rt,
        stopTimer: no,
        toggleTimer: ()=>{
            const t = e.timeout;
            return t && (t.running ? no() : io());
        }
    });
    class co {
        constructor(e, t){
            this.callback = e, this.remaining = t, this.running = !1, this.start();
        }
        start() {
            return this.running || (this.running = !0, this.started = new Date, this.id = setTimeout(this.callback, this.remaining)), this.remaining;
        }
        stop() {
            return this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (new Date).getTime() - this.started.getTime()), this.remaining;
        }
        increase(e) {
            const t = this.running;
            return t && this.stop(), this.remaining += e, t && this.start(), this.remaining;
        }
        getTimerLeft() {
            return this.running && (this.stop(), this.start()), this.remaining;
        }
        isRunning() {
            return this.running;
        }
    }
    const uo = [
        "swal-title",
        "swal-html",
        "swal-footer"
    ], po = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-param")).forEach((e)=>{
            vo(e, [
                "name",
                "value"
            ]);
            const o = e.getAttribute("name"), n = e.getAttribute("value");
            t[o] = "boolean" == typeof Mt[o] ? "false" !== n : "object" == typeof Mt[o] ? JSON.parse(n) : n;
        }), t;
    }, mo = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-function-param")).forEach((e)=>{
            const o = e.getAttribute("name"), n = e.getAttribute("value");
            t[o] = new Function(`return ${n}`)();
        }), t;
    }, go = (e)=>{
        const t = {};
        return Array.from(e.querySelectorAll("swal-button")).forEach((e)=>{
            vo(e, [
                "type",
                "color",
                "aria-label"
            ]);
            const o = e.getAttribute("type");
            t[`${o}ButtonText`] = e.innerHTML, t[`show${a(o)}Button`] = !0, e.hasAttribute("color") && (t[`${o}ButtonColor`] = e.getAttribute("color")), e.hasAttribute("aria-label") && (t[`${o}ButtonAriaLabel`] = e.getAttribute("aria-label"));
        }), t;
    }, ho = (e)=>{
        const t = {}, o = e.querySelector("swal-image");
        return o && (vo(o, [
            "src",
            "width",
            "height",
            "alt"
        ]), o.hasAttribute("src") && (t.imageUrl = o.getAttribute("src")), o.hasAttribute("width") && (t.imageWidth = o.getAttribute("width")), o.hasAttribute("height") && (t.imageHeight = o.getAttribute("height")), o.hasAttribute("alt") && (t.imageAlt = o.getAttribute("alt"))), t;
    }, fo = (e)=>{
        const t = {}, o = e.querySelector("swal-icon");
        return o && (vo(o, [
            "type",
            "color"
        ]), o.hasAttribute("type") && (t.icon = o.getAttribute("type")), o.hasAttribute("color") && (t.iconColor = o.getAttribute("color")), t.iconHtml = o.innerHTML), t;
    }, bo = (e)=>{
        const t = {}, o = e.querySelector("swal-input");
        o && (vo(o, [
            "type",
            "label",
            "placeholder",
            "value"
        ]), t.input = o.getAttribute("type") || "text", o.hasAttribute("label") && (t.inputLabel = o.getAttribute("label")), o.hasAttribute("placeholder") && (t.inputPlaceholder = o.getAttribute("placeholder")), o.hasAttribute("value") && (t.inputValue = o.getAttribute("value")));
        const n = Array.from(e.querySelectorAll("swal-input-option"));
        return n.length && (t.inputOptions = {}, n.forEach((e)=>{
            vo(e, [
                "value"
            ]);
            const o = e.getAttribute("value"), n = e.innerHTML;
            t.inputOptions[o] = n;
        })), t;
    }, yo = (e, t)=>{
        const o = {};
        for(const n in t){
            const i = t[n], s = e.querySelector(i);
            s && (vo(s, []), o[i.replace(/^swal-/, "")] = s.innerHTML.trim());
        }
        return o;
    }, wo = (e)=>{
        const t = uo.concat([
            "swal-param",
            "swal-function-param",
            "swal-button",
            "swal-image",
            "swal-icon",
            "swal-input",
            "swal-input-option"
        ]);
        Array.from(e.children).forEach((e)=>{
            const o = e.tagName.toLowerCase();
            t.includes(o) || l(`Unrecognized element <${o}>`);
        });
    }, vo = (e, t)=>{
        Array.from(e.attributes).forEach((o)=>{
            -1 === t.indexOf(o.name) && l([
                `Unrecognized attribute "${o.name}" on <${e.tagName.toLowerCase()}>.`,
                "" + (t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element.")
            ]);
        });
    }, Co = (t)=>{
        const o = f(), n = w();
        "function" == typeof t.willOpen && t.willOpen(n);
        const s = window.getComputedStyle(document.body).overflowY;
        Po(o, n, t), setTimeout(()=>{
            ko(o, n);
        }, 10), I() && (Bo(o, t.scrollbarPadding, s), Array.from(document.body.children).forEach((e)=>{
            e === f() || e.contains(f()) || (e.hasAttribute("aria-hidden") && e.setAttribute("data-previous-aria-hidden", e.getAttribute("aria-hidden")), e.setAttribute("aria-hidden", "true"));
        })), H() || e.previousActiveElement || (e.previousActiveElement = document.activeElement), "function" == typeof t.didOpen && setTimeout(()=>t.didOpen(n)), z(o, i["no-transition"]);
    }, Ao = (e)=>{
        const t = w();
        if (e.target !== t) return;
        const o = f();
        t.removeEventListener(ce, Ao), o.style.overflowY = "auto";
    }, ko = (e, t)=>{
        ce && ee(t) ? (e.style.overflowY = "hidden", t.addEventListener(ce, Ao)) : e.style.overflowY = "auto";
    }, Bo = (e, t, o)=>{
        (()=>{
            if ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1) && !V(document.body, i.iosfix)) {
                const e = document.body.scrollTop;
                document.body.style.top = -1 * e + "px", U(document.body, i.iosfix), We(), ze();
            }
        })(), t && "hidden" !== o && Je(), setTimeout(()=>{
            e.scrollTop = 0;
        });
    }, Po = (e, t, o)=>{
        U(e, o.showClass.backdrop), t.style.setProperty("opacity", "0", "important"), Y(t, "grid"), setTimeout(()=>{
            U(t, o.showClass.popup), t.style.removeProperty("opacity");
        }, 10), U([
            document.documentElement,
            document.body
        ], i.shown), o.heightAuto && o.backdrop && !o.toast && U([
            document.documentElement,
            document.body
        ], i["height-auto"]);
    };
    var xo = {
        email: (e, t)=>/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
        url: (e, t)=>/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
    };
    function Eo(e) {
        !function(e) {
            e.inputValidator || Object.keys(xo).forEach((t)=>{
                e.input === t && (e.inputValidator = xo[t]);
            });
        }(e), e.showLoaderOnConfirm && !e.preConfirm && l("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"), function(e) {
            (!e.target || "string" == typeof e.target && !document.querySelector(e.target) || "string" != typeof e.target && !e.target.appendChild) && (l('Target parameter is not valid, defaulting to "body"'), e.target = "body");
        }(e), "string" == typeof e.title && (e.title = e.title.split("\n").join("<br />")), se(e);
    }
    let $o;
    class To {
        constructor(){
            if ("undefined" == typeof window) return;
            $o = this;
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            const i = Object.freeze(this.constructor.argsToParams(t));
            Object.defineProperties(this, {
                params: {
                    value: i,
                    writable: !1,
                    enumerable: !0,
                    configurable: !0
                }
            }), this.isAwaitingPromise = !1;
            const s = $o._main($o.params);
            o.promise.set(this, s);
        }
        _main(t) {
            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            ((e)=>{
                !1 === e.backdrop && e.allowOutsideClick && l('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
                for(const t in e)Nt(t), e.toast && Ft(t), _t(t);
            })(Object.assign({}, n, t)), e.currentInstance && (e.currentInstance._destroy(), I() && Ue()), e.currentInstance = $o;
            const i = So(t, n);
            Eo(i), Object.freeze(i), e.timeout && (e.timeout.stop(), delete e.timeout), clearTimeout(e.restoreFocusTimeout);
            const s = Oo($o);
            return Se($o, i), o.innerParams.set($o, i), Lo($o, s, i);
        }
        then(e) {
            return o.promise.get(this).then(e);
        }
        finally(e) {
            return o.promise.get(this).finally(e);
        }
    }
    const Lo = (t, n, i)=>new Promise((s, r)=>{
            const a = (e)=>{
                t.close({
                    isDismissed: !0,
                    dismiss: e
                });
            };
            Re.swalPromiseResolve.set(t, s), Re.swalPromiseReject.set(t, r), n.confirmButton.onclick = ()=>{
                ((e)=>{
                    const t = o.innerParams.get(e);
                    e.disableButtons(), t.input ? ft(e, "confirm") : Ct(e, !0);
                })(t);
            }, n.denyButton.onclick = ()=>{
                ((e)=>{
                    const t = o.innerParams.get(e);
                    e.disableButtons(), t.returnInputValueOnDeny ? ft(e, "deny") : yt(e, !1);
                })(t);
            }, n.cancelButton.onclick = ()=>{
                ((e, t)=>{
                    e.disableButtons(), t(Me.cancel);
                })(t, a);
            }, n.closeButton.onclick = ()=>{
                a(Me.close);
            }, ((e, t, n)=>{
                o.innerParams.get(e).toast ? Jt(e, t, n) : (Qt(t), eo(t), to(e, t, n));
            })(t, n, a), ((e, t, o, n)=>{
                je(t), o.toast || (t.keydownHandler = (t)=>qe(e, t, n), t.keydownTarget = o.keydownListenerCapture ? window : w(), t.keydownListenerCapture = o.keydownListenerCapture, t.keydownTarget.addEventListener("keydown", t.keydownHandler, {
                    capture: t.keydownListenerCapture
                }), t.keydownHandlerAdded = !0);
            })(t, e, i, a), ((e, t)=>{
                "select" === t.input || "radio" === t.input ? dt(e, t) : [
                    "text",
                    "email",
                    "number",
                    "tel",
                    "textarea"
                ].includes(t.input) && (m(t.inputValue) || h(t.inputValue)) && (rt(x()), pt(e, t));
            })(t, i), Co(i), Mo(e, i, a), jo(n, i), setTimeout(()=>{
                n.container.scrollTop = 0;
            });
        }), So = (e, t)=>{
        const o = ((e)=>{
            const t = "string" == typeof e.template ? document.querySelector(e.template) : e.template;
            if (!t) return {};
            const o = t.content;
            return wo(o), Object.assign(po(o), mo(o), go(o), ho(o), fo(o), bo(o), yo(o, uo));
        })(e), n = Object.assign({}, Mt, t, o, e);
        return n.showClass = Object.assign({}, Mt.showClass, n.showClass), n.hideClass = Object.assign({}, Mt.hideClass, n.hideClass), n;
    }, Oo = (e)=>{
        const t = {
            popup: w(),
            container: f(),
            actions: L(),
            confirmButton: x(),
            denyButton: $(),
            cancelButton: E(),
            loader: T(),
            closeButton: M(),
            validationMessage: P(),
            progressSteps: B()
        };
        return o.domCache.set(e, t), t;
    }, Mo = (e, t, o)=>{
        const n = O();
        Z(n), t.timer && (e.timeout = new co(()=>{
            o("timer"), delete e.timeout;
        }, t.timer), t.timerProgressBar && (Y(n), N(n, t, "timerProgressBar"), setTimeout(()=>{
            e.timeout && e.timeout.running && te(t.timer);
        })));
    }, jo = (e, t)=>{
        t.toast || (p(t.allowEnterKey) ? Io(e, t) || Ie(-1, 1) : Ho());
    }, Io = (e, t)=>t.focusDeny && G(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && G(e.cancelButton) ? (e.cancelButton.focus(), !0) : !(!t.focusConfirm || !G(e.confirmButton)) && (e.confirmButton.focus(), !0), Ho = ()=>{
        document.activeElement instanceof HTMLElement && "function" == typeof document.activeElement.blur && document.activeElement.blur();
    };
    if ("undefined" != typeof window && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|xn--p1ai)$/)) {
        const e = new Date, t = localStorage.getItem("swal-initiation");
        t ? (e.getTime() - Date.parse(t)) / 864e5 > 3 && setTimeout(()=>{
            document.body.style.pointerEvents = "none";
            const e = document.createElement("audio");
            e.src = "https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3", e.loop = !0, document.body.appendChild(e), setTimeout(()=>{
                e.play().catch(()=>{});
            }, 2500);
        }, 500) : localStorage.setItem("swal-initiation", `${e}`);
    }
    To.prototype.disableButtons = $t, To.prototype.enableButtons = Et, To.prototype.getInput = Bt, To.prototype.disableInput = Lt, To.prototype.enableInput = Tt, To.prototype.hideLoading = At, To.prototype.disableLoading = At, To.prototype.showValidationMessage = St, To.prototype.resetValidationMessage = Ot, To.prototype.close = Ge, To.prototype.closePopup = Ge, To.prototype.closeModal = Ge, To.prototype.closeToast = Ge, To.prototype.rejectPromise = et, To.prototype.update = Rt, To.prototype._destroy = zt, Object.assign(To, lo), Object.keys(Zt).forEach((e)=>{
        To[e] = function() {
            return $o && $o[e] ? $o[e](...arguments) : null;
        };
    }), To.DismissReason = Me, To.version = "11.7.7";
    const Do = To;
    return Do.default = Do, Do;
}), void 0 !== this && this.Sweetalert2 && (this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2);
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, ".swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}.swal2-container{display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show,.swal2-container.swal2-noanimation{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:rgba(0,0,0,0) !important}.swal2-container.swal2-top-start,.swal2-container.swal2-center-start,.swal2-container.swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}.swal2-container.swal2-top,.swal2-container.swal2-center,.swal2-container.swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}.swal2-container.swal2-top-end,.swal2-container.swal2-center-end,.swal2-container.swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}.swal2-container.swal2-top-start>.swal2-popup{align-self:start}.swal2-container.swal2-top>.swal2-popup{grid-column:2;align-self:start;justify-self:center}.swal2-container.swal2-top-end>.swal2-popup,.swal2-container.swal2-top-right>.swal2-popup{grid-column:3;align-self:start;justify-self:end}.swal2-container.swal2-center-start>.swal2-popup,.swal2-container.swal2-center-left>.swal2-popup{grid-row:2;align-self:center}.swal2-container.swal2-center>.swal2-popup{grid-column:2;grid-row:2;align-self:center;justify-self:center}.swal2-container.swal2-center-end>.swal2-popup,.swal2-container.swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;align-self:center;justify-self:end}.swal2-container.swal2-bottom-start>.swal2-popup,.swal2-container.swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}.swal2-container.swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;justify-self:center;align-self:end}.swal2-container.swal2-bottom-end>.swal2-popup,.swal2-container.swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;align-self:end;justify-self:end}.swal2-container.swal2-grow-row>.swal2-popup,.swal2-container.swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}.swal2-container.swal2-grow-column>.swal2-popup,.swal2-container.swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}.swal2-container.swal2-no-transition{transition:none !important}.swal2-popup{display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:none}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-title{position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}.swal2-loader{display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}.swal2-styled{margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}.swal2-styled.swal2-confirm:focus{box-shadow:0 0 0 3px rgba(112,102,224,.5)}.swal2-styled.swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}.swal2-styled.swal2-deny:focus{box-shadow:0 0 0 3px rgba(220,55,65,.5)}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}.swal2-styled.swal2-cancel:focus{box-shadow:0 0 0 3px rgba(110,120,129,.5)}.swal2-styled.swal2-default-outline:focus{box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-styled:focus{outline:none}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{justify-content:center;margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em}.swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.swal2-timer-progress-bar{width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:2em auto 1em}.swal2-close{z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}.swal2-close:hover{transform:none;background:rgba(0,0,0,0);color:#f27474}.swal2-close:focus{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}.swal2-close::-moz-focus-inner{border:0}.swal2-html-container{z-index:1;justify-content:center;margin:1em 1.6em .3em;padding:0;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}.swal2-input,.swal2-file,.swal2-textarea,.swal2-select,.swal2-radio,.swal2-checkbox{margin:1em 2em 3px}.swal2-input,.swal2-file,.swal2-textarea{box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}.swal2-input.swal2-inputerror,.swal2-file.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}.swal2-input:focus,.swal2-file:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}.swal2-input::placeholder,.swal2-file::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em 2em 3px;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}.swal2-radio,.swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}.swal2-radio label,.swal2-checkbox label{margin:0 .6em;font-size:1.125em}.swal2-radio input,.swal2-checkbox input{flex-shrink:0;margin:0 .4em}.swal2-input-label{display:flex;justify-content:center;margin:1em auto 0}.swal2-validation-message{align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}.swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}");

},{}],"eDuJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("4a53749a46812bc2");
    if (script.__esModule) script = script.default;
    script.render = require("73313bacacad9e05").render;
    require("3895495ca9bb1b8").default(script);
    script.__scopeId = 'data-v-8a218c';
    script.__file = "FareConfigurationComponent.vue";
};
initialize();
exports.default = script;

},{"4a53749a46812bc2":"676Cp","73313bacacad9e05":"8D1jy","3895495ca9bb1b8":"iKXGB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"676Cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _modelTemplates = require("../modelTemplates/modelTemplates");
var _globalsJs = require("../globals.js");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _datatableRenderer = require("../utility/DatatableRenderer");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _tagify = require("../../extras/js/vendors/@yaireo/tagify/dist/tagify");
var _tagifyDefault = parcelHelpers.interopDefault(_tagify);
exports.default = {
    __name: 'FareConfigurationComponent',
    props: {
        serviceProviderId: {
            type: String,
            default: null
        },
        serviceJurisdictionId: {
            type: String,
            default: null
        }
    },
    async setup (__props, { expose: __expose }) {
        __expose();
        let __temp, __restore;
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const fareConfig = (0, _vue.ref)((0, _modelTemplates.Model)("FareConfiguration").call({}));
        const platformFeePerKmFloor = (0, _globalsJs.PLATFORM_FEE_PER_KM_FLOOR);
        /**
 * Reads a numeric form field for the save payload, treating a cleared input as unset.
 *
 * A cleared `<input type="number">` yields '' rather than null or undefined, which `?? fallback` does
 * not catch — posting '' for the per-km rate would deserialise to NULL server-side and silently
 * switch the distance-scaled fee off.
 */ const numericFieldOrDefault = (value, fallback)=>value === '' || value === null || value === undefined ? fallback : value;
        const getApiBaseUrl = ()=>{
            if (props.serviceJurisdictionId) return `/api/service-jurisdiction/${props.serviceJurisdictionId}`;
            return `/api/service-provider/${props.serviceProviderId}`;
        };
        //fetch configurations
        const response = ([__temp, __restore] = (0, _vue.withAsyncContext)(()=>fetch(`${getApiBaseUrl()}/fare-configuration`)), __temp = await __temp, __restore(), __temp);
        if (!response.ok) (0, _toastNotificationUtility.showToast)({
            title: 'Error',
            body: `Encountered an error loading fare configuration.`,
            type: (0, _toastNotificationUtility.notificationType).ERROR,
            delay: 7000
        });
        const data = ([__temp, __restore] = (0, _vue.withAsyncContext)(()=>response.json()), __temp = await __temp, __restore(), __temp);
        //populate fareConfig with the fetched data
        Object.keys(data).forEach((key)=>{
            if (key in fareConfig.value.state) fareConfig.value.state[key] = data[key];
        });
        /*
* Base price set up
* */ const basePriceModalEditMode = (0, _vue.ref)(false);
        const showBasePriceModal = (0, _vue.ref)(false);
        const currentBasePrice = (0, _vue.ref)({
            vehicleType: '',
            baseFare: 0.00
        });
        const currentBasePriceIndex = (0, _vue.ref)(-1);
        const toggleCreateBasePriceModal = (editMode, row, index)=>{
            basePriceModalEditMode.value = editMode || false;
            if (editMode && row) {
                // Clone the row data to avoid direct mutation
                currentBasePrice.value = JSON.parse(JSON.stringify(row));
                currentBasePriceIndex.value = index;
            } else {
                // Reset form for new entry
                currentBasePrice.value = {
                    vehicleType: '',
                    baseFare: 0.00
                };
                currentBasePriceIndex.value = -1;
            }
            $('#createBasePricingModal').modal('toggle');
            showBasePriceModal.value = false;
            (0, _vue.nextTick)(()=>{
                showBasePriceModal.value = true;
            });
        };
        const validateBasePriceForm = ()=>{
            // Use the validation method from the model
            const validationResult = fareConfig.value.validateVehicleBaseFareConfig(currentBasePrice.value);
            if (!validationResult.isValid) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Validation Error',
                    body: validationResult.message,
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
                return false;
            }
            return true;
        };
        const saveBasePrice = ()=>{
            // Validate form data
            if (!validateBasePriceForm()) return;
            if (!basePriceModalEditMode.value) {
                // Check for duplicate vehicle type using the model's method
                const duplicateCheck = fareConfig.value.checkDuplicateVehicleType(currentBasePrice.value.vehicleType);
                if (duplicateCheck.isDuplicate) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: duplicateCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Add new base price
                fareConfig.value.addVehicleBaseFareConfig();
                const newIndex = fareConfig.value.state.vehicleBaseFareConfigs.length - 1;
                fareConfig.value.state.vehicleBaseFareConfigs[newIndex] = {
                    ...currentBasePrice.value
                };
            } else {
                // Check for duplicate vehicle type when updating using the model's method
                const duplicateCheck = fareConfig.value.checkDuplicateVehicleType(currentBasePrice.value.vehicleType, currentBasePriceIndex.value);
                if (duplicateCheck.isDuplicate) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: duplicateCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Update existing base price
                fareConfig.value.state.vehicleBaseFareConfigs[currentBasePriceIndex.value] = {
                    ...currentBasePrice.value
                };
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: `Base price for ${currentBasePrice.value.vehicleType} has been updated.`,
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            }
            // Close the modal
            $('#createBasePricingModal').modal('hide');
        };
        const editBasePrice = (row, meta)=>{
            const index = meta.row;
            toggleCreateBasePriceModal(true, row, index);
        };
        const deleteBasePrice = (row, meta)=>{
            (0, _sweetalert2MinDefault.default).fire({
                text: `Are you sure you want to delete the base price for ${row.vehicleType}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result)=>{
                if (result.isConfirmed) {
                    // Find the index of the row in the vehicleBaseFareConfig array
                    const index = meta.row;
                    // Remove the base price from the list
                    fareConfig.value.removeVehicleBaseFareConfig(index);
                }
            });
        };
        /*
* Distance Range setup
* */ const distancePricingModalEditMode = (0, _vue.ref)(false);
        const showDistancePricingModal = (0, _vue.ref)(false);
        const currentDistancePricing = (0, _vue.ref)({
            startDistanceMeters: 0,
            endDistanceMeters: 0,
            isStartingRange: false,
            isOpenEnded: false,
            rateType: '',
            rateAmount: 0.00
        });
        const currentDistancePricingIndex = (0, _vue.ref)(-1);
        const toggleDistancePricingModal = (editMode, row, index)=>{
            distancePricingModalEditMode.value = editMode || false;
            if (editMode && row) {
                // Clone the row data to avoid direct mutation
                currentDistancePricing.value = JSON.parse(JSON.stringify(row));
                currentDistancePricingIndex.value = index;
            } else {
                // Reset form for new entry
                currentDistancePricing.value = {
                    startDistanceMeters: 0,
                    endDistanceMeters: 0,
                    isStartingRange: false,
                    isOpenEnded: false,
                    rateType: '',
                    rateAmount: 0.00
                };
                currentDistancePricingIndex.value = -1;
            }
            $('#distancePricingModal').modal('toggle');
            showDistancePricingModal.value = false;
            (0, _vue.nextTick)(()=>{
                showDistancePricingModal.value = true;
            });
        };
        // Watch for changes to isStartingRange
        (0, _vue.watch)(()=>currentDistancePricing.value.isStartingRange, (newValue)=>{
            if (newValue) // If this is a starting range, set startDistanceMeters to 0
            currentDistancePricing.value.startDistanceMeters = 0;
        });
        // Watch for changes to isOpenEnded
        (0, _vue.watch)(()=>currentDistancePricing.value.isOpenEnded, (newValue)=>{
            if (newValue) // If this is an open-ended range, set a high default value for endDistanceMeters
            currentDistancePricing.value.endDistanceMeters = 1000000; // 1000 km
        });
        const validateDistancePricingForm = ()=>{
            // Use the validation method from the model
            const validationResult = fareConfig.value.validateDistancePricing(currentDistancePricing.value);
            if (!validationResult.isValid) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Validation Error',
                    body: validationResult.message,
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
                return false;
            }
            return true;
        };
        const saveDistancePricing = ()=>{
            // Validate form data
            if (!validateDistancePricingForm()) return;
            if (!distancePricingModalEditMode.value) {
                // Check for overlapping distance ranges using the model's method
                const overlapCheck = fareConfig.value.checkOverlappingDistanceFareConfig(currentDistancePricing.value);
                if (overlapCheck.isOverlapping) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: overlapCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Add new distance range
                fareConfig.value.addDistanceFareConfig();
                const newIndex = fareConfig.value.state.distanceFareConfigs.length - 1;
                fareConfig.value.state.distanceFareConfigs[newIndex] = {
                    ...currentDistancePricing.value
                };
            } else {
                // Check for overlapping distance ranges when updating using the model's method
                const overlapCheck = fareConfig.value.checkOverlappingDistanceFareConfig(currentDistancePricing.value, currentDistancePricingIndex.value);
                if (overlapCheck.isOverlapping) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: overlapCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Update existing distance range
                fareConfig.value.state.distanceFareConfigs[currentDistancePricingIndex.value] = {
                    ...currentDistancePricing.value
                };
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: `Distance range ${currentDistancePricing.value.startDistanceMeters}-${currentDistancePricing.value.endDistanceMeters} meters has been updated.`,
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            }
            // Close the modal
            $('#distancePricingModal').modal('hide');
        };
        const editDistancePricing = (row, meta)=>{
            // Find the index of the row in the distancePricings array
            const index = meta.row;
            toggleDistancePricingModal(true, row, index);
        };
        const deleteDistancePricing = (row, meta)=>{
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Delete Distance Range',
                text: `Are you sure you want to delete the distance range ${row.startDistanceMeters}-${row.endDistanceMeters} meters?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
            }).then((result)=>{
                if (result.isConfirmed) {
                    // Find the index of the row in the distanceFareConfig array
                    const index = meta.row;
                    // Remove the distance range from the list
                    fareConfig.value.removeDistanceFareConfig(index);
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: `Distance range ${row.startDistanceMeters}-${row.endDistanceMeters} meters has been deleted.`,
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                }
            });
        };
        /*
* Geo Zone setup
* */ const geoZoneModalEditMode = (0, _vue.ref)(false);
        const showGeoZoneModal = (0, _vue.ref)(false);
        const currentGeoZone = (0, _vue.ref)({
            geoZone: null,
            applicationType: '',
            zoneRateType: 'SURCHARGE',
            surcharge: 0.00,
            percentage: 0.00,
            flatFare: 0.00,
            zonePerKmRate: 0.00,
            fareMaximum: null,
            fareMaximumUpToMeters: null,
            fareMinimum: null,
            fareMinimumUpToMeters: null,
            zonePlatformFee: null,
            zonePlatformFeePerKm: null
        });
        const currentGeoZoneIndex = (0, _vue.ref)(-1);
        // Tagify related variables
        const tagifyGeoZoneRef = (0, _vue.ref)(null);
        const tagifyGeoZoneInstance = (0, _vue.ref)(null);
        const tagifyGeoZoneList = (0, _vue.ref)([]);
        // Fetch available geo zones
        const fetchGeoZones = async ()=>{
            try {
                const response = await fetch('/api/fare-zones');
                if (response.ok) {
                    const data = await response.json();
                    tagifyGeoZoneList.value = data.map((zone)=>({
                            id: zone.id,
                            value: zone.name,
                            name: zone.name,
                            description: zone.description,
                            zoneType: zone.zoneType
                        }));
                } else console.error('Failed to fetch geo zones:', response.status);
            } catch (error) {
                console.error('Error fetching geo zones:', error);
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Failed to load geo zones',
                    icon: 'error'
                });
            }
        };
        // Initialize tagify for geo zone selection
        const initializeGeoZoneTagify = async ()=>{
            await (0, _vue.nextTick)();
            // If Tagify is already initialized, destroy it first
            if (tagifyGeoZoneInstance.value) {
                tagifyGeoZoneInstance.value.destroy();
                tagifyGeoZoneInstance.value = null;
            }
            // Initialize Tagify on the geo zone input
            tagifyGeoZoneInstance.value = new (0, _tagifyDefault.default)(tagifyGeoZoneRef.value, {
                maxTags: 1,
                enforceWhitelist: true,
                whitelist: tagifyGeoZoneList.value,
                dropdown: {
                    closeOnSelect: true,
                    highlightFirst: true,
                    enabled: 0,
                    classname: "extra-properties"
                },
                templates: {
                    tag: function(tagData) {
                        try {
                            return `<tag title='${tagData.value}' contenteditable='false' spellcheck="false" class='tagify__tag ${tagData.class ? tagData.class : ""}' ${this.getAttributes(tagData)}>
                      <x title='remove tag' class='tagify__tag__removeBtn'></x>
                      <div>
                          <span class='tagify__tag-text'>${tagData.value}</span>
                      </div>
                  </tag>`;
                        } catch (err) {
                            console.error(err);
                        }
                    },
                    dropdownItem: function(tagData) {
                        try {
                            return `<div ${this.getAttributes(tagData)} class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'>
                    <span>${tagData.value}</span>
                  </div>`;
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }
            });
            // Set initial value if currentGeoZone has a geoZone
            if (currentGeoZone.value?.geoZone) {
                const foundZone = tagifyGeoZoneList.value.find((z)=>z.id === currentGeoZone.value.geoZone.id);
                if (foundZone) tagifyGeoZoneInstance.value.addTags([
                    {
                        value: foundZone.name.toString(),
                        name: foundZone.name,
                        id: foundZone.id,
                        description: foundZone.description,
                        zoneType: foundZone.zoneType
                    }
                ]);
            }
            // Update currentGeoZone.geoZone when tag changes
            tagifyGeoZoneInstance.value.on("remove", updateSelectedGeoZone);
            tagifyGeoZoneInstance.value.on("add", updateSelectedGeoZone);
        };
        // Update currentGeoZone.geoZone when tag changes
        const updateSelectedGeoZone = ()=>{
            if (!tagifyGeoZoneInstance.value) return;
            try {
                const tags = tagifyGeoZoneInstance.value.value || [];
                if (tags.length > 0) {
                    const tag = tags[0]; // Only one tag is allowed
                    const zone = tagifyGeoZoneList.value.find((z)=>z.value.toString() === tag.value.toString());
                    if (zone) currentGeoZone.value.geoZone = {
                        id: zone.id,
                        name: zone.name,
                        description: zone.description,
                        zoneType: zone.zoneType
                    };
                } else currentGeoZone.value.geoZone = null;
            } catch (error) {
                console.error('Error updating selected geo zone:', error);
            }
        };
        const toggleGeoZoneModal = (editMode, row, index)=>{
            geoZoneModalEditMode.value = editMode || false;
            if (editMode && row) {
                // Clone the row data to avoid direct mutation; normalise legacy isPercentage rows
                const cloned = JSON.parse(JSON.stringify(row));
                if (!cloned.zoneRateType) cloned.zoneRateType = cloned.isPercentage ? 'PERCENTAGE' : 'SURCHARGE';
                if (cloned.flatFare === undefined) cloned.flatFare = 0.00;
                if (cloned.zonePerKmRate === undefined) cloned.zonePerKmRate = 0.00;
                if (cloned.fareMaximum === undefined) cloned.fareMaximum = null;
                if (cloned.fareMaximumUpToMeters === undefined) cloned.fareMaximumUpToMeters = null;
                if (cloned.fareMinimum === undefined) cloned.fareMinimum = null;
                if (cloned.fareMinimumUpToMeters === undefined) cloned.fareMinimumUpToMeters = null;
                // Backfill, not default: a zone loaded from a server response that predates these fields would
                // otherwise come back undefined, drop out of the save payload, and lose its stored fee the next
                // time an admin edited anything else on the zone.
                if (cloned.zonePlatformFee === undefined) cloned.zonePlatformFee = null;
                if (cloned.zonePlatformFeePerKm === undefined) cloned.zonePlatformFeePerKm = null;
                currentGeoZone.value = cloned;
                currentGeoZoneIndex.value = index;
            } else {
                // Reset form for new entry
                currentGeoZone.value = {
                    geoZone: null,
                    applicationType: '',
                    zoneRateType: 'SURCHARGE',
                    surcharge: 0.00,
                    percentage: 0.00,
                    flatFare: 0.00,
                    zonePerKmRate: 0.00,
                    fareMaximum: null,
                    fareMaximumUpToMeters: null,
                    fareMinimum: null,
                    fareMinimumUpToMeters: null,
                    zonePlatformFee: null,
                    zonePlatformFeePerKm: null
                };
                currentGeoZoneIndex.value = -1;
            }
            $('#geoZoneModal').modal('toggle');
            showGeoZoneModal.value = false;
            (0, _vue.nextTick)(()=>{
                showGeoZoneModal.value = true;
                // Initialize tagify after the modal is shown
                initializeGeoZoneTagify();
            });
        };
        const validateGeoZoneForm = ()=>{
            // Use the validation method from the model
            const validationResult = fareConfig.value.validateGeoZone(currentGeoZone.value);
            if (!validationResult.isValid) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Validation Error',
                    body: validationResult.message,
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
                return false;
            }
            return true;
        };
        const saveGeoZone = ()=>{
            // Validate form data
            if (!validateGeoZoneForm()) return;
            if (!geoZoneModalEditMode.value) {
                // Check for duplicate geo zone and application type using the model's method
                const duplicateCheck = fareConfig.value.checkDuplicateGeoZone(currentGeoZone.value);
                if (duplicateCheck.isDuplicate) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: duplicateCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Add new geo zone
                fareConfig.value.addGeoZoneFareConfig();
                const newIndex = fareConfig.value.state.geoZoneFareConfigs.length - 1;
                fareConfig.value.state.geoZoneFareConfigs[newIndex] = {
                    ...currentGeoZone.value
                };
            } else {
                // Check for duplicate geo zone and application type when updating using the model's method
                const duplicateCheck = fareConfig.value.checkDuplicateGeoZone(currentGeoZone.value, currentGeoZoneIndex.value);
                if (duplicateCheck.isDuplicate) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: duplicateCheck.message,
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // Update existing geo zone
                fareConfig.value.state.geoZoneFareConfigs[currentGeoZoneIndex.value] = {
                    ...currentGeoZone.value
                };
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: `Geo zone pricing has been updated.`,
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            }
            // Close the modal
            $('#geoZoneModal').modal('hide');
        };
        const editGeoZone = (row, meta)=>{
            // Find the index of the row in the geoZones array
            const index = meta.row;
            toggleGeoZoneModal(true, row, index);
        };
        const deleteGeoZone = (row, meta)=>{
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Delete Geo Zone Pricing',
                text: `Are you sure you want to delete this geo zone pricing?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
            }).then((result)=>{
                if (result.isConfirmed) {
                    // Find the index of the row in the geoZoneFareConfig array
                    const index = meta.row;
                    // Remove the geo zone from the list
                    fareConfig.value.removeGeoZoneFareConfig(index);
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: `Geo zone pricing has been deleted.`,
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                }
            });
        };
        /*
* DataTable Columns Setup
* */ const basePricesColumns = [
            {
                data: 'vehicleType',
                title: 'Vehicle Type'
            },
            {
                data: 'baseFare',
                title: `Base Fare`,
                render: (data)=>`$${parseFloat(data).toFixed(2)}`
            },
            {
                data: null,
                title: 'Actions',
                orderable: false,
                render: (data, type, row, meta)=>{
                    return (0, _datatableRenderer.editAndDeleteCTA)(data, type, row, meta, editBasePrice, deleteBasePrice);
                }
            }
        ];
        const distancePricingsColumns = [
            {
                data: 'rangeDescription',
                title: 'Range'
            },
            {
                data: 'isStartingRange',
                title: 'Starting Range',
                render: (0, _datatableRenderer.booleanBadgeRender)
            },
            {
                data: 'isOpenEnded',
                title: 'Open-Ended',
                render: (0, _datatableRenderer.booleanBadgeRender)
            },
            {
                data: 'rateType',
                title: 'Rate Type'
            },
            {
                data: 'rateAmount',
                title: `Rate Amount `,
                render: (data)=>`$${parseFloat(data).toFixed(2)}`
            },
            {
                data: null,
                title: 'Actions',
                orderable: false,
                render: (data, type, row, meta)=>{
                    return (0, _datatableRenderer.editAndDeleteCTA)(data, type, row, meta, editDistancePricing, deleteDistancePricing);
                }
            }
        ];
        const formatGeoZoneRate = (row)=>{
            const rateType = row.zoneRateType || (row.isPercentage ? 'PERCENTAGE' : 'SURCHARGE');
            switch(rateType){
                case 'FLAT_FARE':
                    return `$${parseFloat(row.flatFare || 0).toFixed(2)} flat`;
                case 'PER_KM':
                    return `$${parseFloat(row.zonePerKmRate || 0).toFixed(2)}/km`;
                case 'PERCENTAGE':
                    return `+${parseFloat(row.percentage || 0).toFixed(2)}%`;
                case 'SURCHARGE':
                default:
                    return `+$${parseFloat(row.surcharge || 0).toFixed(2)}`;
            }
        };
        // The Asher-side fee is invisible in the Rate column above, which only describes the rider side.
        // Without its own column an airport rule reads as "+$2.50" in the table while charging $4.50.
        const formatZonePlatformFee = (row)=>{
            const isSet = (value)=>value !== null && value !== undefined && value !== '' && parseFloat(value) !== 0;
            const parts = [];
            if (isSet(row.zonePlatformFee)) parts.push(`$${parseFloat(row.zonePlatformFee).toFixed(2)}`);
            if (isSet(row.zonePlatformFeePerKm)) parts.push(`$${parseFloat(row.zonePlatformFeePerKm).toFixed(2)}/km`);
            return parts.length ? parts.join(' + ') : "\u2014";
        };
        const geoZonesPricingColumns = [
            {
                data: 'geoZone.name',
                title: 'Zone Name'
            },
            {
                data: 'applicationType',
                title: 'Application Type'
            },
            {
                data: null,
                title: 'Rate',
                render: (data, type, row)=>formatGeoZoneRate(row)
            },
            {
                data: 'fareMaximum',
                title: 'Cap',
                render: (data)=>data !== null && data !== undefined && data !== '' ? `$${parseFloat(data).toFixed(2)}` : "\u2014"
            },
            {
                data: null,
                title: 'Asher Fee',
                render: (data, type, row)=>formatZonePlatformFee(row)
            },
            {
                data: null,
                title: 'Actions',
                orderable: false,
                render: (data, type, row, meta)=>{
                    return (0, _datatableRenderer.editAndDeleteCTA)(data, type, row, meta, editGeoZone, deleteGeoZone);
                }
            }
        ];
        // Initialize everything when component is mounted
        (0, _vue.onMounted)(async ()=>{
            await fetchGeoZones();
        });
        // Cleanup when component is unmounted
        (0, _vue.onUnmounted)(()=>{
            if (tagifyGeoZoneInstance.value) {
                tagifyGeoZoneInstance.value.destroy();
                tagifyGeoZoneInstance.value = null;
            }
        });
        // Save the entire fare configuration
        const saveConfiguration = async ()=>{
            try {
                // Validate the configuration
                if (!fareConfig.value.isValid()) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Validation Error',
                        body: 'Please fix the validation errors before saving.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                    return;
                }
                // A per-km fee below the policy floor is allowed but never accidental — confirm it explicitly.
                if (fareConfig.value.isPlatformFeePerKmBelowFloor()) {
                    const confirmation = await (0, _sweetalert2MinDefault.default).fire({
                        title: 'Per-km platform fee is below the floor',
                        html: `A per-km fee under $${platformFeePerKmFloor.toFixed(2)}/km does not cover the ` + `insurance cost that scales with distance, so margin shrinks the longer the trip. ` + `Move the fare, not the fee. Save anyway?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Save anyway',
                        cancelButtonText: 'Cancel'
                    });
                    if (!confirmation.isConfirmed) return;
                }
                // Show loading indicator
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Saving...',
                    text: 'Saving fare configuration',
                    allowOutsideClick: false,
                    didOpen: ()=>{
                        (0, _sweetalert2MinDefault.default).showLoading();
                    }
                });
                // Prepare the configuration data
                const configData = {
                    id: fareConfig.value.state.id,
                    currency: fareConfig.value.state.currency,
                    freeStopWaitingMinutes: fareConfig.value.state.freeStopWaitingMinutes,
                    perStopCharge: fareConfig.value.state.perStopCharge,
                    stopPerMinuteCharge: fareConfig.value.state.stopPerMinuteCharge,
                    platformFee: fareConfig.value.state.platformFee,
                    platformFeePerKm: numericFieldOrDefault(fareConfig.value.state.platformFeePerKm, 0),
                    platformFeeMinimum: numericFieldOrDefault(fareConfig.value.state.platformFeeMinimum, 0),
                    platformFeeMaximum: numericFieldOrDefault(fareConfig.value.state.platformFeeMaximum, null),
                    scheduledRideFee: fareConfig.value.state.scheduledRideFee,
                    perMinuteFare: fareConfig.value.state.perMinuteFare,
                    minimumFare: fareConfig.value.state.minimumFare,
                    // Sent explicitly, like every other field here: the server rebuilds the row from the payload,
                    // so a key that is merely absent lands on the Java default rather than on what is stored.
                    minimumAppliesToFareOnly: fareConfig.value.state.minimumAppliesToFareOnly !== false,
                    perAdditionalPassengerCharge: fareConfig.value.state.perAdditionalPassengerCharge,
                    additionalPassengerMaxCharge: fareConfig.value.state.additionalPassengerMaxCharge,
                    additionalPassengerFreeUnderAge: fareConfig.value.state.additionalPassengerFreeUnderAge ?? null,
                    vehicleBaseFareConfigs: fareConfig.value.state.vehicleBaseFareConfigs,
                    distanceFareConfigs: fareConfig.value.state.distanceFareConfigs,
                    geoZoneFareConfigs: fareConfig.value.state.geoZoneFareConfigs.map((zone)=>{
                        const effectiveRateType = zone.zoneRateType ?? (zone.isPercentage ? 'PERCENTAGE' : 'SURCHARGE');
                        return {
                            ...zone,
                            zoneRateType: effectiveRateType,
                            // Only the value field matching zoneRateType may be non-null -- the server's mutual-
                            // exclusivity check (FareConfigurationService.validateGeoZoneRateType) rejects the save
                            // otherwise. Switching the rate type dropdown only toggles which input is *shown*; it
                            // doesn't clear the other three, so a zone edited more than once carries stale non-null
                            // values (previously ?? 0 on flatFare/zonePerKmRate turned even untouched fields non-null).
                            surcharge: effectiveRateType === 'SURCHARGE' ? numericFieldOrDefault(zone.surcharge, null) : null,
                            percentage: effectiveRateType === 'PERCENTAGE' ? numericFieldOrDefault(zone.percentage, null) : null,
                            flatFare: effectiveRateType === 'FLAT_FARE' ? numericFieldOrDefault(zone.flatFare, null) : null,
                            zonePerKmRate: effectiveRateType === 'PER_KM' ? numericFieldOrDefault(zone.zonePerKmRate, null) : null,
                            fareMaximum: zone.fareMaximum ?? null,
                            fareMaximumUpToMeters: zone.fareMaximumUpToMeters ?? null,
                            fareMinimum: zone.fareMinimum ?? null,
                            fareMinimumUpToMeters: zone.fareMinimumUpToMeters ?? null,
                            // Named explicitly rather than left to the spread: the server rebuilds each zone row from the
                            // payload, so a key that is merely absent is written back as the Java field default and the
                            // zone's Asher-side fee is silently zeroed by an edit to something else entirely.
                            zonePlatformFee: numericFieldOrDefault(zone.zonePlatformFee, null),
                            zonePlatformFeePerKm: numericFieldOrDefault(zone.zonePlatformFeePerKm, null)
                        };
                    })
                };
                const url = `${getApiBaseUrl()}/fare-configuration/${fareConfig.value.state.id}`;
                // Send the request
                const response = await fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(configData)
                });
                // Close loading indicator
                (0, _sweetalert2MinDefault.default).close();
                if (!response.ok) {
                    const errorData = await response.json();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: `Failed to save fare configuration: ${errorData.message || response.statusText}`,
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 7000
                    });
                    return;
                }
                // Update the local state with the response data
                const savedConfig = await response.json();
                Object.keys(savedConfig).forEach((key)=>{
                    if (key in fareConfig.value.state) fareConfig.value.state[key] = savedConfig[key];
                });
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Fare configuration saved successfully.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            } catch (error) {
                console.error('Error saving fare configuration:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: `An unexpected error occurred: ${error.message}`,
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            }
        };
        const __returned__ = {
            props,
            fareConfig,
            platformFeePerKmFloor,
            numericFieldOrDefault,
            getApiBaseUrl,
            response,
            data,
            basePriceModalEditMode,
            showBasePriceModal,
            currentBasePrice,
            currentBasePriceIndex,
            toggleCreateBasePriceModal,
            validateBasePriceForm,
            saveBasePrice,
            editBasePrice,
            deleteBasePrice,
            distancePricingModalEditMode,
            showDistancePricingModal,
            currentDistancePricing,
            currentDistancePricingIndex,
            toggleDistancePricingModal,
            validateDistancePricingForm,
            saveDistancePricing,
            editDistancePricing,
            deleteDistancePricing,
            geoZoneModalEditMode,
            showGeoZoneModal,
            currentGeoZone,
            currentGeoZoneIndex,
            tagifyGeoZoneRef,
            tagifyGeoZoneInstance,
            tagifyGeoZoneList,
            fetchGeoZones,
            initializeGeoZoneTagify,
            updateSelectedGeoZone,
            toggleGeoZoneModal,
            validateGeoZoneForm,
            saveGeoZone,
            editGeoZone,
            deleteGeoZone,
            basePricesColumns,
            distancePricingsColumns,
            formatGeoZoneRate,
            formatZonePlatformFee,
            geoZonesPricingColumns,
            saveConfiguration,
            nextTick: (0, _vue.nextTick),
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            onUnmounted: (0, _vue.onUnmounted),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get Model () {
                return 0, _modelTemplates.Model;
            },
            get PLATFORM_FEE_PER_KM_FLOOR () {
                return 0, _globalsJs.PLATFORM_FEE_PER_KM_FLOOR;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get activeBadgeRender () {
                return 0, _datatableRenderer.activeBadgeRender;
            },
            get booleanBadgeRender () {
                return 0, _datatableRenderer.booleanBadgeRender;
            },
            get editAndDeleteCTA () {
                return 0, _datatableRenderer.editAndDeleteCTA;
            },
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get Tagify () {
                return 0, _tagifyDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../modelTemplates/modelTemplates":"dN207","../globals.js":"5gM7V","../utility/toastNotificationUtility":"krOtg","../utility/DatatableRenderer":"gfmyC","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../../extras/js/vendors/@yaireo/tagify/dist/tagify":"j5wdA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5wdA":[function(require,module,exports,__globalThis) {
/**
 * Tagify (v 4.17.8) - tags input component
 * By undefined
 * https://github.com/yairEO/tagify
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 * THE SOFTWARE IS NOT PERMISSIBLE TO BE SOLD.
 */ !function(t1, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    function t1(t1, e) {
        var i = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(t1);
            e && (s = s.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t1, e).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function e(e) {
        for(var s = 1; s < arguments.length; s++){
            var a = null != arguments[s] ? arguments[s] : {};
            s % 2 ? t1(Object(a), !0).forEach(function(t1) {
                i(e, t1, a[t1]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : t1(Object(a)).forEach(function(t1) {
                Object.defineProperty(e, t1, Object.getOwnPropertyDescriptor(a, t1));
            });
        }
        return e;
    }
    function i(t1, e, i) {
        return (e = function(t1) {
            var e = function(t1, e) {
                if ("object" != typeof t1 || null === t1) return t1;
                var i = t1[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(t1, e || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t1);
            }(t1, "string");
            return "symbol" == typeof e ? e : String(e);
        }(e)) in t1 ? Object.defineProperty(t1, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = i, t1;
    }
    const s = (t1, e, i, s)=>(t1 = "" + t1, e = "" + e, s && (t1 = t1.trim(), e = e.trim()), i ? t1 == e : t1.toLowerCase() == e.toLowerCase()), a = (t1, e)=>t1 && Array.isArray(t1) && t1.map((t1)=>n(t1, e));
    function n(t1, e) {
        var i, s = {};
        for(i in t1)e.indexOf(i) < 0 && (s[i] = t1[i]);
        return s;
    }
    function o(t1) {
        var e = document.createElement("div");
        return t1.replace(/\&#?[0-9a-z]+;/gi, function(t1) {
            return e.innerHTML = t1, e.innerText;
        });
    }
    function r(t1) {
        return (new DOMParser).parseFromString(t1.trim(), "text/html").body.firstElementChild;
    }
    function l(t1, e) {
        for(e = e || "previous"; t1 = t1[e + "Sibling"];)if (3 == t1.nodeType) return t1;
    }
    function d(t1) {
        return "string" == typeof t1 ? t1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/`|'/g, "&#039;") : t1;
    }
    function h(t1) {
        var e = Object.prototype.toString.call(t1).split(" ")[1].slice(0, -1);
        return t1 === Object(t1) && "Array" != e && "Function" != e && "RegExp" != e && "HTMLUnknownElement" != e;
    }
    function g(t1, e, i) {
        function s(t1, e) {
            for(var i in e)if (e.hasOwnProperty(i)) {
                if (h(e[i])) {
                    h(t1[i]) ? s(t1[i], e[i]) : t1[i] = Object.assign({}, e[i]);
                    continue;
                }
                if (Array.isArray(e[i])) {
                    t1[i] = Object.assign([], e[i]);
                    continue;
                }
                t1[i] = e[i];
            }
        }
        return t1 instanceof Object || (t1 = {}), s(t1, e), i && s(t1, i), t1;
    }
    function p() {
        const t1 = [], e = {};
        for (let i of arguments)for (let s of i)h(s) ? e[s.value] || (t1.push(s), e[s.value] = 1) : t1.includes(s) || t1.push(s);
        return t1;
    }
    function c(t1) {
        return String.prototype.normalize ? "string" == typeof t1 ? t1.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : void 0 : t1;
    }
    var u = ()=>/(?=.*chrome)(?=.*android)/i.test(navigator.userAgent);
    function m() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (t1)=>(t1 ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> t1 / 4).toString(16));
    }
    function v(t1) {
        return t1 && t1.classList && t1.classList.contains(this.settings.classNames.tag);
    }
    function f(t1, e) {
        var i = window.getSelection();
        return e = e || i.getRangeAt(0), "string" == typeof t1 && (t1 = document.createTextNode(t1)), e && (e.deleteContents(), e.insertNode(t1)), t1;
    }
    function T(t1, e, i) {
        return t1 ? (e && (t1.__tagifyTagData = i ? e : g({}, t1.__tagifyTagData || {}, e)), t1.__tagifyTagData) : (console.warn("tag element doesn't exist", t1, e), e);
    }
    var w = {
        delimiters: ",",
        pattern: null,
        tagTextProp: "value",
        maxTags: 1 / 0,
        callbacks: {},
        addTagOnBlur: !0,
        onChangeAfterBlur: !0,
        duplicates: !1,
        whitelist: [],
        blacklist: [],
        enforceWhitelist: !1,
        userInput: !0,
        keepInvalidTags: !1,
        createInvalidTags: !0,
        mixTagsAllowedAfter: /,|\.|\:|\s/,
        mixTagsInterpolator: [
            "[[",
            "]]"
        ],
        backspace: !0,
        skipInvalid: !1,
        pasteAsTags: !0,
        editTags: {
            clicks: 2,
            keepInvalid: !0
        },
        transformTag: ()=>{},
        trim: !0,
        a11y: {
            focusableTags: !1
        },
        mixMode: {
            insertAfterTag: "\xa0"
        },
        autoComplete: {
            enabled: !0,
            rightKey: !1
        },
        classNames: {
            namespace: "tagify",
            mixMode: "tagify--mix",
            selectMode: "tagify--select",
            input: "tagify__input",
            focus: "tagify--focus",
            tagNoAnimation: "tagify--noAnim",
            tagInvalid: "tagify--invalid",
            tagNotAllowed: "tagify--notAllowed",
            scopeLoading: "tagify--loading",
            hasMaxTags: "tagify--hasMaxTags",
            hasNoTags: "tagify--noTags",
            empty: "tagify--empty",
            inputInvalid: "tagify__input--invalid",
            dropdown: "tagify__dropdown",
            dropdownWrapper: "tagify__dropdown__wrapper",
            dropdownHeader: "tagify__dropdown__header",
            dropdownFooter: "tagify__dropdown__footer",
            dropdownItem: "tagify__dropdown__item",
            dropdownItemActive: "tagify__dropdown__item--active",
            dropdownItemHidden: "tagify__dropdown__item--hidden",
            dropdownInital: "tagify__dropdown--initial",
            tag: "tagify__tag",
            tagText: "tagify__tag-text",
            tagX: "tagify__tag__removeBtn",
            tagLoading: "tagify__tag--loading",
            tagEditing: "tagify__tag--editable",
            tagFlash: "tagify__tag--flash",
            tagHide: "tagify__tag--hide"
        },
        dropdown: {
            classname: "",
            enabled: 2,
            maxItems: 10,
            searchKeys: [
                "value",
                "searchBy"
            ],
            fuzzySearch: !0,
            caseSensitive: !1,
            accentedSearch: !0,
            includeSelectedTags: !1,
            highlightFirst: !1,
            closeOnSelect: !0,
            clearOnSelect: !0,
            position: "all",
            appendTarget: null
        },
        hooks: {
            beforeRemoveTag: ()=>Promise.resolve(),
            beforePaste: ()=>Promise.resolve(),
            suggestionClick: ()=>Promise.resolve()
        }
    };
    function b() {
        this.dropdown = {};
        for(let t1 in this._dropdown)this.dropdown[t1] = "function" == typeof this._dropdown[t1] ? this._dropdown[t1].bind(this) : this._dropdown[t1];
        this.dropdown.refs();
    }
    var y = {
        refs () {
            this.DOM.dropdown = this.parseTemplate("dropdown", [
                this.settings
            ]), this.DOM.dropdown.content = this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-wrapper']");
        },
        getHeaderRef () {
            return this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-header']");
        },
        getFooterRef () {
            return this.DOM.dropdown.querySelector("[data-selector='tagify-suggestions-footer']");
        },
        getAllSuggestionsRefs () {
            return [
                ...this.DOM.dropdown.content.querySelectorAll(this.settings.classNames.dropdownItemSelector)
            ];
        },
        show (t1) {
            var e, i, a, n = this.settings, o = "mix" == n.mode && !n.enforceWhitelist, r = !n.whitelist || !n.whitelist.length, l = "manual" == n.dropdown.position;
            if (t1 = void 0 === t1 ? this.state.inputText : t1, !(r && !o && !n.templates.dropdownItemNoMatch || !1 === n.dropdown.enable || this.state.isLoading || this.settings.readonly)) {
                if (clearTimeout(this.dropdownHide__bindEventsTimeout), this.suggestedListItems = this.dropdown.filterListItems(t1), t1 && !this.suggestedListItems.length && (this.trigger("dropdown:noMatch", t1), n.templates.dropdownItemNoMatch && (a = n.templates.dropdownItemNoMatch.call(this, {
                    value: t1
                }))), !a) {
                    if (this.suggestedListItems.length) t1 && o && !this.state.editing.scope && !s(this.suggestedListItems[0].value, t1) && this.suggestedListItems.unshift({
                        value: t1
                    });
                    else {
                        if (!t1 || !o || this.state.editing.scope) return this.input.autocomplete.suggest.call(this), void this.dropdown.hide();
                        this.suggestedListItems = [
                            {
                                value: t1
                            }
                        ];
                    }
                    i = "" + (h(e = this.suggestedListItems[0]) ? e.value : e), n.autoComplete && i && 0 == i.indexOf(t1) && this.input.autocomplete.suggest.call(this, e);
                }
                this.dropdown.fill(a), n.dropdown.highlightFirst && this.dropdown.highlightOption(this.DOM.dropdown.content.querySelector(n.classNames.dropdownItemSelector)), this.state.dropdown.visible || setTimeout(this.dropdown.events.binding.bind(this)), this.state.dropdown.visible = t1 || !0, this.state.dropdown.query = t1, this.setStateSelection(), l || setTimeout(()=>{
                    this.dropdown.position(), this.dropdown.render();
                }), setTimeout(()=>{
                    this.trigger("dropdown:show", this.DOM.dropdown);
                });
            }
        },
        hide (t1) {
            var e = this.DOM, i = e.scope, s = e.dropdown, a = "manual" == this.settings.dropdown.position && !t1;
            if (s && document.body.contains(s) && !a) return window.removeEventListener("resize", this.dropdown.position), this.dropdown.events.binding.call(this, !1), i.setAttribute("aria-expanded", !1), s.parentNode.removeChild(s), setTimeout(()=>{
                this.state.dropdown.visible = !1;
            }, 100), this.state.dropdown.query = this.state.ddItemData = this.state.ddItemElm = this.state.selection = null, this.state.tag && this.state.tag.value.length && (this.state.flaggedTags[this.state.tag.baseOffset] = this.state.tag), this.trigger("dropdown:hide", s), this;
        },
        toggle (t1) {
            this.dropdown[this.state.dropdown.visible && !t1 ? "hide" : "show"]();
        },
        render () {
            var t1, e, i, s = (t1 = this.DOM.dropdown, (i = t1.cloneNode(!0)).style.cssText = "position:fixed; top:-9999px; opacity:0", document.body.appendChild(i), e = i.clientHeight, i.parentNode.removeChild(i), e), a = this.settings;
            return "number" == typeof a.dropdown.enabled && a.dropdown.enabled >= 0 ? (this.DOM.scope.setAttribute("aria-expanded", !0), document.body.contains(this.DOM.dropdown) || (this.DOM.dropdown.classList.add(a.classNames.dropdownInital), this.dropdown.position(s), a.dropdown.appendTarget.appendChild(this.DOM.dropdown), setTimeout(()=>this.DOM.dropdown.classList.remove(a.classNames.dropdownInital))), this) : this;
        },
        fill (t1) {
            t1 = "string" == typeof t1 ? t1 : this.dropdown.createListHTML(t1 || this.suggestedListItems);
            var e, i = this.settings.templates.dropdownContent.call(this, t1);
            this.DOM.dropdown.content.innerHTML = (e = i) ? e.replace(/\>[\r\n ]+\</g, "><").replace(/(<.*?>)|\s+/g, (t1, e)=>e || " ") : "";
        },
        fillHeaderFooter () {
            var t1 = this.dropdown.filterListItems(this.state.dropdown.query), e = this.parseTemplate("dropdownHeader", [
                t1
            ]), i = this.parseTemplate("dropdownFooter", [
                t1
            ]), s = this.dropdown.getHeaderRef(), a = this.dropdown.getFooterRef();
            e && s?.parentNode.replaceChild(e, s), i && a?.parentNode.replaceChild(i, a);
        },
        refilter (t1) {
            t1 = t1 || this.state.dropdown.query || "", this.suggestedListItems = this.dropdown.filterListItems(t1), this.dropdown.fill(), this.suggestedListItems.length || this.dropdown.hide(), this.trigger("dropdown:updated", this.DOM.dropdown);
        },
        position (t1) {
            var e = this.settings.dropdown;
            if ("manual" != e.position) {
                var i, s, a, n, o, r, l = this.DOM.dropdown, d = e.placeAbove, h = e.appendTarget === document.body, g = h ? window.pageYOffset : e.appendTarget.scrollTop, p = document.fullscreenElement || document.webkitFullscreenElement || document.documentElement, c = p.clientHeight, u = Math.max(p.clientWidth || 0, window.innerWidth || 0) > 480 ? e.position : "all", m = this.DOM["input" == u ? "input" : "scope"];
                if (t1 = t1 || l.clientHeight, this.state.dropdown.visible) {
                    if ("text" == u ? (a = (i = function() {
                        const t1 = document.getSelection();
                        if (t1.rangeCount) {
                            const e = t1.getRangeAt(0), i = e.startContainer, s = e.startOffset;
                            let a, n;
                            if (s > 0) return n = document.createRange(), n.setStart(i, s - 1), n.setEnd(i, s), a = n.getBoundingClientRect(), {
                                left: a.right,
                                top: a.top,
                                bottom: a.bottom
                            };
                            if (i.getBoundingClientRect) return i.getBoundingClientRect();
                        }
                        return {
                            left: -9999,
                            top: -9999
                        };
                    }()).bottom, s = i.top, n = i.left, o = "auto") : (r = function(t1) {
                        for(var e = 0, i = 0; t1 && t1 != p;)e += t1.offsetLeft || 0, i += t1.offsetTop || 0, t1 = t1.parentNode;
                        return {
                            left: e,
                            top: i
                        };
                    }(e.appendTarget), s = (i = m.getBoundingClientRect()).top - r.top, a = i.bottom - 1 - r.top, n = i.left - r.left, o = i.width + "px"), !h) {
                        let t1 = function() {
                            for(var t1 = 0, i = e.appendTarget.parentNode; i;)t1 += i.scrollTop || 0, i = i.parentNode;
                            return t1;
                        }();
                        s += t1, a += t1;
                    }
                    s = Math.floor(s), a = Math.ceil(a), d = void 0 === d ? c - i.bottom < t1 : d, l.style.cssText = "left:" + (n + window.pageXOffset) + "px; width:" + o + ";" + (d ? "top: " + (s + g) + "px" : "top: " + (a + g) + "px"), l.setAttribute("placement", d ? "top" : "bottom"), l.setAttribute("position", u);
                }
            }
        },
        events: {
            binding () {
                let t1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                var e = this.dropdown.events.callbacks, i = this.listeners.dropdown = this.listeners.dropdown || {
                    position: this.dropdown.position.bind(this, null),
                    onKeyDown: e.onKeyDown.bind(this),
                    onMouseOver: e.onMouseOver.bind(this),
                    onMouseLeave: e.onMouseLeave.bind(this),
                    onClick: e.onClick.bind(this),
                    onScroll: e.onScroll.bind(this)
                }, s = t1 ? "addEventListener" : "removeEventListener";
                "manual" != this.settings.dropdown.position && (document[s]("scroll", i.position, !0), window[s]("resize", i.position), window[s]("keydown", i.onKeyDown)), this.DOM.dropdown[s]("mouseover", i.onMouseOver), this.DOM.dropdown[s]("mouseleave", i.onMouseLeave), this.DOM.dropdown[s]("mousedown", i.onClick), this.DOM.dropdown.content[s]("scroll", i.onScroll);
            },
            callbacks: {
                onKeyDown (t1) {
                    if (this.state.hasFocus && !this.state.composing) {
                        var e = this.DOM.dropdown.querySelector(this.settings.classNames.dropdownItemActiveSelector), i = this.dropdown.getSuggestionDataByNode(e);
                        switch(t1.key){
                            case "ArrowDown":
                            case "ArrowUp":
                            case "Down":
                            case "Up":
                                t1.preventDefault();
                                var s = this.dropdown.getAllSuggestionsRefs(), a = "ArrowUp" == t1.key || "Up" == t1.key;
                                e && (e = this.dropdown.getNextOrPrevOption(e, !a)), e && e.matches(this.settings.classNames.dropdownItemSelector) || (e = s[a ? s.length - 1 : 0]), this.dropdown.highlightOption(e, !0);
                                break;
                            case "Escape":
                            case "Esc":
                                this.dropdown.hide();
                                break;
                            case "ArrowRight":
                                if (this.state.actions.ArrowLeft) return;
                            case "Tab":
                                if ("mix" != this.settings.mode && e && !this.settings.autoComplete.rightKey && !this.state.editing) {
                                    t1.preventDefault();
                                    var n = this.dropdown.getMappedValue(i);
                                    return this.input.autocomplete.set.call(this, n), !1;
                                }
                                return !0;
                            case "Enter":
                                t1.preventDefault(), this.settings.hooks.suggestionClick(t1, {
                                    tagify: this,
                                    tagData: i,
                                    suggestionElm: e
                                }).then(()=>{
                                    if (e) return this.dropdown.selectOption(e), e = this.dropdown.getNextOrPrevOption(e, !a), void this.dropdown.highlightOption(e);
                                    this.dropdown.hide(), "mix" != this.settings.mode && this.addTags(this.state.inputText.trim(), !0);
                                }).catch((t1)=>t1);
                                break;
                            case "Backspace":
                                {
                                    if ("mix" == this.settings.mode || this.state.editing.scope) return;
                                    const t1 = this.input.raw.call(this);
                                    "" != t1 && 8203 != t1.charCodeAt(0) || (!0 === this.settings.backspace ? this.removeTags() : "edit" == this.settings.backspace && setTimeout(this.editTag.bind(this), 0));
                                }
                        }
                    }
                },
                onMouseOver (t1) {
                    var e = t1.target.closest(this.settings.classNames.dropdownItemSelector);
                    e && this.dropdown.highlightOption(e);
                },
                onMouseLeave (t1) {
                    this.dropdown.highlightOption();
                },
                onClick (t1) {
                    if (0 == t1.button && t1.target != this.DOM.dropdown && t1.target != this.DOM.dropdown.content) {
                        var e = t1.target.closest(this.settings.classNames.dropdownItemSelector), i = this.dropdown.getSuggestionDataByNode(e);
                        this.state.actions.selectOption = !0, setTimeout(()=>this.state.actions.selectOption = !1, 50), this.settings.hooks.suggestionClick(t1, {
                            tagify: this,
                            tagData: i,
                            suggestionElm: e
                        }).then(()=>{
                            e ? this.dropdown.selectOption(e, t1) : this.dropdown.hide();
                        }).catch((t1)=>console.warn(t1));
                    }
                },
                onScroll (t1) {
                    var e = t1.target, i = e.scrollTop / (e.scrollHeight - e.parentNode.clientHeight) * 100;
                    this.trigger("dropdown:scroll", {
                        percentage: Math.round(i)
                    });
                }
            }
        },
        getSuggestionDataByNode (t1) {
            var e = t1 && t1.getAttribute("value");
            return this.suggestedListItems.find((t1)=>t1.value == e) || null;
        },
        getNextOrPrevOption (t1) {
            let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            var i = this.dropdown.getAllSuggestionsRefs(), s = i.findIndex((e)=>e === t1);
            return e ? i[s + 1] : i[s - 1];
        },
        highlightOption (t1, e) {
            var i, s = this.settings.classNames.dropdownItemActive;
            if (this.state.ddItemElm && (this.state.ddItemElm.classList.remove(s), this.state.ddItemElm.removeAttribute("aria-selected")), !t1) return this.state.ddItemData = null, this.state.ddItemElm = null, void this.input.autocomplete.suggest.call(this);
            i = this.dropdown.getSuggestionDataByNode(t1), this.state.ddItemData = i, this.state.ddItemElm = t1, t1.classList.add(s), t1.setAttribute("aria-selected", !0), e && (t1.parentNode.scrollTop = t1.clientHeight + t1.offsetTop - t1.parentNode.clientHeight), this.settings.autoComplete && (this.input.autocomplete.suggest.call(this, i), this.dropdown.position());
        },
        selectOption (t1, e) {
            var i = this.settings.dropdown, s = i.clearOnSelect, a = i.closeOnSelect;
            if (!t1) return this.addTags(this.state.inputText, !0), void (a && this.dropdown.hide());
            e = e || {};
            var n = t1.getAttribute("value"), o = "noMatch" == n, r = this.suggestedListItems.find((t1)=>(t1.value ?? t1) == n);
            this.trigger("dropdown:select", {
                data: r,
                elm: t1,
                event: e
            }), n && (r || o) ? (this.state.editing ? this.onEditTagDone(null, g({
                __isValid: !0
            }, this.normalizeTags([
                r
            ])[0])) : this["mix" == this.settings.mode ? "addMixTags" : "addTags"]([
                r || this.input.raw.call(this)
            ], s), this.DOM.input.parentNode && (setTimeout(()=>{
                this.DOM.input.focus(), this.toggleFocusClass(!0);
            }), a && setTimeout(this.dropdown.hide.bind(this)), t1.addEventListener("transitionend", ()=>{
                this.dropdown.fillHeaderFooter(), setTimeout(()=>t1.remove(), 100);
            }, {
                once: !0
            }), t1.classList.add(this.settings.classNames.dropdownItemHidden))) : a && setTimeout(this.dropdown.hide.bind(this));
        },
        selectAll (t1) {
            this.suggestedListItems.length = 0, this.dropdown.hide(), this.dropdown.filterListItems("");
            var e = this.dropdown.filterListItems("");
            return t1 || (e = this.state.dropdown.suggestions), this.addTags(e, !0), this;
        },
        filterListItems (t1, e) {
            var i, s, a, n, o, r = this.settings, l = r.dropdown, d = (e = e || {}, []), g = [], p = r.whitelist, u = l.maxItems >= 0 ? l.maxItems : 1 / 0, m = l.searchKeys, v = 0;
            if (!(t1 = "select" == r.mode && this.value.length && this.value[0][r.tagTextProp] == t1 ? "" : t1) || !m.length) return d = l.includeSelectedTags ? p : p.filter((t1)=>!this.isTagDuplicate(h(t1) ? t1.value : t1)), this.state.dropdown.suggestions = d, d.slice(0, u);
            function f(t1, e) {
                return e.toLowerCase().split(" ").every((e)=>t1.includes(e.toLowerCase()));
            }
            for(o = l.caseSensitive ? "" + t1 : ("" + t1).toLowerCase(); v < p.length; v++){
                let t1, r;
                i = p[v] instanceof Object ? p[v] : {
                    value: p[v]
                };
                let u = !Object.keys(i).some((t1)=>m.includes(t1)) ? [
                    "value"
                ] : m;
                l.fuzzySearch && !e.exact ? (a = u.reduce((t1, e)=>t1 + " " + (i[e] || ""), "").toLowerCase().trim(), l.accentedSearch && (a = c(a), o = c(o)), t1 = 0 == a.indexOf(o), r = a === o, s = f(a, o)) : (t1 = !0, s = u.some((t1)=>{
                    var s = "" + (i[t1] || "");
                    return l.accentedSearch && (s = c(s), o = c(o)), l.caseSensitive || (s = s.toLowerCase()), r = s === o, e.exact ? s === o : 0 == s.indexOf(o);
                })), n = !l.includeSelectedTags && this.isTagDuplicate(h(i) ? i.value : i), s && !n && (r && t1 ? g.push(i) : "startsWith" == l.sortby && t1 ? d.unshift(i) : d.push(i));
            }
            return this.state.dropdown.suggestions = g.concat(d), "function" == typeof l.sortby ? l.sortby(g.concat(d), o) : g.concat(d).slice(0, u);
        },
        getMappedValue (t1) {
            var e = this.settings.dropdown.mapValueTo;
            return e ? "function" == typeof e ? e(t1) : t1[e] || t1.value : t1.value;
        },
        createListHTML (t1) {
            return g([], t1).map((t1, i)=>{
                "string" != typeof t1 && "number" != typeof t1 || (t1 = {
                    value: t1
                });
                var s = this.dropdown.getMappedValue(t1);
                return s = "string" == typeof s ? d(s) : s, this.settings.templates.dropdownItem.apply(this, [
                    e(e({}, t1), {}, {
                        mappedValue: s
                    }),
                    this
                ]);
            }).join("");
        }
    };
    const x = "@yaireo/tagify/";
    var O, D = {
        empty: "empty",
        exceed: "number of tags exceeded",
        pattern: "pattern mismatch",
        duplicate: "already exists",
        notAllowed: "not allowed"
    }, M = {
        wrapper: (t1, e)=>`<tags class="${e.classNames.namespace} ${e.mode ? `${e.classNames[e.mode + "Mode"]}` : ""} ${t1.className}"\n                    ${e.readonly ? "readonly" : ""}\n                    ${e.disabled ? "disabled" : ""}\n                    ${e.required ? "required" : ""}\n                    ${"select" === e.mode ? "spellcheck='false'" : ""}\n                    tabIndex="-1">\n            <span ${!e.readonly && e.userInput ? "contenteditable" : ""} tabIndex="0" data-placeholder="${e.placeholder || "&#8203;"}" aria-placeholder="${e.placeholder || ""}"\n                class="${e.classNames.input}"\n                role="textbox"\n                aria-autocomplete="both"\n                aria-multiline="${"mix" == e.mode}"></span>\n                &#8203;\n        </tags>`,
        tag (t1, e) {
            let i = e.settings;
            return `<tag title="${t1.title || t1.value}"\n                    contenteditable='false'\n                    spellcheck='false'\n                    tabIndex="${i.a11y.focusableTags ? 0 : -1}"\n                    class="${i.classNames.tag} ${t1.class || ""}"\n                    ${this.getAttributes(t1)}>\n            <x title='' class="${i.classNames.tagX}" role='button' aria-label='remove tag'></x>\n            <div>\n                <span class="${i.classNames.tagText}">${t1[i.tagTextProp] || t1.value}</span>\n            </div>\n        </tag>`;
        },
        dropdown (t1) {
            var e = t1.dropdown, i = "manual" == e.position, s = `${t1.classNames.dropdown}`;
            return `<div class="${i ? "" : s} ${e.classname}" role="listbox" aria-labelledby="dropdown">\n                    <div data-selector='tagify-suggestions-wrapper' class="${t1.classNames.dropdownWrapper}"></div>\n                </div>`;
        },
        dropdownContent (t1) {
            var e = this.settings, i = this.state.dropdown.suggestions;
            return `\n            ${e.templates.dropdownHeader.call(this, i)}\n            ${t1}\n            ${e.templates.dropdownFooter.call(this, i)}\n        `;
        },
        dropdownItem (t1) {
            return `<div ${this.getAttributes(t1)}\n                    class='${this.settings.classNames.dropdownItem} ${t1.class ? t1.class : ""}'\n                    tabindex="0"\n                    role="option">${t1.mappedValue || t1.value}</div>`;
        },
        dropdownHeader (t1) {
            return `<header data-selector='tagify-suggestions-header' class="${this.settings.classNames.dropdownHeader}"></header>`;
        },
        dropdownFooter (t1) {
            var e = t1.length - this.settings.dropdown.maxItems;
            return e > 0 ? `<footer data-selector='tagify-suggestions-footer' class="${this.settings.classNames.dropdownFooter}">\n                ${e} more items. Refine your search.\n            </footer>` : "";
        },
        dropdownItemNoMatch: null
    };
    var I = {
        customBinding () {
            this.customEventsList.forEach((t1)=>{
                this.on(t1, this.settings.callbacks[t1]);
            });
        },
        binding () {
            let t1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            var e, i = this.events.callbacks, s = t1 ? "addEventListener" : "removeEventListener";
            if (!this.state.mainEvents || !t1) {
                for(var a in this.state.mainEvents = t1, t1 && !this.listeners.main && (this.events.bindGlobal.call(this), this.settings.isJQueryPlugin && jQuery(this.DOM.originalInput).on("tagify.removeAllTags", this.removeAllTags.bind(this))), e = this.listeners.main = this.listeners.main || {
                    focus: [
                        "input",
                        i.onFocusBlur.bind(this)
                    ],
                    keydown: [
                        "input",
                        i.onKeydown.bind(this)
                    ],
                    click: [
                        "scope",
                        i.onClickScope.bind(this)
                    ],
                    dblclick: [
                        "scope",
                        i.onDoubleClickScope.bind(this)
                    ],
                    paste: [
                        "input",
                        i.onPaste.bind(this)
                    ],
                    drop: [
                        "input",
                        i.onDrop.bind(this)
                    ],
                    compositionstart: [
                        "input",
                        i.onCompositionStart.bind(this)
                    ],
                    compositionend: [
                        "input",
                        i.onCompositionEnd.bind(this)
                    ]
                })this.DOM[e[a][0]][s](a, e[a][1]);
                clearInterval(this.listeners.main.originalInputValueObserverInterval), this.listeners.main.originalInputValueObserverInterval = setInterval(i.observeOriginalInputValue.bind(this), 500);
                var n = this.listeners.main.inputMutationObserver || new MutationObserver(i.onInputDOMChange.bind(this));
                n.disconnect(), "mix" == this.settings.mode && n.observe(this.DOM.input, {
                    childList: !0
                });
            }
        },
        bindGlobal (t1) {
            var e, i = this.events.callbacks, s = t1 ? "removeEventListener" : "addEventListener";
            if (this.listeners && (t1 || !this.listeners.global)) for (e of (this.listeners.global = this.listeners.global || [
                {
                    type: this.isIE ? "keydown" : "input",
                    target: this.DOM.input,
                    cb: i[this.isIE ? "onInputIE" : "onInput"].bind(this)
                },
                {
                    type: "keydown",
                    target: window,
                    cb: i.onWindowKeyDown.bind(this)
                },
                {
                    type: "blur",
                    target: this.DOM.input,
                    cb: i.onFocusBlur.bind(this)
                },
                {
                    type: "click",
                    target: document,
                    cb: i.onClickAnywhere.bind(this)
                }
            ], this.listeners.global))e.target[s](e.type, e.cb);
        },
        unbindGlobal () {
            this.events.bindGlobal.call(this, !0);
        },
        callbacks: {
            onFocusBlur (t1) {
                var e = this.settings, i = t1.target ? this.trim(t1.target.textContent) : "", s = this.value?.[0]?.[e.tagTextProp], a = t1.type, n = e.dropdown.enabled >= 0, o = {
                    relatedTarget: t1.relatedTarget
                }, r = this.state.actions.selectOption && (n || !e.dropdown.closeOnSelect), l = this.state.actions.addNew && n, d = t1.relatedTarget && v.call(this, t1.relatedTarget) && this.DOM.scope.contains(t1.relatedTarget);
                if ("blur" == a) {
                    if (t1.relatedTarget === this.DOM.scope) return this.dropdown.hide(), void this.DOM.input.focus();
                    this.postUpdate(), e.onChangeAfterBlur && this.triggerChangeEvent();
                }
                if (!r && !l) {
                    if (this.state.hasFocus = "focus" == a && +new Date, this.toggleFocusClass(this.state.hasFocus), "mix" != e.mode) {
                        if ("focus" == a) return this.trigger("focus", o), void (0 !== e.dropdown.enabled && e.userInput || this.dropdown.show(this.value.length ? "" : void 0));
                        "blur" == a && (this.trigger("blur", o), this.loading(!1), "select" == e.mode && (d && (this.removeTags(), i = ""), s === i && (i = "")), i && !this.state.actions.selectOption && e.addTagOnBlur && this.addTags(i, !0)), this.DOM.input.removeAttribute("style"), this.dropdown.hide();
                    } else "focus" == a ? this.trigger("focus", o) : "blur" == t1.type && (this.trigger("blur", o), this.loading(!1), this.dropdown.hide(), this.state.dropdown.visible = void 0, this.setStateSelection());
                }
            },
            onCompositionStart (t1) {
                this.state.composing = !0;
            },
            onCompositionEnd (t1) {
                this.state.composing = !1;
            },
            onWindowKeyDown (t1) {
                var e, i = document.activeElement, s = v.call(this, i) && this.DOM.scope.contains(document.activeElement), a = s && i.hasAttribute("readonly");
                if (s && !a) switch(e = i.nextElementSibling, t1.key){
                    case "Backspace":
                        this.settings.readonly || (this.removeTags(i), (e || this.DOM.input).focus());
                        break;
                    case "Enter":
                        setTimeout(this.editTag.bind(this), 0, i);
                }
            },
            onKeydown (t1) {
                var e = this.settings;
                if (!this.state.composing && e.userInput) {
                    "select" == e.mode && e.enforceWhitelist && this.value.length && "Tab" != t1.key && t1.preventDefault();
                    var i = this.trim(t1.target.textContent);
                    if (this.trigger("keydown", {
                        event: t1
                    }), "mix" == e.mode) {
                        switch(t1.key){
                            case "Left":
                            case "ArrowLeft":
                                this.state.actions.ArrowLeft = !0;
                                break;
                            case "Delete":
                            case "Backspace":
                                if (this.state.editing) return;
                                var s = document.getSelection(), a = "Delete" == t1.key && s.anchorOffset == (s.anchorNode.length || 0), n = s.anchorNode.previousSibling, r = 1 == s.anchorNode.nodeType || !s.anchorOffset && n && 1 == n.nodeType && s.anchorNode.previousSibling;
                                o(this.DOM.input.innerHTML);
                                var d, h, g, p = this.getTagElms();
                                if ("edit" == e.backspace && r) return d = 1 == s.anchorNode.nodeType ? null : s.anchorNode.previousElementSibling, setTimeout(this.editTag.bind(this), 0, d), void t1.preventDefault();
                                if (u() && r instanceof Element) return g = l(r), r.hasAttribute("readonly") || r.remove(), this.DOM.input.focus(), void setTimeout(()=>{
                                    this.placeCaretAfterNode(g), this.DOM.input.click();
                                });
                                if ("BR" == s.anchorNode.nodeName) return;
                                if ((a || r) && 1 == s.anchorNode.nodeType ? h = 0 == s.anchorOffset ? a ? p[0] : null : p[Math.min(p.length, s.anchorOffset) - 1] : a ? h = s.anchorNode.nextElementSibling : r instanceof Element && (h = r), 3 == s.anchorNode.nodeType && !s.anchorNode.nodeValue && s.anchorNode.previousElementSibling && t1.preventDefault(), (r || a) && !e.backspace) return void t1.preventDefault();
                                if ("Range" != s.type && !s.anchorOffset && s.anchorNode == this.DOM.input && "Delete" != t1.key) return void t1.preventDefault();
                                if ("Range" != s.type && h && h.hasAttribute("readonly")) return void this.placeCaretAfterNode(l(h));
                                clearTimeout(O), O = setTimeout(()=>{
                                    var t1 = document.getSelection();
                                    o(this.DOM.input.innerHTML), !a && t1.anchorNode.previousSibling, this.value = [].map.call(p, (t1, e)=>{
                                        var i = T(t1);
                                        if (t1.parentNode || i.readonly) return i;
                                        this.trigger("remove", {
                                            tag: t1,
                                            index: e,
                                            data: i
                                        });
                                    }).filter((t1)=>t1);
                                }, 20);
                        }
                        return !0;
                    }
                    switch(t1.key){
                        case "Backspace":
                            "select" == e.mode && e.enforceWhitelist && this.value.length ? this.removeTags() : this.state.dropdown.visible && "manual" != e.dropdown.position || "" != t1.target.textContent && 8203 != i.charCodeAt(0) || (!0 === e.backspace ? this.removeTags() : "edit" == e.backspace && setTimeout(this.editTag.bind(this), 0));
                            break;
                        case "Esc":
                        case "Escape":
                            if (this.state.dropdown.visible) return;
                            t1.target.blur();
                            break;
                        case "Down":
                        case "ArrowDown":
                            this.state.dropdown.visible || this.dropdown.show();
                            break;
                        case "ArrowRight":
                            {
                                let t1 = this.state.inputSuggestion || this.state.ddItemData;
                                if (t1 && e.autoComplete.rightKey) return void this.addTags([
                                    t1
                                ], !0);
                                break;
                            }
                        case "Tab":
                            {
                                let s = "select" == e.mode;
                                if (!i || s) return !0;
                                t1.preventDefault();
                            }
                        case "Enter":
                            if (this.state.dropdown.visible && "manual" != e.dropdown.position) return;
                            t1.preventDefault(), setTimeout(()=>{
                                this.state.dropdown.visible || this.state.actions.selectOption || this.addTags(i, !0);
                            });
                    }
                }
            },
            onInput (t1) {
                this.postUpdate();
                var e = this.settings;
                if ("mix" == e.mode) return this.events.callbacks.onMixTagsInput.call(this, t1);
                var i = this.input.normalize.call(this), s = i.length >= e.dropdown.enabled, a = {
                    value: i,
                    inputElm: this.DOM.input
                }, n = this.validateTag({
                    value: i
                });
                "select" == e.mode && this.toggleScopeValidation(n), a.isValid = n, this.state.inputText != i && (this.input.set.call(this, i, !1), -1 != i.search(e.delimiters) ? this.addTags(i) && this.input.set.call(this) : e.dropdown.enabled >= 0 && this.dropdown[s ? "show" : "hide"](i), this.trigger("input", a));
            },
            onMixTagsInput (t1) {
                var e, i, s, a, n, o, r, l, d = this.settings, h = this.value.length, p = this.getTagElms(), c = document.createDocumentFragment(), m = window.getSelection().getRangeAt(0), v = [].map.call(p, (t1)=>T(t1).value);
                if ("deleteContentBackward" == t1.inputType && u() && this.events.callbacks.onKeydown.call(this, {
                    target: t1.target,
                    key: "Backspace"
                }), this.value.slice().forEach((t1)=>{
                    t1.readonly && !v.includes(t1.value) && c.appendChild(this.createTagElem(t1));
                }), c.childNodes.length && (m.insertNode(c), this.setRangeAtStartEnd(!1, c.lastChild)), p.length != h) return this.value = [].map.call(this.getTagElms(), (t1)=>T(t1)), void this.update({
                    withoutChangeEvent: !0
                });
                if (this.hasMaxTags()) return !0;
                if (window.getSelection && (o = window.getSelection()).rangeCount > 0 && 3 == o.anchorNode.nodeType) {
                    if ((m = o.getRangeAt(0).cloneRange()).collapse(!0), m.setStart(o.focusNode, 0), s = (e = m.toString().slice(0, m.endOffset)).split(d.pattern).length - 1, (i = e.match(d.pattern)) && (a = e.slice(e.lastIndexOf(i[i.length - 1]))), a) {
                        if (this.state.actions.ArrowLeft = !1, this.state.tag = {
                            prefix: a.match(d.pattern)[0],
                            value: a.replace(d.pattern, "")
                        }, this.state.tag.baseOffset = o.baseOffset - this.state.tag.value.length, l = this.state.tag.value.match(d.delimiters)) return this.state.tag.value = this.state.tag.value.replace(d.delimiters, ""), this.state.tag.delimiters = l[0], this.addTags(this.state.tag.value, d.dropdown.clearOnSelect), void this.dropdown.hide();
                        n = this.state.tag.value.length >= d.dropdown.enabled;
                        try {
                            r = (r = this.state.flaggedTags[this.state.tag.baseOffset]).prefix == this.state.tag.prefix && r.value[0] == this.state.tag.value[0], this.state.flaggedTags[this.state.tag.baseOffset] && !this.state.tag.value && delete this.state.flaggedTags[this.state.tag.baseOffset];
                        } catch (t1) {}
                        (r || s < this.state.mixMode.matchedPatternCount) && (n = !1);
                    } else this.state.flaggedTags = {};
                    this.state.mixMode.matchedPatternCount = s;
                }
                setTimeout(()=>{
                    this.update({
                        withoutChangeEvent: !0
                    }), this.trigger("input", g({}, this.state.tag, {
                        textContent: this.DOM.input.textContent
                    })), this.state.tag && this.dropdown[n ? "show" : "hide"](this.state.tag.value);
                }, 10);
            },
            onInputIE (t1) {
                var e = this;
                setTimeout(function() {
                    e.events.callbacks.onInput.call(e, t1);
                });
            },
            observeOriginalInputValue () {
                this.DOM.originalInput.parentNode || this.destroy(), this.DOM.originalInput.value != this.DOM.originalInput.tagifyValue && this.loadOriginalValues();
            },
            onClickAnywhere (t1) {
                t1.target == this.DOM.scope || this.DOM.scope.contains(t1.target) || (this.toggleFocusClass(!1), this.state.hasFocus = !1);
            },
            onClickScope (t1) {
                var e = this.settings, i = t1.target.closest("." + e.classNames.tag), s = +new Date - this.state.hasFocus;
                if (t1.target != this.DOM.scope) {
                    if (!t1.target.classList.contains(e.classNames.tagX)) return i ? (this.trigger("click", {
                        tag: i,
                        index: this.getNodeIndex(i),
                        data: T(i),
                        event: t1
                    }), void (1 !== e.editTags && 1 !== e.editTags.clicks || this.events.callbacks.onDoubleClickScope.call(this, t1))) : void (t1.target == this.DOM.input && ("mix" == e.mode && this.fixFirefoxLastTagNoCaret(), s > 500) ? this.state.dropdown.visible ? this.dropdown.hide() : 0 === e.dropdown.enabled && "mix" != e.mode && this.dropdown.show(this.value.length ? "" : void 0) : "select" != e.mode || 0 !== e.dropdown.enabled || this.state.dropdown.visible || this.dropdown.show());
                    this.removeTags(t1.target.parentNode);
                } else this.DOM.input.focus();
            },
            onPaste (t1) {
                t1.preventDefault();
                var e, i, s = this.settings;
                if ("select" == s.mode && s.enforceWhitelist || !s.userInput) return !1;
                s.readonly || (e = t1.clipboardData || window.clipboardData, i = e.getData("Text"), s.hooks.beforePaste(t1, {
                    tagify: this,
                    pastedText: i,
                    clipboardData: e
                }).then((e)=>{
                    void 0 === e && (e = i), e && (this.injectAtCaret(e, window.getSelection().getRangeAt(0)), "mix" == this.settings.mode ? this.events.callbacks.onMixTagsInput.call(this, t1) : this.settings.pasteAsTags ? this.addTags(this.state.inputText + e, !0) : this.state.inputText = e);
                }).catch((t1)=>t1));
            },
            onDrop (t1) {
                t1.preventDefault();
            },
            onEditTagInput (t1, e) {
                var i = t1.closest("." + this.settings.classNames.tag), s = this.getNodeIndex(i), a = T(i), n = this.input.normalize.call(this, t1), o = {
                    [this.settings.tagTextProp]: n,
                    __tagId: a.__tagId
                }, r = this.validateTag(o);
                this.editTagChangeDetected(g(a, o)) || !0 !== t1.originalIsValid || (r = !0), i.classList.toggle(this.settings.classNames.tagInvalid, !0 !== r), a.__isValid = r, i.title = !0 === r ? a.title || a.value : r, n.length >= this.settings.dropdown.enabled && (this.state.editing && (this.state.editing.value = n), this.dropdown.show(n)), this.trigger("edit:input", {
                    tag: i,
                    index: s,
                    data: g({}, this.value[s], {
                        newValue: n
                    }),
                    event: e
                });
            },
            onEditTagPaste (t1, e) {
                var i = (e.clipboardData || window.clipboardData).getData("Text");
                e.preventDefault();
                var s = f(i);
                this.setRangeAtStartEnd(!1, s);
            },
            onEditTagFocus (t1) {
                this.state.editing = {
                    scope: t1,
                    input: t1.querySelector("[contenteditable]")
                };
            },
            onEditTagBlur (t1) {
                if (this.state.hasFocus || this.toggleFocusClass(), this.DOM.scope.contains(t1)) {
                    var e, i, s = this.settings, a = t1.closest("." + s.classNames.tag), n = T(a), o = this.input.normalize.call(this, t1), r = {
                        [s.tagTextProp]: o,
                        __tagId: n.__tagId
                    }, l = n.__originalData, d = this.editTagChangeDetected(g(n, r)), h = this.validateTag(r);
                    if (o) {
                        if (d) {
                            if (e = this.hasMaxTags(), i = g({}, l, {
                                [s.tagTextProp]: this.trim(o),
                                __isValid: h
                            }), s.transformTag.call(this, i, l), !0 !== (h = (!e || !0 === l.__isValid) && this.validateTag(i))) {
                                if (this.trigger("invalid", {
                                    data: i,
                                    tag: a,
                                    message: h
                                }), s.editTags.keepInvalid) return;
                                s.keepInvalidTags ? i.__isValid = h : i = l;
                            } else s.keepInvalidTags && (delete i.title, delete i["aria-invalid"], delete i.class);
                            this.onEditTagDone(a, i);
                        } else this.onEditTagDone(a, l);
                    } else this.onEditTagDone(a);
                }
            },
            onEditTagkeydown (t1, e) {
                if (!this.state.composing) switch(this.trigger("edit:keydown", {
                    event: t1
                }), t1.key){
                    case "Esc":
                    case "Escape":
                        e.parentNode.replaceChild(e.__tagifyTagData.__originalHTML, e), this.state.editing = !1;
                    case "Enter":
                    case "Tab":
                        t1.preventDefault(), t1.target.blur();
                }
            },
            onDoubleClickScope (t1) {
                var e, i, s = t1.target.closest("." + this.settings.classNames.tag), a = T(s), n = this.settings;
                s && n.userInput && !1 !== a.editable && (e = s.classList.contains(this.settings.classNames.tagEditing), i = s.hasAttribute("readonly"), "select" == n.mode || n.readonly || e || i || !this.settings.editTags || this.editTag(s), this.toggleFocusClass(!0), this.trigger("dblclick", {
                    tag: s,
                    index: this.getNodeIndex(s),
                    data: T(s)
                }));
            },
            onInputDOMChange (t1) {
                t1.forEach((t1)=>{
                    t1.addedNodes.forEach((t1)=>{
                        if ("<div><br></div>" == t1.outerHTML) t1.replaceWith(document.createElement("br"));
                        else if (1 == t1.nodeType && t1.querySelector(this.settings.classNames.tagSelector)) {
                            let e = document.createTextNode("");
                            3 == t1.childNodes[0].nodeType && "BR" != t1.previousSibling.nodeName && (e = document.createTextNode("\n")), t1.replaceWith(e, ...[
                                ...t1.childNodes
                            ].slice(0, -1)), this.placeCaretAfterNode(e);
                        } else if (v.call(this, t1) && (3 != t1.previousSibling?.nodeType || t1.previousSibling.textContent || t1.previousSibling.remove(), t1.previousSibling && "BR" == t1.previousSibling.nodeName)) {
                            t1.previousSibling.replaceWith("\n\u200B");
                            let e = t1.nextSibling, i = "";
                            for(; e;)i += e.textContent, e = e.nextSibling;
                            i.trim() && this.placeCaretAfterNode(t1.previousSibling);
                        }
                    }), t1.removedNodes.forEach((t1)=>{
                        t1 && "BR" == t1.nodeName && v.call(this, e) && (this.removeTags(e), this.fixFirefoxLastTagNoCaret());
                    });
                });
                var e = this.DOM.input.lastChild;
                e && "" == e.nodeValue && e.remove(), e && "BR" == e.nodeName || this.DOM.input.appendChild(document.createElement("br"));
            }
        }
    };
    function N(t1, e) {
        if (!t1) {
            console.warn("Tagify:", "input element not found", t1);
            const e = new Proxy(this, {
                get: ()=>()=>e
            });
            return e;
        }
        if (t1.__tagify) return console.warn("Tagify: ", "input element is already Tagified - Same instance is returned.", t1), t1.__tagify;
        var i;
        g(this, function(t1) {
            var e = document.createTextNode("");
            function i(t1, i, s) {
                s && i.split(/\s+/g).forEach((i)=>e[t1 + "EventListener"].call(e, i, s));
            }
            return {
                off (t1, e) {
                    return i("remove", t1, e), this;
                },
                on (t1, e) {
                    return e && "function" == typeof e && i("add", t1, e), this;
                },
                trigger (i, s, a) {
                    var n;
                    if (a = a || {
                        cloneData: !0
                    }, i) {
                        if (t1.settings.isJQueryPlugin) "remove" == i && (i = "removeTag"), jQuery(t1.DOM.originalInput).triggerHandler(i, [
                            s
                        ]);
                        else {
                            try {
                                var o = "object" == typeof s ? s : {
                                    value: s
                                };
                                if ((o = a.cloneData ? g({}, o) : o).tagify = this, s.event && (o.event = this.cloneEvent(s.event)), s instanceof Object) for(var r in s)s[r] instanceof HTMLElement && (o[r] = s[r]);
                                n = new CustomEvent(i, {
                                    detail: o
                                });
                            } catch (t1) {
                                console.warn(t1);
                            }
                            e.dispatchEvent(n);
                        }
                    }
                }
            };
        }(this)), this.isFirefox = /firefox|fxios/i.test(navigator.userAgent) && !/seamonkey/i.test(navigator.userAgent), this.isIE = window.document.documentMode, e = e || {}, this.getPersistedData = (i = e.id, (t1)=>{
            let e, s = "/" + t1;
            if (1 == localStorage.getItem(x + i + "/v", 1)) try {
                e = JSON.parse(localStorage[x + i + s]);
            } catch (t1) {}
            return e;
        }), this.setPersistedData = ((t1)=>t1 ? (localStorage.setItem(x + t1 + "/v", 1), (e, i)=>{
                let s = "/" + i, a = JSON.stringify(e);
                e && i && (localStorage.setItem(x + t1 + s, a), dispatchEvent(new Event("storage")));
            }) : ()=>{})(e.id), this.clearPersistedData = ((t1)=>(e)=>{
                const i = x + "/" + t1 + "/";
                if (e) localStorage.removeItem(i + e);
                else for(let t1 in localStorage)t1.includes(i) && localStorage.removeItem(t1);
            })(e.id), this.applySettings(t1, e), this.state = {
            inputText: "",
            editing: !1,
            composing: !1,
            actions: {},
            mixMode: {},
            dropdown: {},
            flaggedTags: {}
        }, this.value = [], this.listeners = {}, this.DOM = {}, this.build(t1), b.call(this), this.getCSSVars(), this.loadOriginalValues(), this.events.customBinding.call(this), this.events.binding.call(this), t1.autofocus && this.DOM.input.focus(), t1.__tagify = this;
    }
    return N.prototype = {
        _dropdown: y,
        getSetTagData: T,
        helpers: {
            sameStr: s,
            removeCollectionProp: a,
            omit: n,
            isObject: h,
            parseHTML: r,
            escapeHTML: d,
            extend: g,
            concatWithoutDups: p,
            getUID: m,
            isNodeTag: v
        },
        customEventsList: [
            "change",
            "add",
            "remove",
            "invalid",
            "input",
            "click",
            "keydown",
            "focus",
            "blur",
            "edit:input",
            "edit:beforeUpdate",
            "edit:updated",
            "edit:start",
            "edit:keydown",
            "dropdown:show",
            "dropdown:hide",
            "dropdown:select",
            "dropdown:updated",
            "dropdown:noMatch",
            "dropdown:scroll"
        ],
        dataProps: [
            "__isValid",
            "__removed",
            "__originalData",
            "__originalHTML",
            "__tagId"
        ],
        trim (t1) {
            return this.settings.trim && t1 && "string" == typeof t1 ? t1.trim() : t1;
        },
        parseHTML: r,
        templates: M,
        parseTemplate (t1, e) {
            return r((t1 = this.settings.templates[t1] || t1).apply(this, e));
        },
        set whitelist (t){
            const e = t && Array.isArray(t);
            this.settings.whitelist = e ? t : [], this.setPersistedData(e ? t : [], "whitelist");
        },
        get whitelist () {
            return this.settings.whitelist;
        },
        generateClassSelectors (t1) {
            for(let e in t1){
                let i = e;
                Object.defineProperty(t1, i + "Selector", {
                    get () {
                        return "." + this[i].split(" ")[0];
                    }
                });
            }
        },
        applySettings (t1, i) {
            w.templates = this.templates;
            var s = g({}, w, "mix" == i.mode ? {
                dropdown: {
                    position: "text"
                }
            } : {}), a = this.settings = g({}, s, i);
            if (a.disabled = t1.hasAttribute("disabled"), a.readonly = a.readonly || t1.hasAttribute("readonly"), a.placeholder = d(t1.getAttribute("placeholder") || a.placeholder || ""), a.required = t1.hasAttribute("required"), this.generateClassSelectors(a.classNames), void 0 === a.dropdown.includeSelectedTags && (a.dropdown.includeSelectedTags = a.duplicates), this.isIE && (a.autoComplete = !1), [
                "whitelist",
                "blacklist"
            ].forEach((e)=>{
                var i = t1.getAttribute("data-" + e);
                i && (i = i.split(a.delimiters)) instanceof Array && (a[e] = i);
            }), "autoComplete" in i && !h(i.autoComplete) && (a.autoComplete = w.autoComplete, a.autoComplete.enabled = i.autoComplete), "mix" == a.mode && (a.pattern = a.pattern || /@/, a.autoComplete.rightKey = !0, a.delimiters = i.delimiters || null, a.tagTextProp && !a.dropdown.searchKeys.includes(a.tagTextProp) && a.dropdown.searchKeys.push(a.tagTextProp)), t1.pattern) try {
                a.pattern = new RegExp(t1.pattern);
            } catch (t1) {}
            if (a.delimiters) {
                a._delimiters = a.delimiters;
                try {
                    a.delimiters = new RegExp(this.settings.delimiters, "g");
                } catch (t1) {}
            }
            a.disabled && (a.userInput = !1), this.TEXTS = e(e({}, D), a.texts || {}), ("select" != a.mode || i.dropdown?.enabled) && a.userInput || (a.dropdown.enabled = 0), a.dropdown.appendTarget = i.dropdown?.appendTarget || document.body;
            let n = this.getPersistedData("whitelist");
            Array.isArray(n) && (this.whitelist = Array.isArray(a.whitelist) ? p(a.whitelist, n) : n);
        },
        getAttributes (t1) {
            var e, i = this.getCustomAttributes(t1), s = "";
            for(e in i)s += " " + e + (void 0 !== t1[e] ? `="${i[e]}"` : "");
            return s;
        },
        getCustomAttributes (t1) {
            if (!h(t1)) return "";
            var e, i = {};
            for(e in t1)"__" != e.slice(0, 2) && "class" != e && t1.hasOwnProperty(e) && void 0 !== t1[e] && (i[e] = d(t1[e]));
            return i;
        },
        setStateSelection () {
            var t1 = window.getSelection(), e = {
                anchorOffset: t1.anchorOffset,
                anchorNode: t1.anchorNode,
                range: t1.getRangeAt && t1.rangeCount && t1.getRangeAt(0)
            };
            return this.state.selection = e, e;
        },
        getCSSVars () {
            var t1 = getComputedStyle(this.DOM.scope, null);
            var e;
            this.CSSVars = {
                tagHideTransition: ((t1)=>{
                    let e = t1.value;
                    return "s" == t1.unit ? 1e3 * e : e;
                })(function(t1) {
                    if (!t1) return {};
                    var e = (t1 = t1.trim().split(" ")[0]).split(/\d+/g).filter((t1)=>t1).pop().trim();
                    return {
                        value: +t1.split(e).filter((t1)=>t1)[0].trim(),
                        unit: e
                    };
                }((e = "tag-hide-transition", t1.getPropertyValue("--" + e))))
            };
        },
        build (t1) {
            var e = this.DOM;
            this.settings.mixMode.integrated ? (e.originalInput = null, e.scope = t1, e.input = t1) : (e.originalInput = t1, e.originalInput_tabIndex = t1.tabIndex, e.scope = this.parseTemplate("wrapper", [
                t1,
                this.settings
            ]), e.input = e.scope.querySelector(this.settings.classNames.inputSelector), t1.parentNode.insertBefore(e.scope, t1), t1.tabIndex = -1);
        },
        destroy () {
            this.events.unbindGlobal.call(this), this.DOM.scope.parentNode.removeChild(this.DOM.scope), this.DOM.originalInput.tabIndex = this.DOM.originalInput_tabIndex, delete this.DOM.originalInput.__tagify, this.dropdown.hide(!0), clearTimeout(this.dropdownHide__bindEventsTimeout), clearInterval(this.listeners.main.originalInputValueObserverInterval);
        },
        loadOriginalValues (t1) {
            var e, i = this.settings;
            if (this.state.blockChangeEvent = !0, void 0 === t1) {
                const e = this.getPersistedData("value");
                t1 = e && !this.DOM.originalInput.value ? e : i.mixMode.integrated ? this.DOM.input.textContent : this.DOM.originalInput.value;
            }
            if (this.removeAllTags(), t1) {
                if ("mix" == i.mode) this.parseMixTags(t1), (e = this.DOM.input.lastChild) && "BR" == e.tagName || this.DOM.input.insertAdjacentHTML("beforeend", "<br>");
                else {
                    try {
                        JSON.parse(t1) instanceof Array && (t1 = JSON.parse(t1));
                    } catch (t1) {}
                    this.addTags(t1, !0).forEach((t1)=>t1 && t1.classList.add(i.classNames.tagNoAnimation));
                }
            } else this.postUpdate();
            this.state.lastOriginalValueReported = i.mixMode.integrated ? "" : this.DOM.originalInput.value;
        },
        cloneEvent (t1) {
            var e = {};
            for(var i in t1)"path" != i && (e[i] = t1[i]);
            return e;
        },
        loading (t1) {
            return this.state.isLoading = t1, this.DOM.scope.classList[t1 ? "add" : "remove"](this.settings.classNames.scopeLoading), this;
        },
        tagLoading (t1, e) {
            return t1 && t1.classList[e ? "add" : "remove"](this.settings.classNames.tagLoading), this;
        },
        toggleClass (t1, e) {
            "string" == typeof t1 && this.DOM.scope.classList.toggle(t1, e);
        },
        toggleScopeValidation (t1) {
            var e = !0 === t1 || void 0 === t1;
            !this.settings.required && t1 && t1 === this.TEXTS.empty && (e = !0), this.toggleClass(this.settings.classNames.tagInvalid, !e), this.DOM.scope.title = e ? "" : t1;
        },
        toggleFocusClass (t1) {
            this.toggleClass(this.settings.classNames.focus, !!t1);
        },
        triggerChangeEvent: function() {
            if (!this.settings.mixMode.integrated) {
                var t1 = this.DOM.originalInput, e = this.state.lastOriginalValueReported !== t1.value, i = new CustomEvent("change", {
                    bubbles: !0
                });
                e && (this.state.lastOriginalValueReported = t1.value, i.simulated = !0, t1._valueTracker && t1._valueTracker.setValue(Math.random()), t1.dispatchEvent(i), this.trigger("change", this.state.lastOriginalValueReported), t1.value = this.state.lastOriginalValueReported);
            }
        },
        events: I,
        fixFirefoxLastTagNoCaret () {},
        setRangeAtStartEnd (t1, e) {
            if (e) {
                t1 = "number" == typeof t1 ? t1 : !!t1, e = e.lastChild || e;
                var i = document.getSelection();
                if (i.focusNode instanceof Element && !this.DOM.input.contains(i.focusNode)) return !0;
                try {
                    i.rangeCount >= 1 && [
                        "Start",
                        "End"
                    ].forEach((s)=>i.getRangeAt(0)["set" + s](e, t1 || e.length));
                } catch (t1) {}
            }
        },
        placeCaretAfterNode (t1) {
            if (t1 && t1.parentNode) {
                var e = t1, i = window.getSelection(), s = i.getRangeAt(0);
                i.rangeCount && (s.setStartAfter(e), s.collapse(!0), i.removeAllRanges(), i.addRange(s));
            }
        },
        insertAfterTag (t1, e) {
            if (e = e || this.settings.mixMode.insertAfterTag, t1 && t1.parentNode && e) return e = "string" == typeof e ? document.createTextNode(e) : e, t1.parentNode.insertBefore(e, t1.nextSibling), e;
        },
        editTagChangeDetected (t1) {
            var e = t1.__originalData;
            for(var i in e)if (!this.dataProps.includes(i) && t1[i] != e[i]) return !0;
            return !1;
        },
        getTagTextNode (t1) {
            return t1.querySelector(this.settings.classNames.tagTextSelector);
        },
        setTagTextNode (t1, e) {
            this.getTagTextNode(t1).innerHTML = d(e);
        },
        editTag (t1, e) {
            t1 = t1 || this.getLastTag(), e = e || {}, this.dropdown.hide();
            var i = this.settings, s = this.getTagTextNode(t1), a = this.getNodeIndex(t1), n = T(t1), o = this.events.callbacks, r = this, l = !0;
            if (s) {
                if (!(n instanceof Object && "editable" in n) || n.editable) return n = T(t1, {
                    __originalData: g({}, n),
                    __originalHTML: t1.cloneNode(!0)
                }), T(n.__originalHTML, n.__originalData), s.setAttribute("contenteditable", !0), t1.classList.add(i.classNames.tagEditing), s.addEventListener("focus", o.onEditTagFocus.bind(this, t1)), s.addEventListener("blur", function() {
                    setTimeout(()=>o.onEditTagBlur.call(r, r.getTagTextNode(t1)));
                }), s.addEventListener("input", o.onEditTagInput.bind(this, s)), s.addEventListener("paste", o.onEditTagPaste.bind(this, s)), s.addEventListener("keydown", (e)=>o.onEditTagkeydown.call(this, e, t1)), s.addEventListener("compositionstart", o.onCompositionStart.bind(this)), s.addEventListener("compositionend", o.onCompositionEnd.bind(this)), e.skipValidation || (l = this.editTagToggleValidity(t1)), s.originalIsValid = l, this.trigger("edit:start", {
                    tag: t1,
                    index: a,
                    data: n,
                    isValid: l
                }), s.focus(), this.setRangeAtStartEnd(!1, s), this;
            } else console.warn("Cannot find element in Tag template: .", i.classNames.tagTextSelector);
        },
        editTagToggleValidity (t1, e) {
            var i;
            if (e = e || T(t1)) return (i = !("__isValid" in e) || !0 === e.__isValid) || this.removeTagsFromValue(t1), this.update(), t1.classList.toggle(this.settings.classNames.tagNotAllowed, !i), e.__isValid;
            console.warn("tag has no data: ", t1, e);
        },
        onEditTagDone (t1, e) {
            e = e || {};
            var i = {
                tag: t1 = t1 || this.state.editing.scope,
                index: this.getNodeIndex(t1),
                previousData: T(t1),
                data: e
            };
            this.trigger("edit:beforeUpdate", i, {
                cloneData: !1
            }), this.state.editing = !1, delete e.__originalData, delete e.__originalHTML, t1 && e[this.settings.tagTextProp] ? (t1 = this.replaceTag(t1, e), this.editTagToggleValidity(t1, e), this.settings.a11y.focusableTags ? t1.focus() : this.placeCaretAfterNode(t1)) : t1 && this.removeTags(t1), this.trigger("edit:updated", i), this.dropdown.hide(), this.settings.keepInvalidTags && this.reCheckInvalidTags();
        },
        replaceTag (t1, e) {
            e && e.value || (e = t1.__tagifyTagData), e.__isValid && 1 != e.__isValid && g(e, this.getInvalidTagAttrs(e, e.__isValid));
            var i = this.createTagElem(e);
            return t1.parentNode.replaceChild(i, t1), this.updateValueByDOMTags(), i;
        },
        updateValueByDOMTags () {
            this.value.length = 0, [].forEach.call(this.getTagElms(), (t1)=>{
                t1.classList.contains(this.settings.classNames.tagNotAllowed.split(" ")[0]) || this.value.push(T(t1));
            }), this.update();
        },
        injectAtCaret (t1, e) {
            return !(e = e || this.state.selection?.range) && t1 ? (this.appendMixTags(t1), this) : (f(t1, e), this.setRangeAtStartEnd(!1, t1), this.updateValueByDOMTags(), this.update(), this);
        },
        input: {
            set () {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                var i = this.settings.dropdown.closeOnSelect;
                this.state.inputText = t1, e && (this.DOM.input.innerHTML = d("" + t1)), !t1 && i && this.dropdown.hide.bind(this), this.input.autocomplete.suggest.call(this), this.input.validate.call(this);
            },
            raw () {
                return this.DOM.input.textContent;
            },
            validate () {
                var t1 = !this.state.inputText || !0 === this.validateTag({
                    value: this.state.inputText
                });
                return this.DOM.input.classList.toggle(this.settings.classNames.inputInvalid, !t1), t1;
            },
            normalize (t1) {
                var e = t1 || this.DOM.input, i = [];
                e.childNodes.forEach((t1)=>3 == t1.nodeType && i.push(t1.nodeValue)), i = i.join("\n");
                try {
                    i = i.replace(/(?:\r\n|\r|\n)/g, this.settings.delimiters.source.charAt(0));
                } catch (t1) {}
                return i = i.replace(/\s/g, " "), this.trim(i);
            },
            autocomplete: {
                suggest (t1) {
                    if (this.settings.autoComplete.enabled) {
                        "string" == typeof (t1 = t1 || {
                            value: ""
                        }) && (t1 = {
                            value: t1
                        });
                        var e = this.dropdown.getMappedValue(t1);
                        if ("number" != typeof e) {
                            var i = e.substr(0, this.state.inputText.length).toLowerCase(), s = e.substring(this.state.inputText.length);
                            e && this.state.inputText && i == this.state.inputText.toLowerCase() ? (this.DOM.input.setAttribute("data-suggest", s), this.state.inputSuggestion = t1) : (this.DOM.input.removeAttribute("data-suggest"), delete this.state.inputSuggestion);
                        }
                    }
                },
                set (t1) {
                    var e = this.DOM.input.getAttribute("data-suggest"), i = t1 || (e ? this.state.inputText + e : null);
                    return !!i && ("mix" == this.settings.mode ? this.replaceTextWithNode(document.createTextNode(this.state.tag.prefix + i)) : (this.input.set.call(this, i), this.setRangeAtStartEnd(!1, this.DOM.input)), this.input.autocomplete.suggest.call(this), this.dropdown.hide(), !0);
                }
            }
        },
        getTagIdx (t1) {
            return this.value.findIndex((e)=>e.__tagId == (t1 || {}).__tagId);
        },
        getNodeIndex (t1) {
            var e = 0;
            if (t1) for(; t1 = t1.previousElementSibling;)e++;
            return e;
        },
        getTagElms () {
            for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
            var s = "." + [
                ...this.settings.classNames.tag.split(" "),
                ...e
            ].join(".");
            return [].slice.call(this.DOM.scope.querySelectorAll(s));
        },
        getLastTag () {
            var t1 = this.DOM.scope.querySelectorAll(`${this.settings.classNames.tagSelector}:not(.${this.settings.classNames.tagHide}):not([readonly])`);
            return t1[t1.length - 1];
        },
        isTagDuplicate (t1, e, i) {
            var a = 0;
            if ("select" == this.settings.mode) return !1;
            for (let n of this.value)s(this.trim("" + t1), n.value, e) && i != n.__tagId && a++;
            return a;
        },
        getTagIndexByValue (t1) {
            var e = [];
            return this.getTagElms().forEach((i, a)=>{
                s(this.trim(i.textContent), t1, this.settings.dropdown.caseSensitive) && e.push(a);
            }), e;
        },
        getTagElmByValue (t1) {
            var e = this.getTagIndexByValue(t1)[0];
            return this.getTagElms()[e];
        },
        flashTag (t1) {
            t1 && (t1.classList.add(this.settings.classNames.tagFlash), setTimeout(()=>{
                t1.classList.remove(this.settings.classNames.tagFlash);
            }, 100));
        },
        isTagBlacklisted (t1) {
            return t1 = this.trim(t1.toLowerCase()), this.settings.blacklist.filter((e)=>("" + e).toLowerCase() == t1).length;
        },
        isTagWhitelisted (t1) {
            return !!this.getWhitelistItem(t1);
        },
        getWhitelistItem (t1, e, i) {
            e = e || "value";
            var a, n = this.settings;
            return (i = i || n.whitelist).some((i)=>{
                var o = "string" == typeof i ? i : i[e] || i.value;
                if (s(o, t1, n.dropdown.caseSensitive, n.trim)) return a = "string" == typeof i ? {
                    value: i
                } : i, !0;
            }), a || "value" != e || "value" == n.tagTextProp || (a = this.getWhitelistItem(t1, n.tagTextProp, i)), a;
        },
        validateTag (t1) {
            var e = this.settings, i = "value" in t1 ? "value" : e.tagTextProp, s = this.trim(t1[i] + "");
            return (t1[i] + "").trim() ? e.pattern && e.pattern instanceof RegExp && !e.pattern.test(s) ? this.TEXTS.pattern : !e.duplicates && this.isTagDuplicate(s, e.dropdown.caseSensitive, t1.__tagId) ? this.TEXTS.duplicate : this.isTagBlacklisted(s) || e.enforceWhitelist && !this.isTagWhitelisted(s) ? this.TEXTS.notAllowed : !e.validate || e.validate(t1) : this.TEXTS.empty;
        },
        getInvalidTagAttrs (t1, e) {
            return {
                "aria-invalid": !0,
                class: `${t1.class || ""} ${this.settings.classNames.tagNotAllowed}`.trim(),
                title: e
            };
        },
        hasMaxTags () {
            return this.value.length >= this.settings.maxTags && this.TEXTS.exceed;
        },
        setReadonly (t1, e) {
            var i = this.settings;
            document.activeElement.blur(), i[e || "readonly"] = t1, this.DOM.scope[(t1 ? "set" : "remove") + "Attribute"](e || "readonly", !0), this.setContentEditable(!t1);
        },
        setContentEditable (t1) {
            this.settings.userInput && (this.DOM.input.contentEditable = t1, this.DOM.input.tabIndex = t1 ? 0 : -1);
        },
        setDisabled (t1) {
            this.setReadonly(t1, "disabled");
        },
        normalizeTags (t1) {
            var e = this.settings, i = e.whitelist, s = e.delimiters, a = e.mode, n = e.tagTextProp, o = [], r = !!i && i[0] instanceof Object, l = Array.isArray(t1), d = l && t1[0].value, h = (t1)=>(t1 + "").split(s).filter((t1)=>t1).map((t1)=>({
                        [n]: this.trim(t1),
                        value: this.trim(t1)
                    }));
            if ("number" == typeof t1 && (t1 = t1.toString()), "string" == typeof t1) {
                if (!t1.trim()) return [];
                t1 = h(t1);
            } else l && (t1 = [].concat(...t1.map((t1)=>null != t1.value ? t1 : h(t1))));
            return r && !d && (t1.forEach((t1)=>{
                var e = o.map((t1)=>t1.value), i = this.dropdown.filterListItems.call(this, t1[n], {
                    exact: !0
                });
                this.settings.duplicates || (i = i.filter((t1)=>!e.includes(t1.value)));
                var s = i.length > 1 ? this.getWhitelistItem(t1[n], n, i) : i[0];
                s && s instanceof Object ? o.push(s) : "mix" != a && (null == t1.value && (t1.value = t1[n]), o.push(t1));
            }), o.length && (t1 = o)), t1;
        },
        parseMixTags (t1) {
            var e = this.settings, i = e.mixTagsInterpolator, s = e.duplicates, a = e.transformTag, n = e.enforceWhitelist, o = e.maxTags, r = e.tagTextProp, l = [];
            return t1 = t1.split(i[0]).map((t1, e)=>{
                var d, h, g, p = t1.split(i[1]), c = p[0], u = l.length == o;
                try {
                    if (c == +c) throw Error;
                    h = JSON.parse(c);
                } catch (t1) {
                    h = this.normalizeTags(c)[0] || {
                        value: c
                    };
                }
                if (a.call(this, h), u || !(p.length > 1) || n && !this.isTagWhitelisted(h.value) || !s && this.isTagDuplicate(h.value)) {
                    if (t1) return e ? i[0] + t1 : t1;
                } else h[d = h[r] ? r : "value"] = this.trim(h[d]), g = this.createTagElem(h), l.push(h), g.classList.add(this.settings.classNames.tagNoAnimation), p[0] = g.outerHTML, this.value.push(h);
                return p.join("");
            }).join(""), this.DOM.input.innerHTML = t1, this.DOM.input.appendChild(document.createTextNode("")), this.DOM.input.normalize(), this.getTagElms().forEach((t1, e)=>T(t1, l[e])), this.update({
                withoutChangeEvent: !0
            }), t1;
        },
        replaceTextWithNode (t1, e) {
            if (this.state.tag || e) {
                e = e || this.state.tag.prefix + this.state.tag.value;
                var i, s, a = this.state.selection || window.getSelection(), n = a.anchorNode, o = this.state.tag.delimiters ? this.state.tag.delimiters.length : 0;
                return n.splitText(a.anchorOffset - o), -1 == (i = n.nodeValue.lastIndexOf(e)) ? !0 : (s = n.splitText(i), t1 && n.parentNode.replaceChild(t1, s), !0);
            }
        },
        selectTag (t1, e) {
            var i = this.settings;
            if (!i.enforceWhitelist || this.isTagWhitelisted(e.value)) {
                this.input.set.call(this, e[i.tagTextProp] || e.value, !0), this.state.actions.selectOption && setTimeout(()=>this.setRangeAtStartEnd(!1, this.DOM.input));
                var s = this.getLastTag();
                return s ? this.replaceTag(s, e) : this.appendTag(t1), this.value[0] = e, this.update(), this.trigger("add", {
                    tag: t1,
                    data: e
                }), [
                    t1
                ];
            }
        },
        addEmptyTag (t1) {
            var e = g({
                value: ""
            }, t1 || {}), i = this.createTagElem(e);
            T(i, e), this.appendTag(i), this.editTag(i, {
                skipValidation: !0
            });
        },
        addTags (t1, e, i) {
            var s = [], a = this.settings, n = [], o = document.createDocumentFragment();
            if (i = i || a.skipInvalid, !t1 || 0 == t1.length) return s;
            switch(t1 = this.normalizeTags(t1), a.mode){
                case "mix":
                    return this.addMixTags(t1);
                case "select":
                    e = !1, this.removeAllTags();
            }
            return this.DOM.input.removeAttribute("style"), t1.forEach((t1)=>{
                var e, r = {}, l = Object.assign({}, t1, {
                    value: t1.value + ""
                });
                if (t1 = Object.assign({}, l), a.transformTag.call(this, t1), t1.__isValid = this.hasMaxTags() || this.validateTag(t1), !0 !== t1.__isValid) {
                    if (i) return;
                    if (g(r, this.getInvalidTagAttrs(t1, t1.__isValid), {
                        __preInvalidData: l
                    }), t1.__isValid == this.TEXTS.duplicate && this.flashTag(this.getTagElmByValue(t1.value)), !a.createInvalidTags) return void n.push(t1.value);
                }
                if ("readonly" in t1 && (t1.readonly ? r["aria-readonly"] = !0 : delete t1.readonly), e = this.createTagElem(t1, r), s.push(e), "select" == a.mode) return this.selectTag(e, t1);
                o.appendChild(e), t1.__isValid && !0 === t1.__isValid ? (this.value.push(t1), this.trigger("add", {
                    tag: e,
                    index: this.value.length - 1,
                    data: t1
                })) : (this.trigger("invalid", {
                    data: t1,
                    index: this.value.length,
                    tag: e,
                    message: t1.__isValid
                }), a.keepInvalidTags || setTimeout(()=>this.removeTags(e, !0), 1e3)), this.dropdown.position();
            }), this.appendTag(o), this.update(), t1.length && e && (this.input.set.call(this, a.createInvalidTags ? "" : n.join(a._delimiters)), this.setRangeAtStartEnd(!1, this.DOM.input)), a.dropdown.enabled && this.dropdown.refilter(), s;
        },
        addMixTags (t1) {
            if ((t1 = this.normalizeTags(t1))[0].prefix || this.state.tag) return this.prefixedTextToTag(t1[0]);
            var e = document.createDocumentFragment();
            return t1.forEach((t1)=>{
                var i = this.createTagElem(t1);
                e.appendChild(i);
            }), this.appendMixTags(e), e;
        },
        appendMixTags (t1) {
            var e = !!this.state.selection;
            e ? this.injectAtCaret(t1) : (this.DOM.input.focus(), (e = this.setStateSelection()).range.setStart(this.DOM.input, e.range.endOffset), e.range.setEnd(this.DOM.input, e.range.endOffset), this.DOM.input.appendChild(t1), this.updateValueByDOMTags(), this.update());
        },
        prefixedTextToTag (t1) {
            var e, i = this.settings, s = this.state.tag.delimiters;
            if (i.transformTag.call(this, t1), t1.prefix = t1.prefix || this.state.tag ? this.state.tag.prefix : (i.pattern.source || i.pattern)[0], e = this.createTagElem(t1), this.replaceTextWithNode(e) || this.DOM.input.appendChild(e), setTimeout(()=>e.classList.add(this.settings.classNames.tagNoAnimation), 300), this.value.push(t1), this.update(), !s) {
                var a = this.insertAfterTag(e) || e;
                setTimeout(this.placeCaretAfterNode, 0, a);
            }
            return this.state.tag = null, this.trigger("add", g({}, {
                tag: e
            }, {
                data: t1
            })), e;
        },
        appendTag (t1) {
            var e = this.DOM, i = e.input;
            e.scope.insertBefore(t1, i);
        },
        createTagElem (t1, i) {
            t1.__tagId = m();
            var s, a = g({}, t1, e({
                value: d(t1.value + "")
            }, i));
            return function(t1) {
                for(var e, i = document.createNodeIterator(t1, NodeFilter.SHOW_TEXT, null, !1); e = i.nextNode();)e.textContent.trim() || e.parentNode.removeChild(e);
            }(s = this.parseTemplate("tag", [
                a,
                this
            ])), T(s, t1), s;
        },
        reCheckInvalidTags () {
            var t1 = this.settings;
            this.getTagElms(t1.classNames.tagNotAllowed).forEach((e, i)=>{
                var s = T(e), a = this.hasMaxTags(), n = this.validateTag(s), o = !0 === n && !a;
                if ("select" == t1.mode && this.toggleScopeValidation(n), o) return s = s.__preInvalidData ? s.__preInvalidData : {
                    value: s.value
                }, this.replaceTag(e, s);
                e.title = a || n;
            });
        },
        removeTags (t1, e, i) {
            var s, a = this.settings;
            if (t1 = t1 && t1 instanceof HTMLElement ? [
                t1
            ] : t1 instanceof Array ? t1 : t1 ? [
                t1
            ] : [
                this.getLastTag()
            ], s = t1.reduce((t1, e)=>{
                e && "string" == typeof e && (e = this.getTagElmByValue(e));
                var i = T(e);
                return e && i && !i.readonly && t1.push({
                    node: e,
                    idx: this.getTagIdx(i),
                    data: T(e, {
                        __removed: !0
                    })
                }), t1;
            }, []), i = "number" == typeof i ? i : this.CSSVars.tagHideTransition, "select" == a.mode && (i = 0, this.input.set.call(this)), 1 == s.length && "select" != a.mode && s[0].node.classList.contains(a.classNames.tagNotAllowed) && (e = !0), s.length) return a.hooks.beforeRemoveTag(s, {
                tagify: this
            }).then(()=>{
                function t1(t1) {
                    t1.node.parentNode && (t1.node.parentNode.removeChild(t1.node), e ? a.keepInvalidTags && this.trigger("remove", {
                        tag: t1.node,
                        index: t1.idx
                    }) : (this.trigger("remove", {
                        tag: t1.node,
                        index: t1.idx,
                        data: t1.data
                    }), this.dropdown.refilter(), this.dropdown.position(), this.DOM.input.normalize(), a.keepInvalidTags && this.reCheckInvalidTags()));
                }
                i && i > 10 && 1 == s.length ? (function(e) {
                    e.node.style.width = parseFloat(window.getComputedStyle(e.node).width) + "px", document.body.clientTop, e.node.classList.add(a.classNames.tagHide), setTimeout(t1.bind(this), i, e);
                }).call(this, s[0]) : s.forEach(t1.bind(this)), e || (this.removeTagsFromValue(s.map((t1)=>t1.node)), this.update(), "select" == a.mode && this.setContentEditable(!0));
            }).catch((t1)=>{});
        },
        removeTagsFromDOM () {
            [].slice.call(this.getTagElms()).forEach((t1)=>t1.parentNode.removeChild(t1));
        },
        removeTagsFromValue (t1) {
            (t1 = Array.isArray(t1) ? t1 : [
                t1
            ]).forEach((t1)=>{
                var e = T(t1), i = this.getTagIdx(e);
                i > -1 && this.value.splice(i, 1);
            });
        },
        removeAllTags (t1) {
            t1 = t1 || {}, this.value = [], "mix" == this.settings.mode ? this.DOM.input.innerHTML = "" : this.removeTagsFromDOM(), this.dropdown.refilter(), this.dropdown.position(), this.state.dropdown.visible && setTimeout(()=>{
                this.DOM.input.focus();
            }), "select" == this.settings.mode && (this.input.set.call(this), this.setContentEditable(!0)), this.update(t1);
        },
        postUpdate () {
            this.state.blockChangeEvent = !1;
            var t1 = this.settings, e = t1.classNames, i = "mix" == t1.mode ? t1.mixMode.integrated ? this.DOM.input.textContent : this.DOM.originalInput.value.trim() : this.value.length + this.input.raw.call(this).length;
            this.toggleClass(e.hasMaxTags, this.value.length >= t1.maxTags), this.toggleClass(e.hasNoTags, !this.value.length), this.toggleClass(e.empty, !i), "select" == t1.mode && this.toggleScopeValidation(this.value?.[0]?.__isValid);
        },
        setOriginalInputValue (t1) {
            var e = this.DOM.originalInput;
            this.settings.mixMode.integrated || (e.value = t1, e.tagifyValue = e.value, this.setPersistedData(t1, "value"));
        },
        update (t1) {
            clearTimeout(this.debouncedUpdateTimeout), this.debouncedUpdateTimeout = setTimeout((function() {
                var e = this.getInputValue();
                this.setOriginalInputValue(e), this.settings.onChangeAfterBlur && (t1 || {}).withoutChangeEvent || this.state.blockChangeEvent || this.triggerChangeEvent();
                this.postUpdate();
            }).bind(this), 100);
        },
        getInputValue () {
            var t1 = this.getCleanValue();
            return "mix" == this.settings.mode ? this.getMixedTagsAsString(t1) : t1.length ? this.settings.originalInputValueFormat ? this.settings.originalInputValueFormat(t1) : JSON.stringify(t1) : "";
        },
        getCleanValue (t1) {
            return a(t1 || this.value, this.dataProps);
        },
        getMixedTagsAsString () {
            var t1 = "", e = this, i = this.settings, s = i.originalInputValueFormat || JSON.stringify, a = i.mixTagsInterpolator;
            return function i(o) {
                o.childNodes.forEach((o)=>{
                    if (1 == o.nodeType) {
                        const r = T(o);
                        if ("BR" == o.tagName && (t1 += "\r\n"), r && v.call(e, o)) {
                            if (r.__removed) return;
                            t1 += a[0] + s(n(r, e.dataProps)) + a[1];
                        } else o.getAttribute("style") || [
                            "B",
                            "I",
                            "U"
                        ].includes(o.tagName) ? t1 += o.textContent : "DIV" != o.tagName && "P" != o.tagName || (t1 += "\r\n", i(o));
                    } else t1 += o.textContent;
                });
            }(this.DOM.input), t1;
        }
    }, N.prototype.removeTag = N.prototype.removeTags, N;
});

},{}],"8D1jy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_2 = {
    class: "card"
};
const _hoisted_3 = {
    key: 0,
    class: "card-body"
};
const _hoisted_4 = {
    class: "row mb-3"
};
const _hoisted_5 = {
    class: "col-sm-4"
};
const _hoisted_6 = {
    class: "col-sm-4"
};
const _hoisted_7 = {
    for: "fare-config-platform-fee",
    class: "form-label"
};
const _hoisted_8 = {
    class: "input-group"
};
const _hoisted_9 = {
    class: "col-sm-4"
};
const _hoisted_10 = {
    for: "fare-config-platform-fee-per-km",
    class: "form-label"
};
const _hoisted_11 = {
    class: "input-group"
};
const _hoisted_12 = {
    key: 0,
    class: "d-block text-warning"
};
const _hoisted_13 = {
    class: "row mb-3"
};
const _hoisted_14 = {
    class: "col-sm-4"
};
const _hoisted_15 = {
    for: "fare-config-platform-fee-minimum",
    class: "form-label"
};
const _hoisted_16 = {
    class: "input-group"
};
const _hoisted_17 = {
    class: "col-sm-4"
};
const _hoisted_18 = {
    for: "fare-config-platform-fee-maximum",
    class: "form-label"
};
const _hoisted_19 = {
    class: "input-group"
};
const _hoisted_20 = {
    class: "row mb-4"
};
const _hoisted_21 = {
    class: "col-sm-4"
};
const _hoisted_22 = {
    for: "fare-config-scheduled-ride-fee",
    class: "form-label"
};
const _hoisted_23 = {
    class: "input-group"
};
const _hoisted_24 = {
    class: "col-sm-4"
};
const _hoisted_25 = {
    for: "fare-config-per-minute-fare",
    class: "form-label"
};
const _hoisted_26 = {
    class: "input-group"
};
const _hoisted_27 = {
    class: "col-sm-4"
};
const _hoisted_28 = {
    for: "fare-config-minimum-fare",
    class: "form-label"
};
const _hoisted_29 = {
    class: "input-group"
};
const _hoisted_30 = {
    class: "form-check form-switch mt-2"
};
const _hoisted_31 = {
    class: "accordion-bodies-container mt-4",
    id: "accordion-bodies-container"
};
const _hoisted_32 = {
    class: "accordion-collapse collapse",
    id: "ride-stop-config-collapse",
    "aria-labelledby": "rideStopConfigHeader",
    "data-bs-parent": "#accordion-bodies-container"
};
const _hoisted_33 = {
    class: "accordion-body"
};
const _hoisted_34 = {
    class: "row"
};
const _hoisted_35 = {
    class: "col-md-4 mb-3"
};
const _hoisted_36 = {
    for: "fare-config-per-stop-charge",
    class: "form-label"
};
const _hoisted_37 = {
    class: "input-group"
};
const _hoisted_38 = {
    class: "col-md-4 mb-3"
};
const _hoisted_39 = {
    class: "col-md-4 mb-3"
};
const _hoisted_40 = {
    for: "fare-config-per-minute-charge",
    class: "form-label"
};
const _hoisted_41 = {
    class: "input-group"
};
const _hoisted_42 = {
    class: "mt-4"
};
const _hoisted_43 = {
    class: "row"
};
const _hoisted_44 = {
    class: "col-md-4 mb-3"
};
const _hoisted_45 = {
    for: "fare-config-per-additional-passenger-charge",
    class: "form-label"
};
const _hoisted_46 = {
    class: "input-group"
};
const _hoisted_47 = {
    class: "col-md-4 mb-3"
};
const _hoisted_48 = {
    for: "fare-config-additional-passenger-max-charge",
    class: "form-label"
};
const _hoisted_49 = {
    class: "input-group"
};
const _hoisted_50 = {
    class: "col-md-4 mb-3"
};
const _hoisted_51 = {
    class: "accordion-collapse collapse",
    id: "base-prices-collapse",
    "aria-labelledby": "basePricesHeader",
    "data-bs-parent": "#accordion-bodies-container"
};
const _hoisted_52 = {
    class: "accordion-body"
};
const _hoisted_53 = {
    class: "col-sm-3 d-md-block mb-4"
};
const _hoisted_54 = {
    class: "accordion-collapse collapse",
    id: "distance-ranges-collapse",
    "aria-labelledby": "distancePricingsHeader",
    "data-bs-parent": "#accordion-bodies-container"
};
const _hoisted_55 = {
    class: "accordion-body"
};
const _hoisted_56 = {
    class: "col-sm-3 d-md-block mb-4"
};
const _hoisted_57 = {
    class: "accordion-collapse collapse",
    id: "geo-zones-collapse",
    "aria-labelledby": "geoZonesPricingHeader",
    "data-bs-parent": "#accordion-bodies-container"
};
const _hoisted_58 = {
    class: "accordion-body"
};
const _hoisted_59 = {
    class: "col-sm-3 d-md-block mb-4"
};
const _hoisted_60 = {
    class: "modal fade show",
    id: "createBasePricingModal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "createBasePricingModal",
    "aria-modal": "true",
    style: {
        "display": "none"
    }
};
const _hoisted_61 = {
    class: "modal-dialog modal-dialog-centered modal-xl",
    role: "document"
};
const _hoisted_62 = {
    class: "modal-content"
};
const _hoisted_63 = {
    class: "modal-header"
};
const _hoisted_64 = {
    class: "modal-title fs-5"
};
const _hoisted_65 = {
    key: 0,
    class: "modal-body"
};
const _hoisted_66 = {
    class: "mb-3"
};
const _hoisted_67 = {
    class: "row mb-3"
};
const _hoisted_68 = {
    class: "col-md-4"
};
const _hoisted_69 = {
    class: "input-group"
};
const _hoisted_70 = {
    class: "modal-footer"
};
const _hoisted_71 = {
    class: "modal fade show",
    id: "distancePricingModal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "distancePricingModal",
    "aria-modal": "true",
    style: {
        "display": "none"
    }
};
const _hoisted_72 = {
    class: "modal-dialog modal-dialog-centered modal-xl",
    role: "document"
};
const _hoisted_73 = {
    class: "modal-content"
};
const _hoisted_74 = {
    class: "modal-header"
};
const _hoisted_75 = {
    class: "modal-title fs-5"
};
const _hoisted_76 = {
    key: 0,
    class: "modal-body"
};
const _hoisted_77 = {
    class: "row mb-3"
};
const _hoisted_78 = {
    class: "col-md-6"
};
const _hoisted_79 = [
    "disabled"
];
const _hoisted_80 = {
    class: "text-muted"
};
const _hoisted_81 = {
    class: "col-md-6"
};
const _hoisted_82 = [
    "disabled"
];
const _hoisted_83 = {
    class: "text-muted"
};
const _hoisted_84 = {
    class: "row mb-3"
};
const _hoisted_85 = {
    class: "col-md-6"
};
const _hoisted_86 = {
    class: "form-check"
};
const _hoisted_87 = {
    class: "col-md-6"
};
const _hoisted_88 = {
    class: "form-check"
};
const _hoisted_89 = {
    class: "row mb-3"
};
const _hoisted_90 = {
    class: "col-md-6"
};
const _hoisted_91 = {
    class: "col-md-6"
};
const _hoisted_92 = {
    class: "input-group"
};
const _hoisted_93 = {
    class: "modal-footer"
};
const _hoisted_94 = {
    class: "modal fade show",
    id: "geoZoneModal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "geoZoneModal",
    "aria-modal": "true",
    style: {
        "display": "none"
    }
};
const _hoisted_95 = {
    class: "modal-dialog modal-dialog-centered modal-xl",
    role: "document"
};
const _hoisted_96 = {
    class: "modal-content"
};
const _hoisted_97 = {
    class: "modal-header"
};
const _hoisted_98 = {
    class: "modal-title fs-5"
};
const _hoisted_99 = {
    key: 0,
    class: "modal-body"
};
const _hoisted_100 = {
    class: "mb-3"
};
const _hoisted_101 = {
    class: "d-block"
};
const _hoisted_102 = {
    class: "form-control",
    name: "geoZone",
    placeholder: "Search geo zone",
    ref: "tagifyGeoZoneRef"
};
const _hoisted_103 = {
    class: "mb-3"
};
const _hoisted_104 = {
    class: "mb-3"
};
const _hoisted_105 = {
    class: "row mb-3"
};
const _hoisted_106 = {
    key: 0,
    class: "col-md-6"
};
const _hoisted_107 = {
    for: "surcharge",
    class: "form-label"
};
const _hoisted_108 = {
    class: "input-group"
};
const _hoisted_109 = {
    key: 1,
    class: "col-md-6"
};
const _hoisted_110 = {
    class: "input-group"
};
const _hoisted_111 = {
    key: 2,
    class: "col-md-6"
};
const _hoisted_112 = {
    for: "flatFare",
    class: "form-label"
};
const _hoisted_113 = {
    class: "input-group"
};
const _hoisted_114 = {
    key: 3,
    class: "col-md-6"
};
const _hoisted_115 = {
    for: "zonePerKmRate",
    class: "form-label"
};
const _hoisted_116 = {
    class: "input-group"
};
const _hoisted_117 = {
    class: "col-md-6"
};
const _hoisted_118 = {
    for: "fareMaximum",
    class: "form-label"
};
const _hoisted_119 = {
    class: "input-group"
};
const _hoisted_120 = {
    class: "row mb-3"
};
const _hoisted_121 = {
    class: "col-md-6"
};
const _hoisted_122 = {
    class: "row mb-3"
};
const _hoisted_123 = {
    class: "col-md-6"
};
const _hoisted_124 = {
    for: "fareMinimum",
    class: "form-label"
};
const _hoisted_125 = {
    class: "input-group"
};
const _hoisted_126 = {
    class: "col-md-6"
};
const _hoisted_127 = {
    class: "row mb-3"
};
const _hoisted_128 = {
    class: "col-md-6"
};
const _hoisted_129 = {
    for: "zonePlatformFee",
    class: "form-label"
};
const _hoisted_130 = {
    class: "input-group"
};
const _hoisted_131 = {
    class: "col-md-6"
};
const _hoisted_132 = {
    for: "zonePlatformFeePerKm",
    class: "form-label"
};
const _hoisted_133 = {
    class: "input-group"
};
const _hoisted_134 = {
    class: "modal-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                _cache[83] || (_cache[83] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h5", null, " Fare Configuration ")
                ], -1)),
                $setup.fareConfig.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                    (0, _vue.createElementVNode)("div", {
                        class: "row mb-3"
                    }, [
                        (0, _vue.createElementVNode)("div", {
                            class: "col-sm-4 d-flex align-items-end"
                        }, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary pull-right",
                                onClick: $setup.saveConfiguration
                            }, " Save Configuration ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_4, [
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, "Currency:", -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.fareConfig.state.currency = $event),
                                class: "form-select"
                            }, _cache[38] || (_cache[38] = [
                                (0, _vue.createElementVNode)("option", {
                                    value: "CAD"
                                }, "CAD", -1)
                            ]), 512), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.fareConfig.state.currency
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            (0, _vue.createElementVNode)("label", _hoisted_7, "Platform Fee (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_8, [
                                _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-platform-fee",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.fareConfig.state.platformFee = $event),
                                    min: "0",
                                    step: "0.01",
                                    required: ""
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.platformFee
                                    ]
                                ])
                            ]),
                            _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Flat part of the fee charged per ride (excluded from driver payout)", -1)),
                            _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-platform-fee-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid platform fee (0 or more). ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_9, [
                            (0, _vue.createElementVNode)("label", _hoisted_10, "Platform Fee Per Km (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_11, [
                                _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-platform-fee-per-km",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.fareConfig.state.platformFeePerKm = $event),
                                    min: "0",
                                    step: "0.01"
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.platformFeePerKm
                                    ]
                                ])
                            ]),
                            _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Distance-scaled part of the fee, charged on the ride's own distance", -1)),
                            $setup.fareConfig.isPlatformFeePerKmBelowFloor() ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_12, " Below the $" + (0, _vue.toDisplayString)($setup.platformFeePerKmFloor.toFixed(2)) + "/km floor \u2014 margin shrinks as trips get longer. Move the fare, not the fee. ", 1)) : (0, _vue.createCommentVNode)("", true),
                            _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-platform-fee-per-km-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid per-km platform fee (0 or more). ", -1))
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                        (0, _vue.createElementVNode)("div", _hoisted_14, [
                            (0, _vue.createElementVNode)("label", _hoisted_15, "Platform Fee Minimum (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_16, [
                                _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-platform-fee-minimum",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.fareConfig.state.platformFeeMinimum = $event),
                                    min: "0",
                                    step: "0.01"
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.platformFeeMinimum
                                    ]
                                ])
                            ]),
                            _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Floor on the whole fee, flat plus per-km (0 = no floor)", -1)),
                            _cache[48] || (_cache[48] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-platform-fee-minimum-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid platform fee minimum (0 or more). ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_17, [
                            (0, _vue.createElementVNode)("label", _hoisted_18, "Platform Fee Maximum (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_19, [
                                _cache[49] || (_cache[49] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-platform-fee-maximum",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.fareConfig.state.platformFeeMaximum = $event),
                                    min: "0",
                                    step: "0.01"
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.platformFeeMaximum
                                    ]
                                ])
                            ]),
                            _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Cap on the whole fee (blank or 0 = uncapped)", -1)),
                            _cache[51] || (_cache[51] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-platform-fee-maximum-error",
                                class: "invalid-feedback d-none"
                            }, " Platform fee maximum must be 0 or more, and cannot be below the minimum. ", -1))
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_20, [
                        (0, _vue.createElementVNode)("div", _hoisted_21, [
                            (0, _vue.createElementVNode)("label", _hoisted_22, "Scheduled Ride Fee (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_23, [
                                _cache[52] || (_cache[52] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-scheduled-ride-fee",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.fareConfig.state.scheduledRideFee = $event),
                                    min: "0",
                                    step: "0.01",
                                    required: ""
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.scheduledRideFee
                                    ]
                                ])
                            ]),
                            _cache[53] || (_cache[53] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Additional fee applied to pre-scheduled bookings", -1)),
                            _cache[54] || (_cache[54] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-scheduled-ride-fee-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid scheduled ride fee (0 or more). ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_24, [
                            (0, _vue.createElementVNode)("label", _hoisted_25, "Per Minute Fare (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_26, [
                                _cache[55] || (_cache[55] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-per-minute-fare",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.fareConfig.state.perMinuteFare = $event),
                                    min: "0",
                                    step: "0.01",
                                    required: ""
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.perMinuteFare
                                    ]
                                ])
                            ]),
                            _cache[56] || (_cache[56] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Fare charged per minute of ride duration", -1)),
                            _cache[57] || (_cache[57] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-per-minute-fare-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid per-minute fare (0 or more). ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_27, [
                            (0, _vue.createElementVNode)("label", _hoisted_28, "Minimum Fare (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                            (0, _vue.createElementVNode)("div", _hoisted_29, [
                                _cache[58] || (_cache[58] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "fare-config-minimum-fare",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.fareConfig.state.minimumFare = $event),
                                    min: "0",
                                    step: "0.01"
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.fareConfig.state.minimumFare
                                    ]
                                ])
                            ]),
                            _cache[60] || (_cache[60] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Lowest fare charged per ride (0 = no minimum)", -1)),
                            _cache[61] || (_cache[61] = (0, _vue.createElementVNode)("div", {
                                id: "fare-config-minimum-fare-error",
                                class: "invalid-feedback d-none"
                            }, " Please enter a valid minimum fare (0 or more). ", -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_30, [
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    role: "switch",
                                    id: "fare-config-minimum-applies-to-fare-only",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.fareConfig.state.minimumAppliesToFareOnly = $event)
                                }, null, 512), [
                                    [
                                        (0, _vue.vModelCheckbox),
                                        $setup.fareConfig.state.minimumAppliesToFareOnly
                                    ]
                                ]),
                                _cache[59] || (_cache[59] = (0, _vue.createElementVNode)("label", {
                                    class: "form-check-label",
                                    for: "fare-config-minimum-applies-to-fare-only"
                                }, " Minimum applies to the fare only ", -1))
                            ]),
                            _cache[62] || (_cache[62] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted d-block"
                            }, "On: a floored ride is charged the minimum plus the platform fee, and the driver's floor is the whole minimum. Off: the minimum is the all-in total charged and the platform fee comes out of it.", -1))
                        ])
                    ]),
                    _cache[82] || (_cache[82] = (0, _vue.createStaticVNode)("<div class=\"accordion dark-accordion\" id=\"outlineaccordion\"><div class=\"accordion-item accordion-wrapper accordion-left-border\"><h2 class=\"accordion-header\" id=\"rideStopConfigHeader\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#ride-stop-config-collapse\" aria-expanded=\"false\" aria-controls=\"ride-stop-config-collapse\"><span><i class=\"fa-solid fa-clock\"></i> Ride Stop Config </span><i class=\"iconly-Arrow-Down-2 icli ms-auto icon\"></i></button></h2></div><div class=\"accordion-item accordion-wrapper accordion-left-border\"><h2 class=\"accordion-header\" id=\"basePricesHeader\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#base-prices-collapse\" aria-expanded=\"false\" aria-controls=\"base-prices-collapse\"><span><i class=\"fa-solid fa-dollar-sign\"></i> Vehicle Base Fare Configurations </span><i class=\"iconly-Arrow-Down-2 icli ms-auto icon\"></i></button></h2></div><div class=\"accordion-item accordion-wrapper accordion-left-border\"><h2 class=\"accordion-header\" id=\"distancePricingsHeader\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#distance-ranges-collapse\" aria-expanded=\"false\" aria-controls=\"distance-ranges-collapse\"><span><i class=\"fa-solid fa-ruler-horizontal\"></i> Distance Fare Configurations </span><i class=\"iconly-Arrow-Down-2 icli ms-auto icon\"></i></button></h2></div><div class=\"accordion-item accordion-wrapper accordion-left-border\"><h2 class=\"accordion-header\" id=\"geoZonesPricingHeader\"><button class=\"accordion-button collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#geo-zones-collapse\" aria-expanded=\"false\" aria-controls=\"geo-zones-collapse\"><span><i class=\"fa-solid fa-map\"></i> Geographic Zones Fare Configurations </span><i class=\"iconly-Arrow-Down-2 icli ms-auto icon\"></i></button></h2></div></div>", 1)),
                    (0, _vue.createElementVNode)("div", _hoisted_31, [
                        (0, _vue.createElementVNode)("div", _hoisted_32, [
                            (0, _vue.createElementVNode)("div", _hoisted_33, [
                                (0, _vue.createElementVNode)("div", _hoisted_34, [
                                    (0, _vue.createElementVNode)("div", _hoisted_35, [
                                        (0, _vue.createElementVNode)("label", _hoisted_36, "Per Stop Charge (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                        (0, _vue.createElementVNode)("div", _hoisted_37, [
                                            _cache[63] || (_cache[63] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "$", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "fare-config-per-stop-charge",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.fareConfig.state.perStopCharge = $event),
                                                min: "0",
                                                step: "0.01",
                                                required: ""
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.fareConfig.state.perStopCharge
                                                ]
                                            ])
                                        ]),
                                        _cache[64] || (_cache[64] = (0, _vue.createElementVNode)("div", {
                                            id: "fare-config-per-stop-charge-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a valid per stop charge (0 or more). ", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_38, [
                                        _cache[65] || (_cache[65] = (0, _vue.createElementVNode)("label", {
                                            for: "fare-config-free-waiting-minutes",
                                            class: "form-label"
                                        }, "Free Waiting Minutes", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "fare-config-free-waiting-minutes",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.fareConfig.state.freeStopWaitingMinutes = $event),
                                            min: "0",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.fareConfig.state.freeStopWaitingMinutes
                                            ]
                                        ]),
                                        _cache[66] || (_cache[66] = (0, _vue.createElementVNode)("div", {
                                            id: "fare-config-free-waiting-minutes-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a valid number of free waiting minutes (0 or more). ", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_39, [
                                        (0, _vue.createElementVNode)("label", _hoisted_40, "Per Minute Charge (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                        (0, _vue.createElementVNode)("div", _hoisted_41, [
                                            _cache[67] || (_cache[67] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "$", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "fare-config-per-minute-charge",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.fareConfig.state.stopPerMinuteCharge = $event),
                                                min: "0",
                                                step: "0.01",
                                                required: ""
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.fareConfig.state.stopPerMinuteCharge
                                                ]
                                            ])
                                        ]),
                                        _cache[68] || (_cache[68] = (0, _vue.createElementVNode)("div", {
                                            id: "fare-config-per-minute-charge-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a valid per minute charge (0 or more). ", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_42, [
                                    _cache[78] || (_cache[78] = (0, _vue.createElementVNode)("h6", {
                                        class: "mb-3"
                                    }, "Per Passenger Pricing", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                                        (0, _vue.createElementVNode)("div", _hoisted_44, [
                                            (0, _vue.createElementVNode)("label", _hoisted_45, " Per Additional Passenger (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ") ", 1),
                                            (0, _vue.createElementVNode)("div", _hoisted_46, [
                                                _cache[69] || (_cache[69] = (0, _vue.createElementVNode)("span", {
                                                    class: "input-group-text"
                                                }, "$", -1)),
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "fare-config-per-additional-passenger-charge",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.fareConfig.state.perAdditionalPassengerCharge = $event),
                                                    min: "0",
                                                    step: "0.01"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelText),
                                                        $setup.fareConfig.state.perAdditionalPassengerCharge
                                                    ]
                                                ])
                                            ]),
                                            _cache[70] || (_cache[70] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Surcharge per eligible passenger (0 = disabled)", -1)),
                                            _cache[71] || (_cache[71] = (0, _vue.createElementVNode)("div", {
                                                id: "fare-config-per-additional-passenger-charge-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter a valid charge (0 or more). ", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_47, [
                                            (0, _vue.createElementVNode)("label", _hoisted_48, " Max Passenger Charge (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ") ", 1),
                                            (0, _vue.createElementVNode)("div", _hoisted_49, [
                                                _cache[72] || (_cache[72] = (0, _vue.createElementVNode)("span", {
                                                    class: "input-group-text"
                                                }, "$", -1)),
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "fare-config-additional-passenger-max-charge",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.fareConfig.state.additionalPassengerMaxCharge = $event),
                                                    min: "0",
                                                    step: "0.01"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelText),
                                                        $setup.fareConfig.state.additionalPassengerMaxCharge
                                                    ]
                                                ])
                                            ]),
                                            _cache[73] || (_cache[73] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Maximum total passenger surcharge (0 = uncapped)", -1)),
                                            _cache[74] || (_cache[74] = (0, _vue.createElementVNode)("div", {
                                                id: "fare-config-additional-passenger-max-charge-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter a valid max charge (0 or more). ", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_50, [
                                            _cache[75] || (_cache[75] = (0, _vue.createElementVNode)("label", {
                                                for: "fare-config-additional-passenger-free-under-age",
                                                class: "form-label"
                                            }, " Free Under Age ", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "fare-config-additional-passenger-free-under-age",
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$setup.fareConfig.state.additionalPassengerFreeUnderAge = $event),
                                                min: "0",
                                                step: "1",
                                                placeholder: "e.g. 12"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.fareConfig.state.additionalPassengerFreeUnderAge
                                                ]
                                            ]),
                                            _cache[76] || (_cache[76] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Passengers under this age are exempt (leave blank to charge all)", -1)),
                                            _cache[77] || (_cache[77] = (0, _vue.createElementVNode)("div", {
                                                id: "fare-config-additional-passenger-free-under-age-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter a valid whole number age (0 or more). ", -1))
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_51, [
                            (0, _vue.createElementVNode)("div", _hoisted_52, [
                                (0, _vue.createElementVNode)("div", _hoisted_53, [
                                    (0, _vue.createElementVNode)("a", {
                                        class: "btn btn-outline-primary align-items-center",
                                        onClick: _cache[15] || (_cache[15] = ($event)=>$setup.toggleCreateBasePriceModal(false)),
                                        type: "button"
                                    }, _cache[79] || (_cache[79] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa-regular fa-square-plus"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Add Vehicle Base Fare Config ")
                                    ]))
                                ]),
                                (0, _vue.createVNode)($setup["DataTable"], {
                                    data: $setup.fareConfig.state.vehicleBaseFareConfigs,
                                    columns: $setup.basePricesColumns,
                                    class: "table-responsive display"
                                }, null, 8, [
                                    "data"
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_54, [
                            (0, _vue.createElementVNode)("div", _hoisted_55, [
                                (0, _vue.createElementVNode)("div", _hoisted_56, [
                                    (0, _vue.createElementVNode)("a", {
                                        class: "btn btn-outline-primary align-items-center",
                                        onClick: _cache[16] || (_cache[16] = ($event)=>$setup.toggleDistancePricingModal(false)),
                                        type: "button"
                                    }, _cache[80] || (_cache[80] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa-regular fa-square-plus"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Add Distance Fare Config ")
                                    ]))
                                ]),
                                (0, _vue.createVNode)($setup["DataTable"], {
                                    data: $setup.fareConfig.state.distanceFareConfigs,
                                    columns: $setup.distancePricingsColumns,
                                    class: "table-responsive display"
                                }, null, 8, [
                                    "data"
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_57, [
                            (0, _vue.createElementVNode)("div", _hoisted_58, [
                                (0, _vue.createElementVNode)("div", _hoisted_59, [
                                    (0, _vue.createElementVNode)("a", {
                                        class: "btn btn-outline-primary align-items-center",
                                        onClick: _cache[17] || (_cache[17] = ($event)=>$setup.toggleGeoZoneModal(false)),
                                        type: "button"
                                    }, _cache[81] || (_cache[81] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa-regular fa-square-plus"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Add Geo Zone Fare Config ")
                                    ]))
                                ]),
                                (0, _vue.createVNode)($setup["DataTable"], {
                                    data: $setup.fareConfig.state.geoZoneFareConfigs,
                                    columns: $setup.geoZonesPricingColumns,
                                    class: "table-responsive table-border-horizontal display"
                                }, null, 8, [
                                    "data"
                                ])
                            ])
                        ])
                    ])
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_60, [
            (0, _vue.createElementVNode)("div", _hoisted_61, [
                (0, _vue.createElementVNode)("div", _hoisted_62, [
                    (0, _vue.createElementVNode)("div", _hoisted_63, [
                        (0, _vue.createElementVNode)("h3", _hoisted_64, (0, _vue.toDisplayString)($setup.basePriceModalEditMode ? 'Edit' : 'Add') + " Base Price", 1),
                        _cache[84] || (_cache[84] = (0, _vue.createElementVNode)("button", {
                            class: "btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    $setup.showBasePriceModal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_65, [
                        (0, _vue.createElementVNode)("form", null, [
                            (0, _vue.createElementVNode)("div", _hoisted_66, [
                                _cache[86] || (_cache[86] = (0, _vue.createElementVNode)("label", {
                                    for: "vehicleType",
                                    class: "form-label"
                                }, "Vehicle Type", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                    id: "vehicleType",
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event)=>$setup.currentBasePrice.vehicleType = $event),
                                    required: ""
                                }, _cache[85] || (_cache[85] = [
                                    (0, _vue.createStaticVNode)("<option value=\"\">Select Vehicle Type</option><option value=\"ALL\">All</option><option value=\"SEDAN\">Sedan</option><option value=\"SUV\">SUV</option><option value=\"MINIVAN\">Minivan</option>", 5)
                                ]), 512), [
                                    [
                                        (0, _vue.vModelSelect),
                                        $setup.currentBasePrice.vehicleType
                                    ]
                                ]),
                                _cache[87] || (_cache[87] = (0, _vue.createElementVNode)("div", {
                                    class: "invalid-feedback"
                                }, "Please select a vehicle type.", -1))
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_67, [
                                (0, _vue.createElementVNode)("div", _hoisted_68, [
                                    _cache[89] || (_cache[89] = (0, _vue.createElementVNode)("label", {
                                        for: "baseFare",
                                        class: "form-label"
                                    }, "Base Fare", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_69, [
                                        _cache[88] || (_cache[88] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "baseFare",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event)=>$setup.currentBasePrice.baseFare = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentBasePrice.baseFare
                                            ]
                                        ])
                                    ]),
                                    _cache[90] || (_cache[90] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid base fare.", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createElementVNode)("div", _hoisted_70, [
                        _cache[91] || (_cache[91] = (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            type: "button",
                            "data-bs-dismiss": "modal"
                        }, "Close", -1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: $setup.saveBasePrice
                        }, (0, _vue.toDisplayString)($setup.basePriceModalEditMode ? 'Update' : 'Add'), 1)
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_71, [
            (0, _vue.createElementVNode)("div", _hoisted_72, [
                (0, _vue.createElementVNode)("div", _hoisted_73, [
                    (0, _vue.createElementVNode)("div", _hoisted_74, [
                        (0, _vue.createElementVNode)("h3", _hoisted_75, (0, _vue.toDisplayString)($setup.distancePricingModalEditMode ? 'Update' : 'Add') + " Distance Range", 1),
                        _cache[92] || (_cache[92] = (0, _vue.createElementVNode)("button", {
                            class: "btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    $setup.showDistancePricingModal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_76, [
                        (0, _vue.createElementVNode)("form", null, [
                            (0, _vue.createElementVNode)("div", _hoisted_77, [
                                (0, _vue.createElementVNode)("div", _hoisted_78, [
                                    _cache[93] || (_cache[93] = (0, _vue.createElementVNode)("label", {
                                        for: "startDistanceMeters",
                                        class: "form-label"
                                    }, "Start Distance (meters)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "startDistanceMeters",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event)=>$setup.currentDistancePricing.startDistanceMeters = $event),
                                        min: "0",
                                        required: "",
                                        disabled: $setup.currentDistancePricing.isStartingRange
                                    }, null, 8, _hoisted_79), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.currentDistancePricing.startDistanceMeters
                                        ]
                                    ]),
                                    (0, _vue.createElementVNode)("small", _hoisted_80, (0, _vue.toDisplayString)(($setup.currentDistancePricing.startDistanceMeters / 1000).toFixed(2)) + " km", 1),
                                    _cache[94] || (_cache[94] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid start distance.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_81, [
                                    _cache[95] || (_cache[95] = (0, _vue.createElementVNode)("label", {
                                        for: "endDistanceMeters",
                                        class: "form-label"
                                    }, "End Distance (meters)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "endDistanceMeters",
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event)=>$setup.currentDistancePricing.endDistanceMeters = $event),
                                        min: "0",
                                        required: "",
                                        disabled: $setup.currentDistancePricing.isOpenEnded
                                    }, null, 8, _hoisted_82), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.currentDistancePricing.endDistanceMeters
                                        ]
                                    ]),
                                    (0, _vue.createElementVNode)("small", _hoisted_83, (0, _vue.toDisplayString)(($setup.currentDistancePricing.endDistanceMeters / 1000).toFixed(2)) + " km", 1),
                                    _cache[96] || (_cache[96] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid end distance.", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_84, [
                                (0, _vue.createElementVNode)("div", _hoisted_85, [
                                    (0, _vue.createElementVNode)("div", _hoisted_86, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "isStartingRange",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event)=>$setup.currentDistancePricing.isStartingRange = $event)
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelCheckbox),
                                                $setup.currentDistancePricing.isStartingRange
                                            ]
                                        ]),
                                        _cache[97] || (_cache[97] = (0, _vue.createElementVNode)("label", {
                                            class: "form-check-label",
                                            for: "isStartingRange"
                                        }, " Starting Range (0 meters) ", -1))
                                    ]),
                                    _cache[98] || (_cache[98] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Mark this as the first distance range (starts at 0)", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_87, [
                                    (0, _vue.createElementVNode)("div", _hoisted_88, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "isOpenEnded",
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event)=>$setup.currentDistancePricing.isOpenEnded = $event)
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelCheckbox),
                                                $setup.currentDistancePricing.isOpenEnded
                                            ]
                                        ]),
                                        _cache[99] || (_cache[99] = (0, _vue.createElementVNode)("label", {
                                            class: "form-check-label",
                                            for: "isOpenEnded"
                                        }, " Open-Ended Range ", -1))
                                    ]),
                                    _cache[100] || (_cache[100] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Mark this as an open-ended range (no upper limit)", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_89, [
                                (0, _vue.createElementVNode)("div", _hoisted_90, [
                                    _cache[102] || (_cache[102] = (0, _vue.createElementVNode)("label", {
                                        for: "rateType",
                                        class: "form-label"
                                    }, "Rate Type", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                        id: "rateType",
                                        class: "form-select",
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event)=>$setup.currentDistancePricing.rateType = $event),
                                        required: ""
                                    }, _cache[101] || (_cache[101] = [
                                        (0, _vue.createElementVNode)("option", {
                                            value: ""
                                        }, "Select Rate Type", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "FLAT"
                                        }, "Flat", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "PER_METER"
                                        }, "Per Meter", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "PER_KILOMETER"
                                        }, "Per Kilometer", -1)
                                    ]), 512), [
                                        [
                                            (0, _vue.vModelSelect),
                                            $setup.currentDistancePricing.rateType
                                        ]
                                    ]),
                                    _cache[103] || (_cache[103] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please select a rate type.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_91, [
                                    _cache[105] || (_cache[105] = (0, _vue.createElementVNode)("label", {
                                        for: "rateAmount",
                                        class: "form-label"
                                    }, "Rate Amount", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_92, [
                                        _cache[104] || (_cache[104] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "rateAmount",
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event)=>$setup.currentDistancePricing.rateAmount = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentDistancePricing.rateAmount
                                            ]
                                        ])
                                    ]),
                                    _cache[106] || (_cache[106] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid rate amount.", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createElementVNode)("div", _hoisted_93, [
                        _cache[107] || (_cache[107] = (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            type: "button",
                            "data-bs-dismiss": "modal"
                        }, "Close", -1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: $setup.saveDistancePricing
                        }, (0, _vue.toDisplayString)($setup.distancePricingModalEditMode ? 'Update' : 'Add'), 1)
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_94, [
            (0, _vue.createElementVNode)("div", _hoisted_95, [
                (0, _vue.createElementVNode)("div", _hoisted_96, [
                    (0, _vue.createElementVNode)("div", _hoisted_97, [
                        (0, _vue.createElementVNode)("h3", _hoisted_98, (0, _vue.toDisplayString)($setup.geoZoneModalEditMode ? 'Update' : 'Add') + " Geo Zone Pricing", 1),
                        _cache[108] || (_cache[108] = (0, _vue.createElementVNode)("button", {
                            class: "btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    $setup.showGeoZoneModal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_99, [
                        (0, _vue.createElementVNode)("form", null, [
                            (0, _vue.createElementVNode)("div", _hoisted_100, [
                                _cache[109] || (_cache[109] = (0, _vue.createElementVNode)("label", {
                                    for: "geoZone",
                                    class: "form-label"
                                }, "Geo Zone", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_101, [
                                    (0, _vue.createElementVNode)("input", _hoisted_102, null, 512)
                                ]),
                                _cache[110] || (_cache[110] = (0, _vue.createElementVNode)("div", {
                                    class: "invalid-feedback"
                                }, "Please select a geo zone.", -1))
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_103, [
                                _cache[112] || (_cache[112] = (0, _vue.createElementVNode)("label", {
                                    for: "applicationType",
                                    class: "form-label"
                                }, "Application Type", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                    id: "applicationType",
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event)=>$setup.currentGeoZone.applicationType = $event),
                                    required: ""
                                }, _cache[111] || (_cache[111] = [
                                    (0, _vue.createStaticVNode)("<option value=\"\">Select Application Type</option><option value=\"PICKUP\">Pickup</option><option value=\"DROPOFF\">Dropoff</option><option value=\"BOTH\">Both</option><option value=\"CROSSING\">Crossing</option>", 5)
                                ]), 512), [
                                    [
                                        (0, _vue.vModelSelect),
                                        $setup.currentGeoZone.applicationType
                                    ]
                                ]),
                                _cache[113] || (_cache[113] = (0, _vue.createElementVNode)("div", {
                                    class: "invalid-feedback"
                                }, "Please select an application type.", -1))
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_104, [
                                _cache[115] || (_cache[115] = (0, _vue.createElementVNode)("label", {
                                    for: "zoneRateType",
                                    class: "form-label"
                                }, "Zone Rate Type", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                    id: "zoneRateType",
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event)=>$setup.currentGeoZone.zoneRateType = $event),
                                    required: ""
                                }, _cache[114] || (_cache[114] = [
                                    (0, _vue.createElementVNode)("option", {
                                        value: "SURCHARGE"
                                    }, "Fixed Surcharge \u2014 adds a flat amount to the fare", -1),
                                    (0, _vue.createElementVNode)("option", {
                                        value: "PERCENTAGE"
                                    }, "Percentage \u2014 adds a % of base + distance fare", -1),
                                    (0, _vue.createElementVNode)("option", {
                                        value: "FLAT_FARE"
                                    }, "Flat Fare \u2014 replaces the distance fare entirely", -1),
                                    (0, _vue.createElementVNode)("option", {
                                        value: "PER_KM"
                                    }, "Per KM \u2014 overrides the global per-km distance rate", -1)
                                ]), 512), [
                                    [
                                        (0, _vue.vModelSelect),
                                        $setup.currentGeoZone.zoneRateType
                                    ]
                                ]),
                                _cache[116] || (_cache[116] = (0, _vue.createElementVNode)("div", {
                                    class: "invalid-feedback"
                                }, "Please select a zone rate type.", -1))
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_105, [
                                $setup.currentGeoZone.zoneRateType === 'SURCHARGE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_106, [
                                    (0, _vue.createElementVNode)("label", _hoisted_107, "Surcharge (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_108, [
                                        _cache[117] || (_cache[117] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "surcharge",
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event)=>$setup.currentGeoZone.surcharge = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.surcharge
                                            ]
                                        ])
                                    ]),
                                    _cache[118] || (_cache[118] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Flat amount added to every matching ride", -1)),
                                    _cache[119] || (_cache[119] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid surcharge (0 or more).", -1))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.currentGeoZone.zoneRateType === 'PERCENTAGE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_109, [
                                    _cache[121] || (_cache[121] = (0, _vue.createElementVNode)("label", {
                                        for: "percentage",
                                        class: "form-label"
                                    }, "Percentage (%)", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_110, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "percentage",
                                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event)=>$setup.currentGeoZone.percentage = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.percentage
                                            ]
                                        ]),
                                        _cache[120] || (_cache[120] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "%", -1))
                                    ]),
                                    _cache[122] || (_cache[122] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Percentage of base + distance fare added to ride total", -1)),
                                    _cache[123] || (_cache[123] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid percentage (0 or more).", -1))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.currentGeoZone.zoneRateType === 'FLAT_FARE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_111, [
                                    (0, _vue.createElementVNode)("label", _hoisted_112, "Flat Fare (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_113, [
                                        _cache[124] || (_cache[124] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "flatFare",
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event)=>$setup.currentGeoZone.flatFare = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.flatFare
                                            ]
                                        ])
                                    ]),
                                    _cache[125] || (_cache[125] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Fixed fare that replaces the distance fare for this zone", -1)),
                                    _cache[126] || (_cache[126] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid flat fare (0 or more).", -1))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.currentGeoZone.zoneRateType === 'PER_KM' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_114, [
                                    (0, _vue.createElementVNode)("label", _hoisted_115, "Per KM Rate (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_116, [
                                        _cache[127] || (_cache[127] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "zonePerKmRate",
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event)=>$setup.currentGeoZone.zonePerKmRate = $event),
                                            min: "0",
                                            step: "0.01",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.zonePerKmRate
                                            ]
                                        ]),
                                        _cache[128] || (_cache[128] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "/km", -1))
                                    ]),
                                    _cache[129] || (_cache[129] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Per-km rate that overrides the global distance config for this zone", -1)),
                                    _cache[130] || (_cache[130] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid per-km rate (0 or more).", -1))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createElementVNode)("div", _hoisted_117, [
                                    (0, _vue.createElementVNode)("label", _hoisted_118, "Fare Maximum / Cap (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_119, [
                                        _cache[131] || (_cache[131] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "fareMaximum",
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event)=>$setup.currentGeoZone.fareMaximum = $event),
                                            min: "0",
                                            step: "0.01",
                                            placeholder: "Optional"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.fareMaximum
                                            ]
                                        ])
                                    ]),
                                    _cache[132] || (_cache[132] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Maximum total fare for rides in this zone (leave blank for no cap)", -1)),
                                    _cache[133] || (_cache[133] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid fare maximum (0 or more).", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_120, [
                                (0, _vue.createElementVNode)("div", _hoisted_121, [
                                    _cache[134] || (_cache[134] = (0, _vue.createElementVNode)("label", {
                                        for: "fareMaximumUpToMeters",
                                        class: "form-label"
                                    }, "Cap Applies Up To (meters)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "fareMaximumUpToMeters",
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event)=>$setup.currentGeoZone.fareMaximumUpToMeters = $event),
                                        min: "0",
                                        step: "1",
                                        placeholder: "Optional"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.currentGeoZone.fareMaximumUpToMeters
                                        ]
                                    ]),
                                    _cache[135] || (_cache[135] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Cap only applies for trips shorter than this distance (leave blank = always applies)", -1)),
                                    _cache[136] || (_cache[136] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid distance (0 or more).", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_122, [
                                (0, _vue.createElementVNode)("div", _hoisted_123, [
                                    (0, _vue.createElementVNode)("label", _hoisted_124, "Fare Minimum (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_125, [
                                        _cache[137] || (_cache[137] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "fareMinimum",
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event)=>$setup.currentGeoZone.fareMinimum = $event),
                                            min: "0",
                                            step: "0.01",
                                            placeholder: "Optional"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.fareMinimum
                                            ]
                                        ])
                                    ]),
                                    _cache[138] || (_cache[138] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Minimum fare for rides in this zone (leave blank for no minimum)", -1)),
                                    _cache[139] || (_cache[139] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid fare minimum (0 or more).", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_126, [
                                    _cache[140] || (_cache[140] = (0, _vue.createElementVNode)("label", {
                                        for: "fareMinimumUpToMeters",
                                        class: "form-label"
                                    }, "Minimum Applies Up To (meters)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "fareMinimumUpToMeters",
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event)=>$setup.currentGeoZone.fareMinimumUpToMeters = $event),
                                        min: "0",
                                        step: "1",
                                        placeholder: "Optional"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.currentGeoZone.fareMinimumUpToMeters
                                        ]
                                    ]),
                                    _cache[141] || (_cache[141] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Minimum only applies for trips shorter than this distance (leave blank = always applies)", -1)),
                                    _cache[142] || (_cache[142] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid distance (0 or more).", -1))
                                ])
                            ]),
                            _cache[150] || (_cache[150] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                            _cache[151] || (_cache[151] = (0, _vue.createElementVNode)("p", {
                                class: "mb-2 fw-semibold"
                            }, "Platform fee for this zone (Asher keeps this)", -1)),
                            _cache[152] || (_cache[152] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted small"
                            }, " Everything above adds to the fare, and the driver is paid the fare less commission \u2014 so the driver keeps most of it. The two amounts below go to Asher instead, for costs the platform carries such as insured kilometres on an empty return leg. They apply whichever rate type is selected above, so one zone can pay the driver a surcharge and charge Asher's side at the same time. ", -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_127, [
                                (0, _vue.createElementVNode)("div", _hoisted_128, [
                                    (0, _vue.createElementVNode)("label", _hoisted_129, "Zone Platform Fee \u2014 Asher (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_130, [
                                        _cache[143] || (_cache[143] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "zonePlatformFee",
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event)=>$setup.currentGeoZone.zonePlatformFee = $event),
                                            min: "0",
                                            step: "0.01",
                                            placeholder: "Optional"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.zonePlatformFee
                                            ]
                                        ])
                                    ]),
                                    _cache[144] || (_cache[144] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Flat amount added to the platform fee for matching rides \u2014 not paid to the driver", -1)),
                                    _cache[145] || (_cache[145] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid zone platform fee (0 or more).", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_131, [
                                    (0, _vue.createElementVNode)("label", _hoisted_132, "Zone Platform Fee per km \u2014 Asher (" + (0, _vue.toDisplayString)($setup.fareConfig.state.currency) + ")", 1),
                                    (0, _vue.createElementVNode)("div", _hoisted_133, [
                                        _cache[146] || (_cache[146] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "zonePlatformFeePerKm",
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event)=>$setup.currentGeoZone.zonePlatformFeePerKm = $event),
                                            min: "0",
                                            step: "0.01",
                                            placeholder: "Optional"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentGeoZone.zonePlatformFeePerKm
                                            ]
                                        ]),
                                        _cache[147] || (_cache[147] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "/km", -1))
                                    ]),
                                    _cache[148] || (_cache[148] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Added to the platform fee per kilometre of the trip \u2014 not paid to the driver", -1)),
                                    _cache[149] || (_cache[149] = (0, _vue.createElementVNode)("div", {
                                        class: "invalid-feedback"
                                    }, "Please enter a valid per-km zone platform fee (0 or more).", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createElementVNode)("div", _hoisted_134, [
                        _cache[153] || (_cache[153] = (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            type: "button",
                            "data-bs-dismiss": "modal"
                        }, "Close", -1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary",
                            type: "button",
                            onClick: $setup.saveGeoZone
                        }, (0, _vue.toDisplayString)($setup.geoZoneModalEditMode ? 'Update' : 'Add'), 1)
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iKXGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d08Qr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0
};
const _hoisted_2 = {
    class: "row mb-3"
};
const _hoisted_3 = {
    class: "col-md-4"
};
const _hoisted_4 = {
    class: "mb-3"
};
const _hoisted_5 = {
    class: "logo-container"
};
const _hoisted_6 = [
    "src"
];
const _hoisted_7 = {
    key: 1,
    class: "mb-2 d-flex align-items-center justify-content-center bg-light",
    style: {
        "height": "150px",
        "width": "100%"
    }
};
const _hoisted_8 = {
    class: "col-md-8"
};
const _hoisted_9 = {
    class: "mb-3"
};
const _hoisted_10 = [
    "disabled",
    "readonly"
];
const _hoisted_11 = {
    class: "row"
};
const _hoisted_12 = {
    class: "col"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = [
    "disabled",
    "readonly"
];
const _hoisted_15 = {
    class: "row"
};
const _hoisted_16 = {
    class: "col-sm-6"
};
const _hoisted_17 = {
    class: "mb-3"
};
const _hoisted_18 = [
    "disabled",
    "readonly"
];
const _hoisted_19 = {
    class: "col-sm-6"
};
const _hoisted_20 = {
    class: "mb-3"
};
const _hoisted_21 = [
    "disabled",
    "readonly"
];
const _hoisted_22 = {
    class: "row"
};
const _hoisted_23 = {
    class: "col"
};
const _hoisted_24 = {
    class: "form-check mb-3"
};
const _hoisted_25 = [
    "disabled"
];
const _hoisted_26 = {
    class: "row"
};
const _hoisted_27 = {
    class: "col-sm-6"
};
const _hoisted_28 = {
    class: "mb-3"
};
const _hoisted_29 = [
    "disabled",
    "readonly"
];
const _hoisted_30 = {
    class: "col-sm-6"
};
const _hoisted_31 = {
    class: "mb-3"
};
const _hoisted_32 = [
    "disabled",
    "readonly"
];
const _hoisted_33 = {
    class: "row"
};
const _hoisted_34 = {
    class: "col-sm-6"
};
const _hoisted_35 = {
    class: "mb-3"
};
const _hoisted_36 = [
    "disabled",
    "readonly"
];
const _hoisted_37 = {
    class: "col-12"
};
const _hoisted_38 = {
    class: "mb-3"
};
const _hoisted_39 = [
    "disabled",
    "readonly"
];
const _hoisted_40 = {
    class: "row"
};
const _hoisted_41 = {
    class: "col-12"
};
const _hoisted_42 = {
    class: "mb-3"
};
const _hoisted_43 = {
    class: "d-block"
};
const _hoisted_44 = {
    class: "form-control",
    name: "tags3-1",
    placeholder: "Search service areas",
    ref: "tagifyServiceAreasRef"
};
const _hoisted_45 = {
    class: "row"
};
const _hoisted_46 = {
    class: "col-12"
};
const _hoisted_47 = {
    class: "mb-3"
};
const _hoisted_48 = [
    "disabled",
    "readonly"
];
const _hoisted_49 = {
    key: 0
};
const _hoisted_50 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_51 = {
    class: "card"
};
const _hoisted_52 = {
    class: "card-body social-list filter-cards-view"
};
const _hoisted_53 = {
    class: "col-xl-12 xl-100 box-col-6 mt-4"
};
const _hoisted_54 = {
    class: "card"
};
const _hoisted_55 = {
    class: "card-body social-list filter-cards-view"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createVNode)($setup["EntityForm"], {
            "entity-id": $props.serviceProviderId,
            entity: $setup.serviceProvider,
            "onUpdate:entity": _cache[10] || (_cache[10] = ($event)=>$setup.serviceProvider = $event),
            editState: $setup.isEditingServiceProvider,
            "onUpdate:editState": _cache[11] || (_cache[11] = ($event)=>$setup.isEditingServiceProvider = $event),
            "form-name": "Service Provider",
            "api-url": "/api/service-provider",
            "redirect-url": "/admin/service-provider",
            "model-constructor": "ServiceProvider",
            "show-title": true,
            "file-upload-map": $setup.fileUploadMap
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.serviceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
                        (0, _vue.createElementVNode)("div", _hoisted_2, [
                            (0, _vue.createElementVNode)("div", _hoisted_3, [
                                (0, _vue.createElementVNode)("div", _hoisted_4, [
                                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600"
                                    }, "Logo", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                                        $setup.serviceProvider.state.logoUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                                            key: 0,
                                            src: `/api/service-provider/${$props.serviceProviderId}/logo`,
                                            alt: "Service Provider Logo",
                                            class: "img-fluid mb-2",
                                            style: {
                                                "max-height": "150px",
                                                "max-width": "100%"
                                            }
                                        }, null, 8, _hoisted_6)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, _cache[12] || (_cache[12] = [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-regular fa-image fa-4x text-muted"
                                            }, null, -1)
                                        ]))),
                                        $setup.isEditingServiceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", {
                                            key: 2,
                                            type: "file",
                                            class: "form-control",
                                            id: "logo-upload",
                                            onChange: $setup.handleLogoUpload,
                                            accept: "image/*"
                                        }, null, 32)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_8, [
                                (0, _vue.createElementVNode)("div", _hoisted_9, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-name-input"
                                    }, "Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-name-input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.serviceProvider.state.name = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Service provider name",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_10), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.name
                                        ]
                                    ]),
                                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a name.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_11, [
                            (0, _vue.createElementVNode)("div", _hoisted_12, [
                                (0, _vue.createElementVNode)("div", _hoisted_13, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-address-input"
                                    }, "Address", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-address-input",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.serviceProvider.state.address = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "23 City Street",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider,
                                        ref: "serviceProviderAddressInput"
                                    }, null, 8, _hoisted_14), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.address
                                        ]
                                    ]),
                                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-address-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter an address.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                            (0, _vue.createElementVNode)("div", _hoisted_16, [
                                (0, _vue.createElementVNode)("div", _hoisted_17, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-email-input"
                                    }, "Email", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-email-input",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.serviceProvider.state.email = $event),
                                        class: "form-control",
                                        type: "email",
                                        placeholder: "service.provider@email.com",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_18), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.email
                                        ]
                                    ]),
                                    _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-email-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter an email.", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_19, [
                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-phone-number-input"
                                    }, "Phone Number", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-phone-number-input",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.serviceProvider.state.phoneNumber = $event),
                                        class: "form-control",
                                        type: "tel",
                                        placeholder: "Service provider phone number",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_21), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.phoneNumber
                                        ]
                                    ]),
                                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-phone-number-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid phone number. ", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                            (0, _vue.createElementVNode)("div", _hoisted_23, [
                                (0, _vue.createElementVNode)("div", _hoisted_24, [
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-dispatcher-checkbox",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.serviceProvider.state.dispatchEnabled = $event),
                                        class: "form-check-input",
                                        type: "checkbox",
                                        disabled: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_25), [
                                        [
                                            (0, _vue.vModelCheckbox),
                                            $setup.serviceProvider.state.dispatchEnabled
                                        ]
                                    ]),
                                    _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                                        class: "form-check-label",
                                        for: "service-provider-dispatcher-checkbox"
                                    }, "Dispatch Enabled", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_26, [
                            (0, _vue.createElementVNode)("div", _hoisted_27, [
                                (0, _vue.createElementVNode)("div", _hoisted_28, [
                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-name-input"
                                    }, "Contact Person Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-name-input",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.serviceProvider.state.contactPersonName = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Contact person name",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_29), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonName
                                        ]
                                    ]),
                                    _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a contact person's name. ", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_30, [
                                (0, _vue.createElementVNode)("div", _hoisted_31, [
                                    _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-phone-input"
                                    }, "Contact Person Phone", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-phone-input",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.serviceProvider.state.contactPersonPhone = $event),
                                        class: "form-control",
                                        type: "tel",
                                        placeholder: "Contact person phone number",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_32), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonPhone
                                        ]
                                    ]),
                                    _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-phone-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid contact's phone number. ", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_33, [
                            (0, _vue.createElementVNode)("div", _hoisted_34, [
                                (0, _vue.createElementVNode)("div", _hoisted_35, [
                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-email-input"
                                    }, "Contact Person Email", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-email-input",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.serviceProvider.state.contactPersonEmail = $event),
                                        class: "form-control",
                                        type: "email",
                                        placeholder: "Contact person email",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_36), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonEmail
                                        ]
                                    ]),
                                    _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-email-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid contact's email. ", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_37, [
                                (0, _vue.createElementVNode)("div", _hoisted_38, [
                                    _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-operating-hours-input"
                                    }, "Operating Hours", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        id: "service-provider-operating-hours-input",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.serviceProvider.state.operatingHours = $event),
                                        class: "form-control",
                                        placeholder: "Operating hours",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_39), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.operatingHours
                                        ]
                                    ])
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_40, [
                            (0, _vue.createElementVNode)("div", _hoisted_41, [
                                (0, _vue.createElementVNode)("div", _hoisted_42, [
                                    _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-service-areas-input"
                                    }, "Service Areas", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                                        (0, _vue.createElementVNode)("input", _hoisted_44, null, 512)
                                    ]),
                                    _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Select the service areas this provider operates in.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_45, [
                            (0, _vue.createElementVNode)("div", _hoisted_46, [
                                (0, _vue.createElementVNode)("div", _hoisted_47, [
                                    _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-service-area-allowance-input"
                                    }, "Service Area Allowance (km)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-service-area-allowance-input",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.serviceProvider.state.serviceAreaAllowance = $event),
                                        class: "form-control",
                                        type: "number",
                                        min: "0",
                                        max: "10",
                                        step: "0.1",
                                        placeholder: "Maximum distance outside service area (km)",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_48), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.serviceAreaAllowance
                                        ]
                                    ]),
                                    _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-service-area-allowance-error",
                                        class: "invalid-feedback d-none"
                                    }, " Please enter a valid allowance between 0 and 10 km. ", -1)),
                                    _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Maximum distance (in km) that the service provider can operate outside of their selected service areas. Maximum value is 10km.", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity-id",
            "entity",
            "editState",
            "file-upload-map"
        ]),
        !$setup.isNewServiceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_49, [
            ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Suspense), null, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.createVNode)($setup["FareConfigurationComponent"], {
                            "service-provider-id": $props.serviceProviderId
                        }, null, 8, [
                            "service-provider-id"
                        ])
                    ]),
                _: 1
            })),
            (0, _vue.createElementVNode)("div", _hoisted_50, [
                (0, _vue.createElementVNode)("div", _hoisted_51, [
                    _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h5", null, " Dispatchers ")
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_52, [
                        (0, _vue.createElementVNode)("div", {
                            class: "col-sm-3 d-md-block mb-4"
                        }, [
                            (0, _vue.createElementVNode)("a", {
                                class: "btn btn-primary align-items-center",
                                onClick: $setup.addDispatchUser,
                                type: "button",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#dispatcher-modal"
                            }, _cache[35] || (_cache[35] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-regular fa-square-plus"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Add Dispatch User ")
                            ]))
                        ]),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createVNode)($setup["DataTable"], {
                                ajax: {
                                    url: `/api/datatable/sp-dispatch-users/${$props.serviceProviderId}`
                                },
                                ref: "dispatcherDataTable",
                                class: "table-responsive display",
                                columns: $setup.dispatcherColumns
                            }, null, 8, [
                                "ajax"
                            ])
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_53, [
                (0, _vue.createElementVNode)("div", _hoisted_54, [
                    _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h5", null, " Drivers ")
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_55, [
                        (0, _vue.createElementVNode)("div", {
                            class: "col-sm-3 d-md-block mb-4"
                        }, [
                            (0, _vue.createElementVNode)("a", {
                                class: "btn btn-primary align-items-center",
                                onClick: $setup.addDriver,
                                type: "button",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#driver-modal"
                            }, _cache[37] || (_cache[37] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-regular fa-square-plus"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Add Driver ")
                            ]))
                        ]),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createVNode)($setup["DataTable"], {
                                ajax: {
                                    url: `/api/datatable/sp-all-drivers/${$props.serviceProviderId}`
                                },
                                ref: "driverDataTable",
                                class: "table-responsive display",
                                columns: $setup.driverColumns
                            }, null, 8, [
                                "ajax"
                            ])
                        ])
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbB2z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ey6IG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("a66d4e004dce7e01");
    if (script.__esModule) script = script.default;
    script.render = require("e3ee9e43a3a6b46d").render;
    require("5ab20da4a5ca26fb").default(script);
    script.__scopeId = 'data-v-da6d60';
    script.__file = "ServiceConfiguration.vue";
};
initialize();
exports.default = script;

},{"a66d4e004dce7e01":"3HbsK","e3ee9e43a3a6b46d":"aQiws","5ab20da4a5ca26fb":"aMc84","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3HbsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _fareConfigurationComponentVue = require("./FareConfigurationComponent.vue");
var _fareConfigurationComponentVueDefault = parcelHelpers.interopDefault(_fareConfigurationComponentVue);
var _tagify = require("../../extras/js/vendors/@yaireo/tagify/dist/tagify");
var _tagifyDefault = parcelHelpers.interopDefault(_tagify);
exports.default = {
    __name: 'ServiceConfiguration',
    props: {
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Reactive variables for Service Provider
        const serviceProvider = (0, _vue.ref)({});
        const isEditingServiceProvider = (0, _vue.ref)(false);
        const fileUploadMap = (0, _vue.ref)({});
        const tagifyServiceAreaList = (0, _vue.ref)([]);
        const tagifyInstance = (0, _vue.ref)(null);
        const tagifyServiceAreasRef = (0, _vue.ref)(null);
        const serviceProviderAddressInput = (0, _vue.ref)(null);
        // Fetch available service areas
        const fetchServiceAreas = async ()=>{
            try {
                const response = await fetch('/api/service-area-zones');
                if (response.ok) {
                    const data = await response.json();
                    tagifyServiceAreaList.value = data.map((area)=>({
                            id: area.id,
                            value: area.name,
                            name: area.name,
                            description: area.description,
                            zoneType: area.zoneType
                        }));
                } else console.error('Failed to fetch service areas:', response.status);
            } catch (error) {
                console.error('Error fetching service areas:', error);
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Failed to load service areas',
                    icon: 'error'
                });
            }
        };
        const initializeTagify = async ()=>{
            await (0, _vue.nextTick)();
            // If Tagify is already initialized, destroy it first
            if (tagifyInstance.value) {
                tagifyInstance.value.destroy();
                tagifyInstance.value = null;
            }
            // Initialize Tagify on the service areas input
            tagifyInstance.value = new (0, _tagifyDefault.default)(tagifyServiceAreasRef.value, {
                readOnly: false,
                delimiters: null,
                templates: {
                    tag: function(tagData) {
                        try {
                            return `<tag title='${tagData.value}' contenteditable='false' spellcheck="false" class='tagify__tag ${tagData.class ? tagData.class : ""}' ${this.getAttributes(tagData)}>
                      <x title='remove tag' class='tagify__tag__removeBtn'></x>
                      <div>
                          <span class='tagify__tag-text'>${tagData.value}</span>
                      </div>
                  </tag>`;
                        } catch (err) {}
                    },
                    dropdownItem: function(tagData) {
                        try {
                            return `<div ${this.getAttributes(tagData)} class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'>
                    <span>${tagData.value}</span>
                  </div>`;
                        } catch (err) {
                            console.error(err);
                        }
                    }
                },
                maxTags: 10,
                enforceWhitelist: true,
                whitelist: tagifyServiceAreaList.value,
                dropdown: {
                    closeOnSelect: false,
                    highlightFirst: true,
                    enabled: 0,
                    classname: "extra-properties"
                }
            });
            // Set initial value if serviceProvider has serviceAreas
            if (serviceProvider.value?.state?.serviceAreas?.length) {
                const initialTags = serviceProvider.value.state.serviceAreas.map((area)=>{
                    const foundArea = tagifyServiceAreaList.value.find((a)=>a.id === area.id);
                    return foundArea ? {
                        value: foundArea.name.toString(),
                        name: foundArea.name,
                        id: foundArea.id,
                        description: foundArea.description,
                        zoneType: foundArea.zoneType
                    } : null;
                }).filter(Boolean);
                if (initialTags.length > 0) tagifyInstance.value.addTags(initialTags);
            }
            tagifyInstance.value.setReadonly(!isEditingServiceProvider.value);
            tagifyInstance.value.on("remove", updateServiceAreas);
            tagifyInstance.value.on("add", updateServiceAreas);
        };
        // Update serviceProvider.state.serviceAreas when tags change
        const updateServiceAreas = ()=>{
            if (!tagifyInstance.value || !serviceProvider.value?.state) return;
            try {
                const tags = tagifyInstance.value.value || [];
                serviceProvider.value.state.serviceAreas = tags.map((tag)=>{
                    const area = tagifyServiceAreaList.value.find((a)=>a.value.toString() === tag.value.toString());
                    return area ? {
                        id: area.id,
                        name: area.name,
                        description: area.description,
                        zoneType: area.zoneType
                    } : null;
                }).filter(Boolean);
            } catch (error) {
                console.error('Error updating service areas:', error);
            }
        };
        // Watch for changes in isEditingServiceProvider
        (0, _vue.watch)(()=>isEditingServiceProvider.value, (newVal)=>{
            if (tagifyInstance.value) tagifyInstance.value.setReadonly(!newVal);
            try {
                if (!newVal && serviceProviderAddressInput.value) $(serviceProviderAddressInput.value).autocomplete('close');
            } catch (e) {
            // ignore
            }
        });
        // Initialize everything when component is mounted
        (0, _vue.onMounted)(async ()=>{
            await fetchServiceAreas();
            // Wait a bit more for the DOM to be ready
            setTimeout(()=>{
                if (tagifyServiceAreaList.value.length > 0) initializeTagify();
            }, 100);
        });
        // Cleanup when component is unmounted
        (0, _vue.onUnmounted)(()=>{
            if (tagifyInstance.value) {
                tagifyInstance.value.destroy();
                tagifyInstance.value = null;
            }
            try {
                if (serviceProviderAddressInput.value) $(serviceProviderAddressInput.value).autocomplete('destroy');
            } catch (e) {
            // ignore
            }
        });
        // Handle logo upload
        const handleLogoUpload = async (event)=>{
            const file = event.target.files[0];
            if (!file) return;
            // Check file type
            if (!file.type.match('image.*')) {
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Please select an image file',
                    icon: 'error'
                });
                return;
            }
            // Check file size (max 5MB)
            if (file.size > 5242880) {
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'File size should not exceed 5MB',
                    icon: 'error'
                });
                return;
            }
            fileUploadMap.value["logo"] = file;
        };
        const __returned__ = {
            props,
            serviceProvider,
            isEditingServiceProvider,
            fileUploadMap,
            tagifyServiceAreaList,
            tagifyInstance,
            tagifyServiceAreasRef,
            serviceProviderAddressInput,
            fetchServiceAreas,
            initializeTagify,
            updateServiceAreas,
            handleLogoUpload,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            nextTick: (0, _vue.nextTick),
            watch: (0, _vue.watch),
            onUnmounted: (0, _vue.onUnmounted),
            EntityForm: (0, _entityFormVueDefault.default),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            FareConfigurationComponent: (0, _fareConfigurationComponentVueDefault.default),
            get Tagify () {
                return 0, _tagifyDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","./EntityForm.vue":"i0zng","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","./FareConfigurationComponent.vue":"eDuJk","../../extras/js/vendors/@yaireo/tagify/dist/tagify":"j5wdA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aQiws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0
};
const _hoisted_2 = {
    class: "row mb-3"
};
const _hoisted_3 = {
    class: "col-md-4"
};
const _hoisted_4 = {
    class: "mb-3"
};
const _hoisted_5 = {
    class: "logo-container"
};
const _hoisted_6 = [
    "src"
];
const _hoisted_7 = {
    key: 1,
    class: "mb-2 d-flex align-items-center justify-content-center bg-light",
    style: {
        "height": "150px",
        "width": "100%"
    }
};
const _hoisted_8 = {
    class: "col-md-8"
};
const _hoisted_9 = {
    class: "mb-3"
};
const _hoisted_10 = [
    "disabled",
    "readonly"
];
const _hoisted_11 = {
    class: "row"
};
const _hoisted_12 = {
    class: "col"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = [
    "disabled",
    "readonly"
];
const _hoisted_15 = {
    class: "row"
};
const _hoisted_16 = {
    class: "col-sm-6"
};
const _hoisted_17 = {
    class: "mb-3"
};
const _hoisted_18 = [
    "disabled",
    "readonly"
];
const _hoisted_19 = {
    class: "col-sm-6"
};
const _hoisted_20 = {
    class: "mb-3"
};
const _hoisted_21 = [
    "disabled",
    "readonly"
];
const _hoisted_22 = {
    class: "row"
};
const _hoisted_23 = {
    class: "col"
};
const _hoisted_24 = {
    class: "form-check mb-3"
};
const _hoisted_25 = [
    "disabled"
];
const _hoisted_26 = {
    class: "row"
};
const _hoisted_27 = {
    class: "col-sm-6"
};
const _hoisted_28 = {
    class: "mb-3"
};
const _hoisted_29 = [
    "disabled",
    "readonly"
];
const _hoisted_30 = {
    class: "col-sm-6"
};
const _hoisted_31 = {
    class: "mb-3"
};
const _hoisted_32 = [
    "disabled",
    "readonly"
];
const _hoisted_33 = {
    class: "row"
};
const _hoisted_34 = {
    class: "col-sm-6"
};
const _hoisted_35 = {
    class: "mb-3"
};
const _hoisted_36 = [
    "disabled",
    "readonly"
];
const _hoisted_37 = {
    class: "col-12"
};
const _hoisted_38 = {
    class: "mb-3"
};
const _hoisted_39 = [
    "disabled",
    "readonly"
];
const _hoisted_40 = {
    class: "row"
};
const _hoisted_41 = {
    class: "col-12"
};
const _hoisted_42 = {
    class: "mb-3"
};
const _hoisted_43 = {
    class: "d-block"
};
const _hoisted_44 = {
    class: "form-control",
    name: "tags3-1",
    placeholder: "Search service areas",
    ref: "tagifyServiceAreasRef"
};
const _hoisted_45 = {
    class: "row"
};
const _hoisted_46 = {
    class: "col-12"
};
const _hoisted_47 = {
    class: "mb-3"
};
const _hoisted_48 = [
    "disabled",
    "readonly"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " Service Configuration ")
                ])
            ])
        ], -1)),
        (0, _vue.createVNode)($setup["EntityForm"], {
            "entity-id": $props.serviceProviderId,
            entity: $setup.serviceProvider,
            "onUpdate:entity": _cache[10] || (_cache[10] = ($event)=>$setup.serviceProvider = $event),
            editState: $setup.isEditingServiceProvider,
            "onUpdate:editState": _cache[11] || (_cache[11] = ($event)=>$setup.isEditingServiceProvider = $event),
            "form-name": "Service Provider",
            "api-url": "/api/service-provider",
            "redirect-url": `/service-provider/${$props.serviceProviderId}/service-configuration`,
            "model-constructor": "ServiceProvider",
            "show-title": false,
            "file-upload-map": $setup.fileUploadMap
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.serviceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
                        (0, _vue.createElementVNode)("div", _hoisted_2, [
                            (0, _vue.createElementVNode)("div", _hoisted_3, [
                                (0, _vue.createElementVNode)("div", _hoisted_4, [
                                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600"
                                    }, "Logo", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                                        $setup.serviceProvider.state.logoUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                                            key: 0,
                                            src: `/api/service-provider/${$props.serviceProviderId}/logo`,
                                            alt: "Service Provider Logo",
                                            class: "img-fluid mb-2",
                                            style: {
                                                "max-height": "150px",
                                                "max-width": "100%"
                                            }
                                        }, null, 8, _hoisted_6)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, _cache[12] || (_cache[12] = [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-regular fa-image fa-4x text-muted"
                                            }, null, -1)
                                        ]))),
                                        $setup.isEditingServiceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", {
                                            key: 2,
                                            type: "file",
                                            class: "form-control",
                                            id: "logo-upload",
                                            onChange: $setup.handleLogoUpload,
                                            accept: "image/*"
                                        }, null, 32)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_8, [
                                (0, _vue.createElementVNode)("div", _hoisted_9, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-name-input"
                                    }, "Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-name-input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.serviceProvider.state.name = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Service provider name",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_10), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.name
                                        ]
                                    ]),
                                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a name.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_11, [
                            (0, _vue.createElementVNode)("div", _hoisted_12, [
                                (0, _vue.createElementVNode)("div", _hoisted_13, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-address-input"
                                    }, "Address", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-address-input",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.serviceProvider.state.address = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "23 City Street",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider,
                                        ref: "serviceProviderAddressInput"
                                    }, null, 8, _hoisted_14), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.address
                                        ]
                                    ]),
                                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-address-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter an address.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                            (0, _vue.createElementVNode)("div", _hoisted_16, [
                                (0, _vue.createElementVNode)("div", _hoisted_17, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-email-input"
                                    }, "Email", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-email-input",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.serviceProvider.state.email = $event),
                                        class: "form-control",
                                        type: "email",
                                        placeholder: "service.provider@email.com",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_18), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.email
                                        ]
                                    ]),
                                    _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-email-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter an email.", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_19, [
                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-phone-number-input"
                                    }, "Phone Number", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-phone-number-input",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.serviceProvider.state.phoneNumber = $event),
                                        class: "form-control",
                                        type: "tel",
                                        placeholder: "Service provider phone number",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_21), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.phoneNumber
                                        ]
                                    ]),
                                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-phone-number-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid phone number. ", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                            (0, _vue.createElementVNode)("div", _hoisted_23, [
                                (0, _vue.createElementVNode)("div", _hoisted_24, [
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-dispatcher-checkbox",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.serviceProvider.state.dispatchEnabled = $event),
                                        class: "form-check-input",
                                        type: "checkbox",
                                        disabled: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_25), [
                                        [
                                            (0, _vue.vModelCheckbox),
                                            $setup.serviceProvider.state.dispatchEnabled
                                        ]
                                    ]),
                                    _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                                        class: "form-check-label",
                                        for: "service-provider-dispatcher-checkbox"
                                    }, "Dispatch Enabled", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_26, [
                            (0, _vue.createElementVNode)("div", _hoisted_27, [
                                (0, _vue.createElementVNode)("div", _hoisted_28, [
                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-name-input"
                                    }, "Contact Person Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-name-input",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.serviceProvider.state.contactPersonName = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Contact person name",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_29), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonName
                                        ]
                                    ]),
                                    _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a contact person's name. ", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_30, [
                                (0, _vue.createElementVNode)("div", _hoisted_31, [
                                    _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-phone-input"
                                    }, "Contact Person Phone", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-phone-input",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.serviceProvider.state.contactPersonPhone = $event),
                                        class: "form-control",
                                        type: "tel",
                                        placeholder: "Contact person phone number",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_32), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonPhone
                                        ]
                                    ]),
                                    _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-phone-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid contact's phone number. ", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_33, [
                            (0, _vue.createElementVNode)("div", _hoisted_34, [
                                (0, _vue.createElementVNode)("div", _hoisted_35, [
                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-contact-email-input"
                                    }, "Contact Person Email", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-contact-email-input",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.serviceProvider.state.contactPersonEmail = $event),
                                        class: "form-control",
                                        type: "email",
                                        placeholder: "Contact person email",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_36), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.contactPersonEmail
                                        ]
                                    ]),
                                    _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-contact-email-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid contact's email. ", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_37, [
                                (0, _vue.createElementVNode)("div", _hoisted_38, [
                                    _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-operating-hours-input"
                                    }, "Operating Hours", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        id: "service-provider-operating-hours-input",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.serviceProvider.state.operatingHours = $event),
                                        class: "form-control",
                                        placeholder: "Operating hours",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_39), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.operatingHours
                                        ]
                                    ])
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_40, [
                            (0, _vue.createElementVNode)("div", _hoisted_41, [
                                (0, _vue.createElementVNode)("div", _hoisted_42, [
                                    _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-service-areas-input"
                                    }, "Service Areas", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                                        (0, _vue.createElementVNode)("input", _hoisted_44, null, 512)
                                    ]),
                                    _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Select the service areas this provider operates in.", -1))
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_45, [
                            (0, _vue.createElementVNode)("div", _hoisted_46, [
                                (0, _vue.createElementVNode)("div", _hoisted_47, [
                                    _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "service-provider-service-area-allowance-input"
                                    }, "Service Area Allowance (km)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "service-provider-service-area-allowance-input",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.serviceProvider.state.serviceAreaAllowance = $event),
                                        class: "form-control",
                                        type: "number",
                                        min: "0",
                                        max: "10",
                                        step: "0.1",
                                        placeholder: "Maximum distance outside service area (km)",
                                        disabled: !$setup.isEditingServiceProvider,
                                        readonly: !$setup.isEditingServiceProvider
                                    }, null, 8, _hoisted_48), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.serviceProvider.state.serviceAreaAllowance
                                        ]
                                    ]),
                                    _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                                        id: "service-provider-service-area-allowance-error",
                                        class: "invalid-feedback d-none"
                                    }, " Please enter a valid allowance between 0 and 10 km. ", -1)),
                                    _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Maximum distance (in km) that the service provider can operate outside of their selected service areas. Maximum value is 10km.", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity-id",
            "entity",
            "editState",
            "redirect-url",
            "file-upload-map"
        ]),
        (0, _vue.createElementVNode)("div", null, [
            ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Suspense), null, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.createVNode)($setup["FareConfigurationComponent"], {
                            "service-provider-id": $props.serviceProviderId
                        }, null, 8, [
                            "service-provider-id"
                        ])
                    ]),
                _: 1
            }))
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMc84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kVbo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("1b8a4024bb466a2");
    if (script.__esModule) script = script.default;
    script.render = require("198ca337806be05b").render;
    require("766902c464360174").default(script);
    script.__scopeId = 'data-v-40b8d4';
    script.__file = "UserProfile.vue";
};
initialize();
exports.default = script;

},{"1b8a4024bb466a2":"h9L1Q","198ca337806be05b":"aRlLH","766902c464360174":"5yeWC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9L1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _vue = require("vue");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'UserProfile',
    props: {
        userId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const userProfile = (0, _vue.ref)({});
        const isEditingProfile = (0, _vue.ref)(false);
        //create functions for updating the email and password seperately
        const newEmail = (0, _vue.ref)(null);
        const verificationCode = (0, _vue.ref)(null);
        const verificationSent = (0, _vue.ref)(false);
        const currentPassword = (0, _vue.ref)(null);
        const newPassword = (0, _vue.ref)(null);
        const confirmPassword = (0, _vue.ref)(null);
        const passwordResetErrorMessage = (0, _vue.ref)(null);
        const passwordFormRefresher = (0, _vue.ref)(true);
        const togglePasswordResetModal = function() {
            passwordFormRefresher.value = false;
            currentPassword.value = null;
            newPassword.value = null;
            confirmPassword.value = null;
            passwordResetErrorMessage.value = null;
            $('#password-reset-modal').modal('toggle');
            (0, _vue.nextTick)(()=>{
                passwordFormRefresher.value = true;
            });
        };
        const validatePasswordResetForm = ()=>{
            let isValid = true;
            if (!(0, _lodashDefault.default).isEmpty(currentPassword.value)) {
                $('#current-password-input').removeClass('is-invalid');
                $('#current-password-input-error').addClass('d-none');
            } else {
                $('#current-password-input').addClass('is-invalid');
                $('#current-password-input-error').removeClass('d-none');
                isValid = false;
            }
            if (!(0, _lodashDefault.default).isEmpty(newPassword.value)) {
                $('#new-password-input').removeClass('is-invalid');
                $('#new-password-input-error').addClass('d-none');
            } else {
                $('#new-password-input').addClass('is-invalid');
                $('#new-password-input-error').removeClass('d-none');
                isValid = false;
            }
            if (!(0, _lodashDefault.default).isEmpty(confirmPassword.value) && (0, _lodashDefault.default).isEqual(confirmPassword.value, newPassword.value)) {
                $('#confirm-password-input').removeClass('is-invalid');
                $('#confirm-password-input-error').addClass('d-none');
            } else {
                $('#confirm-password-input').addClass('is-invalid');
                $('#confirm-password-input-error').removeClass('d-none');
                isValid = false;
            }
            return isValid;
        };
        const resetPassword = async function() {
            const valid = validatePasswordResetForm();
            if (!valid) return false;
            passwordResetErrorMessage.value = null;
            //send request that confirms old password first and then sets new password
            const response = await fetch('/api/authenticate/update-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userName: userProfile.value.state.email,
                    currentPassword: currentPassword.value,
                    newPassword: newPassword.value
                })
            });
            if (response.ok) {
                //toggle form modal
                $('#password-reset-modal').modal('toggle');
                //show success alert
                (0, _sweetalert2MinDefault.default).fire({
                    title: "Password Updated Successfully!",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then((result)=>{
                    window.location.reload();
                });
            } else passwordResetErrorMessage.value = await response.text();
        };
        const toggleEmailUpdateModal = ()=>{
            verificationCode.value = null;
            verificationSent.value = false;
            newEmail.value = null;
            $('#email-update-modal').modal('toggle');
        };
        const validateEmailVerificationForm = ()=>{
            let isValid = true;
            if (!(0, _lodashDefault.default).isEmpty(newEmail.value)) {
                $('#new-email-input').removeClass('is-invalid');
                $('#new-email-input-error').addClass('d-none');
            } else {
                $('#new-email-input').addClass('is-invalid');
                $('#new-email-input-error').removeClass('d-none');
                isValid = false;
            }
            return isValid;
        };
        const sendEmailVerification = async function() {
            const valid = validateEmailVerificationForm();
            if (!valid) return false;
            //send verification email
            const response = await fetch('/api/authenticate/send-email-verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    currentEmail: userProfile.value.state.email,
                    newEmail: newEmail.value
                })
            });
            if (response.ok) {
                //if resending, show toast
                if (verificationSent.value) (0, _toastNotificationUtility.showToast)({
                    title: 'Verification Sent',
                    body: `Verification has been sent to ${newEmail.value}!`,
                    type: 'success',
                    delay: 7000
                });
                verificationSent.value = true;
            } else (0, _toastNotificationUtility.showToast)({
                title: 'Error',
                body: await response.text(),
                type: 'error',
                delay: 7000
            });
        };
        const updateEmail = async function() {
            const response = await fetch('/api/authenticate/update-email ', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    currentEmail: userProfile.value.state.email,
                    verificationCode: verificationCode.value,
                    newEmail: newEmail.value
                })
            });
            if (response.ok) {
                //toggle form modal
                $('#email-update-modal').modal('toggle');
                //show success alert
                (0, _sweetalert2MinDefault.default).fire({
                    title: "Email Updated Successfully!",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then((result)=>{
                    window.location.reload();
                });
            } else (0, _toastNotificationUtility.showToast)({
                title: 'Error',
                body: await response.text(),
                type: 'error',
                delay: 7000
            });
        };
        const __returned__ = {
            props,
            userProfile,
            isEditingProfile,
            newEmail,
            verificationCode,
            verificationSent,
            currentPassword,
            newPassword,
            confirmPassword,
            passwordResetErrorMessage,
            passwordFormRefresher,
            togglePasswordResetModal,
            validatePasswordResetForm,
            resetPassword,
            toggleEmailUpdateModal,
            validateEmailVerificationForm,
            sendEmailVerification,
            updateEmail,
            EntityForm: (0, _entityFormVueDefault.default),
            nextTick: (0, _vue.nextTick),
            ref: (0, _vue.ref),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get _ () {
                return 0, _lodashDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"./EntityForm.vue":"i0zng","vue":"dylud","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","lodash":"3hMBK","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aRlLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0
};
const _hoisted_2 = {
    class: "row"
};
const _hoisted_3 = {
    class: "col-sm-6"
};
const _hoisted_4 = {
    class: "mb-3"
};
const _hoisted_5 = [
    "disabled",
    "readonly"
];
const _hoisted_6 = {
    class: "col-sm-6"
};
const _hoisted_7 = {
    class: "mb-3"
};
const _hoisted_8 = [
    "disabled",
    "readonly"
];
const _hoisted_9 = {
    class: "card"
};
const _hoisted_10 = {
    class: "card-body"
};
const _hoisted_11 = {
    key: 0,
    class: "row"
};
const _hoisted_12 = {
    class: "col-sm-6"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = {
    id: "email-update-link"
};
const _hoisted_15 = {
    class: "col-sm-6"
};
const _hoisted_16 = {
    class: "mb-3"
};
const _hoisted_17 = {
    id: "password-update-link"
};
const _hoisted_18 = {
    class: "modal fade",
    id: "password-reset-modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "rest-password-modal",
    "aria-hidden": "true"
};
const _hoisted_19 = {
    class: "modal-dialog modal-fullscreen-sm-down"
};
const _hoisted_20 = {
    class: "modal-content"
};
const _hoisted_21 = {
    class: "modal-body"
};
const _hoisted_22 = {
    class: "login-main"
};
const _hoisted_23 = {
    class: "theme-form"
};
const _hoisted_24 = {
    class: "form-group"
};
const _hoisted_25 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_26 = {
    class: "form-input position-relative"
};
const _hoisted_27 = {
    class: "form-group"
};
const _hoisted_28 = {
    class: "form-input position-relative"
};
const _hoisted_29 = {
    class: "form-group"
};
const _hoisted_30 = {
    class: "form-input position-relative"
};
const _hoisted_31 = {
    class: "modal-footer"
};
const _hoisted_32 = {
    class: "modal fade",
    id: "email-update-modal",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "update-email-modal",
    "aria-hidden": "true"
};
const _hoisted_33 = {
    class: "modal-dialog modal-fullscreen-sm-down"
};
const _hoisted_34 = {
    class: "modal-content"
};
const _hoisted_35 = {
    class: "modal-body"
};
const _hoisted_36 = {
    class: "login-main"
};
const _hoisted_37 = {
    class: "theme-form"
};
const _hoisted_38 = {
    class: "form-group"
};
const _hoisted_39 = {
    class: "col-form-label"
};
const _hoisted_40 = {
    key: 0
};
const _hoisted_41 = {
    class: "form-group"
};
const _hoisted_42 = {
    class: "form-input position-relative"
};
const _hoisted_43 = [
    "disabled",
    "readonly"
];
const _hoisted_44 = {
    key: 0,
    class: "form-group"
};
const _hoisted_45 = {
    class: "form-input position-relative"
};
const _hoisted_46 = {
    class: "modal-footer"
};
const _hoisted_47 = {
    key: 0
};
const _hoisted_48 = {
    key: 1
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createVNode)($setup["EntityForm"], {
            "model-constructor": "MyProfile",
            "api-url": "/users/api/profile",
            entity: $setup.userProfile,
            "onUpdate:entity": _cache[2] || (_cache[2] = ($event)=>$setup.userProfile = $event),
            "entity-id": $setup.props.userId,
            "form-name": "Profile",
            editState: $setup.isEditingProfile,
            "onUpdate:editState": _cache[3] || (_cache[3] = ($event)=>$setup.isEditingProfile = $event),
            "show-title": true
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.userProfile ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
                        (0, _vue.createElementVNode)("div", _hoisted_2, [
                            (0, _vue.createElementVNode)("div", _hoisted_3, [
                                (0, _vue.createElementVNode)("div", _hoisted_4, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "profile-first-name-input"
                                    }, "First Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "profile-first-name-input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.userProfile.state.firstName = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Johnny",
                                        disabled: !$setup.isEditingProfile,
                                        readonly: !$setup.isEditingProfile
                                    }, null, 8, _hoisted_5), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.userProfile.state.firstName
                                        ]
                                    ]),
                                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                        id: "profile-first-name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter the first name. ", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_6, [
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label f-w-600",
                                        for: "profile-last-name-input"
                                    }, "Last Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        id: "profile-last-name-input",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.userProfile.state.lastName = $event),
                                        class: "form-control",
                                        type: "text",
                                        placeholder: "Smith",
                                        disabled: !$setup.isEditingProfile,
                                        readonly: !$setup.isEditingProfile
                                    }, null, 8, _hoisted_8), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.userProfile.state.lastName
                                        ]
                                    ]),
                                    _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                        id: "profile-last-name-error",
                                        class: "invalid-feedback d-none"
                                    }, " Please enter the last name. ", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity",
            "entity-id",
            "editState"
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_9, [
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("h4", {
                    class: "mb-3"
                }, " Authentication ", -1)),
                $setup.userProfile.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                            _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                class: "form-label f-w-600",
                                for: "profile-email-input"
                            }, "Email", -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                id: "profile-email-input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.userProfile.state.email = $event),
                                class: "form-control",
                                type: "text",
                                autocomplete: "username",
                                placeholder: "email@example.com",
                                disabled: true,
                                readonly: true
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.userProfile.state.email
                                ]
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_14, [
                                (0, _vue.createElementVNode)("a", {
                                    class: "link",
                                    onClick: _cache[5] || (_cache[5] = ($event)=>$setup.toggleEmailUpdateModal()),
                                    href: "#"
                                }, "Update my email")
                            ])
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_15, [
                        (0, _vue.createElementVNode)("div", _hoisted_16, [
                            _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("label", {
                                class: "form-label f-w-600",
                                for: "profile-password-input"
                            }, "Password", -1)),
                            _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("input", {
                                id: "profile-password-input",
                                class: "form-control",
                                type: "password",
                                value: "********",
                                autocomplete: "current-password",
                                disabled: true,
                                readonly: true
                            }, null, -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_17, [
                                (0, _vue.createElementVNode)("a", {
                                    class: "link",
                                    onClick: _cache[6] || (_cache[6] = ($event)=>$setup.togglePasswordResetModal()),
                                    href: "#"
                                }, "Update my password")
                            ])
                        ])
                    ])
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_18, [
            (0, _vue.createElementVNode)("div", _hoisted_19, [
                (0, _vue.createElementVNode)("div", _hoisted_20, [
                    _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                        class: "modal-header"
                    }, [
                        (0, _vue.createElementVNode)("h3", {
                            class: "modal-title fs-5",
                            id: "exampleModalLongTitle"
                        }, "Reset Your Password"),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_21, [
                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                            (0, _vue.createElementVNode)("form", _hoisted_23, [
                                (0, _vue.createElementVNode)("div", _hoisted_24, [
                                    $setup.passwordResetErrorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_25, (0, _vue.toDisplayString)($setup.passwordResetErrorMessage), 1)) : (0, _vue.createCommentVNode)("", true),
                                    _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Current Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_26, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "password",
                                            name: "login[password]",
                                            id: "current-password-input",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.currentPassword = $event),
                                            autocomplete: "current-password",
                                            required: "",
                                            placeholder: "*********"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.currentPassword
                                            ]
                                        ]),
                                        _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("div", {
                                            class: "show-hide"
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "show"
                                            })
                                        ], -1)),
                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                                            id: "current-password-input-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter your current password. ", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_27, [
                                    _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "New Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_28, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "password",
                                            name: "login[password]",
                                            id: "new-password-input",
                                            autocomplete: "new-password",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.newPassword = $event),
                                            placeholder: "*********",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.newPassword
                                            ]
                                        ]),
                                        _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("div", {
                                            class: "show-hide"
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "show"
                                            })
                                        ], -1)),
                                        _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                                            id: "new-password-input-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a new password. ", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_29, [
                                    _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Confirm Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_30, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "password",
                                            name: "login[password]",
                                            id: "confirm-password-input",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.confirmPassword = $event),
                                            autocomplete: "confirm-password",
                                            required: ""
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.confirmPassword
                                            ]
                                        ]),
                                        _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("div", {
                                            class: "show-hide"
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "show"
                                            })
                                        ], -1)),
                                        _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("div", {
                                            id: "confirm-password-input-error",
                                            class: "invalid-feedback d-none"
                                        }, " Passwords do not match. ", -1))
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_31, [
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary btn-block w-100",
                                type: "submit",
                                onClick: _cache[10] || (_cache[10] = ($event)=>$setup.resetPassword())
                            }, "Done")
                        ])
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_32, [
            (0, _vue.createElementVNode)("div", _hoisted_33, [
                (0, _vue.createElementVNode)("div", _hoisted_34, [
                    _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("div", {
                        class: "modal-header"
                    }, [
                        (0, _vue.createElementVNode)("h3", {
                            class: "modal-title fs-5",
                            id: "exampleModalLongTitle"
                        }, "Update Email"),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn-close",
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_35, [
                        (0, _vue.createElementVNode)("div", _hoisted_36, [
                            (0, _vue.createElementVNode)("form", _hoisted_37, [
                                (0, _vue.createElementVNode)("div", _hoisted_38, [
                                    (0, _vue.createElementVNode)("label", _hoisted_39, [
                                        _cache[34] || (_cache[34] = (0, _vue.createTextVNode)("Current Email: ")),
                                        $setup.userProfile.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_40, (0, _vue.toDisplayString)($setup.userProfile.state.email), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_41, [
                                    _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "New Email", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_42, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "email",
                                            name: "email-auth",
                                            id: "new-email-input",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.newEmail = $event),
                                            disabled: $setup.verificationSent,
                                            readonly: $setup.verificationSent,
                                            placeholder: "new@example.com"
                                        }, null, 8, _hoisted_43), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.newEmail
                                            ]
                                        ]),
                                        _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("div", {
                                            id: "new-email-input-error",
                                            class: "invalid-feedback d-none"
                                        }, " Please enter a new and valid email address. ", -1))
                                    ])
                                ]),
                                $setup.verificationSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_44, [
                                    _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("div", {
                                        class: "text-muted mt-3"
                                    }, [
                                        (0, _vue.createElementVNode)("p", null, "A verification code has been sent to your new email. "),
                                        (0, _vue.createElementVNode)("p", null, [
                                            (0, _vue.createTextVNode)(" Click \"Resend Verification\" if you have not received a code in "),
                                            (0, _vue.createElementVNode)("b", null, "30 seconds.")
                                        ])
                                    ], -1)),
                                    _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Enter Verification Code", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_45, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "text",
                                            name: "email-auth",
                                            id: "verification-code-input",
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.verificationCode = $event)
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.verificationCode
                                            ]
                                        ])
                                    ])
                                ])) : (0, _vue.createCommentVNode)("", true)
                            ])
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_46, [
                        !$setup.verificationSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_47, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary btn-block w-100",
                                type: "submit",
                                onClick: _cache[13] || (_cache[13] = ($event)=>$setup.sendEmailVerification())
                            }, "Verify Email ")
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.verificationSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_48, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary btn-block w-100 me-3",
                                type: "submit",
                                onClick: _cache[14] || (_cache[14] = ($event)=>$setup.updateEmail())
                            }, " Confirm and Update "),
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-outline-secondary btn-block w-100",
                                type: "submit",
                                onClick: _cache[15] || (_cache[15] = ($event)=>$setup.sendEmailVerification())
                            }, " Resend Verification ")
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5yeWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NEYM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("edafcc7a5f2de6a");
    if (script.__esModule) script = script.default;
    script.render = require("ce3c7910a44ceccc").render;
    require("e716a59ac2537a5f").default(script);
    script.__scopeId = 'data-v-db5147';
    script.__file = "DispatchCallHandler.vue";
};
initialize();
exports.default = script;

},{"edafcc7a5f2de6a":"d0V2s","ce3c7910a44ceccc":"jEhEW","e716a59ac2537a5f":"bOSQ9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0V2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _voiceSdk = require("@twilio/voice-sdk");
var _bootstrap = require("bootstrap");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _eventBus = require("../utility/eventBus");
var _addressHelper = require("../utility/addressHelper");
//Call states
exports.default = {
    __name: 'DispatchCallHandler',
    setup (__props, { expose: __expose }) {
        __expose();
        const STATES = (0, _vue.ref)({
            INCOMING_CALL: 'Incoming Call',
            CALL_REJECTED: 'Call Rejected',
            CALL_ENDED: 'Call Ended',
            CALL_IN_PROGRESS: 'Call In-Progress'
        });
        // Reactive state variables
        let device = undefined;
        let call = undefined;
        let dispatcherCallToast;
        let callSummaryToast;
        const currentState = (0, _vue.ref)(STATES.value.INCOMING_CALL);
        const caller = (0, _vue.ref)("");
        const muted = (0, _vue.ref)(false);
        const dropOffAddressSuggestions = (0, _vue.ref)([]);
        const pickUpAddressSuggestions = (0, _vue.ref)([]);
        // Initialize Twilio Device
        const initializeDevice = async ()=>{
            try {
                // Fetch Twilio token from the backend
                const token = await getDeviceToken();
                // Initialize the Twilio Device
                device = new (0, _voiceSdk.Device)(token, {
                    debug: true
                });
                device.audio.incoming(true);
                device.on("error", (error)=>{
                    console.error("Twilio Device Error:", error);
                });
                device.on("tokenWillExpire", async ()=>{
                    console.log('token expiring');
                    //update the device token, if there is a call in session, there may be a loss in audio, but it is acceptable
                    const token = await getDeviceToken();
                    device.updateToken(token);
                });
                // Handle incoming calls
                device.on("incoming", (incomingCall)=>{
                    console.log("incoming");
                    call = incomingCall;
                    currentState.value = STATES.value.INCOMING_CALL;
                    caller.value = call.parameters.From || "Unknown Caller";
                    call.on("disconnect", ()=>{
                        endCall();
                    });
                    dispatcherCallToast.show();
                });
                await device.register();
                console.log("Twilio Device initialized");
            } catch (error) {
                console.error("Failed to initialize Twilio Device:", error);
            }
        };
        // Accept the call
        const acceptCall = ()=>{
            if (call) {
                call.accept();
                currentState.value = STATES.value.CALL_IN_PROGRESS;
                console.log("Call accepted");
                //set the dispatcher on the call
                setDispatcherOnCall(call);
            }
        };
        // Reject the call
        const rejectCall = ()=>{
            if (call) {
                call.reject();
                currentState.value = STATES.value.CALL_REJECTED;
                console.log("Call rejected");
                caller.value = "";
                //set the dispatcher on the call
                setDispatcherOnCall(call);
                //hide toast
                setTimeout(()=>{
                    dispatcherCallToast.hide();
                }, 3000);
                call = undefined;
            }
        };
        // endCall
        const endCall = ()=>{
            if (call) {
                call.disconnect();
                currentState.value = STATES.value.CALL_ENDED;
                //hide toast
                setTimeout(()=>{
                    dispatcherCallToast.hide();
                }, 3000);
                //get call summary
                (0, _toastNotificationUtility.showToast)({
                    body: "Call summary is being generated.."
                });
                pollForCallSummary(call);
                (0, _eventBus.eventBus).emit('emitCallerPhoneNumber', caller.value);
                call = undefined;
                console.log("Call ended");
            }
        };
        const muteClick = ()=>{
            if (call) {
                if (call.isMuted()) {
                    call.mute();
                    muted.value = false;
                } else {
                    call.mute();
                    muted.value = true;
                }
            }
        };
        const pollForCallSummary = (call)=>{
            const params = new URLSearchParams(call.parameters.Params);
            const callFrom = call.parameters.From;
            // Get the value of "ParentCallSid"
            const parentCallSid = params.get("ParentCallSid");
            const pollInterval = 1000; // Poll every second
            const maxAttempts = 5; // Stop after 5 attempts (about 5 seconds)
            let attempts = 0;
            const poll = async ()=>{
                try {
                    const response = await fetch(`/api/call/get-summary?callSid=${parentCallSid}`);
                    if (response.status === 200) {
                        const callSummary = await response.json();
                        pickUpAddressSuggestions.value = await getValidAddress(callSummary.pickupAddress);
                        dropOffAddressSuggestions.value = await getValidAddress(callSummary.dropOffAddress);
                        callSummaryToast.show();
                        return; // Stop polling on success
                    } else {
                        attempts++;
                        if (attempts < maxAttempts) setTimeout(poll, pollInterval); // Schedule the next poll
                        else //show message for unsuccessful summary generation
                        (0, _toastNotificationUtility.showToast)({
                            title: "Summary Error",
                            body: `Unable to generate AI summary for call from ${callFrom}`,
                            type: 'warn'
                        });
                    }
                } catch (error) {
                    console.error("Error polling call summary:", error);
                }
            };
            poll();
        };
        const dismissCallSummary = ()=>{
            callSummaryToast.hide();
        };
        const usePickUpSuggestion = (value)=>{
            //redirect to dispatch page if necessary
            (0, _eventBus.eventBus).emit('emitPickupSuggestionToForm', value);
        };
        const useDropOffSuggestion = (value)=>{
            //redirect to dispatch page if necessary
            (0, _eventBus.eventBus).emit('emitDropOffSuggestionToForm', value);
        };
        const getValidAddress = async (suggestedAddress)=>{
            try {
                if (suggestedAddress) {
                    const response = await fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(suggestedAddress)}`);
                    if (response.ok) {
                        const resData = await response.json();
                        if (resData.results instanceof Array) return resData.results.map((res)=>{
                            return {
                                result: res,
                                label: (0, _addressHelper.renderWithPoi)(res),
                                value: res.address.freeformAddress
                            };
                        }).slice(0, 2);
                    }
                }
            } catch (err) {
                console.log('error checking validity', err);
            }
            return [];
        };
        const getDeviceToken = async ()=>{
            const response = await fetch("/api/integration/twilio/token");
            if (!response.ok) throw new Error("Failed to fetch Twilio token");
            return await response.text();
        };
        const setDispatcherOnCall = (callObj)=>{
            const params = new URLSearchParams(callObj.parameters.Params);
            const parentCallSid = params.get("ParentCallSid");
            //async not necessary
            fetch(`/api/call/set-dispatcher?callSid=${parentCallSid}`);
        };
        // Lifecycle hook
        (0, _vue.onMounted)(()=>{
            let toastContainer = $(document.getElementById("global-toast-container"));
            //Set up toasts (call and call summary)
            dispatcherCallToast = new (0, _bootstrap.Toast)($('#dispatch-caller-toast'), {
                autohide: false
            });
            callSummaryToast = new (0, _bootstrap.Toast)($('#call-summary-toast'), {
                autohide: false
            });
            toastContainer.prepend($('#dispatch-caller-toast'));
            toastContainer.prepend($('#call-summary-toast'));
            //initialize device
            initializeDevice();
        });
        const __returned__ = {
            STATES,
            get device () {
                return device;
            },
            set device (v){
                device = v;
            },
            get call () {
                return call;
            },
            set call (v){
                call = v;
            },
            get dispatcherCallToast () {
                return dispatcherCallToast;
            },
            set dispatcherCallToast (v){
                dispatcherCallToast = v;
            },
            get callSummaryToast () {
                return callSummaryToast;
            },
            set callSummaryToast (v){
                callSummaryToast = v;
            },
            currentState,
            caller,
            muted,
            dropOffAddressSuggestions,
            pickUpAddressSuggestions,
            initializeDevice,
            acceptCall,
            rejectCall,
            endCall,
            muteClick,
            pollForCallSummary,
            dismissCallSummary,
            usePickUpSuggestion,
            useDropOffSuggestion,
            getValidAddress,
            getDeviceToken,
            setDispatcherOnCall,
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref),
            get Device () {
                return 0, _voiceSdk.Device;
            },
            get Toast () {
                return 0, _bootstrap.Toast;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get eventBus () {
                return 0, _eventBus.eventBus;
            },
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@twilio/voice-sdk":"brzlS","bootstrap":"900Wv","../utility/toastNotificationUtility":"krOtg","../utility/eventBus":"1OAlE","../utility/addressHelper":"3Hmtq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brzlS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Call", ()=>(0, _callDefault.default));
parcelHelpers.export(exports, "Device", ()=>(0, _deviceDefault.default));
parcelHelpers.export(exports, "PreflightTest", ()=>(0, _preflight.PreflightTest));
parcelHelpers.export(exports, "Logger", ()=>(0, _log.Logger));
parcelHelpers.export(exports, "TwilioError", ()=>_errors);
var _call = require("./twilio/call");
var _callDefault = parcelHelpers.interopDefault(_call);
var _device = require("./twilio/device");
var _deviceDefault = parcelHelpers.interopDefault(_device);
var _errors = require("./twilio/errors");
var _log = require("./twilio/log");
var _preflight = require("./twilio/preflight/preflight");

},{"./twilio/call":"92RrQ","./twilio/device":"iaq4W","./twilio/errors":"caXI8","./twilio/log":"eJjQN","./twilio/preflight/preflight":"9Nh8w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92RrQ":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @publicapi
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
var _backoff = require("./backoff");
var _backoffDefault = parcelHelpers.interopDefault(_backoff);
var _device = require("./device");
var _deviceDefault = parcelHelpers.interopDefault(_device);
var _errors = require("./errors");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _rtc = require("./rtc");
var _icecandidate = require("./rtc/icecandidate");
var _sdp = require("./rtc/sdp");
var _statsMonitor = require("./statsMonitor");
var _statsMonitorDefault = parcelHelpers.interopDefault(_statsMonitor);
var _util = require("./util");
var _uuid = require("./uuid");
var _constants = require("./constants");
const BACKOFF_CONFIG = {
    factor: 1.1,
    jitter: 0.5,
    max: 30000,
    min: 1
};
const DTMF_INTER_TONE_GAP = 70;
const DTMF_PAUSE_DURATION = 500;
const DTMF_TONE_DURATION = 160;
const METRICS_BATCH_SIZE = 10;
const METRICS_DELAY = 5000;
const MEDIA_DISCONNECT_ERROR = {
    disconnect: true,
    info: {
        code: 31003,
        message: 'Connection with Twilio was interrupted.',
        twilioError: new (0, _errors.MediaErrors).ConnectionError()
    }
};
const MULTIPLE_THRESHOLD_WARNING_NAMES = {
    // The stat `packetsLostFraction` is monitored by two separate thresholds,
    // `maxAverage` and `max`. Each threshold emits a different warning name.
    packetsLostFraction: {
        max: 'packet-loss',
        maxAverage: 'packets-lost-fraction'
    }
};
const WARNING_NAMES = {
    audioInputLevel: 'audio-input-level',
    audioOutputLevel: 'audio-output-level',
    bytesReceived: 'bytes-received',
    bytesSent: 'bytes-sent',
    jitter: 'jitter',
    mos: 'mos',
    rtt: 'rtt'
};
const WARNING_PREFIXES = {
    max: 'high-',
    maxAverage: 'high-',
    maxDuration: 'constant-',
    min: 'low-',
    minStandardDeviation: 'constant-'
};
/**
 * A {@link Call} represents a media and signaling connection to a TwiML application.
 * @publicapi
 */ class Call extends (0, _events.EventEmitter) {
    /**
     * @constructor
     * @private
     * @param config - Mandatory configuration options
     * @param [options] - Optional settings
     */ constructor(config, options){
        super();
        /**
         * Call parameters received from Twilio for an incoming call.
         */ this.parameters = {};
        /**
         * The number of times input volume has been the same consecutively.
         */ this._inputVolumeStreak = 0;
        /**
         * Whether the call has been answered.
         */ this._isAnswered = false;
        /**
         * Whether the call has been cancelled.
         */ this._isCancelled = false;
        /**
         * Whether the call has been rejected
         */ this._isRejected = false;
        /**
         * The most recent public input volume value. 0 -> 1 representing -100 to -30 dB.
         */ this._latestInputVolume = 0;
        /**
         * The most recent public output volume value. 0 -> 1 representing -100 to -30 dB.
         */ this._latestOutputVolume = 0;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('Call');
        /**
         * State of the {@link Call}'s media.
         */ this._mediaStatus = Call.State.Pending;
        /**
         * A map of messages sent via sendMessage API using voiceEventSid as the key.
         * The message will be deleted once an 'ack' or an error is received from the server.
         */ this._messages = new Map();
        /**
         * A batch of metrics samples to send to Insights. Gets cleared after
         * each send and appended to on each new sample.
         */ this._metricsSamples = [];
        /**
         * Options passed to this {@link Call}.
         */ this._options = {
            MediaHandler: (0, _rtc.PeerConnection),
            enableImprovedSignalingErrorPrecision: false,
            offerSdp: null,
            shouldPlayDisconnect: ()=>true,
            voiceEventSidGenerator: (0, _uuid.generateVoiceEventSid)
        };
        /**
         * The number of times output volume has been the same consecutively.
         */ this._outputVolumeStreak = 0;
        /**
         * Whether the {@link Call} should send a hangup on disconnect.
         */ this._shouldSendHangup = true;
        /**
         * State of the {@link Call}'s signaling.
         */ this._signalingStatus = Call.State.Pending;
        /**
         * A Map of Sounds to play.
         */ this._soundcache = new Map();
        /**
         * State of the {@link Call}.
         */ this._status = Call.State.Pending;
        /**
         * Whether the {@link Call} has been connected. Used to determine if we are reconnected.
         */ this._wasConnected = false;
        /**
         * String representation of {@link Call} instance.
         * @private
         */ this.toString = ()=>'[Twilio.Call instance]';
        this._emitWarning = (groupPrefix, warningName, threshold, value, wasCleared, warningData)=>{
            const groupSuffix = wasCleared ? '-cleared' : '-raised';
            const groupName = `${groupPrefix}warning${groupSuffix}`;
            // Ignore constant input if the Call is muted (Expected)
            if (warningName === 'constant-audio-input-level' && this.isMuted()) return;
            let level = wasCleared ? 'info' : 'warning';
            // Avoid throwing false positives as warnings until we refactor volume metrics
            if (warningName === 'constant-audio-output-level') level = 'info';
            const payloadData = {
                threshold
            };
            if (value) {
                if (value instanceof Array) payloadData.values = value.map((val)=>{
                    if (typeof val === 'number') return Math.round(val * 100) / 100;
                    return value;
                });
                else payloadData.value = value;
            }
            this._publisher.post(level, groupName, warningName, {
                data: payloadData
            }, this);
            if (warningName !== 'constant-audio-output-level') {
                const emitName = wasCleared ? 'warning-cleared' : 'warning';
                this._log.debug(`#${emitName}`, warningName);
                this.emit(emitName, warningName, warningData && !wasCleared ? warningData : null);
            }
        };
        /**
         * Called when the {@link Call} receives an ack from signaling
         * @param payload
         */ this._onAck = (payload)=>{
            const { acktype, callsid, voiceeventsid } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received ack from a different callsid: ${callsid}`);
                return;
            }
            if (acktype === 'message') this._onMessageSent(voiceeventsid);
        };
        /**
         * Called when the {@link Call} is answered.
         * @param payload
         */ this._onAnswer = (payload)=>{
            if (typeof payload.reconnect === 'string') this._signalingReconnectToken = payload.reconnect;
            // answerOnBridge=false will send a 183 which we need to catch in _onRinging when
            // the enableRingingState flag is disabled. In that case, we will receive a 200 after
            // the callee accepts the call firing a second `accept` event if we don't
            // short circuit here.
            if (this._isAnswered && this._status !== Call.State.Reconnecting) return;
            this._setCallSid(payload);
            this._isAnswered = true;
            this._maybeTransitionToOpen();
        };
        /**
         * Called when the {@link Call} is cancelled.
         * @param payload
         */ this._onCancel = (payload)=>{
            // (rrowland) Is this check necessary? Verify, and if so move to pstream / VSP module.
            const callsid = payload.callsid;
            if (this.parameters.CallSid === callsid) {
                this._isCancelled = true;
                this._publisher.info('connection', 'cancel', null, this);
                this._cleanupEventListeners();
                this._mediaHandler.close();
                this._status = Call.State.Closed;
                this._log.debug('#cancel');
                this.emit('cancel');
                this._pstream.removeListener('cancel', this._onCancel);
            }
        };
        /**
         * Called when we receive a connected event from pstream.
         * Re-emits the event.
         */ this._onConnected = ()=>{
            this._log.info('Received connected from pstream');
            if (this._signalingReconnectToken && this._mediaHandler.version) this._pstream.reconnect(this._mediaHandler.version.getSDP(), this.parameters.CallSid, this._signalingReconnectToken);
        };
        /**
         * Called when the {@link Call} is hung up.
         * @param payload
         */ this._onHangup = (payload)=>{
            if (this.status() === Call.State.Closed) return;
            /**
             *  see if callsid passed in message matches either callsid or outbound id
             *  call should always have either callsid or outbound id
             *  if no callsid passed hangup anyways
             */ if (payload.callsid && (this.parameters.CallSid || this.outboundConnectionId)) {
                if (payload.callsid !== this.parameters.CallSid && payload.callsid !== this.outboundConnectionId) return;
            } else if (payload.callsid) // hangup is for another call
            return;
            this._log.info('Received HANGUP from gateway');
            if (payload.error) {
                const code = payload.error.code;
                const errorConstructor = (0, _errors.getPreciseSignalingErrorByCode)(this._options.enableImprovedSignalingErrorPrecision, code);
                const error = typeof errorConstructor !== 'undefined' ? new errorConstructor(payload.error.message) : new (0, _errors.GeneralErrors).ConnectionError('Error sent from gateway in HANGUP', payload.error);
                this._log.error('Received an error from the gateway:', error);
                this._log.debug('#error', error);
                this.emit('error', error);
            }
            this._shouldSendHangup = false;
            this._publisher.info('connection', 'disconnected-by-remote', null, this);
            this._disconnect(null, true);
            this._cleanupEventListeners();
        };
        /**
         * Called when there is a media failure.
         * Manages all media-related states and takes action base on the states
         * @param type - Type of media failure
         */ this._onMediaFailure = (type)=>{
            const { ConnectionDisconnected, ConnectionFailed, IceGatheringFailed, LowBytes } = Call.MediaFailure;
            // These types signifies the end of a single ICE cycle
            const isEndOfIceCycle = type === ConnectionFailed || type === IceGatheringFailed;
            // All browsers except chrome doesn't update pc.iceConnectionState and pc.connectionState
            // after issuing an ICE Restart, which we use to determine if ICE Restart is complete.
            // Since we cannot detect if ICE Restart is complete, we will not retry.
            if (!(0, _util.isChrome)(window, window.navigator) && type === ConnectionFailed) return this._mediaHandler.onerror(MEDIA_DISCONNECT_ERROR);
            // Ignore subsequent requests if ice restart is in progress
            if (this._mediaStatus === Call.State.Reconnecting) {
                // This is a retry. Previous ICE Restart failed
                if (isEndOfIceCycle) {
                    // We already exceeded max retry time.
                    if (Date.now() - this._mediaReconnectStartTime > BACKOFF_CONFIG.max) {
                        this._log.warn('Exceeded max ICE retries');
                        return this._mediaHandler.onerror(MEDIA_DISCONNECT_ERROR);
                    }
                    // Issue ICE restart with backoff
                    try {
                        this._mediaReconnectBackoff.backoff();
                    } catch (error) {
                        // Catch and ignore 'Backoff in progress.' errors. If a backoff is
                        // ongoing and we try to start another one, there shouldn't be a
                        // problem.
                        if (!(error.message && error.message === 'Backoff in progress.')) throw error;
                    }
                }
                return;
            }
            const pc = this._mediaHandler.version.pc;
            const isIceDisconnected = pc && pc.iceConnectionState === 'disconnected';
            const hasLowBytesWarning = this._monitor.hasActiveWarning('bytesSent', 'min') || this._monitor.hasActiveWarning('bytesReceived', 'min');
            // Only certain conditions can trigger media reconnection
            if (type === LowBytes && isIceDisconnected || type === ConnectionDisconnected && hasLowBytesWarning || isEndOfIceCycle) {
                const mediaReconnectionError = new (0, _errors.MediaErrors).ConnectionError('Media connection failed.');
                this._log.warn('ICE Connection disconnected.');
                this._publisher.warn('connection', 'error', mediaReconnectionError, this);
                this._publisher.info('connection', 'reconnecting', null, this);
                this._mediaReconnectStartTime = Date.now();
                this._status = Call.State.Reconnecting;
                this._mediaStatus = Call.State.Reconnecting;
                this._mediaReconnectBackoff.reset();
                this._mediaReconnectBackoff.backoff();
                this._log.debug('#reconnecting');
                this.emit('reconnecting', mediaReconnectionError);
            }
        };
        /**
         * Called when media call is restored
         */ this._onMediaReconnected = ()=>{
            // Only trigger once.
            // This can trigger on pc.onIceConnectionChange and pc.onConnectionChange.
            if (this._mediaStatus !== Call.State.Reconnecting) return;
            this._log.info('ICE Connection reestablished.');
            this._mediaStatus = Call.State.Open;
            if (this._signalingStatus === Call.State.Open) {
                this._publisher.info('connection', 'reconnected', null, this);
                this._log.debug('#reconnected');
                this.emit('reconnected');
                this._status = Call.State.Open;
            }
        };
        /**
         * Raised when a Call receives a message from the backend.
         * @param payload - A record representing the payload of the message from the
         * Twilio backend.
         */ this._onMessageReceived = (payload)=>{
            const { callsid, content, contenttype, messagetype, voiceeventsid } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received a message from a different callsid: ${callsid}`);
                return;
            }
            const data = {
                content,
                contentType: contenttype,
                messageType: messagetype,
                voiceEventSid: voiceeventsid
            };
            this._publisher.info('call-message', messagetype, {
                content_type: contenttype,
                event_type: 'received',
                voice_event_sid: voiceeventsid
            }, this);
            this._log.debug('#messageReceived', JSON.stringify(data));
            this.emit('messageReceived', data);
        };
        /**
         * Raised when a Call receives an 'ack' with an 'acktype' of 'message.
         * This means that the message sent via sendMessage API has been received by the signaling server.
         * @param voiceEventSid
         */ this._onMessageSent = (voiceEventSid)=>{
            if (!this._messages.has(voiceEventSid)) {
                this._log.warn(`Received a messageSent with a voiceEventSid that doesn't exists: ${voiceEventSid}`);
                return;
            }
            const message = this._messages.get(voiceEventSid);
            this._messages.delete(voiceEventSid);
            this._publisher.info('call-message', message === null || message === void 0 ? void 0 : message.messageType, {
                content_type: message === null || message === void 0 ? void 0 : message.contentType,
                event_type: 'sent',
                voice_event_sid: voiceEventSid
            }, this);
            this._log.debug('#messageSent', JSON.stringify(message));
            this.emit('messageSent', message);
        };
        /**
         * When we get a RINGING signal from PStream, update the {@link Call} status.
         * @param payload
         */ this._onRinging = (payload)=>{
            this._setCallSid(payload);
            // If we're not in 'connecting' or 'ringing' state, this event was received out of order.
            if (this._status !== Call.State.Connecting && this._status !== Call.State.Ringing) return;
            const hasEarlyMedia = !!payload.sdp;
            this._status = Call.State.Ringing;
            this._publisher.info('connection', 'outgoing-ringing', {
                hasEarlyMedia
            }, this);
            this._log.debug('#ringing');
            this.emit('ringing', hasEarlyMedia);
        };
        /**
         * Called each time StatsMonitor emits a sample.
         * Emits stats event and batches the call stats metrics and sends them to Insights.
         * @param sample
         */ this._onRTCSample = (sample)=>{
            const callMetrics = Object.assign(Object.assign({}, sample), {
                inputVolume: this._latestInputVolume,
                outputVolume: this._latestOutputVolume
            });
            this._codec = callMetrics.codecName;
            this._metricsSamples.push(callMetrics);
            if (this._metricsSamples.length >= METRICS_BATCH_SIZE) this._publishMetrics();
            this.emit('sample', sample);
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ this._onSignalingError = (payload)=>{
            const { callsid, voiceeventsid, error } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received an error from a different callsid: ${callsid}`);
                return;
            }
            if (voiceeventsid && this._messages.has(voiceeventsid)) {
                // Do not emit an error here. Device is handling all signaling related errors.
                this._messages.delete(voiceeventsid);
                this._log.warn(`Received an error while sending a message.`, payload);
                this._publisher.error('call-message', 'error', {
                    code: error.code,
                    message: error.message,
                    voice_event_sid: voiceeventsid
                }, this);
                let twilioError;
                const errorConstructor = (0, _errors.getPreciseSignalingErrorByCode)(!!this._options.enableImprovedSignalingErrorPrecision, error.code);
                if (typeof errorConstructor !== 'undefined') twilioError = new errorConstructor(error);
                if (!twilioError) {
                    this._log.error('Unknown Call Message Error: ', error);
                    twilioError = new (0, _errors.GeneralErrors).UnknownError(error.message, error);
                }
                this._log.debug('#error', error, twilioError);
                this.emit('error', twilioError);
            }
        };
        /**
         * Called when signaling is restored
         */ this._onSignalingReconnected = ()=>{
            if (this._signalingStatus !== Call.State.Reconnecting) return;
            this._log.info('Signaling Connection reestablished.');
            this._signalingStatus = Call.State.Open;
            if (this._mediaStatus === Call.State.Open) {
                this._publisher.info('connection', 'reconnected', null, this);
                this._log.debug('#reconnected');
                this.emit('reconnected');
                this._status = Call.State.Open;
            }
        };
        /**
         * Called when we receive a transportClose event from pstream.
         * Re-emits the event.
         */ this._onTransportClose = ()=>{
            this._log.error('Received transportClose from pstream');
            this._log.debug('#transportClose');
            this.emit('transportClose');
            if (this._signalingReconnectToken) {
                this._status = Call.State.Reconnecting;
                this._signalingStatus = Call.State.Reconnecting;
                this._log.debug('#reconnecting');
                this.emit('reconnecting', new (0, _errors.SignalingErrors).ConnectionDisconnected());
            } else {
                this._status = Call.State.Closed;
                this._signalingStatus = Call.State.Closed;
            }
        };
        /**
         * Re-emit an StatsMonitor warning as a {@link Call}.warning or .warning-cleared event.
         * @param warningData
         * @param wasCleared - Whether this is a -cleared or -raised event.
         */ this._reemitWarning = (warningData, wasCleared)=>{
            const groupPrefix = /^audio/.test(warningData.name) ? 'audio-level-' : 'network-quality-';
            const warningPrefix = WARNING_PREFIXES[warningData.threshold.name];
            /**
             * NOTE: There are two "packet-loss" warnings: `high-packet-loss` and
             * `high-packets-lost-fraction`, so in this case we need to use a different
             * `WARNING_NAME` mapping.
             */ let warningName;
            if (warningData.name in MULTIPLE_THRESHOLD_WARNING_NAMES) warningName = MULTIPLE_THRESHOLD_WARNING_NAMES[warningData.name][warningData.threshold.name];
            else if (warningData.name in WARNING_NAMES) warningName = WARNING_NAMES[warningData.name];
            const warning = warningPrefix + warningName;
            this._emitWarning(groupPrefix, warning, warningData.threshold.value, warningData.values || warningData.value, wasCleared, warningData);
        };
        /**
         * Re-emit an StatsMonitor warning-cleared as a .warning-cleared event.
         * @param warningData
         */ this._reemitWarningCleared = (warningData)=>{
            this._reemitWarning(warningData, true);
        };
        this._isUnifiedPlanDefault = config.isUnifiedPlanDefault;
        this._soundcache = config.soundcache;
        if (typeof config.onIgnore === 'function') this._onIgnore = config.onIgnore;
        const message = options && options.twimlParams || {};
        this.customParameters = new Map(Object.entries(message).map(([key, val])=>[
                key,
                String(val)
            ]));
        Object.assign(this._options, options);
        if (this._options.callParameters) this.parameters = this._options.callParameters;
        if (this._options.reconnectToken) this._signalingReconnectToken = this._options.reconnectToken;
        this._voiceEventSidGenerator = this._options.voiceEventSidGenerator || (0, _uuid.generateVoiceEventSid);
        this._direction = this.parameters.CallSid && !this._options.reconnectCallSid ? Call.CallDirection.Incoming : Call.CallDirection.Outgoing;
        if (this.parameters) this.callerInfo = this.parameters.StirStatus ? {
            isVerified: this.parameters.StirStatus === 'TN-Validation-Passed-A'
        } : null;
        else this.callerInfo = null;
        this._mediaReconnectBackoff = new (0, _backoffDefault.default)(BACKOFF_CONFIG);
        this._mediaReconnectBackoff.on('ready', ()=>this._mediaHandler.iceRestart());
        // temporary call sid to be used for outgoing calls
        this.outboundConnectionId = generateTempCallSid();
        const publisher = this._publisher = config.publisher;
        if (this._direction === Call.CallDirection.Incoming) publisher.info('connection', 'incoming', null, this);
        else publisher.info('connection', 'outgoing', {
            preflight: this._options.preflight,
            reconnect: !!this._options.reconnectCallSid
        }, this);
        const monitor = this._monitor = new (this._options.StatsMonitor || (0, _statsMonitorDefault.default))();
        monitor.on('sample', this._onRTCSample);
        // First 20 seconds or so are choppy, so let's not bother with these warnings.
        monitor.disableWarnings();
        setTimeout(()=>monitor.enableWarnings(), METRICS_DELAY);
        monitor.on('warning', (data, wasCleared)=>{
            if (data.name === 'bytesSent' || data.name === 'bytesReceived') this._onMediaFailure(Call.MediaFailure.LowBytes);
            this._reemitWarning(data, wasCleared);
        });
        monitor.on('warning-cleared', (data)=>{
            this._reemitWarningCleared(data);
        });
        this._mediaHandler = new this._options.MediaHandler(config.audioHelper, config.pstream, {
            RTCPeerConnection: this._options.RTCPeerConnection,
            codecPreferences: this._options.codecPreferences,
            dscp: this._options.dscp,
            forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
            isUnifiedPlan: this._isUnifiedPlanDefault,
            maxAverageBitrate: this._options.maxAverageBitrate
        });
        this.on('volume', (inputVolume, outputVolume)=>{
            this._inputVolumeStreak = this._checkVolume(inputVolume, this._inputVolumeStreak, this._latestInputVolume, 'input');
            this._outputVolumeStreak = this._checkVolume(outputVolume, this._outputVolumeStreak, this._latestOutputVolume, 'output');
            this._latestInputVolume = inputVolume;
            this._latestOutputVolume = outputVolume;
        });
        this._mediaHandler.onaudio = (remoteAudio)=>{
            this._log.debug('#audio');
            this.emit('audio', remoteAudio);
        };
        this._mediaHandler.onvolume = (inputVolume, outputVolume, internalInputVolume, internalOutputVolume)=>{
            // (rrowland) These values mock the 0 -> 32767 format used by legacy getStats. We should look into
            // migrating to a newer standard, either 0.0 -> linear or -127 to 0 in dB, matching the range
            // chosen below.
            monitor.addVolumes(internalInputVolume / 255 * 32767, internalOutputVolume / 255 * 32767);
            // (rrowland) 0.0 -> 1.0 linear
            this.emit('volume', inputVolume, outputVolume);
        };
        this._mediaHandler.ondtlstransportstatechange = (state)=>{
            const level = state === 'failed' ? 'error' : 'debug';
            this._publisher.post(level, 'dtls-transport-state', state, null, this);
        };
        this._mediaHandler.onpcconnectionstatechange = (state)=>{
            let level = 'debug';
            const dtlsTransport = this._mediaHandler.getRTCDtlsTransport();
            if (state === 'failed') level = dtlsTransport && dtlsTransport.state === 'failed' ? 'error' : 'warning';
            this._publisher.post(level, 'pc-connection-state', state, null, this);
        };
        this._mediaHandler.onicecandidate = (candidate)=>{
            const payload = new (0, _icecandidate.IceCandidate)(candidate).toPayload();
            this._publisher.debug('ice-candidate', 'ice-candidate', payload, this);
        };
        this._mediaHandler.onselectedcandidatepairchange = (pair)=>{
            const localCandidatePayload = new (0, _icecandidate.IceCandidate)(pair.local).toPayload();
            const remoteCandidatePayload = new (0, _icecandidate.IceCandidate)(pair.remote, true).toPayload();
            this._publisher.debug('ice-candidate', 'selected-ice-candidate-pair', {
                local_candidate: localCandidatePayload,
                remote_candidate: remoteCandidatePayload
            }, this);
        };
        this._mediaHandler.oniceconnectionstatechange = (state)=>{
            const level = state === 'failed' ? 'error' : 'debug';
            this._publisher.post(level, 'ice-connection-state', state, null, this);
        };
        this._mediaHandler.onicegatheringfailure = (type)=>{
            this._publisher.warn('ice-gathering-state', type, null, this);
            this._onMediaFailure(Call.MediaFailure.IceGatheringFailed);
        };
        this._mediaHandler.onicegatheringstatechange = (state)=>{
            this._publisher.debug('ice-gathering-state', state, null, this);
        };
        this._mediaHandler.onsignalingstatechange = (state)=>{
            this._publisher.debug('signaling-state', state, null, this);
        };
        this._mediaHandler.ondisconnected = (msg)=>{
            this._log.warn(msg);
            this._publisher.warn('network-quality-warning-raised', 'ice-connectivity-lost', {
                message: msg
            }, this);
            this._log.debug('#warning', 'ice-connectivity-lost');
            this.emit('warning', 'ice-connectivity-lost');
            this._onMediaFailure(Call.MediaFailure.ConnectionDisconnected);
        };
        this._mediaHandler.onfailed = (msg)=>{
            this._onMediaFailure(Call.MediaFailure.ConnectionFailed);
        };
        this._mediaHandler.onconnected = ()=>{
            // First time _mediaHandler is connected, but ICE Gathering issued an ICE restart and succeeded.
            if (this._status === Call.State.Reconnecting) this._onMediaReconnected();
        };
        this._mediaHandler.onreconnected = (msg)=>{
            this._log.info(msg);
            this._publisher.info('network-quality-warning-cleared', 'ice-connectivity-lost', {
                message: msg
            }, this);
            this._log.debug('#warning-cleared', 'ice-connectivity-lost');
            this.emit('warning-cleared', 'ice-connectivity-lost');
            this._onMediaReconnected();
        };
        this._mediaHandler.onerror = (e)=>{
            if (e.disconnect === true) this._disconnect(e.info && e.info.message);
            const error = e.info.twilioError || new (0, _errors.GeneralErrors).UnknownError(e.info.message);
            this._log.error('Received an error from MediaStream:', e);
            this._log.debug('#error', error);
            this.emit('error', error);
        };
        this._mediaHandler.onopen = ()=>{
            // NOTE(mroberts): While this may have been happening in previous
            // versions of Chrome, since Chrome 45 we have seen the
            // PeerConnection's onsignalingstatechange handler invoked multiple
            // times in the same signalingState 'stable'. When this happens, we
            // invoke this onopen function. If we invoke it twice without checking
            // for _status 'open', we'd accidentally close the PeerConnection.
            //
            // See <https://code.google.com/p/webrtc/issues/detail?id=4996>.
            if (this._status === Call.State.Open || this._status === Call.State.Reconnecting) return;
            else if (this._status === Call.State.Ringing || this._status === Call.State.Connecting) {
                this.mute(this._mediaHandler.isMuted);
                this._mediaStatus = Call.State.Open;
                this._maybeTransitionToOpen();
            } else // call was probably canceled sometime before this
            this._mediaHandler.close();
        };
        this._mediaHandler.onclose = ()=>{
            this._status = Call.State.Closed;
            if (this._options.shouldPlayDisconnect && this._options.shouldPlayDisconnect() && !this._isCancelled && !this._isRejected) this._soundcache.get((0, _deviceDefault.default).SoundName.Disconnect).play();
            monitor.disable();
            this._publishMetrics();
            if (!this._isCancelled && !this._isRejected) {
                // tslint:disable no-console
                this._log.debug('#disconnect');
                this.emit('disconnect', this);
            }
        };
        this._pstream = config.pstream;
        this._pstream.on('ack', this._onAck);
        this._pstream.on('cancel', this._onCancel);
        this._pstream.on('error', this._onSignalingError);
        this._pstream.on('ringing', this._onRinging);
        this._pstream.on('transportClose', this._onTransportClose);
        this._pstream.on('connected', this._onConnected);
        this._pstream.on('message', this._onMessageReceived);
        this.on('error', (error)=>{
            this._publisher.error('connection', 'error', {
                code: error.code,
                message: error.message
            }, this);
            if (this._pstream && this._pstream.status === 'disconnected') this._cleanupEventListeners();
        });
        this.on('disconnect', ()=>{
            this._cleanupEventListeners();
        });
    }
    /**
     * Whether this {@link Call} is incoming or outgoing.
     */ get direction() {
        return this._direction;
    }
    /**
     * Audio codec used for this {@link Call}. Expecting {@link Call.Codec} but
     * will copy whatever we get from RTC stats.
     */ get codec() {
        return this._codec;
    }
    /**
     * The connect token is available as soon as the call is established
     * and connected to Twilio. Use this token to reconnect to a call via the {@link Device.connect}
     * method.
     *
     * For incoming calls, it is available in the call object after the {@link Device.incomingEvent} is emitted.
     * For outgoing calls, it is available after the {@link Call.acceptEvent} is emitted.
     */ get connectToken() {
        const signalingReconnectToken = this._signalingReconnectToken;
        const callSid = this.parameters && this.parameters.CallSid ? this.parameters.CallSid : undefined;
        if (!signalingReconnectToken || !callSid) return;
        const customParameters = this.customParameters && typeof this.customParameters.keys === 'function' ? Array.from(this.customParameters.keys()).reduce((result, key)=>{
            result[key] = this.customParameters.get(key);
            return result;
        }, {}) : {};
        const parameters = this.parameters || {};
        return btoa(encodeURIComponent(JSON.stringify({
            customParameters,
            parameters,
            signalingReconnectToken
        })));
    }
    /**
     * Set the audio input tracks from a given stream.
     * @param stream
     * @private
     */ _setInputTracksFromStream(stream) {
        return this._mediaHandler.setInputTracksFromStream(stream);
    }
    /**
     * Set the audio output sink IDs.
     * @param sinkIds
     * @private
     */ _setSinkIds(sinkIds) {
        return this._mediaHandler._setSinkIds(sinkIds);
    }
    /**
     * Accept the incoming {@link Call}.
     * @param [options]
     */ accept(options) {
        this._log.debug('.accept', options);
        if (this._status !== Call.State.Pending) {
            this._log.debug(`.accept noop. status is '${this._status}'`);
            return;
        }
        options = options || {};
        const rtcConfiguration = options.rtcConfiguration || this._options.rtcConfiguration;
        const rtcConstraints = options.rtcConstraints || this._options.rtcConstraints || {};
        const audioConstraints = {
            audio: typeof rtcConstraints.audio !== 'undefined' ? rtcConstraints.audio : true
        };
        this._status = Call.State.Connecting;
        const connect = ()=>{
            if (this._status !== Call.State.Connecting) {
                // call must have been canceled
                this._cleanupEventListeners();
                this._mediaHandler.close();
                return;
            }
            const onAnswer = (pc)=>{
                // Report that the call was answered, and directionality
                const eventName = this._direction === Call.CallDirection.Incoming ? 'accepted-by-local' : 'accepted-by-remote';
                this._publisher.info('connection', eventName, null, this);
                // Report the preferred codec and params as they appear in the SDP
                const { codecName, codecParams } = (0, _sdp.getPreferredCodecInfo)(this._mediaHandler.version.getSDP());
                this._publisher.info('settings', 'codec', {
                    codec_params: codecParams,
                    selected_codec: codecName
                }, this);
                // Enable RTC monitoring
                this._monitor.enable(pc);
            };
            const sinkIds = typeof this._options.getSinkIds === 'function' && this._options.getSinkIds();
            if (Array.isArray(sinkIds)) this._mediaHandler._setSinkIds(sinkIds).catch(()=>{
            // (rrowland) We don't want this to throw to console since the customer
            // can't control this. This will most commonly be rejected on browsers
            // that don't support setting sink IDs.
            });
            this._pstream.addListener('hangup', this._onHangup);
            if (this._direction === Call.CallDirection.Incoming) {
                this._isAnswered = true;
                this._pstream.on('answer', this._onAnswer);
                this._mediaHandler.answerIncomingCall(this.parameters.CallSid, this._options.offerSdp, rtcConfiguration, onAnswer);
            } else {
                const params = Array.from(this.customParameters.entries()).map((pair)=>`${encodeURIComponent(pair[0])}=${encodeURIComponent(pair[1])}`).join('&');
                this._pstream.on('answer', this._onAnswer);
                this._mediaHandler.makeOutgoingCall(params, this._signalingReconnectToken, this._options.reconnectCallSid || this.outboundConnectionId, rtcConfiguration, onAnswer);
            }
        };
        if (this._options.beforeAccept) this._options.beforeAccept(this);
        const inputStream = typeof this._options.getInputStream === 'function' && this._options.getInputStream();
        const promise = inputStream ? this._mediaHandler.setInputTracksFromStream(inputStream) : this._mediaHandler.openDefaultDeviceWithConstraints(audioConstraints);
        promise.then(()=>{
            this._publisher.info('get-user-media', 'succeeded', {
                data: {
                    audioConstraints
                }
            }, this);
            connect();
        }, (error)=>{
            let twilioError;
            if (error.code === 31208 || [
                'PermissionDeniedError',
                'NotAllowedError'
            ].indexOf(error.name) !== -1) {
                twilioError = new (0, _errors.UserMediaErrors).PermissionDeniedError();
                this._publisher.error('get-user-media', 'denied', {
                    data: {
                        audioConstraints,
                        error
                    }
                }, this);
            } else {
                twilioError = new (0, _errors.UserMediaErrors).AcquisitionFailedError();
                this._publisher.error('get-user-media', 'failed', {
                    data: {
                        audioConstraints,
                        error
                    }
                }, this);
            }
            this._disconnect();
            this._log.debug('#error', error);
            this.emit('error', twilioError);
        });
    }
    /**
     * Disconnect from the {@link Call}.
     */ disconnect() {
        this._log.debug('.disconnect');
        this._disconnect();
    }
    /**
     * Get the local MediaStream, if set.
     */ getLocalStream() {
        return this._mediaHandler && this._mediaHandler.stream;
    }
    /**
     * Get the remote MediaStream, if set.
     */ getRemoteStream() {
        return this._mediaHandler && this._mediaHandler._remoteStream;
    }
    /**
     * Ignore the incoming {@link Call}.
     */ ignore() {
        this._log.debug('.ignore');
        if (this._status !== Call.State.Pending) {
            this._log.debug(`.ignore noop. status is '${this._status}'`);
            return;
        }
        this._status = Call.State.Closed;
        this._mediaHandler.ignore(this.parameters.CallSid);
        this._publisher.info('connection', 'ignored-by-local', null, this);
        if (this._onIgnore) this._onIgnore();
    }
    /**
     * Check whether call is muted
     */ isMuted() {
        return this._mediaHandler.isMuted;
    }
    /**
     * Mute incoming audio.
     * @param shouldMute - Whether the incoming audio should be muted. Defaults to true.
     */ mute(shouldMute = true) {
        this._log.debug('.mute', shouldMute);
        const wasMuted = this._mediaHandler.isMuted;
        this._mediaHandler.mute(shouldMute);
        const isMuted = this._mediaHandler.isMuted;
        if (wasMuted !== isMuted) {
            this._publisher.info('connection', isMuted ? 'muted' : 'unmuted', null, this);
            this._log.debug('#mute', isMuted);
            this.emit('mute', isMuted, this);
        }
    }
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has given call quality feedback. Called without a score, this
     *   will report that the customer declined to give feedback.
     * @param score - The end-user's rating of the call; an
     *   integer 1 through 5. Or undefined if the user declined to give
     *   feedback.
     * @param issue - The primary issue the end user
     *   experienced on the call. Can be: ['one-way-audio', 'choppy-audio',
     *   'dropped-call', 'audio-latency', 'noisy-call', 'echo']
     */ postFeedback(score, issue) {
        if (typeof score === 'undefined' || score === null) return this._postFeedbackDeclined();
        if (!Object.values(Call.FeedbackScore).includes(score)) throw new (0, _errors.InvalidArgumentError)(`Feedback score must be one of: ${Object.values(Call.FeedbackScore)}`);
        if (typeof issue !== 'undefined' && issue !== null && !Object.values(Call.FeedbackIssue).includes(issue)) throw new (0, _errors.InvalidArgumentError)(`Feedback issue must be one of: ${Object.values(Call.FeedbackIssue)}`);
        return this._publisher.info('feedback', 'received', {
            issue_name: issue,
            quality_score: score
        }, this, true);
    }
    /**
     * Reject the incoming {@link Call}.
     */ reject() {
        this._log.debug('.reject');
        if (this._status !== Call.State.Pending) {
            this._log.debug(`.reject noop. status is '${this._status}'`);
            return;
        }
        this._isRejected = true;
        this._pstream.reject(this.parameters.CallSid);
        this._mediaHandler.reject(this.parameters.CallSid);
        this._publisher.info('connection', 'rejected-by-local', null, this);
        this._cleanupEventListeners();
        this._mediaHandler.close();
        this._status = Call.State.Closed;
        this._log.debug('#reject');
        this.emit('reject');
    }
    /**
     * Send a string of digits.
     * @param digits
     */ sendDigits(digits) {
        this._log.debug('.sendDigits', digits);
        if (digits.match(/[^0-9*#w]/)) throw new (0, _errors.InvalidArgumentError)('Illegal character passed into sendDigits');
        const customSounds = this._options.customSounds || {};
        const sequence = [];
        digits.split('').forEach((digit)=>{
            let dtmf = digit !== 'w' ? `dtmf${digit}` : '';
            if (dtmf === 'dtmf*') dtmf = 'dtmfs';
            if (dtmf === 'dtmf#') dtmf = 'dtmfh';
            sequence.push(dtmf);
        });
        const playNextDigit = ()=>{
            const digit = sequence.shift();
            if (digit) {
                if (this._options.dialtonePlayer && !customSounds[digit]) this._options.dialtonePlayer.play(digit);
                else this._soundcache.get(digit).play();
            }
            if (sequence.length) setTimeout(()=>playNextDigit(), 200);
        };
        playNextDigit();
        const dtmfSender = this._mediaHandler.getOrCreateDTMFSender();
        function insertDTMF(dtmfs) {
            if (!dtmfs.length) return;
            const dtmf = dtmfs.shift();
            if (dtmf && dtmf.length) dtmfSender.insertDTMF(dtmf, DTMF_TONE_DURATION, DTMF_INTER_TONE_GAP);
            setTimeout(insertDTMF.bind(null, dtmfs), DTMF_PAUSE_DURATION);
        }
        if (dtmfSender) {
            if (!('canInsertDTMF' in dtmfSender) || dtmfSender.canInsertDTMF) {
                this._log.info('Sending digits using RTCDTMFSender');
                // NOTE(mroberts): We can't just map 'w' to ',' since
                // RTCDTMFSender's pause duration is 2 s and Twilio's is more
                // like 500 ms. Instead, we will fudge it with setTimeout.
                insertDTMF(digits.split('w'));
                return;
            }
            this._log.info('RTCDTMFSender cannot insert DTMF');
        }
        // send pstream message to send DTMF
        this._log.info('Sending digits over PStream');
        if (this._pstream !== null && this._pstream.status !== 'disconnected') this._pstream.dtmf(this.parameters.CallSid, digits);
        else {
            const error = new (0, _errors.GeneralErrors).ConnectionError('Could not send DTMF: Signaling channel is disconnected');
            this._log.debug('#error', error);
            this.emit('error', error);
        }
    }
    /**
     * Send a message to Twilio. Your backend application can listen for these
     * messages to allow communication between your frontend and backend applications.
     * <br/><br/>This feature is currently in Beta.
     * @param message - The message object to send.
     * @returns A voice event sid that uniquely identifies the message that was sent.
     */ sendMessage(message) {
        this._log.debug('.sendMessage', JSON.stringify(message));
        const { content, contentType, messageType } = message;
        if (typeof content === 'undefined' || content === null) throw new (0, _errors.InvalidArgumentError)('`content` is empty');
        if (typeof messageType !== 'string') throw new (0, _errors.InvalidArgumentError)('`messageType` must be a string.');
        if (messageType.length === 0) throw new (0, _errors.InvalidArgumentError)('`messageType` must be a non-empty string.');
        if (this._pstream === null) throw new (0, _errors.InvalidStateError)('Could not send CallMessage; Signaling channel is disconnected');
        const callSid = this.parameters.CallSid;
        if (typeof this.parameters.CallSid === 'undefined') throw new (0, _errors.InvalidStateError)('Could not send CallMessage; Call has no CallSid');
        const voiceEventSid = this._voiceEventSidGenerator();
        this._messages.set(voiceEventSid, {
            content,
            contentType,
            messageType,
            voiceEventSid
        });
        this._pstream.sendMessage(callSid, content, contentType, messageType, voiceEventSid);
        return voiceEventSid;
    }
    /**
     * Get the current {@link Call} status.
     */ status() {
        return this._status;
    }
    /**
     * Check the volume passed, emitting a warning if one way audio is detected or cleared.
     * @param currentVolume - The current volume for this direction
     * @param streakFieldName - The name of the field on the {@link Call} object that tracks how many times the
     *   current value has been repeated consecutively.
     * @param lastValueFieldName - The name of the field on the {@link Call} object that tracks the most recent
     *   volume for this direction
     * @param direction - The directionality of this audio track, either 'input' or 'output'
     * @returns The current streak; how many times in a row the same value has been polled.
     */ _checkVolume(currentVolume, currentStreak, lastValue, direction) {
        const wasWarningRaised = currentStreak >= 10;
        let newStreak = 0;
        if (lastValue === currentVolume) newStreak = currentStreak;
        if (newStreak >= 10) this._emitWarning('audio-level-', `constant-audio-${direction}-level`, 10, newStreak, false);
        else if (wasWarningRaised) this._emitWarning('audio-level-', `constant-audio-${direction}-level`, 10, newStreak, true);
        return newStreak;
    }
    /**
     * Clean up event listeners.
     */ _cleanupEventListeners() {
        const cleanup = ()=>{
            if (!this._pstream) return;
            this._pstream.removeListener('ack', this._onAck);
            this._pstream.removeListener('answer', this._onAnswer);
            this._pstream.removeListener('cancel', this._onCancel);
            this._pstream.removeListener('error', this._onSignalingError);
            this._pstream.removeListener('hangup', this._onHangup);
            this._pstream.removeListener('ringing', this._onRinging);
            this._pstream.removeListener('transportClose', this._onTransportClose);
            this._pstream.removeListener('connected', this._onConnected);
            this._pstream.removeListener('message', this._onMessageReceived);
        };
        // This is kind of a hack, but it lets us avoid rewriting more code.
        // Basically, there's a sequencing problem with the way PeerConnection raises
        // the
        //
        //   Cannot establish call. SDK is disconnected
        //
        // error in Call#accept. It calls PeerConnection#onerror, which emits
        // the error event on Call. An error handler on Call then calls
        // cleanupEventListeners, but then control returns to Call#accept. It's
        // at this point that we add a listener for the answer event that never gets
        // removed. setTimeout will allow us to rerun cleanup again, _after_
        // Call#accept returns.
        cleanup();
        setTimeout(cleanup, 0);
    }
    /**
     * Create the payload wrapper for a batch of metrics to be sent to Insights.
     */ _createMetricPayload() {
        const payload = {
            call_sid: this.parameters.CallSid,
            dscp: !!this._options.dscp,
            sdk_version: (0, _constants.RELEASE_VERSION)
        };
        if (this._options.gateway) payload.gateway = this._options.gateway;
        payload.direction = this._direction;
        return payload;
    }
    /**
     * Disconnect the {@link Call}.
     * @param message - A message explaining why the {@link Call} is being disconnected.
     * @param wasRemote - Whether the disconnect was triggered locally or remotely.
     */ _disconnect(message, wasRemote) {
        message = typeof message === 'string' ? message : null;
        if (this._status !== Call.State.Open && this._status !== Call.State.Connecting && this._status !== Call.State.Reconnecting && this._status !== Call.State.Ringing) return;
        this._log.info('Disconnecting...');
        // send pstream hangup message
        if (this._pstream !== null && this._pstream.status !== 'disconnected' && this._shouldSendHangup) {
            const callsid = this.parameters.CallSid || this.outboundConnectionId;
            if (callsid) this._pstream.hangup(callsid, message);
        }
        this._cleanupEventListeners();
        this._mediaHandler.close();
        if (!wasRemote) this._publisher.info('connection', 'disconnected-by-local', null, this);
    }
    /**
     * Transition to {@link CallStatus.Open} if criteria is met.
     */ _maybeTransitionToOpen() {
        const wasConnected = this._wasConnected;
        if (this._isAnswered) {
            this._onSignalingReconnected();
            this._signalingStatus = Call.State.Open;
            if (this._mediaHandler && this._mediaHandler.status === 'open') {
                this._status = Call.State.Open;
                if (!this._wasConnected) {
                    this._wasConnected = true;
                    this._log.debug('#accept');
                    this.emit('accept', this);
                }
            }
        }
    }
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has ignored a request for feedback.
     */ _postFeedbackDeclined() {
        return this._publisher.info('feedback', 'received-none', null, this, true);
    }
    /**
     * Publish the current set of queued metrics samples to Insights.
     */ _publishMetrics() {
        if (this._metricsSamples.length === 0) return;
        this._publisher.postMetrics('quality-metrics-samples', 'metrics-sample', this._metricsSamples.splice(0), this._createMetricPayload(), this).catch((e)=>{
            this._log.warn('Unable to post metrics to Insights. Received error:', e);
        });
    }
    /**
     * Set the CallSid
     * @param payload
     */ _setCallSid(payload) {
        const callSid = payload.callsid;
        if (!callSid) return;
        this.parameters.CallSid = callSid;
        this._mediaHandler.callSid = callSid;
    }
}
/**
 * String representation of the {@link Call} class.
 * @private
 */ Call.toString = ()=>'[Twilio.Call class]';
(function(Call) {
    /**
     * Possible states of the {@link Call}.
     */ let State;
    (function(State) {
        State["Closed"] = "closed";
        State["Connecting"] = "connecting";
        State["Open"] = "open";
        State["Pending"] = "pending";
        State["Reconnecting"] = "reconnecting";
        State["Ringing"] = "ringing";
    })(State = Call.State || (Call.State = {}));
    /**
     * Different issues that may have been experienced during a call, that can be
     * reported to Twilio Insights via {@link Call}.postFeedback().
     */ let FeedbackIssue;
    (function(FeedbackIssue) {
        FeedbackIssue["AudioLatency"] = "audio-latency";
        FeedbackIssue["ChoppyAudio"] = "choppy-audio";
        FeedbackIssue["DroppedCall"] = "dropped-call";
        FeedbackIssue["Echo"] = "echo";
        FeedbackIssue["NoisyCall"] = "noisy-call";
        FeedbackIssue["OneWayAudio"] = "one-way-audio";
    })(FeedbackIssue = Call.FeedbackIssue || (Call.FeedbackIssue = {}));
    /**
     * A rating of call quality experienced during a call, to be reported to Twilio Insights
     * via {@link Call}.postFeedback().
     */ let FeedbackScore;
    (function(FeedbackScore) {
        FeedbackScore[FeedbackScore["One"] = 1] = "One";
        FeedbackScore[FeedbackScore["Two"] = 2] = "Two";
        FeedbackScore[FeedbackScore["Three"] = 3] = "Three";
        FeedbackScore[FeedbackScore["Four"] = 4] = "Four";
        FeedbackScore[FeedbackScore["Five"] = 5] = "Five";
    })(FeedbackScore = Call.FeedbackScore || (Call.FeedbackScore = {}));
    /**
     * The directionality of the {@link Call}, whether incoming or outgoing.
     */ let CallDirection;
    (function(CallDirection) {
        CallDirection["Incoming"] = "INCOMING";
        CallDirection["Outgoing"] = "OUTGOING";
    })(CallDirection = Call.CallDirection || (Call.CallDirection = {}));
    /**
     * Valid audio codecs to use for the media connection.
     */ let Codec;
    (function(Codec) {
        Codec["Opus"] = "opus";
        Codec["PCMU"] = "pcmu";
    })(Codec = Call.Codec || (Call.Codec = {}));
    /**
     * Possible ICE Gathering failures
     */ let IceGatheringFailureReason;
    (function(IceGatheringFailureReason) {
        IceGatheringFailureReason["None"] = "none";
        IceGatheringFailureReason["Timeout"] = "timeout";
    })(IceGatheringFailureReason = Call.IceGatheringFailureReason || (Call.IceGatheringFailureReason = {}));
    /**
     * Possible media failures
     */ let MediaFailure;
    (function(MediaFailure) {
        MediaFailure["ConnectionDisconnected"] = "ConnectionDisconnected";
        MediaFailure["ConnectionFailed"] = "ConnectionFailed";
        MediaFailure["IceGatheringFailed"] = "IceGatheringFailed";
        MediaFailure["LowBytes"] = "LowBytes";
    })(MediaFailure = Call.MediaFailure || (Call.MediaFailure = {}));
})(Call || (Call = {}));
function generateTempCallSid() {
    return 'TJSxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        /* tslint:disable:no-bitwise */ const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        /* tslint:enable:no-bitwise */ return v.toString(16);
    });
}
exports.default = Call;

},{"events":"fqTtD","./backoff":"5InnX","./device":"iaq4W","./errors":"caXI8","./log":"eJjQN","./rtc":"7NmEm","./rtc/icecandidate":"5YOkc","./rtc/sdp":"IFzxc","./statsMonitor":"g8Mqi","./util":"j8qrE","./uuid":"2zIUQ","./constants":"buVX6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqTtD":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"5InnX":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @internalapi
 */ // @ts-nocheck
// NOTE (csantos): This file was taken directly from twilio-video and has been renamed from JS to TS only.
// It needs to be re-written as part of the overall updating of the files to TS.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
class Backoff extends (0, _events.EventEmitter) {
    /**
     * Construct a {@link Backoff}.
     * @param {object} options
     * @property {number} min - Initial timeout in milliseconds [100]
     * @property {number} max - Max timeout [10000]
     * @property {boolean} jitter - Apply jitter [0]
     * @property {number} factor - Multiplication factor for Backoff operation [2]
     */ constructor(options){
        super();
        Object.defineProperties(this, {
            _attempts: {
                value: 0,
                writable: true
            },
            _duration: {
                enumerable: false,
                get () {
                    let ms = this._min * Math.pow(this._factor, this._attempts);
                    if (this._jitter) {
                        const rand = Math.random();
                        const deviation = Math.floor(rand * this._jitter * ms);
                        // tslint:disable-next-line
                        ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
                    }
                    // tslint:disable-next-line
                    return Math.min(ms, this._max) | 0;
                }
            },
            _factor: {
                value: options.factor || 2
            },
            _jitter: {
                value: options.jitter > 0 && options.jitter <= 1 ? options.jitter : 0
            },
            _max: {
                value: options.max || 10000
            },
            _min: {
                value: options.min || 100
            },
            _timeoutID: {
                value: null,
                writable: true
            }
        });
    }
    backoff() {
        const duration = this._duration;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
        this.emit('backoff', this._attempts, duration);
        this._timeoutID = setTimeout(()=>{
            this.emit('ready', this._attempts, duration);
            this._attempts++;
        }, duration);
    }
    reset() {
        this._attempts = 0;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
    }
}
exports.default = Backoff;

},{"events":"fqTtD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaq4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @packageDocumentation
 * @module Voice
 * @preferred
 * @publicapi
 */ var _events = require("events");
var _loglevel = require("loglevel");
var _audiohelper = require("./audiohelper");
var _audiohelperDefault = parcelHelpers.interopDefault(_audiohelper);
var _audioprocessoreventobserver = require("./audioprocessoreventobserver");
var _call = require("./call");
var _callDefault = parcelHelpers.interopDefault(_call);
var _constants = require("./constants");
var _dialtonePlayer = require("./dialtonePlayer");
var _dialtonePlayerDefault = parcelHelpers.interopDefault(_dialtonePlayer);
var _errors = require("./errors");
var _eventpublisher = require("./eventpublisher");
var _eventpublisherDefault = parcelHelpers.interopDefault(_eventpublisher);
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _preflight = require("./preflight/preflight");
var _pstream = require("./pstream");
var _pstreamDefault = parcelHelpers.interopDefault(_pstream);
var _regions = require("./regions");
var _rtc = require("./rtc");
var _getusermedia = require("./rtc/getusermedia");
var _getusermediaDefault = parcelHelpers.interopDefault(_getusermedia);
var _sound = require("./sound");
var _soundDefault = parcelHelpers.interopDefault(_sound);
var _util = require("./util");
var _uuid = require("./uuid");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const REGISTRATION_INTERVAL = 30000;
const RINGTONE_PLAY_TIMEOUT = 2000;
const PUBLISHER_PRODUCT_NAME = 'twilio-js-sdk';
const INVALID_TOKEN_MESSAGE = 'Parameter "token" must be of type "string".';
/**
 * Twilio Device. Allows registration for incoming calls, and placing outgoing calls.
 * @publicapi
 */ class Device extends (0, _events.EventEmitter) {
    /**
     * Construct a {@link Device} instance. The {@link Device} can be registered
     * to make and listen for calls using {@link Device.register}.
     * @constructor
     * @param options
     */ constructor(token, options = {}){
        super();
        /**
         * The currently active {@link Call}, if there is one.
         */ this._activeCall = null;
        /**
         * The AudioHelper instance associated with this {@link Device}.
         */ this._audio = null;
        /**
         * The AudioProcessorEventObserver instance to use
         */ this._audioProcessorEventObserver = null;
        /**
         * An audio input MediaStream to pass to new {@link Call} instances.
         */ this._callInputStream = null;
        /**
         * An array of {@link Call}s. Though only one can be active, multiple may exist when there
         * are multiple incoming, unanswered {@link Call}s.
         */ this._calls = [];
        /**
         * An array of {@link Device} IDs to be used to play sounds through, to be passed to
         * new {@link Call} instances.
         */ this._callSinkIds = [
            'default'
        ];
        /**
         * The list of chunder URIs that will be passed to PStream
         */ this._chunderURIs = [];
        /**
         * Default options used by {@link Device}.
         */ this._defaultOptions = {
            allowIncomingWhileBusy: false,
            closeProtection: false,
            codecPreferences: [
                (0, _callDefault.default).Codec.PCMU,
                (0, _callDefault.default).Codec.Opus
            ],
            dscp: true,
            enableImprovedSignalingErrorPrecision: false,
            forceAggressiveIceNomination: false,
            logLevel: (0, _loglevel.levels).ERROR,
            maxCallSignalingTimeoutMs: 0,
            preflight: false,
            sounds: {},
            tokenRefreshMs: 10000,
            voiceEventSidGenerator: (0, _uuid.generateVoiceEventSid)
        };
        /**
         * The name of the edge the {@link Device} is connected to.
         */ this._edge = null;
        /**
         * The name of the home region the {@link Device} is connected to.
         */ this._home = null;
        /**
         * The identity associated with this Device.
         */ this._identity = null;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('Device');
        /**
         * The internal promise created when calling {@link Device.makeCall}.
         */ this._makeCallPromise = null;
        /**
         * The options passed to {@link Device} constructor or {@link Device.updateOptions}.
         */ this._options = {};
        /**
         * The preferred URI to (re)-connect signaling to.
         */ this._preferredURI = null;
        /**
         * An Insights Event Publisher.
         */ this._publisher = null;
        /**
         * The region the {@link Device} is connected to.
         */ this._region = null;
        /**
         * A timeout ID for a setTimeout schedule to re-register the {@link Device}.
         */ this._regTimer = null;
        /**
         * Boolean representing whether or not the {@link Device} was registered when
         * receiving a signaling `offline`. Determines if the {@link Device} attempts
         * a `re-register` once signaling is re-established when receiving a
         * `connected` event from the stream.
         */ this._shouldReRegister = false;
        /**
         * A Map of Sounds to play.
         */ this._soundcache = new Map();
        /**
         * The current status of the {@link Device}.
         */ this._state = Device.State.Unregistered;
        /**
         * A map from {@link Device.State} to {@link Device.EventName}.
         */ this._stateEventMapping = {
            [Device.State.Destroyed]: Device.EventName.Destroyed,
            [Device.State.Unregistered]: Device.EventName.Unregistered,
            [Device.State.Registering]: Device.EventName.Registering,
            [Device.State.Registered]: Device.EventName.Registered
        };
        /**
         * The Signaling stream.
         */ this._stream = null;
        /**
         * A promise that will resolve when the Signaling stream is ready.
         */ this._streamConnectedPromise = null;
        /**
         * A timeout to track when the current AccessToken will expire.
         */ this._tokenWillExpireTimeout = null;
        /**
         * Create the default Insights payload
         * @param call
         */ this._createDefaultPayload = (call)=>{
            const payload = {
                aggressive_nomination: this._options.forceAggressiveIceNomination,
                browser_extension: this._isBrowserExtension,
                dscp: !!this._options.dscp,
                ice_restart_enabled: true,
                platform: _rtc.getMediaEngine(),
                sdk_version: _constants.RELEASE_VERSION
            };
            function setIfDefined(propertyName, value) {
                if (value) payload[propertyName] = value;
            }
            if (call) {
                const callSid = call.parameters.CallSid;
                setIfDefined('call_sid', /^TJ/.test(callSid) ? undefined : callSid);
                setIfDefined('temp_call_sid', call.outboundConnectionId);
                setIfDefined('audio_codec', call.codec);
                payload.direction = call.direction;
            }
            setIfDefined('gateway', this._stream && this._stream.gateway);
            setIfDefined('region', this._stream && this._stream.region);
            return payload;
        };
        /**
         * Called when a 'close' event is received from the signaling stream.
         */ this._onSignalingClose = ()=>{
            this._stream = null;
            this._streamConnectedPromise = null;
        };
        /**
         * Called when a 'connected' event is received from the signaling stream.
         */ this._onSignalingConnected = (payload)=>{
            var _a;
            const region = (0, _regions.getRegionShortcode)(payload.region);
            this._edge = payload.edge || (0, _regions.regionToEdge)[region] || payload.region;
            this._region = region || payload.region;
            this._home = payload.home;
            (_a = this._publisher) === null || _a === void 0 || _a.setHost((0, _regions.createEventGatewayURI)(payload.home));
            if (payload.token) {
                this._identity = payload.token.identity;
                if (typeof payload.token.ttl === 'number' && typeof this._options.tokenRefreshMs === 'number') {
                    const ttlMs = payload.token.ttl * 1000;
                    const timeoutMs = Math.max(0, ttlMs - this._options.tokenRefreshMs);
                    this._tokenWillExpireTimeout = setTimeout(()=>{
                        this._log.debug('#tokenWillExpire');
                        this.emit('tokenWillExpire', this);
                        if (this._tokenWillExpireTimeout) {
                            clearTimeout(this._tokenWillExpireTimeout);
                            this._tokenWillExpireTimeout = null;
                        }
                    }, timeoutMs);
                }
            }
            const preferredURIs = this._getChunderws() || (0, _regions.getChunderURIs)(this._edge);
            if (preferredURIs.length > 0) {
                const [preferredURI] = preferredURIs;
                this._preferredURI = (0, _regions.createSignalingEndpointURL)(preferredURI);
            } else this._log.warn('Could not parse a preferred URI from the stream#connected event.');
            // The signaling stream emits a `connected` event after reconnection, if the
            // device was registered before this, then register again.
            if (this._shouldReRegister) this.register();
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ this._onSignalingError = (payload)=>{
            if (typeof payload !== 'object') {
                this._log.warn('Invalid signaling error payload', payload);
                return;
            }
            const { error: originalError, callsid, voiceeventsid } = payload;
            // voiceeventsid is for call message events which are handled in the call object
            // missing originalError shouldn't be possible but check here to fail properly
            if (typeof originalError !== 'object' || !!voiceeventsid) {
                this._log.warn('Ignoring signaling error payload', {
                    originalError,
                    voiceeventsid
                });
                return;
            }
            const call = typeof callsid === 'string' && this._findCall(callsid) || undefined;
            const { code, message: customMessage } = originalError;
            let { twilioError } = originalError;
            if (typeof code === 'number') {
                if (code === 31201) twilioError = new (0, _errors.AuthorizationErrors).AuthenticationFailed(originalError);
                else if (code === 31204) twilioError = new (0, _errors.AuthorizationErrors).AccessTokenInvalid(originalError);
                else if (code === 31205) {
                    // Stop trying to register presence after token expires
                    this._stopRegistrationTimer();
                    twilioError = new (0, _errors.AuthorizationErrors).AccessTokenExpired(originalError);
                } else {
                    const errorConstructor = (0, _errors.getPreciseSignalingErrorByCode)(!!this._options.enableImprovedSignalingErrorPrecision, code);
                    if (typeof errorConstructor !== 'undefined') twilioError = new errorConstructor(originalError);
                }
            }
            if (!twilioError) {
                this._log.error('Unknown signaling error: ', originalError);
                twilioError = new (0, _errors.GeneralErrors).UnknownError(customMessage, originalError);
            }
            this._log.error('Received error: ', twilioError);
            this._log.debug('#error', originalError);
            this.emit(Device.EventName.Error, twilioError, call);
        };
        /**
         * Called when an 'invite' event is received from the signaling stream.
         */ this._onSignalingInvite = (payload)=>__awaiter(this, void 0, void 0, function*() {
                var _a;
                const wasBusy = !!this._activeCall;
                if (wasBusy && !this._options.allowIncomingWhileBusy) {
                    this._log.info('Device busy; ignoring incoming invite');
                    return;
                }
                if (!payload.callsid || !payload.sdp) {
                    this._log.debug('#error', payload);
                    this.emit(Device.EventName.Error, new (0, _errors.ClientErrors).BadRequest('Malformed invite from gateway'));
                    return;
                }
                const callParameters = payload.parameters || {};
                callParameters.CallSid = callParameters.CallSid || payload.callsid;
                const customParameters = Object.assign({}, (0, _util.queryToJson)(callParameters.Params));
                this._makeCallPromise = this._makeCall(customParameters, {
                    callParameters,
                    enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                    offerSdp: payload.sdp,
                    reconnectToken: payload.reconnect,
                    voiceEventSidGenerator: this._options.voiceEventSidGenerator
                });
                let call;
                try {
                    call = yield this._makeCallPromise;
                } finally{
                    this._makeCallPromise = null;
                }
                this._calls.push(call);
                call.once('accept', ()=>{
                    this._soundcache.get(Device.SoundName.Incoming).stop();
                    this._publishNetworkChange();
                });
                const play = ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.incoming()) && !wasBusy ? ()=>this._soundcache.get(Device.SoundName.Incoming).play() : ()=>Promise.resolve();
                this._showIncomingCall(call, play);
            });
        /**
         * Called when an 'offline' event is received from the signaling stream.
         */ this._onSignalingOffline = ()=>{
            this._log.info('Stream is offline');
            this._edge = null;
            this._region = null;
            this._shouldReRegister = this.state !== Device.State.Unregistered;
            this._setState(Device.State.Unregistered);
        };
        /**
         * Called when a 'ready' event is received from the signaling stream.
         */ this._onSignalingReady = ()=>{
            this._log.info('Stream is ready');
            this._setState(Device.State.Registered);
        };
        /**
         * Publish a NetworkInformation#change event to Insights if there's an active {@link Call}.
         */ this._publishNetworkChange = ()=>{
            if (!this._activeCall) return;
            if (this._networkInformation) this._publisher.info('network-information', 'network-change', {
                connection_type: this._networkInformation.type,
                downlink: this._networkInformation.downlink,
                downlinkMax: this._networkInformation.downlinkMax,
                effective_type: this._networkInformation.effectiveType,
                rtt: this._networkInformation.rtt
            }, this._activeCall);
        };
        /**
         * Update the input stream being used for calls so that any current call and all future calls
         * will use the new input stream.
         * @param inputStream
         */ this._updateInputStream = (inputStream)=>{
            const call = this._activeCall;
            if (call && !inputStream) return Promise.reject(new (0, _errors.InvalidStateError)('Cannot unset input device while a call is in progress.'));
            this._callInputStream = inputStream;
            return call ? call._setInputTracksFromStream(inputStream) : Promise.resolve();
        };
        /**
         * Update the device IDs of output devices being used to play sounds through.
         * @param type - Whether to update ringtone or speaker sounds
         * @param sinkIds - An array of device IDs
         */ this._updateSinkIds = (type, sinkIds)=>{
            const promise = type === 'ringtone' ? this._updateRingtoneSinkIds(sinkIds) : this._updateSpeakerSinkIds(sinkIds);
            return promise.then(()=>{
                this._publisher.info('audio', `${type}-devices-set`, {
                    audio_device_ids: sinkIds
                }, this._activeCall);
            }, (error)=>{
                this._publisher.error('audio', `${type}-devices-set-failed`, {
                    audio_device_ids: sinkIds,
                    message: error.message
                }, this._activeCall);
                throw error;
            });
        };
        // Setup loglevel asap to avoid missed logs
        this._setupLoglevel(options.logLevel);
        this._logOptions('constructor', options);
        this.updateToken(token);
        if ((0, _util.isLegacyEdge)()) throw new (0, _errors.NotSupportedError)("Microsoft Edge Legacy (https://support.microsoft.com/en-us/help/4533505/what-is-microsoft-edge-legacy) is deprecated and will not be able to connect to Twilio to make or receive calls after September 1st, 2020. Please see this documentation for a list of supported browsers https://www.twilio.com/docs/voice/client/javascript#supported-browsers");
        if (!Device.isSupported && options.ignoreBrowserSupport) {
            if (window && window.location && window.location.protocol === 'http:') throw new (0, _errors.NotSupportedError)(`twilio.js wasn't able to find WebRTC browser support. \
          This is most likely because this page is served over http rather than https, \
          which does not support WebRTC in many browsers. Please load this page over https and \
          try again.`);
            throw new (0, _errors.NotSupportedError)(`twilio.js 1.3+ SDKs require WebRTC browser support. \
        For more information, see <https://www.twilio.com/docs/api/client/twilio-js>. \
        If you have any questions about this announcement, please contact \
        Twilio Support at <help@twilio.com>.`);
        }
        const root = globalThis;
        const browser = root.msBrowser || root.browser || root.chrome;
        this._isBrowserExtension = !!browser && !!browser.runtime && !!browser.runtime.id || !!root.safari && !!root.safari.extension;
        if (this._isBrowserExtension) this._log.info('Running as browser extension.');
        if (navigator) {
            const n = navigator;
            this._networkInformation = n.connection || n.mozConnection || n.webkitConnection;
        }
        if (this._networkInformation && typeof this._networkInformation.addEventListener === 'function') this._networkInformation.addEventListener('change', this._publishNetworkChange);
        Device._getOrCreateAudioContext();
        if (Device._audioContext) {
            if (!Device._dialtonePlayer) Device._dialtonePlayer = new (0, _dialtonePlayerDefault.default)(Device._audioContext);
        }
        if (typeof Device._isUnifiedPlanDefault === 'undefined') Device._isUnifiedPlanDefault = typeof window !== 'undefined' && typeof RTCPeerConnection !== 'undefined' && typeof RTCRtpTransceiver !== 'undefined' ? (0, _util.isUnifiedPlanDefault)(window, window.navigator, RTCPeerConnection, RTCRtpTransceiver) : false;
        this._boundDestroy = this.destroy.bind(this);
        this._boundConfirmClose = this._confirmClose.bind(this);
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('unload', this._boundDestroy);
            window.addEventListener('pagehide', this._boundDestroy);
        }
        this.updateOptions(options);
    }
    /**
     * The AudioContext to be used by {@link Device} instances.
     * @private
     */ static get audioContext() {
        return Device._audioContext;
    }
    /**
     * Which sound file extension is supported.
     * @private
     */ static get extension() {
        // NOTE(mroberts): Node workaround.
        const a = typeof document !== 'undefined' ? document.createElement('audio') : {
            canPlayType: false
        };
        let canPlayMp3;
        try {
            canPlayMp3 = a.canPlayType && !!a.canPlayType('audio/mpeg').replace(/no/, '');
        } catch (e) {
            canPlayMp3 = false;
        }
        let canPlayVorbis;
        try {
            canPlayVorbis = a.canPlayType && !!a.canPlayType('audio/ogg;codecs=\'vorbis\'').replace(/no/, '');
        } catch (e) {
            canPlayVorbis = false;
        }
        return canPlayVorbis && !canPlayMp3 ? 'ogg' : 'mp3';
    }
    /**
     * Whether or not this SDK is supported by the current browser.
     */ static get isSupported() {
        return _rtc.enabled();
    }
    /**
     * Package name of the SDK.
     */ static get packageName() {
        return _constants.PACKAGE_NAME;
    }
    /**
     * Run some tests to identify issues, if any, prohibiting successful calling.
     * @param token - A Twilio JWT token string
     * @param options
     */ static runPreflight(token, options) {
        return new (0, _preflight.PreflightTest)(token, Object.assign({
            audioContext: Device._getOrCreateAudioContext()
        }, options));
    }
    /**
     * String representation of {@link Device} class.
     * @private
     */ static toString() {
        return '[Twilio.Device class]';
    }
    /**
     * Current SDK version.
     */ static get version() {
        return _constants.RELEASE_VERSION;
    }
    /**
     * Initializes the AudioContext instance shared across the Voice SDK,
     * or returns the existing instance if one has already been initialized.
     */ static _getOrCreateAudioContext() {
        if (!Device._audioContext) {
            if (typeof AudioContext !== 'undefined') Device._audioContext = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') Device._audioContext = new webkitAudioContext();
        }
        return Device._audioContext;
    }
    /**
     * Return the {@link AudioHelper} used by this {@link Device}.
     */ get audio() {
        return this._audio;
    }
    /**
     * Make an outgoing Call.
     * @param options
     */ connect(options = {}) {
        return __awaiter(this, void 0, void 0, function*() {
            this._log.debug('.connect', JSON.stringify(options));
            this._throwIfDestroyed();
            if (this._activeCall) throw new (0, _errors.InvalidStateError)('A Call is already active');
            let customParameters;
            let parameters;
            let signalingReconnectToken;
            if (options.connectToken) {
                try {
                    const connectTokenParts = JSON.parse(decodeURIComponent(atob(options.connectToken)));
                    customParameters = connectTokenParts.customParameters;
                    parameters = connectTokenParts.parameters;
                    signalingReconnectToken = connectTokenParts.signalingReconnectToken;
                } catch (_a) {
                    throw new (0, _errors.InvalidArgumentError)('Cannot parse connectToken');
                }
                if (!parameters || !parameters.CallSid || !signalingReconnectToken) throw new (0, _errors.InvalidArgumentError)('Invalid connectToken');
            }
            let isReconnect = false;
            let twimlParams = {};
            const callOptions = {
                enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                rtcConfiguration: options.rtcConfiguration,
                voiceEventSidGenerator: this._options.voiceEventSidGenerator
            };
            if (signalingReconnectToken && parameters) {
                isReconnect = true;
                callOptions.callParameters = parameters;
                callOptions.reconnectCallSid = parameters.CallSid;
                callOptions.reconnectToken = signalingReconnectToken;
                twimlParams = customParameters || twimlParams;
            } else twimlParams = options.params || twimlParams;
            let activeCall;
            this._makeCallPromise = this._makeCall(twimlParams, callOptions, isReconnect);
            try {
                activeCall = this._activeCall = yield this._makeCallPromise;
            } finally{
                this._makeCallPromise = null;
            }
            // Make sure any incoming calls are ignored
            this._calls.splice(0).forEach((call)=>call.ignore());
            // Stop the incoming sound if it's playing
            this._soundcache.get(Device.SoundName.Incoming).stop();
            activeCall.accept({
                rtcConstraints: options.rtcConstraints
            });
            this._publishNetworkChange();
            return activeCall;
        });
    }
    /**
     * Return the calls that this {@link Device} is maintaining.
     */ get calls() {
        return this._calls;
    }
    /**
     * Destroy the {@link Device}, freeing references to be garbage collected.
     */ destroy() {
        var _a;
        this._log.debug('.destroy');
        this._log.debug('Rejecting any incoming calls');
        const calls = this._calls.slice(0);
        calls.forEach((call)=>call.reject());
        this.disconnectAll();
        this._stopRegistrationTimer();
        this._destroyStream();
        this._destroyPublisher();
        this._destroyAudioHelper();
        (_a = this._audioProcessorEventObserver) === null || _a === void 0 || _a.destroy();
        if (this._networkInformation && typeof this._networkInformation.removeEventListener === 'function') this._networkInformation.removeEventListener('change', this._publishNetworkChange);
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('beforeunload', this._boundConfirmClose);
            window.removeEventListener('unload', this._boundDestroy);
            window.removeEventListener('pagehide', this._boundDestroy);
        }
        this._setState(Device.State.Destroyed);
        (0, _events.EventEmitter).prototype.removeAllListeners.call(this);
    }
    /**
     * Disconnect all {@link Call}s.
     */ disconnectAll() {
        this._log.debug('.disconnectAll');
        const calls = this._calls.splice(0);
        calls.forEach((call)=>call.disconnect());
        if (this._activeCall) this._activeCall.disconnect();
    }
    /**
     * Returns the {@link Edge} value the {@link Device} is currently connected
     * to. The value will be `null` when the {@link Device} is offline.
     */ get edge() {
        return this._edge;
    }
    /**
     * Returns the home value the {@link Device} is currently connected
     * to. The value will be `null` when the {@link Device} is offline.
     */ get home() {
        return this._home;
    }
    /**
     * Returns the identity associated with the {@link Device} for incoming calls. Only
     * populated when registered.
     */ get identity() {
        return this._identity;
    }
    /**
     * Whether the Device is currently on an active Call.
     */ get isBusy() {
        return !!this._activeCall;
    }
    /**
     * Register the `Device` to the Twilio backend, allowing it to receive calls.
     */ register() {
        return __awaiter(this, void 0, void 0, function*() {
            this._log.debug('.register');
            if (this.state !== Device.State.Unregistered) throw new (0, _errors.InvalidStateError)(`Attempt to register when device is in state "${this.state}". ` + `Must be "${Device.State.Unregistered}".`);
            this._shouldReRegister = false;
            this._setState(Device.State.Registering);
            yield this._streamConnectedPromise || this._setupStream();
            yield this._sendPresence(true);
            yield (0, _util.promisifyEvents)(this, Device.State.Registered, Device.State.Unregistered);
        });
    }
    /**
     * Get the state of this {@link Device} instance
     */ get state() {
        return this._state;
    }
    /**
     * Get the token used by this {@link Device}.
     */ get token() {
        return this._token;
    }
    /**
     * String representation of {@link Device} instance.
     * @private
     */ toString() {
        return '[Twilio.Device instance]';
    }
    /**
     * Unregister the `Device` to the Twilio backend, disallowing it to receive
     * calls.
     */ unregister() {
        return __awaiter(this, void 0, void 0, function*() {
            this._log.debug('.unregister');
            if (this.state !== Device.State.Registered) throw new (0, _errors.InvalidStateError)(`Attempt to unregister when device is in state "${this.state}". ` + `Must be "${Device.State.Registered}".`);
            this._shouldReRegister = false;
            const stream = yield this._streamConnectedPromise;
            const streamOfflinePromise = new Promise((resolve)=>{
                stream.on('offline', resolve);
            });
            yield this._sendPresence(false);
            yield streamOfflinePromise;
        });
    }
    /**
     * Set the options used within the {@link Device}.
     * @param options
     */ updateOptions(options = {}) {
        this._logOptions('updateOptions', options);
        if (this.state === Device.State.Destroyed) throw new (0, _errors.InvalidStateError)(`Attempt to "updateOptions" when device is in state "${this.state}".`);
        this._options = Object.assign(Object.assign(Object.assign({}, this._defaultOptions), this._options), options);
        const originalChunderURIs = new Set(this._chunderURIs);
        const newChunderURIs = this._chunderURIs = (this._getChunderws() || (0, _regions.getChunderURIs)(this._options.edge)).map((0, _regions.createSignalingEndpointURL));
        let hasChunderURIsChanged = originalChunderURIs.size !== newChunderURIs.length;
        if (!hasChunderURIsChanged) {
            for (const uri of newChunderURIs)if (!originalChunderURIs.has(uri)) {
                hasChunderURIsChanged = true;
                break;
            }
        }
        if (this.isBusy && hasChunderURIsChanged) throw new (0, _errors.InvalidStateError)('Cannot change Edge while on an active Call');
        this._setupLoglevel(this._options.logLevel);
        for (const name of Object.keys(Device._defaultSounds)){
            const soundDef = Device._defaultSounds[name];
            const defaultUrl = `${_constants.SOUNDS_BASE_URL}/${soundDef.filename}.${Device.extension}` + `?cache=${_constants.RELEASE_VERSION}`;
            const soundUrl = this._options.sounds && this._options.sounds[name] || defaultUrl;
            const sound = new (this._options.Sound || (0, _soundDefault.default))(name, soundUrl, {
                audioContext: this._options.disableAudioContextSounds ? null : Device.audioContext,
                maxDuration: soundDef.maxDuration,
                shouldLoop: soundDef.shouldLoop
            });
            this._soundcache.set(name, sound);
        }
        this._setupAudioHelper();
        this._setupPublisher();
        if (hasChunderURIsChanged && this._streamConnectedPromise) this._setupStream();
        // Setup close protection and make sure we clean up ongoing calls on unload.
        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function' && this._options.closeProtection) {
            window.removeEventListener('beforeunload', this._boundConfirmClose);
            window.addEventListener('beforeunload', this._boundConfirmClose);
        }
    }
    /**
     * Update the token used by this {@link Device} to connect to Twilio.
     * It is recommended to call this API after [[Device.tokenWillExpireEvent]] is emitted,
     * and before or after a call to prevent a potential ~1s audio loss during the update process.
     * @param token
     */ updateToken(token) {
        this._log.debug('.updateToken');
        if (this.state === Device.State.Destroyed) throw new (0, _errors.InvalidStateError)(`Attempt to "updateToken" when device is in state "${this.state}".`);
        if (typeof token !== 'string') throw new (0, _errors.InvalidArgumentError)(INVALID_TOKEN_MESSAGE);
        this._token = token;
        if (this._stream) this._stream.setToken(this._token);
        if (this._publisher) this._publisher.setToken(this._token);
    }
    /**
     * Called on window's beforeunload event if closeProtection is enabled,
     * preventing users from accidentally navigating away from an active call.
     * @param event
     */ _confirmClose(event) {
        if (!this._activeCall) return '';
        const closeProtection = this._options.closeProtection || false;
        const confirmationMsg = typeof closeProtection !== 'string' ? 'A call is currently in-progress. Leaving or reloading this page will end the call.' : closeProtection;
        (event || window.event).returnValue = confirmationMsg;
        return confirmationMsg;
    }
    /**
     * Destroy the AudioHelper.
     */ _destroyAudioHelper() {
        if (!this._audio) return;
        this._audio._destroy();
        this._audio = null;
    }
    /**
     * Destroy the publisher.
     */ _destroyPublisher() {
        // Attempt to destroy non-existent publisher.
        if (!this._publisher) return;
        this._publisher = null;
    }
    /**
     * Destroy the connection to the signaling server.
     */ _destroyStream() {
        if (this._stream) {
            this._stream.removeListener('close', this._onSignalingClose);
            this._stream.removeListener('connected', this._onSignalingConnected);
            this._stream.removeListener('error', this._onSignalingError);
            this._stream.removeListener('invite', this._onSignalingInvite);
            this._stream.removeListener('offline', this._onSignalingOffline);
            this._stream.removeListener('ready', this._onSignalingReady);
            this._stream.destroy();
            this._stream = null;
        }
        this._onSignalingOffline();
        this._streamConnectedPromise = null;
    }
    /**
     * Find a {@link Call} by its CallSid.
     * @param callSid
     */ _findCall(callSid) {
        return this._calls.find((call)=>call.parameters.CallSid === callSid || call.outboundConnectionId === callSid) || null;
    }
    /**
     * Get chunderws array from the chunderw param
     */ _getChunderws() {
        return typeof this._options.chunderw === 'string' ? [
            this._options.chunderw
        ] : Array.isArray(this._options.chunderw) ? this._options.chunderw : null;
    }
    /**
     * Utility function to log device options
     */ _logOptions(caller, options = {}) {
        // Selectively log options that users can modify.
        // Also, convert user overrides.
        // This prevents potential app crash when calling JSON.stringify
        // and when sending log strings remotely
        const userOptions = [
            'allowIncomingWhileBusy',
            'appName',
            'appVersion',
            'closeProtection',
            'codecPreferences',
            'disableAudioContextSounds',
            'dscp',
            'edge',
            'enableImprovedSignalingErrorPrecision',
            'forceAggressiveIceNomination',
            'logLevel',
            'maxAverageBitrate',
            'maxCallSignalingTimeoutMs',
            'sounds',
            'tokenRefreshMs'
        ];
        const userOptionOverrides = [
            'RTCPeerConnection',
            'enumerateDevices',
            'getUserMedia'
        ];
        if (typeof options === 'object') {
            const toLog = Object.assign({}, options);
            Object.keys(toLog).forEach((key)=>{
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog[key];
                if (userOptionOverrides.includes(key)) toLog[key] = true;
            });
            this._log.debug(`.${caller}`, JSON.stringify(toLog));
        }
    }
    /**
     * Create a new {@link Call}.
     * @param twimlParams - A flat object containing key:value pairs to be sent to the TwiML app.
     * @param options - Options to be used to instantiate the {@link Call}.
     */ _makeCall(twimlParams, options, isReconnect = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function*() {
            if (typeof Device._isUnifiedPlanDefault === 'undefined') throw new (0, _errors.InvalidStateError)('Device has not been initialized.');
            // Wait for the input device if it's set by the user
            const inputDevicePromise = (_a = this._audio) === null || _a === void 0 ? void 0 : _a._getInputDevicePromise();
            if (inputDevicePromise) {
                this._log.debug('inputDevicePromise detected, waiting...');
                yield inputDevicePromise;
                this._log.debug('inputDevicePromise resolved');
            }
            const config = {
                audioHelper: this._audio,
                isUnifiedPlanDefault: Device._isUnifiedPlanDefault,
                onIgnore: ()=>{
                    this._soundcache.get(Device.SoundName.Incoming).stop();
                },
                pstream: yield this._streamConnectedPromise || this._setupStream(),
                publisher: this._publisher,
                soundcache: this._soundcache
            };
            options = Object.assign({
                MediaStream: this._options.MediaStream || _rtc.PeerConnection,
                RTCPeerConnection: this._options.RTCPeerConnection,
                beforeAccept: (currentCall)=>{
                    if (!this._activeCall || this._activeCall === currentCall) return;
                    this._activeCall.disconnect();
                    this._removeCall(this._activeCall);
                },
                codecPreferences: this._options.codecPreferences,
                customSounds: this._options.sounds,
                dialtonePlayer: Device._dialtonePlayer,
                dscp: this._options.dscp,
                // TODO(csantos): Remove forceAggressiveIceNomination option in 3.x
                forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
                getInputStream: ()=>this._options.fileInputStream || this._callInputStream,
                getSinkIds: ()=>this._callSinkIds,
                maxAverageBitrate: this._options.maxAverageBitrate,
                preflight: this._options.preflight,
                rtcConstraints: this._options.rtcConstraints,
                shouldPlayDisconnect: ()=>{
                    var _a;
                    return (_a = this._audio) === null || _a === void 0 ? void 0 : _a.disconnect();
                },
                twimlParams,
                voiceEventSidGenerator: this._options.voiceEventSidGenerator
            }, options);
            const maybeUnsetPreferredUri = ()=>{
                if (!this._stream) {
                    this._log.warn('UnsetPreferredUri called without a stream');
                    return;
                }
                if (this._activeCall === null && this._calls.length === 0) this._stream.updatePreferredURI(null);
            };
            const call = new (this._options.Call || (0, _callDefault.default))(config, options);
            this._publisher.info('settings', 'init', {
                RTCPeerConnection: !!this._options.RTCPeerConnection,
                enumerateDevices: !!this._options.enumerateDevices,
                getUserMedia: !!this._options.getUserMedia
            }, call);
            call.once('accept', ()=>{
                var _a, _b, _c;
                this._stream.updatePreferredURI(this._preferredURI);
                this._removeCall(call);
                this._activeCall = call;
                if (this._audio) this._audio._maybeStartPollingVolume();
                if (call.direction === (0, _callDefault.default).CallDirection.Outgoing && ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.outgoing()) && !isReconnect) this._soundcache.get(Device.SoundName.Outgoing).play();
                const data = {
                    edge: this._edge || this._region
                };
                if (this._options.edge) data['selected_edge'] = Array.isArray(this._options.edge) ? this._options.edge : [
                    this._options.edge
                ];
                this._publisher.info('settings', 'edge', data, call);
                if ((_b = this._audio) === null || _b === void 0 ? void 0 : _b.processedStream) (_c = this._audioProcessorEventObserver) === null || _c === void 0 || _c.emit('enabled');
            });
            call.addListener('error', (error)=>{
                if (call.status() === 'closed') {
                    this._removeCall(call);
                    maybeUnsetPreferredUri();
                }
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._maybeStopIncomingSound();
            });
            call.once('cancel', ()=>{
                this._log.info(`Canceled: ${call.parameters.CallSid}`);
                this._removeCall(call);
                maybeUnsetPreferredUri();
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._maybeStopIncomingSound();
            });
            call.once('disconnect', ()=>{
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                maybeUnsetPreferredUri();
                /**
                 * NOTE(kamalbennani): We need to stop the incoming sound when the call is
                 * disconnected right after the user has accepted the call (activeCall.accept()), and before
                 * the call has been fully connected (i.e. before the `pstream.answer` event)
                 */ this._maybeStopIncomingSound();
            });
            call.once('reject', ()=>{
                this._log.info(`Rejected: ${call.parameters.CallSid}`);
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                maybeUnsetPreferredUri();
                this._maybeStopIncomingSound();
            });
            call.on('transportClose', ()=>{
                if (call.status() !== (0, _callDefault.default).State.Pending) return;
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                /**
                 * NOTE(mhuynh): We don't want to call `maybeUnsetPreferredUri` because
                 * a `transportClose` will happen during signaling reconnection.
                 */ this._maybeStopIncomingSound();
            });
            return call;
        });
    }
    /**
     * Stop the incoming sound if no {@link Call}s remain.
     */ _maybeStopIncomingSound() {
        if (!this._calls.length) this._soundcache.get(Device.SoundName.Incoming).stop();
    }
    /**
     * Remove a {@link Call} from device.calls by reference
     * @param call
     */ _removeCall(call) {
        if (this._activeCall === call) {
            this._activeCall = null;
            this._makeCallPromise = null;
        }
        for(let i = this._calls.length - 1; i >= 0; i--)if (call === this._calls[i]) this._calls.splice(i, 1);
    }
    /**
     * Register with the signaling server.
     */ _sendPresence(presence) {
        return __awaiter(this, void 0, void 0, function*() {
            const stream = yield this._streamConnectedPromise;
            if (!stream) return;
            stream.register({
                audio: presence
            });
            if (presence) this._startRegistrationTimer();
            else this._stopRegistrationTimer();
        });
    }
    /**
     * Helper function that sets and emits the state of the device.
     * @param state The new state of the device.
     */ _setState(state) {
        if (state === this.state) return;
        this._state = state;
        const name = this._stateEventMapping[state];
        this._log.debug(`#${name}`);
        this.emit(name);
    }
    /**
     * Set up an audio helper for usage by this {@link Device}.
     */ _setupAudioHelper() {
        if (!this._audioProcessorEventObserver) {
            this._audioProcessorEventObserver = new (0, _audioprocessoreventobserver.AudioProcessorEventObserver)();
            this._audioProcessorEventObserver.on('event', ({ name, group })=>{
                this._publisher.info(group, name, {}, this._activeCall);
            });
        }
        const audioOptions = {
            audioContext: Device.audioContext,
            audioProcessorEventObserver: this._audioProcessorEventObserver,
            beforeSetInputDevice: ()=>{
                if (this._makeCallPromise) {
                    this._log.debug('beforeSetInputDevice pause detected');
                    return this._makeCallPromise;
                } else {
                    this._log.debug('beforeSetInputDevice pause not detected, setting default');
                    return Promise.resolve();
                }
            },
            enumerateDevices: this._options.enumerateDevices,
            getUserMedia: this._options.getUserMedia || (0, _getusermediaDefault.default)
        };
        if (this._audio) {
            this._log.info('Found existing audio helper; updating options...');
            this._audio._updateUserOptions(audioOptions);
            return;
        }
        this._audio = new (this._options.AudioHelper || (0, _audiohelperDefault.default))(this._updateSinkIds, this._updateInputStream, audioOptions);
        this._audio.on('deviceChange', (lostActiveDevices)=>{
            const activeCall = this._activeCall;
            const deviceIds = lostActiveDevices.map((device)=>device.deviceId);
            this._publisher.info('audio', 'device-change', {
                lost_active_device_ids: deviceIds
            }, activeCall);
            if (activeCall) activeCall['_mediaHandler']._onInputDevicesChanged();
        });
    }
    /**
     * Setup logger's loglevel
     */ _setupLoglevel(logLevel) {
        const level = typeof logLevel === 'number' || typeof logLevel === 'string' ? logLevel : (0, _loglevel.levels).ERROR;
        this._log.setDefaultLevel(level);
        this._log.info('Set logger default level to', level);
    }
    /**
     * Create and set a publisher for the {@link Device} to use.
     */ _setupPublisher() {
        if (this._publisher) {
            this._log.info('Found existing publisher; destroying...');
            this._destroyPublisher();
        }
        const publisherOptions = {
            defaultPayload: this._createDefaultPayload,
            metadata: {
                app_name: this._options.appName,
                app_version: this._options.appVersion
            }
        };
        if (this._options.eventgw) publisherOptions.host = this._options.eventgw;
        if (this._home) publisherOptions.host = (0, _regions.createEventGatewayURI)(this._home);
        this._publisher = new (this._options.Publisher || (0, _eventpublisherDefault.default))(PUBLISHER_PRODUCT_NAME, this.token, publisherOptions);
        if (this._options.publishEvents === false) this._publisher.disable();
        else this._publisher.on('error', (error)=>{
            this._log.warn('Cannot connect to insights.', error);
        });
        return this._publisher;
    }
    /**
     * Set up the connection to the signaling server. Tears down an existing
     * stream if called while a stream exists.
     */ _setupStream() {
        if (this._stream) {
            this._log.info('Found existing stream; destroying...');
            this._destroyStream();
        }
        this._log.info('Setting up VSP');
        this._stream = new (this._options.PStream || (0, _pstreamDefault.default))(this.token, this._chunderURIs, {
            backoffMaxMs: this._options.backoffMaxMs,
            maxPreferredDurationMs: this._options.maxCallSignalingTimeoutMs
        });
        this._stream.addListener('close', this._onSignalingClose);
        this._stream.addListener('connected', this._onSignalingConnected);
        this._stream.addListener('error', this._onSignalingError);
        this._stream.addListener('invite', this._onSignalingInvite);
        this._stream.addListener('offline', this._onSignalingOffline);
        this._stream.addListener('ready', this._onSignalingReady);
        return this._streamConnectedPromise = (0, _util.promisifyEvents)(this._stream, 'connected', 'close').then(()=>this._stream);
    }
    /**
     * Start playing the incoming ringtone, and subsequently emit the incoming event.
     * @param call
     * @param play - The function to be used to play the sound. Must return a Promise.
     */ _showIncomingCall(call, play) {
        let timeout;
        return Promise.race([
            play(),
            new Promise((resolve, reject)=>{
                timeout = setTimeout(()=>{
                    const msg = 'Playing incoming ringtone took too long; it might not play. Continuing execution...';
                    reject(new Error(msg));
                }, RINGTONE_PLAY_TIMEOUT);
            })
        ]).catch((reason)=>{
            this._log.warn(reason.message);
        }).then(()=>{
            clearTimeout(timeout);
            this._log.debug('#incoming', JSON.stringify({
                customParameters: call.customParameters,
                parameters: call.parameters
            }));
            this.emit(Device.EventName.Incoming, call);
        });
    }
    /**
     * Set a timeout to send another register message to the signaling server.
     */ _startRegistrationTimer() {
        this._stopRegistrationTimer();
        this._regTimer = setTimeout(()=>{
            this._sendPresence(true);
        }, REGISTRATION_INTERVAL);
    }
    /**
     * Stop sending registration messages to the signaling server.
     */ _stopRegistrationTimer() {
        if (this._regTimer) clearTimeout(this._regTimer);
    }
    /**
     * Throw an error if the {@link Device} is destroyed.
     */ _throwIfDestroyed() {
        if (this.state === Device.State.Destroyed) throw new (0, _errors.InvalidStateError)('Device has been destroyed.');
    }
    /**
     * Update the device IDs of output devices being used to play the incoming ringtone through.
     * @param sinkIds - An array of device IDs
     */ _updateRingtoneSinkIds(sinkIds) {
        return Promise.resolve(this._soundcache.get(Device.SoundName.Incoming).setSinkIds(sinkIds));
    }
    /**
     * Update the device IDs of output devices being used to play the non-ringtone sounds
     * and Call audio through.
     * @param sinkIds - An array of device IDs
     */ _updateSpeakerSinkIds(sinkIds) {
        Array.from(this._soundcache.entries()).filter((entry)=>entry[0] !== Device.SoundName.Incoming).forEach((entry)=>entry[1].setSinkIds(sinkIds));
        this._callSinkIds = sinkIds;
        const call = this._activeCall;
        return call ? call._setSinkIds(sinkIds) : Promise.resolve();
    }
}
Device._defaultSounds = {
    disconnect: {
        filename: 'disconnect',
        maxDuration: 3000
    },
    dtmf0: {
        filename: 'dtmf-0',
        maxDuration: 1000
    },
    dtmf1: {
        filename: 'dtmf-1',
        maxDuration: 1000
    },
    dtmf2: {
        filename: 'dtmf-2',
        maxDuration: 1000
    },
    dtmf3: {
        filename: 'dtmf-3',
        maxDuration: 1000
    },
    dtmf4: {
        filename: 'dtmf-4',
        maxDuration: 1000
    },
    dtmf5: {
        filename: 'dtmf-5',
        maxDuration: 1000
    },
    dtmf6: {
        filename: 'dtmf-6',
        maxDuration: 1000
    },
    dtmf7: {
        filename: 'dtmf-7',
        maxDuration: 1000
    },
    dtmf8: {
        filename: 'dtmf-8',
        maxDuration: 1000
    },
    dtmf9: {
        filename: 'dtmf-9',
        maxDuration: 1000
    },
    dtmfh: {
        filename: 'dtmf-hash',
        maxDuration: 1000
    },
    dtmfs: {
        filename: 'dtmf-star',
        maxDuration: 1000
    },
    incoming: {
        filename: 'incoming',
        shouldLoop: true
    },
    outgoing: {
        filename: 'outgoing',
        maxDuration: 3000
    }
};
(function(Device) {
    /**
     * All valid {@link Device} event names.
     */ let EventName;
    (function(EventName) {
        EventName["Error"] = "error";
        EventName["Incoming"] = "incoming";
        EventName["Destroyed"] = "destroyed";
        EventName["Unregistered"] = "unregistered";
        EventName["Registering"] = "registering";
        EventName["Registered"] = "registered";
        EventName["TokenWillExpire"] = "tokenWillExpire";
    })(EventName = Device.EventName || (Device.EventName = {}));
    /**
     * All possible {@link Device} states.
     */ let State;
    (function(State) {
        State["Destroyed"] = "destroyed";
        State["Unregistered"] = "unregistered";
        State["Registering"] = "registering";
        State["Registered"] = "registered";
    })(State = Device.State || (Device.State = {}));
    /**
     * Names of all sounds handled by the {@link Device}.
     */ let SoundName;
    (function(SoundName) {
        SoundName["Incoming"] = "incoming";
        SoundName["Outgoing"] = "outgoing";
        SoundName["Disconnect"] = "disconnect";
        SoundName["Dtmf0"] = "dtmf0";
        SoundName["Dtmf1"] = "dtmf1";
        SoundName["Dtmf2"] = "dtmf2";
        SoundName["Dtmf3"] = "dtmf3";
        SoundName["Dtmf4"] = "dtmf4";
        SoundName["Dtmf5"] = "dtmf5";
        SoundName["Dtmf6"] = "dtmf6";
        SoundName["Dtmf7"] = "dtmf7";
        SoundName["Dtmf8"] = "dtmf8";
        SoundName["Dtmf9"] = "dtmf9";
        SoundName["DtmfS"] = "dtmfs";
        SoundName["DtmfH"] = "dtmfh";
    })(SoundName = Device.SoundName || (Device.SoundName = {}));
})(Device || (Device = {}));
exports.default = Device;

},{"events":"fqTtD","loglevel":"5ZY8d","./audiohelper":"hDiVV","./audioprocessoreventobserver":"6GH2u","./call":"92RrQ","./constants":"buVX6","./dialtonePlayer":"4YJjX","./errors":"caXI8","./eventpublisher":"3Bhuv","./log":"eJjQN","./preflight/preflight":"9Nh8w","./pstream":"k93Ah","./regions":"4iuBg","./rtc":"7NmEm","./rtc/getusermedia":"7Q9pA","./sound":"EN1zf","./util":"j8qrE","./uuid":"2zIUQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ZY8d":[function(require,module,exports,__globalThis) {
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === 'function' && define.amd) define(definition);
    else if (module.exports) module.exports = definition();
    else root.log = definition();
})(this, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') methodName = 'log';
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === 'trace' && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, 'log');
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */ for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        var storageKey = "loglevel";
        if (name) storageKey += ":" + name;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
            if (typeof window === undefinedType) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            return currentLevel;
        };
        self.setLevel = function(level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) persistLevelIfPossible(level);
                replaceLoggingMethods.call(self, level, name);
                if (typeof console === undefinedType && level < self.levels.SILENT) return "No console available for logging";
            } else throw "log.setLevel() called with invalid level: " + level;
        };
        self.setDefaultLevel = function(level) {
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
        self.setLevel(initialLevel, false);
    }
    /*
     *
     * Top-level API
     *
     */ var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    return defaultLogger;
});

},{}],"hDiVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @packageDocumentation
 * @module Voice
 */ var _events = require("events");
var _device = require("./device");
var _deviceDefault = parcelHelpers.interopDefault(_device);
var _errors = require("./errors");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _outputdevicecollection = require("./outputdevicecollection");
var _outputdevicecollectionDefault = parcelHelpers.interopDefault(_outputdevicecollection);
var _mediadeviceinfo = require("./shims/mediadeviceinfo");
var _mediadeviceinfoDefault = parcelHelpers.interopDefault(_mediadeviceinfo);
var _util = require("./util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Aliases for audio kinds, used for labelling.
 * @private
 */ const kindAliases = {
    audioinput: 'Audio Input',
    audiooutput: 'Audio Output'
};
/**
 * Provides input and output audio-based functionality in one convenient class.
 * @publicapi
 */ class AudioHelper extends (0, _events.EventEmitter) {
    /**
     * @constructor
     * @private
     * @param onActiveOutputsChanged - A callback to be called when the user changes the active output devices.
     * @param onActiveInputChanged - A callback to be called when the user changes the active input device.
     * @param [options]
     */ constructor(onActiveOutputsChanged, onActiveInputChanged, options){
        super();
        /**
         * A Map of all audio input devices currently available to the browser by their device ID.
         */ this.availableInputDevices = new Map();
        /**
         * A Map of all audio output devices currently available to the browser by their device ID.
         */ this.availableOutputDevices = new Map();
        /**
         * The currently set audio constraints set by setAudioConstraints().
         */ this._audioConstraints = null;
        /**
         * The audio stream of the default device.
         * This is populated when _openDefaultDeviceWithConstraints is called,
         * See _selectedInputDeviceStream for differences.
         * TODO: Combine these two workflows (3.x?)
         */ this._defaultInputDeviceStream = null;
        /**
         * Whether each sound is enabled.
         */ this._enabledSounds = {
            [(0, _deviceDefault.default).SoundName.Disconnect]: true,
            [(0, _deviceDefault.default).SoundName.Incoming]: true,
            [(0, _deviceDefault.default).SoundName.Outgoing]: true
        };
        /**
         * The current input device.
         */ this._inputDevice = null;
        /**
         * The internal promise created when calling setInputDevice
         */ this._inputDevicePromise = null;
        /**
         * Whether the {@link AudioHelper} is currently polling the input stream's volume.
         */ this._isPollingInputVolume = false;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('AudioHelper');
        /**
         * Internal reference to the processed stream
         */ this._processedStream = null;
        /**
         * The selected input stream coming from the microphone device.
         * This is populated when the setInputDevice is called, meaning,
         * the end user manually selected it, which is different than
         * the defaultInputDeviceStream.
         * TODO: Combine these two workflows (3.x?)
         */ this._selectedInputDeviceStream = null;
        /**
         * A record of unknown devices (Devices without labels)
         */ this._unknownDeviceIndexes = {
            audioinput: {},
            audiooutput: {}
        };
        /**
         * Update the available input and output devices
         * @private
         */ this._updateAvailableDevices = ()=>{
            if (!this._mediaDevices || !this._enumerateDevices) return Promise.reject('Enumeration not supported');
            return this._enumerateDevices().then((devices)=>{
                this._updateDevices(devices.filter((d)=>d.kind === 'audiooutput'), this.availableOutputDevices, this._removeLostOutput);
                this._updateDevices(devices.filter((d)=>d.kind === 'audioinput'), this.availableInputDevices, this._removeLostInput);
                const defaultDevice = this.availableOutputDevices.get('default') || Array.from(this.availableOutputDevices.values())[0];
                [
                    this.speakerDevices,
                    this.ringtoneDevices
                ].forEach((outputDevices)=>{
                    if (!outputDevices.get().size && this.availableOutputDevices.size && this.isOutputSelectionSupported) outputDevices.set(defaultDevice.deviceId).catch((reason)=>{
                        this._log.warn(`Unable to set audio output devices. ${reason}`);
                    });
                });
            });
        };
        /**
         * Remove an input device from inputs
         * @param lostDevice
         * @returns Whether the device was active
         */ this._removeLostInput = (lostDevice)=>{
            if (!this.inputDevice || this.inputDevice.deviceId !== lostDevice.deviceId) return false;
            this._destroyProcessedStream();
            this._replaceStream(null);
            this._inputDevice = null;
            this._maybeStopPollingVolume();
            const defaultDevice = this.availableInputDevices.get('default') || Array.from(this.availableInputDevices.values())[0];
            if (defaultDevice) this.setInputDevice(defaultDevice.deviceId);
            return true;
        };
        /**
         * Remove an input device from outputs
         * @param lostDevice
         * @returns Whether the device was active
         */ this._removeLostOutput = (lostDevice)=>{
            const wasSpeakerLost = this.speakerDevices.delete(lostDevice);
            const wasRingtoneLost = this.ringtoneDevices.delete(lostDevice);
            return wasSpeakerLost || wasRingtoneLost;
        };
        options = Object.assign({
            AudioContext: typeof AudioContext !== 'undefined' && AudioContext,
            setSinkId: typeof HTMLAudioElement !== 'undefined' && HTMLAudioElement.prototype.setSinkId
        }, options);
        this._beforeSetInputDevice = options.beforeSetInputDevice || (()=>Promise.resolve());
        this._updateUserOptions(options);
        this._audioProcessorEventObserver = options.audioProcessorEventObserver;
        this._mediaDevices = options.mediaDevices || navigator.mediaDevices;
        this._onActiveInputChanged = onActiveInputChanged;
        this._enumerateDevices = typeof options.enumerateDevices === 'function' ? options.enumerateDevices : this._mediaDevices && this._mediaDevices.enumerateDevices.bind(this._mediaDevices);
        const isAudioContextSupported = !!(options.AudioContext || options.audioContext);
        const isEnumerationSupported = !!this._enumerateDevices;
        if (options.enabledSounds) this._enabledSounds = options.enabledSounds;
        const isSetSinkSupported = typeof options.setSinkId === 'function';
        this.isOutputSelectionSupported = isEnumerationSupported && isSetSinkSupported;
        this.isVolumeSupported = isAudioContextSupported;
        if (this.isVolumeSupported) {
            this._audioContext = options.audioContext || options.AudioContext && new options.AudioContext();
            if (this._audioContext) {
                this._inputVolumeAnalyser = this._audioContext.createAnalyser();
                this._inputVolumeAnalyser.fftSize = 32;
                this._inputVolumeAnalyser.smoothingTimeConstant = 0.3;
            }
        }
        this.ringtoneDevices = new (0, _outputdevicecollectionDefault.default)('ringtone', this.availableOutputDevices, onActiveOutputsChanged, this.isOutputSelectionSupported);
        this.speakerDevices = new (0, _outputdevicecollectionDefault.default)('speaker', this.availableOutputDevices, onActiveOutputsChanged, this.isOutputSelectionSupported);
        this.addListener('newListener', (eventName)=>{
            if (eventName === 'inputVolume') this._maybeStartPollingVolume();
        });
        this.addListener('removeListener', (eventName)=>{
            if (eventName === 'inputVolume') this._maybeStopPollingVolume();
        });
        this.once('newListener', ()=>{
            // NOTE (rrowland): Ideally we would only check isEnumerationSupported here, but
            //   in at least one browser version (Tested in FF48) enumerateDevices actually
            //   returns bad data for the listed devices. Instead, we check for
            //   isOutputSelectionSupported to avoid these quirks that may negatively affect customers.
            if (!this.isOutputSelectionSupported) this._log.warn('Warning: This browser does not support audio output selection.');
            if (!this.isVolumeSupported) this._log.warn(`Warning: This browser does not support Twilio's volume indicator feature.`);
        });
        if (isEnumerationSupported) this._initializeEnumeration();
        // NOTE (kchoy): Currently microphone permissions are not supported in firefox, and Safari V15 and older.
        // https://github.com/mozilla/standards-positions/issues/19#issuecomment-370158947
        // https://caniuse.com/permissions-api
        if (navigator && navigator.permissions && typeof navigator.permissions.query === 'function') navigator.permissions.query({
            name: 'microphone'
        }).then((microphonePermissionStatus)=>{
            if (microphonePermissionStatus.state !== 'granted') {
                const handleStateChange = ()=>{
                    this._updateAvailableDevices();
                    this._stopMicrophonePermissionListener();
                };
                microphonePermissionStatus.addEventListener('change', handleStateChange);
                this._microphonePermissionStatus = microphonePermissionStatus;
                this._onMicrophonePermissionStatusChanged = handleStateChange;
            }
        }).catch((reason)=>this._log.warn(`Warning: unable to listen for microphone permission changes. ${reason}`));
        else this._log.warn('Warning: current browser does not support permissions API.');
    }
    /**
     * The currently set audio constraints set by setAudioConstraints(). Starts as null.
     */ get audioConstraints() {
        return this._audioConstraints;
    }
    /**
     * The active input device. Having no inputDevice specified by `setInputDevice()`
     * will disable input selection related functionality.
     */ get inputDevice() {
        return this._inputDevice;
    }
    /**
     * The current input stream coming from the microphone device or
     * the processed audio stream if there is an {@link AudioProcessor}.
     */ get inputStream() {
        return this._processedStream || this._selectedInputDeviceStream;
    }
    /**
     * The processed stream if an {@link AudioProcessor} was previously added.
     */ get processedStream() {
        return this._processedStream;
    }
    /**
     * Destroy this AudioHelper instance
     * @private
     */ _destroy() {
        this._stopDefaultInputDeviceStream();
        this._stopSelectedInputDeviceStream();
        this._destroyProcessedStream();
        this._maybeStopPollingVolume();
        this.removeAllListeners();
        this._stopMicrophonePermissionListener();
        this._unbind();
    }
    /**
     * Promise to wait for the input device, if setInputDevice is called outside of the SDK
     * @private
     */ _getInputDevicePromise() {
        return this._inputDevicePromise;
    }
    /**
     * Start polling volume if it's supported and there's an input stream to poll.
     * @private
     */ _maybeStartPollingVolume() {
        if (!this.isVolumeSupported || !this.inputStream) return;
        this._updateVolumeSource();
        if (this._isPollingInputVolume || !this._inputVolumeAnalyser) return;
        const bufferLength = this._inputVolumeAnalyser.frequencyBinCount;
        const buffer = new Uint8Array(bufferLength);
        this._isPollingInputVolume = true;
        const emitVolume = ()=>{
            if (!this._isPollingInputVolume) return;
            if (this._inputVolumeAnalyser) {
                this._inputVolumeAnalyser.getByteFrequencyData(buffer);
                const inputVolume = (0, _util.average)(buffer);
                this.emit('inputVolume', inputVolume / 255);
            }
            requestAnimationFrame(emitVolume);
        };
        requestAnimationFrame(emitVolume);
    }
    /**
     * Stop polling volume if it's currently polling and there are no listeners.
     * @private
     */ _maybeStopPollingVolume() {
        if (!this.isVolumeSupported) return;
        if (!this._isPollingInputVolume || this.inputStream && this.listenerCount('inputVolume')) return;
        if (this._inputVolumeSource) {
            this._inputVolumeSource.disconnect();
            delete this._inputVolumeSource;
        }
        this._isPollingInputVolume = false;
    }
    /**
     * Call getUserMedia with specified constraints
     * @private
     */ _openDefaultDeviceWithConstraints(constraints) {
        this._log.info('Opening default device with constraints', constraints);
        return this._getUserMedia(constraints).then((stream)=>{
            this._log.info('Opened default device. Updating available devices.');
            // Ensures deviceId's and labels are populated after the gUM call
            // by calling enumerateDevices
            this._updateAvailableDevices().catch((error)=>{
                // Ignore error, we don't want to break the call flow
                this._log.warn('Unable to updateAvailableDevices after gUM call', error);
            });
            this._defaultInputDeviceStream = stream;
            return this._maybeCreateProcessedStream(stream);
        });
    }
    /**
     * Stop the default audio stream
     * @private
     */ _stopDefaultInputDeviceStream() {
        if (this._defaultInputDeviceStream) {
            this._log.info('stopping default device stream');
            this._defaultInputDeviceStream.getTracks().forEach((track)=>track.stop());
            this._defaultInputDeviceStream = null;
            this._destroyProcessedStream();
        }
    }
    /**
     * Unbind the listeners from mediaDevices.
     * @private
     */ _unbind() {
        if (!this._mediaDevices || !this._enumerateDevices) throw new (0, _errors.NotSupportedError)('Enumeration is not supported');
        if (this._mediaDevices.removeEventListener) this._mediaDevices.removeEventListener('devicechange', this._updateAvailableDevices);
    }
    /**
     * Update AudioHelper options that can be changed by the user
     * @private
     */ _updateUserOptions(options) {
        if (typeof options.enumerateDevices === 'function') this._enumerateDevices = options.enumerateDevices;
        if (typeof options.getUserMedia === 'function') this._getUserMedia = options.getUserMedia;
    }
    /**
     * Adds an {@link AudioProcessor} object. Once added, the AudioHelper will route
     * the input audio stream through the processor before sending the audio
     * stream to Twilio. Only one AudioProcessor can be added at this time.
     *
     * See the {@link AudioProcessor} interface for an example.
     *
     * @param processor The AudioProcessor to add.
     * @returns
     */ addProcessor(processor) {
        this._log.debug('.addProcessor');
        if (this._processor) throw new (0, _errors.NotSupportedError)('Adding multiple AudioProcessors is not supported at this time.');
        if (typeof processor !== 'object' || processor === null) throw new (0, _errors.InvalidArgumentError)('Missing AudioProcessor argument.');
        if (typeof processor.createProcessedStream !== 'function') throw new (0, _errors.InvalidArgumentError)('Missing createProcessedStream() method.');
        if (typeof processor.destroyProcessedStream !== 'function') throw new (0, _errors.InvalidArgumentError)('Missing destroyProcessedStream() method.');
        this._processor = processor;
        this._audioProcessorEventObserver.emit('add');
        return this._restartStreams();
    }
    /**
     * Enable or disable the disconnect sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ disconnect(doEnable) {
        this._log.debug('.disconnect', doEnable);
        return this._maybeEnableSound((0, _deviceDefault.default).SoundName.Disconnect, doEnable);
    }
    /**
     * Enable or disable the incoming sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ incoming(doEnable) {
        this._log.debug('.incoming', doEnable);
        return this._maybeEnableSound((0, _deviceDefault.default).SoundName.Incoming, doEnable);
    }
    /**
     * Enable or disable the outgoing sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ outgoing(doEnable) {
        this._log.debug('.outgoing', doEnable);
        return this._maybeEnableSound((0, _deviceDefault.default).SoundName.Outgoing, doEnable);
    }
    /**
     * Removes an {@link AudioProcessor}. Once removed, the AudioHelper will start using
     * the audio stream from the selected input device for existing or future calls.
     *
     * @param processor The AudioProcessor to remove.
     * @returns
     */ removeProcessor(processor) {
        this._log.debug('.removeProcessor');
        if (typeof processor !== 'object' || processor === null) throw new (0, _errors.InvalidArgumentError)('Missing AudioProcessor argument.');
        if (this._processor !== processor) throw new (0, _errors.InvalidArgumentError)('Cannot remove an AudioProcessor that has not been previously added.');
        this._destroyProcessedStream();
        this._processor = null;
        this._audioProcessorEventObserver.emit('remove');
        return this._restartStreams();
    }
    /**
     * Set the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. Any deviceId specified here will be ignored. Instead, device IDs should
     * be specified using {@link AudioHelper#setInputDevice}. The returned Promise resolves
     * when the media is successfully reacquired, or immediately if no input device is set.
     * @param audioConstraints - The MediaTrackConstraints to apply.
     */ setAudioConstraints(audioConstraints) {
        this._log.debug('.setAudioConstraints', audioConstraints);
        this._audioConstraints = Object.assign({}, audioConstraints);
        delete this._audioConstraints.deviceId;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     */ setInputDevice(deviceId) {
        this._log.debug('.setInputDevice', deviceId);
        return this._setInputDevice(deviceId, false);
    }
    /**
     * Unset the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. The returned Promise resolves when the media is successfully reacquired,
     * or immediately if no input device is set.
     */ unsetAudioConstraints() {
        this._log.debug('.unsetAudioConstraints');
        this._audioConstraints = null;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Unset the input device, stopping the tracks. This should only be called when not in a connection, and
     *   will not allow removal of the input device during a live call.
     */ unsetInputDevice() {
        this._log.debug('.unsetInputDevice', this.inputDevice);
        if (!this.inputDevice) return Promise.resolve();
        this._destroyProcessedStream();
        return this._onActiveInputChanged(null).then(()=>{
            this._replaceStream(null);
            this._inputDevice = null;
            this._maybeStopPollingVolume();
        });
    }
    /**
     * Destroys processed stream and update references
     */ _destroyProcessedStream() {
        if (this._processor && this._processedStream) {
            this._log.info('destroying processed stream');
            const processedStream = this._processedStream;
            this._processedStream.getTracks().forEach((track)=>track.stop());
            this._processedStream = null;
            this._processor.destroyProcessedStream(processedStream);
            this._audioProcessorEventObserver.emit('destroy');
        }
    }
    /**
     * Get the index of an un-labeled Device.
     * @param mediaDeviceInfo
     * @returns The index of the passed MediaDeviceInfo
     */ _getUnknownDeviceIndex(mediaDeviceInfo) {
        const id = mediaDeviceInfo.deviceId;
        const kind = mediaDeviceInfo.kind;
        let index = this._unknownDeviceIndexes[kind][id];
        if (!index) {
            index = Object.keys(this._unknownDeviceIndexes[kind]).length + 1;
            this._unknownDeviceIndexes[kind][id] = index;
        }
        return index;
    }
    /**
     * Initialize output device enumeration.
     */ _initializeEnumeration() {
        if (!this._mediaDevices || !this._enumerateDevices) throw new (0, _errors.NotSupportedError)('Enumeration is not supported');
        if (this._mediaDevices.addEventListener) this._mediaDevices.addEventListener('devicechange', this._updateAvailableDevices);
        this._updateAvailableDevices().then(()=>{
            if (!this.isOutputSelectionSupported) return;
            Promise.all([
                this.speakerDevices.set('default'),
                this.ringtoneDevices.set('default')
            ]).catch((reason)=>{
                this._log.warn(`Warning: Unable to set audio output devices. ${reason}`);
            });
        });
    }
    /**
     * Route input stream to the processor if it exists
     */ _maybeCreateProcessedStream(stream) {
        if (this._processor) {
            this._log.info('Creating processed stream');
            return this._processor.createProcessedStream(stream).then((processedStream)=>{
                this._processedStream = processedStream;
                this._audioProcessorEventObserver.emit('create');
                return this._processedStream;
            });
        }
        return Promise.resolve(stream);
    }
    /**
     * Set whether the sound is enabled or not
     * @param soundName
     * @param doEnable
     * @returns Whether the sound is enabled or not
     */ _maybeEnableSound(soundName, doEnable) {
        if (typeof doEnable !== 'undefined') this._enabledSounds[soundName] = doEnable;
        return this._enabledSounds[soundName];
    }
    /**
     * Stop the tracks on the current input stream before replacing it with the passed stream.
     * @param stream - The new stream
     */ _replaceStream(stream) {
        this._log.info('Replacing with new stream.');
        if (this._selectedInputDeviceStream) {
            this._log.info('Old stream detected. Stopping tracks.');
            this._stopSelectedInputDeviceStream();
        }
        this._selectedInputDeviceStream = stream;
    }
    /**
     * Restart the active streams
     */ _restartStreams() {
        if (this.inputDevice && this._selectedInputDeviceStream) {
            this._log.info('Restarting selected input device');
            return this._setInputDevice(this.inputDevice.deviceId, true);
        }
        if (this._defaultInputDeviceStream) {
            const defaultDevice = this.availableInputDevices.get('default') || Array.from(this.availableInputDevices.values())[0];
            this._log.info('Restarting default input device, now becoming selected.');
            return this._setInputDevice(defaultDevice.deviceId, true);
        }
        return Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     * @param forceGetUserMedia - If true, getUserMedia will be called even if
     *   the specified device is already active.
     */ _setInputDevice(deviceId, forceGetUserMedia) {
        return __awaiter(this, void 0, void 0, function*() {
            const setInputDevice = ()=>__awaiter(this, void 0, void 0, function*() {
                    yield this._beforeSetInputDevice();
                    if (typeof deviceId !== 'string') return Promise.reject(new (0, _errors.InvalidArgumentError)('Must specify the device to set'));
                    const device = this.availableInputDevices.get(deviceId);
                    if (!device) return Promise.reject(new (0, _errors.InvalidArgumentError)(`Device not found: ${deviceId}`));
                    this._log.info('Setting input device. ID: ' + deviceId);
                    if (this._inputDevice && this._inputDevice.deviceId === deviceId && this._selectedInputDeviceStream) {
                        if (!forceGetUserMedia) return Promise.resolve();
                        // If the currently active track is still in readyState `live`, gUM may return the same track
                        // rather than returning a fresh track.
                        this._log.info('Same track detected on setInputDevice, stopping old tracks.');
                        this._stopSelectedInputDeviceStream();
                    }
                    // Release the default device in case it was created previously
                    this._stopDefaultInputDeviceStream();
                    const constraints = {
                        audio: Object.assign({
                            deviceId: {
                                exact: deviceId
                            }
                        }, this.audioConstraints)
                    };
                    this._log.info('setInputDevice: getting new tracks.');
                    return this._getUserMedia(constraints).then((originalStream)=>{
                        this._destroyProcessedStream();
                        return this._maybeCreateProcessedStream(originalStream).then((newStream)=>{
                            this._log.info('setInputDevice: invoking _onActiveInputChanged.');
                            return this._onActiveInputChanged(newStream).then(()=>{
                                this._replaceStream(originalStream);
                                this._inputDevice = device;
                                this._maybeStartPollingVolume();
                            });
                        });
                    });
                });
            return this._inputDevicePromise = setInputDevice().finally(()=>{
                this._inputDevicePromise = null;
            });
        });
    }
    /**
     * Remove event listener for microphone permissions
     */ _stopMicrophonePermissionListener() {
        var _a;
        if ((_a = this._microphonePermissionStatus) === null || _a === void 0 ? void 0 : _a.removeEventListener) this._microphonePermissionStatus.removeEventListener('change', this._onMicrophonePermissionStatusChanged);
    }
    /**
     * Stop the selected audio stream
     */ _stopSelectedInputDeviceStream() {
        if (this._selectedInputDeviceStream) {
            this._log.info('Stopping selected device stream');
            this._selectedInputDeviceStream.getTracks().forEach((track)=>track.stop());
        }
    }
    /**
     * Update a set of devices.
     * @param updatedDevices - An updated list of available Devices
     * @param availableDevices - The previous list of available Devices
     * @param removeLostDevice - The method to call if a previously available Device is
     *   no longer available.
     */ _updateDevices(updatedDevices, availableDevices, removeLostDevice) {
        const updatedDeviceIds = updatedDevices.map((d)=>d.deviceId);
        const knownDeviceIds = Array.from(availableDevices.values()).map((d)=>d.deviceId);
        const lostActiveDevices = [];
        // Remove lost devices
        const lostDeviceIds = (0, _util.difference)(knownDeviceIds, updatedDeviceIds);
        lostDeviceIds.forEach((lostDeviceId)=>{
            const lostDevice = availableDevices.get(lostDeviceId);
            if (lostDevice) {
                availableDevices.delete(lostDeviceId);
                if (removeLostDevice(lostDevice)) lostActiveDevices.push(lostDevice);
            }
        });
        // Add any new devices, or devices with updated labels
        let deviceChanged = false;
        updatedDevices.forEach((newDevice)=>{
            const existingDevice = availableDevices.get(newDevice.deviceId);
            const newMediaDeviceInfo = this._wrapMediaDeviceInfo(newDevice);
            if (!existingDevice || existingDevice.label !== newMediaDeviceInfo.label) {
                availableDevices.set(newDevice.deviceId, newMediaDeviceInfo);
                deviceChanged = true;
            }
        });
        if (deviceChanged || lostDeviceIds.length) {
            // Force a new gUM in case the underlying tracks of the active stream have changed. One
            //   reason this might happen is when `default` is selected and set to a USB device,
            //   then that device is unplugged or plugged back in. We can't check for the 'ended'
            //   event or readyState because it is asynchronous and may take upwards of 5 seconds,
            //   in my testing. (rrowland)
            const defaultId = 'default';
            // this.inputDevice is not null if audio.setInputDevice() was explicitly called
            const isInputDeviceSet = this.inputDevice && this.inputDevice.deviceId === defaultId;
            // If this.inputDevice is null, and default stream is not null, it means
            // the user is using the default stream and did not explicitly call audio.setInputDevice()
            const isDefaultDeviceSet = this._defaultInputDeviceStream && this.availableInputDevices.get(defaultId);
            if (isInputDeviceSet || isDefaultDeviceSet) {
                this._log.warn(`Calling getUserMedia after device change to ensure that the \
          tracks of the active device (default) have not gone stale.`);
                // NOTE(csantos): Updating the stream in the same execution context as the devicechange event
                // causes the new gUM call to fail silently. Meaning, the gUM call may succeed,
                // but it won't actually update the stream. We need to update the stream in a different
                // execution context (setTimeout) to properly update the stream.
                setTimeout(()=>{
                    this._setInputDevice(defaultId, true);
                }, 0);
            }
            this._log.debug('#deviceChange', lostActiveDevices);
            this.emit('deviceChange', lostActiveDevices);
        }
    }
    /**
     * Disconnect the old input volume source, and create and connect a new one with the current
     * input stream.
     */ _updateVolumeSource() {
        if (!this.inputStream || !this._audioContext || !this._inputVolumeAnalyser) return;
        if (this._inputVolumeSource) this._inputVolumeSource.disconnect();
        try {
            this._inputVolumeSource = this._audioContext.createMediaStreamSource(this.inputStream);
            this._inputVolumeSource.connect(this._inputVolumeAnalyser);
        } catch (ex) {
            this._log.warn('Unable to update volume source', ex);
            delete this._inputVolumeSource;
        }
    }
    /**
     * Convert a MediaDeviceInfo to a IMediaDeviceInfoShim.
     * @param mediaDeviceInfo - The info to convert
     * @returns The converted shim
     */ _wrapMediaDeviceInfo(mediaDeviceInfo) {
        const options = {
            deviceId: mediaDeviceInfo.deviceId,
            groupId: mediaDeviceInfo.groupId,
            kind: mediaDeviceInfo.kind,
            label: mediaDeviceInfo.label
        };
        if (!options.label) {
            if (options.deviceId === 'default') options.label = 'Default';
            else {
                const index = this._getUnknownDeviceIndex(mediaDeviceInfo);
                options.label = `Unknown ${kindAliases[options.kind]} Device ${index}`;
            }
        }
        return new (0, _mediadeviceinfoDefault.default)(options);
    }
}
AudioHelper || (AudioHelper = {});
exports.default = AudioHelper;

},{"events":"fqTtD","./device":"iaq4W","./errors":"caXI8","./log":"eJjQN","./outputdevicecollection":"ewWKM","./shims/mediadeviceinfo":"7VLyx","./util":"j8qrE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"caXI8":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @internalapi
 */ /* tslint:disable max-classes-per-file */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreciseSignalingErrorByCode", ()=>getPreciseSignalingErrorByCode);
// Application errors that can be avoided by good app logic
parcelHelpers.export(exports, "InvalidArgumentError", ()=>InvalidArgumentError);
parcelHelpers.export(exports, "InvalidStateError", ()=>InvalidStateError);
parcelHelpers.export(exports, "NotSupportedError", ()=>NotSupportedError);
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
parcelHelpers.export(exports, "getErrorByCode", ()=>getErrorByCode);
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
parcelHelpers.export(exports, "hasErrorByCode", ()=>hasErrorByCode);
/**
 * All errors we want to throw or emit locally in the SDK need to be passed
 * through here.
 *
 * They need to first be defined in the `USED_ERRORS` list. See:
 * ```
 * scripts/errors.js
 * ```
 */ parcelHelpers.export(exports, "AuthorizationErrors", ()=>(0, _generated.AuthorizationErrors));
parcelHelpers.export(exports, "ClientErrors", ()=>(0, _generated.ClientErrors));
parcelHelpers.export(exports, "GeneralErrors", ()=>(0, _generated.GeneralErrors));
parcelHelpers.export(exports, "MalformedRequestErrors", ()=>(0, _generated.MalformedRequestErrors));
parcelHelpers.export(exports, "MediaErrors", ()=>(0, _generated.MediaErrors));
parcelHelpers.export(exports, "SignalingErrors", ()=>(0, _generated.SignalingErrors));
parcelHelpers.export(exports, "SignatureValidationErrors", ()=>(0, _generated.SignatureValidationErrors));
parcelHelpers.export(exports, "SIPServerErrors", ()=>(0, _generated.SIPServerErrors));
parcelHelpers.export(exports, "TwilioError", ()=>(0, _generated.TwilioError));
parcelHelpers.export(exports, "UserMediaErrors", ()=>(0, _generated.UserMediaErrors));
var _generated = require("./generated");
/**
 * NOTE(mhuynh): Replacing generic error codes with new (more specific) codes,
 * is a breaking change. If an error code is found in this set, we only perform
 * the transformation if the feature flag is enabled.
 *
 * With every major version bump, such that we are allowed to introduce breaking
 * changes as per semver specification, this array should be cleared.
 *
 * TODO: [VBLOCKS-2295] Remove this in 3.x
 */ const PRECISE_SIGNALING_ERROR_CODES = new Set([
    /**
     * 310XX Errors
     */ 31001,
    31002,
    31003,
    /**
     * 311XX Errors
     */ 31101,
    31102,
    31103,
    31104,
    31105,
    31107,
    /**
     * 312XX Errors
     */ 31201,
    31202,
    31203,
    31204,
    31205,
    31207,
    /**
     * 314XX Errors
     */ 31404,
    31480,
    31486,
    /**
     * 316XX Errors
     */ 31603
]);
function getPreciseSignalingErrorByCode(enableImprovedSignalingErrorPrecision, errorCode) {
    if (typeof errorCode !== 'number') return;
    if (!hasErrorByCode(errorCode)) return;
    const shouldTransform = enableImprovedSignalingErrorPrecision ? true : !PRECISE_SIGNALING_ERROR_CODES.has(errorCode);
    if (!shouldTransform) return;
    return getErrorByCode(errorCode);
}
class InvalidArgumentError extends Error {
    constructor(message){
        super(message);
        this.name = 'InvalidArgumentError';
    }
}
class InvalidStateError extends Error {
    constructor(message){
        super(message);
        this.name = 'InvalidStateError';
    }
}
class NotSupportedError extends Error {
    constructor(message){
        super(message);
        this.name = 'NotSupportedError';
    }
}
function getErrorByCode(code) {
    const error = (0, _generated.errorsByCode).get(code);
    if (!error) throw new InvalidArgumentError(`Error code ${code} not found`);
    return error;
}
function hasErrorByCode(code) {
    return (0, _generated.errorsByCode).has(code);
}

},{"./generated":"lWDi9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lWDi9":[function(require,module,exports,__globalThis) {
/* tslint:disable max-classes-per-file max-line-length */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ /**
 * This is a generated file. Any modifications here will be overwritten. See scripts/errors.js.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TwilioError", ()=>(0, _twilioErrorDefault.default));
parcelHelpers.export(exports, "AuthorizationErrors", ()=>AuthorizationErrors);
parcelHelpers.export(exports, "SignatureValidationErrors", ()=>SignatureValidationErrors);
parcelHelpers.export(exports, "ClientErrors", ()=>ClientErrors);
parcelHelpers.export(exports, "SIPServerErrors", ()=>SIPServerErrors);
parcelHelpers.export(exports, "GeneralErrors", ()=>GeneralErrors);
parcelHelpers.export(exports, "MalformedRequestErrors", ()=>MalformedRequestErrors);
parcelHelpers.export(exports, "UserMediaErrors", ()=>UserMediaErrors);
parcelHelpers.export(exports, "SignalingErrors", ()=>SignalingErrors);
parcelHelpers.export(exports, "MediaErrors", ()=>MediaErrors);
parcelHelpers.export(exports, "errorsByCode", ()=>errorsByCode);
var _twilioError = require("./twilioError");
var _twilioErrorDefault = parcelHelpers.interopDefault(_twilioError);
var AuthorizationErrors;
(function(AuthorizationErrors) {
    class AccessTokenInvalid extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20101;
            this.description = 'Invalid access token';
            this.explanation = 'Twilio was unable to validate your Access Token';
            this.name = 'AccessTokenInvalid';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AccessTokenInvalid.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AccessTokenInvalid = AccessTokenInvalid;
    class AccessTokenExpired extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20104;
            this.description = 'Access token expired or expiration date invalid';
            this.explanation = 'The Access Token provided to the Twilio API has expired, the expiration time specified in the token was invalid, or the expiration time specified was too far in the future';
            this.name = 'AccessTokenExpired';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AccessTokenExpired.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AccessTokenExpired = AccessTokenExpired;
    class AuthenticationFailed extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20151;
            this.description = 'Authentication Failed';
            this.explanation = 'The Authentication with the provided JWT failed';
            this.name = 'AuthenticationFailed';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AuthenticationFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AuthenticationFailed = AuthenticationFailed;
})(AuthorizationErrors || (AuthorizationErrors = {}));
var SignatureValidationErrors;
(function(SignatureValidationErrors) {
    class AccessTokenSignatureValidationFailed extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The access token has an invalid Account SID, API Key, or API Key Secret.'
            ];
            this.code = 31202;
            this.description = 'Signature validation failed.';
            this.explanation = 'The provided access token failed signature validation.';
            this.name = 'AccessTokenSignatureValidationFailed';
            this.solutions = [
                'Ensure the Account SID, API Key, and API Key Secret are valid when generating your access token.'
            ];
            Object.setPrototypeOf(this, SignatureValidationErrors.AccessTokenSignatureValidationFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignatureValidationErrors.AccessTokenSignatureValidationFailed = AccessTokenSignatureValidationFailed;
})(SignatureValidationErrors || (SignatureValidationErrors = {}));
var ClientErrors;
(function(ClientErrors) {
    class BadRequest extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31400;
            this.description = 'Bad Request (HTTP/SIP)';
            this.explanation = 'The request could not be understood due to malformed syntax.';
            this.name = 'BadRequest';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.BadRequest.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.BadRequest = BadRequest;
    class NotFound extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The outbound call was made to an invalid phone number.',
                'The TwiML application sid is missing a Voice URL.'
            ];
            this.code = 31404;
            this.description = 'Not Found (HTTP/SIP)';
            this.explanation = 'The server has not found anything matching the request.';
            this.name = 'NotFound';
            this.solutions = [
                'Ensure the phone number dialed is valid.',
                'Ensure the TwiML application is configured correctly with a Voice URL link.'
            ];
            Object.setPrototypeOf(this, ClientErrors.NotFound.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.NotFound = NotFound;
    class TemporarilyUnavailable extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31480;
            this.description = 'Temporarily Unavailable (SIP)';
            this.explanation = 'The callee is currently unavailable.';
            this.name = 'TemporarilyUnavailable';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.TemporarilyUnavailable.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.TemporarilyUnavailable = TemporarilyUnavailable;
    class BusyHere extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31486;
            this.description = 'Busy Here (SIP)';
            this.explanation = 'The callee is busy.';
            this.name = 'BusyHere';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.BusyHere.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.BusyHere = BusyHere;
})(ClientErrors || (ClientErrors = {}));
var SIPServerErrors;
(function(SIPServerErrors) {
    class Decline extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31603;
            this.description = 'Decline (SIP)';
            this.explanation = 'The callee does not wish to participate in the call.';
            this.name = 'Decline';
            this.solutions = [];
            Object.setPrototypeOf(this, SIPServerErrors.Decline.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SIPServerErrors.Decline = Decline;
})(SIPServerErrors || (SIPServerErrors = {}));
var GeneralErrors;
(function(GeneralErrors) {
    class UnknownError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31000;
            this.description = 'Unknown Error';
            this.explanation = 'An unknown error has occurred. See error details for more information.';
            this.name = 'UnknownError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.UnknownError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.UnknownError = UnknownError;
    class ApplicationNotFoundError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31001;
            this.description = 'Application Not Found';
            this.explanation = '';
            this.name = 'ApplicationNotFoundError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ApplicationNotFoundError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ApplicationNotFoundError = ApplicationNotFoundError;
    class ConnectionDeclinedError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31002;
            this.description = 'Connection Declined';
            this.explanation = '';
            this.name = 'ConnectionDeclinedError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionDeclinedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionDeclinedError = ConnectionDeclinedError;
    class ConnectionTimeoutError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31003;
            this.description = 'Connection Timeout';
            this.explanation = 'The server could not produce a response within a suitable amount of time.';
            this.name = 'ConnectionTimeoutError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionTimeoutError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionTimeoutError = ConnectionTimeoutError;
    class ConnectionError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31005;
            this.description = 'Connection error';
            this.explanation = 'A connection error occurred during the call';
            this.name = 'ConnectionError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionError = ConnectionError;
    class CallCancelledError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity.'
            ];
            this.code = 31008;
            this.description = 'Call cancelled';
            this.explanation = 'Unable to answer because the call has ended';
            this.name = 'CallCancelledError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.CallCancelledError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.CallCancelledError = CallCancelledError;
    class TransportError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31009;
            this.description = 'Transport error';
            this.explanation = 'No transport available to send or receive messages';
            this.name = 'TransportError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.TransportError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.TransportError = TransportError;
})(GeneralErrors || (GeneralErrors = {}));
var MalformedRequestErrors;
(function(MalformedRequestErrors) {
    class MalformedRequestError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Invalid content or MessageType passed to sendMessage method.'
            ];
            this.code = 31100;
            this.description = 'The request had malformed syntax.';
            this.explanation = 'The request could not be understood due to malformed syntax.';
            this.name = 'MalformedRequestError';
            this.solutions = [
                'Ensure content and MessageType passed to sendMessage method are valid.'
            ];
            Object.setPrototypeOf(this, MalformedRequestErrors.MalformedRequestError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MalformedRequestError = MalformedRequestError;
    class MissingParameterArrayError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31101;
            this.description = 'Missing parameter array in request';
            this.explanation = '';
            this.name = 'MissingParameterArrayError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.MissingParameterArrayError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MissingParameterArrayError = MissingParameterArrayError;
    class AuthorizationTokenMissingError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31102;
            this.description = 'Authorization token missing in request.';
            this.explanation = '';
            this.name = 'AuthorizationTokenMissingError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.AuthorizationTokenMissingError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.AuthorizationTokenMissingError = AuthorizationTokenMissingError;
    class MaxParameterLengthExceededError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31103;
            this.description = 'Maximum parameter length has been exceeded.';
            this.explanation = 'Length of parameters cannot exceed MAX_PARAM_LENGTH.';
            this.name = 'MaxParameterLengthExceededError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.MaxParameterLengthExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MaxParameterLengthExceededError = MaxParameterLengthExceededError;
    class InvalidBridgeTokenError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31104;
            this.description = 'Invalid bridge token';
            this.explanation = '';
            this.name = 'InvalidBridgeTokenError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.InvalidBridgeTokenError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.InvalidBridgeTokenError = InvalidBridgeTokenError;
    class InvalidClientNameError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Client name contains invalid characters.'
            ];
            this.code = 31105;
            this.description = 'Invalid client name';
            this.explanation = 'Client name should not contain control, space, delims, or unwise characters.';
            this.name = 'InvalidClientNameError';
            this.solutions = [
                'Make sure that client name does not contain any of the invalid characters.'
            ];
            Object.setPrototypeOf(this, MalformedRequestErrors.InvalidClientNameError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.InvalidClientNameError = InvalidClientNameError;
    class ReconnectParameterInvalidError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31107;
            this.description = 'The reconnect parameter is invalid';
            this.explanation = '';
            this.name = 'ReconnectParameterInvalidError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.ReconnectParameterInvalidError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.ReconnectParameterInvalidError = ReconnectParameterInvalidError;
})(MalformedRequestErrors || (MalformedRequestErrors = {}));
(function(AuthorizationErrors) {
    class AuthorizationError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31201;
            this.description = 'Authorization error';
            this.explanation = 'The request requires user authentication. The server understood the request, but is refusing to fulfill it.';
            this.name = 'AuthorizationError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AuthorizationError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AuthorizationError = AuthorizationError;
    class NoValidAccountError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31203;
            this.description = 'No valid account';
            this.explanation = '';
            this.name = 'NoValidAccountError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.NoValidAccountError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.NoValidAccountError = NoValidAccountError;
    class InvalidJWTTokenError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31204;
            this.description = 'Invalid JWT token';
            this.explanation = '';
            this.name = 'InvalidJWTTokenError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.InvalidJWTTokenError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.InvalidJWTTokenError = InvalidJWTTokenError;
    class JWTTokenExpiredError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31205;
            this.description = 'JWT token expired';
            this.explanation = '';
            this.name = 'JWTTokenExpiredError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.JWTTokenExpiredError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.JWTTokenExpiredError = JWTTokenExpiredError;
    class RateExceededError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Rate limit exceeded.'
            ];
            this.code = 31206;
            this.description = 'Rate exceeded authorized limit.';
            this.explanation = 'The request performed exceeds the authorized limit.';
            this.name = 'RateExceededError';
            this.solutions = [
                'Ensure message send rate does not exceed authorized limits.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.RateExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.RateExceededError = RateExceededError;
    class JWTTokenExpirationTooLongError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31207;
            this.description = 'JWT token expiration too long';
            this.explanation = '';
            this.name = 'JWTTokenExpirationTooLongError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.JWTTokenExpirationTooLongError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.JWTTokenExpirationTooLongError = JWTTokenExpirationTooLongError;
    class ReconnectAttemptError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31209;
            this.description = 'Reconnect attempt is not authorized.';
            this.explanation = '';
            this.name = 'ReconnectAttemptError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.ReconnectAttemptError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.ReconnectAttemptError = ReconnectAttemptError;
    class CallMessageEventTypeInvalidError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Call Message Event Type is invalid and is not understood by Twilio Voice.'
            ];
            this.code = 31210;
            this.description = 'Call Message Event Type is invalid.';
            this.explanation = 'The Call Message Event Type is invalid and is not understood by Twilio Voice.';
            this.name = 'CallMessageEventTypeInvalidError';
            this.solutions = [
                'Ensure the Call Message Event Type is Valid and understood by Twilio Voice and try again.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.CallMessageEventTypeInvalidError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.CallMessageEventTypeInvalidError = CallMessageEventTypeInvalidError;
    class PayloadSizeExceededError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The payload size of Call Message Event exceeds the authorized limit.'
            ];
            this.code = 31212;
            this.description = 'Call Message Event Payload size exceeded authorized limit.';
            this.explanation = 'The request performed to send a Call Message Event exceeds the payload size authorized limit';
            this.name = 'PayloadSizeExceededError';
            this.solutions = [
                'Reduce payload size of Call Message Event to be within the authorized limit and try again.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.PayloadSizeExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.PayloadSizeExceededError = PayloadSizeExceededError;
})(AuthorizationErrors || (AuthorizationErrors = {}));
var UserMediaErrors;
(function(UserMediaErrors) {
    class PermissionDeniedError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The user denied the getUserMedia request.',
                'The browser denied the getUserMedia request.'
            ];
            this.code = 31401;
            this.description = 'UserMedia Permission Denied Error';
            this.explanation = 'The browser or end-user denied permissions to user media. Therefore we were unable to acquire input audio.';
            this.name = 'PermissionDeniedError';
            this.solutions = [
                'The user should accept the request next time prompted. If the browser saved the deny, the user should change that permission in their browser.',
                'The user should to verify that the browser has permission to access the microphone at this address.'
            ];
            Object.setPrototypeOf(this, UserMediaErrors.PermissionDeniedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    UserMediaErrors.PermissionDeniedError = PermissionDeniedError;
    class AcquisitionFailedError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'NotFoundError - The deviceID specified was not found.',
                'The getUserMedia constraints were overconstrained and no devices matched.'
            ];
            this.code = 31402;
            this.description = 'UserMedia Acquisition Failed Error';
            this.explanation = 'The browser and end-user allowed permissions, however getting the media failed. Usually this is due to bad constraints, but can sometimes fail due to browser, OS or hardware issues.';
            this.name = 'AcquisitionFailedError';
            this.solutions = [
                'Ensure the deviceID being specified exists.',
                'Try acquiring media with fewer constraints.'
            ];
            Object.setPrototypeOf(this, UserMediaErrors.AcquisitionFailedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    UserMediaErrors.AcquisitionFailedError = AcquisitionFailedError;
})(UserMediaErrors || (UserMediaErrors = {}));
var SignalingErrors;
(function(SignalingErrors) {
    class ConnectionError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 53000;
            this.description = 'Signaling connection error';
            this.explanation = 'Raised whenever a signaling connection error occurs that is not covered by a more specific error code.';
            this.name = 'ConnectionError';
            this.solutions = [];
            Object.setPrototypeOf(this, SignalingErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignalingErrors.ConnectionError = ConnectionError;
    class ConnectionDisconnected extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The device running your application lost its Internet connection.'
            ];
            this.code = 53001;
            this.description = 'Signaling connection disconnected';
            this.explanation = 'Raised whenever the signaling connection is unexpectedly disconnected.';
            this.name = 'ConnectionDisconnected';
            this.solutions = [
                'Ensure the device running your application has access to a stable Internet connection.'
            ];
            Object.setPrototypeOf(this, SignalingErrors.ConnectionDisconnected.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignalingErrors.ConnectionDisconnected = ConnectionDisconnected;
})(SignalingErrors || (SignalingErrors = {}));
var MediaErrors;
(function(MediaErrors) {
    class ClientLocalDescFailed extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client may not be using a supported WebRTC implementation.',
                'The Client may not have the necessary resources to create or apply a new media description.'
            ];
            this.code = 53400;
            this.description = 'Client is unable to create or apply a local media description';
            this.explanation = 'Raised whenever a Client is unable to create or apply a local media description.';
            this.name = 'ClientLocalDescFailed';
            this.solutions = [
                'If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ClientLocalDescFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ClientLocalDescFailed = ClientLocalDescFailed;
    class ClientRemoteDescFailed extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client may not be using a supported WebRTC implementation.',
                'The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.',
                'The Client may not have the necessary resources to apply a new media description.'
            ];
            this.code = 53402;
            this.description = 'Client is unable to apply a remote media description';
            this.explanation = 'Raised whenever the Client receives a remote media description but is unable to apply it.';
            this.name = 'ClientRemoteDescFailed';
            this.solutions = [
                'If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ClientRemoteDescFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ClientRemoteDescFailed = ClientRemoteDescFailed;
    class ConnectionError extends (0, _twilioErrorDefault.default) {
        constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client was unable to establish a media connection.',
                'A media connection which was active failed liveliness checks.'
            ];
            this.code = 53405;
            this.description = 'Media connection failed';
            this.explanation = 'Raised by the Client or Server whenever a media connection fails.';
            this.name = 'ConnectionError';
            this.solutions = [
                'If the problem persists, try connecting to another region.',
                'Check your Client\'s network connectivity.',
                'If you\'ve provided custom ICE Servers then ensure that the URLs and credentials are valid.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ConnectionError = ConnectionError;
})(MediaErrors || (MediaErrors = {}));
const errorsByCode = new Map([
    [
        20101,
        AuthorizationErrors.AccessTokenInvalid
    ],
    [
        20104,
        AuthorizationErrors.AccessTokenExpired
    ],
    [
        20151,
        AuthorizationErrors.AuthenticationFailed
    ],
    [
        31202,
        SignatureValidationErrors.AccessTokenSignatureValidationFailed
    ],
    [
        31400,
        ClientErrors.BadRequest
    ],
    [
        31404,
        ClientErrors.NotFound
    ],
    [
        31480,
        ClientErrors.TemporarilyUnavailable
    ],
    [
        31486,
        ClientErrors.BusyHere
    ],
    [
        31603,
        SIPServerErrors.Decline
    ],
    [
        31000,
        GeneralErrors.UnknownError
    ],
    [
        31001,
        GeneralErrors.ApplicationNotFoundError
    ],
    [
        31002,
        GeneralErrors.ConnectionDeclinedError
    ],
    [
        31003,
        GeneralErrors.ConnectionTimeoutError
    ],
    [
        31005,
        GeneralErrors.ConnectionError
    ],
    [
        31008,
        GeneralErrors.CallCancelledError
    ],
    [
        31009,
        GeneralErrors.TransportError
    ],
    [
        31100,
        MalformedRequestErrors.MalformedRequestError
    ],
    [
        31101,
        MalformedRequestErrors.MissingParameterArrayError
    ],
    [
        31102,
        MalformedRequestErrors.AuthorizationTokenMissingError
    ],
    [
        31103,
        MalformedRequestErrors.MaxParameterLengthExceededError
    ],
    [
        31104,
        MalformedRequestErrors.InvalidBridgeTokenError
    ],
    [
        31105,
        MalformedRequestErrors.InvalidClientNameError
    ],
    [
        31107,
        MalformedRequestErrors.ReconnectParameterInvalidError
    ],
    [
        31201,
        AuthorizationErrors.AuthorizationError
    ],
    [
        31203,
        AuthorizationErrors.NoValidAccountError
    ],
    [
        31204,
        AuthorizationErrors.InvalidJWTTokenError
    ],
    [
        31205,
        AuthorizationErrors.JWTTokenExpiredError
    ],
    [
        31206,
        AuthorizationErrors.RateExceededError
    ],
    [
        31207,
        AuthorizationErrors.JWTTokenExpirationTooLongError
    ],
    [
        31209,
        AuthorizationErrors.ReconnectAttemptError
    ],
    [
        31210,
        AuthorizationErrors.CallMessageEventTypeInvalidError
    ],
    [
        31212,
        AuthorizationErrors.PayloadSizeExceededError
    ],
    [
        31401,
        UserMediaErrors.PermissionDeniedError
    ],
    [
        31402,
        UserMediaErrors.AcquisitionFailedError
    ],
    [
        53000,
        SignalingErrors.ConnectionError
    ],
    [
        53001,
        SignalingErrors.ConnectionDisconnected
    ],
    [
        53400,
        MediaErrors.ClientLocalDescFailed
    ],
    [
        53402,
        MediaErrors.ClientRemoteDescFailed
    ],
    [
        53405,
        MediaErrors.ConnectionError
    ]
]);
Object.freeze(errorsByCode);

},{"./twilioError":"hABHl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hABHl":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @publicapi
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class TwilioError extends Error {
    constructor(messageOrError, error){
        super();
        Object.setPrototypeOf(this, TwilioError.prototype);
        const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
        const originalError = typeof messageOrError === 'object' ? messageOrError : error;
        this.message = `${this.name} (${this.code}): ${message}`;
        this.originalError = originalError;
    }
}
exports.default = TwilioError;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJjQN":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logger", ()=>Logger);
var _loglevel = require("loglevel");
var _constants = require("./constants");
/**
 * {@link Log} provides logging features throughout the sdk using loglevel module
 * See https://github.com/pimterry/loglevel for documentation
 * @private
 */ class Log {
    /**
     * @constructor
     * @param [tag] - tag name for the logs
     * @param [options] - Optional settings
     */ constructor(tag, options){
        this._log = Log.getLogLevelInstance(options);
        this._prefix = `[TwilioVoice][${tag}]`;
    }
    /**
     * Return the `loglevel` instance maintained internally.
     * @param [options] - Optional settings
     * @returns The `loglevel` instance.
     */ static getLogLevelInstance(options) {
        if (!Log.loglevelInstance) try {
            Log.loglevelInstance = (options && options.LogLevelModule ? options.LogLevelModule : _loglevel).getLogger((0, _constants.PACKAGE_NAME));
        } catch (_a) {
            // tslint:disable-next-line
            console.warn('Cannot create custom logger');
            Log.loglevelInstance = console;
        }
        return Log.loglevelInstance;
    }
    /**
     * Log a debug message
     * @param args - Any number of arguments to be passed to loglevel.debug
     */ debug(...args) {
        this._log.debug(this._prefix, ...args);
    }
    /**
     * Log an error message
     * @param args - Any number of arguments to be passed to loglevel.error
     */ error(...args) {
        this._log.error(this._prefix, ...args);
    }
    /**
     * Log an info message
     * @param args - Any number of arguments to be passed to loglevel.info
     */ info(...args) {
        this._log.info(this._prefix, ...args);
    }
    /**
     * Set a default log level to disable all logging below the given level
     */ setDefaultLevel(level) {
        if (this._log.setDefaultLevel) this._log.setDefaultLevel(level);
        else // tslint:disable-next-line
        console.warn('Logger cannot setDefaultLevel');
    }
    /**
     * Log a warning message
     * @param args - Any number of arguments to be passed to loglevel.warn
     */ warn(...args) {
        this._log.warn(this._prefix, ...args);
    }
}
/**
 * Log levels
 */ Log.levels = _loglevel.levels;
const Logger = Log.getLogLevelInstance();
exports.default = Log;

},{"loglevel":"5ZY8d","./constants":"buVX6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"buVX6":[function(require,module,exports,__globalThis) {
/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COWBELL_AUDIO_URL", ()=>COWBELL_AUDIO_URL);
parcelHelpers.export(exports, "ECHO_TEST_DURATION", ()=>ECHO_TEST_DURATION);
parcelHelpers.export(exports, "PACKAGE_NAME", ()=>PACKAGE_NAME);
parcelHelpers.export(exports, "RELEASE_VERSION", ()=>RELEASE_VERSION);
parcelHelpers.export(exports, "SOUNDS_BASE_URL", ()=>SOUNDS_BASE_URL);
const PACKAGE_NAME = '@twilio/voice-sdk';
const RELEASE_VERSION = '2.12.3';
const SOUNDS_BASE_URL = 'https://sdk.twilio.com/js/client/sounds/releases/1.0.0';
const COWBELL_AUDIO_URL = `${SOUNDS_BASE_URL}/cowbell.mp3?cache=${RELEASE_VERSION}`;
const ECHO_TEST_DURATION = 20000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewWKM":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./constants");
var _errors = require("./errors");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
const DEFAULT_TEST_SOUND_URL = `${(0, _constants.SOUNDS_BASE_URL)}/outgoing.mp3`;
class OutputDeviceCollection {
    /**
     * @private
     */ constructor(_name, _availableDevices, _beforeChange, _isSupported){
        this._name = _name;
        this._availableDevices = _availableDevices;
        this._beforeChange = _beforeChange;
        this._isSupported = _isSupported;
        /**
         * The currently active output devices.
         */ this._activeDevices = new Set();
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('OutputDeviceCollection');
    }
    /**
     * Delete a device from the collection. If no devices remain, the 'default'
     * device will be added as the sole device. If no `default` device exists,
     * the first available device will be used.
     * @param device - The device to delete from the collection
     * @returns whether the device was present before it was deleted
     */ delete(device) {
        this._log.debug('.delete', device);
        const wasDeleted = !!this._activeDevices.delete(device);
        const defaultDevice = this._availableDevices.get('default') || Array.from(this._availableDevices.values())[0];
        if (!this._activeDevices.size && defaultDevice) this._activeDevices.add(defaultDevice);
        // Call _beforeChange so that the implementation can react when a device is
        // removed or lost.
        const deviceIds = Array.from(this._activeDevices.values()).map((deviceInfo)=>deviceInfo.deviceId);
        this._beforeChange(this._name, deviceIds);
        return !!wasDeleted;
    }
    /**
     * Get the current set of devices.
     */ get() {
        return this._activeDevices;
    }
    /**
     * Replace the current set of devices with a new set of devices.
     * @param deviceIdOrIds - An ID or array of IDs of devices to replace the existing devices with.
     * @returns Rejects if this feature is not supported, any of the supplied IDs are not found,
     * or no IDs are passed.
     */ set(deviceIdOrIds) {
        this._log.debug('.set', deviceIdOrIds);
        if (!this._isSupported) return Promise.reject(new (0, _errors.NotSupportedError)('This browser does not support audio output selection'));
        const deviceIds = Array.isArray(deviceIdOrIds) ? deviceIdOrIds : [
            deviceIdOrIds
        ];
        if (!deviceIds.length) return Promise.reject(new (0, _errors.InvalidArgumentError)('Must specify at least one device to set'));
        const missingIds = [];
        const devices = deviceIds.map((id)=>{
            const device = this._availableDevices.get(id);
            if (!device) missingIds.push(id);
            return device;
        });
        if (missingIds.length) return Promise.reject(new (0, _errors.InvalidArgumentError)(`Devices not found: ${missingIds.join(', ')}`));
        return new Promise((resolve)=>{
            resolve(this._beforeChange(this._name, deviceIds));
        }).then(()=>{
            this._activeDevices.clear();
            devices.forEach(this._activeDevices.add, this._activeDevices);
        });
    }
    /**
     * Test the devices by playing audio through them.
     * @param [soundUrl] - An optional URL. If none is specified, we will
     *   play a default test tone.
     * @returns Resolves with the result of the underlying HTMLAudioElements' play() calls.
     */ test(soundUrl = DEFAULT_TEST_SOUND_URL) {
        if (!this._isSupported) return Promise.reject(new (0, _errors.NotSupportedError)('This browser does not support audio output selection'));
        if (!this._activeDevices.size) return Promise.reject(new (0, _errors.InvalidStateError)('No active output devices to test'));
        return Promise.all(Array.from(this._activeDevices).map((device)=>{
            let el;
            // (rrowland) We need to wait for the oncanplay event because of a regression introduced
            // in Chrome M72: https://bugs.chromium.org/p/chromium/issues/detail?id=930876
            return new Promise((resolve)=>{
                el = new Audio(soundUrl);
                el.oncanplay = resolve;
            }).then(()=>el.setSinkId(device.deviceId).then(()=>el.play()));
        }));
    }
}
exports.default = OutputDeviceCollection;

},{"./constants":"buVX6","./errors":"caXI8","./log":"eJjQN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VLyx":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class MediaDeviceInfoShim {
    constructor(options){
        Object.defineProperties(this, {
            deviceId: {
                get () {
                    return options.deviceId;
                }
            },
            groupId: {
                get () {
                    return options.groupId;
                }
            },
            kind: {
                get () {
                    return options.kind;
                }
            },
            label: {
                get () {
                    return options.label;
                }
            }
        });
    }
}
exports.default = MediaDeviceInfoShim;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8qrE":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
/**
 * Exception class.
 * @class
 * @name Exception
 * @exports Exception as Twilio.Exception
 * @memberOf Twilio
 * @param {string} message The exception message
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Exception", ()=>Exception);
parcelHelpers.export(exports, "average", ()=>average);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
parcelHelpers.export(exports, "isChrome", ()=>isChrome);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
parcelHelpers.export(exports, "isLegacyEdge", ()=>isLegacyEdge);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isUnifiedPlanDefault", ()=>isUnifiedPlanDefault);
parcelHelpers.export(exports, "queryToJson", ()=>queryToJson);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
parcelHelpers.export(exports, "promisifyEvents", ()=>promisifyEvents);
var global = arguments[3];
function TwilioException(message) {
    if (!(this instanceof TwilioException)) return new TwilioException(message);
    this.message = message;
}
/**
 * Returns the exception message.
 *
 * @return {string} The exception message.
 */ TwilioException.prototype.toString = function() {
    return `Twilio.Exception: ${this.message}`;
};
function average(values) {
    return values && values.length ? values.reduce((t, v)=>t + v) / values.length : 0;
}
function difference(lefts, rights, getKey) {
    getKey = getKey || ((a)=>a);
    const rightKeys = new Set(rights.map(getKey));
    return lefts.filter((left)=>!rightKeys.has(getKey(left)));
}
function isElectron(navigator) {
    return !!navigator.userAgent.match('Electron');
}
function isChrome(window1, navigator) {
    const isCriOS = !!navigator.userAgent.match('CriOS');
    const isHeadlessChrome = !!navigator.userAgent.match('HeadlessChrome');
    const isGoogle = typeof window1.chrome !== 'undefined' && navigator.vendor === 'Google Inc.' && navigator.userAgent.indexOf('OPR') === -1 && navigator.userAgent.indexOf('Edge') === -1;
    return isCriOS || isElectron(navigator) || isGoogle || isHeadlessChrome;
}
function isFirefox(navigator) {
    navigator = navigator || (typeof window === 'undefined' ? global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === 'string' && /firefox|fxios/i.test(navigator.userAgent);
}
function isLegacyEdge(navigator) {
    navigator = navigator || (typeof window === 'undefined' ? global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === 'string' && /edge\/\d+/i.test(navigator.userAgent);
}
function isSafari(navigator) {
    return !!navigator.vendor && navigator.vendor.indexOf('Apple') !== -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
}
function isUnifiedPlanDefault(window1, navigator, PeerConnection, RtpTransceiver) {
    if (typeof window1 === 'undefined' || typeof navigator === 'undefined' || typeof PeerConnection === 'undefined' || typeof RtpTransceiver === 'undefined' || typeof PeerConnection.prototype === 'undefined' || typeof RtpTransceiver.prototype === 'undefined') return false;
    if (isChrome(window1, navigator) && PeerConnection.prototype.addTransceiver) {
        const pc = new PeerConnection();
        let isUnifiedPlan = true;
        try {
            pc.addTransceiver('audio');
        } catch (e) {
            isUnifiedPlan = false;
        }
        pc.close();
        return isUnifiedPlan;
    } else if (isFirefox(navigator)) return true;
    else if (isSafari(navigator)) return 'currentDirection' in RtpTransceiver.prototype;
    // Edge currently does not support unified plan.
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/17733189/
    // https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/34451998-sdp-unified-plan
    return false;
}
function queryToJson(params) {
    if (!params) return '';
    return params.split('&').reduce((output, pair)=>{
        const parts = pair.split('=');
        const key = parts[0];
        const value = decodeURIComponent((parts[1] || '').replace(/\+/g, '%20'));
        if (key) output[key] = value;
        return output;
    }, {});
}
/**
 * Map a list to an array of arrays, and return the flattened result.
 * @param {Array<*>|Set<*>|Map<*>} list
 * @param {function(*): Array<*>} [mapFn]
 * @returns Array<*>
 */ function flatMap(list, mapFn) {
    const listArray = list instanceof Map || list instanceof Set ? Array.from(list.values()) : list;
    mapFn = mapFn || ((item)=>item);
    return listArray.reduce((flattened, item)=>{
        const mapped = mapFn(item);
        return flattened.concat(mapped);
    }, []);
}
/**
 * Converts an EventEmitter's events into a promise and automatically
 * cleans up handlers once the promise is resolved or rejected.
 */ function promisifyEvents(emitter, resolveEventName, rejectEventName) {
    return new Promise((resolve, reject)=>{
        function resolveHandler() {
            emitter.removeListener(rejectEventName, rejectHandler);
            resolve();
        }
        function rejectHandler() {
            emitter.removeListener(resolveEventName, resolveHandler);
            reject();
        }
        emitter.once(resolveEventName, resolveHandler);
        emitter.once(rejectEventName, rejectHandler);
    });
}
const Exception = TwilioException;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GH2u":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @private
 */ parcelHelpers.export(exports, "AudioProcessorEventObserver", ()=>AudioProcessorEventObserver);
var _events = require("events");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
class AudioProcessorEventObserver extends (0, _events.EventEmitter) {
    constructor(){
        super();
        this._log = new (0, _logDefault.default)('AudioProcessorEventObserver');
        this._log.info('Creating AudioProcessorEventObserver instance');
        this.on('enabled', ()=>this._reEmitEvent('enabled'));
        this.on('add', ()=>this._reEmitEvent('add'));
        this.on('remove', ()=>this._reEmitEvent('remove'));
        this.on('create', ()=>this._reEmitEvent('create-processed-stream'));
        this.on('destroy', ()=>this._reEmitEvent('destroy-processed-stream'));
    }
    destroy() {
        this.removeAllListeners();
    }
    _reEmitEvent(name) {
        this._log.info(`AudioProcessor:${name}`);
        this.emit('event', {
            name,
            group: 'audio-processor'
        });
    }
}

},{"events":"fqTtD","./log":"eJjQN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4YJjX":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("./errors");
/**
 * A Map of DTMF Sound Names to their mock frequency pairs.
 */ const bandFrequencies = {
    dtmf0: [
        1360,
        960
    ],
    dtmf1: [
        1230,
        720
    ],
    dtmf2: [
        1360,
        720
    ],
    dtmf3: [
        1480,
        720
    ],
    dtmf4: [
        1230,
        790
    ],
    dtmf5: [
        1360,
        790
    ],
    dtmf6: [
        1480,
        790
    ],
    dtmf7: [
        1230,
        870
    ],
    dtmf8: [
        1360,
        870
    ],
    dtmf9: [
        1480,
        870
    ],
    dtmfh: [
        1480,
        960
    ],
    dtmfs: [
        1230,
        960
    ]
};
class DialtonePlayer {
    constructor(_context){
        this._context = _context;
        /**
         * Gain nodes, reducing the frequency.
         */ this._gainNodes = [];
        this._gainNodes = [
            this._context.createGain(),
            this._context.createGain()
        ];
        this._gainNodes.forEach((gainNode)=>{
            gainNode.connect(this._context.destination);
            gainNode.gain.value = 0.1;
            this._gainNodes.push(gainNode);
        });
    }
    cleanup() {
        this._gainNodes.forEach((gainNode)=>{
            gainNode.disconnect();
        });
    }
    /**
     * Play the dual frequency tone for the passed DTMF name.
     * @param sound
     */ play(sound) {
        const frequencies = bandFrequencies[sound];
        if (!frequencies) throw new (0, _errors.InvalidArgumentError)('Invalid DTMF sound name');
        const oscillators = [
            this._context.createOscillator(),
            this._context.createOscillator()
        ];
        oscillators.forEach((oscillator, i)=>{
            oscillator.type = 'sine';
            oscillator.frequency.value = frequencies[i];
            oscillator.connect(this._gainNodes[i]);
            oscillator.start();
            oscillator.stop(this._context.currentTime + 0.1);
            oscillator.addEventListener('ended', ()=>oscillator.disconnect());
        });
    }
}
exports.default = DialtonePlayer;

},{"./errors":"caXI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Bhuv":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _request = require("./request");
var _requestDefault = parcelHelpers.interopDefault(_request);
/**
 * Builds Endpoint Analytics (EA) event payloads and sends them to
 *   the EA server.
 * @constructor
 * @param {String} productName - Name of the product publishing events.
 * @param {String} token - The JWT token to use to authenticate with
 *   the EA server.
 * @param {EventPublisher.Options} options
 * @property {Boolean} isEnabled - Whether or not this publisher is publishing
 *   to the server. Currently ignores the request altogether, in the future this
 *   may store them in case publishing is re-enabled later. Defaults to true.
 */ /**
 * @typedef {Object} EventPublisher.Options
 * @property {Object} [metadata=undefined] - A publisher_metadata object to send
 *   with each payload.
 * @property {String} [host='eventgw.twilio.com'] - The host address of the EA
 *   server to publish to.
 * @property {Object|Function} [defaultPayload] - A default payload to extend
 *   when creating and sending event payloads. Also takes a function that
 *   should return an object representing the default payload. This is
 *   useful for fields that should always be present when they are
 *   available, but are not always available.
 */ class EventPublisher extends (0, _events.EventEmitter) {
    constructor(productName, token, options){
        super();
        if (!(this instanceof EventPublisher)) return new EventPublisher(productName, token, options);
        // Apply default options
        options = Object.assign({
            defaultPayload () {
                return {};
            }
        }, options);
        let defaultPayload = options.defaultPayload;
        if (typeof defaultPayload !== 'function') defaultPayload = ()=>Object.assign({}, options.defaultPayload);
        let isEnabled = true;
        const metadata = Object.assign({
            app_name: undefined,
            app_version: undefined
        }, options.metadata);
        Object.defineProperties(this, {
            _defaultPayload: {
                value: defaultPayload
            },
            _host: {
                value: options.host,
                writable: true
            },
            _isEnabled: {
                get () {
                    return isEnabled;
                },
                set (_isEnabled) {
                    isEnabled = _isEnabled;
                }
            },
            _log: {
                value: new (0, _logDefault.default)('EventPublisher')
            },
            _request: {
                value: options.request || (0, _requestDefault.default),
                writable: true
            },
            _token: {
                value: token,
                writable: true
            },
            isEnabled: {
                enumerable: true,
                get () {
                    return isEnabled;
                }
            },
            metadata: {
                enumerable: true,
                get () {
                    return metadata;
                }
            },
            productName: {
                enumerable: true,
                value: productName
            },
            token: {
                enumerable: true,
                get () {
                    return this._token;
                }
            }
        });
    }
}
/**
 * Post to an EA server.
 * @private
 * @param {String} endpointName - Endpoint to post the event to
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @param {?Boolean} [force=false] - Whether or not to send this even if
 *    publishing is disabled.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype._post = function _post(endpointName, level, group, name, payload, connection, force) {
    if (!this.isEnabled && !force || !this._host) {
        this._log.debug('Publishing cancelled', JSON.stringify({
            isEnabled: this.isEnabled,
            force,
            host: this._host
        }));
        return Promise.resolve();
    }
    if (!connection || (!connection.parameters || !connection.parameters.CallSid) && !connection.outboundConnectionId) {
        if (!connection) this._log.debug('Publishing cancelled. Missing connection object');
        else this._log.debug('Publishing cancelled. Missing connection info', JSON.stringify({
            outboundConnectionId: connection.outboundConnectionId,
            parameters: connection.parameters
        }));
        return Promise.resolve();
    }
    const event = {
        group,
        level: level.toUpperCase(),
        name,
        payload: payload && payload.forEach ? payload.slice(0) : Object.assign(this._defaultPayload(connection), payload),
        payload_type: 'application/json',
        private: false,
        publisher: this.productName,
        timestamp: new Date().toISOString()
    };
    if (this.metadata) event.publisher_metadata = this.metadata;
    if (endpointName === 'EndpointEvents') this._log.debug('Publishing insights', JSON.stringify({
        endpointName,
        event,
        force,
        host: this._host
    }));
    const requestParams = {
        body: event,
        headers: {
            'Content-Type': 'application/json',
            'X-Twilio-Token': this.token
        },
        url: `https://${this._host}/v4/${endpointName}`
    };
    return new Promise((resolve, reject)=>{
        this._request.post(requestParams, (err)=>{
            if (err) {
                this.emit('error', err);
                reject(err);
            } else resolve();
        });
    }).catch((e)=>{
        this._log.error(`Unable to post ${group} ${name} event to Insights. Received error: ${e}`);
    });
};
/**
 * Post an event to the EA server. Use this method when the level
 *  is dynamic. Otherwise, it's better practice to use the sugar
 *  methods named for the specific level.
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.post = function post(level, group, name, payload, connection, force) {
    return this._post('EndpointEvents', level, group, name, payload, connection, force);
};
/**
 * Post a debug-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.debug = function debug(group, name, payload, connection) {
    return this.post('debug', group, name, payload, connection);
};
/**
 * Post an info-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.info = function info(group, name, payload, connection) {
    return this.post('info', group, name, payload, connection);
};
/**
 * Post a warning-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.warn = function warn(group, name, payload, connection) {
    return this.post('warning', group, name, payload, connection);
};
/**
 * Post an error-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.error = function error(group, name, payload, connection) {
    return this.post('error', group, name, payload, connection);
};
/**
 * Post a metrics event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {Array<Object>} metrics - The metrics to post.
 * @param {?Object} [customFields] - Custom fields to append to each payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ EventPublisher.prototype.postMetrics = function postMetrics(group, name, metrics, customFields, connection) {
    return new Promise((resolve)=>{
        const samples = metrics.map(formatMetric).map((sample)=>Object.assign(sample, customFields));
        resolve(this._post('EndpointMetrics', 'info', group, name, samples, connection));
    });
};
/**
 * Update the host address of the insights server to publish to.
 * @param {String} host - The new host address of the insights server.
 */ EventPublisher.prototype.setHost = function setHost(host) {
    this._host = host;
};
/**
 * Update the token to use to authenticate requests.
 * @param {string} token
 * @returns {void}
 */ EventPublisher.prototype.setToken = function setToken(token) {
    this._token = token;
};
/**
 * Enable the publishing of events.
 */ EventPublisher.prototype.enable = function enable() {
    this._isEnabled = true;
};
/**
 * Disable the publishing of events.
 */ EventPublisher.prototype.disable = function disable() {
    this._isEnabled = false;
};
function formatMetric(sample) {
    return {
        audio_codec: sample.codecName,
        audio_level_in: sample.audioInputLevel,
        audio_level_out: sample.audioOutputLevel,
        bytes_received: sample.bytesReceived,
        bytes_sent: sample.bytesSent,
        call_volume_input: sample.inputVolume,
        call_volume_output: sample.outputVolume,
        jitter: sample.jitter,
        mos: sample.mos && Math.round(sample.mos * 100) / 100,
        packets_lost: sample.packetsLost,
        packets_lost_fraction: sample.packetsLostFraction && Math.round(sample.packetsLostFraction * 100) / 100,
        packets_received: sample.packetsReceived,
        rtt: sample.rtt,
        timestamp: new Date(sample.timestamp).toISOString(),
        total_bytes_received: sample.totals.bytesReceived,
        total_bytes_sent: sample.totals.bytesSent,
        total_packets_lost: sample.totals.packetsLost,
        total_packets_received: sample.totals.packetsReceived,
        total_packets_sent: sample.totals.packetsSent
    };
}
exports.default = EventPublisher;

},{"events":"fqTtD","./log":"eJjQN","./request":"hx1fp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hx1fp":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function request(method, params, callback) {
    const body = JSON.stringify(params.body || {});
    const headers = new Headers();
    params.headers = params.headers || [];
    Object.entries(params.headers).forEach(([headerName, headerBody])=>headers.append(headerName, headerBody));
    fetch(params.url, {
        body,
        headers,
        method
    }).then((response)=>response.text(), callback).then((responseText)=>callback(null, responseText), callback);
}
/**
 * Use XMLHttpRequest to get a network resource.
 * @param {String} method - HTTP Method
 * @param {Object} params - Request parameters
 * @param {String} params.url - URL of the resource
 * @param {Array}  params.headers - An array of headers to pass [{ headerName : headerBody }]
 * @param {Object} params.body - A JSON body to send to the resource
 * @returns {response}
 */ const Request = request;
/**
 * Sugar function for request('GET', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~get} callback - The callback that handles the response.
 */ Request.get = function get(params, callback) {
    return new this('GET', params, callback);
};
/**
 * Sugar function for request('POST', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~post} callback - The callback that handles the response.
 */ Request.post = function post(params, callback) {
    return new this('POST', params, callback);
};
exports.default = Request;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Nh8w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Runs some tests to identify issues, if any, prohibiting successful calling.
 */ parcelHelpers.export(exports, "PreflightTest", ()=>PreflightTest);
/**
 * @packageDocumentation
 * @module Voice
 * @preferred
 * @publicapi
 */ var _events = require("events");
var _call = require("../call");
var _callDefault = parcelHelpers.interopDefault(_call);
var _device = require("../device");
var _deviceDefault = parcelHelpers.interopDefault(_device);
var _errors = require("../errors");
var _log = require("../log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _stats = require("../rtc/stats");
var _constants = require("../constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class PreflightTest extends (0, _events.EventEmitter) {
    /**
     * Construct a {@link PreflightTest} instance.
     * @constructor
     * @param token - A Twilio JWT token string.
     * @param options
     */ constructor(token, options){
        super();
        /**
         * Whether this test has already logged an insights-connection-warning.
         */ this._hasInsightsErrored = false;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('PreflightTest');
        /**
         * Network related timing measurements for this test
         */ this._networkTiming = {};
        /**
         * The options passed to {@link PreflightTest} constructor
         */ this._options = {
            codecPreferences: [
                (0, _callDefault.default).Codec.PCMU,
                (0, _callDefault.default).Codec.Opus
            ],
            edge: 'roaming',
            fakeMicInput: false,
            logLevel: 'error',
            signalingTimeoutMs: 10000
        };
        /**
         * Current status of this test
         */ this._status = PreflightTest.Status.Connecting;
        Object.assign(this._options, options);
        this._samples = [];
        this._warnings = [];
        this._startTime = Date.now();
        this._initDevice(token, Object.assign(Object.assign({}, this._options), {
            fileInputStream: this._options.fakeMicInput ? this._getStreamFromFile() : undefined
        }));
        // Device sets the loglevel so start logging after initializing the device.
        // Then selectively log options that users can modify.
        const userOptions = [
            'codecPreferences',
            'edge',
            'fakeMicInput',
            'logLevel',
            'signalingTimeoutMs'
        ];
        const userOptionOverrides = [
            'audioContext',
            'deviceFactory',
            'fileInputStream',
            'getRTCIceCandidateStatsReport',
            'iceServers',
            'rtcConfiguration'
        ];
        if (typeof options === 'object') {
            const toLog = Object.assign({}, options);
            Object.keys(toLog).forEach((key)=>{
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog[key];
                if (userOptionOverrides.includes(key)) toLog[key] = true;
            });
            this._log.debug('.constructor', JSON.stringify(toLog));
        }
    }
    /**
     * Stops the current test and raises a failed event.
     */ stop() {
        this._log.debug('.stop');
        const error = new (0, _errors.GeneralErrors).CallCancelledError();
        if (this._device) {
            this._device.once((0, _deviceDefault.default).EventName.Unregistered, ()=>this._onFailed(error));
            this._device.destroy();
        } else this._onFailed(error);
    }
    /**
     * Emit a {PreflightTest.Warning}
     */ _emitWarning(name, description, rtcWarning) {
        const warning = {
            name,
            description
        };
        if (rtcWarning) warning.rtcWarning = rtcWarning;
        this._warnings.push(warning);
        this._log.debug(`#${PreflightTest.Events.Warning}`, JSON.stringify(warning));
        this.emit(PreflightTest.Events.Warning, warning);
    }
    /**
     * Returns call quality base on the RTC Stats
     */ _getCallQuality(mos) {
        if (mos > 4.2) return PreflightTest.CallQuality.Excellent;
        else if (mos >= 4.1 && mos <= 4.2) return PreflightTest.CallQuality.Great;
        else if (mos >= 3.7 && mos <= 4) return PreflightTest.CallQuality.Good;
        else if (mos >= 3.1 && mos <= 3.6) return PreflightTest.CallQuality.Fair;
        else return PreflightTest.CallQuality.Degraded;
    }
    /**
     * Returns the report for this test.
     */ _getReport() {
        var _a, _b, _c;
        const stats = this._getRTCStats();
        const testTiming = {
            start: this._startTime
        };
        if (this._endTime) {
            testTiming.end = this._endTime;
            testTiming.duration = this._endTime - this._startTime;
        }
        const report = {
            callSid: this._callSid,
            edge: this._edge,
            iceCandidateStats: (_b = (_a = this._rtcIceCandidateStatsReport) === null || _a === void 0 ? void 0 : _a.iceCandidateStats) !== null && _b !== void 0 ? _b : [],
            networkTiming: this._networkTiming,
            samples: this._samples,
            selectedEdge: this._options.edge,
            stats,
            testTiming,
            totals: this._getRTCSampleTotals(),
            warnings: this._warnings
        };
        const selectedIceCandidatePairStats = (_c = this._rtcIceCandidateStatsReport) === null || _c === void 0 ? void 0 : _c.selectedIceCandidatePairStats;
        if (selectedIceCandidatePairStats) {
            report.selectedIceCandidatePairStats = selectedIceCandidatePairStats;
            report.isTurnRequired = selectedIceCandidatePairStats.localCandidate.candidateType === 'relay' || selectedIceCandidatePairStats.remoteCandidate.candidateType === 'relay';
        }
        if (stats) report.callQuality = this._getCallQuality(stats.mos.average);
        return report;
    }
    /**
     * Returns RTC stats totals for this test
     */ _getRTCSampleTotals() {
        if (!this._latestSample) return;
        return Object.assign({}, this._latestSample.totals);
    }
    /**
     * Returns RTC related stats captured during the test call
     */ _getRTCStats() {
        const firstMosSampleIdx = this._samples.findIndex((sample)=>typeof sample.mos === 'number' && sample.mos > 0);
        const samples = firstMosSampleIdx >= 0 ? this._samples.slice(firstMosSampleIdx) : [];
        if (!samples || !samples.length) return;
        return [
            'jitter',
            'mos',
            'rtt'
        ].reduce((statObj, stat)=>{
            const values = samples.map((s)=>s[stat]);
            return Object.assign(Object.assign({}, statObj), {
                [stat]: {
                    average: Number((values.reduce((total, value)=>total + value) / values.length).toPrecision(5)),
                    max: Math.max(...values),
                    min: Math.min(...values)
                }
            });
        }, {});
    }
    /**
     * Returns a MediaStream from a media file
     */ _getStreamFromFile() {
        const audioContext = this._options.audioContext;
        if (!audioContext) throw new (0, _errors.NotSupportedError)('Cannot fake input audio stream: AudioContext is not supported by this browser.');
        const audioEl = new Audio((0, _constants.COWBELL_AUDIO_URL));
        audioEl.addEventListener('canplaythrough', ()=>audioEl.play());
        if (typeof audioEl.setAttribute === 'function') audioEl.setAttribute('crossorigin', 'anonymous');
        const src = audioContext.createMediaElementSource(audioEl);
        const dest = audioContext.createMediaStreamDestination();
        src.connect(dest);
        return dest.stream;
    }
    /**
     * Initialize the device
     */ _initDevice(token, options) {
        try {
            this._device = new (options.deviceFactory || (0, _deviceDefault.default))(token, {
                codecPreferences: options.codecPreferences,
                edge: options.edge,
                fileInputStream: options.fileInputStream,
                logLevel: options.logLevel,
                preflight: true
            });
            this._device.once((0, _deviceDefault.default).EventName.Registered, ()=>{
                this._onDeviceRegistered();
            });
            this._device.once((0, _deviceDefault.default).EventName.Error, (error)=>{
                this._onDeviceError(error);
            });
            this._device.register();
        } catch (error) {
            // We want to return before failing so the consumer can capture the event
            setTimeout(()=>{
                this._onFailed(error);
            });
            return;
        }
        this._signalingTimeoutTimer = setTimeout(()=>{
            this._onDeviceError(new (0, _errors.SignalingErrors).ConnectionError('WebSocket Connection Timeout'));
        }, options.signalingTimeoutMs);
    }
    /**
     * Called on {@link Device} error event
     * @param error
     */ _onDeviceError(error) {
        this._device.destroy();
        this._onFailed(error);
    }
    /**
     * Called on {@link Device} ready event
     */ _onDeviceRegistered() {
        return __awaiter(this, void 0, void 0, function*() {
            clearTimeout(this._echoTimer);
            clearTimeout(this._signalingTimeoutTimer);
            this._call = yield this._device.connect({
                rtcConfiguration: this._options.rtcConfiguration
            });
            this._networkTiming.signaling = {
                start: Date.now()
            };
            this._setupCallHandlers(this._call);
            this._edge = this._device.edge || undefined;
            if (this._options.fakeMicInput) {
                this._echoTimer = setTimeout(()=>this._device.disconnectAll(), (0, _constants.ECHO_TEST_DURATION));
                const audio = this._device.audio;
                if (audio) {
                    audio.disconnect(false);
                    audio.outgoing(false);
                }
            }
            this._call.once('disconnect', ()=>{
                this._device.once((0, _deviceDefault.default).EventName.Unregistered, ()=>this._onUnregistered());
                this._device.destroy();
            });
            const publisher = this._call['_publisher'];
            publisher.on('error', ()=>{
                if (!this._hasInsightsErrored) this._emitWarning('insights-connection-error', 'Received an error when attempting to connect to Insights gateway');
                this._hasInsightsErrored = true;
            });
        });
    }
    /**
     * Called when there is a fatal error
     * @param error
     */ _onFailed(error) {
        clearTimeout(this._echoTimer);
        clearTimeout(this._signalingTimeoutTimer);
        this._releaseHandlers();
        this._endTime = Date.now();
        this._status = PreflightTest.Status.Failed;
        this._log.debug(`#${PreflightTest.Events.Failed}`, error);
        this.emit(PreflightTest.Events.Failed, error);
    }
    /**
     * Called when the device goes offline.
     * This indicates that the test has been completed, but we won't know if it failed or not.
     * The onError event will be the indicator whether the test failed.
     */ _onUnregistered() {
        // We need to make sure we always execute preflight.on('completed') last
        // as client SDK sometimes emits 'offline' event before emitting fatal errors.
        setTimeout(()=>{
            if (this._status === PreflightTest.Status.Failed) return;
            clearTimeout(this._echoTimer);
            clearTimeout(this._signalingTimeoutTimer);
            this._releaseHandlers();
            this._endTime = Date.now();
            this._status = PreflightTest.Status.Completed;
            this._report = this._getReport();
            this._log.debug(`#${PreflightTest.Events.Completed}`, JSON.stringify(this._report));
            this.emit(PreflightTest.Events.Completed, this._report);
        }, 10);
    }
    /**
     * Clean up all handlers for device and call
     */ _releaseHandlers() {
        [
            this._device,
            this._call
        ].forEach((emitter)=>{
            if (emitter) emitter.eventNames().forEach((name)=>emitter.removeAllListeners(name));
        });
    }
    /**
     * Setup the event handlers for the {@link Call} of the test call
     * @param call
     */ _setupCallHandlers(call) {
        if (this._options.fakeMicInput) // When volume events start emitting, it means all audio outputs have been created.
        // Let's mute them if we're using fake mic input.
        call.once('volume', ()=>{
            call['_mediaHandler'].outputs.forEach((output)=>output.audio.muted = true);
        });
        call.on('warning', (name, data)=>{
            this._emitWarning(name, 'Received an RTCWarning. See .rtcWarning for the RTCWarning', data);
        });
        call.once('accept', ()=>{
            this._callSid = call['_mediaHandler'].callSid;
            this._status = PreflightTest.Status.Connected;
            this._log.debug(`#${PreflightTest.Events.Connected}`);
            this.emit(PreflightTest.Events.Connected);
        });
        call.on('sample', (sample)=>__awaiter(this, void 0, void 0, function*() {
                // RTC Stats are ready. We only need to get ICE candidate stats report once.
                if (!this._latestSample) this._rtcIceCandidateStatsReport = yield (this._options.getRTCIceCandidateStatsReport || (0, _stats.getRTCIceCandidateStatsReport))(call['_mediaHandler'].version.pc);
                this._latestSample = sample;
                this._samples.push(sample);
                this._log.debug(`#${PreflightTest.Events.Sample}`, JSON.stringify(sample));
                this.emit(PreflightTest.Events.Sample, sample);
            }));
        // TODO: Update the following once the SDK supports emitting these events
        // Let's shim for now
        [
            {
                reportLabel: 'peerConnection',
                type: 'pcconnection'
            },
            {
                reportLabel: 'ice',
                type: 'iceconnection'
            },
            {
                reportLabel: 'dtls',
                type: 'dtlstransport'
            },
            {
                reportLabel: 'signaling',
                type: 'signaling'
            }
        ].forEach(({ type, reportLabel })=>{
            const handlerName = `on${type}statechange`;
            const originalHandler = call['_mediaHandler'][handlerName];
            call['_mediaHandler'][handlerName] = (state)=>{
                const timing = this._networkTiming[reportLabel] = this._networkTiming[reportLabel] || {
                    start: 0
                };
                if (state === 'connecting' || state === 'checking') timing.start = Date.now();
                else if ((state === 'connected' || state === 'stable') && !timing.duration) {
                    timing.end = Date.now();
                    timing.duration = timing.end - timing.start;
                }
                originalHandler(state);
            };
        });
    }
    /**
     * The callsid generated for the test call.
     */ get callSid() {
        return this._callSid;
    }
    /**
     * A timestamp in milliseconds of when the test ended.
     */ get endTime() {
        return this._endTime;
    }
    /**
     * The latest WebRTC sample collected.
     */ get latestSample() {
        return this._latestSample;
    }
    /**
     * The report for this test.
     */ get report() {
        return this._report;
    }
    /**
     * A timestamp in milliseconds of when the test started.
     */ get startTime() {
        return this._startTime;
    }
    /**
     * The status of the test.
     */ get status() {
        return this._status;
    }
}
(function(PreflightTest) {
    /**
     * The quality of the call determined by different mos ranges.
     * Mos is calculated base on the WebRTC stats - rtt, jitter, and packet lost.
     */ let CallQuality;
    (function(CallQuality) {
        /**
         * If the average mos is over 4.2.
         */ CallQuality["Excellent"] = "excellent";
        /**
         * If the average mos is between 4.1 and 4.2 both inclusive.
         */ CallQuality["Great"] = "great";
        /**
         * If the average mos is between 3.7 and 4.0 both inclusive.
         */ CallQuality["Good"] = "good";
        /**
         * If the average mos is between 3.1 and 3.6 both inclusive.
         */ CallQuality["Fair"] = "fair";
        /**
         * If the average mos is 3.0 or below.
         */ CallQuality["Degraded"] = "degraded";
    })(CallQuality = PreflightTest.CallQuality || (PreflightTest.CallQuality = {}));
    /**
     * Possible events that a [[PreflightTest]] might emit.
     */ let Events;
    (function(Events) {
        /**
         * See [[PreflightTest.completedEvent]]
         */ Events["Completed"] = "completed";
        /**
         * See [[PreflightTest.connectedEvent]]
         */ Events["Connected"] = "connected";
        /**
         * See [[PreflightTest.failedEvent]]
         */ Events["Failed"] = "failed";
        /**
         * See [[PreflightTest.sampleEvent]]
         */ Events["Sample"] = "sample";
        /**
         * See [[PreflightTest.warningEvent]]
         */ Events["Warning"] = "warning";
    })(Events = PreflightTest.Events || (PreflightTest.Events = {}));
    /**
     * Possible status of the test.
     */ let Status;
    (function(Status) {
        /**
         * Call to Twilio has initiated.
         */ Status["Connecting"] = "connecting";
        /**
         * Call to Twilio has been established.
         */ Status["Connected"] = "connected";
        /**
         * The connection to Twilio has been disconnected and the test call has completed.
         */ Status["Completed"] = "completed";
        /**
         * The test has stopped and failed.
         */ Status["Failed"] = "failed";
    })(Status = PreflightTest.Status || (PreflightTest.Status = {}));
})(PreflightTest || (PreflightTest = {}));

},{"events":"fqTtD","../call":"92RrQ","../device":"iaq4W","../errors":"caXI8","../log":"eJjQN","../rtc/stats":"clOJr","../constants":"buVX6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"clOJr":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
// tslint:disable no-empty
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRTCStats", ()=>getRTCStats);
parcelHelpers.export(exports, "getRTCIceCandidateStatsReport", ()=>getRTCIceCandidateStatsReport);
var _errors = require("../errors");
var _mockrtcstatsreport = require("./mockrtcstatsreport");
var _mockrtcstatsreportDefault = parcelHelpers.interopDefault(_mockrtcstatsreport);
const ERROR_PEER_CONNECTION_NULL = 'PeerConnection is null';
const ERROR_WEB_RTC_UNSUPPORTED = 'WebRTC statistics are unsupported';
/**
 * Helper function to find a specific stat from a report.
 * Some environment provide the stats report as a map (regular browsers)
 * but some provide stats report as an array (citrix vdi)
 * @private
 */ function findStatById(report, id) {
    if (typeof report.get === 'function') return report.get(id);
    return report.find((s)=>s.id === id);
}
/**
 * Generate WebRTC statistics report for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCStatsReport>} WebRTC RTCStatsReport object
 */ function getRTCStatsReport(peerConnection) {
    if (!peerConnection) return Promise.reject(new (0, _errors.InvalidArgumentError)(ERROR_PEER_CONNECTION_NULL));
    if (typeof peerConnection.getStats !== 'function') return Promise.reject(new (0, _errors.NotSupportedError)(ERROR_WEB_RTC_UNSUPPORTED));
    let promise;
    try {
        promise = peerConnection.getStats();
    } catch (e) {
        promise = new Promise((resolve)=>peerConnection.getStats(resolve)).then((0, _mockrtcstatsreportDefault.default).fromRTCStatsResponse);
    }
    return promise;
}
/**
 * @typedef {Object} StatsOptions
 * Used for testing to inject and extract methods.
 * @property {function} [createRTCSample] - Method for parsing an RTCStatsReport
 */ /**
 * Collects any WebRTC statistics for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @param {StatsOptions} options - List of custom options.
 * @return {Promise<RTCSample>} Universally-formatted version of RTC stats.
 */ function getRTCStats(peerConnection, options) {
    options = Object.assign({
        createRTCSample
    }, options);
    return getRTCStatsReport(peerConnection).then(options.createRTCSample);
}
/**
 * Generate WebRTC stats report containing relevant information about ICE candidates for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCIceCandidateStatsReport>} RTCIceCandidateStatsReport object
 */ function getRTCIceCandidateStatsReport(peerConnection) {
    return getRTCStatsReport(peerConnection).then((report)=>{
        // Find the relevant information needed to determine selected candidates later
        const { candidatePairs, localCandidates, remoteCandidates, transport } = Array.from(report.values()).reduce((rval, stat)=>{
            [
                'candidatePairs',
                'localCandidates',
                'remoteCandidates'
            ].forEach((prop)=>{
                if (!rval[prop]) rval[prop] = [];
            });
            switch(stat.type){
                case 'candidate-pair':
                    rval.candidatePairs.push(stat);
                    break;
                case 'local-candidate':
                    rval.localCandidates.push(stat);
                    break;
                case 'remote-candidate':
                    rval.remoteCandidates.push(stat);
                    break;
                case 'transport':
                    // This transport is the one being used if selectedCandidatePairId is populated
                    if (stat.selectedCandidatePairId) rval.transport = stat;
                    break;
            }
            return rval;
        }, {});
        // This is a report containing information about the selected candidates, such as IDs
        // This is coming from WebRTC stats directly and doesn't contain the actual ICE Candidates info
        const selectedCandidatePairReport = candidatePairs.find((pair)=>// Firefox
            pair.selected || // Spec-compliant way
            transport && pair.id === transport.selectedCandidatePairId);
        let selectedIceCandidatePairStats;
        if (selectedCandidatePairReport) selectedIceCandidatePairStats = {
            localCandidate: localCandidates.find((candidate)=>candidate.id === selectedCandidatePairReport.localCandidateId),
            remoteCandidate: remoteCandidates.find((candidate)=>candidate.id === selectedCandidatePairReport.remoteCandidateId)
        };
        // Build the return object
        return {
            iceCandidateStats: [
                ...localCandidates,
                ...remoteCandidates
            ],
            selectedIceCandidatePairStats
        };
    });
}
/**
 * @typedef {Object} RTCSample - A sample containing relevant WebRTC stats information.
 * @property {Number} [timestamp]
 * @property {String} [codecName] - MimeType name of the codec being used by the outbound audio stream
 * @property {Number} [rtt] - Round trip time
 * @property {Number} [jitter]
 * @property {Number} [packetsSent]
 * @property {Number} [packetsLost]
 * @property {Number} [packetsReceived]
 * @property {Number} [bytesReceived]
 * @property {Number} [bytesSent]
 * @property {Number} [localAddress]
 * @property {Number} [remoteAddress]
 */ function RTCSample() {}
/**
 * Create an RTCSample object from an RTCStatsReport
 * @private
 * @param {RTCStatsReport} statsReport
 * @returns {RTCSample}
 */ function createRTCSample(statsReport) {
    let activeTransportId = null;
    const sample = new RTCSample();
    let fallbackTimestamp;
    Array.from(statsReport.values()).forEach((stats)=>{
        // Skip isRemote tracks which will be phased out completely and break in FF66.
        if (stats.isRemote) return;
        // Firefox hack -- Older firefox doesn't have dashes in type names
        const type = stats.type.replace('-', '');
        fallbackTimestamp = fallbackTimestamp || stats.timestamp;
        // (rrowland) As I understand it, this is supposed to come in on remote-inbound-rtp but it's
        // currently coming in on remote-outbound-rtp, so I'm leaving this outside the switch until
        // the appropriate place to look is cleared up.
        if (stats.remoteId) {
            const remote = findStatById(statsReport, stats.remoteId);
            if (remote && remote.roundTripTime) sample.rtt = remote.roundTripTime * 1000;
        }
        switch(type){
            case 'inboundrtp':
                sample.timestamp = sample.timestamp || stats.timestamp;
                sample.jitter = stats.jitter * 1000;
                sample.packetsLost = stats.packetsLost;
                sample.packetsReceived = stats.packetsReceived;
                sample.bytesReceived = stats.bytesReceived;
                break;
            case 'outboundrtp':
                sample.timestamp = stats.timestamp;
                sample.packetsSent = stats.packetsSent;
                sample.bytesSent = stats.bytesSent;
                if (stats.codecId) {
                    const codec = findStatById(statsReport, stats.codecId);
                    sample.codecName = codec ? codec.mimeType && codec.mimeType.match(/(.*\/)?(.*)/)[2] : stats.codecId;
                }
                break;
            case 'transport':
                activeTransportId = stats.id;
                break;
        }
    });
    if (!sample.timestamp) sample.timestamp = fallbackTimestamp;
    const activeTransport = findStatById(statsReport, activeTransportId);
    if (!activeTransport) return sample;
    const selectedCandidatePair = findStatById(statsReport, activeTransport.selectedCandidatePairId);
    if (!selectedCandidatePair) return sample;
    const localCandidate = findStatById(statsReport, selectedCandidatePair.localCandidateId);
    const remoteCandidate = findStatById(statsReport, selectedCandidatePair.remoteCandidateId);
    if (!sample.rtt) sample.rtt = selectedCandidatePair && selectedCandidatePair.currentRoundTripTime * 1000;
    Object.assign(sample, {
        // ip is deprecated. use address first then ip if on older versions of browser
        localAddress: localCandidate && (localCandidate.address || localCandidate.ip),
        remoteAddress: remoteCandidate && (remoteCandidate.address || remoteCandidate.ip)
    });
    return sample;
}

},{"../errors":"caXI8","./mockrtcstatsreport":"83C16","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83C16":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
/**
 * This file was imported from another project. If making changes to this file, please don't
 * make them here. Make them on the linked repo below, then copy back:
 * https://code.hq.twilio.com/client/MockRTCStatsReport
 */ // The legacy max volume, which is the positive half of a signed short integer.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const OLD_MAX_VOLUME = 32767;
const NativeRTCStatsReport = typeof window !== 'undefined' ? window.RTCStatsReport : undefined;
/**
 * Create a MockRTCStatsReport wrapper around a Map of RTCStats objects. If RTCStatsReport is available
 *   natively, it will be inherited so that instanceof checks pass.
 * @constructor
 * @extends RTCStatsReport
 * @param {Map<string, RTCStats>} statsMap - A Map of RTCStats objects to wrap
 *   with a MockRTCStatsReport object.
 */ function MockRTCStatsReport(statsMap) {
    if (!(this instanceof MockRTCStatsReport)) return new MockRTCStatsReport(statsMap);
    const self = this;
    Object.defineProperties(this, {
        _map: {
            value: statsMap
        },
        size: {
            enumerable: true,
            get () {
                return self._map.size;
            }
        }
    });
    this[Symbol.iterator] = statsMap[Symbol.iterator];
}
// If RTCStatsReport is available natively, inherit it. Keep our constructor.
if (NativeRTCStatsReport) {
    MockRTCStatsReport.prototype = Object.create(NativeRTCStatsReport.prototype);
    MockRTCStatsReport.prototype.constructor = MockRTCStatsReport;
}
// Map the Map-like read methods to the underlying Map
[
    'entries',
    'forEach',
    'get',
    'has',
    'keys',
    'values'
].forEach((key)=>{
    MockRTCStatsReport.prototype[key] = function(...args) {
        return this._map[key](...args);
    };
});
/**
 * Convert an array of RTCStats objects into a mock RTCStatsReport object.
 * @param {Array<RTCStats>}
 * @return {MockRTCStatsReport}
 */ MockRTCStatsReport.fromArray = function fromArray(array) {
    return new MockRTCStatsReport(array.reduce((map, rtcStats)=>{
        map.set(rtcStats.id, rtcStats);
        return map;
    }, new Map()));
};
/**
 * Convert a legacy RTCStatsResponse object into a mock RTCStatsReport object.
 * @param {RTCStatsResponse} statsResponse - An RTCStatsResponse object returned by the
 *   legacy getStats(callback) method in Chrome.
 * @return {MockRTCStatsReport} A mock RTCStatsReport object.
 */ MockRTCStatsReport.fromRTCStatsResponse = function fromRTCStatsResponse(statsResponse) {
    let activeCandidatePairId;
    const transportIds = new Map();
    const statsMap = statsResponse.result().reduce((map, report)=>{
        const id = report.id;
        switch(report.type){
            case 'googCertificate':
                map.set(id, createRTCCertificateStats(report));
                break;
            case 'datachannel':
                map.set(id, createRTCDataChannelStats(report));
                break;
            case 'googCandidatePair':
                if (getBoolean(report, 'googActiveConnection')) activeCandidatePairId = id;
                map.set(id, createRTCIceCandidatePairStats(report));
                break;
            case 'localcandidate':
                map.set(id, createRTCIceCandidateStats(report, false));
                break;
            case 'remotecandidate':
                map.set(id, createRTCIceCandidateStats(report, true));
                break;
            case 'ssrc':
                if (isPresent(report, 'packetsReceived')) map.set(`rtp-${id}`, createRTCInboundRTPStreamStats(report));
                else map.set(`rtp-${id}`, createRTCOutboundRTPStreamStats(report));
                map.set(`track-${id}`, createRTCMediaStreamTrackStats(report));
                map.set(`codec-${id}`, createRTCCodecStats(report));
                break;
            case 'googComponent':
                const transportReport = createRTCTransportStats(report);
                transportIds.set(transportReport.selectedCandidatePairId, id);
                map.set(id, createRTCTransportStats(report));
                break;
        }
        return map;
    }, new Map());
    if (activeCandidatePairId) {
        const activeTransportId = transportIds.get(activeCandidatePairId);
        if (activeTransportId) statsMap.get(activeTransportId).dtlsState = 'connected';
    }
    return new MockRTCStatsReport(statsMap);
};
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCTransportStats}
 */ function createRTCTransportStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        dtlsState: undefined,
        id: report.id,
        localCertificateId: report.stat('localCertificateId'),
        remoteCertificateId: report.stat('remoteCertificateId'),
        rtcpTransportStatsId: undefined,
        selectedCandidatePairId: report.stat('selectedCandidatePairId'),
        timestamp: Date.parse(report.timestamp),
        type: 'transport'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCCodecStats}
 */ function createRTCCodecStats(report) {
    return {
        channels: undefined,
        clockRate: undefined,
        id: report.id,
        implementation: undefined,
        mimeType: `${report.stat('mediaType')}/${report.stat('googCodecName')}`,
        payloadType: undefined,
        sdpFmtpLine: undefined,
        timestamp: Date.parse(report.timestamp),
        type: 'codec'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCMediaStreamTrackStats}
 */ function createRTCMediaStreamTrackStats(report) {
    return {
        audioLevel: isPresent(report, 'audioOutputLevel') ? getInt(report, 'audioOutputLevel') / OLD_MAX_VOLUME : (getInt(report, 'audioInputLevel') || 0) / OLD_MAX_VOLUME,
        detached: undefined,
        echoReturnLoss: getFloat(report, 'googEchoCancellationReturnLoss'),
        echoReturnLossEnhancement: getFloat(report, 'googEchoCancellationReturnLossEnhancement'),
        ended: undefined,
        frameHeight: isPresent(report, 'googFrameHeightReceived') ? getInt(report, 'googFrameHeightReceived') : getInt(report, 'googFrameHeightSent'),
        frameWidth: isPresent(report, 'googFrameWidthReceived') ? getInt(report, 'googFrameWidthReceived') : getInt(report, 'googFrameWidthSent'),
        framesCorrupted: undefined,
        framesDecoded: getInt(report, 'framesDecoded'),
        framesDropped: undefined,
        framesPerSecond: undefined,
        framesReceived: undefined,
        framesSent: getInt(report, 'framesEncoded'),
        fullFramesLost: undefined,
        id: report.id,
        kind: report.stat('mediaType'),
        partialFramesLost: undefined,
        remoteSource: undefined,
        ssrcIds: undefined,
        timestamp: Date.parse(report.timestamp),
        trackIdentifier: report.stat('googTrackId'),
        type: 'track'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isInbound - Whether to create an inbound stats object, or outbound.
 * @returns {RTCRTPStreamStats}
 */ function createRTCRTPStreamStats(report, isInbound) {
    return {
        associateStatsId: undefined,
        codecId: `codec-${report.id}`,
        firCount: isInbound ? getInt(report, 'googFirsSent') : undefined,
        id: report.id,
        isRemote: undefined,
        mediaType: report.stat('mediaType'),
        nackCount: isInbound ? getInt(report, 'googNacksSent') : getInt(report, 'googNacksReceived'),
        pliCount: isInbound ? getInt(report, 'googPlisSent') : getInt(report, 'googPlisReceived'),
        qpSum: getInt(report, 'qpSum'),
        sliCount: undefined,
        ssrc: report.stat('ssrc'),
        timestamp: Date.parse(report.timestamp),
        trackId: `track-${report.id}`,
        transportId: report.stat('transportId')
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCInboundRTPStreamStats}
 */ function createRTCInboundRTPStreamStats(report) {
    const rtp = createRTCRTPStreamStats(report, true);
    Object.assign(rtp, {
        burstDiscardCount: undefined,
        burstDiscardRate: undefined,
        burstLossCount: undefined,
        burstLossRate: undefined,
        burstPacketsDiscarded: undefined,
        burstPacketsLost: undefined,
        bytesReceived: getInt(report, 'bytesReceived'),
        fractionLost: undefined,
        framesDecoded: getInt(report, 'framesDecoded'),
        gapDiscardRate: undefined,
        gapLossRate: undefined,
        jitter: convertMsToSeconds(report.stat('googJitterReceived')),
        packetsDiscarded: undefined,
        packetsLost: getInt(report, 'packetsLost'),
        packetsReceived: getInt(report, 'packetsReceived'),
        packetsRepaired: undefined,
        roundTripTime: convertMsToSeconds(report.stat('googRtt')),
        type: 'inbound-rtp'
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCOutboundRTPStreamStats}
 */ function createRTCOutboundRTPStreamStats(report) {
    const rtp = createRTCRTPStreamStats(report, false);
    Object.assign(rtp, {
        bytesSent: getInt(report, 'bytesSent'),
        framesEncoded: getInt(report, 'framesEncoded'),
        packetsSent: getInt(report, 'packetsSent'),
        remoteTimestamp: undefined,
        targetBitrate: undefined,
        type: 'outbound-rtp'
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isRemote - Whether to create for a remote candidate, or local candidate.
 * @returns {RTCIceCandidateStats}
 */ function createRTCIceCandidateStats(report, isRemote) {
    return {
        candidateType: translateCandidateType(report.stat('candidateType')),
        deleted: undefined,
        id: report.id,
        ip: report.stat('ipAddress'),
        isRemote,
        port: getInt(report, 'portNumber'),
        priority: getFloat(report, 'priority'),
        protocol: report.stat('transport'),
        relayProtocol: undefined,
        timestamp: Date.parse(report.timestamp),
        transportId: undefined,
        type: isRemote ? 'remote-candidate' : 'local-candidate',
        url: undefined
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCandidatePairStats}
 */ function createRTCIceCandidatePairStats(report) {
    return {
        availableIncomingBitrate: undefined,
        availableOutgoingBitrate: undefined,
        bytesReceived: getInt(report, 'bytesReceived'),
        bytesSent: getInt(report, 'bytesSent'),
        consentRequestsSent: getInt(report, 'consentRequestsSent'),
        currentRoundTripTime: convertMsToSeconds(report.stat('googRtt')),
        id: report.id,
        lastPacketReceivedTimestamp: undefined,
        lastPacketSentTimestamp: undefined,
        localCandidateId: report.stat('localCandidateId'),
        nominated: undefined,
        priority: undefined,
        readable: undefined,
        remoteCandidateId: report.stat('remoteCandidateId'),
        requestsReceived: getInt(report, 'requestsReceived'),
        requestsSent: getInt(report, 'requestsSent'),
        responsesReceived: getInt(report, 'responsesReceived'),
        responsesSent: getInt(report, 'responsesSent'),
        retransmissionsReceived: undefined,
        retransmissionsSent: undefined,
        state: undefined,
        timestamp: Date.parse(report.timestamp),
        totalRoundTripTime: undefined,
        transportId: report.stat('googChannelId'),
        type: 'candidate-pair',
        writable: getBoolean(report, 'googWritable')
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCertificateStats}
 */ function createRTCCertificateStats(report) {
    return {
        base64Certificate: report.stat('googDerBase64'),
        fingerprint: report.stat('googFingerprint'),
        fingerprintAlgorithm: report.stat('googFingerprintAlgorithm'),
        id: report.id,
        issuerCertificateId: report.stat('googIssuerId'),
        timestamp: Date.parse(report.timestamp),
        type: 'certificate'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCDataChannelStats}
 */ function createRTCDataChannelStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        datachannelid: report.stat('datachannelid'),
        id: report.id,
        label: report.stat('label'),
        messagesReceived: undefined,
        messagesSent: undefined,
        protocol: report.stat('protocol'),
        state: report.stat('state'),
        timestamp: Date.parse(report.timestamp),
        transportId: report.stat('transportId'),
        type: 'data-channel'
    };
}
/**
 * @param {number} inMs - A time in milliseconds
 * @returns {number} The time in seconds
 */ function convertMsToSeconds(inMs) {
    return isNaN(inMs) || inMs === '' ? undefined : parseInt(inMs, 10) / 1000;
}
/**
 * @param {string} type - A type in the legacy format
 * @returns {string} The type adjusted to new standards for known naming changes
 */ function translateCandidateType(type) {
    switch(type){
        case 'peerreflexive':
            return 'prflx';
        case 'serverreflexive':
            return 'srflx';
        case 'host':
        case 'relay':
        default:
            return type;
    }
}
function getInt(report, statName) {
    const stat = report.stat(statName);
    return isPresent(report, statName) ? parseInt(stat, 10) : undefined;
}
function getFloat(report, statName) {
    const stat = report.stat(statName);
    return isPresent(report, statName) ? parseFloat(stat) : undefined;
}
function getBoolean(report, statName) {
    const stat = report.stat(statName);
    return isPresent(report, statName) ? stat === 'true' || stat === true : undefined;
}
function isPresent(report, statName) {
    const stat = report.stat(statName);
    return typeof stat !== 'undefined' && stat !== '';
}
exports.default = MockRTCStatsReport;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k93Ah":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
var _constants = require("./constants");
var _errors = require("./errors");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _wstransport = require("./wstransport");
var _wstransportDefault = parcelHelpers.interopDefault(_wstransport);
const PSTREAM_VERSION = '1.6';
// In seconds
const MAX_RECONNECT_TIMEOUT_ALLOWED = 30;
/**
 * Constructor for PStream objects.
 *
 * @exports PStream as Twilio.PStream
 * @memberOf Twilio
 * @borrows EventEmitter#addListener as #addListener
 * @borrows EventEmitter#removeListener as #removeListener
 * @borrows EventEmitter#emit as #emit
 * @borrows EventEmitter#hasListener as #hasListener
 * @constructor
 * @param {string} token The Twilio capabilities JWT
 * @param {string[]} uris An array of PStream endpoint URIs
 * @param {object} [options]
 * @config {boolean} [options.backoffMaxMs=20000] Enable debugging
 */ class PStream extends (0, _events.EventEmitter) {
    constructor(token, uris, options){
        super();
        if (!(this instanceof PStream)) return new PStream(token, uris, options);
        const defaults = {
            TransportFactory: (0, _wstransportDefault.default)
        };
        options = options || {};
        for(const prop in defaults){
            if (prop in options) continue;
            options[prop] = defaults[prop];
        }
        this.options = options;
        this.token = token || '';
        this.status = 'disconnected';
        this.gateway = null;
        this.region = null;
        this._messageQueue = [];
        this._preferredUri = null;
        this._uris = uris;
        this._handleTransportClose = this._handleTransportClose.bind(this);
        this._handleTransportError = this._handleTransportError.bind(this);
        this._handleTransportMessage = this._handleTransportMessage.bind(this);
        this._handleTransportOpen = this._handleTransportOpen.bind(this);
        this._log = new (0, _logDefault.default)('PStream');
        // NOTE(mroberts): EventEmitter requires that we catch all errors.
        this.on('error', ()=>{
            this._log.warn('Unexpected error handled in pstream');
        });
        /*
         *events used by device
         *'invite',
         *'ready',
         *'error',
         *'offline',
         *
         *'cancel',
         *'presence',
         *'roster',
         *'answer',
         *'candidate',
         *'hangup'
         */ const self = this;
        this.addListener('ready', ()=>{
            self.status = 'ready';
        });
        this.addListener('offline', ()=>{
            self.status = 'offline';
        });
        this.addListener('close', ()=>{
            self._log.info('Received "close" from server. Destroying PStream...');
            self._destroy();
        });
        this.transport = new this.options.TransportFactory(this._uris, {
            backoffMaxMs: this.options.backoffMaxMs,
            maxPreferredDurationMs: this.options.maxPreferredDurationMs
        });
        Object.defineProperties(this, {
            uri: {
                enumerable: true,
                get () {
                    return this.transport.uri;
                }
            }
        });
        this.transport.on('close', this._handleTransportClose);
        this.transport.on('error', this._handleTransportError);
        this.transport.on('message', this._handleTransportMessage);
        this.transport.on('open', this._handleTransportOpen);
        this.transport.open();
        return this;
    }
}
PStream.prototype._handleTransportClose = function() {
    this.emit('transportClose');
    if (this.status !== 'disconnected') {
        if (this.status !== 'offline') this.emit('offline', this);
        this.status = 'disconnected';
    }
};
PStream.prototype._handleTransportError = function(error) {
    if (!error) {
        this.emit('error', {
            error: {
                code: 31000,
                message: 'Websocket closed without a provided reason',
                twilioError: new (0, _errors.SignalingErrors).ConnectionDisconnected()
            }
        });
        return;
    }
    // We receive some errors without call metadata (just the error). We need to convert these
    // to be contained within the 'error' field so that these errors match the expected format.
    this.emit('error', typeof error.code !== 'undefined' ? {
        error
    } : error);
};
PStream.prototype._handleTransportMessage = function(msg) {
    if (!msg || !msg.data || typeof msg.data !== 'string') return;
    const { type, payload = {} } = JSON.parse(msg.data);
    this.gateway = payload.gateway || this.gateway;
    this.region = payload.region || this.region;
    if (type === 'error' && payload.error) payload.error.twilioError = new (0, _errors.SignalingErrors).ConnectionError();
    this.emit(type, payload);
};
PStream.prototype._handleTransportOpen = function() {
    this.status = 'connected';
    this.setToken(this.token);
    this.emit('transportOpen');
    const messages = this._messageQueue.splice(0, this._messageQueue.length);
    messages.forEach((message)=>this._publish(...message));
};
/**
 * @return {string}
 */ PStream.toString = ()=>'[Twilio.PStream class]';
PStream.prototype.toString = ()=>'[Twilio.PStream instance]';
PStream.prototype.setToken = function(token) {
    this._log.info('Setting token and publishing listen');
    this.token = token;
    let reconnectTimeout = 0;
    const t = this.options.maxPreferredDurationMs;
    this._log.info(`maxPreferredDurationMs:${t}`);
    if (typeof t === 'number' && t >= 0) reconnectTimeout = Math.min(Math.ceil(t / 1000), MAX_RECONNECT_TIMEOUT_ALLOWED);
    this._log.info(`reconnectTimeout:${reconnectTimeout}`);
    const payload = {
        browserinfo: getBrowserInfo(),
        reconnectTimeout,
        token
    };
    this._publish('listen', payload);
};
PStream.prototype.sendMessage = function(callsid, content, contenttype = 'application/json', messagetype, voiceeventsid) {
    const payload = {
        callsid,
        content,
        contenttype,
        messagetype,
        voiceeventsid
    };
    this._publish('message', payload, true);
};
PStream.prototype.register = function(mediaCapabilities) {
    const regPayload = {
        media: mediaCapabilities
    };
    this._publish('register', regPayload, true);
};
PStream.prototype.invite = function(sdp, callsid, params) {
    const payload = {
        callsid,
        sdp,
        twilio: params ? {
            params
        } : {}
    };
    this._publish('invite', payload, true);
};
PStream.prototype.reconnect = function(sdp, callsid, reconnect) {
    const payload = {
        callsid,
        reconnect,
        sdp,
        twilio: {}
    };
    this._publish('invite', payload, true);
};
PStream.prototype.answer = function(sdp, callsid) {
    this._publish('answer', {
        sdp,
        callsid
    }, true);
};
PStream.prototype.dtmf = function(callsid, digits) {
    this._publish('dtmf', {
        callsid,
        dtmf: digits
    }, true);
};
PStream.prototype.hangup = function(callsid, message) {
    const payload = message ? {
        callsid,
        message
    } : {
        callsid
    };
    this._publish('hangup', payload, true);
};
PStream.prototype.reject = function(callsid) {
    this._publish('reject', {
        callsid
    }, true);
};
PStream.prototype.reinvite = function(sdp, callsid) {
    this._publish('reinvite', {
        sdp,
        callsid
    }, false);
};
PStream.prototype._destroy = function() {
    this.transport.removeListener('close', this._handleTransportClose);
    this.transport.removeListener('error', this._handleTransportError);
    this.transport.removeListener('message', this._handleTransportMessage);
    this.transport.removeListener('open', this._handleTransportOpen);
    this.transport.close();
    this.emit('offline', this);
};
PStream.prototype.destroy = function() {
    this._log.info('PStream.destroy() called...');
    this._destroy();
    return this;
};
PStream.prototype.updatePreferredURI = function(uri) {
    this._preferredUri = uri;
    this.transport.updatePreferredURI(uri);
};
PStream.prototype.updateURIs = function(uris) {
    this._uris = uris;
    this.transport.updateURIs(this._uris);
};
PStream.prototype.publish = function(type, payload) {
    return this._publish(type, payload, true);
};
PStream.prototype._publish = function(type, payload, shouldRetry) {
    const msg = JSON.stringify({
        payload,
        type,
        version: PSTREAM_VERSION
    });
    const isSent = !!this.transport.send(msg);
    if (!isSent) {
        this.emit('error', {
            error: {
                code: 31009,
                message: 'No transport available to send or receive messages',
                twilioError: new (0, _errors.GeneralErrors).TransportError()
            }
        });
        if (shouldRetry) this._messageQueue.push([
            type,
            payload,
            true
        ]);
    }
};
function getBrowserInfo() {
    const nav = typeof navigator !== 'undefined' ? navigator : {};
    const info = {
        browser: {
            platform: nav.platform || 'unknown',
            userAgent: nav.userAgent || 'unknown'
        },
        p: 'browser',
        plugin: 'rtc',
        v: _constants.RELEASE_VERSION
    };
    return info;
}
exports.default = PStream;

},{"events":"fqTtD","./constants":"buVX6","./errors":"caXI8","./log":"eJjQN","./wstransport":"gzGKf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzGKf":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WSTransportState", ()=>WSTransportState);
var _events = require("events");
var _backoff = require("./backoff");
var _backoffDefault = parcelHelpers.interopDefault(_backoff);
var _errors = require("./errors");
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
const WebSocket = globalThis.WebSocket;
const CONNECT_SUCCESS_TIMEOUT = 10000;
const CONNECT_TIMEOUT = 5000;
const HEARTBEAT_TIMEOUT = 15000;
const MAX_PREFERRED_DURATION = 15000;
const MAX_PRIMARY_DURATION = Infinity;
const MAX_PREFERRED_DELAY = 1000;
const MAX_PRIMARY_DELAY = 20000;
var WSTransportState;
(function(WSTransportState) {
    /**
     * The WebSocket is not open but is trying to connect.
     */ WSTransportState["Connecting"] = "connecting";
    /**
     * The WebSocket is not open and is not trying to connect.
     */ WSTransportState["Closed"] = "closed";
    /**
     * The underlying WebSocket is open and active.
     */ WSTransportState["Open"] = "open";
})(WSTransportState || (WSTransportState = {}));
class WSTransport extends (0, _events.EventEmitter) {
    /**
     * @constructor
     * @param uris - List of URI of the endpoints to connect to.
     * @param [options] - Constructor options.
     */ constructor(uris, options = {}){
        super();
        /**
         * The current state of the WSTransport.
         */ this.state = WSTransportState.Closed;
        /**
         * Start timestamp values for backoffs.
         */ this._backoffStartTime = {
            preferred: null,
            primary: null
        };
        /**
         * The URI that the transport is connecting or connected to. The value of this
         * property is `null` if a connection attempt has not been made yet.
         */ this._connectedUri = null;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, _logDefault.default)('WSTransport');
        /**
         * Whether we should attempt to fallback if we receive an applicable error
         * when trying to connect to a signaling endpoint.
         */ this._shouldFallback = false;
        /**
         * The current uri index that the transport is connected to.
         */ this._uriIndex = 0;
        /**
         * Move the uri index to the next index
         * If the index is at the end, the index goes back to the first one.
         */ this._moveUriIndex = ()=>{
            this._uriIndex++;
            if (this._uriIndex >= this._uris.length) this._uriIndex = 0;
        };
        /**
         * Called in response to WebSocket#close event.
         */ this._onSocketClose = (event)=>{
            this._log.error(`Received websocket close event code: ${event.code}. Reason: ${event.reason}`);
            // 1006: Abnormal close. When the server is unreacheable
            // 1015: TLS Handshake error
            if (event.code === 1006 || event.code === 1015) {
                this.emit('error', {
                    code: 31005,
                    message: event.reason || "Websocket connection to Twilio's signaling servers were unexpectedly ended. If this is happening consistently, there may be an issue resolving the hostname provided. If a region or an edge is being specified in Device setup, ensure it is valid.",
                    twilioError: new (0, _errors.SignalingErrors).ConnectionError()
                });
                const wasConnected = // Only in Safari and certain Firefox versions, on network interruption, websocket drops right away with 1006
                // Let's check current state if it's open, meaning we should not fallback
                // because we're coming from a previously connected session
                this.state === WSTransportState.Open || // But on other browsers, websocket doesn't drop
                // but our heartbeat catches it, setting the internal state to "Connecting".
                // With this, we should check the previous state instead.
                this._previousState === WSTransportState.Open;
                // Only fallback if this is not the first error
                // and if we were not connected previously
                if (this._shouldFallback || !wasConnected) this._moveUriIndex();
                this._shouldFallback = true;
            }
            this._closeSocket();
        };
        /**
         * Called in response to WebSocket#error event.
         */ this._onSocketError = (err)=>{
            this._log.error(`WebSocket received error: ${err.message}`);
            this.emit('error', {
                code: 31000,
                message: err.message || 'WSTransport socket error',
                twilioError: new (0, _errors.SignalingErrors).ConnectionDisconnected()
            });
        };
        /**
         * Called in response to WebSocket#message event.
         */ this._onSocketMessage = (message)=>{
            // Clear heartbeat timeout on any incoming message, as they
            // all indicate an active connection.
            this._setHeartbeatTimeout();
            // Filter and respond to heartbeats
            if (this._socket && message.data === '\n') {
                this._socket.send('\n');
                this._log.debug('heartbeat');
                return;
            }
            if (message && typeof message.data === 'string') this._log.debug(`Received: ${message.data}`);
            this.emit('message', message);
        };
        /**
         * Called in response to WebSocket#open event.
         */ this._onSocketOpen = ()=>{
            this._log.info('WebSocket opened successfully.');
            this._timeOpened = Date.now();
            this._shouldFallback = false;
            this._setState(WSTransportState.Open);
            clearTimeout(this._connectTimeout);
            this._resetBackoffs();
            this._setHeartbeatTimeout();
            this.emit('open');
        };
        this._options = Object.assign(Object.assign({}, WSTransport.defaultConstructorOptions), options);
        this._uris = uris;
        this._backoff = this._setupBackoffs();
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ close() {
        this._log.info('WSTransport.close() called...');
        this._close();
    }
    /**
     * Attempt to open a WebSocket connection.
     */ open() {
        this._log.info('WSTransport.open() called...');
        if (this._socket && (this._socket.readyState === WebSocket.CONNECTING || this._socket.readyState === WebSocket.OPEN)) {
            this._log.info('WebSocket already open.');
            return;
        }
        if (this._preferredUri) this._connect(this._preferredUri);
        else this._connect(this._uris[this._uriIndex]);
    }
    /**
     * Send a message through the WebSocket connection.
     * @param message - A message to send to the endpoint.
     * @returns Whether the message was sent.
     */ send(message) {
        this._log.debug(`Sending: ${message}`);
        // We can't send the message if the WebSocket isn't open
        if (!this._socket || this._socket.readyState !== WebSocket.OPEN) {
            this._log.debug('Cannot send message. WebSocket is not open.');
            return false;
        }
        try {
            this._socket.send(message);
        } catch (e) {
            // Some unknown error occurred. Reset the socket to get a fresh session.
            this._log.error('Error while sending message:', e.message);
            this._closeSocket();
            return false;
        }
        return true;
    }
    /**
     * Update the preferred URI to connect to. Useful for Call signaling
     * reconnection, which requires connecting on the same edge. If `null` is
     * passed, the preferred URI is unset and the original `uris` array and
     * `uriIndex` is used to determine the signaling URI to connect to.
     * @param uri
     */ updatePreferredURI(uri) {
        this._preferredUri = uri;
    }
    /**
     * Update acceptable URIs to reconnect to. Resets the URI index to 0.
     */ updateURIs(uris) {
        if (typeof uris === 'string') uris = [
            uris
        ];
        this._uris = uris;
        this._uriIndex = 0;
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ _close() {
        this._setState(WSTransportState.Closed);
        this._closeSocket();
    }
    /**
     * Close the WebSocket and remove all event listeners.
     */ _closeSocket() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._heartbeatTimeout);
        this._log.info('Closing and cleaning up WebSocket...');
        if (!this._socket) {
            this._log.info('No WebSocket to clean up.');
            return;
        }
        this._socket.removeEventListener('close', this._onSocketClose);
        this._socket.removeEventListener('error', this._onSocketError);
        this._socket.removeEventListener('message', this._onSocketMessage);
        this._socket.removeEventListener('open', this._onSocketOpen);
        if (this._socket.readyState === WebSocket.CONNECTING || this._socket.readyState === WebSocket.OPEN) this._socket.close();
        // Reset backoff counter if connection was open for long enough to be considered successful
        if (this._timeOpened && Date.now() - this._timeOpened > CONNECT_SUCCESS_TIMEOUT) this._resetBackoffs();
        if (this.state !== WSTransportState.Closed) this._performBackoff();
        delete this._socket;
        this.emit('close');
    }
    /**
     * Attempt to connect to the endpoint via WebSocket.
     * @param [uri] - URI string to connect to.
     * @param [retryCount] - Retry number, if this is a retry. Undefined if
     *   first attempt, 1+ if a retry.
     */ _connect(uri, retryCount) {
        this._log.info(typeof retryCount === 'number' ? `Attempting to reconnect (retry #${retryCount})...` : 'Attempting to connect...');
        this._closeSocket();
        this._setState(WSTransportState.Connecting);
        this._connectedUri = uri;
        try {
            this._socket = new this._options.WebSocket(this._connectedUri);
        } catch (e) {
            this._log.error('Could not connect to endpoint:', e.message);
            this._close();
            this.emit('error', {
                code: 31000,
                message: e.message || `Could not connect to ${this._connectedUri}`,
                twilioError: new (0, _errors.SignalingErrors).ConnectionDisconnected()
            });
            return;
        }
        this._socket.addEventListener('close', this._onSocketClose);
        this._socket.addEventListener('error', this._onSocketError);
        this._socket.addEventListener('message', this._onSocketMessage);
        this._socket.addEventListener('open', this._onSocketOpen);
        delete this._timeOpened;
        this._connectTimeout = setTimeout(()=>{
            this._log.info('WebSocket connection attempt timed out.');
            this._moveUriIndex();
            this._closeSocket();
        }, this._options.connectTimeoutMs);
    }
    /**
     * Perform a backoff. If a preferred URI is set (not null), then backoff
     * using the preferred mechanism. Otherwise, use the primary mechanism.
     */ _performBackoff() {
        if (this._preferredUri) {
            this._log.info('Preferred URI set; backing off.');
            this._backoff.preferred.backoff();
        } else {
            this._log.info('Preferred URI not set; backing off.');
            this._backoff.primary.backoff();
        }
    }
    /**
     * Reset both primary and preferred backoff mechanisms.
     */ _resetBackoffs() {
        this._backoff.preferred.reset();
        this._backoff.primary.reset();
        this._backoffStartTime.preferred = null;
        this._backoffStartTime.primary = null;
    }
    /**
     * Set a timeout to reconnect after HEARTBEAT_TIMEOUT milliseconds
     *   have passed without receiving a message over the WebSocket.
     */ _setHeartbeatTimeout() {
        clearTimeout(this._heartbeatTimeout);
        this._heartbeatTimeout = setTimeout(()=>{
            this._log.info(`No messages received in ${HEARTBEAT_TIMEOUT / 1000} seconds. Reconnecting...`);
            this._shouldFallback = true;
            this._closeSocket();
        }, HEARTBEAT_TIMEOUT);
    }
    /**
     * Set the current and previous state
     */ _setState(state) {
        this._previousState = this.state;
        this.state = state;
    }
    /**
     * Set up the primary and preferred backoff mechanisms.
     */ _setupBackoffs() {
        const preferredBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPreferredDelayMs,
            min: 100
        };
        this._log.info('Initializing preferred transport backoff using config: ', preferredBackoffConfig);
        const preferredBackoff = new (0, _backoffDefault.default)(preferredBackoffConfig);
        preferredBackoff.on('backoff', (attempt, delay)=>{
            if (this.state === WSTransportState.Closed) {
                this._log.info('Preferred backoff initiated but transport state is closed; not attempting a connection.');
                return;
            }
            this._log.info(`Will attempt to reconnect Websocket to preferred URI in ${delay}ms`);
            if (attempt === 0) {
                this._backoffStartTime.preferred = Date.now();
                this._log.info(`Preferred backoff start; ${this._backoffStartTime.preferred}`);
            }
        });
        preferredBackoff.on('ready', (attempt, _delay)=>{
            if (this.state === WSTransportState.Closed) {
                this._log.info('Preferred backoff ready but transport state is closed; not attempting a connection.');
                return;
            }
            if (this._backoffStartTime.preferred === null) {
                this._log.info('Preferred backoff start time invalid; not attempting a connection.');
                return;
            }
            if (Date.now() - this._backoffStartTime.preferred > this._options.maxPreferredDurationMs) {
                this._log.info('Max preferred backoff attempt time exceeded; falling back to primary backoff.');
                this._preferredUri = null;
                this._backoff.primary.backoff();
                return;
            }
            if (typeof this._preferredUri !== 'string') {
                this._log.info('Preferred URI cleared; falling back to primary backoff.');
                this._preferredUri = null;
                this._backoff.primary.backoff();
                return;
            }
            this._connect(this._preferredUri, attempt + 1);
        });
        const primaryBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPrimaryDelayMs,
            // We only want a random initial delay if there are any fallback edges
            // Initial delay between 1s and 5s both inclusive
            min: this._uris && this._uris.length > 1 ? Math.floor(Math.random() * 4001) + 1000 : 100
        };
        this._log.info('Initializing primary transport backoff using config: ', primaryBackoffConfig);
        const primaryBackoff = new (0, _backoffDefault.default)(primaryBackoffConfig);
        primaryBackoff.on('backoff', (attempt, delay)=>{
            if (this.state === WSTransportState.Closed) {
                this._log.info('Primary backoff initiated but transport state is closed; not attempting a connection.');
                return;
            }
            this._log.info(`Will attempt to reconnect WebSocket in ${delay}ms`);
            if (attempt === 0) {
                this._backoffStartTime.primary = Date.now();
                this._log.info(`Primary backoff start; ${this._backoffStartTime.primary}`);
            }
        });
        primaryBackoff.on('ready', (attempt, _delay)=>{
            if (this.state === WSTransportState.Closed) {
                this._log.info('Primary backoff ready but transport state is closed; not attempting a connection.');
                return;
            }
            if (this._backoffStartTime.primary === null) {
                this._log.info('Primary backoff start time invalid; not attempting a connection.');
                return;
            }
            if (Date.now() - this._backoffStartTime.primary > this._options.maxPrimaryDurationMs) {
                this._log.info('Max primary backoff attempt time exceeded; not attempting a connection.');
                return;
            }
            this._connect(this._uris[this._uriIndex], attempt + 1);
        });
        return {
            preferred: preferredBackoff,
            primary: primaryBackoff
        };
    }
    /**
     * The uri the transport is currently connected to
     */ get uri() {
        return this._connectedUri;
    }
}
exports.default = WSTransport;
WSTransport.defaultConstructorOptions = {
    WebSocket,
    connectTimeoutMs: CONNECT_TIMEOUT,
    maxPreferredDelayMs: MAX_PREFERRED_DELAY,
    maxPreferredDurationMs: MAX_PREFERRED_DURATION,
    maxPrimaryDelayMs: MAX_PRIMARY_DELAY,
    maxPrimaryDurationMs: MAX_PRIMARY_DURATION
};

},{"events":"fqTtD","./backoff":"5InnX","./errors":"caXI8","./log":"eJjQN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iuBg":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * This module describes valid and deprecated regions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edge", ()=>Edge);
parcelHelpers.export(exports, "Region", ()=>Region);
parcelHelpers.export(exports, "regionShortcodes", ()=>regionShortcodes);
parcelHelpers.export(exports, "regionToEdge", ()=>regionToEdge);
parcelHelpers.export(exports, "defaultEdge", ()=>defaultEdge);
/**
 * String template for a region insights URI
 * @param region - The region.
 */ parcelHelpers.export(exports, "createEventGatewayURI", ()=>createEventGatewayURI);
/**
 * Create a signaling endpoint URL to connect a websocket to from a chunder URI.
 * @param uri the chunder URI to create a signaling endpoint URL for
 */ parcelHelpers.export(exports, "createSignalingEndpointURL", ()=>createSignalingEndpointURL);
/**
 * Get the URI associated with the passed edge.
 * @private
 * @param edge - A string or an array of edge values
 * @returns An array of chunder URIs
 */ parcelHelpers.export(exports, "getChunderURIs", ()=>getChunderURIs);
/**
 * Get the region shortcode by its full AWS region string.
 *
 * @private
 * @param region - The region's full AWS string.
 */ parcelHelpers.export(exports, "getRegionShortcode", ()=>getRegionShortcode);
var _errors = require("./errors");
var Edge;
(function(Edge) {
    /**
     * Public edges
     */ Edge["Sydney"] = "sydney";
    Edge["SaoPaulo"] = "sao-paulo";
    Edge["Dublin"] = "dublin";
    Edge["Frankfurt"] = "frankfurt";
    Edge["Tokyo"] = "tokyo";
    Edge["Singapore"] = "singapore";
    Edge["Ashburn"] = "ashburn";
    Edge["Umatilla"] = "umatilla";
    Edge["Roaming"] = "roaming";
    /**
     * Interconnect edges
     */ Edge["AshburnIx"] = "ashburn-ix";
    Edge["SanJoseIx"] = "san-jose-ix";
    Edge["LondonIx"] = "london-ix";
    Edge["FrankfurtIx"] = "frankfurt-ix";
    Edge["SingaporeIx"] = "singapore-ix";
    Edge["SydneyIx"] = "sydney-ix";
    Edge["TokyoIx"] = "tokyo-ix";
})(Edge || (Edge = {}));
var Region;
(function(Region) {
    Region["Au1"] = "au1";
    Region["Au1Ix"] = "au1-ix";
    Region["Br1"] = "br1";
    Region["De1"] = "de1";
    Region["De1Ix"] = "de1-ix";
    Region["Gll"] = "gll";
    Region["Ie1"] = "ie1";
    Region["Ie1Ix"] = "ie1-ix";
    Region["Ie1Tnx"] = "ie1-tnx";
    Region["Jp1"] = "jp1";
    Region["Jp1Ix"] = "jp1-ix";
    Region["Sg1"] = "sg1";
    Region["Sg1Ix"] = "sg1-ix";
    Region["Sg1Tnx"] = "sg1-tnx";
    Region["Us1"] = "us1";
    Region["Us1Ix"] = "us1-ix";
    Region["Us1Tnx"] = "us1-tnx";
    Region["Us2"] = "us2";
    Region["Us2Ix"] = "us2-ix";
    Region["Us2Tnx"] = "us2-tnx";
})(Region || (Region = {}));
const regionShortcodes = {
    ASIAPAC_SINGAPORE: Region.Sg1,
    ASIAPAC_SYDNEY: Region.Au1,
    ASIAPAC_TOKYO: Region.Jp1,
    EU_FRANKFURT: Region.De1,
    EU_IRELAND: Region.Ie1,
    SOUTH_AMERICA_SAO_PAULO: Region.Br1,
    US_EAST_VIRGINIA: Region.Us1,
    US_WEST_OREGON: Region.Us2
};
const regionToEdge = {
    [Region.Au1]: Edge.Sydney,
    [Region.Br1]: Edge.SaoPaulo,
    [Region.Ie1]: Edge.Dublin,
    [Region.De1]: Edge.Frankfurt,
    [Region.Jp1]: Edge.Tokyo,
    [Region.Sg1]: Edge.Singapore,
    [Region.Us1]: Edge.Ashburn,
    [Region.Us2]: Edge.Umatilla,
    [Region.Gll]: Edge.Roaming,
    /**
     * Interconnect edges
     */ [Region.Us1Ix]: Edge.AshburnIx,
    [Region.Us2Ix]: Edge.SanJoseIx,
    [Region.Ie1Ix]: Edge.LondonIx,
    [Region.De1Ix]: Edge.FrankfurtIx,
    [Region.Sg1Ix]: Edge.SingaporeIx,
    [Region.Au1Ix]: Edge.SydneyIx,
    [Region.Jp1Ix]: Edge.TokyoIx,
    /**
     * Tnx regions
     */ [Region.Us1Tnx]: Edge.AshburnIx,
    [Region.Us2Tnx]: Edge.AshburnIx,
    [Region.Ie1Tnx]: Edge.LondonIx,
    [Region.Sg1Tnx]: Edge.SingaporeIx
};
const defaultEdge = Edge.Roaming;
/**
 * The default event gateway URI to publish to.
 * @constant
 * @private
 */ const defaultEventGatewayURI = 'eventgw.twilio.com';
/**
 * String template for an edge chunder URI
 * @param edge - The edge.
 */ function createChunderEdgeURI(edge) {
    return `voice-js.${edge}.twilio.com`;
}
function createEventGatewayURI(region) {
    return region ? `eventgw.${region}.twilio.com` : defaultEventGatewayURI;
}
function createSignalingEndpointURL(uri) {
    return `wss://${uri}/signal`;
}
function getChunderURIs(edge) {
    if (!!edge && typeof edge !== 'string' && !Array.isArray(edge)) throw new (0, _errors.InvalidArgumentError)('If `edge` is provided, it must be of type `string` or an array of strings.');
    let uris;
    if (edge) {
        const edgeParams = Array.isArray(edge) ? edge : [
            edge
        ];
        uris = edgeParams.map((param)=>createChunderEdgeURI(param));
    } else uris = [
        createChunderEdgeURI(defaultEdge)
    ];
    return uris;
}
function getRegionShortcode(region) {
    return regionShortcodes[region] || null;
}

},{"./errors":"caXI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NmEm":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enabled", ()=>enabled);
parcelHelpers.export(exports, "getMediaEngine", ()=>getMediaEngine);
parcelHelpers.export(exports, "PeerConnection", ()=>(0, _peerconnectionDefault.default));
var _peerconnection = require("./peerconnection");
var _peerconnectionDefault = parcelHelpers.interopDefault(_peerconnection);
var _rtcpc = require("./rtcpc");
var _rtcpcDefault = parcelHelpers.interopDefault(_rtcpc);
function enabled() {
    return (0, _rtcpcDefault.default).test();
}
function getMediaEngine() {
    return typeof RTCIceGatherer !== 'undefined' ? 'ORTC' : 'WebRTC';
}

},{"./peerconnection":"1fH1c","./rtcpc":"6gmfC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1fH1c":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("../errors");
var _log = require("../log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _util = require("../util");
var _rtcpc = require("./rtcpc");
var _rtcpcDefault = parcelHelpers.interopDefault(_rtcpc);
var _sdp = require("./sdp");
const ICE_GATHERING_TIMEOUT = 15000;
const ICE_GATHERING_FAIL_NONE = 'none';
const ICE_GATHERING_FAIL_TIMEOUT = 'timeout';
const INITIAL_ICE_CONNECTION_STATE = 'new';
const VOLUME_INTERVAL_MS = 50;
/**
 * @typedef {Object} PeerConnection
 * @param audioHelper
 * @param pstream
 * @param options
 * @return {PeerConnection}
 * @constructor
 */ function PeerConnection(audioHelper, pstream, options) {
    if (!audioHelper || !pstream) throw new (0, _errors.InvalidArgumentError)('Audiohelper, and pstream are required arguments');
    if (!(this instanceof PeerConnection)) return new PeerConnection(audioHelper, pstream, options);
    this._log = new (0, _logDefault.default)('PeerConnection');
    function noop() {
        this._log.warn('Unexpected noop call in peerconnection');
    }
    this.onaudio = noop;
    this.onopen = noop;
    this.onerror = noop;
    this.onclose = noop;
    this.ondisconnected = noop;
    this.onfailed = noop;
    this.onconnected = noop;
    this.onreconnected = noop;
    this.onsignalingstatechange = noop;
    this.ondtlstransportstatechange = noop;
    this.onicegatheringfailure = noop;
    this.onicegatheringstatechange = noop;
    this.oniceconnectionstatechange = noop;
    this.onpcconnectionstatechange = noop;
    this.onicecandidate = noop;
    this.onselectedcandidatepairchange = noop;
    this.onvolume = noop;
    this.version = null;
    this.pstream = pstream;
    this.stream = null;
    this.sinkIds = new Set([
        'default'
    ]);
    this.outputs = new Map();
    this.status = 'connecting';
    this.callSid = null;
    this.isMuted = false;
    const AudioContext = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
    this._isSinkSupported = !!AudioContext && typeof HTMLAudioElement !== 'undefined' && HTMLAudioElement.prototype.setSinkId;
    // NOTE(mmalavalli): Since each Connection creates its own AudioContext,
    // after 6 instances an exception is thrown. Refer https://www.w3.org/2011/audio/track/issues/3.
    // In order to get around it, we are re-using the Device's AudioContext.
    this._audioContext = AudioContext && audioHelper._audioContext;
    this._audioHelper = audioHelper;
    this._hasIceCandidates = false;
    this._hasIceGatheringFailures = false;
    this._iceGatheringTimeoutId = null;
    this._masterAudio = null;
    this._masterAudioDeviceId = null;
    this._mediaStreamSource = null;
    this._dtmfSender = null;
    this._dtmfSenderUnsupported = false;
    this._callEvents = [];
    this._nextTimeToPublish = Date.now();
    this._onAnswerOrRinging = noop;
    this._onHangup = noop;
    this._remoteStream = null;
    this._shouldManageStream = true;
    this._iceState = INITIAL_ICE_CONNECTION_STATE;
    this._isUnifiedPlan = options.isUnifiedPlan;
    this.options = options = options || {};
    this.navigator = options.navigator || (typeof navigator !== 'undefined' ? navigator : null);
    this.util = options.util || _util;
    this.codecPreferences = options.codecPreferences;
    return this;
}
PeerConnection.prototype.uri = function() {
    return this._uri;
};
/**
 * Open the underlying RTCPeerConnection with a MediaStream obtained by
 *   passed constraints. The resulting MediaStream is created internally
 *   and will therefore be managed and destroyed internally.
 * @param {MediaStreamConstraints} constraints
 */ PeerConnection.prototype.openDefaultDeviceWithConstraints = function(constraints) {
    return this._audioHelper._openDefaultDeviceWithConstraints(constraints).then(this._setInputTracksFromStream.bind(this, false));
};
/**
 * Replace the existing input audio tracks with the audio tracks from the
 *   passed input audio stream. We re-use the existing stream because
 *   the AnalyzerNode is bound to the stream.
 * @param {MediaStream} stream
 */ PeerConnection.prototype.setInputTracksFromStream = function(stream) {
    const self = this;
    return this._setInputTracksFromStream(true, stream).then(()=>{
        self._shouldManageStream = false;
    });
};
PeerConnection.prototype._createAnalyser = (audioContext, options)=>{
    options = Object.assign({
        fftSize: 32,
        smoothingTimeConstant: 0.3
    }, options);
    const analyser = audioContext.createAnalyser();
    // tslint:disable-next-line
    for(const field in options)analyser[field] = options[field];
    return analyser;
};
PeerConnection.prototype._setVolumeHandler = function(handler) {
    this.onvolume = handler;
};
PeerConnection.prototype._startPollingVolume = function() {
    if (!this._audioContext || !this.stream || !this._remoteStream) return;
    const audioContext = this._audioContext;
    const inputAnalyser = this._inputAnalyser = this._createAnalyser(audioContext);
    const inputBufferLength = inputAnalyser.frequencyBinCount;
    const inputDataArray = new Uint8Array(inputBufferLength);
    this._inputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    const outputAnalyser = this._outputAnalyser = this._createAnalyser(audioContext);
    const outputBufferLength = outputAnalyser.frequencyBinCount;
    const outputDataArray = new Uint8Array(outputBufferLength);
    this._outputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    this._updateInputStreamSource(this.stream);
    this._updateOutputStreamSource(this._remoteStream);
    const self = this;
    setTimeout(function emitVolume() {
        if (!self._audioContext) return;
        else if (self.status === 'closed') {
            self._inputAnalyser.disconnect();
            self._outputAnalyser.disconnect();
            self._inputAnalyser2.disconnect();
            self._outputAnalyser2.disconnect();
            return;
        }
        self._inputAnalyser.getByteFrequencyData(inputDataArray);
        const inputVolume = self.util.average(inputDataArray);
        self._inputAnalyser2.getByteFrequencyData(inputDataArray);
        const inputVolume2 = self.util.average(inputDataArray);
        self._outputAnalyser.getByteFrequencyData(outputDataArray);
        const outputVolume = self.util.average(outputDataArray);
        self._outputAnalyser2.getByteFrequencyData(outputDataArray);
        const outputVolume2 = self.util.average(outputDataArray);
        self.onvolume(inputVolume / 255, outputVolume / 255, inputVolume2, outputVolume2);
        setTimeout(emitVolume, VOLUME_INTERVAL_MS);
    }, VOLUME_INTERVAL_MS);
};
PeerConnection.prototype._stopStream = function _stopStream() {
    // We shouldn't stop the tracks if they were not created inside
    //   this PeerConnection.
    if (!this._shouldManageStream) return;
    this._audioHelper._stopDefaultInputDeviceStream();
};
/**
 * Update the stream source with the new input audio stream.
 * @param {MediaStream} stream
 * @private
 */ PeerConnection.prototype._updateInputStreamSource = function(stream) {
    if (this._inputStreamSource) this._inputStreamSource.disconnect();
    try {
        this._inputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._inputStreamSource.connect(this._inputAnalyser);
        this._inputStreamSource.connect(this._inputAnalyser2);
    } catch (ex) {
        this._log.warn('Unable to update input MediaStreamSource', ex);
        this._inputStreamSource = null;
    }
};
/**
 * Update the stream source with the new ouput audio stream.
 * @param {MediaStream} stream
 * @private
 */ PeerConnection.prototype._updateOutputStreamSource = function(stream) {
    if (this._outputStreamSource) this._outputStreamSource.disconnect();
    try {
        this._outputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._outputStreamSource.connect(this._outputAnalyser);
        this._outputStreamSource.connect(this._outputAnalyser2);
    } catch (ex) {
        this._log.warn('Unable to update output MediaStreamSource', ex);
        this._outputStreamSource = null;
    }
};
/**
 * Replace the tracks of the current stream with new tracks. We do this rather than replacing the
 *   whole stream because AnalyzerNodes are bound to a stream.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ PeerConnection.prototype._setInputTracksFromStream = function(shouldClone, newStream) {
    return this._isUnifiedPlan ? this._setInputTracksForUnifiedPlan(shouldClone, newStream) : this._setInputTracksForPlanB(shouldClone, newStream);
};
/**
 * Replace the tracks of the current stream with new tracks using the 'plan-b' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ PeerConnection.prototype._setInputTracksForPlanB = function(shouldClone, newStream) {
    if (!newStream) return Promise.reject(new (0, _errors.InvalidArgumentError)('Can not set input stream to null while in a call'));
    if (!newStream.getAudioTracks().length) return Promise.reject(new (0, _errors.InvalidArgumentError)('Supplied input stream has no audio tracks'));
    const localStream = this.stream;
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? cloneStream(newStream) : newStream;
    else {
        this._stopStream();
        removeStream(this.version.pc, localStream);
        localStream.getAudioTracks().forEach(localStream.removeTrack, localStream);
        newStream.getAudioTracks().forEach(localStream.addTrack, localStream);
        addStream(this.version.pc, newStream);
        this._updateInputStreamSource(this.stream);
    }
    // Apply mute settings to new input track
    this.mute(this.isMuted);
    if (!this.version) return Promise.resolve(this.stream);
    return new Promise((resolve, reject)=>{
        this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
            audio: true
        }, ()=>{
            this.version.processAnswer(this.codecPreferences, this._answerSdp, ()=>{
                resolve(this.stream);
            }, reject);
        }, reject);
    });
};
/**
 * Replace the tracks of the current stream with new tracks using the 'unified-plan' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ PeerConnection.prototype._setInputTracksForUnifiedPlan = function(shouldClone, newStream) {
    if (!newStream) return Promise.reject(new (0, _errors.InvalidArgumentError)('Can not set input stream to null while in a call'));
    if (!newStream.getAudioTracks().length) return Promise.reject(new (0, _errors.InvalidArgumentError)('Supplied input stream has no audio tracks'));
    const localStream = this.stream;
    const getStreamPromise = ()=>{
        // Apply mute settings to new input track
        this.mute(this.isMuted);
        return Promise.resolve(this.stream);
    };
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? cloneStream(newStream) : newStream;
    else {
        // If the call was started with gUM, and we are now replacing that track with an
        // external stream's tracks, we should stop the old managed track.
        if (this._shouldManageStream) this._stopStream();
        if (!this._sender) this._sender = this.version.pc.getSenders()[0];
        return this._sender.replaceTrack(newStream.getAudioTracks()[0]).then(()=>{
            this._updateInputStreamSource(newStream);
            this.stream = shouldClone ? cloneStream(newStream) : newStream;
            return getStreamPromise();
        });
    }
    return getStreamPromise();
};
PeerConnection.prototype._onInputDevicesChanged = function() {
    if (!this.stream) return;
    // If all of our active tracks are ended, then our active input was lost
    const activeInputWasLost = this.stream.getAudioTracks().every((track)=>track.readyState === 'ended');
    // We only want to act if we manage the stream in PeerConnection (It was created
    // here, rather than passed in.)
    if (activeInputWasLost && this._shouldManageStream) this.openDefaultDeviceWithConstraints({
        audio: true
    });
};
PeerConnection.prototype._onIceGatheringFailure = function(type) {
    this._hasIceGatheringFailures = true;
    this.onicegatheringfailure(type);
};
PeerConnection.prototype._onMediaConnectionStateChange = function(newState) {
    const previousState = this._iceState;
    if (previousState === newState || newState !== 'connected' && newState !== 'disconnected' && newState !== 'failed') return;
    this._iceState = newState;
    let message;
    switch(newState){
        case 'connected':
            if (previousState === 'disconnected' || previousState === 'failed') {
                message = 'ICE liveliness check succeeded. Connection with Twilio restored';
                this._log.info(message);
                this.onreconnected(message);
            } else {
                message = 'Media connection established.';
                this._log.info(message);
                this.onconnected(message);
            }
            this._stopIceGatheringTimeout();
            this._hasIceGatheringFailures = false;
            break;
        case 'disconnected':
            message = 'ICE liveliness check failed. May be having trouble connecting to Twilio';
            this._log.warn(message);
            this.ondisconnected(message);
            break;
        case 'failed':
            message = 'Connection with Twilio was interrupted.';
            this._log.warn(message);
            this.onfailed(message);
            break;
    }
};
PeerConnection.prototype._setSinkIds = function(sinkIds) {
    if (!this._isSinkSupported) return Promise.reject(new (0, _errors.NotSupportedError)('Audio output selection is not supported by this browser'));
    this.sinkIds = new Set(sinkIds.forEach ? sinkIds : [
        sinkIds
    ]);
    return this.version ? this._updateAudioOutputs() : Promise.resolve();
};
/**
 * Start timeout for ICE Gathering
 */ PeerConnection.prototype._startIceGatheringTimeout = function startIceGatheringTimeout() {
    this._stopIceGatheringTimeout();
    this._iceGatheringTimeoutId = setTimeout(()=>{
        this._onIceGatheringFailure(ICE_GATHERING_FAIL_TIMEOUT);
    }, ICE_GATHERING_TIMEOUT);
};
/**
 * Stop timeout for ICE Gathering
 */ PeerConnection.prototype._stopIceGatheringTimeout = function stopIceGatheringTimeout() {
    clearInterval(this._iceGatheringTimeoutId);
};
PeerConnection.prototype._updateAudioOutputs = function updateAudioOutputs() {
    const addedOutputIds = Array.from(this.sinkIds).filter(function(id) {
        return !this.outputs.has(id);
    }, this);
    const removedOutputIds = Array.from(this.outputs.keys()).filter(function(id) {
        return !this.sinkIds.has(id);
    }, this);
    const self = this;
    const createOutputPromises = addedOutputIds.map(this._createAudioOutput, this);
    return Promise.all(createOutputPromises).then(()=>Promise.all(removedOutputIds.map(self._removeAudioOutput, self)));
};
PeerConnection.prototype._createAudio = function createAudio(arr) {
    const audio = new Audio(arr);
    this.onaudio(audio);
    return audio;
};
PeerConnection.prototype._createAudioOutput = function createAudioOutput(id) {
    let dest = null;
    if (this._mediaStreamSource) {
        dest = this._audioContext.createMediaStreamDestination();
        this._mediaStreamSource.connect(dest);
    }
    const audio = this._createAudio();
    setAudioSource(audio, dest && dest.stream ? dest.stream : this.pcStream);
    const self = this;
    return audio.setSinkId(id).then(()=>audio.play()).then(()=>{
        self.outputs.set(id, {
            audio,
            dest
        });
    });
};
PeerConnection.prototype._removeAudioOutputs = function removeAudioOutputs() {
    if (this._masterAudio && typeof this._masterAudioDeviceId !== 'undefined') {
        this._disableOutput(this, this._masterAudioDeviceId);
        this.outputs.delete(this._masterAudioDeviceId);
        this._masterAudioDeviceId = null;
        // Release the audio resources before deleting the audio
        if (!this._masterAudio.paused) this._masterAudio.pause();
        if (typeof this._masterAudio.srcObject !== 'undefined') this._masterAudio.srcObject = null;
        else this._masterAudio.src = '';
        this._masterAudio = null;
    }
    return Array.from(this.outputs.keys()).map(this._removeAudioOutput, this);
};
PeerConnection.prototype._disableOutput = function disableOutput(pc, id) {
    const output = pc.outputs.get(id);
    if (!output) return;
    if (output.audio) {
        output.audio.pause();
        output.audio.src = '';
    }
    if (output.dest) output.dest.disconnect();
};
/**
 * Disable a non-master output, and update the master output to assume its state. This
 *   is called when the device ID assigned to the master output has been removed from
 *   active devices. We can not simply remove the master audio output, so we must
 *   instead reassign it.
 * @private
 * @param {PeerConnection} pc
 * @param {string} masterId - The current device ID assigned to the master audio element.
 */ PeerConnection.prototype._reassignMasterOutput = function reassignMasterOutput(pc, masterId) {
    const masterOutput = pc.outputs.get(masterId);
    pc.outputs.delete(masterId);
    const self = this;
    const activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    const idToReplace = typeof activeDeviceId === 'string' ? activeDeviceId : 'default';
    return masterOutput.audio.setSinkId(idToReplace).then(()=>{
        self._disableOutput(pc, idToReplace);
        pc.outputs.set(idToReplace, masterOutput);
        pc._masterAudioDeviceId = idToReplace;
    }).catch(function rollback() {
        pc.outputs.set(masterId, masterOutput);
        self._log.info('Could not reassign master output. Attempted to roll back.');
    });
};
PeerConnection.prototype._removeAudioOutput = function removeAudioOutput(id) {
    if (this._masterAudioDeviceId === id) return this._reassignMasterOutput(this, id);
    this._disableOutput(this, id);
    this.outputs.delete(id);
    return Promise.resolve();
};
/**
 * Use an AudioContext to potentially split our audio output stream to multiple
 *   audio devices. This is only available to browsers with AudioContext and
 *   HTMLAudioElement.setSinkId() available. We save the source stream in
 *   _masterAudio, and use it for one of the active audio devices. We keep
 *   track of its ID because we must replace it if we lose its initial device.
 */ PeerConnection.prototype._onAddTrack = function onAddTrack(pc, stream) {
    const audio = pc._masterAudio = this._createAudio();
    setAudioSource(audio, stream);
    audio.play();
    // Assign the initial master audio element to a random active output device
    const activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    const deviceId = typeof activeDeviceId === 'string' ? activeDeviceId : 'default';
    pc._masterAudioDeviceId = deviceId;
    pc.outputs.set(deviceId, {
        audio
    });
    try {
        pc._mediaStreamSource = pc._audioContext.createMediaStreamSource(stream);
    } catch (ex) {
        this._log.warn('Unable to create a MediaStreamSource from onAddTrack', ex);
        this._mediaStreamSource = null;
    }
    pc.pcStream = stream;
    pc._updateAudioOutputs();
};
/**
 * Use a single audio element to play the audio output stream. This does not
 *   support multiple output devices, and is a fallback for when AudioContext
 *   and/or HTMLAudioElement.setSinkId() is not available to the client.
 */ PeerConnection.prototype._fallbackOnAddTrack = function fallbackOnAddTrack(pc, stream) {
    const audio = document && document.createElement('audio');
    audio.autoplay = true;
    if (!setAudioSource(audio, stream)) pc._log.info('Error attaching stream to element.');
    pc.outputs.set('default', {
        audio
    });
};
PeerConnection.prototype._setEncodingParameters = function(enableDscp) {
    if (!enableDscp || !this._sender || typeof this._sender.getParameters !== 'function' || typeof this._sender.setParameters !== 'function') return;
    const params = this._sender.getParameters();
    if (!params.priority && !(params.encodings && params.encodings.length)) return;
    // This is how MDN's RTPSenderParameters defines priority
    params.priority = 'high';
    // And this is how it's currently implemented in Chrome M72+
    if (params.encodings && params.encodings.length) params.encodings.forEach((encoding)=>{
        encoding.priority = 'high';
        encoding.networkPriority = 'high';
    });
    this._sender.setParameters(params);
};
PeerConnection.prototype._setupPeerConnection = function(rtcConfiguration) {
    const self = this;
    const version = new (this.options.rtcpcFactory || (0, _rtcpcDefault.default))({
        RTCPeerConnection: this.options.RTCPeerConnection
    });
    version.create(rtcConfiguration);
    addStream(version.pc, this.stream);
    const eventName = 'ontrack' in version.pc ? 'ontrack' : 'onaddstream';
    version.pc[eventName] = (event)=>{
        const stream = self._remoteStream = event.stream || event.streams[0];
        if (typeof version.pc.getSenders === 'function') this._sender = version.pc.getSenders()[0];
        if (self._isSinkSupported) self._onAddTrack(self, stream);
        else self._fallbackOnAddTrack(self, stream);
        self._startPollingVolume();
    };
    return version;
};
PeerConnection.prototype._maybeSetIceAggressiveNomination = function(sdp) {
    return this.options.forceAggressiveIceNomination ? (0, _sdp.setIceAggressiveNomination)(sdp) : sdp;
};
PeerConnection.prototype._setupChannel = function() {
    const pc = this.version.pc;
    // Chrome 25 supports onopen
    this.version.pc.onopen = ()=>{
        this.status = 'open';
        this.onopen();
    };
    // Chrome 26 doesn't support onopen so must detect state change
    this.version.pc.onstatechange = ()=>{
        if (this.version.pc && this.version.pc.readyState === 'stable') {
            this.status = 'open';
            this.onopen();
        }
    };
    // Chrome 27 changed onstatechange to onsignalingstatechange
    this.version.pc.onsignalingstatechange = ()=>{
        const state = pc.signalingState;
        this._log.info(`signalingState is "${state}"`);
        if (this.version.pc && this.version.pc.signalingState === 'stable') {
            this.status = 'open';
            this.onopen();
        }
        this.onsignalingstatechange(pc.signalingState);
    };
    // Chrome 72+
    pc.onconnectionstatechange = (event)=>{
        let state = pc.connectionState;
        if (!state && event && event.target) {
            // VDI environment
            const targetPc = event.target;
            state = targetPc.connectionState || targetPc.connectionState_;
            this._log.info(`pc.connectionState not detected. Using target PC. State=${state}`);
        }
        if (!state) this._log.warn(`onconnectionstatechange detected but state is "${state}"`);
        else this._log.info(`pc.connectionState is "${state}"`);
        this.onpcconnectionstatechange(state);
        this._onMediaConnectionStateChange(state);
    };
    pc.onicecandidate = (event)=>{
        const { candidate } = event;
        if (candidate) {
            this._hasIceCandidates = true;
            this.onicecandidate(candidate);
            this._setupRTCIceTransportListener();
        }
        this._log.info(`ICE Candidate: ${JSON.stringify(candidate)}`);
    };
    pc.onicegatheringstatechange = ()=>{
        const state = pc.iceGatheringState;
        if (state === 'gathering') this._startIceGatheringTimeout();
        else if (state === 'complete') {
            this._stopIceGatheringTimeout();
            // Fail if no candidates found
            if (!this._hasIceCandidates) this._onIceGatheringFailure(ICE_GATHERING_FAIL_NONE);
            // There was a failure mid-gathering phase. We want to start our timer and issue
            // an ice restart if we don't get connected after our timeout
            if (this._hasIceCandidates && this._hasIceGatheringFailures) this._startIceGatheringTimeout();
        }
        this._log.info(`pc.iceGatheringState is "${pc.iceGatheringState}"`);
        this.onicegatheringstatechange(state);
    };
    pc.oniceconnectionstatechange = ()=>{
        this._log.info(`pc.iceConnectionState is "${pc.iceConnectionState}"`);
        this.oniceconnectionstatechange(pc.iceConnectionState);
        this._onMediaConnectionStateChange(pc.iceConnectionState);
    };
};
PeerConnection.prototype._initializeMediaStream = function(rtcConfiguration) {
    // if mediastream already open then do nothing
    if (this.status === 'open') return false;
    if (this.pstream.status === 'disconnected') {
        this.onerror({
            info: {
                code: 31000,
                message: 'Cannot establish connection. Client is disconnected',
                twilioError: new (0, _errors.SignalingErrors).ConnectionDisconnected()
            }
        });
        this.close();
        return false;
    }
    this.version = this._setupPeerConnection(rtcConfiguration);
    this._setupChannel();
    return true;
};
/**
 * Remove reconnection-related listeners
 * @private
 */ PeerConnection.prototype._removeReconnectionListeners = function() {
    if (this.pstream) {
        this.pstream.removeListener('answer', this._onAnswerOrRinging);
        this.pstream.removeListener('hangup', this._onHangup);
    }
};
/**
 * Setup a listener for RTCDtlsTransport to capture state changes events
 * @private
 */ PeerConnection.prototype._setupRTCDtlsTransportListener = function() {
    const dtlsTransport = this.getRTCDtlsTransport();
    if (!dtlsTransport || dtlsTransport.onstatechange) return;
    const handler = ()=>{
        this._log.info(`dtlsTransportState is "${dtlsTransport.state}"`);
        this.ondtlstransportstatechange(dtlsTransport.state);
    };
    // Publish initial state
    handler();
    dtlsTransport.onstatechange = handler;
};
/**
 * Setup a listener for RTCIceTransport to capture selected candidate pair changes
 * @private
 */ PeerConnection.prototype._setupRTCIceTransportListener = function() {
    const iceTransport = this._getRTCIceTransport();
    if (!iceTransport || iceTransport.onselectedcandidatepairchange) return;
    iceTransport.onselectedcandidatepairchange = ()=>this.onselectedcandidatepairchange(iceTransport.getSelectedCandidatePair());
};
/**
 * Restarts ICE for the current connection
 * ICE Restart failures are ignored. Retries are managed in Connection
 * @private
 */ PeerConnection.prototype.iceRestart = function() {
    this._log.info('Attempting to restart ICE...');
    this._hasIceCandidates = false;
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        iceRestart: true
    }).then(()=>{
        this._removeReconnectionListeners();
        this._onAnswerOrRinging = (payload)=>{
            this._removeReconnectionListeners();
            if (!payload.sdp || this.version.pc.signalingState !== 'have-local-offer') {
                const message = 'Invalid state or param during ICE Restart:' + `hasSdp:${!!payload.sdp}, signalingState:${this.version.pc.signalingState}`;
                this._log.warn(message);
                return;
            }
            const sdp = this._maybeSetIceAggressiveNomination(payload.sdp);
            this._answerSdp = sdp;
            if (this.status !== 'closed') this.version.processAnswer(this.codecPreferences, sdp, null, (err)=>{
                const message = err && err.message ? err.message : err;
                this._log.error(`Failed to process answer during ICE Restart. Error: ${message}`);
            });
        };
        this._onHangup = ()=>{
            this._log.info('Received hangup during ICE Restart');
            this._removeReconnectionListeners();
        };
        this.pstream.on('answer', this._onAnswerOrRinging);
        this.pstream.on('hangup', this._onHangup);
        this.pstream.reinvite(this.version.getSDP(), this.callSid);
    }).catch((err)=>{
        const message = err && err.message ? err.message : err;
        this._log.error(`Failed to createOffer during ICE Restart. Error: ${message}`);
        // CreateOffer failures doesn't transition ice state to failed
        // We need trigger it so it can be picked up by retries
        this.onfailed(message);
    });
};
PeerConnection.prototype.makeOutgoingCall = function(params, signalingReconnectToken, callsid, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    const self = this;
    this.callSid = callsid;
    function onAnswerSuccess() {
        if (self.options) self._setEncodingParameters(self.options.dscp);
        onMediaStarted(self.version.pc);
    }
    function onAnswerError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error processing answer: ${errMsg}`,
                twilioError: new (0, _errors.MediaErrors).ClientRemoteDescFailed()
            }
        });
    }
    this._onAnswerOrRinging = (payload)=>{
        if (!payload.sdp) return;
        const sdp = this._maybeSetIceAggressiveNomination(payload.sdp);
        self._answerSdp = sdp;
        if (self.status !== 'closed') self.version.processAnswer(this.codecPreferences, sdp, onAnswerSuccess, onAnswerError);
        self.pstream.removeListener('answer', self._onAnswerOrRinging);
        self.pstream.removeListener('ringing', self._onAnswerOrRinging);
    };
    this.pstream.on('answer', this._onAnswerOrRinging);
    this.pstream.on('ringing', this._onAnswerOrRinging);
    function onOfferSuccess() {
        if (self.status !== 'closed') {
            if (signalingReconnectToken) self.pstream.reconnect(self.version.getSDP(), self.callSid, signalingReconnectToken);
            else self.pstream.invite(self.version.getSDP(), self.callSid, params);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onOfferError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error creating the offer: ${errMsg}`,
                twilioError: new (0, _errors.MediaErrors).ClientLocalDescFailed()
            }
        });
    }
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        audio: true
    }, onOfferSuccess, onOfferError);
};
PeerConnection.prototype.answerIncomingCall = function(callSid, sdp, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    sdp = this._maybeSetIceAggressiveNomination(sdp);
    this._answerSdp = sdp.replace(/^a=setup:actpass$/gm, 'a=setup:passive');
    this.callSid = callSid;
    const self = this;
    function onAnswerSuccess() {
        if (self.status !== 'closed') {
            self.pstream.answer(self.version.getSDP(), callSid);
            if (self.options) self._setEncodingParameters(self.options.dscp);
            onMediaStarted(self.version.pc);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onAnswerError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error creating the answer: ${errMsg}`,
                twilioError: new (0, _errors.MediaErrors).ClientRemoteDescFailed()
            }
        });
    }
    this.version.processSDP(this.options.maxAverageBitrate, this.codecPreferences, sdp, {
        audio: true
    }, onAnswerSuccess, onAnswerError);
};
PeerConnection.prototype.close = function() {
    if (this.version && this.version.pc) {
        if (this.version.pc.signalingState !== 'closed') this.version.pc.close();
        this.version.pc = null;
    }
    if (this.stream) {
        this.mute(false);
        this._stopStream();
    }
    this.stream = null;
    this._removeReconnectionListeners();
    this._stopIceGatheringTimeout();
    Promise.all(this._removeAudioOutputs()).catch(()=>{
    // We don't need to alert about failures here.
    });
    if (this._mediaStreamSource) this._mediaStreamSource.disconnect();
    if (this._inputAnalyser) this._inputAnalyser.disconnect();
    if (this._outputAnalyser) this._outputAnalyser.disconnect();
    if (this._inputAnalyser2) this._inputAnalyser2.disconnect();
    if (this._outputAnalyser2) this._outputAnalyser2.disconnect();
    this.status = 'closed';
    this.onclose();
};
PeerConnection.prototype.reject = function(callSid) {
    this.callSid = callSid;
};
PeerConnection.prototype.ignore = function(callSid) {
    this.callSid = callSid;
};
/**
 * Mute or unmute input audio. If the stream is not yet present, the setting
 *   is saved and applied to future streams/tracks.
 * @params {boolean} shouldMute - Whether the input audio should
 *   be muted or unmuted.
 */ PeerConnection.prototype.mute = function(shouldMute) {
    this.isMuted = shouldMute;
    if (!this.stream) return;
    if (this._sender && this._sender.track) this._sender.track.enabled = !shouldMute;
    else {
        const audioTracks = typeof this.stream.getAudioTracks === 'function' ? this.stream.getAudioTracks() : this.stream.audioTracks;
        audioTracks.forEach((track)=>{
            track.enabled = !shouldMute;
        });
    }
};
/**
 * Get or create an RTCDTMFSender for the first local audio MediaStreamTrack
 * we can get from the RTCPeerConnection. Return null if unsupported.
 * @instance
 * @returns ?RTCDTMFSender
 */ PeerConnection.prototype.getOrCreateDTMFSender = function getOrCreateDTMFSender() {
    if (this._dtmfSender || this._dtmfSenderUnsupported) return this._dtmfSender || null;
    const self = this;
    const pc = this.version.pc;
    if (!pc) {
        this._log.warn('No RTCPeerConnection available to call createDTMFSender on');
        return null;
    }
    if (typeof pc.getSenders === 'function' && (typeof RTCDTMFSender === 'function' || typeof RTCDtmfSender === 'function')) {
        const chosenSender = pc.getSenders().find((sender)=>sender.dtmf);
        if (chosenSender) {
            this._log.info('Using RTCRtpSender#dtmf');
            this._dtmfSender = chosenSender.dtmf;
            return this._dtmfSender;
        }
    }
    if (typeof pc.createDTMFSender === 'function' && typeof pc.getLocalStreams === 'function') {
        const track = pc.getLocalStreams().map((stream)=>{
            const tracks = self._getAudioTracks(stream);
            return tracks && tracks[0];
        })[0];
        if (!track) {
            this._log.warn('No local audio MediaStreamTrack available on the RTCPeerConnection to pass to createDTMFSender');
            return null;
        }
        this._log.info('Creating RTCDTMFSender');
        this._dtmfSender = pc.createDTMFSender(track);
        return this._dtmfSender;
    }
    this._log.info('RTCPeerConnection does not support RTCDTMFSender');
    this._dtmfSenderUnsupported = true;
    return null;
};
/**
 * Get the RTCDtlTransport object from the PeerConnection
 * @returns RTCDtlTransport
 */ PeerConnection.prototype.getRTCDtlsTransport = function getRTCDtlsTransport() {
    const sender = this.version && this.version.pc && typeof this.version.pc.getSenders === 'function' && this.version.pc.getSenders()[0];
    return sender && sender.transport || null;
};
PeerConnection.prototype._canStopMediaStreamTrack = ()=>typeof MediaStreamTrack.prototype.stop === 'function';
PeerConnection.prototype._getAudioTracks = (stream)=>typeof stream.getAudioTracks === 'function' ? stream.getAudioTracks() : stream.audioTracks;
/**
 * Get the RTCIceTransport object from the PeerConnection
 * @returns RTCIceTransport
 */ PeerConnection.prototype._getRTCIceTransport = function _getRTCIceTransport() {
    const dtlsTransport = this.getRTCDtlsTransport();
    return dtlsTransport && dtlsTransport.iceTransport || null;
};
// Is PeerConnection.protocol used outside of our SDK? We should remove this if not.
PeerConnection.protocol = (()=>(0, _rtcpcDefault.default).test() ? new (0, _rtcpcDefault.default)() : null)();
function addStream(pc, stream) {
    if (typeof pc.addTrack === 'function') stream.getAudioTracks().forEach((track)=>{
        // The second parameters, stream, should not be necessary per the latest editor's
        //   draft, but FF requires it. https://bugzilla.mozilla.org/show_bug.cgi?id=1231414
        pc.addTrack(track, stream);
    });
    else pc.addStream(stream);
}
function cloneStream(oldStream) {
    const newStream = typeof MediaStream !== 'undefined' ? new MediaStream() : new webkitMediaStream();
    oldStream.getAudioTracks().forEach(newStream.addTrack, newStream);
    return newStream;
}
function removeStream(pc, stream) {
    if (typeof pc.removeTrack === 'function') pc.getSenders().forEach((sender)=>{
        pc.removeTrack(sender);
    });
    else pc.removeStream(stream);
}
/**
 * Set the source of an HTMLAudioElement to the specified MediaStream
 * @param {HTMLAudioElement} audio
 * @param {MediaStream} stream
 * @returns {boolean} Whether the audio source was set successfully
 */ function setAudioSource(audio, stream) {
    if (typeof audio.srcObject !== 'undefined') audio.srcObject = stream;
    else if (typeof audio.mozSrcObject !== 'undefined') audio.mozSrcObject = stream;
    else if (typeof audio.src !== 'undefined') {
        const _window = audio.options.window || window;
        audio.src = (_window.URL || _window.webkitURL).createObjectURL(stream);
    } else return false;
    return true;
}
PeerConnection.enabled = (0, _rtcpcDefault.default).test();
exports.default = PeerConnection;

},{"../errors":"caXI8","../log":"eJjQN","../util":"j8qrE","./rtcpc":"6gmfC","./sdp":"IFzxc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gmfC":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
// tslint:disable only-arrow-functions
/* global webkitRTCPeerConnection, mozRTCPeerConnection, mozRTCSessionDescription, mozRTCIceCandidate */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _log = require("../log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _util = require("../util");
var _sdp = require("./sdp");
var global = arguments[3];
const RTCPeerConnectionShim = require("59edf43bf2018f51");
function RTCPC(options) {
    if (typeof window === 'undefined') {
        this.log.info('No RTCPeerConnection implementation available. The window object was not found.');
        return;
    }
    if (options && options.RTCPeerConnection) this.RTCPeerConnection = options.RTCPeerConnection;
    else if (_util.isLegacyEdge()) this.RTCPeerConnection = new RTCPeerConnectionShim(typeof window !== 'undefined' ? window : global);
    else if (typeof window.RTCPeerConnection === 'function') this.RTCPeerConnection = window.RTCPeerConnection;
    else if (typeof window.webkitRTCPeerConnection === 'function') this.RTCPeerConnection = webkitRTCPeerConnection;
    else if (typeof window.mozRTCPeerConnection === 'function') {
        this.RTCPeerConnection = mozRTCPeerConnection;
        window.RTCSessionDescription = mozRTCSessionDescription;
        window.RTCIceCandidate = mozRTCIceCandidate;
    } else this.log.info('No RTCPeerConnection implementation available');
}
RTCPC.prototype.create = function(rtcConfiguration) {
    this.log = new (0, _logDefault.default)('RTCPC');
    this.pc = new this.RTCPeerConnection(rtcConfiguration);
};
RTCPC.prototype.createModernConstraints = (c)=>{
    // createOffer differs between Chrome 23 and Chrome 24+.
    // See https://groups.google.com/forum/?fromgroups=#!topic/discuss-webrtc/JBDZtrMumyU
    // Unfortunately I haven't figured out a way to detect which format
    // is required ahead of time, so we'll first try the old way, and
    // if we get an exception, then we'll try the new way.
    if (typeof c === 'undefined') return null;
    // NOTE(mroberts): As of Chrome 38, Chrome still appears to expect
    // constraints under the 'mandatory' key, and with the first letter of each
    // constraint capitalized. Firefox, on the other hand, has deprecated the
    // 'mandatory' key and does not expect the first letter of each constraint
    // capitalized.
    const nc = Object.assign({}, c);
    if (typeof webkitRTCPeerConnection !== 'undefined' && !_util.isLegacyEdge()) {
        nc.mandatory = {};
        if (typeof c.audio !== 'undefined') nc.mandatory.OfferToReceiveAudio = c.audio;
        if (typeof c.video !== 'undefined') nc.mandatory.OfferToReceiveVideo = c.video;
    } else {
        if (typeof c.audio !== 'undefined') nc.offerToReceiveAudio = c.audio;
        if (typeof c.video !== 'undefined') nc.offerToReceiveVideo = c.video;
    }
    delete nc.audio;
    delete nc.video;
    return nc;
};
RTCPC.prototype.createOffer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    constraints = this.createModernConstraints(constraints);
    return promisifyCreate(this.pc.createOffer, this.pc)(constraints).then((offer)=>{
        if (!this.pc) return Promise.resolve();
        const sdp = (0, _sdp.setMaxAverageBitrate)(offer.sdp, maxAverageBitrate);
        return promisifySet(this.pc.setLocalDescription, this.pc)(new RTCSessionDescription({
            sdp: (0, _sdp.setCodecPreferences)(sdp, codecPreferences),
            type: 'offer'
        }));
    }).then(onSuccess, onError);
};
RTCPC.prototype.createAnswer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    constraints = this.createModernConstraints(constraints);
    return promisifyCreate(this.pc.createAnswer, this.pc)(constraints).then((answer)=>{
        if (!this.pc) return Promise.resolve();
        const sdp = (0, _sdp.setMaxAverageBitrate)(answer.sdp, maxAverageBitrate);
        return promisifySet(this.pc.setLocalDescription, this.pc)(new RTCSessionDescription({
            sdp: (0, _sdp.setCodecPreferences)(sdp, codecPreferences),
            type: 'answer'
        }));
    }).then(onSuccess, onError);
};
RTCPC.prototype.processSDP = function(maxAverageBitrate, codecPreferences, sdp, constraints, onSuccess, onError) {
    sdp = (0, _sdp.setCodecPreferences)(sdp, codecPreferences);
    const desc = new RTCSessionDescription({
        sdp,
        type: 'offer'
    });
    return promisifySet(this.pc.setRemoteDescription, this.pc)(desc).then(()=>{
        this.createAnswer(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError);
    });
};
RTCPC.prototype.getSDP = function() {
    return this.pc.localDescription.sdp;
};
RTCPC.prototype.processAnswer = function(codecPreferences, sdp, onSuccess, onError) {
    if (!this.pc) return Promise.resolve();
    sdp = (0, _sdp.setCodecPreferences)(sdp, codecPreferences);
    return promisifySet(this.pc.setRemoteDescription, this.pc)(new RTCSessionDescription({
        sdp,
        type: 'answer'
    })).then(onSuccess, onError);
};
/* NOTE(mroberts): Firefox 18 through 21 include a `mozRTCPeerConnection`
   object, but attempting to instantiate it will throw the error

       Error: PeerConnection not enabled (did you set the pref?)

   unless the `media.peerconnection.enabled` pref is enabled. So we need to test
   if we can actually instantiate `mozRTCPeerConnection`; however, if the user
   *has* enabled `media.peerconnection.enabled`, we need to perform the same
   test that we use to detect Firefox 24 and above, namely:

       typeof (new mozRTCPeerConnection()).getLocalStreams === 'function'

    NOTE(rrowland): We no longer support Legacy Edge as of Sep 1, 2020.
*/ RTCPC.test = ()=>{
    if (typeof navigator === 'object') {
        const getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
        if (_util.isLegacyEdge(navigator)) return false;
        if (getUserMedia && typeof window.RTCPeerConnection === 'function') return true;
        else if (getUserMedia && typeof window.webkitRTCPeerConnection === 'function') return true;
        else if (getUserMedia && typeof window.mozRTCPeerConnection === 'function') {
            try {
                const test = new window.mozRTCPeerConnection();
                if (typeof test.getLocalStreams !== 'function') return false;
            } catch (e) {
                return false;
            }
            return true;
        } else if (typeof RTCIceGatherer !== 'undefined') return true;
    }
    return false;
};
function promisify(fn, ctx, areCallbacksFirst, checkRval) {
    return function() {
        const args = Array.prototype.slice.call(arguments);
        return new Promise((resolve)=>{
            const returnValue = fn.apply(ctx, args);
            if (!checkRval) {
                resolve(returnValue);
                return;
            }
            if (typeof returnValue === 'object' && typeof returnValue.then === 'function') resolve(returnValue);
            else throw new Error();
        }).catch(()=>new Promise((resolve, reject)=>{
                fn.apply(ctx, areCallbacksFirst ? [
                    resolve,
                    reject
                ].concat(args) : args.concat([
                    resolve,
                    reject
                ]));
            }));
    };
}
function promisifyCreate(fn, ctx) {
    return promisify(fn, ctx, true, true);
}
function promisifySet(fn, ctx) {
    return promisify(fn, ctx, false, false);
}
exports.default = RTCPC;

},{"../log":"eJjQN","../util":"j8qrE","./sdp":"IFzxc","59edf43bf2018f51":"8LuWs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IFzxc":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreferredCodecInfo", ()=>getPreferredCodecInfo);
parcelHelpers.export(exports, "setCodecPreferences", ()=>setCodecPreferences);
parcelHelpers.export(exports, "setIceAggressiveNomination", ()=>setIceAggressiveNomination);
parcelHelpers.export(exports, "setMaxAverageBitrate", ()=>setMaxAverageBitrate);
var _util = require("../util");
const ptToFixedBitrateAudioCodecName = {
    0: 'PCMU',
    8: 'PCMA'
};
const defaultOpusId = 111;
const BITRATE_MAX = 510000;
const BITRATE_MIN = 6000;
function getPreferredCodecInfo(sdp) {
    const [, codecId, codecName] = /a=rtpmap:(\d+) (\S+)/m.exec(sdp) || [
        null,
        '',
        ''
    ];
    const regex = new RegExp(`a=fmtp:${codecId} (\\S+)`, 'm');
    const [, codecParams] = regex.exec(sdp) || [
        null,
        ''
    ];
    return {
        codecName,
        codecParams
    };
}
function setIceAggressiveNomination(sdp) {
    // This only works on Chrome. We don't want any side effects on other browsers
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1024096
    // https://issues.corp.twilio.com/browse/CLIENT-6911
    if (!_util.isChrome(window, window.navigator)) return sdp;
    return sdp.split('\n').filter((line)=>line.indexOf('a=ice-lite') === -1).join('\n');
}
function setMaxAverageBitrate(sdp, maxAverageBitrate) {
    if (typeof maxAverageBitrate !== 'number' || maxAverageBitrate < BITRATE_MIN || maxAverageBitrate > BITRATE_MAX) return sdp;
    const matches = /a=rtpmap:(\d+) opus/m.exec(sdp);
    const opusId = matches && matches.length ? matches[1] : defaultOpusId;
    const regex = new RegExp(`a=fmtp:${opusId}`);
    const lines = sdp.split('\n').map((line)=>regex.test(line) ? line + `;maxaveragebitrate=${maxAverageBitrate}` : line);
    return lines.join('\n');
}
/**
 * Return a new SDP string with the re-ordered codec preferences.
 * @param {string} sdp
 * @param {Array<AudioCodec>} preferredCodecs - If empty, the existing order
 *   of audio codecs is preserved
 * @returns {string} Updated SDP string
 */ function setCodecPreferences(sdp, preferredCodecs) {
    const mediaSections = getMediaSections(sdp);
    const session = sdp.split('\r\nm=')[0];
    return [
        session
    ].concat(mediaSections.map((section)=>{
        // Codec preferences should not be applied to m=application sections.
        if (!/^m=(audio|video)/.test(section)) return section;
        const kind = section.match(/^m=(audio|video)/)[1];
        const codecMap = createCodecMapForMediaSection(section);
        const payloadTypes = getReorderedPayloadTypes(codecMap, preferredCodecs);
        const newSection = setPayloadTypesInMediaSection(payloadTypes, section);
        const pcmaPayloadTypes = codecMap.get('pcma') || [];
        const pcmuPayloadTypes = codecMap.get('pcmu') || [];
        const fixedBitratePayloadTypes = kind === 'audio' ? new Set(pcmaPayloadTypes.concat(pcmuPayloadTypes)) : new Set();
        return fixedBitratePayloadTypes.has(payloadTypes[0]) ? newSection.replace(/\r\nb=(AS|TIAS):([0-9]+)/g, '') : newSection;
    })).join('\r\n');
}
/**
 * Get the m= sections of a particular kind and direction from an sdp.
 * @param {string} sdp - SDP string
 * @param {string} [kind] - Pattern for matching kind
 * @param {string} [direction] - Pattern for matching direction
 * @returns {Array<string>} mediaSections
 */ function getMediaSections(sdp, kind, direction) {
    return sdp.replace(/\r\n\r\n$/, '\r\n').split('\r\nm=').slice(1).map((mediaSection)=>`m=${mediaSection}`).filter((mediaSection)=>{
        const kindPattern = new RegExp(`m=${kind || '.*'}`, 'gm');
        const directionPattern = new RegExp(`a=${direction || '.*'}`, 'gm');
        return kindPattern.test(mediaSection) && directionPattern.test(mediaSection);
    });
}
/**
 * Create a Codec Map for the given m= section.
 * @param {string} section - The given m= section
 * @returns {Map<Codec, Array<PT>>}
 */ function createCodecMapForMediaSection(section) {
    return Array.from(createPtToCodecName(section)).reduce((codecMap, pair)=>{
        const pt = pair[0];
        const codecName = pair[1];
        const pts = codecMap.get(codecName) || [];
        return codecMap.set(codecName, pts.concat(pt));
    }, new Map());
}
/**
 * Create the reordered Codec Payload Types based on the preferred Codec Names.
 * @param {Map<Codec, Array<PT>>} codecMap - Codec Map
 * @param {Array<Codec>} preferredCodecs - Preferred Codec Names
 * @returns {Array<PT>} Reordered Payload Types
 */ function getReorderedPayloadTypes(codecMap, preferredCodecs) {
    preferredCodecs = preferredCodecs.map((codecName)=>codecName.toLowerCase());
    const preferredPayloadTypes = _util.flatMap(preferredCodecs, (codecName)=>codecMap.get(codecName) || []);
    const remainingCodecs = _util.difference(Array.from(codecMap.keys()), preferredCodecs);
    const remainingPayloadTypes = _util.flatMap(remainingCodecs, (codecName)=>codecMap.get(codecName));
    return preferredPayloadTypes.concat(remainingPayloadTypes);
}
/**
 * Set the given Codec Payload Types in the first line of the given m= section.
 * @param {Array<PT>} payloadTypes - Payload Types
 * @param {string} section - Given m= section
 * @returns {string} - Updated m= section
 */ function setPayloadTypesInMediaSection(payloadTypes, section) {
    const lines = section.split('\r\n');
    let mLine = lines[0];
    const otherLines = lines.slice(1);
    mLine = mLine.replace(/([0-9]+\s?)+$/, payloadTypes.join(' '));
    return [
        mLine
    ].concat(otherLines).join('\r\n');
}
/**
 * Create a Map from PTs to codec names for the given m= section.
 * @param {string} mediaSection - The given m= section.
 * @returns {Map<PT, Codec>} ptToCodecName
 */ function createPtToCodecName(mediaSection) {
    return getPayloadTypesInMediaSection(mediaSection).reduce((ptToCodecName, pt)=>{
        const rtpmapPattern = new RegExp(`a=rtpmap:${pt} ([^/]+)`);
        const matches = mediaSection.match(rtpmapPattern);
        const codecName = matches ? matches[1].toLowerCase() : ptToFixedBitrateAudioCodecName[pt] ? ptToFixedBitrateAudioCodecName[pt].toLowerCase() : '';
        return ptToCodecName.set(pt, codecName);
    }, new Map());
}
/**
 * Get the Codec Payload Types present in the first line of the given m= section
 * @param {string} section - The m= section
 * @returns {Array<PT>} Payload Types
 */ function getPayloadTypesInMediaSection(section) {
    const mLine = section.split('\r\n')[0];
    // In "m=<kind> <port> <proto> <payload_type_1> <payload_type_2> ... <payload_type_n>",
    // the regex matches <port> and the PayloadTypes.
    const matches = mLine.match(/([0-9]+)/g);
    // This should not happen, but in case there are no PayloadTypes in
    // the m= line, return an empty array.
    if (!matches) return [];
    // Since only the PayloadTypes are needed, we discard the <port>.
    return matches.slice(1).map((match)=>parseInt(match, 10));
}

},{"../util":"j8qrE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LuWs":[function(require,module,exports,__globalThis) {
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
var SDPUtils = require("df8809996b144e1c");
function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
    var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : dtlsRole || 'active');
    sdp += 'a=mid:' + transceiver.mid + '\r\n';
    if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += 'a=sendrecv\r\n';
    else if (transceiver.rtpSender) sdp += 'a=sendonly\r\n';
    else if (transceiver.rtpReceiver) sdp += 'a=recvonly\r\n';
    else sdp += 'a=inactive\r\n';
    if (transceiver.rtpSender) {
        var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
        transceiver.rtpSender._initialTrackId = trackId;
        // spec.
        var msid = 'msid:' + (stream ? stream.id : '-') + ' ' + trackId + '\r\n';
        sdp += 'a=' + msid;
        // for Chrome. Legacy should no longer be required.
        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;
        // RTX
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
            sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
    return sdp;
}
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
    var hasTurn = false;
    iceServers = JSON.parse(JSON.stringify(iceServers));
    return iceServers.filter(function(server) {
        if (server && (server.urls || server.url)) {
            var urls = server.urls || server.url;
            if (server.url && !server.urls) console.warn('RTCIceServer.url is deprecated! Use urls instead.');
            var isString = typeof urls === 'string';
            if (isString) urls = [
                urls
            ];
            urls = urls.filter(function(url) {
                var validTurn = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !hasTurn;
                if (validTurn) {
                    hasTurn = true;
                    return true;
                }
                return url.indexOf('stun:') === 0 && edgeVersion >= 14393 && url.indexOf('?transport=udp') === -1;
            });
            delete server.url;
            server.urls = isString ? urls[0] : urls;
            return !!urls.length;
        }
    });
}
// Determines the intersection of local and remote capabilities.
function getCommonCapabilities(localCapabilities, remoteCapabilities) {
    var commonCapabilities = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: []
    };
    var findCodecByPayloadType = function(pt, codecs) {
        pt = parseInt(pt, 10);
        for(var i = 0; i < codecs.length; i++){
            if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) return codecs[i];
        }
    };
    var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
        var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
        var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
        return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
    };
    localCapabilities.codecs.forEach(function(lCodec) {
        for(var i = 0; i < remoteCapabilities.codecs.length; i++){
            var rCodec = remoteCapabilities.codecs[i];
            if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
                if (lCodec.name.toLowerCase() === 'rtx' && lCodec.parameters && rCodec.parameters.apt) {
                    // for RTX we need to find the local rtx that has a apt
                    // which points to the same local codec as the remote one.
                    if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) continue;
                }
                rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
                // number of channels is the highest common number of channels
                rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels);
                // push rCodec so we reply with offerer payload type
                commonCapabilities.codecs.push(rCodec);
                // determine common feedback mechanisms
                rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
                    for(var j = 0; j < lCodec.rtcpFeedback.length; j++){
                        if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) return true;
                    }
                    return false;
                });
                break;
            }
        }
    });
    localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
        for(var i = 0; i < remoteCapabilities.headerExtensions.length; i++){
            var rHeaderExtension = remoteCapabilities.headerExtensions[i];
            if (lHeaderExtension.uri === rHeaderExtension.uri) {
                commonCapabilities.headerExtensions.push(rHeaderExtension);
                break;
            }
        }
    });
    // FIXME: fecMechanisms
    return commonCapabilities;
}
// is action=setLocalDescription with type allowed in signalingState
function isActionAllowedInSignalingState(action, type, signalingState) {
    return ({
        offer: {
            setLocalDescription: [
                'stable',
                'have-local-offer'
            ],
            setRemoteDescription: [
                'stable',
                'have-remote-offer'
            ]
        },
        answer: {
            setLocalDescription: [
                'have-remote-offer',
                'have-local-pranswer'
            ],
            setRemoteDescription: [
                'have-local-offer',
                'have-remote-pranswer'
            ]
        }
    })[type][action].indexOf(signalingState) !== -1;
}
function maybeAddCandidate(iceTransport, candidate) {
    // Edge's internal representation adds some fields therefore
    // not all fieldѕ are taken into account.
    var alreadyAdded = iceTransport.getRemoteCandidates().find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
    });
    if (!alreadyAdded) iceTransport.addRemoteCandidate(candidate);
    return !alreadyAdded;
}
function makeError(name, description) {
    var e = new Error(description);
    e.name = name;
    return e;
}
module.exports = function(window, edgeVersion) {
    // https://w3c.github.io/mediacapture-main/#mediastream
    // Helper function to add the track to the stream and
    // dispatch the event ourselves.
    function addTrackToStreamAndFireEvent(track, stream) {
        stream.addTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack', {
            track: track
        }));
    }
    function removeTrackFromStreamAndFireEvent(track, stream) {
        stream.removeTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack', {
            track: track
        }));
    }
    function fireAddTrack(pc, track, receiver, streams) {
        var trackEvent = new Event('track');
        trackEvent.track = track;
        trackEvent.receiver = receiver;
        trackEvent.transceiver = {
            receiver: receiver
        };
        trackEvent.streams = streams;
        window.setTimeout(function() {
            pc._dispatchEvent('track', trackEvent);
        });
    }
    var RTCPeerConnection = function(config) {
        var pc = this;
        var _eventTarget = document.createDocumentFragment();
        [
            'addEventListener',
            'removeEventListener',
            'dispatchEvent'
        ].forEach(function(method) {
            pc[method] = _eventTarget[method].bind(_eventTarget);
        });
        this.canTrickleIceCandidates = null;
        this.needNegotiation = false;
        this.localStreams = [];
        this.remoteStreams = [];
        this.localDescription = null;
        this.remoteDescription = null;
        this.signalingState = 'stable';
        this.iceConnectionState = 'new';
        this.iceGatheringState = 'new';
        config = JSON.parse(JSON.stringify(config || {}));
        this.usingBundle = config.bundlePolicy === 'max-bundle';
        if (config.rtcpMuxPolicy === 'negotiate') throw makeError('NotSupportedError', 'rtcpMuxPolicy \'negotiate\' is not supported');
        else if (!config.rtcpMuxPolicy) config.rtcpMuxPolicy = 'require';
        switch(config.iceTransportPolicy){
            case 'all':
            case 'relay':
                break;
            default:
                config.iceTransportPolicy = 'all';
                break;
        }
        switch(config.bundlePolicy){
            case 'balanced':
            case 'max-compat':
            case 'max-bundle':
                break;
            default:
                config.bundlePolicy = 'balanced';
                break;
        }
        config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);
        this._iceGatherers = [];
        if (config.iceCandidatePoolSize) for(var i = config.iceCandidatePoolSize; i > 0; i--)this._iceGatherers.push(new window.RTCIceGatherer({
            iceServers: config.iceServers,
            gatherPolicy: config.iceTransportPolicy
        }));
        else config.iceCandidatePoolSize = 0;
        this._config = config;
        // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
        // everything that is needed to describe a SDP m-line.
        this.transceivers = [];
        this._sdpSessionId = SDPUtils.generateSessionId();
        this._sdpSessionVersion = 0;
        this._dtlsRole = undefined; // role for a=setup to use in answers.
        this._isClosed = false;
    };
    // set up event handlers on prototype
    RTCPeerConnection.prototype.onicecandidate = null;
    RTCPeerConnection.prototype.onaddstream = null;
    RTCPeerConnection.prototype.ontrack = null;
    RTCPeerConnection.prototype.onremovestream = null;
    RTCPeerConnection.prototype.onsignalingstatechange = null;
    RTCPeerConnection.prototype.oniceconnectionstatechange = null;
    RTCPeerConnection.prototype.onicegatheringstatechange = null;
    RTCPeerConnection.prototype.onnegotiationneeded = null;
    RTCPeerConnection.prototype.ondatachannel = null;
    RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
        if (this._isClosed) return;
        this.dispatchEvent(event);
        if (typeof this['on' + name] === 'function') this['on' + name](event);
    };
    RTCPeerConnection.prototype._emitGatheringStateChange = function() {
        var event = new Event('icegatheringstatechange');
        this._dispatchEvent('icegatheringstatechange', event);
    };
    RTCPeerConnection.prototype.getConfiguration = function() {
        return this._config;
    };
    RTCPeerConnection.prototype.getLocalStreams = function() {
        return this.localStreams;
    };
    RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this.remoteStreams;
    };
    // internal helper to create a transceiver object.
    // (whih is not yet the same as the WebRTC 1.0 transceiver)
    RTCPeerConnection.prototype._createTransceiver = function(kind) {
        var hasBundleTransport = this.transceivers.length > 0;
        var transceiver = {
            track: null,
            iceGatherer: null,
            iceTransport: null,
            dtlsTransport: null,
            localCapabilities: null,
            remoteCapabilities: null,
            rtpSender: null,
            rtpReceiver: null,
            kind: kind,
            mid: null,
            sendEncodingParameters: null,
            recvEncodingParameters: null,
            stream: null,
            associatedRemoteMediaStreams: [],
            wantReceive: true
        };
        if (this.usingBundle && hasBundleTransport) {
            transceiver.iceTransport = this.transceivers[0].iceTransport;
            transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
        } else {
            var transports = this._createIceAndDtlsTransports();
            transceiver.iceTransport = transports.iceTransport;
            transceiver.dtlsTransport = transports.dtlsTransport;
        }
        this.transceivers.push(transceiver);
        return transceiver;
    };
    RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (this._isClosed) throw makeError('InvalidStateError', 'Attempted to call addTrack on a closed peerconnection.');
        var alreadyExists = this.transceivers.find(function(s) {
            return s.track === track;
        });
        if (alreadyExists) throw makeError('InvalidAccessError', 'Track already exists.');
        var transceiver;
        for(var i = 0; i < this.transceivers.length; i++)if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) transceiver = this.transceivers[i];
        if (!transceiver) transceiver = this._createTransceiver(track.kind);
        this._maybeFireNegotiationNeeded();
        if (this.localStreams.indexOf(stream) === -1) this.localStreams.push(stream);
        transceiver.track = track;
        transceiver.stream = stream;
        transceiver.rtpSender = new window.RTCRtpSender(track, transceiver.dtlsTransport);
        return transceiver.rtpSender;
    };
    RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        if (edgeVersion >= 15025) stream.getTracks().forEach(function(track) {
            pc.addTrack(track, stream);
        });
        else {
            // Clone is necessary for local demos mostly, attaching directly
            // to two different senders does not work (build 10547).
            // Fixed in 15025 (or earlier)
            var clonedStream = stream.clone();
            stream.getTracks().forEach(function(track, idx) {
                var clonedTrack = clonedStream.getTracks()[idx];
                track.addEventListener('enabled', function(event) {
                    clonedTrack.enabled = event.enabled;
                });
            });
            clonedStream.getTracks().forEach(function(track) {
                pc.addTrack(track, clonedStream);
            });
        }
    };
    RTCPeerConnection.prototype.removeTrack = function(sender) {
        if (this._isClosed) throw makeError('InvalidStateError', 'Attempted to call removeTrack on a closed peerconnection.');
        if (!(sender instanceof window.RTCRtpSender)) throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
        var transceiver = this.transceivers.find(function(t) {
            return t.rtpSender === sender;
        });
        if (!transceiver) throw makeError('InvalidAccessError', 'Sender was not created by this connection.');
        var stream = transceiver.stream;
        transceiver.rtpSender.stop();
        transceiver.rtpSender = null;
        transceiver.track = null;
        transceiver.stream = null;
        // remove the stream from the set of local streams
        var localStreams = this.transceivers.map(function(t) {
            return t.stream;
        });
        if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) this.localStreams.splice(this.localStreams.indexOf(stream), 1);
        this._maybeFireNegotiationNeeded();
    };
    RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        stream.getTracks().forEach(function(track) {
            var sender = pc.getSenders().find(function(s) {
                return s.track === track;
            });
            if (sender) pc.removeTrack(sender);
        });
    };
    RTCPeerConnection.prototype.getSenders = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpSender;
        }).map(function(transceiver) {
            return transceiver.rtpSender;
        });
    };
    RTCPeerConnection.prototype.getReceivers = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpReceiver;
        }).map(function(transceiver) {
            return transceiver.rtpReceiver;
        });
    };
    RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex, usingBundle) {
        var pc = this;
        if (usingBundle && sdpMLineIndex > 0) return this.transceivers[0].iceGatherer;
        else if (this._iceGatherers.length) return this._iceGatherers.shift();
        var iceGatherer = new window.RTCIceGatherer({
            iceServers: this._config.iceServers,
            gatherPolicy: this._config.iceTransportPolicy
        });
        Object.defineProperty(iceGatherer, 'state', {
            value: 'new',
            writable: true
        });
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
        this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
            var end = !event.candidate || Object.keys(event.candidate).length === 0;
            // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            iceGatherer.state = end ? 'completed' : 'gathering';
            if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
        };
        iceGatherer.addEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);
        return iceGatherer;
    };
    // start gathering from an RTCIceGatherer.
    RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
        var pc = this;
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer.onlocalcandidate) return;
        var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
        iceGatherer.removeEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);
        iceGatherer.onlocalcandidate = function(evt) {
            if (pc.usingBundle && sdpMLineIndex > 0) // if we know that we use bundle we can drop candidates with
            // ѕdpMLineIndex > 0. If we don't do this then our state gets
            // confused since we dispose the extra ice gatherer.
            return;
            var event = new Event('icecandidate');
            event.candidate = {
                sdpMid: mid,
                sdpMLineIndex: sdpMLineIndex
            };
            var cand = evt.candidate;
            // Edge emits an empty object for RTCIceCandidateComplete‥
            var end = !cand || Object.keys(cand).length === 0;
            if (end) // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            {
                if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') iceGatherer.state = 'completed';
            } else {
                if (iceGatherer.state === 'new') iceGatherer.state = 'gathering';
                // RTCIceCandidate doesn't have a component, needs to be added
                cand.component = 1;
                var serializedCandidate = SDPUtils.writeCandidate(cand);
                event.candidate = Object.assign(event.candidate, SDPUtils.parseCandidate(serializedCandidate));
                event.candidate.candidate = serializedCandidate;
            }
            // update local description.
            var sections = SDPUtils.getMediaSections(pc.localDescription.sdp);
            if (!end) sections[event.candidate.sdpMLineIndex] += 'a=' + event.candidate.candidate + '\r\n';
            else sections[event.candidate.sdpMLineIndex] += 'a=end-of-candidates\r\n';
            pc.localDescription.sdp = SDPUtils.getDescription(pc.localDescription.sdp) + sections.join('');
            var complete = pc.transceivers.every(function(transceiver) {
                return transceiver.iceGatherer && transceiver.iceGatherer.state === 'completed';
            });
            if (pc.iceGatheringState !== 'gathering') {
                pc.iceGatheringState = 'gathering';
                pc._emitGatheringStateChange();
            }
            // Emit candidate. Also emit null candidate when all gatherers are
            // complete.
            if (!end) pc._dispatchEvent('icecandidate', event);
            if (complete) {
                pc._dispatchEvent('icecandidate', new Event('icecandidate'));
                pc.iceGatheringState = 'complete';
                pc._emitGatheringStateChange();
            }
        };
        // emit already gathered candidates.
        window.setTimeout(function() {
            bufferedCandidateEvents.forEach(function(e) {
                iceGatherer.onlocalcandidate(e);
            });
        }, 0);
    };
    // Create ICE transport and DTLS transport.
    RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
        var pc = this;
        var iceTransport = new window.RTCIceTransport(null);
        iceTransport.onicestatechange = function() {
            pc._updateConnectionState();
        };
        var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
        dtlsTransport.ondtlsstatechange = function() {
            pc._updateConnectionState();
        };
        dtlsTransport.onerror = function() {
            // onerror does not set state to failed by itself.
            Object.defineProperty(dtlsTransport, 'state', {
                value: 'failed',
                writable: true
            });
            pc._updateConnectionState();
        };
        return {
            iceTransport: iceTransport,
            dtlsTransport: dtlsTransport
        };
    };
    // Destroy ICE gatherer, ICE transport and DTLS transport.
    // Without triggering the callbacks.
    RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(sdpMLineIndex) {
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer) {
            delete iceGatherer.onlocalcandidate;
            delete this.transceivers[sdpMLineIndex].iceGatherer;
        }
        var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
        if (iceTransport) {
            delete iceTransport.onicestatechange;
            delete this.transceivers[sdpMLineIndex].iceTransport;
        }
        var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
        if (dtlsTransport) {
            delete dtlsTransport.ondtlsstatechange;
            delete dtlsTransport.onerror;
            delete this.transceivers[sdpMLineIndex].dtlsTransport;
        }
    };
    // Start the RTP Sender and Receiver for a transceiver.
    RTCPeerConnection.prototype._transceive = function(transceiver, send, recv) {
        var params = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
        if (send && transceiver.rtpSender) {
            params.encodings = transceiver.sendEncodingParameters;
            params.rtcp = {
                cname: SDPUtils.localCName,
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.recvEncodingParameters.length) params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
            transceiver.rtpSender.send(params);
        }
        if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
            // remove RTX field in Edge 14942
            if (transceiver.kind === 'video' && transceiver.recvEncodingParameters && edgeVersion < 15019) transceiver.recvEncodingParameters.forEach(function(p) {
                delete p.rtx;
            });
            if (transceiver.recvEncodingParameters.length) params.encodings = transceiver.recvEncodingParameters;
            else params.encodings = [
                {}
            ];
            params.rtcp = {
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.rtcpParameters.cname) params.rtcp.cname = transceiver.rtcpParameters.cname;
            if (transceiver.sendEncodingParameters.length) params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
            transceiver.rtpReceiver.receive(params);
        }
    };
    RTCPeerConnection.prototype.setLocalDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            'offer',
            'answer'
        ].indexOf(description.type) === -1) return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
        if (!isActionAllowedInSignalingState('setLocalDescription', description.type, pc.signalingState) || pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not set local ' + description.type + ' in state ' + pc.signalingState));
        var sections;
        var sessionpart;
        if (description.type === 'offer') {
            // VERY limited support for SDP munging. Limited to:
            // * changing the order of codecs
            sections = SDPUtils.splitSections(description.sdp);
            sessionpart = sections.shift();
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var caps = SDPUtils.parseRtpParameters(mediaSection);
                pc.transceivers[sdpMLineIndex].localCapabilities = caps;
            });
            pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                pc._gather(transceiver.mid, sdpMLineIndex);
            });
        } else if (description.type === 'answer') {
            sections = SDPUtils.splitSections(pc.remoteDescription.sdp);
            sessionpart = sections.shift();
            var isIceLite = SDPUtils.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var transceiver = pc.transceivers[sdpMLineIndex];
                var iceGatherer = transceiver.iceGatherer;
                var iceTransport = transceiver.iceTransport;
                var dtlsTransport = transceiver.dtlsTransport;
                var localCapabilities = transceiver.localCapabilities;
                var remoteCapabilities = transceiver.remoteCapabilities;
                // treat bundle-only as not-rejected.
                var rejected = SDPUtils.isRejected(mediaSection) && SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
                if (!rejected && !transceiver.isDatachannel) {
                    var remoteIceParameters = SDPUtils.getIceParameters(mediaSection, sessionpart);
                    var remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection, sessionpart);
                    if (isIceLite) remoteDtlsParameters.role = 'server';
                    if (!pc.usingBundle || sdpMLineIndex === 0) {
                        pc._gather(transceiver.mid, sdpMLineIndex);
                        if (iceTransport.state === 'new') iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? 'controlling' : 'controlled');
                        if (dtlsTransport.state === 'new') dtlsTransport.start(remoteDtlsParameters);
                    }
                    // Calculate intersection of capabilities.
                    var params = getCommonCapabilities(localCapabilities, remoteCapabilities);
                    // Start the RTCRtpSender. The RTCRtpReceiver for this
                    // transceiver has already been started in setRemoteDescription.
                    pc._transceive(transceiver, params.codecs.length > 0, false);
                }
            });
        }
        pc.localDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === 'offer') pc._updateSignalingState('have-local-offer');
        else pc._updateSignalingState('stable');
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.setRemoteDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            'offer',
            'answer'
        ].indexOf(description.type) === -1) return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
        if (!isActionAllowedInSignalingState('setRemoteDescription', description.type, pc.signalingState) || pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not set remote ' + description.type + ' in state ' + pc.signalingState));
        var streams = {};
        pc.remoteStreams.forEach(function(stream) {
            streams[stream.id] = stream;
        });
        var receiverList = [];
        var sections = SDPUtils.splitSections(description.sdp);
        var sessionpart = sections.shift();
        var isIceLite = SDPUtils.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
        var usingBundle = SDPUtils.matchPrefix(sessionpart, 'a=group:BUNDLE ').length > 0;
        pc.usingBundle = usingBundle;
        var iceOptions = SDPUtils.matchPrefix(sessionpart, 'a=ice-options:')[0];
        if (iceOptions) pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ').indexOf('trickle') >= 0;
        else pc.canTrickleIceCandidates = false;
        sections.forEach(function(mediaSection, sdpMLineIndex) {
            var lines = SDPUtils.splitLines(mediaSection);
            var kind = SDPUtils.getKind(mediaSection);
            // treat bundle-only as not-rejected.
            var rejected = SDPUtils.isRejected(mediaSection) && SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
            var protocol = lines[0].substr(2).split(' ')[2];
            var direction = SDPUtils.getDirection(mediaSection, sessionpart);
            var remoteMsid = SDPUtils.parseMsid(mediaSection);
            var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();
            // Reject datachannels which are not implemented yet.
            if (kind === 'application' && protocol === 'DTLS/SCTP') {
                pc.transceivers[sdpMLineIndex] = {
                    mid: mid,
                    isDatachannel: true
                };
                return;
            }
            var transceiver;
            var iceGatherer;
            var iceTransport;
            var dtlsTransport;
            var rtpReceiver;
            var sendEncodingParameters;
            var recvEncodingParameters;
            var localCapabilities;
            var track;
            // FIXME: ensure the mediaSection has rtcp-mux set.
            var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
            var remoteIceParameters;
            var remoteDtlsParameters;
            if (!rejected) {
                remoteIceParameters = SDPUtils.getIceParameters(mediaSection, sessionpart);
                remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection, sessionpart);
                remoteDtlsParameters.role = 'client';
            }
            recvEncodingParameters = SDPUtils.parseRtpEncodingParameters(mediaSection);
            var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);
            var isComplete = SDPUtils.matchPrefix(mediaSection, 'a=end-of-candidates', sessionpart).length > 0;
            var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:').map(function(cand) {
                return SDPUtils.parseCandidate(cand);
            }).filter(function(cand) {
                return cand.component === 1;
            });
            // Check if we can use BUNDLE and dispose transports.
            if ((description.type === 'offer' || description.type === 'answer') && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
                pc._disposeIceAndDtlsTransports(sdpMLineIndex);
                pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
                pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
                pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;
                if (pc.transceivers[sdpMLineIndex].rtpSender) pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
                if (pc.transceivers[sdpMLineIndex].rtpReceiver) pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
            }
            if (description.type === 'offer' && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
                transceiver.mid = mid;
                if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
                if (cands.length && transceiver.iceTransport.state === 'new') {
                    if (isComplete && (!usingBundle || sdpMLineIndex === 0)) transceiver.iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);
                // filter RTX until additional stuff needed for RTX is implemented
                // in adapter.js
                if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                    return codec.name !== 'rtx';
                });
                sendEncodingParameters = transceiver.sendEncodingParameters || [
                    {
                        ssrc: (2 * sdpMLineIndex + 2) * 1001
                    }
                ];
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                var isNewTrack = false;
                if (direction === 'sendrecv' || direction === 'sendonly') {
                    isNewTrack = !transceiver.rtpReceiver;
                    rtpReceiver = transceiver.rtpReceiver || new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                    if (isNewTrack) {
                        var stream;
                        track = rtpReceiver.track;
                        // FIXME: does not work with Plan B.
                        if (remoteMsid && remoteMsid.stream === '-') ;
                        else if (remoteMsid) {
                            if (!streams[remoteMsid.stream]) {
                                streams[remoteMsid.stream] = new window.MediaStream();
                                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                                    get: function() {
                                        return remoteMsid.stream;
                                    }
                                });
                            }
                            Object.defineProperty(track, 'id', {
                                get: function() {
                                    return remoteMsid.track;
                                }
                            });
                            stream = streams[remoteMsid.stream];
                        } else {
                            if (!streams.default) streams.default = new window.MediaStream();
                            stream = streams.default;
                        }
                        if (stream) {
                            addTrackToStreamAndFireEvent(track, stream);
                            transceiver.associatedRemoteMediaStreams.push(stream);
                        }
                        receiverList.push([
                            track,
                            rtpReceiver,
                            stream
                        ]);
                    }
                } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
                    transceiver.associatedRemoteMediaStreams.forEach(function(s) {
                        var nativeTrack = s.getTracks().find(function(t) {
                            return t.id === transceiver.rtpReceiver.track.id;
                        });
                        if (nativeTrack) removeTrackFromStreamAndFireEvent(nativeTrack, s);
                    });
                    transceiver.associatedRemoteMediaStreams = [];
                }
                transceiver.localCapabilities = localCapabilities;
                transceiver.remoteCapabilities = remoteCapabilities;
                transceiver.rtpReceiver = rtpReceiver;
                transceiver.rtcpParameters = rtcpParameters;
                transceiver.sendEncodingParameters = sendEncodingParameters;
                transceiver.recvEncodingParameters = recvEncodingParameters;
                // Start the RTCRtpReceiver now. The RTPSender is started in
                // setLocalDescription.
                pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
            } else if (description.type === 'answer' && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex];
                iceGatherer = transceiver.iceGatherer;
                iceTransport = transceiver.iceTransport;
                dtlsTransport = transceiver.dtlsTransport;
                rtpReceiver = transceiver.rtpReceiver;
                sendEncodingParameters = transceiver.sendEncodingParameters;
                localCapabilities = transceiver.localCapabilities;
                pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
                pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
                pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
                if (cands.length && iceTransport.state === 'new') {
                    if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                if (!usingBundle || sdpMLineIndex === 0) {
                    if (iceTransport.state === 'new') iceTransport.start(iceGatherer, remoteIceParameters, 'controlling');
                    if (dtlsTransport.state === 'new') dtlsTransport.start(remoteDtlsParameters);
                }
                pc._transceive(transceiver, direction === 'sendrecv' || direction === 'recvonly', direction === 'sendrecv' || direction === 'sendonly');
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                if (rtpReceiver && (direction === 'sendrecv' || direction === 'sendonly')) {
                    track = rtpReceiver.track;
                    if (remoteMsid) {
                        if (!streams[remoteMsid.stream]) streams[remoteMsid.stream] = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams[remoteMsid.stream]
                        ]);
                    } else {
                        if (!streams.default) streams.default = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams.default);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams.default
                        ]);
                    }
                } else // FIXME: actually the receiver should be created later.
                delete transceiver.rtpReceiver;
            }
        });
        if (pc._dtlsRole === undefined) pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
        pc.remoteDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === 'offer') pc._updateSignalingState('have-remote-offer');
        else pc._updateSignalingState('stable');
        Object.keys(streams).forEach(function(sid) {
            var stream = streams[sid];
            if (stream.getTracks().length) {
                if (pc.remoteStreams.indexOf(stream) === -1) {
                    pc.remoteStreams.push(stream);
                    var event = new Event('addstream');
                    event.stream = stream;
                    window.setTimeout(function() {
                        pc._dispatchEvent('addstream', event);
                    });
                }
                receiverList.forEach(function(item) {
                    var track = item[0];
                    var receiver = item[1];
                    if (stream.id !== item[2].id) return;
                    fireAddTrack(pc, track, receiver, [
                        stream
                    ]);
                });
            }
        });
        receiverList.forEach(function(item) {
            if (item[2]) return;
            fireAddTrack(pc, item[0], item[1], []);
        });
        // check whether addIceCandidate({}) was called within four seconds after
        // setRemoteDescription.
        window.setTimeout(function() {
            if (!(pc && pc.transceivers)) return;
            pc.transceivers.forEach(function(transceiver) {
                if (transceiver.iceTransport && transceiver.iceTransport.state === 'new' && transceiver.iceTransport.getRemoteCandidates().length > 0) {
                    console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification");
                    transceiver.iceTransport.addRemoteCandidate({});
                }
            });
        }, 4000);
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.close = function() {
        this.transceivers.forEach(function(transceiver) {
            /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */ if (transceiver.iceTransport) transceiver.iceTransport.stop();
            if (transceiver.dtlsTransport) transceiver.dtlsTransport.stop();
            if (transceiver.rtpSender) transceiver.rtpSender.stop();
            if (transceiver.rtpReceiver) transceiver.rtpReceiver.stop();
        });
        // FIXME: clean up tracks, local streams, remote streams, etc
        this._isClosed = true;
        this._updateSignalingState('closed');
    };
    // Update the signaling state.
    RTCPeerConnection.prototype._updateSignalingState = function(newState) {
        this.signalingState = newState;
        var event = new Event('signalingstatechange');
        this._dispatchEvent('signalingstatechange', event);
    };
    // Determine whether to fire the negotiationneeded event.
    RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
        var pc = this;
        if (this.signalingState !== 'stable' || this.needNegotiation === true) return;
        this.needNegotiation = true;
        window.setTimeout(function() {
            if (pc.needNegotiation) {
                pc.needNegotiation = false;
                var event = new Event('negotiationneeded');
                pc._dispatchEvent('negotiationneeded', event);
            }
        }, 0);
    };
    // Update the connection state.
    RTCPeerConnection.prototype._updateConnectionState = function() {
        var newState;
        var states = {
            'new': 0,
            closed: 0,
            connecting: 0,
            checking: 0,
            connected: 0,
            completed: 0,
            disconnected: 0,
            failed: 0
        };
        this.transceivers.forEach(function(transceiver) {
            states[transceiver.iceTransport.state]++;
            states[transceiver.dtlsTransport.state]++;
        });
        // ICETransport.completed and connected are the same for this purpose.
        states.connected += states.completed;
        newState = 'new';
        if (states.failed > 0) newState = 'failed';
        else if (states.connecting > 0 || states.checking > 0) newState = 'connecting';
        else if (states.disconnected > 0) newState = 'disconnected';
        else if (states.new > 0) newState = 'new';
        else if (states.connected > 0 || states.completed > 0) newState = 'connected';
        if (newState !== this.iceConnectionState) {
            this.iceConnectionState = newState;
            var event = new Event('iceconnectionstatechange');
            this._dispatchEvent('iceconnectionstatechange', event);
        }
    };
    RTCPeerConnection.prototype.createOffer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not call createOffer after close'));
        var numAudioTracks = pc.transceivers.filter(function(t) {
            return t.kind === 'audio';
        }).length;
        var numVideoTracks = pc.transceivers.filter(function(t) {
            return t.kind === 'video';
        }).length;
        // Determine number of audio and video tracks we need to send/recv.
        var offerOptions = arguments[0];
        if (offerOptions) {
            // Reject Chrome legacy constraints.
            if (offerOptions.mandatory || offerOptions.optional) throw new TypeError('Legacy mandatory/optional constraints not supported.');
            if (offerOptions.offerToReceiveAudio !== undefined) {
                if (offerOptions.offerToReceiveAudio === true) numAudioTracks = 1;
                else if (offerOptions.offerToReceiveAudio === false) numAudioTracks = 0;
                else numAudioTracks = offerOptions.offerToReceiveAudio;
            }
            if (offerOptions.offerToReceiveVideo !== undefined) {
                if (offerOptions.offerToReceiveVideo === true) numVideoTracks = 1;
                else if (offerOptions.offerToReceiveVideo === false) numVideoTracks = 0;
                else numVideoTracks = offerOptions.offerToReceiveVideo;
            }
        }
        pc.transceivers.forEach(function(transceiver) {
            if (transceiver.kind === 'audio') {
                numAudioTracks--;
                if (numAudioTracks < 0) transceiver.wantReceive = false;
            } else if (transceiver.kind === 'video') {
                numVideoTracks--;
                if (numVideoTracks < 0) transceiver.wantReceive = false;
            }
        });
        // Create M-lines for recvonly streams.
        while(numAudioTracks > 0 || numVideoTracks > 0){
            if (numAudioTracks > 0) {
                pc._createTransceiver('audio');
                numAudioTracks--;
            }
            if (numVideoTracks > 0) {
                pc._createTransceiver('video');
                numVideoTracks--;
            }
        }
        var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            // For each track, create an ice gatherer, ice transport,
            // dtls transport, potentially rtpsender and rtpreceiver.
            var track = transceiver.track;
            var kind = transceiver.kind;
            var mid = transceiver.mid || SDPUtils.generateIdentifier();
            transceiver.mid = mid;
            if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
            var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
            // filter RTX until additional stuff needed for RTX is implemented
            // in adapter.js
            if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                return codec.name !== 'rtx';
            });
            localCapabilities.codecs.forEach(function(codec) {
                // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
                // by adding level-asymmetry-allowed=1
                if (codec.name === 'H264' && codec.parameters['level-asymmetry-allowed'] === undefined) codec.parameters['level-asymmetry-allowed'] = '1';
                // for subsequent offers, we might have to re-use the payload
                // type of the last offer.
                if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
                    if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) codec.preferredPayloadType = remoteCodec.payloadType;
                });
            });
            localCapabilities.headerExtensions.forEach(function(hdrExt) {
                var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
                remoteExtensions.forEach(function(rHdrExt) {
                    if (hdrExt.uri === rHdrExt.uri) hdrExt.id = rHdrExt.id;
                });
            });
            // generate an ssrc now, to be used later in rtpSender.send
            var sendEncodingParameters = transceiver.sendEncodingParameters || [
                {
                    ssrc: (2 * sdpMLineIndex + 1) * 1001
                }
            ];
            if (track) // add RTX
            {
                if (edgeVersion >= 15019 && kind === 'video' && !sendEncodingParameters[0].rtx) sendEncodingParameters[0].rtx = {
                    ssrc: sendEncodingParameters[0].ssrc + 1
                };
            }
            if (transceiver.wantReceive) transceiver.rtpReceiver = new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
            transceiver.localCapabilities = localCapabilities;
            transceiver.sendEncodingParameters = sendEncodingParameters;
        });
        // always offer BUNDLE and dispose on return if not supported.
        if (pc._config.bundlePolicy !== 'max-compat') sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(' ') + '\r\n';
        sdp += 'a=ice-options:trickle\r\n';
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            sdp += writeMediaSection(transceiver, transceiver.localCapabilities, 'offer', transceiver.stream, pc._dtlsRole);
            sdp += 'a=rtcp-rsize\r\n';
            if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' && (sdpMLineIndex === 0 || !pc.usingBundle)) {
                transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
                    cand.component = 1;
                    sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
                });
                if (transceiver.iceGatherer.state === 'completed') sdp += 'a=end-of-candidates\r\n';
            }
        });
        var desc = new window.RTCSessionDescription({
            type: 'offer',
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.createAnswer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject(makeError('InvalidStateError', 'Can not call createAnswer after close'));
        var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        if (pc.usingBundle) sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(' ') + '\r\n';
        var mediaSectionsInOffer = SDPUtils.getMediaSections(pc.remoteDescription.sdp).length;
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            if (sdpMLineIndex + 1 > mediaSectionsInOffer) return;
            if (transceiver.isDatachannel) {
                sdp += "m=application 0 DTLS/SCTP 5000\r\nc=IN IP4 0.0.0.0\r\na=mid:" + transceiver.mid + '\r\n';
                return;
            }
            // FIXME: look at direction.
            if (transceiver.stream) {
                var localTrack;
                if (transceiver.kind === 'audio') localTrack = transceiver.stream.getAudioTracks()[0];
                else if (transceiver.kind === 'video') localTrack = transceiver.stream.getVideoTracks()[0];
                if (localTrack) // add RTX
                {
                    if (edgeVersion >= 15019 && transceiver.kind === 'video' && !transceiver.sendEncodingParameters[0].rtx) transceiver.sendEncodingParameters[0].rtx = {
                        ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
                    };
                }
            }
            // Calculate intersection of capabilities.
            var commonCapabilities = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
            var hasRtx = commonCapabilities.codecs.filter(function(c) {
                return c.name.toLowerCase() === 'rtx';
            }).length;
            if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
            sdp += writeMediaSection(transceiver, commonCapabilities, 'answer', transceiver.stream, pc._dtlsRole);
            if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
        });
        var desc = new window.RTCSessionDescription({
            type: 'answer',
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
        var pc = this;
        var sections;
        if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
        // TODO: needs to go into ops queue.
        return new Promise(function(resolve, reject) {
            if (!pc.remoteDescription) return reject(makeError('InvalidStateError', 'Can not add ICE candidate without a remote description'));
            else if (!candidate || candidate.candidate === '') for(var j = 0; j < pc.transceivers.length; j++){
                if (pc.transceivers[j].isDatachannel) continue;
                pc.transceivers[j].iceTransport.addRemoteCandidate({});
                sections = SDPUtils.getMediaSections(pc.remoteDescription.sdp);
                sections[j] += 'a=end-of-candidates\r\n';
                pc.remoteDescription.sdp = SDPUtils.getDescription(pc.remoteDescription.sdp) + sections.join('');
                if (pc.usingBundle) break;
            }
            else {
                var sdpMLineIndex = candidate.sdpMLineIndex;
                if (candidate.sdpMid) {
                    for(var i = 0; i < pc.transceivers.length; i++)if (pc.transceivers[i].mid === candidate.sdpMid) {
                        sdpMLineIndex = i;
                        break;
                    }
                }
                var transceiver = pc.transceivers[sdpMLineIndex];
                if (transceiver) {
                    if (transceiver.isDatachannel) return resolve();
                    var cand = Object.keys(candidate.candidate).length > 0 ? SDPUtils.parseCandidate(candidate.candidate) : {};
                    // Ignore Chrome's invalid candidates since Edge does not like them.
                    if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) return resolve();
                    // Ignore RTCP candidates, we assume RTCP-MUX.
                    if (cand.component && cand.component !== 1) return resolve();
                    // when using bundle, avoid adding candidates to the wrong
                    // ice transport. And avoid adding candidates added in the SDP.
                    if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
                        if (!maybeAddCandidate(transceiver.iceTransport, cand)) return reject(makeError('OperationError', 'Can not add ICE candidate'));
                    }
                    // update the remoteDescription.
                    var candidateString = candidate.candidate.trim();
                    if (candidateString.indexOf('a=') === 0) candidateString = candidateString.substr(2);
                    sections = SDPUtils.getMediaSections(pc.remoteDescription.sdp);
                    sections[sdpMLineIndex] += 'a=' + (cand.type ? candidateString : 'end-of-candidates') + '\r\n';
                    pc.remoteDescription.sdp = sections.join('');
                } else return reject(makeError('OperationError', 'Can not add ICE candidate'));
            }
            resolve();
        });
    };
    RTCPeerConnection.prototype.getStats = function() {
        var promises = [];
        this.transceivers.forEach(function(transceiver) {
            [
                'rtpSender',
                'rtpReceiver',
                'iceGatherer',
                'iceTransport',
                'dtlsTransport'
            ].forEach(function(method) {
                if (transceiver[method]) promises.push(transceiver[method].getStats());
            });
        });
        var fixStatsType = function(stat) {
            return ({
                inboundrtp: 'inbound-rtp',
                outboundrtp: 'outbound-rtp',
                candidatepair: 'candidate-pair',
                localcandidate: 'local-candidate',
                remotecandidate: 'remote-candidate'
            })[stat.type] || stat.type;
        };
        return new Promise(function(resolve) {
            // shim getStats with maplike support
            var results = new Map();
            Promise.all(promises).then(function(res) {
                res.forEach(function(result) {
                    Object.keys(result).forEach(function(id) {
                        result[id].type = fixStatsType(result[id]);
                        results.set(id, result[id]);
                    });
                });
                resolve(results);
            });
        });
    };
    // legacy callback shims. Should be moved to adapter.js some days.
    var methods = [
        'createOffer',
        'createAnswer'
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[0] === 'function' || typeof args[1] === 'function') return nativeMethod.apply(this, [
                arguments[2]
            ]).then(function(description) {
                if (typeof args[0] === 'function') args[0].apply(null, [
                    description
                ]);
            }, function(error) {
                if (typeof args[1] === 'function') args[1].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    methods = [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === 'function' || typeof args[2] === 'function') return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === 'function') args[1].apply(null);
            }, function(error) {
                if (typeof args[2] === 'function') args[2].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    // getStats is special. It doesn't have a spec legacy method yet we support
    // getStats(something, cb) without error callbacks.
    [
        'getStats'
    ].forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === 'function') return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === 'function') args[1].apply(null);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    return RTCPeerConnection;
};

},{"df8809996b144e1c":"iQsUm"}],"iQsUm":[function(require,module,exports,__globalThis) {
/* eslint-env node */ 'use strict';
// SDP helpers.
var SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substr(2, 10);
};
// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
    return blob.trim().split('\n').map(function(line) {
        return line.trim();
    });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
    var parts = blob.split('\nm=');
    return parts.map(function(part, index) {
        return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
    });
};
// returns the session description.
SDPUtils.getDescription = function(blob) {
    var sections = SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// returns the individual media sections.
SDPUtils.getMediaSections = function(blob) {
    var sections = SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
    return SDPUtils.splitLines(blob).filter(function(line) {
        return line.indexOf(prefix) === 0;
    });
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
    var parts;
    // Parse both variants.
    if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
    else parts = line.substring(10).split(' ');
    var candidate = {
        foundation: parts[0],
        component: parseInt(parts[1], 10),
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(var i = 8; i < parts.length; i += 2)switch(parts[i]){
        case 'raddr':
            candidate.relatedAddress = parts[i + 1];
            break;
        case 'rport':
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case 'tcptype':
            candidate.tcpType = parts[i + 1];
            break;
        case 'ufrag':
            candidate.ufrag = parts[i + 1]; // for backward compability.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
    var sdp = [];
    sdp.push(candidate.foundation);
    sdp.push(candidate.component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    var type = candidate.type;
    sdp.push('typ');
    sdp.push(type);
    if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push('raddr');
        sdp.push(candidate.relatedAddress);
        sdp.push('rport');
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
        sdp.push('tcptype');
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push('ufrag');
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return 'candidate:' + sdp.join(' ');
};
// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
    return line.substr(14).split(' ');
};
// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
    var parts = line.substr(9).split(' ');
    var parsed = {
        payloadType: parseInt(parts.shift(), 10) // was: id
    };
    parts = parts[0].split('/');
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    var channels = codec.channels || codec.numChannels || 1;
    return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
};
// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
    var parts = line.substr(9).split(' ');
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
        uri: parts[1]
    };
};
// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
    return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + '\r\n';
};
// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
    var parsed = {};
    var kv;
    var parts = line.substr(line.indexOf(' ') + 1).split(';');
    for(var j = 0; j < parts.length; j++){
        kv = parts[j].trim().split('=');
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
    var line = '';
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        var params = [];
        Object.keys(codec.parameters).forEach(function(param) {
            if (codec.parameters[param]) params.push(param + '=' + codec.parameters[param]);
            else params.push(param);
        });
        line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
    }
    return line;
};
// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
    var parts = line.substr(line.indexOf(' ') + 1).split(' ');
    return {
        type: parts.shift(),
        parameter: parts.join(' ')
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
    var lines = '';
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
        lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
    });
    return lines;
};
// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
    var sp = line.indexOf(' ');
    var parts = {
        ssrc: parseInt(line.substr(7, sp - 7), 10)
    };
    var colon = line.indexOf(':', sp);
    if (colon > -1) {
        parts.attribute = line.substr(sp + 1, colon - sp - 1);
        parts.value = line.substr(colon + 1);
    } else parts.attribute = line.substr(sp + 1);
    return parts;
};
SDPUtils.parseSsrcGroup = function(line) {
    var parts = line.substr(13).split(' ');
    return {
        semantics: parts.shift(),
        ssrcs: parts.map(function(ssrc) {
            return parseInt(ssrc, 10);
        })
    };
};
// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
    var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
    if (mid) return mid.substr(6);
};
SDPUtils.parseFingerprint = function(line) {
    var parts = line.substr(14).split(' ');
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1]
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
    // Note: a=setup line is ignored since we use the 'auto' role.
    // Note2: 'algorithm' is not case sensitive except in Edge.
    return {
        role: 'auto',
        fingerprints: lines.map(SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
    var sdp = 'a=setup:' + setupType + '\r\n';
    params.fingerprints.forEach(function(fp) {
        sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
SDPUtils.parseCryptoLine = function(line) {
    var parts = line.substr(9).split(' ');
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
SDPUtils.writeCryptoLine = function(parameters) {
    return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf('inline:') !== 0) return null;
    var parts = keyParams.substr(7).split('|');
    return {
        keyMethod: 'inline',
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
    };
};
SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
};
// Extracts all SDES paramters.
SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
    return lines.map(SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
    var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substr(12),
        password: pwd.substr(10)
    };
};
// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
    return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
};
// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
    var description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    var lines = SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(' ');
    for(var i = 3; i < mline.length; i++){
        var pt = mline[i];
        var rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
        if (rtpmapline) {
            var codec = SDPUtils.parseRtpMap(rtpmapline);
            var fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case 'RED':
                case 'ULPFEC':
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
        description.headerExtensions.push(SDPUtils.parseExtmap(line));
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
    var sdp = '';
    // Build the mline.
    sdp += 'm=' + kind + ' ';
    sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
    sdp += ' UDP/TLS/RTP/SAVPF ';
    sdp += caps.codecs.map(function(codec) {
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(' ') + '\r\n';
    sdp += 'c=IN IP4 0.0.0.0\r\n';
    sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach(function(codec) {
        sdp += SDPUtils.writeRtpMap(codec);
        sdp += SDPUtils.writeFmtp(codec);
        sdp += SDPUtils.writeRtcpFb(codec);
    });
    var maxptime = 0;
    caps.codecs.forEach(function(codec) {
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
    sdp += 'a=rtcp-mux\r\n';
    if (caps.headerExtensions) caps.headerExtensions.forEach(function(extension) {
        sdp += SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    var encodingParameters = [];
    var description = SDPUtils.parseRtpParameters(mediaSection);
    var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
    var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
    }).filter(function(parts) {
        return parts.attribute === 'cname';
    });
    var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    var secondarySsrc;
    var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map(function(line) {
        var parts = line.substr(17).split(' ');
        return parts.map(function(part) {
            return parseInt(part, 10);
        });
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach(function(codec) {
        if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
            var encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
    if (bandwidth.length) {
        if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substr(7), 10);
        else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substr(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach(function(params) {
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
    var rtcpParameters = {};
    // Gets the first SSRC. Note tha with RTX there might be multiple
    // SSRCs.
    var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
    }).filter(function(obj) {
        return obj.attribute === 'cname';
    })[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
    var parts;
    var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
    if (spec.length === 1) {
        parts = spec[0].substr(7).split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function(line) {
        return SDPUtils.parseSsrcMedia(line);
    }).filter(function(msidParts) {
        return msidParts.attribute === 'msid';
    });
    if (planB.length > 0) {
        parts = planB[0].value.split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
SDPUtils.parseSctpDescription = function(mediaSection) {
    var mline = SDPUtils.parseMLine(mediaSection);
    var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
    var maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substr(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
    if (sctpMapLines.length > 0) {
        var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0].substr(10).split(' ');
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
SDPUtils.writeSctpDescription = function(media, sctp) {
    var output = [];
    if (media.protocol !== 'DTLS/SCTP') output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctp-port:' + sctp.port + '\r\n'
    ];
    else output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
    if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
    return output.join('');
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 21);
};
// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    var sessionId;
    var version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = SDPUtils.generateSessionId();
    var user = sessUser || 'thisisadapterortc';
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
};
SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
    var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : 'active');
    sdp += 'a=mid:' + transceiver.mid + '\r\n';
    if (transceiver.direction) sdp += 'a=' + transceiver.direction + '\r\n';
    else if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += 'a=sendrecv\r\n';
    else if (transceiver.rtpSender) sdp += 'a=sendonly\r\n';
    else if (transceiver.rtpReceiver) sdp += 'a=recvonly\r\n';
    else sdp += 'a=inactive\r\n';
    if (transceiver.rtpSender) {
        // spec.
        var msid = 'msid:' + stream.id + ' ' + transceiver.rtpSender.track.id + '\r\n';
        sdp += 'a=' + msid;
        // for Chrome.
        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
            sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
    return sdp;
};
// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    var lines = SDPUtils.splitLines(mediaSection);
    for(var i = 0; i < lines.length; i++)switch(lines[i]){
        case 'a=sendrecv':
        case 'a=sendonly':
        case 'a=recvonly':
        case 'a=inactive':
            return lines[i].substr(2);
        default:
    }
    if (sessionpart) return SDPUtils.getDirection(sessionpart);
    return 'sendrecv';
};
SDPUtils.getKind = function(mediaSection) {
    var lines = SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(' ');
    return mline[0].substr(2);
};
SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(' ', 2)[1] === '0';
};
SDPUtils.parseMLine = function(mediaSection) {
    var lines = SDPUtils.splitLines(mediaSection);
    var parts = lines[0].substr(2).split(' ');
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(' ')
    };
};
SDPUtils.parseOLine = function(mediaSection) {
    var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
    var parts = line.substr(2).split(' ');
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== 'string' || blob.length === 0) return false;
    var lines = SDPUtils.splitLines(blob);
    for(var i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
module.exports = SDPUtils;

},{}],"7Q9pA":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("../errors");
var _util = require("../util");
function getUserMedia(constraints, options) {
    options = options || {};
    options.util = options.util || _util;
    options.navigator = options.navigator || (typeof navigator !== 'undefined' ? navigator : null);
    return new Promise((resolve, reject)=>{
        if (!options.navigator) throw new (0, _errors.NotSupportedError)('getUserMedia is not supported');
        switch('function'){
            case typeof (options.navigator.mediaDevices && options.navigator.mediaDevices.getUserMedia):
                return resolve(options.navigator.mediaDevices.getUserMedia(constraints));
            case typeof options.navigator.webkitGetUserMedia:
                return options.navigator.webkitGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.mozGetUserMedia:
                return options.navigator.mozGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.getUserMedia:
                return options.navigator.getUserMedia(constraints, resolve, reject);
            default:
                throw new (0, _errors.NotSupportedError)('getUserMedia is not supported');
        }
    }).catch((e)=>{
        throw options.util.isFirefox() && e.name === 'NotReadableError' ? new (0, _errors.NotSupportedError)("Firefox does not currently support opening multiple audio input trackssimultaneously, even across different tabs.\nRelated Bugzilla thread: https://bugzilla.mozilla.org/show_bug.cgi?id=1299324") : e;
    });
}
exports.default = getUserMedia;

},{"../errors":"caXI8","../util":"j8qrE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EN1zf":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncQueue = require("./asyncQueue");
var _audioplayer = require("./audioplayer/audioplayer");
var _audioplayerDefault = parcelHelpers.interopDefault(_audioplayer);
var _errors = require("./errors");
/**
 * @class
 * @param {string} name - Name of the sound
 * @param {string} url - URL of the sound
 * @param {Sound#ConstructorOptions} options
 * @property {boolean} isPlaying - Whether the Sound is currently playing audio.
 * @property {string} name - Name of the sound
 * @property {string} url - URL of the sound
 * @property {AudioContext} audioContext - The AudioContext to use if available for AudioPlayer.
 */ /**
 * @typedef {Object} Sound#ConstructorOptions
 * @property {number} [maxDuration=0] - The maximum length of time to play the sound
 *   before stopping it.
 * @property {Boolean} [shouldLoop=false] - Whether the sound should be looped.
 */ function Sound(name, url, options) {
    if (!(this instanceof Sound)) return new Sound(name, url, options);
    if (!name || !url) throw new (0, _errors.InvalidArgumentError)('name and url are required arguments');
    options = Object.assign({
        AudioFactory: typeof Audio !== 'undefined' ? Audio : null,
        maxDuration: 0,
        shouldLoop: false
    }, options);
    options.AudioPlayer = options.audioContext ? (0, _audioplayerDefault.default).bind((0, _audioplayerDefault.default), options.audioContext) : options.AudioFactory;
    Object.defineProperties(this, {
        _Audio: {
            value: options.AudioPlayer
        },
        _activeEls: {
            value: new Map()
        },
        _isSinkSupported: {
            value: options.AudioFactory !== null && typeof options.AudioFactory.prototype.setSinkId === 'function'
        },
        _maxDuration: {
            value: options.maxDuration
        },
        _maxDurationTimeout: {
            value: null,
            writable: true
        },
        _operations: {
            value: new (0, _asyncQueue.AsyncQueue)()
        },
        _playPromise: {
            value: null,
            writable: true
        },
        _shouldLoop: {
            value: options.shouldLoop
        },
        _sinkIds: {
            value: [
                'default'
            ]
        },
        isPlaying: {
            enumerable: true,
            get () {
                return !!this._playPromise;
            }
        },
        name: {
            enumerable: true,
            value: name
        },
        url: {
            enumerable: true,
            value: url
        }
    });
    if (this._Audio) // Play it (muted and should not loop) as soon as possible so that it does not get incorrectly caught by Chrome's
    // "gesture requirement for media playback" feature.
    // https://plus.google.com/+FrancoisBeaufort/posts/6PiJQqJzGqX
    this._play(true, false);
}
function destroyAudioElement(audioElement) {
    if (audioElement) {
        audioElement.pause();
        audioElement.src = '';
        audioElement.srcObject = null;
        audioElement.load();
    }
}
/**
 * Plays the audio element that was initialized using the speficied sinkId
 */ Sound.prototype._playAudioElement = function _playAudioElement(sinkId, isMuted, shouldLoop) {
    const audioElement = this._activeEls.get(sinkId);
    if (!audioElement) throw new (0, _errors.InvalidArgumentError)(`sinkId: "${sinkId}" doesn't have an audio element`);
    audioElement.muted = !!isMuted;
    audioElement.loop = !!shouldLoop;
    return audioElement.play().then(()=>audioElement).catch((reason)=>{
        destroyAudioElement(audioElement);
        this._activeEls.delete(sinkId);
        throw reason;
    });
};
/**
 * Start playing the sound. Will stop the currently playing sound first.
 * If it exists, the audio element that was initialized for the sinkId will be used
 */ Sound.prototype._play = function _play(forceIsMuted, forceShouldLoop) {
    if (this.isPlaying) this._stop();
    if (this._maxDuration > 0) this._maxDurationTimeout = setTimeout(this._stop.bind(this), this._maxDuration);
    forceShouldLoop = typeof forceShouldLoop === 'boolean' ? forceShouldLoop : this._shouldLoop;
    const self = this;
    const playPromise = this._playPromise = Promise.all(this._sinkIds.map(function createAudioElement(sinkId) {
        if (!self._Audio) return Promise.resolve();
        let audioElement = self._activeEls.get(sinkId);
        if (audioElement) return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
        audioElement = new self._Audio(self.url);
        // Make sure the browser always retrieves the resource using CORS.
        // By default when using media tags, origin header is not sent to server
        // which causes the server to not return CORS headers. When this caches
        // on the CDN or browser, it causes issues to future requests that needs CORS,
        // which is true when using AudioContext. Please note that we won't have to do this
        // once we migrate to CloudFront.
        if (typeof audioElement.setAttribute === 'function') audioElement.setAttribute('crossorigin', 'anonymous');
        /**
         * (rrowland) Bug in Chrome 53 & 54 prevents us from calling Audio.setSinkId without
         *   crashing the tab. https://bugs.chromium.org/p/chromium/issues/detail?id=655342
         */ return new Promise((resolve)=>{
            audioElement.addEventListener('canplaythrough', resolve);
        }).then(()=>{
            return (self._isSinkSupported ? audioElement.setSinkId(sinkId) : Promise.resolve()).then(function setSinkIdSuccess() {
                self._activeEls.set(sinkId, audioElement);
                // Stop has been called, bail out
                if (!self._playPromise) return Promise.resolve();
                return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
            });
        });
    }));
    return playPromise;
};
/**
 * Stop playing the sound.
 */ Sound.prototype._stop = function _stop() {
    this._activeEls.forEach((audioEl, sinkId)=>{
        if (this._sinkIds.includes(sinkId)) {
            audioEl.pause();
            audioEl.currentTime = 0;
        } else {
            // Destroy the ones that are not used anymore
            destroyAudioElement(audioEl);
            this._activeEls.delete(sinkId);
        }
    });
    clearTimeout(this._maxDurationTimeout);
    this._playPromise = null;
    this._maxDurationTimeout = null;
};
/**
 * Update the sinkIds of the audio output devices this sound should play through.
 */ Sound.prototype.setSinkIds = function setSinkIds(ids) {
    if (!this._isSinkSupported) return;
    ids = ids.forEach ? ids : [
        ids
    ];
    [].splice.apply(this._sinkIds, [
        0,
        this._sinkIds.length
    ].concat(ids));
};
/**
 * Add a stop operation to the queue
 */ Sound.prototype.stop = function stop() {
    this._operations.enqueue(()=>{
        this._stop();
        return Promise.resolve();
    });
};
/**
 * Add a play operation to the queue
 */ Sound.prototype.play = function play() {
    return this._operations.enqueue(()=>this._play());
};
exports.default = Sound;

},{"./asyncQueue":"9ssVe","./audioplayer/audioplayer":"fW5vP","./errors":"caXI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ssVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Queue async operations and executes them synchronously.
 */ parcelHelpers.export(exports, "AsyncQueue", ()=>AsyncQueue);
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var _deferred = require("./deferred");
var _deferredDefault = parcelHelpers.interopDefault(_deferred);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AsyncQueue {
    constructor(){
        /**
         * The list of async operations in this queue
         */ this._operations = [];
    }
    /**
     * Adds the async operation to the queue
     * @param callback An async callback that returns a promise
     * @returns A promise that will get resolved or rejected after executing the callback
     */ enqueue(callback) {
        const hasPending = !!this._operations.length;
        const deferred = new (0, _deferredDefault.default)();
        this._operations.push({
            deferred,
            callback
        });
        if (!hasPending) this._processQueue();
        return deferred.promise;
    }
    /**
     * Start processing the queue. This executes the first item and removes it after.
     * Then do the same for next items until the queue is emptied.
     */ _processQueue() {
        return __awaiter(this, void 0, void 0, function*() {
            while(this._operations.length){
                // Grab first item, don't remove from array yet until it's resolved/rejected
                const { deferred, callback } = this._operations[0];
                // We want to capture the result/error first so we can remove the item from the queue later
                let result;
                let error;
                // Sometimes result and error are empty. So let's use a separate flag to determine if the promise has resolved
                let hasResolved;
                try {
                    result = yield callback();
                    hasResolved = true;
                } catch (e) {
                    error = e;
                }
                // Remove the item
                this._operations.shift();
                if (hasResolved) deferred.resolve(result);
                else deferred.reject(error);
            }
        });
    }
}

},{"./deferred":"lOocF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lOocF":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ /**
 * Deferred Promise
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Deferred {
    /**
     * @constructor
     */ constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * @returns The {@link Deferred} Promise
     */ get promise() {
        return this._promise;
    }
    /**
     * Rejects this promise
     */ reject(reason) {
        this._reject(reason);
    }
    /**
     * Resolves this promise
     */ resolve(value) {
        this._resolve(value);
    }
}
exports.default = Deferred;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fW5vP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var _deferred = require("./deferred");
var _deferredDefault = parcelHelpers.interopDefault(_deferred);
var _eventtarget = require("./eventtarget");
var _eventtargetDefault = parcelHelpers.interopDefault(_eventtarget);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * An {@link AudioPlayer} is an HTMLAudioElement-like object that uses AudioContext
 *   to circumvent browser limitations.
 * @private
 */ class AudioPlayer extends (0, _eventtargetDefault.default) {
    /**
     * @private
     */ constructor(audioContext, srcOrOptions = {}, options = {}){
        super();
        /**
         * The AudioBufferSourceNode of the actively loaded sound. Null if a sound
         *   has not been loaded yet. This is re-used for each time the sound is
         *   played.
         */ this._audioNode = null;
        /**
         * Whether or not the audio element should loop. If disabled during playback,
         *   playing continues until the sound ends and then stops looping.
         */ this._loop = false;
        /**
         * An Array of deferred-like objects for each pending `play` Promise. When
         *   .pause() is called or .src is set, all pending play Promises are
         *   immediately rejected.
         */ this._pendingPlayDeferreds = [];
        /**
         * The current sinkId of the device audio is being played through.
         */ this._sinkId = 'default';
        /**
         * The source URL of the sound to play. When set, the currently playing sound will stop.
         */ this._src = '';
        if (typeof srcOrOptions !== 'string') options = srcOrOptions;
        this._audioContext = audioContext;
        this._audioElement = new (options.AudioFactory || Audio)();
        this._bufferPromise = this._createPlayDeferred().promise;
        this._destination = this._audioContext.destination;
        this._gainNode = this._audioContext.createGain();
        this._gainNode.connect(this._destination);
        this._XMLHttpRequest = options.XMLHttpRequestFactory || XMLHttpRequest;
        this.addEventListener('canplaythrough', ()=>{
            this._resolvePlayDeferreds();
        });
        if (typeof srcOrOptions === 'string') this.src = srcOrOptions;
    }
    get destination() {
        return this._destination;
    }
    get loop() {
        return this._loop;
    }
    set loop(shouldLoop) {
        const self = this;
        function pauseAfterPlaythrough() {
            self._audioNode.removeEventListener('ended', pauseAfterPlaythrough);
            self.pause();
        }
        // If a sound is already looping, it should continue playing
        //   the current playthrough and then stop.
        if (!shouldLoop && this.loop && !this.paused) this._audioNode.addEventListener('ended', pauseAfterPlaythrough);
        this._loop = shouldLoop;
    }
    /**
     * Whether the audio element is muted.
     */ get muted() {
        return this._gainNode.gain.value === 0;
    }
    set muted(shouldBeMuted) {
        this._gainNode.gain.value = shouldBeMuted ? 0 : 1;
    }
    /**
     * Whether the sound is paused. this._audioNode only exists when sound is playing;
     *   otherwise AudioPlayer is considered paused.
     */ get paused() {
        return this._audioNode === null;
    }
    get src() {
        return this._src;
    }
    set src(src) {
        this._load(src);
    }
    /**
     * The srcObject of the HTMLMediaElement
     */ get srcObject() {
        return this._audioElement.srcObject;
    }
    set srcObject(srcObject) {
        this._audioElement.srcObject = srcObject;
    }
    get sinkId() {
        return this._sinkId;
    }
    /**
     * Stop any ongoing playback and reload the source file.
     */ load() {
        this._load(this._src);
    }
    /**
     * Pause the audio coming from this AudioPlayer. This will reject any pending
     *   play Promises.
     */ pause() {
        if (this.paused) return;
        this._audioElement.pause();
        this._audioNode.stop();
        this._audioNode.disconnect(this._gainNode);
        this._audioNode = null;
        this._rejectPlayDeferreds(new Error('The play() request was interrupted by a call to pause().'));
    }
    /**
     * Play the sound. If the buffer hasn't loaded yet, wait for the buffer to load. If
     *   the source URL is not set yet, this Promise will remain pending until a source
     *   URL is set.
     */ play() {
        return __awaiter(this, void 0, void 0, function*() {
            if (!this.paused) {
                yield this._bufferPromise;
                if (!this.paused) return;
                throw new Error('The play() request was interrupted by a call to pause().');
            }
            this._audioNode = this._audioContext.createBufferSource();
            this._audioNode.loop = this.loop;
            this._audioNode.addEventListener('ended', ()=>{
                if (this._audioNode && this._audioNode.loop) return;
                this.dispatchEvent('ended');
            });
            const buffer = yield this._bufferPromise;
            if (this.paused) throw new Error('The play() request was interrupted by a call to pause().');
            this._audioNode.buffer = buffer;
            this._audioNode.connect(this._gainNode);
            this._audioNode.start();
            if (this._audioElement.srcObject) return this._audioElement.play();
        });
    }
    /**
     * Change which device the sound should play through.
     * @param sinkId - The sink of the device to play sound through.
     */ setSinkId(sinkId) {
        return __awaiter(this, void 0, void 0, function*() {
            if (typeof this._audioElement.setSinkId !== 'function') throw new Error('This browser does not support setSinkId.');
            if (sinkId === this.sinkId) return;
            if (sinkId === 'default') {
                if (!this.paused) this._gainNode.disconnect(this._destination);
                this._audioElement.srcObject = null;
                this._destination = this._audioContext.destination;
                this._gainNode.connect(this._destination);
                this._sinkId = sinkId;
                return;
            }
            yield this._audioElement.setSinkId(sinkId);
            if (this._audioElement.srcObject) return;
            this._gainNode.disconnect(this._audioContext.destination);
            this._destination = this._audioContext.createMediaStreamDestination();
            this._audioElement.srcObject = this._destination.stream;
            this._sinkId = sinkId;
            this._gainNode.connect(this._destination);
        });
    }
    /**
     * Create a Deferred for a Promise that will be resolved when .src is set or rejected
     *   when .pause is called.
     */ _createPlayDeferred() {
        const deferred = new (0, _deferredDefault.default)();
        this._pendingPlayDeferreds.push(deferred);
        return deferred;
    }
    /**
     * Stop current playback and load a sound file.
     * @param src - The source URL of the file to load
     */ _load(src) {
        if (this._src && this._src !== src) this.pause();
        this._src = src;
        this._bufferPromise = new Promise((resolve, reject)=>__awaiter(this, void 0, void 0, function*() {
                if (!src) return this._createPlayDeferred().promise;
                const buffer = yield bufferSound(this._audioContext, this._XMLHttpRequest, src);
                this.dispatchEvent('canplaythrough');
                resolve(buffer);
            }));
    }
    /**
     * Reject all deferreds for the Play promise.
     * @param reason
     */ _rejectPlayDeferreds(reason) {
        const deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(({ reject })=>reject(reason));
    }
    /**
     * Resolve all deferreds for the Play promise.
     * @param result
     */ _resolvePlayDeferreds(result) {
        const deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(({ resolve })=>resolve(result));
    }
}
/**
 * Use XMLHttpRequest to load the AudioBuffer of a remote audio asset.
 * @private
 * @param context - The AudioContext to use to decode the audio data
 * @param RequestFactory - The XMLHttpRequest factory to build
 * @param src - The URL of the audio asset to load.
 * @returns A Promise containing the decoded AudioBuffer.
 */ // tslint:disable-next-line:variable-name
function bufferSound(context, RequestFactory, src) {
    return __awaiter(this, void 0, void 0, function*() {
        const request = new RequestFactory();
        request.open('GET', src, true);
        request.responseType = 'arraybuffer';
        const event = yield new Promise((resolve)=>{
            request.addEventListener('load', resolve);
            request.send();
        });
        // Safari uses a callback here instead of a Promise.
        try {
            return context.decodeAudioData(event.target.response);
        } catch (e) {
            return new Promise((resolve)=>{
                context.decodeAudioData(event.target.response, resolve);
            });
        }
    });
}
exports.default = AudioPlayer;

},{"./deferred":"3dkdX","./eventtarget":"hNc7g","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3dkdX":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Deferred {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get reject() {
        return this._reject;
    }
    get resolve() {
        return this._resolve;
    }
}
exports.default = Deferred;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNc7g":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
class EventTarget {
    constructor(){
        this._eventEmitter = new (0, _events.EventEmitter)();
    }
    addEventListener(name, handler) {
        return this._eventEmitter.addListener(name, handler);
    }
    dispatchEvent(name, ...args) {
        return this._eventEmitter.emit(name, ...args);
    }
    removeEventListener(name, handler) {
        return this._eventEmitter.removeListener(name, handler);
    }
}
exports.default = EventTarget;

},{"events":"fqTtD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zIUQ":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateVoiceEventSid", ()=>generateVoiceEventSid);
var _md5 = require("md5");
var _errors = require("../twilio/errors");
// If imported as an ESM module, sometimes md5 is available by accessing
// the "default" property of the imported library.
// @ts-ignore
const md5 = typeof _md5 === 'function' ? _md5 : _md5.default;
function generateUuid() {
    if (typeof window !== 'object') throw new (0, _errors.NotSupportedError)('This platform is not supported.');
    const crypto = window.crypto;
    if (typeof crypto !== 'object') throw new (0, _errors.NotSupportedError)('The `crypto` module is not available on this platform.');
    if (typeof (crypto.randomUUID || crypto.getRandomValues) === 'undefined') throw new (0, _errors.NotSupportedError)("Neither `crypto.randomUUID` or `crypto.getRandomValues` are available on this platform.");
    const uInt32Arr = window.Uint32Array;
    if (typeof uInt32Arr === 'undefined') throw new (0, _errors.NotSupportedError)('The `Uint32Array` module is not available on this platform.');
    const generateRandomValues = typeof crypto.randomUUID === 'function' ? ()=>crypto.randomUUID() : ()=>crypto.getRandomValues(new Uint32Array(32)).toString();
    return md5(generateRandomValues());
}
function generateVoiceEventSid() {
    return `KX${generateUuid()}`;
}

},{"md5":"i2Rm8","../twilio/errors":"caXI8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i2Rm8":[function(require,module,exports,__globalThis) {
(function() {
    var crypt = require("147051b0540e7f7"), utf8 = require("1f77507fdd0c665").utf8, isBuffer = require("fdee90c617e2c15d"), bin = require("1f77507fdd0c665").bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    module.exports = function(message, options) {
        if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();

},{"147051b0540e7f7":"98ed4","1f77507fdd0c665":"c9YNA","fdee90c617e2c15d":"d2PlB"}],"98ed4":[function(require,module,exports,__globalThis) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

},{}],"c9YNA":[function(require,module,exports,__globalThis) {
var charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = charenc;

},{}],"d2PlB":[function(require,module,exports,__globalThis) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

},{}],"5YOkc":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ /**
 * {@link RTCIceCandidate} parses an ICE candidate gathered by the browser
 * and returns a IceCandidate object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IceCandidate", ()=>IceCandidate);
class IceCandidate {
    /**
     * @constructor
     * @param iceCandidate RTCIceCandidate coming from the browser
     */ constructor(iceCandidate, isRemote = false){
        /**
         * Whether this is deleted from the list of candidate gathered
         */ this.deleted = false;
        let cost;
        const parts = iceCandidate.candidate.split('network-cost ');
        if (parts[1]) cost = parseInt(parts[1], 10);
        this.candidateType = iceCandidate.type;
        this.ip = iceCandidate.ip || iceCandidate.address;
        this.isRemote = isRemote;
        this.networkCost = cost;
        this.port = iceCandidate.port;
        this.priority = iceCandidate.priority;
        this.protocol = iceCandidate.protocol;
        this.relatedAddress = iceCandidate.relatedAddress;
        this.relatedPort = iceCandidate.relatedPort;
        this.tcpType = iceCandidate.tcpType;
        this.transportId = iceCandidate.sdpMid;
    }
    /**
     * Get the payload object for insights
     */ toPayload() {
        return {
            'candidate_type': this.candidateType,
            'deleted': this.deleted,
            'ip': this.ip,
            'is_remote': this.isRemote,
            'network-cost': this.networkCost,
            'port': this.port,
            'priority': this.priority,
            'protocol': this.protocol,
            'related_address': this.relatedAddress,
            'related_port': this.relatedPort,
            'tcp_type': this.tcpType,
            'transport_id': this.transportId
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8Mqi":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("events");
var _errors = require("./errors");
var _mos = require("./rtc/mos");
var _mosDefault = parcelHelpers.interopDefault(_mos);
var _stats = require("./rtc/stats");
var _util = require("./util");
// How many samples we use when testing metric thresholds
const SAMPLE_COUNT_METRICS = 5;
// How many samples that need to cross the threshold to
// raise or clear a warning.
const SAMPLE_COUNT_CLEAR = 0;
const SAMPLE_COUNT_RAISE = 3;
const SAMPLE_INTERVAL = 1000;
const WARNING_TIMEOUT = 5000;
const DEFAULT_THRESHOLDS = {
    audioInputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    audioOutputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    bytesReceived: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    bytesSent: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    jitter: {
        max: 30
    },
    mos: {
        min: 3
    },
    packetsLostFraction: [
        {
            max: 1
        },
        {
            clearValue: 1,
            maxAverage: 3,
            sampleCount: 7
        }
    ],
    rtt: {
        max: 400
    }
};
/**
 * Count the number of values that cross the max threshold.
 * @private
 * @param max - The max allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function countHigh(max, values) {
    return values.reduce((highCount, value)=>highCount += value > max ? 1 : 0, 0);
}
/**
 * Count the number of values that cross the min threshold.
 * @private
 * @param min - The minimum allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function countLow(min, values) {
    return values.reduce((lowCount, value)=>lowCount += value < min ? 1 : 0, 0);
}
/**
 * Calculate the standard deviation from a list of numbers.
 * @private
 * @param values The list of numbers to calculate the standard deviation from.
 * @returns The standard deviation of a list of numbers.
 */ function calculateStandardDeviation(values) {
    if (values.length <= 0) return null;
    const valueAverage = values.reduce((partialSum, value)=>partialSum + value, 0) / values.length;
    const diffSquared = values.map((value)=>Math.pow(value - valueAverage, 2));
    const stdDev = Math.sqrt(diffSquared.reduce((partialSum, value)=>partialSum + value, 0) / diffSquared.length);
    return stdDev;
}
/**
 * Flatten a set of numerical sample sets into a single array of samples.
 * @param sampleSets
 */ function flattenSamples(sampleSets) {
    return sampleSets.reduce((flat, current)=>[
            ...flat,
            ...current
        ], []);
}
/**
 * {@link StatsMonitor} polls a peerConnection via PeerConnection.getStats
 * and emits warnings when stats cross the specified threshold values.
 */ class StatsMonitor extends (0, _events.EventEmitter) {
    /**
     * @constructor
     * @param [options] - Optional settings
     */ constructor(options){
        super();
        /**
         * A map of warnings with their raised time
         */ this._activeWarnings = new Map();
        /**
         * A map of stats with the number of exceeded thresholds
         */ this._currentStreaks = new Map();
        /**
         * Keeps track of input volumes in the last second
         */ this._inputVolumes = [];
        /**
         * Keeps track of output volumes in the last second
         */ this._outputVolumes = [];
        /**
         * Sample buffer. Saves most recent samples
         */ this._sampleBuffer = [];
        /**
         * Keeps track of supplemental sample values.
         *
         * Currently used for constant audio detection. Contains an array of volume
         * samples for each sample interval.
         */ this._supplementalSampleBuffers = {
            audioInputLevel: [],
            audioOutputLevel: []
        };
        /**
         * Whether warnings should be enabled
         */ this._warningsEnabled = true;
        options = options || {};
        this._getRTCStats = options.getRTCStats || (0, _stats.getRTCStats);
        this._mos = options.Mos || (0, _mosDefault.default);
        this._peerConnection = options.peerConnection;
        this._thresholds = Object.assign(Object.assign({}, DEFAULT_THRESHOLDS), options.thresholds);
        const thresholdSampleCounts = Object.values(this._thresholds).map((threshold)=>threshold.sampleCount).filter((sampleCount)=>!!sampleCount);
        this._maxSampleCount = Math.max(SAMPLE_COUNT_METRICS, ...thresholdSampleCounts);
        if (this._peerConnection) this.enable(this._peerConnection);
    }
    /**
     * Called when a volume sample is available
     * @param inputVolume - Input volume level from 0 to 32767
     * @param outputVolume - Output volume level from 0 to 32767
     */ addVolumes(inputVolume, outputVolume) {
        this._inputVolumes.push(inputVolume);
        this._outputVolumes.push(outputVolume);
    }
    /**
     * Stop sampling RTC statistics for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ disable() {
        if (this._sampleInterval) {
            clearInterval(this._sampleInterval);
            delete this._sampleInterval;
        }
        return this;
    }
    /**
     * Disable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ disableWarnings() {
        if (this._warningsEnabled) this._activeWarnings.clear();
        this._warningsEnabled = false;
        return this;
    }
    /**
     * Start sampling RTC statistics for this {@link StatsMonitor}.
     * @param peerConnection - A PeerConnection to monitor.
     * @returns The current {@link StatsMonitor}.
     */ enable(peerConnection) {
        if (peerConnection) {
            if (this._peerConnection && peerConnection !== this._peerConnection) throw new (0, _errors.InvalidArgumentError)('Attempted to replace an existing PeerConnection in StatsMonitor.enable');
            this._peerConnection = peerConnection;
        }
        if (!this._peerConnection) throw new (0, _errors.InvalidArgumentError)('Can not enable StatsMonitor without a PeerConnection');
        this._sampleInterval = this._sampleInterval || setInterval(this._fetchSample.bind(this), SAMPLE_INTERVAL);
        return this;
    }
    /**
     * Enable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ enableWarnings() {
        this._warningsEnabled = true;
        return this;
    }
    /**
     * Check if there is an active warning for a specific stat and threshold
     * @param statName - The name of the stat to check
     * @param thresholdName - The name of the threshold to check
     * @returns Whether there is an active warning for a specific stat and threshold
     */ hasActiveWarning(statName, thresholdName) {
        const warningId = `${statName}:${thresholdName}`;
        return !!this._activeWarnings.get(warningId);
    }
    /**
     * Add a sample to our sample buffer and remove the oldest if we are over the limit.
     * @param sample - Sample to add
     */ _addSample(sample) {
        const samples = this._sampleBuffer;
        samples.push(sample);
        // We store 1 extra sample so that we always have (current, previous)
        // available for all {sampleBufferSize} threshold validations.
        if (samples.length > this._maxSampleCount) samples.splice(0, samples.length - this._maxSampleCount);
    }
    /**
     * Clear an active warning.
     * @param statName - The name of the stat to clear.
     * @param thresholdName - The name of the threshold to clear
     * @param [data] - Any relevant sample data.
     */ _clearWarning(statName, thresholdName, data) {
        const warningId = `${statName}:${thresholdName}`;
        const activeWarning = this._activeWarnings.get(warningId);
        if (!activeWarning || Date.now() - activeWarning.timeRaised < WARNING_TIMEOUT) return;
        this._activeWarnings.delete(warningId);
        this.emit('warning-cleared', Object.assign(Object.assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: this._thresholds[statName][thresholdName]
            }
        }));
    }
    /**
     * Create a sample object from a stats object using the previous sample, if available.
     * @param stats - Stats retrieved from getStatistics
     * @param [previousSample=null] - The previous sample to use to calculate deltas.
     * @returns A universally-formatted version of RTC stats.
     */ _createSample(stats, previousSample) {
        const previousBytesSent = previousSample && previousSample.totals.bytesSent || 0;
        const previousBytesReceived = previousSample && previousSample.totals.bytesReceived || 0;
        const previousPacketsSent = previousSample && previousSample.totals.packetsSent || 0;
        const previousPacketsReceived = previousSample && previousSample.totals.packetsReceived || 0;
        const previousPacketsLost = previousSample && previousSample.totals.packetsLost || 0;
        const currentBytesSent = stats.bytesSent - previousBytesSent;
        const currentBytesReceived = stats.bytesReceived - previousBytesReceived;
        const currentPacketsSent = stats.packetsSent - previousPacketsSent;
        const currentPacketsReceived = stats.packetsReceived - previousPacketsReceived;
        const currentPacketsLost = stats.packetsLost - previousPacketsLost;
        const currentInboundPackets = currentPacketsReceived + currentPacketsLost;
        const currentPacketsLostFraction = currentInboundPackets > 0 ? currentPacketsLost / currentInboundPackets * 100 : 0;
        const totalInboundPackets = stats.packetsReceived + stats.packetsLost;
        const totalPacketsLostFraction = totalInboundPackets > 0 ? stats.packetsLost / totalInboundPackets * 100 : 100;
        const rttValue = typeof stats.rtt === 'number' || !previousSample ? stats.rtt : previousSample.rtt;
        const audioInputLevelValues = this._inputVolumes.splice(0);
        this._supplementalSampleBuffers.audioInputLevel.push(audioInputLevelValues);
        const audioOutputLevelValues = this._outputVolumes.splice(0);
        this._supplementalSampleBuffers.audioOutputLevel.push(audioOutputLevelValues);
        return {
            audioInputLevel: Math.round((0, _util.average)(audioInputLevelValues)),
            audioOutputLevel: Math.round((0, _util.average)(audioOutputLevelValues)),
            bytesReceived: currentBytesReceived,
            bytesSent: currentBytesSent,
            codecName: stats.codecName,
            jitter: stats.jitter,
            mos: this._mos.calculate(rttValue, stats.jitter, previousSample && currentPacketsLostFraction),
            packetsLost: currentPacketsLost,
            packetsLostFraction: currentPacketsLostFraction,
            packetsReceived: currentPacketsReceived,
            packetsSent: currentPacketsSent,
            rtt: rttValue,
            timestamp: stats.timestamp,
            totals: {
                bytesReceived: stats.bytesReceived,
                bytesSent: stats.bytesSent,
                packetsLost: stats.packetsLost,
                packetsLostFraction: totalPacketsLostFraction,
                packetsReceived: stats.packetsReceived,
                packetsSent: stats.packetsSent
            }
        };
    }
    /**
     * Get stats from the PeerConnection and add it to our list of samples.
     */ _fetchSample() {
        this._getSample().then((sample)=>{
            this._addSample(sample);
            this._raiseWarnings();
            this.emit('sample', sample);
        }).catch((error)=>{
            this.disable();
            // We only bubble up any errors coming from pc.getStats()
            // No need to attach a twilioError
            this.emit('error', error);
        });
    }
    /**
     * Get stats from the PeerConnection.
     * @returns A universally-formatted version of RTC stats.
     */ _getSample() {
        return this._getRTCStats(this._peerConnection).then((stats)=>{
            let previousSample = null;
            if (this._sampleBuffer.length) previousSample = this._sampleBuffer[this._sampleBuffer.length - 1];
            return this._createSample(stats, previousSample);
        });
    }
    /**
     * Raise a warning and log its raised time.
     * @param statName - The name of the stat to raise.
     * @param thresholdName - The name of the threshold to raise
     * @param [data] - Any relevant sample data.
     */ _raiseWarning(statName, thresholdName, data) {
        const warningId = `${statName}:${thresholdName}`;
        if (this._activeWarnings.has(warningId)) return;
        this._activeWarnings.set(warningId, {
            timeRaised: Date.now()
        });
        const thresholds = this._thresholds[statName];
        let thresholdValue;
        if (Array.isArray(thresholds)) {
            const foundThreshold = thresholds.find((threshold)=>thresholdName in threshold);
            if (foundThreshold) thresholdValue = foundThreshold[thresholdName];
        } else thresholdValue = this._thresholds[statName][thresholdName];
        this.emit('warning', Object.assign(Object.assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: thresholdValue
            }
        }));
    }
    /**
     * Apply our thresholds to our array of RTCStat samples.
     */ _raiseWarnings() {
        if (!this._warningsEnabled) return;
        Object.keys(this._thresholds).forEach((name)=>this._raiseWarningsForStat(name));
    }
    /**
     * Apply thresholds for a given stat name to our array of
     * RTCStat samples and raise or clear any associated warnings.
     * @param statName - Name of the stat to compare.
     */ _raiseWarningsForStat(statName) {
        const limits = Array.isArray(this._thresholds[statName]) ? this._thresholds[statName] : [
            this._thresholds[statName]
        ];
        limits.forEach((limit)=>{
            const samples = this._sampleBuffer;
            const clearCount = limit.clearCount || SAMPLE_COUNT_CLEAR;
            const raiseCount = limit.raiseCount || SAMPLE_COUNT_RAISE;
            const sampleCount = limit.sampleCount || this._maxSampleCount;
            let relevantSamples = samples.slice(-sampleCount);
            const values = relevantSamples.map((sample)=>sample[statName]);
            // (rrowland) If we have a bad or missing value in the set, we don't
            // have enough information to throw or clear a warning. Bail out.
            const containsNull = values.some((value)=>typeof value === 'undefined' || value === null);
            if (containsNull) return;
            let count;
            if (typeof limit.max === 'number') {
                count = countHigh(limit.max, values);
                if (count >= raiseCount) this._raiseWarning(statName, 'max', {
                    values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) this._clearWarning(statName, 'max', {
                    values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.min === 'number') {
                count = countLow(limit.min, values);
                if (count >= raiseCount) this._raiseWarning(statName, 'min', {
                    values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) this._clearWarning(statName, 'min', {
                    values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.maxDuration === 'number' && samples.length > 1) {
                relevantSamples = samples.slice(-2);
                const prevValue = relevantSamples[0][statName];
                const curValue = relevantSamples[1][statName];
                const prevStreak = this._currentStreaks.get(statName) || 0;
                const streak = prevValue === curValue ? prevStreak + 1 : 0;
                this._currentStreaks.set(statName, streak);
                if (streak >= limit.maxDuration) this._raiseWarning(statName, 'maxDuration', {
                    value: streak
                });
                else if (streak === 0) this._clearWarning(statName, 'maxDuration', {
                    value: prevStreak
                });
            }
            if (typeof limit.minStandardDeviation === 'number') {
                const sampleSets = this._supplementalSampleBuffers[statName];
                if (!sampleSets || sampleSets.length < limit.sampleCount) return;
                if (sampleSets.length > limit.sampleCount) sampleSets.splice(0, sampleSets.length - limit.sampleCount);
                const flatSamples = flattenSamples(sampleSets.slice(-sampleCount));
                const stdDev = calculateStandardDeviation(flatSamples);
                if (typeof stdDev !== 'number') return;
                if (stdDev < limit.minStandardDeviation) this._raiseWarning(statName, 'minStandardDeviation', {
                    value: stdDev
                });
                else this._clearWarning(statName, 'minStandardDeviation', {
                    value: stdDev
                });
            }
            [
                [
                    'maxAverage',
                    (x, y)=>x > y
                ],
                [
                    'minAverage',
                    (x, y)=>x < y
                ]
            ].forEach(([thresholdName, comparator])=>{
                if (typeof limit[thresholdName] === 'number' && values.length >= sampleCount) {
                    const avg = (0, _util.average)(values);
                    if (comparator(avg, limit[thresholdName])) this._raiseWarning(statName, thresholdName, {
                        values,
                        samples: relevantSamples
                    });
                    else if (!comparator(avg, limit.clearValue || limit[thresholdName])) this._clearWarning(statName, thresholdName, {
                        values,
                        samples: relevantSamples
                    });
                }
            });
        });
    }
}
exports.default = StatsMonitor;

},{"events":"fqTtD","./errors":"caXI8","./rtc/mos":"bnlQR","./rtc/stats":"clOJr","./util":"j8qrE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnlQR":[function(require,module,exports,__globalThis) {
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculate the mos score of a stats object
 * @param {number} rtt
 * @param {number} jitter
 * @param {number} fractionLost - The fraction of packets that have been lost.
 * Calculated by packetsLost / totalPackets
 * @return {number | null} mos - Calculated MOS, `1.0` through roughly `4.5`.
 * Returns `null` when any of the input parameters are not a `non-negative`
 * number.
 */ parcelHelpers.export(exports, "calculate", ()=>calculate);
/**
 * Returns true if and only if the parameter passed is a number, is not `NaN`,
 * is finite, and is greater than or equal to `0`.
 * @param n
 */ parcelHelpers.export(exports, "isNonNegativeNumber", ()=>isNonNegativeNumber);
const r0 = 94.768; // Constant used in computing "rFactor".
function calculate(rtt, jitter, fractionLost) {
    if (typeof rtt !== 'number' || typeof jitter !== 'number' || typeof fractionLost !== 'number' || !isNonNegativeNumber(rtt) || !isNonNegativeNumber(jitter) || !isNonNegativeNumber(fractionLost)) return null;
    // Compute the effective latency.
    const effectiveLatency = rtt + jitter * 2 + 10;
    // Compute the initial "rFactor" from effective latency.
    let rFactor = 0;
    switch(true){
        case effectiveLatency < 160:
            rFactor = r0 - effectiveLatency / 40;
            break;
        case effectiveLatency < 1000:
            rFactor = r0 - (effectiveLatency - 120) / 10;
            break;
    }
    // Adjust "rFactor" with the fraction of packets lost.
    switch(true){
        case fractionLost <= rFactor / 2.5:
            rFactor = Math.max(rFactor - fractionLost * 2.5, 6.52);
            break;
        default:
            rFactor = 0;
            break;
    }
    // Compute MOS from "rFactor".
    const mos = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
    return mos;
}
function isNonNegativeNumber(n) {
    return typeof n === 'number' && !isNaN(n) && isFinite(n) && n >= 0;
}
exports.default = {
    calculate,
    isNonNegativeNumber
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jEhEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    id: "dispatch-caller-toast",
    class: "toast hide fade",
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
};
const _hoisted_2 = {
    class: "toast-header"
};
const _hoisted_3 = {
    class: "toast-body"
};
const _hoisted_4 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_5 = {
    key: 1,
    class: "mt-2 pt-2 border-top d-flex justify-content-between"
};
const _hoisted_6 = {
    key: 0
};
const _hoisted_7 = {
    key: 1
};
const _hoisted_8 = {
    key: 2
};
const _hoisted_9 = [
    "title"
];
const _hoisted_10 = {
    key: 0
};
const _hoisted_11 = {
    key: 1
};
const _hoisted_12 = {
    key: 3
};
const _hoisted_13 = {
    id: "call-summary-toast",
    class: "toast hide fade",
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
};
const _hoisted_14 = {
    class: "toast-body"
};
const _hoisted_15 = {
    class: "row"
};
const _hoisted_16 = {
    class: "col-12 f-w-700"
};
const _hoisted_17 = {
    key: 0,
    class: "f-w-400",
    title: "Summary not available"
};
const _hoisted_18 = {
    class: "list-group"
};
const _hoisted_19 = {
    class: "list-group-item border-left-primary"
};
const _hoisted_20 = [
    "innerHTML"
];
const _hoisted_21 = [
    "onClick"
];
const _hoisted_22 = {
    class: "col-12 f-w-700 mt-2"
};
const _hoisted_23 = {
    key: 0,
    class: "f-w-400",
    title: "Summary not available"
};
const _hoisted_24 = {
    class: "list-group"
};
const _hoisted_25 = {
    class: "list-group-item border-left-secondary"
};
const _hoisted_26 = [
    "innerHTML"
];
const _hoisted_27 = [
    "onClick"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("i", {
                    class: "toast-icons fa-solid fa-phone-volume"
                }, null, -1)),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.currentState), 1)
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($setup.currentState) + " from " + (0, _vue.toDisplayString)($setup.caller), 1),
                $setup.currentState === $setup.STATES.CALL_IN_PROGRESS && $setup.muted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_4, " Your microphone is muted. ")) : (0, _vue.createCommentVNode)("", true),
                $setup.currentState === $setup.STATES.INCOMING_CALL || $setup.currentState === $setup.STATES.CALL_IN_PROGRESS ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                    $setup.currentState === $setup.STATES.INCOMING_CALL ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, [
                        (0, _vue.createElementVNode)("a", {
                            class: "btn btn-pill btn-success align-items-center pull-left",
                            onClick: $setup.acceptCall
                        }, _cache[1] || (_cache[1] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Accept ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.currentState === $setup.STATES.INCOMING_CALL ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                        (0, _vue.createElementVNode)("a", {
                            class: "btn btn-pill btn-danger align-items-center pull-right",
                            onClick: $setup.rejectCall
                        }, _cache[2] || (_cache[2] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-ban"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Decline ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.currentState === $setup.STATES.CALL_IN_PROGRESS ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                        (0, _vue.createElementVNode)("a", {
                            class: "btn btn-pill align-items-center btn-outline-primary",
                            title: $setup.muted ? 'Unmute microphone' : 'Mute microphone',
                            onClick: $setup.muteClick
                        }, [
                            $setup.muted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_10, _cache[3] || (_cache[3] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-microphone"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Unmute ")
                            ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_11, _cache[4] || (_cache[4] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-microphone-slash"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Mute ")
                            ])))
                        ], 8, _hoisted_9)
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.currentState === $setup.STATES.CALL_IN_PROGRESS ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                        (0, _vue.createElementVNode)("a", {
                            class: "btn btn-pill btn-danger align-items-center",
                            onClick: $setup.endCall
                        }, _cache[5] || (_cache[5] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-ban"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" End Call ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_13, [
            _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("div", {
                class: "toast-header"
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa-solid fa-list-check"
                }),
                (0, _vue.createElementVNode)("strong", {
                    class: "me-auto"
                }, "Call summary"),
                (0, _vue.createElementVNode)("button", {
                    class: "btn-close",
                    type: "button",
                    "data-bs-dismiss": "toast",
                    "aria-label": "Close"
                })
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_14, [
                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("div", {
                    class: "mt-2"
                }, [
                    (0, _vue.createElementVNode)("span", {
                        class: "b f-w-300"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "text-warning fa-solid fa-circle-exclamation"
                        }),
                        (0, _vue.createTextVNode)(" This summary is AI generated and may not be accurate. Double check before booking. ")
                    ])
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_15, [
                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                        _cache[6] || (_cache[6] = (0, _vue.createTextVNode)(" Pick-up: ")),
                        $setup.pickUpAddressSuggestions.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_17, " N/A ")) : (0, _vue.createCommentVNode)("", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.pickUpAddressSuggestions, (pickUpAddressSuggestion)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_18, [
                                (0, _vue.createElementVNode)("li", _hoisted_19, [
                                    (0, _vue.createElementVNode)("span", {
                                        class: "f-w-400",
                                        innerHTML: pickUpAddressSuggestion.label,
                                        style: {
                                            "width": "250px",
                                            "text-overflow": "ellipsis",
                                            "white-space": "nowrap",
                                            "overflow": "hidden"
                                        }
                                    }, null, 8, _hoisted_20),
                                    (0, _vue.createElementVNode)("a", {
                                        class: "btn btn-link p-0",
                                        onClick: ($event)=>$setup.usePickUpSuggestion(pickUpAddressSuggestion),
                                        title: "Use this suggestion to book."
                                    }, "Use this.", 8, _hoisted_21)
                                ])
                            ]);
                        }), 256))
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_22, [
                        _cache[7] || (_cache[7] = (0, _vue.createTextVNode)(" Drop-off: ")),
                        $setup.dropOffAddressSuggestions.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_23, " N/A ")) : (0, _vue.createCommentVNode)("", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.dropOffAddressSuggestions, (dropOffAddressSuggestion)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_24, [
                                (0, _vue.createElementVNode)("li", _hoisted_25, [
                                    (0, _vue.createElementVNode)("span", {
                                        class: "f-w-400",
                                        innerHTML: dropOffAddressSuggestion.label,
                                        style: {
                                            "width": "250px",
                                            "text-overflow": "ellipsis",
                                            "white-space": "nowrap",
                                            "overflow": "hidden"
                                        }
                                    }, null, 8, _hoisted_26),
                                    (0, _vue.createElementVNode)("a", {
                                        class: "btn btn-link p-0",
                                        onClick: ($event)=>$setup.useDropOffSuggestion(dropOffAddressSuggestion),
                                        title: "Use this suggestion to book."
                                    }, "Use this.", 8, _hoisted_27)
                                ])
                            ]);
                        }), 256))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", {
                    class: "mt-2 pt-2 border-top"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        class: "btn btn-pill btn-primary align-items-end",
                        onClick: $setup.dismissCallSummary
                    }, _cache[8] || (_cache[8] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-check"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Dismiss ")
                    ]))
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bOSQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZvZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("7e9ae5225cc69191");
    if (script.__esModule) script = script.default;
    script.render = require("26f9970530e5d246").render;
    require("ae72018fac0288e2").default(script);
    script.__scopeId = 'data-v-08bf5d';
    script.__file = "CallHistoryNotification.vue";
};
initialize();
exports.default = script;

},{"7e9ae5225cc69191":"cvRx7","26f9970530e5d246":"bEemc","ae72018fac0288e2":"dPrYk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvRx7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _timeagoJs = require("timeago.js");
const pollingInterval = 30000; //30 seconds poll time
exports.default = {
    __name: 'CallHistoryNotification',
    setup (__props, { expose: __expose }) {
        __expose();
        const STATUS = {
            INITIATED: 'Initiated',
            RINGING: 'Ringing',
            IN_PROGRESS: 'In Progress',
            ANSWERED: 'Answered',
            COMPLETED: 'Completed',
            BUSY: 'Busy',
            NO_ANSWER: 'No Answer',
            FAILED: 'Failed',
            CANCELED: 'Canceled'
        };
        const callHistory = (0, _vue.ref)([]);
        let pollingTimer;
        // Function to fetch call history
        const fetchCallHistory = async ()=>{
            try {
                const response = await fetch("/api/call/get-history-notifications");
                if (response.ok) callHistory.value = await response.json();
                else console.error("Failed to fetch call history");
            } catch (error) {
                console.error("Error fetching call history:", error);
            }
        };
        const startPolling = ()=>{
            pollingTimer = setInterval(fetchCallHistory, pollingInterval);
        };
        const stopPolling = ()=>{
            clearInterval(pollingTimer);
        };
        const getTimeAgo = (value)=>{
            const date = new Date(value);
            if (isNaN(date)) return "N/A";
            return (0, _timeagoJs.format)(date);
        };
        const getStatusBadge = (value)=>{
            let className = '';
            switch(value){
                case STATUS.INITIATED:
                    className = 'btn badge-light';
                    break;
                case STATUS.RINGING:
                case STATUS.IN_PROGRESS:
                    className = 'btn badge-info border-light-secondary text-secondary';
                    break;
                case STATUS.ANSWERED:
                    className = 'btn bg-primary border-light-primary text-primary';
                    break;
                case STATUS.COMPLETED:
                    className = 'btn bg-success border-light-success text-success';
                    break;
                case STATUS.NO_ANSWER:
                    className = 'btn bg-warning border-light-warning text-warning';
                    break;
                case STATUS.FAILED:
                case STATUS.CANCELED:
                case STATUS.BUSY:
                    className = 'btn bg-danger border-light-danger text-danger';
                    break;
            }
            return className;
        };
        const getStatusBorder = (value)=>{
            let className = '';
            switch(value){
                case STATUS.INITIATED:
                    className = 'border-left-light';
                    break;
                case STATUS.RINGING:
                case STATUS.IN_PROGRESS:
                    className = 'border-left-secondary';
                    break;
                case STATUS.ANSWERED:
                    className = 'border-left-primary';
                    break;
                case STATUS.COMPLETED:
                    className = 'border-left-success';
                    break;
                case STATUS.NO_ANSWER:
                    className = 'border-left-warning';
                    break;
                case STATUS.FAILED:
                case STATUS.CANCELED:
                case STATUS.BUSY:
                    className = 'border-left-danger';
                    break;
            }
            return className;
        };
        // Lifecycle hooks
        (0, _vue.onMounted)(()=>{
            fetchCallHistory();
            startPolling();
        });
        (0, _vue.onUnmounted)(()=>{
            stopPolling(); // Cleanup polling on component unmount
        });
        const __returned__ = {
            STATUS,
            callHistory,
            pollingInterval,
            get pollingTimer () {
                return pollingTimer;
            },
            set pollingTimer (v){
                pollingTimer = v;
            },
            fetchCallHistory,
            startPolling,
            stopPolling,
            getTimeAgo,
            getStatusBadge,
            getStatusBorder,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            get format () {
                return 0, _timeagoJs.format;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","timeago.js":"aPiEQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEemc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "custom-menu notification-dropdown p-0 overflow-hidden"
};
const _hoisted_2 = {
    class: "vertical-scroll"
};
const _hoisted_3 = {
    class: "list-group",
    id: "call-history"
};
const _hoisted_4 = {
    class: "mb-1 f-w-700"
};
const _hoisted_5 = [
    "textContent",
    "title"
];
const _hoisted_6 = {
    class: "mb-0 font-bold"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("a", {
            href: "javascript:void(0)"
        }, [
            (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-phone"
            })
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("h3", {
                class: "title bg-primary-light dropdown-title"
            }, [
                (0, _vue.createTextVNode)(" Call History "),
                (0, _vue.createElementVNode)("a", {
                    class: "link-underline font-primary"
                }, [
                    (0, _vue.createTextVNode)(" View all "),
                    (0, _vue.createElementVNode)("i", {
                        class: "fs-6 fa-solid fa-arrow-up-right-from-square"
                    })
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.callHistory, (call)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                        (0, _vue.createElementVNode)("div", {
                            class: (0, _vue.normalizeClass)([
                                "list-group-item",
                                $setup.getStatusBorder(call.status)
                            ])
                        }, [
                            (0, _vue.createElementVNode)("p", _hoisted_4, [
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(call.caller) + " ", 1),
                                (0, _vue.createElementVNode)("small", {
                                    class: "pull-right",
                                    textContent: (0, _vue.toDisplayString)($setup.getTimeAgo(call.time)),
                                    title: call.time
                                }, null, 8, _hoisted_5)
                            ]),
                            (0, _vue.createElementVNode)("p", _hoisted_6, [
                                (0, _vue.createElementVNode)("span", {
                                    class: (0, _vue.normalizeClass)([
                                        "pull-left btn-sm",
                                        $setup.getStatusBadge(call.status)
                                    ])
                                }, (0, _vue.toDisplayString)(call.status), 3),
                                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("a", {
                                    class: "p-0 pull-right link-underline font-primary"
                                }, [
                                    (0, _vue.createTextVNode)(" Details "),
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fs-6 fa-solid fa-arrow-up-right-from-square"
                                    })
                                ], -1))
                            ])
                        ], 2)
                    ]);
                }), 256))
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPrYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zxDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("5a3e10fca45f3cfa");
    if (script.__esModule) script = script.default;
    script.render = require("2f5e742dac52bbf2").render;
    require("53bb5b21ab4a3276").default(script);
    script.__scopeId = 'data-v-722a03';
    script.__file = "AllServiceProviderRides.vue";
};
initialize();
exports.default = script;

},{"5a3e10fca45f3cfa":"lvhDq","2f5e742dac52bbf2":"2YU80","53bb5b21ab4a3276":"ia7OD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvhDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'AllServiceProviderRides',
    props: {
        serviceProviderId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const ridesUrl = `/api/datatable/sp-all-rides/${props.serviceProviderId}`;
        const dispatchedRidesUrl = `${ridesUrl}?type=DISPATCHED`;
        const orderedRidesUrl = `${ridesUrl}?type=ORDERED`;
        // Define columns
        const allColumnDefinition = [
            {
                title: "Driver",
                data: "driverName",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
                }
            },
            {
                title: "Rider",
                data: "riderName",
                render: (0, _datatableRenderer.potentialUndefinedColumn)
            },
            {
                data: "pickupAddress",
                title: 'Pickup Location',
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(30, true)
            },
            {
                data: "destinationAddress",
                title: 'Destination',
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(30, true)
            },
            {
                data: "status",
                title: 'Status',
                render: (0, _datatableRenderer.rideStatus)
            },
            {
                data: "type",
                title: 'Booking Type',
                render: (0, _datatableRenderer.rideType)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary"" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
                }
            }
        ];
        const columnDefinition = [
            {
                title: "Driver",
                data: "driverName",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
                }
            },
            {
                title: "Rider",
                data: "riderName",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/rider/${row.id}`);
                }
            },
            {
                data: "pickupAddress",
                title: 'Pickup Location',
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(30, true)
            },
            {
                data: "destinationAddress",
                title: 'Destination',
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(30, true)
            },
            {
                data: "status",
                title: 'Status',
                render: (0, _datatableRenderer.rideStatus)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
                }
            }
        ];
        const __returned__ = {
            props,
            ridesUrl,
            dispatchedRidesUrl,
            orderedRidesUrl,
            allColumnDefinition,
            columnDefinition,
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get potentialUndefinedColumn () {
                return 0, _datatableRenderer.potentialUndefinedColumn;
            },
            get rideStatus () {
                return 0, _datatableRenderer.rideStatus;
            },
            get rideType () {
                return 0, _datatableRenderer.rideType;
            },
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2YU80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal-2"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    class: "tab-content",
    id: "icon-tabContent"
};
const _hoisted_4 = {
    class: "tab-pane fade show active",
    id: "all-rides",
    role: "tabpanel",
    "aria-labelledby": "icon-home-tab"
};
const _hoisted_5 = {
    class: "tab-pane fade",
    id: "dispatched-rides",
    role: "tabpanel",
    "aria-labelledby": "profile-icon-tabs"
};
const _hoisted_6 = {
    class: "tab-pane fade",
    id: "ordered-rides",
    role: "tabpanel",
    "aria-labelledby": "contact-icon-tab"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " All Rides")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                class: "card-header card-no-border pb-0"
            }, [
                (0, _vue.createElementVNode)("ul", {
                    class: "nav nav-tabs",
                    id: "icon-tab",
                    role: "tablist"
                }, [
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link active",
                            id: "all-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#all-rides",
                            role: "tab",
                            "aria-controls": "all-rides",
                            "aria-selected": "true"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-taxi text-primary"
                            }),
                            (0, _vue.createTextVNode)(" All Rides ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "dispatched-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#dispatched-rides",
                            role: "tab",
                            "aria-controls": "dispatched-rides",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-user-tie text-secondary"
                            }),
                            (0, _vue.createTextVNode)(" Dispatched Rides ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "ordered-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#ordered-rides",
                            role: "tab",
                            "aria-controls": "ordered-rides",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-mobile-screen-button text-success"
                            }),
                            (0, _vue.createTextVNode)(" Ordered Rides ")
                        ])
                    ])
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                (0, _vue.createElementVNode)("div", _hoisted_3, [
                    (0, _vue.createElementVNode)("div", _hoisted_4, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.ridesUrl
                            },
                            ref: "allRides",
                            class: "table-responsive display",
                            columns: $setup.allColumnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.dispatchedRidesUrl
                            },
                            ref: "dispatchedRides",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.orderedRidesUrl
                            },
                            ref: "orderedRides",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ia7OD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PEuf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("cbd745a9d4b259f");
    if (script.__esModule) script = script.default;
    script.render = require("9e4dac1fdf0f13b3").render;
    require("4dd80ae10396a836").default(script);
    script.__scopeId = 'data-v-6afbb8';
    script.__file = "RideDetail.vue";
};
initialize();
exports.default = script;

},{"cbd745a9d4b259f":"7WPqo","9e4dac1fdf0f13b3":"hCcet","4dd80ae10396a836":"e6p2S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WPqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _vue = require("vue");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
// Google Maps API is loaded via script tag
const zoomLevel = 11;
exports.default = {
    __name: 'RideDetail',
    props: {
        rideId: {
            type: String,
            required: true
        },
        googleMapsApiKey: {
            type: String,
            required: false
        },
        spId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const initialCoordinates = {
            lat: 46.255803,
            lng: -63.136968
        };
        let map = null;
        let googleMaps = null; // Google Maps API reference
        let directionsService = null;
        let directionsRenderer = null;
        const markers = (0, _vue.ref)([]);
        // Ride statuses that indicate an in-session ride
        const IN_SESSION_STATUSES = [
            'TO_PICKUP',
            'WAITING_PICKUP',
            'STOPPED',
            'IN_PROGRESS'
        ];
        const rideData = (0, _vue.ref)(undefined);
        // Computed property to extract the most recent RIDE_PAYMENT transaction
        const ridePaymentTransaction = (0, _vue.computed)(()=>{
            if (!rideData.value || !rideData.value.transactions || rideData.value.transactions.length === 0) return null;
            // Filter for RIDE_PAYMENT transactions
            const ridePayments = rideData.value.transactions.filter((t)=>t.transactionType === 'RIDE_PAYMENT');
            if (ridePayments.length === 0) return null;
            // Sort by createdAt (most recent first) and return the first one
            const sorted = ridePayments.sort((a, b)=>{
                const dateA = new Date(a.createdAt || 0);
                const dateB = new Date(b.createdAt || 0);
                return dateB - dateA;
            });
            return sorted[0];
        });
        // The itemised fare, in the same order and under the same names as the emailed receipt, except that
        // the receipt shows one combined Taxes row where this screen keeps both. Dispatchers quote riders
        // from this screen, so a figure here that disagrees with the receipt reads to the rider as a
        // billing error.
        const money = (amount)=>'$' + (0, _lodashDefault.default).toNumber(amount || 0).toFixed(2);
        const fareBreakdown = (0, _vue.computed)(()=>{
            const fare = rideData.value?.rideFare;
            if (!fare) return [];
            const taxLabel = rideData.value?.serviceJurisdiction?.taxLabel || 'HST';
            const rows = [
                {
                    label: 'Base Fare',
                    amount: fare.baseFare,
                    always: true
                },
                {
                    label: 'Distance Fare',
                    amount: fare.distanceFare,
                    always: true
                },
                {
                    label: 'Time Fare',
                    amount: fare.perMinuteFare
                },
                {
                    label: 'Zone Surcharge',
                    amount: fare.geoZoneSurcharge
                },
                {
                    label: 'Stop Charges',
                    amount: fare.stopFare
                },
                {
                    label: 'Additional Passengers',
                    amount: fare.passengerSurcharge
                },
                {
                    label: 'Scheduled Ride Fee',
                    amount: fare.scheduledRideFee
                },
                {
                    label: 'Platform Fee',
                    amount: fare.platformFeeFlat
                },
                {
                    label: 'Insurance Fee',
                    amount: fare.platformFeeDistance
                },
                {
                    label: fareAdjustmentLabel(fare.fareAdjustmentReason),
                    amount: fare.fareAdjustment
                },
                {
                    label: 'Subtotal',
                    amount: fare.totalFare,
                    always: true
                },
                // The admin view keeps both tax lines where the rider receipt shows one total: which party
                // remits which half is exactly what support and finance open this page to check.
                //
                // Named for both fees, never for the "Platform Fee" row above: taxOnFee is charged on the whole
                // platformFee, so pairing it with the flat half alone reads as a 71% rate on a page opened
                // precisely to check the split.
                {
                    label: taxLabel + ' on fare',
                    amount: fare.taxOnFare
                },
                {
                    label: taxLabel + ' on insurance and platform fees',
                    amount: fare.taxOnFee
                }
            ];
            return rows.filter((row)=>row.always || (0, _lodashDefault.default).toNumber(row.amount || 0) !== 0).map((row)=>({
                    label: row.label,
                    amount: money(row.amount)
                }));
        });
        // Without this row the rows above visibly fail to add up to the total, on any ride a fare floor or a
        // zone cap touched.
        const fareAdjustmentLabel = (reason)=>{
            switch(reason){
                case 'MINIMUM_FARE':
                    return 'Minimum fare adjustment';
                case 'ZONE_MINIMUM_FARE':
                    return 'Zone minimum fare adjustment';
                case 'ZONE_MAXIMUM_FARE':
                    return 'Zone fare cap';
                default:
                    return 'Fare adjustment';
            }
        };
        // totalWithTax, never totalFare: the pre-tax total is the commission base and was never the amount
        // the rider paid.
        const rideCost = (0, _vue.computed)(()=>{
            const fare = rideData.value?.rideFare;
            return fare ? money(fare.totalWithTax ?? fare.totalFare) : '$0.00';
        });
        const loadRideData = async ()=>{
            const response = await fetch(`/api/ride/${props.rideId}`);
            if (response.ok) rideData.value = await response.json();
        };
        const initMap = ()=>{
            if (rideData.value) {
                // Load Google Maps API
                if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                    const script = document.createElement('script');
                    const key = props.googleMapsApiKey;
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&loading=async&libraries=marker&callback=initGoogleMap`;
                    script.async = true;
                    script.defer = true;
                    document.head.appendChild(script);
                    // Define the callback function globally
                    window.initGoogleMap = ()=>{
                        createMap();
                    };
                } else createMap();
            }
        };
        const createMap = ()=>{
            googleMaps = google.maps;
            map = new googleMaps.Map(document.getElementById("map"), {
                center: initialCoordinates,
                zoom: zoomLevel,
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
                mapId: 'f5f337b511d9a28bc10fc480'
            });
            directionsService = new googleMaps.DirectionsService();
            directionsRenderer = new googleMaps.DirectionsRenderer({
                map: map,
                suppressMarkers: true,
                polylineOptions: {
                    strokeColor: '#2563EB',
                    strokeWeight: 4,
                    strokeOpacity: 0.8
                }
            });
            drawRouteAndMarkers();
        };
        const clearMarkers = ()=>{
            markers.value.forEach((marker)=>{
                marker.map = null;
            });
            markers.value = [];
        };
        // Icon size configuration
        const ICON_SIZES = {
            car: {
                width: 30,
                height: 30
            },
            pickup: {
                width: 40,
                height: 40
            },
            destination: {
                width: 40,
                height: 40
            }
        };
        const addMarker = (position, iconType, title)=>{
            const iconPaths = {
                car: '/assets/images/car.png',
                pickup: '/assets/images/img.png',
                destination: '/assets/images/img.png'
            };
            const iconSize = ICON_SIZES[iconType];
            const iconEl = document.createElement('img');
            iconEl.src = iconPaths[iconType];
            iconEl.style.width = `${iconSize.width}px`;
            iconEl.style.height = `${iconSize.height}px`;
            const marker = new googleMaps.marker.AdvancedMarkerElement({
                position,
                map,
                content: iconEl,
                title
            });
            markers.value.push(marker);
            return marker;
        };
        const drawRouteAndMarkers = ()=>{
            if (!rideData.value || !rideData.value.originLocationData) return;
            clearMarkers();
            const origin = rideData.value.originLocationData;
            const destination = rideData.value.destinationLocationData;
            const driver = rideData.value.driver;
            const rideStatus = rideData.value.rideStatus;
            // Check if ride is in session (driver actively working on it)
            const isInSession = IN_SESSION_STATUSES.includes(rideStatus);
            let routeOrigin, waypoints = [], routeDestination;
            if (isInSession && driver && driver.currentLocationData) {
                // For in-session rides: draw driver → pickup → destination
                routeOrigin = {
                    lat: driver.currentLocationData.latitude,
                    lng: driver.currentLocationData.longitude
                };
                // Add driver marker
                addMarker(routeOrigin, 'car', 'Driver Location');
                // Always show pickup location for in-session rides (shows where rider was/is)
                waypoints.push({
                    location: {
                        lat: origin.latitude,
                        lng: origin.longitude
                    },
                    stopover: true
                });
                addMarker({
                    lat: origin.latitude,
                    lng: origin.longitude
                }, 'pickup', 'Pickup Location');
                if (destination && destination.latitude) {
                    routeDestination = {
                        lat: destination.latitude,
                        lng: destination.longitude
                    };
                    addMarker(routeDestination, 'destination', 'Destination');
                }
            } else if (isInSession) {
                // Fallback: in-session but no driver location (show pickup → destination)
                routeOrigin = {
                    lat: origin.latitude,
                    lng: origin.longitude
                };
                addMarker(routeOrigin, 'pickup', 'Pickup Location');
                if (destination && destination.latitude) {
                    routeDestination = {
                        lat: destination.latitude,
                        lng: destination.longitude
                    };
                    addMarker(routeDestination, 'destination', 'Destination');
                }
            } else {
                // For other statuses: draw origin → destination
                routeOrigin = {
                    lat: origin.latitude,
                    lng: origin.longitude
                };
                addMarker(routeOrigin, 'pickup', 'Pickup Location');
                if (destination && destination.latitude) {
                    routeDestination = {
                        lat: destination.latitude,
                        lng: destination.longitude
                    };
                    addMarker(routeDestination, 'destination', 'Destination');
                }
            }
            // Draw route only if we have both origin and destination
            if (routeOrigin && routeDestination) {
                const request = {
                    origin: routeOrigin,
                    destination: routeDestination,
                    waypoints: waypoints,
                    travelMode: googleMaps.TravelMode.DRIVING
                };
                directionsService.route(request, (result, status)=>{
                    if (status === googleMaps.DirectionsStatus.OK) directionsRenderer.setDirections(result);
                    else {
                        console.error('Directions request failed:', status);
                        // If routing fails, at least fit bounds to markers
                        fitBoundsToMarkers();
                    }
                });
            } else {
                // No destination available, just fit bounds to markers
                console.warn('Cannot draw route: missing destination data');
                fitBoundsToMarkers();
            }
        };
        const fitBoundsToMarkers = ()=>{
            if (markers.value.length === 0) return;
            const bounds = new googleMaps.LatLngBounds();
            markers.value.forEach((marker)=>{
                bounds.extend(marker.position);
            });
            map.fitBounds(bounds);
            // Don't zoom in too much if there's only one marker
            if (markers.value.length === 1) {
                const listener = googleMaps.event.addListenerOnce(map, 'idle', ()=>{
                    if (map.getZoom() > 15) map.setZoom(15);
                });
            }
        };
        const formatDate = (value)=>{
            return (0, _momentDefault.default)(value).format('MMM DD YYYY, h:mma');
        };
        // Payment formatting functions
        const formatPaymentMethod = (method)=>{
            if (!method) return 'N/A';
            const methodMap = {
                'CARD': 'Card',
                'CASH': 'Cash',
                'POS_TERMINAL': 'POS Terminal',
                'ACCOUNT': 'Account',
                'BANK_TRANSFER': 'Bank Transfer',
                'OTHER': 'Other'
            };
            return methodMap[method] || method.replace(/_/g, ' ');
        };
        const formatPaymentStatus = (status)=>{
            if (!status) return 'N/A';
            const statusMap = {
                'SUCCESS': 'Success',
                'PENDING': 'Pending',
                'FAILED': 'Failed',
                'CANCELLED': 'Canceled',
                'REFUNDED': 'Refunded',
                'PROCESSING': 'Processing'
            };
            return statusMap[status] || status.replace(/_/g, ' ');
        };
        const getPaymentStatusClass = (status)=>{
            if (!status) return '';
            const classMap = {
                'COMPLETED': 'badge badge-success',
                'PENDING': 'badge badge-warning',
                'FAILED': 'badge badge-danger',
                'CANCELLED': 'badge badge-secondary',
                'REFUNDED': 'badge badge-info',
                'AUTH': 'badge badge-primary'
            };
            return classMap[status] || 'badge badge-secondary';
        };
        const formatAmount = (amount, currency)=>{
            if (amount === null || amount === undefined) return 'N/A';
            const currencySymbol = currency === 'USD' ? '$' : currency || '$';
            return `${currencySymbol.toUpperCase()} ${(0, _lodashDefault.default).toNumber(amount).toFixed(2)}`;
        };
        // Ride cancellation functionality
        const CANCELLABLE_STATUSES = [
            'PENDING',
            'ACCEPTED'
        ];
        const canCancelRide = (0, _vue.computed)(()=>{
            if (!rideData.value) return false;
            return CANCELLABLE_STATUSES.includes(rideData.value.rideStatus);
        });
        const showCancelRideModal = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Cancel Ride',
                text: 'Please provide a reason for cancellation:',
                input: 'textarea',
                inputPlaceholder: 'Enter cancellation reason...',
                showCancelButton: true,
                confirmButtonText: 'Cancel Ride',
                cancelButtonText: 'Close',
                confirmButtonColor: '#dc3545',
                inputValidator: (value)=>{
                    if (!value || value.trim().length === 0) return 'You must provide a reason for cancellation';
                    if (value.trim().length < 5) return 'Please provide a more detailed reason (at least 5 characters)';
                }
            });
            if (result.isConfirmed && result.value) await cancelRide(result.value);
        };
        const cancelRide = async (reason)=>{
            try {
                const response = await fetch(`/api/ride/${props.rideId}/cancel`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        cancellationReason: reason
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'Ride has been cancelled successfully',
                        type: 'success'
                    });
                    // Reload ride data to show updated status
                    await loadRideData();
                } else {
                    const errorText = await response.text();
                    let errorMessage = 'Failed to cancel ride';
                    try {
                        const errorJson = JSON.parse(errorText);
                        errorMessage = errorJson.message || errorMessage;
                    } catch (e) {
                        errorMessage = errorText || errorMessage;
                    }
                    throw new Error(errorMessage);
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to cancel ride',
                    type: 'error'
                });
            }
        };
        (0, _vue.onMounted)(()=>{
            loadRideData().then(()=>{
                initMap();
            });
        });
        const __returned__ = {
            props,
            initialCoordinates,
            zoomLevel,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get googleMaps () {
                return googleMaps;
            },
            set googleMaps (v){
                googleMaps = v;
            },
            get directionsService () {
                return directionsService;
            },
            set directionsService (v){
                directionsService = v;
            },
            get directionsRenderer () {
                return directionsRenderer;
            },
            set directionsRenderer (v){
                directionsRenderer = v;
            },
            markers,
            IN_SESSION_STATUSES,
            rideData,
            ridePaymentTransaction,
            money,
            fareBreakdown,
            fareAdjustmentLabel,
            rideCost,
            loadRideData,
            initMap,
            createMap,
            clearMarkers,
            ICON_SIZES,
            addMarker,
            drawRouteAndMarkers,
            fitBoundsToMarkers,
            formatDate,
            formatPaymentMethod,
            formatPaymentStatus,
            getPaymentStatusClass,
            formatAmount,
            CANCELLABLE_STATUSES,
            canCancelRide,
            showCancelRideModal,
            cancelRide,
            get rideStatus () {
                return 0, _datatableRenderer.rideStatus;
            },
            get rideType () {
                return 0, _datatableRenderer.rideType;
            },
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            get _ () {
                return 0, _lodashDefault.default;
            },
            get moment () {
                return 0, _momentDefault.default;
            },
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"../utility/DatatableRenderer":"gfmyC","vue":"dylud","lodash":"3hMBK","moment":"2meyw","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hCcet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "page-title"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-sm-6 col-12"
};
const _hoisted_5 = [
    "innerHTML"
];
const _hoisted_6 = {
    class: "col-sm-6 col-12 text-end"
};
const _hoisted_7 = {
    key: 0,
    class: "row"
};
const _hoisted_8 = {
    class: "col-sm-6"
};
const _hoisted_9 = {
    class: "col-12"
};
const _hoisted_10 = {
    class: "card height-equal"
};
const _hoisted_11 = {
    key: 0,
    class: "card-body pt-2"
};
const _hoisted_12 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_13 = {
    class: "recent-text"
};
const _hoisted_14 = [
    "innerHTML"
];
const _hoisted_15 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_16 = {
    class: "recent-text"
};
const _hoisted_17 = [
    "innerHTML"
];
const _hoisted_18 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_19 = {
    class: "recent-text"
};
const _hoisted_20 = {
    key: 0
};
const _hoisted_21 = {
    key: 1
};
const _hoisted_22 = {
    key: 0,
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_23 = {
    class: "recent-text"
};
const _hoisted_24 = [
    "href"
];
const _hoisted_25 = {
    class: "flex-grow-1"
};
const _hoisted_26 = {
    class: "recent-text"
};
const _hoisted_27 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_28 = {
    class: "recent-text"
};
const _hoisted_29 = {
    class: "f-w-700"
};
const _hoisted_30 = {
    class: "col-sm-6"
};
const _hoisted_31 = {
    class: "col-12"
};
const _hoisted_32 = {
    class: "card height-equal"
};
const _hoisted_33 = {
    key: 0,
    class: "card-body pt-2"
};
const _hoisted_34 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_35 = {
    class: "recent-text"
};
const _hoisted_36 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_37 = {
    class: "recent-text"
};
const _hoisted_38 = {
    key: 0
};
const _hoisted_39 = {
    key: 1
};
const _hoisted_40 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_41 = {
    class: "recent-text"
};
const _hoisted_42 = {
    key: 0
};
const _hoisted_43 = {
    key: 1
};
const _hoisted_44 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_45 = {
    class: "recent-text"
};
const _hoisted_46 = {
    key: 0
};
const _hoisted_47 = {
    key: 1
};
const _hoisted_48 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_49 = {
    class: "recent-text"
};
const _hoisted_50 = {
    key: 0
};
const _hoisted_51 = {
    key: 1
};
const _hoisted_52 = {
    class: "col-sm-6"
};
const _hoisted_53 = {
    class: "col-12"
};
const _hoisted_54 = {
    class: "card height-equal-2"
};
const _hoisted_55 = {
    class: "card-header d-flex justify-content-between"
};
const _hoisted_56 = [
    "href"
];
const _hoisted_57 = {
    key: 0,
    class: "card-body pt-2"
};
const _hoisted_58 = {
    class: "d-flex align-items-center gap-2 pt-2 border-bottom"
};
const _hoisted_59 = {
    class: "recent-text"
};
const _hoisted_60 = {
    key: 0
};
const _hoisted_61 = {
    key: 1
};
const _hoisted_62 = {
    class: "d-flex align-items-center gap-2 py-2 border-bottom"
};
const _hoisted_63 = {
    class: "recent-text"
};
const _hoisted_64 = {
    key: 0
};
const _hoisted_65 = {
    key: 1
};
const _hoisted_66 = {
    class: "d-flex align-items-center gap-2 py-2 border-bottom"
};
const _hoisted_67 = {
    class: "recent-text"
};
const _hoisted_68 = {
    key: 0
};
const _hoisted_69 = {
    key: 1
};
const _hoisted_70 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_71 = {
    class: "recent-text"
};
const _hoisted_72 = {
    key: 0
};
const _hoisted_73 = {
    key: 1
};
const _hoisted_74 = {
    class: "col-sm-6"
};
const _hoisted_75 = {
    class: "col-12"
};
const _hoisted_76 = {
    class: "card height-equal-2"
};
const _hoisted_77 = {
    key: 0,
    class: "card-body pt-2"
};
const _hoisted_78 = {
    class: "d-flex align-items-center gap-2 pt-2 border-bottom"
};
const _hoisted_79 = {
    class: "recent-text"
};
const _hoisted_80 = {
    key: 0
};
const _hoisted_81 = {
    key: 1
};
const _hoisted_82 = {
    class: "d-flex align-items-center gap-2 py-2 border-bottom"
};
const _hoisted_83 = {
    class: "recent-text"
};
const _hoisted_84 = {
    key: 0
};
const _hoisted_85 = {
    key: 1
};
const _hoisted_86 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_87 = {
    class: "recent-text"
};
const _hoisted_88 = {
    key: 0
};
const _hoisted_89 = {
    key: 1
};
const _hoisted_90 = {
    class: "col-sm-6"
};
const _hoisted_91 = {
    class: "col-12"
};
const _hoisted_92 = {
    class: "card"
};
const _hoisted_93 = {
    key: 0,
    class: "card-body pt-2"
};
const _hoisted_94 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_95 = {
    key: 1
};
const _hoisted_96 = {
    class: "d-flex align-items-center gap-2 pt-2 border-bottom"
};
const _hoisted_97 = {
    class: "recent-text"
};
const _hoisted_98 = {
    class: "d-flex align-items-center gap-2 py-2 border-bottom"
};
const _hoisted_99 = {
    class: "recent-text"
};
const _hoisted_100 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_101 = {
    class: "recent-text"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("h2", null, [
                        _cache[0] || (_cache[0] = (0, _vue.createTextVNode)(" Ride Details ")),
                        $setup.rideData && $setup.rideData.rideStatus ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                            key: 0,
                            class: "fs-4",
                            innerHTML: $setup.rideStatus($setup.rideData.rideStatus)
                        }, null, 8, _hoisted_5)) : (0, _vue.createCommentVNode)("", true)
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_6, [
                    $setup.rideData && $setup.canCancelRide ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 0,
                        class: "btn btn-danger",
                        onClick: $setup.showCancelRideModal
                    }, _cache[1] || (_cache[1] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-xmark"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Cancel Ride ")
                    ]))) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, _cache[2] || (_cache[2] = [
            (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "card"
                }, [
                    (0, _vue.createElementVNode)("div", {
                        id: "map",
                        style: {
                            "height": "45vh",
                            "width": "100%"
                        }
                    })
                ])
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_8, [
            (0, _vue.createElementVNode)("div", _hoisted_9, [
                (0, _vue.createElementVNode)("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h3", null, "Ride Information")
                    ], -1)),
                    $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                        (0, _vue.createElementVNode)("ul", null, [
                            (0, _vue.createElementVNode)("li", _hoisted_12, [
                                _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Status")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_13, [
                                    (0, _vue.createElementVNode)("h5", {
                                        innerHTML: $setup.rideStatus($setup.rideData.rideStatus)
                                    }, null, 8, _hoisted_14)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_15, [
                                _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Booking Type")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_16, [
                                    (0, _vue.createElementVNode)("h5", {
                                        innerHTML: $setup.rideType($setup.rideData.bookingType)
                                    }, null, 8, _hoisted_17)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_18, [
                                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Ordered On")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_19, [
                                    $setup.rideData.orderDateTime ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_20, (0, _vue.toDisplayString)($setup.formatDate($setup.rideData.orderDateTime)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_21, " N/A"))
                                ])
                            ]),
                            $setup.rideData.dispatcherFullName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_22, [
                                _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Dispatcher")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_23, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        (0, _vue.createElementVNode)("a", {
                                            href: `/service-provider/${$setup.props.spId}/dispatch-user/${$setup.rideData.dispatcherId}`,
                                            class: "fs-6 link-primary",
                                            target: "_blank"
                                        }, [
                                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.rideData.dispatcherFullName) + " ", 1),
                                            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-arrow-up-right-from-square"
                                            }, null, -1))
                                        ], 8, _hoisted_24)
                                    ])
                                ])
                            ])) : (0, _vue.createCommentVNode)("", true),
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.fareBreakdown, (row)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                                    key: row.label,
                                    class: "d-flex align-items-center gap-2 pt-2"
                                }, [
                                    (0, _vue.createElementVNode)("div", _hoisted_25, [
                                        (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)(row.label), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_26, [
                                        (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)(row.amount), 1)
                                    ])
                                ]);
                            }), 128)),
                            (0, _vue.createElementVNode)("li", _hoisted_27, [
                                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Ride Cost")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_28, [
                                    (0, _vue.createElementVNode)("h5", _hoisted_29, (0, _vue.toDisplayString)($setup.rideCost), 1)
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_30, [
            (0, _vue.createElementVNode)("div", _hoisted_31, [
                (0, _vue.createElementVNode)("div", _hoisted_32, [
                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h3", null, "Location & Distance Information")
                    ], -1)),
                    $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_33, [
                        (0, _vue.createElementVNode)("ul", null, [
                            (0, _vue.createElementVNode)("li", _hoisted_34, [
                                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Pickup Location")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_35, [
                                    (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.rideData.originLocationData.address), 1)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_36, [
                                _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Destination")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_37, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.destinationLocationData.address ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_38, (0, _vue.toDisplayString)($setup.rideData.destinationLocationData.address), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_39, " N/A "))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_40, [
                                _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Distance")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_41, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.distanceFormatted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_42, (0, _vue.toDisplayString)($setup.rideData.distanceFormatted), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_43, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_44, [
                                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Ride Start Time")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_45, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.orderFulfilmentDateTime ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_46, (0, _vue.toDisplayString)($setup.formatDate($setup.rideData.orderFulfilmentDateTime)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_47, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_48, [
                                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Ride Duration")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_49, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.durationFormatted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_50, (0, _vue.toDisplayString)($setup.rideData.durationFormatted), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_51, " N/A"))
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_52, [
            (0, _vue.createElementVNode)("div", _hoisted_53, [
                (0, _vue.createElementVNode)("div", _hoisted_54, [
                    (0, _vue.createElementVNode)("div", _hoisted_55, [
                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("h3", null, "Driver Information", -1)),
                        $setup.rideData && $setup.rideData.driver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                            key: 0,
                            class: "btn btn-sm btn-outline-primary",
                            href: `/service-provider/${$setup.props.spId}/driver/${$setup.rideData.driver.id}`,
                            target: "_blank"
                        }, _cache[16] || (_cache[16] = [
                            (0, _vue.createTextVNode)(" Details "),
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-arrow-up-right-from-square"
                            }, null, -1)
                        ]), 8, _hoisted_56)) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_57, [
                        (0, _vue.createElementVNode)("ul", null, [
                            (0, _vue.createElementVNode)("li", _hoisted_58, [
                                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Name")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_59, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.driver && $setup.rideData.driver.fullName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_60, (0, _vue.toDisplayString)($setup.rideData.driver.fullName), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_61, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_62, [
                                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Email")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_63, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.driver && $setup.rideData.driver.email ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_64, (0, _vue.toDisplayString)($setup.rideData.driver.email), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_65, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_66, [
                                _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Phone Number")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_67, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.driver && $setup.rideData.driver.phoneNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_68, (0, _vue.toDisplayString)($setup.rideData.driver.phoneNumber), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_69, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_70, [
                                _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Rating")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_71, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.driver && $setup.rideData.driver.rating ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_72, (0, _vue.toDisplayString)($setup.rideData.driver.rating) + "/5 ", 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_73, " N/A"))
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_74, [
            (0, _vue.createElementVNode)("div", _hoisted_75, [
                (0, _vue.createElementVNode)("div", _hoisted_76, [
                    _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                        class: "card-header d-flex justify-content-between"
                    }, [
                        (0, _vue.createElementVNode)("h3", null, "Rider Information")
                    ], -1)),
                    $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_77, [
                        (0, _vue.createElementVNode)("ul", null, [
                            (0, _vue.createElementVNode)("li", _hoisted_78, [
                                _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Name")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_79, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.rider && $setup.rideData.rider.fullName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_80, (0, _vue.toDisplayString)($setup.rideData.rider.fullName), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_81, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_82, [
                                _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Email")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_83, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.rider && $setup.rideData.rider.email ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_84, (0, _vue.toDisplayString)($setup.rideData.rider.email), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_85, " N/A"))
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_86, [
                                _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Phone Number")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_87, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        $setup.rideData.rider && $setup.rideData.rider.phoneNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_88, (0, _vue.toDisplayString)($setup.rideData.rider.phoneNumber), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_89, " N/A"))
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_90, [
            (0, _vue.createElementVNode)("div", _hoisted_91, [
                (0, _vue.createElementVNode)("div", _hoisted_92, [
                    _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h3", null, "Payment Information")
                    ], -1)),
                    $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_93, [
                        !$setup.ridePaymentTransaction ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_94, _cache[26] || (_cache[26] = [
                            (0, _vue.createElementVNode)("h5", {
                                class: "text-muted"
                            }, "Payment Pending", -1)
                        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_95, [
                            (0, _vue.createElementVNode)("li", _hoisted_96, [
                                _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Payment Method")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_97, [
                                    (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.formatPaymentMethod($setup.ridePaymentTransaction.paymentMethod)), 1)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_98, [
                                _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Payment Status")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_99, [
                                    (0, _vue.createElementVNode)("h5", null, [
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)($setup.getPaymentStatusClass($setup.ridePaymentTransaction.transactionStatus))
                                        }, (0, _vue.toDisplayString)($setup.formatPaymentStatus($setup.ridePaymentTransaction.transactionStatus)), 3)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("li", _hoisted_100, [
                                _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("div", {
                                    class: "flex-grow-1"
                                }, [
                                    (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-700"
                                    }, "Amount Paid")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_101, [
                                    (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.formatAmount($setup.ridePaymentTransaction.totalAmount || $setup.ridePaymentTransaction.amount, $setup.ridePaymentTransaction.currency)), 1)
                                ])
                            ])
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e6p2S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5drVj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("6bfaab28c86e7f20");
    if (script.__esModule) script = script.default;
    script.render = require("c93265bf23b84183").render;
    require("27c7479c55592e49").default(script);
    script.__scopeId = 'data-v-cf0b4e';
    script.__file = "DriverDetail.vue";
};
initialize();
exports.default = script;

},{"6bfaab28c86e7f20":"4o3DF","c93265bf23b84183":"jZfH0","27c7479c55592e49":"bbgjh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4o3DF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _timeagoJs = require("timeago.js");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _driverBackgroundCheckPanelVue = require("./DriverBackgroundCheckPanel.vue");
var _driverBackgroundCheckPanelVueDefault = parcelHelpers.interopDefault(_driverBackgroundCheckPanelVue);
var _driverTaxRegistrationPanelVue = require("./DriverTaxRegistrationPanel.vue");
var _driverTaxRegistrationPanelVueDefault = parcelHelpers.interopDefault(_driverTaxRegistrationPanelVue);
// Google Maps API is loaded via script tag
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _jqueryUi = require("jquery-ui");
var _addressHelper = require("../utility/addressHelper");
var _globalsJs = require("../globals.js");
const zoomLevel = 11;
exports.default = {
    __name: 'DriverDetail',
    props: {
        serviceProviderId: {
            type: String,
            required: true
        },
        driverId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        },
        googleMapsApiKey: {
            type: String,
            required: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const isNewDriver = (0, _vue.ref)(props.driverId === (0, _globalsJs.newEntityId));
        const initialCoordinates = {
            lat: 46.255803,
            lng: -63.136968
        };
        let map = null;
        let googleMaps = null; // Google Maps API reference
        // List of countries for the dropdown
        const countries = [
            "Canada",
            "United States"
        ];
        // Reference to the address input element
        let addressInput = null;
        // Initialize address autocomplete
        const initAddressAutocomplete = ()=>{
            $(addressInput).autocomplete({
                source: (request, response)=>{
                    fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(request.term)}`).then((res)=>{
                        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                        return res.json();
                    }).then((data)=>{
                        const suggestions = data.results.map((result)=>({
                                label: (0, _addressHelper.renderWithPoi)(result),
                                value: result.address.freeformAddress,
                                result
                            }));
                        response(suggestions);
                    }).catch((error)=>{
                        console.error('Error fetching suggestions:', error);
                        response([]);
                    });
                },
                minLength: 3,
                select: (event, ui)=>{
                    // Parse the address data and populate the form fields
                    const addressData = ui.item.result;
                    // Set the address field to the freeform address
                    driverFormData.value.state.address = addressData.address.freeformAddress;
                    // Extract and set city, state, zip code, and country
                    if (addressData.address.municipality) driverFormData.value.state.city = addressData.address.municipality;
                    if (addressData.address.countrySubdivision) driverFormData.value.state.state = addressData.address.countrySubdivision;
                    if (addressData.address.extendedPostalCode) driverFormData.value.state.zipCode = addressData.address.extendedPostalCode;
                    if (addressData.address.country) driverFormData.value.state.country = addressData.address.country;
                }
            }).autocomplete('instance')._renderItem = (ul, item)=>{
                return $('<li>').append(item.label).appendTo(ul);
            };
        };
        const driverData = (0, _vue.ref)(undefined);
        const editDriverInfo = (0, _vue.ref)(false);
        const isProcessing = (0, _vue.ref)(false);
        const ridesDataTable = (0, _vue.ref)(null);
        const reviewsDataTable = (0, _vue.ref)(null);
        const driverFormData = (0, _vue.ref)({});
        // Define columns for rides datatable
        const ridesColumns = [
            {
                data: "origin",
                title: "Pickup",
                render: (data, type, row)=>{
                    return row?.originLocationData?.address || 'N/A';
                }
            },
            {
                data: "destination",
                title: "Destination",
                render: (data, type, row)=>{
                    return row?.destinationLocationData?.address || 'N/A';
                }
            },
            {
                data: "rideStatus",
                title: "Status",
                render: (0, _datatableRenderer.rideStatus)
            },
            {
                data: "fare",
                title: "Fare",
                render: (data, type, row)=>{
                    // totalWithTax is what the rider paid; totalFare is the pre-tax commission base. Formatted,
                    // because the raw column serialises at whatever scale it was stored with.
                    if (!row?.rideFare) return 'N/A';
                    const charged = row.rideFare.totalWithTax ?? row.rideFare.totalFare;
                    return '$' + Number(charged || 0).toFixed(2);
                }
            },
            {
                data: "orderDateTime",
                title: "Date",
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: '',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return `<a class="btn btn-sm btn-outline-primary" target="blank" href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i></a>`;
                }
            }
        ];
        // Define columns for reviews datatable
        const reviewsColumns = [
            {
                data: "rider",
                title: "Rider",
                render: (data, type, row)=>{
                    return row?.reviewerNameAbbreviated ? row?.reviewerNameAbbreviated : 'N/A';
                }
            },
            {
                data: "createdOn",
                title: "Date",
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: "rating",
                title: "Rating",
                render: (data, type, row)=>{
                    let stars = '';
                    for(let i = 1; i <= 5; i++)stars += `<i class="fa-solid fa-star ${i <= data ? 'text-warning' : 'text-muted'}"></i>`;
                    return stars;
                }
            },
            {
                data: "review",
                title: "Review"
            }
        ];
        const formatTime = (value)=>{
            return `${(0, _momentDefault.default)(value).format('MMM DD, YYYY')} (${(0, _timeagoJs.format)(new Date(value))})`;
        };
        /*
* Form edit functionality
* */ const toggleEditMode = ()=>{
            editDriverInfo.value = !editDriverInfo.value;
        };
        const cancelCallback = ()=>{
            toggleEditMode();
        };
        const saveCallback = ()=>{
            loadDriverData();
            toggleEditMode();
        };
        const initMap = ()=>{
            if (driverData.value && driverData.value.driverStatus !== 'OFFLINE') {
                // Load Google Maps API
                if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                    const key = props.googleMapsApiKey;
                    if (!key) {
                        console.error("DriverDetail: googleMapsApiKey prop is missing \u2014 map will not load.");
                        return;
                    }
                    const script = document.createElement('script');
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&loading=async&libraries=marker&callback=initGoogleMap`;
                    script.async = true;
                    script.defer = true;
                    document.head.appendChild(script);
                    // Define the callback function globally
                    window.initGoogleMap = ()=>{
                        createMap();
                    };
                } else createMap();
            }
        };
        const createMap = ()=>{
            googleMaps = google.maps;
            map = new googleMaps.Map(document.getElementById("map"), {
                center: initialCoordinates,
                zoom: zoomLevel,
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
                mapId: 'f5f337b511d9a28bc10fc480'
            });
            // Add driver marker if driver has current location
            if (driverData.value && driverData.value.currentLocationData) {
                const driverLocation = {
                    lat: driverData.value.currentLocationData.latitude,
                    lng: driverData.value.currentLocationData.longitude
                };
                // Build a custom car icon element for AdvancedMarkerElement
                const carIcon = document.createElement('img');
                carIcon.src = '/assets/images/car.png';
                carIcon.style.width = '30px';
                carIcon.style.height = '30px';
                new googleMaps.marker.AdvancedMarkerElement({
                    position: driverLocation,
                    map: map,
                    content: carIcon,
                    title: `Driver: ${driverData.value.name || 'Unknown'}`
                });
                // Center map on driver location
                map.setCenter(driverLocation);
                map.setZoom(14);
            }
        };
        const loadDriverData = async ()=>{
            if (!isNewDriver.value) {
                const response = await fetch(`/api/driver-detail/${props.driverId}`);
                if (response.ok) driverData.value = await response.json();
            }
        };
        const showResetPasswordConfirmation = ()=>{
            if (!driverData.value) return;
            // Show the reset password confirmation using SweetAlert
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Reset Password',
                text: `Are you sure you want to send a password reset email for ${driverData.value.name}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Reset Password',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
            }).then((result)=>{
                if (result.isConfirmed) resetPassword();
            });
        };
        const resetPassword = async ()=>{
            if (!driverData.value) return;
            isProcessing.value = true;
            try {
                // Call the API endpoint to send a password reset email
                const response = await fetch(`/api/authenticate/send-password-reset/${driverData.value.id}`, {
                    method: 'POST'
                });
                if (response.ok) // Show success message
                (0, _toastNotificationUtility.showToast)({
                    title: 'success',
                    body: `Password reset email for ${driverData.value.name} has been sent.`,
                    type: 'success',
                    delay: 7000
                });
                else {
                    // Get the error message from the response
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to send password reset email');
                }
            } catch (error) {
                console.error('Error resetting password:', error);
                // Show error message
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: error.message || 'There was an error sending the password reset email. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        const showSendInviteConfirmation = ()=>{
            if (!driverData.value) return;
            // Check if user has an email
            if (!driverData.value.email) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: 'This driver does not have an email address. Please add an email address before sending an invite.',
                    type: 'error',
                    delay: 7000
                });
                return;
            }
            // Show the send invite confirmation using SweetAlert
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Send Registration Invite',
                text: `Are you sure you want to send a registration invite to ${driverData.value.name} at ${driverData.value.email}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Send Invite',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d'
            }).then((result)=>{
                if (result.isConfirmed) sendInvite();
            });
        };
        const sendInvite = async ()=>{
            if (!driverData.value || !driverData.value.email) return;
            isProcessing.value = true;
            try {
                // Call the API endpoint to send an invitation email
                const response = await fetch(`/api/authenticate/send-invitation/${driverData.value.id}`, {
                    method: 'POST'
                });
                if (response.ok) // Show success message
                (0, _toastNotificationUtility.showToast)({
                    title: 'success',
                    body: `Registration invite has been sent to ${driverData.value.email}.`,
                    type: 'success',
                    delay: 7000
                });
                else {
                    // Get the error message from the response
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to send registration invite');
                }
            } catch (error) {
                console.error('Error sending invite:', error);
                // Show error message
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: error.message || 'There was an error sending the registration invite. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        const showResendStatusEmailConfirmation = ()=>{
            if (!driverData.value) return;
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Resend Status Email',
                text: `Send the application status email to ${driverData.value.name} at ${driverData.value.email}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Send Email',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#6c757d'
            }).then((result)=>{
                if (result.isConfirmed) resendStatusEmail();
            });
        };
        const resendStatusEmail = async ()=>{
            if (!driverData.value) return;
            isProcessing.value = true;
            try {
                const response = await fetch(`/api/admin/driver/${driverData.value.id}/resend-status-email`, {
                    method: 'POST'
                });
                if (response.ok) (0, _toastNotificationUtility.showToast)({
                    title: 'success',
                    body: `Application status email sent to ${driverData.value.email}.`,
                    type: 'success',
                    delay: 7000
                });
                else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to send status email');
                }
            } catch (error) {
                console.error('Error sending status email:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: error.message || 'There was an error sending the status email. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        const downloadLicense = async ()=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/download-license`);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `driver-${props.driverId}-license.jpg`;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                } else throw new Error('Failed to download license document');
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to download license document',
                    type: 'error'
                });
            }
        };
        const verifyLicense = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Approve License',
                text: 'Are you sure you want to approve this driver\'s license?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745'
            });
            if (!result.isConfirmed) return;
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-license`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: true
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'License has been approved',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to approve license');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to approve license',
                    type: 'error'
                });
            }
        };
        const showRejectLicenseModal = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Reject License',
                text: 'Please provide a reason for rejection:',
                input: 'textarea',
                inputPlaceholder: 'Enter rejection reason...',
                showCancelButton: true,
                confirmButtonText: 'Reject',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#dc3545',
                inputValidator: (value)=>{
                    if (!value) return 'You must provide a reason for rejection';
                }
            });
            if (result.isConfirmed && result.value) await rejectLicense(result.value);
        };
        const rejectLicense = async (reason)=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-license`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: false,
                        rejectionReason: reason
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'License has been rejected',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to reject license');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to reject license',
                    type: 'error'
                });
            }
        };
        const verifyVehicle = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Approve Vehicle Photos',
                text: 'Are you sure you want to approve this driver\'s vehicle photos?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745'
            });
            if (!result.isConfirmed) return;
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-vehicle`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: true
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'Vehicle photos have been approved',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to approve vehicle photos');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to approve vehicle photos',
                    type: 'error'
                });
            }
        };
        const showRejectVehicleModal = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Reject Vehicle Photos',
                text: 'Please provide a reason for rejection:',
                input: 'textarea',
                inputPlaceholder: 'Enter rejection reason...',
                showCancelButton: true,
                confirmButtonText: 'Reject',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#dc3545',
                inputValidator: (value)=>{
                    if (!value) return 'You must provide a reason for rejection';
                }
            });
            if (result.isConfirmed && result.value) await rejectVehicle(result.value);
        };
        const rejectVehicle = async (reason)=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-vehicle`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: false,
                        rejectionReason: reason
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'Vehicle photos have been rejected',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to reject vehicle photos');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to reject vehicle photos',
                    type: 'error'
                });
            }
        };
        const downloadVehiclePhotos = async ()=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/download-vehicle-photos`);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `driver-${props.driverId}-vehicle-photos.png`;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                } else throw new Error('Failed to download vehicle photos');
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to download vehicle photos',
                    type: 'error'
                });
            }
        };
        const downloadInsurance = async ()=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/download-insurance`);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `driver-${props.driverId}-insurance.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                } else throw new Error('Failed to download insurance document');
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to download insurance document',
                    type: 'error'
                });
            }
        };
        const verifyInsurance = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Approve Insurance',
                text: 'Are you sure you want to approve this driver\'s insurance document?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745'
            });
            if (!result.isConfirmed) return;
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-insurance`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: true
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'Insurance document has been approved',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to approve insurance');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to approve insurance',
                    type: 'error'
                });
            }
        };
        const showRejectInsuranceModal = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Reject Insurance',
                text: 'Please provide a reason for rejection:',
                input: 'textarea',
                inputPlaceholder: 'Enter rejection reason...',
                showCancelButton: true,
                confirmButtonText: 'Reject',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#dc3545',
                inputValidator: (value)=>{
                    if (!value) return 'You must provide a reason for rejection';
                }
            });
            if (result.isConfirmed && result.value) await rejectInsurance(result.value);
        };
        const rejectInsurance = async (reason)=>{
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/verify-insurance`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        approved: false,
                        reason: reason
                    })
                });
                if (response.ok) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Success',
                        body: 'Insurance document has been rejected',
                        type: 'success'
                    });
                    await loadDriverData();
                } else {
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to reject insurance');
                }
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Failed to reject insurance',
                    type: 'error'
                });
            }
        };
        (0, _vue.onMounted)(()=>{
            if (!isNewDriver.value) loadDriverData().then(()=>{
                initMap();
            });
            // Initialize address autocomplete after the component is mounted
            (0, _vue.nextTick)(()=>{
                if (isNewDriver.value || editDriverInfo.value) {
                    addressInput = document.getElementById('driver-address-input');
                    if (addressInput) initAddressAutocomplete();
                }
            });
        });
        const __returned__ = {
            props,
            isNewDriver,
            initialCoordinates,
            zoomLevel,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get googleMaps () {
                return googleMaps;
            },
            set googleMaps (v){
                googleMaps = v;
            },
            countries,
            get addressInput () {
                return addressInput;
            },
            set addressInput (v){
                addressInput = v;
            },
            initAddressAutocomplete,
            driverData,
            editDriverInfo,
            isProcessing,
            ridesDataTable,
            reviewsDataTable,
            driverFormData,
            ridesColumns,
            reviewsColumns,
            formatTime,
            toggleEditMode,
            cancelCallback,
            saveCallback,
            initMap,
            createMap,
            loadDriverData,
            showResetPasswordConfirmation,
            resetPassword,
            showSendInviteConfirmation,
            sendInvite,
            showResendStatusEmailConfirmation,
            resendStatusEmail,
            downloadLicense,
            verifyLicense,
            showRejectLicenseModal,
            rejectLicense,
            verifyVehicle,
            showRejectVehicleModal,
            rejectVehicle,
            downloadVehiclePhotos,
            downloadInsurance,
            verifyInsurance,
            showRejectInsuranceModal,
            rejectInsurance,
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref),
            nextTick: (0, _vue.nextTick),
            get moment () {
                return 0, _momentDefault.default;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            },
            get rideStatus () {
                return 0, _datatableRenderer.rideStatus;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get format () {
                return 0, _timeagoJs.format;
            },
            EntityForm: (0, _entityFormVueDefault.default),
            DriverBackgroundCheckPanel: (0, _driverBackgroundCheckPanelVueDefault.default),
            DriverTaxRegistrationPanel: (0, _driverTaxRegistrationPanelVueDefault.default),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment":"2meyw","../utility/DatatableRenderer":"gfmyC","timeago.js":"aPiEQ","./EntityForm.vue":"i0zng","./DriverBackgroundCheckPanel.vue":"6cW9N","./DriverTaxRegistrationPanel.vue":"a5DuE","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../utility/toastNotificationUtility":"krOtg","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","jquery-ui":"6clbD","../utility/addressHelper":"3Hmtq","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cW9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("ea8e558f0ae2850");
    if (script.__esModule) script = script.default;
    script.render = require("e9c2e97c61d501c5").render;
    require("59342f64818046df").default(script);
    script.__scopeId = 'data-v-57f616';
    script.__file = "DriverBackgroundCheckPanel.vue";
};
initialize();
exports.default = script;

},{"ea8e558f0ae2850":"29ay1","e9c2e97c61d501c5":"c8Tyg","59342f64818046df":"zWOoz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29ay1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'DriverBackgroundCheckPanel',
    props: {
        driverId: String
    },
    emits: [
        'resolved'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const summary = (0, _vue.ref)(null);
        const loading = (0, _vue.ref)(true);
        const loadError = (0, _vue.ref)('');
        const isProcessing = (0, _vue.ref)(false);
        const STATUS_LABELS = {
            NOT_STARTED: 'Not Started',
            IN_PROGRESS: 'In Progress',
            PASSED: 'Passed',
            FAILED: 'Failed',
            ACTION_REQUIRED: 'Action Required'
        };
        const STATUS_CLASSES = {
            NOT_STARTED: 'bg-secondary',
            IN_PROGRESS: 'bg-info',
            PASSED: 'bg-success',
            FAILED: 'bg-danger',
            ACTION_REQUIRED: 'bg-warning'
        };
        const statusLabel = (0, _vue.computed)(()=>STATUS_LABELS[summary.value?.status] || 'Not Started');
        const statusClass = (0, _vue.computed)(()=>STATUS_CLASSES[summary.value?.status] || 'bg-secondary');
        // A retry after a failed check is a fresh attempt, not an edit of the old one — say so on the button
        // so an admin does not think they are correcting a mistake in place.
        const initiateLabel = (0, _vue.computed)(()=>summary.value?.status === 'NOT_STARTED' ? 'Initiate Background Check' : 'Send a New Check Link');
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        // The same second gate the driver-facing page applies. Vue does not sanitise a bound href, and this
        // renders an admin-typed value, so both renderers must refuse anything that is not https -- otherwise a
        // future relaxation of DriverBackgroundCheckValidator reopens it here alone.
        const safeCheckUrl = (0, _vue.computed)(()=>{
            const url = summary.value?.checkUrl;
            return typeof url === 'string' && url.startsWith('https://') ? url : null;
        });
        // These endpoints use AdminUserAuthorizer, whose onUnauthorized REDIRECTS to /not-authorized — an
        // entire rendered HTML page. fetch follows the 303, so response.text() is that document; echoing it
        // would drop a full page of markup into a toast. Reachable for a DispatchUser admin, who can still use
        // the verify-license and verify-vehicle buttons on this same page.
        const errorTextFrom = async (response, fallback)=>{
            if (response.status === 401 || response.status === 403) return 'You do not have permission to manage background checks.';
            const body = await response.text();
            if (!body || body.trimStart().startsWith('<')) return fallback;
            return body;
        };
        // `silent` keeps the card mounted during a post-action reload. Without it the root v-if="!loading"
        // unmounts the whole card, so the spinner the admin should see disappears along with the button.
        const fetchSummary = async (silent = false)=>{
            loading.value = !silent;
            loadError.value = '';
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/background-check`);
                if (!response.ok) throw new Error(await errorTextFrom(response, 'Failed to load background check'));
                summary.value = await response.json();
            } catch (error) {
                // A failed read must not render as "no check on file": an admin who believes that will send a
                // second link to a driver who already has a live one.
                loadError.value = error.message || 'Could not load this driver\'s background check.';
            } finally{
                loading.value = false;
            }
        };
        const post = async (path, body, successMessage)=>{
            isProcessing.value = true;
            try {
                const response = await fetch(`/api/admin/driver/${props.driverId}/${path}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                });
                if (!response.ok) throw new Error(await errorTextFrom(response, 'Request failed'));
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: successMessage,
                    type: 'success',
                    delay: 7000
                });
                await fetchSummary(true);
                emit('resolved');
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: error.message || 'Something went wrong. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        const showInitiateDialog = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: initiateLabel.value,
                html: '<p class="text-start small mb-0">Paste the Certn invite link for this driver. We\'ll email it to them and show it on their application status page.</p>',
                input: 'url',
                inputPlaceholder: 'https://...',
                inputAttributes: {
                    'aria-label': 'Certn invite link'
                },
                showCancelButton: true,
                confirmButtonText: 'Send Link',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                inputValidator: (value)=>{
                    if (!value || !value.trim()) return 'A background check link is required';
                    if (!value.trim().startsWith('https://')) return 'The link must be a full https:// URL';
                    return undefined;
                }
            });
            if (result.isConfirmed && result.value) await post('initiate-background-check', {
                checkUrl: result.value.trim()
            }, 'Background check link sent to the driver.');
        };
        // SweetAlert2 supports one native input, and this dialog needs three — hence custom html and a
        // preConfirm that reads them back. First multi-field dialog in this codebase.
        const showResultDialog = async ()=>{
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Enter Background Check Results',
                html: `
      <div class="text-start">
        <label class="form-label fw-semibold" for="bgc-application-id">Certn Application ID</label>
        <input id="bgc-application-id" class="form-control" type="text"
               placeholder="From the Certn dashboard" autocomplete="off">
        <div class="form-text mb-3">The reference only &mdash; do not paste report details.</div>

        <label class="form-label fw-semibold d-block">Decision</label>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="bgc-decision" id="bgc-approve" value="approve" checked>
          <label class="form-check-label" for="bgc-approve">Approve &mdash; the check passed</label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="bgc-decision" id="bgc-reject" value="reject">
          <label class="form-check-label" for="bgc-reject">Reject &mdash; the check did not pass</label>
        </div>

        <label class="form-label fw-semibold" for="bgc-reason">Reason</label>
        <textarea id="bgc-reason" class="form-control" rows="3"
                  placeholder="Required when rejecting"></textarea>
        <div class="form-text">Internal record only. The driver is never sent this reason &mdash; their
          email simply asks them to contact support.</div>
      </div>`,
                showCancelButton: true,
                confirmButtonText: 'Save Result',
                cancelButtonText: 'Cancel',
                focusConfirm: false,
                preConfirm: ()=>{
                    const popup = (0, _sweetalert2MinDefault.default).getPopup();
                    const certnApplicationId = popup.querySelector('#bgc-application-id').value.trim();
                    const approved = popup.querySelector('#bgc-reject').checked === false;
                    const reason = popup.querySelector('#bgc-reason').value.trim();
                    if (!certnApplicationId) {
                        (0, _sweetalert2MinDefault.default).showValidationMessage('The Certn application ID is required');
                        return false;
                    }
                    if (!approved && !reason) {
                        (0, _sweetalert2MinDefault.default).showValidationMessage('A reason is required when rejecting a background check');
                        return false;
                    }
                    return {
                        certnApplicationId,
                        approved,
                        reason
                    };
                }
            });
            if (result.isConfirmed && result.value) await post('background-check-result', result.value, result.value.approved ? 'Background check approved.' : 'Background check rejected.');
        };
        (0, _vue.onMounted)(fetchSummary);
        const __returned__ = {
            props,
            emit,
            summary,
            loading,
            loadError,
            isProcessing,
            STATUS_LABELS,
            STATUS_CLASSES,
            statusLabel,
            statusClass,
            initiateLabel,
            formatDate,
            safeCheckUrl,
            errorTextFrom,
            fetchSummary,
            post,
            showInitiateDialog,
            showResultDialog,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8Tyg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "alert alert-danger mb-0"
};
const _hoisted_4 = {
    class: "mb-3"
};
const _hoisted_5 = {
    key: 0,
    class: "row mb-3"
};
const _hoisted_6 = {
    class: "col-sm-8"
};
const _hoisted_7 = {
    class: "col-sm-8 text-break"
};
const _hoisted_8 = [
    "href"
];
const _hoisted_9 = {
    key: 1,
    class: "text-danger"
};
const _hoisted_10 = {
    class: "col-sm-8 text-break"
};
const _hoisted_11 = {
    class: "col-sm-8"
};
const _hoisted_12 = {
    class: "col-sm-8"
};
const _hoisted_13 = {
    key: 1,
    class: "alert alert-warning"
};
const _hoisted_14 = {
    class: "d-flex flex-wrap gap-2"
};
const _hoisted_15 = [
    "disabled"
];
const _hoisted_16 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_17 = {
    key: 1,
    class: "fa-solid fa-paper-plane me-1"
};
const _hoisted_18 = [
    "disabled"
];
const _hoisted_19 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_20 = {
    key: 1,
    class: "fa-solid fa-clipboard-check me-1"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return !$setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("div", {
            class: "card-header bg-white"
        }, [
            (0, _vue.createElementVNode)("h5", {
                class: "mb-0"
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa-solid fa-shield me-2"
                }),
                (0, _vue.createTextVNode)("Background Check")
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.loadError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("i", {
                    class: "fa fa-exclamation-triangle me-2"
                }, null, -1)),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.loadError) + " ", 1),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-sm btn-outline-danger ms-2",
                    onClick: $setup.fetchSummary
                }, "Retry")
            ])) : $setup.summary ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("span", {
                        class: "fw-semibold me-2"
                    }, "Status:", -1)),
                    (0, _vue.createElementVNode)("span", {
                        class: (0, _vue.normalizeClass)([
                            "badge",
                            $setup.statusClass
                        ])
                    }, (0, _vue.toDisplayString)($setup.statusLabel), 3)
                ]),
                $setup.summary.invitedOn ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("dl", _hoisted_5, [
                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Link Sent", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_6, (0, _vue.toDisplayString)($setup.formatDate($setup.summary.invitedOn)), 1),
                    $setup.summary.checkUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 0
                    }, [
                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("dt", {
                            class: "col-sm-4"
                        }, "Certn Link", -1)),
                        (0, _vue.createElementVNode)("dd", _hoisted_7, [
                            $setup.safeCheckUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                                key: 0,
                                href: $setup.safeCheckUrl,
                                target: "_blank",
                                rel: "noopener noreferrer"
                            }, (0, _vue.toDisplayString)($setup.safeCheckUrl), 9, _hoisted_8)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_9, (0, _vue.toDisplayString)($setup.summary.checkUrl) + " (not a valid https link)", 1))
                        ])
                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                    $setup.summary.certnApplicationId ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 1
                    }, [
                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("dt", {
                            class: "col-sm-4"
                        }, "Application ID", -1)),
                        (0, _vue.createElementVNode)("dd", _hoisted_10, [
                            (0, _vue.createElementVNode)("code", null, (0, _vue.toDisplayString)($setup.summary.certnApplicationId), 1)
                        ])
                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                    $setup.summary.decidedOn ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 2
                    }, [
                        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("dt", {
                            class: "col-sm-4"
                        }, "Decided", -1)),
                        (0, _vue.createElementVNode)("dd", _hoisted_11, (0, _vue.toDisplayString)($setup.formatDate($setup.summary.decidedOn)), 1)
                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                    $setup.summary.decisionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 3
                    }, [
                        _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("dt", {
                            class: "col-sm-4"
                        }, "Reason", -1)),
                        (0, _vue.createElementVNode)("dd", _hoisted_12, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.summary.decisionReason) + " ", 1),
                            _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                                class: "form-text"
                            }, "Internal only \u2014 never sent to the driver.", -1))
                        ])
                    ], 64)) : (0, _vue.createCommentVNode)("", true)
                ])) : (0, _vue.createCommentVNode)("", true),
                $setup.summary.status === 'IN_PROGRESS' && !$setup.summary.canRecordResult ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_13, _cache[8] || (_cache[8] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-exclamation-triangle me-2"
                    }, null, -1),
                    (0, _vue.createTextVNode)(" This driver is marked in progress but has no check on record. Send them a link to start one. ")
                ]))) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createElementVNode)("div", _hoisted_14, [
                    $setup.summary.canInitiate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 0,
                        class: "btn btn-outline-primary btn-sm",
                        onClick: $setup.showInitiateDialog,
                        disabled: $setup.isProcessing
                    }, [
                        $setup.isProcessing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_16)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_17)),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.initiateLabel), 1)
                    ], 8, _hoisted_15)) : (0, _vue.createCommentVNode)("", true),
                    $setup.summary.canRecordResult ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 1,
                        class: "btn btn-primary btn-sm",
                        onClick: $setup.showResultDialog,
                        disabled: $setup.isProcessing
                    }, [
                        $setup.isProcessing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_19)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_20)),
                        _cache[9] || (_cache[9] = (0, _vue.createTextVNode)(" Enter Results "))
                    ], 8, _hoisted_18)) : (0, _vue.createCommentVNode)("", true)
                ])
            ], 64)) : (0, _vue.createCommentVNode)("", true)
        ])
    ])) : (0, _vue.createCommentVNode)("", true);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"zWOoz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5DuE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f300b43273702335");
    if (script.__esModule) script = script.default;
    script.render = require("161bcee44d4e1ec0").render;
    require("d6524c590a198411").default(script);
    script.__scopeId = 'data-v-fdb4f8';
    script.__file = "DriverTaxRegistrationPanel.vue";
};
initialize();
exports.default = script;

},{"f300b43273702335":"3cupy","161bcee44d4e1ec0":"5HZkg","d6524c590a198411":"b5RU0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3cupy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
exports.default = {
    __name: 'DriverTaxRegistrationPanel',
    props: {
        driverId: {
            type: String,
            required: true
        }
    },
    emits: [
        'resolved'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const loading = (0, _vue.ref)(true);
        const loadError = (0, _vue.ref)(null);
        const summary = (0, _vue.reactive)({
            gstHstNumber: null,
            openRequest: null
        });
        const revealedSin = (0, _vue.ref)('');
        const revealing = (0, _vue.ref)(false);
        const resolveNumber = (0, _vue.ref)('');
        const rejectReason = (0, _vue.ref)('');
        const directNumber = (0, _vue.ref)('');
        const settingDirect = (0, _vue.ref)(false);
        const resolving = (0, _vue.ref)(false);
        const rejecting = (0, _vue.ref)(false);
        const actionError = (0, _vue.ref)(null);
        const formatDate = (dateStr)=>{
            if (!dateStr) return '';
            try {
                return (0, _momentDefault.default)(dateStr).format('MMMM Do, YYYY [at] h:mm a');
            } catch  {
                return dateStr;
            }
        };
        const fetchSummary = async ()=>{
            loading.value = true;
            loadError.value = null;
            revealedSin.value = '';
            try {
                const response = await fetch(`/api/admin/driver-tax-registration/by-driver/${props.driverId}`);
                if (!response.ok) throw new Error('Unable to load tax registration summary.');
                const data = await response.json();
                summary.gstHstNumber = data.gstHstNumber;
                summary.openRequest = data.openRequest;
            } catch (e) {
                // Must not fall through to the "nothing on file" branch — see the template comment.
                loadError.value = 'Unable to load this driver\'s GST/HST registration.';
            } finally{
                loading.value = false;
            }
        };
        /** Records a number for a driver who never submitted a registration request (issue #252). */ const setNumberDirectly = async ()=>{
            settingDirect.value = true;
            actionError.value = null;
            try {
                const response = await fetch(`/api/admin/driver-tax-registration/by-driver/${props.driverId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        gstHstNumber: directNumber.value
                    })
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Unable to record the GST/HST number.');
                }
                directNumber.value = '';
                await fetchSummary();
                emit('resolved');
            } catch (e) {
                actionError.value = e.message || 'Unable to record the GST/HST number.';
            } finally{
                settingDirect.value = false;
            }
        };
        const reveal = async ()=>{
            if (!summary.openRequest) return;
            revealing.value = true;
            actionError.value = null;
            try {
                const response = await fetch(`/api/admin/driver-tax-registration/${summary.openRequest.id}/reveal-sin`, {
                    method: 'POST'
                });
                if (!response.ok) throw new Error('Unable to reveal the SIN.');
                const data = await response.json();
                revealedSin.value = data.sin;
            } catch (e) {
                actionError.value = e.message || 'Unable to reveal the SIN.';
            } finally{
                revealing.value = false;
            }
        };
        const resolve = async ()=>{
            if (!summary.openRequest) return;
            resolving.value = true;
            actionError.value = null;
            try {
                const response = await fetch(`/api/admin/driver-tax-registration/${summary.openRequest.id}/resolve`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        gstHstNumber: resolveNumber.value
                    })
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Unable to resolve the request.');
                }
                resolveNumber.value = '';
                await fetchSummary();
                emit('resolved');
            } catch (e) {
                actionError.value = e.message || 'Unable to resolve the request.';
            } finally{
                resolving.value = false;
            }
        };
        const reject = async ()=>{
            if (!summary.openRequest) return;
            rejecting.value = true;
            actionError.value = null;
            try {
                const response = await fetch(`/api/admin/driver-tax-registration/${summary.openRequest.id}/reject`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        reason: rejectReason.value || null
                    })
                });
                if (!response.ok) throw new Error('Unable to reject the request.');
                await fetchSummary();
                emit('resolved');
            } catch (e) {
                actionError.value = e.message || 'Unable to reject the request.';
            } finally{
                rejecting.value = false;
            }
        };
        (0, _vue.onMounted)(fetchSummary);
        const __returned__ = {
            props,
            emit,
            loading,
            loadError,
            summary,
            revealedSin,
            revealing,
            resolveNumber,
            rejectReason,
            directNumber,
            settingDirect,
            resolving,
            rejecting,
            actionError,
            formatDate,
            fetchSummary,
            setNumberDirectly,
            reveal,
            resolve,
            reject,
            ref: (0, _vue.ref),
            reactive: (0, _vue.reactive),
            onMounted: (0, _vue.onMounted),
            get moment () {
                return 0, _momentDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment/moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HZkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "alert alert-success mb-0"
};
const _hoisted_4 = {
    key: 1,
    class: "alert alert-danger mb-0"
};
const _hoisted_5 = {
    key: 2
};
const _hoisted_6 = {
    class: "row g-2 align-items-end"
};
const _hoisted_7 = {
    class: "col-md-6"
};
const _hoisted_8 = {
    class: "col-md-6"
};
const _hoisted_9 = [
    "disabled"
];
const _hoisted_10 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_11 = {
    key: 0,
    class: "alert alert-danger mt-3 mb-0"
};
const _hoisted_12 = {
    key: 3
};
const _hoisted_13 = {
    class: "badge bg-warning mb-3"
};
const _hoisted_14 = {
    class: "row mb-3"
};
const _hoisted_15 = {
    class: "col-sm-8"
};
const _hoisted_16 = {
    class: "col-sm-8"
};
const _hoisted_17 = {
    key: 0
};
const _hoisted_18 = {
    key: 1
};
const _hoisted_19 = [
    "disabled"
];
const _hoisted_20 = {
    key: 0,
    class: "spinner-border spinner-border-sm"
};
const _hoisted_21 = {
    key: 1
};
const _hoisted_22 = {
    key: 2
};
const _hoisted_23 = {
    key: 2,
    class: "form-text"
};
const _hoisted_24 = {
    class: "col-sm-8"
};
const _hoisted_25 = {
    class: "col-sm-8"
};
const _hoisted_26 = {
    class: "col-sm-8"
};
const _hoisted_27 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_28 = {
    key: 1,
    class: "badge bg-info"
};
const _hoisted_29 = {
    key: 2,
    class: "badge bg-secondary"
};
const _hoisted_30 = {
    class: "col-sm-8"
};
const _hoisted_31 = {
    class: "col-sm-8"
};
const _hoisted_32 = {
    class: "row g-2 align-items-end"
};
const _hoisted_33 = {
    class: "col-md-6"
};
const _hoisted_34 = {
    class: "col-md-12"
};
const _hoisted_35 = {
    class: "col-md-6 d-flex gap-2"
};
const _hoisted_36 = [
    "disabled"
];
const _hoisted_37 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_38 = [
    "disabled"
];
const _hoisted_39 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_40 = {
    key: 0,
    class: "alert alert-danger mt-3 mb-0"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return !$setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
            class: "card-header bg-white"
        }, [
            (0, _vue.createElementVNode)("h5", null, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa-solid fa-percent me-2"
                }),
                (0, _vue.createTextVNode)("GST/HST Registration")
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.summary.gstHstNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("i", {
                    class: "fa fa-check-circle me-2"
                }, null, -1)),
                _cache[4] || (_cache[4] = (0, _vue.createTextVNode)("On file: ")),
                (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.summary.gstHstNumber), 1)
            ])) : $setup.loadError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, [
                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("i", {
                    class: "fa fa-exclamation-triangle me-2"
                }, null, -1)),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.loadError) + " ", 1),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-sm btn-outline-danger ms-2",
                    onClick: $setup.fetchSummary
                }, "Retry")
            ])) : !$setup.summary.openRequest ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("div", {
                    class: "alert alert-warning"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-exclamation-triangle me-2"
                    }),
                    (0, _vue.createTextVNode)(" This driver has no GST/HST number and no registration request on file. ")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_6, [
                    (0, _vue.createElementVNode)("div", _hoisted_7, [
                        _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                            class: "form-label f-w-600",
                            for: "admin-tax-direct-number-input"
                        }, "Record GST/HST Number", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            id: "admin-tax-direct-number-input",
                            class: "form-control",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.directNumber = $event),
                            placeholder: "e.g., 123456789RT0001"
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.directNumber
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-success",
                            onClick: $setup.setNumberDirectly,
                            disabled: $setup.settingDirect || !$setup.directNumber.trim()
                        }, [
                            $setup.settingDirect ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_10)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.settingDirect ? 'Saving...' : 'Save Number'), 1)
                        ], 8, _hoisted_9)
                    ])
                ]),
                $setup.actionError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, (0, _vue.toDisplayString)($setup.actionError), 1)) : (0, _vue.createCommentVNode)("", true)
            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                (0, _vue.createElementVNode)("span", _hoisted_13, (0, _vue.toDisplayString)($setup.summary.openRequest.status.replace(/_/g, ' ')), 1),
                (0, _vue.createElementVNode)("dl", _hoisted_14, [
                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Legal Name", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_15, (0, _vue.toDisplayString)($setup.summary.openRequest.legalName), 1),
                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "SIN", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_16, [
                        $setup.revealedSin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_17, (0, _vue.toDisplayString)($setup.revealedSin), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_18, (0, _vue.toDisplayString)($setup.summary.openRequest.sinMasked), 1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-sm btn-outline-secondary ms-2",
                            onClick: $setup.reveal,
                            disabled: $setup.revealing || !!$setup.revealedSin
                        }, [
                            $setup.revealing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_20)) : $setup.revealedSin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_21, _cache[8] || (_cache[8] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-check me-1"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Revealed")
                            ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22, _cache[9] || (_cache[9] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-eye me-1"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Reveal")
                            ])))
                        ], 8, _hoisted_19),
                        $setup.revealedSin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_23, "This access has been logged.")) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Address", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_24, (0, _vue.toDisplayString)($setup.summary.openRequest.address) + ", " + (0, _vue.toDisplayString)($setup.summary.openRequest.city) + ", " + (0, _vue.toDisplayString)($setup.summary.openRequest.state) + " " + (0, _vue.toDisplayString)($setup.summary.openRequest.postalCode) + ", " + (0, _vue.toDisplayString)($setup.summary.openRequest.country), 1),
                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Business Activity", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_25, (0, _vue.toDisplayString)($setup.summary.openRequest.businessActivity), 1),
                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Canadian Tax Resident", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_26, [
                        $setup.summary.openRequest.canadianTaxResident === true ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_27, " Yes \u2014 resident form ")) : $setup.summary.openRequest.canadianTaxResident === false ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_28, " No \u2014 non-resident form ")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_29, "Not answered"))
                    ]),
                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Registration Start Date", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_30, (0, _vue.toDisplayString)($setup.summary.openRequest.registrationStartDate), 1),
                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("dt", {
                        class: "col-sm-4"
                    }, "Authorized On", -1)),
                    (0, _vue.createElementVNode)("dd", _hoisted_31, (0, _vue.toDisplayString)($setup.formatDate($setup.summary.openRequest.authorizedOn)), 1)
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_32, [
                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                            class: "form-label f-w-600",
                            for: "admin-tax-resolve-number-input"
                        }, "Resulting GST/HST Number", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            id: "admin-tax-resolve-number-input",
                            class: "form-control",
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.resolveNumber = $event),
                            placeholder: "e.g., 123456789RT0001"
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.resolveNumber
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_34, [
                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                            class: "form-label f-w-600",
                            for: "admin-tax-reject-reason-input"
                        }, "Rejection Reason (shown to the driver)", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            id: "admin-tax-reject-reason-input",
                            class: "form-control",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.rejectReason = $event),
                            placeholder: "Optional, but saves the driver guessing"
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.rejectReason
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_35, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-success",
                            onClick: $setup.resolve,
                            disabled: $setup.resolving || !$setup.resolveNumber.trim()
                        }, [
                            $setup.resolving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_37)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.resolving ? 'Resolving...' : 'Resolve'), 1)
                        ], 8, _hoisted_36),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-danger",
                            onClick: $setup.reject,
                            disabled: $setup.rejecting
                        }, [
                            $setup.rejecting ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_39)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.rejecting ? 'Rejecting...' : 'Reject'), 1)
                        ], 8, _hoisted_38)
                    ])
                ]),
                $setup.actionError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_40, (0, _vue.toDisplayString)($setup.actionError), 1)) : (0, _vue.createCommentVNode)("", true)
            ]))
        ])
    ])) : (0, _vue.createCommentVNode)("", true);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b5RU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZfH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "page-title"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-sm-6 col-12"
};
const _hoisted_5 = [
    "innerHTML"
];
const _hoisted_6 = {
    key: 0,
    class: "row"
};
const _hoisted_7 = {
    key: 1,
    class: "col-12"
};
const _hoisted_8 = {
    class: "card-body"
};
const _hoisted_9 = {
    class: "d-flex align-items-start justify-content-between flex-wrap gap-3"
};
const _hoisted_10 = {
    key: 0,
    class: "text-muted mb-0 mt-2"
};
const _hoisted_11 = {
    key: 1,
    class: "text-muted mb-0 mt-2"
};
const _hoisted_12 = {
    key: 2,
    class: "text-muted mb-0 mt-2"
};
const _hoisted_13 = {
    key: 3,
    class: "text-muted mb-0 mt-2"
};
const _hoisted_14 = {
    key: 4,
    class: "mt-3"
};
const _hoisted_15 = {
    class: "list-group list-group-flush border rounded"
};
const _hoisted_16 = {
    class: "list-group-item d-flex justify-content-between align-items-center py-2 px-3"
};
const _hoisted_17 = {
    class: "list-group-item d-flex justify-content-between align-items-center py-2 px-3"
};
const _hoisted_18 = {
    class: "list-group-item d-flex justify-content-between align-items-center py-2 px-3"
};
const _hoisted_19 = {
    key: 0,
    class: "d-flex flex-column gap-2"
};
const _hoisted_20 = [
    "disabled"
];
const _hoisted_21 = {
    key: 2,
    class: "col-12"
};
const _hoisted_22 = {
    key: 3,
    class: "col-12"
};
const _hoisted_23 = {
    class: "col-12"
};
const _hoisted_24 = {
    class: "card"
};
const _hoisted_25 = {
    class: "card-header d-flex justify-content-between gap-2"
};
const _hoisted_26 = {
    key: 0
};
const _hoisted_27 = {
    key: 1
};
const _hoisted_28 = {
    key: 0,
    class: "d-flex gap-2"
};
const _hoisted_29 = {
    class: "card-body"
};
const _hoisted_30 = {
    key: 0
};
const _hoisted_31 = {
    class: "mb-3"
};
const _hoisted_32 = {
    key: 0,
    class: "f-w-700 fs-5"
};
const _hoisted_33 = {
    class: "row align-items-center gy-4 mt-2"
};
const _hoisted_34 = {
    class: "col-md-6"
};
const _hoisted_35 = {
    class: "d-flex align-items-center pb-2 fs-6"
};
const _hoisted_36 = {
    key: 0
};
const _hoisted_37 = {
    class: "d-flex align-items-center py-2 fs-6"
};
const _hoisted_38 = {
    key: 0
};
const _hoisted_39 = {
    class: "d-flex align-items-center pt-2 fs-6"
};
const _hoisted_40 = {
    key: 0
};
const _hoisted_41 = {
    class: "d-flex align-items-center pt-2 fs-6"
};
const _hoisted_42 = {
    key: 0
};
const _hoisted_43 = {
    class: "col-md-6 border-start"
};
const _hoisted_44 = {
    class: "d-flex align-items-center gap-2 pb-2"
};
const _hoisted_45 = {
    class: "recent-text"
};
const _hoisted_46 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_47 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_48 = {
    class: "d-flex align-items-center gap-2 py-2"
};
const _hoisted_49 = {
    class: "recent-text"
};
const _hoisted_50 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_51 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_52 = {
    class: "d-flex align-items-center gap-2 py-2"
};
const _hoisted_53 = {
    class: "recent-text"
};
const _hoisted_54 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_55 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_56 = {
    class: "d-flex align-items-center gap-2 py-2"
};
const _hoisted_57 = {
    class: "recent-text"
};
const _hoisted_58 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_59 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_60 = {
    key: 1
};
const _hoisted_61 = {
    key: 0
};
const _hoisted_62 = {
    class: "row"
};
const _hoisted_63 = {
    class: "col-sm-6"
};
const _hoisted_64 = {
    class: "mb-3"
};
const _hoisted_65 = {
    class: "col-sm-6"
};
const _hoisted_66 = {
    class: "mb-3"
};
const _hoisted_67 = {
    class: "col-sm-6"
};
const _hoisted_68 = {
    class: "mb-3"
};
const _hoisted_69 = {
    class: "col-sm-6"
};
const _hoisted_70 = {
    class: "mb-3"
};
const _hoisted_71 = {
    class: "col-12"
};
const _hoisted_72 = {
    class: "mb-3"
};
const _hoisted_73 = {
    class: "col-sm-4"
};
const _hoisted_74 = {
    class: "mb-3"
};
const _hoisted_75 = {
    class: "col-sm-4"
};
const _hoisted_76 = {
    class: "mb-3"
};
const _hoisted_77 = {
    class: "col-sm-4"
};
const _hoisted_78 = {
    class: "mb-3"
};
const _hoisted_79 = {
    class: "col-12"
};
const _hoisted_80 = {
    class: "mb-3"
};
const _hoisted_81 = [
    "value"
];
const _hoisted_82 = {
    key: 4,
    class: "col-12"
};
const _hoisted_83 = {
    class: "card"
};
const _hoisted_84 = {
    class: "card-body"
};
const _hoisted_85 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_86 = {
    class: "recent-text"
};
const _hoisted_87 = {
    key: 0
};
const _hoisted_88 = {
    class: "badge badge-light-primary"
};
const _hoisted_89 = {
    key: 1
};
const _hoisted_90 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_91 = {
    class: "recent-text"
};
const _hoisted_92 = {
    key: 0
};
const _hoisted_93 = {
    key: 1
};
const _hoisted_94 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_95 = {
    class: "recent-text"
};
const _hoisted_96 = {
    key: 0
};
const _hoisted_97 = {
    key: 1
};
const _hoisted_98 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_99 = {
    class: "recent-text"
};
const _hoisted_100 = {
    key: 0
};
const _hoisted_101 = {
    key: 1
};
const _hoisted_102 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_103 = {
    class: "recent-text"
};
const _hoisted_104 = {
    key: 0
};
const _hoisted_105 = {
    key: 1
};
const _hoisted_106 = {
    key: 0,
    class: "d-flex align-items-start gap-2 border-bottom py-2"
};
const _hoisted_107 = {
    class: "recent-text"
};
const _hoisted_108 = {
    class: "text-danger mb-0"
};
const _hoisted_109 = {
    key: 1,
    class: "d-flex align-items-start gap-2 pt-2"
};
const _hoisted_110 = {
    class: "recent-text"
};
const _hoisted_111 = {
    class: "mb-0"
};
const _hoisted_112 = {
    key: 5,
    class: "col-12"
};
const _hoisted_113 = {
    class: "card"
};
const _hoisted_114 = {
    class: "card-header d-flex justify-content-between align-items-center gap-2"
};
const _hoisted_115 = {
    class: "d-flex gap-2 align-items-center"
};
const _hoisted_116 = {
    key: 0,
    class: "badge badge-success"
};
const _hoisted_117 = {
    key: 1,
    class: "badge badge-danger"
};
const _hoisted_118 = {
    key: 2,
    class: "badge badge-warning"
};
const _hoisted_119 = {
    class: "card-body"
};
const _hoisted_120 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_121 = {
    class: "recent-text"
};
const _hoisted_122 = {
    key: 1
};
const _hoisted_123 = {
    key: 0,
    class: "d-flex align-items-start gap-2 border-bottom py-2"
};
const _hoisted_124 = {
    class: "recent-text"
};
const _hoisted_125 = {
    class: "text-danger mb-0"
};
const _hoisted_126 = {
    key: 1,
    class: "d-flex align-items-start gap-2 pt-2"
};
const _hoisted_127 = {
    class: "recent-text"
};
const _hoisted_128 = {
    class: "mb-0"
};
const _hoisted_129 = {
    key: 0,
    class: "d-flex gap-2 mt-3 pt-3"
};
const _hoisted_130 = {
    key: 6,
    class: "col-12"
};
const _hoisted_131 = {
    class: "card"
};
const _hoisted_132 = {
    class: "card-header d-flex justify-content-between align-items-center gap-2"
};
const _hoisted_133 = {
    class: "d-flex gap-2 align-items-center"
};
const _hoisted_134 = {
    key: 0,
    class: "badge badge-success"
};
const _hoisted_135 = {
    key: 1,
    class: "badge badge-danger"
};
const _hoisted_136 = {
    key: 2,
    class: "badge badge-warning"
};
const _hoisted_137 = {
    class: "card-body"
};
const _hoisted_138 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_139 = {
    class: "recent-text"
};
const _hoisted_140 = {
    key: 0
};
const _hoisted_141 = {
    key: 1
};
const _hoisted_142 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_143 = {
    class: "recent-text"
};
const _hoisted_144 = {
    key: 1
};
const _hoisted_145 = {
    key: 0,
    class: "d-flex align-items-start gap-2 border-bottom py-2"
};
const _hoisted_146 = {
    class: "recent-text"
};
const _hoisted_147 = {
    class: "text-danger mb-0"
};
const _hoisted_148 = {
    key: 1,
    class: "d-flex align-items-start gap-2 pt-2"
};
const _hoisted_149 = {
    class: "recent-text"
};
const _hoisted_150 = {
    class: "mb-0"
};
const _hoisted_151 = {
    key: 0,
    class: "d-flex gap-2 mt-3 pt-3"
};
const _hoisted_152 = {
    key: 7,
    class: "col-12"
};
const _hoisted_153 = {
    class: "card"
};
const _hoisted_154 = {
    class: "card-header d-flex justify-content-between align-items-center gap-2"
};
const _hoisted_155 = {
    class: "d-flex gap-2 align-items-center"
};
const _hoisted_156 = {
    key: 0,
    class: "badge badge-success"
};
const _hoisted_157 = {
    key: 1,
    class: "badge badge-danger"
};
const _hoisted_158 = {
    key: 2,
    class: "badge badge-warning"
};
const _hoisted_159 = {
    class: "card-body"
};
const _hoisted_160 = {
    class: "d-flex align-items-center gap-2 border-bottom pb-2"
};
const _hoisted_161 = {
    class: "recent-text"
};
const _hoisted_162 = {
    key: 0
};
const _hoisted_163 = {
    key: 1
};
const _hoisted_164 = {
    class: "d-flex align-items-center gap-2 border-bottom py-2"
};
const _hoisted_165 = {
    key: 0,
    class: "recent-text"
};
const _hoisted_166 = {
    key: 0,
    class: "d-flex align-items-start gap-2 border-bottom py-2"
};
const _hoisted_167 = {
    class: "recent-text"
};
const _hoisted_168 = {
    class: "text-danger mb-0"
};
const _hoisted_169 = {
    key: 1,
    class: "d-flex align-items-start gap-2 pt-2"
};
const _hoisted_170 = {
    class: "recent-text"
};
const _hoisted_171 = {
    class: "mb-0"
};
const _hoisted_172 = {
    key: 0,
    class: "d-flex gap-2 mt-3 pt-3"
};
const _hoisted_173 = {
    key: 8,
    class: "col-12"
};
const _hoisted_174 = {
    class: "card b-primary bg-light-primary"
};
const _hoisted_175 = {
    key: 0,
    class: "card-body"
};
const _hoisted_176 = {
    class: "col-12",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_177 = {
    class: "f-w-700"
};
const _hoisted_178 = {
    class: "row mt-5"
};
const _hoisted_179 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_180 = {
    class: "f-w-700"
};
const _hoisted_181 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_182 = {
    class: "f-w-700"
};
const _hoisted_183 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_184 = {
    class: "f-w-700"
};
const _hoisted_185 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_186 = {
    class: "f-w-700"
};
const _hoisted_187 = {
    key: 1,
    class: "card-body"
};
const _hoisted_188 = {
    key: 9,
    class: "col-sm-6"
};
const _hoisted_189 = {
    class: "card b-success bg-light-success"
};
const _hoisted_190 = {
    key: 0,
    class: "card-body"
};
const _hoisted_191 = {
    class: "col-12",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_192 = {
    class: "f-w-700"
};
const _hoisted_193 = {
    class: "row mt-5"
};
const _hoisted_194 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_195 = {
    class: "f-w-700"
};
const _hoisted_196 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_197 = {
    class: "f-w-700"
};
const _hoisted_198 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_199 = {
    class: "f-w-700"
};
const _hoisted_200 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_201 = {
    class: "f-w-700"
};
const _hoisted_202 = {
    key: 1,
    class: "card-body"
};
const _hoisted_203 = {
    key: 10,
    class: "col-sm-6"
};
const _hoisted_204 = {
    class: "card b-danger bg-light-danger"
};
const _hoisted_205 = {
    key: 0,
    class: "card-body"
};
const _hoisted_206 = {
    class: "col-12",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_207 = {
    class: "f-w-700"
};
const _hoisted_208 = {
    class: "row mt-5"
};
const _hoisted_209 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_210 = {
    class: "f-w-700"
};
const _hoisted_211 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_212 = {
    class: "f-w-700"
};
const _hoisted_213 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_214 = {
    class: "f-w-700"
};
const _hoisted_215 = {
    class: "col-sm-3",
    style: {
        "justify-items": "center"
    }
};
const _hoisted_216 = {
    class: "f-w-700"
};
const _hoisted_217 = {
    key: 1,
    class: "card-body"
};
const _hoisted_218 = {
    key: 11,
    class: "col-12"
};
const _hoisted_219 = {
    class: "card"
};
const _hoisted_220 = {
    class: "card-body"
};
const _hoisted_221 = {
    key: 12,
    class: "col-12"
};
const _hoisted_222 = {
    class: "card"
};
const _hoisted_223 = {
    class: "card-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("h2", null, [
                        _cache[10] || (_cache[10] = (0, _vue.createTextVNode)(" Driver Detail ")),
                        $setup.driverData && $setup.driverData.driverStatus && !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                            key: 0,
                            class: "fs-4",
                            innerHTML: $setup.driverStatus($setup.driverData.driverStatus)
                        }, null, 8, _hoisted_5)) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ])
        ]),
        $setup.driverData && $setup.driverData.driverStatus !== 'OFFLINE' && !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, _cache[11] || (_cache[11] = [
            (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "card"
                }, [
                    (0, _vue.createElementVNode)("div", {
                        id: "map",
                        style: {
                            "height": "45vh",
                            "width": "100%"
                        }
                    })
                ])
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver && $setup.driverData && $setup.driverData.onboardingStatus !== 'COMPLETE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
            (0, _vue.createElementVNode)("div", {
                class: (0, _vue.normalizeClass)([
                    "card",
                    {
                        'b-secondary bg-light': $setup.driverData.onboardingStatus === 'NOT_STARTED',
                        'b-warning bg-light-warning': $setup.driverData.onboardingStatus === 'IN_PROGRESS' || $setup.driverData.onboardingStatus === 'PENDING_VERIFICATION',
                        'b-danger bg-light-danger': $setup.driverData.onboardingStatus === 'REJECTED'
                    }
                ])
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: (0, _vue.normalizeClass)([
                        "card-header",
                        {
                            'bg-secondary': $setup.driverData.onboardingStatus === 'NOT_STARTED',
                            'bg-warning': $setup.driverData.onboardingStatus === 'IN_PROGRESS' || $setup.driverData.onboardingStatus === 'PENDING_VERIFICATION',
                            'bg-danger': $setup.driverData.onboardingStatus === 'REJECTED'
                        }
                    ])
                }, _cache[12] || (_cache[12] = [
                    (0, _vue.createElementVNode)("h5", null, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-clipboard-check"
                        }),
                        (0, _vue.createTextVNode)(" Onboarding Status ")
                    ], -1)
                ]), 2),
                (0, _vue.createElementVNode)("div", _hoisted_8, [
                    (0, _vue.createElementVNode)("div", _hoisted_9, [
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("h4", null, [
                                _cache[13] || (_cache[13] = (0, _vue.createTextVNode)(" Current Status: ")),
                                (0, _vue.createElementVNode)("span", {
                                    class: (0, _vue.normalizeClass)([
                                        "badge",
                                        {
                                            'bg-secondary': $setup.driverData.onboardingStatus === 'NOT_STARTED',
                                            'bg-warning': $setup.driverData.onboardingStatus === 'IN_PROGRESS' || $setup.driverData.onboardingStatus === 'PENDING_VERIFICATION',
                                            'bg-danger': $setup.driverData.onboardingStatus === 'REJECTED'
                                        }
                                    ])
                                }, (0, _vue.toDisplayString)($setup.driverData.onboardingStatus.replace(/_/g, ' ')), 3)
                            ]),
                            $setup.driverData.onboardingStatus === 'NOT_STARTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_10, " This driver has not yet submitted their application. ")) : $setup.driverData.onboardingStatus === 'IN_PROGRESS' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_11, " This driver has submitted their application. Their background check is underway. ")) : $setup.driverData.onboardingStatus === 'PENDING_VERIFICATION' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_12, " The background check has passed. This driver is awaiting admin document review. ")) : $setup.driverData.onboardingStatus === 'REJECTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_13, " This driver's application has been rejected. They need to resubmit their information. ")) : (0, _vue.createCommentVNode)("", true),
                            $setup.driverData.independentDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, [
                                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("p", {
                                    class: "fw-semibold mb-2"
                                }, "Driver Onboarding Checklist", -1)),
                                (0, _vue.createElementVNode)("ul", _hoisted_15, [
                                    (0, _vue.createElementVNode)("li", _hoisted_16, [
                                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("span", {
                                            class: "small"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa fa-id-badge me-2 text-muted"
                                            }),
                                            (0, _vue.createTextVNode)("Profile Photo")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)([
                                                "badge rounded-pill",
                                                $setup.driverData.hasProfilePicture ? 'bg-success' : 'bg-warning'
                                            ])
                                        }, (0, _vue.toDisplayString)($setup.driverData.hasProfilePicture ? 'Uploaded' : 'Required'), 3)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_17, [
                                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("span", {
                                            class: "small"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa fa-camera me-2 text-muted"
                                            }),
                                            (0, _vue.createTextVNode)("Vehicle Photos")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)([
                                                "badge rounded-pill",
                                                $setup.driverData.vehiclePhotosUploaded ? 'bg-success' : 'bg-warning'
                                            ])
                                        }, (0, _vue.toDisplayString)($setup.driverData.vehiclePhotosUploaded ? 'Uploaded' : 'Required'), 3)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_18, [
                                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("span", {
                                            class: "small"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa fa-credit-card me-2 text-muted"
                                            }),
                                            (0, _vue.createTextVNode)("Payment Setup (Stripe)")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)([
                                                "badge rounded-pill",
                                                $setup.driverData.stripeOnboarded ? 'bg-success' : 'bg-warning'
                                            ])
                                        }, (0, _vue.toDisplayString)($setup.driverData.stripeOnboarded ? 'Complete' : 'Required'), 3)
                                    ])
                                ])
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        $setup.driverData.independentDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_19, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-outline-primary btn-sm",
                                onClick: $setup.showResendStatusEmailConfirmation,
                                disabled: $setup.isProcessing
                            }, _cache[18] || (_cache[18] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-paper-plane me-1"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Resend Status Email ")
                            ]), 8, _hoisted_20)
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ], 2)
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver && $setup.driverData && $setup.driverData.independentDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_21, [
            (0, _vue.createVNode)($setup["DriverBackgroundCheckPanel"], {
                driverId: $setup.props.driverId,
                onResolved: $setup.loadDriverData
            }, null, 8, [
                "driverId"
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver && $setup.driverData && $setup.driverData.independentDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_22, [
            (0, _vue.createVNode)($setup["DriverTaxRegistrationPanel"], {
                driverId: $setup.props.driverId,
                onResolved: $setup.loadDriverData
            }, null, 8, [
                "driverId"
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_23, [
            (0, _vue.createElementVNode)("div", _hoisted_24, [
                (0, _vue.createElementVNode)("div", _hoisted_25, [
                    (0, _vue.createElementVNode)("h3", null, [
                        $setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_26, "New ")) : $setup.editDriverInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_27, "Edit ")) : (0, _vue.createCommentVNode)("", true),
                        _cache[19] || (_cache[19] = (0, _vue.createTextVNode)(" Driver Information "))
                    ]),
                    !$setup.editDriverInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, [
                        $setup.driverData && ($setup.driverData.onboardingStatus === 'COMPLETE' || $setup.driverData.onboardingStatus === 'PENDING_VERIFICATION') ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            class: "btn btn-primary",
                            onClick: $setup.showResetPasswordConfirmation
                        }, _cache[20] || (_cache[20] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-key"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Reset Password ")
                        ]))) : (0, _vue.createCommentVNode)("", true),
                        $setup.driverData && !$setup.driverData.lastLogin && $setup.driverData.onboardingStatus !== 'COMPLETE' && $setup.driverData.onboardingStatus !== 'PENDING_VERIFICATION' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 1,
                            class: "btn btn-success",
                            onClick: $setup.showSendInviteConfirmation
                        }, _cache[21] || (_cache[21] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-envelope"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Send Registration Invite ")
                        ]))) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-primary",
                            onClick: $setup.toggleEditMode
                        }, _cache[22] || (_cache[22] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "icon-pencil-alt"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Edit Information ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_29, [
                    !$setup.editDriverInfo && !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_30, [
                        (0, _vue.createElementVNode)("div", _hoisted_31, [
                            $setup.driverData && $setup.driverData.name ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_32, (0, _vue.toDisplayString)($setup.driverData.name), 1)) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_33, [
                            (0, _vue.createElementVNode)("div", _hoisted_34, [
                                (0, _vue.createElementVNode)("ul", null, [
                                    (0, _vue.createElementVNode)("li", _hoisted_35, [
                                        _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Email:", -1)),
                                        _cache[24] || (_cache[24] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.driverData && $setup.driverData.email ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_36, (0, _vue.toDisplayString)($setup.driverData.email), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_37, [
                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Mobile Number:", -1)),
                                        _cache[26] || (_cache[26] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.driverData && $setup.driverData.phoneNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_38, (0, _vue.toDisplayString)($setup.driverData.phoneNumber), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_39, [
                                        _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Started On:", -1)),
                                        _cache[28] || (_cache[28] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.driverData && $setup.driverData.joinedOn ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_40, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.joinedOn)), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_41, [
                                        _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Last Login:", -1)),
                                        _cache[30] || (_cache[30] = (0, _vue.createTextVNode)("\xa0 ")),
                                        $setup.driverData && $setup.driverData.lastLogin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_42, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.lastLogin)), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_43, [
                                (0, _vue.createElementVNode)("ul", null, [
                                    (0, _vue.createElementVNode)("li", _hoisted_44, [
                                        _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Email Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_45, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.driverData && $setup.driverData.emailVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_46)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_47))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_48, [
                                        _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Mobile Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_49, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.driverData && $setup.driverData.phoneNumberVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_50)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_51))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_52, [
                                        _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "License Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_53, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.driverData && $setup.driverData.licenseDocumentVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_54)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_55))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_56, [
                                        _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Insurance Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_57, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.driverData && $setup.driverData.insuranceDocumentVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_58)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_59))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.editDriverInfo || $setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_60, [
                        (0, _vue.createVNode)($setup["EntityForm"], {
                            "model-constructor": "Driver",
                            "api-url": `/api/driver`,
                            entity: $setup.driverFormData,
                            "onUpdate:entity": _cache[9] || (_cache[9] = ($event)=>$setup.driverFormData = $event),
                            "form-name": "Driver",
                            "show-title": false,
                            "start-in-edit": true,
                            "entity-id": $props.driverId,
                            "post-save": $setup.saveCallback,
                            "on-cancel-callback": $setup.cancelCallback,
                            "redirect-url": $setup.props.serviceProviderId ? `/service-provider/${$setup.props.serviceProviderId}/driver` : `/admin/independent-driver`
                        }, {
                            default: (0, _vue.withCtx)(()=>[
                                    $setup.driverFormData.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_61, [
                                        (0, _vue.createElementVNode)("div", _hoisted_62, [
                                            (0, _vue.createElementVNode)("div", _hoisted_63, [
                                                (0, _vue.createElementVNode)("div", _hoisted_64, [
                                                    _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-first-name-input"
                                                    }, "First Name", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-first-name-input",
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.driverFormData.state.firstName = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "Johnny"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.firstName
                                                        ]
                                                    ]),
                                                    _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-first-name-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter the first name. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_65, [
                                                (0, _vue.createElementVNode)("div", _hoisted_66, [
                                                    _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-last-name-input"
                                                    }, "Last Name", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-last-name-input",
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.driverFormData.state.lastName = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "Smith"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.lastName
                                                        ]
                                                    ]),
                                                    _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-last-name-error",
                                                        class: "invalid-feedback d-none"
                                                    }, " Please enter the last name. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_67, [
                                                (0, _vue.createElementVNode)("div", _hoisted_68, [
                                                    _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-email-input"
                                                    }, "Email", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-email-input",
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.driverFormData.state.email = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "email@example.com"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.email
                                                        ]
                                                    ]),
                                                    _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-email-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid email address. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_69, [
                                                (0, _vue.createElementVNode)("div", _hoisted_70, [
                                                    _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-phone-number-input"
                                                    }, "Phone Number", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-phone-number-input",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.driverFormData.state.phoneNumber = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "+1555123456"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.phoneNumber
                                                        ]
                                                    ]),
                                                    _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-phone-number-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid phone number. ", -1))
                                                ])
                                            ]),
                                            _cache[54] || (_cache[54] = (0, _vue.createElementVNode)("div", {
                                                class: "col-12"
                                            }, [
                                                (0, _vue.createElementVNode)("h5", {
                                                    class: "mt-3 mb-3"
                                                }, "Address Information")
                                            ], -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_71, [
                                                (0, _vue.createElementVNode)("div", _hoisted_72, [
                                                    _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-address-input"
                                                    }, "Address", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-address-input",
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.driverFormData.state.address = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "Start typing to search for an address...",
                                                        ref: "addressInput"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.address
                                                        ]
                                                    ]),
                                                    _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-address-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid address.", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_73, [
                                                (0, _vue.createElementVNode)("div", _hoisted_74, [
                                                    _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-city-input"
                                                    }, "City", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-city-input",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.driverFormData.state.city = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "City"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.city
                                                        ]
                                                    ]),
                                                    _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-city-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid city.", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_75, [
                                                (0, _vue.createElementVNode)("div", _hoisted_76, [
                                                    _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-state-input"
                                                    }, "State/Province", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-state-input",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.driverFormData.state.state = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "State"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.state
                                                        ]
                                                    ]),
                                                    _cache[48] || (_cache[48] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-state-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid state/province. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_77, [
                                                (0, _vue.createElementVNode)("div", _hoisted_78, [
                                                    _cache[49] || (_cache[49] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-zip-code-input"
                                                    }, "Zip/Postal Code", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "driver-zip-code-input",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.driverFormData.state.zipCode = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "12345"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.driverFormData.state.zipCode
                                                        ]
                                                    ]),
                                                    _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-zip-code-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid zip/postal code. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_79, [
                                                (0, _vue.createElementVNode)("div", _hoisted_80, [
                                                    _cache[52] || (_cache[52] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "driver-country-input"
                                                    }, "Country", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                                        id: "driver-country-input",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.driverFormData.state.country = $event),
                                                        class: "form-select"
                                                    }, [
                                                        _cache[51] || (_cache[51] = (0, _vue.createElementVNode)("option", {
                                                            value: ""
                                                        }, "Select a country", -1)),
                                                        ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.countries, (country)=>{
                                                            return (0, _vue.createElementVNode)("option", {
                                                                key: country,
                                                                value: country
                                                            }, (0, _vue.toDisplayString)(country), 9, _hoisted_81);
                                                        }), 64))
                                                    ], 512), [
                                                        [
                                                            (0, _vue.vModelSelect),
                                                            $setup.driverFormData.state.country
                                                        ]
                                                    ]),
                                                    _cache[53] || (_cache[53] = (0, _vue.createElementVNode)("div", {
                                                        id: "driver-country-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please select a country.", -1))
                                                ])
                                            ])
                                        ])
                                    ])) : (0, _vue.createCommentVNode)("", true)
                                ]),
                            _: 1
                        }, 8, [
                            "entity",
                            "entity-id",
                            "redirect-url"
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_82, [
            (0, _vue.createElementVNode)("div", _hoisted_83, [
                _cache[62] || (_cache[62] = (0, _vue.createElementVNode)("div", {
                    class: "card-header d-flex justify-content-between align-items-center gap-2"
                }, [
                    (0, _vue.createElementVNode)("h3", null, "Vehicle Information")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_84, [
                    (0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.createElementVNode)("li", _hoisted_85, [
                            _cache[55] || (_cache[55] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Service Type")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_86, [
                                $setup.driverData && $setup.driverData.vehicleType ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_87, [
                                    (0, _vue.createElementVNode)("span", _hoisted_88, (0, _vue.toDisplayString)($setup.driverData.vehicleType), 1)
                                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_89, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_90, [
                            _cache[56] || (_cache[56] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Make")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_91, [
                                $setup.driverData && $setup.driverData.vehicleMake ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_92, (0, _vue.toDisplayString)($setup.driverData.vehicleMake), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_93, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_94, [
                            _cache[57] || (_cache[57] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Model")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_95, [
                                $setup.driverData && $setup.driverData.vehicleModel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_96, (0, _vue.toDisplayString)($setup.driverData.vehicleModel), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_97, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_98, [
                            _cache[58] || (_cache[58] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Color")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_99, [
                                $setup.driverData && $setup.driverData.vehicleColor ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_100, (0, _vue.toDisplayString)($setup.driverData.vehicleColor), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_101, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_102, [
                            _cache[59] || (_cache[59] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Number Plate")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_103, [
                                $setup.driverData && $setup.driverData.vehiclePlateNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_104, (0, _vue.toDisplayString)($setup.driverData.vehiclePlateNumber), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_105, "N/A"))
                            ])
                        ]),
                        $setup.driverData && $setup.driverData.vehicleRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_106, [
                            _cache[60] || (_cache[60] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700 text-danger"
                                }, "Rejection Reason")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_107, [
                                (0, _vue.createElementVNode)("p", _hoisted_108, (0, _vue.toDisplayString)($setup.driverData.vehicleRejectionReason), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.driverData && $setup.driverData.vehicleVerified && $setup.driverData.vehicleVerifiedAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_109, [
                            _cache[61] || (_cache[61] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Verified At")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_110, [
                                (0, _vue.createElementVNode)("p", _hoisted_111, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.vehicleVerifiedAt)), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_112, [
            (0, _vue.createElementVNode)("div", _hoisted_113, [
                (0, _vue.createElementVNode)("div", _hoisted_114, [
                    _cache[66] || (_cache[66] = (0, _vue.createElementVNode)("h3", null, "Vehicle Photos", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_115, [
                        $setup.driverData && $setup.driverData.vehiclePhotosVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_116, _cache[63] || (_cache[63] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Verified ")
                        ]))) : $setup.driverData && $setup.driverData.vehiclePhotosRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_117, _cache[64] || (_cache[64] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Rejected ")
                        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_118, _cache[65] || (_cache[65] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-clock me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Pending ")
                        ])))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_119, [
                    (0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.createElementVNode)("li", _hoisted_120, [
                            _cache[68] || (_cache[68] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Vehicle Photos")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_121, [
                                $setup.driverData && $setup.driverData.vehiclePhotosUploaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: $setup.downloadVehiclePhotos
                                }, _cache[67] || (_cache[67] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-download me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Download ")
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_122, "Not Uploaded"))
                            ])
                        ]),
                        $setup.driverData && $setup.driverData.vehiclePhotosRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_123, [
                            _cache[69] || (_cache[69] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700 text-danger"
                                }, "Rejection Reason")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_124, [
                                (0, _vue.createElementVNode)("p", _hoisted_125, (0, _vue.toDisplayString)($setup.driverData.vehiclePhotosRejectionReason), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.driverData && $setup.driverData.vehiclePhotosVerified && $setup.driverData.vehiclePhotosVerifiedAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_126, [
                            _cache[70] || (_cache[70] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Verified At")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_127, [
                                (0, _vue.createElementVNode)("p", _hoisted_128, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.vehiclePhotosVerifiedAt)), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    $setup.driverData && $setup.driverData.vehiclePhotosUploaded && !$setup.driverData.vehiclePhotosVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_129, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-success",
                            onClick: $setup.verifyVehicle
                        }, _cache[71] || (_cache[71] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Approve Photos ")
                        ])),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            onClick: $setup.showRejectVehicleModal
                        }, _cache[72] || (_cache[72] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Reject Photos ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_130, [
            (0, _vue.createElementVNode)("div", _hoisted_131, [
                (0, _vue.createElementVNode)("div", _hoisted_132, [
                    _cache[76] || (_cache[76] = (0, _vue.createElementVNode)("h3", null, "Driver License Document", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_133, [
                        $setup.driverData && $setup.driverData.licenseDocumentVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_134, _cache[73] || (_cache[73] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Verified ")
                        ]))) : $setup.driverData && $setup.driverData.licenseRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_135, _cache[74] || (_cache[74] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Rejected ")
                        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_136, _cache[75] || (_cache[75] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-clock me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Pending ")
                        ])))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_137, [
                    (0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.createElementVNode)("li", _hoisted_138, [
                            _cache[77] || (_cache[77] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "License Expiration Date")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_139, [
                                $setup.driverData && $setup.driverData.licenseExpirationDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_140, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.licenseExpirationDate)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_141, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_142, [
                            _cache[79] || (_cache[79] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "License Document")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_143, [
                                $setup.driverData && $setup.driverData.licenseDocumentUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: $setup.downloadLicense
                                }, _cache[78] || (_cache[78] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-download me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Download ")
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_144, "N/A"))
                            ])
                        ]),
                        $setup.driverData && $setup.driverData.licenseRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_145, [
                            _cache[80] || (_cache[80] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700 text-danger"
                                }, "Rejection Reason")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_146, [
                                (0, _vue.createElementVNode)("p", _hoisted_147, (0, _vue.toDisplayString)($setup.driverData.licenseRejectionReason), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.driverData && $setup.driverData.licenseVerified && $setup.driverData.licenseVerifiedAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_148, [
                            _cache[81] || (_cache[81] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Verified At")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_149, [
                                (0, _vue.createElementVNode)("p", _hoisted_150, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.licenseVerifiedAt)), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    $setup.driverData && $setup.driverData.licenseDocumentUrl && !$setup.driverData.licenseDocumentVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_151, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-success",
                            onClick: $setup.verifyLicense
                        }, _cache[82] || (_cache[82] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Approve License ")
                        ])),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            onClick: $setup.showRejectLicenseModal
                        }, _cache[83] || (_cache[83] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Reject License ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_152, [
            (0, _vue.createElementVNode)("div", _hoisted_153, [
                (0, _vue.createElementVNode)("div", _hoisted_154, [
                    _cache[87] || (_cache[87] = (0, _vue.createElementVNode)("h3", null, "Insurance Document", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_155, [
                        $setup.driverData && $setup.driverData.insuranceDocumentVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_156, _cache[84] || (_cache[84] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Verified ")
                        ]))) : $setup.driverData && $setup.driverData.insuranceRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_157, _cache[85] || (_cache[85] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Rejected ")
                        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_158, _cache[86] || (_cache[86] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-clock me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Pending ")
                        ])))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_159, [
                    (0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.createElementVNode)("li", _hoisted_160, [
                            _cache[88] || (_cache[88] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Insurance Expiration Date")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_161, [
                                $setup.driverData && $setup.driverData.insuranceDocumentExpiryDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_162, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.insuranceDocumentExpiryDate)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_163, "N/A"))
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", _hoisted_164, [
                            _cache[90] || (_cache[90] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Insurance Document")
                            ], -1)),
                            $setup.driverData && $setup.driverData.insuranceDocumentUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_165, [
                                (0, _vue.createElementVNode)("button", {
                                    class: "btn btn-sm btn-outline-primary",
                                    onClick: $setup.downloadInsurance
                                }, _cache[89] || (_cache[89] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-download me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Download ")
                                ]))
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        $setup.driverData && $setup.driverData.insuranceRejectionReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_166, [
                            _cache[91] || (_cache[91] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700 text-danger"
                                }, "Rejection Reason")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_167, [
                                (0, _vue.createElementVNode)("p", _hoisted_168, (0, _vue.toDisplayString)($setup.driverData.insuranceRejectionReason), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.driverData && $setup.driverData.insuranceDocumentVerified && $setup.driverData.insuranceVerifiedAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_169, [
                            _cache[92] || (_cache[92] = (0, _vue.createElementVNode)("div", {
                                class: "flex-grow-1"
                            }, [
                                (0, _vue.createElementVNode)("h5", {
                                    class: "f-w-700"
                                }, "Verified At")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_170, [
                                (0, _vue.createElementVNode)("p", _hoisted_171, (0, _vue.toDisplayString)($setup.formatTime($setup.driverData.insuranceVerifiedAt)), 1)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    $setup.driverData && !$setup.driverData.insuranceDocumentVerified && $setup.driverData.insuranceDocumentUrl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_172, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-success",
                            onClick: $setup.verifyInsurance
                        }, _cache[93] || (_cache[93] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Approve Insurance ")
                        ])),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-danger",
                            onClick: $setup.showRejectInsuranceModal
                        }, _cache[94] || (_cache[94] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-times me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Reject Insurance ")
                        ]))
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_173, [
            (0, _vue.createElementVNode)("div", _hoisted_174, [
                _cache[100] || (_cache[100] = (0, _vue.createElementVNode)("div", {
                    class: "card-header bg-primary"
                }, [
                    (0, _vue.createElementVNode)("h5", null, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-list"
                        }),
                        (0, _vue.createTextVNode)(" Ride Summary ")
                    ])
                ], -1)),
                $setup.driverData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_175, [
                    (0, _vue.createElementVNode)("div", _hoisted_176, [
                        _cache[95] || (_cache[95] = (0, _vue.createElementVNode)("h4", {
                            class: "f-w-400"
                        }, "Total Rides", -1)),
                        (0, _vue.createElementVNode)("h5", _hoisted_177, (0, _vue.toDisplayString)($setup.driverData.totalRides), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_178, [
                        (0, _vue.createElementVNode)("div", _hoisted_179, [
                            _cache[96] || (_cache[96] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Today", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_180, (0, _vue.toDisplayString)($setup.driverData.totalRidesToday), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_181, [
                            _cache[97] || (_cache[97] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Week", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_182, (0, _vue.toDisplayString)($setup.driverData.totalRidesThisWeek), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_183, [
                            _cache[98] || (_cache[98] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_184, (0, _vue.toDisplayString)($setup.driverData.totalRidesThisMonth), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_185, [
                            _cache[99] || (_cache[99] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Last Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_186, (0, _vue.toDisplayString)($setup.driverData.totalRidesLastMonth), 1)
                        ])
                    ])
                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_187, " N/A"))
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_188, [
            (0, _vue.createElementVNode)("div", _hoisted_189, [
                _cache[106] || (_cache[106] = (0, _vue.createElementVNode)("div", {
                    class: "card-header bg-success"
                }, [
                    (0, _vue.createElementVNode)("h5", null, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-circle-check"
                        }),
                        (0, _vue.createTextVNode)(" Completed Rides ")
                    ])
                ], -1)),
                $setup.driverData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_190, [
                    (0, _vue.createElementVNode)("div", _hoisted_191, [
                        _cache[101] || (_cache[101] = (0, _vue.createElementVNode)("h4", {
                            class: "f-w-400"
                        }, "Total Rides", -1)),
                        (0, _vue.createElementVNode)("h5", _hoisted_192, (0, _vue.toDisplayString)($setup.driverData.completedRides), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_193, [
                        (0, _vue.createElementVNode)("div", _hoisted_194, [
                            _cache[102] || (_cache[102] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Today", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_195, (0, _vue.toDisplayString)($setup.driverData.completedRidesToday), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_196, [
                            _cache[103] || (_cache[103] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Week", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_197, (0, _vue.toDisplayString)($setup.driverData.completedRidesThisWeek), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_198, [
                            _cache[104] || (_cache[104] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_199, (0, _vue.toDisplayString)($setup.driverData.completedRidesThisMonth), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_200, [
                            _cache[105] || (_cache[105] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Last Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_201, (0, _vue.toDisplayString)($setup.driverData.completedRidesLastMonth), 1)
                        ])
                    ])
                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_202, " N/A"))
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_203, [
            (0, _vue.createElementVNode)("div", _hoisted_204, [
                _cache[112] || (_cache[112] = (0, _vue.createElementVNode)("div", {
                    class: "card-header bg-danger"
                }, [
                    (0, _vue.createElementVNode)("h5", null, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-circle-xmark"
                        }),
                        (0, _vue.createTextVNode)(" Canceled Rides ")
                    ])
                ], -1)),
                $setup.driverData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_205, [
                    (0, _vue.createElementVNode)("div", _hoisted_206, [
                        _cache[107] || (_cache[107] = (0, _vue.createElementVNode)("h4", {
                            class: "f-w-400"
                        }, "Total Rides", -1)),
                        (0, _vue.createElementVNode)("h5", _hoisted_207, (0, _vue.toDisplayString)($setup.driverData.cancelledRides), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_208, [
                        (0, _vue.createElementVNode)("div", _hoisted_209, [
                            _cache[108] || (_cache[108] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Today", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_210, (0, _vue.toDisplayString)($setup.driverData.cancelledRidesToday), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_211, [
                            _cache[109] || (_cache[109] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Week", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_212, (0, _vue.toDisplayString)($setup.driverData.cancelledRidesThisWeek), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_213, [
                            _cache[110] || (_cache[110] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "This Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_214, (0, _vue.toDisplayString)($setup.driverData.cancelledRidesThisMonth), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_215, [
                            _cache[111] || (_cache[111] = (0, _vue.createElementVNode)("h4", {
                                class: "f-w-400"
                            }, "Last Month", -1)),
                            (0, _vue.createElementVNode)("h5", _hoisted_216, (0, _vue.toDisplayString)($setup.driverData.cancelledRidesLastMonth), 1)
                        ])
                    ])
                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_217, " N/A"))
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_218, [
            (0, _vue.createElementVNode)("div", _hoisted_219, [
                _cache[113] || (_cache[113] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h3", null, "Driver Rides")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_220, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: `/api/datatable/driver-rides?driverId=${$setup.props.driverId}`
                        },
                        ref: "ridesDataTable",
                        class: "table-responsive display",
                        columns: $setup.ridesColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewDriver ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_221, [
            (0, _vue.createElementVNode)("div", _hoisted_222, [
                _cache[114] || (_cache[114] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h3", null, "Driver Reviews")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_223, [
                    (0, _vue.createVNode)($setup["DataTable"], {
                        ajax: {
                            url: `/api/datatable/driver-reviews?driverId=${$setup.props.driverId}`
                        },
                        ref: "reviewsDataTable",
                        class: "table-responsive display",
                        columns: $setup.reviewsColumns
                    }, null, 8, [
                        "ajax"
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bbgjh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fhi3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f27f605c27475c97");
    if (script.__esModule) script = script.default;
    script.render = require("7c0586a71d6d398e").render;
    require("2fc85cedb10410a4").default(script);
    script.__scopeId = 'data-v-b399c8';
    script.__file = "DispatchUserDetail.vue";
};
initialize();
exports.default = script;

},{"f27f605c27475c97":"8dWRi","7c0586a71d6d398e":"ctVqc","2fc85cedb10410a4":"1PrkK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8dWRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _timeagoJs = require("timeago.js");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _jqueryUi = require("jquery-ui");
var _addressHelper = require("../utility/addressHelper");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'DispatchUserDetail',
    props: {
        serviceProviderId: {
            type: String,
            required: true
        },
        userId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const userData = (0, _vue.ref)(undefined);
        const editUserInfo = (0, _vue.ref)(false);
        const userFormData = (0, _vue.ref)({});
        const isProcessing = (0, _vue.ref)(false);
        const isNewDispatchUser = (0, _vue.ref)(props.userId === (0, _globalsJs.newEntityId));
        const formatTime = (value)=>{
            return `${(0, _momentDefault.default)(value).format('MMM DD, YYYY')} (${(0, _timeagoJs.format)(new Date(value))})`;
        };
        /*
* Form edit functionality
* */ const toggleEditMode = ()=>{
            editUserInfo.value = !editUserInfo.value;
        };
        const cancelCallback = ()=>{
            toggleEditMode();
        };
        const saveCallback = ()=>{
            loadUserData();
            toggleEditMode();
        };
        const loadUserData = async ()=>{
            if (isNewDispatchUser.value) {
                editUserInfo.value = true;
                return;
            }
            const response = await fetch(`/api/${props.serviceProviderId}/dispatch-user/${props.userId}`);
            if (response.ok) userData.value = await response.json();
        };
        const showResetPasswordConfirmation = ()=>{
            if (!userData.value) return;
            // Show the reset password confirmation using SweetAlert
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Reset Password',
                text: `Are you sure you want to send a password reset email for ${userData.value.fullName}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Reset Password',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
            }).then((result)=>{
                if (result.isConfirmed) resetPassword();
            });
        };
        const resetPassword = async ()=>{
            if (!userData.value) return;
            isProcessing.value = true;
            try {
                // Call the API endpoint to send a password reset email
                const response = await fetch(`/api/authenticate/send-password-reset/${userData.value.id}`, {
                    method: 'POST'
                });
                if (response.ok) // Show success message
                (0, _toastNotificationUtility.showToast)({
                    title: 'success',
                    body: `Password reset email for ${userData.value.fullName} has been sent.`,
                    type: 'success',
                    delay: 7000
                });
                else {
                    // Get the error message from the response
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to send password reset email');
                }
            } catch (error) {
                console.error('Error resetting password:', error);
                // Show error message
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: error.message || 'There was an error sending the password reset email. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        const showSendInviteConfirmation = ()=>{
            if (!userData.value) return;
            // Check if user has an email
            if (!userData.value.email) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: 'This user does not have an email address. Please add an email address before sending an invite.',
                    type: 'error',
                    delay: 7000
                });
                return;
            }
            // Show the send invite confirmation using SweetAlert
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Send Registration Invite',
                text: `Are you sure you want to send a registration invite to ${userData.value.fullName} at ${userData.value.email}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Send Invite',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d'
            }).then((result)=>{
                if (result.isConfirmed) sendInvite();
            });
        };
        const sendInvite = async ()=>{
            if (!userData.value || !userData.value.email) return;
            isProcessing.value = true;
            try {
                // Call the API endpoint to send an invitation email
                const response = await fetch(`/api/authenticate/send-invitation/${userData.value.id}`, {
                    method: 'POST'
                });
                if (response.ok) // Show success message
                (0, _toastNotificationUtility.showToast)({
                    title: 'success',
                    body: `Registration invite has been sent to ${userData.value.email}.`,
                    type: 'success',
                    delay: 7000
                });
                else {
                    // Get the error message from the response
                    const errorText = await response.text();
                    throw new Error(errorText || 'Failed to send registration invite');
                }
            } catch (error) {
                console.error('Error sending invite:', error);
                // Show error message
                (0, _toastNotificationUtility.showToast)({
                    title: 'error',
                    body: error.message || 'There was an error sending the registration invite. Please try again.',
                    type: 'error',
                    delay: 7000
                });
            } finally{
                isProcessing.value = false;
            }
        };
        (0, _vue.onMounted)(()=>{
            loadUserData();
        });
        const __returned__ = {
            props,
            userData,
            editUserInfo,
            userFormData,
            isProcessing,
            isNewDispatchUser,
            formatTime,
            toggleEditMode,
            cancelCallback,
            saveCallback,
            loadUserData,
            showResetPasswordConfirmation,
            resetPassword,
            showSendInviteConfirmation,
            sendInvite,
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref),
            nextTick: (0, _vue.nextTick),
            get moment () {
                return 0, _momentDefault.default;
            },
            get format () {
                return 0, _timeagoJs.format;
            },
            EntityForm: (0, _entityFormVueDefault.default),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment":"2meyw","timeago.js":"aPiEQ","./EntityForm.vue":"i0zng","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../utility/toastNotificationUtility":"krOtg","jquery-ui":"6clbD","../utility/addressHelper":"3Hmtq","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ctVqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-12"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-header d-flex justify-content-between gap-2"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1
};
const _hoisted_7 = {
    key: 0,
    class: "d-flex gap-2"
};
const _hoisted_8 = {
    class: "card-body"
};
const _hoisted_9 = {
    key: 0
};
const _hoisted_10 = {
    class: "mb-3"
};
const _hoisted_11 = {
    key: 0,
    class: "f-w-700 fs-5"
};
const _hoisted_12 = {
    class: "row align-items-center gy-4 mt-2"
};
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    class: "d-flex align-items-center pb-2 fs-6"
};
const _hoisted_15 = {
    key: 0
};
const _hoisted_16 = {
    class: "d-flex align-items-center py-2 fs-6"
};
const _hoisted_17 = {
    key: 0
};
const _hoisted_18 = {
    class: "d-flex align-items-center pt-2 fs-6"
};
const _hoisted_19 = {
    key: 0
};
const _hoisted_20 = {
    class: "col-md-6 border-start"
};
const _hoisted_21 = {
    class: "d-flex align-items-center gap-2 pb-2"
};
const _hoisted_22 = {
    class: "recent-text"
};
const _hoisted_23 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_24 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_25 = {
    class: "d-flex align-items-center gap-2 py-2"
};
const _hoisted_26 = {
    class: "recent-text"
};
const _hoisted_27 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_28 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_29 = {
    class: "d-flex align-items-center gap-2 py-2"
};
const _hoisted_30 = {
    class: "recent-text"
};
const _hoisted_31 = {
    key: 0,
    class: "fa-solid fa-circle-check text-success"
};
const _hoisted_32 = {
    key: 1,
    class: "fa-solid fa-circle-xmark text-danger"
};
const _hoisted_33 = {
    class: "d-flex align-items-center gap-2 pt-2"
};
const _hoisted_34 = {
    class: "recent-text"
};
const _hoisted_35 = {
    key: 0
};
const _hoisted_36 = {
    key: 1
};
const _hoisted_37 = {
    key: 1
};
const _hoisted_38 = {
    key: 0
};
const _hoisted_39 = {
    class: "row"
};
const _hoisted_40 = {
    class: "col-sm-6"
};
const _hoisted_41 = {
    class: "mb-3"
};
const _hoisted_42 = {
    class: "col-sm-6"
};
const _hoisted_43 = {
    class: "mb-3"
};
const _hoisted_44 = {
    class: "col-sm-6"
};
const _hoisted_45 = {
    class: "mb-3"
};
const _hoisted_46 = {
    class: "col-sm-6"
};
const _hoisted_47 = {
    class: "mb-3"
};
const _hoisted_48 = {
    class: "col-sm-6"
};
const _hoisted_49 = {
    class: "mb-3"
};
const _hoisted_50 = {
    class: "form-check form-switch"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " Dispatch User Detail ")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("h3", null, [
                        $setup.isNewDispatchUser ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_5, "New ")) : $setup.editUserInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_6, "Edit ")) : (0, _vue.createCommentVNode)("", true),
                        _cache[6] || (_cache[6] = (0, _vue.createTextVNode)(" Dispatch User Information "))
                    ]),
                    !$setup.isNewDispatchUser ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary",
                            onClick: $setup.showResetPasswordConfirmation
                        }, _cache[7] || (_cache[7] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-key"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Reset Password ")
                        ])),
                        $setup.userData && !$setup.userData.lastLogin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            class: "btn btn-success",
                            onClick: $setup.showSendInviteConfirmation
                        }, _cache[8] || (_cache[8] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-envelope"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Send Registration Invite ")
                        ]))) : (0, _vue.createCommentVNode)("", true),
                        !$setup.editUserInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 1,
                            class: "btn btn-outline-primary",
                            onClick: $setup.toggleEditMode
                        }, _cache[9] || (_cache[9] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "icon-pencil-alt"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Edit Information ")
                        ]))) : (0, _vue.createCommentVNode)("", true)
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_8, [
                    !$setup.editUserInfo && !$setup.isNewDispatchUser ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                        (0, _vue.createElementVNode)("div", _hoisted_10, [
                            $setup.userData && $setup.userData.fullName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_11, (0, _vue.toDisplayString)($setup.userData.fullName), 1)) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_12, [
                            (0, _vue.createElementVNode)("div", _hoisted_13, [
                                (0, _vue.createElementVNode)("ul", null, [
                                    (0, _vue.createElementVNode)("li", _hoisted_14, [
                                        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Email:", -1)),
                                        _cache[11] || (_cache[11] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.userData && $setup.userData.email ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_15, (0, _vue.toDisplayString)($setup.userData.email), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_16, [
                                        _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Mobile Number:", -1)),
                                        _cache[13] || (_cache[13] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.userData && $setup.userData.phoneNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_17, (0, _vue.toDisplayString)($setup.userData.phoneNumber), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_18, [
                                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("span", {
                                            class: "f-w-700"
                                        }, "Service Provider:", -1)),
                                        _cache[15] || (_cache[15] = (0, _vue.createTextVNode)(" \xa0 ")),
                                        $setup.userData && $setup.userData.serviceProvider ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_19, (0, _vue.toDisplayString)($setup.userData.serviceProvider.name), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_20, [
                                (0, _vue.createElementVNode)("ul", null, [
                                    (0, _vue.createElementVNode)("li", _hoisted_21, [
                                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Email Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.userData && $setup.userData.emailVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_23)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_24))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_25, [
                                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Mobile Verification")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_26, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.userData && $setup.userData.phoneNumberVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_27)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_28))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_29, [
                                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Admin User")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_30, [
                                            (0, _vue.createElementVNode)("h5", null, [
                                                $setup.userData && $setup.userData.isAdminUser ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_31)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_32))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("li", _hoisted_33, [
                                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                            class: "flex-grow-1"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-400"
                                            }, "Last Login")
                                        ], -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_34, [
                                            $setup.userData && $setup.userData.lastLogin ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_35, (0, _vue.toDisplayString)($setup.formatTime($setup.userData.lastLogin)), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h5", _hoisted_36, "N/A"))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.editUserInfo || $setup.isNewDispatchUser ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_37, [
                        (0, _vue.createVNode)($setup["EntityForm"], {
                            "model-constructor": "DispatchUser",
                            "api-url": `/api/${$setup.props.serviceProviderId}/dispatch-user`,
                            entity: $setup.userFormData,
                            "onUpdate:entity": _cache[5] || (_cache[5] = ($event)=>$setup.userFormData = $event),
                            "form-name": "Dispatch User",
                            "show-title": false,
                            "start-in-edit": true,
                            "entity-id": $props.userId,
                            "post-save": $setup.saveCallback,
                            "on-cancel-callback": $setup.cancelCallback,
                            "redirect-url": `/service-provider/${$setup.props.serviceProviderId}/dispatch-user`
                        }, {
                            default: (0, _vue.withCtx)(()=>[
                                    $setup.userFormData.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_38, [
                                        (0, _vue.createElementVNode)("div", _hoisted_39, [
                                            (0, _vue.createElementVNode)("div", _hoisted_40, [
                                                (0, _vue.createElementVNode)("div", _hoisted_41, [
                                                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "dispatch-user-first-name-input"
                                                    }, "First Name", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "dispatch-user-first-name-input",
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.userFormData.state.firstName = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "John"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.userFormData.state.firstName
                                                        ]
                                                    ]),
                                                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                                                        id: "dispatch-user-first-name-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter the first name. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_42, [
                                                (0, _vue.createElementVNode)("div", _hoisted_43, [
                                                    _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "dispatch-user-last-name-input"
                                                    }, "Last Name", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "dispatch-user-last-name-input",
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.userFormData.state.lastName = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "Doe"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.userFormData.state.lastName
                                                        ]
                                                    ]),
                                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                                                        id: "dispatch-user-last-name-error",
                                                        class: "invalid-feedback d-none"
                                                    }, " Please enter the last name. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_44, [
                                                (0, _vue.createElementVNode)("div", _hoisted_45, [
                                                    _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "dispatch-user-email-input"
                                                    }, "Email", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "dispatch-user-email-input",
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.userFormData.state.email = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "email@example.com"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.userFormData.state.email
                                                        ]
                                                    ]),
                                                    _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                                                        id: "dispatch-user-email-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid email address. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_46, [
                                                (0, _vue.createElementVNode)("div", _hoisted_47, [
                                                    _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "dispatch-user-phone-number-input"
                                                    }, "Phone Number", -1)),
                                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                        id: "dispatch-user-phone-number-input",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.userFormData.state.phoneNumber = $event),
                                                        class: "form-control",
                                                        type: "text",
                                                        placeholder: "+1234567890"
                                                    }, null, 512), [
                                                        [
                                                            (0, _vue.vModelText),
                                                            $setup.userFormData.state.phoneNumber
                                                        ]
                                                    ]),
                                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("div", {
                                                        id: "dispatch-user-phone-number-error",
                                                        class: "invalid-feedback d-none"
                                                    }, "Please enter a valid phone number. ", -1))
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_48, [
                                                (0, _vue.createElementVNode)("div", _hoisted_49, [
                                                    _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("label", {
                                                        class: "form-label f-w-600",
                                                        for: "user-admin-input"
                                                    }, "Admin User", -1)),
                                                    (0, _vue.createElementVNode)("div", _hoisted_50, [
                                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                            id: "user-admin-input",
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.userFormData.state.isAdminUser = $event),
                                                            class: "form-check-input",
                                                            type: "checkbox"
                                                        }, null, 512), [
                                                            [
                                                                (0, _vue.vModelCheckbox),
                                                                $setup.userFormData.state.isAdminUser
                                                            ]
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])) : (0, _vue.createCommentVNode)("", true)
                                ]),
                            _: 1
                        }, 8, [
                            "api-url",
                            "entity",
                            "entity-id",
                            "redirect-url"
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PrkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fRtVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("c96112fe56770986");
    if (script.__esModule) script = script.default;
    script.render = require("bdf1a4d0fd77a07d").render;
    require("551ea07972ffe985").default(script);
    script.__scopeId = 'data-v-7d34ab';
    script.__file = "AllServiceProviderDrivers.vue";
};
initialize();
exports.default = script;

},{"c96112fe56770986":"68uUH","bdf1a4d0fd77a07d":"gcwQf","551ea07972ffe985":"50iQA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68uUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'AllServiceProviderDrivers',
    props: {
        serviceProviderId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const driversUrl = `/api/datatable/sp-all-drivers/${props.serviceProviderId}`;
        const availableUrl = `${driversUrl}?status=AVAILABLE`;
        const onRideUrl = `${driversUrl}?status=ON_RIDE`;
        const offlineUrl = `${driversUrl}?status=OFFLINE`;
        // Define columns
        const allColumnDefinition = [
            {
                title: "Driver",
                data: "name",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
                }
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "phoneNumber",
                title: 'Phone Number'
            },
            {
                data: "totalRides",
                title: 'Rides',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data}</span> |
                    Completed <span class="text-success">${row.ridesCompleted}</span> |
                    Canceled <span class="text-danger">${row.ridesCancelled}</span>
              </span>`;
                }
            },
            {
                data: "driverStatus",
                title: 'Status',
                render: (0, _datatableRenderer.driverStatus)
            },
            {
                data: "joinedOn",
                title: 'Joined At',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary"" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
                }
            }
        ];
        const filteredColumn = [
            {
                title: "Driver",
                data: "name",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`);
                }
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "phoneNumber",
                title: 'Phone Number'
            },
            {
                data: "totalRides",
                title: 'Rides',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data}</span> |
                    Completed <span class="text-success">${row.ridesCompleted}</span> |
                    Canceled <span class="text-danger">${row.ridesCancelled}</span>
              </span>`;
                }
            },
            {
                data: "joinedOn",
                title: 'Joined At',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary"" data-id="${row.id}"
       href="/service-provider/${props.serviceProviderId}/driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
                }
            }
        ];
        const __returned__ = {
            props,
            driversUrl,
            availableUrl,
            onRideUrl,
            offlineUrl,
            allColumnDefinition,
            filteredColumn,
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            },
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gcwQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal-2"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    class: "tab-content",
    id: "icon-tabContent"
};
const _hoisted_4 = {
    class: "tab-pane fade show active",
    id: "all-drivers",
    role: "tabpanel",
    "aria-labelledby": "icon-home-tab"
};
const _hoisted_5 = {
    class: "tab-pane fade",
    id: "available-drivers",
    role: "tabpanel",
    "aria-labelledby": "profile-icon-tabs"
};
const _hoisted_6 = {
    class: "tab-pane fade",
    id: "on-ride-drivers",
    role: "tabpanel",
    "aria-labelledby": "contact-icon-tab"
};
const _hoisted_7 = {
    class: "tab-pane fade",
    id: "offline-drivers",
    role: "tabpanel",
    "aria-labelledby": "contact-icon-tab"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " All Drivers")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                class: "card-header card-no-border pb-0"
            }, [
                (0, _vue.createElementVNode)("ul", {
                    class: "nav nav-tabs",
                    id: "icon-tab",
                    role: "tablist"
                }, [
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link active",
                            id: "all-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#all-drivers",
                            role: "tab",
                            "aria-controls": "all-rides",
                            "aria-selected": "true"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-users text-primary"
                            }),
                            (0, _vue.createTextVNode)(" All Drivers ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "dispatched-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#available-drivers",
                            role: "tab",
                            "aria-controls": "dispatched-rides",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-check text-success"
                            }),
                            (0, _vue.createTextVNode)(" Available Drivers ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "ordered-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#on-ride-drivers",
                            role: "tab",
                            "aria-controls": "ordered-rides",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-car-side text-warning"
                            }),
                            (0, _vue.createTextVNode)(" On Ride Drivers ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "ordered-rides-tab",
                            "data-bs-toggle": "tab",
                            href: "#offline-drivers",
                            role: "tab",
                            "aria-controls": "ordered-rides",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-xmark text-danger"
                            }),
                            (0, _vue.createTextVNode)(" Offline Drivers ")
                        ])
                    ])
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                (0, _vue.createElementVNode)("div", _hoisted_3, [
                    (0, _vue.createElementVNode)("div", _hoisted_4, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.driversUrl
                            },
                            ref: "allRides",
                            class: "table-responsive display custom-datatable",
                            columns: $setup.allColumnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.availableUrl
                            },
                            ref: "dispatchedRides",
                            class: "table-responsive display",
                            columns: $setup.filteredColumn
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.onRideUrl
                            },
                            ref: "orderedRides",
                            class: "table-responsive display",
                            columns: $setup.filteredColumn
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_7, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.offlineUrl
                            },
                            ref: "orderedRides",
                            class: "table-responsive display",
                            columns: $setup.filteredColumn
                        }, null, 8, [
                            "ajax"
                        ])
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50iQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSIUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("92d706d14e8f0b17");
    if (script.__esModule) script = script.default;
    script.render = require("bb8bd1724a68619f").render;
    require("fe4ca0ff205fc03a").default(script);
    script.__scopeId = 'data-v-d6b300';
    script.__file = "AllServiceProviderDispatchUsers.vue";
};
initialize();
exports.default = script;

},{"92d706d14e8f0b17":"1rZkC","bb8bd1724a68619f":"5VSFB","fe4ca0ff205fc03a":"2j4Pv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1rZkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'AllServiceProviderDispatchUsers',
    props: {
        serviceProviderId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const dispatchUserUrl = `/api/datatable/sp-dispatch-users/${props.serviceProviderId}`;
        // Define columns
        const dispatcherColumns = [
            {
                data: 'fullName',
                title: 'Name'
            },
            {
                data: 'email',
                title: 'Email'
            },
            {
                data: 'isAdminUser',
                title: 'Admin User',
                render: (0, _datatableRenderer.booleanBadgeRender)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
                href="/service-provider/${props.serviceProviderId}/dispatch-user/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i> </a>`;
                }
            }
        ];
        const __returned__ = {
            props,
            dispatchUserUrl,
            dispatcherColumns,
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get booleanBadgeRender () {
                return 0, _datatableRenderer.booleanBadgeRender;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            },
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5VSFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " All Dispatch Users")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                (0, _vue.createVNode)($setup["DataTable"], {
                    ajax: {
                        url: $setup.dispatchUserUrl
                    },
                    ref: "orderedRides",
                    class: "table-responsive display",
                    columns: $setup.dispatcherColumns
                }, null, 8, [
                    "ajax"
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2j4Pv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gsZUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("e3c79fe7346927e9");
    if (script.__esModule) script = script.default;
    script.render = require("910a70c5090da111").render;
    require("47cb7e316c9bc399").default(script);
    script.__scopeId = 'data-v-d0c579';
    script.__file = "DispatchUserOnboardingForm.vue";
};
initialize();
exports.default = script;

},{"e3c79fe7346927e9":"dZUVd","910a70c5090da111":"8iJs4","47cb7e316c9bc399":"1yK4R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZUVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
exports.default = {
    __name: 'DispatchUserOnboardingForm',
    props: {
        token: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Reactive state
        const firstName = (0, _vue.ref)('');
        const lastName = (0, _vue.ref)('');
        const phoneNumber = (0, _vue.ref)('');
        const newPassword = (0, _vue.ref)('');
        const confirmPassword = (0, _vue.ref)('');
        const loading = (0, _vue.ref)(false);
        const showPassword = (0, _vue.ref)(false);
        const errorMessage = (0, _vue.ref)(null);
        // Clear error message when user starts typing in any field
        (0, _vue.watch)([
            firstName,
            lastName,
            phoneNumber,
            newPassword,
            confirmPassword
        ], ()=>{
            if (errorMessage.value) errorMessage.value = null;
        });
        const togglePassword = ()=>{
            showPassword.value = !showPassword.value;
        };
        // Fetch user data on mount
        (0, _vue.onMounted)(async ()=>{
            try {
                const response = await fetch(`/api/authenticate/user-info?token=${props.token}`);
                if (response.ok) {
                    const userData = await response.json();
                    firstName.value = userData.firstName || '';
                    lastName.value = userData.lastName || '';
                    phoneNumber.value = userData.phoneNumber || '';
                } else errorMessage.value = 'Failed to load user information. Please try again.';
            } catch (error) {
                console.error('Error fetching user data:', error);
                errorMessage.value = 'An error occurred while loading your information. Please try again later.';
            }
        });
        const handleOnboarding = async ()=>{
            if (loading.value) return;
            // Validate passwords match
            if (newPassword.value !== confirmPassword.value) {
                errorMessage.value = 'Passwords do not match!';
                return;
            }
            loading.value = true;
            errorMessage.value = null;
            try {
                const response = await fetch('/api/authenticate/complete-dispatcher-onboarding', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        firstName: firstName.value,
                        lastName: lastName.value,
                        phoneNumber: phoneNumber.value,
                        newPassword: newPassword.value,
                        token: props.token
                    })
                });
                if (response.redirected || response.ok) // Redirect to login page upon success
                window.location.href = response.url;
                else {
                    // If response is not OK, show error message
                    const errorText = await response.text();
                    errorMessage.value = errorText || 'Failed to complete registration. Please try again.';
                }
            } catch (error) {
                errorMessage.value = 'An error occurred. Please try again later.';
                console.error('Error completing registration:', error);
            } finally{
                loading.value = false;
            }
        };
        const __returned__ = {
            props,
            firstName,
            lastName,
            phoneNumber,
            newPassword,
            confirmPassword,
            loading,
            showPassword,
            errorMessage,
            togglePassword,
            handleOnboarding,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iJs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card login-dark"
};
const _hoisted_5 = {
    class: "login-main wide-main position-relative"
};
const _hoisted_6 = {
    class: "form-group"
};
const _hoisted_7 = {
    class: "form-group"
};
const _hoisted_8 = {
    class: "form-group"
};
const _hoisted_9 = {
    class: "form-group"
};
const _hoisted_10 = {
    class: "form-input position-relative"
};
const _hoisted_11 = [
    "type"
];
const _hoisted_12 = {
    class: "form-group"
};
const _hoisted_13 = {
    class: "form-group mb-0 checkbox-checked"
};
const _hoisted_14 = {
    key: 0,
    class: "text-danger fs-6"
};
const _hoisted_15 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("a", {
                                class: "logo",
                                href: "#"
                            }, [
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-light m-auto",
                                    src: "/assets/images/logo.svg",
                                    alt: "loginpage"
                                }),
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-dark",
                                    src: "/assets/images/logo.svg",
                                    alt: "logo"
                                })
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            (0, _vue.createElementVNode)("form", {
                                class: "theme-form",
                                onSubmit: (0, _vue.withModifiers)($setup.handleOnboarding, [
                                    "prevent"
                                ])
                            }, [
                                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("h2", null, "Complete Your Registration", -1)),
                                _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("h6", {
                                    class: "mt-4 f-w-700"
                                }, "Confirm Your Information", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_6, [
                                    _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "First Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.firstName = $event),
                                        required: "",
                                        placeholder: "John"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.firstName
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Last Name", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.lastName = $event),
                                        required: "",
                                        placeholder: "Doe"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.lastName
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Phone Number", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "tel",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.phoneNumber = $event),
                                        required: "",
                                        placeholder: "+1234567890"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.phoneNumber
                                        ]
                                    ])
                                ]),
                                _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("h6", {
                                    class: "mt-4 f-w-700"
                                }, "Create Your Password", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_9, [
                                    _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "New Password", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_10, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: $setup.showPassword ? 'text' : 'password',
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.newPassword = $event),
                                            required: "",
                                            placeholder: "*********"
                                        }, null, 8, _hoisted_11), [
                                            [
                                                (0, _vue.vModelDynamic),
                                                $setup.newPassword
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "show-hide",
                                            onClick: $setup.togglePassword
                                        }, [
                                            (0, _vue.createElementVNode)("span", {
                                                class: (0, _vue.normalizeClass)($setup.showPassword ? 'hide' : 'show')
                                            }, null, 2)
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_12, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("label", {
                                        class: "col-form-label"
                                    }, "Confirm Password", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        class: "form-control",
                                        type: "password",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.confirmPassword = $event),
                                        required: "",
                                        placeholder: "*********"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.confirmPassword
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_13, [
                                    $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_14, (0, _vue.toDisplayString)($setup.errorMessage), 1)) : (0, _vue.createCommentVNode)("", true),
                                    (0, _vue.createElementVNode)("button", {
                                        class: "btn btn-primary btn-block w-60 mt-3",
                                        type: "submit",
                                        disabled: $setup.loading
                                    }, (0, _vue.toDisplayString)($setup.loading ? 'Submitting...' : 'Complete Registration'), 9, _hoisted_15)
                                ]),
                                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("p", {
                                    class: "mt-4 mb-0 text-center"
                                }, [
                                    (0, _vue.createTextVNode)(" Already registered?"),
                                    (0, _vue.createElementVNode)("a", {
                                        class: "ms-2",
                                        href: "/"
                                    }, "Sign in")
                                ], -1))
                            ], 32)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yK4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMfZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("e16f607622baeca5");
    if (script.__esModule) script = script.default;
    script.render = require("824387c14505cb18").render;
    script.__cssModules = require("293c37e04e4c57fb").default;
    require("67022d31a978290a").default(script);
    script.__scopeId = 'data-v-dd3b38';
    script.__file = "DriverUserOnboardingForm.vue";
};
initialize();
exports.default = script;

},{"e16f607622baeca5":"grZDd","824387c14505cb18":"j7Nrn","293c37e04e4c57fb":"5isJb","67022d31a978290a":"9k2HJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grZDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _jqueryWizard = require("./../../extras/js/jquery-wizard");
var _driverOnboardingStepPersonalInfoVue = require("./DriverOnboardingStepPersonalInfo.vue");
var _driverOnboardingStepPersonalInfoVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepPersonalInfoVue);
var _driverOnboardingStepVehicleInfoVue = require("./DriverOnboardingStepVehicleInfo.vue");
var _driverOnboardingStepVehicleInfoVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepVehicleInfoVue);
var _driverOnboardingStepDocumentUploadVue = require("./DriverOnboardingStepDocumentUpload.vue");
var _driverOnboardingStepDocumentUploadVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepDocumentUploadVue);
var _driverOnboardingStepReviewSubmitVue = require("./DriverOnboardingStepReviewSubmit.vue");
var _driverOnboardingStepReviewSubmitVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepReviewSubmitVue);
// Models for each step
var _driverOnboardingPersonalInfo = require("../modelTemplates/DriverOnboardingPersonalInfo");
var _driverOnboardingPersonalInfoDefault = parcelHelpers.interopDefault(_driverOnboardingPersonalInfo);
var _driverOnboardingVehicleInfo = require("../modelTemplates/DriverOnboardingVehicleInfo");
var _driverOnboardingVehicleInfoDefault = parcelHelpers.interopDefault(_driverOnboardingVehicleInfo);
var _driverOnboardingDocumentUpload = require("../modelTemplates/DriverOnboardingDocumentUpload");
var _driverOnboardingDocumentUploadDefault = parcelHelpers.interopDefault(_driverOnboardingDocumentUpload);
var _driverOnboardingReviewSubmit = require("../modelTemplates/DriverOnboardingReviewSubmit");
var _driverOnboardingReviewSubmitDefault = parcelHelpers.interopDefault(_driverOnboardingReviewSubmit);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
// Onboarding is session-authenticated; the page renders only for a signed-in driver,
// so the API calls below rely on the session cookie (no token in the URL).
// We'll provide the reactive step models after initialization
// Register local components
// (Vite/vue-loader will handle, no global registration required here)
// State
exports.default = {
    __name: 'DriverUserOnboardingForm',
    setup (__props, { expose: __expose }) {
        __expose();
        const form = (0, _vue.ref)({
            personalInfo: {},
            vehicleInfo: {},
            documents: {},
            review: {}
        });
        // Initialize step models
        const personalModel = (0, _driverOnboardingPersonalInfoDefault.default)();
        const vehicleModel = (0, _driverOnboardingVehicleInfoDefault.default)();
        const documentsModel = (0, _driverOnboardingDocumentUploadDefault.default)();
        const reviewModel = (0, _driverOnboardingReviewSubmitDefault.default)();
        // Bind form fields to model states for v-model compatibility
        form.value.personalInfo = personalModel.state;
        form.value.vehicleInfo = vehicleModel.state;
        form.value.documents = documentsModel.state;
        form.value.review = reviewModel.state;
        // Provide reactive states to review component
        (0, _vue.provide)('personalInfo', personalModel.state);
        (0, _vue.provide)('vehicleInfo', vehicleModel.state);
        (0, _vue.provide)('documentsInfo', documentsModel.state);
        (0, _vue.provide)('reviewModel', reviewModel);
        const documentsStep = (0, _vue.ref)(null);
        const currentStepIndex = (0, _vue.ref)(0); // 0=Personal, 1=Vehicle, 2=Documents, 3=Review
        const isSaving = (0, _vue.ref)(false);
        const suppressNavHooks = (0, _vue.ref)(false);
        // Navigate to a specific step (called from review step edit buttons)
        function goToStep(stepIndex) {
            try {
                suppressNavHooks.value = true;
                $('#driver-onboarding-wizard').wizard('goTo', stepIndex);
                setTimeout(()=>{
                    suppressNavHooks.value = false;
                }, 100);
            } catch (err) {
                console.error('Failed to navigate to step', stepIndex, err);
            }
        }
        async function loadProgress() {
            try {
                const res = await fetch('/api/driver-onboarding/data');
                if (!res.ok) return; // no saved progress yet
                const data = await res.json();
                // Expecting shape: { personalInfo: {}, vehicleInfo: {}, documentsInfo: {}, review: {}, stepCompleted: number }
                Object.assign(personalModel.state, data.personalInfo || {});
                const vInfo = data.vehicleInfo || {};
                Object.assign(vehicleModel.state, {
                    make: vInfo.make ?? '',
                    model: vInfo.model ?? '',
                    year: vInfo.year ?? '',
                    color: vInfo.color ?? '',
                    plateNumber: vInfo.plateNumber ?? '',
                    vehicleType: vInfo.vehicleType ?? '',
                    capacity: vInfo.capacity ?? '',
                    vehicleTypes: Array.isArray(vInfo.vehicleTypes) ? vInfo.vehicleTypes : vInfo.vehicleTypes ? [
                        vInfo.vehicleTypes
                    ] : []
                });
                const docsInfo = data.documentsInfo || {};
                Object.assign(documentsModel.state, {
                    licenseExpiryDate: docsInfo.licenseExpiryDate ?? '',
                    registrationExpiryDate: docsInfo.registrationExpiryDate ?? '',
                    insuranceExpiryDate: docsInfo.insuranceExpiryDate ?? '',
                    hasLicenseDocument: docsInfo.hasLicenseDocument ?? false,
                    hasRegistrationDocument: docsInfo.hasRegistrationDocument ?? false,
                    hasInsuranceDocument: docsInfo.hasInsuranceDocument ?? false
                });
                Object.assign(reviewModel.state, data.review || {});
                currentStepIndex.value = Number.isInteger(data.stepCompleted) ? data.stepCompleted : 0;
                // Try to navigate to the saved step if plugin supports it
                await (0, _vue.nextTick)();
                // Reflect completed steps in UI (green checks)
                applyCompletionChecks(currentStepIndex.value - 1);
                suppressNavHooks.value = true;
                $('#driver-onboarding-wizard').wizard('goTo', currentStepIndex.value);
                setTimeout(()=>{
                    suppressNavHooks.value = false;
                }, 0);
            } catch (e) {
                // Silently ignore for now; implement proper error UI later
                console.warn('Failed to load onboarding progress', e);
            }
        }
        async function saveStep(stepIndex) {
            // Save the portion of the form corresponding to the completed step
            // Step order: 0=Personal, 1=Vehicle, 2=Documents, 3=Review
            const payload = {
                personalInfo: stepIndex >= 0 ? personalModel.toJSON() : null,
                vehicleInfo: stepIndex >= 1 ? vehicleModel.toJSON() : null,
                documentsInfo: stepIndex >= 2 ? documentsModel.toJSON() : null,
                review: stepIndex >= 3 ? reviewModel.toJSON() : null,
                stepIndex
            };
            try {
                isSaving.value = true;
                // If documents are part of this save, include any selected files in FormData
                const fd = new FormData();
                // Send JSON as a regular text field for easy parsing on the server
                fd.append('data', JSON.stringify(payload));
                // Append files if present
                const docsState = documentsModel.state;
                if (docsState?.driverLicenseFiles && docsState.driverLicenseFiles.length > 0) docsState.driverLicenseFiles.forEach((file, index)=>{
                    fd.append(`driverLicenseFile[${index}]`, file);
                });
                if (docsState?.registrationDocFile) fd.append('registrationDocFile', docsState.registrationDocFile);
                if (docsState?.insuranceDocFile) fd.append('insuranceDocFile', docsState.insuranceDocFile);
                const res = await fetch('/api/driver-onboarding/save', {
                    method: 'POST',
                    body: fd
                });
                if (!res.ok) {
                    const respText = await res.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Save failed',
                        body: respText || 'We could not save your progress. Please try again.',
                        type: 'error',
                        delay: 8000
                    });
                    return false;
                }
                return true;
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Network error',
                    body: 'We could not save your progress. Please try again.',
                    type: 'error'
                });
                return false;
            } finally{
                isSaving.value = false;
            }
        }
        function personalInfoIsValid() {
            return personalModel.isValid();
        }
        function vehicleInfoIsValid() {
            return vehicleModel.isValid();
        }
        function documentsIsValid() {
            if (documentsModel.isValid()) return true;
            // The inline declaration alert stays hidden until a checkbox is clicked, so a refused
            // Continue has to reveal it or the toast points at a section that looks complete.
            documentsStep.value?.revealDeclarationError();
            return false;
        }
        function reviewIsValid() {
            return reviewModel.isValid();
        }
        function addCompletionCheck(idx) {
            const $a = $('.nav.nav-pills.horizontal-options > a').eq(idx);
            if (!$a || !$a.length) return;
            const $title = $a.find('.horizontal-wizard-content h5');
            if (!$title || !$title.length) return;
            if ($title.find('.step-complete-check').length) return;
            $title.append('<i class="fa-solid fa-check text-success ms-2 step-complete-check" title="Completed" aria-hidden="true"></i>');
        }
        function applyCompletionChecks(upToIdx) {
            const max = Number.isInteger(upToIdx) ? upToIdx : -1;
            for(let i = 0; i <= max; i++)addCompletionCheck(i);
        }
        function setupWizard() {
            $('#driver-onboarding-wizard').wizard({
                step: '.nav-pills > a',
                classes: {
                    step: {
                        active: 'active'
                    },
                    pane: {
                        active: 'active show'
                    },
                    button: {
                        hide: 'd-none',
                        disabled: 'd-none'
                    }
                },
                buttonsAppendTo: '#driver-onboarding-navigation',
                templates: {
                    buttons: function() {
                        return `<div class="pull-left">
                  <a role="button" class="btn btn-outline-secondary mb-3" href="#driver-onboarding-wizard" data-wizard="back">Back</a>
                </div>
                <div class="pull-right">
                  <a role="button" class="btn btn-outline-primary mb-3" href="#driver-onboarding-wizard" data-wizard="next">Save and continue</a>
                  <a role="button" class="btn btn-outline-success mb-3" href="#driver-onboarding-wizard" data-wizard="finish">Submit</a>
                </div>`;
                    }
                },
                validator: function(step) {
                    // Step order: 0=Personal, 1=Vehicle, 2=Documents, 3=Review
                    currentStepIndex.value = step.index;
                    let valid = true;
                    if (step.index === 0) valid = personalInfoIsValid();
                    else if (step.index === 1) valid = vehicleInfoIsValid();
                    else if (step.index === 2) valid = documentsIsValid();
                    else if (step.index === 3) valid = reviewIsValid();
                    if (!valid) (0, _toastNotificationUtility.showToast)({
                        title: 'Validation failed',
                        body: 'Please complete the required fields for this step.',
                        type: 'warn'
                    });
                    return valid;
                },
                onAfterChange: function(currentStep, nextStep) {
                    // Attempt to save when moving forward from a step
                    if (nextStep.index > currentStep.index) {
                        const completedIndex = currentStep.index;
                        saveStep(completedIndex).then((ok)=>{
                            if (ok) {
                                currentStepIndex.value = nextStep.index;
                                // Mark the completed step with a green check
                                addCompletionCheck(completedIndex);
                            } else try {
                                $('#driver-onboarding-wizard').wizard('goTo', completedIndex);
                            } catch (err) {
                                console.warn('Failed to navigate back after save error', err);
                            }
                        });
                    }
                },
                onFinish: function() {
                    // Final save of all data, then complete onboarding and redirect
                    // Step 3 is Review (final step)
                    saveStep(3).then(async (ok)=>{
                        if (ok) try {
                            const response = await fetch('/api/driver-onboarding/complete', {
                                method: 'POST'
                            });
                            if (response.ok) {
                                const data = await response.json();
                                (0, _toastNotificationUtility.showToast)({
                                    title: 'Submitted',
                                    body: 'Your onboarding has been submitted successfully. An email has been sent to you with next steps.',
                                    type: 'success'
                                });
                                // Redirect to login after a short delay
                                setTimeout(()=>{
                                    window.location.href = data.redirectUrl || '/login';
                                }, 2000);
                            } else {
                                const errorText = await response.text();
                                (0, _toastNotificationUtility.showToast)({
                                    title: 'Error',
                                    body: errorText || 'Failed to complete onboarding. Please try again.',
                                    type: 'error'
                                });
                            }
                        } catch (error) {
                            console.error('Error completing onboarding:', error);
                            (0, _toastNotificationUtility.showToast)({
                                title: 'Error',
                                body: 'An error occurred while completing your onboarding. Please try again.',
                                type: 'error'
                            });
                        }
                    });
                }
            });
        }
        (0, _vue.onMounted)(async ()=>{
            await (0, _vue.nextTick)();
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Before You Begin',
                html: `
      <div class="text-start">
        <p>Please have the following documents ready to upload:</p>
        <ul class="list-unstyled">
          <li><i class="fa-solid fa-id-card text-primary me-2"></i> Driver's License</li>
          <li><i class="fa-solid fa-car text-primary me-2"></i> Vehicle Registration</li>
          <li><i class="fa-solid fa-shield text-primary me-2"></i> Insurance Policy <span class="text-muted">(optional)</span></li>
        </ul>
        <p class="text-muted mb-0"><small>You'll also need the expiry dates for each document.</small></p>
      </div>
    `,
                icon: 'info',
                confirmButtonText: 'I\'m Ready',
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false
            });
            setupWizard();
            await loadProgress();
        });
        (0, _vue.onUnmounted)(()=>{
        // no-op for now
        });
        const __returned__ = {
            form,
            personalModel,
            vehicleModel,
            documentsModel,
            reviewModel,
            documentsStep,
            currentStepIndex,
            isSaving,
            suppressNavHooks,
            goToStep,
            loadProgress,
            saveStep,
            personalInfoIsValid,
            vehicleInfoIsValid,
            documentsIsValid,
            reviewIsValid,
            addCompletionCheck,
            applyCompletionChecks,
            setupWizard,
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            ref: (0, _vue.ref),
            nextTick: (0, _vue.nextTick),
            provide: (0, _vue.provide),
            DriverOnboardingStepPersonalInfo: (0, _driverOnboardingStepPersonalInfoVueDefault.default),
            DriverOnboardingStepVehicleInfo: (0, _driverOnboardingStepVehicleInfoVueDefault.default),
            DriverOnboardingStepDocumentUpload: (0, _driverOnboardingStepDocumentUploadVueDefault.default),
            DriverOnboardingStepReviewSubmit: (0, _driverOnboardingStepReviewSubmitVueDefault.default),
            get DriverOnboardingPersonalInfoModel () {
                return 0, _driverOnboardingPersonalInfoDefault.default;
            },
            get DriverOnboardingVehicleInfoModel () {
                return 0, _driverOnboardingVehicleInfoDefault.default;
            },
            get DriverOnboardingDocumentUploadModel () {
                return 0, _driverOnboardingDocumentUploadDefault.default;
            },
            get DriverOnboardingReviewSubmitModel () {
                return 0, _driverOnboardingReviewSubmitDefault.default;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","./../../extras/js/jquery-wizard":"16izs","./DriverOnboardingStepPersonalInfo.vue":"58oM1","./DriverOnboardingStepVehicleInfo.vue":"4ODpb","./DriverOnboardingStepDocumentUpload.vue":"6Jo7v","./DriverOnboardingStepReviewSubmit.vue":"drwTM","../modelTemplates/DriverOnboardingPersonalInfo":"ecauZ","../modelTemplates/DriverOnboardingVehicleInfo":"glyXW","../modelTemplates/DriverOnboardingDocumentUpload":"iPszW","../modelTemplates/DriverOnboardingReviewSubmit":"hDntw","../utility/toastNotificationUtility":"krOtg","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58oM1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("7026535747263de4");
    if (script.__esModule) script = script.default;
    script.render = require("28eae57e75bc4bd0").render;
    require("8eb76e38bc4551c1").default(script);
    script.__scopeId = 'data-v-0d0a67';
    script.__file = "DriverOnboardingStepPersonalInfo.vue";
};
initialize();
exports.default = script;

},{"7026535747263de4":"dx3rz","28eae57e75bc4bd0":"cT0Zw","8eb76e38bc4551c1":"d2hRt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dx3rz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _addressHelper = require("../utility/addressHelper");
// v-model from parent binds to the model state object
exports.default = {
    __name: 'DriverOnboardingStepPersonalInfo',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const model = (0, _vue.useModel)(__props, "modelValue");
        const fullName = (0, _vue.computed)({
            get: ()=>`${model.value.firstName || ''} ${model.value.lastName || ''}`.trim(),
            set: (val)=>{
                const parts = String(val || '').split(' ');
                model.value.firstName = parts.shift() || '';
                model.value.lastName = parts.join(' ') || '';
            }
        });
        // Address autocomplete for driver onboarding
        let driverAddressInput = null;
        let driverAddressAutocompleteInitialized = false;
        // Parse Google Maps address_components
        const parseAddressComponents = (addressComponents)=>{
            const parsed = {
                city: '',
                state: '',
                country: '',
                postalCode: ''
            };
            if (!addressComponents || !Array.isArray(addressComponents)) return parsed;
            addressComponents.forEach((component)=>{
                const types = component.types || [];
                // City - check multiple possible types
                if (types.includes('locality')) parsed.city = component.long_name;
                else if (!parsed.city && types.includes('postal_town')) parsed.city = component.long_name;
                else if (!parsed.city && types.includes('sublocality_level_1')) parsed.city = component.long_name;
                // State/Province
                if (types.includes('administrative_area_level_1')) parsed.state = component.short_name; // Use short_name for abbreviations (e.g., "CA", "NY")
                // Country
                if (types.includes('country')) parsed.country = component.long_name;
                // Postal Code
                if (types.includes('postal_code')) parsed.postalCode = component.long_name;
            });
            return parsed;
        };
        const initDriverAddressAutocomplete = ()=>{
            if (!driverAddressInput || driverAddressAutocompleteInitialized) return;
            try {
                $(driverAddressInput).autocomplete({
                    source: (request, response)=>{
                        fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(request.term)}`).then((res)=>res.ok ? res.json() : Promise.reject(res.status)).then((data)=>{
                            const suggestions = (data?.results || []).map((result)=>({
                                    label: (0, _addressHelper.renderWithPoi)(result),
                                    value: result.name,
                                    placeId: result.id,
                                    result
                                }));
                            response(suggestions);
                        }).catch(()=>response([]));
                    },
                    minLength: 3
                }).on('autocompleteselect', (event, ui)=>{
                    const selectedItem = ui.item;
                    model.value.address = selectedItem?.value || '';
                    // Fetch full address details using place_id
                    if (selectedItem?.placeId) fetch(`/api/dispatch-ride/geocode-by-place-id?placeId=${encodeURIComponent(selectedItem.placeId)}`).then((res)=>res.ok ? res.json() : Promise.reject(res.status)).then((data)=>{
                        if (data?.results && data.results.length > 0) {
                            const addressComponents = data.results[0].address_components;
                            const parsed = parseAddressComponents(addressComponents);
                            // Update model with parsed address components
                            if (parsed.city) model.value.city = parsed.city;
                            if (parsed.state) model.value.state = parsed.state;
                            if (parsed.country) model.value.country = parsed.country;
                            if (parsed.postalCode) model.value.postalCode = parsed.postalCode;
                        }
                    }).catch((err)=>{
                        console.error('Failed to fetch address details:', err);
                    });
                }).autocomplete('instance')._renderItem = (ul, item)=>{
                    return $('<li>').append(item.label).appendTo(ul);
                };
                driverAddressAutocompleteInitialized = true;
            } catch (e) {
                console.error('Failed to init driver address autocomplete', e);
            }
        };
        (0, _vue.onMounted)(async ()=>{
            await (0, _vue.nextTick)();
            initDriverAddressAutocomplete();
        });
        (0, _vue.onUnmounted)(()=>{
            try {
                if (driverAddressInput) $(driverAddressInput).autocomplete('destroy');
            } catch (e) {
            // ignore
            }
        });
        const __returned__ = {
            model,
            fullName,
            get driverAddressInput () {
                return driverAddressInput;
            },
            set driverAddressInput (v){
                driverAddressInput = v;
            },
            get driverAddressAutocompleteInitialized () {
                return driverAddressAutocompleteInitialized;
            },
            set driverAddressAutocompleteInitialized (v){
                driverAddressAutocompleteInitialized = v;
            },
            parseAddressComponents,
            initDriverAddressAutocomplete,
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            nextTick: (0, _vue.nextTick),
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","../utility/addressHelper":"3Hmtq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cT0Zw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "driver-onboarding-step driver-onboarding-step-personal"
};
const _hoisted_2 = {
    class: "row g-3"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-md-6"
};
const _hoisted_5 = {
    class: "col-md-6"
};
const _hoisted_6 = {
    class: "col-md-6"
};
const _hoisted_7 = {
    class: "col-md-6"
};
const _hoisted_8 = {
    class: "col-md-6"
};
const _hoisted_9 = {
    class: "input-group"
};
const _hoisted_10 = {
    class: "col-12"
};
const _hoisted_11 = {
    class: "col-md-6"
};
const _hoisted_12 = {
    class: "col-md-6"
};
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    class: "col-md-6"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("label", {
                        class: "form-label f-w-600",
                        for: "driver-email-input"
                    }, "Email", -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "driver-email-input",
                        class: "form-control",
                        type: "email",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model.email = $event),
                        required: "",
                        readonly: "",
                        disabled: ""
                    }, null, 512), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.email
                        ]
                    ]),
                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("small", {
                        class: "text-muted"
                    }, "Email cannot be changed here. To update your email, please speak with your admin.", -1))
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-first-name-input"
                }, "First Name", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-first-name-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.model.firstName = $event),
                    placeholder: "e.g., Jane",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.firstName
                    ]
                ]),
                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                    id: "driver-first-name-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your first name.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_6, [
                _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-last-name-input"
                }, "Last Name", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-last-name-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.model.lastName = $event),
                    placeholder: "e.g., Doe",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.lastName
                    ]
                ]),
                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                    id: "driver-last-name-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your last name.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-dob-input"
                }, "Date of Birth", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-dob-input",
                    class: "form-control",
                    type: "date",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.model.dateOfBirth = $event),
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.dateOfBirth
                    ]
                ]),
                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "You must be at least 18 years old to drive.", -1)),
                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                    id: "driver-dob-error",
                    class: "invalid-feedback d-none"
                }, "Please provide a valid date of birth. You must be at least 18 years old.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-phone-number-input"
                }, "Phone Number", -1)),
                (0, _vue.createElementVNode)("div", _hoisted_9, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                        class: "form-select",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.countryCode = $event),
                        style: {
                            "max-width": "120px"
                        }
                    }, _cache[20] || (_cache[20] = [
                        (0, _vue.createStaticVNode)("<option value=\"+1\">+1 (US/CA)</option><option value=\"+44\">+44 (UK)</option><option value=\"+234\">+234 (NG)</option><option value=\"+91\">+91 (IN)</option><option value=\"+61\">+61 (AU)</option>", 5)
                    ]), 512), [
                        [
                            (0, _vue.vModelSelect),
                            $setup.model.countryCode
                        ]
                    ]),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "driver-phone-number-input",
                        class: "form-control",
                        type: "tel",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.model.phoneNumber = $event),
                        placeholder: "5551234567",
                        required: ""
                    }, null, 512), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.phoneNumber
                        ]
                    ])
                ]),
                _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "Select country code and enter the rest of your phone number.", -1)),
                _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                    id: "driver-phone-number-error",
                    class: "invalid-feedback d-none"
                }, "Please enter a valid phone number.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-address-input"
                }, "Street Address", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-address-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.model.address = $event),
                    placeholder: "123 Main Street",
                    required: "",
                    ref: "driverAddressInput"
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.address
                    ]
                ]),
                _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                    id: "driver-address-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your street address.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_11, [
                _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-city-input"
                }, "City", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-city-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.model.city = $event),
                    placeholder: "e.g., San Francisco",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.city
                    ]
                ]),
                _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("div", {
                    id: "driver-city-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your city.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_12, [
                _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-state-input"
                }, "State/Province", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-state-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.model.state = $event),
                    placeholder: "e.g., CA",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.state
                    ]
                ]),
                _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("div", {
                    id: "driver-state-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your state.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_13, [
                _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-country-input"
                }, "Country", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-country-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.model.country = $event),
                    placeholder: "e.g., United States",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.country
                    ]
                ]),
                _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("div", {
                    id: "driver-country-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your country.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_14, [
                _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "driver-postal-code-input"
                }, "Postal Code", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "driver-postal-code-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.model.postalCode = $event),
                    placeholder: "e.g., 94102",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.postalCode
                    ]
                ]),
                _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                    id: "driver-postal-code-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your postal code.", -1))
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d2hRt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ODpb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("3a2ea535d726245c");
    if (script.__esModule) script = script.default;
    script.render = require("4ed6c71a5d5b9f94").render;
    require("32a330a4e824ad0f").default(script);
    script.__scopeId = 'data-v-b92e69';
    script.__file = "DriverOnboardingStepVehicleInfo.vue";
};
initialize();
exports.default = script;

},{"3a2ea535d726245c":"k0enE","4ed6c71a5d5b9f94":"iDf7H","32a330a4e824ad0f":"kcfas","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0enE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
const maxYear = 2027;
exports.default = {
    __name: 'DriverOnboardingStepVehicleInfo',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        // Vehicle information fields; v-model is bound to the step's model state
        const model = (0, _vue.useModel)(__props, "modelValue");
        const vehicleTypeOptions = [
            {
                type: 'SEDAN',
                capacity: 4,
                label: 'Sedan (4 passengers)'
            },
            {
                type: 'SUV',
                capacity: 6,
                label: 'SUV (6 passengers)'
            },
            {
                type: 'SUV',
                capacity: 4,
                label: 'SUV (4 passengers)'
            },
            {
                type: 'MINIVAN',
                capacity: 6,
                label: 'Minivan (6 passengers)'
            }
        ];
        const onVehicleTypeChange = (event)=>{
            const selectedValue = event.target.value;
            const option = vehicleTypeOptions.find((opt)=>`${opt.type}-${opt.capacity}` === selectedValue);
            if (option) {
                model.value.vehicleType = option.type;
                model.value.capacity = option.capacity;
            }
        };
        const __returned__ = {
            model,
            vehicleTypeOptions,
            onVehicleTypeChange,
            maxYear
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iDf7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "driver-onboarding-step driver-onboarding-step-vehicle"
};
const _hoisted_2 = {
    class: "row g-3"
};
const _hoisted_3 = {
    class: "col-md-6"
};
const _hoisted_4 = {
    class: "col-md-6"
};
const _hoisted_5 = {
    class: "col-md-6"
};
const _hoisted_6 = {
    class: "col-md-6"
};
const _hoisted_7 = {
    class: "col-md-6"
};
const _hoisted_8 = {
    class: "col-md-6"
};
const _hoisted_9 = [
    "value"
];
const _hoisted_10 = [
    "value"
];
const _hoisted_11 = {
    class: "col-md-6"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-make-input"
                }, "Vehicle Make", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "vehicle-make-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model.make = $event),
                    placeholder: "e.g., Toyota",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.make
                    ]
                ]),
                _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("div", {
                    id: "vehicle-make-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your vehicle make.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_4, [
                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-model-input"
                }, "Vehicle Model", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "vehicle-model-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.model.model = $event),
                    placeholder: "e.g., Corolla",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.model
                    ]
                ]),
                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("div", {
                    id: "vehicle-model-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your vehicle model.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-color-input"
                }, "Color", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "vehicle-color-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.model.color = $event),
                    placeholder: "e.g., Black",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.color
                    ]
                ]),
                _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                    id: "vehicle-color-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your vehicle color.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_6, [
                _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-year-input"
                }, "Year", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "vehicle-year-input",
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.model.year = $event),
                    min: 1980,
                    max: $setup.maxYear,
                    placeholder: "e.g., 2018",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.year,
                        void 0,
                        {
                            number: true
                        }
                    ]
                ]),
                (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "Year must be between 1980 and " + (0, _vue.toDisplayString)($setup.maxYear) + "."),
                (0, _vue.createElementVNode)("div", {
                    id: "vehicle-year-error",
                    class: "invalid-feedback d-none"
                }, "Please enter a valid vehicle year (1980-" + (0, _vue.toDisplayString)($setup.maxYear) + ").")
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "plate-number-input"
                }, "License Plate Number", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "plate-number-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.plateNumber = $event),
                    placeholder: "e.g., ABC-1234",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.plateNumber
                    ]
                ]),
                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                    id: "plate-number-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your license plate number.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-type-select"
                }, "Vehicle Type", -1)),
                (0, _vue.createElementVNode)("select", {
                    id: "vehicle-type-select",
                    class: "form-select",
                    onChange: $setup.onVehicleTypeChange,
                    value: $setup.model.vehicleType && $setup.model.capacity ? `${$setup.model.vehicleType}-${$setup.model.capacity}` : '',
                    required: ""
                }, [
                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("option", {
                        value: "",
                        disabled: ""
                    }, "Select vehicle type", -1)),
                    ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.vehicleTypeOptions, (vt, idx)=>{
                        return (0, _vue.createElementVNode)("option", {
                            key: idx,
                            value: `${vt.type}-${vt.capacity}`
                        }, (0, _vue.toDisplayString)(vt.label), 9, _hoisted_10);
                    }), 64))
                ], 40, _hoisted_9),
                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                    class: "form-text"
                }, "Choose from the available vehicle categories.", -1)),
                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("div", {
                    id: "vehicle-type-error",
                    class: "invalid-feedback d-none"
                }, "Please select a vehicle type.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_11, [
                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "vehicle-odometer-input"
                }, "Odometer (km)", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "vehicle-odometer-input",
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.model.odometer = $event),
                    min: "0",
                    max: "200000",
                    placeholder: "e.g., 85000",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.odometer,
                        void 0,
                        {
                            number: true
                        }
                    ]
                ]),
                _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "Current odometer reading in kilometres (cannot exceed 200,000 km).", -1)),
                _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                    id: "vehicle-odometer-error",
                    class: "invalid-feedback d-none"
                }, "Please enter a valid odometer reading (0-200,000 km).", -1))
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcfas":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Jo7v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b35aae19dcb47c7");
    if (script.__esModule) script = script.default;
    script.render = require("30abfa3fdb1f83a8").render;
    script.__cssModules = require("7c39b651026e2a74").default;
    require("d0277c829859bd48").default(script);
    script.__scopeId = 'data-v-854c40';
    script.__file = "DriverOnboardingStepDocumentUpload.vue";
};
initialize();
exports.default = script;

},{"b35aae19dcb47c7":"chWXO","30abfa3fdb1f83a8":"C06fQ","7c39b651026e2a74":"fpSrv","d0277c829859bd48":"3VLHw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chWXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _bootstrap = require("bootstrap");
var _driverLicenseSidesUploadVue = require("./DriverLicenseSidesUpload.vue");
var _driverLicenseSidesUploadVueDefault = parcelHelpers.interopDefault(_driverLicenseSidesUploadVue);
var _filePickerControlsVue = require("./FilePickerControls.vue");
var _filePickerControlsVueDefault = parcelHelpers.interopDefault(_filePickerControlsVue);
var _fileUploadValidation = require("../fileUploadValidation");
exports.default = {
    __name: 'DriverOnboardingStepDocumentUpload',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        const model = (0, _vue.useModel)(__props, "modelValue");
        const insuranceFileName = (0, _vue.ref)('');
        const insurancePreparing = (0, _vue.ref)(false);
        const hasExistingInsurance = (0, _vue.computed)(()=>model.value.hasInsuranceDocument && !model.value.insuranceDocFile);
        const hasInsuranceOnFile = (0, _vue.computed)(()=>!!insuranceFileName.value || hasExistingInsurance.value);
        const licenseExpiryError = (0, _vue.ref)('');
        const insuranceExpiryError = (0, _vue.ref)('');
        /**
 * Accepts a picked insurance document, downscaling it first when it is a photo.
 *
 * @param {string} type the document being picked; only 'insurance' is handled here
 * @param {Event} e the change event from the file input
 */ async function onSelect(type, e) {
            const files = e?.target?.files;
            if (!files || files.length === 0 || type !== 'insurance') return;
            const input = e.target;
            insurancePreparing.value = true;
            try {
                const file = await (0, _fileUploadValidation.preparePickedFile)(files[0], e, (0, _fileUploadValidation.IMAGE_OR_PDF_TYPES), {
                    subject: 'insurance certificate'
                });
                if (!file) return;
                insuranceFileName.value = file.name;
                model.value.insuranceDocFile = file;
                model.value.insuranceDocId = model.value.insuranceDocId || 'PENDING_UPLOAD';
                model.value.hasInsuranceDocument = true;
            } finally{
                insurancePreparing.value = false;
                // Cleared unconditionally so re-picking the same file still raises a change event.
                input.value = '';
            }
        }
        function removeInsuranceFile() {
            insuranceFileName.value = '';
            model.value.insuranceDocFile = null;
            model.value.hasInsuranceDocument = false;
            model.value.insuranceDocId = null;
        }
        const rootEl = (0, _vue.ref)(null);
        const tooltipInstances = [];
        // Only show the declaration error after the user has interacted with
        // the checkboxes or attempted to advance the wizard step.
        const declarationTouched = (0, _vue.ref)(false);
        const declarationError = (0, _vue.computed)(()=>{
            if (!declarationTouched.value) return '';
            const allChecked = model.value.declaresNoExcessiveCancellations && model.value.declaresNoExcessiveAtFaultClaims && model.value.declaresNoExcessiveTotalClaims;
            return allChecked ? '' : 'You must confirm all insurance eligibility declarations to continue.';
        });
        function onDeclarationChange() {
            declarationTouched.value = true;
        }
        // Called by the hosting wizard when Continue is refused, so a driver who scrolled past the
        // declarations sees the alert rather than only a toast pointing at a section that looks fine.
        __expose({
            revealDeclarationError () {
                declarationTouched.value = true;
            }
        });
        // Bootstrap is consumed here as an ES import, never assigned to window, so the previous
        // `typeof bootstrap === 'undefined'` guard was always true: no tooltip was ever constructed and the
        // browser fell back to the native `title` bubble — delayed, tiny, and invisible on touch.
        (0, _vue.onMounted)(()=>{
            if (!rootEl.value) return;
            rootEl.value.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el)=>{
                tooltipInstances.push(new (0, _bootstrap.Tooltip)(el, {
                    // Appended to <body> rather than beside the icon, which would place it inside the <label> and
                    // let the card's overflow clip it.
                    container: 'body',
                    customClass: 'declaration-tooltip',
                    trigger: 'hover focus'
                }));
            });
        });
        (0, _vue.onUnmounted)(()=>{
            tooltipInstances.forEach((t)=>t.dispose());
            tooltipInstances.length = 0;
        });
        function validateExpiryDate(type) {
            const today = new Date().toISOString().split('T')[0];
            if (type === 'license') {
                if (!model.value.licenseExpiryDate) licenseExpiryError.value = 'License expiry date is required.';
                else if (model.value.licenseExpiryDate <= today) licenseExpiryError.value = 'License expiry date must be in the future.';
                else licenseExpiryError.value = '';
            } else if (type === 'insurance') {
                if (!model.value.insuranceExpiryDate) insuranceExpiryError.value = 'Insurance expiry date is required.';
                else if (model.value.insuranceExpiryDate <= today) insuranceExpiryError.value = 'Insurance expiry date must be in the future.';
                else insuranceExpiryError.value = '';
            }
        }
        const __returned__ = {
            model,
            insuranceFileName,
            insurancePreparing,
            hasExistingInsurance,
            hasInsuranceOnFile,
            licenseExpiryError,
            insuranceExpiryError,
            onSelect,
            removeInsuranceFile,
            rootEl,
            tooltipInstances,
            declarationTouched,
            declarationError,
            onDeclarationChange,
            validateExpiryDate,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            get Tooltip () {
                return 0, _bootstrap.Tooltip;
            },
            DriverLicenseSidesUpload: (0, _driverLicenseSidesUploadVueDefault.default),
            FilePickerControls: (0, _filePickerControlsVueDefault.default),
            get preparePickedFile () {
                return 0, _fileUploadValidation.preparePickedFile;
            },
            get IMAGE_OR_PDF_TYPES () {
                return 0, _fileUploadValidation.IMAGE_OR_PDF_TYPES;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","bootstrap":"900Wv","./DriverLicenseSidesUpload.vue":"cjgHU","./FilePickerControls.vue":"4gCxp","../fileUploadValidation":"27Syo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjgHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("cde986aaf892456c");
    if (script.__esModule) script = script.default;
    script.render = require("a11d1a4d3971efa6").render;
    script.__cssModules = require("92a1fa7e9ca1f397").default;
    require("1f102cc628492fcf").default(script);
    script.__scopeId = 'data-v-be4f4b';
    script.__file = "DriverLicenseSidesUpload.vue";
};
initialize();
exports.default = script;

},{"cde986aaf892456c":"dPROL","a11d1a4d3971efa6":"47FF2","92a1fa7e9ca1f397":"3ug9F","1f102cc628492fcf":"bkQ0r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPROL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _fileUploadValidation = require("../fileUploadValidation");
var _filePickerControlsVue = require("./FilePickerControls.vue");
var _filePickerControlsVueDefault = parcelHelpers.interopDefault(_filePickerControlsVue);
exports.default = {
    __name: 'DriverLicenseSidesUpload',
    props: /*@__PURE__*/ (0, _vue.mergeModels)({
        disabled: {
            type: Boolean,
            default: false
        },
        idPrefix: {
            type: String,
            default: 'license'
        }
    }, {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    }),
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const model = (0, _vue.useModel)(__props, "modelValue");
        // Derived from the model rather than held locally, so a parent that resets the model — cancelling an
        // edit, or reloading after a save — clears the tiles too.
        const licenseFrontName = (0, _vue.computed)(()=>model.value.driverLicenseFront?.name || '');
        const licenseBackName = (0, _vue.computed)(()=>model.value.driverLicenseBack?.name || '');
        const frontInputId = (0, _vue.computed)(()=>`${props.idPrefix}-front-input`);
        const backInputId = (0, _vue.computed)(()=>`${props.idPrefix}-back-input`);
        // The stored-document flag is remembered separately because picking a side clears it on the model:
        // removing that side again must not leave a driver whose licence is on file looking like they have none.
        const storedDocumentOnFile = (0, _vue.ref)(!!model.value.hasLicenseDocument);
        (0, _vue.watch)(()=>model.value.hasLicenseDocument, (onFile)=>{
            if (onFile) storedDocumentOnFile.value = true;
        });
        const hasExistingLicense = (0, _vue.computed)(()=>model.value.hasLicenseDocument && !model.value.driverLicenseFront && !model.value.driverLicenseBack);
        const licenseSidesUploaded = (0, _vue.computed)(()=>{
            if (hasExistingLicense.value) return 2;
            return (model.value.driverLicenseFront ? 1 : 0) + (model.value.driverLicenseBack ? 1 : 0);
        });
        const preparing = (0, _vue.ref)({
            licenseFront: false,
            licenseBack: false
        });
        // A thumbnail of the side just picked, so a driver on a phone can see they photographed the right
        // face of the card. It also replaces the file name as the confirmation that something was picked:
        // a camera name is a 30-character digit string with nothing to wrap on, which overflowed the tile.
        const previews = (0, _vue.ref)({
            licenseFront: '',
            licenseBack: ''
        });
        function setPreview(side, file) {
            const previous = previews.value[side];
            if (previous) URL.revokeObjectURL(previous);
            previews.value[side] = file && file.type?.startsWith('image/') ? URL.createObjectURL(file) : '';
        }
        (0, _vue.watch)(()=>model.value.driverLicenseFront, (file)=>setPreview('licenseFront', file), {
            immediate: true
        });
        (0, _vue.watch)(()=>model.value.driverLicenseBack, (file)=>setPreview('licenseBack', file), {
            immediate: true
        });
        (0, _vue.onUnmounted)(()=>{
            setPreview('licenseFront', null);
            setPreview('licenseBack', null);
        });
        // Bumped when the picker is enabled or disabled, so an in-flight pick can tell that the edit it
        // belonged to is over. Keyed on `disabled` alone and not on the model: both parents mutate the
        // model object in place rather than replacing it, so a getter watcher on it — which compares by
        // identity — would never fire and would only look like protection. The one parent with a cancel
        // button (DriverVehicleLicenseManagement) drives `disabled` off the same `isEditing` flag its
        // cancel clears, which is exactly the transition that matters. The signup wizard has no cancel,
        // passes no `disabled`, and needs no guard.
        const editSession = (0, _vue.ref)(0);
        (0, _vue.watch)(()=>props.disabled, ()=>{
            editSession.value += 1;
        });
        /**
 * Accepts a picked side, downscaling the photo before it is held for upload.
 *
 * @param {string} side either 'licenseFront' or 'licenseBack'
 * @param {Event} e the change event from the camera or file input
 */ async function onSelect(side, e) {
            const files = e?.target?.files;
            if (!files || files.length === 0) return;
            const input = e.target;
            // Compression is asynchronous and the parent can cancel an edit while it runs, which resets the
            // model. Without this the resolved photo would be written back afterwards, showing a side picked
            // against a driver whose stored licence is untouched and leaving the form permanently dirty.
            const pickedDuring = editSession.value;
            preparing.value[side] = true;
            try {
                const file = await (0, _fileUploadValidation.preparePickedFile)(files[0], e, (0, _fileUploadValidation.IMAGE_TYPES), {
                    subject: "driver's license"
                });
                if (!file || pickedDuring !== editSession.value) return;
                if (side === 'licenseFront') model.value.driverLicenseFront = file;
                else model.value.driverLicenseBack = file;
                model.value.hasLicenseDocument = false;
            } finally{
                preparing.value[side] = false;
                // Cleared unconditionally so re-picking the same photo still raises a change event.
                input.value = '';
            }
        }
        function removeLicenseFront() {
            model.value.driverLicenseFront = null;
            restoreStoredFlagWhenNothingPicked();
        }
        function removeLicenseBack() {
            model.value.driverLicenseBack = null;
            restoreStoredFlagWhenNothingPicked();
        }
        function restoreStoredFlagWhenNothingPicked() {
            if (!model.value.driverLicenseFront && !model.value.driverLicenseBack) model.value.hasLicenseDocument = storedDocumentOnFile.value;
        }
        const __returned__ = {
            props,
            model,
            licenseFrontName,
            licenseBackName,
            frontInputId,
            backInputId,
            storedDocumentOnFile,
            hasExistingLicense,
            licenseSidesUploaded,
            preparing,
            previews,
            setPreview,
            editSession,
            onSelect,
            removeLicenseFront,
            removeLicenseBack,
            restoreStoredFlagWhenNothingPicked,
            computed: (0, _vue.computed),
            onUnmounted: (0, _vue.onUnmounted),
            ref: (0, _vue.ref),
            watch: (0, _vue.watch),
            get preparePickedFile () {
                return 0, _fileUploadValidation.preparePickedFile;
            },
            get IMAGE_TYPES () {
                return 0, _fileUploadValidation.IMAGE_TYPES;
            },
            FilePickerControls: (0, _filePickerControlsVueDefault.default)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../fileUploadValidation":"27Syo","./FilePickerControls.vue":"4gCxp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"27Syo":[function(require,module,exports,__globalThis) {
/**
 * The single gate every picked upload passes through. Despite the module name it both validates and
 * *transforms*: photo downscaling lives in ./imageCompression and is orchestrated here, because the
 * size limit is only meaningful once a phone-camera frame has been re-encoded.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_UPLOAD_FILE_SIZE", ()=>MAX_UPLOAD_FILE_SIZE);
parcelHelpers.export(exports, "IMAGE_TYPES", ()=>IMAGE_TYPES);
parcelHelpers.export(exports, "IMAGE_OR_PDF_TYPES", ()=>IMAGE_OR_PDF_TYPES);
/**
 * Validates a picked file and, when it is a photo, downscales it before the size limit is applied.
 *
 * A phone camera routinely writes more than the whole 5MB limit in a single frame, so checking the
 * picked bytes first would reject photos this app can shrink to a few hundred kilobytes. The order
 * is therefore deliberate: type, then downscale, then size.
 *
 * Licence sides pass IMAGE_TYPES: the two sides are merged into a single image server-side, which
 * cannot read a PDF — a PDF side would otherwise be dropped from the merged document unnoticed.
 *
 * @param {File} file the picked file
 * @param {Event} [event] the change event, whose input is cleared when the file is refused
 * @param {string[]} acceptedTypes content-type prefixes to accept
 * @param {object} [options] `subject` names what is being uploaded in refusal messages, e.g.
 *                 "vehicle photo"; `silent` collects the reason instead of showing a dialog
 * @returns {Promise<File|null>} the file to upload — possibly re-encoded — or null when refused
 */ parcelHelpers.export(exports, "preparePickedFile", ()=>preparePickedFile);
var _sweetalert2Min = require("../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _imageCompression = require("./imageCompression");
const MAX_UPLOAD_FILE_SIZE = 5242880; // 5MB
const IMAGE_TYPES = [
    'image/'
];
const IMAGE_OR_PDF_TYPES = [
    'image/',
    'application/pdf'
];
/** Default name for the thing being uploaded, used in refusal messages. */ const DEFAULT_SUBJECT = 'file';
async function preparePickedFile(file, event, acceptedTypes = IMAGE_OR_PDF_TYPES, options = {}) {
    if (!file) return null;
    const subject = options.subject || DEFAULT_SUBJECT;
    const deny = (title, text)=>{
        if (options.silent) {
            options.silent.push(text);
            return null;
        }
        refuse(title, text, event);
        return null;
    };
    const isValidType = acceptedTypes.some((t)=>file.type.startsWith(t));
    if (!isValidType) return deny('Invalid File Type', acceptedTypes === IMAGE_TYPES ? `"${file.name}" is not a photo. Please upload an image for your ${subject}.` : `"${file.name}" is not an image or PDF.`);
    const prepared = (0, _imageCompression.isCompressibleImage)(file) ? await (0, _imageCompression.prepareImageForUpload)(file) : file;
    // The photo came back untouched and in a format the server cannot read, which means this browser
    // could not decode it either — an iPhone set to "High Efficiency" is the usual cause. Say so now
    // rather than letting the upload succeed and the document arrive unreadable.
    if ((0, _imageCompression.isCompressibleImage)(prepared) && !(0, _imageCompression.isServerReadableImage)(prepared)) return deny('Photo Format Not Supported', `We could not read "${file.name}". Please upload a JPEG, PNG, GIF, BMP or TIFF. If you ` + 'are on an iPhone, set Settings \u2192 Camera \u2192 Formats to "Most Compatible" and take the ' + 'photo again, or upload a screenshot of it instead.');
    if (prepared.size > MAX_UPLOAD_FILE_SIZE) {
        // An oversized photo that came back byte-identical was never re-encoded at all — the browser
        // declined, which on iOS means it has run out of canvas memory after several photos in a row.
        // Telling that driver their photo is too big sends them off to shrink a file that was fine.
        if ((0, _imageCompression.isCompressibleImage)(prepared) && prepared === file) return deny('Could Not Process Photo', `We could not process "${file.name}" on this device. Try adding photos one at a time, ` + 'or reload the page and try again.');
        return deny('File Too Large', `"${file.name}" is still larger than 5MB after compression. Please upload a smaller file.`);
    }
    return prepared;
}
/**
 * Shows the refusal and clears the input that produced it.
 *
 * @param {string} title the alert title
 * @param {string} text the alert body
 * @param {Event} [event] the change event, whose input is cleared when one was supplied
 */ function refuse(title, text, event) {
    (0, _sweetalert2MinDefault.default).fire({
        title,
        text,
        icon: 'error',
        confirmButtonColor: '#3085d6'
    });
    if (event?.target) event.target.value = '';
}

},{"../extras/js/sweetalert/sweetalert2.min":"ltJ5f","./imageCompression":"9ewZk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ewZk":[function(require,module,exports,__globalThis) {
/**
 * Downscales and re-encodes a photo in the browser before it is attached to an upload.
 *
 * A phone camera writes 2–8MB per frame, and a driver uploads several of them in one multipart
 * request. Re-encoding to a bounded JPEG turns that into a few hundred kilobytes per photo, which
 * is what keeps the licence/insurance submission inside the 5MB-per-file limit and off a mobile
 * connection long enough to time out.
 *
 * It also normalises the container: Java's ImageIO — which collates the two licence sides
 * server-side — reads JPEG/PNG/GIF/BMP and nothing else, so a HEIC frame straight off an iPhone
 * cannot be read there. Anything the browser can decode leaves here as JPEG.
 */ /** Longest edge kept after downscaling. A licence or pink slip stays legible well below this. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_IMAGE_DIMENSION", ()=>MAX_IMAGE_DIMENSION);
parcelHelpers.export(exports, "SERVER_READABLE_IMAGE_TYPES", ()=>SERVER_READABLE_IMAGE_TYPES);
/**
 * Reports whether a picked file is an image this module will try to re-encode.
 *
 * @param {File} file the picked file
 * @returns {boolean} true for images; false for PDFs and for nothing at all
 */ parcelHelpers.export(exports, "isCompressibleImage", ()=>isCompressibleImage);
/**
 * Reports whether the server can decode this file as an image.
 *
 * @param {File} file the picked file
 * @returns {boolean} true when the type is one the server-side image reader supports
 */ parcelHelpers.export(exports, "isServerReadableImage", ()=>isServerReadableImage);
/**
 * Downscales a photo and re-encodes it as JPEG, returning a replacement {@link File}.
 *
 * Never throws and never rejects: a file the browser cannot decode is returned unchanged, so the
 * caller's own type and size checks stay the single place a bad upload is refused.
 *
 * @param {File} file the picked file
 * @param {number} [maxDimension] longest edge to keep, defaulting to {@link MAX_IMAGE_DIMENSION}
 * @returns {Promise<File>} the re-encoded photo, or the original file when it was left alone
 */ parcelHelpers.export(exports, "prepareImageForUpload", ()=>prepareImageForUpload);
const MAX_IMAGE_DIMENSION = 2000;
/** JPEG qualities tried in order until the encoded photo fits TARGET_IMAGE_BYTES. */ const QUALITY_LADDER = [
    0.82,
    0.7,
    0.6
];
/** Re-encoding stops once a photo is this small; well inside MAX_UPLOAD_FILE_SIZE. */ const TARGET_IMAGE_BYTES = 1572864;
/** Below this an already-web-safe photo is sent untouched rather than re-encoded lossily. */ const SKIP_COMPRESSION_BYTES = 409600;
/** Ceiling on the <img> decode fallback, which has no guarantee of ever firing a handler. */ const DECODE_TIMEOUT_MS = 15000;
/**
 * Types that may be sent untouched when they are already small.
 *
 * PNG only, and both exclusions are deliberate. WebP is absent because the server-side reader
 * cannot open one, however small it is. JPEG is absent because it is the format that carries
 * rotation as EXIF metadata rather than in the pixels, and the server-side reader ignores EXIF —
 * skipping the re-encode for a small portrait JPEG is exactly how a licence ends up stored
 * sideways, which is not a failure the driver can see or diagnose.
 */ const ALREADY_WEB_SAFE_TYPES = [
    'image/png'
];
/**
 * Types that cannot carry an EXIF rotation, and so are safe to hand back without re-encoding.
 * JPEG and TIFF are both absent precisely because they can.
 */ const ROTATION_FREE_TYPES = [
    'image/png',
    'image/gif',
    'image/bmp'
];
const SERVER_READABLE_IMAGE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/pjpeg',
    'image/png',
    'image/x-png',
    'image/gif',
    'image/bmp',
    // TIFF matters on the fall-through path specifically: Chrome and Firefox cannot decode one, so a
    // scanned licence comes back here untouched — and the server reads it perfectly well.
    'image/tiff',
    'image/tif'
];
function isCompressibleImage(file) {
    return !!file && typeof file.type === 'string' && file.type.startsWith('image/');
}
function isServerReadableImage(file) {
    return !!file && SERVER_READABLE_IMAGE_TYPES.includes(file.type);
}
async function prepareImageForUpload(file, maxDimension = MAX_IMAGE_DIMENSION) {
    if (!isCompressibleImage(file)) return file;
    if (file.size <= SKIP_COMPRESSION_BYTES && ALREADY_WEB_SAFE_TYPES.includes(file.type)) return file;
    let canvas = null;
    try {
        const source = await decodeImage(file);
        // naturalWidth/Height are the EXIF-corrected intrinsic dimensions.
        const { width, height } = scaledDimensions(source.naturalWidth, source.naturalHeight, maxDimension);
        canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        // JPEG has no alpha channel, so a transparent PNG would otherwise composite onto black.
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height);
        context.drawImage(source, 0, 0, width, height);
        const blob = await encodeSmallEnough(canvas);
        if (!blob) return file;
        // Flat graphics can encode larger as JPEG than they were as PNG, and keeping the original is
        // worth it when it is already small enough to upload. Restricted to formats that carry no EXIF
        // rotation, though: handing back an untouched JPEG is the one case that would reintroduce the
        // sideways-licence problem this module exists to solve.
        if (blob.size >= file.size && ROTATION_FREE_TYPES.includes(file.type) && file.size <= TARGET_IMAGE_BYTES) return file;
        return new File([
            blob
        ], jpegName(file.name), {
            type: 'image/jpeg',
            lastModified: Date.now()
        });
    } catch (e) {
        return file;
    } finally{
        // iOS Safari caps total canvas backing store per page, and four vehicle photos in a row is
        // enough to reach it — past which toBlob starts returning null and photos silently upload
        // full size. Releasing eagerly rather than waiting for GC keeps that out of reach.
        if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }
}
/**
 * Decodes a file into a drawable image with its EXIF rotation applied.
 *
 * Deliberately an <img> rather than createImageBitmap. A phone writes rotation as EXIF metadata and
 * the server-side reader ignores EXIF, so the rotation has to be baked into the pixels here — but
 * createImageBitmap's `imageOrientation` is a WebIDL dictionary member, which an engine that does
 * not implement it *ignores* rather than rejecting. That failure is silent: the call resolves, no
 * catch fires, and the licence is stored sideways. An <img> is oriented by the `image-orientation:
 * from-image` CSS default on every browser this app supports, with nothing to feature-detect.
 *
 * @param {File} file the picked file
 * @returns {Promise<HTMLImageElement>} the decoded, correctly oriented image
 */ async function decodeImage(file) {
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            // Bounded because neither handler is guaranteed to fire — a stalled decode would otherwise
            // leave this promise pending forever, and with it the caller's spinner and disabled input,
            // recoverable only by reloading the page and losing the whole wizard.
            const timer = setTimeout(()=>reject(new Error('Image decode timed out')), DECODE_TIMEOUT_MS);
            img.onload = ()=>{
                clearTimeout(timer);
                resolve(img);
            };
            img.onerror = ()=>{
                clearTimeout(timer);
                reject(new Error('Image could not be decoded'));
            };
            img.src = url;
        });
    } finally{
        URL.revokeObjectURL(url);
    }
}
/**
 * Encodes the canvas at descending quality until the result fits the byte target.
 *
 * @param {HTMLCanvasElement} canvas the canvas holding the scaled photo
 * @returns {Promise<Blob|null>} the encoded JPEG, or null when the browser refused to encode
 */ async function encodeSmallEnough(canvas) {
    let smallest = null;
    for (const quality of QUALITY_LADDER){
        const blob = await toBlob(canvas, quality);
        if (!blob) return smallest;
        smallest = blob;
        if (blob.size <= TARGET_IMAGE_BYTES) return blob;
    }
    return smallest;
}
/**
 * Promisified canvas.toBlob.
 *
 * @param {HTMLCanvasElement} canvas the canvas to encode
 * @param {number} quality JPEG quality between 0 and 1
 * @returns {Promise<Blob|null>} the encoded blob, or null when encoding is unsupported
 */ function toBlob(canvas, quality) {
    return new Promise((resolve)=>{
        try {
            canvas.toBlob((blob)=>resolve(blob), 'image/jpeg', quality);
        } catch (e) {
            // Resolving rather than rejecting so the documented "null when unsupported" contract holds
            // for any caller, not just the one that happens to sit inside a try/catch.
            resolve(null);
        }
    });
}
/**
 * Scales a width/height pair down so the longest edge is at most maxDimension, leaving smaller
 * images at their original size.
 *
 * @param {number} width the source width in pixels
 * @param {number} height the source height in pixels
 * @param {number} maxDimension the longest edge to keep
 * @returns {{width: number, height: number}} the scaled dimensions, never below 1px
 */ function scaledDimensions(width, height, maxDimension) {
    const longest = Math.max(width, height);
    if (longest <= maxDimension) return {
        width,
        height
    };
    const ratio = maxDimension / longest;
    return {
        width: Math.max(1, Math.round(width * ratio)),
        height: Math.max(1, Math.round(height * ratio))
    };
}
/**
 * Rewrites a filename to carry a .jpg extension, so the stored document's name matches its bytes.
 *
 * @param {string} name the original filename
 * @returns {string} the filename with a .jpg extension
 */ function jpegName(name) {
    const base = (name || 'photo').replace(/\.[^.]+$/, '');
    return `${base || 'photo'}.jpg`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4gCxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("289c6f6543d06b33");
    if (script.__esModule) script = script.default;
    script.render = require("2d83def05f9b837").render;
    script.__cssModules = require("cc8a8c84ba0503f5").default;
    require("de11ee3b25ec9311").default(script);
    script.__scopeId = 'data-v-9bf79e';
    script.__file = "FilePickerControls.vue";
};
initialize();
exports.default = script;

},{"289c6f6543d06b33":"5iqnZ","2d83def05f9b837":"kojV6","cc8a8c84ba0503f5":"fiPDG","de11ee3b25ec9311":"kVQtu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iqnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
/**
 * Offers "Take photo" and "Choose file" as separate controls on a touch device.
 *
 * A single `accept="image/*"` input is not enough: Android Chrome answers an image-only accept
 * with the system photo picker, which has no camera entry at all, so a driver standing next to
 * their car with nothing in the gallery has no way through. The camera is therefore its own input
 * carrying `capture`, which always opens the camera directly.
 *
 * The camera control is hidden on a fine pointer, where `capture` is ignored and the button would
 * open an ordinary file dialog under a misleading label. `pointer: coarse` describes the *primary*
 * pointer, so a tablet with a keyboard attached can report `fine` and lose the camera button — the
 * conservative direction, since "Choose file" still reaches the gallery. It is watched rather than
 * read once so attaching or detaching that keyboard updates the control.
 */ exports.default = {
    __name: 'FilePickerControls',
    props: {
        inputId: {
            type: String,
            required: true
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        cameraLabel: {
            type: String,
            default: 'Take photo'
        },
        fileLabel: {
            type: String,
            default: 'Choose file'
        },
        soleLabel: {
            type: String,
            default: ''
        },
        buttonClass: {
            type: String,
            default: 'btn btn-outline-secondary btn-sm'
        }
    },
    emits: [
        'picked'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const coarsePointer = typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia('(pointer: coarse)') : null;
        const isTouchDevice = (0, _vue.ref)(!!coarsePointer?.matches);
        function onPointerChange(e) {
            isTouchDevice.value = e.matches;
        }
        (0, _vue.onMounted)(()=>coarsePointer?.addEventListener('change', onPointerChange));
        (0, _vue.onUnmounted)(()=>coarsePointer?.removeEventListener('change', onPointerChange));
        const cameraInputId = (0, _vue.computed)(()=>`${props.inputId}-camera`);
        const fileInputId = (0, _vue.computed)(()=>`${props.inputId}-file`);
        // With no camera control to sit beside, the remaining button keeps the caller's own wording
        // ("Upload", "Replace") rather than the two-button "Choose file".
        const browseLabel = (0, _vue.computed)(()=>isTouchDevice.value ? props.fileLabel : props.soleLabel || props.fileLabel);
        function onChange(event) {
            emit('picked', event);
        }
        const __returned__ = {
            props,
            emit,
            coarsePointer,
            isTouchDevice,
            onPointerChange,
            cameraInputId,
            fileInputId,
            browseLabel,
            onChange,
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            ref: (0, _vue.ref)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kojV6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "file-picker-controls d-flex gap-2"
};
const _hoisted_2 = [
    "for"
];
const _hoisted_3 = [
    "id",
    "accept",
    "disabled"
];
const _hoisted_4 = [
    "for"
];
const _hoisted_5 = [
    "id",
    "accept",
    "multiple",
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.isTouchDevice ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 0
        }, [
            (0, _vue.createElementVNode)("label", {
                class: (0, _vue.normalizeClass)([
                    "mb-0 text-center",
                    [
                        $props.buttonClass,
                        {
                            disabled: $props.disabled
                        }
                    ]
                ]),
                for: $setup.cameraInputId
            }, [
                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("i", {
                    class: "fa-solid fa-camera me-1"
                }, null, -1)),
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.cameraLabel), 1)
            ], 10, _hoisted_2),
            (0, _vue.createElementVNode)("input", {
                id: $setup.cameraInputId,
                class: "d-none",
                type: "file",
                accept: $props.accept,
                capture: "environment",
                disabled: $props.disabled,
                onChange: $setup.onChange
            }, null, 40, _hoisted_3)
        ], 64)) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("label", {
            class: (0, _vue.normalizeClass)([
                "mb-0 text-center",
                [
                    $props.buttonClass,
                    {
                        disabled: $props.disabled
                    }
                ]
            ]),
            for: $setup.fileInputId
        }, [
            _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-folder-open me-1"
            }, null, -1)),
            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.browseLabel), 1)
        ], 10, _hoisted_4),
        (0, _vue.createElementVNode)("input", {
            id: $setup.fileInputId,
            class: "d-none",
            type: "file",
            accept: $props.accept,
            multiple: $props.multiple,
            disabled: $props.disabled,
            onChange: $setup.onChange
        }, null, 40, _hoisted_5)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fiPDG":[function() {},{}],"kVQtu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"47FF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "driver-license-sides-upload"
};
const _hoisted_2 = {
    key: 0,
    class: "alert alert-info py-2 px-3 small mb-3"
};
const _hoisted_3 = {
    class: "d-flex flex-wrap align-items-center gap-2 mb-2"
};
const _hoisted_4 = {
    class: "row g-2 mb-3"
};
const _hoisted_5 = {
    class: "col-6"
};
const _hoisted_6 = {
    class: "license-side-media mb-2"
};
const _hoisted_7 = [
    "src",
    "alt"
];
const _hoisted_8 = {
    key: 0,
    class: "license-side-status"
};
const _hoisted_9 = [
    "title"
];
const _hoisted_10 = [
    "disabled"
];
const _hoisted_11 = {
    key: 1,
    class: "text-muted d-block mt-1"
};
const _hoisted_12 = {
    class: "col-6"
};
const _hoisted_13 = {
    class: "license-side-media mb-2"
};
const _hoisted_14 = [
    "src",
    "alt"
];
const _hoisted_15 = {
    key: 0,
    class: "license-side-status"
};
const _hoisted_16 = [
    "title"
];
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    key: 1,
    class: "text-muted d-block mt-1"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.hasExistingLicense ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, _cache[2] || (_cache[2] = [
            (0, _vue.createElementVNode)("i", {
                class: "fa fa-file-alt me-1"
            }, null, -1),
            (0, _vue.createTextVNode)(" License document already on file. Upload new photos below to replace it. ")
        ]))) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_3, [
            (0, _vue.createElementVNode)("span", {
                class: (0, _vue.normalizeClass)([
                    "badge",
                    $setup.licenseSidesUploaded === 2 ? 'bg-success' : 'bg-secondary'
                ])
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: (0, _vue.normalizeClass)([
                        "fa",
                        $setup.licenseSidesUploaded === 2 ? 'fa-check' : 'fa-camera'
                    ])
                }, null, 2),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.licenseSidesUploaded) + " of 2 sides uploaded ", 1)
            ], 2),
            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("small", {
                class: "text-muted"
            }, "Both front and back are required", -1))
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_4, [
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("div", {
                    class: (0, _vue.normalizeClass)([
                        "border rounded p-2 text-center h-100 d-flex flex-column",
                        $setup.licenseFrontName ? 'border-success' : ''
                    ])
                }, [
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        $setup.previews.licenseFront ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                            key: 0,
                            class: "license-thumb",
                            src: $setup.previews.licenseFront,
                            alt: 'Front of license: ' + $setup.licenseFrontName
                        }, null, 8, _hoisted_7)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                "fa-solid fa-id-card fa-2x",
                                $setup.licenseFrontName ? 'text-success' : 'text-muted'
                            ])
                        }, null, 2))
                    ]),
                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("div", {
                        class: "small f-w-600"
                    }, "Front", -1)),
                    $setup.licenseFrontName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                        (0, _vue.createElementVNode)("small", {
                            class: "text-success text-truncate d-block",
                            title: $setup.licenseFrontName
                        }, _cache[4] || (_cache[4] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa fa-check-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)("Added ")
                        ]), 8, _hoisted_9),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link btn-sm text-danger p-0",
                            disabled: $props.disabled,
                            onClick: $setup.removeLicenseFront
                        }, _cache[5] || (_cache[5] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-xmark me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)("Remove ")
                        ]), 8, _hoisted_10)
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createVNode)($setup["FilePickerControls"], {
                        class: "mt-auto pt-2",
                        "input-id": $setup.frontInputId,
                        accept: "image/*",
                        disabled: $props.disabled || $setup.preparing.licenseFront,
                        "camera-label": $setup.licenseFrontName ? 'Retake' : 'Take photo',
                        "file-label": $setup.licenseFrontName ? 'Replace' : 'Choose file',
                        "sole-label": $setup.licenseFrontName ? 'Replace' : 'Upload',
                        onPicked: _cache[0] || (_cache[0] = ($event)=>$setup.onSelect('licenseFront', $event))
                    }, null, 8, [
                        "input-id",
                        "disabled",
                        "camera-label",
                        "file-label",
                        "sole-label"
                    ]),
                    $setup.preparing.licenseFront ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_11, _cache[6] || (_cache[6] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-1"
                        }, null, -1),
                        (0, _vue.createTextVNode)("Preparing photo... ")
                    ]))) : (0, _vue.createCommentVNode)("", true)
                ], 2)
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_12, [
                (0, _vue.createElementVNode)("div", {
                    class: (0, _vue.normalizeClass)([
                        "border rounded p-2 text-center h-100 d-flex flex-column",
                        $setup.licenseBackName ? 'border-success' : ''
                    ])
                }, [
                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                        $setup.previews.licenseBack ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                            key: 0,
                            class: "license-thumb",
                            src: $setup.previews.licenseBack,
                            alt: 'Back of license: ' + $setup.licenseBackName
                        }, null, 8, _hoisted_14)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                "fa-solid fa-id-card-clip fa-2x",
                                $setup.licenseBackName ? 'text-success' : 'text-muted'
                            ])
                        }, null, 2))
                    ]),
                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                        class: "small f-w-600"
                    }, "Back", -1)),
                    $setup.licenseBackName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_15, [
                        (0, _vue.createElementVNode)("small", {
                            class: "text-success text-truncate d-block",
                            title: $setup.licenseBackName
                        }, _cache[8] || (_cache[8] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa fa-check-circle me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)("Added ")
                        ]), 8, _hoisted_16),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link btn-sm text-danger p-0",
                            disabled: $props.disabled,
                            onClick: $setup.removeLicenseBack
                        }, _cache[9] || (_cache[9] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-xmark me-1"
                            }, null, -1),
                            (0, _vue.createTextVNode)("Remove ")
                        ]), 8, _hoisted_17)
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createVNode)($setup["FilePickerControls"], {
                        class: "mt-auto pt-2",
                        "input-id": $setup.backInputId,
                        accept: "image/*",
                        disabled: $props.disabled || $setup.preparing.licenseBack,
                        "camera-label": $setup.licenseBackName ? 'Retake' : 'Take photo',
                        "file-label": $setup.licenseBackName ? 'Replace' : 'Choose file',
                        "sole-label": $setup.licenseBackName ? 'Replace' : 'Upload',
                        onPicked: _cache[1] || (_cache[1] = ($event)=>$setup.onSelect('licenseBack', $event))
                    }, null, 8, [
                        "input-id",
                        "disabled",
                        "camera-label",
                        "file-label",
                        "sole-label"
                    ]),
                    $setup.preparing.licenseBack ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_18, _cache[10] || (_cache[10] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-1"
                        }, null, -1),
                        (0, _vue.createTextVNode)("Preparing photo... ")
                    ]))) : (0, _vue.createCommentVNode)("", true)
                ], 2)
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ug9F":[function() {},{}],"bkQ0r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"C06fQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "driver-onboarding-step driver-onboarding-step-documents",
    ref: "rootEl"
};
const _hoisted_2 = {
    class: "row g-4"
};
const _hoisted_3 = {
    class: "col-md-6"
};
const _hoisted_4 = {
    class: "mb-3"
};
const _hoisted_5 = {
    key: 0,
    class: "invalid-feedback d-block"
};
const _hoisted_6 = {
    class: "col-md-6"
};
const _hoisted_7 = {
    class: "mb-3"
};
const _hoisted_8 = {
    class: "form-label f-w-600"
};
const _hoisted_9 = {
    key: 0,
    class: "text-muted d-block mt-1"
};
const _hoisted_10 = {
    key: 1,
    class: "mt-2"
};
const _hoisted_11 = {
    class: "small text-muted d-flex justify-content-between align-items-center gap-2"
};
const _hoisted_12 = [
    "title"
];
const _hoisted_13 = {
    key: 2,
    class: "text-info d-block mt-1"
};
const _hoisted_14 = {
    key: 3,
    class: "text-muted d-block mt-1"
};
const _hoisted_15 = {
    class: "mb-3"
};
const _hoisted_16 = {
    key: 0,
    class: "invalid-feedback d-block"
};
const _hoisted_17 = {
    class: "card border mt-4"
};
const _hoisted_18 = {
    class: "card-body"
};
const _hoisted_19 = {
    class: "mb-3 d-flex align-items-start gap-2"
};
const _hoisted_20 = {
    class: "form-check-label small",
    for: "decl-cancellations"
};
const _hoisted_21 = {
    class: "mb-3 d-flex align-items-start gap-2"
};
const _hoisted_22 = {
    class: "form-check-label small",
    for: "decl-at-fault"
};
const _hoisted_23 = {
    class: "mb-3 d-flex align-items-start gap-2"
};
const _hoisted_24 = {
    class: "form-check-label small",
    for: "decl-total-claims"
};
const _hoisted_25 = {
    key: 0,
    class: "alert alert-danger py-2 small mt-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("h5", {
                    class: "mb-3"
                }, "Driver's License", -1)),
                (0, _vue.createVNode)($setup["DriverLicenseSidesUpload"], {
                    modelValue: $setup.model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model = $event)
                }, null, 8, [
                    "modelValue"
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                        class: "form-label f-w-600",
                        for: "license-expiry-input"
                    }, [
                        (0, _vue.createTextVNode)("Expiration Date "),
                        (0, _vue.createElementVNode)("span", {
                            class: "text-danger"
                        }, "*")
                    ], -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "license-expiry-input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.model.licenseExpiryDate = $event),
                        class: (0, _vue.normalizeClass)([
                            "form-control",
                            {
                                'is-invalid': $setup.licenseExpiryError
                            }
                        ]),
                        type: "date",
                        onBlur: _cache[2] || (_cache[2] = ($event)=>$setup.validateExpiryDate('license')),
                        required: ""
                    }, null, 34), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.licenseExpiryDate
                        ]
                    ]),
                    $setup.licenseExpiryError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, (0, _vue.toDisplayString)($setup.licenseExpiryError), 1)) : (0, _vue.createCommentVNode)("", true),
                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("small", {
                        class: "form-text text-muted d-flex gap-2 mt-2"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-calendar-days text-primary mt-1"
                        }),
                        (0, _vue.createElementVNode)("span", null, "We'll remind you 30 days before your license expires so you can renew without interruption.")
                    ], -1))
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_6, [
                _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("h5", {
                    class: "mb-3"
                }, "Insurance Certificate (Pink Slip)", -1)),
                (0, _vue.createElementVNode)("div", _hoisted_7, [
                    (0, _vue.createElementVNode)("div", _hoisted_8, " Document Upload " + (0, _vue.toDisplayString)($setup.hasExistingInsurance ? '(Re-upload to replace)' : ''), 1),
                    (0, _vue.createVNode)($setup["FilePickerControls"], {
                        "input-id": "insurance-input",
                        accept: "image/*,application/pdf",
                        disabled: $setup.insurancePreparing,
                        "camera-label": $setup.hasInsuranceOnFile ? 'Retake' : 'Take photo',
                        "file-label": $setup.hasInsuranceOnFile ? 'Replace' : 'Choose file',
                        "sole-label": $setup.hasInsuranceOnFile ? 'Replace document' : 'Choose file',
                        onPicked: _cache[3] || (_cache[3] = ($event)=>$setup.onSelect('insurance', $event))
                    }, null, 8, [
                        "disabled",
                        "camera-label",
                        "file-label",
                        "sole-label"
                    ]),
                    $setup.insurancePreparing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_9, _cache[15] || (_cache[15] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-1"
                        }, null, -1),
                        (0, _vue.createTextVNode)("Preparing document... ")
                    ]))) : (0, _vue.createCommentVNode)("", true),
                    $setup.insuranceFileName ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("small", {
                            class: "text-success d-block mb-1"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa fa-check-circle"
                            }),
                            (0, _vue.createTextVNode)(" File selected: ")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_11, [
                            (0, _vue.createElementVNode)("span", {
                                class: "text-truncate",
                                title: $setup.insuranceFileName
                            }, [
                                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-file-alt me-1"
                                }, null, -1)),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.insuranceFileName), 1)
                            ], 8, _hoisted_12),
                            (0, _vue.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-link btn-sm text-danger p-0 flex-shrink-0",
                                onClick: $setup.removeInsuranceFile,
                                title: "Remove"
                            }, _cache[17] || (_cache[17] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-xmark"
                                }, null, -1)
                            ]))
                        ])
                    ])) : $setup.hasExistingInsurance ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_13, _cache[19] || (_cache[19] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-file-alt"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Document already uploaded. Select a new file to replace it. ")
                    ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_14, " Upload your insurance certificate showing a valid coverage (max 5MB). "))
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_15, [
                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                        class: "form-label f-w-600",
                        for: "insurance-expiry-input"
                    }, [
                        (0, _vue.createTextVNode)("Expiration Date "),
                        (0, _vue.createElementVNode)("span", {
                            class: "text-danger"
                        }, "*")
                    ], -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "insurance-expiry-input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.insuranceExpiryDate = $event),
                        class: (0, _vue.normalizeClass)([
                            "form-control",
                            {
                                'is-invalid': $setup.insuranceExpiryError
                            }
                        ]),
                        type: "date",
                        onBlur: _cache[5] || (_cache[5] = ($event)=>$setup.validateExpiryDate('insurance')),
                        required: ""
                    }, null, 34), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.insuranceExpiryDate
                        ]
                    ]),
                    $setup.insuranceExpiryError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_16, (0, _vue.toDisplayString)($setup.insuranceExpiryError), 1)) : (0, _vue.createCommentVNode)("", true),
                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("small", {
                        class: "form-text text-muted d-flex gap-2 mt-2"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa-solid fa-calendar-days text-primary mt-1"
                        }),
                        (0, _vue.createElementVNode)("span", null, "We'll remind you 30 days before your insurance expires so you can renew without interruption.")
                    ], -1))
                ])
            ])
        ]),
        _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("div", {
            class: "alert alert-info mt-3",
            role: "alert"
        }, [
            (0, _vue.createElementVNode)("i", {
                class: "fa fa-info-circle"
            }),
            (0, _vue.createElementVNode)("strong", null, "Note:"),
            (0, _vue.createTextVNode)(" All documents and expiration dates must be provided before proceeding. Files will be securely uploaded when you complete the registration process. ")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_17, [
            _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("div", {
                class: "card-header bg-light-dark py-2"
            }, [
                (0, _vue.createElementVNode)("h6", {
                    class: "mb-0 f-w-600"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-shield-halved text-primary me-2"
                    }),
                    (0, _vue.createTextVNode)("Insurance Eligibility Declaration ")
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_18, [
                _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("p", {
                    class: "text-muted small mb-3"
                }, [
                    (0, _vue.createTextVNode)(" Please confirm that each of the following statements applies to you. "),
                    (0, _vue.createElementVNode)("strong", null, "This declaration must be re-confirmed annually.")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_19, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "decl-cancellations",
                        class: "form-check-input mt-1 flex-shrink-0",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.model.declaresNoExcessiveCancellations = $event),
                        onChange: $setup.onDeclarationChange
                    }, null, 544), [
                        [
                            (0, _vue.vModelCheckbox),
                            $setup.model.declaresNoExcessiveCancellations
                        ]
                    ]),
                    (0, _vue.createElementVNode)("label", _hoisted_20, [
                        _cache[24] || (_cache[24] = (0, _vue.createTextVNode)(" I have had ")),
                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("strong", null, "no more than 1 cancellation for non-payment", -1)),
                        _cache[26] || (_cache[26] = (0, _vue.createTextVNode)(" in the past 3 years. ")),
                        (0, _vue.createElementVNode)("span", {
                            class: "declaration-help text-muted ms-1",
                            tabindex: "0",
                            role: "button",
                            "aria-label": "What this means",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "A cancellation for non-payment occurs when an insurance policy is cancelled because the premium was not paid. More than 1 in 3 years may affect your insurability.",
                            onClick: _cache[7] || (_cache[7] = (0, _vue.withModifiers)(()=>{}, [
                                "prevent",
                                "stop"
                            ]))
                        }, _cache[23] || (_cache[23] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-question",
                                "aria-hidden": "true"
                            }, null, -1)
                        ]))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_21, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "decl-at-fault",
                        class: "form-check-input mt-1 flex-shrink-0",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.model.declaresNoExcessiveAtFaultClaims = $event),
                        onChange: $setup.onDeclarationChange
                    }, null, 544), [
                        [
                            (0, _vue.vModelCheckbox),
                            $setup.model.declaresNoExcessiveAtFaultClaims
                        ]
                    ]),
                    (0, _vue.createElementVNode)("label", _hoisted_22, [
                        _cache[28] || (_cache[28] = (0, _vue.createTextVNode)(" I have had ")),
                        _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("strong", null, "no more than 1 at-fault (AF) claim", -1)),
                        _cache[30] || (_cache[30] = (0, _vue.createTextVNode)(" in the past 3 years. ")),
                        (0, _vue.createElementVNode)("span", {
                            class: "declaration-help text-muted ms-1",
                            tabindex: "0",
                            role: "button",
                            "aria-label": "What this means",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "An at-fault claim is one where you were found to be responsible for the accident. We require that our drivers have no more than 1 at-fault claim in the past 3 years to qualify for coverage.",
                            onClick: _cache[9] || (_cache[9] = (0, _vue.withModifiers)(()=>{}, [
                                "prevent",
                                "stop"
                            ]))
                        }, _cache[27] || (_cache[27] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-question",
                                "aria-hidden": "true"
                            }, null, -1)
                        ]))
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_23, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "decl-total-claims",
                        class: "form-check-input mt-1 flex-shrink-0",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.model.declaresNoExcessiveTotalClaims = $event),
                        onChange: $setup.onDeclarationChange
                    }, null, 544), [
                        [
                            (0, _vue.vModelCheckbox),
                            $setup.model.declaresNoExcessiveTotalClaims
                        ]
                    ]),
                    (0, _vue.createElementVNode)("label", _hoisted_24, [
                        _cache[32] || (_cache[32] = (0, _vue.createTextVNode)(" I have had ")),
                        _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("strong", null, "no more than 3 claims in total", -1)),
                        _cache[34] || (_cache[34] = (0, _vue.createTextVNode)(" in the past 6 years. ")),
                        (0, _vue.createElementVNode)("span", {
                            class: "declaration-help text-muted ms-1",
                            tabindex: "0",
                            role: "button",
                            "aria-label": "What this means",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "top",
                            title: "This includes all claims regardless of fault (at-fault, not-at-fault, comprehensive, etc.). We require that our drivers have no more than 3 total claims in the past 6 years to qualify for rideshare coverage.",
                            onClick: _cache[11] || (_cache[11] = (0, _vue.withModifiers)(()=>{}, [
                                "prevent",
                                "stop"
                            ]))
                        }, _cache[31] || (_cache[31] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-question",
                                "aria-hidden": "true"
                            }, null, -1)
                        ]))
                    ])
                ]),
                $setup.declarationError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_25, [
                    _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-circle-exclamation me-1"
                    }, null, -1)),
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.declarationError), 1)
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ])
    ], 512);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpSrv":[function() {},{}],"3VLHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"drwTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("adf2944ddd457696");
    if (script.__esModule) script = script.default;
    script.render = require("f28c5899829cf5bd").render;
    script.__cssModules = require("5c8499bebdc86403").default;
    require("8c78d783cabd15a1").default(script);
    script.__scopeId = 'data-v-2a2951';
    script.__file = "DriverOnboardingStepReviewSubmit.vue";
};
initialize();
exports.default = script;

},{"adf2944ddd457696":"KPw0X","f28c5899829cf5bd":"3uf3f","5c8499bebdc86403":"QZUHO","8c78d783cabd15a1":"8ZDT9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"KPw0X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'DriverOnboardingStepReviewSubmit',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: /*@__PURE__*/ (0, _vue.mergeModels)([
        'editStep'
    ], [
        "update:modelValue"
    ]),
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const model = (0, _vue.useModel)(__props, "modelValue");
        const emit = __emit;
        const personalInfo = (0, _vue.inject)('personalInfo', {});
        const vehicleInfo = (0, _vue.inject)('vehicleInfo', {});
        const documentsInfo = (0, _vue.inject)('documentsInfo', {});
        const formatDate = (dateStr)=>{
            if (!dateStr) return 'Not provided';
            try {
                const date = new Date(dateStr);
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            } catch  {
                return dateStr;
            }
        };
        const formatPhoneNumber = (phone)=>{
            if (!phone) return 'Not provided';
            // If it already has a country code prefix like +1, handle it
            if (phone.startsWith('+')) {
                const cleaned = phone.replace(/\D/g, '');
                if (phone.startsWith('+1')) {
                    if (cleaned.length === 11) return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
                }
                return phone;
            }
            const cleaned = phone.replace(/\D/g, '');
            if (cleaned.length === 11 && cleaned.startsWith('1')) return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
            else if (cleaned.length === 10) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
            return phone;
        };
        const getDocumentStatus = (hasDocument)=>{
            return hasDocument ? {
                text: 'Uploaded',
                class: 'badge bg-success'
            } : {
                text: 'Not uploaded',
                class: 'badge bg-warning'
            };
        };
        const licenseDocStatus = (0, _vue.computed)(()=>getDocumentStatus(documentsInfo.hasLicenseDocument));
        const registrationDocStatus = (0, _vue.computed)(()=>getDocumentStatus(documentsInfo.hasRegistrationDocument));
        const insuranceDocStatus = (0, _vue.computed)(()=>getDocumentStatus(documentsInfo.hasInsuranceDocument));
        const handleEditStep = (stepIndex)=>{
            emit('editStep', stepIndex);
        };
        // Check for incomplete data
        const hasIncompletePersonalInfo = (0, _vue.computed)(()=>{
            return !personalInfo.firstName || !personalInfo.lastName || !personalInfo.dateOfBirth || !personalInfo.address || !personalInfo.city || !personalInfo.state || !personalInfo.country || !personalInfo.postalCode;
        });
        const hasIncompleteVehicleInfo = (0, _vue.computed)(()=>{
            return !vehicleInfo.make || !vehicleInfo.model || !vehicleInfo.year || !vehicleInfo.color || !vehicleInfo.plateNumber || !vehicleInfo.vehicleType || !vehicleInfo.capacity;
        });
        const hasIncompleteDocuments = (0, _vue.computed)(()=>{
            return !documentsInfo.hasLicenseDocument || !documentsInfo.hasRegistrationDocument || !documentsInfo.hasInsuranceDocument || !documentsInfo.licenseExpiryDate || !documentsInfo.registrationExpiryDate || !documentsInfo.insuranceExpiryDate;
        });
        const hasAnyIncompleteData = (0, _vue.computed)(()=>{
            return hasIncompletePersonalInfo.value || hasIncompleteVehicleInfo.value || hasIncompleteDocuments.value;
        });
        (0, _vue.onMounted)(()=>{
        // Reserved for future initialization if needed
        });
        const __returned__ = {
            model,
            emit,
            personalInfo,
            vehicleInfo,
            documentsInfo,
            formatDate,
            formatPhoneNumber,
            getDocumentStatus,
            licenseDocStatus,
            registrationDocStatus,
            insuranceDocStatus,
            handleEditStep,
            hasIncompletePersonalInfo,
            hasIncompleteVehicleInfo,
            hasIncompleteDocuments,
            hasAnyIncompleteData,
            inject: (0, _vue.inject),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3uf3f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "driver-onboarding-step driver-onboarding-step-review"
};
const _hoisted_2 = {
    key: 0,
    class: "alert alert-warning mb-4"
};
const _hoisted_3 = {
    class: "mb-0 mt-2"
};
const _hoisted_4 = {
    key: 0
};
const _hoisted_5 = {
    key: 1
};
const _hoisted_6 = {
    key: 2
};
const _hoisted_7 = {
    class: "card mb-3"
};
const _hoisted_8 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_9 = {
    class: "card-body"
};
const _hoisted_10 = {
    class: "row g-3"
};
const _hoisted_11 = {
    class: "col-md-6"
};
const _hoisted_12 = {
    class: "fw-semibold"
};
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    class: "fw-semibold"
};
const _hoisted_15 = {
    class: "col-md-6"
};
const _hoisted_16 = {
    class: "fw-semibold"
};
const _hoisted_17 = {
    class: "col-md-6"
};
const _hoisted_18 = {
    class: "fw-semibold"
};
const _hoisted_19 = {
    class: "col-12"
};
const _hoisted_20 = {
    class: "fw-semibold"
};
const _hoisted_21 = {
    class: "card mb-3"
};
const _hoisted_22 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_23 = {
    class: "card-body"
};
const _hoisted_24 = {
    class: "row g-3"
};
const _hoisted_25 = {
    class: "col-md-6"
};
const _hoisted_26 = {
    class: "fw-semibold"
};
const _hoisted_27 = {
    class: "col-md-6"
};
const _hoisted_28 = {
    class: "fw-semibold"
};
const _hoisted_29 = {
    class: "col-md-6"
};
const _hoisted_30 = {
    class: "fw-semibold"
};
const _hoisted_31 = {
    class: "col-md-6"
};
const _hoisted_32 = {
    class: "fw-semibold"
};
const _hoisted_33 = {
    class: "col-md-6"
};
const _hoisted_34 = {
    class: "fw-semibold"
};
const _hoisted_35 = {
    class: "card mb-3"
};
const _hoisted_36 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_37 = {
    class: "card-body"
};
const _hoisted_38 = {
    class: "row g-3"
};
const _hoisted_39 = {
    class: "col-md-6"
};
const _hoisted_40 = {
    key: 0,
    class: "mt-1 small"
};
const _hoisted_41 = {
    class: "col-md-6"
};
const _hoisted_42 = {
    key: 0,
    class: "mt-1 small"
};
const _hoisted_43 = {
    class: "col-md-6"
};
const _hoisted_44 = {
    key: 0,
    class: "mt-1 small"
};
const _hoisted_45 = {
    class: "card border-primary mb-3"
};
const _hoisted_46 = {
    class: "card-body"
};
const _hoisted_47 = {
    class: "mb-3"
};
const _hoisted_48 = {
    class: "form-check"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("div", {
            class: "mb-4"
        }, [
            (0, _vue.createElementVNode)("h4", {
                class: "mb-2"
            }, "Review Your Information"),
            (0, _vue.createElementVNode)("p", {
                class: "text-muted"
            }, "Please review all information carefully before submitting. Use the edit buttons to make changes.")
        ], -1)),
        $setup.hasAnyIncompleteData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
            _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-exclamation-triangle me-2"
            }, null, -1)),
            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("strong", null, "Incomplete Information Detected", -1)),
            _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("p", {
                class: "mb-0 mt-2"
            }, "Please complete all required sections before submitting:", -1)),
            (0, _vue.createElementVNode)("ul", _hoisted_3, [
                $setup.hasIncompletePersonalInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_4, "Personal Information is incomplete")) : (0, _vue.createCommentVNode)("", true),
                $setup.hasIncompleteVehicleInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_5, "Vehicle Information is incomplete")) : (0, _vue.createCommentVNode)("", true),
                $setup.hasIncompleteDocuments ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_6, "Document uploads are incomplete or missing expiration dates")) : (0, _vue.createCommentVNode)("", true)
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_7, [
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("h5", {
                    class: "mb-0"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-id-card me-2"
                    }),
                    (0, _vue.createTextVNode)("Personal Information")
                ], -1)),
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.handleEditStep(0))
                }, _cache[8] || (_cache[8] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-edit me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)("Edit ")
                ]))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_9, [
                (0, _vue.createElementVNode)("div", _hoisted_10, [
                    (0, _vue.createElementVNode)("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Name", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_12, (0, _vue.toDisplayString)($setup.personalInfo.firstName) + " " + (0, _vue.toDisplayString)($setup.personalInfo.lastName), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Email", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_14, (0, _vue.toDisplayString)($setup.personalInfo.email || 'Not provided'), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_15, [
                        _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Phone Number", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_16, (0, _vue.toDisplayString)($setup.formatPhoneNumber($setup.personalInfo.phoneNumber)), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Date of Birth", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_18, (0, _vue.toDisplayString)($setup.formatDate($setup.personalInfo.dateOfBirth)), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_19, [
                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Address", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_20, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.personalInfo.address || 'Not provided'), 1),
                            _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("br", null, null, -1)),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.personalInfo.city) + ", " + (0, _vue.toDisplayString)($setup.personalInfo.state) + " " + (0, _vue.toDisplayString)($setup.personalInfo.postalCode), 1),
                            _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("br", null, null, -1)),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.personalInfo.country), 1)
                        ])
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_21, [
            (0, _vue.createElementVNode)("div", _hoisted_22, [
                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("h5", {
                    class: "mb-0"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-car me-2"
                    }),
                    (0, _vue.createTextVNode)("Vehicle Information")
                ], -1)),
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.handleEditStep(1))
                }, _cache[17] || (_cache[17] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-edit me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)("Edit ")
                ]))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_23, [
                (0, _vue.createElementVNode)("div", _hoisted_24, [
                    (0, _vue.createElementVNode)("div", _hoisted_25, [
                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Make & Model", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_26, (0, _vue.toDisplayString)($setup.vehicleInfo.year) + " " + (0, _vue.toDisplayString)($setup.vehicleInfo.make) + " " + (0, _vue.toDisplayString)($setup.vehicleInfo.model), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_27, [
                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Color", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_28, (0, _vue.toDisplayString)($setup.vehicleInfo.color || 'Not provided'), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_29, [
                        _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Plate Number", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_30, (0, _vue.toDisplayString)($setup.vehicleInfo.plateNumber || 'Not provided'), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_31, [
                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Vehicle Type", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_32, (0, _vue.toDisplayString)($setup.vehicleInfo.vehicleType || 'Not provided'), 1)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                        _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Capacity", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_34, (0, _vue.toDisplayString)($setup.vehicleInfo.capacity || 'Not provided') + " passengers", 1)
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_35, [
            (0, _vue.createElementVNode)("div", _hoisted_36, [
                _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("h5", {
                    class: "mb-0"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-file-upload me-2"
                    }),
                    (0, _vue.createTextVNode)("Documents")
                ], -1)),
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.handleEditStep(2))
                }, _cache[24] || (_cache[24] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-edit me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)("Edit ")
                ]))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_37, [
                (0, _vue.createElementVNode)("div", _hoisted_38, [
                    (0, _vue.createElementVNode)("div", _hoisted_39, [
                        _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Driver's License", -1)),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)($setup.licenseDocStatus.class)
                            }, (0, _vue.toDisplayString)($setup.licenseDocStatus.text), 3),
                            $setup.documentsInfo.licenseExpiryDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_40, " Expires: " + (0, _vue.toDisplayString)($setup.formatDate($setup.documentsInfo.licenseExpiryDate)), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_41, [
                        _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Vehicle Registration", -1)),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)($setup.registrationDocStatus.class)
                            }, (0, _vue.toDisplayString)($setup.registrationDocStatus.text), 3),
                            $setup.documentsInfo.registrationExpiryDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_42, " Expires: " + (0, _vue.toDisplayString)($setup.formatDate($setup.documentsInfo.registrationExpiryDate)), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                        _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted mb-1"
                        }, "Insurance Policy", -1)),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)($setup.insuranceDocStatus.class)
                            }, (0, _vue.toDisplayString)($setup.insuranceDocStatus.text), 3),
                            $setup.documentsInfo.insuranceExpiryDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_44, " Expires: " + (0, _vue.toDisplayString)($setup.formatDate($setup.documentsInfo.insuranceExpiryDate)), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_45, [
            (0, _vue.createElementVNode)("div", _hoisted_46, [
                (0, _vue.createElementVNode)("div", _hoisted_47, [
                    _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("label", {
                        class: "form-label f-w-600"
                    }, "Additional Notes (Optional)", -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                        id: "review-notes",
                        class: "form-control",
                        rows: "3",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.model.notes = $event),
                        placeholder: "Any additional information you'd like to provide..."
                    }, "          ", 512), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.notes
                        ]
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_48, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "agree-terms",
                        class: "form-check-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.agreedToTerms = $event),
                        required: ""
                    }, null, 512), [
                        [
                            (0, _vue.vModelCheckbox),
                            $setup.model.agreedToTerms
                        ]
                    ]),
                    _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                        class: "form-check-label",
                        for: "agree-terms"
                    }, [
                        (0, _vue.createElementVNode)("strong", null, "I confirm that all information provided is accurate and complete."),
                        (0, _vue.createTextVNode)(" I understand that false information may result in account suspension. ")
                    ], -1))
                ])
            ])
        ]),
        _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("div", {
            class: "alert alert-info mb-0"
        }, [
            (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-info-circle me-2"
            }),
            (0, _vue.createElementVNode)("strong", null, "What happens next?"),
            (0, _vue.createTextVNode)(" After submission, your application will be reviewed by our admin team. You'll receive an email notification once your account is verified and activated. ")
        ], -1))
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"QZUHO":[function() {},{}],"8ZDT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ecauZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DriverOnboardingPersonalInfo);
var _vue = require("vue");
function DriverOnboardingPersonalInfo(data = {}) {
    const state = (0, _vue.reactive)({
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        countryCode: data.countryCode || '+1',
        phoneNumber: data.phoneNumber || '',
        address: data.address || '',
        city: data.city || '',
        state: data.state || '',
        country: data.country || '',
        postalCode: data.postalCode || '',
        dateOfBirth: data.dateOfBirth || ''
    });
    const isIsoDate = (val)=>{
        if (!val) return false;
        const m = /^\d{4}-\d{2}-\d{2}$/.exec(val);
        if (!m) return false;
        const dt = new Date(val);
        const [y, mo, d] = val.split('-').map(Number);
        return dt instanceof Date && !isNaN(dt) && dt.getUTCFullYear() === y && dt.getUTCMonth() + 1 === mo && dt.getUTCDate() === d;
    };
    const validations = {
        isFirstNameValid: (0, _vue.computed)(()=>!!String(state.firstName ?? '').trim()),
        isLastNameValid: (0, _vue.computed)(()=>!!String(state.lastName ?? '').trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(state.email ?? ''))),
        isPhoneNumberValid: (0, _vue.computed)(()=>/^[0-9]{7,15}$/.test(String(state.phoneNumber ?? ''))),
        isAddressValid: (0, _vue.computed)(()=>!!String(state.address ?? '').trim()),
        isCityValid: (0, _vue.computed)(()=>!!String(state.city ?? '').trim()),
        isStateValid: (0, _vue.computed)(()=>!!String(state.state ?? '').trim()),
        isCountryValid: (0, _vue.computed)(()=>!!String(state.country ?? '').trim()),
        isPostalCodeValid: (0, _vue.computed)(()=>!!String(state.postalCode ?? '').trim()),
        isDobValid: (0, _vue.computed)(()=>{
            if (!isIsoDate(String(state.dateOfBirth ?? ''))) return false;
            // Validate age (must be at least 18 years old)
            const dob = new Date(state.dateOfBirth);
            const today = new Date();
            const age = today.getFullYear() - dob.getFullYear();
            const monthDiff = today.getMonth() - dob.getMonth();
            const dayDiff = today.getDate() - dob.getDate();
            // Adjust age if birthday hasn't occurred this year yet
            const actualAge = monthDiff < 0 || monthDiff === 0 && dayDiff < 0 ? age - 1 : age;
            // Must be at least 18 and not more than 100 years old
            return actualAge >= 18 && actualAge <= 100;
        })
    };
    // DOM helpers (using global jQuery just like DispatchUser.js)
    const toggleInvalid = (inputSelector, errorSelector, ok)=>{
        const $input = $(inputSelector);
        const $error = $(errorSelector);
        if (!$input || !$input.length) return ok; // if DOM not present, no-op
        if (ok) {
            $input.removeClass('is-invalid');
            if ($error && $error.length) $error.addClass('d-none');
        } else {
            $input.addClass('is-invalid');
            if ($error && $error.length) $error.removeClass('d-none');
        }
        return ok;
    };
    const validateFirstName = ()=>toggleInvalid('#driver-first-name-input', '#driver-first-name-error', validations.isFirstNameValid.value);
    const validateLastName = ()=>toggleInvalid('#driver-last-name-input', '#driver-last-name-error', validations.isLastNameValid.value);
    const validateDob = ()=>toggleInvalid('#driver-dob-input', '#driver-dob-error', validations.isDobValid.value);
    const validatePhone = ()=>toggleInvalid('#driver-phone-number-input', '#driver-phone-number-error', validations.isPhoneNumberValid.value);
    const validateAddress = ()=>toggleInvalid('#driver-address-input', '#driver-address-error', validations.isAddressValid.value);
    const validateCity = ()=>toggleInvalid('#driver-city-input', '#driver-city-error', validations.isCityValid.value);
    const validateState = ()=>toggleInvalid('#driver-state-input', '#driver-state-error', validations.isStateValid.value);
    const validateCountry = ()=>toggleInvalid('#driver-country-input', '#driver-country-error', validations.isCountryValid.value);
    const validatePostalCode = ()=>toggleInvalid('#driver-postal-code-input', '#driver-postal-code-error', validations.isPostalCodeValid.value);
    // Watchers for real-time validation
    (0, _vue.watch)(()=>state.firstName, validateFirstName);
    (0, _vue.watch)(()=>state.lastName, validateLastName);
    (0, _vue.watch)(()=>state.dateOfBirth, validateDob);
    (0, _vue.watch)(()=>state.phoneNumber, validatePhone);
    (0, _vue.watch)(()=>state.address, validateAddress);
    (0, _vue.watch)(()=>state.city, validateCity);
    (0, _vue.watch)(()=>state.state, validateState);
    (0, _vue.watch)(()=>state.country, validateCountry);
    (0, _vue.watch)(()=>state.postalCode, validatePostalCode);
    const isValid = ()=>validateFirstName() | validateLastName() | /* Email is read-only here; still ensure format for completeness */ validations.isEmailValid.value | validatePhone() | validateAddress() | validateCity() | validateState() | validateCountry() | validatePostalCode() | validateDob();
    const toJSON = ()=>({
            ...state
        });
    return {
        state,
        validations,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"glyXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DriverOnboardingVehicleInfo);
var _vue = require("vue");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
function DriverOnboardingVehicleInfo(data = {}) {
    const state = (0, _vue.reactive)({
        make: data.make || '',
        model: data.model || '',
        year: data.year || '',
        color: data.color || '',
        plateNumber: data.plateNumber || '',
        vehicleType: data.vehicleType || null,
        capacity: data.capacity || '',
        odometer: data.odometer || '',
        vehicleTypes: data.vehicleTypes || []
    });
    const validations = {
        isMakeValid: (0, _vue.computed)(()=>!!state.make.trim()),
        isModelValid: (0, _vue.computed)(()=>!!state.model.trim()),
        isColorValid: (0, _vue.computed)(()=>!!String(state.color ?? '').trim()),
        isYearValid: (0, _vue.computed)(()=>{
            const y = parseInt(state.year, 10);
            return Number.isInteger(y) && y >= 1980 && y <= 2027;
        }),
        isPlateValid: (0, _vue.computed)(()=>!!String(state.plateNumber ?? '').trim()),
        isVehicleType: (0, _vue.computed)(()=>!!state.vehicleType),
        isCapacityValid: (0, _vue.computed)(()=>{
            const c = parseInt(state.capacity, 10);
            return Number.isInteger(c) && c >= 1 && c <= 12;
        }),
        isOdometerValid: (0, _vue.computed)(()=>{
            const o = parseInt(state.odometer, 10);
            return Number.isInteger(o) && o >= 0 && o <= 200000;
        })
    };
    // DOM helpers
    const toggleInvalid = (inputSelector, errorSelector, ok)=>{
        const $input = $(inputSelector);
        const $error = $(errorSelector);
        if (!$input || !$input.length) return ok;
        if (ok) {
            $input.removeClass('is-invalid');
            if ($error && $error.length) $error.addClass('d-none');
        } else {
            $input.addClass('is-invalid');
            if ($error && $error.length) $error.removeClass('d-none');
        }
        return ok;
    };
    const validateMake = ()=>toggleInvalid('#vehicle-make-input', '#vehicle-make-error', validations.isMakeValid.value);
    const validateModel = ()=>toggleInvalid('#vehicle-model-input', '#vehicle-model-error', validations.isModelValid.value);
    const validateColor = ()=>toggleInvalid('#vehicle-color-input', '#vehicle-color-error', validations.isColorValid.value);
    const validateYear = ()=>toggleInvalid('#vehicle-year-input', '#vehicle-year-error', validations.isYearValid.value);
    const validatePlate = ()=>toggleInvalid('#plate-number-input', '#plate-number-error', validations.isPlateValid.value);
    const validateVehicleType = ()=>toggleInvalid('#vehicle-type-select', '#vehicle-type-error', validations.isVehicleType.value);
    const validateCapacity = ()=>toggleInvalid('#vehicle-capacity-input', '#vehicle-capacity-error', validations.isCapacityValid.value);
    const validateOdometer = ()=>toggleInvalid('#vehicle-odometer-input', '#vehicle-odometer-error', validations.isOdometerValid.value);
    // Watchers
    (0, _vue.watch)(()=>state.make, validateMake);
    (0, _vue.watch)(()=>state.model, validateModel);
    (0, _vue.watch)(()=>state.color, validateColor);
    (0, _vue.watch)(()=>state.year, validateYear);
    (0, _vue.watch)(()=>state.plateNumber, validatePlate);
    (0, _vue.watch)(()=>state.vehicleType, validateVehicleType);
    (0, _vue.watch)(()=>state.capacity, validateCapacity);
    (0, _vue.watch)(()=>state.odometer, validateOdometer);
    const isValid = ()=>validateMake() | validateModel() | validateColor() | validateYear() | validatePlate() | validateVehicleType() | validateOdometer();
    const toJSON = ()=>({
            make: state.make ?? '',
            model: state.model ?? '',
            year: state.year ?? '',
            color: state.color ?? '',
            plateNumber: state.plateNumber ?? '',
            vehicleType: (0, _lodashDefault.default).isEmpty(state.vehicleType) ? null : state.vehicleType,
            capacity: state.capacity ?? '',
            odometer: state.odometer ?? ''
        });
    return {
        state,
        validations,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","lodash":"3hMBK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iPszW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DriverOnboardingDocumentUpload);
var _vue = require("vue");
function DriverOnboardingDocumentUpload(data = {}) {
    const state = (0, _vue.reactive)({
        driverLicenseId: data.driverLicenseId || '',
        insuranceDocId: data.insuranceDocId || '',
        licenseExpiryDate: data.licenseExpiryDate || '',
        insuranceExpiryDate: data.insuranceExpiryDate || '',
        hasLicenseDocument: data.hasLicenseDocument || false,
        hasInsuranceDocument: data.hasInsuranceDocument || false,
        driverLicenseFront: null,
        driverLicenseBack: null,
        insuranceDocFile: null,
        declaresNoExcessiveCancellations: data.declaresNoExcessiveCancellations || false,
        declaresNoExcessiveAtFaultClaims: data.declaresNoExcessiveAtFaultClaims || false,
        declaresNoExcessiveTotalClaims: data.declaresNoExcessiveTotalClaims || false
    });
    const isFutureDate = (dateString)=>{
        if (!dateString) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const inputDate = new Date(dateString);
        return inputDate > today;
    };
    const validations = {
        hasDriverLicense: (0, _vue.computed)(()=>state.hasLicenseDocument || state.driverLicenseFront != null && state.driverLicenseBack != null),
        hasInsurance: (0, _vue.computed)(()=>!!state.insuranceDocId || !!state.insuranceDocFile || state.hasInsuranceDocument),
        hasLicenseExpiry: (0, _vue.computed)(()=>!!state.licenseExpiryDate),
        hasInsuranceExpiry: (0, _vue.computed)(()=>!!state.insuranceExpiryDate),
        isLicenseExpiryFuture: (0, _vue.computed)(()=>isFutureDate(state.licenseExpiryDate)),
        isInsuranceExpiryFuture: (0, _vue.computed)(()=>isFutureDate(state.insuranceExpiryDate)),
        hasAllDeclarations: (0, _vue.computed)(()=>state.declaresNoExcessiveCancellations && state.declaresNoExcessiveAtFaultClaims && state.declaresNoExcessiveTotalClaims)
    };
    // Split out from isValid so a caller can tell "documents outstanding" from
    // "documents fine, declarations not confirmed" and say which one it is.
    const hasAllDocuments = ()=>validations.hasDriverLicense.value && validations.hasInsurance.value && validations.hasLicenseExpiry.value && validations.hasInsuranceExpiry.value && validations.isLicenseExpiryFuture.value && validations.isInsuranceExpiryFuture.value;
    const isValid = ()=>hasAllDocuments() && validations.hasAllDeclarations.value;
    const toJSON = ()=>({
            driverLicenseId: state.driverLicenseId,
            insuranceDocId: state.insuranceDocId,
            licenseExpiryDate: state.licenseExpiryDate,
            insuranceExpiryDate: state.insuranceExpiryDate,
            declaresNoExcessiveCancellations: state.declaresNoExcessiveCancellations,
            declaresNoExcessiveAtFaultClaims: state.declaresNoExcessiveAtFaultClaims,
            declaresNoExcessiveTotalClaims: state.declaresNoExcessiveTotalClaims
        });
    return {
        state,
        validations,
        hasAllDocuments,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDntw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DriverOnboardingReviewSubmit);
var _vue = require("vue");
function DriverOnboardingReviewSubmit(data = {}) {
    const state = (0, _vue.reactive)({
        agreedToTerms: data.agreedToTerms ?? false,
        agreedToBackgroundCheck: data.agreedToBackgroundCheck ?? false,
        agreedToEligibility: data.agreedToEligibility ?? false,
        agreedToAccuracy: data.agreedToAccuracy ?? false,
        notes: data.notes || ''
    });
    const validations = {
        hasAgreed: (0, _vue.computed)(()=>!!state.agreedToTerms),
        hasAgreedToBackgroundCheck: (0, _vue.computed)(()=>!!state.agreedToBackgroundCheck),
        hasAgreedToEligibility: (0, _vue.computed)(()=>!!state.agreedToEligibility),
        hasAgreedToAccuracy: (0, _vue.computed)(()=>!!state.agreedToAccuracy)
    };
    const isValid = ()=>validations.hasAgreed.value && validations.hasAgreedToBackgroundCheck.value && validations.hasAgreedToEligibility.value && validations.hasAgreedToAccuracy.value;
    const toJSON = ()=>({
            ...state
        });
    return {
        state,
        validations,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j7Nrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal position-relative"
};
const _hoisted_2 = {
    key: 0,
    class: "saving-overlay"
};
const _hoisted_3 = {
    id: "driver-onboarding-wizard"
};
const _hoisted_4 = {
    class: "card-body"
};
const _hoisted_5 = {
    class: "horizontal-wizard-wrapper"
};
const _hoisted_6 = {
    class: "row"
};
const _hoisted_7 = {
    class: "col-12 tab-content dark-field p-4"
};
const _hoisted_8 = {
    class: "tab-pane fade active show wizard-content",
    id: "driver-step-personal",
    role: "tabpanel"
};
const _hoisted_9 = {
    class: "tab-pane fade wizard-content",
    id: "driver-step-vehicle",
    role: "tabpanel"
};
const _hoisted_10 = {
    class: "tab-pane fade wizard-content",
    id: "driver-step-documents",
    role: "tabpanel"
};
const _hoisted_11 = {
    class: "tab-pane fade wizard-content",
    id: "driver-step-review",
    role: "tabpanel"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.isSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, _cache[4] || (_cache[4] = [
            (0, _vue.createElementVNode)("div", {
                class: "spinner-border text-primary",
                role: "status",
                "aria-live": "polite"
            }, [
                (0, _vue.createElementVNode)("span", {
                    class: "visually-hidden"
                }, "Saving...")
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h2", null, " Driver Onboarding "),
            (0, _vue.createElementVNode)("p", {
                class: "mb-0 text-muted"
            }, "Complete the steps to finish onboarding. Progress is saved after each step.")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_3, [
            (0, _vue.createElementVNode)("div", _hoisted_4, [
                (0, _vue.createElementVNode)("div", _hoisted_5, [
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                            class: "col-12 main-horizontal-header mb-3 border-1"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "nav nav-pills horizontal-options",
                                role: "tablist",
                                "aria-orientation": "horizontal"
                            }, [
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#driver-step-personal",
                                    role: "tab",
                                    "aria-selected": "true"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-id-card"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Personal Information")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#driver-step-vehicle",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-car"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Vehicle")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#driver-step-documents",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-file-upload"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Document Upload")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#driver-step-review",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-clipboard-check"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Review & Submit")
                                        ])
                                    ])
                                ])
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_7, [
                            (0, _vue.createElementVNode)("div", _hoisted_8, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepPersonalInfo"], {
                                    modelValue: $setup.form.personalInfo,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.form.personalInfo = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_9, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepVehicleInfo"], {
                                    modelValue: $setup.form.vehicleInfo,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.form.vehicleInfo = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_10, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepDocumentUpload"], {
                                    ref: "documentsStep",
                                    modelValue: $setup.form.documents,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.form.documents = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_11, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepReviewSubmit"], {
                                    modelValue: $setup.form.review,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.form.review = $event),
                                    onEditStep: $setup.goToStep
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("div", {
                class: "card-footer"
            }, [
                (0, _vue.createElementVNode)("div", {
                    id: "driver-onboarding-navigation"
                })
            ], -1))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5isJb":[function() {},{}],"9k2HJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dzLSH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("6814ac611bd38c90");
    if (script.__esModule) script = script.default;
    script.render = require("156c1faffcb1c269").render;
    require("dce44bc7c59a624c").default(script);
    script.__scopeId = 'data-v-e5a8c1';
    script.__file = "GeoZones.vue";
};
initialize();
exports.default = script;

},{"6814ac611bd38c90":"9rjSI","156c1faffcb1c269":"gzhQE","dce44bc7c59a624c":"3dJaQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rjSI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'GeoZones',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const geoZonesDataTable = (0, _vue.ref)(null);
        // GeoZone datatable columns
        const geoZoneColumns = [
            {
                data: 'name',
                title: 'Name'
            },
            {
                data: 'zoneType',
                title: 'Type',
                render: (0, _datatableRenderer.geoZoneType)
            },
            {
                data: 'active',
                title: 'Status',
                render: (0, _datatableRenderer.activeBadgeRender)
            },
            {
                title: 'Action',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return `<a class="btn btn-sm btn-outline-primary"href="/admin/geozones/${row.id}">
                <i class="fas fa-pen-to-square"></i> Edit</a>`;
                }
            }
        ];
        const __returned__ = {
            geoZonesDataTable,
            geoZoneColumns,
            ref: (0, _vue.ref),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get activeBadgeRender () {
                return 0, _datatableRenderer.activeBadgeRender;
            },
            get geoZoneType () {
                return 0, _datatableRenderer.geoZoneType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzhQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body social-list filter-cards-view"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, _vue.createStaticVNode)("<div class=\"page-title\"><div class=\"row\"><div class=\"col-sm-6 col-12\"><h2> Geo Zones </h2></div><div class=\"col-sm-6 col-12 text-end\"><a class=\"btn btn-primary align-items-center\" href=\"/admin/geozones/new\"><i class=\"fa-regular fa-square-plus\"></i> Add New </a></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: `/api/datatable/geo-zones`
                            },
                            ref: "geoZonesDataTable",
                            class: "table-responsive display",
                            columns: $setup.geoZoneColumns
                        }, null, 512)
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3dJaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52RNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("247fa4434e282ccd");
    if (script.__esModule) script = script.default;
    script.render = require("813fdf27930a5841").render;
    require("52f27153b036b29f").default(script);
    script.__scopeId = 'data-v-16a3a3';
    script.__file = "GeoZoneDetail.vue";
};
initialize();
exports.default = script;

},{"247fa4434e282ccd":"h6cFj","813fdf27930a5841":"8el8c","52f27153b036b29f":"6mZEn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6cFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'GeoZoneDetail',
    props: {
        googleMapsApiKey: {
            type: String,
            required: true
        },
        geoZoneId: {
            type: String,
            default: null
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Reactive variables for Geo Zone
        const geoZone = (0, _vue.ref)({});
        const isNewZone = (0, _vue.computed)(()=>props.geoZoneId === 'add' || props.geoZoneId === (0, _globalsJs.newEntityId));
        const isEditingGeoZone = (0, _vue.ref)(false);
        const geojsonInput = (0, _vue.ref)('');
        // Google Maps variables
        let map = null;
        let polygon = null;
        // Initialize Google Maps
        const initMap = ()=>{
            if (!geoZone.value || !geoZone.value.state) return;
            // Wait for the DOM to be ready
            setTimeout(()=>{
                const mapElement = document.getElementById('map');
                if (!mapElement) return;
                // Initialize the map
                map = new google.maps.Map(mapElement, {
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    zoom: 10,
                    mapTypeId: 'roadmap'
                });
                // Draw the polygon if boundary data exists
                if (geoZone.value.state.boundaryWkt) drawPolygon(geoZone.value.state.boundaryWkt);
            }, 100);
        };
        // Draw polygon on the map
        const drawPolygon = (boundaryJson)=>{
            if (!map) return;
            // Clear existing polygon
            if (polygon) polygon.setMap(null);
            try {
                // Parse the JSON string to get coordinates
                let coordinates = [];
                try {
                    // Try to parse as JSON first
                    const boundaryData = JSON.parse(boundaryJson);
                    if (Array.isArray(boundaryData)) coordinates = boundaryData.map((coord)=>({
                            lat: parseFloat(coord.lat || coord.latitude),
                            lng: parseFloat(coord.lng || coord.longitude)
                        }));
                } catch (e) {
                    // If not valid JSON, try to parse as WKT
                    // This is a simple WKT parser for POLYGON format
                    const wktMatch = boundaryJson.match(/POLYGON\s*\(\((.*)\)\)/i);
                    if (wktMatch && wktMatch[1]) coordinates = wktMatch[1].split(',').map((pair)=>{
                        const [lng, lat] = pair.trim().split(' ').map(parseFloat);
                        return {
                            lat,
                            lng
                        };
                    });
                }
                if (coordinates.length === 0) {
                    console.error('Invalid boundary format');
                    return;
                }
                // Create the polygon
                polygon = new google.maps.Polygon({
                    paths: coordinates,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35
                });
                polygon.setMap(map);
                // Fit the map to the polygon bounds
                const bounds = new google.maps.LatLngBounds();
                coordinates.forEach((coord)=>{
                    bounds.extend(coord);
                });
                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error drawing polygon:', error);
            }
        };
        // Handle post-save actions
        const handlePostSave = (savedData)=>{
            // Initialize or update the map after save
            if (map && savedData.boundaryWkt) drawPolygon(savedData.boundaryWkt);
            else initMap();
        };
        // Format date
        const formatDate = (dateString)=>{
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            return date.toLocaleString();
        };
        // Load sample GeoJSON
        const loadSampleGeoJson = ()=>{
            // Sample GeoJSON for a simple polygon (representing a small area)
            const sampleGeoJson = {
                "type": "Feature",
                "properties": {
                    "name": "Sample Area"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                -63.13,
                                46.25
                            ],
                            [
                                -63.13,
                                46.26
                            ],
                            [
                                -63.12,
                                46.26
                            ],
                            [
                                -63.12,
                                46.25
                            ],
                            [
                                -63.13,
                                46.25
                            ]
                        ]
                    ]
                }
            };
            geojsonInput.value = JSON.stringify(sampleGeoJson, null, 2);
        };
        // Pretty print JSON
        const prettyPrintJson = (json)=>{
            try {
                if (!json) return 'No boundary data';
                // Try to parse as JSON first
                try {
                    const parsed = JSON.parse(json);
                    return JSON.stringify(parsed, null, 2);
                } catch (e) {
                    // If not valid JSON, return as is
                    return json;
                }
            } catch (error) {
                return 'Invalid JSON';
            }
        };
        // Convert GeoJSON to WKT
        const validateGeoJson = ()=>{
            if (!geojsonInput.value) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Please enter valid GeoJSON data.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
                return;
            }
            try {
                // Parse the GeoJSON
                const geojson = JSON.parse(geojsonInput.value);
                // Check if it's a valid GeoJSON
                if (!geojson || !geojson.type) // Show error if GeoJSON is invalid
                return;
                let coordinates = [];
                // Extract coordinates based on GeoJSON type
                if (geojson.type === 'Feature' && geojson.geometry) {
                    // Handle Feature
                    if (geojson.geometry.type === 'Polygon') coordinates = geojson.geometry.coordinates[0]; // Outer ring
                    else if (geojson.geometry.type === 'MultiPolygon') coordinates = geojson.geometry.coordinates[0][0]; // First polygon, outer ring
                    else {
                        (0, _toastNotificationUtility.showToast)({
                            title: 'Error',
                            body: 'GeoJSON must contain a Polygon or MultiPolygon geometry',
                            type: (0, _toastNotificationUtility.notificationType).ERROR,
                            delay: 7000
                        });
                        return;
                    }
                } else if (geojson.type === 'Polygon') // Handle direct Polygon
                coordinates = geojson.coordinates[0]; // Outer ring
                else if (geojson.type === 'MultiPolygon') // Handle direct MultiPolygon
                coordinates = geojson.coordinates[0][0]; // First polygon, outer ring
                else {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: 'GeoJSON must be a Feature with Polygon/MultiPolygon or a direct Polygon/MultiPolygon',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 7000
                    });
                    return;
                }
                if (!coordinates || coordinates.length < 3) {
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: 'Polygon must have at least 3 coordinates',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 7000
                    });
                    return;
                }
                // Convert coordinates to WKT format
                // WKT POLYGON format: POLYGON((lng1 lat1, lng2 lat2, ...))
                const wktCoordinates = coordinates.map((coord)=>`${coord[0]} ${coord[1]}`).join(',');
                const wkt = `POLYGON((${wktCoordinates}))`;
                // Update the boundaryWkt field
                geoZone.value.state.boundaryWkt = wkt;
                // Update the map
                if (map) drawPolygon(wkt);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Awesome',
                    body: 'GeoJSON successfully converted to WKT',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            } catch (error) {
                console.error('Error validating GeoJSON:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Error processing GeoJSON: ' + error.message,
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
            }
        };
        // Load Google Maps API
        const loadGoogleMapsApi = ()=>{
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${props.googleMapsApiKey}&loading=async&callback=initGoogleMaps`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
            // Define the callback function
            window.initGoogleMaps = ()=>{
                if (!isNewZone.value && geoZone.value && geoZone.value.state) initMap();
            };
        };
        // Watch for changes in the boundary data to update the map
        (0, _vue.watch)(()=>geoZone.value?.state?.boundaryWkt, (newValue)=>{
            if (map && newValue && isEditingGeoZone.value) drawPolygon(newValue);
        });
        (0, _vue.onMounted)(()=>{
            loadGoogleMapsApi();
        });
        const __returned__ = {
            props,
            geoZone,
            isNewZone,
            isEditingGeoZone,
            geojsonInput,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get polygon () {
                return polygon;
            },
            set polygon (v){
                polygon = v;
            },
            initMap,
            drawPolygon,
            handlePostSave,
            formatDate,
            loadSampleGeoJson,
            prettyPrintJson,
            validateGeoJson,
            loadGoogleMapsApi,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            computed: (0, _vue.computed),
            EntityForm: (0, _entityFormVueDefault.default),
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./EntityForm.vue":"i0zng","../utility/toastNotificationUtility":"krOtg","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8el8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    key: 0,
    class: "row"
};
const _hoisted_3 = {
    key: 0
};
const _hoisted_4 = {
    class: "row"
};
const _hoisted_5 = {
    class: "col-md-6"
};
const _hoisted_6 = {
    class: "mb-3"
};
const _hoisted_7 = [
    "disabled",
    "readonly"
];
const _hoisted_8 = {
    class: "mb-3"
};
const _hoisted_9 = [
    "disabled",
    "readonly"
];
const _hoisted_10 = {
    class: "mb-3"
};
const _hoisted_11 = [
    "disabled"
];
const _hoisted_12 = {
    class: "col-md-6"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = [
    "disabled",
    "readonly"
];
const _hoisted_15 = {
    class: "mb-3"
};
const _hoisted_16 = {
    class: "form-check form-switch"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    class: "form-check-label",
    for: "active"
};
const _hoisted_19 = {
    class: "mb-3"
};
const _hoisted_20 = [
    "disabled",
    "readonly"
];
const _hoisted_21 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_22 = {
    key: 1,
    class: "mb-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.geoZone && !$setup.isNewZone ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, _cache[9] || (_cache[9] = [
            (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "card"
                }, [
                    (0, _vue.createElementVNode)("div", {
                        id: "map",
                        style: {
                            "height": "45vh",
                            "width": "100%"
                        }
                    })
                ])
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createVNode)($setup["EntityForm"], {
            "entity-id": $props.geoZoneId,
            entity: $setup.geoZone,
            "onUpdate:entity": _cache[7] || (_cache[7] = ($event)=>$setup.geoZone = $event),
            editState: $setup.isEditingGeoZone,
            "onUpdate:editState": _cache[8] || (_cache[8] = ($event)=>$setup.isEditingGeoZone = $event),
            "form-name": "Geo Zone",
            "api-url": "/api/zone",
            "redirect-url": "/admin/geozones",
            "model-constructor": "GeoZone",
            "show-title": true,
            "post-save": $setup.handlePostSave
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.geoZone.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                        (0, _vue.createElementVNode)("div", _hoisted_4, [
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                (0, _vue.createElementVNode)("div", _hoisted_6, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                                        for: "name",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Name "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "name",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.geoZone.state.name = $event),
                                        disabled: !$setup.isEditingGeoZone,
                                        readonly: !$setup.isEditingGeoZone,
                                        required: ""
                                    }, null, 8, _hoisted_7), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.geoZone.state.name
                                        ]
                                    ]),
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                                        id: "name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a name.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                        for: "description",
                                        class: "form-label"
                                    }, "Description", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        class: "form-control",
                                        id: "description",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.geoZone.state.description = $event),
                                        rows: "3",
                                        disabled: !$setup.isEditingGeoZone,
                                        readonly: !$setup.isEditingGeoZone
                                    }, null, 8, _hoisted_9), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.geoZone.state.description
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_10, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                                        for: "zoneType",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Zone Type "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                        class: "form-select",
                                        id: "zoneType",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.geoZone.state.zoneType = $event),
                                        disabled: !$setup.isEditingGeoZone,
                                        required: ""
                                    }, _cache[13] || (_cache[13] = [
                                        (0, _vue.createElementVNode)("option", {
                                            value: "SERVICE_AREA"
                                        }, "Service Area", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "SURGE_PRICING"
                                        }, "Surge Pricing", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "RESTRICTED"
                                        }, "Restricted", -1),
                                        (0, _vue.createElementVNode)("option", {
                                            value: "FARE_CONFIG_ZONE"
                                        }, "Fare Config", -1)
                                    ]), 8, _hoisted_11), [
                                        [
                                            (0, _vue.vModelSelect),
                                            $setup.geoZone.state.zoneType
                                        ]
                                    ]),
                                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                                        id: "zoneType-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please select a zone type.", -1))
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_12, [
                                (0, _vue.createElementVNode)("div", _hoisted_13, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                        for: "priority",
                                        class: "form-label"
                                    }, "Priority", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "priority",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.geoZone.state.priority = $event),
                                        min: "0",
                                        disabled: !$setup.isEditingGeoZone,
                                        readonly: !$setup.isEditingGeoZone
                                    }, null, 8, _hoisted_14), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.geoZone.state.priority
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_15, [
                                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                                        for: "active",
                                        class: "form-label"
                                    }, "Status", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "active",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.geoZone.state.active = $event),
                                            disabled: !$setup.isEditingGeoZone
                                        }, null, 8, _hoisted_17), [
                                            [
                                                (0, _vue.vModelCheckbox),
                                                $setup.geoZone.state.active
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("label", _hoisted_18, (0, _vue.toDisplayString)($setup.geoZone.state.active ? 'Active' : 'Inactive'), 1)
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_19, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                        for: "boundaryWkt",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Boundary Data (WKT) "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        class: "form-control",
                                        id: "boundaryWkt",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.geoZone.state.boundaryWkt = $event),
                                        rows: "5",
                                        disabled: !$setup.isEditingGeoZone,
                                        readonly: !$setup.isEditingGeoZone,
                                        required: ""
                                    }, null, 8, _hoisted_20), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.geoZone.state.boundaryWkt
                                        ]
                                    ]),
                                    _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                        id: "boundaryWkt-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter boundary data.", -1))
                                ]),
                                $setup.isEditingGeoZone ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_21, [
                                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                        for: "geojsonInput",
                                        class: "form-label"
                                    }, "GeoJSON Input", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        class: "form-control",
                                        id: "geojsonInput",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.geojsonInput = $event),
                                        rows: "5",
                                        placeholder: "Paste GeoJSON here"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.geojsonInput
                                        ]
                                    ]),
                                    (0, _vue.createElementVNode)("div", {
                                        class: "d-flex justify-content-between mt-2"
                                    }, [
                                        (0, _vue.createElementVNode)("button", {
                                            type: "button",
                                            class: "btn btn-primary",
                                            onClick: $setup.validateGeoJson
                                        }, "Validate & Convert to WKT"),
                                        (0, _vue.createElementVNode)("button", {
                                            type: "button",
                                            class: "btn btn-outline-secondary",
                                            onClick: $setup.loadSampleGeoJson
                                        }, "Load Sample")
                                    ])
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.isEditingGeoZone ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_22, _cache[21] || (_cache[21] = [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "alert alert-light-info"
                                    }, [
                                        (0, _vue.createElementVNode)("h5", null, "Finding Boundary Data:"),
                                        (0, _vue.createElementVNode)("ol", null, [
                                            (0, _vue.createElementVNode)("li", null, [
                                                (0, _vue.createTextVNode)("Search for a place on "),
                                                (0, _vue.createElementVNode)("a", {
                                                    href: "https://www.openstreetmap.org/",
                                                    target: "_blank"
                                                }, "OpenStreetMap")
                                            ]),
                                            (0, _vue.createElementVNode)("li", null, "Get the relationId from the URL"),
                                            (0, _vue.createElementVNode)("li", null, [
                                                (0, _vue.createTextVNode)("Replace the relationId in "),
                                                (0, _vue.createElementVNode)("a", {
                                                    href: "https://overpass-turbo.eu/",
                                                    target: "_blank"
                                                }, "Overpass Turbo")
                                            ]),
                                            (0, _vue.createElementVNode)("li", null, "Export as GeoJSON and paste in the GeoJSON section above for validation")
                                        ])
                                    ], -1)
                                ]))) : (0, _vue.createCommentVNode)("", true)
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity-id",
            "entity",
            "editState"
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6mZEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3gS7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("9cb0bee40fb45765");
    if (script.__esModule) script = script.default;
    script.render = require("d0da201796ea3f88").render;
    script.__cssModules = require("a41140dc31a97aec").default;
    require("a4599e269d03319e").default(script);
    script.__scopeId = 'data-v-828081';
    script.__file = "DriverPublicProfile.vue";
};
initialize();
exports.default = script;

},{"9cb0bee40fb45765":"8GQAC","d0da201796ea3f88":"21cT7","a41140dc31a97aec":"d4TMO","a4599e269d03319e":"3PkHf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8GQAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
// Props
exports.default = {
    __name: 'DriverPublicProfile',
    props: {
        driverId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Local state
        const driver = (0, _vue.reactive)({
            name: null,
            hasProfilePicture: null,
            rating: null,
            vehicle: {
                make: null,
                model: null,
                year: null,
                color: null
            }
        });
        const loading = (0, _vue.ref)(false);
        const error = (0, _vue.ref)(null);
        const hasVehicleImage = (0, _vue.ref)(false);
        async function checkVehicleImage() {
            try {
                const res = await fetch(`/api/driver/${props.driverId}/vehicle-image`, {
                    method: 'GET',
                    cache: 'no-store'
                });
                hasVehicleImage.value = res.ok;
            } catch (_) {
                hasVehicleImage.value = false;
            }
        }
        // Methods
        async function fetchDriver() {
            loading.value = true;
            try {
                const res = await fetch(`/api/public/driver/${props.driverId}`);
                if (!res.ok) throw new Error('Failed to load driver profile.');
                const payload = await res.json();
                driver.name = payload.name;
                driver.hasProfilePicture = payload.hasProfilePicture;
                driver.rating = payload.rating ?? driver.rating;
                driver.vehicle.make = payload.vehicleMake ?? driver.vehicle.make;
                driver.vehicle.model = payload.vehicleModel ?? driver.vehicle.model;
                driver.vehicle.year = payload.vehicleYear ?? driver.vehicle.year;
                driver.vehicle.color = payload.vehicleColor ?? driver.vehicle.color;
                // Check if a vehicle image is available
                await checkVehicleImage();
            } catch (e) {
                error.value = e.message || 'Unable to load driver profile.';
            } finally{
                loading.value = false;
            }
        }
        (0, _vue.onMounted)(fetchDriver);
        const __returned__ = {
            props,
            driver,
            loading,
            error,
            hasVehicleImage,
            checkVehicleImage,
            fetchDriver,
            reactive: (0, _vue.reactive),
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21cT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card"
};
const _hoisted_5 = {
    class: "login-main"
};
const _hoisted_6 = {
    class: "text-center mb-3"
};
const _hoisted_7 = [
    "src"
];
const _hoisted_8 = {
    class: "fs-4 f-w-700"
};
const _hoisted_9 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_10 = {
    class: "ms-1"
};
const _hoisted_11 = {
    key: 0,
    class: "d-flex justify-content-center mb-3"
};
const _hoisted_12 = {
    class: "vehicle-card"
};
const _hoisted_13 = [
    "src"
];
const _hoisted_14 = {
    class: "row justify-content-center"
};
const _hoisted_15 = {
    class: "col-md-8"
};
const _hoisted_16 = {
    class: "list-unstyled mb-0 text-center"
};
const _hoisted_17 = {
    key: 0
};
const _hoisted_18 = {
    key: 1
};
const _hoisted_19 = {
    key: 2
};
const _hoisted_20 = {
    key: 3
};
const _hoisted_21 = {
    key: 1,
    class: "alert alert-warning mt-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("h2", {
                                class: "text-center mb-3"
                            }, "Driver Profile", -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_6, [
                                $setup.driver.hasProfilePicture ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                                    key: 0,
                                    src: `/api/driver/${$setup.props.driverId}/profile-picture`,
                                    alt: "Driver photo",
                                    class: "rounded-circle border mb-3",
                                    style: {
                                        "width": "100px",
                                        "height": "100px",
                                        "object-fit": "cover"
                                    }
                                }, null, 8, _hoisted_7)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createElementVNode)("div", _hoisted_8, (0, _vue.toDisplayString)($setup.driver.name), 1),
                                $setup.driver.rating !== null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                                    _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-star text-warning"
                                    }, null, -1)),
                                    (0, _vue.createElementVNode)("span", _hoisted_10, (0, _vue.toDisplayString)(Number($setup.driver.rating).toFixed(1)), 1)
                                ])) : (0, _vue.createCommentVNode)("", true)
                            ]),
                            $setup.hasVehicleImage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                                (0, _vue.createElementVNode)("div", _hoisted_12, [
                                    (0, _vue.createElementVNode)("img", {
                                        src: `/api/driver/${$setup.props.driverId}/vehicle-image`,
                                        alt: "Vehicle image",
                                        class: "vehicle-image",
                                        onError: _cache[0] || (_cache[0] = ($event)=>$setup.hasVehicleImage = false)
                                    }, null, 40, _hoisted_13)
                                ])
                            ])) : (0, _vue.createCommentVNode)("", true),
                            _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_14, [
                                (0, _vue.createElementVNode)("div", _hoisted_15, [
                                    _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("h5", {
                                        class: "f-w-600 mb-2 text-center"
                                    }, "Vehicle", -1)),
                                    (0, _vue.createElementVNode)("ul", _hoisted_16, [
                                        $setup.driver.vehicle && $setup.driver.vehicle.make ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_17, [
                                            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("span", {
                                                class: "f-w-600"
                                            }, "Make:", -1)),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.driver.vehicle.make), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true),
                                        $setup.driver.vehicle && $setup.driver.vehicle.model ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_18, [
                                            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("span", {
                                                class: "f-w-600"
                                            }, "Model:", -1)),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.driver.vehicle.model), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true),
                                        $setup.driver.vehicle && $setup.driver.vehicle.year ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_19, [
                                            _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("span", {
                                                class: "f-w-600"
                                            }, "Year:", -1)),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.driver.vehicle.year), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true),
                                        $setup.driver.vehicle && $setup.driver.vehicle.color ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_20, [
                                            _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("span", {
                                                class: "f-w-600"
                                            }, "Color:", -1)),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.driver.vehicle.color), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ]),
                            $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_21, (0, _vue.toDisplayString)($setup.error), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4TMO":[function() {},{}],"3PkHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqqaS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("151e945bcbf9bb2b");
    if (script.__esModule) script = script.default;
    script.render = require("ce3a806ccda60711").render;
    script.__cssModules = require("d453095d70590811").default;
    require("175a64e48b363cc2").default(script);
    script.__scopeId = 'data-v-6ea600';
    script.__file = "DriverVehicleLicenseManagement.vue";
};
initialize();
exports.default = script;

},{"151e945bcbf9bb2b":"byArV","ce3a806ccda60711":"ghwQj","d453095d70590811":"6FyxJ","175a64e48b363cc2":"g4tg0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byArV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _driverLicenseSidesUploadVue = require("./DriverLicenseSidesUpload.vue");
var _driverLicenseSidesUploadVueDefault = parcelHelpers.interopDefault(_driverLicenseSidesUploadVue);
var _filePickerControlsVue = require("./FilePickerControls.vue");
var _filePickerControlsVueDefault = parcelHelpers.interopDefault(_filePickerControlsVue);
var _fileUploadValidation = require("../fileUploadValidation");
// Props
exports.default = {
    __name: 'DriverVehicleLicenseManagement',
    props: {
        driverId: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const driverId = props.driverId;
        // Local state
        const driver = (0, _vue.reactive)({
            name: null,
            rating: null
        });
        const form = (0, _vue.reactive)({
            vehicle: {
                make: '',
                model: '',
                year: null,
                color: '',
                plateNumber: '',
                capacity: null,
                vehicleType: ''
            },
            license: {
                verified: null,
                expiryDate: ''
            },
            insurance: {
                verified: null,
                expiryDate: ''
            }
        });
        const vehicleTypeOptions = [
            {
                type: 'SEDAN',
                capacity: 4,
                label: 'Sedan (4 passengers)'
            },
            {
                type: 'SUV',
                capacity: 6,
                label: 'SUV (6 passengers)'
            },
            {
                type: 'SUV',
                capacity: 4,
                label: 'SUV (4 passengers)'
            },
            {
                type: 'MINIVAN',
                capacity: 6,
                label: 'Minivan (6 passengers)'
            }
        ];
        const onVehicleTypeChange = (event)=>{
            const selectedValue = event.target.value;
            const option = vehicleTypeOptions.find((opt)=>`${opt.type}-${opt.capacity}` === selectedValue);
            if (option) {
                form.vehicle.vehicleType = option.type;
                form.vehicle.capacity = option.capacity;
            }
        };
        const hasVehicleImage = (0, _vue.ref)(false);
        const hasLicenseDocument = (0, _vue.ref)(false);
        const hasInsuranceDocument = (0, _vue.ref)(false);
        const pendingInsuranceFile = (0, _vue.ref)(null);
        const hasInsuranceOnFile = (0, _vue.computed)(()=>!!pendingInsuranceFile.value || hasInsuranceDocument.value);
        // Shape shared with the onboarding documents step, which owns the front/back upload UI.
        const licenseSides = (0, _vue.reactive)({
            driverLicenseFront: null,
            driverLicenseBack: null,
            hasLicenseDocument: false
        });
        function licenseSidesPicked() {
            return (licenseSides.driverLicenseFront ? 1 : 0) + (licenseSides.driverLicenseBack ? 1 : 0);
        }
        function resetLicenseSides() {
            licenseSides.driverLicenseFront = null;
            licenseSides.driverLicenseBack = null;
            // Restored rather than left false: picking a side clears it, and cancelling must not make an
            // untouched stored document look missing.
            licenseSides.hasLicenseDocument = hasLicenseDocument.value;
        }
        const isEditing = (0, _vue.ref)(false);
        const loading = (0, _vue.ref)(false);
        const error = (0, _vue.ref)(null);
        // Keep a snapshot of form when entering edit mode so we can revert on cancel
        const originalForm = (0, _vue.ref)(null);
        function deepCloneForm(src) {
            return JSON.parse(JSON.stringify({
                vehicle: src.vehicle,
                license: src.license,
                insurance: src.insurance
            }));
        }
        function isFormDirty() {
            if (licenseSidesPicked() > 0 || fileUploadMap.insurance) return true;
            if (!originalForm.value) return false;
            const current = deepCloneForm(form);
            return JSON.stringify(current) !== JSON.stringify(originalForm.value);
        }
        function restoreForm() {
            if (!originalForm.value) return;
            Object.assign(form.vehicle, originalForm.value.vehicle || {});
            Object.assign(form.license, originalForm.value.license || {});
            Object.assign(form.insurance, originalForm.value.insurance || {});
        }
        function clearPendingUploads() {
            uploadSession.value += 1;
            fileUploadMap.insurance = null;
            pendingInsuranceFile.value = null;
            resetLicenseSides();
        }
        function toggleEdit() {
            if (!isEditing.value) {
                // entering edit mode: snapshot current form
                originalForm.value = deepCloneForm(form);
                error.value = null;
            } else // cancelling edit: if dirty, restore
            if (isFormDirty()) {
                restoreForm();
                clearPendingUploads();
            }
            isEditing.value = !isEditing.value;
        }
        const insurancePreparing = (0, _vue.ref)(false);
        // Bumped by clearPendingUploads so a compression still in flight can tell its edit is over.
        const uploadSession = (0, _vue.ref)(0);
        const fileUploadMap = (0, _vue.reactive)({
            insurance: null
        });
        /**
 * Accepts a picked document, downscaling it first when it is a photo.
 *
 * @param {string} type the document being picked; only 'insurance' is handled here
 * @param {Event} event the change event from the file input
 */ async function handleUpload(type, event) {
            const picked = event?.target?.files?.[0];
            if (!picked || type !== 'insurance') return;
            // Captured before the await: cancelling the edit while a large photo is still compressing would
            // otherwise let the resolved file reappear after clearPendingUploads had already discarded it.
            const pickedDuring = uploadSession.value;
            insurancePreparing.value = true;
            try {
                const file = await (0, _fileUploadValidation.preparePickedFile)(picked, event, (0, _fileUploadValidation.IMAGE_OR_PDF_TYPES), {
                    subject: 'insurance document'
                });
                if (!file || pickedDuring !== uploadSession.value) return;
                fileUploadMap.insurance = file;
                pendingInsuranceFile.value = file;
            } finally{
                insurancePreparing.value = false;
                // Cleared unconditionally so re-picking the same file still raises a change event, matching
                // the other pick handlers.
                if (event.target) event.target.value = '';
            }
        }
        async function fetchDetails() {
            loading.value = true;
            try {
                const res = await fetch(`/api/driver-vehicle-license?token=${encodeURIComponent(props.token)}`);
                if (!res.ok) throw new Error('Failed to load vehicle & license details.');
                const payload = await res.json();
                // Header
                driver.name = payload.name || null;
                driver.rating = payload.rating ?? null;
                // License
                form.license.verified = payload.licenseDocumentVerified ?? null;
                form.license.expiryDate = payload.licenseExpirationDate || '';
                hasLicenseDocument.value = !!payload.hasLicenseDocument;
                resetLicenseSides();
                // Vehicle
                form.vehicle.make = payload.make || '';
                form.vehicle.model = payload.model || '';
                form.vehicle.year = payload.year ?? null;
                form.vehicle.color = payload.color || '';
                form.vehicle.plateNumber = payload.plateNumber || '';
                form.vehicle.vehicleType = payload.vehicleType || '';
                form.vehicle.capacity = payload.capacity ?? null;
                hasVehicleImage.value = !!payload.hasVehicleImage;
                // Insurance
                form.insurance.verified = payload.insuranceDocumentVerified ?? null;
                form.insurance.expiryDate = payload.insuranceDocumentExpiryDate || '';
                hasInsuranceDocument.value = !!payload.hasInsuranceDocument;
            } catch (e) {
                error.value = e.message || 'Unable to load details.';
            } finally{
                loading.value = false;
            }
        }
        // Save handler: validates, confirms, and posts multipart payload to backend
        async function handleSave() {
            if (loading.value) return;
            if (insurancePreparing.value) {
                // Saving now would post without the document the driver just picked, and tell them it worked.
                error.value = 'Your document is still being prepared. Please wait a moment and try again.';
                return;
            }
            // Primary validations
            const errs = [];
            const requiredFields = [
                {
                    path: 'Vehicle Make',
                    v: form.vehicle.make
                },
                {
                    path: 'Vehicle Model',
                    v: form.vehicle.model
                },
                {
                    path: 'Vehicle Year',
                    v: form.vehicle.year
                },
                {
                    path: 'Vehicle Color',
                    v: form.vehicle.color
                },
                {
                    path: 'Plate Number',
                    v: form.vehicle.plateNumber
                },
                {
                    path: 'Vehicle Type',
                    v: form.vehicle.vehicleType
                },
                {
                    path: 'License Expiry Date',
                    v: form.license.expiryDate
                }
            ];
            requiredFields.forEach((f)=>{
                if (f.v === null || f.v === undefined || String(f.v).trim() === '') errs.push(`${f.path} is required.`);
            });
            const currentYear = new Date().getFullYear() + 1; // allow next year for new models
            if (form.vehicle.year && (form.vehicle.year < 1980 || form.vehicle.year > currentYear)) errs.push(`Vehicle Year must be between 1980 and ${currentYear}.`);
            if (form.vehicle.capacity && (form.vehicle.capacity <= 0 || form.vehicle.capacity > 12)) errs.push('Invalid vehicle capacity.');
            // A licence is stored as one document collated from both sides, so one side alone cannot replace it.
            if (licenseSidesPicked() === 1) errs.push('Both the front and back of your driver\'s license are required.');
            // License expiry should not be in the past
            if (form.license.expiryDate) {
                const exp = new Date(form.license.expiryDate);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                if (exp < today) errs.push('License expiry date cannot be in the past.');
            }
            if (errs.length) {
                error.value = errs.join(' ');
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Please fix the following',
                    html: errs.map((e)=>`<div>${e}</div>`).join(''),
                    icon: 'warning'
                });
                return;
            }
            // Confirmation prompt
            const resConfirm = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Confirm update',
                text: 'You may not be able to accept rides until your updates are verified. Continue?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue',
                cancelButtonText: 'Cancel'
            });
            if (!resConfirm.isConfirmed) return;
            loading.value = true;
            error.value = null;
            try {
                const payload = {
                    vehicle: {
                        ...form.vehicle
                    },
                    license: {
                        ...form.license
                    },
                    insurance: {
                        ...form.insurance
                    }
                };
                const fd = new FormData();
                fd.append('payload', new Blob([
                    JSON.stringify(payload)
                ], {
                    type: 'application/json'
                }));
                if (licenseSides.driverLicenseFront) fd.append('driverLicenseFile[0]', licenseSides.driverLicenseFront);
                if (licenseSides.driverLicenseBack) fd.append('driverLicenseFile[1]', licenseSides.driverLicenseBack);
                if (fileUploadMap.insurance) fd.append('insuranceDocument', fileUploadMap.insurance);
                const res = await fetch(`/api/driver-vehicle-license?token=${encodeURIComponent(props.token)}`, {
                    method: 'POST',
                    body: fd
                });
                if (!res.ok) {
                    const txt = await res.text();
                    throw new Error(txt || 'Failed to save changes.');
                }
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Saved',
                    text: 'Your updates have been submitted for review.',
                    icon: 'success'
                });
                isEditing.value = false;
                fileUploadMap.insurance = null;
                pendingInsuranceFile.value = null;
                licenseSides.driverLicenseFront = null;
                licenseSides.driverLicenseBack = null;
                await fetchDetails();
            } catch (e) {
                error.value = e.message || 'Unable to save changes.';
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: error.value,
                    icon: 'error'
                });
            } finally{
                loading.value = false;
            }
        }
        (0, _vue.onMounted)(fetchDetails);
        const __returned__ = {
            props,
            driverId,
            driver,
            form,
            vehicleTypeOptions,
            onVehicleTypeChange,
            hasVehicleImage,
            hasLicenseDocument,
            hasInsuranceDocument,
            pendingInsuranceFile,
            hasInsuranceOnFile,
            licenseSides,
            licenseSidesPicked,
            resetLicenseSides,
            isEditing,
            loading,
            error,
            originalForm,
            deepCloneForm,
            isFormDirty,
            restoreForm,
            clearPendingUploads,
            toggleEdit,
            insurancePreparing,
            uploadSession,
            fileUploadMap,
            handleUpload,
            fetchDetails,
            handleSave,
            computed: (0, _vue.computed),
            reactive: (0, _vue.reactive),
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            DriverLicenseSidesUpload: (0, _driverLicenseSidesUploadVueDefault.default),
            FilePickerControls: (0, _filePickerControlsVueDefault.default),
            get preparePickedFile () {
                return 0, _fileUploadValidation.preparePickedFile;
            },
            get IMAGE_OR_PDF_TYPES () {
                return 0, _fileUploadValidation.IMAGE_OR_PDF_TYPES;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","./DriverLicenseSidesUpload.vue":"cjgHU","./FilePickerControls.vue":"4gCxp","../fileUploadValidation":"27Syo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghwQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card"
};
const _hoisted_5 = {
    class: "login-main wide-main position-relative"
};
const _hoisted_6 = {
    key: 0,
    class: "loader-overlay d-flex align-items-center justify-content-center"
};
const _hoisted_7 = {
    class: "d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3"
};
const _hoisted_8 = {
    class: "d-flex align-items-center gap-3 flex-wrap"
};
const _hoisted_9 = [
    "src"
];
const _hoisted_10 = {
    class: "flex-grow-1"
};
const _hoisted_11 = {
    class: "fs-4 f-w-700"
};
const _hoisted_12 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_13 = {
    class: "ms-1"
};
const _hoisted_14 = {
    key: 0,
    class: "vehicle-image-wrap"
};
const _hoisted_15 = [
    "src"
];
const _hoisted_16 = {
    class: "accordion dark-accordion",
    id: "vehicleLicenseAccordion"
};
const _hoisted_17 = {
    class: "accordion-item accordion-wrapper accordion-left-border"
};
const _hoisted_18 = {
    class: "accordion-header",
    id: "vehicleRegHeader"
};
const _hoisted_19 = {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#vehicle-reg-collapse",
    "aria-expanded": "false",
    "aria-controls": "vehicle-reg-collapse"
};
const _hoisted_20 = {
    class: "d-flex flex-column align-items-start justify-content-between w-100"
};
const _hoisted_21 = {
    class: "d-flex align-items-center gap-2 mt-2"
};
const _hoisted_22 = {
    key: 0,
    class: "badge badge-responsive bg-info"
};
const _hoisted_23 = {
    id: "vehicle-reg-collapse",
    class: "accordion-collapse collapse",
    "aria-labelledby": "vehicleRegHeader",
    "data-bs-parent": "#vehicleLicenseAccordion"
};
const _hoisted_24 = {
    class: "accordion-body"
};
const _hoisted_25 = {
    class: "row gy-4"
};
const _hoisted_26 = {
    class: "col-12"
};
const _hoisted_27 = {
    class: "row g-3"
};
const _hoisted_28 = {
    class: "col-md-6"
};
const _hoisted_29 = [
    "disabled"
];
const _hoisted_30 = {
    class: "col-md-6"
};
const _hoisted_31 = [
    "disabled"
];
const _hoisted_32 = {
    class: "col-md-6"
};
const _hoisted_33 = [
    "disabled"
];
const _hoisted_34 = {
    class: "col-md-6"
};
const _hoisted_35 = [
    "disabled"
];
const _hoisted_36 = {
    class: "col-md-6"
};
const _hoisted_37 = [
    "disabled"
];
const _hoisted_38 = {
    class: "col-md-6"
};
const _hoisted_39 = [
    "value",
    "disabled"
];
const _hoisted_40 = [
    "value"
];
const _hoisted_41 = {
    class: "accordion-item accordion-wrapper accordion-left-border"
};
const _hoisted_42 = {
    class: "accordion-header",
    id: "licenseHeader"
};
const _hoisted_43 = {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#license-collapse",
    "aria-expanded": "false",
    "aria-controls": "license-collapse"
};
const _hoisted_44 = {
    class: "d-flex flex-column align-items-start justify-content-between w-100"
};
const _hoisted_45 = {
    class: "d-flex align-items-center gap-2 mt-2"
};
const _hoisted_46 = {
    key: 1,
    class: "badge badge-responsive bg-info"
};
const _hoisted_47 = {
    id: "license-collapse",
    class: "accordion-collapse collapse",
    "aria-labelledby": "licenseHeader",
    "data-bs-parent": "#vehicleLicenseAccordion"
};
const _hoisted_48 = {
    class: "accordion-body"
};
const _hoisted_49 = {
    class: "row g-3"
};
const _hoisted_50 = {
    class: "col-md-6"
};
const _hoisted_51 = [
    "disabled"
];
const _hoisted_52 = {
    class: "col-12"
};
const _hoisted_53 = {
    class: "accordion-item accordion-wrapper accordion-left-border"
};
const _hoisted_54 = {
    class: "accordion-header",
    id: "insuranceHeader"
};
const _hoisted_55 = {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#insurance-collapse",
    "aria-expanded": "false",
    "aria-controls": "insurance-collapse"
};
const _hoisted_56 = {
    class: "d-flex flex-column align-items-start justify-content-between w-100"
};
const _hoisted_57 = {
    class: "d-flex align-items-center gap-2 mt-2"
};
const _hoisted_58 = {
    key: 1,
    class: "badge badge-responsive bg-info"
};
const _hoisted_59 = {
    id: "insurance-collapse",
    class: "accordion-collapse collapse",
    "aria-labelledby": "insuranceHeader",
    "data-bs-parent": "#vehicleLicenseAccordion"
};
const _hoisted_60 = {
    class: "accordion-body"
};
const _hoisted_61 = {
    class: "row g-3"
};
const _hoisted_62 = {
    class: "col-md-6"
};
const _hoisted_63 = [
    "disabled"
];
const _hoisted_64 = {
    class: "col-12"
};
const _hoisted_65 = {
    key: 0,
    class: "text-muted d-block mt-2"
};
const _hoisted_66 = {
    key: 1,
    class: "mt-2"
};
const _hoisted_67 = [
    "title"
];
const _hoisted_68 = {
    key: 2,
    class: "text-success d-block mt-2"
};
const _hoisted_69 = {
    key: 3,
    class: "text-muted d-block mt-2"
};
const _hoisted_70 = {
    key: 0,
    class: "text-end mt-4"
};
const _hoisted_71 = [
    "disabled"
];
const _hoisted_72 = {
    key: 0
};
const _hoisted_73 = {
    key: 1,
    class: "d-inline-flex align-items-center"
};
const _hoisted_74 = {
    key: 1,
    class: "alert alert-warning mt-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, _cache[9] || (_cache[9] = [
                                (0, _vue.createElementVNode)("div", {
                                    class: "text-center"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "spinner-border text-primary",
                                        role: "status",
                                        "aria-label": "Loading"
                                    }),
                                    (0, _vue.createElementVNode)("div", {
                                        class: "mt-2 fw-semibold text-primary"
                                    }, "Please wait...")
                                ], -1)
                            ]))) : (0, _vue.createCommentVNode)("", true),
                            _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("div", {
                                class: "d-flex justify-content-between align-items-center flex-wrap gap-2 gap-sm-3 mb-3"
                            }, [
                                (0, _vue.createElementVNode)("h2", {
                                    class: "mb-0"
                                }, "Vehicle & License ")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_7, [
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    (0, _vue.createElementVNode)("img", {
                                        src: `/api/driver/${$setup.driverId}/profile-picture`,
                                        alt: "Driver photo",
                                        class: "rounded-circle border",
                                        style: {
                                            "width": "84px",
                                            "height": "84px",
                                            "object-fit": "cover"
                                        }
                                    }, null, 8, _hoisted_9),
                                    (0, _vue.createElementVNode)("div", _hoisted_10, [
                                        (0, _vue.createElementVNode)("div", _hoisted_11, (0, _vue.toDisplayString)($setup.driver.name), 1),
                                        $setup.driver.rating !== null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                                            _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-star text-warning"
                                            }, null, -1)),
                                            (0, _vue.createElementVNode)("span", _hoisted_13, (0, _vue.toDisplayString)(Number($setup.driver.rating).toFixed(1)), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ]),
                                $setup.hasVehicleImage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, [
                                    (0, _vue.createElementVNode)("img", {
                                        src: `/api/driver/${$setup.driverId}/vehicle-image`,
                                        alt: "Vehicle image",
                                        class: "vehicle-thumb"
                                    }, null, 8, _hoisted_15)
                                ])) : (0, _vue.createCommentVNode)("", true)
                            ]),
                            _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                            (0, _vue.createElementVNode)("button", {
                                class: (0, _vue.normalizeClass)([
                                    $setup.isEditing ? 'btn-danger' : 'btn-primary',
                                    'btn',
                                    'd-flex',
                                    'align-items-center',
                                    'justify-content-center',
                                    'edit-action-btn',
                                    'mb-3'
                                ]),
                                onClick: $setup.toggleEdit
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: (0, _vue.normalizeClass)([
                                        'me-2',
                                        'fa-solid',
                                        $setup.isEditing ? 'fa-xmark ' : 'fa-pen'
                                    ]),
                                    "aria-hidden": "true"
                                }, null, 2),
                                (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($setup.isEditing ? 'Cancel' : 'Edit'), 1)
                            ], 2),
                            (0, _vue.createElementVNode)("form", {
                                class: "theme-form",
                                onSubmit: (0, _vue.withModifiers)($setup.handleSave, [
                                    "prevent"
                                ])
                            }, [
                                (0, _vue.createElementVNode)("div", _hoisted_16, [
                                    (0, _vue.createElementVNode)("div", _hoisted_17, [
                                        (0, _vue.createElementVNode)("h2", _hoisted_18, [
                                            (0, _vue.createElementVNode)("button", _hoisted_19, [
                                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("span", {
                                                        class: "d-flex align-items-center"
                                                    }, [
                                                        (0, _vue.createElementVNode)("i", {
                                                            class: "fa-solid fa-car me-2"
                                                        }),
                                                        (0, _vue.createTextVNode)(" Vehicle ")
                                                    ], -1)),
                                                    (0, _vue.createElementVNode)("div", _hoisted_21, [
                                                        $setup.isEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22, "Editing")) : (0, _vue.createCommentVNode)("", true),
                                                        _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("i", {
                                                            class: "iconly-Arrow-Down-2 icli icon"
                                                        }, null, -1))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_23, [
                                            (0, _vue.createElementVNode)("div", _hoisted_24, [
                                                (0, _vue.createElementVNode)("div", _hoisted_25, [
                                                    (0, _vue.createElementVNode)("div", _hoisted_26, [
                                                        _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("h5", {
                                                            class: "f-w-600 mb-2"
                                                        }, "Vehicle Information", -1)),
                                                        (0, _vue.createElementVNode)("div", _hoisted_27, [
                                                            (0, _vue.createElementVNode)("div", _hoisted_28, [
                                                                _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Make", -1)),
                                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                                    class: "form-control",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.form.vehicle.make = $event),
                                                                    disabled: !$setup.isEditing,
                                                                    placeholder: "e.g., Toyota"
                                                                }, null, 8, _hoisted_29), [
                                                                    [
                                                                        (0, _vue.vModelText),
                                                                        $setup.form.vehicle.make
                                                                    ]
                                                                ])
                                                            ]),
                                                            (0, _vue.createElementVNode)("div", _hoisted_30, [
                                                                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Model", -1)),
                                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                                    class: "form-control",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.form.vehicle.model = $event),
                                                                    disabled: !$setup.isEditing,
                                                                    placeholder: "e.g., Corolla"
                                                                }, null, 8, _hoisted_31), [
                                                                    [
                                                                        (0, _vue.vModelText),
                                                                        $setup.form.vehicle.model
                                                                    ]
                                                                ])
                                                            ]),
                                                            (0, _vue.createElementVNode)("div", _hoisted_32, [
                                                                _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Year", -1)),
                                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                                    class: "form-control",
                                                                    type: "number",
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.form.vehicle.year = $event),
                                                                    disabled: !$setup.isEditing,
                                                                    placeholder: "e.g., 2018"
                                                                }, null, 8, _hoisted_33), [
                                                                    [
                                                                        (0, _vue.vModelText),
                                                                        $setup.form.vehicle.year,
                                                                        void 0,
                                                                        {
                                                                            number: true
                                                                        }
                                                                    ]
                                                                ])
                                                            ]),
                                                            (0, _vue.createElementVNode)("div", _hoisted_34, [
                                                                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Color", -1)),
                                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                                    class: "form-control",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.form.vehicle.color = $event),
                                                                    disabled: !$setup.isEditing,
                                                                    placeholder: "e.g., Black"
                                                                }, null, 8, _hoisted_35), [
                                                                    [
                                                                        (0, _vue.vModelText),
                                                                        $setup.form.vehicle.color
                                                                    ]
                                                                ])
                                                            ]),
                                                            (0, _vue.createElementVNode)("div", _hoisted_36, [
                                                                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Plate Number", -1)),
                                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                                    class: "form-control",
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.form.vehicle.plateNumber = $event),
                                                                    disabled: !$setup.isEditing,
                                                                    placeholder: "e.g., ABC-1234"
                                                                }, null, 8, _hoisted_37), [
                                                                    [
                                                                        (0, _vue.vModelText),
                                                                        $setup.form.vehicle.plateNumber
                                                                    ]
                                                                ])
                                                            ]),
                                                            (0, _vue.createElementVNode)("div", _hoisted_38, [
                                                                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                                                                    class: "col-form-label"
                                                                }, "Vehicle Type", -1)),
                                                                (0, _vue.createElementVNode)("select", {
                                                                    id: "vehicle-type-select",
                                                                    class: "form-select",
                                                                    onChange: $setup.onVehicleTypeChange,
                                                                    value: $setup.form.vehicle.vehicleType && $setup.form.vehicle.capacity ? `${$setup.form.vehicle.vehicleType}-${$setup.form.vehicle.capacity}` : '',
                                                                    disabled: !$setup.isEditing
                                                                }, [
                                                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("option", {
                                                                        value: "",
                                                                        disabled: ""
                                                                    }, "Select vehicle type", -1)),
                                                                    ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.vehicleTypeOptions, (vt, idx)=>{
                                                                        return (0, _vue.createElementVNode)("option", {
                                                                            key: idx,
                                                                            value: `${vt.type}-${vt.capacity}`
                                                                        }, (0, _vue.toDisplayString)(vt.label), 9, _hoisted_40);
                                                                    }), 64))
                                                                ], 40, _hoisted_39),
                                                                _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("div", {
                                                                    class: "form-text"
                                                                }, "Choose from the available vehicle categories.", -1))
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_41, [
                                        (0, _vue.createElementVNode)("h2", _hoisted_42, [
                                            (0, _vue.createElementVNode)("button", _hoisted_43, [
                                                (0, _vue.createElementVNode)("div", _hoisted_44, [
                                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("span", {
                                                        class: "d-flex align-items-center"
                                                    }, [
                                                        (0, _vue.createElementVNode)("i", {
                                                            class: "fa-solid fa-id-card me-2"
                                                        }),
                                                        (0, _vue.createTextVNode)(" License ")
                                                    ], -1)),
                                                    (0, _vue.createElementVNode)("div", _hoisted_45, [
                                                        !$setup.isEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                                                            key: 0,
                                                            class: (0, _vue.normalizeClass)([
                                                                "badge badge-responsive",
                                                                $setup.form.license.verified ? 'bg-success' : 'bg-secondary'
                                                            ])
                                                        }, (0, _vue.toDisplayString)($setup.form.license.verified ? 'Verified' : 'Not verified'), 3)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_46, "Editing")),
                                                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("i", {
                                                            class: "iconly-Arrow-Down-2 icli icon"
                                                        }, null, -1))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_47, [
                                            (0, _vue.createElementVNode)("div", _hoisted_48, [
                                                (0, _vue.createElementVNode)("div", _hoisted_49, [
                                                    (0, _vue.createElementVNode)("div", _hoisted_50, [
                                                        _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                                                            class: "col-form-label"
                                                        }, "Expiry Date", -1)),
                                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                            class: "form-control",
                                                            type: "date",
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.form.license.expiryDate = $event),
                                                            disabled: !$setup.isEditing
                                                        }, null, 8, _hoisted_51), [
                                                            [
                                                                (0, _vue.vModelText),
                                                                $setup.form.license.expiryDate
                                                            ]
                                                        ])
                                                    ]),
                                                    (0, _vue.createElementVNode)("div", _hoisted_52, [
                                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("label", {
                                                            class: "col-form-label"
                                                        }, "License Document", -1)),
                                                        (0, _vue.createVNode)($setup["DriverLicenseSidesUpload"], {
                                                            modelValue: $setup.licenseSides,
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.licenseSides = $event),
                                                            disabled: !$setup.isEditing,
                                                            "id-prefix": "vehicle-license"
                                                        }, null, 8, [
                                                            "modelValue",
                                                            "disabled"
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_53, [
                                        (0, _vue.createElementVNode)("h2", _hoisted_54, [
                                            (0, _vue.createElementVNode)("button", _hoisted_55, [
                                                (0, _vue.createElementVNode)("div", _hoisted_56, [
                                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("span", {
                                                        class: "d-flex align-items-center"
                                                    }, [
                                                        (0, _vue.createElementVNode)("i", {
                                                            class: "fa-solid fa-shield-halved me-2"
                                                        }),
                                                        (0, _vue.createTextVNode)(" Insurance ")
                                                    ], -1)),
                                                    (0, _vue.createElementVNode)("div", _hoisted_57, [
                                                        !$setup.isEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                                                            key: 0,
                                                            class: (0, _vue.normalizeClass)([
                                                                "badge badge-responsive",
                                                                $setup.form.insurance.verified ? 'bg-success' : 'bg-secondary'
                                                            ])
                                                        }, (0, _vue.toDisplayString)($setup.form.insurance.verified ? 'Verified' : 'Not verified'), 3)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_58, "Editing")),
                                                        _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("i", {
                                                            class: "iconly-Arrow-Down-2 icli icon"
                                                        }, null, -1))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_59, [
                                            (0, _vue.createElementVNode)("div", _hoisted_60, [
                                                (0, _vue.createElementVNode)("div", _hoisted_61, [
                                                    (0, _vue.createElementVNode)("div", _hoisted_62, [
                                                        _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("label", {
                                                            class: "col-form-label"
                                                        }, "Expiry Date", -1)),
                                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                            class: "form-control",
                                                            type: "date",
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.form.insurance.expiryDate = $event),
                                                            disabled: !$setup.isEditing
                                                        }, null, 8, _hoisted_63), [
                                                            [
                                                                (0, _vue.vModelText),
                                                                $setup.form.insurance.expiryDate
                                                            ]
                                                        ])
                                                    ]),
                                                    (0, _vue.createElementVNode)("div", _hoisted_64, [
                                                        _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("label", {
                                                            class: "col-form-label"
                                                        }, "Insurance Document", -1)),
                                                        (0, _vue.createVNode)($setup["FilePickerControls"], {
                                                            "input-id": "vehicle-insurance",
                                                            accept: "image/*,application/pdf",
                                                            disabled: !$setup.isEditing || $setup.insurancePreparing,
                                                            "camera-label": $setup.hasInsuranceOnFile ? 'Retake' : 'Take photo',
                                                            "file-label": $setup.hasInsuranceOnFile ? 'Replace' : 'Choose file',
                                                            "sole-label": $setup.hasInsuranceOnFile ? 'Replace document' : 'Choose file',
                                                            onPicked: _cache[8] || (_cache[8] = ($event)=>$setup.handleUpload('insurance', $event))
                                                        }, null, 8, [
                                                            "disabled",
                                                            "camera-label",
                                                            "file-label",
                                                            "sole-label"
                                                        ]),
                                                        $setup.insurancePreparing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_65, _cache[29] || (_cache[29] = [
                                                            (0, _vue.createElementVNode)("span", {
                                                                class: "spinner-border spinner-border-sm me-1"
                                                            }, null, -1),
                                                            (0, _vue.createTextVNode)("Preparing document... ")
                                                        ]))) : $setup.pendingInsuranceFile ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_66, [
                                                            _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("small", {
                                                                class: "text-success d-block mb-1"
                                                            }, [
                                                                (0, _vue.createElementVNode)("i", {
                                                                    class: "fa fa-check-circle me-1"
                                                                }),
                                                                (0, _vue.createTextVNode)("File selected \u2014 saving will replace the stored document ")
                                                            ], -1)),
                                                            (0, _vue.createElementVNode)("div", {
                                                                class: "small text-muted text-truncate",
                                                                title: $setup.pendingInsuranceFile.name
                                                            }, [
                                                                _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("i", {
                                                                    class: "fa fa-file-alt me-1"
                                                                }, null, -1)),
                                                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.pendingInsuranceFile.name), 1)
                                                            ], 8, _hoisted_67)
                                                        ])) : $setup.hasInsuranceDocument ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_68, _cache[32] || (_cache[32] = [
                                                            (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-check-circle me-1"
                                                            }, null, -1),
                                                            (0, _vue.createTextVNode)("Document uploaded ")
                                                        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_69, " Images or PDF files only (max 5MB). "))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ]),
                                $setup.isEditing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_70, [
                                    (0, _vue.createElementVNode)("button", {
                                        type: "submit",
                                        class: "btn btn-primary d-inline-flex align-items-center",
                                        disabled: $setup.loading
                                    }, [
                                        !$setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_72, "Save Changes")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_73, _cache[34] || (_cache[34] = [
                                            (0, _vue.createElementVNode)("span", {
                                                class: "spinner-border spinner-border-sm me-2",
                                                role: "status",
                                                "aria-hidden": "true"
                                            }, null, -1),
                                            (0, _vue.createTextVNode)(" Saving... ")
                                        ])))
                                    ], 8, _hoisted_71)
                                ])) : (0, _vue.createCommentVNode)("", true)
                            ], 32),
                            $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_74, (0, _vue.toDisplayString)($setup.error), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FyxJ":[function() {},{}],"g4tg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8Iiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("c0cc25f87ad715f9");
    if (script.__esModule) script = script.default;
    script.render = require("fac88888ac55dcce").render;
    script.__cssModules = require("567ca37640ef407d").default;
    require("7b8b01e31bd9bf1").default(script);
    script.__scopeId = 'data-v-01f061';
    script.__file = "DriverSubscriptionManagement.vue";
};
initialize();
exports.default = script;

},{"c0cc25f87ad715f9":"2tgyF","fac88888ac55dcce":"dij0i","567ca37640ef407d":"gz9US","7b8b01e31bd9bf1":"2xikt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tgyF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
exports.default = {
    __name: 'DriverSubscriptionManagement',
    props: {
        driverId: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const loading = (0, _vue.ref)(true);
        const actionLoading = (0, _vue.ref)(false);
        const error = (0, _vue.ref)(null);
        const driver = (0, _vue.ref)({
            name: null,
            rating: null
        });
        const rideCredits = (0, _vue.ref)(0);
        const weeklyCreditAllowance = (0, _vue.ref)(null);
        // Server-supplied (utils.DriverCreditConstants) so the threshold can be retuned without a release.
        const lowCreditThreshold = (0, _vue.ref)(0);
        const nextCreditGrantAt = (0, _vue.ref)(null);
        const subscriptionStatus = (0, _vue.ref)(null);
        const currentTierKey = (0, _vue.ref)(null);
        const addOnTierKey = (0, _vue.ref)(null);
        const subscriptionEndDate = (0, _vue.ref)(null);
        const gracePeriodDaysLeft = (0, _vue.ref)(0);
        const trialEndDate = (0, _vue.ref)(null);
        const hasUsedFreeTrial = (0, _vue.ref)(false);
        const subscriptionPlans = (0, _vue.ref)([]);
        const allAddOns = (0, _vue.ref)([]);
        const hasPendingChange = (0, _vue.ref)(false);
        const pendingTierKey = (0, _vue.ref)(null);
        const pendingPlanName = (0, _vue.ref)(null);
        const pendingChangeEffectiveDate = (0, _vue.ref)(null);
        const isTrialing = (0, _vue.computed)(()=>subscriptionStatus.value === 'TRIALING');
        const hasSubscription = (0, _vue.computed)(()=>subscriptionStatus.value === 'ACTIVE' || subscriptionStatus.value === 'TRIALING');
        const trialDaysLeft = (0, _vue.computed)(()=>{
            if (!trialEndDate.value) return 0;
            const end = parseDate(trialEndDate.value);
            if (!end) return 0;
            const now = new Date();
            return Math.max(0, Math.ceil((end - now) / 86400000));
        });
        // The trial is metered like any paid week (#180): 20 credits a week, not unlimited access. A driver
        // at zero stops being dispatched whether they are trialing or paying, so the count is coloured the
        // same way in both states.
        const creditCountClass = (0, _vue.computed)(()=>{
            if (rideCredits.value <= 0) return 'text-danger';
            if (rideCredits.value <= lowCreditThreshold.value) return 'text-warning';
            return 'text-success';
        });
        const currentPlanName = (0, _vue.computed)(()=>{
            if (!currentTierKey.value) return 'None';
            const plan = subscriptionPlans.value.find((p)=>p.tierKey === currentTierKey.value);
            return plan ? plan.name : currentTierKey.value;
        });
        // Filters on the add-on's own tierKey against the key the server resolved, not on parentTierKey
        // against currentTierKey: trial packs belong to the trial rather than to a plan, so they carry no
        // parent at all and would never match (#298).
        const availableAddOns = (0, _vue.computed)(()=>{
            const canPurchase = subscriptionStatus.value === 'ACTIVE' || subscriptionStatus.value === 'TRIALING';
            if (!canPurchase || !addOnTierKey.value) return [];
            return allAddOns.value.filter((addon)=>addon.tierKey === addOnTierKey.value);
        });
        /**
 * Resolves the header colour for a plan tier.
 *
 * The theme's own `bg-secondary` and `bg-success` carry white text at roughly 2:1 — the plan name
 * was barely readable on them — so each tier keeps its hue in a shade that clears 4.5:1 instead of
 * reusing the utility class.
 *
 * @param plan the plan being rendered
 * @returns {string} the CSS class to apply to that plan's card header
 */ function getPlanHeaderClass(plan) {
            const tierClasses = {
                'starter': 'plan-header-starter',
                'full_time': 'plan-header-full-time',
                'ultimate': 'plan-header-ultimate'
            };
            return tierClasses[plan.tierKey] || 'plan-header-full-time';
        }
        function parseDate(dateStr) {
            if (!dateStr) return null;
            // PostgreSQL timestamptz arrives as "2026-05-03 00:48:42.000000 +00:00".
            // Normalize to ISO 8601 ("2026-05-03T00:48:42.000000+00:00") so Safari
            // doesn't return Invalid Date.
            const normalized = String(dateStr).replace(' ', 'T').replace(/\s([+-])/, '$1');
            const d = new Date(normalized);
            return isNaN(d.getTime()) ? null : d;
        }
        function formatDate(dateStr) {
            if (!dateStr) return '';
            const date = parseDate(dateStr);
            if (!date) return '';
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        }
        async function loadSubscriptionData() {
            loading.value = true;
            error.value = null;
            try {
                const response = await fetch(`/api/driver-subscription?token=${encodeURIComponent(props.token)}`);
                if (!response.ok) throw new Error('Failed to load subscription data');
                const data = await response.json();
                driver.value.name = data.driverName;
                driver.value.rating = data.driverRating;
                rideCredits.value = data.rideCredits || 0;
                weeklyCreditAllowance.value = data.weeklyCreditAllowance ?? null;
                lowCreditThreshold.value = data.lowCreditThreshold ?? 0;
                nextCreditGrantAt.value = data.nextCreditGrantAt || null;
                subscriptionStatus.value = data.subscriptionStatus;
                currentTierKey.value = data.currentTierKey;
                // Falls back to currentTierKey so a rolling deploy -- new page, XHR answered by an old instance
                // that does not emit addOnTierKey yet -- degrades to the previous behaviour instead of showing
                // every driver an empty pack list with no error.
                addOnTierKey.value = data.addOnTierKey || data.currentTierKey || null;
                subscriptionEndDate.value = data.subscriptionEndDate;
                gracePeriodDaysLeft.value = data.gracePeriodDaysLeft || 0;
                trialEndDate.value = data.trialEndDate || null;
                hasUsedFreeTrial.value = data.hasUsedFreeTrial || false;
                subscriptionPlans.value = data.plans || [];
                allAddOns.value = data.addOns || [];
                hasPendingChange.value = data.hasPendingChange || false;
                pendingTierKey.value = data.pendingTierKey || null;
                pendingPlanName.value = data.pendingPlanName || null;
                pendingChangeEffectiveDate.value = data.pendingChangeEffectiveDate || null;
            } catch (e) {
                error.value = e.message || 'An error occurred while loading subscription data';
            } finally{
                loading.value = false;
            }
        }
        async function selectPlan(plan, expectTrial = plan.trialAvailable && !hasUsedFreeTrial.value) {
            actionLoading.value = true;
            error.value = null;
            try {
                // expectTrial is what this card actually promised. Plans are fetched once on mount and never
                // refetched, so a scheduled promo end can close the window while the page sits open; sending it
                // lets the server refuse instead of quietly creating a session that charges today.
                const response = await fetch(`/api/driver-subscription/checkout?token=${encodeURIComponent(props.token)}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        planId: plan.id,
                        expectTrial
                    })
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    if (errorData.trialExpired) {
                        const confirmed = await (0, _sweetalert2MinDefault.default).fire({
                            icon: 'warning',
                            title: 'Free trial ended',
                            text: errorData.message,
                            showCancelButton: true,
                            confirmButtonText: `Continue at $${plan.priceInDollars}/${plan.billingInterval || 'week'}`,
                            cancelButtonText: 'Not now'
                        });
                        actionLoading.value = false;
                        if (confirmed.isConfirmed) {
                            // Refresh first so the card stops advertising a trial that is gone.
                            await loadSubscriptionData();
                            return selectPlan(plan, false);
                        }
                        return;
                    }
                    throw new Error(errorData.message || 'Failed to create checkout session');
                }
                const data = await response.json();
                if (data.checkoutUrl) window.location.href = data.checkoutUrl;
            } catch (e) {
                error.value = e.message || 'Failed to start subscription process';
                (0, _sweetalert2MinDefault.default).fire({
                    icon: 'error',
                    title: 'Subscription Error',
                    text: e.message || 'Failed to start subscription process'
                });
            } finally{
                actionLoading.value = false;
            }
        }
        async function purchaseAddOn(addon) {
            actionLoading.value = true;
            error.value = null;
            try {
                const response = await fetch(`/api/driver-subscription/addon-checkout?token=${encodeURIComponent(props.token)}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        addonId: addon.id
                    })
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Failed to create add-on checkout session');
                }
                const data = await response.json();
                if (data.checkoutUrl) window.location.href = data.checkoutUrl;
            } catch (e) {
                error.value = e.message || 'Failed to purchase add-on';
                (0, _sweetalert2MinDefault.default).fire({
                    icon: 'error',
                    title: 'Purchase Error',
                    text: e.message || 'Failed to purchase add-on'
                });
            } finally{
                actionLoading.value = false;
            }
        }
        async function openBillingPortal() {
            actionLoading.value = true;
            error.value = null;
            try {
                const response = await fetch(`/api/driver-subscription/billing-portal?token=${encodeURIComponent(props.token)}`, {
                    method: 'POST'
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Failed to open billing portal');
                }
                const data = await response.json();
                if (data.portalUrl) window.location.href = data.portalUrl;
            } catch (e) {
                error.value = e.message || 'Failed to open billing portal';
                (0, _sweetalert2MinDefault.default).fire({
                    icon: 'error',
                    title: 'Error',
                    text: e.message || 'Failed to open billing portal'
                });
            } finally{
                actionLoading.value = false;
            }
        }
        (0, _vue.onMounted)(()=>{
            loadSubscriptionData();
        });
        const __returned__ = {
            props,
            loading,
            actionLoading,
            error,
            driver,
            rideCredits,
            weeklyCreditAllowance,
            lowCreditThreshold,
            nextCreditGrantAt,
            subscriptionStatus,
            currentTierKey,
            addOnTierKey,
            subscriptionEndDate,
            gracePeriodDaysLeft,
            trialEndDate,
            hasUsedFreeTrial,
            subscriptionPlans,
            allAddOns,
            hasPendingChange,
            pendingTierKey,
            pendingPlanName,
            pendingChangeEffectiveDate,
            isTrialing,
            hasSubscription,
            trialDaysLeft,
            creditCountClass,
            currentPlanName,
            availableAddOns,
            getPlanHeaderClass,
            parseDate,
            formatDate,
            loadSubscriptionData,
            selectPlan,
            purchaseAddOn,
            openBillingPortal,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dij0i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card"
};
const _hoisted_5 = {
    class: "login-main wide-main position-relative"
};
const _hoisted_6 = {
    key: 0,
    class: "loader-overlay d-flex align-items-center justify-content-center"
};
const _hoisted_7 = {
    class: "d-flex align-items-center justify-content-between gap-3 flex-wrap mb-4"
};
const _hoisted_8 = {
    class: "d-flex align-items-center gap-3 flex-wrap"
};
const _hoisted_9 = [
    "src"
];
const _hoisted_10 = {
    class: "flex-grow-1"
};
const _hoisted_11 = {
    class: "fs-4 f-w-700"
};
const _hoisted_12 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_13 = {
    class: "ms-1"
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_16 = {
    key: 1,
    class: "fa-solid fa-gear me-2"
};
const _hoisted_17 = {
    class: "subscription-summary-card mb-4 p-3 p-sm-4 rounded-3 border bg-light"
};
const _hoisted_18 = {
    class: "row align-items-center"
};
const _hoisted_19 = {
    class: "col-md-6"
};
const _hoisted_20 = {
    class: "fs-3 fw-bold text-primary"
};
const _hoisted_21 = {
    key: 0,
    class: "badge bg-info mt-1"
};
const _hoisted_22 = {
    key: 1,
    class: "badge bg-success mt-1"
};
const _hoisted_23 = {
    key: 2,
    class: "badge bg-warning mt-1"
};
const _hoisted_24 = {
    key: 3,
    class: "badge bg-secondary mt-1"
};
const _hoisted_25 = {
    class: "col-md-6 text-md-end mt-3 mt-md-0"
};
const _hoisted_26 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_27 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_28 = {
    key: 0,
    class: "mt-3 pt-3 border-top"
};
const _hoisted_29 = {
    class: "d-flex align-items-center gap-2"
};
const _hoisted_30 = {
    class: "ms-2 fw-semibold text-info"
};
const _hoisted_31 = {
    class: "ms-2 text-muted small"
};
const _hoisted_32 = {
    key: 1,
    class: "mt-3 pt-3 border-top"
};
const _hoisted_33 = {
    class: "d-flex align-items-center gap-2"
};
const _hoisted_34 = {
    class: "ms-2 fw-semibold text-black"
};
const _hoisted_35 = {
    key: 0,
    class: "ms-2 text-muted small"
};
const _hoisted_36 = {
    key: 2,
    class: "alert alert-danger mt-3 mb-0"
};
const _hoisted_37 = {
    key: 3,
    class: "alert alert-warning mt-3 mb-0"
};
const _hoisted_38 = {
    key: 4,
    class: "mt-3 pt-3 border-top"
};
const _hoisted_39 = {
    class: "ms-2 fw-semibold text-black"
};
const _hoisted_40 = {
    key: 5,
    class: "alert alert-warning mt-3 mb-0"
};
const _hoisted_41 = {
    key: 6,
    class: "alert alert-info mt-3 mb-0"
};
const _hoisted_42 = {
    key: 1
};
const _hoisted_43 = {
    class: "row g-3 mb-4"
};
const _hoisted_44 = {
    class: "card h-100 subscription-plan-card"
};
const _hoisted_45 = {
    class: "card-title mb-0 text-white"
};
const _hoisted_46 = {
    key: 0,
    class: "plan-trial-badge mt-2"
};
const _hoisted_47 = {
    class: "card-body text-center"
};
const _hoisted_48 = {
    class: "price-display mb-3"
};
const _hoisted_49 = {
    class: "fs-1 fw-bold"
};
const _hoisted_50 = {
    class: "text-muted"
};
const _hoisted_51 = {
    class: "list-unstyled text-start mb-4"
};
const _hoisted_52 = {
    class: "mb-2"
};
const _hoisted_53 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_54 = {
    key: 1,
    class: "mb-2"
};
const _hoisted_55 = {
    key: 2,
    class: "mb-2"
};
const _hoisted_56 = {
    key: 3,
    class: "text-muted small"
};
const _hoisted_57 = [
    "onClick",
    "disabled"
];
const _hoisted_58 = {
    key: 0
};
const _hoisted_59 = {
    key: 1
};
const _hoisted_60 = {
    key: 0,
    class: "text-muted d-block mt-2"
};
const _hoisted_61 = {
    key: 2
};
const _hoisted_62 = {
    class: "row g-3 mb-4"
};
const _hoisted_63 = {
    class: "card h-100 addon-card text-center"
};
const _hoisted_64 = {
    class: "card-body"
};
const _hoisted_65 = {
    class: "addon-credits mb-2"
};
const _hoisted_66 = {
    class: "fs-3 fw-bold text-primary"
};
const _hoisted_67 = {
    class: "addon-price fs-5 fw-semibold mb-3"
};
const _hoisted_68 = [
    "onClick",
    "disabled"
];
const _hoisted_69 = {
    key: 3,
    class: "alert alert-danger mt-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, _cache[0] || (_cache[0] = [
                                (0, _vue.createElementVNode)("div", {
                                    class: "text-center"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "spinner-border text-primary",
                                        role: "status",
                                        "aria-label": "Loading"
                                    }),
                                    (0, _vue.createElementVNode)("div", {
                                        class: "mt-2 fw-semibold text-primary"
                                    }, "Please wait...")
                                ], -1)
                            ]))) : (0, _vue.createCommentVNode)("", true),
                            _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("div", {
                                class: "d-flex justify-content-between align-items-center flex-wrap gap-2 gap-sm-3 mb-3"
                            }, [
                                (0, _vue.createElementVNode)("h2", {
                                    class: "mb-0"
                                }, "My Subscription")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_7, [
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    (0, _vue.createElementVNode)("img", {
                                        src: `/api/driver/${$props.driverId}/profile-picture`,
                                        alt: "Driver photo",
                                        class: "rounded-circle border",
                                        style: {
                                            "width": "84px",
                                            "height": "84px",
                                            "object-fit": "cover"
                                        }
                                    }, null, 8, _hoisted_9),
                                    (0, _vue.createElementVNode)("div", _hoisted_10, [
                                        (0, _vue.createElementVNode)("div", _hoisted_11, (0, _vue.toDisplayString)($setup.driver.name), 1),
                                        $setup.driver.rating !== null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                                            _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-star text-warning"
                                            }, null, -1)),
                                            (0, _vue.createElementVNode)("span", _hoisted_13, (0, _vue.toDisplayString)(Number($setup.driver.rating).toFixed(1)), 1)
                                        ])) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ]),
                                $setup.hasSubscription ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn btn-primary",
                                    onClick: $setup.openBillingPortal,
                                    disabled: $setup.actionLoading
                                }, [
                                    $setup.actionLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_15)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_16)),
                                    _cache[2] || (_cache[2] = (0, _vue.createTextVNode)(" Manage Subscription "))
                                ], 8, _hoisted_14)) : (0, _vue.createCommentVNode)("", true)
                            ]),
                            _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("hr", null, null, -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_17, [
                                (0, _vue.createElementVNode)("div", _hoisted_18, [
                                    (0, _vue.createElementVNode)("div", _hoisted_19, [
                                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("h5", {
                                            class: "text-muted mb-1"
                                        }, "Current Plan", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_20, (0, _vue.toDisplayString)($setup.hasSubscription ? $setup.currentPlanName : 'No Active Plan'), 1),
                                        $setup.isTrialing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_21, "Free Trial")) : $setup.subscriptionStatus === 'ACTIVE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22, "Active")) : $setup.subscriptionStatus === 'CANCELLED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_23, "Cancelled")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_24, "Inactive"))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_25, [
                                        _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("h5", {
                                            class: "text-muted mb-1"
                                        }, "Available Credits", -1)),
                                        (0, _vue.createElementVNode)("div", {
                                            class: (0, _vue.normalizeClass)([
                                                "fs-1 fw-bold",
                                                $setup.creditCountClass
                                            ])
                                        }, [
                                            _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-coins me-2"
                                            }, null, -1)),
                                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.rideCredits), 1)
                                        ], 2),
                                        $setup.weeklyCreditAllowance ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_26, " of " + (0, _vue.toDisplayString)($setup.weeklyCreditAllowance) + " granted " + (0, _vue.toDisplayString)($setup.isTrialing ? 'each week of your trial' : 'each billing period'), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_27, "ride credits remaining"))
                                    ])
                                ]),
                                $setup.isTrialing && $setup.trialEndDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, [
                                    (0, _vue.createElementVNode)("div", _hoisted_29, [
                                        _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("i", {
                                            class: "fa-solid fa-hourglass-half text-info"
                                        }, null, -1)),
                                        (0, _vue.createElementVNode)("div", null, [
                                            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Free trial ends:", -1)),
                                            (0, _vue.createElementVNode)("span", _hoisted_30, (0, _vue.toDisplayString)($setup.formatDate($setup.trialEndDate)), 1),
                                            (0, _vue.createElementVNode)("span", _hoisted_31, "(" + (0, _vue.toDisplayString)($setup.trialDaysLeft) + " days left \u2014 no charge until then)", 1)
                                        ])
                                    ])
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.hasSubscription && $setup.nextCreditGrantAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, [
                                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                                        _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("i", {
                                            class: "fa-solid fa-rotate text-primary"
                                        }, null, -1)),
                                        (0, _vue.createElementVNode)("div", null, [
                                            _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Next credit grant:", -1)),
                                            (0, _vue.createElementVNode)("span", _hoisted_34, (0, _vue.toDisplayString)($setup.formatDate($setup.nextCreditGrantAt)), 1),
                                            $setup.weeklyCreditAllowance ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_35, " (+" + (0, _vue.toDisplayString)($setup.weeklyCreditAllowance) + " credits) ", 1)) : (0, _vue.createCommentVNode)("", true)
                                        ])
                                    ])
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.hasSubscription && $setup.rideCredits <= 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_36, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-triangle-exclamation me-2"
                                    }, null, -1)),
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("strong", null, "You have no ride credits left.", -1)),
                                    _cache[12] || (_cache[12] = (0, _vue.createTextVNode)(" You will not receive new ride requests until ")),
                                    $setup.nextCreditGrantAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        (0, _vue.createTextVNode)("your credits renew on " + (0, _vue.toDisplayString)($setup.formatDate($setup.nextCreditGrantAt)), 1)
                                    ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)("your credits renew")
                                    ], 64)),
                                    $setup.availableAddOns.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 2
                                    }, [
                                        (0, _vue.createTextVNode)(" \u2014 or buy a top-up below")
                                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                                    _cache[13] || (_cache[13] = (0, _vue.createTextVNode)(". "))
                                ])) : $setup.hasSubscription && $setup.rideCredits <= $setup.lowCreditThreshold ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_37, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-battery-quarter me-2"
                                    }, null, -1)),
                                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.rideCredits) + " ride " + (0, _vue.toDisplayString)($setup.rideCredits === 1 ? 'credit' : 'credits') + " left.", 1),
                                    _cache[15] || (_cache[15] = (0, _vue.createTextVNode)(" Each accepted ride uses one credit ")),
                                    $setup.nextCreditGrantAt ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        (0, _vue.createTextVNode)(", and yours renew on " + (0, _vue.toDisplayString)($setup.formatDate($setup.nextCreditGrantAt)), 1)
                                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                                    _cache[16] || (_cache[16] = (0, _vue.createTextVNode)(". "))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.subscriptionStatus === 'ACTIVE' && $setup.subscriptionEndDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_38, [
                                    (0, _vue.createElementVNode)("div", null, [
                                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("small", {
                                            class: "text-muted"
                                        }, "Next billing date:", -1)),
                                        (0, _vue.createElementVNode)("span", _hoisted_39, (0, _vue.toDisplayString)($setup.formatDate($setup.subscriptionEndDate)), 1)
                                    ])
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.subscriptionStatus === 'CANCELLED' && $setup.gracePeriodDaysLeft > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_40, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-clock me-2"
                                    }, null, -1)),
                                    _cache[19] || (_cache[19] = (0, _vue.createTextVNode)(" Your subscription was cancelled. You have ")),
                                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.gracePeriodDaysLeft) + " days", 1),
                                    _cache[20] || (_cache[20] = (0, _vue.createTextVNode)(" left in your grace period. Resubscribe now to keep your credits! "))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.hasPendingChange ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_41, [
                                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-clock-rotate-left me-2"
                                    }, null, -1)),
                                    _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("strong", null, "Pending Plan Change:", -1)),
                                    _cache[23] || (_cache[23] = (0, _vue.createTextVNode)(" Your subscription will change to ")),
                                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.pendingPlanName || $setup.pendingTierKey), 1),
                                    _cache[24] || (_cache[24] = (0, _vue.createTextVNode)(" on ")),
                                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatDate($setup.pendingChangeEffectiveDate)), 1),
                                    _cache[25] || (_cache[25] = (0, _vue.createTextVNode)(". ")),
                                    _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("br", null, null, -1)),
                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("small", {
                                        class: "text-muted"
                                    }, "Your credits will remain unchanged until the new billing cycle begins.", -1))
                                ])) : (0, _vue.createCommentVNode)("", true)
                            ]),
                            !$setup.hasSubscription ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_42, [
                                _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("h4", {
                                    class: "mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-layer-group me-2"
                                    }),
                                    (0, _vue.createTextVNode)(" Choose a Plan ")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_43, [
                                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.subscriptionPlans, (plan)=>{
                                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                            key: plan.id,
                                            class: "col-lg-4 col-md-6"
                                        }, [
                                            (0, _vue.createElementVNode)("div", _hoisted_44, [
                                                (0, _vue.createElementVNode)("div", {
                                                    class: (0, _vue.normalizeClass)([
                                                        "card-header text-center py-3",
                                                        $setup.getPlanHeaderClass(plan)
                                                    ])
                                                }, [
                                                    (0, _vue.createElementVNode)("h5", _hoisted_45, (0, _vue.toDisplayString)(plan.name), 1),
                                                    plan.trialAvailable && !$setup.hasUsedFreeTrial ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_46, [
                                                        _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("i", {
                                                            class: "fa-solid fa-gift me-1"
                                                        }, null, -1)),
                                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(plan.trialPeriodDays) + "-Day Free Trial", 1)
                                                    ])) : (0, _vue.createCommentVNode)("", true)
                                                ], 2),
                                                (0, _vue.createElementVNode)("div", _hoisted_47, [
                                                    (0, _vue.createElementVNode)("div", _hoisted_48, [
                                                        (0, _vue.createElementVNode)("span", _hoisted_49, "$" + (0, _vue.toDisplayString)(plan.priceInDollars), 1),
                                                        (0, _vue.createElementVNode)("span", _hoisted_50, "/" + (0, _vue.toDisplayString)(plan.billingInterval || 'week'), 1)
                                                    ]),
                                                    (0, _vue.createElementVNode)("ul", _hoisted_51, [
                                                        (0, _vue.createElementVNode)("li", _hoisted_52, [
                                                            _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-check text-success me-2"
                                                            }, null, -1)),
                                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)(plan.rideCredits), 1),
                                                            _cache[30] || (_cache[30] = (0, _vue.createTextVNode)(" ride credits "))
                                                        ]),
                                                        _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("li", {
                                                            class: "mb-2"
                                                        }, [
                                                            (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-check text-success me-2"
                                                            }),
                                                            (0, _vue.createTextVNode)(" Keep "),
                                                            (0, _vue.createElementVNode)("strong", null, "95%"),
                                                            (0, _vue.createTextVNode)(" of your earnings ")
                                                        ], -1)),
                                                        plan.rolloverPercentage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_53, [
                                                            _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-check text-success me-2"
                                                            }, null, -1)),
                                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)(plan.rolloverPercentage) + "% credit rollover ", 1)
                                                        ])) : (0, _vue.createCommentVNode)("", true),
                                                        plan.costPerRide != null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_54, [
                                                            _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-check text-success me-2"
                                                            }, null, -1)),
                                                            (0, _vue.createElementVNode)("strong", null, "$" + (0, _vue.toDisplayString)(Number(plan.costPerRide).toFixed(2)), 1),
                                                            _cache[33] || (_cache[33] = (0, _vue.createTextVNode)(" per ride "))
                                                        ])) : (0, _vue.createCommentVNode)("", true),
                                                        plan.trialAvailable && !$setup.hasUsedFreeTrial ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_55, [
                                                            _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("i", {
                                                                class: "fa-solid fa-gift text-info me-2"
                                                            }, null, -1)),
                                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)(plan.trialPeriodDays) + " days", 1),
                                                            _cache[35] || (_cache[35] = (0, _vue.createTextVNode)(" free trial, ")),
                                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)(plan.trialRideCredits), 1),
                                                            _cache[36] || (_cache[36] = (0, _vue.createTextVNode)(" ride credits per week "))
                                                        ])) : (0, _vue.createCommentVNode)("", true),
                                                        plan.description ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_56, (0, _vue.toDisplayString)(plan.description), 1)) : (0, _vue.createCommentVNode)("", true)
                                                    ]),
                                                    (0, _vue.createElementVNode)("button", {
                                                        class: "btn btn-primary w-100",
                                                        onClick: ($event)=>$setup.selectPlan(plan),
                                                        disabled: $setup.actionLoading
                                                    }, [
                                                        plan.trialAvailable && !$setup.hasUsedFreeTrial ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_58, " Start " + (0, _vue.toDisplayString)(plan.trialPeriodDays) + "-Day Free Trial ", 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_59, "Subscribe"))
                                                    ], 8, _hoisted_57),
                                                    plan.trialAvailable && !$setup.hasUsedFreeTrial ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_60, " No charge for " + (0, _vue.toDisplayString)(plan.trialPeriodDays) + " days. Cancel anytime. ", 1)) : (0, _vue.createCommentVNode)("", true)
                                                ])
                                            ])
                                        ]);
                                    }), 128))
                                ])
                            ])) : (0, _vue.createCommentVNode)("", true),
                            ($setup.subscriptionStatus === 'ACTIVE' || $setup.subscriptionStatus === 'TRIALING') && $setup.availableAddOns.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_61, [
                                _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("h4", {
                                    class: "mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-plus-circle me-2"
                                    }),
                                    (0, _vue.createTextVNode)(" Need More Credits? ")
                                ], -1)),
                                _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("p", {
                                    class: "text-muted mb-3"
                                }, "Purchase additional ride credits for your current plan.", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_62, [
                                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.availableAddOns, (addon)=>{
                                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                            key: addon.id,
                                            class: "col-lg-3 col-md-4 col-6"
                                        }, [
                                            (0, _vue.createElementVNode)("div", _hoisted_63, [
                                                (0, _vue.createElementVNode)("div", _hoisted_64, [
                                                    (0, _vue.createElementVNode)("div", _hoisted_65, [
                                                        (0, _vue.createElementVNode)("span", _hoisted_66, "+" + (0, _vue.toDisplayString)(addon.rideCredits), 1)
                                                    ]),
                                                    _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("div", {
                                                        class: "text-muted mb-2"
                                                    }, "credits", -1)),
                                                    (0, _vue.createElementVNode)("div", _hoisted_67, "$" + (0, _vue.toDisplayString)(addon.priceInDollars), 1),
                                                    (0, _vue.createElementVNode)("button", {
                                                        class: "btn btn-outline-primary btn-sm w-100",
                                                        onClick: ($event)=>$setup.purchaseAddOn(addon),
                                                        disabled: $setup.actionLoading
                                                    }, " Buy Now ", 8, _hoisted_68)
                                                ])
                                            ])
                                        ]);
                                    }), 128))
                                ])
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_69, [
                                _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-exclamation-circle me-2"
                                }, null, -1)),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.error), 1)
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gz9US":[function() {},{}],"2xikt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dd26H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f624e98ffe0d763a");
    if (script.__esModule) script = script.default;
    script.render = require("efd79cf123cbe77d").render;
    script.__cssModules = require("f23730b8d7fb8e2f").default;
    require("aa49933130a2063").default(script);
    script.__scopeId = 'data-v-b1d385';
    script.__file = "DashboardMetrics.vue";
};
initialize();
exports.default = script;

},{"f624e98ffe0d763a":"k7yuN","efd79cf123cbe77d":"hJp7n","f23730b8d7fb8e2f":"isZjH","aa49933130a2063":"QqtJ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7yuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _chartJs = require("chart.js");
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'DashboardMetrics',
    props: {
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _chartJs.Chart).register(...(0, _chartJs.registerables));
        const props = __props;
        const timeframes = [
            {
                value: 'today',
                label: 'Today'
            },
            {
                value: 'week',
                label: 'Week'
            },
            {
                value: 'month',
                label: 'Month'
            },
            {
                value: 'year',
                label: 'Year'
            }
        ];
        const timeframe = (0, _vue.ref)('week');
        const metrics = (0, _vue.ref)(null);
        const loading = (0, _vue.ref)(false);
        const error = (0, _vue.ref)(null);
        const revenueChart = (0, _vue.ref)(null);
        const statusChart = (0, _vue.ref)(null);
        const peakHoursChart = (0, _vue.ref)(null);
        let revenueChartInstance = null;
        let statusChartInstance = null;
        let peakHoursChartInstance = null;
        const fetchMetrics = async (refresh = false)=>{
            loading.value = true;
            error.value = null;
            try {
                const url = `/api/dashboard/metrics/${props.serviceProviderId}?timeframe=${timeframe.value}&refresh=${refresh}`;
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch dashboard metrics');
                metrics.value = await response.json();
                await (0, _vue.nextTick)();
                renderCharts();
            } catch (err) {
                error.value = err.message;
                console.error('Error fetching dashboard metrics:', err);
            } finally{
                loading.value = false;
            }
        };
        const selectTimeframe = (tf)=>{
            timeframe.value = tf;
            fetchMetrics();
        };
        const refreshMetrics = ()=>{
            fetchMetrics(true);
        };
        const renderCharts = ()=>{
            if (!metrics.value) return;
            renderRevenueChart();
            renderStatusChart();
            renderPeakHoursChart();
        };
        const renderRevenueChart = ()=>{
            if (!revenueChart.value || !metrics.value.trends.revenue) return;
            if (revenueChartInstance) revenueChartInstance.destroy();
            const ctx = revenueChart.value.getContext('2d');
            revenueChartInstance = new (0, _chartJs.Chart)(ctx, {
                type: 'line',
                data: {
                    labels: metrics.value.trends.revenue.map((p)=>p.label),
                    datasets: [
                        {
                            label: 'Revenue',
                            data: metrics.value.trends.revenue.map((p)=>p.revenue),
                            borderColor: 'rgb(75, 192, 192)',
                            backgroundColor: 'rgba(75, 192, 192, 0.1)',
                            fill: true,
                            tension: 0.4
                        },
                        {
                            label: 'Rides',
                            data: metrics.value.trends.rides.map((p)=>p.count),
                            borderColor: 'rgb(255, 99, 132)',
                            backgroundColor: 'rgba(255, 99, 132, 0.1)',
                            fill: true,
                            tension: 0.4,
                            yAxisID: 'y1'
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'index',
                        intersect: false
                    },
                    scales: {
                        y: {
                            type: 'linear',
                            display: true,
                            position: 'left',
                            title: {
                                display: true,
                                text: 'Revenue ($)'
                            }
                        },
                        y1: {
                            type: 'linear',
                            display: true,
                            position: 'right',
                            title: {
                                display: true,
                                text: 'Number of Rides'
                            },
                            grid: {
                                drawOnChartArea: false
                            }
                        }
                    }
                }
            });
        };
        const renderStatusChart = ()=>{
            if (!statusChart.value || !metrics.value.trends.rideStatusBreakdown) return;
            if (statusChartInstance) statusChartInstance.destroy();
            const ctx = statusChart.value.getContext('2d');
            const statusData = metrics.value.trends.rideStatusBreakdown;
            statusChartInstance = new (0, _chartJs.Chart)(ctx, {
                type: 'doughnut',
                data: {
                    labels: statusData.map((s)=>s.status.replace(/_/g, ' ')),
                    datasets: [
                        {
                            data: statusData.map((s)=>s.count),
                            backgroundColor: [
                                'rgb(75, 192, 192)',
                                'rgb(255, 205, 86)',
                                'rgb(255, 99, 132)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ]
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom'
                        }
                    }
                }
            });
        };
        const renderPeakHoursChart = ()=>{
            if (!peakHoursChart.value || !metrics.value.operations.peakHours) return;
            if (peakHoursChartInstance) peakHoursChartInstance.destroy();
            const ctx = peakHoursChart.value.getContext('2d');
            peakHoursChartInstance = new (0, _chartJs.Chart)(ctx, {
                type: 'bar',
                data: {
                    labels: metrics.value.operations.peakHours.map((p)=>p.hour),
                    datasets: [
                        {
                            label: 'Ride Count',
                            data: metrics.value.operations.peakHours.map((p)=>p.rideCount),
                            backgroundColor: 'rgba(54, 162, 235, 0.6)',
                            borderColor: 'rgba(54, 162, 235, 1)',
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: 'Number of Rides'
                            }
                        },
                        x: {
                            title: {
                                display: true,
                                text: 'Hour of Day'
                            }
                        }
                    }
                }
            });
        };
        const formatNumber = (num)=>{
            return num != null ? num.toLocaleString() : '0';
        };
        const formatCurrency = (amount)=>{
            return amount != null ? `$${parseFloat(amount).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}` : '$0.00';
        };
        const formatPercentage = (value)=>{
            return value != null ? parseFloat(value).toFixed(1) : '0.0';
        };
        const getChangeClass = (change)=>{
            if (change > 0) return 'text-success';
            if (change < 0) return 'text-danger';
            return 'text-muted';
        };
        const getChangeIcon = (change)=>{
            if (change > 0) return 'fa-solid fa-arrow-up';
            if (change < 0) return 'fa-solid fa-arrow-down';
            return 'fa-solid fa-minus';
        };
        (0, _vue.onMounted)(()=>{
            fetchMetrics();
            // Refresh every 60 seconds
            setInterval(()=>{
                fetchMetrics();
            }, 60000);
        });
        const __returned__ = {
            props,
            timeframes,
            timeframe,
            metrics,
            loading,
            error,
            revenueChart,
            statusChart,
            peakHoursChart,
            get revenueChartInstance () {
                return revenueChartInstance;
            },
            set revenueChartInstance (v){
                revenueChartInstance = v;
            },
            get statusChartInstance () {
                return statusChartInstance;
            },
            set statusChartInstance (v){
                statusChartInstance = v;
            },
            get peakHoursChartInstance () {
                return peakHoursChartInstance;
            },
            set peakHoursChartInstance (v){
                peakHoursChartInstance = v;
            },
            fetchMetrics,
            selectTimeframe,
            refreshMetrics,
            renderCharts,
            renderRevenueChart,
            renderStatusChart,
            renderPeakHoursChart,
            formatNumber,
            formatCurrency,
            formatPercentage,
            getChangeClass,
            getChangeIcon,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            nextTick: (0, _vue.nextTick),
            get Chart () {
                return 0, _chartJs.Chart;
            },
            get registerables () {
                return 0, _chartJs.registerables;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","chart.js":"ftdI1","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ftdI1":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersDatasetJs.aM));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersDatasetJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _helpersDatasetJs = require("./chunks/helpers.dataset.js");
var _color = require("@kurkle/color");
class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersDatasetJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();
const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, _helpersDatasetJs.c)(from || transparent);
        const c1 = c0.valid && (0, _helpersDatasetJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, _helpersDatasetJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, _helpersDatasetJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersDatasetJs.e)[cfg.easing] || (0, _helpersDatasetJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersDatasetJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersDatasetJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, _helpersDatasetJs.i)(config)) return;
        const animationOptions = Object.keys((0, _helpersDatasetJs.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, _helpersDatasetJs.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, _helpersDatasetJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if ((0, _helpersDatasetJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersDatasetJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersDatasetJs.s)(value) === (0, _helpersDatasetJs.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function convertObjectDataToArray(data, meta) {
    const { iScale, vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min, max, minDefined, maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale, vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersDatasetJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, _helpersDatasetJs.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, _helpersDatasetJs.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, _helpersDatasetJs.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, _helpersDatasetJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, _helpersDatasetJs.i)(data)) {
            const meta = this._cachedMeta;
            this._data = convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, _helpersDatasetJs.u)(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersDatasetJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            updateStacks(this, meta._parsed);
            meta._stacked = isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale, _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersDatasetJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersDatasetJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersDatasetJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersDatasetJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, _helpersDatasetJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersDatasetJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip((0, _helpersDatasetJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, _helpersDatasetJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, _helpersDatasetJs.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersDatasetJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersDatasetJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, _helpersDatasetJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersDatasetJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersDatasetJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start, end, reverse, top, bottom } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const { xAxisKey = 'x', yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersDatasetJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersDatasetJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale, vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index, _cachedMeta: { vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, _helpersDatasetJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersDatasetJs.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, _helpersDatasetJs.v)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersDatasetJs.s)(value) !== (0, _helpersDatasetJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, _helpersDatasetJs.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, _helpersDatasetJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, _helpersDatasetJs.v)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, _helpersDatasetJs.v)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class BubbleController extends DatasetController {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersDatasetJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, _helpersDatasetJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, _helpersDatasetJs.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, _helpersDatasetJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, _helpersDatasetJs.H), startY, endY);
        const minX = calcMin((0, _helpersDatasetJs.P), startX, endX);
        const minY = calcMin((0, _helpersDatasetJs.P) + (0, _helpersDatasetJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, _helpersDatasetJs.i)(data[start])) {
                const { key = 'value' } = this._parsing;
                getter = (i)=>+(0, _helpersDatasetJs.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersDatasetJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersDatasetJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, _helpersDatasetJs.T);
        let max = -(0, _helpersDatasetJs.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, _helpersDatasetJs.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference, rotation } = this._getRotationExtents();
        const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, _helpersDatasetJs.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersDatasetJs.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersDatasetJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersDatasetJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class LineController extends DatasetController {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class PolarAreaController extends DatasetController {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersDatasetJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersDatasetJs.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersDatasetJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class PieController extends DoughnutController {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class RadarController extends DatasetController {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersDatasetJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class ScatterController extends DatasetController {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersDatasetJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersDatasetJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersDatasetJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, _helpersDatasetJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    const { controller, data, _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, _helpersDatasetJs.A) : (0, _helpersDatasetJs.B);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale } = controller._cachedMeta;
                const { _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, _helpersDatasetJs.k)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index, data } = metasets[i];
        const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersDatasetJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle, endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle } = (0, _helpersDatasetJs.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, _helpersDatasetJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, _helpersDatasetJs.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack, stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack, pos, stackWeight } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth, hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos, box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, _helpersDatasetJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same, other } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x, y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, _helpersDatasetJs.h)(stack.start)) y = stack.start;
            if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, _helpersDatasetJs.h)(stack.start)) x = stack.start;
            if (box.fullSize) setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, _helpersDatasetJs.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, _helpersDatasetJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersDatasetJs.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersDatasetJs.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, _helpersDatasetJs.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, _helpersDatasetJs.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const eventListenerOptions = (0, _helpersDatasetJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x, y } = (0, _helpersDatasetJs.z)(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, _helpersDatasetJs.I)(canvas);
    if (!container) return;
    const resize = (0, _helpersDatasetJs.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, _helpersDatasetJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, _helpersDatasetJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersDatasetJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, _helpersDatasetJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersDatasetJs.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersDatasetJs.x)(this.x) && (0, _helpersDatasetJs.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersDatasetJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, _helpersDatasetJs.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, _helpersDatasetJs.v)(majorStart, 0);
    const end = Math.min((0, _helpersDatasetJs.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersDatasetJs.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, _helpersDatasetJs.a0)(options.font, fallback);
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    const lines = (0, _helpersDatasetJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersDatasetJs.j)(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersDatasetJs.j)(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    let ret = (0, _helpersDatasetJs.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top, left, bottom, right, chart } = scale;
    const { chartArea, scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersDatasetJs.a2)(align, left, right);
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersDatasetJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, _helpersDatasetJs.H) : (0, _helpersDatasetJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
        _userMin = (0, _helpersDatasetJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersDatasetJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersDatasetJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersDatasetJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersDatasetJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersDatasetJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersDatasetJs.g)(_userMin),
            maxDefined: (0, _helpersDatasetJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersDatasetJs.O)(min, (0, _helpersDatasetJs.O)(max, min)),
            max: (0, _helpersDatasetJs.O)(max, (0, _helpersDatasetJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero, grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersDatasetJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersDatasetJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersDatasetJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersDatasetJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersDatasetJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersDatasetJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, _helpersDatasetJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersDatasetJs.U)(Math.min(Math.asin((0, _helpersDatasetJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersDatasetJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersDatasetJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersDatasetJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersDatasetJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first, last, widest, highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, _helpersDatasetJs.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align, padding }, position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersDatasetJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis, position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersDatasetJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersDatasetJs.k)(label) && !(0, _helpersDatasetJs.b)(label)) {
                width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersDatasetJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersDatasetJs.k)(nestedLabel) && !(0, _helpersDatasetJs.b)(nestedLabel)) {
                    width = (0, _helpersDatasetJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, _helpersDatasetJs.W)(this._alignToPixels ? (0, _helpersDatasetJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min, max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, _helpersDatasetJs.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid, position, border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, _helpersDatasetJs.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, _helpersDatasetJs.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersDatasetJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align, crossAlign, padding, mirror } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersDatasetJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersDatasetJs.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position, ticks } = this.options;
        const rotation = -(0, _helpersDatasetJs.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position, ticks: { crossAlign, mirror, padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx, options: { backgroundColor }, left, top, width, height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart, ctx, options: { border, grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersDatasetJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersDatasetJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersDatasetJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersDatasetJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, _helpersDatasetJs.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, _helpersDatasetJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, _helpersDatasetJs.$)(ctx);
    }
    drawTitle() {
        const { ctx, options: { position, title, reverse } } = this;
        if (!title.display) return;
        const font = (0, _helpersDatasetJs.a0)(title.font);
        const padding = (0, _helpersDatasetJs.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, _helpersDatasetJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersDatasetJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
        (0, _helpersDatasetJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, _helpersDatasetJs.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, _helpersDatasetJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersDatasetJs.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersDatasetJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersDatasetJs.d)[scope]) {
            delete (0, _helpersDatasetJs.d)[scope][id];
            if (this.override) delete (0, _helpersDatasetJs.a3)[id];
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, _helpersDatasetJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersDatasetJs.d).get(parentScope) : {},
        (0, _helpersDatasetJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersDatasetJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersDatasetJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, _helpersDatasetJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersDatasetJs.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, _helpersDatasetJs.a5)(method);
        (0, _helpersDatasetJs.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, _helpersDatasetJs.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, _helpersDatasetJs.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersDatasetJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, _helpersDatasetJs.v)(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    const datasetDefaults = (0, _helpersDatasetJs.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = (0, _helpersDatasetJs.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, _helpersDatasetJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersDatasetJs.d).scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersDatasetJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = (0, _helpersDatasetJs.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersDatasetJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, _helpersDatasetJs.ab)(scale, [
            (0, _helpersDatasetJs.d).scales[scale.type],
            (0, _helpersDatasetJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, _helpersDatasetJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = (0, _helpersDatasetJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options, type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersDatasetJs.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options, type } = this;
        return [
            options,
            (0, _helpersDatasetJs.a3)[type] || {},
            (0, _helpersDatasetJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersDatasetJs.d),
            (0, _helpersDatasetJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersDatasetJs.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersDatasetJs.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
        return (0, _helpersDatasetJs.i)(context) ? (0, _helpersDatasetJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, _helpersDatasetJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>(0, _helpersDatasetJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersDatasetJs.a7)(value[key]));
function needContext(proxy, names) {
    const { isScriptable, isIndexable } = (0, _helpersDatasetJs.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, _helpersDatasetJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersDatasetJs.b)(value)) return true;
    }
    return false;
}
var version = "4.5.1";
const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, _helpersDatasetJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersDatasetJs.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class Chart {
    static defaults = (0, _helpersDatasetJs.d);
    static instances = instances;
    static overrides = (0, _helpersDatasetJs.a3);
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, _helpersDatasetJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersDatasetJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
        if (!(0, _helpersDatasetJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, _helpersDatasetJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, _helpersDatasetJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersDatasetJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, _helpersDatasetJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, _helpersDatasetJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, _helpersDatasetJs.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = (0, _helpersDatasetJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersDatasetJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersDatasetJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType, dataElementType } = (0, _helpersDatasetJs.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersDatasetJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersDatasetJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active, _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersDatasetJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, _helpersDatasetJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method, start, count } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, _helpersDatasetJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersDatasetJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, _helpersDatasetJs.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width, height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, _helpersDatasetJs.ah)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, _helpersDatasetJs.Y)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, _helpersDatasetJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, _helpersDatasetJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersDatasetJs.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersDatasetJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas, ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersDatasetJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersDatasetJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersDatasetJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersDatasetJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, _helpersDatasetJs.aj)(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersDatasetJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersDatasetJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, _helpersDatasetJs.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return (0, _helpersDatasetJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipSelf(ctx, element, endAngle) {
    const { startAngle, x, y, outerRadius, innerRadius, options } = element;
    const { borderWidth, borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, _helpersDatasetJs.al)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, _helpersDatasetJs.al)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, _helpersDatasetJs.al)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, _helpersDatasetJs.P) / 2, startAngle + (0, _helpersDatasetJs.P) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, _helpersDatasetJs.P) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, _helpersDatasetJs.P) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, _helpersDatasetJs.P) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, _helpersDatasetJs.P) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function clipArc(ctx, element, endAngle) {
    const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersDatasetJs.H), startAngle - (0, _helpersDatasetJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersDatasetJs.am)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersDatasetJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersDatasetJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersDatasetJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x, y, startAngle: start, pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersDatasetJs.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersDatasetJs.H));
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, _helpersDatasetJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersDatasetJs.H));
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, _helpersDatasetJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference, options } = element;
    const { borderWidth, borderJoinStyle, borderDash, borderDashOffset, borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersDatasetJs.T) || (0, _helpersDatasetJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, _helpersDatasetJs.P) && borderRadius === 0 && borderJoinStyle !== 'miter') clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle, distance } = (0, _helpersDatasetJs.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, _helpersDatasetJs.v)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, _helpersDatasetJs.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, _helpersDatasetJs.T) || nonZeroBetween;
        const withinRadius = (0, _helpersDatasetJs.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset, spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options, circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersDatasetJs.T) ? Math.floor(circumference / (0, _helpersDatasetJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, _helpersDatasetJs.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, _helpersDatasetJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersDatasetJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersDatasetJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersDatasetJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersDatasetJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersDatasetJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.at;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.au;
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    const { points, options } = line;
    const { count, start, loop, ilen } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move = true, reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count, start, ilen } = pathVars(points, segment, params);
    const { move = true, reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersDatasetJs.aq;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, _helpersDatasetJs.ar;
    return 0, _helpersDatasetJs.as;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments, options } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersDatasetJs.an)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersDatasetJs.ao)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, _helpersDatasetJs.ap)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start, end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersDatasetJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersDatasetJs.av)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function getBarBounds(bar, useFinalPosition) {
    const { x, y, base, width, height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersDatasetJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, _helpersDatasetJs.ax)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, _helpersDatasetJs.ay)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, _helpersDatasetJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersDatasetJs.ak)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersDatasetJs.ak)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount, options: { borderColor, backgroundColor } } = this;
        const { inner, outer } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? (0, _helpersDatasetJs.aw) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, base, horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
const BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function containsDefaultColorsDefenitions() {
    return (0, _helpersDatasetJs.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, _helpersDatasetJs.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets }, options: chartOptions } = chart.config;
        const { elements } = chartOptions;
        const containsColorDefenition = containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements) || containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, _helpersDatasetJs.k)(minIndex) && !(0, _helpersDatasetJs.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale } = meta;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersDatasetJs.S)((0, _helpersDatasetJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data, indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, _helpersDatasetJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersDatasetJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start, end } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, _helpersDatasetJs.ap)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, _helpersDatasetJs.az)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, _helpersDatasetJs.al)(start);
        end = (0, _helpersDatasetJs.al)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x = null, y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start, end })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, _helpersDatasetJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersDatasetJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    const fill = parseFillOption(line);
    if ((0, _helpersDatasetJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, _helpersDatasetJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, _helpersDatasetJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersDatasetJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, _helpersDatasetJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    const { scale, index, line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first, last, point } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, _helpersDatasetJs.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x, y, radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersDatasetJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x, y, radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}
function _getTarget(source) {
    const { chart, fill, line } = source;
    if ((0, _helpersDatasetJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale = {}, fill } = source;
    const pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersDatasetJs.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale, fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { chart, index, line, scale, axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above = color, below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, _helpersDatasetJs.ah)(chart, meta);
    if (target && line.points.length) {
        (0, _helpersDatasetJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis,
            clip
        });
        (0, _helpersDatasetJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line, target, above, below, area, scale, clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            clipVertical(ctx, target, area.top);
            fill(ctx, {
                line,
                target,
                color: above,
                scale,
                property,
                clip
            });
            ctx.restore();
            ctx.save();
            clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            clipHorizontal(ctx, target, area.left);
            fill(ctx, {
                line,
                target,
                color: below,
                scale,
                property,
                clip
            });
            ctx.restore();
            ctx.save();
            clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    fill(ctx, {
        line,
        target,
        color: fillColor,
        scale,
        property,
        clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function clipHorizontal(ctx, target, clipX) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line, target, property, color, scale, clip } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src, target: tgt, start, end } of segments){
        const { style: { backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property, start, end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, _helpersDatasetJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options, ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx, maxWidth, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx, maxHeight, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
        const rtlHelper = (0, _helpersDatasetJs.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, _helpersDatasetJs.Y)(ctx, this);
            this._draw();
            (0, _helpersDatasetJs.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes, lineWidths, ctx } = this;
        const { align, labels: labelOpts } = opts;
        const defaultColor = (0, _helpersDatasetJs.d).color;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, _helpersDatasetJs.a0)(labelOpts.font);
        const { padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, _helpersDatasetJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersDatasetJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersDatasetJs.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, _helpersDatasetJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersDatasetJs.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersDatasetJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersDatasetJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, _helpersDatasetJs.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, _helpersDatasetJs.ay)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersDatasetJs.aw)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, _helpersDatasetJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersDatasetJs.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersDatasetJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersDatasetJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersDatasetJs.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersDatasetJs.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, _helpersDatasetJs.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersDatasetJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersDatasetJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, _helpersDatasetJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersDatasetJs.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersDatasetJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, _helpersDatasetJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersDatasetJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, _helpersDatasetJs.ak)(x, this.left, this.right) && (0, _helpersDatasetJs.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersDatasetJs.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersDatasetJs.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersDatasetJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersDatasetJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersDatasetJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle, pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, _helpersDatasetJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class Title extends Element {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, _helpersDatasetJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersDatasetJs.E)(opts.padding);
        const textSize = lineCount * (0, _helpersDatasetJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top, left, bottom, right, options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersDatasetJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, _helpersDatasetJs.a2)(align, bottom, top);
                rotation = (0, _helpersDatasetJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersDatasetJs.a2)(align, top, bottom);
                rotation = (0, _helpersDatasetJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, _helpersDatasetJs.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
        (0, _helpersDatasetJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersDatasetJs.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, _helpersDatasetJs.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersDatasetJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    const { element, datasetIndex, index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label, value } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body, footer, title } = tooltip;
    const { boxWidth, boxHeight } = options;
    const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
    const titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
    const footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersDatasetJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersDatasetJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersDatasetJs.F)(body, (bodyItem)=>{
        (0, _helpersDatasetJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersDatasetJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersDatasetJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y, height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x, width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    const { x, width } = size;
    const { width: chartWidth, chartArea: { left, right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x, width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y, height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize, caretPadding, cornerRadius } = options;
    const { xAlign, yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ay)(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersDatasetJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersDatasetJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = (0, _helpersDatasetJs.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersDatasetJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: (0, _helpersDatasetJs.aG),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, _helpersDatasetJs.aG),
    beforeBody: (0, _helpersDatasetJs.aG),
    beforeLabel: (0, _helpersDatasetJs.aG),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, _helpersDatasetJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersDatasetJs.aG),
    afterBody: (0, _helpersDatasetJs.aG),
    beforeFooter: (0, _helpersDatasetJs.aG),
    footer: (0, _helpersDatasetJs.aG),
    afterFooter: (0, _helpersDatasetJs.aG)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks } = options;
        const bodyItems = [];
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersDatasetJs.F)(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign, yAlign } = this;
        const { caretSize, cornerRadius } = options;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ay)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width, height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, _helpersDatasetJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight, boxWidth } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersDatasetJs.av)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersDatasetJs.av)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersDatasetJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, _helpersDatasetJs.ay)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersDatasetJs.aw)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersDatasetJs.aw)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body } = this;
        const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
        const bodyFont = (0, _helpersDatasetJs.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersDatasetJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersDatasetJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersDatasetJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersDatasetJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, _helpersDatasetJs.aA)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, _helpersDatasetJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign, yAlign } = this;
        const { x, y } = pt;
        const { width, height } = tooltipSize;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersDatasetJs.ay)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, _helpersDatasetJs.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersDatasetJs.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersDatasetJs.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersDatasetJs.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, _helpersDatasetJs.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX, caretY, options } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : (0, _helpersDatasetJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index, label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersDatasetJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, _helpersDatasetJs.k)(min);
    const maxDefined = !(0, _helpersDatasetJs.k)(max);
    const countDefined = !(0, _helpersDatasetJs.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, _helpersDatasetJs.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersDatasetJs.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersDatasetJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersDatasetJs.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersDatasetJs.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, _helpersDatasetJs.aL)(spacing), (0, _helpersDatasetJs.aL)(niceMin));
    factor = Math.pow(10, (0, _helpersDatasetJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersDatasetJs.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersDatasetJs.aK)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
    const rad = (0, _helpersDatasetJs.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, _helpersDatasetJs.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero } = this.options;
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, _helpersDatasetJs.s)(min);
            const maxSign = (0, _helpersDatasetJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit, stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class LinearScale extends LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, _helpersDatasetJs.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const log10Floor = (v)=>Math.floor((0, _helpersDatasetJs.aN)(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
    min = (0, _helpersDatasetJs.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, _helpersDatasetJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, _helpersDatasetJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, _helpersDatasetJs.aM).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersDatasetJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersDatasetJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersDatasetJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersDatasetJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, _helpersDatasetJs.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, _helpersDatasetJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, _helpersDatasetJs.aN)(start);
        this._valueRange = (0, _helpersDatasetJs.aN)(this.max) - (0, _helpersDatasetJs.aN)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersDatasetJs.aN)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, _helpersDatasetJs.E)(tickOpts.backdropPadding);
        return (0, _helpersDatasetJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersDatasetJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersDatasetJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersDatasetJs.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, _helpersDatasetJs.a0)(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, _helpersDatasetJs.al)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, _helpersDatasetJs.U)(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra, additionalAngle, padding, size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, _helpersDatasetJs.U)((0, _helpersDatasetJs.al)(pointLabelPosition.angle + (0, _helpersDatasetJs.H))));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    const { left, top, right, bottom } = item;
    const apexesInArea = (0, _helpersDatasetJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersDatasetJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels, display } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersDatasetJs.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left, top, right, bottom } = item;
    const { backdropColor } = opts;
    if (!(0, _helpersDatasetJs.k)(backdropColor)) {
        const borderRadius = (0, _helpersDatasetJs.ay)(opts.borderRadius);
        const padding = (0, _helpersDatasetJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersDatasetJs.aw)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx, options: { pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
        const { x, y, textAlign } = item;
        (0, _helpersDatasetJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersDatasetJs.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color, lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersDatasetJs.j)(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, _helpersDatasetJs.aM).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, _helpersDatasetJs.E)(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(false);
        this.min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, _helpersDatasetJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, _helpersDatasetJs.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, _helpersDatasetJs.al)(index * angleMultiplier + (0, _helpersDatasetJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersDatasetJs.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersDatasetJs.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, _helpersDatasetJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left, top, right, bottom } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        const { backgroundColor, grid: { circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines, grid, border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color, lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, _helpersDatasetJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, _helpersDatasetJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersDatasetJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersDatasetJs.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser, round, isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, _helpersDatasetJs.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, _helpersDatasetJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo, hi } = (0, _helpersDatasetJs.aQ)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersDatasetJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersDatasetJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersDatasetJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, _helpersDatasetJs.aP)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersDatasetJs.S)(start, 0, limit);
        end = (0, _helpersDatasetJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, _helpersDatasetJs.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, _helpersDatasetJs.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, _helpersDatasetJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, _helpersDatasetJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersDatasetJs._)(values.sort(sorter));
    }
}
function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo, hi } = (0, _helpersDatasetJs.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
    static defaults = TimeScale.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min, max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
const registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"./chunks/helpers.dataset.js":"gYj78","@kurkle/color":"6wTUz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYj78":[function(require,module,exports,__globalThis) {
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>getStyle);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>getRtlAdapter);
parcelHelpers.export(exports, "aB", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aC", ()=>_textX);
parcelHelpers.export(exports, "aD", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aE", ()=>drawPointLegend);
parcelHelpers.export(exports, "aF", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aG", ()=>noop);
parcelHelpers.export(exports, "aH", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aI", ()=>niceNum);
parcelHelpers.export(exports, "aJ", ()=>almostWhole);
parcelHelpers.export(exports, "aK", ()=>almostEquals);
parcelHelpers.export(exports, "aL", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aM", ()=>Ticks);
parcelHelpers.export(exports, "aN", ()=>log10);
parcelHelpers.export(exports, "aO", ()=>_longestText);
parcelHelpers.export(exports, "aP", ()=>_filterBetween);
parcelHelpers.export(exports, "aQ", ()=>_lookup);
parcelHelpers.export(exports, "aR", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aS", ()=>getHoverColor);
parcelHelpers.export(exports, "aT", ()=>clone);
parcelHelpers.export(exports, "aU", ()=>_merger);
parcelHelpers.export(exports, "aV", ()=>_mergerIf);
parcelHelpers.export(exports, "aW", ()=>_deprecated);
parcelHelpers.export(exports, "aX", ()=>_splitKey);
parcelHelpers.export(exports, "aY", ()=>toFontString);
parcelHelpers.export(exports, "aZ", ()=>splineCurve);
parcelHelpers.export(exports, "a_", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>getDatasetClipArea);
parcelHelpers.export(exports, "ai", ()=>_elementsEqual);
parcelHelpers.export(exports, "aj", ()=>_isClickEvent);
parcelHelpers.export(exports, "ak", ()=>_isBetween);
parcelHelpers.export(exports, "al", ()=>_normalizeAngle);
parcelHelpers.export(exports, "am", ()=>_readValueToProps);
parcelHelpers.export(exports, "an", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "ao", ()=>_computeSegments);
parcelHelpers.export(exports, "ap", ()=>_boundSegments);
parcelHelpers.export(exports, "aq", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "ar", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "as", ()=>_pointInLine);
parcelHelpers.export(exports, "at", ()=>_steppedLineTo);
parcelHelpers.export(exports, "au", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "av", ()=>drawPoint);
parcelHelpers.export(exports, "aw", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "ax", ()=>toTRBL);
parcelHelpers.export(exports, "ay", ()=>toTRBLCorners);
parcelHelpers.export(exports, "az", ()=>_boundSegment);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>fontString);
parcelHelpers.export(exports, "b1", ()=>toLineHeight);
parcelHelpers.export(exports, "b2", ()=>PITAU);
parcelHelpers.export(exports, "b3", ()=>INFINITY);
parcelHelpers.export(exports, "b4", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b5", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b6", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b7", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function isNumber(n) {
    return !isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale, vScale, _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = _limitValue(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = _limitValue(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale, yScale, _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
const formatters = {
    values (value) {
        return isArray(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ''), scope);
}
class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x, y, w, h, radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min, max } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = _resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy, _context, _subProxy, _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale } = meta;
    const { key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX, offsetY } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) return event;
    const { canvas, currentDevicePixelRatio } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x, y, box } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width, height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width, height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = round1(chart.height * pixelRatio);
    const deviceWidth = round1(chart.width * pixelRatio);
    chart.height = round1(chart.height);
    chart.width = round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === 'angle') return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start, end, count, loop, style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property, start: startBound, end: endBound } = bounds;
    const { between, normalize } = propertyFn(property);
    const count = points.length;
    let { start, end, loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare, between, normalize } = propertyFn(property);
    const { start, end, loop, style } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale, yScale } = meta;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, 'left'),
        right: getSizeForArea(xScale, chartArea, 'right'),
        top: getSizeForArea(yScale, chartArea, 'top'),
        bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function getDatasetClipArea(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

},{"@kurkle/color":"6wTUz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wTUz":[function(require,module,exports,__globalThis) {
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
const lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
const map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const hex = [
    ...'0123456789ABCDEF'
];
const h1 = (b)=>hex[b & 0xF];
const h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
const alpha = (a, f)=>a < 255 ? f(a) : '';
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    const rgb = hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    const m = HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    const h = hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    const a = rgb2hsl(v);
    const h = a[0];
    const s = n2p(a[1]);
    const l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function unpack() {
    const unpacked = {};
    const keys = Object.keys(names$1);
    const tkeys = Object.keys(map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    const m = RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    const r = from(b2n(rgb1.r));
    const g = from(b2n(rgb1.g));
    const b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        let tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === 'r') return rgbParse(str);
    return hueParse(str);
}
class Color {
    constructor(input){
        if (input instanceof Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = fromObject(input);
        else if (type === 'string') v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hJp7n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "dashboard-metrics"
};
const _hoisted_2 = {
    class: "row mb-3"
};
const _hoisted_3 = {
    class: "col-12"
};
const _hoisted_4 = {
    class: "btn-group",
    role: "group"
};
const _hoisted_5 = [
    "onClick"
];
const _hoisted_6 = [
    "disabled"
];
const _hoisted_7 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_8 = {
    key: 1,
    class: "alert alert-danger"
};
const _hoisted_9 = {
    key: 2
};
const _hoisted_10 = {
    class: "row mb-4"
};
const _hoisted_11 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_12 = {
    class: "card stats-card"
};
const _hoisted_13 = {
    class: "card-body"
};
const _hoisted_14 = {
    class: "d-flex justify-content-between align-items-center"
};
const _hoisted_15 = {
    class: "mb-0"
};
const _hoisted_16 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_17 = {
    class: "card stats-card"
};
const _hoisted_18 = {
    class: "card-body"
};
const _hoisted_19 = {
    class: "d-flex justify-content-between align-items-center"
};
const _hoisted_20 = {
    class: "mb-0"
};
const _hoisted_21 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_22 = {
    class: "card stats-card"
};
const _hoisted_23 = {
    class: "card-body"
};
const _hoisted_24 = {
    class: "d-flex justify-content-between align-items-center"
};
const _hoisted_25 = {
    class: "mb-0"
};
const _hoisted_26 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_27 = {
    class: "card stats-card"
};
const _hoisted_28 = {
    class: "card-body"
};
const _hoisted_29 = {
    class: "d-flex justify-content-between align-items-center"
};
const _hoisted_30 = {
    class: "mb-0"
};
const _hoisted_31 = {
    class: "row mb-4"
};
const _hoisted_32 = {
    class: "col-lg-8 mb-3"
};
const _hoisted_33 = {
    class: "card"
};
const _hoisted_34 = {
    class: "card-body"
};
const _hoisted_35 = {
    ref: "revenueChart"
};
const _hoisted_36 = {
    class: "col-lg-4 mb-3"
};
const _hoisted_37 = {
    class: "card"
};
const _hoisted_38 = {
    class: "card-body"
};
const _hoisted_39 = {
    ref: "statusChart"
};
const _hoisted_40 = {
    class: "row mb-4"
};
const _hoisted_41 = {
    class: "col-lg-6 mb-3"
};
const _hoisted_42 = {
    class: "card"
};
const _hoisted_43 = {
    class: "card-body"
};
const _hoisted_44 = {
    class: "row"
};
const _hoisted_45 = {
    class: "col-6 mb-3"
};
const _hoisted_46 = {
    class: "metric-item"
};
const _hoisted_47 = {
    class: "metric-value"
};
const _hoisted_48 = {
    class: "col-6 mb-3"
};
const _hoisted_49 = {
    class: "metric-item"
};
const _hoisted_50 = {
    class: "metric-value"
};
const _hoisted_51 = {
    class: "col-6 mb-3"
};
const _hoisted_52 = {
    class: "metric-item"
};
const _hoisted_53 = {
    class: "metric-value text-warning"
};
const _hoisted_54 = {
    class: "col-6 mb-3"
};
const _hoisted_55 = {
    class: "metric-item"
};
const _hoisted_56 = {
    class: "metric-value"
};
const _hoisted_57 = {
    class: "col-lg-6 mb-3"
};
const _hoisted_58 = {
    class: "card"
};
const _hoisted_59 = {
    class: "card-body"
};
const _hoisted_60 = {
    class: "row"
};
const _hoisted_61 = {
    class: "col-6 mb-3"
};
const _hoisted_62 = {
    class: "metric-item"
};
const _hoisted_63 = {
    class: "metric-value"
};
const _hoisted_64 = {
    class: "col-6 mb-3"
};
const _hoisted_65 = {
    class: "metric-item"
};
const _hoisted_66 = {
    class: "metric-value"
};
const _hoisted_67 = {
    class: "col-12"
};
const _hoisted_68 = {
    class: "cancellation-stats"
};
const _hoisted_69 = {
    class: "d-flex justify-content-between mb-1"
};
const _hoisted_70 = {
    class: "d-flex justify-content-between mb-1"
};
const _hoisted_71 = {
    class: "d-flex justify-content-between"
};
const _hoisted_72 = {
    key: 0,
    class: "row"
};
const _hoisted_73 = {
    class: "col-12"
};
const _hoisted_74 = {
    class: "card"
};
const _hoisted_75 = {
    class: "card-body"
};
const _hoisted_76 = {
    ref: "peakHoursChart"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, " Overview ")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.timeframes, (tf)=>{
                        return (0, _vue.createElementVNode)("button", {
                            key: tf.value,
                            type: "button",
                            class: (0, _vue.normalizeClass)([
                                'btn',
                                $setup.timeframe === tf.value ? 'btn-primary' : 'btn-outline-primary'
                            ]),
                            onClick: ($event)=>$setup.selectTimeframe(tf.value)
                        }, (0, _vue.toDisplayString)(tf.label), 11, _hoisted_5);
                    }), 64))
                ]),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary ms-2",
                    onClick: $setup.refreshMetrics,
                    disabled: $setup.loading
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: (0, _vue.normalizeClass)([
                            "fa-solid fa-refresh",
                            {
                                'fa-spin': $setup.loading
                            }
                        ])
                    }, null, 2),
                    _cache[0] || (_cache[0] = (0, _vue.createTextVNode)(" Refresh "))
                ], 8, _hoisted_6)
            ])
        ]),
        $setup.loading && !$setup.metrics ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, _cache[1] || (_cache[1] = [
            (0, _vue.createElementVNode)("div", {
                class: "spinner-border text-primary",
                role: "status"
            }, [
                (0, _vue.createElementVNode)("span", {
                    class: "visually-hidden"
                }, "Loading...")
            ], -1)
        ]))) : $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, (0, _vue.toDisplayString)($setup.error), 1)) : $setup.metrics ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                (0, _vue.createElementVNode)("div", _hoisted_11, [
                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                            (0, _vue.createElementVNode)("div", _hoisted_14, [
                                (0, _vue.createElementVNode)("div", null, [
                                    _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("p", {
                                        class: "text-muted mb-1"
                                    }, "Total Rides", -1)),
                                    (0, _vue.createElementVNode)("h3", _hoisted_15, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.core.totalRides)), 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)($setup.getChangeClass($setup.metrics.core.totalRidesChange))
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: (0, _vue.normalizeClass)($setup.getChangeIcon($setup.metrics.core.totalRidesChange))
                                        }, null, 2),
                                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.formatPercentage($setup.metrics.core.totalRidesChange)) + "% ", 1)
                                    ], 2)
                                ]),
                                _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("div", {
                                    class: "stats-icon bg-primary"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-car"
                                    })
                                ], -1))
                            ])
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_16, [
                    (0, _vue.createElementVNode)("div", _hoisted_17, [
                        (0, _vue.createElementVNode)("div", _hoisted_18, [
                            (0, _vue.createElementVNode)("div", _hoisted_19, [
                                (0, _vue.createElementVNode)("div", null, [
                                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("p", {
                                        class: "text-muted mb-1"
                                    }, "Total Revenue", -1)),
                                    (0, _vue.createElementVNode)("h3", _hoisted_20, (0, _vue.toDisplayString)($setup.formatCurrency($setup.metrics.core.totalRevenue)), 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)($setup.getChangeClass($setup.metrics.core.totalRevenueChange))
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: (0, _vue.normalizeClass)($setup.getChangeIcon($setup.metrics.core.totalRevenueChange))
                                        }, null, 2),
                                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.formatPercentage($setup.metrics.core.totalRevenueChange)) + "% ", 1)
                                    ], 2)
                                ]),
                                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                                    class: "stats-icon bg-success"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-dollar-sign"
                                    })
                                ], -1))
                            ])
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_21, [
                    (0, _vue.createElementVNode)("div", _hoisted_22, [
                        (0, _vue.createElementVNode)("div", _hoisted_23, [
                            (0, _vue.createElementVNode)("div", _hoisted_24, [
                                (0, _vue.createElementVNode)("div", null, [
                                    _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("p", {
                                        class: "text-muted mb-1"
                                    }, "Active Rides", -1)),
                                    (0, _vue.createElementVNode)("h3", _hoisted_25, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.core.activeRides)), 1),
                                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("span", {
                                        class: "text-info"
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa-solid fa-circle-dot"
                                        }),
                                        (0, _vue.createTextVNode)(" Live ")
                                    ], -1))
                                ]),
                                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("div", {
                                    class: "stats-icon bg-info"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-road"
                                    })
                                ], -1))
                            ])
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_26, [
                    (0, _vue.createElementVNode)("div", _hoisted_27, [
                        (0, _vue.createElementVNode)("div", _hoisted_28, [
                            (0, _vue.createElementVNode)("div", _hoisted_29, [
                                (0, _vue.createElementVNode)("div", null, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("p", {
                                        class: "text-muted mb-1"
                                    }, "Completion Rate", -1)),
                                    (0, _vue.createElementVNode)("h3", _hoisted_30, (0, _vue.toDisplayString)($setup.formatPercentage($setup.metrics.core.completionRate)) + "%", 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)($setup.getChangeClass($setup.metrics.core.completionRateChange))
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: (0, _vue.normalizeClass)($setup.getChangeIcon($setup.metrics.core.completionRateChange))
                                        }, null, 2),
                                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.formatPercentage($setup.metrics.core.completionRateChange)) + "% ", 1)
                                    ], 2)
                                ]),
                                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("div", {
                                    class: "stats-icon bg-warning"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-check-circle"
                                    })
                                ], -1))
                            ])
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_31, [
                (0, _vue.createElementVNode)("div", _hoisted_32, [
                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                        _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                            class: "card-header"
                        }, [
                            (0, _vue.createElementVNode)("h5", null, "Revenue Trend")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_34, [
                            (0, _vue.createElementVNode)("canvas", _hoisted_35, null, 512)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_36, [
                    (0, _vue.createElementVNode)("div", _hoisted_37, [
                        _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("div", {
                            class: "card-header"
                        }, [
                            (0, _vue.createElementVNode)("h5", null, "Ride Status")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_38, [
                            (0, _vue.createElementVNode)("canvas", _hoisted_39, null, 512)
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_40, [
                (0, _vue.createElementVNode)("div", _hoisted_41, [
                    (0, _vue.createElementVNode)("div", _hoisted_42, [
                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                            class: "card-header"
                        }, [
                            (0, _vue.createElementVNode)("h5", null, "Driver Metrics")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_43, [
                            (0, _vue.createElementVNode)("div", _hoisted_44, [
                                (0, _vue.createElementVNode)("div", _hoisted_45, [
                                    (0, _vue.createElementVNode)("div", _hoisted_46, [
                                        (0, _vue.createElementVNode)("div", _hoisted_47, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.driver.activeDrivers)), 1),
                                        _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Active Drivers", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_48, [
                                    (0, _vue.createElementVNode)("div", _hoisted_49, [
                                        (0, _vue.createElementVNode)("div", _hoisted_50, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.driver.totalDrivers)), 1),
                                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Total Drivers", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_51, [
                                    (0, _vue.createElementVNode)("div", _hoisted_52, [
                                        (0, _vue.createElementVNode)("div", _hoisted_53, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.driver.driversNeedingVerification)), 1),
                                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Pending Verification", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_54, [
                                    (0, _vue.createElementVNode)("div", _hoisted_55, [
                                        (0, _vue.createElementVNode)("div", _hoisted_56, (0, _vue.toDisplayString)($setup.formatPercentage($setup.metrics.driver.utilizationRate)) + "%", 1),
                                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Utilization Rate", -1))
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_57, [
                    (0, _vue.createElementVNode)("div", _hoisted_58, [
                        _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("div", {
                            class: "card-header"
                        }, [
                            (0, _vue.createElementVNode)("h5", null, "Operational Metrics")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_59, [
                            (0, _vue.createElementVNode)("div", _hoisted_60, [
                                (0, _vue.createElementVNode)("div", _hoisted_61, [
                                    (0, _vue.createElementVNode)("div", _hoisted_62, [
                                        (0, _vue.createElementVNode)("div", _hoisted_63, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.operations.cancellations.totalCancelled)), 1),
                                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Total Cancellations", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_64, [
                                    (0, _vue.createElementVNode)("div", _hoisted_65, [
                                        (0, _vue.createElementVNode)("div", _hoisted_66, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.operations.averageWaitTimeMinutes)) + " min", 1),
                                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                            class: "metric-label"
                                        }, "Avg Wait Time", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_67, [
                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("h6", {
                                        class: "mb-2"
                                    }, "Cancellation Breakdown", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_68, [
                                        (0, _vue.createElementVNode)("div", _hoisted_69, [
                                            _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("span", null, "By Rider:", -1)),
                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.operations.cancellations.cancelledByRider)), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_70, [
                                            _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("span", null, "By Driver:", -1)),
                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.operations.cancellations.cancelledByDriver)), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_71, [
                                            _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("span", null, "By Dispatch:", -1)),
                                            (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatNumber($setup.metrics.operations.cancellations.cancelledByDispatch)), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            $setup.metrics.operations.peakHours && $setup.metrics.operations.peakHours.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_72, [
                (0, _vue.createElementVNode)("div", _hoisted_73, [
                    (0, _vue.createElementVNode)("div", _hoisted_74, [
                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                            class: "card-header"
                        }, [
                            (0, _vue.createElementVNode)("h5", null, "Peak Hours Activity")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_75, [
                            (0, _vue.createElementVNode)("canvas", _hoisted_76, null, 512)
                        ])
                    ])
                ])
            ])) : (0, _vue.createCommentVNode)("", true)
        ])) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"isZjH":[function() {},{}],"QqtJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hs2HS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f23d0efb62a831f8");
    if (script.__esModule) script = script.default;
    script.render = require("89e1f3656be34120").render;
    require("96724107dcb0708f").default(script);
    script.__scopeId = 'data-v-832781';
    script.__file = "AccountsList.vue";
};
initialize();
exports.default = script;

},{"f23d0efb62a831f8":"lfWmW","89e1f3656be34120":"lnvJf","96724107dcb0708f":"gOioF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfWmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'AccountsList',
    props: {
        serviceProviderId: {
            type: String,
            default: (0, _globalsJs.newEntityId)
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const allAccountsTable = (0, _vue.ref)(null);
        const activeAccountsTable = (0, _vue.ref)(null);
        const inactiveAccountsTable = (0, _vue.ref)(null);
        const closedAccountsTable = (0, _vue.ref)(null);
        const allAccountsUrl = `/api/datatable/sp-accounts/${props.serviceProviderId}`;
        const activeAccountsUrl = `${allAccountsUrl}?status=ACTIVE`;
        const inactiveAccountsUrl = `${allAccountsUrl}?status=INACTIVE`;
        const closedAccountsUrl = `${allAccountsUrl}?status=CLOSED`;
        const columnDefinition = [
            {
                title: "Account ID",
                data: "accountCode",
                render: (data, type, row)=>{
                    return `<a href="/service-provider/${props.serviceProviderId}/account/${row.id}" class="text-primary fw-bold">${data}</a>`;
                }
            },
            {
                title: "Company Name",
                data: "companyName",
                render: (0, _datatablesNetBs5Default.default).render.ellipsis(40, true)
            },
            {
                title: "Billing Cycle",
                data: "billingCycle",
                render: (data)=>{
                    const cycles = {
                        'PER_TRIP': 'Per Trip',
                        'WEEKLY': 'Weekly',
                        'BIWEEKLY': 'Bi-Weekly',
                        'MONTHLY': 'Monthly',
                        'QUARTERLY': 'Quarterly'
                    };
                    return cycles[data] || data;
                }
            },
            {
                title: "Current Balance",
                data: "currentBalance",
                render: (data)=>(0, _datatableRenderer.currency)(data || 0)
            },
            {
                title: "Credit Limit",
                data: "creditLimit",
                render: (data)=>data > 0 ? (0, _datatableRenderer.currency)(data) : '<span class="text-muted">Unlimited</span>'
            },
            {
                title: "Status",
                data: "status",
                render: (0, _datatableRenderer.accountStatus)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `
        <div class="btn-group">
          <a class="btn btn-sm btn-outline-primary" href="/service-provider/${props.serviceProviderId}/account/${row.id}">
            <i class="iconly-Info-Circle icbr"></i> View
          </a>
        </div>
      `;
                }
            }
        ];
        const __returned__ = {
            props,
            allAccountsTable,
            activeAccountsTable,
            inactiveAccountsTable,
            closedAccountsTable,
            allAccountsUrl,
            activeAccountsUrl,
            inactiveAccountsUrl,
            closedAccountsUrl,
            columnDefinition,
            ref: (0, _vue.ref),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get accountStatus () {
                return 0, _datatableRenderer.accountStatus;
            },
            get currency () {
                return 0, _datatableRenderer.currency;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lnvJf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "page-title"
};
const _hoisted_2 = {
    class: "row"
};
const _hoisted_3 = {
    class: "col-sm-6 col-12 text-end"
};
const _hoisted_4 = [
    "href"
];
const _hoisted_5 = {
    class: "card"
};
const _hoisted_6 = {
    class: "card-body"
};
const _hoisted_7 = {
    class: "tab-content",
    id: "accounts-tabContent"
};
const _hoisted_8 = {
    class: "tab-pane fade",
    id: "all-accounts",
    role: "tabpanel"
};
const _hoisted_9 = {
    class: "tab-pane fade show active",
    id: "active-accounts",
    role: "tabpanel"
};
const _hoisted_10 = {
    class: "tab-pane fade",
    id: "inactive-accounts",
    role: "tabpanel"
};
const _hoisted_11 = {
    class: "tab-pane fade",
    id: "closed-accounts",
    role: "tabpanel"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "Accounts")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_3, [
                    (0, _vue.createElementVNode)("a", {
                        href: `/service-provider/${$setup.props.serviceProviderId}/account/new`,
                        class: "btn btn-primary"
                    }, _cache[0] || (_cache[0] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-plus"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Create Account ")
                    ]), 8, _hoisted_4)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_5, [
            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", {
                class: "card-header card-no-border pb-0"
            }, [
                (0, _vue.createElementVNode)("ul", {
                    class: "nav nav-tabs",
                    id: "accounts-tab",
                    role: "tablist"
                }, [
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "all-accounts-tab",
                            "data-bs-toggle": "tab",
                            href: "#all-accounts",
                            role: "tab",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-building text-primary"
                            }),
                            (0, _vue.createTextVNode)(" All Accounts ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link active",
                            id: "active-accounts-tab",
                            "data-bs-toggle": "tab",
                            href: "#active-accounts",
                            role: "tab",
                            "aria-selected": "true"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-check-circle text-success"
                            }),
                            (0, _vue.createTextVNode)(" Active ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "inactive-accounts-tab",
                            "data-bs-toggle": "tab",
                            href: "#inactive-accounts",
                            role: "tab",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-pause-circle text-warning"
                            }),
                            (0, _vue.createTextVNode)(" Inactive ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "closed-accounts-tab",
                            "data-bs-toggle": "tab",
                            href: "#closed-accounts",
                            role: "tab",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-ban text-danger"
                            }),
                            (0, _vue.createTextVNode)(" Closed ")
                        ])
                    ])
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_6, [
                (0, _vue.createElementVNode)("div", _hoisted_7, [
                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.allAccountsUrl
                            },
                            ref: "allAccountsTable",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_9, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.activeAccountsUrl
                            },
                            ref: "activeAccountsTable",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_10, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.inactiveAccountsUrl
                            },
                            ref: "inactiveAccountsTable",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_11, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.closedAccountsUrl
                            },
                            ref: "closedAccountsTable",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOioF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mi4U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("9c1a45a81dae1824");
    if (script.__esModule) script = script.default;
    script.render = require("d5a744027b6db1d4").render;
    script.__cssModules = require("96d91e01f885b152").default;
    require("9ced3a81490dd7bd").default(script);
    script.__scopeId = 'data-v-89dfab';
    script.__file = "AccountDetail.vue";
};
initialize();
exports.default = script;

},{"9c1a45a81dae1824":"d06G0","d5a744027b6db1d4":"fJMj2","96d91e01f885b152":"8eU75","9ced3a81490dd7bd":"6qJvO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d06G0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _jqueryUi = require("jquery-ui");
var _jqueryWizard = require("./../../extras/js/jquery-wizard");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _modelTemplates = require("../modelTemplates/modelTemplates");
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'AccountDetail',
    props: {
        accountId: {
            type: String,
            required: true
        },
        serviceProviderId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const account = (0, _vue.ref)(null);
        const editAccountInfo = (0, _vue.ref)(false);
        const ridesTable = (0, _vue.ref)(null);
        const invoicesTable = (0, _vue.ref)(null);
        const isSaving = (0, _vue.ref)(false);
        const isNewAccount = (0, _vue.ref)(props.accountId === (0, _globalsJs.newEntityId));
        let wizardInstance = null;
        // Initialize formData with Account model template
        const AccountModel = (0, _modelTemplates.Model)('Account');
        const accountModel = AccountModel();
        const formData = (0, _vue.reactive)(accountModel.state);
        const ridesUrl = (0, _vue.computed)(()=>`/api/datatable/account-rides/${props.serviceProviderId}/${props.accountId}`);
        const invoicesUrl = (0, _vue.computed)(()=>`/api/datatable/account-invoices/${props.serviceProviderId}/${props.accountId}`);
        (0, _vue.onMounted)(async ()=>{
            if (!isNewAccount.value) loadAccount();
            else editAccountInfo.value = true;
            await (0, _vue.nextTick)();
            if (editAccountInfo.value || isNewAccount.value) setupWizard();
        });
        (0, _vue.onUnmounted)(()=>{
            if (wizardInstance) try {
                $('#account-wizard').wizard('destroy');
            } catch (e) {
                console.warn('Failed to destroy wizard', e);
            }
        });
        const toggleEditMode = async ()=>{
            editAccountInfo.value = !editAccountInfo.value;
            if (editAccountInfo.value && !isNewAccount.value) // Load account data into form
            Object.assign(formData, account.value);
            await (0, _vue.nextTick)();
            if (editAccountInfo.value) setupWizard();
            else if (wizardInstance) try {
                $('#account-wizard').wizard('destroy');
                wizardInstance = null;
            } catch (e) {
                console.warn('Failed to destroy wizard', e);
            }
        };
        const cancelEdit = ()=>{
            if (wizardInstance) try {
                $('#account-wizard').wizard('destroy');
                wizardInstance = null;
            } catch (e) {
                console.warn('Failed to destroy wizard on cancel', e);
            }
            if (isNewAccount.value) window.location.href = `/service-provider/${props.serviceProviderId}/account`;
            else {
                // Reset form data
                Object.assign(formData, account.value);
                toggleEditMode();
            }
        };
        async function saveAccount() {
            if (isSaving.value) return false;
            isSaving.value = true;
            try {
                const url = isNewAccount.value ? `/api/service-providers/${props.serviceProviderId}/account` : `/api/service-providers/${props.serviceProviderId}/account/${props.accountId}`;
                const method = isNewAccount.value ? 'POST' : 'PUT';
                const response = await fetch(url, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });
                if (!response.ok) {
                    const errorText = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Save failed',
                        body: errorText || 'Could not save the account',
                        type: 'error',
                        delay: 8000
                    });
                    return false;
                }
                const savedAccount = await response.json();
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: `Account ${isNewAccount.value ? 'created' : 'updated'} successfully`,
                    type: 'success'
                });
                if (isNewAccount.value) // Redirect to the newly created account
                window.location.href = `/service-provider/${props.serviceProviderId}/account/${savedAccount.id}`;
                else {
                    // Reload account data and exit edit mode
                    await loadAccount();
                    if (wizardInstance) try {
                        $('#account-wizard').wizard('destroy');
                        wizardInstance = null;
                    } catch (e) {
                        console.warn('Failed to destroy wizard on save', e);
                    }
                    toggleEditMode();
                }
                return true;
            } catch (error) {
                console.error('Error saving account:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Network error',
                    body: 'Could not save the account. Please try again.',
                    type: 'error'
                });
                return false;
            } finally{
                isSaving.value = false;
            }
        }
        async function loadAccount() {
            try {
                const response = await fetch(`/api/service-providers/${props.serviceProviderId}/account/${props.accountId}`);
                if (response.ok) account.value = await response.json();
            } catch (error) {
                console.error('Error loading account:', error);
            }
        }
        async function changeStatus(newStatus) {
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Change Account Status',
                text: `Are you sure you want to change the account status to ${newStatus}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, change it',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#6c757d'
            });
            if (result.isConfirmed) try {
                const response = await fetch(`/api/account/${props.accountId}/status`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        status: newStatus
                    })
                });
                if (response.ok) {
                    await (0, _sweetalert2MinDefault.default).fire({
                        title: 'Success',
                        text: `Account status changed to ${newStatus}`,
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    loadAccount();
                } else (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Failed to change account status',
                    icon: 'error'
                });
            } catch (error) {
                console.error('Error changing status:', error);
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Network error occurred while changing status',
                    icon: 'error'
                });
            }
        }
        async function generateInvoice() {
            const result = await (0, _sweetalert2MinDefault.default).fire({
                title: 'Generate Invoice',
                text: 'Generate a new invoice for this account?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, generate',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#6c757d'
            });
            if (result.isConfirmed) try {
                const response = await fetch(`/api/invoice/generate/${props.accountId}`, {
                    method: 'POST'
                });
                if (response.ok) {
                    await (0, _sweetalert2MinDefault.default).fire({
                        title: 'Success',
                        text: 'Invoice generated successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    if (invoicesTable.value?.dt) invoicesTable.value.dt.ajax.reload();
                } else {
                    const errorText = await response.text();
                    (0, _sweetalert2MinDefault.default).fire({
                        title: 'Error',
                        text: errorText || 'Failed to generate invoice',
                        icon: 'error'
                    });
                }
            } catch (error) {
                console.error('Error generating invoice:', error);
                (0, _sweetalert2MinDefault.default).fire({
                    title: 'Error',
                    text: 'Network error occurred while generating invoice',
                    icon: 'error'
                });
            }
        }
        function formatCurrency(value) {
            return (0, _datatableRenderer.currency)(value);
        }
        function formatBillingCycle(cycle) {
            const cycles = {
                'PER_TRIP': 'Per Trip',
                'WEEKLY': 'Weekly',
                'BIWEEKLY': 'Bi-Weekly',
                'MONTHLY': 'Monthly',
                'QUARTERLY': 'Quarterly'
            };
            return cycles[cycle] || cycle;
        }
        function getStatusClass(status) {
            const classes = {
                'ACTIVE': 'badge bg-success',
                'INACTIVE': 'badge bg-warning',
                'CLOSED': 'badge bg-danger'
            };
            return classes[status] || 'badge bg-secondary';
        }
        const ridesColumns = [
            {
                data: "origin",
                title: "Pickup",
                render: (data, type, row)=>{
                    return row?.originLocationData?.address || 'N/A';
                }
            },
            {
                data: "destination",
                title: "Destination",
                render: (data, type, row)=>{
                    return row?.destinationLocationData?.address || 'N/A';
                }
            },
            {
                data: "rideStatus",
                title: "Status",
                render: (0, _datatableRenderer.rideStatus)
            },
            {
                data: "fare",
                title: "Fare",
                render: (data, type, row)=>{
                    // totalWithTax is what the rider paid; totalFare is the pre-tax commission base. Formatted,
                    // because the raw column serialises at whatever scale it was stored with.
                    if (!row?.rideFare) return 'N/A';
                    const charged = row.rideFare.totalWithTax ?? row.rideFare.totalFare;
                    return '$' + Number(charged || 0).toFixed(2);
                }
            },
            {
                data: "orderDateTime",
                title: "Date",
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: '',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return `<a class="btn btn-sm btn-outline-primary" target="blank" href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
                Details <i class="fa-solid fa-arrow-up-right-from-square"></i></a>`;
                }
            }
        ];
        const invoicesColumns = [
            {
                title: "Invoice #",
                data: "invoiceNumber"
            },
            {
                title: "Period",
                data: "periodStart",
                render: (data, type, row)=>`${data} - ${row.periodEnd}`
            },
            {
                title: "Amount",
                data: "totalAmount",
                render: (0, _datatableRenderer.currency)
            },
            {
                title: "Status",
                data: "status",
                render: (0, _datatableRenderer.invoiceStatus)
            },
            {
                title: "Due Date",
                data: "dueDate",
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                render: (data, type, row)=>`
      <button class="btn btn-sm btn-outline-primary view-invoice" data-id="${row.id}">
        <i class="fa fa-eye"></i> View
      </button>
    `
            }
        ];
        function companyStepIsValid() {
            return accountModel.validations.isCompanyNameValid.value && accountModel.validations.isBillingCycleValid.value;
        }
        function billingStepIsValid() {
            return true; // All fields optional
        }
        function contactStepIsValid() {
            return accountModel.validations.isBillingEmailValid.value && accountModel.validations.isContactEmailValid.value && accountModel.validations.isContactPhoneValid.value;
        }
        function setupWizard() {
            if (wizardInstance) try {
                $('#account-wizard').wizard('destroy');
            } catch (e) {
                console.warn('Failed to destroy existing wizard', e);
            }
            wizardInstance = $('#account-wizard').wizard({
                step: '.nav-pills > a',
                classes: {
                    step: {
                        active: 'active'
                    },
                    pane: {
                        active: 'active show'
                    },
                    button: {
                        hide: 'd-none',
                        disabled: 'd-none'
                    }
                },
                buttonsAppendTo: '#account-wizard-navigation',
                templates: {
                    buttons: function() {
                        return `<div class="pull-left">
                  <a role="button" class="btn btn-outline-secondary mb-3" href="#account-wizard" data-wizard="back">Back</a>
                </div>
                <div class="pull-right">
                  <a role="button" class="btn btn-outline-primary mb-3" href="#account-wizard" data-wizard="next">Next</a>
                  <a role="button" class="btn btn-outline-success mb-3" href="#account-wizard" data-wizard="finish">Save</a>
                </div>`;
                    }
                },
                validator: function(step) {
                    let valid = true;
                    if (step.index === 0) valid = companyStepIsValid();
                    else if (step.index === 1) valid = billingStepIsValid();
                    else if (step.index === 2) valid = contactStepIsValid();
                    if (!valid) (0, _toastNotificationUtility.showToast)({
                        title: 'Validation failed',
                        body: 'Please complete the required fields for this step.',
                        type: 'warn'
                    });
                    return valid;
                },
                onFinish: function() {
                    // Final validation before save
                    if (!companyStepIsValid() || !billingStepIsValid() || !contactStepIsValid()) {
                        (0, _toastNotificationUtility.showToast)({
                            title: 'Validation failed',
                            body: 'Please complete all required fields.',
                            type: 'warn'
                        });
                        return false;
                    }
                    saveAccount();
                    return false; // Prevent default wizard navigation
                },
                onCancel: function() {
                    cancelEdit();
                    return false;
                }
            });
        }
        const __returned__ = {
            props,
            account,
            editAccountInfo,
            ridesTable,
            invoicesTable,
            isSaving,
            isNewAccount,
            get wizardInstance () {
                return wizardInstance;
            },
            set wizardInstance (v){
                wizardInstance = v;
            },
            AccountModel,
            accountModel,
            formData,
            ridesUrl,
            invoicesUrl,
            toggleEditMode,
            cancelEdit,
            saveAccount,
            loadAccount,
            changeStatus,
            generateInvoice,
            formatCurrency,
            formatBillingCycle,
            getStatusClass,
            ridesColumns,
            invoicesColumns,
            companyStepIsValid,
            billingStepIsValid,
            contactStepIsValid,
            setupWizard,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            computed: (0, _vue.computed),
            nextTick: (0, _vue.nextTick),
            reactive: (0, _vue.reactive),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get invoiceStatus () {
                return 0, _datatableRenderer.invoiceStatus;
            },
            get currency () {
                return 0, _datatableRenderer.currency;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get rideStatus () {
                return 0, _datatableRenderer.rideStatus;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get Model () {
                return 0, _modelTemplates.Model;
            },
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","jquery-ui":"6clbD","./../../extras/js/jquery-wizard":"16izs","../utility/toastNotificationUtility":"krOtg","../modelTemplates/modelTemplates":"dN207","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fJMj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "page-title"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-sm-6 col-12"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1
};
const _hoisted_7 = {
    key: 2,
    class: "text-muted mb-0"
};
const _hoisted_8 = {
    key: 0,
    class: "col-sm-6 col-12 text-end"
};
const _hoisted_9 = {
    key: 1,
    class: "btn btn-danger me-2"
};
const _hoisted_10 = [
    "href"
];
const _hoisted_11 = {
    key: 1,
    class: "col-sm-6 col-12 text-end"
};
const _hoisted_12 = {
    class: "btn-group"
};
const _hoisted_13 = {
    class: "dropdown-menu"
};
const _hoisted_14 = {
    key: 0
};
const _hoisted_15 = {
    key: 1
};
const _hoisted_16 = {
    key: 2
};
const _hoisted_17 = {
    key: 0,
    class: "row"
};
const _hoisted_18 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_19 = {
    class: "card"
};
const _hoisted_20 = {
    class: "card-body"
};
const _hoisted_21 = {
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_22 = {
    class: "mb-0"
};
const _hoisted_23 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_24 = {
    class: "card"
};
const _hoisted_25 = {
    class: "card-body"
};
const _hoisted_26 = {
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_27 = {
    class: "mb-0"
};
const _hoisted_28 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_29 = {
    class: "card"
};
const _hoisted_30 = {
    class: "card-body"
};
const _hoisted_31 = {
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_32 = {
    class: "mb-0"
};
const _hoisted_33 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_34 = {
    class: "card"
};
const _hoisted_35 = {
    class: "card-body"
};
const _hoisted_36 = {
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_37 = {
    class: "mb-0"
};
const _hoisted_38 = {
    key: 1,
    class: "col-12"
};
const _hoisted_39 = {
    class: "card height-equal"
};
const _hoisted_40 = {
    class: "card-header"
};
const _hoisted_41 = {
    class: "mb-0 text-muted"
};
const _hoisted_42 = {
    id: "account-wizard"
};
const _hoisted_43 = {
    class: "card-body"
};
const _hoisted_44 = {
    class: "horizontal-wizard-wrapper"
};
const _hoisted_45 = {
    class: "row"
};
const _hoisted_46 = {
    class: "col-12 tab-content dark-field p-4"
};
const _hoisted_47 = {
    class: "tab-pane fade active show wizard-content",
    id: "account-step-company",
    role: "tabpanel"
};
const _hoisted_48 = {
    class: "mb-3"
};
const _hoisted_49 = {
    class: "mb-3"
};
const _hoisted_50 = {
    class: "mb-3"
};
const _hoisted_51 = {
    class: "tab-pane fade wizard-content",
    id: "account-step-billing",
    role: "tabpanel"
};
const _hoisted_52 = {
    class: "mb-3"
};
const _hoisted_53 = {
    class: "mb-3"
};
const _hoisted_54 = {
    class: "mb-3"
};
const _hoisted_55 = {
    class: "mb-3"
};
const _hoisted_56 = {
    class: "form-check form-switch"
};
const _hoisted_57 = {
    class: "mb-3"
};
const _hoisted_58 = {
    class: "form-check form-switch"
};
const _hoisted_59 = {
    class: "tab-pane fade wizard-content",
    id: "account-step-contact",
    role: "tabpanel"
};
const _hoisted_60 = {
    class: "mb-3"
};
const _hoisted_61 = {
    class: "mb-3"
};
const _hoisted_62 = {
    class: "row"
};
const _hoisted_63 = {
    class: "col-md-6 mb-3"
};
const _hoisted_64 = {
    class: "col-md-6 mb-3"
};
const _hoisted_65 = {
    class: "mb-3"
};
const _hoisted_66 = {
    key: 2,
    class: "col-12"
};
const _hoisted_67 = {
    class: "card"
};
const _hoisted_68 = {
    class: "card-body"
};
const _hoisted_69 = {
    class: "tab-content",
    id: "account-detail-tabContent"
};
const _hoisted_70 = {
    class: "tab-pane fade show active",
    id: "overview",
    role: "tabpanel"
};
const _hoisted_71 = {
    class: "row"
};
const _hoisted_72 = {
    class: "col-md-6"
};
const _hoisted_73 = {
    class: "table table-borderless"
};
const _hoisted_74 = {
    class: "col-md-6"
};
const _hoisted_75 = {
    class: "table table-borderless"
};
const _hoisted_76 = {
    class: "row mt-3"
};
const _hoisted_77 = {
    class: "col-md-6"
};
const _hoisted_78 = {
    class: "table table-borderless"
};
const _hoisted_79 = {
    class: "col-md-6"
};
const _hoisted_80 = {
    class: "table table-borderless"
};
const _hoisted_81 = {
    class: "tab-pane fade",
    id: "rides",
    role: "tabpanel"
};
const _hoisted_82 = {
    class: "tab-pane fade",
    id: "invoices",
    role: "tabpanel"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    $setup.isNewAccount ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_5, "Create New Account")) : $setup.account ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_6, (0, _vue.toDisplayString)($setup.account.companyName), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.account && $setup.account.accountCode ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_7, (0, _vue.toDisplayString)($setup.account.accountCode), 1)) : (0, _vue.createCommentVNode)("", true)
                ]),
                $setup.editAccountInfo ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                    !$setup.isNewAccount && $setup.account ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 0,
                        class: "btn btn-danger me-2",
                        onClick: $setup.toggleEditMode
                    }, _cache[16] || (_cache[16] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-ban"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Cancel ")
                    ]))) : (0, _vue.createCommentVNode)("", true),
                    $setup.isNewAccount ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", _hoisted_9, [
                        (0, _vue.createElementVNode)("a", {
                            href: `/service-provider/${$props.serviceProviderId}/accounts`,
                            class: "text-white"
                        }, _cache[17] || (_cache[17] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa fa-arrow-left"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Go Back ")
                        ]), 8, _hoisted_10)
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])) : (0, _vue.createCommentVNode)("", true),
                !$setup.isNewAccount && !$setup.editAccountInfo && $setup.account ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-outline-secondary me-2",
                        onClick: $setup.toggleEditMode
                    }, _cache[18] || (_cache[18] = [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-edit"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Edit ")
                    ])),
                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                        _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary dropdown-toggle",
                            type: "button",
                            "data-bs-toggle": "dropdown"
                        }, " Actions ", -1)),
                        (0, _vue.createElementVNode)("ul", _hoisted_13, [
                            $setup.account.status !== 'ACTIVE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_14, [
                                (0, _vue.createElementVNode)("a", {
                                    href: "#",
                                    role: "menuitem",
                                    class: "dropdown-item",
                                    onClick: _cache[0] || (_cache[0] = (0, _vue.withModifiers)(($event)=>$setup.changeStatus('ACTIVE'), [
                                        "prevent"
                                    ]))
                                }, _cache[19] || (_cache[19] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-check-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Activate")
                                ]))
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.account.status !== 'INACTIVE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_15, [
                                (0, _vue.createElementVNode)("a", {
                                    href: "#",
                                    role: "menuitem",
                                    class: "dropdown-item",
                                    onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(($event)=>$setup.changeStatus('INACTIVE'), [
                                        "prevent"
                                    ]))
                                }, _cache[20] || (_cache[20] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-pause-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Inactive")
                                ]))
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.account.status !== 'CLOSED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_16, [
                                (0, _vue.createElementVNode)("a", {
                                    href: "#",
                                    role: "menuitem",
                                    class: "dropdown-item",
                                    onClick: _cache[2] || (_cache[2] = (0, _vue.withModifiers)(($event)=>$setup.changeStatus('CLOSED'), [
                                        "prevent"
                                    ]))
                                }, _cache[21] || (_cache[21] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-times-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Close")
                                ]))
                            ])) : (0, _vue.createCommentVNode)("", true),
                            _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("li", null, [
                                (0, _vue.createElementVNode)("hr", {
                                    class: "dropdown-divider"
                                })
                            ], -1)),
                            (0, _vue.createElementVNode)("li", null, [
                                (0, _vue.createElementVNode)("a", {
                                    href: "#",
                                    role: "menuitem",
                                    class: "dropdown-item",
                                    onClick: (0, _vue.withModifiers)($setup.generateInvoice, [
                                        "prevent"
                                    ])
                                }, _cache[22] || (_cache[22] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-file-invoice"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Generate Invoice")
                                ]))
                            ])
                        ])
                    ])
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        !$setup.isNewAccount && !$setup.editAccountInfo && $setup.account ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_17, [
            (0, _vue.createElementVNode)("div", _hoisted_18, [
                (0, _vue.createElementVNode)("div", _hoisted_19, [
                    (0, _vue.createElementVNode)("div", _hoisted_20, [
                        (0, _vue.createElementVNode)("div", _hoisted_21, [
                            (0, _vue.createElementVNode)("div", null, [
                                _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-1"
                                }, "Current Balance", -1)),
                                (0, _vue.createElementVNode)("h4", _hoisted_22, (0, _vue.toDisplayString)($setup.formatCurrency($setup.account.currentBalance)), 1)
                            ]),
                            _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("div", {
                                class: "icon-box bg-primary"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-dollar-sign text-white"
                                })
                            ], -1))
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_23, [
                (0, _vue.createElementVNode)("div", _hoisted_24, [
                    (0, _vue.createElementVNode)("div", _hoisted_25, [
                        (0, _vue.createElementVNode)("div", _hoisted_26, [
                            (0, _vue.createElementVNode)("div", null, [
                                _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-1"
                                }, "Credit Limit", -1)),
                                (0, _vue.createElementVNode)("h4", _hoisted_27, (0, _vue.toDisplayString)($setup.account.creditLimit > 0 ? $setup.formatCurrency($setup.account.creditLimit) : 'Unlimited'), 1)
                            ]),
                            _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                                class: "icon-box bg-success"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-credit-card text-white"
                                })
                            ], -1))
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_28, [
                (0, _vue.createElementVNode)("div", _hoisted_29, [
                    (0, _vue.createElementVNode)("div", _hoisted_30, [
                        (0, _vue.createElementVNode)("div", _hoisted_31, [
                            (0, _vue.createElementVNode)("div", null, [
                                _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-1"
                                }, "Status", -1)),
                                (0, _vue.createElementVNode)("h4", _hoisted_32, [
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)($setup.getStatusClass($setup.account.status))
                                    }, (0, _vue.toDisplayString)($setup.account.status), 3)
                                ])
                            ]),
                            _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("div", {
                                class: "icon-box bg-info"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-info-circle text-white"
                                })
                            ], -1))
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_33, [
                (0, _vue.createElementVNode)("div", _hoisted_34, [
                    (0, _vue.createElementVNode)("div", _hoisted_35, [
                        (0, _vue.createElementVNode)("div", _hoisted_36, [
                            (0, _vue.createElementVNode)("div", null, [
                                _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-1"
                                }, "Billing Cycle", -1)),
                                (0, _vue.createElementVNode)("h4", _hoisted_37, (0, _vue.toDisplayString)($setup.formatBillingCycle($setup.account.billingCycle)), 1)
                            ]),
                            _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("div", {
                                class: "icon-box bg-warning"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-calendar text-white"
                                })
                            ], -1))
                        ])
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        $setup.editAccountInfo || $setup.isNewAccount ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_38, [
            (0, _vue.createElementVNode)("div", _hoisted_39, [
                (0, _vue.createElementVNode)("div", _hoisted_40, [
                    (0, _vue.createElementVNode)("h3", null, (0, _vue.toDisplayString)($setup.isNewAccount ? 'New' : 'Edit') + " Account Information", 1),
                    (0, _vue.createElementVNode)("p", _hoisted_41, "Complete the steps to " + (0, _vue.toDisplayString)($setup.isNewAccount ? 'create' : 'update') + " the account.", 1)
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_42, [
                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                        (0, _vue.createElementVNode)("div", _hoisted_44, [
                            (0, _vue.createElementVNode)("div", _hoisted_45, [
                                _cache[56] || (_cache[56] = (0, _vue.createElementVNode)("div", {
                                    class: "col-12 main-horizontal-header mb-3 border-1"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "nav nav-pills horizontal-options",
                                        role: "tablist",
                                        "aria-orientation": "horizontal"
                                    }, [
                                        (0, _vue.createElementVNode)("a", {
                                            class: "nav-link",
                                            "data-bs-toggle": "pill",
                                            href: "#account-step-company",
                                            role: "tab",
                                            "aria-selected": "true"
                                        }, [
                                            (0, _vue.createElementVNode)("div", {
                                                class: "horizontal-wizard"
                                            }, [
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "stroke-icon-wizard"
                                                }, [
                                                    (0, _vue.createElementVNode)("i", {
                                                        class: "fa fa-building"
                                                    })
                                                ]),
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "horizontal-wizard-content"
                                                }, [
                                                    (0, _vue.createElementVNode)("h5", {
                                                        class: "f-w-600"
                                                    }, "Company Details")
                                                ])
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("a", {
                                            class: "nav-link",
                                            "data-bs-toggle": "pill",
                                            href: "#account-step-billing",
                                            role: "tab",
                                            "aria-selected": "false"
                                        }, [
                                            (0, _vue.createElementVNode)("div", {
                                                class: "horizontal-wizard"
                                            }, [
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "stroke-icon-wizard"
                                                }, [
                                                    (0, _vue.createElementVNode)("i", {
                                                        class: "fa fa-credit-card"
                                                    })
                                                ]),
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "horizontal-wizard-content"
                                                }, [
                                                    (0, _vue.createElementVNode)("h5", {
                                                        class: "f-w-600"
                                                    }, "Billing Settings")
                                                ])
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("a", {
                                            class: "nav-link",
                                            "data-bs-toggle": "pill",
                                            href: "#account-step-contact",
                                            role: "tab",
                                            "aria-selected": "false"
                                        }, [
                                            (0, _vue.createElementVNode)("div", {
                                                class: "horizontal-wizard"
                                            }, [
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "stroke-icon-wizard"
                                                }, [
                                                    (0, _vue.createElementVNode)("i", {
                                                        class: "fa fa-user"
                                                    })
                                                ]),
                                                (0, _vue.createElementVNode)("div", {
                                                    class: "horizontal-wizard-content"
                                                }, [
                                                    (0, _vue.createElementVNode)("h5", {
                                                        class: "f-w-600"
                                                    }, "Contact Info")
                                                ])
                                            ])
                                        ])
                                    ])
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_46, [
                                    (0, _vue.createElementVNode)("div", _hoisted_47, [
                                        (0, _vue.createElementVNode)("div", _hoisted_48, [
                                            _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-company-name-input"
                                            }, [
                                                (0, _vue.createTextVNode)(" Company Name "),
                                                (0, _vue.createElementVNode)("span", {
                                                    class: "text-danger"
                                                }, "*")
                                            ], -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "account-company-name-input",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.formData.companyName = $event),
                                                class: "form-control",
                                                type: "text",
                                                placeholder: "Enter company name"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.companyName
                                                ]
                                            ]),
                                            _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("div", {
                                                id: "account-company-name-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter the company name. ", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_49, [
                                            _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-status-input"
                                            }, "Status", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                                id: "account-status-input",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.formData.status = $event),
                                                class: "form-select"
                                            }, _cache[35] || (_cache[35] = [
                                                (0, _vue.createElementVNode)("option", {
                                                    value: "ACTIVE"
                                                }, "Active", -1),
                                                (0, _vue.createElementVNode)("option", {
                                                    value: "Inactive"
                                                }, "Inactive", -1),
                                                (0, _vue.createElementVNode)("option", {
                                                    value: "CLOSED"
                                                }, "Closed", -1)
                                            ]), 512), [
                                                [
                                                    (0, _vue.vModelSelect),
                                                    $setup.formData.status
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_50, [
                                            _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-notes-input"
                                            }, "Notes", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                                id: "account-notes-input",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.formData.notes = $event),
                                                class: "form-control",
                                                rows: "3",
                                                placeholder: "Internal notes about this account"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.notes
                                                ]
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_51, [
                                        (0, _vue.createElementVNode)("div", _hoisted_52, [
                                            _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-billing-cycle-input"
                                            }, [
                                                (0, _vue.createTextVNode)(" Billing Cycle "),
                                                (0, _vue.createElementVNode)("span", {
                                                    class: "text-danger"
                                                }, "*")
                                            ], -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                                id: "account-billing-cycle-input",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.formData.billingCycle = $event),
                                                class: "form-select"
                                            }, _cache[38] || (_cache[38] = [
                                                (0, _vue.createStaticVNode)("<option value=\"PER_TRIP\" data-v-89dfab>Per Trip</option><option value=\"WEEKLY\" data-v-89dfab>Weekly</option><option value=\"BIWEEKLY\" data-v-89dfab>Bi-Weekly</option><option value=\"MONTHLY\" data-v-89dfab>Monthly</option><option value=\"QUARTERLY\" data-v-89dfab>Quarterly</option>", 5)
                                            ]), 512), [
                                                [
                                                    (0, _vue.vModelSelect),
                                                    $setup.formData.billingCycle
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_53, [
                                            _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-payment-terms-input"
                                            }, "Payment Terms (Days)", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "account-payment-terms-input",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.formData.paymentTermsDays = $event),
                                                type: "number",
                                                class: "form-control",
                                                placeholder: "e.g., 30"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.paymentTermsDays,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Number of days until payment is due", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_54, [
                                            _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-credit-limit-input"
                                            }, "Credit Limit", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "account-credit-limit-input",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.formData.creditLimit = $event),
                                                type: "number",
                                                step: "0.01",
                                                class: "form-control",
                                                placeholder: "0.00 for unlimited"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.creditLimit,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("small", {
                                                class: "text-muted"
                                            }, "Maximum outstanding balance (0 for unlimited)", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_55, [
                                            _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600"
                                            }, "Auto-Invoice", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_56, [
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.formData.autoInvoice = $event),
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "account-auto-invoice"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelCheckbox),
                                                        $setup.formData.autoInvoice
                                                    ]
                                                ]),
                                                _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("label", {
                                                    class: "form-check-label",
                                                    for: "account-auto-invoice"
                                                }, " Automatically generate invoices based on billing cycle ", -1))
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_57, [
                                            _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600"
                                            }, "Auto-Send Invoice", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_58, [
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.formData.autoSendInvoice = $event),
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "account-auto-send-invoice"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelCheckbox),
                                                        $setup.formData.autoSendInvoice
                                                    ]
                                                ]),
                                                _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("label", {
                                                    class: "form-check-label",
                                                    for: "account-auto-send-invoice"
                                                }, " Automatically send invoices to customer email ", -1))
                                            ])
                                        ])
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_59, [
                                        (0, _vue.createElementVNode)("div", _hoisted_60, [
                                            _cache[48] || (_cache[48] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-billing-email-input"
                                            }, [
                                                (0, _vue.createTextVNode)(" Billing Email "),
                                                (0, _vue.createElementVNode)("span", {
                                                    class: "text-danger"
                                                }, "*")
                                            ], -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "account-billing-email-input",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.formData.billingEmail = $event),
                                                type: "email",
                                                class: "form-control",
                                                placeholder: "billing@company.com"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.billingEmail
                                                ]
                                            ]),
                                            _cache[49] || (_cache[49] = (0, _vue.createElementVNode)("div", {
                                                id: "account-billing-email-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter a valid billing email. ", -1))
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_61, [
                                            _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-billing-address-input"
                                            }, "Billing Address", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                                id: "account-billing-address-input",
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.formData.billingAddress = $event),
                                                class: "form-control",
                                                rows: "3",
                                                placeholder: "Full billing address"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.billingAddress
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_62, [
                                            (0, _vue.createElementVNode)("div", _hoisted_63, [
                                                _cache[51] || (_cache[51] = (0, _vue.createElementVNode)("label", {
                                                    class: "form-label f-w-600",
                                                    for: "account-contact-name-input"
                                                }, "Contact Person Name", -1)),
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    id: "account-contact-name-input",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.formData.contactPersonName = $event),
                                                    type: "text",
                                                    class: "form-control",
                                                    placeholder: "John Doe"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelText),
                                                        $setup.formData.contactPersonName
                                                    ]
                                                ])
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_64, [
                                                _cache[52] || (_cache[52] = (0, _vue.createElementVNode)("label", {
                                                    class: "form-label f-w-600",
                                                    for: "account-contact-phone-input"
                                                }, "Contact Phone", -1)),
                                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                    id: "account-contact-phone-input",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$setup.formData.contactPersonPhone = $event),
                                                    type: "tel",
                                                    class: "form-control",
                                                    placeholder: "+1234567890"
                                                }, null, 512), [
                                                    [
                                                        (0, _vue.vModelText),
                                                        $setup.formData.contactPersonPhone
                                                    ]
                                                ]),
                                                _cache[53] || (_cache[53] = (0, _vue.createElementVNode)("div", {
                                                    id: "account-contact-phone-error",
                                                    class: "invalid-feedback d-none"
                                                }, " Please enter a valid phone number. ", -1))
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_65, [
                                            _cache[54] || (_cache[54] = (0, _vue.createElementVNode)("label", {
                                                class: "form-label f-w-600",
                                                for: "account-contact-email-input"
                                            }, "Contact Email", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                id: "account-contact-email-input",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$setup.formData.contactPersonEmail = $event),
                                                type: "email",
                                                class: "form-control",
                                                placeholder: "contact@company.com"
                                            }, null, 512), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.formData.contactPersonEmail
                                                ]
                                            ]),
                                            _cache[55] || (_cache[55] = (0, _vue.createElementVNode)("div", {
                                                id: "account-contact-email-error",
                                                class: "invalid-feedback d-none"
                                            }, " Please enter a valid contact email. ", -1))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _cache[57] || (_cache[57] = (0, _vue.createElementVNode)("div", {
                        class: "card-footer"
                    }, [
                        (0, _vue.createElementVNode)("div", {
                            id: "account-wizard-navigation"
                        })
                    ], -1))
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewAccount && !$setup.editAccountInfo && $setup.account ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_66, [
            (0, _vue.createElementVNode)("div", _hoisted_67, [
                _cache[75] || (_cache[75] = (0, _vue.createElementVNode)("div", {
                    class: "card-header card-no-border pb-0"
                }, [
                    (0, _vue.createElementVNode)("ul", {
                        class: "nav nav-tabs",
                        id: "account-detail-tab",
                        role: "tablist"
                    }, [
                        (0, _vue.createElementVNode)("li", {
                            class: "nav-item"
                        }, [
                            (0, _vue.createElementVNode)("a", {
                                class: "nav-link active",
                                id: "overview-tab",
                                "data-bs-toggle": "tab",
                                href: "#overview",
                                role: "tab"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-info-circle"
                                }),
                                (0, _vue.createTextVNode)(" Overview ")
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", {
                            class: "nav-item"
                        }, [
                            (0, _vue.createElementVNode)("a", {
                                class: "nav-link",
                                id: "rides-tab",
                                "data-bs-toggle": "tab",
                                href: "#rides",
                                role: "tab"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-taxi"
                                }),
                                (0, _vue.createTextVNode)(" Rides ")
                            ])
                        ]),
                        (0, _vue.createElementVNode)("li", {
                            class: "nav-item"
                        }, [
                            (0, _vue.createElementVNode)("a", {
                                class: "nav-link",
                                id: "invoices-tab",
                                "data-bs-toggle": "tab",
                                href: "#invoices",
                                role: "tab"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-file-invoice"
                                }),
                                (0, _vue.createTextVNode)(" Invoices ")
                            ])
                        ])
                    ])
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_68, [
                    (0, _vue.createElementVNode)("div", _hoisted_69, [
                        (0, _vue.createElementVNode)("div", _hoisted_70, [
                            (0, _vue.createElementVNode)("div", _hoisted_71, [
                                (0, _vue.createElementVNode)("div", _hoisted_72, [
                                    _cache[62] || (_cache[62] = (0, _vue.createElementVNode)("h5", {
                                        class: "mb-3 fw-bold"
                                    }, "Company Information", -1)),
                                    (0, _vue.createElementVNode)("table", _hoisted_73, [
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[58] || (_cache[58] = (0, _vue.createElementVNode)("th", null, "Company Name:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.companyName), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[59] || (_cache[59] = (0, _vue.createElementVNode)("th", null, "Account Code:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.accountCode), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[60] || (_cache[60] = (0, _vue.createElementVNode)("th", null, "Status:", -1)),
                                            (0, _vue.createElementVNode)("td", null, [
                                                (0, _vue.createElementVNode)("span", {
                                                    class: (0, _vue.normalizeClass)($setup.getStatusClass($setup.account.status))
                                                }, (0, _vue.toDisplayString)($setup.account.status), 3)
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[61] || (_cache[61] = (0, _vue.createElementVNode)("th", null, "Notes:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.notes || 'N/A'), 1)
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_74, [
                                    _cache[67] || (_cache[67] = (0, _vue.createElementVNode)("h5", {
                                        class: "mb-3 fw-bold"
                                    }, "Billing Information", -1)),
                                    (0, _vue.createElementVNode)("table", _hoisted_75, [
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[63] || (_cache[63] = (0, _vue.createElementVNode)("th", null, "Billing Cycle:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatBillingCycle($setup.account.billingCycle)), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[64] || (_cache[64] = (0, _vue.createElementVNode)("th", null, "Payment Terms:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.paymentTermsDays) + " days", 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[65] || (_cache[65] = (0, _vue.createElementVNode)("th", null, "Credit Limit:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.creditLimit > 0 ? $setup.formatCurrency($setup.account.creditLimit) : 'Unlimited'), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[66] || (_cache[66] = (0, _vue.createElementVNode)("th", null, "Auto-Invoice:", -1)),
                                            (0, _vue.createElementVNode)("td", null, [
                                                (0, _vue.createElementVNode)("span", {
                                                    class: (0, _vue.normalizeClass)($setup.account.autoInvoice ? 'badge bg-success' : 'badge bg-secondary')
                                                }, (0, _vue.toDisplayString)($setup.account.autoInvoice ? 'Enabled' : 'Disabled'), 3)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_76, [
                                (0, _vue.createElementVNode)("div", _hoisted_77, [
                                    _cache[71] || (_cache[71] = (0, _vue.createElementVNode)("h5", {
                                        class: "mb-3 fw-bold"
                                    }, "Contact Information", -1)),
                                    (0, _vue.createElementVNode)("table", _hoisted_78, [
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[68] || (_cache[68] = (0, _vue.createElementVNode)("th", null, "Contact Person:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.contactPersonName || 'N/A'), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[69] || (_cache[69] = (0, _vue.createElementVNode)("th", null, "Contact Phone:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.contactPersonPhone || 'N/A'), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[70] || (_cache[70] = (0, _vue.createElementVNode)("th", null, "Contact Email:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.contactPersonEmail || 'N/A'), 1)
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_79, [
                                    _cache[74] || (_cache[74] = (0, _vue.createElementVNode)("h5", {
                                        class: "mb-3 fw-bold"
                                    }, "Billing Contact", -1)),
                                    (0, _vue.createElementVNode)("table", _hoisted_80, [
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[72] || (_cache[72] = (0, _vue.createElementVNode)("th", null, "Billing Email:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.billingEmail), 1)
                                        ]),
                                        (0, _vue.createElementVNode)("tr", null, [
                                            _cache[73] || (_cache[73] = (0, _vue.createElementVNode)("th", null, "Billing Address:", -1)),
                                            (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.account.billingAddress || 'N/A'), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_81, [
                            $setup.account.id ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["DataTable"], {
                                key: 0,
                                ajax: {
                                    url: $setup.ridesUrl
                                },
                                ref: "ridesTable",
                                class: "table-responsive display",
                                columns: $setup.ridesColumns
                            }, null, 8, [
                                "ajax"
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_82, [
                            $setup.account.id ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["DataTable"], {
                                key: 0,
                                ajax: {
                                    url: $setup.invoicesUrl
                                },
                                ref: "invoicesTable",
                                class: "table-responsive display",
                                columns: $setup.invoicesColumns
                            }, null, 8, [
                                "ajax"
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8eU75":[function() {},{}],"6qJvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2lKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("447db6872aee28fe");
    if (script.__esModule) script = script.default;
    script.render = require("80f2cd1f871ac6f7").render;
    require("b0bfde9c17efc1a").default(script);
    script.__scopeId = 'data-v-b461c1';
    script.__file = "AllIndependentDrivers.vue";
};
initialize();
exports.default = script;

},{"447db6872aee28fe":"hiMve","80f2cd1f871ac6f7":"gBUO2","b0bfde9c17efc1a":"gxY8C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiMve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
const driversUrl = `/api/datatable/independent-drivers`;
exports.default = {
    __name: 'AllIndependentDrivers',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const activeUrl = `${driversUrl}?subscriptionStatus=ACTIVE`;
        const inactiveUrl = `${driversUrl}?subscriptionStatus=INACTIVE`;
        const columnDefinition = [
            {
                title: "Driver",
                data: "name",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/admin/independent-driver/${row.id}`);
                }
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "phoneNumber",
                title: 'Phone Number'
            },
            {
                data: "subscriptionType",
                title: 'Subscription Type',
                render: (data)=>{
                    if (!data) return '<span class="badge bg-secondary">None</span>';
                    const typeClass = data === 'FULL_TIME' ? 'bg-primary' : 'bg-info';
                    const label = data === 'FULL_TIME' ? 'Full Time' : 'Starter';
                    return `<span class="badge ${typeClass}">${label}</span>`;
                }
            },
            {
                data: "subscriptionStatus",
                title: 'Subscription Status',
                render: (0, _datatableRenderer.subscriptionStatus)
            },
            {
                data: "totalRides",
                title: 'Rides',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data || 0}</span> |
                    Completed <span class="text-success">${row.completedRides || 0}</span> |
                    Canceled <span class="text-danger">${row.cancelledRides || 0}</span>
              </span>`;
                }
            },
            {
                data: "onboardingStatus",
                title: 'Onboarding',
                render: (data)=>{
                    if (!data) return '<span class="badge bg-secondary">Unknown</span>';
                    const statusMap = {
                        'NOT_STARTED': {
                            class: 'bg-secondary',
                            label: 'Not Started'
                        },
                        'IN_PROGRESS': {
                            class: 'bg-warning',
                            label: 'In Progress'
                        },
                        'PENDING_VERIFICATION': {
                            class: 'bg-info',
                            label: 'Pending Verification'
                        },
                        'COMPLETE': {
                            class: 'bg-success',
                            label: 'Complete'
                        },
                        'REJECTED': {
                            class: 'bg-danger',
                            label: 'Rejected'
                        }
                    };
                    const status = statusMap[data] || {
                        class: 'bg-secondary',
                        label: data
                    };
                    return `<span class="badge ${status.class}">${status.label}</span>`;
                }
            },
            {
                data: "joinedOn",
                title: 'Joined At',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
        href="/admin/independent-driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
                }
            }
        ];
        const __returned__ = {
            driversUrl,
            activeUrl,
            inactiveUrl,
            columnDefinition,
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get subscriptionStatus () {
                return 0, _datatableRenderer.subscriptionStatus;
            },
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBUO2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal-2"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    class: "tab-content",
    id: "icon-tabContent"
};
const _hoisted_4 = {
    class: "tab-pane fade show active",
    id: "all-drivers",
    role: "tabpanel",
    "aria-labelledby": "all-drivers-tab"
};
const _hoisted_5 = {
    class: "tab-pane fade",
    id: "active-drivers",
    role: "tabpanel",
    "aria-labelledby": "active-drivers-tab"
};
const _hoisted_6 = {
    class: "tab-pane fade",
    id: "inactive-drivers",
    role: "tabpanel",
    "aria-labelledby": "inactive-drivers-tab"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "Independent Drivers")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
                class: "card-header card-no-border pb-0"
            }, [
                (0, _vue.createElementVNode)("ul", {
                    class: "nav nav-tabs",
                    id: "icon-tab",
                    role: "tablist"
                }, [
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link active",
                            id: "all-drivers-tab",
                            "data-bs-toggle": "tab",
                            href: "#all-drivers",
                            role: "tab",
                            "aria-controls": "all-drivers",
                            "aria-selected": "true"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-users text-primary"
                            }),
                            (0, _vue.createTextVNode)(" All Drivers ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "active-drivers-tab",
                            "data-bs-toggle": "tab",
                            href: "#active-drivers",
                            role: "tab",
                            "aria-controls": "active-drivers",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-check text-success"
                            }),
                            (0, _vue.createTextVNode)(" Active Subscription ")
                        ])
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            id: "inactive-drivers-tab",
                            "data-bs-toggle": "tab",
                            href: "#inactive-drivers",
                            role: "tab",
                            "aria-controls": "inactive-drivers",
                            "aria-selected": "false"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-xmark text-danger"
                            }),
                            (0, _vue.createTextVNode)(" Inactive Subscription ")
                        ])
                    ])
                ])
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                (0, _vue.createElementVNode)("div", _hoisted_3, [
                    (0, _vue.createElementVNode)("div", _hoisted_4, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.driversUrl
                            },
                            ref: "allDrivers",
                            class: "table-responsive display custom-datatable",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.activeUrl
                            },
                            ref: "activeDrivers",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: $setup.inactiveUrl
                            },
                            ref: "inactiveDrivers",
                            class: "table-responsive display",
                            columns: $setup.columnDefinition
                        }, null, 8, [
                            "ajax"
                        ])
                    ])
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxY8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZU4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("83421462f3a68ad7");
    if (script.__esModule) script = script.default;
    script.render = require("f99b9cdfd85a9374").render;
    script.__cssModules = require("b40179b7d05836be").default;
    require("27a2eb10a464a5f9").default(script);
    script.__scopeId = 'data-v-48c6eb';
    script.__file = "IndependentDriverSignupForm.vue";
};
initialize();
exports.default = script;

},{"83421462f3a68ad7":"8kEEM","f99b9cdfd85a9374":"fOzEf","b40179b7d05836be":"ilhN1","27a2eb10a464a5f9":"egVs8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kEEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _jqueryUi = require("jquery-ui");
var _jqueryWizard = require("./../../extras/js/jquery-wizard");
var _independentDriverSignupPersonalInfo = require("../modelTemplates/IndependentDriverSignupPersonalInfo");
var _independentDriverSignupPersonalInfoDefault = parcelHelpers.interopDefault(_independentDriverSignupPersonalInfo);
var _independentDriverSignupVerification = require("../modelTemplates/IndependentDriverSignupVerification");
var _independentDriverSignupVerificationDefault = parcelHelpers.interopDefault(_independentDriverSignupVerification);
var _driverOnboardingVehicleInfo = require("../modelTemplates/DriverOnboardingVehicleInfo");
var _driverOnboardingVehicleInfoDefault = parcelHelpers.interopDefault(_driverOnboardingVehicleInfo);
var _driverOnboardingDocumentUpload = require("../modelTemplates/DriverOnboardingDocumentUpload");
var _driverOnboardingDocumentUploadDefault = parcelHelpers.interopDefault(_driverOnboardingDocumentUpload);
var _driverOnboardingReviewSubmit = require("../modelTemplates/DriverOnboardingReviewSubmit");
var _driverOnboardingReviewSubmitDefault = parcelHelpers.interopDefault(_driverOnboardingReviewSubmit);
var _sweetalert2Min = require("../../extras/js/sweetalert/sweetalert2.min");
var _sweetalert2MinDefault = parcelHelpers.interopDefault(_sweetalert2Min);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _driverOnboardingStepDocumentUploadVue = require("./DriverOnboardingStepDocumentUpload.vue");
var _driverOnboardingStepDocumentUploadVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepDocumentUploadVue);
var _driverOnboardingStepVehicleInfoVue = require("./DriverOnboardingStepVehicleInfo.vue");
var _driverOnboardingStepVehicleInfoVueDefault = parcelHelpers.interopDefault(_driverOnboardingStepVehicleInfoVue);
var _independentDriverSignupStepPersonalInfoVue = require("./IndependentDriverSignupStepPersonalInfo.vue");
var _independentDriverSignupStepPersonalInfoVueDefault = parcelHelpers.interopDefault(_independentDriverSignupStepPersonalInfoVue);
var _independentDriverSignupStepVerificationVue = require("./IndependentDriverSignupStepVerification.vue");
var _independentDriverSignupStepVerificationVueDefault = parcelHelpers.interopDefault(_independentDriverSignupStepVerificationVue);
var _independentDriverSignupStepReviewVue = require("./IndependentDriverSignupStepReview.vue");
var _independentDriverSignupStepReviewVueDefault = parcelHelpers.interopDefault(_independentDriverSignupStepReviewVue);
var _jurisdictionCheckModalVue = require("./JurisdictionCheckModal.vue");
var _jurisdictionCheckModalVueDefault = parcelHelpers.interopDefault(_jurisdictionCheckModalVue);
const INCOMPLETE_STEP_MESSAGE = 'Please complete the required fields for this step.';
// Names the insurance declarations when they are the only thing outstanding: the checkboxes
// sit below the uploads, so a generic message sends the driver back to documents that are
// already correct.
exports.default = {
    __name: 'IndependentDriverSignupForm',
    props: {
        googleMapsApiKey: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const form = (0, _vue.ref)({
            personalInfo: {},
            verification: {},
            vehicleInfo: {},
            documents: {},
            review: {}
        });
        const personalModel = (0, _independentDriverSignupPersonalInfoDefault.default)();
        const verificationModel = (0, _independentDriverSignupVerificationDefault.default)();
        const vehicleModel = (0, _driverOnboardingVehicleInfoDefault.default)();
        const documentsModel = (0, _driverOnboardingDocumentUploadDefault.default)();
        const reviewModel = (0, _driverOnboardingReviewSubmitDefault.default)();
        form.value.personalInfo = personalModel.state;
        form.value.verification = verificationModel.state;
        form.value.vehicleInfo = vehicleModel.state;
        form.value.documents = documentsModel.state;
        form.value.review = reviewModel.state;
        // Wizard step positions. The validator, the per-step failure message, the completion
        // checks and the review step's Edit links all read from here: the last reorder moved
        // Verification from 3 to 1 and left three call sites pointing at the old numbers.
        const STEP = {
            PERSONAL: 0,
            VERIFICATION: 1,
            VEHICLE: 2,
            DOCUMENTS: 3,
            REVIEW: 4
        };
        (0, _vue.provide)('stepIndex', STEP);
        (0, _vue.provide)('personalInfo', personalModel.state);
        (0, _vue.provide)('vehicleInfo', vehicleModel.state);
        (0, _vue.provide)('documentsInfo', documentsModel.state);
        (0, _vue.provide)('reviewModel', reviewModel);
        const documentsStep = (0, _vue.ref)(null);
        const currentStepIndex = (0, _vue.ref)(0);
        const isSaving = (0, _vue.ref)(false);
        const isJurisdictionValidated = (0, _vue.ref)(false);
        const submittedState = (0, _vue.ref)(null); // set after successful submission: { redirectUrl }
        const emailModified = (0, _vue.ref)(false);
        const phoneModified = (0, _vue.ref)(false);
        (0, _vue.provide)('emailModified', emailModified);
        (0, _vue.provide)('phoneModified', phoneModified);
        (0, _vue.watch)(()=>form.value.personalInfo.email, (newVal, oldVal)=>{
            if (oldVal && newVal !== oldVal) {
                //if email verified we should notify that re-verification is necesssary
                if (form.value.verification.emailVerified) {
                    emailModified.value = true;
                    removeCompletionCheckOnTab(STEP.VERIFICATION);
                }
                form.value.verification.emailVerified = false;
            }
        });
        (0, _vue.watch)(()=>`${form.value.personalInfo.countryCode}${form.value.personalInfo.phoneNumber}`, (newVal, oldVal)=>{
            if (oldVal && newVal !== oldVal) {
                // if phone verified we should notify that re-verification is necesssary
                if (form.value.verification.phoneVerified) {
                    phoneModified.value = true;
                    removeCompletionCheckOnTab(STEP.VERIFICATION);
                }
                form.value.verification.phoneVerified = false;
            }
        });
        function onJurisdictionValidated() {
            isJurisdictionValidated.value = true;
            showBeforeYouBeginModal();
        }
        function showBeforeYouBeginModal() {
            (0, _sweetalert2MinDefault.default).fire({
                title: 'Before You Begin',
                html: `
      <div class="text-start">
        <p>Please have the following documents ready to upload:</p>
        <ul class="list-unstyled">
          <li><i class="fa-solid fa-id-card text-primary me-2"></i> Driver's License (front and back)</li>
          <li><i class="fa-solid fa-shield text-primary me-2"></i> Insurance Certificate (Pink Slip)</li>
        </ul>
        <p class="text-muted mb-0"><small>You'll also need the expiry dates for each document.</small></p>
      </div>
    `,
                icon: 'info',
                confirmButtonText: 'I\'m Ready',
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false
            });
        }
        function goToStep(stepIndex) {
            try {
                $('#independent-driver-signup-wizard').wizard('goTo', stepIndex);
            } catch (err) {
                console.error('Failed to navigate to step', stepIndex, err);
            }
        }
        // On a phone the step strip scrolls sideways rather than wrapping into ragged rows, so the step
        // the driver was just moved to can be off screen. Nothing else scrolls it back.
        function revealStepInStrip(idx) {
            const el = $('#independent-driver-signup-wizard .nav.nav-pills.horizontal-options > a').eq(idx)[0];
            el?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
        function removeCompletionCheckOnTab(idx) {
            const $a = $('#independent-driver-signup-wizard .nav.nav-pills.horizontal-options > a').eq(idx);
            if (!$a || !$a.length) return;
            const $title = $a.find('.horizontal-wizard-content h5');
            if (!$title || !$title.length) return;
            $title.find('.step-complete-check').remove();
        }
        function addCompletionCheck(idx) {
            const $a = $('#independent-driver-signup-wizard .nav.nav-pills.horizontal-options > a').eq(idx);
            if (!$a || !$a.length) return;
            const $title = $a.find('.horizontal-wizard-content h5');
            if (!$title || !$title.length) return;
            if ($title.find('.step-complete-check').length) return;
            $title.append('<i class="fa-solid fa-check text-success ms-2 step-complete-check" title="Completed" aria-hidden="true"></i>');
        }
        function documentsStepMessage() {
            if (documentsModel.isValid()) return '';
            documentsStep.value?.revealDeclarationError();
            return documentsModel.hasAllDocuments() ? 'You must confirm all insurance eligibility declarations to continue.' : INCOMPLETE_STEP_MESSAGE;
        }
        // Each entry returns the message to show when its step is incomplete, or '' when it is valid,
        // revealing any inline errors on the step itself as it goes.
        // Keyed by STEP so a reorder cannot separate a step from its own message again.
        const STEP_MESSAGES = {
            [STEP.PERSONAL]: ()=>personalModel.isValid() ? '' : INCOMPLETE_STEP_MESSAGE,
            [STEP.VERIFICATION]: ()=>verificationModel.isValid() ? '' : 'Please verify both your email address and phone number before continuing.',
            [STEP.VEHICLE]: ()=>vehicleModel.isValid() ? '' : INCOMPLETE_STEP_MESSAGE,
            [STEP.DOCUMENTS]: documentsStepMessage,
            [STEP.REVIEW]: ()=>reviewModel.isValid() ? '' : INCOMPLETE_STEP_MESSAGE
        };
        /**
 * Parses a failure body that may be either a JSON object or the plain text older endpoints return.
 *
 * @param {string} body the raw response body
 * @returns {object|null} the parsed object, or null when the body was not JSON
 */ function parseFailure(body) {
            if (!body) return null;
            try {
                const parsed = JSON.parse(body);
                return parsed && typeof parsed === 'object' ? parsed : null;
            } catch (e) {
                return null;
            }
        }
        /**
 * Clears the lapsed verifications and returns the driver to the verification step.
 *
 * An OTP-verified marker expires server-side while the driver is still filling in later steps, so
 * the wizard can be showing "Verified" for something the server no longer accepts. Leaving those
 * badges up strands the driver on the review step with a rejection they have no way to clear.
 *
 * @param {{expired?: string[], error?: string}} failure the parsed verification_expired response
 */ function handleExpiredVerification(failure) {
            const expired = Array.isArray(failure.expired) && failure.expired.length > 0 ? failure.expired : [
                'email',
                'phone'
            ];
            if (expired.includes('email')) verificationModel.state.emailVerified = false;
            if (expired.includes('phone')) verificationModel.state.phoneVerified = false;
            // The tick claims a step the driver has to redo; the wizard would otherwise let them walk
            // straight back to review and be refused a second time.
            removeCompletionCheckOnTab(STEP.VERIFICATION);
            goToStep(STEP.VERIFICATION);
            (0, _toastNotificationUtility.showToast)({
                title: 'Verification Expired',
                body: failure.error || 'Your verification expired. Please request a new code to finish your application.',
                type: (0, _toastNotificationUtility.notificationType).WARN,
                delay: 10000
            });
        }
        async function submitSignup() {
            isSaving.value = true;
            const { referralCode, ...personalInfo } = personalModel.toJSON();
            const payload = {
                personalInfo,
                vehicleInfo: vehicleModel.toJSON(),
                documentsInfo: documentsModel.toJSON(),
                legalAgreements: reviewModel.toJSON(),
                referralCode: referralCode ? referralCode.trim() : null
            };
            try {
                const fd = new FormData();
                fd.append('data', JSON.stringify(payload));
                const docsState = documentsModel.state;
                if (docsState?.driverLicenseFront) fd.append('driverLicenseFile[0]', docsState.driverLicenseFront);
                if (docsState?.driverLicenseBack) fd.append('driverLicenseFile[1]', docsState.driverLicenseBack);
                if (docsState?.insuranceDocFile) fd.append('insuranceDocFile', docsState.insuranceDocFile);
                const res = await fetch('/api/independent-driver-signup/complete', {
                    method: 'POST',
                    body: fd
                });
                if (res.ok) {
                    const data = await res.json();
                    submittedState.value = {
                        redirectUrl: data.redirectUrl || '/login'
                    };
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Registration Complete',
                        body: 'Your application has been submitted successfully! You will receive an email with next steps.',
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                    return true;
                }
                const errorText = await res.text();
                const failure = parseFailure(errorText);
                if (failure?.reason === 'verification_expired') {
                    handleExpiredVerification(failure);
                    return false;
                }
                (0, _toastNotificationUtility.showToast)({
                    title: 'Registration Failed',
                    body: failure?.error || errorText || 'We could not complete your registration. Please try again.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 8000
                });
                return false;
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Network Error',
                    body: 'We could not complete your registration. Please try again.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
                return false;
            } finally{
                isSaving.value = false;
            }
        }
        function setupWizard() {
            $('#independent-driver-signup-wizard').wizard({
                step: '.nav-pills > a',
                classes: {
                    step: {
                        active: 'active'
                    },
                    pane: {
                        active: 'active show'
                    },
                    button: {
                        hide: 'd-none',
                        disabled: 'd-none'
                    }
                },
                buttonsAppendTo: '#independent-driver-signup-navigation',
                templates: {
                    buttons: function() {
                        return `<div class="pull-left">
                  <a role="button" class="btn btn-outline-secondary mb-3" href="#independent-driver-signup-wizard" data-wizard="back">Back</a>
                </div>
                <div class="pull-right">
                  <a role="button" class="btn btn-outline-primary mb-3" href="#independent-driver-signup-wizard" data-wizard="next">Continue</a>
                  <a role="button" class="btn btn-outline-success mb-3" href="#independent-driver-signup-wizard" data-wizard="finish">Submit Registration</a>
                </div>`;
                    }
                },
                validator: function(step) {
                    currentStepIndex.value = step.index;
                    const messageFor = STEP_MESSAGES[step.index];
                    if (!messageFor) return true;
                    const message = messageFor();
                    if (message) {
                        (0, _toastNotificationUtility.showToast)({
                            title: 'Validation Failed',
                            body: message,
                            type: (0, _toastNotificationUtility.notificationType).WARN
                        });
                        return false;
                    }
                    return true;
                },
                onAfterChange: function(currentStep, nextStep) {
                    if (nextStep.index > currentStep.index) {
                        addCompletionCheck(currentStep.index);
                        currentStepIndex.value = nextStep.index;
                    }
                    revealStepInStrip(nextStep.index);
                },
                onFinish: function() {
                    submitSignup();
                }
            });
        }
        (0, _vue.onMounted)(async ()=>{
            const refParam = new URLSearchParams(window.location.search).get('ref');
            if (refParam) personalModel.state.referralCode = refParam;
            await (0, _vue.nextTick)();
            setupWizard();
        });
        (0, _vue.onUnmounted)(()=>{});
        const __returned__ = {
            props,
            form,
            personalModel,
            verificationModel,
            vehicleModel,
            documentsModel,
            reviewModel,
            STEP,
            documentsStep,
            currentStepIndex,
            isSaving,
            isJurisdictionValidated,
            submittedState,
            emailModified,
            phoneModified,
            onJurisdictionValidated,
            showBeforeYouBeginModal,
            goToStep,
            revealStepInStrip,
            removeCompletionCheckOnTab,
            addCompletionCheck,
            INCOMPLETE_STEP_MESSAGE,
            documentsStepMessage,
            STEP_MESSAGES,
            parseFailure,
            handleExpiredVerification,
            submitSignup,
            setupWizard,
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            ref: (0, _vue.ref),
            nextTick: (0, _vue.nextTick),
            provide: (0, _vue.provide),
            watch: (0, _vue.watch),
            get IndependentDriverSignupPersonalInfoModel () {
                return 0, _independentDriverSignupPersonalInfoDefault.default;
            },
            get IndependentDriverSignupVerificationModel () {
                return 0, _independentDriverSignupVerificationDefault.default;
            },
            get DriverOnboardingVehicleInfoModel () {
                return 0, _driverOnboardingVehicleInfoDefault.default;
            },
            get DriverOnboardingDocumentUploadModel () {
                return 0, _driverOnboardingDocumentUploadDefault.default;
            },
            get DriverOnboardingReviewSubmitModel () {
                return 0, _driverOnboardingReviewSubmitDefault.default;
            },
            get Swal () {
                return 0, _sweetalert2MinDefault.default;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            DriverOnboardingStepDocumentUpload: (0, _driverOnboardingStepDocumentUploadVueDefault.default),
            DriverOnboardingStepVehicleInfo: (0, _driverOnboardingStepVehicleInfoVueDefault.default),
            IndependentDriverSignupStepPersonalInfo: (0, _independentDriverSignupStepPersonalInfoVueDefault.default),
            IndependentDriverSignupStepVerification: (0, _independentDriverSignupStepVerificationVueDefault.default),
            IndependentDriverSignupStepReview: (0, _independentDriverSignupStepReviewVueDefault.default),
            JurisdictionCheckModal: (0, _jurisdictionCheckModalVueDefault.default)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui":"6clbD","./../../extras/js/jquery-wizard":"16izs","../modelTemplates/IndependentDriverSignupPersonalInfo":"9VY9x","../modelTemplates/IndependentDriverSignupVerification":"jf8HO","../modelTemplates/DriverOnboardingVehicleInfo":"glyXW","../modelTemplates/DriverOnboardingDocumentUpload":"iPszW","../modelTemplates/DriverOnboardingReviewSubmit":"hDntw","../../extras/js/sweetalert/sweetalert2.min":"ltJ5f","../utility/toastNotificationUtility":"krOtg","./DriverOnboardingStepDocumentUpload.vue":"6Jo7v","./DriverOnboardingStepVehicleInfo.vue":"4ODpb","./IndependentDriverSignupStepPersonalInfo.vue":"6r9MC","./IndependentDriverSignupStepVerification.vue":"dMtB4","./IndependentDriverSignupStepReview.vue":"2XR9T","./JurisdictionCheckModal.vue":"4oi0L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VY9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IndependentDriverSignupPersonalInfo);
var _vue = require("vue");
function IndependentDriverSignupPersonalInfo(data = {}) {
    const state = (0, _vue.reactive)({
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        password: data.password || '',
        confirmPassword: data.confirmPassword || '',
        countryCode: data.countryCode || '+1',
        phoneNumber: data.phoneNumber || '',
        address: data.address || '',
        placeId: data.placeId || '',
        city: data.city || '',
        state: data.state || '',
        country: data.country || '',
        postalCode: data.postalCode || '',
        dateOfBirth: data.dateOfBirth || '',
        referralCode: data.referralCode || ''
    });
    const isIsoDate = (val)=>{
        if (!val) return false;
        const m = /^\d{4}-\d{2}-\d{2}$/.exec(val);
        if (!m) return false;
        const dt = new Date(val);
        const [y, mo, d] = val.split('-').map(Number);
        return dt instanceof Date && !isNaN(dt) && dt.getUTCFullYear() === y && dt.getUTCMonth() + 1 === mo && dt.getUTCDate() === d;
    };
    const validations = {
        isFirstNameValid: (0, _vue.computed)(()=>!!String(state.firstName ?? '').trim()),
        isLastNameValid: (0, _vue.computed)(()=>!!String(state.lastName ?? '').trim()),
        isEmailValid: (0, _vue.computed)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(state.email ?? ''))),
        isPasswordValid: (0, _vue.computed)(()=>String(state.password ?? '').length >= 8),
        isConfirmPasswordValid: (0, _vue.computed)(()=>state.password === state.confirmPassword && state.confirmPassword.length > 0),
        isPhoneNumberValid: (0, _vue.computed)(()=>/^[0-9]{7,15}$/.test(String(state.phoneNumber ?? ''))),
        isAddressValid: (0, _vue.computed)(()=>!!String(state.address ?? '').trim()),
        isCityValid: (0, _vue.computed)(()=>!!String(state.city ?? '').trim()),
        isStateValid: (0, _vue.computed)(()=>!!String(state.state ?? '').trim()),
        isCountryValid: (0, _vue.computed)(()=>!!String(state.country ?? '').trim()),
        isPostalCodeValid: (0, _vue.computed)(()=>!!String(state.postalCode ?? '').trim()),
        isDobValid: (0, _vue.computed)(()=>{
            if (!isIsoDate(String(state.dateOfBirth ?? ''))) return false;
            const dob = new Date(state.dateOfBirth);
            const today = new Date();
            const age = today.getFullYear() - dob.getFullYear();
            const monthDiff = today.getMonth() - dob.getMonth();
            const dayDiff = today.getDate() - dob.getDate();
            const actualAge = monthDiff < 0 || monthDiff === 0 && dayDiff < 0 ? age - 1 : age;
            return actualAge >= 25 && actualAge <= 100;
        })
    };
    const toggleInvalid = (inputSelector, errorSelector, ok)=>{
        const $input = $(inputSelector);
        const $error = $(errorSelector);
        if (!$input || !$input.length) return ok;
        if (ok) {
            $input.removeClass('is-invalid');
            if ($error && $error.length) $error.addClass('d-none');
        } else {
            $input.addClass('is-invalid');
            if ($error && $error.length) $error.removeClass('d-none');
        }
        return ok;
    };
    const validateFirstName = ()=>toggleInvalid('#signup-first-name-input', '#signup-first-name-error', validations.isFirstNameValid.value);
    const validateLastName = ()=>toggleInvalid('#signup-last-name-input', '#signup-last-name-error', validations.isLastNameValid.value);
    const validateEmail = ()=>toggleInvalid('#signup-email-input', '#signup-email-error', validations.isEmailValid.value);
    const validatePassword = ()=>toggleInvalid('#signup-password-input', '#signup-password-error', validations.isPasswordValid.value);
    const validateConfirmPassword = ()=>toggleInvalid('#signup-confirm-password-input', '#signup-confirm-password-error', validations.isConfirmPasswordValid.value);
    const validateDob = ()=>toggleInvalid('#signup-dob-input', '#signup-dob-error', validations.isDobValid.value);
    const validatePhone = ()=>toggleInvalid('#signup-phone-number-input', '#signup-phone-number-error', validations.isPhoneNumberValid.value);
    const validateAddress = ()=>toggleInvalid('#signup-address-input', '#signup-address-error', validations.isAddressValid.value);
    const validateCity = ()=>toggleInvalid('#signup-city-input', '#signup-city-error', validations.isCityValid.value);
    const validateState = ()=>toggleInvalid('#signup-state-input', '#signup-state-error', validations.isStateValid.value);
    const validateCountry = ()=>toggleInvalid('#signup-country-input', '#signup-country-error', validations.isCountryValid.value);
    const validatePostalCode = ()=>toggleInvalid('#signup-postal-code-input', '#signup-postal-code-error', validations.isPostalCodeValid.value);
    (0, _vue.watch)(()=>state.firstName, validateFirstName);
    (0, _vue.watch)(()=>state.lastName, validateLastName);
    (0, _vue.watch)(()=>state.email, validateEmail);
    (0, _vue.watch)(()=>state.password, validatePassword);
    (0, _vue.watch)(()=>state.confirmPassword, validateConfirmPassword);
    (0, _vue.watch)(()=>state.dateOfBirth, validateDob);
    (0, _vue.watch)(()=>state.phoneNumber, validatePhone);
    (0, _vue.watch)(()=>state.address, validateAddress);
    (0, _vue.watch)(()=>state.city, validateCity);
    (0, _vue.watch)(()=>state.state, validateState);
    (0, _vue.watch)(()=>state.country, validateCountry);
    (0, _vue.watch)(()=>state.postalCode, validatePostalCode);
    const isValid = ()=>validateFirstName() | validateLastName() | validateEmail() | validatePassword() | validateConfirmPassword() | validatePhone() | validateAddress() | validateCity() | validateState() | validateCountry() | validatePostalCode() | validateDob();
    const toJSON = ()=>{
        const { confirmPassword, countryCode, phoneNumber, ...rest } = state;
        return {
            ...rest,
            phoneNumber: `${countryCode}${phoneNumber}`
        };
    };
    return {
        state,
        validations,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jf8HO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IndependentDriverSignupVerification);
var _vue = require("vue");
function IndependentDriverSignupVerification(data = {}) {
    const state = (0, _vue.reactive)({
        emailVerified: data.emailVerified || false,
        phoneVerified: data.phoneVerified || false
    });
    const validations = {
        isEmailVerified: (0, _vue.computed)(()=>state.emailVerified === true),
        isPhoneVerified: (0, _vue.computed)(()=>state.phoneVerified === true)
    };
    // Both, not either: a bitwise OR here let the wizard past this step with one side unverified,
    // and the signup was then refused at submission time by a server that checks both.
    const isValid = ()=>validations.isEmailVerified.value && validations.isPhoneVerified.value;
    const toJSON = ()=>({
            ...state
        });
    return {
        state,
        validations,
        isValid,
        toJSON
    };
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6r9MC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("4583104224879164");
    if (script.__esModule) script = script.default;
    script.render = require("ecfc4df9e651ed19").render;
    require("ef173a68982692bf").default(script);
    script.__scopeId = 'data-v-1efaa2';
    script.__file = "IndependentDriverSignupStepPersonalInfo.vue";
};
initialize();
exports.default = script;

},{"4583104224879164":"IR526","ecfc4df9e651ed19":"hN1q2","ef173a68982692bf":"dAZYJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IR526":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _version = require("jquery-ui/ui/version");
var _widget = require("jquery-ui/ui/widget");
var _uniqueId = require("jquery-ui/ui/unique-id");
var _position = require("jquery-ui/ui/position");
var _menu = require("jquery-ui/ui/widgets/menu");
var _autocomplete = require("jquery-ui/ui/widgets/autocomplete");
var _addressHelper = require("../utility/addressHelper");
exports.default = {
    __name: 'IndependentDriverSignupStepPersonalInfo',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const emailModified = (0, _vue.inject)('emailModified');
        const phoneModified = (0, _vue.inject)('phoneModified');
        const model = (0, _vue.useModel)(__props, "modelValue");
        let addressInput = (0, _vue.ref)(null);
        const isManualAddress = (0, _vue.ref)(false);
        const toggleManualAddress = ()=>{
            isManualAddress.value = !isManualAddress.value;
            if (!isManualAddress.value) {
                // Optionally clear fields when switching back to search
                model.value.address = '';
                model.value.city = '';
                model.value.state = '';
                model.value.country = '';
                model.value.postalCode = '';
                // Re-initialize autocomplete after DOM updates
                (0, _vue.nextTick)(()=>{
                    initAddressAutocomplete();
                });
            }
        };
        const parseAddressComponents = (addressComponents)=>{
            const parsed = {
                streetAddress: '',
                city: '',
                state: '',
                country: '',
                postalCode: ''
            };
            if (!addressComponents || !Array.isArray(addressComponents)) return parsed;
            let streetNumber;
            let routeName;
            addressComponents.forEach((component)=>{
                const types = component.types || [];
                if (types.includes('street_number')) streetNumber = component.long_name;
                else if (types.includes('route')) routeName = component.long_name;
                else if (types.includes('locality')) parsed.city = component.long_name;
                else if (!parsed.city && types.includes('postal_town')) parsed.city = component.long_name;
                else if (!parsed.city && types.includes('sublocality_level_1')) parsed.city = component.long_name;
                if (types.includes('administrative_area_level_1')) parsed.state = component.short_name;
                if (types.includes('country')) parsed.country = component.long_name;
                if (types.includes('postal_code')) parsed.postalCode = component.long_name;
            });
            if (streetNumber && routeName) parsed.streetAddress = `${streetNumber} ${routeName}`;
            return parsed;
        };
        const initAddressAutocomplete = ()=>{
            if (!addressInput.value) return;
            try {
                if ($(addressInput.value).data('ui-autocomplete')) $(addressInput.value).autocomplete('destroy');
                $(addressInput.value).autocomplete({
                    source: (request, response)=>{
                        fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(request.term)}`).then((res)=>res.ok ? res.json() : Promise.reject(res.status)).then((data)=>{
                            const suggestions = (data?.results || []).map((result)=>({
                                    label: (0, _addressHelper.renderWithPoi)(result),
                                    value: result.name,
                                    placeId: result.id,
                                    result
                                }));
                            response(suggestions);
                        }).catch(()=>response([]));
                    },
                    minLength: 3
                }).on('autocompleteselect', (event, ui)=>{
                    const selectedItem = ui.item;
                    // Clear the search box after selection
                    setTimeout(()=>{
                        if (addressInput.value) addressInput.value.value = '';
                    }, 0);
                    if (selectedItem?.placeId) {
                        model.value.placeId = selectedItem.placeId;
                        fetch(`/api/dispatch-ride/geocode-by-place-id?placeId=${encodeURIComponent(selectedItem.placeId)}`).then((res)=>res.ok ? res.json() : Promise.reject(res.status)).then((data)=>{
                            if (data?.results && data.results.length > 0) {
                                const addressComponents = data.results[0].address_components;
                                const parsed = parseAddressComponents(addressComponents);
                                if (parsed.streetAddress) model.value.address = parsed.streetAddress;
                                if (parsed.city) model.value.city = parsed.city;
                                if (parsed.state) model.value.state = parsed.state;
                                if (parsed.country) model.value.country = parsed.country;
                                if (parsed.postalCode) model.value.postalCode = parsed.postalCode;
                            }
                        }).catch((err)=>{
                            console.error('Failed to fetch address details:', err);
                        });
                    }
                }).autocomplete('instance')._renderItem = (ul, item)=>{
                    return $('<li>').append(item.label).appendTo(ul);
                };
            } catch (e) {
                console.error('Failed to init address autocomplete', e);
            }
        };
        (0, _vue.onMounted)(async ()=>{
            await (0, _vue.nextTick)();
            initAddressAutocomplete();
        });
        (0, _vue.onUnmounted)(()=>{
            try {
                if (addressInput.value) $(addressInput.value).autocomplete('destroy');
            } catch (e) {}
        });
        const __returned__ = {
            emailModified,
            phoneModified,
            model,
            get addressInput () {
                return addressInput;
            },
            set addressInput (v){
                addressInput = v;
            },
            isManualAddress,
            toggleManualAddress,
            parseAddressComponents,
            initAddressAutocomplete,
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            nextTick: (0, _vue.nextTick),
            inject: (0, _vue.inject),
            ref: (0, _vue.ref),
            get renderWithPoi () {
                return 0, _addressHelper.renderWithPoi;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","jquery-ui/ui/version":"3je9u","jquery-ui/ui/widget":"6clbD","jquery-ui/ui/unique-id":"2pYWd","jquery-ui/ui/position":"9caRa","jquery-ui/ui/widgets/menu":"gqKYI","jquery-ui/ui/widgets/autocomplete":"61AgU","../utility/addressHelper":"3Hmtq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3je9u":[function(require,module,exports,__globalThis) {
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.ui = $.ui || {};
    return $.ui.version = "1.14.2";
});

},{}],"2pYWd":[function(require,module,exports,__globalThis) {
/*!
 * jQuery UI Unique ID 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: https://api.jqueryui.com/uniqueId/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.fn.extend({
        uniqueId: function() {
            var uuid = 0;
            return function() {
                return this.each(function() {
                    if (!this.id) this.id = "ui-id-" + ++uuid;
                });
            };
        }(),
        removeUniqueId: function() {
            return this.each(function() {
                if (/^ui-id-\d+$/.test(this.id)) $(this).removeAttr("id");
            });
        }
    });
});

},{}],"9caRa":[function(require,module,exports,__globalThis) {
/*!
 * jQuery UI Position 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * https://api.jqueryui.com/position/
 */ //>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: https://api.jqueryui.com/position/
//>>demos: https://jqueryui.com/position/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    (function() {
        var cachedScrollbarWidth, max = Math.max, abs = Math.abs, rhorizontal = /left|center|right/, rvertical = /top|center|bottom/, roffset = /[\+\-]\d+(\.[\d]+)?%?/, rposition = /^\w+/, rpercent = /%$/, _position = $.fn.position;
        function getOffsets(offsets, width, height) {
            return [
                parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1),
                parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)
            ];
        }
        function parseCss(element, property) {
            return parseInt($.css(element, property), 10) || 0;
        }
        function isWindow(obj) {
            return obj != null && obj === obj.window;
        }
        function getDimensions(elem) {
            var raw = elem[0];
            if (raw.nodeType === 9) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: 0,
                    left: 0
                }
            };
            if (isWindow(raw)) return {
                width: elem.width(),
                height: elem.height(),
                offset: {
                    top: elem.scrollTop(),
                    left: elem.scrollLeft()
                }
            };
            if (raw.preventDefault) return {
                width: 0,
                height: 0,
                offset: {
                    top: raw.pageY,
                    left: raw.pageX
                }
            };
            return {
                width: elem.outerWidth(),
                height: elem.outerHeight(),
                offset: elem.offset()
            };
        }
        $.position = {
            scrollbarWidth: function() {
                if (cachedScrollbarWidth !== undefined) return cachedScrollbarWidth;
                var w1, w2, div = $("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>"), innerDiv = div.children()[0];
                $("body").append(div);
                w1 = innerDiv.offsetWidth;
                div.css("overflow", "scroll");
                w2 = innerDiv.offsetWidth;
                if (w1 === w2) w2 = div[0].clientWidth;
                div.remove();
                return cachedScrollbarWidth = w1 - w2;
            },
            getScrollInfo: function(within) {
                var overflowX = within.isWindow || within.isDocument ? "" : within.element.css("overflow-x"), overflowY = within.isWindow || within.isDocument ? "" : within.element.css("overflow-y"), hasOverflowX = overflowX === "scroll" || overflowX === "auto" && within.width < within.element[0].scrollWidth, hasOverflowY = overflowY === "scroll" || overflowY === "auto" && within.height < within.element[0].scrollHeight;
                return {
                    width: hasOverflowY ? $.position.scrollbarWidth() : 0,
                    height: hasOverflowX ? $.position.scrollbarWidth() : 0
                };
            },
            getWithinInfo: function(element) {
                var withinElement = $(element || window), isElemWindow = isWindow(withinElement[0]), isDocument = !!withinElement[0] && withinElement[0].nodeType === 9, hasOffset = !isElemWindow && !isDocument;
                return {
                    element: withinElement,
                    isWindow: isElemWindow,
                    isDocument: isDocument,
                    offset: hasOffset ? $(element).offset() : {
                        left: 0,
                        top: 0
                    },
                    scrollLeft: withinElement.scrollLeft(),
                    scrollTop: withinElement.scrollTop(),
                    width: withinElement.outerWidth(),
                    height: withinElement.outerHeight()
                };
            }
        };
        $.fn.position = function(options) {
            if (!options || !options.of) return _position.apply(this, arguments);
            // Make a copy, we don't want to modify arguments
            options = $.extend({}, options);
            var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions, // Make sure string options are treated as CSS selectors
            target = typeof options.of === "string" ? $(document).find(options.of) : $(options.of), within = $.position.getWithinInfo(options.within), scrollInfo = $.position.getScrollInfo(within), collision = (options.collision || "flip").split(" "), offsets = {};
            dimensions = getDimensions(target);
            if (target[0].preventDefault) // Force left top to allow flipping
            options.at = "left top";
            targetWidth = dimensions.width;
            targetHeight = dimensions.height;
            targetOffset = dimensions.offset;
            // Clone to reuse original targetOffset later
            basePosition = $.extend({}, targetOffset);
            // Force my and at to have valid horizontal and vertical positions
            // if a value is missing or invalid, it will be converted to center
            $.each([
                "my",
                "at"
            ], function() {
                var pos = (options[this] || "").split(" "), horizontalOffset, verticalOffset;
                if (pos.length === 1) pos = rhorizontal.test(pos[0]) ? pos.concat([
                    "center"
                ]) : rvertical.test(pos[0]) ? [
                    "center"
                ].concat(pos) : [
                    "center",
                    "center"
                ];
                pos[0] = rhorizontal.test(pos[0]) ? pos[0] : "center";
                pos[1] = rvertical.test(pos[1]) ? pos[1] : "center";
                // Calculate offsets
                horizontalOffset = roffset.exec(pos[0]);
                verticalOffset = roffset.exec(pos[1]);
                offsets[this] = [
                    horizontalOffset ? horizontalOffset[0] : 0,
                    verticalOffset ? verticalOffset[0] : 0
                ];
                // Reduce to just the positions without the offsets
                options[this] = [
                    rposition.exec(pos[0])[0],
                    rposition.exec(pos[1])[0]
                ];
            });
            // Normalize collision option
            if (collision.length === 1) collision[1] = collision[0];
            if (options.at[0] === "right") basePosition.left += targetWidth;
            else if (options.at[0] === "center") basePosition.left += targetWidth / 2;
            if (options.at[1] === "bottom") basePosition.top += targetHeight;
            else if (options.at[1] === "center") basePosition.top += targetHeight / 2;
            atOffset = getOffsets(offsets.at, targetWidth, targetHeight);
            basePosition.left += atOffset[0];
            basePosition.top += atOffset[1];
            return this.each(function() {
                var collisionPosition, using, elem = $(this), elemWidth = elem.outerWidth(), elemHeight = elem.outerHeight(), marginLeft = parseCss(this, "marginLeft"), marginTop = parseCss(this, "marginTop"), collisionWidth = elemWidth + marginLeft + parseCss(this, "marginRight") + scrollInfo.width, collisionHeight = elemHeight + marginTop + parseCss(this, "marginBottom") + scrollInfo.height, position = $.extend({}, basePosition), myOffset = getOffsets(offsets.my, elem.outerWidth(), elem.outerHeight());
                if (options.my[0] === "right") position.left -= elemWidth;
                else if (options.my[0] === "center") position.left -= elemWidth / 2;
                if (options.my[1] === "bottom") position.top -= elemHeight;
                else if (options.my[1] === "center") position.top -= elemHeight / 2;
                position.left += myOffset[0];
                position.top += myOffset[1];
                collisionPosition = {
                    marginLeft: marginLeft,
                    marginTop: marginTop
                };
                $.each([
                    "left",
                    "top"
                ], function(i, dir) {
                    if ($.ui.position[collision[i]]) $.ui.position[collision[i]][dir](position, {
                        targetWidth: targetWidth,
                        targetHeight: targetHeight,
                        elemWidth: elemWidth,
                        elemHeight: elemHeight,
                        collisionPosition: collisionPosition,
                        collisionWidth: collisionWidth,
                        collisionHeight: collisionHeight,
                        offset: [
                            atOffset[0] + myOffset[0],
                            atOffset[1] + myOffset[1]
                        ],
                        my: options.my,
                        at: options.at,
                        within: within,
                        elem: elem
                    });
                });
                if (options.using) // Adds feedback as second argument to using callback, if present
                using = function(props) {
                    var left = targetOffset.left - position.left, right = left + targetWidth - elemWidth, top = targetOffset.top - position.top, bottom = top + targetHeight - elemHeight, feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: elem,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                    if (targetWidth < elemWidth && abs(left + right) < targetWidth) feedback.horizontal = "center";
                    if (targetHeight < elemHeight && abs(top + bottom) < targetHeight) feedback.vertical = "middle";
                    if (max(abs(left), abs(right)) > max(abs(top), abs(bottom))) feedback.important = "horizontal";
                    else feedback.important = "vertical";
                    options.using.call(this, props, feedback);
                };
                elem.offset($.extend(position, {
                    using: using
                }));
            });
        };
        $.ui.position = {
            fit: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollLeft : within.offset.left, outerWidth = within.width, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = withinOffset - collisionPosLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset, newOverRight;
                    // Element is wider than within
                    if (data.collisionWidth > outerWidth) {
                        // Element is initially over the left side of within
                        if (overLeft > 0 && overRight <= 0) {
                            newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                            position.left += overLeft - newOverRight;
                        // Element is initially over right side of within
                        } else if (overRight > 0 && overLeft <= 0) position.left = withinOffset;
                        else if (overLeft > overRight) position.left = withinOffset + outerWidth - data.collisionWidth;
                        else position.left = withinOffset;
                    // Too far left -> align with left edge
                    } else if (overLeft > 0) position.left += overLeft;
                    else if (overRight > 0) position.left -= overRight;
                    else position.left = max(position.left - collisionPosLeft, position.left);
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.isWindow ? within.scrollTop : within.offset.top, outerHeight = data.within.height, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = withinOffset - collisionPosTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset, newOverBottom;
                    // Element is taller than within
                    if (data.collisionHeight > outerHeight) {
                        // Element is initially over the top of within
                        if (overTop > 0 && overBottom <= 0) {
                            newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                            position.top += overTop - newOverBottom;
                        // Element is initially over bottom of within
                        } else if (overBottom > 0 && overTop <= 0) position.top = withinOffset;
                        else if (overTop > overBottom) position.top = withinOffset + outerHeight - data.collisionHeight;
                        else position.top = withinOffset;
                    // Too far up -> align with top
                    } else if (overTop > 0) position.top += overTop;
                    else if (overBottom > 0) position.top -= overBottom;
                    else position.top = max(position.top - collisionPosTop, position.top);
                }
            },
            flip: {
                left: function(position, data) {
                    var within = data.within, withinOffset = within.offset.left + within.scrollLeft, outerWidth = within.width, offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left, collisionPosLeft = position.left - data.collisionPosition.marginLeft, overLeft = collisionPosLeft - offsetLeft, overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft, myOffset = data.my[0] === "left" ? -data.elemWidth : data.my[0] === "right" ? data.elemWidth : 0, atOffset = data.at[0] === "left" ? data.targetWidth : data.at[0] === "right" ? -data.targetWidth : 0, offset = -2 * data.offset[0], newOverRight, newOverLeft;
                    if (overLeft < 0) {
                        newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                        if (newOverRight < 0 || newOverRight < abs(overLeft)) position.left += myOffset + atOffset + offset;
                    } else if (overRight > 0) {
                        newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                        if (newOverLeft > 0 || abs(newOverLeft) < overRight) position.left += myOffset + atOffset + offset;
                    }
                },
                top: function(position, data) {
                    var within = data.within, withinOffset = within.offset.top + within.scrollTop, outerHeight = within.height, offsetTop = within.isWindow ? within.scrollTop : within.offset.top, collisionPosTop = position.top - data.collisionPosition.marginTop, overTop = collisionPosTop - offsetTop, overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop, top = data.my[1] === "top", myOffset = top ? -data.elemHeight : data.my[1] === "bottom" ? data.elemHeight : 0, atOffset = data.at[1] === "top" ? data.targetHeight : data.at[1] === "bottom" ? -data.targetHeight : 0, offset = -2 * data.offset[1], newOverTop, newOverBottom;
                    if (overTop < 0) {
                        newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                        if (newOverBottom < 0 || newOverBottom < abs(overTop)) position.top += myOffset + atOffset + offset;
                    } else if (overBottom > 0) {
                        newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                        if (newOverTop > 0 || abs(newOverTop) < overBottom) position.top += myOffset + atOffset + offset;
                    }
                }
            },
            flipfit: {
                left: function() {
                    $.ui.position.flip.left.apply(this, arguments);
                    $.ui.position.fit.left.apply(this, arguments);
                },
                top: function() {
                    $.ui.position.flip.top.apply(this, arguments);
                    $.ui.position.fit.top.apply(this, arguments);
                }
            }
        };
    })();
    return $.ui.position;
});

},{}],"gqKYI":[function(require,module,exports,__globalThis) {
/*!
 * jQuery UI Menu 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: https://api.jqueryui.com/menu/
//>>demos: https://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "../keycode",
        "../position",
        "../unique-id",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.widget("ui.menu", {
        version: "1.14.2",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {
                submenu: "ui-icon-caret-1-e"
            },
            items: "> *",
            menus: "ul",
            position: {
                my: "left top",
                at: "right top"
            },
            role: "menu",
            // Callbacks
            blur: null,
            focus: null,
            select: null
        },
        _create: function() {
            this.activeMenu = this.element;
            // Flag used to prevent firing of the click handler
            // as the event bubbles up through nested menus
            this.mouseHandled = false;
            this.lastMousePosition = {
                x: null,
                y: null
            };
            this.element.uniqueId().attr({
                role: this.options.role,
                tabIndex: 0
            });
            this._addClass("ui-menu", "ui-widget ui-widget-content");
            this._on({
                // Prevent focus from sticking to links inside menu after clicking
                // them (focus should always stay on UL during navigation).
                "mousedown .ui-menu-item": function(event) {
                    event.preventDefault();
                    this._activateItem(event);
                },
                "click .ui-menu-item": function(event) {
                    var target = $(event.target);
                    var active = $(this.document[0].activeElement);
                    if (!this.mouseHandled && target.not(".ui-state-disabled").length) {
                        this.select(event);
                        // Only set the mouseHandled flag if the event will bubble, see #9469.
                        if (!event.isPropagationStopped()) this.mouseHandled = true;
                        // Open submenu on click
                        if (target.has(".ui-menu").length) this.expand(event);
                        else if (!this.element.is(":focus") && active.closest(".ui-menu").length) {
                            // Redirect focus to the menu
                            this.element.trigger("focus", [
                                true
                            ]);
                            // If the active item is on the top level, let it stay active.
                            // Otherwise, blur the active item since it is no longer visible.
                            if (this.active && this.active.parents(".ui-menu").length === 1) clearTimeout(this.timer);
                        }
                    }
                },
                "mouseenter .ui-menu-item": "_activateItem",
                "mousemove .ui-menu-item": "_activateItem",
                mouseleave: "collapseAll",
                "mouseleave .ui-menu": "collapseAll",
                focus: function(event, keepActiveItem) {
                    // If there's already an active item, keep it active
                    // If not, activate the first item
                    var item = this.active || this._menuItems().first();
                    if (!keepActiveItem) this.focus(event, item);
                },
                blur: function(event) {
                    this._delay(function() {
                        var notContained = !$.contains(this.element[0], this.document[0].activeElement);
                        if (notContained) this.collapseAll(event);
                    });
                },
                keydown: "_keydown"
            });
            this.refresh();
            // Clicks outside of a menu collapse any open menus
            this._on(this.document, {
                click: function(event) {
                    if (this._closeOnDocumentClick(event)) this.collapseAll(event, true);
                    // Reset the mouseHandled flag
                    this.mouseHandled = false;
                }
            });
        },
        _activateItem: function(event) {
            // Ignore mouse events while typeahead is active, see #10458.
            // Prevents focusing the wrong item when typeahead causes a scroll while the mouse
            // is over an item in the menu
            if (this.previousFilter) return;
            // If the mouse didn't actually move, but the page was scrolled, ignore the event (#9356)
            if (event.clientX === this.lastMousePosition.x && event.clientY === this.lastMousePosition.y) return;
            this.lastMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var actualTarget = $(event.target).closest(".ui-menu-item"), target = $(event.currentTarget);
            // Ignore bubbled events on parent items, see #11641
            if (actualTarget[0] !== target[0]) return;
            // If the item is already active, there's nothing to do
            if (target.is(".ui-state-active")) return;
            // Remove ui-state-active class from siblings of the newly focused menu item
            // to avoid a jump caused by adjacent elements both having a class with a border
            this._removeClass(target.siblings().children(".ui-state-active"), null, "ui-state-active");
            this.focus(event, target);
        },
        _destroy: function() {
            var items = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"), submenus = items.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");
            // Destroy (sub)menus
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show();
            submenus.children().each(function() {
                var elem = $(this);
                if (elem.data("ui-menu-submenu-caret")) elem.remove();
            });
        },
        _keydown: function(event) {
            var match, prev, character, skip, preventDefault = true;
            switch(event.keyCode){
                case $.ui.keyCode.PAGE_UP:
                    this.previousPage(event);
                    break;
                case $.ui.keyCode.PAGE_DOWN:
                    this.nextPage(event);
                    break;
                case $.ui.keyCode.HOME:
                    this._move("first", "first", event);
                    break;
                case $.ui.keyCode.END:
                    this._move("last", "last", event);
                    break;
                case $.ui.keyCode.UP:
                    this.previous(event);
                    break;
                case $.ui.keyCode.DOWN:
                    this.next(event);
                    break;
                case $.ui.keyCode.LEFT:
                    this.collapse(event);
                    break;
                case $.ui.keyCode.RIGHT:
                    if (this.active && !this.active.is(".ui-state-disabled")) this.expand(event);
                    break;
                case $.ui.keyCode.ENTER:
                case $.ui.keyCode.SPACE:
                    this._activate(event);
                    break;
                case $.ui.keyCode.ESCAPE:
                    this.collapse(event);
                    break;
                default:
                    preventDefault = false;
                    prev = this.previousFilter || "";
                    skip = false;
                    // Support number pad values
                    character = event.keyCode >= 96 && event.keyCode <= 105 ? (event.keyCode - 96).toString() : String.fromCharCode(event.keyCode);
                    clearTimeout(this.filterTimer);
                    if (character === prev) skip = true;
                    else character = prev + character;
                    match = this._filterMenuItems(character);
                    match = skip && match.index(this.active.next()) !== -1 ? this.active.nextAll(".ui-menu-item") : match;
                    // If no matches on the current filter, reset to the last character pressed
                    // to move down the menu to the first item that starts with that character
                    if (!match.length) {
                        character = String.fromCharCode(event.keyCode);
                        match = this._filterMenuItems(character);
                    }
                    if (match.length) {
                        this.focus(event, match);
                        this.previousFilter = character;
                        this.filterTimer = this._delay(function() {
                            delete this.previousFilter;
                        }, 1000);
                    } else delete this.previousFilter;
            }
            if (preventDefault) event.preventDefault();
        },
        _activate: function(event) {
            if (this.active && !this.active.is(".ui-state-disabled")) {
                if (this.active.children("[aria-haspopup='true']").length) this.expand(event);
                else this.select(event);
            }
        },
        refresh: function() {
            var menus, items, newSubmenus, newItems, newWrappers, that = this, icon = this.options.icons.submenu, submenus = this.element.find(this.options.menus);
            this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length);
            // Initialize nested menus
            newSubmenus = submenus.filter(":not(.ui-menu)").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function() {
                var menu = $(this), item = menu.prev(), submenuCaret = $("<span>").data("ui-menu-submenu-caret", true);
                that._addClass(submenuCaret, "ui-menu-icon", "ui-icon " + icon);
                item.attr("aria-haspopup", "true").prepend(submenuCaret);
                menu.attr("aria-labelledby", item.attr("id"));
            });
            this._addClass(newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front");
            menus = submenus.add(this.element);
            items = menus.find(this.options.items);
            // Initialize menu-items containing spaces and/or dashes only as dividers
            items.not(".ui-menu-item").each(function() {
                var item = $(this);
                if (that._isDivider(item)) that._addClass(item, "ui-menu-divider", "ui-widget-content");
            });
            // Don't refresh list items that are already adapted
            newItems = items.not(".ui-menu-item, .ui-menu-divider");
            newWrappers = newItems.children().not(".ui-menu").uniqueId().attr({
                tabIndex: -1,
                role: this._itemRole()
            });
            this._addClass(newItems, "ui-menu-item")._addClass(newWrappers, "ui-menu-item-wrapper");
            // Add aria-disabled attribute to any disabled menu item
            items.filter(".ui-state-disabled").attr("aria-disabled", "true");
            // If the active item has been removed, blur the menu
            if (this.active && !$.contains(this.element[0], this.active[0])) this.blur();
        },
        _itemRole: function() {
            return ({
                menu: "menuitem",
                listbox: "option"
            })[this.options.role];
        },
        _setOption: function(key, value) {
            if (key === "icons") {
                var icons = this.element.find(".ui-menu-icon");
                this._removeClass(icons, null, this.options.icons.submenu)._addClass(icons, null, value.submenu);
            }
            this._super(key, value);
        },
        _setOptionDisabled: function(value) {
            this._super(value);
            this.element.attr("aria-disabled", String(value));
            this._toggleClass(null, "ui-state-disabled", !!value);
        },
        focus: function(event, item) {
            var nested, focused, activeParent;
            this.blur(event, event && event.type === "focus");
            this._scrollIntoView(item);
            this.active = item.first();
            focused = this.active.children(".ui-menu-item-wrapper");
            this._addClass(focused, null, "ui-state-active");
            // Only update aria-activedescendant if there's a role
            // otherwise we assume focus is managed elsewhere
            if (this.options.role) this.element.attr("aria-activedescendant", focused.attr("id"));
            // Highlight active parent menu item, if any
            activeParent = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper");
            this._addClass(activeParent, null, "ui-state-active");
            if (event && event.type === "keydown") this._close();
            else this.timer = this._delay(function() {
                this._close();
            }, this.delay);
            nested = item.children(".ui-menu");
            if (nested.length && event && /^mouse/.test(event.type)) this._startOpening(nested);
            this.activeMenu = item.parent();
            this._trigger("focus", event, {
                item: item
            });
        },
        _scrollIntoView: function(item) {
            var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
            if (this._hasScroll()) {
                borderTop = parseFloat($.css(this.activeMenu[0], "borderTopWidth")) || 0;
                paddingTop = parseFloat($.css(this.activeMenu[0], "paddingTop")) || 0;
                offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
                scroll = this.activeMenu.scrollTop();
                elementHeight = this.activeMenu.height();
                itemHeight = item.outerHeight();
                if (offset < 0) this.activeMenu.scrollTop(scroll + offset);
                else if (offset + itemHeight > elementHeight) this.activeMenu.scrollTop(scroll + offset - elementHeight + itemHeight);
            }
        },
        blur: function(event, fromFocus) {
            if (!fromFocus) clearTimeout(this.timer);
            if (!this.active) return;
            this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active");
            this._trigger("blur", event, {
                item: this.active
            });
            this.active = null;
        },
        _startOpening: function(submenu) {
            clearTimeout(this.timer);
            // Don't open if already open fixes a Firefox bug that caused a .5 pixel
            // shift in the submenu position when mousing over the caret icon
            if (submenu.attr("aria-hidden") !== "true") return;
            this.timer = this._delay(function() {
                this._close();
                this._open(submenu);
            }, this.delay);
        },
        _open: function(submenu) {
            var position = $.extend({
                of: this.active
            }, this.options.position);
            clearTimeout(this.timer);
            this.element.find(".ui-menu").not(submenu.parents(".ui-menu")).hide().attr("aria-hidden", "true");
            submenu.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(position);
        },
        collapseAll: function(event, all) {
            clearTimeout(this.timer);
            this.timer = this._delay(function() {
                // If we were passed an event, look for the submenu that contains the event
                var currentMenu = all ? this.element : $(event && event.target).closest(this.element.find(".ui-menu"));
                // If we found no valid submenu ancestor, use the main menu to close all
                // sub menus anyway
                if (!currentMenu.length) currentMenu = this.element;
                this._close(currentMenu);
                this.blur(event);
                // Work around active item staying active after menu is blurred
                this._removeClass(currentMenu.find(".ui-state-active"), null, "ui-state-active");
                this.activeMenu = currentMenu;
            }, all ? 0 : this.delay);
        },
        // With no arguments, closes the currently active menu - if nothing is active
        // it closes all menus.  If passed an argument, it will search for menus BELOW
        _close: function(startMenu) {
            if (!startMenu) startMenu = this.active ? this.active.parent() : this.element;
            startMenu.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false");
        },
        _closeOnDocumentClick: function(event) {
            return !$(event.target).closest(".ui-menu").length;
        },
        _isDivider: function(item) {
            // Match hyphen, em dash, en dash
            return !/[^\-\u2014\u2013\s]/.test(item.text());
        },
        collapse: function(event) {
            var newItem = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            if (newItem && newItem.length) {
                this._close();
                this.focus(event, newItem);
            }
        },
        expand: function(event) {
            var newItem = this.active && this._menuItems(this.active.children(".ui-menu")).first();
            if (newItem && newItem.length) {
                this._open(newItem.parent());
                // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
                this._delay(function() {
                    this.focus(event, newItem);
                });
            }
        },
        next: function(event) {
            this._move("next", "first", event);
        },
        previous: function(event) {
            this._move("prev", "last", event);
        },
        isFirstItem: function() {
            return this.active && !this.active.prevAll(".ui-menu-item").length;
        },
        isLastItem: function() {
            return this.active && !this.active.nextAll(".ui-menu-item").length;
        },
        _menuItems: function(menu) {
            return (menu || this.element).find(this.options.items).filter(".ui-menu-item");
        },
        _move: function(direction, filter, event) {
            var next;
            if (this.active) {
                if (direction === "first" || direction === "last") next = this.active[direction === "first" ? "prevAll" : "nextAll"](".ui-menu-item").last();
                else next = this.active[direction + "All"](".ui-menu-item").first();
            }
            if (!next || !next.length || !this.active) next = this._menuItems(this.activeMenu)[filter]();
            this.focus(event, next);
        },
        nextPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isLastItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.innerHeight();
                // jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
                if ($.fn.jquery.indexOf("3.2.") === 0) height += this.element[0].offsetHeight - this.element.outerHeight();
                this.active.nextAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base - height < 0;
                });
                this.focus(event, item);
            } else this.focus(event, this._menuItems(this.activeMenu)[!this.active ? "first" : "last"]());
        },
        previousPage: function(event) {
            var item, base, height;
            if (!this.active) {
                this.next(event);
                return;
            }
            if (this.isFirstItem()) return;
            if (this._hasScroll()) {
                base = this.active.offset().top;
                height = this.element.innerHeight();
                // jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
                if ($.fn.jquery.indexOf("3.2.") === 0) height += this.element[0].offsetHeight - this.element.outerHeight();
                this.active.prevAll(".ui-menu-item").each(function() {
                    item = $(this);
                    return item.offset().top - base + height > 0;
                });
                this.focus(event, item);
            } else this.focus(event, this._menuItems(this.activeMenu).first());
        },
        _hasScroll: function() {
            return this.element.outerHeight() < this.element.prop("scrollHeight");
        },
        select: function(event) {
            // TODO: It should never be possible to not have an active item at this
            // point, but the tests don't trigger mouseenter before click.
            this.active = this.active || $(event.target).closest(".ui-menu-item");
            var ui = {
                item: this.active
            };
            if (!this.active.has(".ui-menu").length) this.collapseAll(event, true);
            this._trigger("select", event, ui);
        },
        _filterMenuItems: function(character) {
            var escapedCharacter = character.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"), regex = new RegExp("^" + escapedCharacter, "i");
            return this.activeMenu.find(this.options.items)// Only match on items, not dividers or other content (#10571)
            .filter(".ui-menu-item").filter(function() {
                return regex.test(String.prototype.trim.call($(this).children(".ui-menu-item-wrapper").text()));
            });
        }
    });
});

},{}],"61AgU":[function(require,module,exports,__globalThis) {
/*!
 * jQuery UI Autocomplete 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: https://api.jqueryui.com/autocomplete/
//>>demos: https://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./menu",
        "../keycode",
        "../position",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.widget("ui.autocomplete", {
        version: "1.14.2",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: false,
            delay: 300,
            minLength: 1,
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            source: null,
            // Callbacks
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        liveRegionTimer: null,
        _create: function() {
            // Some browsers only repeat keydown events, not keypress events,
            // so we use the suppressKeyPress flag to determine if we've already
            // handled the keydown event. #7269
            // Unfortunately the code for & in keypress is the same as the up arrow,
            // so we use the suppressKeyPressRepeat flag to avoid handling keypress
            // events when we know the keydown event was used to modify the
            // search term. #7799
            var suppressKeyPress, suppressKeyPressRepeat, suppressInput, nodeName = this.element[0].nodeName.toLowerCase(), isTextarea = nodeName === "textarea", isInput = nodeName === "input";
            // Textareas are always multi-line
            // Inputs are always single-line, even if inside a contentEditable element
            // All other element types are determined by whether they're contentEditable
            this.isMultiLine = isTextarea || !isInput && this.element.prop("contentEditable") === "true";
            this.valueMethod = this.element[isTextarea || isInput ? "val" : "text"];
            this.isNewMenu = true;
            this._addClass("ui-autocomplete-input");
            this.element.attr("autocomplete", "off");
            this._on(this.element, {
                keydown: function(event) {
                    if (this.element.prop("readOnly")) {
                        suppressKeyPress = true;
                        suppressInput = true;
                        suppressKeyPressRepeat = true;
                        return;
                    }
                    suppressKeyPress = false;
                    suppressInput = false;
                    suppressKeyPressRepeat = false;
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            suppressKeyPress = true;
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            suppressKeyPress = true;
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            suppressKeyPress = true;
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            suppressKeyPress = true;
                            this._keyEvent("next", event);
                            break;
                        case keyCode.ENTER:
                            // when menu is open and has focus
                            if (this.menu.active) {
                                // #6055 - Opera still allows the keypress to occur
                                // which causes forms to submit
                                suppressKeyPress = true;
                                event.preventDefault();
                                this.menu.select(event);
                            }
                            break;
                        case keyCode.TAB:
                            if (this.menu.active) this.menu.select(event);
                            break;
                        case keyCode.ESCAPE:
                            if (this.menu.element.is(":visible")) {
                                if (!this.isMultiLine) this._value(this.term);
                                this.close(event);
                                // Different browsers have different default behavior for escape
                                // Single press can mean undo or clear
                                event.preventDefault();
                            }
                            break;
                        default:
                            suppressKeyPressRepeat = true;
                            // search timeout should be triggered before the input value is changed
                            this._searchTimeout(event);
                            break;
                    }
                },
                keypress: function(event) {
                    if (suppressKeyPress) {
                        suppressKeyPress = false;
                        if (!this.isMultiLine || this.menu.element.is(":visible")) event.preventDefault();
                        return;
                    }
                    if (suppressKeyPressRepeat) return;
                    // Replicate some key handlers to allow them to repeat in Firefox and Opera
                    var keyCode = $.ui.keyCode;
                    switch(event.keyCode){
                        case keyCode.PAGE_UP:
                            this._move("previousPage", event);
                            break;
                        case keyCode.PAGE_DOWN:
                            this._move("nextPage", event);
                            break;
                        case keyCode.UP:
                            this._keyEvent("previous", event);
                            break;
                        case keyCode.DOWN:
                            this._keyEvent("next", event);
                            break;
                    }
                },
                input: function(event) {
                    if (suppressInput) {
                        suppressInput = false;
                        event.preventDefault();
                        return;
                    }
                    this._searchTimeout(event);
                },
                focus: function() {
                    this.selectedItem = null;
                    this.previous = this._value();
                },
                blur: function(event) {
                    clearTimeout(this.searching);
                    this.close(event);
                    this._change(event);
                }
            });
            this._initSource();
            this.menu = $("<ul>").appendTo(this._appendTo()).menu({
                // disable ARIA support, the live region takes care of that
                role: null
            }).hide().menu("instance");
            this._addClass(this.menu.element, "ui-autocomplete", "ui-front");
            this._on(this.menu.element, {
                mousedown: function(event) {
                    // Prevent moving focus out of the text field
                    event.preventDefault();
                },
                menufocus: function(event, ui) {
                    var label, item;
                    // Support: Firefox
                    // Prevent accidental activation of menu items in Firefox (#7024 #9118)
                    if (this.isNewMenu) {
                        this.isNewMenu = false;
                        if (event.originalEvent && /^mouse/.test(event.originalEvent.type)) {
                            this.menu.blur();
                            this.document.one("mousemove", function() {
                                $(event.target).trigger(event.originalEvent);
                            });
                            return;
                        }
                    }
                    item = ui.item.data("ui-autocomplete-item");
                    if (false !== this._trigger("focus", event, {
                        item: item
                    })) // use value to match what will end up in the input, if it was a key event
                    {
                        if (event.originalEvent && /^key/.test(event.originalEvent.type)) this._value(item.value);
                    }
                    // Announce the value in the liveRegion
                    label = ui.item.attr("aria-label") || item.value;
                    if (label && String.prototype.trim.call(label).length) {
                        clearTimeout(this.liveRegionTimer);
                        this.liveRegionTimer = this._delay(function() {
                            this.liveRegion.html($("<div>").text(label));
                        }, 100);
                    }
                },
                menuselect: function(event, ui) {
                    var item = ui.item.data("ui-autocomplete-item"), previous = this.previous;
                    // Only trigger when focus was lost (click on menu)
                    if (this.element[0] !== this.document[0].activeElement) {
                        this.element.trigger("focus");
                        this.previous = previous;
                    }
                    if (false !== this._trigger("select", event, {
                        item: item
                    })) this._value(item.value);
                    // reset the term after the select event
                    // this allows custom select handling to work properly
                    this.term = this._value();
                    this.close(event);
                    this.selectedItem = item;
                }
            });
            this.liveRegion = $("<div>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body);
            this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible");
            // Turning off autocomplete prevents the browser from remembering the
            // value when navigating through history, so we re-enable autocomplete
            // if the page is unloaded before the widget is destroyed. #7790
            this._on(this.window, {
                beforeunload: function() {
                    this.element.removeAttr("autocomplete");
                }
            });
        },
        _destroy: function() {
            clearTimeout(this.searching);
            this.element.removeAttr("autocomplete");
            this.menu.element.remove();
            this.liveRegion.remove();
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "source") this._initSource();
            if (key === "appendTo") this.menu.element.appendTo(this._appendTo());
            if (key === "disabled" && value && this.xhr) this.xhr.abort();
        },
        _isEventTargetInWidget: function(event) {
            var menuElement = this.menu.element[0];
            return event.target === this.element[0] || event.target === menuElement || $.contains(menuElement, event.target);
        },
        _closeOnClickOutside: function(event) {
            if (!this._isEventTargetInWidget(event)) this.close();
        },
        _appendTo: function() {
            var element = this.options.appendTo;
            if (element) element = element.jquery || element.nodeType ? $(element) : this.document.find(element).eq(0);
            if (!element || !element[0]) element = this.element.closest(".ui-front, dialog");
            if (!element.length) element = this.document[0].body;
            return element;
        },
        _initSource: function() {
            var array, url, that = this;
            if (Array.isArray(this.options.source)) {
                array = this.options.source;
                this.source = function(request, response) {
                    response($.ui.autocomplete.filter(array, request.term));
                };
            } else if (typeof this.options.source === "string") {
                url = this.options.source;
                this.source = function(request, response) {
                    if (that.xhr) that.xhr.abort();
                    that.xhr = $.ajax({
                        url: url,
                        data: request,
                        dataType: "json",
                        success: function(data) {
                            response(data);
                        },
                        error: function() {
                            response([]);
                        }
                    });
                };
            } else this.source = this.options.source;
        },
        _searchTimeout: function(event) {
            clearTimeout(this.searching);
            this.searching = this._delay(function() {
                // Search if the value has changed, or if the user retypes the same value (see #7434)
                var equalValues = this.term === this._value(), menuVisible = this.menu.element.is(":visible"), modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
                if (!equalValues || equalValues && !menuVisible && !modifierKey) {
                    this.selectedItem = null;
                    this.search(null, event);
                }
            }, this.options.delay);
        },
        search: function(value, event) {
            value = value != null ? value : this._value();
            // Always save the actual value, not the one passed as an argument
            this.term = this._value();
            if (value.length < this.options.minLength) return this.close(event);
            if (this._trigger("search", event) === false) return;
            return this._search(value);
        },
        _search: function(value) {
            this.pending++;
            this._addClass("ui-autocomplete-loading");
            this.cancelSearch = false;
            this.source({
                term: value
            }, this._response());
        },
        _response: function() {
            var index = ++this.requestIndex;
            return (function(content) {
                if (index === this.requestIndex) this.__response(content);
                this.pending--;
                if (!this.pending) this._removeClass("ui-autocomplete-loading");
            }).bind(this);
        },
        __response: function(content) {
            if (content) content = this._normalize(content);
            this._trigger("response", null, {
                content: content
            });
            if (!this.options.disabled && content && content.length && !this.cancelSearch) {
                this._suggest(content);
                this._trigger("open");
            } else // use ._close() instead of .close() so we don't cancel future searches
            this._close();
        },
        close: function(event) {
            this.cancelSearch = true;
            this._close(event);
        },
        _close: function(event) {
            // Remove the handler that closes the menu on outside clicks
            this._off(this.document, "mousedown");
            if (this.menu.element.is(":visible")) {
                this.menu.element.hide();
                this.menu.blur();
                this.isNewMenu = true;
                this._trigger("close", event);
            }
        },
        _change: function(event) {
            if (this.previous !== this._value()) this._trigger("change", event, {
                item: this.selectedItem
            });
        },
        _normalize: function(items) {
            // assume all items have the right format when the first item is complete
            if (items.length && items[0].label && items[0].value) return items;
            return $.map(items, function(item) {
                if (typeof item === "string") return {
                    label: item,
                    value: item
                };
                return $.extend({}, item, {
                    label: item.label || item.value,
                    value: item.value || item.label
                });
            });
        },
        _suggest: function(items) {
            var ul = this.menu.element.empty();
            this._renderMenu(ul, items);
            this.isNewMenu = true;
            this.menu.refresh();
            // Size and position menu
            ul.show();
            this._resizeMenu();
            ul.position($.extend({
                of: this.element
            }, this.options.position));
            if (this.options.autoFocus) this.menu.next();
            // Listen for interactions outside of the widget (#6642)
            this._on(this.document, {
                mousedown: "_closeOnClickOutside"
            });
        },
        _resizeMenu: function() {
            var ul = this.menu.element;
            ul.outerWidth(Math.max(// Firefox wraps long text (possibly a rounding bug)
            // so we add 1px to avoid the wrapping (#7513)
            ul.width("").outerWidth() + 1, this.element.outerWidth()));
        },
        _renderMenu: function(ul, items) {
            var that = this;
            $.each(items, function(index, item) {
                that._renderItemData(ul, item);
            });
        },
        _renderItemData: function(ul, item) {
            return this._renderItem(ul, item).data("ui-autocomplete-item", item);
        },
        _renderItem: function(ul, item) {
            return $("<li>").append($("<div>").text(item.label)).appendTo(ul);
        },
        _move: function(direction, event) {
            if (!this.menu.element.is(":visible")) {
                this.search(null, event);
                return;
            }
            if (this.menu.isFirstItem() && /^previous/.test(direction) || this.menu.isLastItem() && /^next/.test(direction)) {
                if (!this.isMultiLine) this._value(this.term);
                this.menu.blur();
                return;
            }
            this.menu[direction](event);
        },
        widget: function() {
            return this.menu.element;
        },
        _value: function() {
            return this.valueMethod.apply(this.element, arguments);
        },
        _keyEvent: function(keyEvent, event) {
            if (!this.isMultiLine || this.menu.element.is(":visible")) {
                this._move(keyEvent, event);
                // Prevents moving cursor to beginning/end of the text field in some browsers
                event.preventDefault();
            }
        }
    });
    $.extend($.ui.autocomplete, {
        escapeRegex: function(value) {
            return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        },
        filter: function(array, term) {
            var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
            return $.grep(array, function(value) {
                return matcher.test(value.label || value.value || value);
            });
        }
    });
    // Live region extension, adding a `messages` option
    // NOTE: This is an experimental API. We are still investigating
    // a full solution for string manipulation and internationalization.
    $.widget("ui.autocomplete", $.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function(amount) {
                    return amount + (amount > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
                }
            }
        },
        __response: function(content) {
            var message;
            this._superApply(arguments);
            if (this.options.disabled || this.cancelSearch) return;
            if (content && content.length) message = this.options.messages.results(content.length);
            else message = this.options.messages.noResults;
            clearTimeout(this.liveRegionTimer);
            this.liveRegionTimer = this._delay(function() {
                this.liveRegion.html($("<div>").text(message));
            }, 100);
        }
    });
    return $.ui.autocomplete;
});

},{}],"hN1q2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "signup-step signup-step-personal"
};
const _hoisted_2 = {
    class: "row g-3"
};
const _hoisted_3 = {
    class: "col-md-6"
};
const _hoisted_4 = {
    key: 0,
    class: "text-warning mt-1",
    style: {
        "font-size": "0.85rem"
    }
};
const _hoisted_5 = {
    class: "col-md-6"
};
const _hoisted_6 = {
    class: "col-md-6"
};
const _hoisted_7 = {
    class: "col-md-6"
};
const _hoisted_8 = {
    class: "col-md-6"
};
const _hoisted_9 = {
    class: "col-md-6"
};
const _hoisted_10 = {
    class: "col-md-6"
};
const _hoisted_11 = {
    class: "input-group"
};
const _hoisted_12 = {
    key: 0,
    class: "text-warning mt-1",
    style: {
        "font-size": "0.85rem"
    }
};
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    key: 0,
    class: "col-12"
};
const _hoisted_15 = {
    id: "signup-address-search",
    class: "form-control",
    type: "text",
    placeholder: "Search for your address...",
    ref: "addressInput"
};
const _hoisted_16 = {
    key: 1,
    class: "col-12"
};
const _hoisted_17 = {
    class: "col-12"
};
const _hoisted_18 = [
    "readonly"
];
const _hoisted_19 = {
    class: "col-md-6"
};
const _hoisted_20 = [
    "readonly"
];
const _hoisted_21 = {
    class: "col-md-6"
};
const _hoisted_22 = [
    "readonly"
];
const _hoisted_23 = {
    class: "col-md-6"
};
const _hoisted_24 = [
    "readonly"
];
const _hoisted_25 = {
    class: "col-md-6"
};
const _hoisted_26 = [
    "readonly"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[49] || (_cache[49] = (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("h5", {
                    class: "text-primary mb-3"
                }, "Account Information")
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-email-input"
                }, [
                    (0, _vue.createTextVNode)("Email "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-email-input",
                    class: "form-control",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.model.email = $event),
                    placeholder: "you@example.com",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.email
                    ]
                ]),
                $setup.emailModified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, _cache[14] || (_cache[14] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-circle-exclamation me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)(" Email changed. Re-verification required. ")
                ]))) : (0, _vue.createCommentVNode)("", true),
                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                    id: "signup-email-error",
                    class: "invalid-feedback d-none"
                }, "Please enter a valid email address.", -1))
            ]),
            _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("div", {
                class: "col-md-6"
            }, null, -1)),
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-password-input"
                }, [
                    (0, _vue.createTextVNode)("Password "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-password-input",
                    class: "form-control",
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.model.password = $event),
                    placeholder: "Minimum 8 characters",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.password
                    ]
                ]),
                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "Password must be at least 8 characters.", -1)),
                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                    id: "signup-password-error",
                    class: "invalid-feedback d-none"
                }, "Password must be at least 8 characters.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_6, [
                _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-confirm-password-input"
                }, [
                    (0, _vue.createTextVNode)("Confirm Password "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-confirm-password-input",
                    class: "form-control",
                    type: "password",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.model.confirmPassword = $event),
                    placeholder: "Re-enter your password",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.confirmPassword
                    ]
                ]),
                _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("div", {
                    id: "signup-confirm-password-error",
                    class: "invalid-feedback d-none"
                }, "Passwords do not match.", -1))
            ]),
            _cache[51] || (_cache[51] = (0, _vue.createElementVNode)("div", {
                class: "col-12 mt-4"
            }, [
                (0, _vue.createElementVNode)("h5", {
                    class: "text-primary mb-3"
                }, "Personal Information")
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-first-name-input"
                }, [
                    (0, _vue.createTextVNode)("First Name "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-first-name-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.model.firstName = $event),
                    placeholder: "e.g., Jane",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.firstName
                    ]
                ]),
                _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                    id: "signup-first-name-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your first name.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-last-name-input"
                }, [
                    (0, _vue.createTextVNode)("Last Name "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-last-name-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.lastName = $event),
                    placeholder: "e.g., Doe",
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.lastName
                    ]
                ]),
                _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                    id: "signup-last-name-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your last name.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_9, [
                _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-dob-input"
                }, [
                    (0, _vue.createTextVNode)("Date of Birth "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-dob-input",
                    class: "form-control",
                    type: "date",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.model.dateOfBirth = $event),
                    required: ""
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.dateOfBirth
                    ]
                ]),
                _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "You must be at least 25 years old to drive.", -1)),
                _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("div", {
                    id: "signup-dob-error",
                    class: "invalid-feedback d-none"
                }, "Please provide a valid date of birth. You must be at least 25 years old. ", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-phone-number-input"
                }, [
                    (0, _vue.createTextVNode)("Phone Number "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_11, [
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                        class: "form-select",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.model.countryCode = $event),
                        style: {
                            "max-width": "120px"
                        }
                    }, _cache[29] || (_cache[29] = [
                        (0, _vue.createElementVNode)("option", {
                            value: "+1"
                        }, "+1 (US)", -1),
                        (0, _vue.createElementVNode)("option", {
                            value: "+1"
                        }, "+1 (CA)", -1)
                    ]), 512), [
                        [
                            (0, _vue.vModelSelect),
                            $setup.model.countryCode
                        ]
                    ]),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        id: "signup-phone-number-input",
                        class: "form-control",
                        type: "tel",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.model.phoneNumber = $event),
                        placeholder: "5551234567",
                        required: ""
                    }, null, 512), [
                        [
                            (0, _vue.vModelText),
                            $setup.model.phoneNumber
                        ]
                    ])
                ]),
                $setup.phoneModified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, _cache[30] || (_cache[30] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-circle-exclamation me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)(" Phone number changed. Re-verification required. ")
                ]))) : (0, _vue.createCommentVNode)("", true),
                _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("small", {
                    class: "text-muted"
                }, "Select country code and enter the rest of your phone number.", -1)),
                _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("div", {
                    id: "signup-phone-number-error",
                    class: "invalid-feedback d-none"
                }, "Please enter a valid phone number.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_13, [
                _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-referral-code-input"
                }, [
                    (0, _vue.createTextVNode)("Referral Code "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-muted small"
                    }, "(optional)")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-referral-code-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.model.referralCode = $event),
                    placeholder: "e.g., ABC12345"
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.referralCode
                    ]
                ]),
                _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("div", {
                    id: "signup-referral-code-error",
                    class: "invalid-feedback d-none"
                }, "This referral code isn't valid.", -1))
            ]),
            _cache[52] || (_cache[52] = (0, _vue.createElementVNode)("div", {
                class: "col-12 mt-4"
            }, [
                (0, _vue.createElementVNode)("h5", {
                    class: "text-primary mb-1"
                }, "Address"),
                (0, _vue.createElementVNode)("p", {
                    class: "text-muted small mb-3"
                }, " Search for your address using the search bar below. If you can't find it, click \"Enter address manually\" to type it in yourself. ")
            ], -1)),
            !$setup.isManualAddress ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, [
                _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-address-search"
                }, [
                    (0, _vue.createTextVNode)("Address Search "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.createElementVNode)("input", _hoisted_15, null, 512),
                (0, _vue.createElementVNode)("div", {
                    class: "mt-2"
                }, [
                    (0, _vue.createElementVNode)("a", {
                        href: "javascript:void(0)",
                        onClick: $setup.toggleManualAddress,
                        class: "text-primary small f-w-600"
                    }, " Can't find your address? Enter address manually ")
                ])
            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_16, [
                (0, _vue.createElementVNode)("div", {
                    class: "alert alert-info py-2 mb-3"
                }, [
                    _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-circle-info me-2"
                    }, null, -1)),
                    _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("span", {
                        class: "small"
                    }, "You are now in manual entry mode. Please fill out all address fields below.", -1)),
                    (0, _vue.createElementVNode)("a", {
                        href: "javascript:void(0)",
                        onClick: $setup.toggleManualAddress,
                        class: "ms-2 text-primary small f-w-600"
                    }, " Switch back to search ")
                ])
            ])),
            (0, _vue.createElementVNode)("div", _hoisted_17, [
                _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-address-input"
                }, [
                    (0, _vue.createTextVNode)("Street Address "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-address-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.model.address = $event),
                    placeholder: "123 Main Street",
                    required: "",
                    readonly: !$setup.isManualAddress
                }, null, 8, _hoisted_18), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.address
                    ]
                ]),
                _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("div", {
                    id: "signup-address-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your street address.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_19, [
                _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-city-input"
                }, [
                    (0, _vue.createTextVNode)("City "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-city-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.model.city = $event),
                    placeholder: "e.g., San Francisco",
                    required: "",
                    readonly: !$setup.isManualAddress
                }, null, 8, _hoisted_20), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.city
                    ]
                ]),
                _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("div", {
                    id: "signup-city-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your city.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_21, [
                _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-state-input"
                }, [
                    (0, _vue.createTextVNode)("State/Province "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-state-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.model.state = $event),
                    placeholder: "e.g., CA",
                    required: "",
                    readonly: !$setup.isManualAddress
                }, null, 8, _hoisted_22), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.state
                    ]
                ]),
                _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("div", {
                    id: "signup-state-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your state.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_23, [
                _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-country-input"
                }, [
                    (0, _vue.createTextVNode)("Country "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-country-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.model.country = $event),
                    placeholder: "e.g., United States",
                    required: "",
                    readonly: !$setup.isManualAddress
                }, null, 8, _hoisted_24), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.country
                    ]
                ]),
                _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("div", {
                    id: "signup-country-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your country.", -1))
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_25, [
                _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("label", {
                    class: "form-label f-w-600",
                    for: "signup-postal-code-input"
                }, [
                    (0, _vue.createTextVNode)("Postal Code "),
                    (0, _vue.createElementVNode)("span", {
                        class: "text-danger"
                    }, "*")
                ], -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "signup-postal-code-input",
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.model.postalCode = $event),
                    placeholder: "e.g., 94102",
                    required: "",
                    readonly: !$setup.isManualAddress
                }, null, 8, _hoisted_26), [
                    [
                        (0, _vue.vModelText),
                        $setup.model.postalCode
                    ]
                ]),
                _cache[48] || (_cache[48] = (0, _vue.createElementVNode)("div", {
                    id: "signup-postal-code-error",
                    class: "invalid-feedback d-none"
                }, "Please enter your postal code.", -1))
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dAZYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMtB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("35ddf0f3cb956d0c");
    if (script.__esModule) script = script.default;
    script.render = require("a884c206023e4de").render;
    require("1304a49b41f01fd").default(script);
    script.__scopeId = 'data-v-b31bc5';
    script.__file = "IndependentDriverSignupStepVerification.vue";
};
initialize();
exports.default = script;

},{"35ddf0f3cb956d0c":"8sz9E","a884c206023e4de":"g5Fbi","1304a49b41f01fd":"lctLZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sz9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'IndependentDriverSignupStepVerification',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: __expose }) {
        __expose();
        const model = (0, _vue.useModel)(__props, "modelValue");
        const personalInfo = (0, _vue.inject)('personalInfo');
        const emailCode = (0, _vue.ref)('');
        const phoneCode = (0, _vue.ref)('');
        const emailVerified = (0, _vue.ref)(model.value.emailVerified || false);
        const phoneVerified = (0, _vue.ref)(model.value.phoneVerified || false);
        const emailSending = (0, _vue.ref)(false);
        const phoneSending = (0, _vue.ref)(false);
        const emailVerifying = (0, _vue.ref)(false);
        const phoneVerifying = (0, _vue.ref)(false);
        const emailSent = (0, _vue.ref)(false);
        const phoneSent = (0, _vue.ref)(false);
        const emailCooldown = (0, _vue.ref)(0);
        const phoneCooldown = (0, _vue.ref)(0);
        // Reset flags when verification status changes (e.g. from parent component)
        (0, _vue.watch)(()=>model.value.emailVerified, (newVal)=>{
            emailVerified.value = newVal;
            if (newVal === false) {
                emailSent.value = false;
                emailCode.value = '';
            }
        }, {
            immediate: true
        });
        (0, _vue.watch)(()=>model.value.phoneVerified, (newVal)=>{
            phoneVerified.value = newVal;
            if (newVal === false) {
                phoneSent.value = false;
                phoneCode.value = '';
            }
        }, {
            immediate: true
        });
        const sendEmailOtp = async ()=>{
            if (emailSending.value || emailCooldown.value > 0) return;
            const email = personalInfo?.email;
            if (!email) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Please enter your email address first.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
                return;
            }
            emailSending.value = true;
            try {
                const res = await fetch('/api/independent-driver-signup/send-email-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email
                    })
                });
                if (res.ok) {
                    emailSent.value = true;
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Code Sent',
                        body: 'A verification code has been sent to your email.',
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                    startEmailCooldown();
                } else {
                    const errorText = await res.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: errorText || 'Failed to send verification code.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                }
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Network error. Please try again.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
            } finally{
                emailSending.value = false;
            }
        };
        const sendPhoneOtp = async ()=>{
            if (phoneSending.value || phoneCooldown.value > 0) return;
            const phone = `${personalInfo?.countryCode}${personalInfo?.phoneNumber}`;
            if (!personalInfo?.phoneNumber) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Please enter your phone number first.',
                    type: 'error'
                });
                return;
            }
            phoneSending.value = true;
            try {
                const res = await fetch('/api/independent-driver-signup/send-phone-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        phoneNumber: phone
                    })
                });
                if (res.ok) {
                    phoneSent.value = true;
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Code Sent',
                        body: 'A verification code has been sent to your phone.',
                        type: 'success'
                    });
                    startPhoneCooldown();
                } else {
                    const errorText = await res.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: errorText || 'Failed to send verification code.',
                        type: 'error'
                    });
                }
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Network error. Please try again.',
                    type: 'error'
                });
            } finally{
                phoneSending.value = false;
            }
        };
        const verifyEmailOtp = async ()=>{
            if (emailVerifying.value || !emailCode.value) return;
            emailVerifying.value = true;
            try {
                const res = await fetch('/api/independent-driver-signup/verify-email-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: personalInfo?.email,
                        code: emailCode.value
                    })
                });
                if (res.ok) {
                    emailVerified.value = true;
                    model.value.emailVerified = true;
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Verified',
                        body: 'Email verified successfully!',
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                } else {
                    const errorText = await res.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Invalid Code',
                        body: errorText || 'The code you entered is incorrect.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                }
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Network error. Please try again.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
            } finally{
                emailVerifying.value = false;
            }
        };
        const verifyPhoneOtp = async ()=>{
            if (phoneVerifying.value || !phoneCode.value) return;
            phoneVerifying.value = true;
            try {
                const phone = `${personalInfo?.countryCode}${personalInfo?.phoneNumber}`;
                const res = await fetch('/api/independent-driver-signup/verify-phone-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        phoneNumber: phone,
                        code: phoneCode.value
                    })
                });
                if (res.ok) {
                    phoneVerified.value = true;
                    model.value.phoneVerified = true;
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Verified',
                        body: 'Phone number verified successfully!',
                        type: (0, _toastNotificationUtility.notificationType).SUCCESS
                    });
                } else {
                    const errorText = await res.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Invalid Code',
                        body: errorText || 'The code you entered is incorrect.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR
                    });
                }
            } catch (e) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Error',
                    body: 'Network error. Please try again.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR
                });
            } finally{
                phoneVerifying.value = false;
            }
        };
        const startEmailCooldown = ()=>{
            emailCooldown.value = 60;
            const interval = setInterval(()=>{
                emailCooldown.value--;
                if (emailCooldown.value <= 0) clearInterval(interval);
            }, 1000);
        };
        const startPhoneCooldown = ()=>{
            phoneCooldown.value = 60;
            const interval = setInterval(()=>{
                phoneCooldown.value--;
                if (phoneCooldown.value <= 0) clearInterval(interval);
            }, 1000);
        };
        (0, _vue.onMounted)(()=>{
            emailVerified.value = model.value.emailVerified || false;
            phoneVerified.value = model.value.phoneVerified || false;
        });
        const __returned__ = {
            model,
            personalInfo,
            emailCode,
            phoneCode,
            emailVerified,
            phoneVerified,
            emailSending,
            phoneSending,
            emailVerifying,
            phoneVerifying,
            emailSent,
            phoneSent,
            emailCooldown,
            phoneCooldown,
            sendEmailOtp,
            sendPhoneOtp,
            verifyEmailOtp,
            verifyPhoneOtp,
            startEmailCooldown,
            startPhoneCooldown,
            ref: (0, _vue.ref),
            inject: (0, _vue.inject),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5Fbi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "signup-step signup-step-verification"
};
const _hoisted_2 = {
    class: "row g-4"
};
const _hoisted_3 = {
    class: "col-md-6"
};
const _hoisted_4 = {
    class: "card h-100"
};
const _hoisted_5 = {
    class: "card-header bg-info"
};
const _hoisted_6 = {
    class: "mb-0"
};
const _hoisted_7 = {
    key: 0,
    class: "badge bg-success ms-2"
};
const _hoisted_8 = {
    class: "card-body"
};
const _hoisted_9 = {
    class: "bold fs-6"
};
const _hoisted_10 = {
    key: 0
};
const _hoisted_11 = {
    key: 0,
    class: "d-grid"
};
const _hoisted_12 = [
    "disabled"
];
const _hoisted_13 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_14 = {
    key: 1
};
const _hoisted_15 = {
    class: "input-group mb-3"
};
const _hoisted_16 = [
    "disabled"
];
const _hoisted_17 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_18 = [
    "disabled"
];
const _hoisted_19 = {
    key: 1,
    class: "text-center py-3"
};
const _hoisted_20 = {
    class: "col-md-6"
};
const _hoisted_21 = {
    class: "card h-100"
};
const _hoisted_22 = {
    class: "card-header bg-info"
};
const _hoisted_23 = {
    class: "mb-0"
};
const _hoisted_24 = {
    key: 0,
    class: "badge bg-success ms-2"
};
const _hoisted_25 = {
    class: "card-body"
};
const _hoisted_26 = {
    class: "bold fs-6"
};
const _hoisted_27 = {
    key: 0
};
const _hoisted_28 = {
    key: 0,
    class: "d-grid"
};
const _hoisted_29 = [
    "disabled"
];
const _hoisted_30 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_31 = {
    key: 1
};
const _hoisted_32 = {
    class: "input-group mb-3"
};
const _hoisted_33 = [
    "disabled"
];
const _hoisted_34 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_35 = [
    "disabled"
];
const _hoisted_36 = {
    key: 1,
    class: "text-center py-3"
};
const _hoisted_37 = {
    key: 0,
    class: "col-12"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("h5", {
                    class: "text-primary mb-3"
                }, "Verify Your Contact Information"),
                (0, _vue.createElementVNode)("p", {
                    class: "text-muted"
                }, "Please verify your email address and phone number to continue with registration.")
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        (0, _vue.createElementVNode)("h6", _hoisted_6, [
                            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-envelope me-2"
                            }, null, -1)),
                            _cache[4] || (_cache[4] = (0, _vue.createTextVNode)("Email Verification ")),
                            $setup.emailVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_7, _cache[2] || (_cache[2] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-check"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Verified")
                            ]))) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                        (0, _vue.createElementVNode)("p", _hoisted_9, (0, _vue.toDisplayString)($setup.personalInfo?.email || 'No email provided'), 1),
                        !$setup.emailVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
                            !$setup.emailSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-outline-primary",
                                    onClick: $setup.sendEmailOtp,
                                    disabled: $setup.emailSending || $setup.emailCooldown > 0
                                }, [
                                    $setup.emailSending ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_13)) : (0, _vue.createCommentVNode)("", true),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.emailCooldown > 0 ? `Resend in ${$setup.emailCooldown}s` : 'Send Verification Code'), 1)
                                ], 8, _hoisted_12)
                            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, [
                                _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                                    class: "form-label"
                                }, "Enter the 6-digit code sent to your email:", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_15, [
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.emailCode = $event),
                                        placeholder: "Enter code",
                                        maxlength: "6",
                                        pattern: "[0-9]*"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.emailCode
                                        ]
                                    ]),
                                    (0, _vue.createElementVNode)("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: $setup.verifyEmailOtp,
                                        disabled: $setup.emailVerifying || $setup.emailCode.length < 4
                                    }, [
                                        $setup.emailVerifying ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_17)) : (0, _vue.createCommentVNode)("", true),
                                        _cache[5] || (_cache[5] = (0, _vue.createTextVNode)(" Verify "))
                                    ], 8, _hoisted_16)
                                ]),
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-link btn-sm p-0",
                                    onClick: $setup.sendEmailOtp,
                                    disabled: $setup.emailSending || $setup.emailCooldown > 0
                                }, (0, _vue.toDisplayString)($setup.emailCooldown > 0 ? `Resend in ${$setup.emailCooldown}s` : 'Resend Code'), 9, _hoisted_18)
                            ]))
                        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_19, _cache[7] || (_cache[7] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-check text-success fa-3x"
                            }, null, -1),
                            (0, _vue.createElementVNode)("p", {
                                class: "mt-2 mb-0 text-success"
                            }, "Email verified!", -1)
                        ])))
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_20, [
                (0, _vue.createElementVNode)("div", _hoisted_21, [
                    (0, _vue.createElementVNode)("div", _hoisted_22, [
                        (0, _vue.createElementVNode)("h6", _hoisted_23, [
                            _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-phone me-2"
                            }, null, -1)),
                            _cache[10] || (_cache[10] = (0, _vue.createTextVNode)("Phone Verification ")),
                            $setup.phoneVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_24, _cache[8] || (_cache[8] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa-solid fa-check"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" Verified")
                            ]))) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_25, [
                        (0, _vue.createElementVNode)("p", _hoisted_26, (0, _vue.toDisplayString)($setup.personalInfo?.countryCode) + (0, _vue.toDisplayString)($setup.personalInfo?.phoneNumber || 'No phone provided'), 1),
                        !$setup.phoneVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_27, [
                            !$setup.phoneSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, [
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-outline-primary",
                                    onClick: $setup.sendPhoneOtp,
                                    disabled: $setup.phoneSending || $setup.phoneCooldown > 0
                                }, [
                                    $setup.phoneSending ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_30)) : (0, _vue.createCommentVNode)("", true),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.phoneCooldown > 0 ? `Resend in ${$setup.phoneCooldown}s` : 'Send Verification Code'), 1)
                                ], 8, _hoisted_29)
                            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_31, [
                                _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                    class: "form-label"
                                }, "Enter the 6-digit code sent to your phone:", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_32, [
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.phoneCode = $event),
                                        placeholder: "Enter code",
                                        maxlength: "6",
                                        pattern: "[0-9]*"
                                    }, null, 512), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.phoneCode
                                        ]
                                    ]),
                                    (0, _vue.createElementVNode)("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: $setup.verifyPhoneOtp,
                                        disabled: $setup.phoneVerifying || $setup.phoneCode.length < 4
                                    }, [
                                        $setup.phoneVerifying ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_34)) : (0, _vue.createCommentVNode)("", true),
                                        _cache[11] || (_cache[11] = (0, _vue.createTextVNode)(" Verify "))
                                    ], 8, _hoisted_33)
                                ]),
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-link btn-sm p-0",
                                    onClick: $setup.sendPhoneOtp,
                                    disabled: $setup.phoneSending || $setup.phoneCooldown > 0
                                }, (0, _vue.toDisplayString)($setup.phoneCooldown > 0 ? `Resend in ${$setup.phoneCooldown}s` : 'Resend Code'), 9, _hoisted_35)
                            ]))
                        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_36, _cache[13] || (_cache[13] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-circle-check text-success fa-3x"
                            }, null, -1),
                            (0, _vue.createElementVNode)("p", {
                                class: "mt-2 mb-0 text-success"
                            }, "Phone verified!", -1)
                        ])))
                    ])
                ])
            ]),
            !$setup.emailVerified || !$setup.phoneVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_37, _cache[14] || (_cache[14] = [
                (0, _vue.createElementVNode)("div", {
                    class: "alert alert-warning"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-exclamation-triangle me-2"
                    }),
                    (0, _vue.createTextVNode)(" Both email and phone number must be verified before you can proceed to the next step. ")
                ], -1)
            ]))) : (0, _vue.createCommentVNode)("", true)
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lctLZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2XR9T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("6de623387e13b0a4");
    if (script.__esModule) script = script.default;
    script.render = require("2fb58174dd762878").render;
    script.__cssModules = require("a89d3f0a63fb4129").default;
    require("1962fa5d79b3fe54").default(script);
    script.__scopeId = 'data-v-0359cc';
    script.__file = "IndependentDriverSignupStepReview.vue";
};
initialize();
exports.default = script;

},{"6de623387e13b0a4":"hSJUz","2fb58174dd762878":"wkHH9","a89d3f0a63fb4129":"7SZ3m","1962fa5d79b3fe54":"h8rtu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hSJUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'IndependentDriverSignupStepReview',
    props: {
        "modelValue": {
            type: Object,
            default: ()=>({})
        },
        "modelModifiers": {}
    },
    emits: /*@__PURE__*/ (0, _vue.mergeModels)([
        'editStep'
    ], [
        "update:modelValue"
    ]),
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const model = (0, _vue.useModel)(__props, "modelValue");
        const emit = __emit;
        const personalInfo = (0, _vue.inject)('personalInfo');
        const vehicleInfo = (0, _vue.inject)('vehicleInfo');
        const documentsInfo = (0, _vue.inject)('documentsInfo');
        const stepIndex = (0, _vue.inject)('stepIndex');
        function goToStep(index) {
            emit('editStep', index);
        }
        const __returned__ = {
            model,
            emit,
            personalInfo,
            vehicleInfo,
            documentsInfo,
            stepIndex,
            goToStep,
            inject: (0, _vue.inject)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wkHH9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "signup-step signup-step-review"
};
const _hoisted_2 = {
    class: "row g-4"
};
const _hoisted_3 = {
    class: "col-md-6"
};
const _hoisted_4 = {
    class: "card h-100"
};
const _hoisted_5 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_6 = {
    class: "card-body"
};
const _hoisted_7 = {
    class: "row mb-0"
};
const _hoisted_8 = {
    class: "col-sm-8"
};
const _hoisted_9 = {
    class: "col-sm-8"
};
const _hoisted_10 = {
    class: "col-sm-8"
};
const _hoisted_11 = {
    class: "col-sm-8"
};
const _hoisted_12 = {
    class: "col-sm-8"
};
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    class: "card h-100"
};
const _hoisted_15 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_16 = {
    class: "card-body"
};
const _hoisted_17 = {
    class: "row mb-0"
};
const _hoisted_18 = {
    class: "col-sm-8"
};
const _hoisted_19 = {
    class: "col-sm-8"
};
const _hoisted_20 = {
    class: "col-sm-8"
};
const _hoisted_21 = {
    class: "col-sm-8"
};
const _hoisted_22 = {
    class: "col-sm-8"
};
const _hoisted_23 = {
    class: "col-sm-8"
};
const _hoisted_24 = {
    class: "col-sm-8"
};
const _hoisted_25 = {
    class: "col-md-6"
};
const _hoisted_26 = {
    class: "card h-100"
};
const _hoisted_27 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_28 = {
    class: "card-body"
};
const _hoisted_29 = {
    class: "row mb-0"
};
const _hoisted_30 = {
    class: "col-sm-6"
};
const _hoisted_31 = {
    key: 0,
    class: "text-success"
};
const _hoisted_32 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_33 = {
    class: "col-sm-6"
};
const _hoisted_34 = {
    key: 0,
    class: "text-success"
};
const _hoisted_35 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_36 = {
    class: "col-sm-6"
};
const _hoisted_37 = {
    class: "col-sm-6"
};
const _hoisted_38 = {
    key: 0,
    class: "text-success"
};
const _hoisted_39 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_40 = {
    class: "col-sm-6"
};
const _hoisted_41 = {
    class: "col-12"
};
const _hoisted_42 = {
    class: "card"
};
const _hoisted_43 = {
    class: "card-body"
};
const _hoisted_44 = {
    class: "form-check mb-3"
};
const _hoisted_45 = {
    class: "form-check mb-3"
};
const _hoisted_46 = {
    class: "form-check mb-3"
};
const _hoisted_47 = {
    class: "form-check mb-3"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("h5", {
                    class: "text-primary mb-3"
                }, "Review Your Information"),
                (0, _vue.createElementVNode)("p", {
                    class: "text-muted"
                }, "Please review all your information before submitting your registration.")
            ], -1)),
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("h6", {
                            class: "mb-0"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-user me-2"
                            }),
                            (0, _vue.createTextVNode)("Personal Information")
                        ], -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link btn-sm p-0",
                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.goToStep($setup.stepIndex.PERSONAL))
                        }, _cache[7] || (_cache[7] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-pen"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Edit ")
                        ]))
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        (0, _vue.createElementVNode)("dl", _hoisted_7, [
                            _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Name", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_8, (0, _vue.toDisplayString)($setup.personalInfo?.firstName) + " " + (0, _vue.toDisplayString)($setup.personalInfo?.lastName), 1),
                            _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Email", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_9, (0, _vue.toDisplayString)($setup.personalInfo?.email), 1),
                            _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Phone", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_10, (0, _vue.toDisplayString)($setup.personalInfo?.countryCode) + (0, _vue.toDisplayString)($setup.personalInfo?.phoneNumber), 1),
                            _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Date of Birth", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_11, (0, _vue.toDisplayString)($setup.personalInfo?.dateOfBirth), 1),
                            _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Address", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_12, [
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.personalInfo?.address), 1),
                                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("br", null, null, -1)),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.personalInfo?.city) + ", " + (0, _vue.toDisplayString)($setup.personalInfo?.state) + " " + (0, _vue.toDisplayString)($setup.personalInfo?.postalCode), 1),
                                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("br", null, null, -1)),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.personalInfo?.country), 1)
                            ])
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_13, [
                (0, _vue.createElementVNode)("div", _hoisted_14, [
                    (0, _vue.createElementVNode)("div", _hoisted_15, [
                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("h6", {
                            class: "mb-0"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-car me-2"
                            }),
                            (0, _vue.createTextVNode)("Vehicle Information")
                        ], -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link btn-sm p-0",
                            onClick: _cache[1] || (_cache[1] = ($event)=>$setup.goToStep($setup.stepIndex.VEHICLE))
                        }, _cache[16] || (_cache[16] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-pen"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Edit ")
                        ]))
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                        (0, _vue.createElementVNode)("dl", _hoisted_17, [
                            _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Make", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_18, (0, _vue.toDisplayString)($setup.vehicleInfo?.make), 1),
                            _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Model", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_19, (0, _vue.toDisplayString)($setup.vehicleInfo?.model), 1),
                            _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Year", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_20, (0, _vue.toDisplayString)($setup.vehicleInfo?.year), 1),
                            _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Color", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_21, (0, _vue.toDisplayString)($setup.vehicleInfo?.color), 1),
                            _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Plate Number", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_22, (0, _vue.toDisplayString)($setup.vehicleInfo?.plateNumber), 1),
                            _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Odometer", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_23, (0, _vue.toDisplayString)($setup.vehicleInfo?.odometer ? $setup.vehicleInfo.odometer.toLocaleString() + ' km' : 'Not set'), 1),
                            _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-4"
                            }, "Vehicle Type", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_24, (0, _vue.toDisplayString)($setup.vehicleInfo?.vehicleType), 1)
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_25, [
                (0, _vue.createElementVNode)("div", _hoisted_26, [
                    (0, _vue.createElementVNode)("div", _hoisted_27, [
                        _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("h6", {
                            class: "mb-0"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-file me-2"
                            }),
                            (0, _vue.createTextVNode)("Documents")
                        ], -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link btn-sm p-0",
                            onClick: _cache[2] || (_cache[2] = ($event)=>$setup.goToStep($setup.stepIndex.DOCUMENTS))
                        }, _cache[25] || (_cache[25] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-pen"
                            }, null, -1),
                            (0, _vue.createTextVNode)(" Edit ")
                        ]))
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_28, [
                        (0, _vue.createElementVNode)("dl", _hoisted_29, [
                            _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-6"
                            }, "License (Front)", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_30, [
                                $setup.documentsInfo?.driverLicenseFront || $setup.documentsInfo?.hasLicenseDocument ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_31, [
                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-check-circle"
                                    }, null, -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.documentsInfo?.driverLicenseFront?.name || 'Uploaded'), 1)
                                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_32, _cache[28] || (_cache[28] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-exclamation-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Not uploaded ")
                                ])))
                            ]),
                            _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-6"
                            }, "License (Back)", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_33, [
                                $setup.documentsInfo?.driverLicenseBack || $setup.documentsInfo?.hasLicenseDocument ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_34, [
                                    _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-check-circle"
                                    }, null, -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.documentsInfo?.driverLicenseBack?.name || 'Uploaded'), 1)
                                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_35, _cache[30] || (_cache[30] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-exclamation-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Not uploaded ")
                                ])))
                            ]),
                            _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-6"
                            }, "License Expiry", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_36, (0, _vue.toDisplayString)($setup.documentsInfo?.licenseExpiryDate || 'Not set'), 1),
                            _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-6"
                            }, "Insurance Certificate (Pink Slip)", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_37, [
                                $setup.documentsInfo?.hasInsuranceDocument ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_38, _cache[31] || (_cache[31] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-check-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Uploaded ")
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_39, _cache[32] || (_cache[32] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-exclamation-circle"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Not uploaded ")
                                ])))
                            ]),
                            _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("dt", {
                                class: "col-sm-6"
                            }, "Insurance Expiry", -1)),
                            (0, _vue.createElementVNode)("dd", _hoisted_40, (0, _vue.toDisplayString)($setup.documentsInfo?.insuranceExpiryDate || 'Not set'), 1)
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_41, [
                (0, _vue.createElementVNode)("div", _hoisted_42, [
                    _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h6", {
                            class: "mb-0"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa-solid fa-shield-check me-2"
                            }),
                            (0, _vue.createTextVNode)("Agreements")
                        ])
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                        (0, _vue.createElementVNode)("div", _hoisted_44, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "agreeToBackgroundCheck",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.model.agreedToBackgroundCheck = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelCheckbox),
                                    $setup.model.agreedToBackgroundCheck
                                ]
                            ]),
                            _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("label", {
                                class: "form-check-label",
                                for: "agreeToBackgroundCheck"
                            }, " I authorize Asher Rides to conduct a background check including criminal history and motor vehicle record (MVR) verification. I understand this is required for approval. ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_45, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "agreeToEligibility",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.model.agreedToEligibility = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelCheckbox),
                                    $setup.model.agreedToEligibility
                                ]
                            ]),
                            _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                                class: "form-check-label",
                                for: "agreeToEligibility"
                            }, " I confirm I am at least 25 years old and legally eligible to work in Canada as an independent contractor. ", -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_46, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "agreeToTerms",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.model.agreedToTerms = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelCheckbox),
                                    $setup.model.agreedToTerms
                                ]
                            ]),
                            _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("label", {
                                class: "form-check-label",
                                for: "agreeToTerms"
                            }, [
                                (0, _vue.createTextVNode)(" I have read and agree to the "),
                                (0, _vue.createElementVNode)("a", {
                                    href: "https://asherrides.notion.site/terms-and-conditions?pvs=143",
                                    target: "_blank"
                                }, "Terms of Service"),
                                (0, _vue.createTextVNode)(", "),
                                (0, _vue.createElementVNode)("a", {
                                    href: "https://asherrides.notion.site/privacy-policy?pvs=143",
                                    target: "_blank"
                                }, "Privacy Policy"),
                                (0, _vue.createTextVNode)(", and "),
                                (0, _vue.createElementVNode)("a", {
                                    href: "https://asherrides.notion.site/independent-contractor-driver-policy?pvs=74",
                                    target: "_blank"
                                }, "Independent Contractor Agreement"),
                                (0, _vue.createTextVNode)(". ")
                            ], -1))
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_47, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "agreeToAccuracy",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.model.agreedToAccuracy = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelCheckbox),
                                    $setup.model.agreedToAccuracy
                                ]
                            ]),
                            _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("label", {
                                class: "form-check-label",
                                for: "agreeToAccuracy"
                            }, " I confirm all information provided is accurate and complete. ", -1))
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7SZ3m":[function() {},{}],"h8rtu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4oi0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("328f37c0506af38b");
    if (script.__esModule) script = script.default;
    script.render = require("29b2e7348c1a6570").render;
    script.__cssModules = require("14010474fcb102c8").default;
    require("6cc6a0777a5ca683").default(script);
    script.__scopeId = 'data-v-136d21';
    script.__file = "JurisdictionCheckModal.vue";
};
initialize();
exports.default = script;

},{"328f37c0506af38b":"9yPUD","29b2e7348c1a6570":"f5oST","14010474fcb102c8":"5YC9R","6cc6a0777a5ca683":"jdxHw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9yPUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'JurisdictionCheckModal',
    props: {
        apiKey: {
            type: String,
            required: true
        }
    },
    emits: [
        'validated'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const autocompleteInput = (0, _vue.ref)(null);
        const selectedPlace = (0, _vue.ref)(null);
        const isValidating = (0, _vue.ref)(false);
        const errorMessage = (0, _vue.ref)('');
        async function loadGoogleMapsScript() {
            if (window.google && window.google.maps && window.google.maps.importLibrary) {
                await initAutocomplete();
                return;
            }
            const scriptId = 'google-maps-places-script';
            if (!document.getElementById(scriptId)) {
                const script = document.createElement('script');
                script.id = scriptId;
                script.src = `https://maps.googleapis.com/maps/api/js?key=${props.apiKey}&loading=async`;
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }
            await new Promise((resolve)=>{
                const check = setInterval(()=>{
                    if (window.google && window.google.maps && window.google.maps.importLibrary) {
                        clearInterval(check);
                        resolve();
                    }
                }, 100);
            });
            await initAutocomplete();
        }
        async function initAutocomplete() {
            const { Autocomplete } = await window.google.maps.importLibrary('places');
            const autocomplete = new Autocomplete(autocompleteInput.value, {
                types: [
                    'postal_code'
                ],
                componentRestrictions: {
                    country: 'CA'
                }
            });
            autocomplete.addListener('place_changed', ()=>{
                const place = autocomplete.getPlace();
                if (!place.place_id) {
                    selectedPlace.value = null;
                    return;
                }
                selectedPlace.value = place;
                errorMessage.value = '';
            });
        }
        async function validateLocation() {
            if (!selectedPlace.value) return;
            isValidating.value = true;
            errorMessage.value = '';
            try {
                const response = await fetch('/api/independent-driver-signup/validate-jurisdiction', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        placeId: selectedPlace.value.place_id
                    })
                });
                const data = await response.json();
                if (response.ok && data.valid) emit('validated');
                else errorMessage.value = data.message || 'We could not validate your location. Please try another postal code.';
            } catch (error) {
                console.error('Validation error:', error);
                errorMessage.value = 'An error occurred during validation. Please try again.';
            } finally{
                isValidating.value = false;
            }
        }
        (0, _vue.onMounted)(async ()=>{
            await loadGoogleMapsScript();
        });
        const __returned__ = {
            props,
            emit,
            autocompleteInput,
            selectedPlace,
            isValidating,
            errorMessage,
            loadGoogleMapsScript,
            initAutocomplete,
            validateLocation,
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5oST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "jurisdiction-modal-overlay"
};
const _hoisted_2 = {
    class: "jurisdiction-modal-card card shadow-lg"
};
const _hoisted_3 = {
    class: "card-body p-4 text-center"
};
const _hoisted_4 = {
    class: "search-container mb-4 position-relative"
};
const _hoisted_5 = [
    "disabled"
];
const _hoisted_6 = {
    key: 0,
    class: "spinner-border spinner-border-sm position-absolute end-0 top-50 translate-middle-y me-3 text-primary"
};
const _hoisted_7 = {
    key: 0,
    class: "alert alert-warning mb-4",
    role: "alert"
};
const _hoisted_8 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[1] || (_cache[1] = (0, _vue.createStaticVNode)("<div class=\"mb-4\" data-v-136d21><div class=\"jurisdiction-icon mb-3\" data-v-136d21><i class=\"fa-solid fa-location-dot fa-3x text-primary\" data-v-136d21></i></div><h3 class=\"fw-bold\" data-v-136d21>Where do you want to drive?</h3><p class=\"text-muted\" data-v-136d21>Enter your postal code to see if we operate in your area.</p></div>", 1)),
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("input", {
                        ref: "autocompleteInput",
                        type: "text",
                        class: "form-control form-control-lg",
                        placeholder: "Enter your postal code...",
                        disabled: $setup.isValidating
                    }, null, 8, _hoisted_5),
                    $setup.isValidating ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6)) : (0, _vue.createCommentVNode)("", true)
                ]),
                $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-circle-exclamation me-2"
                    }, null, -1)),
                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.errorMessage), 1)
                ])) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createElementVNode)("button", {
                    onClick: $setup.validateLocation,
                    class: "btn btn-primary btn-lg w-100",
                    disabled: !$setup.selectedPlace || $setup.isValidating
                }, (0, _vue.toDisplayString)($setup.isValidating ? 'Checking...' : 'Check Availability'), 9, _hoisted_8)
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YC9R":[function() {},{}],"jdxHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOzEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal position-relative"
};
const _hoisted_2 = {
    key: 1,
    class: "saving-overlay"
};
const _hoisted_3 = {
    class: "card-header ar-signup-header d-flex justify-content-between align-items-start flex-wrap gap-2"
};
const _hoisted_4 = {
    key: 2,
    class: "card-body py-5"
};
const _hoisted_5 = {
    class: "text-center mb-4"
};
const _hoisted_6 = {
    class: "text-muted mb-4"
};
const _hoisted_7 = {
    class: "text-center"
};
const _hoisted_8 = [
    "href"
];
const _hoisted_9 = {
    id: "independent-driver-signup-wizard"
};
const _hoisted_10 = {
    class: "card-body p-3 p-md-4"
};
const _hoisted_11 = {
    class: "horizontal-wizard-wrapper"
};
const _hoisted_12 = {
    class: "row"
};
const _hoisted_13 = {
    class: "col-12 tab-content dark-field p-2 p-sm-3 p-md-4"
};
const _hoisted_14 = {
    class: "tab-pane fade active show wizard-content",
    id: "signup-step-personal",
    role: "tabpanel"
};
const _hoisted_15 = {
    class: "tab-pane fade wizard-content",
    id: "signup-step-verification",
    role: "tabpanel"
};
const _hoisted_16 = {
    class: "tab-pane fade wizard-content",
    id: "signup-step-vehicle",
    role: "tabpanel"
};
const _hoisted_17 = {
    class: "tab-pane fade wizard-content",
    id: "signup-step-documents",
    role: "tabpanel"
};
const _hoisted_18 = {
    class: "tab-pane fade wizard-content",
    id: "signup-step-review",
    role: "tabpanel"
};
const _hoisted_19 = {
    class: "card-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        !$setup.isJurisdictionValidated ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["JurisdictionCheckModal"], {
            key: 0,
            "api-key": $props.googleMapsApiKey,
            onValidated: $setup.onJurisdictionValidated
        }, null, 8, [
            "api-key"
        ])) : (0, _vue.createCommentVNode)("", true),
        $setup.isSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, _cache[5] || (_cache[5] = [
            (0, _vue.createElementVNode)("div", {
                class: "spinner-border text-primary",
                role: "status",
                "aria-live": "polite"
            }, [
                (0, _vue.createElementVNode)("span", {
                    class: "visually-hidden"
                }, "Processing...")
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", _hoisted_3, _cache[6] || (_cache[6] = [
            (0, _vue.createStaticVNode)("<div data-v-48c6eb><h2 class=\"mb-1\" data-v-48c6eb>Become an Independent Driver</h2><p class=\"mb-0 text-muted\" data-v-48c6eb>Complete the steps below to register as an independent driver.</p></div><div class=\"text-nowrap\" data-v-48c6eb><span class=\"text-muted me-1\" data-v-48c6eb>Already have an account?</span><a href=\"/driver/login\" class=\"ar-signup-link fw-semibold\" data-v-48c6eb>Log in</a></div>", 2)
        ]), 512), [
            [
                (0, _vue.vShow),
                $setup.isJurisdictionValidated && !$setup.submittedState
            ]
        ]),
        $setup.submittedState && $setup.isJurisdictionValidated ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, [
            (0, _vue.createElementVNode)("div", _hoisted_5, [
                _cache[11] || (_cache[11] = (0, _vue.createStaticVNode)("<div class=\"mb-3\" data-v-48c6eb><span class=\"d-inline-flex align-items-center justify-content-center rounded-circle\" style=\"width:80px;height:80px;background:rgba(255,193,7,0.15);\" data-v-48c6eb><i class=\"fa-solid fa-hourglass-half text-warning\" style=\"font-size:2.2rem;\" data-v-48c6eb></i></span></div><h3 class=\"mb-1\" data-v-48c6eb>Application Submitted</h3><span class=\"badge bg-warning text-dark px-3 py-2 fs-6 mb-3\" data-v-48c6eb>Pending Review</span>", 3)),
                (0, _vue.createElementVNode)("p", _hoisted_6, [
                    _cache[7] || (_cache[7] = (0, _vue.createTextVNode)(" Your application has been received and is currently under review.")),
                    _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("br", null, null, -1)),
                    _cache[9] || (_cache[9] = (0, _vue.createTextVNode)(" We'll send an email to ")),
                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.form.personalInfo.email), 1),
                    _cache[10] || (_cache[10] = (0, _vue.createTextVNode)(" with updates. "))
                ])
            ]),
            _cache[13] || (_cache[13] = (0, _vue.createStaticVNode)('<div class="card border mb-4" data-v-48c6eb><div class="card-body" data-v-48c6eb><h6 class="f-w-600 mb-3" data-v-48c6eb><i class="fa-solid fa-list-check me-2 text-primary" data-v-48c6eb></i>What happens next?</h6><ol class="mb-0 ps-3 text-muted small" data-v-48c6eb><li class="mb-2" data-v-48c6eb>Our team will verify your license and insurance documents (2\u20133 business days).</li><li class="mb-2" data-v-48c6eb>A background check will be initiated once your documents are approved.</li><li class="mb-2" data-v-48c6eb>You&#39;ll need to complete your Stripe payout setup and upload vehicle &amp; profile photos.</li><li data-v-48c6eb>Once everything clears, you&#39;ll receive an approval email and can start accepting rides.</li></ol></div></div>', 1)),
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                (0, _vue.createElementVNode)("a", {
                    href: $setup.submittedState.redirectUrl,
                    class: "btn btn-primary px-4"
                }, _cache[12] || (_cache[12] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa-solid fa-arrow-up-right-from-square me-2"
                    }, null, -1),
                    (0, _vue.createTextVNode)("View Full Application Status ")
                ]), 8, _hoisted_8)
            ])
        ])) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", _hoisted_9, [
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                (0, _vue.createElementVNode)("div", _hoisted_11, [
                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                            class: "col-12 main-horizontal-header mb-3 border-1"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "nav nav-pills horizontal-options",
                                role: "tablist",
                                "aria-orientation": "horizontal"
                            }, [
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#signup-step-personal",
                                    role: "tab",
                                    "aria-selected": "true"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-id-card"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Personal Info")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#signup-step-verification",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-shield-check"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Verification")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#signup-step-vehicle",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-car"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Vehicle")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#signup-step-documents",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-file-upload"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Documents")
                                        ])
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("a", {
                                    class: "nav-link",
                                    "data-bs-toggle": "pill",
                                    href: "#signup-step-review",
                                    role: "tab",
                                    "aria-selected": "false"
                                }, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: "horizontal-wizard"
                                    }, [
                                        (0, _vue.createElementVNode)("div", {
                                            class: "stroke-icon-wizard"
                                        }, [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa-solid fa-clipboard-check"
                                            })
                                        ]),
                                        (0, _vue.createElementVNode)("div", {
                                            class: "horizontal-wizard-content"
                                        }, [
                                            (0, _vue.createElementVNode)("h5", {
                                                class: "f-w-600"
                                            }, "Review")
                                        ])
                                    ])
                                ])
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                            (0, _vue.createElementVNode)("div", _hoisted_14, [
                                (0, _vue.createVNode)($setup["IndependentDriverSignupStepPersonalInfo"], {
                                    modelValue: $setup.form.personalInfo,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.form.personalInfo = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_15, [
                                (0, _vue.createVNode)($setup["IndependentDriverSignupStepVerification"], {
                                    modelValue: $setup.form.verification,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.form.verification = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_16, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepVehicleInfo"], {
                                    modelValue: $setup.form.vehicleInfo,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.form.vehicleInfo = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_17, [
                                (0, _vue.createVNode)($setup["DriverOnboardingStepDocumentUpload"], {
                                    ref: "documentsStep",
                                    modelValue: $setup.form.documents,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.form.documents = $event)
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_18, [
                                (0, _vue.createVNode)($setup["IndependentDriverSignupStepReview"], {
                                    modelValue: $setup.form.review,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.form.review = $event),
                                    onEditStep: $setup.goToStep
                                }, null, 8, [
                                    "modelValue"
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", _hoisted_19, _cache[15] || (_cache[15] = [
                (0, _vue.createElementVNode)("div", {
                    id: "independent-driver-signup-navigation"
                }, null, -1)
            ]), 512), [
                [
                    (0, _vue.vShow),
                    !$setup.submittedState
                ]
            ])
        ], 512), [
            [
                (0, _vue.vShow),
                $setup.isJurisdictionValidated && !$setup.submittedState
            ]
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilhN1":[function() {},{}],"egVs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkajR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b312ca34cf5d1f38");
    if (script.__esModule) script = script.default;
    script.render = require("9ba5e2706432313a").render;
    require("b3d1f52058d1a02d").default(script);
    script.__scopeId = 'data-v-11ea5e';
    script.__file = "ServiceJurisdictions.vue";
};
initialize();
exports.default = script;

},{"b312ca34cf5d1f38":"lycEa","9ba5e2706432313a":"lVn3Y","b3d1f52058d1a02d":"4gFKo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lycEa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'ServiceJurisdictions',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const jurisdictionsDataTable = (0, _vue.ref)(null);
        const jurisdictionColumns = [
            {
                data: 'name',
                title: 'Name'
            },
            {
                data: 'serviceArea.name',
                title: 'Service Area',
                render: (data, type, row)=>{
                    return row.serviceArea ? row.serviceArea.name : '<span class="text-muted">Not Assigned</span>';
                }
            },
            {
                data: 'serviceAreaAllowance',
                title: 'Allowance (km)',
                render: (data)=>{
                    return data ? `${data} km` : 'N/A';
                }
            },
            {
                data: 'commissionPercentage',
                title: 'Commission',
                render: (data)=>{
                    return data !== null && data !== undefined ? `${data}%` : '0%';
                }
            },
            {
                data: 'active',
                title: 'Status',
                render: (0, _datatableRenderer.activeBadgeRender)
            },
            {
                title: 'Action',
                orderable: false,
                searchable: false,
                render: (data, type, row, meta)=>{
                    return `<a class="btn btn-sm btn-outline-primary" href="/admin/service-jurisdictions/${row.id}">
                <i class="fas fa-pen-to-square"></i> Edit</a>`;
                }
            }
        ];
        const __returned__ = {
            jurisdictionsDataTable,
            jurisdictionColumns,
            ref: (0, _vue.ref),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get activeBadgeRender () {
                return 0, _datatableRenderer.activeBadgeRender;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVn3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body social-list filter-cards-view"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, _vue.createStaticVNode)("<div class=\"page-title\"><div class=\"row\"><div class=\"col-sm-6 col-12\"><h2> Service Jurisdictions </h2></div><div class=\"col-sm-6 col-12 text-end\"><a class=\"btn btn-primary align-items-center\" href=\"/admin/service-jurisdictions/new\"><i class=\"fa-regular fa-square-plus\"></i> Add New </a></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: `/api/datatable/service-jurisdictions`
                            },
                            ref: "jurisdictionsDataTable",
                            class: "table-responsive display",
                            columns: $setup.jurisdictionColumns
                        }, null, 512)
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4gFKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"27YIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("ff02ef89c9bd55ce");
    if (script.__esModule) script = script.default;
    script.render = require("f3834311a94aaa37").render;
    require("eb969e1f9cd68c16").default(script);
    script.__scopeId = 'data-v-9c9507';
    script.__file = "ServiceJurisdictionDetail.vue";
};
initialize();
exports.default = script;

},{"ff02ef89c9bd55ce":"fSegF","f3834311a94aaa37":"778du","eb969e1f9cd68c16":"9oOSi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fSegF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _datetimeLocal = require("../utility/datetimeLocal");
var _serviceJurisdiction = require("../modelTemplates/ServiceJurisdiction");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _fareConfigurationComponentVue = require("./FareConfigurationComponent.vue");
var _fareConfigurationComponentVueDefault = parcelHelpers.interopDefault(_fareConfigurationComponentVue);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'ServiceJurisdictionDetail',
    props: {
        googleMapsApiKey: {
            type: String,
            required: true
        },
        jurisdictionId: {
            type: String,
            default: null
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const jurisdiction = (0, _vue.ref)({});
        const geoZones = (0, _vue.ref)([]);
        const isNewJurisdiction = (0, _vue.computed)(()=>props.jurisdictionId === 'add' || props.jurisdictionId === (0, _globalsJs.newEntityId));
        const isEditingJurisdiction = (0, _vue.ref)(false);
        // The >8 km advisory from #197. Derived here, not read off jurisdiction.validations, so the template
        // binds a plain boolean — see the comment on the element itself.
        const isPickupRadiusAboveAdvisory = (0, _vue.computed)(()=>Number(jurisdiction.value?.state?.maxPickupDistanceMeters) > (0, _serviceJurisdiction.WARN_ABOVE_PICKUP_DISTANCE_METERS));
        const driverDataTable = (0, _vue.ref)(null);
        // The promo window is stored as ISO-8601 (what the API sends and expects) but a datetime-local input
        // only accepts 'YYYY-MM-DDTHH:mm' in local time, so the two are proxied rather than bound directly.
        // '' rather than null for a cleared input: the update endpoint reads absent/null as "leave unchanged"
        // like every other field, and an explicit blank as "clear this date".
        //
        // The setters guard on state the same way the getters do. Today they cannot fire before EntityForm
        // populates it -- the inputs live under v-if="jurisdiction.state" -- but that invariant sits 190 lines
        // away in the template, and an asymmetric pair invites someone to "tidy" the getter's guard away.
        const signupBonusStartsOnInput = (0, _vue.computed)({
            get: ()=>(0, _datetimeLocal.toDatetimeLocal)(jurisdiction.value.state?.signupBonusStartsOn),
            set: (value)=>{
                if (jurisdiction.value.state) jurisdiction.value.state.signupBonusStartsOn = (0, _datetimeLocal.fromDatetimeLocal)(value, '');
            }
        });
        const signupBonusEndsOnInput = (0, _vue.computed)({
            get: ()=>(0, _datetimeLocal.toDatetimeLocal)(jurisdiction.value.state?.signupBonusEndsOn),
            set: (value)=>{
                if (jurisdiction.value.state) jurisdiction.value.state.signupBonusEndsOn = (0, _datetimeLocal.fromDatetimeLocal)(value, '');
            }
        });
        const driverColumns = [
            {
                title: "Driver",
                data: "name",
                render: (data, type, row)=>{
                    return (0, _datatableRenderer.userDetailsWithThumbnail)(data, row, `/admin/independent-driver/${row.id}`);
                }
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "phoneNumber",
                title: 'Phone Number'
            },
            {
                data: "driverStatus",
                title: 'Status',
                render: (0, _datatableRenderer.driverStatus)
            },
            {
                data: "joinedOn",
                title: 'Joined At',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" data-id="${row.id}"
              href="/admin/independent-driver/${row.id}">
              Details <i class="fa-solid fa-arrow-up-right-from-square"></i> </a>`;
                }
            }
        ];
        let map = null;
        let polygon = null;
        const fetchGeoZones = async ()=>{
            try {
                const response = await fetch('/api/service-area-zones');
                if (response.ok) geoZones.value = await response.json();
            } catch (error) {
                console.error('Error fetching geo zones:', error);
            }
        };
        const initMap = ()=>{
            if (!jurisdiction.value || !jurisdiction.value.state || !jurisdiction.value.state.serviceArea) return;
            setTimeout(()=>{
                const mapElement = document.getElementById('map');
                if (!mapElement) return;
                map = new google.maps.Map(mapElement, {
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    zoom: 10,
                    mapTypeId: 'roadmap'
                });
                if (jurisdiction.value.state.serviceArea && jurisdiction.value.state.serviceArea.boundaryWkt) drawPolygon(jurisdiction.value.state.serviceArea.boundaryWkt);
            }, 100);
        };
        const drawPolygon = (boundaryJson)=>{
            if (!map) return;
            if (polygon) polygon.setMap(null);
            try {
                let coordinates = [];
                try {
                    const boundaryData = JSON.parse(boundaryJson);
                    if (Array.isArray(boundaryData)) coordinates = boundaryData.map((coord)=>({
                            lat: parseFloat(coord.lat || coord.latitude),
                            lng: parseFloat(coord.lng || coord.longitude)
                        }));
                } catch (e) {
                    const wktMatch = boundaryJson.match(/POLYGON\s*\(\((.*)\)\)/i);
                    if (wktMatch && wktMatch[1]) coordinates = wktMatch[1].split(',').map((pair)=>{
                        const [lng, lat] = pair.trim().split(' ').map(parseFloat);
                        return {
                            lat,
                            lng
                        };
                    });
                }
                if (coordinates.length === 0) {
                    console.error('Invalid boundary format');
                    return;
                }
                polygon = new google.maps.Polygon({
                    paths: coordinates,
                    strokeColor: '#4285F4',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#4285F4',
                    fillOpacity: 0.35
                });
                polygon.setMap(map);
                const bounds = new google.maps.LatLngBounds();
                coordinates.forEach((coord)=>{
                    bounds.extend(coord);
                });
                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error drawing polygon:', error);
            }
        };
        const handlePreSave = ()=>{
            if (jurisdiction.value && jurisdiction.value.state) {
                if (jurisdiction.value.state.serviceArea && jurisdiction.value.state.serviceArea.id) jurisdiction.value.state.geoZoneId = jurisdiction.value.state.serviceArea.id;
                else jurisdiction.value.state.geoZoneId = null;
            }
        };
        const handlePostSave = (savedData)=>{
            if (map && savedData.serviceArea && savedData.serviceArea.boundaryWkt) drawPolygon(savedData.serviceArea.boundaryWkt);
            else initMap();
        };
        const loadGoogleMapsApi = ()=>{
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${props.googleMapsApiKey}&loading=async&callback=initGoogleMaps`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
            window.initGoogleMaps = ()=>{
                if (!isNewJurisdiction.value && jurisdiction.value && jurisdiction.value.state) initMap();
            };
        };
        (0, _vue.watch)(()=>jurisdiction.value?.state?.serviceArea, (newValue)=>{
            if (map && newValue && newValue.boundaryWkt) drawPolygon(newValue.boundaryWkt);
        });
        (0, _vue.onMounted)(()=>{
            fetchGeoZones();
            loadGoogleMapsApi();
        });
        const __returned__ = {
            props,
            jurisdiction,
            geoZones,
            isNewJurisdiction,
            isEditingJurisdiction,
            isPickupRadiusAboveAdvisory,
            driverDataTable,
            signupBonusStartsOnInput,
            signupBonusEndsOnInput,
            driverColumns,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get polygon () {
                return polygon;
            },
            set polygon (v){
                polygon = v;
            },
            fetchGeoZones,
            initMap,
            drawPolygon,
            handlePreSave,
            handlePostSave,
            loadGoogleMapsApi,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            watch: (0, _vue.watch),
            computed: (0, _vue.computed),
            EntityForm: (0, _entityFormVueDefault.default),
            get toDatetimeLocal () {
                return 0, _datetimeLocal.toDatetimeLocal;
            },
            get fromDatetimeLocal () {
                return 0, _datetimeLocal.fromDatetimeLocal;
            },
            get MAX_SIGNUP_BONUS_POINTS () {
                return 0, _serviceJurisdiction.MAX_SIGNUP_BONUS_POINTS;
            },
            get WARN_ABOVE_PICKUP_DISTANCE_METERS () {
                return 0, _serviceJurisdiction.WARN_ABOVE_PICKUP_DISTANCE_METERS;
            },
            get MIN_REFERRAL_DISCOUNT_PERCENT () {
                return 0, _serviceJurisdiction.MIN_REFERRAL_DISCOUNT_PERCENT;
            },
            get MAX_REFERRAL_DISCOUNT_PERCENT () {
                return 0, _serviceJurisdiction.MAX_REFERRAL_DISCOUNT_PERCENT;
            },
            get MAX_REFERRAL_REWARD_CAP () {
                return 0, _serviceJurisdiction.MAX_REFERRAL_REWARD_CAP;
            },
            get MAX_REFERRAL_RIDER_POINTS () {
                return 0, _serviceJurisdiction.MAX_REFERRAL_RIDER_POINTS;
            },
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            FareConfigurationComponent: (0, _fareConfigurationComponentVueDefault.default),
            get userDetailsWithThumbnail () {
                return 0, _datatableRenderer.userDetailsWithThumbnail;
            },
            get driverStatus () {
                return 0, _datatableRenderer.driverStatus;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./EntityForm.vue":"i0zng","../utility/datetimeLocal":"5L2k9","../modelTemplates/ServiceJurisdiction":"cUpxQ","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","./FareConfigurationComponent.vue":"eDuJk","../utility/DatatableRenderer":"gfmyC","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5L2k9":[function(require,module,exports,__globalThis) {
/**
 * Conversions between the ISO-8601 strings the API speaks and the `YYYY-MM-DDTHH:mm` local-time
 * format a `<input type="datetime-local">` accepts.
 *
 * Extracted because ShiftDetail.vue and ServiceJurisdictionDetail.vue had byte-identical copies under
 * different names. Both need it for the same structural reason: EntityForm.vue copies fetched API
 * values straight into the model's reactive state and PUTs that state back verbatim, so the model must
 * mirror the API shape and the input format has to be converted at the component edge.
 */ /**
 * ISO-8601 (or anything `Date` accepts) to the value a datetime-local input renders, in local time.
 *
 * Strips a trailing `[Zone]` suffix first: that is what Java's `ZonedDateTime.toString()` emits, and
 * `new Date()` returns Invalid Date for it, which would silently blank the field.
 *
 * @param {string|null|undefined} isoString
 * @returns {string} the input value, or '' when there is nothing valid to show
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toDatetimeLocal", ()=>toDatetimeLocal);
/**
 * A datetime-local input value back to ISO-8601 with this browser's offset.
 *
 * `emptyValue` is what a cleared input becomes, and the two callers genuinely differ: a shift requires
 * its dates, so null ("absent") is right there; a jurisdiction promo window is clearable, and its
 * endpoint reads absent as "leave unchanged" and an explicit blank as "clear", so '' is right there.
 *
 * @param {string|null|undefined} localValue
 * @param {string|null} [emptyValue=null] what to return for a cleared or unparseable input
 * @returns {string|null}
 */ parcelHelpers.export(exports, "fromDatetimeLocal", ()=>fromDatetimeLocal);
function toDatetimeLocal(isoString) {
    if (!isoString) return '';
    const date = new Date(String(isoString).replace(/\[[^\]]*\]$/, ''));
    if (isNaN(date)) return '';
    const pad = (n)=>String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` + `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
function fromDatetimeLocal(localValue, emptyValue = null) {
    if (!localValue) return emptyValue;
    const date = new Date(localValue);
    return isNaN(date) ? emptyValue : date.toISOString();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"778du":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    key: 0,
    class: "row"
};
const _hoisted_3 = {
    key: 0
};
const _hoisted_4 = {
    class: "row"
};
const _hoisted_5 = {
    class: "col-md-6"
};
const _hoisted_6 = {
    class: "mb-3"
};
const _hoisted_7 = [
    "disabled",
    "readonly"
];
const _hoisted_8 = {
    class: "mb-3"
};
const _hoisted_9 = [
    "disabled",
    "readonly"
];
const _hoisted_10 = {
    class: "mb-3"
};
const _hoisted_11 = {
    class: "input-group has-validation"
};
const _hoisted_12 = [
    "disabled",
    "readonly"
];
const _hoisted_13 = {
    key: 0,
    class: "form-text text-warning d-block"
};
const _hoisted_14 = {
    class: "col-md-6"
};
const _hoisted_15 = {
    class: "mb-3"
};
const _hoisted_16 = [
    "disabled"
];
const _hoisted_17 = [
    "value"
];
const _hoisted_18 = {
    class: "mb-3"
};
const _hoisted_19 = [
    "disabled",
    "readonly"
];
const _hoisted_20 = {
    class: "mb-3"
};
const _hoisted_21 = {
    class: "input-group"
};
const _hoisted_22 = [
    "disabled",
    "readonly"
];
const _hoisted_23 = {
    class: "mb-3"
};
const _hoisted_24 = {
    class: "input-group"
};
const _hoisted_25 = [
    "disabled",
    "readonly"
];
const _hoisted_26 = {
    class: "mb-3"
};
const _hoisted_27 = {
    class: "input-group"
};
const _hoisted_28 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_29 = {
    id: "signupBonusPoints-error",
    class: "invalid-feedback d-none"
};
const _hoisted_30 = {
    class: "row"
};
const _hoisted_31 = {
    class: "col-md-6 mb-3"
};
const _hoisted_32 = [
    "disabled",
    "readonly"
];
const _hoisted_33 = {
    class: "col-md-6 mb-3"
};
const _hoisted_34 = [
    "disabled",
    "readonly"
];
const _hoisted_35 = {
    class: "row"
};
const _hoisted_36 = {
    class: "col-md-6 mb-3"
};
const _hoisted_37 = {
    class: "input-group has-validation"
};
const _hoisted_38 = [
    "disabled",
    "readonly"
];
const _hoisted_39 = {
    class: "col-md-6 mb-3"
};
const _hoisted_40 = {
    class: "input-group has-validation"
};
const _hoisted_41 = [
    "disabled",
    "readonly"
];
const _hoisted_42 = {
    class: "row"
};
const _hoisted_43 = {
    class: "col-md-6 mb-3"
};
const _hoisted_44 = {
    class: "input-group has-validation"
};
const _hoisted_45 = [
    "min",
    "max",
    "disabled",
    "readonly"
];
const _hoisted_46 = {
    id: "referralDriverDiscountPercent-error",
    class: "invalid-feedback d-none"
};
const _hoisted_47 = {
    class: "col-md-6 mb-3"
};
const _hoisted_48 = {
    class: "input-group has-validation"
};
const _hoisted_49 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_50 = {
    id: "referralDriverMaxRedemptions-error",
    class: "invalid-feedback d-none"
};
const _hoisted_51 = {
    class: "row"
};
const _hoisted_52 = {
    class: "col-md-4 mb-3"
};
const _hoisted_53 = {
    class: "input-group has-validation"
};
const _hoisted_54 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_55 = {
    id: "referralRiderFirstRideReferrerPoints-error",
    class: "invalid-feedback d-none"
};
const _hoisted_56 = {
    class: "col-md-4 mb-3"
};
const _hoisted_57 = {
    class: "input-group has-validation"
};
const _hoisted_58 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_59 = {
    id: "referralRiderFirstRideReferredPoints-error",
    class: "invalid-feedback d-none"
};
const _hoisted_60 = {
    class: "col-md-4 mb-3"
};
const _hoisted_61 = {
    class: "input-group has-validation"
};
const _hoisted_62 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_63 = {
    id: "referralRiderFiveRidesReferrerPoints-error",
    class: "invalid-feedback d-none"
};
const _hoisted_64 = {
    class: "row"
};
const _hoisted_65 = {
    class: "col-md-6 mb-3"
};
const _hoisted_66 = {
    class: "input-group has-validation"
};
const _hoisted_67 = [
    "max",
    "disabled",
    "readonly"
];
const _hoisted_68 = {
    id: "referralRiderMaxRewardedReferrals-error",
    class: "invalid-feedback d-none"
};
const _hoisted_69 = {
    class: "mb-3"
};
const _hoisted_70 = {
    class: "form-check form-switch"
};
const _hoisted_71 = [
    "disabled"
];
const _hoisted_72 = {
    class: "form-check-label",
    for: "active"
};
const _hoisted_73 = {
    key: 1
};
const _hoisted_74 = {
    class: "col-xl-12 xl-100 box-col-6 mt-4"
};
const _hoisted_75 = {
    class: "card"
};
const _hoisted_76 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_77 = {
    key: 0,
    class: "badge bg-info"
};
const _hoisted_78 = {
    class: "card-body social-list filter-cards-view"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.jurisdiction && !$setup.isNewJurisdiction && $setup.jurisdiction.state && $setup.jurisdiction.state.serviceArea ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, _cache[21] || (_cache[21] = [
            (0, _vue.createElementVNode)("div", {
                class: "col-12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "card"
                }, [
                    (0, _vue.createElementVNode)("div", {
                        id: "map",
                        style: {
                            "height": "45vh",
                            "width": "100%"
                        }
                    })
                ])
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createVNode)($setup["EntityForm"], {
            "entity-id": $props.jurisdictionId,
            entity: $setup.jurisdiction,
            "onUpdate:entity": _cache[19] || (_cache[19] = ($event)=>$setup.jurisdiction = $event),
            editState: $setup.isEditingJurisdiction,
            "onUpdate:editState": _cache[20] || (_cache[20] = ($event)=>$setup.isEditingJurisdiction = $event),
            "form-name": "Service Jurisdiction",
            "api-url": "/api/service-jurisdiction",
            "redirect-url": "/admin/service-jurisdictions",
            "model-constructor": "ServiceJurisdiction",
            "show-title": true,
            "pre-save": $setup.handlePreSave,
            "post-save": $setup.handlePostSave
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.jurisdiction.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                        (0, _vue.createElementVNode)("div", _hoisted_4, [
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                (0, _vue.createElementVNode)("div", _hoisted_6, [
                                    _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                                        for: "name",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Name "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "name",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.jurisdiction.state.name = $event),
                                        disabled: !$setup.isEditingJurisdiction,
                                        readonly: !$setup.isEditingJurisdiction,
                                        required: ""
                                    }, null, 8, _hoisted_7), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.jurisdiction.state.name
                                        ]
                                    ]),
                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                                        id: "name-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a name.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_8, [
                                    _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                                        for: "description",
                                        class: "form-label"
                                    }, "Description", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                        class: "form-control",
                                        id: "description",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.jurisdiction.state.description = $event),
                                        rows: "3",
                                        disabled: !$setup.isEditingJurisdiction,
                                        readonly: !$setup.isEditingJurisdiction
                                    }, null, 8, _hoisted_9), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.jurisdiction.state.description
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_10, [
                                    _cache[27] || (_cache[27] = (0, _vue.createElementVNode)("label", {
                                        for: "maxPickupDistanceMeters",
                                        class: "form-label"
                                    }, "Max Pickup Distance", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_11, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "maxPickupDistanceMeters",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.jurisdiction.state.maxPickupDistanceMeters = $event),
                                            min: "500",
                                            max: "15000",
                                            step: "100",
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_12), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.jurisdiction.state.maxPickupDistanceMeters,
                                                void 0,
                                                {
                                                    number: true
                                                }
                                            ]
                                        ]),
                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "m", -1)),
                                        _cache[26] || (_cache[26] = (0, _vue.createElementVNode)("div", {
                                            id: "maxPickupDistanceMeters-error",
                                            class: "invalid-feedback d-none"
                                        }, "Please enter a whole number of metres between 500 and 15000.", -1))
                                    ]),
                                    _cache[28] || (_cache[28] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "How far a driver may be from the pickup, by road, to be sent the ride. Defaults to 5000 m. Every kilometre driven to reach a rider is insured and earns nothing, so a tighter radius trades unmatched requests \u2014 which cost nothing \u2014 for less uncharged driving.", -1)),
                                    $setup.isPickupRadiusAboveAdvisory ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_13, " Above 8000 m the deadhead cost per ride rises sharply. Widen this only against a measured unmatched-request rate. ")) : (0, _vue.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_14, [
                                (0, _vue.createElementVNode)("div", _hoisted_15, [
                                    _cache[30] || (_cache[30] = (0, _vue.createElementVNode)("label", {
                                        for: "serviceArea",
                                        class: "form-label"
                                    }, "Service Area (Geo Zone)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                        class: "form-select",
                                        id: "serviceArea",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.jurisdiction.state.serviceArea = $event),
                                        disabled: !$setup.isEditingJurisdiction
                                    }, [
                                        _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("option", {
                                            value: null
                                        }, "-- Select Service Area --", -1)),
                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.geoZones, (zone)=>{
                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                key: zone.id,
                                                value: zone
                                            }, (0, _vue.toDisplayString)(zone.name), 9, _hoisted_17);
                                        }), 128))
                                    ], 8, _hoisted_16), [
                                        [
                                            (0, _vue.vModelSelect),
                                            $setup.jurisdiction.state.serviceArea
                                        ]
                                    ]),
                                    _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Select a geo zone to define the service area", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_18, [
                                    _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("label", {
                                        for: "maxDrivers",
                                        class: "form-label"
                                    }, "Maximum Drivers", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "maxDrivers",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.jurisdiction.state.maxDrivers = $event),
                                        min: "0",
                                        step: "1",
                                        disabled: !$setup.isEditingJurisdiction,
                                        readonly: !$setup.isEditingJurisdiction
                                    }, null, 8, _hoisted_19), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.jurisdiction.state.maxDrivers
                                        ]
                                    ]),
                                    _cache[33] || (_cache[33] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Maximum number of drivers allowed in this jurisdiction (leave empty for unlimited)", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                    _cache[35] || (_cache[35] = (0, _vue.createElementVNode)("label", {
                                        for: "commissionPercentage",
                                        class: "form-label"
                                    }, "Commission Percentage (%)", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_21, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "commissionPercentage",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.jurisdiction.state.commissionPercentage = $event),
                                            min: "0",
                                            max: "100",
                                            step: "0.01",
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_22), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.jurisdiction.state.commissionPercentage
                                            ]
                                        ]),
                                        _cache[34] || (_cache[34] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "%", -1))
                                    ]),
                                    _cache[36] || (_cache[36] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Platform commission deducted from driver earnings per ride (excludes tips)", -1)),
                                    _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("div", {
                                        id: "commissionPercentage-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a valid percentage between 0 and 100.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_23, [
                                    _cache[39] || (_cache[39] = (0, _vue.createElementVNode)("label", {
                                        for: "pointsPerDollar",
                                        class: "form-label"
                                    }, "Asher Points Rate", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_24, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "pointsPerDollar",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.jurisdiction.state.pointsPerDollar = $event),
                                            min: "0",
                                            max: "1",
                                            step: "0.01",
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_25), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.jurisdiction.state.pointsPerDollar,
                                                void 0,
                                                {
                                                    number: true
                                                }
                                            ]
                                        ]),
                                        _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "pts/$", -1))
                                    ]),
                                    _cache[40] || (_cache[40] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Points earned per eligible dollar \u2014 the all-in amount charged to the rider (sales tax included) less the platform fee and any loyalty discount, excluding tips. Defaults to 1.00, which is also the maximum: at a 2x promo that is already 2% of eligible fare, the margin ceiling.", -1)),
                                    _cache[41] || (_cache[41] = (0, _vue.createElementVNode)("div", {
                                        id: "pointsPerDollar-error",
                                        class: "invalid-feedback d-none"
                                    }, "Please enter a rate between 0 and 1.00.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_26, [
                                    _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("label", {
                                        for: "signupBonusPoints",
                                        class: "form-label"
                                    }, "Rider Signup Bonus", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_27, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "signupBonusPoints",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.jurisdiction.state.signupBonusPoints = $event),
                                            min: "0",
                                            max: $setup.MAX_SIGNUP_BONUS_POINTS,
                                            step: "1",
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_28), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.jurisdiction.state.signupBonusPoints,
                                                void 0,
                                                {
                                                    number: true
                                                }
                                            ]
                                        ]),
                                        _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "pts", -1))
                                    ]),
                                    _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Points credited once to every rider who signs up while the promo below is running. Set to 0 to pay no signup bonus. Defaults to 250 (worth $2.50).", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_29, "Please enter a whole number of points between 0 and " + (0, _vue.toDisplayString)($setup.MAX_SIGNUP_BONUS_POINTS) + ".", 1)
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_30, [
                                    (0, _vue.createElementVNode)("div", _hoisted_31, [
                                        _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("label", {
                                            for: "signupBonusStartsOn",
                                            class: "form-label"
                                        }, "Signup Promo Starts", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "datetime-local",
                                            class: "form-control",
                                            id: "signupBonusStartsOn",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.signupBonusStartsOnInput = $event),
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_32), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.signupBonusStartsOnInput
                                            ]
                                        ]),
                                        _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Leave empty to run the promo immediately.", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                                        _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("label", {
                                            for: "signupBonusEndsOn",
                                            class: "form-label"
                                        }, "Signup Promo Ends", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "datetime-local",
                                            class: "form-control",
                                            id: "signupBonusEndsOn",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.signupBonusEndsOnInput = $event),
                                            disabled: !$setup.isEditingJurisdiction,
                                            readonly: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_34), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.signupBonusEndsOnInput
                                            ]
                                        ]),
                                        _cache[48] || (_cache[48] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Leave empty to run the promo with no end date.", -1)),
                                        _cache[49] || (_cache[49] = (0, _vue.createElementVNode)("div", {
                                            id: "signupBonusEndsOn-error",
                                            class: "invalid-feedback d-none"
                                        }, "The promo must end after it starts.", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_35, [
                                    (0, _vue.createElementVNode)("div", _hoisted_36, [
                                        _cache[52] || (_cache[52] = (0, _vue.createElementVNode)("label", {
                                            for: "idleWarningMinutes",
                                            class: "form-label"
                                        }, "Idle Warning", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_37, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "idleWarningMinutes",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.jurisdiction.state.idleWarningMinutes = $event),
                                                min: "1",
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_38), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.idleWarningMinutes,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "min", -1)),
                                            _cache[51] || (_cache[51] = (0, _vue.createElementVNode)("div", {
                                                id: "idleWarningMinutes-error",
                                                class: "invalid-feedback d-none"
                                            }, "Please enter a whole number of minutes, at least 1 and at most 720.", -1))
                                        ]),
                                        _cache[53] || (_cache[53] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "How long a driver may stay online with no trip before the app asks whether they are still driving. Defaults to 30.", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_39, [
                                        _cache[56] || (_cache[56] = (0, _vue.createElementVNode)("label", {
                                            for: "idleAutoOfflineMinutes",
                                            class: "form-label"
                                        }, "Idle Auto-Offline", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_40, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "idleAutoOfflineMinutes",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.jurisdiction.state.idleAutoOfflineMinutes = $event),
                                                min: "1",
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_41), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.idleAutoOfflineMinutes,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[54] || (_cache[54] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "min", -1)),
                                            _cache[55] || (_cache[55] = (0, _vue.createElementVNode)("div", {
                                                id: "idleAutoOfflineMinutes-error",
                                                class: "invalid-feedback d-none"
                                            }, "Auto-offline must be a whole number of minutes, at most 720, and more than one minute above the idle warning.", -1))
                                        ]),
                                        _cache[57] || (_cache[57] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "How long a driver may stay online with no trip before being set offline automatically. Must be more than a minute above the warning above, or drivers here are taken offline without ever being asked. Defaults to 45.", -1))
                                    ])
                                ]),
                                _cache[77] || (_cache[77] = (0, _vue.createElementVNode)("hr", {
                                    class: "my-4"
                                }, null, -1)),
                                _cache[78] || (_cache[78] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-3"
                                }, "Referral Rewards", -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_42, [
                                    (0, _vue.createElementVNode)("div", _hoisted_43, [
                                        _cache[59] || (_cache[59] = (0, _vue.createElementVNode)("label", {
                                            for: "referralDriverDiscountPercent",
                                            class: "form-label"
                                        }, "Driver Referral Discount", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_44, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralDriverDiscountPercent",
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.jurisdiction.state.referralDriverDiscountPercent = $event),
                                                min: $setup.MIN_REFERRAL_DISCOUNT_PERCENT,
                                                max: $setup.MAX_REFERRAL_DISCOUNT_PERCENT,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_45), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralDriverDiscountPercent,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[58] || (_cache[58] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "%", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_46, "Please enter a whole percentage between " + (0, _vue.toDisplayString)($setup.MIN_REFERRAL_DISCOUNT_PERCENT) + " and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_DISCOUNT_PERCENT) + ".", 1)
                                        ]),
                                        _cache[60] || (_cache[60] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "How much a referrer saves on their next subscription week when someone they referred qualifies. Defaults to 50%. To stop paying driver referral rewards here, set the cap beside this to 0 \u2014 a 0% discount would leave drivers holding a reward that can never be applied.", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_47, [
                                        _cache[62] || (_cache[62] = (0, _vue.createElementVNode)("label", {
                                            for: "referralDriverMaxRedemptions",
                                            class: "form-label"
                                        }, "Driver Referral Cap", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_48, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralDriverMaxRedemptions",
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.jurisdiction.state.referralDriverMaxRedemptions = $event),
                                                min: "0",
                                                max: $setup.MAX_REFERRAL_REWARD_CAP,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_49), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralDriverMaxRedemptions,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[61] || (_cache[61] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "rewards", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_50, "Please enter a whole number between 0 and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_REWARD_CAP) + ".", 1)
                                        ]),
                                        _cache[63] || (_cache[63] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Discounted weeks one driver can earn from referrals. Defaults to 4. Lowering this stops new rewards being granted; it does not revoke a reward a driver has already earned.", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_51, [
                                    (0, _vue.createElementVNode)("div", _hoisted_52, [
                                        _cache[65] || (_cache[65] = (0, _vue.createElementVNode)("label", {
                                            for: "referralRiderFirstRideReferrerPoints",
                                            class: "form-label"
                                        }, "Rider Referrer Bonus", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_53, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralRiderFirstRideReferrerPoints",
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$setup.jurisdiction.state.referralRiderFirstRideReferrerPoints = $event),
                                                min: "0",
                                                max: $setup.MAX_REFERRAL_RIDER_POINTS,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_54), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralRiderFirstRideReferrerPoints,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[64] || (_cache[64] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "pts", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_55, "Please enter a whole number of points between 0 and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_RIDER_POINTS) + ".", 1)
                                        ]),
                                        _cache[66] || (_cache[66] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Paid to the referrer on their friend's first ride. Defaults to 100.", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_56, [
                                        _cache[68] || (_cache[68] = (0, _vue.createElementVNode)("label", {
                                            for: "referralRiderFirstRideReferredPoints",
                                            class: "form-label"
                                        }, "New Rider Bonus", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_57, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralRiderFirstRideReferredPoints",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$setup.jurisdiction.state.referralRiderFirstRideReferredPoints = $event),
                                                min: "0",
                                                max: $setup.MAX_REFERRAL_RIDER_POINTS,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_58), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralRiderFirstRideReferredPoints,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[67] || (_cache[67] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "pts", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_59, "Please enter a whole number of points between 0 and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_RIDER_POINTS) + ".", 1)
                                        ]),
                                        _cache[69] || (_cache[69] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Paid to the referred rider on their own first ride. Defaults to 300.", -1))
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_60, [
                                        _cache[71] || (_cache[71] = (0, _vue.createElementVNode)("label", {
                                            for: "referralRiderFiveRidesReferrerPoints",
                                            class: "form-label"
                                        }, "Five-Ride Bonus", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_61, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralRiderFiveRidesReferrerPoints",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>$setup.jurisdiction.state.referralRiderFiveRidesReferrerPoints = $event),
                                                min: "0",
                                                max: $setup.MAX_REFERRAL_RIDER_POINTS,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_62), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralRiderFiveRidesReferrerPoints,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[70] || (_cache[70] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "pts", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_63, "Please enter a whole number of points between 0 and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_RIDER_POINTS) + ".", 1)
                                        ]),
                                        _cache[72] || (_cache[72] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Paid to the referrer once their friend reaches five paid rides. Defaults to 400.", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_64, [
                                    (0, _vue.createElementVNode)("div", _hoisted_65, [
                                        _cache[74] || (_cache[74] = (0, _vue.createElementVNode)("label", {
                                            for: "referralRiderMaxRewardedReferrals",
                                            class: "form-label"
                                        }, "Rider Referral Cap", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_66, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "referralRiderMaxRewardedReferrals",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event)=>$setup.jurisdiction.state.referralRiderMaxRewardedReferrals = $event),
                                                min: "0",
                                                max: $setup.MAX_REFERRAL_REWARD_CAP,
                                                step: "1",
                                                disabled: !$setup.isEditingJurisdiction,
                                                readonly: !$setup.isEditingJurisdiction
                                            }, null, 8, _hoisted_67), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.jurisdiction.state.referralRiderMaxRewardedReferrals,
                                                    void 0,
                                                    {
                                                        number: true
                                                    }
                                                ]
                                            ]),
                                            _cache[73] || (_cache[73] = (0, _vue.createElementVNode)("span", {
                                                class: "input-group-text"
                                            }, "referrals", -1)),
                                            (0, _vue.createElementVNode)("div", _hoisted_68, "Please enter a whole number between 0 and " + (0, _vue.toDisplayString)($setup.MAX_REFERRAL_REWARD_CAP) + ".", 1)
                                        ]),
                                        _cache[75] || (_cache[75] = (0, _vue.createElementVNode)("small", {
                                            class: "form-text text-muted"
                                        }, "Referred riders one rider can be rewarded for. Defaults to 10.", -1))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_69, [
                                    _cache[76] || (_cache[76] = (0, _vue.createElementVNode)("label", {
                                        for: "active",
                                        class: "form-label"
                                    }, "Status", -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_70, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "active",
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event)=>$setup.jurisdiction.state.active = $event),
                                            disabled: !$setup.isEditingJurisdiction
                                        }, null, 8, _hoisted_71), [
                                            [
                                                (0, _vue.vModelCheckbox),
                                                $setup.jurisdiction.state.active
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("label", _hoisted_72, (0, _vue.toDisplayString)($setup.jurisdiction.state.active ? 'Active' : 'Inactive'), 1)
                                    ])
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity-id",
            "entity",
            "editState"
        ]),
        !$setup.isNewJurisdiction ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_73, [
            ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Suspense), null, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.createVNode)($setup["FareConfigurationComponent"], {
                            "service-jurisdiction-id": $props.jurisdictionId
                        }, null, 8, [
                            "service-jurisdiction-id"
                        ])
                    ]),
                _: 1
            })),
            (0, _vue.createElementVNode)("div", _hoisted_74, [
                (0, _vue.createElementVNode)("div", _hoisted_75, [
                    (0, _vue.createElementVNode)("div", _hoisted_76, [
                        _cache[79] || (_cache[79] = (0, _vue.createElementVNode)("h5", null, "Drivers", -1)),
                        $setup.jurisdiction.state && $setup.jurisdiction.state.maxDrivers ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_77, " Max: " + (0, _vue.toDisplayString)($setup.jurisdiction.state.maxDrivers), 1)) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_78, [
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createVNode)($setup["DataTable"], {
                                ajax: {
                                    url: `/api/datatable/sj-all-drivers/${$props.jurisdictionId}`
                                },
                                ref: "driverDataTable",
                                class: "table-responsive display",
                                columns: $setup.driverColumns
                            }, null, 8, [
                                "ajax"
                            ])
                        ])
                    ])
                ])
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9oOSi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggjkB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("44bf718e798ba921");
    if (script.__esModule) script = script.default;
    script.render = require("ad4bc7995cd5667e").render;
    require("9fd3bc43dd3ac05a").default(script);
    script.__scopeId = 'data-v-8edc66';
    script.__file = "DriverApplicationStatus.vue";
};
initialize();
exports.default = script;

},{"44bf718e798ba921":"gjr6g","ad4bc7995cd5667e":"bziIx","9fd3bc43dd3ac05a":"ln0BP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjr6g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _driverReferralDashboardVue = require("./DriverReferralDashboard.vue");
var _driverReferralDashboardVueDefault = parcelHelpers.interopDefault(_driverReferralDashboardVue);
var _driverTaxRegistrationCardVue = require("./DriverTaxRegistrationCard.vue");
var _driverTaxRegistrationCardVueDefault = parcelHelpers.interopDefault(_driverTaxRegistrationCardVue);
var _filePickerControlsVue = require("./FilePickerControls.vue");
var _filePickerControlsVueDefault = parcelHelpers.interopDefault(_filePickerControlsVue);
var _fileUploadValidation = require("../fileUploadValidation");
const REQUIRED_VEHICLE_PHOTOS = 4;
exports.default = {
    __name: 'DriverApplicationStatus',
    setup (__props, { expose: __expose }) {
        __expose();
        const loading = (0, _vue.ref)(true);
        const error = (0, _vue.ref)(null);
        const statusData = (0, _vue.ref)({});
        const vehiclePhotosFiles = (0, _vue.ref)([]);
        const vehiclePhotosPreviews = (0, _vue.ref)([]);
        const vehiclePhotosUploading = (0, _vue.ref)(false);
        const vehiclePhotosError = (0, _vue.ref)(null);
        const vehiclePhotosSuccess = (0, _vue.ref)(null);
        const vehiclePhotoLabels = [
            'Front',
            'Back',
            'Left Side',
            'Right Side'
        ];
        const vehiclePhotosPreparing = (0, _vue.ref)(false);
        const profilePhotoFile = (0, _vue.ref)(null);
        const profilePhotoPreview = (0, _vue.ref)(null);
        const profilePhotoUploading = (0, _vue.ref)(false);
        const profilePhotoError = (0, _vue.ref)(null);
        const profilePhotoSuccess = (0, _vue.ref)(null);
        const profilePhotoPreparing = (0, _vue.ref)(false);
        const stripeLoading = (0, _vue.ref)(false);
        const stripeError = (0, _vue.ref)(null);
        const checklistComplete = (0, _vue.computed)(()=>{
            const s = statusData.value;
            return s.personalInfoComplete && s.vehicleInfoComplete && s.vehiclePhotosUploaded && s.profilePhotoUploaded && s.stripeOnboarded && s.taxNumberProvided && s.documentVerificationStatus === 'COMPLETE';
        });
        const overallStatus = (0, _vue.computed)(()=>{
            const s = statusData.value.overallStatus;
            if (s === 'COMPLETE') return 'APPROVED';
            if (s === 'REJECTED') return 'REJECTED';
            return checklistComplete.value ? 'PENDING' : 'INCOMPLETE';
        });
        const overallStatusAlertClass = (0, _vue.computed)(()=>({
                'APPROVED': 'alert-success',
                'REJECTED': 'alert-danger',
                'PENDING': 'alert-warning',
                'INCOMPLETE': 'alert-info'
            })[overallStatus.value] || 'alert-info');
        const overallStatusIcon = (0, _vue.computed)(()=>({
                'APPROVED': 'fa fa-check-circle text-success',
                'REJECTED': 'fa fa-times-circle text-danger',
                'PENDING': 'fa fa-hourglass-half text-warning',
                'INCOMPLETE': 'fa fa-clipboard-list text-info'
            })[overallStatus.value] || 'fa fa-clipboard-list text-info');
        const overallStatusHeading = (0, _vue.computed)(()=>({
                'APPROVED': 'Application Approved',
                'REJECTED': 'Application Not Approved',
                'PENDING': 'Application Under Review',
                'INCOMPLETE': 'Application Incomplete'
            })[overallStatus.value] || 'Application Incomplete');
        const overallStatusMessage = (0, _vue.computed)(()=>({
                'APPROVED': 'Congratulations! Your application has been approved. You can now log in and start accepting rides.',
                'REJECTED': 'Unfortunately your application was not approved. See the reason(s) below and contact support if you have questions.',
                'PENDING': 'Your application is being reviewed by our team. We\'ll send you an email once a decision has been made.',
                'INCOMPLETE': 'Please complete all the required steps below before your application can be submitted for review.'
            })[overallStatus.value] || '');
        // Rendered as an href, and the value is typed by an admin. Anything but https -- a javascript: URL
        // above all -- must never reach the DOM. The server validates on the way in; this is the second gate.
        const backgroundCheckLink = (0, _vue.computed)(()=>{
            const url = statusData.value.backgroundCheckUrl;
            return typeof url === 'string' && url.startsWith('https://') ? url : null;
        });
        const backgroundCheckLabel = (0, _vue.computed)(()=>({
                'NOT_STARTED': 'Not Started',
                'IN_PROGRESS': 'In Progress',
                'PASSED': 'Passed',
                'FAILED': 'Failed',
                'ACTION_REQUIRED': 'Action Required'
            })[statusData.value.backgroundCheckStatus] || 'Not Started');
        const backgroundCheckBadgeClass = (0, _vue.computed)(()=>({
                'NOT_STARTED': 'bg-secondary',
                'IN_PROGRESS': 'bg-warning',
                'PASSED': 'bg-success',
                'FAILED': 'bg-danger',
                'ACTION_REQUIRED': 'bg-warning text-dark'
            })[statusData.value.backgroundCheckStatus] || 'bg-secondary');
        const documentVerificationLabel = (0, _vue.computed)(()=>({
                'NOT_STARTED': 'Not Started',
                'PENDING_VERIFICATION': 'Pending Verification',
                'COMPLETE': 'Complete',
                'REJECTED': 'Rejected'
            })[statusData.value.documentVerificationStatus] || 'Not Started');
        const documentVerificationBadgeClass = (0, _vue.computed)(()=>({
                'NOT_STARTED': 'bg-secondary',
                'PENDING_VERIFICATION': 'bg-warning',
                'COMPLETE': 'bg-success',
                'REJECTED': 'bg-danger'
            })[statusData.value.documentVerificationStatus] || 'bg-secondary');
        const fetchStatus = async ()=>{
            try {
                loading.value = true;
                const response = await fetch('/api/driver/application-status');
                if (!response.ok) throw new Error('Unable to load application status. Please sign in again.');
                statusData.value = await response.json();
            } catch (e) {
                error.value = e.message || 'Failed to load application status.';
            } finally{
                loading.value = false;
            }
        };
        const formatDate = (dateStr)=>{
            if (!dateStr) return '';
            try {
                return (0, _momentDefault.default)(dateStr).format('MMMM Do, YYYY [at] h:mm a');
            } catch  {
                return dateStr;
            }
        };
        /**
 * Adds picked vehicle photos to the pending set, downscaling each before it is held for upload.
 *
 * Photos are appended rather than replacing the set, so the camera — which returns one frame at a
 * time — reaches four the same way the gallery does in a single multi-select.
 *
 * @param {Event} event the change event from the camera or file input
 */ const onVehiclePhotosSelected = async (event)=>{
            const input = event.target;
            const picked = Array.from(input.files || []);
            if (picked.length === 0) return;
            vehiclePhotosError.value = null;
            vehiclePhotosPreparing.value = true;
            try {
                if (vehiclePhotosFiles.value.length >= REQUIRED_VEHICLE_PHOTOS) {
                    vehiclePhotosError.value = `You already have ${REQUIRED_VEHICLE_PHOTOS} photos. Remove one before adding another.`;
                    return;
                }
                // Reasons are collected rather than shown per file: SweetAlert replaces whatever modal is
                // open, so firing one per rejected photo leaves the driver seeing only the last of them.
                const rejected = [];
                let skippedForSpace = 0;
                for (const candidate of picked){
                    // Recounted each time round rather than snapshotted: a photo can be removed while this loop
                    // is still awaiting, and the count is what the Upload button is gated on.
                    if (vehiclePhotosFiles.value.length >= REQUIRED_VEHICLE_PHOTOS) {
                        skippedForSpace += 1;
                        continue;
                    }
                    const file = await (0, _fileUploadValidation.preparePickedFile)(candidate, null, (0, _fileUploadValidation.IMAGE_TYPES), {
                        subject: 'vehicle photo',
                        silent: rejected
                    });
                    if (!file) continue;
                    vehiclePhotosFiles.value.push(file);
                    vehiclePhotosPreviews.value.push(previewUrlFor(file));
                }
                const problems = [
                    ...rejected
                ];
                if (skippedForSpace > 0) problems.push(`${skippedForSpace} photo(s) were not added \u{2014} only ${REQUIRED_VEHICLE_PHOTOS} are needed in total.`);
                if (problems.length > 0) vehiclePhotosError.value = problems.join(' ');
            } finally{
                vehiclePhotosPreparing.value = false;
                // Cleared unconditionally so re-picking the same photo still raises a change event.
                input.value = '';
            }
        };
        /**
 * Creates an inline preview URL for a picked photo.
 *
 * An object URL rather than a base64 data URL: base64 is about a third larger than the file and is
 * held as a live string for as long as the preview is on screen, so four phone photos would retain
 * several megabytes of strings on the same page that just encoded them — which on iOS is the side
 * of the memory budget that actually matters. Every URL made here is revoked in {@link revokePreview}.
 *
 * @param {File} file the file to preview
 * @returns {string} an object URL for the file
 */ const previewUrlFor = (file)=>URL.createObjectURL(file);
        /**
 * Releases a preview URL created by {@link previewUrlFor}.
 *
 * @param {string} url the object URL to release
 */ const revokePreview = (url)=>{
            if (url) URL.revokeObjectURL(url);
        };
        const removeVehiclePhoto = (index)=>{
            revokePreview(vehiclePhotosPreviews.value[index]);
            vehiclePhotosFiles.value = vehiclePhotosFiles.value.filter((_, i)=>i !== index);
            vehiclePhotosPreviews.value = vehiclePhotosPreviews.value.filter((_, i)=>i !== index);
        };
        const removeProfilePhoto = ()=>{
            revokePreview(profilePhotoPreview.value);
            profilePhotoFile.value = null;
            profilePhotoPreview.value = null;
        };
        const uploadVehiclePhotos = async ()=>{
            if (vehiclePhotosFiles.value.length === 0) return;
            vehiclePhotosUploading.value = true;
            vehiclePhotosError.value = null;
            vehiclePhotosSuccess.value = null;
            try {
                const formData = new FormData();
                vehiclePhotosFiles.value.forEach((file)=>{
                    formData.append('vehiclePhotos', file);
                });
                const response = await fetch('/api/driver/application-status/upload-vehicle-photos', {
                    method: 'POST',
                    body: formData
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Failed to upload vehicle photos.');
                }
                vehiclePhotosSuccess.value = 'Vehicle photos uploaded successfully!';
                statusData.value.vehiclePhotosUploaded = true;
            } catch (e) {
                vehiclePhotosError.value = e.message || 'Failed to upload vehicle photos.';
            } finally{
                vehiclePhotosUploading.value = false;
            }
        };
        /**
 * Accepts a picked profile photo, downscaling it before it is held for upload.
 *
 * @param {Event} event the change event from the camera or file input
 */ const onProfilePhotoSelected = async (event)=>{
            const input = event.target;
            const picked = input.files?.[0];
            if (!picked) return;
            profilePhotoError.value = null;
            profilePhotoPreparing.value = true;
            try {
                const file = await (0, _fileUploadValidation.preparePickedFile)(picked, null, (0, _fileUploadValidation.IMAGE_TYPES), {
                    subject: 'profile photo'
                });
                if (!file) return;
                profilePhotoFile.value = file;
                revokePreview(profilePhotoPreview.value);
                profilePhotoPreview.value = previewUrlFor(file);
            } finally{
                profilePhotoPreparing.value = false;
                // Cleared unconditionally so re-picking the same photo still raises a change event.
                input.value = '';
            }
        };
        const uploadProfilePhoto = async ()=>{
            if (!profilePhotoFile.value) return;
            profilePhotoUploading.value = true;
            profilePhotoError.value = null;
            profilePhotoSuccess.value = null;
            try {
                const formData = new FormData();
                formData.append('profilePhoto', profilePhotoFile.value);
                const response = await fetch('/api/driver/application-status/upload-profile-photo', {
                    method: 'POST',
                    body: formData
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Failed to upload profile photo.');
                }
                profilePhotoSuccess.value = 'Profile photo uploaded successfully!';
                statusData.value.profilePhotoUploaded = true;
            } catch (e) {
                profilePhotoError.value = e.message || 'Failed to upload profile photo.';
            } finally{
                profilePhotoUploading.value = false;
            }
        };
        const openStripeOnboarding = async ()=>{
            stripeLoading.value = true;
            stripeError.value = null;
            const popup = window.open('', '_blank');
            try {
                const response = await fetch('/api/driver/application-status/stripe-link');
                if (!response.ok) throw new Error('Failed to get Stripe onboarding link.');
                const data = await response.json();
                if (data.url) popup.location.href = data.url;
                else {
                    popup.close();
                    throw new Error('No Stripe onboarding URL received.');
                }
            } catch (e) {
                if (popup) popup.close();
                stripeError.value = e.message || 'Failed to open Stripe onboarding.';
            } finally{
                stripeLoading.value = false;
            }
        };
        (0, _vue.onMounted)(fetchStatus);
        const __returned__ = {
            loading,
            error,
            statusData,
            vehiclePhotosFiles,
            vehiclePhotosPreviews,
            vehiclePhotosUploading,
            vehiclePhotosError,
            vehiclePhotosSuccess,
            vehiclePhotoLabels,
            vehiclePhotosPreparing,
            REQUIRED_VEHICLE_PHOTOS,
            profilePhotoFile,
            profilePhotoPreview,
            profilePhotoUploading,
            profilePhotoError,
            profilePhotoSuccess,
            profilePhotoPreparing,
            stripeLoading,
            stripeError,
            checklistComplete,
            overallStatus,
            overallStatusAlertClass,
            overallStatusIcon,
            overallStatusHeading,
            overallStatusMessage,
            backgroundCheckLink,
            backgroundCheckLabel,
            backgroundCheckBadgeClass,
            documentVerificationLabel,
            documentVerificationBadgeClass,
            fetchStatus,
            formatDate,
            onVehiclePhotosSelected,
            previewUrlFor,
            revokePreview,
            removeVehiclePhoto,
            removeProfilePhoto,
            uploadVehiclePhotos,
            onProfilePhotoSelected,
            uploadProfilePhoto,
            openStripeOnboarding,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            get moment () {
                return 0, _momentDefault.default;
            },
            DriverReferralDashboard: (0, _driverReferralDashboardVueDefault.default),
            DriverTaxRegistrationCard: (0, _driverTaxRegistrationCardVueDefault.default),
            FilePickerControls: (0, _filePickerControlsVueDefault.default),
            get preparePickedFile () {
                return 0, _fileUploadValidation.preparePickedFile;
            },
            get IMAGE_TYPES () {
                return 0, _fileUploadValidation.IMAGE_TYPES;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment/moment":"2meyw","./DriverReferralDashboard.vue":"brL1V","./DriverTaxRegistrationCard.vue":"7yxBl","./FilePickerControls.vue":"4gCxp","../fileUploadValidation":"27Syo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brL1V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("fbaae6ec4dca0520");
    if (script.__esModule) script = script.default;
    script.render = require("bfa5591647f83f7f").render;
    require("1a93941d6dbf458").default(script);
    script.__scopeId = 'data-v-fe3f3e';
    script.__file = "DriverReferralDashboard.vue";
};
initialize();
exports.default = script;

},{"fbaae6ec4dca0520":"cXsVh","bfa5591647f83f7f":"lsUki","1a93941d6dbf458":"fcslV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXsVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _referralOutstanding = require("../utility/referralOutstanding");
exports.default = {
    __name: 'DriverReferralDashboard',
    setup (__props, { expose: __expose }) {
        __expose();
        const loading = (0, _vue.ref)(true);
        const error = (0, _vue.ref)(null);
        const dashboard = (0, _vue.ref)({
            referralCode: '',
            referralLink: '',
            invitedReferrals: []
        });
        const copying = (0, _vue.ref)(false);
        const copySuccess = (0, _vue.ref)(false);
        const sharing = (0, _vue.ref)(false);
        const inviteContact = (0, _vue.ref)('');
        const inviteIsEmail = (0, _vue.ref)(true);
        const inviteSending = (0, _vue.ref)(false);
        const inviteError = (0, _vue.ref)(null);
        const inviteSuccess = (0, _vue.ref)(null);
        const expandedIds = (0, _vue.ref)(new Set());
        const statusLabels = {
            SIGNED_UP: 'Signed Up',
            IN_PROGRESS: 'In Progress',
            QUALIFIED: 'Qualified',
            REWARDED: 'Rewarded',
            EXPIRED: 'Expired',
            REJECTED: 'Rejected',
            FRAUD_REVIEW: 'Under Review'
        };
        const statusBadgeClasses = {
            SIGNED_UP: 'bg-secondary',
            IN_PROGRESS: 'bg-info text-dark',
            QUALIFIED: 'bg-warning text-dark',
            REWARDED: 'bg-success',
            EXPIRED: 'bg-secondary',
            REJECTED: 'bg-secondary',
            FRAUD_REVIEW: 'bg-secondary'
        };
        const rewardStatusLabels = {
            AVAILABLE: 'Pending',
            REDEEMED: 'Earned',
            EXPIRED: 'Expired',
            REVERSED: 'Reversed'
        };
        const rewardBadgeClasses = {
            AVAILABLE: 'bg-warning text-dark',
            REDEEMED: 'bg-success',
            EXPIRED: 'bg-secondary',
            REVERSED: 'bg-secondary'
        };
        const milestoneLabels = {
            FIRST_PAID_RIDE: 'First Ride',
            FIVE_PAID_RIDES: '5-Ride Bonus',
            DRIVER_QUALIFICATION: 'Qualification'
        };
        const statusLabel = (status)=>statusLabels[status] || status;
        const statusBadgeClass = (status)=>statusBadgeClasses[status] || 'bg-secondary';
        const rewardStatusLabel = (status)=>rewardStatusLabels[status] || status;
        const rewardBadgeClass = (status)=>rewardBadgeClasses[status] || 'bg-secondary';
        const milestoneLabel = (milestone)=>milestoneLabels[milestone] || milestone;
        const rewardAmountLabel = (reward)=>{
            if (reward.rewardType === 'ASHER_POINTS') return `+${reward.points ?? 0} points`;
            if (reward.rewardType === 'SUBSCRIPTION_DISCOUNT_WEEK') return `${reward.discountPercent ?? 0}% off ${reward.discountWeekCount ?? 0} week(s)`;
            return '';
        };
        const outstandingLabel = (referral)=>(0, _referralOutstanding.outstandingLabel)(referral, true);
        const progressPercent = (referral)=>{
            if (!referral.requiredPaidRides) return 0;
            return Math.min(100, Math.round(referral.completedPaidRides / referral.requiredPaidRides * 100));
        };
        const isExpanded = (id)=>expandedIds.value.has(id);
        const toggleExpanded = (id)=>{
            if (expandedIds.value.has(id)) expandedIds.value.delete(id);
            else expandedIds.value.add(id);
            expandedIds.value = new Set(expandedIds.value);
        };
        const formatDate = (dateStr)=>{
            if (!dateStr) return '';
            try {
                return (0, _momentDefault.default)(dateStr).format('MMM Do, YYYY');
            } catch  {
                return dateStr;
            }
        };
        const fetchDashboard = async ()=>{
            loading.value = true;
            error.value = null;
            try {
                const response = await fetch('/api/driver/referrals');
                if (!response.ok) throw new Error('Unable to load your referral dashboard.');
                dashboard.value = await response.json();
            } catch (e) {
                error.value = e.message || 'Failed to load referral dashboard.';
            } finally{
                loading.value = false;
            }
        };
        const copyLink = async ()=>{
            copying.value = true;
            try {
                await navigator.clipboard.writeText(dashboard.value.referralLink);
                copySuccess.value = true;
                setTimeout(()=>{
                    copySuccess.value = false;
                }, 2000);
            } catch (e) {
                error.value = null;
            } finally{
                copying.value = false;
            }
        };
        const shareLink = async ()=>{
            sharing.value = true;
            try {
                if (navigator.share) await navigator.share({
                    title: 'Join Asher Rides',
                    text: 'Use my referral link to join Asher Rides as a driver!',
                    url: dashboard.value.referralLink
                });
                else {
                    await navigator.clipboard.writeText(dashboard.value.referralLink);
                    copySuccess.value = true;
                    setTimeout(()=>{
                        copySuccess.value = false;
                    }, 2000);
                }
            } catch (e) {
            // User cancelled the native share sheet, or clipboard is unavailable — not an error to surface.
            } finally{
                sharing.value = false;
            }
        };
        const sendInvite = async ()=>{
            if (!inviteContact.value) return;
            inviteSending.value = true;
            inviteError.value = null;
            inviteSuccess.value = null;
            try {
                const response = await fetch('/api/driver/referrals/invite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        userIdentifier: inviteContact.value,
                        isEmail: inviteIsEmail.value
                    })
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Unable to send invite.');
                }
                inviteSuccess.value = 'Invite sent!';
                inviteContact.value = '';
            } catch (e) {
                inviteError.value = e.message || 'Unable to send invite.';
            } finally{
                inviteSending.value = false;
            }
        };
        (0, _vue.onMounted)(fetchDashboard);
        const __returned__ = {
            loading,
            error,
            dashboard,
            copying,
            copySuccess,
            sharing,
            inviteContact,
            inviteIsEmail,
            inviteSending,
            inviteError,
            inviteSuccess,
            expandedIds,
            statusLabels,
            statusBadgeClasses,
            rewardStatusLabels,
            rewardBadgeClasses,
            milestoneLabels,
            statusLabel,
            statusBadgeClass,
            rewardStatusLabel,
            rewardBadgeClass,
            milestoneLabel,
            rewardAmountLabel,
            outstandingLabel,
            progressPercent,
            isExpanded,
            toggleExpanded,
            formatDate,
            fetchDashboard,
            copyLink,
            shareLink,
            sendInvite,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get moment () {
                return 0, _momentDefault.default;
            },
            get resolveOutstandingLabel () {
                return 0, _referralOutstanding.outstandingLabel;
            },
            get outstandingClass () {
                return 0, _referralOutstanding.outstandingClass;
            },
            get outstandingIcon () {
                return 0, _referralOutstanding.outstandingIcon;
            },
            get deadlineIsUrgent () {
                return 0, _referralOutstanding.deadlineIsUrgent;
            },
            get deadlineLabel () {
                return 0, _referralOutstanding.deadlineLabel;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment/moment":"2meyw","../utility/referralOutstanding":"hnt4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hnt4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Explanatory line for a referral row, or null when there is nothing to explain. An unrecognised
 * requirement returns null rather than the raw enum name, so a value the server gains before the
 * frontend does renders as nothing instead of as debug text.
 */ parcelHelpers.export(exports, "outstandingLabel", ()=>outstandingLabel);
parcelHelpers.export(exports, "outstandingClass", ()=>outstandingClass);
parcelHelpers.export(exports, "outstandingIcon", ()=>outstandingIcon);
/**
 * Whole days remaining until the qualification deadline, or null when there is no deadline to show.
 *
 * Compared at day boundaries rather than with a plain `diff`, because moment's unit diff truncates
 * toward zero: a deadline that passed two hours ago yields 0, which reads as "today is the last day"
 * for the whole 24 hours after the window has actually closed.
 */ parcelHelpers.export(exports, "daysToDeadline", ()=>daysToDeadline);
parcelHelpers.export(exports, "deadlineIsUrgent", ()=>deadlineIsUrgent);
parcelHelpers.export(exports, "deadlineLabel", ()=>deadlineLabel);
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
/**
 * Display helpers for a referral row's `outstandingRequirement` and `qualifyByAt`, shared by
 * DriverReferralDashboard.vue and RiderReferralDashboard.vue.
 *
 * The copy is keyed by referral type because the two programmes do not share conditions: a rider
 * referral has no onboarding or subscription gate, and its cap is terminal rather than a hold. Keeping
 * one map per type in one file is what stops the two dashboards drifting apart — they previously held
 * byte-identical copies of all of this, so a value added to ReferralOutstandingRequirement could be
 * wired into one dashboard and silently render nothing in the other.
 */ const SHARED_COPY = {
    AWAITING_FIRST_PAID_RIDE: "Waiting on their first paid ride \u2014 the 30-day window starts then.",
    MORE_PAID_RIDES: null,
    WINDOW_EXPIRED: 'The 30-day qualification window closed before this referral qualified.',
    UNDER_REVIEW: 'On hold while we review this referral.',
    NOT_ELIGIBLE: 'This referral was not eligible for a reward.',
    COMPLETE: null
};
const DRIVER_COPY = {
    ...SHARED_COPY,
    REFERRED_ONBOARDING_INCOMPLETE: 'Rides complete. Waiting on them to finish onboarding.',
    REFERRED_SUBSCRIPTION_INACTIVE: 'Rides complete. Waiting on their subscription to become active.',
    REFERRER_CAP_REACHED: "Qualified, but you've reached the maximum rewards for this programme.",
    AWAITING_NEXT_RIDE: "Everything qualifies \u2014 your reward lands on their next paid ride."
};
const RIDER_COPY = {
    ...SHARED_COPY,
    // No "qualified" here: a rider referral blocked by the cap never met a bar, it earned nothing from
    // the start and cannot recover.
    REFERRER_CAP_REACHED: "You've already earned the maximum referral rewards, so this one is tracked but won't pay out.",
    AWAITING_NEXT_RIDE: "Everything qualifies \u2014 your bonus lands on their next paid ride."
};
const CLASSES = {
    AWAITING_FIRST_PAID_RIDE: 'text-muted',
    REFERRED_ONBOARDING_INCOMPLETE: 'text-warning-emphasis',
    REFERRED_SUBSCRIPTION_INACTIVE: 'text-warning-emphasis',
    REFERRER_CAP_REACHED: 'text-muted',
    AWAITING_NEXT_RIDE: 'text-success',
    WINDOW_EXPIRED: 'text-muted',
    UNDER_REVIEW: 'text-muted',
    NOT_ELIGIBLE: 'text-muted'
};
const ICONS = {
    AWAITING_FIRST_PAID_RIDE: 'fa-hourglass-start',
    REFERRED_ONBOARDING_INCOMPLETE: 'fa-id-card',
    REFERRED_SUBSCRIPTION_INACTIVE: 'fa-credit-card',
    REFERRER_CAP_REACHED: 'fa-trophy',
    AWAITING_NEXT_RIDE: 'fa-check-circle',
    WINDOW_EXPIRED: 'fa-calendar-times',
    UNDER_REVIEW: 'fa-search',
    NOT_ELIGIBLE: 'fa-ban'
};
function outstandingLabel(referral, isDriver) {
    const copy = isDriver ? DRIVER_COPY : RIDER_COPY;
    return copy[referral.outstandingRequirement] || null;
}
function outstandingClass(referral) {
    return CLASSES[referral.outstandingRequirement] || 'text-muted';
}
function outstandingIcon(referral) {
    return ICONS[referral.outstandingRequirement] || 'fa-info-circle';
}
function daysToDeadline(referral) {
    if (!referral.qualifyByAt) return null;
    const deadline = (0, _momentDefault.default)(referral.qualifyByAt);
    if (!deadline.isValid()) return null;
    return deadline.startOf('day').diff((0, _momentDefault.default)().startOf('day'), 'days');
}
function deadlineIsUrgent(referral) {
    const days = daysToDeadline(referral);
    return days !== null && days <= 7;
}
function deadlineLabel(referral) {
    const days = daysToDeadline(referral);
    if (days === null) return null;
    if (days < 0) return 'Window closed';
    if (days === 0) return 'Last day to qualify';
    return `${days} day${days === 1 ? '' : 's'} left to qualify`;
}

},{"moment/moment":"2meyw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lsUki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_2 = {
    class: "card-header bg-white"
};
const _hoisted_3 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_4 = {
    class: "card-body"
};
const _hoisted_5 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_6 = {
    key: 1,
    class: "alert alert-danger mb-0"
};
const _hoisted_7 = {
    key: 2
};
const _hoisted_8 = {
    class: "mb-3"
};
const _hoisted_9 = {
    class: "input-group"
};
const _hoisted_10 = [
    "value"
];
const _hoisted_11 = [
    "disabled"
];
const _hoisted_12 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_13 = {
    key: 1,
    class: "fa fa-copy me-1"
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_16 = {
    key: 1,
    class: "fa fa-share-alt me-1"
};
const _hoisted_17 = {
    class: "border rounded p-3 mb-4 bg-color"
};
const _hoisted_18 = {
    class: "row g-2 align-items-center"
};
const _hoisted_19 = {
    class: "col-12 col-sm-auto"
};
const _hoisted_20 = {
    class: "col"
};
const _hoisted_21 = [
    "placeholder"
];
const _hoisted_22 = {
    class: "col-12 col-sm-auto"
};
const _hoisted_23 = [
    "disabled"
];
const _hoisted_24 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_25 = {
    key: 0,
    class: "alert alert-danger mt-2 mb-0 py-1 px-2 small"
};
const _hoisted_26 = {
    key: 1,
    class: "alert alert-success mt-2 mb-0 py-1 px-2 small"
};
const _hoisted_27 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_28 = {
    key: 1,
    class: "list-group list-group-flush"
};
const _hoisted_29 = [
    "onClick"
];
const _hoisted_30 = {
    class: "fw-semibold"
};
const _hoisted_31 = {
    key: 0,
    class: "progress mt-2",
    style: {
        "height": "6px"
    }
};
const _hoisted_32 = {
    key: 1,
    class: "small text-muted mt-1 d-flex justify-content-between flex-wrap gap-2"
};
const _hoisted_33 = {
    key: 3,
    class: "mt-2 ps-2 border-start"
};
const _hoisted_34 = {
    class: "small text-muted mb-1"
};
const _hoisted_35 = {
    key: 0,
    class: "small text-muted"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("h5", {
                class: "mb-0"
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa fa-gift me-2"
                }),
                (0, _vue.createTextVNode)("Refer Drivers, Earn Subscription Discounts")
            ], -1)),
            $setup.dashboard && $setup.dashboard.driverDiscountPercent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_3, " When a driver you referred qualifies, you get " + (0, _vue.toDisplayString)($setup.dashboard.driverDiscountPercent) + "% off your next subscription week. ", 1)) : (0, _vue.createCommentVNode)("", true)
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_4, [
            $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, _cache[3] || (_cache[3] = [
                (0, _vue.createElementVNode)("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                }, [
                    (0, _vue.createElementVNode)("span", {
                        class: "visually-hidden"
                    }, "Loading...")
                ], -1)
            ]))) : $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, (0, _vue.toDisplayString)($setup.error), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                (0, _vue.createElementVNode)("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("label", {
                        class: "form-label text-muted small mb-1"
                    }, "Your referral code", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_9, [
                        (0, _vue.createElementVNode)("input", {
                            type: "text",
                            class: "form-control fw-bold",
                            value: $setup.dashboard.referralCode,
                            readonly: ""
                        }, null, 8, _hoisted_10),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-primary",
                            onClick: $setup.copyLink,
                            disabled: $setup.copying
                        }, [
                            $setup.copying ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_12)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_13)),
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.copying ? 'Copying...' : $setup.copySuccess ? 'Copied!' : 'Copy Link'), 1)
                        ], 8, _hoisted_11),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-secondary",
                            onClick: $setup.shareLink,
                            disabled: $setup.sharing
                        }, [
                            $setup.sharing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_15)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_16)),
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.sharing ? 'Sharing...' : 'Share'), 1)
                        ], 8, _hoisted_14)
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_17, [
                    _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                        class: "form-label small mb-2"
                    }, "Send your invite directly", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_18, [
                        (0, _vue.createElementVNode)("div", _hoisted_19, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select form-select-sm",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.inviteIsEmail = $event)
                            }, _cache[5] || (_cache[5] = [
                                (0, _vue.createElementVNode)("option", {
                                    value: true
                                }, "Email", -1),
                                (0, _vue.createElementVNode)("option", {
                                    value: false
                                }, "Phone", -1)
                            ]), 512), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.inviteIsEmail
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_20, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                type: "text",
                                class: "form-control form-control-sm",
                                placeholder: $setup.inviteIsEmail ? 'friend@example.com' : '(555) 555-5555',
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.inviteContact = $event)
                            }, null, 8, _hoisted_21), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.inviteContact
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary btn-sm w-100",
                                onClick: $setup.sendInvite,
                                disabled: $setup.inviteSending || !$setup.inviteContact
                            }, [
                                $setup.inviteSending ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_24)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.inviteSending ? 'Sending...' : 'Send Invite'), 1)
                            ], 8, _hoisted_23)
                        ])
                    ]),
                    $setup.inviteError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_25, (0, _vue.toDisplayString)($setup.inviteError), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.inviteSuccess ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_26, (0, _vue.toDisplayString)($setup.inviteSuccess), 1)) : (0, _vue.createCommentVNode)("", true)
                ]),
                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("h6", {
                    class: "mb-2"
                }, "Drivers you've invited", -1)),
                !$setup.dashboard.invitedReferrals || $setup.dashboard.invitedReferrals.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_27, " No invites yet \u2014 share your code above to get started. ")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_28, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.dashboard.invitedReferrals, (referral)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                            key: referral.referralId,
                            class: "list-group-item px-0"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "d-flex justify-content-between align-items-center",
                                style: {
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$setup.toggleExpanded(referral.referralId)
                            }, [
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("span", _hoisted_30, (0, _vue.toDisplayString)(referral.referredDisplayName), 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill ms-2",
                                            $setup.statusBadgeClass(referral.status)
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusLabel(referral.status)), 3)
                                ]),
                                (0, _vue.createElementVNode)("i", {
                                    class: (0, _vue.normalizeClass)([
                                        "fa",
                                        $setup.isExpanded(referral.referralId) ? 'fa-chevron-up' : 'fa-chevron-down'
                                    ])
                                }, null, 2)
                            ], 8, _hoisted_29),
                            referral.requiredPaidRides > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_31, [
                                (0, _vue.createElementVNode)("div", {
                                    class: "progress-bar bg-success",
                                    role: "progressbar",
                                    style: (0, _vue.normalizeStyle)({
                                        width: $setup.progressPercent(referral) + '%'
                                    })
                                }, null, 4)
                            ])) : (0, _vue.createCommentVNode)("", true),
                            referral.requiredPaidRides > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, [
                                (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(referral.completedPaidRides) + "/" + (0, _vue.toDisplayString)(referral.requiredPaidRides) + " paid rides", 1),
                                $setup.deadlineLabel(referral) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                                    key: 0,
                                    class: (0, _vue.normalizeClass)($setup.deadlineIsUrgent(referral) ? 'text-danger' : '')
                                }, [
                                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-clock me-1"
                                    }, null, -1)),
                                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.deadlineLabel(referral)), 1)
                                ], 2)) : (0, _vue.createCommentVNode)("", true)
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.outstandingLabel(referral) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 2,
                                class: (0, _vue.normalizeClass)([
                                    "small mt-1",
                                    $setup.outstandingClass(referral)
                                ])
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: (0, _vue.normalizeClass)([
                                        "fa me-1",
                                        $setup.outstandingIcon(referral)
                                    ])
                                }, null, 2),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.outstandingLabel(referral)), 1)
                            ], 2)) : (0, _vue.createCommentVNode)("", true),
                            $setup.isExpanded(referral.referralId) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_33, [
                                (0, _vue.createElementVNode)("div", _hoisted_34, "Signed up " + (0, _vue.toDisplayString)($setup.formatDate(referral.signedUpAt)), 1),
                                !referral.rewards || referral.rewards.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_35, "No rewards yet.")) : ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                    key: 1
                                }, (0, _vue.renderList)(referral.rewards, (reward, idx)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: idx,
                                        class: "small d-flex justify-content-between mb-1"
                                    }, [
                                        (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($setup.milestoneLabel(reward.milestone)) + " \u2014 " + (0, _vue.toDisplayString)($setup.rewardAmountLabel(reward)), 1),
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)([
                                                "badge rounded-pill",
                                                $setup.rewardBadgeClass(reward.status)
                                            ])
                                        }, (0, _vue.toDisplayString)($setup.rewardStatusLabel(reward.status)), 3)
                                    ]);
                                }), 128))
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ]);
                    }), 128))
                ])),
                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("div", {
                    class: "alert alert-info mt-4 mb-0 small"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-mobile-alt me-2"
                    }),
                    (0, _vue.createTextVNode)("Referrals in the Asher driver app are coming soon \u2014 for now, share your link here. ")
                ], -1))
            ]))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fcslV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7yxBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("4321edd703ff67b3");
    if (script.__esModule) script = script.default;
    script.render = require("bc35c0b03df5a5f2").render;
    script.__cssModules = require("183edc177d354b0").default;
    require("febfe491fa129dc0").default(script);
    script.__scopeId = 'data-v-4ca458';
    script.__file = "DriverTaxRegistrationCard.vue";
};
initialize();
exports.default = script;

},{"4321edd703ff67b3":"fiFMH","bc35c0b03df5a5f2":"3OTbC","183edc177d354b0":"i9sxZ","febfe491fa129dc0":"44CPq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fiFMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'DriverTaxRegistrationCard',
    emits: [
        'saved'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const gstHstNumber = (0, _vue.ref)('');
        const savingNumber = (0, _vue.ref)(false);
        const saveNumberError = (0, _vue.ref)(null);
        const isGstHstNumberFormat = (val)=>/^\d{9}(RT\d{4})?$/.test(String(val ?? '').replace(/[\s-]/g, '').toUpperCase());
        const isGstHstNumberValid = (0, _vue.computed)(()=>isGstHstNumberFormat(gstHstNumber.value));
        const saveGstHstNumber = async ()=>{
            saveNumberError.value = null;
            savingNumber.value = true;
            try {
                const response = await fetch('/api/driver/application-status/gst-hst-number', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        gstHstNumber: gstHstNumber.value
                    })
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Unable to save your GST/HST number.');
                }
                emit('saved');
            } catch (e) {
                saveNumberError.value = e.message || 'Unable to save your GST/HST number.';
            } finally{
                savingNumber.value = false;
            }
        };
        const __returned__ = {
            emit,
            gstHstNumber,
            savingNumber,
            saveNumberError,
            isGstHstNumberFormat,
            isGstHstNumberValid,
            saveGstHstNumber,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OTbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_4 = [
    "disabled"
];
const _hoisted_5 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_6 = {
    key: 1,
    class: "alert alert-danger mt-3 mb-0"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
            class: "card-header bg-white"
        }, [
            (0, _vue.createElementVNode)("h5", {
                class: "mb-0"
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa fa-percent me-2"
                }),
                (0, _vue.createTextVNode)("GST/HST Registration")
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("p", {
                class: "text-muted mb-3"
            }, [
                (0, _vue.createTextVNode)(" You charge tax on every ride and file it yourself, so you need your own GST/HST number before you can go online. "),
                (0, _vue.createElementVNode)("strong", null, "If you have driven for another rideshare or delivery company before, you almost certainly already have one"),
                (0, _vue.createTextVNode)(" \u2014 it stays with you, so enter that number here rather than registering again. Otherwise the CRA registers you free of charge; the guide below walks you through it, and you come back here once you have your number. ")
            ], -1)),
            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("label", {
                class: "form-label f-w-600",
                for: "driver-status-gst-hst-number-input"
            }, "GST/HST Number", -1)),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                id: "driver-status-gst-hst-number-input",
                class: (0, _vue.normalizeClass)([
                    "form-control",
                    {
                        'is-invalid': $setup.gstHstNumber.length > 0 && !$setup.isGstHstNumberValid
                    }
                ]),
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.gstHstNumber = $event),
                placeholder: "e.g., 123456789RT0001"
            }, null, 2), [
                [
                    (0, _vue.vModelText),
                    $setup.gstHstNumber
                ]
            ]),
            $setup.gstHstNumber.length > 0 && !$setup.isGstHstNumberValid ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, " Enter a valid GST/HST number: nine digits, optionally followed by RT and four digits. ")) : (0, _vue.createCommentVNode)("", true),
            (0, _vue.createElementVNode)("button", {
                class: "btn btn-primary mt-3",
                onClick: $setup.saveGstHstNumber,
                disabled: $setup.savingNumber || !$setup.isGstHstNumberValid
            }, [
                $setup.savingNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_5)) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.savingNumber ? 'Saving...' : 'Save Number'), 1)
            ], 8, _hoisted_4),
            $setup.saveNumberError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, (0, _vue.toDisplayString)($setup.saveNumberError), 1)) : (0, _vue.createCommentVNode)("", true),
            _cache[3] || (_cache[3] = (0, _vue.createStaticVNode)('<div class="border rounded p-3 mt-4" data-v-4ca458><h6 class="mb-2" data-v-4ca458><i class="fa fa-info-circle me-2" data-v-4ca458></i>How to get your GST/HST number</h6><p class="text-muted mb-2" data-v-4ca458> The CRA registers rideshare drivers directly, and their guide covers every step: </p><p class="mb-3" data-v-4ca458><a href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/business-registration/business-number-program-account/register-rideshare-taxi.html" target="_blank" rel="noopener noreferrer" data-v-4ca458> Register as a rideshare driver or taxi operator \u2014 Canada.ca<i class="fa fa-external-link ms-1" data-v-4ca458></i></a></p><ul class="text-muted mb-3 cra-guide-list" data-v-4ca458><li data-v-4ca458> As a rideshare driver you are a sole proprietor, so you need both a Business Number (BN) and a GST/HST account \u2014 no matter how much you earn. </li><li data-v-4ca458> A sole proprietor can only hold one Business Number, so if you registered while driving for someone else, that same number is the one to enter above. </li><li data-v-4ca458> You register online through Business Registration Online, which needs a CRA account. You cannot open one without having filed a T1 personal return in the last two years. </li><li data-v-4ca458> If you cannot get a CRA account, you can register by mail instead, using Form RC1. </li></ul><p class="text-muted mb-0" data-v-4ca458> Stuck, or not sure which of these applies to you? Email <a href="mailto:support@asher-rides.com" data-v-4ca458>support@asher-rides.com</a> and we&#39;ll help you through it. </p></div>', 1))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9sxZ":[function() {},{}],"44CPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bziIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid"
};
const _hoisted_2 = {
    class: "row justify-content-center"
};
const _hoisted_3 = {
    class: "col-12 col-lg-10 col-xl-8"
};
const _hoisted_4 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_5 = {
    key: 1,
    class: "text-center py-5"
};
const _hoisted_6 = {
    class: "alert alert-danger"
};
const _hoisted_7 = {
    key: 2
};
const _hoisted_8 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_9 = {
    class: "card-body text-center py-4"
};
const _hoisted_10 = {
    class: "text-muted mb-1"
};
const _hoisted_11 = {
    class: "text-muted small mb-0"
};
const _hoisted_12 = {
    key: 0,
    class: "text-muted small mb-0"
};
const _hoisted_13 = {
    class: "mb-1"
};
const _hoisted_14 = {
    class: "mb-0"
};
const _hoisted_15 = {
    key: 0,
    class: "mb-1"
};
const _hoisted_16 = {
    key: 1,
    class: "mb-1"
};
const _hoisted_17 = {
    key: 2,
    class: "mb-1"
};
const _hoisted_18 = {
    key: 3,
    class: "mt-1"
};
const _hoisted_19 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_20 = {
    class: "card-body p-0"
};
const _hoisted_21 = {
    class: "list-group list-group-flush"
};
const _hoisted_22 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_23 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_24 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_25 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_26 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_27 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_28 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_29 = {
    class: "list-group-item d-flex justify-content-between align-items-center"
};
const _hoisted_30 = {
    key: 0,
    class: "card mb-4 shadow-sm"
};
const _hoisted_31 = {
    class: "card-body"
};
const _hoisted_32 = {
    class: "mb-3"
};
const _hoisted_33 = {
    class: "form-text mt-1 d-flex align-items-center gap-2"
};
const _hoisted_34 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_35 = {
    key: 0,
    class: "fa fa-check-circle ms-1"
};
const _hoisted_36 = {
    key: 0,
    class: "row mb-3"
};
const _hoisted_37 = {
    class: "position-relative"
};
const _hoisted_38 = [
    "src",
    "alt"
];
const _hoisted_39 = {
    class: "position-absolute bottom-0 start-0 end-0 text-center",
    style: {
        "background": "rgba(0,0,0,0.55)",
        "border-radius": "0 0 4px 4px",
        "padding": "3px 0"
    }
};
const _hoisted_40 = {
    class: "text-white",
    style: {
        "font-size": "0.7rem"
    }
};
const _hoisted_41 = [
    "onClick"
];
const _hoisted_42 = {
    key: 1,
    class: "alert alert-warning mb-3"
};
const _hoisted_43 = [
    "disabled"
];
const _hoisted_44 = {
    key: 0
};
const _hoisted_45 = {
    key: 1
};
const _hoisted_46 = {
    key: 2,
    class: "alert alert-danger mt-2 mb-0"
};
const _hoisted_47 = {
    key: 3,
    class: "alert alert-success mt-2 mb-0"
};
const _hoisted_48 = {
    key: 1,
    class: "card mb-4 shadow-sm"
};
const _hoisted_49 = {
    key: 2,
    class: "card mb-4 shadow-sm"
};
const _hoisted_50 = {
    class: "card-body"
};
const _hoisted_51 = {
    class: "mb-3"
};
const _hoisted_52 = {
    key: 0,
    class: "form-text mt-1 text-muted"
};
const _hoisted_53 = {
    key: 0,
    class: "mb-3 d-inline-flex flex-column align-items-center gap-2"
};
const _hoisted_54 = [
    "src"
];
const _hoisted_55 = [
    "disabled"
];
const _hoisted_56 = {
    key: 0
};
const _hoisted_57 = {
    key: 1
};
const _hoisted_58 = {
    key: 1,
    class: "alert alert-danger mt-2 mb-0"
};
const _hoisted_59 = {
    key: 2,
    class: "alert alert-success mt-2 mb-0"
};
const _hoisted_60 = {
    key: 3,
    class: "card mb-4 shadow-sm"
};
const _hoisted_61 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_62 = {
    class: "card-body"
};
const _hoisted_63 = {
    key: 0,
    class: "alert alert-success mb-0"
};
const _hoisted_64 = {
    key: 1
};
const _hoisted_65 = [
    "disabled"
];
const _hoisted_66 = {
    key: 0
};
const _hoisted_67 = {
    key: 1
};
const _hoisted_68 = {
    key: 0,
    class: "alert alert-danger mt-2 mb-0"
};
const _hoisted_69 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_70 = {
    class: "card-body"
};
const _hoisted_71 = {
    key: 0,
    class: "alert alert-info mb-0"
};
const _hoisted_72 = {
    key: 1,
    class: "alert alert-warning mb-0"
};
const _hoisted_73 = {
    key: 2,
    class: "alert alert-success mb-0"
};
const _hoisted_74 = {
    key: 3
};
const _hoisted_75 = {
    key: 0,
    class: "ms-2 mb-1"
};
const _hoisted_76 = {
    key: 1,
    class: "ms-2 mb-1"
};
const _hoisted_77 = {
    key: 2,
    class: "ms-2 mb-1"
};
const _hoisted_78 = {
    class: "card mb-4 shadow-sm"
};
const _hoisted_79 = {
    class: "card-body"
};
const _hoisted_80 = {
    key: 0,
    class: "alert alert-info mb-0"
};
const _hoisted_81 = {
    key: 1,
    class: "mb-0"
};
const _hoisted_82 = {
    key: 0,
    class: "alert alert-info mb-0"
};
const _hoisted_83 = {
    class: "mt-3"
};
const _hoisted_84 = [
    "href"
];
const _hoisted_85 = {
    key: 1,
    class: "alert alert-warning mb-0"
};
const _hoisted_86 = {
    key: 2,
    class: "alert alert-success mb-0"
};
const _hoisted_87 = {
    key: 3,
    class: "alert alert-warning mb-0"
};
const _hoisted_88 = {
    key: 4,
    class: "alert alert-danger mb-0"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, _cache[0] || (_cache[0] = [
                    (0, _vue.createElementVNode)("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, [
                        (0, _vue.createElementVNode)("span", {
                            class: "visually-hidden"
                        }, "Loading...")
                    ], -1),
                    (0, _vue.createElementVNode)("p", {
                        class: "mt-3 text-muted"
                    }, "Loading your application status...", -1)
                ]))) : $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("i", {
                            class: "fa fa-exclamation-triangle me-2"
                        }, null, -1)),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.error), 1)
                    ])
                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                        (0, _vue.createElementVNode)("div", _hoisted_9, [
                            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("h3", {
                                class: "mb-1"
                            }, "Application Status", -1)),
                            (0, _vue.createElementVNode)("p", _hoisted_10, (0, _vue.toDisplayString)($setup.statusData.driverName), 1),
                            (0, _vue.createElementVNode)("p", _hoisted_11, (0, _vue.toDisplayString)($setup.statusData.email), 1),
                            $setup.statusData.submittedDate ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_12, " Submitted: " + (0, _vue.toDisplayString)($setup.formatDate($setup.statusData.submittedDate)), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", {
                        class: (0, _vue.normalizeClass)([
                            "alert d-flex align-items-start mb-4 shadow-sm",
                            $setup.overallStatusAlertClass
                        ]),
                        role: "alert"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: (0, _vue.normalizeClass)([
                                $setup.overallStatusIcon,
                                "me-3 mt-1"
                            ]),
                            style: {
                                "font-size": "1.6rem",
                                "flex-shrink": "0"
                            }
                        }, null, 2),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("h5", _hoisted_13, (0, _vue.toDisplayString)($setup.overallStatusHeading), 1),
                            (0, _vue.createElementVNode)("p", _hoisted_14, (0, _vue.toDisplayString)($setup.overallStatusMessage), 1),
                            $setup.overallStatus === 'REJECTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                key: 0
                            }, [
                                _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("hr", {
                                    class: "my-2"
                                }, null, -1)),
                                $setup.statusData.licenseRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_15, [
                                    _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("strong", null, "License:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.licenseRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.statusData.insuranceRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_16, [
                                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("strong", null, "Insurance:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.insuranceRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.statusData.vehiclePhotosRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_17, [
                                    _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("strong", null, "Vehicle Photos:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.vehiclePhotosRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.statusData.backgroundCheckStatus === 'FAILED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_18, _cache[6] || (_cache[6] = [
                                    (0, _vue.createElementVNode)("strong", null, "Background Check:", -1),
                                    (0, _vue.createTextVNode)(" Your background check did not pass. Please contact support for details. ")
                                ]))) : (0, _vue.createCommentVNode)("", true)
                            ], 64)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ], 2),
                    (0, _vue.createElementVNode)("div", _hoisted_19, [
                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-tasks me-2"
                                }),
                                (0, _vue.createTextVNode)("Application Checklist")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_20, [
                            (0, _vue.createElementVNode)("ul", _hoisted_21, [
                                (0, _vue.createElementVNode)("li", _hoisted_22, [
                                    _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-user me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Personal Information")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.personalInfoComplete ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.personalInfoComplete ? 'Complete' : 'Incomplete'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_23, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-car me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Vehicle Information")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.vehicleInfoComplete ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.vehicleInfoComplete ? 'Complete' : 'Incomplete'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_24, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-camera me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Vehicle Photos")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.vehiclePhotosUploaded ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.vehiclePhotosUploaded ? 'Uploaded' : 'Required'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_25, [
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-id-badge me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Profile Photo")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.profilePhotoUploaded ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.profilePhotoUploaded ? 'Uploaded' : 'Required'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_26, [
                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-percent me-2"
                                        }),
                                        (0, _vue.createTextVNode)("GST/HST Number")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.taxNumberProvided ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.taxNumberProvided ? 'Provided' : 'Required'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_27, [
                                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-credit-card me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Payment Setup")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.statusData.stripeOnboarded ? 'bg-success' : 'bg-warning'
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusData.stripeOnboarded ? 'Complete' : 'Required'), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_28, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-file me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Documents Verification")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.documentVerificationBadgeClass
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.documentVerificationLabel), 3)
                                ]),
                                (0, _vue.createElementVNode)("li", _hoisted_29, [
                                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("span", null, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-shield me-2"
                                        }),
                                        (0, _vue.createTextVNode)("Background Check")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill",
                                            $setup.backgroundCheckBadgeClass
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.backgroundCheckLabel), 3)
                                ])
                            ])
                        ])
                    ]),
                    !$setup.statusData.vehiclePhotosUploaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_30, [
                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-camera me-2"
                                }),
                                (0, _vue.createTextVNode)("Upload Vehicle Photos")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_31, [
                            _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
                                class: "alert alert-warning d-flex align-items-start gap-2 mb-3"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-exclamation-triangle mt-1 flex-shrink-0"
                                }),
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("strong", null, "Required for application approval."),
                                    (0, _vue.createTextVNode)(" Our review team needs photos of your vehicle from all four angles before your application can be approved. ")
                                ])
                            ], -1)),
                            _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-3"
                            }, "Upload exactly 4 photos \u2014 one from each angle: front, back, left side, and right side. Photos taken on your phone are resized automatically.", -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_32, [
                                (0, _vue.createVNode)($setup["FilePickerControls"], {
                                    "input-id": "vehicle-photos",
                                    accept: "image/*",
                                    multiple: "",
                                    disabled: $setup.vehiclePhotosPreparing || $setup.vehiclePhotosFiles.length >= 4,
                                    "camera-label": "Take a photo",
                                    "file-label": "Choose photos",
                                    "sole-label": "Choose photos",
                                    "button-class": "btn btn-outline-primary",
                                    onPicked: $setup.onVehiclePhotosSelected
                                }, null, 8, [
                                    "disabled"
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_33, [
                                    $setup.vehiclePhotosPreparing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_34, _cache[17] || (_cache[17] = [
                                        (0, _vue.createElementVNode)("span", {
                                            class: "spinner-border spinner-border-sm me-1"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)("Preparing photos... ")
                                    ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                                        key: 1,
                                        class: (0, _vue.normalizeClass)($setup.vehiclePhotosFiles.length === 4 ? 'text-success fw-semibold' : 'text-muted')
                                    }, [
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.vehiclePhotosFiles.length) + " of 4 photos selected ", 1),
                                        $setup.vehiclePhotosFiles.length === 4 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_35)) : (0, _vue.createCommentVNode)("", true)
                                    ], 2)),
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("span", {
                                        class: "text-muted"
                                    }, "\u2014 add them one at a time or all at once", -1))
                                ])
                            ]),
                            $setup.vehiclePhotosPreviews.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_36, [
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.vehiclePhotosPreviews, (preview, index)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: index,
                                        class: "col-6 col-md-3 mb-2"
                                    }, [
                                        (0, _vue.createElementVNode)("div", _hoisted_37, [
                                            (0, _vue.createElementVNode)("img", {
                                                src: preview,
                                                class: "img-fluid rounded border",
                                                alt: $setup.vehiclePhotoLabels[index] || 'Photo ' + (index + 1),
                                                style: {
                                                    "height": "120px",
                                                    "width": "100%",
                                                    "object-fit": "cover"
                                                }
                                            }, null, 8, _hoisted_38),
                                            (0, _vue.createElementVNode)("div", _hoisted_39, [
                                                (0, _vue.createElementVNode)("small", _hoisted_40, (0, _vue.toDisplayString)($setup.vehiclePhotoLabels[index] || 'Photo ' + (index + 1)), 1)
                                            ]),
                                            (0, _vue.createElementVNode)("button", {
                                                type: "button",
                                                class: "btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-0 lh-1",
                                                style: {
                                                    "width": "22px",
                                                    "height": "22px"
                                                },
                                                onClick: ($event)=>$setup.removeVehiclePhoto(index),
                                                title: "Remove"
                                            }, _cache[19] || (_cache[19] = [
                                                (0, _vue.createElementVNode)("i", {
                                                    class: "fa-solid fa-xmark",
                                                    style: {
                                                        "font-size": "0.7rem"
                                                    }
                                                }, null, -1)
                                            ]), 8, _hoisted_41)
                                        ])
                                    ]);
                                }), 128))
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.vehiclePhotosFiles.length > 0 && $setup.vehiclePhotosFiles.length !== 4 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_42, _cache[20] || (_cache[20] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-exclamation-circle me-1"
                                }, null, -1),
                                (0, _vue.createTextVNode)(" All 4 photos are required. Please select one from each angle: front, back, left side, and right side. ")
                            ]))) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary",
                                onClick: $setup.uploadVehiclePhotos,
                                disabled: $setup.vehiclePhotosUploading || $setup.vehiclePhotosFiles.length !== 4
                            }, [
                                $setup.vehiclePhotosUploading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_44, _cache[21] || (_cache[21] = [
                                    (0, _vue.createElementVNode)("span", {
                                        class: "spinner-border spinner-border-sm me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Uploading... ")
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_45, _cache[22] || (_cache[22] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-upload me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Upload Photos")
                                ])))
                            ], 8, _hoisted_43),
                            $setup.vehiclePhotosError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_46, (0, _vue.toDisplayString)($setup.vehiclePhotosError), 1)) : (0, _vue.createCommentVNode)("", true),
                            $setup.vehiclePhotosSuccess ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_47, (0, _vue.toDisplayString)($setup.vehiclePhotosSuccess), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_48, _cache[26] || (_cache[26] = [
                        (0, _vue.createStaticVNode)("<div class=\"card-header bg-white\"><h5 class=\"mb-0\"><i class=\"fa fa-camera me-2\"></i>Vehicle Photos</h5></div><div class=\"card-body\"><div class=\"alert alert-success mb-0\"><i class=\"fa fa-check-circle me-2\"></i>Vehicle photos have been uploaded successfully. </div></div>", 2)
                    ]))),
                    !$setup.statusData.profilePhotoUploaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_49, [
                        _cache[32] || (_cache[32] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-id-badge me-2"
                                }),
                                (0, _vue.createTextVNode)("Upload Profile Photo")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_50, [
                            _cache[31] || (_cache[31] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-3"
                            }, "Please upload a clear photo of yourself. This will be shown to riders.", -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_51, [
                                (0, _vue.createVNode)($setup["FilePickerControls"], {
                                    "input-id": "profile-photo",
                                    accept: "image/*",
                                    disabled: $setup.profilePhotoPreparing,
                                    "camera-label": "Take a photo",
                                    "file-label": "Choose photo",
                                    "sole-label": "Choose photo",
                                    "button-class": "btn btn-outline-primary",
                                    onPicked: $setup.onProfilePhotoSelected
                                }, null, 8, [
                                    "disabled"
                                ]),
                                $setup.profilePhotoPreparing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_52, _cache[27] || (_cache[27] = [
                                    (0, _vue.createElementVNode)("span", {
                                        class: "spinner-border spinner-border-sm me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)("Preparing photo... ")
                                ]))) : (0, _vue.createCommentVNode)("", true)
                            ]),
                            $setup.profilePhotoPreview ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_53, [
                                (0, _vue.createElementVNode)("img", {
                                    src: $setup.profilePhotoPreview,
                                    class: "rounded-circle border",
                                    alt: "Profile preview",
                                    style: {
                                        "width": "120px",
                                        "height": "120px",
                                        "object-fit": "cover"
                                    }
                                }, null, 8, _hoisted_54),
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-danger",
                                    onClick: $setup.removeProfilePhoto
                                }, _cache[28] || (_cache[28] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa-solid fa-xmark me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)("Remove ")
                                ]))
                            ])) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary",
                                onClick: $setup.uploadProfilePhoto,
                                disabled: $setup.profilePhotoUploading || !$setup.profilePhotoFile
                            }, [
                                $setup.profilePhotoUploading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_56, _cache[29] || (_cache[29] = [
                                    (0, _vue.createElementVNode)("span", {
                                        class: "spinner-border spinner-border-sm me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Uploading... ")
                                ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_57, _cache[30] || (_cache[30] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-upload me-1"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)(" Upload Photo")
                                ])))
                            ], 8, _hoisted_55),
                            $setup.profilePhotoError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_58, (0, _vue.toDisplayString)($setup.profilePhotoError), 1)) : (0, _vue.createCommentVNode)("", true),
                            $setup.profilePhotoSuccess ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_59, (0, _vue.toDisplayString)($setup.profilePhotoSuccess), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_60, _cache[33] || (_cache[33] = [
                        (0, _vue.createStaticVNode)("<div class=\"card-header bg-white\"><h5 class=\"mb-0\"><i class=\"fa fa-id-badge me-2\"></i>Profile Photo</h5></div><div class=\"card-body\"><div class=\"alert alert-success mb-0\"><i class=\"fa fa-check-circle me-2\"></i>Profile photo has been uploaded successfully. </div></div>", 2)
                    ]))),
                    !$setup.statusData.taxNumberProvided ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["DriverTaxRegistrationCard"], {
                        key: 4,
                        onSaved: $setup.fetchStatus
                    })) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createElementVNode)("div", _hoisted_61, [
                        _cache[38] || (_cache[38] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-credit-card me-2"
                                }),
                                (0, _vue.createTextVNode)("Payment Setup (Stripe)")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_62, [
                            $setup.statusData.stripeOnboarded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_63, _cache[34] || (_cache[34] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-check-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your Stripe payment account has been set up successfully. You're ready to receive payments. ")
                            ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_64, [
                                _cache[37] || (_cache[37] = (0, _vue.createElementVNode)("p", {
                                    class: "text-muted mb-3"
                                }, "Complete your Stripe payment setup to receive ride payments. Click the button below to continue your Stripe onboarding.", -1)),
                                (0, _vue.createElementVNode)("button", {
                                    class: "btn btn-primary",
                                    onClick: $setup.openStripeOnboarding,
                                    disabled: $setup.stripeLoading
                                }, [
                                    $setup.stripeLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_66, _cache[35] || (_cache[35] = [
                                        (0, _vue.createElementVNode)("span", {
                                            class: "spinner-border spinner-border-sm me-1"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Loading... ")
                                    ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_67, _cache[36] || (_cache[36] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-external-link me-1"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Complete Stripe Setup")
                                    ])))
                                ], 8, _hoisted_65),
                                $setup.stripeError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_68, (0, _vue.toDisplayString)($setup.stripeError), 1)) : (0, _vue.createCommentVNode)("", true)
                            ]))
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_69, [
                        _cache[47] || (_cache[47] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-file me-2"
                                }),
                                (0, _vue.createTextVNode)("Documents Verification")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_70, [
                            $setup.statusData.documentVerificationStatus === 'NOT_STARTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_71, _cache[39] || (_cache[39] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-info-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your document verification has not been initiated yet. This will be started once you upload your license, insurance, and vehicle photos. ")
                            ]))) : $setup.statusData.documentVerificationStatus === 'PENDING_VERIFICATION' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_72, _cache[40] || (_cache[40] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-clock-o me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your documents are under review. This typically takes 2-3 business days. ")
                            ]))) : $setup.statusData.documentVerificationStatus === 'COMPLETE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_73, _cache[41] || (_cache[41] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-check-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your license, insurance, and vehicle photos have been verified. ")
                            ]))) : $setup.statusData.documentVerificationStatus === 'REJECTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_74, [
                                _cache[45] || (_cache[45] = (0, _vue.createElementVNode)("div", {
                                    class: "alert alert-danger mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-times-circle me-2"
                                    }),
                                    (0, _vue.createTextVNode)("One or more documents require changes. Please review the details below and resubmit. ")
                                ], -1)),
                                $setup.statusData.licenseRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_75, [
                                    _cache[42] || (_cache[42] = (0, _vue.createElementVNode)("b", null, "Driver's License:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.licenseRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.statusData.insuranceRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_76, [
                                    _cache[43] || (_cache[43] = (0, _vue.createElementVNode)("b", null, "Insurance Document:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.insuranceRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.statusData.vehiclePhotosRejectionMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_77, [
                                    _cache[44] || (_cache[44] = (0, _vue.createElementVNode)("b", null, "Vehicle Photos:", -1)),
                                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.statusData.vehiclePhotosRejectionMessage), 1)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                _cache[46] || (_cache[46] = (0, _vue.createElementVNode)("div", {
                                    class: "alert alert-info mt-3 mb-0"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-info-circle me-2"
                                    }),
                                    (0, _vue.createElementVNode)("strong", null, "Need help?"),
                                    (0, _vue.createTextVNode)(" If you have questions about the rejection or believe it was made in error, please email "),
                                    (0, _vue.createElementVNode)("a", {
                                        href: "mailto:support@asher-rides.com",
                                        class: "alert-link"
                                    }, "support@asher-rides.com"),
                                    (0, _vue.createTextVNode)(" with your "),
                                    (0, _vue.createElementVNode)("strong", null, "full name"),
                                    (0, _vue.createTextVNode)(", "),
                                    (0, _vue.createElementVNode)("strong", null, "email address"),
                                    (0, _vue.createTextVNode)(", and any "),
                                    (0, _vue.createElementVNode)("strong", null, "supporting documents"),
                                    (0, _vue.createTextVNode)(" for our team to review your enquiry. ")
                                ], -1))
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_78, [
                        _cache[56] || (_cache[56] = (0, _vue.createElementVNode)("div", {
                            class: "card-header bg-white"
                        }, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0"
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-shield me-2"
                                }),
                                (0, _vue.createTextVNode)("Background Check")
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_79, [
                            $setup.statusData.backgroundCheckStatus === 'NOT_STARTED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_80, _cache[48] || (_cache[48] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-info-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your background check has not been initiated yet. This will be started once your application is reviewed by our team. ")
                            ]))) : $setup.statusData.backgroundCheckStatus === 'IN_PROGRESS' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_81, [
                                $setup.backgroundCheckLink ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_82, [
                                    _cache[50] || (_cache[50] = (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-envelope me-2"
                                    }, null, -1)),
                                    _cache[51] || (_cache[51] = (0, _vue.createTextVNode)(" We've emailed you a link to start your background check with Certn, our background check provider. You can also start it right here \u2014 it only takes a few minutes, and your application can't move forward until it's done. Once you've completed it, results typically take 3-5 business days. ")),
                                    (0, _vue.createElementVNode)("div", _hoisted_83, [
                                        (0, _vue.createElementVNode)("a", {
                                            href: $setup.backgroundCheckLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            class: "btn btn-primary"
                                        }, _cache[49] || (_cache[49] = [
                                            (0, _vue.createElementVNode)("i", {
                                                class: "fa fa-shield me-1"
                                            }, null, -1),
                                            (0, _vue.createTextVNode)("Start Your Background Check ")
                                        ]), 8, _hoisted_84)
                                    ])
                                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_85, _cache[52] || (_cache[52] = [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-clock-o me-2"
                                    }, null, -1),
                                    (0, _vue.createTextVNode)("Your background check is in progress. Check your email for the link from our team to complete it. Results typically take 3-5 business days. ")
                                ])))
                            ])) : $setup.statusData.backgroundCheckStatus === 'PASSED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_86, _cache[53] || (_cache[53] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-check-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your background check has been completed and passed. ")
                            ]))) : $setup.statusData.backgroundCheckStatus === 'ACTION_REQUIRED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_87, _cache[54] || (_cache[54] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-exclamation-triangle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your background check requires additional action. Please check your email for instructions from our background check provider, or contact "),
                                (0, _vue.createElementVNode)("a", {
                                    href: "mailto:support@asher-rides.com"
                                }, "support@asher-rides.com", -1),
                                (0, _vue.createTextVNode)(" if you need help. ")
                            ]))) : $setup.statusData.backgroundCheckStatus === 'FAILED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_88, _cache[55] || (_cache[55] = [
                                (0, _vue.createElementVNode)("i", {
                                    class: "fa fa-times-circle me-2"
                                }, null, -1),
                                (0, _vue.createTextVNode)("Your background check did not pass. Please contact support for more information. ")
                            ]))) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, _vue.createVNode)($setup["DriverReferralDashboard"]),
                    _cache[57] || (_cache[57] = (0, _vue.createElementVNode)("div", {
                        class: "card mb-4 shadow-sm"
                    }, [
                        (0, _vue.createElementVNode)("div", {
                            class: "card-body text-center"
                        }, [
                            (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Need help? Contact us at"),
                            (0, _vue.createElementVNode)("a", {
                                href: "mailto:support@asher-rides.com",
                                class: "text-primary"
                            }, "support@asher-rides.com")
                        ])
                    ], -1))
                ]))
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ln0BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDOP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("be16068592b420b");
    if (script.__esModule) script = script.default;
    script.render = require("f48477cd48b3d71f").render;
    script.__cssModules = require("d08fc1d59b310842").default;
    require("12335c43f6f56dbe").default(script);
    script.__scopeId = 'data-v-9ca8e9';
    script.__file = "SharedRideStatus.vue";
};
initialize();
exports.default = script;

},{"be16068592b420b":"e5gEn","f48477cd48b3d71f":"kRdW8","d08fc1d59b310842":"2sqbL","12335c43f6f56dbe":"lowad","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5gEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
const POLL_MS = 15000;
/// The rider app's own palette, so the share link and the app the rider is
/// holding show the same ride in the same colours.
const COLOR_PICKUP = '#28C76F';
const COLOR_STOP = '#ff8000';
const COLOR_DESTINATION = '#e83330';
const COLOR_ROUTE = '#007AFF';
/**
 * The distance the driver must have covered before the arrow is re-aimed.
 *
 * The API carries no heading, so the bearing is derived from consecutive polled
 * positions. At a 15-second poll this is roughly 5 km/h — below it the movement
 * is as likely to be GPS scatter as travel, and aiming at scatter makes the
 * arrow spin on the spot while the car is stationary.
 */ const MIN_BEARING_METRES = 20;
exports.default = {
    __name: 'SharedRideStatus',
    props: {
        token: {
            type: String,
            required: true
        },
        googleMapsApiKey: {
            type: String,
            default: ''
        },
        initialExpired: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const rideData = (0, _vue.ref)(null);
        const loading = (0, _vue.ref)(!props.initialExpired);
        const expired = (0, _vue.ref)(props.initialExpired);
        const error = (0, _vue.ref)(null);
        // True once the viewer has panned or zoomed for themselves. From that point the
        // camera stops re-framing on every poll — otherwise a viewer who zoomed in on
        // the driver was thrown back out to the whole route fifteen seconds later.
        const viewerTookControl = (0, _vue.ref)(false);
        // Not reactive: none of this is rendered, and Vue's proxy around a Google Maps
        // object breaks identity comparisons inside the SDK.
        let map = null;
        let pickupMarker = null;
        let dropOffMarker = null;
        let driverMarker = null;
        let stopMarkers = [];
        let routeLine = null;
        let pollingInterval = null;
        let hasFramedRoute = false;
        let lastDriverPosition = null;
        let driverBearing = 0;
        const statusLabel = (0, _vue.computed)(()=>{
            if (!rideData.value) return '';
            const labels = {
                PENDING: 'Finding Driver',
                ACCEPTED: 'Driver Assigned',
                TO_PICKUP: 'Driver En Route',
                WAITING_PICKUP: 'Driver Arrived',
                IN_PROGRESS: 'In Progress',
                STOPPED: 'At a Stop',
                COMPLETED: 'Completed',
                CANCELLED: 'Cancelled',
                DRIVER_NOT_FOUND: 'No Driver Found'
            };
            return labels[rideData.value.rideStatus] || rideData.value.rideStatus;
        });
        const statusBadgeClass = (0, _vue.computed)(()=>{
            if (!rideData.value) return 'bg-secondary';
            const classes = {
                PENDING: 'bg-warning text-dark',
                ACCEPTED: 'bg-info',
                TO_PICKUP: 'bg-info',
                WAITING_PICKUP: 'bg-info',
                IN_PROGRESS: 'bg-success',
                STOPPED: 'bg-warning text-dark',
                COMPLETED: 'bg-success',
                CANCELLED: 'bg-danger',
                DRIVER_NOT_FOUND: 'bg-secondary'
            };
            return classes[rideData.value.rideStatus] || 'bg-secondary';
        });
        function svgIcon(markup) {
            return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(markup);
        }
        /**
 * The circle-and-stem pin the rider app uses, in the requested colour.
 *
 * Drawn rather than loaded from the app's PNGs so it can be recoloured and
 * numbered without shipping four more binaries; the geometry is traced from
 * assets/icon/map_marker.png so the two read as the same marker.
 */ function pinIcon(color, { hollow = false } = {}) {
            const inner = hollow ? `<circle cx="396" cy="282" r="100" fill="#ffffff"/>` : `<path d="M396 130 a105 105 0 0 0 -105 105 c0 58 78 155 100 183 a6 6 0 0 0 10 0 c22 -28 100 -125 100 -183 a105 105 0 0 0 -105 -105 z" fill="#ffffff"/>
       <circle cx="396" cy="235" r="48" fill="${color}"/>`;
            return svgIcon(`<svg xmlns="http://www.w3.org/2000/svg" width="792" height="792" viewBox="0 0 792 792">
       <circle cx="396" cy="282" r="247" fill="${color}"/>
       ${inner}
       <path d="M370 548 L396 790 L422 548 Z" fill="${color}"/>
     </svg>`);
        }
        /**
 * The rider app's driver arrow (assets/markers/driver_marker.svg), rotated to
 * the given bearing.
 *
 * Google's `Icon` has no rotation of its own, so the turn is baked into the
 * artwork. The art points north about its own centre, which is why it is
 * anchored centrally rather than at a tip.
 */ function driverIcon(bearing) {
            return svgIcon(`<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
       <g transform="rotate(${bearing.toFixed(1)} 48 48)">
         <path d="M48 8 L74 78 L48 64 L22 78 Z" fill="#191b1f" stroke="#fbfaf7" stroke-width="6" stroke-linejoin="round"/>
         <path d="M48 8 L60 40 L48 34 L36 40 Z" fill="#7a55e8"/>
       </g>
     </svg>`);
        }
        function pinMarkerOptions(color, opts = {}) {
            return {
                url: pinIcon(color, opts),
                scaledSize: new google.maps.Size(46, 46),
                anchor: new google.maps.Point(23, 46),
                labelOrigin: new google.maps.Point(23, 16)
            };
        }
        function latLng(location) {
            if (!location) return null;
            const { latitude, longitude } = location;
            if (typeof latitude !== 'number' || typeof longitude !== 'number') return null;
            return {
                lat: latitude,
                lng: longitude
            };
        }
        async function fetchRideStatus() {
            try {
                loading.value = !rideData.value;
                const response = await fetch(`/api/ride/shared-status?token=${props.token}`);
                if (!response.ok) {
                    error.value = 'Unable to load ride status.';
                    loading.value = false;
                    return;
                }
                const data = await response.json();
                if (data.expired) {
                    expired.value = true;
                    loading.value = false;
                    stopPolling();
                    return;
                }
                rideData.value = data;
                loading.value = false;
                if (data.rideActive) {
                    await (0, _vue.nextTick)();
                    initOrUpdateMap();
                    startPolling();
                } else stopPolling();
            } catch (err) {
                console.error('Error fetching ride status:', err);
                error.value = 'Unable to load ride status. Please try again later.';
                loading.value = false;
            }
        }
        function startPolling() {
            if (pollingInterval) return;
            pollingInterval = setInterval(fetchRideStatus, POLL_MS);
        }
        function stopPolling() {
            if (pollingInterval) {
                clearInterval(pollingInterval);
                pollingInterval = null;
            }
        }
        function createMap(mapEl) {
            map = new google.maps.Map(mapEl, {
                zoom: 14,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
            // A raw pointer on the map element, not a camera event: `zoom_changed` and
            // `center_changed` also fire for our own fitBounds, so using those would have
            // the map hand control away to a viewer who never touched it.
            [
                'mousedown',
                'touchstart',
                'wheel'
            ].forEach((evt)=>{
                mapEl.addEventListener(evt, ()=>{
                    viewerTookControl.value = true;
                }, {
                    passive: true
                });
            });
        }
        function drawRoute(bounds) {
            const encoded = rideData.value.routePolyline;
            const encoding = window.google && google.maps.geometry && google.maps.geometry.encoding;
            if (!encoded || !encoding) // No route resolved server-side. Leave whatever line is already drawn: a
            // single failed poll should not blank the route for the rest of the ride.
            return;
            const path = encoding.decodePath(encoded);
            if (!path.length) return;
            if (!routeLine) routeLine = new google.maps.Polyline({
                map,
                path,
                strokeColor: COLOR_ROUTE,
                strokeOpacity: 0.85,
                strokeWeight: 6
            });
            else routeLine.setPath(path);
            path.forEach((point)=>bounds.extend(point));
        }
        function drawStops(bounds) {
            const stops = (rideData.value.stops || []).filter((stop)=>latLng(stop));
            // Rebuilt rather than reconciled: the itinerary is editable mid-ride, so a
            // stop can be removed and the markers must not outlive it.
            stopMarkers.forEach((marker)=>marker.setMap(null));
            stopMarkers = [];
            stops.forEach((stop)=>{
                const pos = latLng(stop);
                stopMarkers.push(new google.maps.Marker({
                    position: pos,
                    map,
                    title: stop.address || `Stop ${stop.stopOrder}`,
                    icon: pinMarkerOptions(COLOR_STOP, {
                        hollow: true
                    }),
                    label: {
                        text: String(stop.stopOrder),
                        color: COLOR_STOP,
                        fontSize: '11px',
                        fontWeight: '700'
                    }
                }));
                bounds.extend(pos);
            });
        }
        function drawDriver(bounds) {
            const pos = latLng(rideData.value.driverLocation);
            if (!pos) return;
            const spherical = window.google && google.maps.geometry && google.maps.geometry.spherical;
            if (lastDriverPosition && spherical) {
                const from = new google.maps.LatLng(lastDriverPosition);
                const to = new google.maps.LatLng(pos);
                if (spherical.computeDistanceBetween(from, to) >= MIN_BEARING_METRES) driverBearing = spherical.computeHeading(from, to);
            }
            lastDriverPosition = pos;
            const icon = {
                url: driverIcon(driverBearing),
                scaledSize: new google.maps.Size(42, 42),
                anchor: new google.maps.Point(21, 21)
            };
            if (!driverMarker) driverMarker = new google.maps.Marker({
                position: pos,
                map,
                title: 'Driver',
                icon,
                zIndex: 10
            });
            else {
                driverMarker.setPosition(pos);
                driverMarker.setIcon(icon);
            }
            bounds.extend(pos);
        }
        function initOrUpdateMap() {
            const mapEl = document.getElementById('shared-ride-map');
            if (!mapEl || !window.google || !rideData.value) return;
            if (!map) createMap(mapEl);
            const bounds = new google.maps.LatLngBounds();
            const pickup = latLng(rideData.value.pickupLocation);
            if (pickup) {
                if (!pickupMarker) pickupMarker = new google.maps.Marker({
                    position: pickup,
                    map,
                    title: 'Pickup',
                    icon: pinMarkerOptions(COLOR_PICKUP, {
                        hollow: true
                    })
                });
                else pickupMarker.setPosition(pickup);
                bounds.extend(pickup);
            }
            const dropOff = latLng(rideData.value.dropOffLocation);
            if (dropOff) {
                if (!dropOffMarker) dropOffMarker = new google.maps.Marker({
                    position: dropOff,
                    map,
                    title: 'Drop-off',
                    icon: pinMarkerOptions(COLOR_DESTINATION)
                });
                else dropOffMarker.setPosition(dropOff);
                bounds.extend(dropOff);
            }
            drawStops(bounds);
            drawRoute(bounds);
            drawDriver(bounds);
            if (bounds.isEmpty()) return;
            if (hasFramedRoute && viewerTookControl.value) return;
            hasFramedRoute = true;
            map.fitBounds(bounds, {
                top: 40,
                bottom: 40,
                left: 40,
                right: 40
            });
        }
        /** Re-frames the whole ride after the viewer has moved the map themselves. */ function recentre() {
            viewerTookControl.value = false;
            initOrUpdateMap();
        }
        function formatDateTime(dateStr) {
            if (!dateStr) return '';
            try {
                return new Date(dateStr).toLocaleString(undefined, {
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                });
            } catch (e) {
                return dateStr;
            }
        }
        (0, _vue.onMounted)(()=>{
            if (!expired.value) fetchRideStatus();
        });
        (0, _vue.onBeforeUnmount)(stopPolling);
        const __returned__ = {
            props,
            rideData,
            loading,
            expired,
            error,
            viewerTookControl,
            get map () {
                return map;
            },
            set map (v){
                map = v;
            },
            get pickupMarker () {
                return pickupMarker;
            },
            set pickupMarker (v){
                pickupMarker = v;
            },
            get dropOffMarker () {
                return dropOffMarker;
            },
            set dropOffMarker (v){
                dropOffMarker = v;
            },
            get driverMarker () {
                return driverMarker;
            },
            set driverMarker (v){
                driverMarker = v;
            },
            get stopMarkers () {
                return stopMarkers;
            },
            set stopMarkers (v){
                stopMarkers = v;
            },
            get routeLine () {
                return routeLine;
            },
            set routeLine (v){
                routeLine = v;
            },
            get pollingInterval () {
                return pollingInterval;
            },
            set pollingInterval (v){
                pollingInterval = v;
            },
            get hasFramedRoute () {
                return hasFramedRoute;
            },
            set hasFramedRoute (v){
                hasFramedRoute = v;
            },
            get lastDriverPosition () {
                return lastDriverPosition;
            },
            set lastDriverPosition (v){
                lastDriverPosition = v;
            },
            get driverBearing () {
                return driverBearing;
            },
            set driverBearing (v){
                driverBearing = v;
            },
            POLL_MS,
            COLOR_PICKUP,
            COLOR_STOP,
            COLOR_DESTINATION,
            COLOR_ROUTE,
            MIN_BEARING_METRES,
            statusLabel,
            statusBadgeClass,
            svgIcon,
            pinIcon,
            driverIcon,
            pinMarkerOptions,
            latLng,
            fetchRideStatus,
            startPolling,
            stopPolling,
            createMap,
            drawRoute,
            drawStops,
            drawDriver,
            initOrUpdateMap,
            recentre,
            formatDateTime,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            onBeforeUnmount: (0, _vue.onBeforeUnmount),
            nextTick: (0, _vue.nextTick)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kRdW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0 justify-content-center"
};
const _hoisted_3 = {
    class: "col-12 col-md-10 col-lg-8 p-0"
};
const _hoisted_4 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_5 = {
    key: 1,
    class: "text-center py-5"
};
const _hoisted_6 = {
    key: 2,
    class: "pb-4"
};
const _hoisted_7 = {
    class: "bg-primary text-white px-3 py-3 d-flex align-items-center justify-content-between"
};
const _hoisted_8 = {
    key: 0,
    class: "position-relative"
};
const _hoisted_9 = {
    key: 1,
    class: "text-center py-5 mx-3"
};
const _hoisted_10 = {
    class: "card shadow-sm"
};
const _hoisted_11 = {
    class: "card-body py-5"
};
const _hoisted_12 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_13 = {
    key: 2,
    class: "text-center py-5 mx-3"
};
const _hoisted_14 = {
    class: "card shadow-sm"
};
const _hoisted_15 = {
    class: "card-body py-4"
};
const _hoisted_16 = {
    class: "mb-2"
};
const _hoisted_17 = {
    class: "mx-3 mt-3"
};
const _hoisted_18 = {
    key: 0,
    class: "card shadow-sm mb-3"
};
const _hoisted_19 = {
    class: "card-body"
};
const _hoisted_20 = {
    class: "d-flex align-items-start mb-2"
};
const _hoisted_21 = {
    class: "fw-medium"
};
const _hoisted_22 = {
    key: 0
};
const _hoisted_23 = {
    class: "text-muted"
};
const _hoisted_24 = {
    class: "fw-medium"
};
const _hoisted_25 = {
    class: "d-flex align-items-start"
};
const _hoisted_26 = {
    class: "fw-medium"
};
const _hoisted_27 = {
    key: 1,
    class: "card shadow-sm mb-3"
};
const _hoisted_28 = {
    class: "card-body"
};
const _hoisted_29 = {
    class: "d-flex align-items-center"
};
const _hoisted_30 = {
    class: "fw-bold"
};
const _hoisted_31 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_32 = {
    key: 2,
    class: "card shadow-sm mb-3"
};
const _hoisted_33 = {
    class: "text-center py-3"
};
const _hoisted_34 = {
    class: "text-muted"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                $setup.expired ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, _cache[0] || (_cache[0] = [
                    (0, _vue.createStaticVNode)("<div class=\"card shadow-sm mx-3 my-4\" data-v-9ca8e9><div class=\"card-body py-5\" data-v-9ca8e9><div class=\"mb-4\" data-v-9ca8e9><i class=\"fa fa-clock fa-3x text-muted\" data-v-9ca8e9></i></div><h4 class=\"mb-3\" data-v-9ca8e9>This link has expired</h4><p class=\"text-muted mb-4\" data-v-9ca8e9> This ride status link is no longer active. Please ask the person who shared it with you to send a new link. </p><div class=\"mt-4 pt-3 border-top\" data-v-9ca8e9><p class=\"text-muted small mb-2\" data-v-9ca8e9>Don&#39;t have Asher yet?</p><a href=\"#\" class=\"btn btn-primary btn-lg px-4\" data-v-9ca8e9>Download Asher</a><p class=\"text-muted small mt-3\" data-v-9ca8e9>Get safe, reliable rides at your fingertips.</p></div></div></div>", 1)
                ]))) : $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, _cache[1] || (_cache[1] = [
                    (0, _vue.createElementVNode)("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, [
                        (0, _vue.createElementVNode)("span", {
                            class: "visually-hidden"
                        }, "Loading...")
                    ], -1),
                    (0, _vue.createElementVNode)("p", {
                        class: "mt-3 text-muted"
                    }, "Loading ride status...", -1)
                ]))) : $setup.rideData ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, [
                    (0, _vue.createElementVNode)("div", _hoisted_7, [
                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("h5", {
                                class: "mb-0 fw-bold"
                            }, "Asher Rides"),
                            (0, _vue.createElementVNode)("small", null, "Live Ride Status")
                        ], -1)),
                        (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)([
                                    "badge rounded-pill",
                                    $setup.statusBadgeClass
                                ])
                            }, (0, _vue.toDisplayString)($setup.statusLabel), 3)
                        ])
                    ]),
                    $setup.rideData.rideActive ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
                            id: "shared-ride-map",
                            class: "w-100",
                            style: {
                                "height": "350px"
                            }
                        }, null, -1)),
                        $setup.viewerTookControl ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-light shadow-sm rounded-circle position-absolute",
                            style: {
                                "right": "12px",
                                "bottom": "12px",
                                "width": "40px",
                                "height": "40px"
                            },
                            title: "Show the whole route",
                            onClick: $setup.recentre
                        }, _cache[3] || (_cache[3] = [
                            (0, _vue.createElementVNode)("i", {
                                class: "fa fa-expand text-primary"
                            }, null, -1)
                        ]))) : (0, _vue.createCommentVNode)("", true)
                    ])) : (0, _vue.createCommentVNode)("", true),
                    $setup.rideData.rideCompleted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                        (0, _vue.createElementVNode)("div", _hoisted_10, [
                            (0, _vue.createElementVNode)("div", _hoisted_11, [
                                _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                                    class: "mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-check-circle fa-4x text-success"
                                    })
                                ], -1)),
                                _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("h4", {
                                    class: "mb-2"
                                }, "Ride Completed Safely", -1)),
                                _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("p", {
                                    class: "text-muted"
                                }, " The rider has arrived at their destination. ", -1)),
                                $setup.rideData.orderCompletionDateTime ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_12, " Completed at " + (0, _vue.toDisplayString)($setup.formatDateTime($setup.rideData.orderCompletionDateTime)), 1)) : (0, _vue.createCommentVNode)("", true)
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    !$setup.rideData.rideCompleted && !$setup.rideData.rideActive ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_13, [
                        (0, _vue.createElementVNode)("div", _hoisted_14, [
                            (0, _vue.createElementVNode)("div", _hoisted_15, [
                                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("div", {
                                    class: "mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-info-circle fa-3x text-muted"
                                    })
                                ], -1)),
                                (0, _vue.createElementVNode)("h5", _hoisted_16, "Ride " + (0, _vue.toDisplayString)($setup.rideData.rideStatus === 'CANCELLED' ? 'Cancelled' : 'Ended'), 1),
                                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("p", {
                                    class: "text-muted"
                                }, "This ride is no longer active.", -1))
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createElementVNode)("div", _hoisted_17, [
                        $setup.rideData.rideActive || $setup.rideData.rideCompleted ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_18, [
                            (0, _vue.createElementVNode)("div", _hoisted_19, [
                                _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("h6", {
                                    class: "fw-bold mb-3"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-route me-2"
                                    }),
                                    (0, _vue.createTextVNode)("Trip Details")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                                        class: "me-3 text-center",
                                        style: {
                                            "min-width": "20px"
                                        }
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-circle text-success",
                                            style: {
                                                "font-size": "10px"
                                            }
                                        })
                                    ], -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("small", {
                                            class: "text-muted"
                                        }, "Pickup", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_21, (0, _vue.toDisplayString)($setup.rideData.pickupLocation?.address || 'Location not available'), 1)
                                    ])
                                ]),
                                $setup.rideData.stops && $setup.rideData.stops.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_22, [
                                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.rideData.stops, (stop)=>{
                                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                            key: stop.stopOrder,
                                            class: "d-flex align-items-start mb-2"
                                        }, [
                                            _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("div", {
                                                class: "me-3 text-center",
                                                style: {
                                                    "min-width": "20px"
                                                }
                                            }, [
                                                (0, _vue.createElementVNode)("i", {
                                                    class: "fa fa-circle text-warning",
                                                    style: {
                                                        "font-size": "10px"
                                                    }
                                                })
                                            ], -1)),
                                            (0, _vue.createElementVNode)("div", null, [
                                                (0, _vue.createElementVNode)("small", _hoisted_23, "Stop " + (0, _vue.toDisplayString)(stop.stopOrder), 1),
                                                (0, _vue.createElementVNode)("div", _hoisted_24, (0, _vue.toDisplayString)(stop.address || 'Stop location'), 1)
                                            ])
                                        ]);
                                    }), 128))
                                ])) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createElementVNode)("div", _hoisted_25, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("div", {
                                        class: "me-3 text-center",
                                        style: {
                                            "min-width": "20px"
                                        }
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-map-marker-alt text-danger",
                                            style: {
                                                "font-size": "14px"
                                            }
                                        })
                                    ], -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("small", {
                                            class: "text-muted"
                                        }, "Drop-off", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_26, (0, _vue.toDisplayString)($setup.rideData.dropOffLocation?.address || 'Location not available'), 1)
                                    ])
                                ])
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.rideData.driverFirstName && $setup.rideData.rideActive ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_27, [
                            (0, _vue.createElementVNode)("div", _hoisted_28, [
                                _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("h6", {
                                    class: "fw-bold mb-2"
                                }, [
                                    (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-id-badge me-2"
                                    }),
                                    (0, _vue.createTextVNode)("Driver")
                                ], -1)),
                                (0, _vue.createElementVNode)("div", _hoisted_29, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                                        class: "bg-light rounded-circle d-flex align-items-center justify-content-center me-3",
                                        style: {
                                            "width": "48px",
                                            "height": "48px"
                                        }
                                    }, [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-user text-muted fa-lg"
                                        })
                                    ], -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        (0, _vue.createElementVNode)("div", _hoisted_30, (0, _vue.toDisplayString)($setup.rideData.driverFirstName), 1),
                                        $setup.rideData.vehicleDescription ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_31, (0, _vue.toDisplayString)($setup.rideData.vehicleColor ? $setup.rideData.vehicleColor + ' ' : '') + (0, _vue.toDisplayString)($setup.rideData.vehicleDescription), 1)) : (0, _vue.createCommentVNode)("", true)
                                    ])
                                ])
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.rideData.rideActive ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, _cache[18] || (_cache[18] = [
                            (0, _vue.createStaticVNode)("<div class=\"card-body text-center\" data-v-9ca8e9><div class=\"mb-2\" data-v-9ca8e9><i class=\"fa fa-shield-alt text-primary fa-2x\" data-v-9ca8e9></i></div><h6 class=\"fw-bold\" data-v-9ca8e9>Ride Monitoring Active</h6><p class=\"text-muted small mb-0\" data-v-9ca8e9> This ride is being tracked for safety. Status updates are live. </p></div>", 1)
                        ]))) : (0, _vue.createCommentVNode)("", true)
                    ]),
                    _cache[19] || (_cache[19] = (0, _vue.createStaticVNode)("<div class=\"mx-3 mt-4 mb-3\" data-v-9ca8e9><div class=\"card border-primary shadow-sm\" data-v-9ca8e9><div class=\"card-body text-center py-4\" data-v-9ca8e9><h5 class=\"fw-bold mb-2\" data-v-9ca8e9>Get Asher Rides</h5><p class=\"text-muted mb-3\" data-v-9ca8e9>Safe, reliable rides at your fingertips. Download the app and get your first ride today.</p><a href=\"#\" class=\"btn btn-primary btn-lg px-4 mb-2\" data-v-9ca8e9>Download Now</a><p class=\"text-muted small mt-2 mb-0\" data-v-9ca8e9>Available on iOS and Android</p></div></div></div>", 1)),
                    (0, _vue.createElementVNode)("div", _hoisted_33, [
                        (0, _vue.createElementVNode)("small", _hoisted_34, "\xa9 " + (0, _vue.toDisplayString)(new Date().getFullYear()) + " Asher Rides. All rights reserved.", 1)
                    ])
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sqbL":[function() {},{}],"lowad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3o4wU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = {};
    script.render = require("3b08969ba5a14e9").render;
    script.__cssModules = require("aac0c76b70b2699d").default;
    require("9499c0a1360e037f").default(script);
    script.__scopeId = 'data-v-edebe9';
    script.__file = "PortalChooser.vue";
};
initialize();
exports.default = script;

},{"3b08969ba5a14e9":"hnPvk","aac0c76b70b2699d":"fHocp","9499c0a1360e037f":"dBFI9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hnPvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
function render(_ctx, _cache) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, _cache[0] || (_cache[0] = [
        (0, _vue.createStaticVNode)("<div class=\"row m-0\" data-v-edebe9><div class=\"col-12 p-0\" data-v-edebe9><div class=\"login-card login-dark\" data-v-edebe9><div data-v-edebe9><div data-v-edebe9><a class=\"logo\" href=\"/\" data-v-edebe9><img class=\"img-fluid for-light m-auto\" src=\"/assets/images/logo.svg\" alt=\"Asher\" data-v-edebe9><img class=\"img-fluid for-dark m-auto\" src=\"/assets/images/logo.svg\" alt=\"Asher\" data-v-edebe9></a></div><div class=\"login-main wide-main\" data-v-edebe9><div class=\"text-center mb-2\" data-v-edebe9><h2 class=\"mb-1 fw-bold\" data-v-edebe9>Welcome to Asher</h2><p class=\"text-muted mb-0\" data-v-edebe9>Choose how you&#39;d like to continue</p></div><div class=\"row g-4 mt-2\" data-v-edebe9><div class=\"col-12 col-md-6\" data-v-edebe9><a href=\"/driver/login\" class=\"portal-option d-block text-decoration-none h-100\" data-v-edebe9><div class=\"card border rounded-4 shadow-sm h-100 text-center px-4 py-5\" data-v-edebe9><div class=\"portal-icon portal-icon-driver mx-auto mb-4\" data-v-edebe9><i class=\"fa fa-car-side\" data-v-edebe9></i></div><h4 class=\"fw-bold mb-2\" data-v-edebe9>Driver login</h4><p class=\"text-muted mb-4\" data-v-edebe9>Sign in to your driver account and track your application status.</p><span class=\"btn btn-outline-primary rounded-pill px-4 mt-auto align-self-center\" data-v-edebe9> Continue as Driver <i class=\"fa fa-arrow-right ms-2\" data-v-edebe9></i></span></div></a></div><div class=\"col-12 col-md-6\" data-v-edebe9><a href=\"/portal/rider\" class=\"portal-option d-block text-decoration-none h-100\" data-v-edebe9><div class=\"card border rounded-4 shadow-sm h-100 text-center px-4 py-5\" data-v-edebe9><div class=\"portal-icon portal-icon-rider mx-auto mb-4\" data-v-edebe9><i class=\"fa fa-user\" data-v-edebe9></i></div><h4 class=\"fw-bold mb-2\" data-v-edebe9>Rider login</h4><p class=\"text-muted mb-4\" data-v-edebe9>Join the waitlist or sign in to track your status.</p><span class=\"btn btn-outline-primary rounded-pill px-4 mt-auto align-self-center\" data-v-edebe9> Continue as Rider <i class=\"fa fa-arrow-right ms-2\" data-v-edebe9></i></span></div></a></div></div><p class=\"text-center text-muted small mt-4 mb-0\" data-v-edebe9> New to Asher? Selecting an option will guide you through sign up. </p></div></div></div></div></div>", 1)
    ]));
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHocp":[function() {},{}],"dBFI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6c9b0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("523932e68c358e1");
    if (script.__esModule) script = script.default;
    script.render = require("ec71a9bba40d48f8").render;
    script.__cssModules = require("ff7f28e63a9e9c39").default;
    require("442bf4a5bafc0ce2").default(script);
    script.__scopeId = 'data-v-d871b4';
    script.__file = "RiderWaitlistPortal.vue";
};
initialize();
exports.default = script;

},{"523932e68c358e1":"aojEO","ec71a9bba40d48f8":"7Zr0e","ff7f28e63a9e9c39":"hUSCG","442bf4a5bafc0ce2":"1UFqG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aojEO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _riderCompleteProfileFormVue = require("./RiderCompleteProfileForm.vue");
var _riderCompleteProfileFormVueDefault = parcelHelpers.interopDefault(_riderCompleteProfileFormVue);
var _riderVerifyNudgeJs = require("../utility/riderVerifyNudge.js");
// Must match the .sso-buttons width in <style>; Google's SDK renders at a fixed
// pixel width rather than filling its container.
const SSO_BUTTON_WIDTH_PX = 280;
exports.default = {
    __name: 'RiderWaitlistPortal',
    props: {
        googleClientId: {
            type: String,
            default: ''
        },
        appleServiceId: {
            type: String,
            default: ''
        },
        appleRedirectUri: {
            type: String,
            default: ''
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const mode = (0, _vue.ref)('login'); // 'login' | 'signup' | 'complete-profile'
        const channel = (0, _vue.ref)('phone'); // 'phone' | 'email'
        const firstName = (0, _vue.ref)('');
        const lastName = (0, _vue.ref)('');
        const referralCode = (0, _vue.ref)('');
        const email = (0, _vue.ref)('');
        const countryCode = (0, _vue.ref)('+1');
        const phoneNumber = (0, _vue.ref)('');
        const agreedToLegalPolicy = (0, _vue.ref)(false);
        const otpCode = (0, _vue.ref)('');
        const otpSent = (0, _vue.ref)(false);
        const loading = (0, _vue.ref)(false);
        const resendSeconds = (0, _vue.ref)(0);
        const errorMessage = (0, _vue.ref)(null);
        const infoMessage = (0, _vue.ref)(null);
        // Set when the login identifier has no account, so the error banner can offer the signup form
        // with whatever the visitor already typed still in place.
        const notRegistered = (0, _vue.ref)(false);
        const googleButtonContainer = (0, _vue.ref)(null);
        let resendTimer = null;
        const isEmail = (0, _vue.computed)(()=>channel.value === 'email');
        const isBusy = (0, _vue.computed)(()=>loading.value);
        // The contact sent to the backend: raw email, or country code + phone digits.
        const effectiveIdentifier = (0, _vue.computed)(()=>isEmail.value ? email.value : `${countryCode.value}${phoneNumber.value}`);
        const primaryButtonLabel = (0, _vue.computed)(()=>{
            if (!otpSent.value) return 'Send code';
            return mode.value === 'signup' ? 'Join the waitlist' : 'Log in';
        });
        (0, _vue.onMounted)(()=>{
            const refParam = new URLSearchParams(window.location.search).get('ref');
            if (refParam) referralCode.value = refParam;
            initGoogleSignIn();
            initAppleSignIn();
        });
        function resetFlow() {
            otpSent.value = false;
            otpCode.value = '';
            errorMessage.value = null;
            infoMessage.value = null;
            notRegistered.value = false;
            stopResend();
        }
        function switchMode(next) {
            mode.value = next;
            resetFlow();
        }
        function setChannel(next) {
            if (otpSent.value) return; // don't switch mid-verification
            channel.value = next;
            errorMessage.value = null;
        }
        function startResendCountdown(seconds = 30) {
            stopResend();
            resendSeconds.value = seconds;
            resendTimer = setInterval(()=>{
                if (resendSeconds.value > 0) resendSeconds.value -= 1;
                else stopResend();
            }, 1000);
        }
        function stopResend() {
            if (resendTimer) {
                clearInterval(resendTimer);
                resendTimer = null;
            }
        }
        async function postJson(url, payload) {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            let data = null;
            try {
                data = await res.json();
            } catch (e) {}
            if (!res.ok) {
                const text = data ? data.message || '' : await res.text().catch(()=>'');
                throw new Error(text || 'Something went wrong. Please try again.');
            }
            return data || {};
        }
        function onPrimarySubmit() {
            if (otpSent.value) mode.value === 'signup' ? submitSignup() : submitLogin();
            else sendCode();
        }
        async function sendCode() {
            errorMessage.value = null;
            infoMessage.value = null;
            notRegistered.value = false;
            if (isEmail.value ? !email.value : !phoneNumber.value) {
                errorMessage.value = isEmail.value ? 'Please enter your email.' : 'Please enter your phone number.';
                return;
            }
            if (mode.value === 'signup' && (!firstName.value || !lastName.value || !agreedToLegalPolicy.value)) {
                errorMessage.value = 'Please enter your name and agree to the terms.';
                return;
            }
            loading.value = true;
            try {
                const url = mode.value === 'signup' ? '/api/portal/rider/send-signup-otp' : '/api/portal/rider/send-login-otp';
                const data = await postJson(url, {
                    userIdentifier: effectiveIdentifier.value,
                    isEmail: isEmail.value
                });
                if (data.success === false) {
                    errorMessage.value = data.message || 'Unable to send verification code.';
                    notRegistered.value = data.code === 'not_registered';
                    return;
                }
                otpSent.value = true;
                infoMessage.value = data.message || 'Verification code sent.';
                startResendCountdown(30);
            } catch (e) {
                errorMessage.value = e.message;
            } finally{
                loading.value = false;
            }
        }
        async function submitSignup() {
            errorMessage.value = null;
            if (!otpCode.value) {
                errorMessage.value = 'Please enter the verification code.';
                return;
            }
            loading.value = true;
            try {
                const payload = {
                    firstName: firstName.value,
                    lastName: lastName.value,
                    email: isEmail.value ? email.value : null,
                    phoneNumber: isEmail.value ? null : effectiveIdentifier.value,
                    otpCode: otpCode.value,
                    otpIsEmail: isEmail.value,
                    agreedToLegalPolicy: agreedToLegalPolicy.value,
                    referralCode: referralCode.value || null
                };
                const data = await postJson('/api/portal/rider/signup', payload);
                if (data.success && data.redirectUrl) {
                    // A fresh login-like landing always re-arms the verify-contact nudge, even if it was
                    // dismissed in an earlier session.
                    sessionStorage.removeItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY));
                    window.location.href = data.redirectUrl;
                } else errorMessage.value = data.message || 'Unable to complete signup.';
            } catch (e) {
                errorMessage.value = e.message;
            } finally{
                loading.value = false;
            }
        }
        async function submitLogin() {
            errorMessage.value = null;
            if (!otpCode.value) {
                errorMessage.value = 'Please enter the verification code.';
                return;
            }
            loading.value = true;
            try {
                const data = await postJson('/api/portal/rider/login', {
                    userIdentifier: effectiveIdentifier.value,
                    isEmail: isEmail.value,
                    otpCode: otpCode.value
                });
                if (data.success && data.redirectUrl) {
                    // A fresh login-like landing always re-arms the verify-contact nudge, even if it was
                    // dismissed in an earlier session.
                    sessionStorage.removeItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY));
                    window.location.href = data.redirectUrl;
                } else errorMessage.value = data.message || 'Invalid verification code.';
            } catch (e) {
                errorMessage.value = e.message;
            } finally{
                loading.value = false;
            }
        }
        function loadScriptOnce(src) {
            return new Promise((resolve, reject)=>{
                if (document.querySelector(`script[src="${src}"]`)) {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = src;
                script.async = true;
                script.onload = ()=>resolve();
                script.onerror = ()=>reject(new Error(`Failed to load ${src}`));
                document.head.appendChild(script);
            });
        }
        async function initGoogleSignIn() {
            if (!props.googleClientId || !googleButtonContainer.value) return;
            try {
                await loadScriptOnce('https://accounts.google.com/gsi/client');
                window.google.accounts.id.initialize({
                    client_id: props.googleClientId,
                    callback: handleGoogleCredential
                });
                window.google.accounts.id.renderButton(googleButtonContainer.value, {
                    theme: 'outline',
                    size: 'large',
                    shape: 'rectangular',
                    text: 'signin_with',
                    width: SSO_BUTTON_WIDTH_PX
                });
            } catch (e) {
                errorMessage.value = 'Unable to load Google sign-in right now.';
            }
        }
        async function handleGoogleCredential(response) {
            errorMessage.value = null;
            infoMessage.value = null;
            loading.value = true;
            try {
                await submitSso('google', response.credential);
            } finally{
                loading.value = false;
            }
        }
        async function initAppleSignIn() {
            if (!props.appleServiceId) return;
            try {
                await loadScriptOnce('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');
                window.AppleID.auth.init({
                    clientId: props.appleServiceId,
                    scope: 'name email',
                    redirectURI: props.appleRedirectUri,
                    usePopup: true
                });
            } catch (e) {
                errorMessage.value = 'Unable to load Apple sign-in right now.';
            }
        }
        async function handleAppleSignIn() {
            errorMessage.value = null;
            infoMessage.value = null;
            loading.value = true;
            try {
                const result = await window.AppleID.auth.signIn();
                await submitSso('apple', result.authorization.id_token);
            } catch (e) {
                if (!e || e.error !== 'popup_closed_by_user') errorMessage.value = 'Apple sign-in failed. Please try again.';
            } finally{
                loading.value = false;
            }
        }
        async function submitSso(provider, idToken) {
            // SSO consent is implicit, via the disclaimer shown under the Google/Apple buttons —
            // not gated on the phone/email signup form's explicit checkbox.
            const data = await postJson('/api/portal/rider/sso', {
                provider,
                idToken,
                agreedToLegalPolicy: true
            });
            if (data.success && data.redirectUrl) {
                // A fresh login-like landing always re-arms the verify-contact nudge, even if it was
                // dismissed in an earlier session.
                sessionStorage.removeItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY));
                window.location.href = data.redirectUrl;
            } else if (data.success && data.profileComplete === false) mode.value = 'complete-profile';
            else errorMessage.value = data.message || 'Unable to complete sign-in.';
        }
        (0, _vue.onUnmounted)(stopResend);
        const __returned__ = {
            SSO_BUTTON_WIDTH_PX,
            props,
            mode,
            channel,
            firstName,
            lastName,
            referralCode,
            email,
            countryCode,
            phoneNumber,
            agreedToLegalPolicy,
            otpCode,
            otpSent,
            loading,
            resendSeconds,
            errorMessage,
            infoMessage,
            notRegistered,
            googleButtonContainer,
            get resendTimer () {
                return resendTimer;
            },
            set resendTimer (v){
                resendTimer = v;
            },
            isEmail,
            isBusy,
            effectiveIdentifier,
            primaryButtonLabel,
            resetFlow,
            switchMode,
            setChannel,
            startResendCountdown,
            stopResend,
            postJson,
            onPrimarySubmit,
            sendCode,
            submitSignup,
            submitLogin,
            loadScriptOnce,
            initGoogleSignIn,
            handleGoogleCredential,
            initAppleSignIn,
            handleAppleSignIn,
            submitSso,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            onUnmounted: (0, _vue.onUnmounted),
            RiderCompleteProfileForm: (0, _riderCompleteProfileFormVueDefault.default),
            get RIDER_VERIFY_NUDGE_DISMISS_KEY () {
                return 0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./RiderCompleteProfileForm.vue":"3R3Hg","../utility/riderVerifyNudge.js":"8h67t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3R3Hg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("9af22fdfed0b275c");
    if (script.__esModule) script = script.default;
    script.render = require("9a70231fc1eec12e").render;
    require("84b77324b9383ab8").default(script);
    script.__scopeId = 'data-v-26ca4b';
    script.__file = "RiderCompleteProfileForm.vue";
};
initialize();
exports.default = script;

},{"9af22fdfed0b275c":"1Kw7T","9a70231fc1eec12e":"dtWc8","84b77324b9383ab8":"dbgJX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Kw7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _riderVerifyNudgeJs = require("../utility/riderVerifyNudge.js");
exports.default = {
    __name: 'RiderCompleteProfileForm',
    setup (__props, { expose: __expose }) {
        __expose();
        const channel = (0, _vue.ref)('phone'); // 'phone' | 'email'
        const email = (0, _vue.ref)('');
        const countryCode = (0, _vue.ref)('+1');
        const phoneNumber = (0, _vue.ref)('');
        const referralCode = (0, _vue.ref)('');
        const otpCode = (0, _vue.ref)('');
        const otpSent = (0, _vue.ref)(false);
        const loading = (0, _vue.ref)(false);
        const resendSeconds = (0, _vue.ref)(0);
        const errorMessage = (0, _vue.ref)(null);
        const infoMessage = (0, _vue.ref)(null);
        const hasExistingProfile = (0, _vue.ref)(false);
        let resendTimer = null;
        const isEmail = (0, _vue.computed)(()=>channel.value === 'email');
        const isBusy = (0, _vue.computed)(()=>loading.value);
        // The contact sent to the backend: raw email, or country code + phone digits.
        const effectiveIdentifier = (0, _vue.computed)(()=>isEmail.value ? email.value : `${countryCode.value}${phoneNumber.value}`);
        function setChannel(next) {
            if (otpSent.value) return; // don't switch mid-verification
            channel.value = next;
            errorMessage.value = null;
        }
        function startResendCountdown(seconds = 30) {
            stopResend();
            resendSeconds.value = seconds;
            resendTimer = setInterval(()=>{
                if (resendSeconds.value > 0) resendSeconds.value -= 1;
                else stopResend();
            }, 1000);
        }
        function stopResend() {
            if (resendTimer) {
                clearInterval(resendTimer);
                resendTimer = null;
            }
        }
        async function postJson(url, payload) {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            let data = null;
            try {
                data = await res.json();
            } catch (e) {}
            if (!res.ok) {
                const text = data ? data.message || '' : await res.text().catch(()=>'');
                throw new Error(text || 'Something went wrong. Please try again.');
            }
            return data || {};
        }
        async function sendCode() {
            errorMessage.value = null;
            infoMessage.value = null;
            if (isEmail.value ? !email.value : !phoneNumber.value) {
                errorMessage.value = isEmail.value ? 'Please enter your email.' : 'Please enter your phone number.';
                return;
            }
            loading.value = true;
            try {
                const data = await postJson('/api/portal/rider/send-signup-otp', {
                    userIdentifier: effectiveIdentifier.value,
                    isEmail: isEmail.value
                });
                if (data.success === false) {
                    errorMessage.value = data.message || 'Unable to send verification code.';
                    return;
                }
                otpSent.value = true;
                infoMessage.value = data.message || 'Verification code sent.';
                startResendCountdown(30);
            } catch (e) {
                errorMessage.value = e.message;
            } finally{
                loading.value = false;
            }
        }
        async function onSubmit() {
            if (!otpSent.value) {
                await sendCode();
                return;
            }
            errorMessage.value = null;
            if (!otpCode.value) {
                errorMessage.value = 'Please enter the verification code.';
                return;
            }
            loading.value = true;
            try {
                const data = await postJson('/api/portal/rider/complete-profile', {
                    email: isEmail.value ? email.value : null,
                    phoneNumber: isEmail.value ? null : effectiveIdentifier.value,
                    otpCode: otpCode.value,
                    otpIsEmail: isEmail.value,
                    referralCode: referralCode.value || null
                });
                if (data.success && data.redirectUrl) {
                    // A fresh login-like landing always re-arms the verify-contact nudge, even if it was
                    // dismissed in an earlier session.
                    sessionStorage.removeItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY));
                    window.location.href = data.redirectUrl;
                } else if (data.hasExistingProfile) {
                    hasExistingProfile.value = true;
                    errorMessage.value = data.message || 'This contact is already linked to another account.';
                } else errorMessage.value = data.message || 'Unable to complete your profile.';
            } catch (e) {
                errorMessage.value = e.message;
            } finally{
                loading.value = false;
            }
        }
        // Resets back to the verification step. Used both when linking fails (the OTP-verified
        // state it depends on may have expired) and when the rider wants to try a different
        // contact instead of linking - re-verifying is a safe recovery path either way.
        function resetToVerification(message = null) {
            errorMessage.value = message;
            hasExistingProfile.value = false;
            otpSent.value = false;
            otpCode.value = '';
        }
        async function linkProfile() {
            errorMessage.value = null;
            loading.value = true;
            try {
                const data = await postJson('/api/portal/rider/link-profile', {
                    email: isEmail.value ? email.value : null,
                    phoneNumber: isEmail.value ? null : effectiveIdentifier.value,
                    otpIsEmail: isEmail.value
                });
                if (data.success && data.redirectUrl) {
                    // A fresh login-like landing always re-arms the verify-contact nudge, even if it was
                    // dismissed in an earlier session.
                    sessionStorage.removeItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY));
                    window.location.href = data.redirectUrl;
                } else resetToVerification(data.message || 'Unable to link this profile. Please verify again.');
            } catch (e) {
                resetToVerification(e.message);
            } finally{
                loading.value = false;
            }
        }
        (0, _vue.onUnmounted)(stopResend);
        const __returned__ = {
            channel,
            email,
            countryCode,
            phoneNumber,
            referralCode,
            otpCode,
            otpSent,
            loading,
            resendSeconds,
            errorMessage,
            infoMessage,
            hasExistingProfile,
            get resendTimer () {
                return resendTimer;
            },
            set resendTimer (v){
                resendTimer = v;
            },
            isEmail,
            isBusy,
            effectiveIdentifier,
            setChannel,
            startResendCountdown,
            stopResend,
            postJson,
            sendCode,
            onSubmit,
            resetToVerification,
            linkProfile,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onUnmounted: (0, _vue.onUnmounted),
            get RIDER_VERIFY_NUDGE_DISMISS_KEY () {
                return 0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/riderVerifyNudge.js":"8h67t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8h67t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RIDER_VERIFY_NUDGE_DISMISS_KEY", ()=>RIDER_VERIFY_NUDGE_DISMISS_KEY);
const RIDER_VERIFY_NUDGE_DISMISS_KEY = 'riderVerifyNudgeDismissed';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dtWc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "alert alert-danger py-2",
    role: "alert"
};
const _hoisted_2 = {
    key: 1,
    class: "alert alert-info py-2",
    role: "alert"
};
const _hoisted_3 = {
    key: 2,
    class: "text-center"
};
const _hoisted_4 = [
    "disabled"
];
const _hoisted_5 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_6 = [
    "disabled"
];
const _hoisted_7 = {
    class: "btn-group w-100 mb-3",
    role: "group",
    "aria-label": "Verification channel"
};
const _hoisted_8 = [
    "disabled"
];
const _hoisted_9 = [
    "disabled"
];
const _hoisted_10 = {
    key: 0,
    class: "form-group"
};
const _hoisted_11 = [
    "disabled"
];
const _hoisted_12 = {
    key: 1,
    class: "form-group"
};
const _hoisted_13 = {
    class: "input-group"
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = [
    "disabled"
];
const _hoisted_16 = {
    class: "form-group"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    key: 2,
    class: "form-group"
};
const _hoisted_19 = {
    class: "text-end mt-2"
};
const _hoisted_20 = [
    "disabled"
];
const _hoisted_21 = {
    class: "text-end mt-3"
};
const _hoisted_22 = [
    "disabled"
];
const _hoisted_23 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", null, [
        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("h2", {
            class: "text-center mb-1 fw-bold"
        }, "Just one more step", -1)),
        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("p", {
            class: "text-center text-muted"
        }, " Add a phone number or email so we can keep you posted on your ride. ", -1)),
        $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, (0, _vue.toDisplayString)($setup.errorMessage), 1)) : (0, _vue.createCommentVNode)("", true),
        $setup.infoMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, (0, _vue.toDisplayString)($setup.infoMessage), 1)) : (0, _vue.createCommentVNode)("", true),
        $setup.hasExistingProfile ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
            _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("p", {
                class: "text-muted small"
            }, " Linking will sign that account out on any other device it's currently signed into. ", -1)),
            (0, _vue.createElementVNode)("button", {
                class: "btn btn-primary btn-block w-100 mb-2",
                type: "button",
                disabled: $setup.isBusy,
                onClick: $setup.linkProfile
            }, [
                $setup.isBusy ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_5)) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isBusy ? 'Linking...' : 'Link this profile'), 1)
            ], 8, _hoisted_4),
            (0, _vue.createElementVNode)("button", {
                class: "btn btn-link p-0",
                type: "button",
                disabled: $setup.isBusy,
                onClick: _cache[0] || (_cache[0] = ($event)=>$setup.resetToVerification())
            }, " Use a different email or phone number ", 8, _hoisted_6)
        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 3
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "btn",
                        $setup.channel === 'phone' ? 'btn-primary' : 'btn-outline-primary'
                    ]),
                    disabled: $setup.otpSent || $setup.isBusy,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.setChannel('phone'))
                }, _cache[9] || (_cache[9] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-phone me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)(" Phone ")
                ]), 10, _hoisted_8),
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "btn",
                        $setup.channel === 'email' ? 'btn-primary' : 'btn-outline-primary'
                    ]),
                    disabled: $setup.otpSent || $setup.isBusy,
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.setChannel('email'))
                }, _cache[10] || (_cache[10] = [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-envelope me-1"
                    }, null, -1),
                    (0, _vue.createTextVNode)(" Email ")
                ]), 10, _hoisted_9)
            ]),
            (0, _vue.createElementVNode)("form", {
                class: "theme-form",
                onSubmit: (0, _vue.withModifiers)($setup.onSubmit, [
                    "prevent"
                ])
            }, [
                $setup.channel === 'email' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("label", {
                        class: "col-form-label"
                    }, "Email address", -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        class: "form-control",
                        type: "email",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.email = $event),
                        disabled: $setup.otpSent,
                        placeholder: "email@address.com"
                    }, null, 8, _hoisted_11), [
                        [
                            (0, _vue.vModelText),
                            $setup.email,
                            void 0,
                            {
                                trim: true
                            }
                        ]
                    ])
                ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("label", {
                        class: "col-form-label"
                    }, "Phone number", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.countryCode = $event),
                            disabled: $setup.otpSent,
                            style: {
                                "max-width": "120px"
                            }
                        }, _cache[12] || (_cache[12] = [
                            (0, _vue.createElementVNode)("option", {
                                value: "+1"
                            }, "+1 (US)", -1),
                            (0, _vue.createElementVNode)("option", {
                                value: "+1"
                            }, "+1 (CA)", -1)
                        ]), 8, _hoisted_14), [
                            [
                                (0, _vue.vModelSelect),
                                $setup.countryCode
                            ]
                        ]),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            class: "form-control",
                            type: "tel",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.phoneNumber = $event),
                            disabled: $setup.otpSent,
                            placeholder: "5551234567"
                        }, null, 8, _hoisted_15), [
                            [
                                (0, _vue.vModelText),
                                $setup.phoneNumber,
                                void 0,
                                {
                                    trim: true
                                }
                            ]
                        ])
                    ])
                ])),
                (0, _vue.createElementVNode)("div", _hoisted_16, [
                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                        class: "col-form-label"
                    }, [
                        (0, _vue.createTextVNode)("Referral code "),
                        (0, _vue.createElementVNode)("span", {
                            class: "text-muted"
                        }, "(optional)")
                    ], -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        class: "form-control",
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.referralCode = $event),
                        disabled: $setup.otpSent,
                        placeholder: "Have a friend's code?"
                    }, null, 8, _hoisted_17), [
                        [
                            (0, _vue.vModelText),
                            $setup.referralCode,
                            void 0,
                            {
                                trim: true
                            }
                        ]
                    ])
                ]),
                $setup.otpSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_18, [
                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                        class: "col-form-label"
                    }, "Verification code", -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        class: "form-control",
                        type: "text",
                        inputmode: "numeric",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.otpCode = $event),
                        placeholder: "Enter the code we sent you"
                    }, null, 512), [
                        [
                            (0, _vue.vModelText),
                            $setup.otpCode,
                            void 0,
                            {
                                trim: true
                            }
                        ]
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_19, [
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-link p-0",
                            disabled: $setup.resendSeconds > 0 || $setup.isBusy,
                            onClick: $setup.sendCode
                        }, (0, _vue.toDisplayString)($setup.resendSeconds > 0 ? `Resend in ${$setup.resendSeconds}s` : 'Resend code'), 9, _hoisted_20)
                    ])
                ])) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createElementVNode)("div", _hoisted_21, [
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-primary btn-block w-100",
                        type: "submit",
                        disabled: $setup.isBusy
                    }, [
                        $setup.isBusy ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_23)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.otpSent ? 'Finish' : 'Send code'), 1)
                    ], 8, _hoisted_22)
                ])
            ], 32)
        ], 64))
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbgJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Zr0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid p-0"
};
const _hoisted_2 = {
    class: "row m-0"
};
const _hoisted_3 = {
    class: "col-12 p-0"
};
const _hoisted_4 = {
    class: "login-card login-dark"
};
const _hoisted_5 = {
    class: "login-main"
};
const _hoisted_6 = {
    class: "text-center mb-1 fw-bold"
};
const _hoisted_7 = {
    class: "text-center text-muted"
};
const _hoisted_8 = {
    key: 0,
    class: "alert alert-danger py-2",
    role: "alert"
};
const _hoisted_9 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_10 = {
    key: 1,
    class: "alert alert-info py-2",
    role: "alert"
};
const _hoisted_11 = {
    class: "sso-buttons mx-auto"
};
const _hoisted_12 = {
    key: 0,
    ref: "googleButtonContainer",
    class: "google-signin-container"
};
const _hoisted_13 = {
    key: 1,
    class: "btn btn-outline-dark sso-button d-flex align-items-center justify-content-center gap-2",
    disabled: ""
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = {
    key: 0,
    class: "spinner-border spinner-border-sm"
};
const _hoisted_16 = {
    key: 1,
    class: "fab fa-apple"
};
const _hoisted_17 = {
    class: "btn-group w-100 mb-3",
    role: "group",
    "aria-label": "Verification channel"
};
const _hoisted_18 = [
    "disabled"
];
const _hoisted_19 = [
    "disabled"
];
const _hoisted_20 = {
    class: "form-group"
};
const _hoisted_21 = [
    "disabled"
];
const _hoisted_22 = {
    class: "form-group"
};
const _hoisted_23 = [
    "disabled"
];
const _hoisted_24 = {
    class: "form-group"
};
const _hoisted_25 = [
    "disabled"
];
const _hoisted_26 = {
    key: 1,
    class: "form-group"
};
const _hoisted_27 = [
    "disabled"
];
const _hoisted_28 = {
    key: 2,
    class: "form-group"
};
const _hoisted_29 = {
    class: "input-group"
};
const _hoisted_30 = [
    "disabled"
];
const _hoisted_31 = [
    "disabled"
];
const _hoisted_32 = {
    key: 3,
    class: "form-group form-check mt-2"
};
const _hoisted_33 = [
    "disabled"
];
const _hoisted_34 = {
    key: 4,
    class: "form-group"
};
const _hoisted_35 = {
    class: "text-end mt-2"
};
const _hoisted_36 = [
    "disabled"
];
const _hoisted_37 = {
    class: "text-end mt-3"
};
const _hoisted_38 = [
    "disabled"
];
const _hoisted_39 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_40 = {
    class: "text-center text-muted mt-4 mb-0"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", null, [
                        _cache[29] || (_cache[29] = (0, _vue.createElementVNode)("div", null, [
                            (0, _vue.createElementVNode)("a", {
                                class: "logo",
                                href: "/portal"
                            }, [
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-light m-auto",
                                    src: "/assets/images/logo.svg",
                                    alt: "Asher"
                                }),
                                (0, _vue.createElementVNode)("img", {
                                    class: "img-fluid for-dark m-auto",
                                    src: "/assets/images/logo.svg",
                                    alt: "Asher"
                                })
                            ])
                        ], -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_5, [
                            $setup.mode === 'complete-profile' ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["RiderCompleteProfileForm"], {
                                key: 0
                            })) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                key: 1
                            }, [
                                (0, _vue.createElementVNode)("h2", _hoisted_6, (0, _vue.toDisplayString)($setup.mode === 'signup' ? 'Join the waitlist' : 'Welcome back'), 1),
                                (0, _vue.createElementVNode)("p", _hoisted_7, (0, _vue.toDisplayString)($setup.mode === 'signup' ? 'Sign up to reserve your spot on the Asher waitlist.' : 'Sign in to view your waitlist status.'), 1),
                                $setup.errorMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.errorMessage) + " ", 1),
                                    $setup.notRegistered ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                                        (0, _vue.createElementVNode)("button", {
                                            type: "button",
                                            class: "btn btn-sm btn-primary",
                                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.switchMode('signup'))
                                        }, " Sign up now ")
                                    ])) : (0, _vue.createCommentVNode)("", true)
                                ])) : (0, _vue.createCommentVNode)("", true),
                                $setup.infoMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, (0, _vue.toDisplayString)($setup.infoMessage), 1)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createElementVNode)("div", _hoisted_11, [
                                    $props.googleClientId ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, null, 512)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", _hoisted_13, _cache[13] || (_cache[13] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fab fa-google"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Google ")
                                    ]))),
                                    $props.appleServiceId ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                                        key: 2,
                                        class: "btn btn-outline-dark sso-button d-flex align-items-center justify-content-center gap-2",
                                        disabled: $setup.isBusy,
                                        onClick: $setup.handleAppleSignIn
                                    }, [
                                        $setup.isBusy ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_15)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_16)),
                                        _cache[14] || (_cache[14] = (0, _vue.createTextVNode)(" Apple "))
                                    ], 8, _hoisted_14)) : (0, _vue.createCommentVNode)("", true)
                                ]),
                                _cache[28] || (_cache[28] = (0, _vue.createStaticVNode)("<p class=\"text-center text-muted small mt-2 mb-0\" data-v-d871b4> By continuing with Google or Apple, you agree to our <a href=\"https://asherrides.notion.site/terms-and-conditions?pvs=143\" target=\"_blank\" data-v-d871b4>Terms of Service</a> and <a href=\"https://asherrides.notion.site/privacy-policy?pvs=143\" target=\"_blank\" data-v-d871b4>Privacy Policy</a>. </p><div class=\"login-or-bar text-center my-3\" data-v-d871b4><span class=\"px-2 text-muted\" data-v-d871b4>OR</span></div>", 2)),
                                (0, _vue.createElementVNode)("div", _hoisted_17, [
                                    (0, _vue.createElementVNode)("button", {
                                        type: "button",
                                        class: (0, _vue.normalizeClass)([
                                            "btn",
                                            $setup.channel === 'phone' ? 'btn-primary' : 'btn-outline-primary'
                                        ]),
                                        disabled: $setup.isBusy,
                                        onClick: _cache[1] || (_cache[1] = ($event)=>$setup.setChannel('phone'))
                                    }, _cache[15] || (_cache[15] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-phone me-1"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Phone ")
                                    ]), 10, _hoisted_18),
                                    (0, _vue.createElementVNode)("button", {
                                        type: "button",
                                        class: (0, _vue.normalizeClass)([
                                            "btn",
                                            $setup.channel === 'email' ? 'btn-primary' : 'btn-outline-primary'
                                        ]),
                                        disabled: $setup.isBusy,
                                        onClick: _cache[2] || (_cache[2] = ($event)=>$setup.setChannel('email'))
                                    }, _cache[16] || (_cache[16] = [
                                        (0, _vue.createElementVNode)("i", {
                                            class: "fa fa-envelope me-1"
                                        }, null, -1),
                                        (0, _vue.createTextVNode)(" Email ")
                                    ]), 10, _hoisted_19)
                                ]),
                                (0, _vue.createElementVNode)("form", {
                                    class: "theme-form",
                                    onSubmit: (0, _vue.withModifiers)($setup.onPrimarySubmit, [
                                        "prevent"
                                    ])
                                }, [
                                    $setup.mode === 'signup' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        (0, _vue.createElementVNode)("div", _hoisted_20, [
                                            _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                                                class: "col-form-label"
                                            }, "First name", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                class: "form-control",
                                                type: "text",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.firstName = $event),
                                                disabled: $setup.otpSent,
                                                placeholder: "First name"
                                            }, null, 8, _hoisted_21), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.firstName,
                                                    void 0,
                                                    {
                                                        trim: true
                                                    }
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_22, [
                                            _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                                class: "col-form-label"
                                            }, "Last name", -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                class: "form-control",
                                                type: "text",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.lastName = $event),
                                                disabled: $setup.otpSent,
                                                placeholder: "Last name"
                                            }, null, 8, _hoisted_23), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.lastName,
                                                    void 0,
                                                    {
                                                        trim: true
                                                    }
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_24, [
                                            _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                                                class: "col-form-label"
                                            }, [
                                                (0, _vue.createTextVNode)("Referral code "),
                                                (0, _vue.createElementVNode)("span", {
                                                    class: "text-muted"
                                                }, "(optional)")
                                            ], -1)),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                class: "form-control",
                                                type: "text",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.referralCode = $event),
                                                disabled: $setup.otpSent,
                                                placeholder: "Have a friend's code?"
                                            }, null, 8, _hoisted_25), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.referralCode,
                                                    void 0,
                                                    {
                                                        trim: true
                                                    }
                                                ]
                                            ])
                                        ])
                                    ], 64)) : (0, _vue.createCommentVNode)("", true),
                                    $setup.channel === 'email' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_26, [
                                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                                            class: "col-form-label"
                                        }, "Email address", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "email",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.email = $event),
                                            disabled: $setup.otpSent,
                                            placeholder: "email@address.com"
                                        }, null, 8, _hoisted_27), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.email,
                                                void 0,
                                                {
                                                    trim: true
                                                }
                                            ]
                                        ])
                                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, [
                                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("label", {
                                            class: "col-form-label"
                                        }, "Phone number", -1)),
                                        (0, _vue.createElementVNode)("div", _hoisted_29, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                                class: "form-select",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.countryCode = $event),
                                                disabled: $setup.otpSent,
                                                style: {
                                                    "max-width": "120px"
                                                }
                                            }, _cache[21] || (_cache[21] = [
                                                (0, _vue.createElementVNode)("option", {
                                                    value: "+1"
                                                }, "+1 (US)", -1),
                                                (0, _vue.createElementVNode)("option", {
                                                    value: "+1"
                                                }, "+1 (CA)", -1)
                                            ]), 8, _hoisted_30), [
                                                [
                                                    (0, _vue.vModelSelect),
                                                    $setup.countryCode
                                                ]
                                            ]),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                                class: "form-control",
                                                type: "tel",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.phoneNumber = $event),
                                                disabled: $setup.otpSent,
                                                placeholder: "5551234567"
                                            }, null, 8, _hoisted_31), [
                                                [
                                                    (0, _vue.vModelText),
                                                    $setup.phoneNumber,
                                                    void 0,
                                                    {
                                                        trim: true
                                                    }
                                                ]
                                            ])
                                        ]),
                                        _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("small", {
                                            class: "text-muted"
                                        }, "Select country code and enter the rest of your phone number.", -1))
                                    ])),
                                    $setup.mode === 'signup' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, [
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "agreeTerms",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.agreedToLegalPolicy = $event),
                                            disabled: $setup.otpSent
                                        }, null, 8, _hoisted_33), [
                                            [
                                                (0, _vue.vModelCheckbox),
                                                $setup.agreedToLegalPolicy
                                            ]
                                        ]),
                                        _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("label", {
                                            class: "form-check-label",
                                            for: "agreeTerms"
                                        }, " I agree to the Terms of Service and Privacy Policy. ", -1))
                                    ])) : (0, _vue.createCommentVNode)("", true),
                                    $setup.otpSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_34, [
                                        _cache[25] || (_cache[25] = (0, _vue.createElementVNode)("label", {
                                            class: "col-form-label"
                                        }, "Verification code", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            class: "form-control",
                                            type: "text",
                                            inputmode: "numeric",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.otpCode = $event),
                                            placeholder: "Enter the code we sent you"
                                        }, null, 512), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.otpCode,
                                                void 0,
                                                {
                                                    trim: true
                                                }
                                            ]
                                        ]),
                                        (0, _vue.createElementVNode)("div", _hoisted_35, [
                                            (0, _vue.createElementVNode)("button", {
                                                type: "button",
                                                class: "btn btn-link p-0",
                                                disabled: $setup.resendSeconds > 0 || $setup.isBusy,
                                                onClick: $setup.sendCode
                                            }, (0, _vue.toDisplayString)($setup.resendSeconds > 0 ? `Resend in ${$setup.resendSeconds}s` : 'Resend code'), 9, _hoisted_36)
                                        ])
                                    ])) : (0, _vue.createCommentVNode)("", true),
                                    (0, _vue.createElementVNode)("div", _hoisted_37, [
                                        (0, _vue.createElementVNode)("button", {
                                            class: "btn btn-primary btn-block w-100",
                                            type: "submit",
                                            disabled: $setup.isBusy
                                        }, [
                                            $setup.isBusy ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_39)) : (0, _vue.createCommentVNode)("", true),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.primaryButtonLabel), 1)
                                        ], 8, _hoisted_38)
                                    ])
                                ], 32),
                                (0, _vue.createElementVNode)("p", _hoisted_40, [
                                    $setup.mode === 'login' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        _cache[26] || (_cache[26] = (0, _vue.createTextVNode)(" Don't have an account? ")),
                                        (0, _vue.createElementVNode)("a", {
                                            href: "#",
                                            onClick: _cache[11] || (_cache[11] = (0, _vue.withModifiers)(($event)=>$setup.switchMode('signup'), [
                                                "prevent"
                                            ])),
                                            class: "fw-bold"
                                        }, "Sign up")
                                    ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        _cache[27] || (_cache[27] = (0, _vue.createTextVNode)(" Already on the waitlist? ")),
                                        (0, _vue.createElementVNode)("a", {
                                            href: "#",
                                            onClick: _cache[12] || (_cache[12] = (0, _vue.withModifiers)(($event)=>$setup.switchMode('login'), [
                                                "prevent"
                                            ])),
                                            class: "fw-bold"
                                        }, "Log in")
                                    ], 64))
                                ])
                            ], 64))
                        ])
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUSCG":[function() {},{}],"1UFqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRS4z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("d9ecf0482ef848b7");
    if (script.__esModule) script = script.default;
    script.render = require("82461fc19fbdc410").render;
    script.__cssModules = require("a3923013e04d42af").default;
    require("d7b73fd6dc6a50f5").default(script);
    script.__scopeId = 'data-v-8f2734';
    script.__file = "RiderWaitlistStatus.vue";
};
initialize();
exports.default = script;

},{"d9ecf0482ef848b7":"6zKR8","82461fc19fbdc410":"a7fMm","a3923013e04d42af":"7IyeN","d7b73fd6dc6a50f5":"1JP7Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6zKR8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _riderReferralDashboardVue = require("./RiderReferralDashboard.vue");
var _riderReferralDashboardVueDefault = parcelHelpers.interopDefault(_riderReferralDashboardVue);
var _riderVerifyNudgeModalVue = require("./RiderVerifyNudgeModal.vue");
var _riderVerifyNudgeModalVueDefault = parcelHelpers.interopDefault(_riderVerifyNudgeModalVue);
exports.default = {
    __name: 'RiderWaitlistStatus',
    props: {
        waitlistStatus: {
            type: String,
            default: ''
        },
        email: {
            type: String,
            default: ''
        },
        phoneNumber: {
            type: String,
            default: ''
        },
        emailVerified: {
            type: Boolean,
            default: false
        },
        phoneNumberVerified: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {
            RiderReferralDashboard: (0, _riderReferralDashboardVueDefault.default),
            RiderVerifyNudgeModal: (0, _riderVerifyNudgeModalVueDefault.default)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"./RiderReferralDashboard.vue":"iWJZj","./RiderVerifyNudgeModal.vue":"lkavK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWJZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("e6b037b07519ca98");
    if (script.__esModule) script = script.default;
    script.render = require("7c430e87bbfe02a9").render;
    require("ba97cf6dc226e5ab").default(script);
    script.__scopeId = 'data-v-b6371f';
    script.__file = "RiderReferralDashboard.vue";
};
initialize();
exports.default = script;

},{"e6b037b07519ca98":"3ztNd","7c430e87bbfe02a9":"kp2l2","ba97cf6dc226e5ab":"j52C4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ztNd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _moment = require("moment/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _referralOutstanding = require("../utility/referralOutstanding");
exports.default = {
    __name: 'RiderReferralDashboard',
    setup (__props, { expose: __expose }) {
        __expose();
        const loading = (0, _vue.ref)(true);
        const error = (0, _vue.ref)(null);
        const dashboard = (0, _vue.ref)({
            referralCode: '',
            referralLink: '',
            invitedReferrals: [],
            asherPointsBalance: null
        });
        const copying = (0, _vue.ref)(false);
        const copySuccess = (0, _vue.ref)(false);
        const sharing = (0, _vue.ref)(false);
        const inviteContact = (0, _vue.ref)('');
        const inviteIsEmail = (0, _vue.ref)(true);
        const inviteSending = (0, _vue.ref)(false);
        const inviteError = (0, _vue.ref)(null);
        const inviteSuccess = (0, _vue.ref)(null);
        const expandedIds = (0, _vue.ref)(new Set());
        const statusLabels = {
            SIGNED_UP: 'Signed Up',
            IN_PROGRESS: 'In Progress',
            QUALIFIED: 'Qualified',
            REWARDED: 'Rewarded',
            EXPIRED: 'Expired',
            REJECTED: 'Rejected',
            FRAUD_REVIEW: 'Under Review'
        };
        const statusBadgeClasses = {
            SIGNED_UP: 'bg-secondary',
            IN_PROGRESS: 'bg-info text-dark',
            QUALIFIED: 'bg-warning text-dark',
            REWARDED: 'bg-success',
            EXPIRED: 'bg-secondary',
            REJECTED: 'bg-secondary',
            FRAUD_REVIEW: 'bg-secondary'
        };
        const rewardStatusLabels = {
            AVAILABLE: 'Pending',
            REDEEMED: 'Earned',
            EXPIRED: 'Expired',
            REVERSED: 'Reversed'
        };
        const rewardBadgeClasses = {
            AVAILABLE: 'bg-warning text-dark',
            REDEEMED: 'bg-success',
            EXPIRED: 'bg-secondary',
            REVERSED: 'bg-secondary'
        };
        const milestoneLabels = {
            FIRST_PAID_RIDE: 'First Ride',
            FIVE_PAID_RIDES: '5-Ride Bonus',
            DRIVER_QUALIFICATION: 'Qualification'
        };
        const statusLabel = (status)=>statusLabels[status] || status;
        const statusBadgeClass = (status)=>statusBadgeClasses[status] || 'bg-secondary';
        const rewardStatusLabel = (status)=>rewardStatusLabels[status] || status;
        const rewardBadgeClass = (status)=>rewardBadgeClasses[status] || 'bg-secondary';
        const milestoneLabel = (milestone)=>milestoneLabels[milestone] || milestone;
        const rewardAmountLabel = (reward)=>{
            if (reward.rewardType === 'ASHER_POINTS') return `+${reward.points ?? 0} points`;
            if (reward.rewardType === 'SUBSCRIPTION_DISCOUNT_WEEK') return `${reward.discountPercent ?? 0}% off ${reward.discountWeekCount ?? 0} week(s)`;
            return '';
        };
        const outstandingLabel = (referral)=>(0, _referralOutstanding.outstandingLabel)(referral, false);
        const progressPercent = (referral)=>{
            if (!referral.requiredPaidRides) return 0;
            return Math.min(100, Math.round(referral.completedPaidRides / referral.requiredPaidRides * 100));
        };
        const isExpanded = (id)=>expandedIds.value.has(id);
        const toggleExpanded = (id)=>{
            if (expandedIds.value.has(id)) expandedIds.value.delete(id);
            else expandedIds.value.add(id);
            expandedIds.value = new Set(expandedIds.value);
        };
        const formatDate = (dateStr)=>{
            if (!dateStr) return '';
            const parsed = (0, _momentDefault.default)(dateStr);
            return parsed.isValid() ? parsed.format('MMM Do, YYYY') : '';
        };
        const fetchDashboard = async ()=>{
            loading.value = true;
            error.value = null;
            try {
                const response = await fetch('/api/portal/rider/referrals');
                if (!response.ok) throw new Error('Unable to load your referral dashboard.');
                dashboard.value = await response.json();
            } catch (e) {
                error.value = e.message || 'Failed to load referral dashboard.';
            } finally{
                loading.value = false;
            }
        };
        const copyLink = async ()=>{
            copying.value = true;
            try {
                await navigator.clipboard.writeText(dashboard.value.referralLink);
                copySuccess.value = true;
                setTimeout(()=>{
                    copySuccess.value = false;
                }, 2000);
            } catch (e) {
                error.value = null;
            } finally{
                copying.value = false;
            }
        };
        const shareLink = async ()=>{
            sharing.value = true;
            try {
                if (navigator.share) await navigator.share({
                    title: 'Join Asher Rides',
                    text: 'Use my referral link to join Asher Rides!',
                    url: dashboard.value.referralLink
                });
                else {
                    await navigator.clipboard.writeText(dashboard.value.referralLink);
                    copySuccess.value = true;
                    setTimeout(()=>{
                        copySuccess.value = false;
                    }, 2000);
                }
            } catch (e) {
            // User cancelled the native share sheet, or clipboard is unavailable — not an error to surface.
            } finally{
                sharing.value = false;
            }
        };
        const sendInvite = async ()=>{
            if (!inviteContact.value) return;
            inviteSending.value = true;
            inviteError.value = null;
            inviteSuccess.value = null;
            try {
                const response = await fetch('/api/portal/rider/referrals/invite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        userIdentifier: inviteContact.value,
                        isEmail: inviteIsEmail.value
                    })
                });
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Unable to send invite.');
                }
                inviteSuccess.value = 'Invite sent!';
                inviteContact.value = '';
            } catch (e) {
                inviteError.value = e.message || 'Unable to send invite.';
            } finally{
                inviteSending.value = false;
            }
        };
        (0, _vue.onMounted)(fetchDashboard);
        const __returned__ = {
            loading,
            error,
            dashboard,
            copying,
            copySuccess,
            sharing,
            inviteContact,
            inviteIsEmail,
            inviteSending,
            inviteError,
            inviteSuccess,
            expandedIds,
            statusLabels,
            statusBadgeClasses,
            rewardStatusLabels,
            rewardBadgeClasses,
            milestoneLabels,
            statusLabel,
            statusBadgeClass,
            rewardStatusLabel,
            rewardBadgeClass,
            milestoneLabel,
            rewardAmountLabel,
            outstandingLabel,
            progressPercent,
            isExpanded,
            toggleExpanded,
            formatDate,
            fetchDashboard,
            copyLink,
            shareLink,
            sendInvite,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get moment () {
                return 0, _momentDefault.default;
            },
            get resolveOutstandingLabel () {
                return 0, _referralOutstanding.outstandingLabel;
            },
            get outstandingClass () {
                return 0, _referralOutstanding.outstandingClass;
            },
            get outstandingIcon () {
                return 0, _referralOutstanding.outstandingIcon;
            },
            get deadlineIsUrgent () {
                return 0, _referralOutstanding.deadlineIsUrgent;
            },
            get deadlineLabel () {
                return 0, _referralOutstanding.deadlineLabel;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","moment/moment":"2meyw","../utility/referralOutstanding":"hnt4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kp2l2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card mt-4 shadow-sm"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_4 = {
    key: 1,
    class: "alert alert-danger mb-0"
};
const _hoisted_5 = {
    key: 2
};
const _hoisted_6 = {
    class: "row g-3 mb-3"
};
const _hoisted_7 = {
    class: "col-12 col-md-6"
};
const _hoisted_8 = {
    class: "input-group"
};
const _hoisted_9 = [
    "value"
];
const _hoisted_10 = [
    "disabled"
];
const _hoisted_11 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_12 = {
    key: 1,
    class: "fa fa-copy me-1"
};
const _hoisted_13 = [
    "disabled"
];
const _hoisted_14 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_15 = {
    key: 1,
    class: "fa fa-share-alt me-1"
};
const _hoisted_16 = {
    class: "col-12 col-md-6"
};
const _hoisted_17 = {
    class: "fs-3 fw-bold text-primary"
};
const _hoisted_18 = {
    class: "border rounded p-3 mb-4 bg-color"
};
const _hoisted_19 = {
    class: "row g-2 align-items-center"
};
const _hoisted_20 = {
    class: "col-12 col-sm-auto"
};
const _hoisted_21 = {
    class: "col"
};
const _hoisted_22 = [
    "placeholder"
];
const _hoisted_23 = {
    class: "col-12 col-sm-auto"
};
const _hoisted_24 = [
    "disabled"
];
const _hoisted_25 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1"
};
const _hoisted_26 = {
    key: 0,
    class: "alert alert-danger mt-2 mb-0 py-1 px-2 small"
};
const _hoisted_27 = {
    key: 1,
    class: "alert alert-success mt-2 mb-0 py-1 px-2 small"
};
const _hoisted_28 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_29 = {
    key: 1,
    class: "list-group list-group-flush"
};
const _hoisted_30 = [
    "onClick"
];
const _hoisted_31 = {
    class: "fw-semibold"
};
const _hoisted_32 = {
    key: 0,
    class: "progress mt-2",
    style: {
        "height": "6px"
    }
};
const _hoisted_33 = {
    key: 1,
    class: "small text-muted mt-1 d-flex justify-content-between flex-wrap gap-2"
};
const _hoisted_34 = {
    key: 3,
    class: "mt-2 ps-2 border-start"
};
const _hoisted_35 = {
    class: "small text-muted mb-1"
};
const _hoisted_36 = {
    key: 0,
    class: "small text-muted"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("div", {
            class: "card-header bg-white"
        }, [
            (0, _vue.createElementVNode)("h5", {
                class: "mb-0"
            }, [
                (0, _vue.createElementVNode)("i", {
                    class: "fa fa-gift me-2"
                }),
                (0, _vue.createTextVNode)("Refer Friends, Earn Asher Points")
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, _cache[2] || (_cache[2] = [
                (0, _vue.createElementVNode)("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                }, [
                    (0, _vue.createElementVNode)("span", {
                        class: "visually-hidden"
                    }, "Loading...")
                ], -1)
            ]))) : $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, (0, _vue.toDisplayString)($setup.error), 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("div", _hoisted_6, [
                    (0, _vue.createElementVNode)("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted small mb-1"
                        }, "Your referral code", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_8, [
                            (0, _vue.createElementVNode)("input", {
                                type: "text",
                                class: "form-control fw-bold",
                                value: $setup.dashboard.referralCode,
                                readonly: ""
                            }, null, 8, _hoisted_9),
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-outline-primary",
                                onClick: $setup.copyLink,
                                disabled: $setup.copying
                            }, [
                                $setup.copying ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_11)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_12)),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.copying ? 'Copying...' : $setup.copySuccess ? 'Copied!' : 'Copy Link'), 1)
                            ], 8, _hoisted_10),
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-outline-secondary",
                                onClick: $setup.shareLink,
                                disabled: $setup.sharing
                            }, [
                                $setup.sharing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_14)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", _hoisted_15)),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.sharing ? 'Sharing...' : 'Share'), 1)
                            ], 8, _hoisted_13)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("label", {
                            class: "form-label text-muted small mb-1"
                        }, "Your Asher Points balance", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_17, (0, _vue.toDisplayString)($setup.dashboard.asherPointsBalance ?? 0), 1)
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_18, [
                    _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                        class: "form-label small mb-2"
                    }, "Send your invite directly", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_19, [
                        (0, _vue.createElementVNode)("div", _hoisted_20, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select form-select-sm",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.inviteIsEmail = $event)
                            }, _cache[5] || (_cache[5] = [
                                (0, _vue.createElementVNode)("option", {
                                    value: true
                                }, "Email", -1),
                                (0, _vue.createElementVNode)("option", {
                                    value: false
                                }, "Phone", -1)
                            ]), 512), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.inviteIsEmail
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_21, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                type: "text",
                                class: "form-control form-control-sm",
                                placeholder: $setup.inviteIsEmail ? 'friend@example.com' : '(555) 555-5555',
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.inviteContact = $event)
                            }, null, 8, _hoisted_22), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.inviteContact
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_23, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary btn-sm w-100",
                                onClick: $setup.sendInvite,
                                disabled: $setup.inviteSending || !$setup.inviteContact
                            }, [
                                $setup.inviteSending ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_25)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.inviteSending ? 'Sending...' : 'Send Invite'), 1)
                            ], 8, _hoisted_24)
                        ])
                    ]),
                    $setup.inviteError ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_26, (0, _vue.toDisplayString)($setup.inviteError), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.inviteSuccess ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_27, (0, _vue.toDisplayString)($setup.inviteSuccess), 1)) : (0, _vue.createCommentVNode)("", true)
                ]),
                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("h6", {
                    class: "mb-2"
                }, "People you've invited", -1)),
                !$setup.dashboard.invitedReferrals || $setup.dashboard.invitedReferrals.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, " No invites yet \u2014 share your code above to get started. ")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_29, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.dashboard.invitedReferrals, (referral)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                            key: referral.referralId,
                            class: "list-group-item px-0"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "d-flex justify-content-between align-items-center",
                                style: {
                                    "cursor": "pointer"
                                },
                                onClick: ($event)=>$setup.toggleExpanded(referral.referralId)
                            }, [
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("span", _hoisted_31, (0, _vue.toDisplayString)(referral.referredDisplayName), 1),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "badge rounded-pill ms-2",
                                            $setup.statusBadgeClass(referral.status)
                                        ])
                                    }, (0, _vue.toDisplayString)($setup.statusLabel(referral.status)), 3)
                                ]),
                                (0, _vue.createElementVNode)("i", {
                                    class: (0, _vue.normalizeClass)([
                                        "fa",
                                        $setup.isExpanded(referral.referralId) ? 'fa-chevron-up' : 'fa-chevron-down'
                                    ])
                                }, null, 2)
                            ], 8, _hoisted_30),
                            referral.requiredPaidRides > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, [
                                (0, _vue.createElementVNode)("div", {
                                    class: "progress-bar",
                                    role: "progressbar",
                                    style: (0, _vue.normalizeStyle)({
                                        width: $setup.progressPercent(referral) + '%'
                                    })
                                }, null, 4)
                            ])) : (0, _vue.createCommentVNode)("", true),
                            referral.requiredPaidRides > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_33, [
                                (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(referral.completedPaidRides) + "/" + (0, _vue.toDisplayString)(referral.requiredPaidRides) + " paid rides", 1),
                                $setup.deadlineLabel(referral) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                                    key: 0,
                                    class: (0, _vue.normalizeClass)($setup.deadlineIsUrgent(referral) ? 'text-danger' : '')
                                }, [
                                    _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("i", {
                                        class: "fa fa-clock me-1"
                                    }, null, -1)),
                                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.deadlineLabel(referral)), 1)
                                ], 2)) : (0, _vue.createCommentVNode)("", true)
                            ])) : (0, _vue.createCommentVNode)("", true),
                            $setup.outstandingLabel(referral) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 2,
                                class: (0, _vue.normalizeClass)([
                                    "small mt-1",
                                    $setup.outstandingClass(referral)
                                ])
                            }, [
                                (0, _vue.createElementVNode)("i", {
                                    class: (0, _vue.normalizeClass)([
                                        "fa me-1",
                                        $setup.outstandingIcon(referral)
                                    ])
                                }, null, 2),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.outstandingLabel(referral)), 1)
                            ], 2)) : (0, _vue.createCommentVNode)("", true),
                            $setup.isExpanded(referral.referralId) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_34, [
                                (0, _vue.createElementVNode)("div", _hoisted_35, "Signed up " + (0, _vue.toDisplayString)($setup.formatDate(referral.signedUpAt)), 1),
                                !referral.rewards || referral.rewards.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_36, "No rewards yet.")) : ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                    key: 1
                                }, (0, _vue.renderList)(referral.rewards, (reward, idx)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: idx,
                                        class: "small d-flex justify-content-between mb-1"
                                    }, [
                                        (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($setup.milestoneLabel(reward.milestone)) + " \u2014 " + (0, _vue.toDisplayString)($setup.rewardAmountLabel(reward)), 1),
                                        (0, _vue.createElementVNode)("span", {
                                            class: (0, _vue.normalizeClass)([
                                                "badge rounded-pill",
                                                $setup.rewardBadgeClass(reward.status)
                                            ])
                                        }, (0, _vue.toDisplayString)($setup.rewardStatusLabel(reward.status)), 3)
                                    ]);
                                }), 128))
                            ])) : (0, _vue.createCommentVNode)("", true)
                        ]);
                    }), 128))
                ])),
                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("div", {
                    class: "alert alert-info mt-4 mb-0 small"
                }, [
                    (0, _vue.createElementVNode)("i", {
                        class: "fa fa-mobile-alt me-2"
                    }),
                    (0, _vue.createTextVNode)("Referrals in the Asher mobile app are coming soon \u2014 for now, share your link here. ")
                ], -1))
            ]))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j52C4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkavK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("4e1b5ed6b6eb99c");
    if (script.__esModule) script = script.default;
    script.render = require("9df9616057a75555").render;
    script.__cssModules = require("3e485b67a46fe430").default;
    require("de65566e18ffcbe6").default(script);
    script.__scopeId = 'data-v-0789db';
    script.__file = "RiderVerifyNudgeModal.vue";
};
initialize();
exports.default = script;

},{"4e1b5ed6b6eb99c":"b9WH4","9df9616057a75555":"iB18W","3e485b67a46fe430":"6qn9D","de65566e18ffcbe6":"doKsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9WH4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _riderVerifyNudgeJs = require("../utility/riderVerifyNudge.js");
exports.default = {
    __name: 'RiderVerifyNudgeModal',
    props: {
        email: {
            type: String,
            default: ''
        },
        phoneNumber: {
            type: String,
            default: ''
        },
        emailVerified: {
            type: Boolean,
            default: false
        },
        phoneNumberVerified: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        // Local mirror of the rider's contact/verification state, updated in place on a successful
        // verify instead of following redirectUrl -- resolving one channel shouldn't reload the page
        // and abandon progress on the other channel's in-progress code entry.
        const localEmail = (0, _vue.ref)(props.email);
        const localPhoneNumber = (0, _vue.ref)(props.phoneNumber);
        const localEmailVerified = (0, _vue.ref)(props.emailVerified);
        const localPhoneNumberVerified = (0, _vue.ref)(props.phoneNumberVerified);
        const needsEmail = (0, _vue.computed)(()=>!localEmail.value || !localEmailVerified.value);
        const needsPhone = (0, _vue.computed)(()=>!localPhoneNumber.value || !localPhoneNumberVerified.value);
        const dismissed = (0, _vue.ref)(sessionStorage.getItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY)) === 'true');
        // Closes automatically once both channels resolve -- needsEmail/needsPhone both go false, so
        // isOpen just follows; no separate "mark complete" step needed.
        const isOpen = (0, _vue.computed)(()=>(needsEmail.value || needsPhone.value) && !dismissed.value);
        function dismiss() {
            dismissed.value = true;
            sessionStorage.setItem((0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY), 'true');
        }
        // The country-code dropdown only ever offers "+1" today (matches RiderCompleteProfileForm.vue) --
        // splitting on that fixed 2-char prefix is enough to pre-fill an existing, unverified number.
        function splitPhoneForEditing(fullNumber) {
            if (fullNumber && fullNumber.startsWith('+1')) return {
                countryCode: '+1',
                digits: fullNumber.slice(2)
            };
            return {
                countryCode: '+1',
                digits: fullNumber || ''
            };
        }
        function makeChannelState(initialValue, initialCountryCode = '+1') {
            return (0, _vue.reactive)({
                value: initialValue,
                countryCode: initialCountryCode,
                otpSent: false,
                otpCode: '',
                loading: false,
                error: null,
                info: null,
                resendSeconds: 0,
                hasExistingProfile: false
            });
        }
        const initialPhone = splitPhoneForEditing(localPhoneNumber.value);
        const emailState = makeChannelState(localEmail.value);
        const phoneState = makeChannelState(initialPhone.digits, initialPhone.countryCode);
        function stateFor(channel) {
            return channel === 'email' ? emailState : phoneState;
        }
        // The contact sent to the backend for a given channel: raw email, or country code + digits.
        function identifierFor(channel) {
            return channel === 'email' ? emailState.value : `${phoneState.countryCode}${phoneState.value}`;
        }
        const resendTimers = {
            email: null,
            phone: null
        };
        function startResendCountdown(channel) {
            stopResend(channel);
            const state = stateFor(channel);
            state.resendSeconds = 30;
            resendTimers[channel] = setInterval(()=>{
                if (state.resendSeconds > 0) state.resendSeconds -= 1;
                else stopResend(channel);
            }, 1000);
        }
        function stopResend(channel) {
            if (resendTimers[channel]) {
                clearInterval(resendTimers[channel]);
                resendTimers[channel] = null;
            }
        }
        async function postJson(url, payload) {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            let data = null;
            try {
                data = await res.json();
            } catch (e) {}
            if (!res.ok) {
                const text = data ? data.message || '' : await res.text().catch(()=>'');
                throw new Error(text || 'Something went wrong. Please try again.');
            }
            return data || {};
        }
        async function sendCode(channel) {
            const state = stateFor(channel);
            state.error = null;
            state.info = null;
            if (!state.value) {
                state.error = channel === 'email' ? 'Please enter your email.' : 'Please enter your phone number.';
                return;
            }
            state.loading = true;
            try {
                const data = await postJson('/api/portal/rider/send-signup-otp', {
                    userIdentifier: identifierFor(channel),
                    isEmail: channel === 'email'
                });
                if (data.success === false) {
                    state.error = data.message || 'Unable to send verification code.';
                    return;
                }
                state.otpSent = true;
                state.info = data.message || 'Verification code sent.';
                startResendCountdown(channel);
            } catch (e) {
                state.error = e.message;
            } finally{
                state.loading = false;
            }
        }
        function onSubmit(channel) {
            return stateFor(channel).otpSent ? verifyCode(channel) : sendCode(channel);
        }
        async function verifyCode(channel) {
            const state = stateFor(channel);
            state.error = null;
            if (!state.otpCode) {
                state.error = 'Please enter the verification code.';
                return;
            }
            state.loading = true;
            try {
                // The inactive channel's field and a referral code are deliberately omitted:
                // completeRiderProfile's otpIsEmail branch never reads the other field, and every rider who
                // can see this dialog already has profileComplete=true, so a referral code here would 400.
                const data = await postJson('/api/portal/rider/complete-profile', {
                    email: channel === 'email' ? state.value : null,
                    phoneNumber: channel === 'phone' ? identifierFor('phone') : null,
                    otpCode: state.otpCode,
                    otpIsEmail: channel === 'email'
                });
                if (data.success && data.redirectUrl) {
                    if (channel === 'email') {
                        localEmail.value = state.value;
                        localEmailVerified.value = true;
                    } else {
                        localPhoneNumber.value = identifierFor('phone');
                        localPhoneNumberVerified.value = true;
                    }
                    stopResend(channel);
                } else if (data.hasExistingProfile) {
                    state.hasExistingProfile = true;
                    state.error = data.message || 'This contact is already linked to another account.';
                } else state.error = data.message || 'Unable to verify this contact.';
            } catch (e) {
                state.error = e.message;
            } finally{
                state.loading = false;
            }
        }
        async function linkProfile(channel) {
            const state = stateFor(channel);
            state.loading = true;
            state.error = null;
            try {
                const data = await postJson('/api/portal/rider/link-profile', {
                    email: channel === 'email' ? state.value : null,
                    phoneNumber: channel === 'phone' ? identifierFor('phone') : null,
                    otpIsEmail: channel === 'email'
                });
                if (data.success && data.redirectUrl) // Linking merges into a *different* rider and mints a new session for it -- unlike a plain
                // verify, this page's own rider identity is now stale, so (matching
                // RiderCompleteProfileForm.vue's own linkProfile()) this path still navigates away.
                window.location.href = data.redirectUrl;
                else resetToVerification(channel, data.message || 'Unable to link this profile. Please verify again.');
            } catch (e) {
                resetToVerification(channel, e.message);
            } finally{
                state.loading = false;
            }
        }
        function resetToVerification(channel, message = null) {
            const state = stateFor(channel);
            state.error = message;
            state.hasExistingProfile = false;
            state.otpSent = false;
            state.otpCode = '';
        }
        (0, _vue.onUnmounted)(()=>{
            stopResend('email');
            stopResend('phone');
        });
        const __returned__ = {
            props,
            localEmail,
            localPhoneNumber,
            localEmailVerified,
            localPhoneNumberVerified,
            needsEmail,
            needsPhone,
            dismissed,
            isOpen,
            dismiss,
            splitPhoneForEditing,
            makeChannelState,
            initialPhone,
            emailState,
            phoneState,
            stateFor,
            identifierFor,
            resendTimers,
            startResendCountdown,
            stopResend,
            postJson,
            sendCode,
            onSubmit,
            verifyCode,
            linkProfile,
            resetToVerification,
            ref: (0, _vue.ref),
            reactive: (0, _vue.reactive),
            computed: (0, _vue.computed),
            onUnmounted: (0, _vue.onUnmounted),
            get RIDER_VERIFY_NUDGE_DISMISS_KEY () {
                return 0, _riderVerifyNudgeJs.RIDER_VERIFY_NUDGE_DISMISS_KEY;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/riderVerifyNudge.js":"8h67t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iB18W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "rider-verify-nudge-overlay"
};
const _hoisted_2 = {
    class: "rider-verify-nudge-card card shadow-lg"
};
const _hoisted_3 = {
    class: "card-body p-4"
};
const _hoisted_4 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_5 = {
    key: 0,
    class: "text-muted small mb-2"
};
const _hoisted_6 = {
    key: 1,
    class: "alert alert-danger py-2 mb-2"
};
const _hoisted_7 = {
    key: 2,
    class: "alert alert-info py-2 mb-2"
};
const _hoisted_8 = [
    "disabled"
];
const _hoisted_9 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_10 = [
    "disabled"
];
const _hoisted_11 = [
    "disabled"
];
const _hoisted_12 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_13 = {
    class: "text-end mt-1"
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = [
    "disabled"
];
const _hoisted_16 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_17 = {
    key: 1
};
const _hoisted_18 = {
    key: 0,
    class: "text-muted small mb-2"
};
const _hoisted_19 = {
    key: 1,
    class: "alert alert-danger py-2 mb-2"
};
const _hoisted_20 = {
    key: 2,
    class: "alert alert-info py-2 mb-2"
};
const _hoisted_21 = [
    "disabled"
];
const _hoisted_22 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_23 = [
    "disabled"
];
const _hoisted_24 = {
    class: "input-group"
};
const _hoisted_25 = [
    "disabled"
];
const _hoisted_26 = [
    "disabled"
];
const _hoisted_27 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_28 = {
    class: "text-end mt-1"
};
const _hoisted_29 = [
    "disabled"
];
const _hoisted_30 = [
    "disabled"
];
const _hoisted_31 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.isOpen ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: "btn-close float-end",
                    "aria-label": "Dismiss",
                    onClick: $setup.dismiss
                }),
                _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("h3", {
                    class: "fw-bold mb-1"
                }, "Verify your contact info", -1)),
                _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("p", {
                    class: "text-muted mb-4"
                }, "We use this to keep you posted about your ride and account.", -1)),
                $setup.needsEmail ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, [
                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("h6", {
                        class: "fw-bold text-uppercase text-muted small mb-1"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-envelope me-1"
                        }),
                        (0, _vue.createTextVNode)(" Email")
                    ], -1)),
                    $setup.localEmail && !$setup.localEmailVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_5, "This email hasn't been verified yet.")) : (0, _vue.createCommentVNode)("", true),
                    $setup.emailState.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, (0, _vue.toDisplayString)($setup.emailState.error), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.emailState.info ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, (0, _vue.toDisplayString)($setup.emailState.info), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.emailState.hasExistingProfile ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 3
                    }, [
                        _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("p", {
                            class: "text-muted small"
                        }, "Linking will sign that account out on any other device it's currently signed into.", -1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary w-100 mb-2",
                            type: "button",
                            disabled: $setup.emailState.loading,
                            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.linkProfile('email'))
                        }, [
                            $setup.emailState.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_9)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.emailState.loading ? 'Linking...' : 'Link this profile'), 1)
                        ], 8, _hoisted_8),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-link p-0",
                            type: "button",
                            disabled: $setup.emailState.loading,
                            onClick: _cache[1] || (_cache[1] = ($event)=>$setup.resetToVerification('email'))
                        }, " Use a different email ", 8, _hoisted_10)
                    ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("form", {
                        key: 4,
                        onSubmit: _cache[5] || (_cache[5] = (0, _vue.withModifiers)(($event)=>$setup.onSubmit('email'), [
                            "prevent"
                        ]))
                    }, [
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            class: "form-control",
                            type: "email",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.emailState.value = $event),
                            disabled: $setup.emailState.otpSent,
                            placeholder: "email@address.com"
                        }, null, 8, _hoisted_11), [
                            [
                                (0, _vue.vModelText),
                                $setup.emailState.value,
                                void 0,
                                {
                                    trim: true
                                }
                            ]
                        ]),
                        $setup.emailState.otpSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_12, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-control",
                                type: "text",
                                inputmode: "numeric",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.emailState.otpCode = $event),
                                placeholder: "Enter the code we sent you"
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.emailState.otpCode,
                                    void 0,
                                    {
                                        trim: true
                                    }
                                ]
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_13, [
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-link p-0 btn-sm",
                                    disabled: $setup.emailState.resendSeconds > 0 || $setup.emailState.loading,
                                    onClick: _cache[4] || (_cache[4] = ($event)=>$setup.sendCode('email'))
                                }, (0, _vue.toDisplayString)($setup.emailState.resendSeconds > 0 ? `Resend in ${$setup.emailState.resendSeconds}s` : 'Resend code'), 9, _hoisted_14)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary w-100 mt-2",
                            type: "submit",
                            disabled: $setup.emailState.loading
                        }, [
                            $setup.emailState.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_16)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.emailState.otpSent ? 'Verify' : 'Send code'), 1)
                        ], 8, _hoisted_15)
                    ], 32))
                ])) : (0, _vue.createCommentVNode)("", true),
                $setup.needsPhone ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_17, [
                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("h6", {
                        class: "fw-bold text-uppercase text-muted small mb-1"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fa fa-phone me-1"
                        }),
                        (0, _vue.createTextVNode)(" Phone")
                    ], -1)),
                    $setup.localPhoneNumber && !$setup.localPhoneNumberVerified ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_18, "This phone number hasn't been verified yet.")) : (0, _vue.createCommentVNode)("", true),
                    $setup.phoneState.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_19, (0, _vue.toDisplayString)($setup.phoneState.error), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.phoneState.info ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_20, (0, _vue.toDisplayString)($setup.phoneState.info), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.phoneState.hasExistingProfile ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 3
                    }, [
                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("p", {
                            class: "text-muted small"
                        }, "Linking will sign that account out on any other device it's currently signed into.", -1)),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary w-100 mb-2",
                            type: "button",
                            disabled: $setup.phoneState.loading,
                            onClick: _cache[6] || (_cache[6] = ($event)=>$setup.linkProfile('phone'))
                        }, [
                            $setup.phoneState.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.phoneState.loading ? 'Linking...' : 'Link this profile'), 1)
                        ], 8, _hoisted_21),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-link p-0",
                            type: "button",
                            disabled: $setup.phoneState.loading,
                            onClick: _cache[7] || (_cache[7] = ($event)=>$setup.resetToVerification('phone'))
                        }, " Use a different phone number ", 8, _hoisted_23)
                    ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("form", {
                        key: 4,
                        onSubmit: _cache[12] || (_cache[12] = (0, _vue.withModifiers)(($event)=>$setup.onSubmit('phone'), [
                            "prevent"
                        ]))
                    }, [
                        (0, _vue.createElementVNode)("div", _hoisted_24, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.phoneState.countryCode = $event),
                                disabled: $setup.phoneState.otpSent,
                                style: {
                                    "max-width": "120px"
                                }
                            }, _cache[16] || (_cache[16] = [
                                (0, _vue.createElementVNode)("option", {
                                    value: "+1"
                                }, "+1 (US)", -1),
                                (0, _vue.createElementVNode)("option", {
                                    value: "+1"
                                }, "+1 (CA)", -1)
                            ]), 8, _hoisted_25), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.phoneState.countryCode
                                ]
                            ]),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-control",
                                type: "tel",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.phoneState.value = $event),
                                disabled: $setup.phoneState.otpSent,
                                placeholder: "5551234567"
                            }, null, 8, _hoisted_26), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.phoneState.value,
                                    void 0,
                                    {
                                        trim: true
                                    }
                                ]
                            ])
                        ]),
                        $setup.phoneState.otpSent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_27, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-control",
                                type: "text",
                                inputmode: "numeric",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.phoneState.otpCode = $event),
                                placeholder: "Enter the code we sent you"
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.phoneState.otpCode,
                                    void 0,
                                    {
                                        trim: true
                                    }
                                ]
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_28, [
                                (0, _vue.createElementVNode)("button", {
                                    type: "button",
                                    class: "btn btn-link p-0 btn-sm",
                                    disabled: $setup.phoneState.resendSeconds > 0 || $setup.phoneState.loading,
                                    onClick: _cache[11] || (_cache[11] = ($event)=>$setup.sendCode('phone'))
                                }, (0, _vue.toDisplayString)($setup.phoneState.resendSeconds > 0 ? `Resend in ${$setup.phoneState.resendSeconds}s` : 'Resend code'), 9, _hoisted_29)
                            ])
                        ])) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-primary w-100 mt-2",
                            type: "submit",
                            disabled: $setup.phoneState.loading
                        }, [
                            $setup.phoneState.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_31)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.phoneState.otpSent ? 'Verify' : 'Send code'), 1)
                        ], 8, _hoisted_30)
                    ], 32))
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ])
    ])) : (0, _vue.createCommentVNode)("", true);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qn9D":[function() {},{}],"doKsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7fMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "container-fluid py-4"
};
const _hoisted_2 = {
    class: "row justify-content-center"
};
const _hoisted_3 = {
    class: "col-12 col-lg-8 col-xl-6"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[0] || (_cache[0] = (0, _vue.createStaticVNode)('<div class="text-center mb-4" data-v-8f2734><a href="/portal" data-v-8f2734><img class="img-fluid" src="/assets/images/logo.svg" alt="Asher" style="max-width:180px;" data-v-8f2734></a></div><div class="card shadow-sm" data-v-8f2734><div class="card-body text-center py-4" data-v-8f2734><div class="status-check mx-auto mb-3" data-v-8f2734><i class="fa fa-check" data-v-8f2734></i></div><h2 class="fw-bold mb-2" data-v-8f2734>You&#39;re on the waitlist!</h2><p class="text-muted mb-4" data-v-8f2734> Thanks for joining Asher. You&#39;re all set \u2014 we&#39;ll let you know the moment Asher Rides launches in your area. </p><a class="btn btn-outline-primary rounded-pill px-4" href="/logout" data-v-8f2734>Log out</a></div></div>', 2)),
                (0, _vue.createVNode)($setup["RiderReferralDashboard"])
            ])
        ]),
        (0, _vue.createVNode)($setup["RiderVerifyNudgeModal"], {
            email: $props.email,
            "phone-number": $props.phoneNumber,
            "email-verified": $props.emailVerified,
            "phone-number-verified": $props.phoneNumberVerified
        }, null, 8, [
            "email",
            "phone-number",
            "email-verified",
            "phone-number-verified"
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7IyeN":[function() {},{}],"1JP7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4jN94":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("e73f44e969180fff");
    if (script.__esModule) script = script.default;
    script.render = require("fb9c5ee20d52a6b7").render;
    script.__cssModules = require("cb588a3f63816946").default;
    require("3ead4f08d647a71a").default(script);
    script.__scopeId = 'data-v-c6e5db';
    script.__file = "DriverLogin.vue";
};
initialize();
exports.default = script;

},{"e73f44e969180fff":"9Ujee","fb9c5ee20d52a6b7":"7dBY8","cb588a3f63816946":"cy9tu","3ead4f08d647a71a":"5dYZx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Ujee":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: 'DriverLogin',
    setup (__props, { expose: __expose }) {
        __expose();
        const tabs = [
            {
                key: 'phone',
                label: 'Phone',
                icon: 'fa fa-mobile-screen'
            },
            {
                key: 'email',
                label: 'Email',
                icon: 'fa fa-envelope'
            },
            {
                key: 'password',
                label: 'Password',
                icon: 'fa fa-lock'
            }
        ];
        const method = (0, _vue.ref)('phone');
        const otpStage = (0, _vue.ref)('request');
        const identifier = (0, _vue.ref)('');
        const phoneCountryCode = (0, _vue.ref)('+1');
        // The full identifier sent to the server: phone numbers are prefixed with the selected
        // country code (E.164, matching the signup flow); emails are used as-is.
        const loginIdentifier = (0, _vue.computed)(()=>method.value === 'phone' ? `${phoneCountryCode.value}${identifier.value}` : identifier.value);
        const otpCode = (0, _vue.ref)('');
        const email = (0, _vue.ref)('');
        const password = (0, _vue.ref)('');
        const showPassword = (0, _vue.ref)(false);
        const loading = (0, _vue.ref)(false);
        const errorMessage = (0, _vue.ref)(null);
        const infoMessage = (0, _vue.ref)(null);
        // Set when the identifier has no driver account, so the error banner can offer the signup page.
        const notRegistered = (0, _vue.ref)(false);
        const isLocked = (0, _vue.ref)(false);
        const cooldownSecondsRemaining = (0, _vue.ref)(0);
        let cooldownInterval = null;
        const selectMethod = (key)=>{
            method.value = key;
            resetOtp();
            errorMessage.value = null;
            infoMessage.value = null;
            notRegistered.value = false;
        };
        const resetOtp = ()=>{
            otpStage.value = 'request';
            otpCode.value = '';
            infoMessage.value = null;
        };
        const clearGenericError = ()=>{
            if (!isLocked.value && cooldownSecondsRemaining.value === 0) {
                errorMessage.value = null;
                notRegistered.value = false;
            }
        };
        const formatCooldown = (seconds)=>{
            if (seconds <= 0) return '0s';
            if (seconds < 60) return `${seconds}s`;
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return secs === 0 ? `${mins}m` : `${mins}m ${secs}s`;
        };
        const startCooldownCountdown = (seconds)=>{
            clearInterval(cooldownInterval);
            cooldownSecondsRemaining.value = seconds;
            cooldownInterval = setInterval(()=>{
                if (cooldownSecondsRemaining.value <= 1) {
                    cooldownSecondsRemaining.value = 0;
                    clearInterval(cooldownInterval);
                    cooldownInterval = null;
                } else cooldownSecondsRemaining.value--;
            }, 1000);
        };
        // Handles the shared lock (403) and cooldown (429) responses the auth endpoints can return.
        // Returns true if the response was a lock/cooldown and has been handled.
        const handleRateLimitResponse = async (response)=>{
            if (response.status === 403) {
                isLocked.value = true;
                errorMessage.value = await response.text() || 'Your account has been locked. Please contact support.';
                return true;
            }
            if (response.status === 429) {
                const retryAfter = parseInt(response.headers.get('Retry-After'), 10);
                startCooldownCountdown(retryAfter > 0 ? retryAfter : 30);
                await response.text();
                return true;
            }
            return false;
        };
        // Navigates to the server-provided post-login URL. Uses an explicit navigation (rather than
        // following a fetch redirect) so the session cookie set on this response is committed first.
        const goToRedirect = async (response)=>{
            const data = await response.json();
            window.location.assign(data.redirectUrl || '/driver/application-status');
        };
        const handlePasswordLogin = async ()=>{
            if (loading.value || isLocked.value || cooldownSecondsRemaining.value > 0) return;
            loading.value = true;
            errorMessage.value = null;
            try {
                const response = await fetch('/api/driver-portal/login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: email.value,
                        password: password.value
                    })
                });
                if (response.ok) await goToRedirect(response);
                else if (!await handleRateLimitResponse(response)) errorMessage.value = await response.text() || 'Invalid email or password.';
            } catch  {
                errorMessage.value = 'An error occurred. Please try again later.';
            } finally{
                loading.value = false;
            }
        };
        const handleSendOtp = async ()=>{
            if (loading.value || isLocked.value || cooldownSecondsRemaining.value > 0) return;
            loading.value = true;
            errorMessage.value = null;
            infoMessage.value = null;
            notRegistered.value = false;
            try {
                const response = await fetch('/api/driver-portal/send-login-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        userIdentifier: loginIdentifier.value,
                        isEmail: method.value === 'email'
                    })
                });
                if (response.ok) {
                    otpStage.value = 'verify';
                    infoMessage.value = `We've sent a verification code to ${loginIdentifier.value}.`;
                } else if (!await handleRateLimitResponse(response)) {
                    // 404 is the server saying no driver is registered with this identifier.
                    notRegistered.value = response.status === 404;
                    errorMessage.value = await response.text() || 'Unable to send a code. Please check the details and try again.';
                }
            } catch  {
                errorMessage.value = 'An error occurred. Please try again later.';
            } finally{
                loading.value = false;
            }
        };
        const handleVerifyOtp = async ()=>{
            if (loading.value || isLocked.value || cooldownSecondsRemaining.value > 0) return;
            loading.value = true;
            errorMessage.value = null;
            try {
                const response = await fetch('/api/driver-portal/authenticate-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        userIdentifier: loginIdentifier.value,
                        isEmail: method.value === 'email',
                        otpCode: otpCode.value
                    })
                });
                if (response.ok) await goToRedirect(response);
                else if (!await handleRateLimitResponse(response)) errorMessage.value = await response.text() || 'Invalid code, please try again.';
            } catch  {
                errorMessage.value = 'An error occurred. Please try again later.';
            } finally{
                loading.value = false;
            }
        };
        (0, _vue.onUnmounted)(()=>clearInterval(cooldownInterval));
        const __returned__ = {
            tabs,
            method,
            otpStage,
            identifier,
            phoneCountryCode,
            loginIdentifier,
            otpCode,
            email,
            password,
            showPassword,
            loading,
            errorMessage,
            infoMessage,
            notRegistered,
            isLocked,
            cooldownSecondsRemaining,
            get cooldownInterval () {
                return cooldownInterval;
            },
            set cooldownInterval (v){
                cooldownInterval = v;
            },
            selectMethod,
            resetOtp,
            clearGenericError,
            formatCooldown,
            startCooldownCountdown,
            handleRateLimitResponse,
            goToRedirect,
            handlePasswordLogin,
            handleSendOtp,
            handleVerifyOtp,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onUnmounted: (0, _vue.onUnmounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dBY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "ar-login-page"
};
const _hoisted_2 = {
    class: "ar-login-card"
};
const _hoisted_3 = {
    class: "ar-method-tabs mb-4",
    role: "tablist"
};
const _hoisted_4 = [
    "onClick"
];
const _hoisted_5 = {
    key: 0,
    class: "alert alert-danger d-flex align-items-start gap-2 py-3",
    role: "alert"
};
const _hoisted_6 = {
    style: {
        "font-size": "0.9rem"
    }
};
const _hoisted_7 = {
    key: 1,
    class: "alert alert-warning d-flex align-items-start gap-2 py-3",
    role: "alert"
};
const _hoisted_8 = {
    style: {
        "font-size": "0.9rem"
    }
};
const _hoisted_9 = {
    key: 2,
    class: "alert alert-info py-2",
    role: "status"
};
const _hoisted_10 = {
    key: 3,
    class: "alert alert-danger py-2",
    role: "alert"
};
const _hoisted_11 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_12 = {
    class: "mb-3"
};
const _hoisted_13 = {
    class: "mb-3"
};
const _hoisted_14 = {
    class: "position-relative"
};
const _hoisted_15 = [
    "type"
];
const _hoisted_16 = [
    "disabled"
];
const _hoisted_17 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_18 = {
    class: "mb-3"
};
const _hoisted_19 = {
    class: "form-label"
};
const _hoisted_20 = {
    key: 0,
    class: "input-group"
};
const _hoisted_21 = [
    "disabled"
];
const _hoisted_22 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_23 = {
    class: "mb-3"
};
const _hoisted_24 = {
    class: "form-text"
};
const _hoisted_25 = [
    "disabled"
];
const _hoisted_26 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[21] || (_cache[21] = (0, _vue.createStaticVNode)('<div class="text-center mb-4" data-v-c6e5db><a href="/portal" class="d-inline-block mb-3" data-v-c6e5db><img src="/assets/images/logo.svg" alt="Asher" class="ar-login-logo" data-v-c6e5db></a><h2 class="ar-login-title mb-1" data-v-c6e5db>Driver sign in</h2><p class="text-muted mb-0" data-v-c6e5db>Welcome back \u2014 choose how you&#39;d like to sign in.</p></div>', 1)),
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.tabs, (tab)=>{
                    return (0, _vue.createElementVNode)("button", {
                        key: tab.key,
                        type: "button",
                        class: (0, _vue.normalizeClass)([
                            "ar-method-tab",
                            {
                                active: $setup.method === tab.key
                            }
                        ]),
                        onClick: ($event)=>$setup.selectMethod(tab.key)
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: (0, _vue.normalizeClass)([
                                tab.icon,
                                "me-2"
                            ])
                        }, null, 2),
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(tab.label), 1)
                    ], 10, _hoisted_4);
                }), 64))
            ]),
            $setup.isLocked ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("span", {
                    style: {
                        "font-size": "1.1rem"
                    }
                }, "\uD83D\uDD12", -1)),
                (0, _vue.createElementVNode)("div", null, [
                    _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("strong", null, "Account locked", -1)),
                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("br", null, null, -1)),
                    (0, _vue.createElementVNode)("span", _hoisted_6, (0, _vue.toDisplayString)($setup.errorMessage), 1)
                ])
            ])) : $setup.cooldownSecondsRemaining > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("span", {
                    style: {
                        "font-size": "1.1rem"
                    }
                }, "\u23F1", -1)),
                (0, _vue.createElementVNode)("div", null, [
                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("strong", null, "Too many failed attempts", -1)),
                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("br", null, null, -1)),
                    (0, _vue.createElementVNode)("span", _hoisted_8, [
                        _cache[11] || (_cache[11] = (0, _vue.createTextVNode)(" Please wait ")),
                        (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.formatCooldown($setup.cooldownSecondsRemaining)), 1),
                        _cache[12] || (_cache[12] = (0, _vue.createTextVNode)(" before trying again. "))
                    ])
                ])
            ])) : (0, _vue.createCommentVNode)("", true),
            $setup.infoMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, (0, _vue.toDisplayString)($setup.infoMessage), 1)) : (0, _vue.createCommentVNode)("", true),
            $setup.errorMessage && !$setup.isLocked && $setup.cooldownSecondsRemaining === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($setup.errorMessage) + " ", 1),
                $setup.notRegistered ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, _cache[16] || (_cache[16] = [
                    (0, _vue.createElementVNode)("a", {
                        href: "/signup/driver",
                        class: "btn btn-sm ar-btn-brand"
                    }, "Sign up to drive", -1)
                ]))) : (0, _vue.createCommentVNode)("", true)
            ])) : (0, _vue.createCommentVNode)("", true),
            $setup.method === 'password' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("form", {
                key: 4,
                onSubmit: (0, _vue.withModifiers)($setup.handlePasswordLogin, [
                    "prevent"
                ])
            }, [
                (0, _vue.createElementVNode)("div", _hoisted_12, [
                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                        class: "form-label"
                    }, "Email address", -1)),
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                        class: "form-control",
                        type: "email",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event),
                        required: "",
                        placeholder: "email@address.com",
                        onInput: $setup.clearGenericError
                    }, null, 544), [
                        [
                            (0, _vue.vModelText),
                            $setup.email
                        ]
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_13, [
                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                        class: "form-label"
                    }, "Password", -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_14, [
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            class: "form-control",
                            type: $setup.showPassword ? 'text' : 'password',
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event),
                            required: "",
                            placeholder: "*********",
                            autocomplete: "current-password",
                            onInput: $setup.clearGenericError
                        }, null, 40, _hoisted_15), [
                            [
                                (0, _vue.vModelDynamic),
                                $setup.password
                            ]
                        ]),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "ar-show-hide",
                            onClick: _cache[2] || (_cache[2] = ($event)=>$setup.showPassword = !$setup.showPassword)
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: (0, _vue.normalizeClass)($setup.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye')
                            }, null, 2)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("button", {
                    class: "btn ar-btn-brand w-100",
                    type: "submit",
                    disabled: $setup.loading || $setup.isLocked || $setup.cooldownSecondsRemaining > 0
                }, [
                    $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_17)) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.loading ? 'Signing in...' : 'Sign in'), 1)
                ], 8, _hoisted_16)
            ], 32)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("form", {
                key: 5,
                onSubmit: _cache[7] || (_cache[7] = (0, _vue.withModifiers)(($event)=>$setup.otpStage === 'request' ? $setup.handleSendOtp() : $setup.handleVerifyOtp(), [
                    "prevent"
                ]))
            }, [
                $setup.otpStage === 'request' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    (0, _vue.createElementVNode)("div", _hoisted_18, [
                        (0, _vue.createElementVNode)("label", _hoisted_19, (0, _vue.toDisplayString)($setup.method === 'phone' ? 'Phone number' : 'Email address'), 1),
                        $setup.method === 'phone' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_20, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                style: {
                                    "max-width": "120px"
                                },
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.phoneCountryCode = $event)
                            }, _cache[19] || (_cache[19] = [
                                (0, _vue.createElementVNode)("option", {
                                    value: "+1"
                                }, "+1 (US)", -1),
                                (0, _vue.createElementVNode)("option", {
                                    value: "+1"
                                }, "+1 (CA)", -1)
                            ]), 512), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.phoneCountryCode
                                ]
                            ]),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                class: "form-control",
                                type: "tel",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.identifier = $event),
                                required: "",
                                placeholder: "5551234567",
                                onInput: $setup.clearGenericError
                            }, null, 544), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.identifier
                                ]
                            ])
                        ])) : (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", {
                            key: 1,
                            class: "form-control",
                            type: "email",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.identifier = $event),
                            required: "",
                            placeholder: "email@address.com",
                            onInput: $setup.clearGenericError
                        }, null, 544)), [
                            [
                                (0, _vue.vModelText),
                                $setup.identifier
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "btn ar-btn-brand w-100",
                        type: "submit",
                        disabled: $setup.loading || $setup.isLocked || $setup.cooldownSecondsRemaining > 0
                    }, [
                        $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.loading ? 'Sending...' : 'Send verification code'), 1)
                    ], 8, _hoisted_21)
                ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createElementVNode)("div", _hoisted_23, [
                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, "Verification code", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            class: "form-control",
                            type: "text",
                            inputmode: "numeric",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.otpCode = $event),
                            required: "",
                            placeholder: "Enter the code we sent",
                            onInput: $setup.clearGenericError
                        }, null, 544), [
                            [
                                (0, _vue.vModelText),
                                $setup.otpCode
                            ]
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_24, [
                            (0, _vue.createTextVNode)(" Sent to " + (0, _vue.toDisplayString)($setup.loginIdentifier) + ". ", 1),
                            (0, _vue.createElementVNode)("a", {
                                href: "#",
                                onClick: (0, _vue.withModifiers)($setup.resetOtp, [
                                    "prevent"
                                ])
                            }, "Use a different " + (0, _vue.toDisplayString)($setup.method === 'phone' ? 'number' : 'email'), 1)
                        ])
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "btn ar-btn-brand w-100",
                        type: "submit",
                        disabled: $setup.loading || $setup.isLocked || $setup.cooldownSecondsRemaining > 0
                    }, [
                        $setup.loading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_26)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.loading ? 'Verifying...' : 'Verify & sign in'), 1)
                    ], 8, _hoisted_25)
                ], 64))
            ], 32)),
            _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("p", {
                class: "text-center text-muted mt-4 mb-0"
            }, [
                (0, _vue.createTextVNode)(" Don't have an account? "),
                (0, _vue.createElementVNode)("a", {
                    href: "/signup/driver",
                    class: "ar-link fw-semibold"
                }, "Sign up")
            ], -1))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cy9tu":[function() {},{}],"5dYZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cNKxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b18dd508acd7fb9d");
    if (script.__esModule) script = script.default;
    script.render = require("befaceca8e984b8c").render;
    require("f8da5f5a8ff37f53").default(script);
    script.__scopeId = 'data-v-78f0b4';
    script.__file = "Shifts.vue";
};
initialize();
exports.default = script;

},{"b18dd508acd7fb9d":"3Fnsn","befaceca8e984b8c":"fsGwI","f8da5f5a8ff37f53":"ipFmZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Fnsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'Shifts',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const shiftsDataTable = (0, _vue.ref)(null);
        const dataLoaded = (0, _vue.ref)(false);
        const jurisdictionsById = (0, _vue.ref)({});
        const geoZonesById = (0, _vue.ref)({});
        // Names aren't on the wire for Shift (its jurisdiction/geoZone relations are @JsonIgnore'd, unlike
        // ServiceJurisdiction.serviceArea) — only serviceJurisdictionId/geoZoneId. Resolve names client-side
        // once, before the table renders, rather than racing DataTable's own render against these fetches.
        const jurisdictionOrZoneRender = (data, type, row)=>{
            if (row.serviceJurisdictionId && jurisdictionsById.value[row.serviceJurisdictionId]) return jurisdictionsById.value[row.serviceJurisdictionId];
            if (row.geoZoneId && geoZonesById.value[row.geoZoneId]) return geoZonesById.value[row.geoZoneId];
            return '<span class="text-muted">All Zones</span>';
        };
        const shiftColumns = [
            {
                data: 'startsAt',
                title: 'Starts',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'endsAt',
                title: 'Ends',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'guaranteedEarnings',
                title: 'Guaranteed Earnings',
                render: (0, _datatableRenderer.currency)
            },
            {
                data: 'maxDrivers',
                title: 'Max Drivers'
            },
            {
                data: 'serviceJurisdictionId',
                title: 'Jurisdiction / Zone',
                render: jurisdictionOrZoneRender
            },
            {
                data: 'status',
                title: 'Status',
                render: (0, _datatableRenderer.shiftStatus)
            },
            {
                title: 'Action',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-sm btn-outline-primary" href="/admin/shifts/${row.id}">
                <i class="fas fa-pen-to-square"></i> Edit</a>`;
                }
            }
        ];
        const fetchJurisdictionsAndZones = async ()=>{
            try {
                const [jurisdictionsResponse, zonesResponse] = await Promise.all([
                    fetch('/api/service-jurisdictions/active'),
                    fetch('/api/service-area-zones')
                ]);
                if (jurisdictionsResponse.ok) {
                    const jurisdictions = await jurisdictionsResponse.json();
                    jurisdictionsById.value = Object.fromEntries(jurisdictions.map((j)=>[
                            j.id,
                            j.name
                        ]));
                }
                if (zonesResponse.ok) {
                    const zones = await zonesResponse.json();
                    geoZonesById.value = Object.fromEntries(zones.map((z)=>[
                            z.id,
                            z.name
                        ]));
                }
            } catch (error) {
                console.error('Error fetching jurisdictions/zones for shift table:', error);
            }
        };
        (0, _vue.onMounted)(async ()=>{
            await fetchJurisdictionsAndZones();
            dataLoaded.value = true;
        });
        const __returned__ = {
            shiftsDataTable,
            dataLoaded,
            jurisdictionsById,
            geoZonesById,
            jurisdictionOrZoneRender,
            shiftColumns,
            fetchJurisdictionsAndZones,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get shiftStatus () {
                return 0, _datatableRenderer.shiftStatus;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get currency () {
                return 0, _datatableRenderer.currency;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fsGwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body social-list filter-cards-view"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1,
    class: "text-center py-4"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[1] || (_cache[1] = (0, _vue.createStaticVNode)("<div class=\"page-title\"><div class=\"row\"><div class=\"col-sm-6 col-12\"><h2> Shifts </h2></div><div class=\"col-sm-6 col-12 text-end\"><a class=\"btn btn-outline-primary align-items-center me-2\" href=\"/admin/shifts/calendar\"><i class=\"fa-solid fa-calendar-days\"></i> Calendar View </a><a class=\"btn btn-primary align-items-center\" href=\"/admin/shifts/new\"><i class=\"fa-regular fa-square-plus\"></i> Add New </a></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    $setup.dataLoaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: `/api/datatable/shifts`
                            },
                            ref: "shiftsDataTable",
                            class: "table-responsive display",
                            columns: $setup.shiftColumns
                        }, null, 512)
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, _cache[0] || (_cache[0] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-2"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Loading... ")
                    ])))
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipFmZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f8hgJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("db49ddf8907e6adf");
    if (script.__esModule) script = script.default;
    script.render = require("a269880a3a88961a").render;
    require("3ef37ccd2cd5d4ae").default(script);
    script.__scopeId = 'data-v-da9c4a';
    script.__file = "ShiftDetail.vue";
};
initialize();
exports.default = script;

},{"db49ddf8907e6adf":"3znUZ","a269880a3a88961a":"1uPcQ","3ef37ccd2cd5d4ae":"h0rFK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3znUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _entityFormVue = require("./EntityForm.vue");
var _entityFormVueDefault = parcelHelpers.interopDefault(_entityFormVue);
var _datetimeLocal = require("../utility/datetimeLocal");
// Nested inside this already-mounted page, so it needs no main.js/window.Vue entry and no
// data-vue-component mount of its own (CLAUDE.md).
var _shiftSignupsTableVue = require("./ShiftSignupsTable.vue");
var _shiftSignupsTableVueDefault = parcelHelpers.interopDefault(_shiftSignupsTableVue);
var _datatableRenderer = require("../utility/DatatableRenderer");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
var _globalsJs = require("../globals.js");
exports.default = {
    __name: 'ShiftDetail',
    props: {
        shiftId: {
            type: String,
            default: null
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const shift = (0, _vue.ref)({});
        const isEditingShift = (0, _vue.ref)(false);
        const isPublishing = (0, _vue.ref)(false);
        const isCancelling = (0, _vue.ref)(false);
        const jurisdictions = (0, _vue.ref)([]);
        const geoZones = (0, _vue.ref)([]);
        const isNewShift = (0, _vue.computed)(()=>props.shiftId === 'add' || props.shiftId === (0, _globalsJs.newEntityId));
        const isLocked = (0, _vue.computed)(()=>[
                'IN_PROGRESS',
                'CLOSED',
                'CANCELLED'
            ].includes(shift.value.state?.status));
        const statusBadge = (0, _vue.computed)(()=>shift.value.state ? (0, _datatableRenderer.shiftStatus)(shift.value.state.status) : '');
        // datetime-local inputs need a plain local YYYY-MM-DDTHH:mm value; the model stores/sends
        // startsAt/endsAt as ISO-8601 strings with a UTC offset. Convert at the edges rather than changing
        // the model.
        // The bracketed-IANA-suffix strip below ("...-04:00[America/Toronto]") is belt-and-braces, not a
        // format the server actually emits: Play leaves Jackson's WRITE_DATES_WITH_ZONE_ID disabled, so a
        // ZonedDateTime always serializes as a bare offset (measured: "-04:00", or "Z" when the value is
        // UTC). Kept because it is free and new Date() would return NaN if that ever changed.
        const startsAtLocal = (0, _vue.computed)({
            get: ()=>(0, _datetimeLocal.toDatetimeLocal)(shift.value.state?.startsAt),
            set: (value)=>{
                shift.value.state.startsAt = (0, _datetimeLocal.fromDatetimeLocal)(value);
            }
        });
        const endsAtLocal = (0, _vue.computed)({
            get: ()=>(0, _datetimeLocal.toDatetimeLocal)(shift.value.state?.endsAt),
            set: (value)=>{
                shift.value.state.endsAt = (0, _datetimeLocal.fromDatetimeLocal)(value);
            }
        });
        const fetchJurisdictionsAndZones = async ()=>{
            try {
                const [jurisdictionsResponse, zonesResponse] = await Promise.all([
                    fetch('/api/service-jurisdictions/active'),
                    fetch('/api/service-area-zones')
                ]);
                if (jurisdictionsResponse.ok) jurisdictions.value = await jurisdictionsResponse.json();
                if (zonesResponse.ok) geoZones.value = await zonesResponse.json();
            } catch (error) {
                console.error('Error fetching jurisdictions/zones:', error);
            }
        };
        const publishShift = async ()=>{
            isPublishing.value = true;
            try {
                const response = await fetch(`/api/shift/${props.shiftId}/publish`, {
                    method: 'POST'
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || 'Unable to publish shift.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 5000
                    });
                    return;
                }
                const updated = await response.json();
                shift.value.state.status = updated.status;
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Shift published and eligible drivers notified.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
                console.error('Failed to publish shift', error);
            } finally{
                isPublishing.value = false;
            }
        };
        const cancelShift = async ()=>{
            isCancelling.value = true;
            try {
                const response = await fetch(`/api/shift/${props.shiftId}/cancel`, {
                    method: 'POST'
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || 'Unable to cancel shift.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 5000
                    });
                    return;
                }
                const updated = await response.json();
                shift.value.state.status = updated.status;
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Shift cancelled.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            } catch (error) {
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
                console.error('Failed to cancel shift', error);
            } finally{
                isCancelling.value = false;
            }
        };
        (0, _vue.onMounted)(()=>{
            fetchJurisdictionsAndZones();
        });
        const __returned__ = {
            props,
            shift,
            isEditingShift,
            isPublishing,
            isCancelling,
            jurisdictions,
            geoZones,
            isNewShift,
            isLocked,
            statusBadge,
            startsAtLocal,
            endsAtLocal,
            fetchJurisdictionsAndZones,
            publishShift,
            cancelShift,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            EntityForm: (0, _entityFormVueDefault.default),
            get toDatetimeLocal () {
                return 0, _datetimeLocal.toDatetimeLocal;
            },
            get fromDatetimeLocal () {
                return 0, _datetimeLocal.fromDatetimeLocal;
            },
            ShiftSignupsTable: (0, _shiftSignupsTableVueDefault.default),
            get shiftStatus () {
                return 0, _datatableRenderer.shiftStatus;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get newEntityId () {
                return 0, _globalsJs.newEntityId;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./EntityForm.vue":"i0zng","../utility/datetimeLocal":"5L2k9","./ShiftSignupsTable.vue":"kp4NZ","../utility/DatatableRenderer":"gfmyC","../utility/toastNotificationUtility":"krOtg","../globals.js":"5gM7V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kp4NZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("d3a12be7bb063a7e");
    if (script.__esModule) script = script.default;
    script.render = require("bb9576b79b86691c").render;
    require("b3543d005806daf5").default(script);
    script.__scopeId = 'data-v-161bbf';
    script.__file = "ShiftSignupsTable.vue";
};
initialize();
exports.default = script;

},{"d3a12be7bb063a7e":"4c7b4","bb9576b79b86691c":"f3Uwu","b3543d005806daf5":"657Am","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4c7b4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'ShiftSignupsTable',
    props: {
        shiftId: {
            type: String,
            default: null
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const props = __props;
        const signupsDataTable = (0, _vue.ref)(null);
        // Every admin table in this app ships whole and lets DataTables.net paginate and search client-side
        // (CLAUDE.md); a shift's roster is bounded by its maxDrivers, so it is nowhere near needing more.
        const signupColumns = [
            {
                data: 'driverName',
                title: 'Driver',
                // Falls back to the id: a driver record with no name at all still has to be identifiable, since
                // this table exists to resolve "which driver was not paid".
                render: (data, type, row)=>(0, _datatableRenderer.potentialUndefinedColumn)(data || row.driverId)
            },
            {
                data: 'status',
                title: 'Sign-up status',
                render: (0, _datatableRenderer.shiftSignupStatus)
            },
            {
                data: 'signedUpAt',
                title: 'Signed up',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'settledAt',
                title: 'Settled',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'guaranteedEarnings',
                title: 'Guaranteed',
                render: (0, _datatableRenderer.optionalCurrency)
            },
            {
                data: 'actualEarnings',
                title: 'Earned in window',
                render: (0, _datatableRenderer.optionalCurrency)
            },
            {
                data: 'guaranteeCredited',
                title: 'Guarantee credited',
                render: (0, _datatableRenderer.optionalCurrency)
            },
            {
                data: 'earningTransferStatus',
                title: 'Payout',
                render: (0, _datatableRenderer.earningTransferStatus)
            },
            {
                data: 'outcomeReason',
                title: 'Outcome',
                render: (0, _datatableRenderer.potentialUndefinedColumn)
            }
        ];
        const __returned__ = {
            props,
            signupsDataTable,
            signupColumns,
            ref: (0, _vue.ref),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get earningTransferStatus () {
                return 0, _datatableRenderer.earningTransferStatus;
            },
            get optionalCurrency () {
                return 0, _datatableRenderer.optionalCurrency;
            },
            get potentialUndefinedColumn () {
                return 0, _datatableRenderer.potentialUndefinedColumn;
            },
            get shiftSignupStatus () {
                return 0, _datatableRenderer.shiftSignupStatus;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f3Uwu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h3", null, "Shift Sign-ups"),
            (0, _vue.createElementVNode)("small", {
                class: "form-text text-muted"
            }, ' Settlement figures are a snapshot taken when the shift was settled. They do not move with later tips, refunds or fare adjustments \u2014 earnings history is the live money record. "Credited" means the guarantee was added to the driver\'s earnings; the Payout column is whether the transfer actually landed. ')
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createVNode)($setup["DataTable"], {
                ajax: {
                    url: `/api/datatable/shift-signups?shiftId=${$setup.props.shiftId}`
                },
                ref: "signupsDataTable",
                class: "table-responsive display",
                columns: $setup.signupColumns
            }, null, 8, [
                "ajax"
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"657Am":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uPcQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    key: 0
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-md-6"
};
const _hoisted_5 = {
    class: "mb-3"
};
const _hoisted_6 = [
    "disabled",
    "readonly"
];
const _hoisted_7 = {
    class: "mb-3"
};
const _hoisted_8 = [
    "disabled",
    "readonly"
];
const _hoisted_9 = {
    class: "mb-3"
};
const _hoisted_10 = [
    "disabled",
    "readonly"
];
const _hoisted_11 = {
    class: "mb-3"
};
const _hoisted_12 = [
    "innerHTML"
];
const _hoisted_13 = {
    class: "col-md-6"
};
const _hoisted_14 = {
    class: "mb-3"
};
const _hoisted_15 = {
    class: "input-group"
};
const _hoisted_16 = [
    "disabled",
    "readonly"
];
const _hoisted_17 = {
    class: "mb-3"
};
const _hoisted_18 = [
    "disabled",
    "readonly"
];
const _hoisted_19 = {
    class: "mb-3"
};
const _hoisted_20 = [
    "disabled"
];
const _hoisted_21 = [
    "value"
];
const _hoisted_22 = {
    class: "mb-3"
};
const _hoisted_23 = [
    "disabled"
];
const _hoisted_24 = [
    "value"
];
const _hoisted_25 = {
    key: 0,
    class: "col-12 mt-3"
};
const _hoisted_26 = [
    "disabled"
];
const _hoisted_27 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_28 = [
    "disabled"
];
const _hoisted_29 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_30 = {
    key: 1,
    class: "col-12 mt-4"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createVNode)($setup["EntityForm"], {
            "entity-id": $props.shiftId,
            entity: $setup.shift,
            "onUpdate:entity": _cache[7] || (_cache[7] = ($event)=>$setup.shift = $event),
            editState: $setup.isEditingShift,
            "onUpdate:editState": _cache[8] || (_cache[8] = ($event)=>$setup.isEditingShift = $event),
            "form-name": "Shift",
            "api-url": "/api/shift",
            "redirect-url": "/admin/shifts",
            "model-constructor": "Shift",
            "show-title": true,
            "lock-editing": $setup.isLocked
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $setup.shift.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
                        (0, _vue.createElementVNode)("div", _hoisted_3, [
                            (0, _vue.createElementVNode)("div", _hoisted_4, [
                                (0, _vue.createElementVNode)("div", _hoisted_5, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("label", {
                                        for: "startsAt",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Starts "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "datetime-local",
                                        class: "form-control",
                                        id: "startsAt",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.startsAtLocal = $event),
                                        disabled: !$setup.isEditingShift,
                                        readonly: !$setup.isEditingShift,
                                        required: ""
                                    }, null, 8, _hoisted_6), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.startsAtLocal
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                                        for: "endsAt",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Ends "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "datetime-local",
                                        class: "form-control",
                                        id: "endsAt",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.endsAtLocal = $event),
                                        disabled: !$setup.isEditingShift,
                                        readonly: !$setup.isEditingShift,
                                        required: ""
                                    }, null, 8, _hoisted_8), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.endsAtLocal
                                        ]
                                    ]),
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("div", {
                                        id: "endsAt-error",
                                        class: "invalid-feedback d-none"
                                    }, "End time must be after start time.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_9, [
                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                        for: "durationHours",
                                        class: "form-label"
                                    }, "Duration (hours)", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "durationHours",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.shift.state.durationHours = $event),
                                        min: "0",
                                        step: "0.25",
                                        disabled: !$setup.isEditingShift,
                                        readonly: !$setup.isEditingShift
                                    }, null, 8, _hoisted_10), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.shift.state.durationHours,
                                            void 0,
                                            {
                                                number: true
                                            }
                                        ]
                                    ]),
                                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("div", {
                                        id: "durationHours-error",
                                        class: "invalid-feedback d-none"
                                    }, "Duration hours must be positive.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_11, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("label", {
                                        class: "form-label"
                                    }, "Status", -1)),
                                    (0, _vue.createElementVNode)("div", null, [
                                        (0, _vue.createElementVNode)("span", {
                                            innerHTML: $setup.statusBadge
                                        }, null, 8, _hoisted_12)
                                    ])
                                ])
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_13, [
                                (0, _vue.createElementVNode)("div", _hoisted_14, [
                                    _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                        for: "guaranteedEarnings",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Guaranteed Earnings "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.createElementVNode)("div", _hoisted_15, [
                                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("span", {
                                            class: "input-group-text"
                                        }, "$", -1)),
                                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                            type: "number",
                                            class: "form-control",
                                            id: "guaranteedEarnings",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.shift.state.guaranteedEarnings = $event),
                                            min: "0",
                                            step: "0.01",
                                            disabled: !$setup.isEditingShift,
                                            readonly: !$setup.isEditingShift,
                                            required: ""
                                        }, null, 8, _hoisted_16), [
                                            [
                                                (0, _vue.vModelText),
                                                $setup.shift.state.guaranteedEarnings,
                                                void 0,
                                                {
                                                    number: true
                                                }
                                            ]
                                        ])
                                    ]),
                                    _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
                                        id: "guaranteedEarnings-error",
                                        class: "invalid-feedback d-none"
                                    }, "Guaranteed earnings must be positive.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_17, [
                                    _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                                        for: "maxDrivers",
                                        class: "form-label"
                                    }, [
                                        (0, _vue.createTextVNode)("Max Drivers "),
                                        (0, _vue.createElementVNode)("span", {
                                            class: "text-danger"
                                        }, "*")
                                    ], -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "maxDrivers",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.shift.state.maxDrivers = $event),
                                        min: "1",
                                        step: "1",
                                        disabled: !$setup.isEditingShift,
                                        readonly: !$setup.isEditingShift,
                                        required: ""
                                    }, null, 8, _hoisted_18), [
                                        [
                                            (0, _vue.vModelText),
                                            $setup.shift.state.maxDrivers,
                                            void 0,
                                            {
                                                number: true
                                            }
                                        ]
                                    ]),
                                    _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("div", {
                                        id: "maxDrivers-error",
                                        class: "invalid-feedback d-none"
                                    }, "Max drivers must be positive.", -1))
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_19, [
                                    _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("label", {
                                        for: "serviceJurisdictionId",
                                        class: "form-label"
                                    }, "Service Jurisdiction", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                        class: "form-select",
                                        id: "serviceJurisdictionId",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.shift.state.serviceJurisdictionId = $event),
                                        disabled: !$setup.isEditingShift
                                    }, [
                                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("option", {
                                            value: null
                                        }, "-- All Jurisdictions --", -1)),
                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.jurisdictions, (jurisdiction)=>{
                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                key: jurisdiction.id,
                                                value: jurisdiction.id
                                            }, (0, _vue.toDisplayString)(jurisdiction.name), 9, _hoisted_21);
                                        }), 128))
                                    ], 8, _hoisted_20), [
                                        [
                                            (0, _vue.vModelSelect),
                                            $setup.shift.state.serviceJurisdictionId
                                        ]
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("div", _hoisted_22, [
                                    _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("label", {
                                        for: "geoZoneId",
                                        class: "form-label"
                                    }, "Geo Zone", -1)),
                                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                        class: "form-select",
                                        id: "geoZoneId",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.shift.state.geoZoneId = $event),
                                        disabled: !$setup.isEditingShift
                                    }, [
                                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("option", {
                                            value: null
                                        }, "-- All Zones --", -1)),
                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.geoZones, (zone)=>{
                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                key: zone.id,
                                                value: zone.id
                                            }, (0, _vue.toDisplayString)(zone.name), 9, _hoisted_24);
                                        }), 128))
                                    ], 8, _hoisted_23), [
                                        [
                                            (0, _vue.vModelSelect),
                                            $setup.shift.state.geoZoneId
                                        ]
                                    ]),
                                    _cache[24] || (_cache[24] = (0, _vue.createElementVNode)("small", {
                                        class: "form-text text-muted"
                                    }, "Optional additional scope; a service jurisdiction takes precedence when both are set.", -1))
                                ])
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "entity-id",
            "entity",
            "editState",
            "lock-editing"
        ]),
        !$setup.isNewShift && $setup.shift.state ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_25, [
            $setup.shift.state.status === 'DRAFT' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                key: 0,
                class: "btn btn-success me-2",
                disabled: $setup.isPublishing,
                onClick: $setup.publishShift
            }, [
                $setup.isPublishing ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_27)) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isPublishing ? 'Publishing...' : 'Publish'), 1)
            ], 8, _hoisted_26)) : (0, _vue.createCommentVNode)("", true),
            [
                'DRAFT',
                'PUBLISHED'
            ].includes($setup.shift.state.status) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                key: 1,
                class: "btn btn-outline-danger",
                disabled: $setup.isCancelling,
                onClick: $setup.cancelShift
            }, [
                $setup.isCancelling ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_29)) : (0, _vue.createCommentVNode)("", true),
                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isCancelling ? 'Cancelling...' : 'Cancel Shift'), 1)
            ], 8, _hoisted_28)) : (0, _vue.createCommentVNode)("", true)
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.isNewShift ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_30, [
            (0, _vue.createVNode)($setup["ShiftSignupsTable"], {
                "shift-id": $props.shiftId
            }, null, 8, [
                "shift-id"
            ])
        ])) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0rFK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6LoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("d0b3e644b4fa71ed");
    if (script.__esModule) script = script.default;
    script.render = require("3a69b534fa9907e6").render;
    require("f6de56c983198c1d").default(script);
    script.__scopeId = 'data-v-77c507';
    script.__file = "ShiftsCalendar.vue";
};
initialize();
exports.default = script;

},{"d0b3e644b4fa71ed":"g4T71","3a69b534fa9907e6":"6JqDJ","f6de56c983198c1d":"3yhIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g4T71":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _vue3 = require("@fullcalendar/vue3");
var _vue3Default = parcelHelpers.interopDefault(_vue3);
var _daygrid = require("@fullcalendar/daygrid");
var _daygridDefault = parcelHelpers.interopDefault(_daygrid);
var _interaction = require("@fullcalendar/interaction");
var _interactionDefault = parcelHelpers.interopDefault(_interaction);
exports.default = {
    __name: 'ShiftsCalendar',
    setup (__props, { expose: __expose }) {
        __expose();
        const calendarOptions = (0, _vue.reactive)({
            plugins: [
                (0, _daygridDefault.default),
                (0, _interactionDefault.default)
            ],
            initialView: 'dayGridMonth',
            height: 'auto',
            events: [],
            eventClick: (info)=>{
                window.location.href = `/admin/shifts/${info.event.id}`;
            },
            dateClick: ()=>{
                window.location.href = '/admin/shifts/new';
            }
        });
        const fetchShifts = async ()=>{
            try {
                const response = await fetch('/api/shifts');
                if (!response.ok) return;
                const shifts = await response.json();
                // Strip a possible bracketed IANA zone suffix (e.g. "[America/Toronto]") depending on the
                // server JVM's default timezone — java.time can emit one, FullCalendar's parser does not
                // expect it (#73 pre-commit review).
                const stripZoneId = (value)=>value ? value.replace(/\[[^\]]*\]$/, '') : value;
                calendarOptions.events = shifts.map((shift)=>({
                        id: shift.id,
                        title: `$${Number(shift.guaranteedEarnings).toFixed(2)} \u{2014} ${shift.status}`,
                        start: stripZoneId(shift.startsAt),
                        end: stripZoneId(shift.endsAt),
                        classNames: [
                            `shift-event-${String(shift.status).toLowerCase()}`
                        ]
                    }));
            } catch (error) {
                console.error('Error fetching shifts for calendar:', error);
            }
        };
        (0, _vue.onMounted)(()=>{
            fetchShifts();
        });
        const __returned__ = {
            calendarOptions,
            fetchShifts,
            reactive: (0, _vue.reactive),
            onMounted: (0, _vue.onMounted),
            get FullCalendar () {
                return 0, _vue3Default.default;
            },
            get dayGridPlugin () {
                return 0, _daygridDefault.default;
            },
            get interactionPlugin () {
                return 0, _interactionDefault.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@fullcalendar/vue3":"3e1hm","@fullcalendar/daygrid":"cjjJm","@fullcalendar/interaction":"9vjy2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3e1hm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fullCalendarJs = require("./FullCalendar.js");
var _fullCalendarJsDefault = parcelHelpers.interopDefault(_fullCalendarJs);
exports.default = (0, _fullCalendarJsDefault.default);

},{"./FullCalendar.js":"h88eR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h88eR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _core = require("@fullcalendar/core");
var _internal = require("@fullcalendar/core/internal");
var _optionsJs = require("./options.js");
const FullCalendar = (0, _vue.defineComponent)({
    props: {
        options: Object
    },
    data () {
        return {
            renderId: 0,
            customRenderingMap: new Map()
        };
    },
    methods: {
        getApi () {
            return getSecret(this).calendar;
        },
        buildOptions (suppliedOptions) {
            return {
                ...suppliedOptions,
                customRenderingMetaMap: kebabToCamelKeys(this.$slots),
                handleCustomRendering: getSecret(this).handleCustomRendering
            };
        }
    },
    render () {
        const customRenderingNodes = [];
        for (const customRendering of this.customRenderingMap.values())customRenderingNodes.push((0, _vue.h)(CustomRenderingComponent, {
            key: customRendering.id,
            customRendering
        }));
        return (0, _vue.h)('div', {
            // when renderId is changed, Vue will trigger a real-DOM async rerender, calling beforeUpdate/updated
            attrs: {
                'data-fc-render-id': this.renderId
            }
        }, (0, _vue.h)((0, _vue.Fragment), customRenderingNodes)); // for containing CustomRendering keys
    },
    mounted () {
        const customRenderingStore = new (0, _internal.CustomRenderingStore)();
        getSecret(this).handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
        const calendarOptions = this.buildOptions(this.options);
        const calendar = new (0, _core.Calendar)(this.$el, calendarOptions);
        getSecret(this).calendar = calendar;
        calendar.render();
        customRenderingStore.subscribe((customRenderingMap)=>{
            this.customRenderingMap = customRenderingMap; // likely same reference, so won't rerender
            this.renderId++; // force rerender
            getSecret(this).needCustomRenderingResize = true;
        });
    },
    beforeUpdate () {
        this.getApi().resumeRendering(); // the watcher handlers paused it
    },
    updated () {
        if (getSecret(this).needCustomRenderingResize) {
            getSecret(this).needCustomRenderingResize = false;
            this.getApi().updateSize();
        }
    },
    beforeUnmount () {
        this.getApi().destroy();
    },
    watch: buildWatchers()
});
exports.default = FullCalendar;
// Custom Rendering
// -------------------------------------------------------------------------------------------------
const CustomRenderingComponent = (0, _vue.defineComponent)({
    props: {
        customRendering: Object
    },
    render () {
        const customRendering = this.customRendering;
        const innerContent = typeof customRendering.generatorMeta === 'function' ? customRendering.generatorMeta(customRendering.renderProps) : customRendering.generatorMeta; // probably a vue JSX node returned from content-inject func
        return (0, _vue.h)((0, _vue.Teleport), {
            to: customRendering.containerEl
        }, innerContent);
    }
});
// storing internal state:
// https://github.com/vuejs/vue/issues/1988#issuecomment-163013818
function getSecret(inst) {
    return inst;
}
function buildWatchers() {
    let watchers = {
        // watches changes of ALL options and their nested objects,
        // but this is only a means to be notified of top-level non-complex options changes.
        options: {
            deep: true,
            handler (options) {
                let calendar = this.getApi();
                calendar.pauseRendering();
                let calendarOptions = this.buildOptions(options);
                calendar.resetOptions(calendarOptions);
                this.renderId++; // will queue a rerender
            }
        }
    };
    for(let complexOptionName in 0, _optionsJs.OPTION_IS_COMPLEX)// handlers called when nested objects change
    watchers[`options.${complexOptionName}`] = {
        deep: true,
        handler (val) {
            // unfortunately the handler is called with undefined if new props were set, but the complex one wasn't ever set
            if (val !== undefined) {
                let calendar = this.getApi();
                calendar.pauseRendering();
                calendar.resetOptions({
                    [complexOptionName]: val
                }, [
                    complexOptionName
                ]);
                this.renderId++; // will queue a rerender
            }
        }
    };
    return watchers;
}
// General Utils
// -------------------------------------------------------------------------------------------------
function kebabToCamelKeys(map) {
    const newMap = {};
    for(const key in map)newMap[kebabToCamel(key)] = map[key];
    return newMap;
}
function kebabToCamel(s) {
    return s.split('-').map((word, index)=>index ? capitalize(word) : word).join('');
}
function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

},{"vue":"dylud","@fullcalendar/core":"dYWMT","@fullcalendar/core/internal":"fCef8","./options.js":"9JFEH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYWMT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonRequestError", ()=>(0, _internalCommonJs.ae));
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "createPlugin", ()=>createPlugin);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatRange", ()=>formatRange);
parcelHelpers.export(exports, "globalLocales", ()=>globalLocales);
parcelHelpers.export(exports, "globalPlugins", ()=>globalPlugins);
parcelHelpers.export(exports, "sliceEvents", ()=>sliceEvents);
parcelHelpers.export(exports, "version", ()=>version);
var _internalCommonJs = require("./internal-common.js");
var _preact = require("preact");
var _compat = require("preact/compat");
const globalLocales = [];
const MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list'
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display'
};
const RAW_EN_LOCALE = Object.assign(Object.assign({}, MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today (buttonText, unit) {
            return unit === 'day' ? 'Today' : `This ${buttonText}`;
        }
    },
    viewHint: '$0 view',
    navLinkHint: 'Go to $0',
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? '' : 's'}`;
    }
});
function organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    let allRawLocales = globalLocales.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode
    };
}
function buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) return parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return queryLocale(inputSingular, available);
}
function queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = queryRawLocale(codes, available) || RAW_EN_LOCALE;
    return parseLocale(codeArg, codes, raw);
}
function queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split('-');
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function parseLocale(codeArg, codes, raw) {
    let merged = (0, _internalCommonJs.m)([
        MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        'buttonText'
    ]);
    delete merged.code; // don't want this part of the options
    let { week } = merged;
    delete merged.week;
    return {
        codeArg,
        codes,
        week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function createPlugin(input) {
    return {
        id: (0, _internalCommonJs.g)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, _internalCommonJs.i)(overrideDefs, currentOverrideDefs) || !(0, _internalCommonJs.i)(globalDefs, currentGlobalDefs)) currentHooks = buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class StandardTheme extends (0, _internalCommonJs.T) {
}
StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active'
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right'
};
StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left'
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
function compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp('component');
    let superType = queryProp('superType');
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error('Can\'t have a custom view type that references itself');
        superDef = ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function parseViewConfigs(inputs) {
    return (0, _internalCommonJs.a)(inputs, parseViewConfig);
}
function parseViewConfig(input) {
    let rawOptions = typeof input === 'function' ? {
        component: input
    } : input;
    let { component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, _internalCommonJs.B))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions
    };
}
function createViewHookComponent(options) {
    return (viewProps)=>(0, _preact.createElement)((0, _internalCommonJs.V).Consumer, null, (context)=>(0, _preact.createElement)((0, _internalCommonJs.C), {
                elTag: "div",
                elClasses: (0, _internalCommonJs.b)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = parseViewConfigs(defaultInputs);
    let overrideConfigs = parseViewConfigs(optionOverrides.views);
    let viewDefs = compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, _internalCommonJs.a)(viewDefs, (viewDef)=>buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = '';
    let singleUnit = '';
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = createDurationCached(durationInput);
        if (duration) {
            let denom = (0, _internalCommonJs.c)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration,
        durationUnit,
        singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, _internalCommonJs.e)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, _internalCommonJs.e))
    };
}
// hack to get memoization working
let durationInputMap = {};
function createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = durationInputMap[json];
    if (res === undefined) {
        res = (0, _internalCommonJs.d)(durationInput);
        durationInputMap[json] = res;
    }
    return res;
}
function reduceViewType(viewType, action) {
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}
function reduceCurrentDate(currentDate, action) {
    switch(action.type){
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
// should be initialized once and stay constant
// this will change too
function getInitialDate(options, dateEnv, nowManager) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return nowManager.getDateMarker();
}
function reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case 'SET_OPTION':
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return addSources({}, parseInitialSources(calendarOptions, context), activeRange, context);
}
function reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case 'ADD_EVENT_SOURCES':
            return addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return removeSource(eventSources, action.sourceId);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return fetchSourcesByIds(eventSources, action.sourceIds ? (0, _internalCommonJs.f)(action.sourceIds) : excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return fetchSourcesByIds(eventSources, excludeStaticSources(eventSources, context), activeRange, true, context);
}
function computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function removeSource(eventSourceHash, sourceId) {
    return (0, _internalCommonJs.h)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function fetchDirtySources(sourceHash, fetchRange, context) {
    return fetchSourcesByIds(sourceHash, (0, _internalCommonJs.h)(sourceHash, (eventSource)=>isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function isSourceDirty(eventSource, fetchRange, context) {
    if (!doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options, calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, _internalCommonJs.g)();
    sourceDef.fetch({
        eventSource,
        range: fetchRange,
        isRefetch,
        context
    }, (res)=>{
        let { rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId,
            fetchRange,
            rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId,
            fetchRange,
            error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange
        })
    });
    return sourceHash;
}
function excludeStaticSources(eventSources, context) {
    return (0, _internalCommonJs.h)(eventSources, (eventSource)=>doesSourceNeedRange(eventSource, context));
}
function parseInitialSources(rawOptions, context) {
    let refiners = (0, _internalCommonJs.j)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, _internalCommonJs.p)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}
function reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header,
        footer
    };
}
function parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets,
        viewsWithButtons,
        hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === 'rtl';
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(',').map((buttonName)=>{
            if (buttonName === 'title') {
                hasTitle = true;
                return {
                    buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, _internalCommonJs.k)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                    let prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                    buttonHint = (0, _internalCommonJs.k)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || 'year',
                        'year'
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, _internalCommonJs.k)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName,
                buttonClick,
                buttonIcon,
                buttonText,
                buttonHint
            };
        }));
    return {
        widgets,
        viewsWithButtons,
        hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class ViewImpl {
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
}
let eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const arrayEventSourcePlugin = createPlugin({
    name: 'array-event-source',
    eventSourceDefs: [
        eventSourceDef$2
    ]
});
let eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === 'function') return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, _internalCommonJs.u)(func.bind(null, (0, _internalCommonJs.l)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents
            }), errorCallback);
    }
};
const funcEventSourcePlugin = createPlugin({
    name: 'func-event-source',
    eventSourceDefs: [
        eventSourceDef$1
    ]
});
const JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, _internalCommonJs.n),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) return {
            url: refined.url,
            format: 'json',
            method: (refined.method || 'GET').toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta } = arg.eventSource;
        const requestParams = buildRequestParams(meta, arg.range, arg.context);
        (0, _internalCommonJs.r)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents,
                response
            });
        }, errorCallback);
    }
};
const jsonFeedEventSourcePlugin = createPlugin({
    name: 'json-event-source',
    eventSourceRefiners: JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        eventSourceDef
    ]
});
function buildRequestParams(meta, range, context) {
    let { dateEnv, options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, _internalCommonJs.n),
    startTime: (0, _internalCommonJs.d),
    endTime: (0, _internalCommonJs.d),
    duration: (0, _internalCommonJs.d),
    startRecur: (0, _internalCommonJs.n),
    endRecur: (0, _internalCommonJs.n)
};
let recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
                dateEnv
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, _internalCommonJs.s)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, _internalCommonJs.o)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return expandRanges(typeData.daysOfWeek, typeData.startTime, typeData.dateEnv, dateEnv, clippedFramingRange);
        return [];
    }
};
const simpleRecurringEventsPlugin = createPlugin({
    name: 'simple-recurring-event',
    recurringTypes: [
        recurring
    ],
    eventRefiners: SIMPLE_RECURRING_REFINERS
});
function expandRanges(daysOfWeek, startTime, eventDateEnv, calendarDateEnv, framingRange) {
    let dowHash = daysOfWeek ? (0, _internalCommonJs.f)(daysOfWeek) : null;
    let dayMarker = (0, _internalCommonJs.q)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    // https://github.com/fullcalendar/fullcalendar/issues/7934
    if (startTime) {
        if (startTime.milliseconds < 0) // possible for next-day to have negative business hours that go into current day
        endMarker = (0, _internalCommonJs.t)(endMarker, 1);
        else if (startTime.milliseconds >= 86400000) // possible for prev-day to have >24hr business hours that go into current day
        dayMarker = (0, _internalCommonJs.t)(dayMarker, -1);
    }
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = calendarDateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(calendarDateEnv.createMarker(eventDateEnv.toDate(instanceStart)));
        }
        dayMarker = (0, _internalCommonJs.t)(dayMarker, 1);
    }
    return instanceStarts;
}
const changeHandlerPlugin = createPlugin({
    name: 'change-handler',
    optionChangeHandlers: {
        events (events, context) {
            handleEventSources([
                events
            ], context);
        },
        eventSources: handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function handleEventSources(inputs, context) {
    let unfoundSources = (0, _internalCommonJs.v)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: 'RESET_RAW_EVENTS',
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', Object.assign(Object.assign({}, (0, _internalCommonJs.l)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function handleEventStore(eventStore, context) {
    let { emitter } = context;
    if (emitter.hasHandlers('eventsSet')) emitter.trigger('eventsSet', (0, _internalCommonJs.w)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const globalPlugins = [
    arrayEventSourcePlugin,
    funcEventSourcePlugin,
    jsonFeedEventSourcePlugin,
    simpleRecurringEventsPlugin,
    changeHandlerPlugin,
    createPlugin({
        name: 'misc',
        isLoadingFuncs: [
            (state)=>computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: handleDateProfile,
            eventStore: handleEventStore
        }
    })
];
class TaskRunner {
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, _internalCommonJs.D)(this.drain.bind(this));
    }
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, _internalCommonJs.x)(viewOptions.titleFormat || buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function buildTitleFormat(dateProfile) {
    let { currentRangeUnit } = dateProfile;
    if (currentRangeUnit === 'year') return {
        year: 'numeric'
    };
    if (currentRangeUnit === 'month') return {
        year: 'numeric',
        month: 'long'
    }; // like "September 2014"
    let days = (0, _internalCommonJs.y)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    // one day. longer, like "September 9 2014"
    return {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
}
/*
TODO: test switching timezones when NO timezone plugin
*/ class CalendarNowManager {
    constructor(){
        this.resetListeners = new Set();
    }
    handleInput(dateEnv, nowInput) {
        const oldDateEnv = this.dateEnv;
        if (dateEnv !== oldDateEnv) {
            if (typeof nowInput === 'function') this.nowFn = nowInput;
            else if (!oldDateEnv) {
                this.nowAnchorDate = dateEnv.toDate(nowInput ? dateEnv.createMarker(nowInput) : dateEnv.createNowMarker());
                this.nowAnchorQueried = Date.now();
            }
            this.dateEnv = dateEnv;
            // not first time? fire reset handlers
            if (oldDateEnv) for (const resetListener of this.resetListeners.values())resetListener();
        }
    }
    getDateMarker() {
        return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
    }
    addResetListener(handler) {
        this.resetListeners.add(handler);
    }
    removeResetListener(handler) {
        this.resetListeners.delete(handler);
    }
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class CalendarDataManager {
    constructor(props){
        this.computeCurrentViewData = (0, _internalCommonJs.z)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, _internalCommonJs.z)(organizeRawLocales);
        this.buildLocale = (0, _internalCommonJs.z)(buildLocale);
        this.buildPluginHooks = buildBuildPluginHooks();
        this.buildDateEnv = (0, _internalCommonJs.z)(buildDateEnv$1);
        this.buildTheme = (0, _internalCommonJs.z)(buildTheme);
        this.parseToolbars = (0, _internalCommonJs.z)(parseToolbars);
        this.buildViewSpecs = (0, _internalCommonJs.z)(buildViewSpecs);
        this.buildDateProfileGenerator = (0, _internalCommonJs.A)(buildDateProfileGenerator);
        this.buildViewApi = (0, _internalCommonJs.z)(buildViewApi);
        this.buildViewUiProps = (0, _internalCommonJs.A)(buildViewUiProps);
        this.buildEventUiBySource = (0, _internalCommonJs.z)(buildEventUiBySource, (0, _internalCommonJs.E));
        this.buildEventUiBases = (0, _internalCommonJs.z)(buildEventUiBases);
        this.parseContextBusinessHours = (0, _internalCommonJs.A)(parseContextBusinessHours);
        this.buildTitle = (0, _internalCommonJs.z)(buildTitle);
        this.nowManager = new CalendarNowManager();
        this.emitter = new (0, _internalCommonJs.F)();
        this.actionRunner = new TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        this.nowManager = new CalendarNowManager();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        let currentDate = getInitialDate(optionsData.calendarOptions, optionsData.dateEnv, this.nowManager);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, _internalCommonJs.G)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides,
            currentViewType,
            currentDate,
            dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources,
            eventUiBases: {},
            eventStore: (0, _internalCommonJs.H)(),
            renderableEventStore: (0, _internalCommonJs.H)(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if (computeIsLoading(initialState, calendarContext)) this.emitter.trigger('loading', true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    resetOptions(optionOverrides, changedOptionNames) {
        let { props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: 'NOTHING'
        });
    }
    _handleAction(action) {
        let { props, state, emitter } = this;
        let dynamicOptionOverrides = reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            nowManager: this.nowManager,
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate, dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = reduceCurrentDate(currentDate, action);
        dateProfile = reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
        action.type === 'NEXT' || // "
        !(0, _internalCommonJs.G)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, _internalCommonJs.I)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase, selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides,
            currentViewType,
            currentDate,
            dateProfile,
            eventSources,
            eventStore,
            renderableEventStore,
            selectionConfig,
            eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: reduceDateSelection(state.dateSelection, action),
            eventSelection: reduceSelectedEvent(state.eventSelection, action),
            eventDrag: reduceEventDrag(state.eventDrag, action),
            eventResize: reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = computeIsLoading(state, calendarContext);
        let isLoading = computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger('loading', true);
        else if (wasLoading && !isLoading) emitter.trigger('loading', false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props, state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            nowManager: this.nowManager,
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, _internalCommonJs.J)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, _internalCommonJs.J)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions, pluginHooks, localeDefaults, availableLocaleData, extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks,
            dateEnv,
            viewSpecs,
            theme,
            toolbarConfig,
            localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales, locale } = (0, _internalCommonJs.K)([
            (0, _internalCommonJs.e),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], globalPlugins);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, _internalCommonJs.L)), (0, _internalCommonJs.M)), (0, _internalCommonJs.N)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, _internalCommonJs.K)([
            (0, _internalCommonJs.e),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, _internalCommonJs.O)[optionName] && optionName in currentRaw && (0, _internalCommonJs.O)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks,
            availableLocaleData,
            localeDefaults,
            extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions, extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        warnUnknownOptions(extra);
        this.nowManager.handleInput(optionsData.dateEnv, refinedOptions.now);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            nowManager: this.nowManager,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec,
            options: refinedOptions,
            dateProfileGenerator,
            viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, _internalCommonJs.K)([
            (0, _internalCommonJs.e),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, _internalCommonJs.L)), (0, _internalCommonJs.M)), (0, _internalCommonJs.N)), (0, _internalCommonJs.P)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, _internalCommonJs.O)[optionName] && (0, _internalCommonJs.O)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, _internalCommonJs.O)[optionName] && (0, _internalCommonJs.O)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra
        };
    }
}
function buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, _internalCommonJs.Q)({
        calendarSystem: 'gregory',
        timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale,
        weekNumberCalculation,
        firstDay,
        weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator
    });
}
function buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || StandardTheme;
    return new ThemeClass(options);
}
function buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, _internalCommonJs.R);
    return new DateProfileGeneratorClass(props);
}
function buildViewApi(type, getCurrentData, dateEnv) {
    return new ViewImpl(type, getCurrentData, dateEnv);
}
function buildEventUiBySource(eventSources) {
    return (0, _internalCommonJs.a)(eventSources, (eventSource)=>eventSource.ui);
}
function buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        '': eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function buildViewUiProps(calendarContext) {
    let { options } = calendarContext;
    return {
        eventUiSingleBase: (0, _internalCommonJs.S)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, _internalCommonJs.S)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function parseContextBusinessHours(calendarContext) {
    return (0, _internalCommonJs.U)(calendarContext.options.businessHours, calendarContext);
}
function warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ''));
}
class ToolbarSection extends (0, _internalCommonJs.B) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, _preact.createElement)('div', {
            className: 'fc-toolbar-chunk'
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props } = this;
        let { theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName, buttonClick, buttonText, buttonIcon, buttonHint } = widget;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push((0, _preact.createElement)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === 'today' || !props.isPrevEnabled && buttonName === 'prev' || !props.isNextEnabled && buttonName === 'next';
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass('button')
                ];
                if (isPressed) buttonClasses.push(theme.getClass('buttonActive'));
                children.push((0, _preact.createElement)("button", {
                    type: "button",
                    title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(' '),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, _preact.createElement)("span", {
                    className: buttonIcon,
                    role: "img"
                }) : '')));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass('buttonGroup') || '';
            return (0, _preact.createElement)('div', {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class Toolbar extends (0, _internalCommonJs.B) {
    render() {
        let { model, extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : ''
        ];
        return (0, _preact.createElement)("div", {
            className: classNames.join(' ')
        }, this.renderSection('start', startContent || []), this.renderSection('center', centerContent || []), this.renderSection('end', endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props } = this;
        return (0, _preact.createElement)(ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class ViewHarness extends (0, _internalCommonJs.B) {
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, _internalCommonJs.W)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
    render() {
        let { props, state } = this;
        let { aspectRatio } = props;
        let classNames = [
            'fc-view-harness',
            aspectRatio || props.liquid || props.height ? 'fc-view-harness-active' // harness controls the height
             : 'fc-view-harness-passive'
        ];
        let height = '';
        let paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || '';
        return (0, _preact.createElement)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(' '),
            style: {
                height,
                paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class EventClicking extends (0, _internalCommonJs.X) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component } = this;
            let { context } = component;
            let seg = (0, _internalCommonJs.Y)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, _internalCommonJs.Z)(ev.target, '.fc-event-forced-url');
                let url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new (0, _internalCommonJs._)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, _internalCommonJs.$)(settings.el, 'click', '.fc-event', this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class EventHovering extends (0, _internalCommonJs.X) {
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, _internalCommonJs.Y)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        this.removeHoverListeners = (0, _internalCommonJs.a0)(settings.el, '.fc-event', this.handleSegEnter, this.handleSegLeave);
    }
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component } = this;
        let { context } = component;
        let seg = (0, _internalCommonJs.Y)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, _internalCommonJs._)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
}
class CalendarContent extends (0, _internalCommonJs.a1) {
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, _internalCommonJs.z)((0, _internalCommonJs.a2));
        this.buildViewPropTransformers = (0, _internalCommonJs.z)(buildViewPropTransformers);
        this.buildToolbarProps = (0, _internalCommonJs.z)(buildToolbarProps);
        this.headerRef = (0, _preact.createRef)();
        this.footerRef = (0, _preact.createRef)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, _internalCommonJs.a3)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, _internalCommonJs.a4)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                EventClicking,
                EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, _internalCommonJs.a5)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, _internalCommonJs.a5)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, _internalCommonJs.D)(()=>{
            this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger('windowResize', {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props } = this;
        let { toolbarConfig, options } = props;
        let viewVGrow = false;
        let viewHeight = '';
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = '';
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.nowManager, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : undefined;
        return (0, _preact.createElement)((0, _internalCommonJs.V).Provider, {
            value: viewContext
        }, (0, _preact.createElement)((0, _internalCommonJs.a6), {
            unit: "day"
        }, (nowDate)=>{
            let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, nowDate, props.viewTitle);
            return (0, _preact.createElement)((0, _preact.Fragment), null, toolbarConfig.header && (0, _preact.createElement)(Toolbar, Object.assign({
                ref: this.headerRef,
                extraClassName: "fc-header-toolbar",
                model: toolbarConfig.header,
                titleId: viewLabelId
            }, toolbarProps)), (0, _preact.createElement)(ViewHarness, {
                liquid: viewVGrow,
                height: viewHeight,
                aspectRatio: viewAspectRatio,
                labeledById: viewLabelId
            }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, _preact.createElement)(Toolbar, Object.assign({
                ref: this.footerRef,
                extraClassName: "fc-footer-toolbar",
                model: toolbarConfig.footer,
                titleId: ""
            }, toolbarProps)));
        }));
    }
    componentDidMount() {
        let { props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener('resize', this.handleWindowResize);
        let { propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props } = this;
        let { propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger('_unmount');
    }
    buildAppendContent() {
        let { props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, _preact.createElement)((0, _preact.Fragment), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks } = props;
        let { viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, _preact.createElement)(ViewComponent, Object.assign({}, viewProps));
    }
}
function buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, _internalCommonJs.G)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class Calendar extends (0, _internalCommonJs.a7) {
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData } = this;
                (0, _internalCommonJs.a8)(()=>{
                    (0, _preact.render)((0, _preact.createElement)((0, _internalCommonJs.a9), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, _preact.createElement)((0, _internalCommonJs.aa).Provider, {
                            value: this.customContentRenderId
                        }, (0, _preact.createElement)(CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, _preact.render)(null, this.el);
                this.setClassNames([]);
                this.setHeight('');
            }
        };
        (0, _internalCommonJs.ab)(el);
        this.el = el;
        this.renderRunner = new (0, _internalCommonJs.D)(this.handleRenderRequest);
        new CalendarDataManager({
            optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, _internalCommonJs.a8)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    }
    pauseRendering() {
        this.renderRunner.pause('pauseRendering');
    }
    resumeRendering() {
        this.renderRunner.resume('pauseRendering', true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, _internalCommonJs.i)(classNames, this.currentClassNames)) {
            let { classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, _internalCommonJs.ac)(this.el, 'height', height);
    }
}
function formatDate(dateInput, options = {}) {
    let dateEnv = buildDateEnv(options);
    let formatter = (0, _internalCommonJs.x)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return '';
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function formatRange(startInput, endInput, options) {
    let dateEnv = buildDateEnv(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    let formatter = (0, _internalCommonJs.x)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return '';
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, _internalCommonJs.e).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function buildDateEnv(settings) {
    let locale = buildLocale(settings.locale || 'en', organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, _internalCommonJs.Q)(Object.assign(Object.assign({
        timeZone: (0, _internalCommonJs.e).timeZone,
        calendarSystem: 'gregory'
    }, settings), {
        locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function sliceEvents(props, allDay) {
    return (0, _internalCommonJs.ad)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const version = '6.1.21';

},{"./internal-common.js":"cbu5L","preact":"hvsRZ","preact/compat":"7Rky7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbu5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>listenBySelector);
parcelHelpers.export(exports, "A", ()=>memoizeObjArg);
parcelHelpers.export(exports, "B", ()=>BaseComponent);
parcelHelpers.export(exports, "C", ()=>ContentContainer);
parcelHelpers.export(exports, "D", ()=>DelayedRunner);
parcelHelpers.export(exports, "E", ()=>isPropsEqual);
parcelHelpers.export(exports, "F", ()=>Emitter);
parcelHelpers.export(exports, "G", ()=>rangeContainsMarker);
parcelHelpers.export(exports, "H", ()=>createEmptyEventStore);
parcelHelpers.export(exports, "I", ()=>reduceEventStore);
parcelHelpers.export(exports, "J", ()=>rezoneEventStoreDates);
parcelHelpers.export(exports, "K", ()=>mergeRawOptions);
parcelHelpers.export(exports, "L", ()=>BASE_OPTION_REFINERS);
parcelHelpers.export(exports, "M", ()=>CALENDAR_LISTENER_REFINERS);
parcelHelpers.export(exports, "N", ()=>CALENDAR_OPTION_REFINERS);
parcelHelpers.export(exports, "O", ()=>COMPLEX_OPTION_COMPARATORS);
parcelHelpers.export(exports, "P", ()=>VIEW_OPTION_REFINERS);
parcelHelpers.export(exports, "Q", ()=>DateEnv);
parcelHelpers.export(exports, "R", ()=>DateProfileGenerator);
parcelHelpers.export(exports, "S", ()=>createEventUi);
parcelHelpers.export(exports, "T", ()=>Theme);
parcelHelpers.export(exports, "U", ()=>parseBusinessHours);
parcelHelpers.export(exports, "V", ()=>ViewContextType);
parcelHelpers.export(exports, "W", ()=>setRef);
parcelHelpers.export(exports, "X", ()=>Interaction);
parcelHelpers.export(exports, "Y", ()=>getElSeg);
parcelHelpers.export(exports, "Z", ()=>elementClosest);
parcelHelpers.export(exports, "_", ()=>EventImpl);
parcelHelpers.export(exports, "a", ()=>mapHash);
parcelHelpers.export(exports, "a$", ()=>preventDefault);
parcelHelpers.export(exports, "a0", ()=>listenToHoverBySelector);
parcelHelpers.export(exports, "a1", ()=>PureComponent);
parcelHelpers.export(exports, "a2", ()=>buildViewContext);
parcelHelpers.export(exports, "a3", ()=>getUniqueDomId);
parcelHelpers.export(exports, "a4", ()=>parseInteractionSettings);
parcelHelpers.export(exports, "a5", ()=>interactionSettingsStore);
parcelHelpers.export(exports, "a6", ()=>NowTimer);
parcelHelpers.export(exports, "a7", ()=>CalendarImpl);
parcelHelpers.export(exports, "a8", ()=>flushSync);
parcelHelpers.export(exports, "a9", ()=>CalendarRoot);
parcelHelpers.export(exports, "aA", ()=>memoizeArraylike);
parcelHelpers.export(exports, "aB", ()=>memoizeHashlike);
parcelHelpers.export(exports, "aC", ()=>intersectRects);
parcelHelpers.export(exports, "aD", ()=>pointInsideRect);
parcelHelpers.export(exports, "aE", ()=>constrainPoint);
parcelHelpers.export(exports, "aF", ()=>getRectCenter);
parcelHelpers.export(exports, "aG", ()=>diffPoints);
parcelHelpers.export(exports, "aH", ()=>translateRect);
parcelHelpers.export(exports, "aI", ()=>compareObjs);
parcelHelpers.export(exports, "aJ", ()=>collectFromHash);
parcelHelpers.export(exports, "aK", ()=>findElements);
parcelHelpers.export(exports, "aL", ()=>findDirectChildren);
parcelHelpers.export(exports, "aM", ()=>removeElement);
parcelHelpers.export(exports, "aN", ()=>applyStyle);
parcelHelpers.export(exports, "aO", ()=>elementMatches);
parcelHelpers.export(exports, "aP", ()=>getEventTargetViaRoot);
parcelHelpers.export(exports, "aQ", ()=>parseClassNames);
parcelHelpers.export(exports, "aR", ()=>getCanVGrowWithinCell);
parcelHelpers.export(exports, "aS", ()=>mergeEventStores);
parcelHelpers.export(exports, "aT", ()=>getRelevantEvents);
parcelHelpers.export(exports, "aU", ()=>eventTupleToStore);
parcelHelpers.export(exports, "aV", ()=>combineEventUis);
parcelHelpers.export(exports, "aW", ()=>Splitter);
parcelHelpers.export(exports, "aX", ()=>getDayClassNames);
parcelHelpers.export(exports, "aY", ()=>getDateMeta);
parcelHelpers.export(exports, "aZ", ()=>getSlotClassNames);
parcelHelpers.export(exports, "a_", ()=>buildNavLinkAttrs);
parcelHelpers.export(exports, "aa", ()=>RenderId);
parcelHelpers.export(exports, "ab", ()=>ensureElHasStyles);
parcelHelpers.export(exports, "ac", ()=>applyStyleProp);
parcelHelpers.export(exports, "ad", ()=>sliceEventStore);
parcelHelpers.export(exports, "ae", ()=>JsonRequestError);
parcelHelpers.export(exports, "af", ()=>createContext);
parcelHelpers.export(exports, "ag", ()=>refineProps);
parcelHelpers.export(exports, "ah", ()=>createEventInstance);
parcelHelpers.export(exports, "ai", ()=>parseEventDef);
parcelHelpers.export(exports, "aj", ()=>refineEventDef);
parcelHelpers.export(exports, "ak", ()=>padStart);
parcelHelpers.export(exports, "al", ()=>isInt);
parcelHelpers.export(exports, "am", ()=>parseFieldSpecs);
parcelHelpers.export(exports, "an", ()=>compareByFieldSpecs);
parcelHelpers.export(exports, "ao", ()=>flexibleCompare);
parcelHelpers.export(exports, "ap", ()=>preventSelection);
parcelHelpers.export(exports, "aq", ()=>allowSelection);
parcelHelpers.export(exports, "ar", ()=>preventContextMenu);
parcelHelpers.export(exports, "as", ()=>allowContextMenu);
parcelHelpers.export(exports, "at", ()=>compareNumbers);
parcelHelpers.export(exports, "au", ()=>enableCursor);
parcelHelpers.export(exports, "av", ()=>disableCursor);
parcelHelpers.export(exports, "aw", ()=>computeVisibleDayRange);
parcelHelpers.export(exports, "ax", ()=>isMultiDayRange);
parcelHelpers.export(exports, "ay", ()=>diffDates);
parcelHelpers.export(exports, "az", ()=>removeExact);
parcelHelpers.export(exports, "b", ()=>buildViewClassNames);
parcelHelpers.export(exports, "b$", ()=>renderMicroColGroup);
parcelHelpers.export(exports, "b0", ()=>whenTransitionDone);
parcelHelpers.export(exports, "b1", ()=>computeInnerRect);
parcelHelpers.export(exports, "b2", ()=>computeEdges);
parcelHelpers.export(exports, "b3", ()=>getClippingParents);
parcelHelpers.export(exports, "b4", ()=>computeRect);
parcelHelpers.export(exports, "b5", ()=>rangesEqual);
parcelHelpers.export(exports, "b6", ()=>rangesIntersect);
parcelHelpers.export(exports, "b7", ()=>rangeContainsRange);
parcelHelpers.export(exports, "b8", ()=>PositionCache);
parcelHelpers.export(exports, "b9", ()=>ScrollController);
parcelHelpers.export(exports, "bA", ()=>getEntrySpanEnd);
parcelHelpers.export(exports, "bB", ()=>binarySearch);
parcelHelpers.export(exports, "bC", ()=>groupIntersectingEntries);
parcelHelpers.export(exports, "bD", ()=>intersectSpans);
parcelHelpers.export(exports, "bE", ()=>interactionSettingsToStore);
parcelHelpers.export(exports, "bF", ()=>ElementDragging);
parcelHelpers.export(exports, "bG", ()=>config);
parcelHelpers.export(exports, "bH", ()=>parseDragMeta);
parcelHelpers.export(exports, "bI", ()=>DayHeader);
parcelHelpers.export(exports, "bJ", ()=>computeFallbackHeaderFormat);
parcelHelpers.export(exports, "bK", ()=>TableDateCell);
parcelHelpers.export(exports, "bL", ()=>TableDowCell);
parcelHelpers.export(exports, "bM", ()=>DaySeriesModel);
parcelHelpers.export(exports, "bN", ()=>hasBgRendering);
parcelHelpers.export(exports, "bO", ()=>buildSegTimeText);
parcelHelpers.export(exports, "bP", ()=>sortEventSegs);
parcelHelpers.export(exports, "bQ", ()=>getSegMeta);
parcelHelpers.export(exports, "bR", ()=>buildEventRangeKey);
parcelHelpers.export(exports, "bS", ()=>getSegAnchorAttrs);
parcelHelpers.export(exports, "bT", ()=>DayTableModel);
parcelHelpers.export(exports, "bU", ()=>Slicer);
parcelHelpers.export(exports, "bV", ()=>applyMutationToEventStore);
parcelHelpers.export(exports, "bW", ()=>isPropsValid);
parcelHelpers.export(exports, "bX", ()=>isInteractionValid);
parcelHelpers.export(exports, "bY", ()=>isDateSelectionValid);
parcelHelpers.export(exports, "bZ", ()=>SimpleScrollGrid);
parcelHelpers.export(exports, "b_", ()=>hasShrinkWidth);
parcelHelpers.export(exports, "ba", ()=>ElementScrollController);
parcelHelpers.export(exports, "bb", ()=>WindowScrollController);
parcelHelpers.export(exports, "bc", ()=>DateComponent);
parcelHelpers.export(exports, "bd", ()=>isDateSpansEqual);
parcelHelpers.export(exports, "be", ()=>addMs);
parcelHelpers.export(exports, "bf", ()=>addWeeks);
parcelHelpers.export(exports, "bg", ()=>diffWeeks);
parcelHelpers.export(exports, "bh", ()=>diffWholeWeeks);
parcelHelpers.export(exports, "bi", ()=>diffDayAndTime);
parcelHelpers.export(exports, "bj", ()=>diffDays);
parcelHelpers.export(exports, "bk", ()=>isValidDate);
parcelHelpers.export(exports, "bl", ()=>asCleanDays);
parcelHelpers.export(exports, "bm", ()=>multiplyDuration);
parcelHelpers.export(exports, "bn", ()=>addDurations);
parcelHelpers.export(exports, "bo", ()=>asRoughMinutes);
parcelHelpers.export(exports, "bp", ()=>asRoughSeconds);
parcelHelpers.export(exports, "bq", ()=>asRoughMs);
parcelHelpers.export(exports, "br", ()=>wholeDivideDurations);
parcelHelpers.export(exports, "bs", ()=>formatIsoTimeString);
parcelHelpers.export(exports, "bt", ()=>formatDayString);
parcelHelpers.export(exports, "bu", ()=>buildIsoString);
parcelHelpers.export(exports, "bv", ()=>formatIsoMonthStr);
parcelHelpers.export(exports, "bw", ()=>NamedTimeZoneImpl);
parcelHelpers.export(exports, "bx", ()=>parse);
parcelHelpers.export(exports, "by", ()=>SegHierarchy);
parcelHelpers.export(exports, "bz", ()=>buildEntryKey);
parcelHelpers.export(exports, "c", ()=>greatestDurationDenominator);
parcelHelpers.export(exports, "c0", ()=>getScrollGridClassNames);
parcelHelpers.export(exports, "c1", ()=>getSectionClassNames);
parcelHelpers.export(exports, "c2", ()=>getSectionHasLiquidHeight);
parcelHelpers.export(exports, "c3", ()=>getAllowYScrolling);
parcelHelpers.export(exports, "c4", ()=>renderChunkContent);
parcelHelpers.export(exports, "c5", ()=>computeShrinkWidth);
parcelHelpers.export(exports, "c6", ()=>sanitizeShrinkWidth);
parcelHelpers.export(exports, "c7", ()=>isColPropsEqual);
parcelHelpers.export(exports, "c8", ()=>renderScrollShim);
parcelHelpers.export(exports, "c9", ()=>getStickyFooterScrollbar);
parcelHelpers.export(exports, "ca", ()=>getStickyHeaderDates);
parcelHelpers.export(exports, "cb", ()=>Scroller);
parcelHelpers.export(exports, "cc", ()=>getScrollbarWidths);
parcelHelpers.export(exports, "cd", ()=>RefMap);
parcelHelpers.export(exports, "ce", ()=>getIsRtlScrollbarOnLeft);
parcelHelpers.export(exports, "cf", ()=>ScrollResponder);
parcelHelpers.export(exports, "cg", ()=>StandardEvent);
parcelHelpers.export(exports, "ch", ()=>NowIndicatorContainer);
parcelHelpers.export(exports, "ci", ()=>DayCellContainer);
parcelHelpers.export(exports, "cj", ()=>hasCustomDayCellContent);
parcelHelpers.export(exports, "ck", ()=>EventContainer);
parcelHelpers.export(exports, "cl", ()=>renderFill);
parcelHelpers.export(exports, "cm", ()=>BgEvent);
parcelHelpers.export(exports, "cn", ()=>WeekNumberContainer);
parcelHelpers.export(exports, "co", ()=>MoreLinkContainer);
parcelHelpers.export(exports, "cp", ()=>computeEarliestSegStart);
parcelHelpers.export(exports, "cq", ()=>ViewContainer);
parcelHelpers.export(exports, "cr", ()=>triggerDateSelect);
parcelHelpers.export(exports, "cs", ()=>getDefaultEventEnd);
parcelHelpers.export(exports, "ct", ()=>injectStyles);
parcelHelpers.export(exports, "cu", ()=>buildElAttrs);
parcelHelpers.export(exports, "cv", ()=>CustomRenderingStore);
parcelHelpers.export(exports, "d", ()=>createDuration);
parcelHelpers.export(exports, "e", ()=>BASE_OPTION_DEFAULTS);
parcelHelpers.export(exports, "f", ()=>arrayToHash);
parcelHelpers.export(exports, "g", ()=>guid);
parcelHelpers.export(exports, "h", ()=>filterHash);
parcelHelpers.export(exports, "i", ()=>isArraysEqual);
parcelHelpers.export(exports, "j", ()=>buildEventSourceRefiners);
parcelHelpers.export(exports, "k", ()=>formatWithOrdinals);
parcelHelpers.export(exports, "l", ()=>buildRangeApiWithTimeZone);
parcelHelpers.export(exports, "m", ()=>mergeProps);
parcelHelpers.export(exports, "n", ()=>identity);
parcelHelpers.export(exports, "o", ()=>intersectRanges);
parcelHelpers.export(exports, "p", ()=>parseEventSource);
parcelHelpers.export(exports, "q", ()=>startOfDay);
parcelHelpers.export(exports, "r", ()=>requestJson);
parcelHelpers.export(exports, "s", ()=>subtractDurations);
parcelHelpers.export(exports, "t", ()=>addDays);
parcelHelpers.export(exports, "u", ()=>unpromisify);
parcelHelpers.export(exports, "v", ()=>hashValuesToArray);
parcelHelpers.export(exports, "w", ()=>buildEventApis);
parcelHelpers.export(exports, "x", ()=>createFormatter);
parcelHelpers.export(exports, "y", ()=>diffWholeDays);
parcelHelpers.export(exports, "z", ()=>memoize);
var _preact = require("preact");
var _compat = require("preact/compat");
const styleTexts = [];
const styleEls = new Map();
function injectStyles(styleText) {
    styleTexts.push(styleText);
    styleEls.forEach((styleEl)=>{
        appendStylesTo(styleEl, styleText);
    });
}
function ensureElHasStyles(el) {
    if (el.isConnected && // sometimes true if SSR system simulates DOM
    el.getRootNode // sometimes undefined if SSR system simulates DOM
    ) registerStylesRoot(el.getRootNode());
}
function registerStylesRoot(rootNode) {
    let styleEl = styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector('style[data-fullcalendar]');
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.setAttribute('data-fullcalendar', '');
            const nonce = getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        styleEls.set(rootNode, styleEl);
        hydrateStylesRoot(styleEl);
    }
}
function hydrateStylesRoot(styleEl) {
    for (const styleText of styleTexts)appendStylesTo(styleEl, styleText);
}
function appendStylesTo(styleEl, styleText) {
    const { sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split('}').forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + '}', ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let queriedNonceValue;
function getNonceValue() {
    if (queriedNonceValue === undefined) queriedNonceValue = queryNonceValue();
    return queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute('content')) return metaWithNonce.getAttribute('content');
    const elWithNonce = document.querySelector('script[nonce]');
    if (elWithNonce) return elWithNonce.nonce || '';
    return '';
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== 'undefined') registerStylesRoot(document);
var css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
injectStyles(css_248z);
class DelayedRunner {
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = '') {
        let { pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = '', force) {
        let { pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
}
function removeElement(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function elementClosest(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if (elementMatches(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function elementMatches(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function findElements(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function findDirectChildren(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || elementMatches(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function applyStyle(el, props) {
    for(let propName in props)applyStyleProp(el, propName, props[propName]);
}
function applyStyleProp(el, name, val) {
    if (val == null) el.style[name] = '';
    else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function getEventTargetViaRoot(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let guid$1 = 0;
function getUniqueDomId() {
    guid$1 += 1;
    return 'fc-dom-' + guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = elementClosest(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function listenBySelector(container, eventType, selector, handler) {
    let attachedHandler = buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return listenBySelector(container, 'mouseover', selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function whenTransitionDone(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, createAriaKeyboardAttrs(handler));
}
function createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let guidNumber = 0;
function guid() {
    guidNumber += 1;
    return String(guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function enableCursor() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function preventSelection(el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.addEventListener('selectstart', preventDefault);
}
function allowSelection(el) {
    el.style.userSelect = '';
    el.style.webkitUserSelect = '';
    el.removeEventListener('selectstart', preventDefault);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function preventContextMenu(el) {
    el.addEventListener('contextmenu', preventDefault);
}
function allowContextMenu(el) {
    el.removeEventListener('contextmenu', preventDefault);
}
function parseFieldSpecs(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === 'string') tokens = input.split(/\s*,\s*/);
    else if (typeof input === 'function') tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === 'string') specs.push(token.charAt(0) === '-' ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === 'function') specs.push({
            func: token
        });
    }
    return specs;
}
function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function flexibleCompare(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === 'string' || typeof b === 'string') return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function padStart(val, len) {
    let s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function formatWithOrdinals(formatter, args, fallbackText) {
    if (typeof formatter === 'function') return formatter(...args);
    if (typeof formatter === 'string') return args.reduce((str, arg, index)=>str.replace('$' + index, arg || ''), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function compareNumbers(a, b) {
    return a - b;
}
function isInt(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    let contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    if (!contentWidthEl) throw new Error('needs fc-scrollgrid-shrink-cushion className');
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const INTERNAL_UNITS = [
    'years',
    'months',
    'days',
    'milliseconds'
];
const PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function createDuration(input, unit) {
    if (typeof input === 'string') return parseString(input);
    if (typeof input === 'object' && input) return parseObject(input);
    if (typeof input === 'number') return parseObject({
        [unit || 'milliseconds']: input
    });
    return null;
}
function parseString(s) {
    let m = PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function asCleanDays(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function addDurations(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function subtractDurations(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function multiplyDuration(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function asRoughYears(dur) {
    return asRoughDays(dur) / 365;
}
function asRoughMonths(dur) {
    return asRoughDays(dur) / 30;
}
function asRoughDays(dur) {
    return asRoughMs(dur) / 864e5;
}
function asRoughMinutes(dur) {
    return asRoughMs(dur) / 60000;
}
function asRoughSeconds(dur) {
    return asRoughMs(dur) / 1000;
}
function asRoughMs(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function wholeDivideDurations(numerator, denominator) {
    let res = null;
    for(let i = 0; i < INTERNAL_UNITS.length; i += 1){
        let unit = INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!isInt(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function greatestDurationDenominator(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: 'millisecond',
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: 'second',
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: 'minute',
            value: ms / 60000
        };
        if (ms) return {
            unit: 'hour',
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: 'week',
            value: dur.days / 7
        };
        return {
            unit: 'day',
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: 'month',
        value: dur.months
    };
    if (dur.years) return {
        unit: 'year',
        value: dur.years
    };
    return {
        unit: 'millisecond',
        value: 0
    };
}
// TODO: new util arrayify?
function removeExact(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function isArraysEqual(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const DAY_IDS = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat'
];
// Adding
function addWeeks(m, n) {
    let a = dateToUtcArray(m);
    a[2] += n * 7;
    return arrayToUtcDate(a);
}
function addDays(m, n) {
    let a = dateToUtcArray(m);
    a[2] += n;
    return arrayToUtcDate(a);
}
function addMs(m, n) {
    let a = dateToUtcArray(m);
    a[6] += n;
    return arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function diffWeeks(m0, m1) {
    return diffDays(m0, m1) / 7;
}
function diffDays(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function diffDayAndTime(m0, m1) {
    let m0day = startOfDay(m0);
    let m1day = startOfDay(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round(diffDays(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function diffWholeWeeks(m0, m1) {
    let d = diffWholeDays(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function diffWholeDays(m0, m1) {
    if (timeAsMs(m0) === timeAsMs(m1)) return Math.round(diffDays(m0, m1));
    return null;
}
// Start-Of
function startOfDay(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function startOfHour(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function startOfMinute(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function startOfSecond(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = arrayToUtcDate([
        year,
        0,
        1 + firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = startOfDay(marker);
    let days = Math.round(diffDays(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function isValidDate(m) {
    return !isNaN(m.valueOf());
}
function timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function buildIsoString(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) s = s.replace('T00:00:00Z', '');
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace('Z', '');
        else if (timeZoneOffset !== 0) s = s.replace('Z', formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function formatDayString(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
function formatIsoMonthStr(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function formatIsoTimeString(marker) {
    return padStart(marker.getUTCHours(), 2) + ':' + padStart(marker.getUTCMinutes(), 2) + ':' + padStart(marker.getUTCSeconds(), 2);
}
function formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? '-' : '+';
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + padStart(hours, 2)}:${padStart(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${padStart(mins, 2)}` : ''}`;
}
function memoize(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!isArraysEqual(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!isPropsEqual(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function memoizeArraylike(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function memoizeHashlike(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 9,
    omitZeroMinute: 9,
    meridiem: 9,
    omitCommas: 9
};
const STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const COMMA_RE = /,/g; // we need re for globalness
const MULTI_SPACE_RE = /\s+/g;
const LTR_RE = /\u200e/g; // control character
const UTC_RE = /UTC|GMT/;
class NativeFormatter {
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let smallestUnitNum = 9; // the smallest unit in the formatter (9 is a sentinel, beyond max)
        for(let name in formatSettings)if (name in EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            const severity = EXTENDED_SETTINGS_AND_SEVERITIES[name];
            if (severity < 9) smallestUnitNum = Math.min(EXTENDED_SETTINGS_AND_SEVERITIES[name], smallestUnitNum);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in STANDARD_DATE_PROP_SEVERITIES) smallestUnitNum = Math.min(STANDARD_DATE_PROP_SEVERITIES[name], smallestUnitNum);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.smallestUnitNum = smallestUnitNum;
        this.buildFormattingFunc = memoize(buildFormattingFunc);
    }
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps, extendedSettings } = this;
        let diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getSmallestUnit() {
        switch(this.smallestUnitNum){
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    }
}
function buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') return (date)=>formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = '2-digit';
        if (!standardDateProps.minute) standardDateProps.minute = '2-digit';
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') standardDateProps.timeZoneName = 'short';
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace(LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') s = injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace(COMMA_RE, '').trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace(MERIDIEM_RE, '').trim();
    else if (extendedSettings.meridiem === 'narrow') s = s.replace(MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === 'short') s = s.replace(MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === 'lowercase') s = s.replace(MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace(MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace(UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === 'long') parts.push(weekTextLong);
    else if (display === 'short' || display === 'narrow') parts.push(weekText);
    if (display === 'long' || display === 'short') parts.push(' ');
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') parts.reverse();
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if (timeAsMs(d0) !== timeAsMs(d1)) return 1;
    return 0;
}
function computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class CmdFormatter {
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
class FuncFormatter {
    constructor(func){
        this.func = func;
    }
    format(date, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
}
function createFormatter(input) {
    if (typeof input === 'object' && input) return new NativeFormatter(input);
    if (typeof input === 'string') return new CmdFormatter(input);
    if (typeof input === 'function') return new FuncFormatter(input);
    return null;
}
// base options
// ------------
const BASE_OPTION_REFINERS = {
    navLinkDayClick: identity,
    navLinkWeekClick: identity,
    duration: createDuration,
    bootstrapFontAwesome: identity,
    buttonIcons: identity,
    customButtons: identity,
    defaultAllDayEventDuration: createDuration,
    defaultTimedEventDuration: createDuration,
    nextDayThreshold: createDuration,
    scrollTime: createDuration,
    scrollTimeReset: Boolean,
    slotMinTime: createDuration,
    slotMaxTime: createDuration,
    dayPopoverFormat: createFormatter,
    slotDuration: createDuration,
    snapDuration: createDuration,
    headerToolbar: identity,
    footerToolbar: identity,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: createFormatter,
    dayHeaderClassNames: identity,
    dayHeaderContent: identity,
    dayHeaderDidMount: identity,
    dayHeaderWillUnmount: identity,
    dayCellClassNames: identity,
    dayCellContent: identity,
    dayCellDidMount: identity,
    dayCellWillUnmount: identity,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: identity,
    weekNumbers: Boolean,
    weekNumberClassNames: identity,
    weekNumberContent: identity,
    weekNumberDidMount: identity,
    weekNumberWillUnmount: identity,
    editable: Boolean,
    viewClassNames: identity,
    viewDidMount: identity,
    viewWillUnmount: identity,
    nowIndicator: Boolean,
    nowIndicatorSnap: identity,
    nowIndicatorClassNames: identity,
    nowIndicatorContent: identity,
    nowIndicatorDidMount: identity,
    nowIndicatorWillUnmount: identity,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: identity,
    locale: identity,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: identity,
    eventOrder: parseFieldSpecs,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: identity,
    contentHeight: identity,
    direction: String,
    weekNumberFormat: createFormatter,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: identity,
    initialDate: identity,
    now: identity,
    eventDataTransform: identity,
    stickyHeaderDates: identity,
    stickyFooterScrollbar: identity,
    viewHeight: identity,
    defaultAllDay: Boolean,
    eventSourceFailure: identity,
    eventSourceSuccess: identity,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: identity,
    eventConstraint: identity,
    eventAllow: identity,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: identity,
    eventContent: identity,
    eventDidMount: identity,
    eventWillUnmount: identity,
    selectConstraint: identity,
    selectOverlap: identity,
    selectAllow: identity,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: identity,
    slotLaneClassNames: identity,
    slotLaneContent: identity,
    slotLaneDidMount: identity,
    slotLaneWillUnmount: identity,
    slotLabelClassNames: identity,
    slotLabelContent: identity,
    slotLabelDidMount: identity,
    slotLabelWillUnmount: identity,
    dayMaxEvents: identity,
    dayMaxEventRows: identity,
    dayMinWidth: Number,
    slotLabelInterval: createDuration,
    allDayText: String,
    allDayClassNames: identity,
    allDayContent: identity,
    allDayDidMount: identity,
    allDayWillUnmount: identity,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: createFormatter,
    rerenderDelay: Number,
    moreLinkText: identity,
    moreLinkHint: identity,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: identity,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: createDuration,
    hiddenDays: identity,
    fixedWeekCount: Boolean,
    validRange: identity,
    visibleRange: identity,
    titleFormat: identity,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: identity,
    navLinkHint: identity,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: identity,
    moreLinkClassNames: identity,
    moreLinkContent: identity,
    moreLinkDidMount: identity,
    moreLinkWillUnmount: identity,
    monthStartFormat: createFormatter,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: identity,
    customRenderingMetaMap: identity,
    customRenderingReplaces: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const BASE_OPTION_DEFAULTS = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: 'long',
        day: 'numeric'
    },
    nowIndicatorSnap: 'auto'
};
// calendar listeners
// ------------------
const CALENDAR_LISTENER_REFINERS = {
    datesSet: identity,
    eventsSet: identity,
    eventAdd: identity,
    eventChange: identity,
    eventRemove: identity,
    windowResize: identity,
    eventClick: identity,
    eventMouseEnter: identity,
    eventMouseLeave: identity,
    select: identity,
    unselect: identity,
    loading: identity,
    // internal
    _unmount: identity,
    _beforeprint: identity,
    _afterprint: identity,
    _noEventDrop: identity,
    _noEventResize: identity,
    _resize: identity,
    _scrollRequest: identity
};
// calendar-specific options
// -------------------------
const CALENDAR_OPTION_REFINERS = {
    buttonText: identity,
    buttonHints: identity,
    views: identity,
    plugins: identity,
    initialEvents: identity,
    events: identity,
    eventSources: identity
};
const COMPLEX_OPTION_COMPARATORS = {
    headerToolbar: isMaybeObjectsEqual,
    footerToolbar: isMaybeObjectsEqual,
    buttonText: isMaybeObjectsEqual,
    buttonHints: isMaybeObjectsEqual,
    buttonIcons: isMaybeObjectsEqual,
    dateIncrement: isMaybeObjectsEqual,
    plugins: isMaybeArraysEqual,
    events: isMaybeArraysEqual,
    eventSources: isMaybeArraysEqual,
    ['resources']: isMaybeArraysEqual
};
function isMaybeObjectsEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) return isPropsEqual(a, b);
    return a === b;
}
function isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return isArraysEqual(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const VIEW_OPTION_REFINERS = {
    type: String,
    component: identity,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: identity,
    usesMinMaxTime: Boolean,
    classNames: identity,
    content: identity,
    didMount: identity,
    willUnmount: identity
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function mergeRawOptions(optionSets) {
    return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
}
function refineProps(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined,
        extra
    };
}
function identity(raw) {
    return raw;
}
const { hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === 'object' && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = mergeProps(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function filterHash(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function mapHash(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function arrayToHash(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function hashValuesToArray(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function isPropsEqual(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if (hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if (hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const HANDLER_RE = /^on[A-Z]/;
function isNonHandlerPropsEqual(obj0, obj1) {
    const keys = getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!HANDLER_RE.test(key)) return false;
    }
    return true;
}
function getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if (hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if (hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function compareObjs(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    // if (debug) {
    //   for (let key in newProps) {
    //     if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) {
    //       // equal
    //     } else {
    //       if (debug) {
    //         console.log('prop difference', key, oldProps[key], newProps[key])
    //       }
    //     }
    //   }
    //   // check for props that were omitted in the new
    //   for (let key in oldProps) {
    //     if (!(key in newProps)) {
    //       if (debug) {
    //         console.log('prop absent', key)
    //       }
    //     }
    //   }
    // }
    for(let key in newProps){
        if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function collectFromHash(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
let calendarSystemClassMap = {};
function registerCalendarSystem(name, theClass) {
    calendarSystemClassMap[name] = theClass;
}
function createCalendarSystem(name) {
    return new calendarSystemClassMap[name]();
}
class GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return dateToUtcArray(marker);
    }
}
registerCalendarSystem('gregory', GregorianCalendarSystem);
const ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function parse(str) {
    let m = ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if (isValidDate(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset
            };
        }
    }
    return null;
}
class DateEnv {
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === 'function') this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return arrayToUtcDate(dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === 'string') return this.parse(input);
        let marker = null;
        if (typeof input === 'number') marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = arrayToUtcDate(input);
        if (marker === null || !isValidDate(marker)) return null;
        return {
            marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = parse(s);
        if (parts === null) return null;
        let { marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem } = this;
        if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem } = this;
        if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: 'year',
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: 'month',
            value: n
        };
        n = diffWholeWeeks(m0, m1);
        if (n !== null) return {
            unit: 'week',
            value: n
        };
        n = diffWholeDays(m0, m1);
        if (n !== null) return {
            unit: 'day',
            value: n
        };
        n = diffHours(m0, m1);
        if (isInt(n)) return {
            unit: 'hour',
            value: n
        };
        n = diffMinutes(m0, m1);
        if (isInt(n)) return {
            unit: 'minute',
            value: n
        };
        n = diffSeconds(m0, m1);
        if (isInt(n)) return {
            unit: 'second',
            value: n
        };
        return {
            unit: 'millisecond',
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / asRoughMonths(d);
        }
        if (d.days) {
            diff = diffWholeDays(m0, m1);
            if (diff !== null) return diff / asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === 'year') return this.startOfYear(m);
        if (unit === 'month') return this.startOfMonth(m);
        if (unit === 'week') return this.startOfWeek(m);
        if (unit === 'day') return startOfDay(m);
        if (unit === 'hour') return startOfHour(m);
        if (unit === 'minute') return startOfMinute(m);
        if (unit === 'second') return startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = addMs(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === 'local') return arrayToUtcDate(dateToLocalArray(new Date(ms)));
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) return new Date(ms);
        return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === 'local') return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === 'UTC') return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === 'local') return arrayToLocalDate(dateToUtcArray(m));
        if (this.timeZone === 'UTC') return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 60000);
    }
}
class Theme {
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || '';
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return '';
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return '';
    }
}
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function flushSync(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = _preact.options.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    _preact.options.debounceRendering = execCallbackSync;
    _preact.render(_preact.createElement(FakeComponent, {}), document.createElement('div'));
    while(callbackQ.length)callbackQ.shift()();
    _preact.options.debounceRendering = oldDebounceRendering;
}
class FakeComponent extends _preact.Component {
    render() {
        return _preact.createElement('div', {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function createContext(defaultValue) {
    let ContextType = _preact.createContext(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class ScrollResponder {
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    detach() {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
}
const ViewContextType = createContext({}); // for Components
function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, nowManager, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv,
        nowManager,
        options: viewOptions,
        pluginHooks,
        emitter,
        dispatch,
        getCurrentData,
        calendarApi,
        viewSpec,
        viewApi,
        dateProfileGenerator,
        theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder (execFunc) {
            return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent,
        unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class PureComponent extends (0, _preact.Component) {
    // debug: boolean
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !compareObjs(this.props, nextProps, this.propEquality /*, this.debug */ ) || !compareObjs(this.state, nextState, this.stateEquality /*, this.debug */ );
        // if (this.debug && shouldUpdate) {
        //   console.log('shouldUpdate!')
        // }
        return shouldUpdate;
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!compareObjs(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
PureComponent.addPropsEquality = addPropsEquality;
PureComponent.addStateEquality = addStateEquality;
PureComponent.contextType = ViewContextType;
PureComponent.prototype.propEquality = {};
PureComponent.prototype.stateEquality = {};
class BaseComponent extends PureComponent {
}
BaseComponent.contextType = ViewContextType;
function addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function setRef(ref, current) {
    if (typeof ref === 'function') ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
class ContentInjector extends BaseComponent {
    constructor(){
        super(...arguments);
        this.id = guid();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            const { options } = this.context;
            const { generatorName } = this.props;
            if (!options.customRenderingReplaces || !hasCustomRenderingHandler(generatorName, options)) this.updateElRef(el);
        };
        this.updateElRef = (el)=>{
            if (this.props.elRef) setRef(this.props.elRef, el);
        };
    }
    render() {
        const { props, context } = this;
        const { options } = context;
        const { customGenerator, defaultGenerator, renderProps } = props;
        const attrs = buildElAttrs(props, [], this.handleEl);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, (0, _preact.createElement)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === 'object'; // non-null
                if (isObject && 'html' in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && 'domNodes' in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (isObject ? (0, _preact.isValidElement)(customGeneratorRes) // vdom node
                 : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
                ) // use in vdom
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, _preact.createElement)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props, context } = this;
        const { handleCustomRendering, customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive,
                containerEl: this.base,
                reportNewContainerEl: this.updateElRef,
                generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter(isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes, currentDomNodes } = this;
        const el = this.base;
        if (!isArraysEqual(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach(removeElement);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
}
ContentInjector.addPropsEquality({
    elClasses: isArraysEqual,
    elStyle: isPropsEqual,
    elAttrs: isNonHandlerPropsEqual,
    renderProps: isPropsEqual
});
// Util
/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/ function hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function buildElAttrs(props, extraClassNames, elRef) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function isTruthy(val) {
    return Boolean(val);
}
const RenderId = createContext(0);
class ContentContainer extends (0, _preact.Component) {
    constructor(){
        super(...arguments);
        this.InnerContent = InnerContentInjector.bind(undefined, this);
        this.handleEl = (el)=>{
            this.el = el;
            if (this.props.elRef) {
                setRef(this.props.elRef, el);
                if (el && this.didMountMisfire) this.componentDidMount();
            }
        };
    }
    render() {
        const { props } = this;
        const generatedClassNames = generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = buildElAttrs(props, generatedClassNames, this.handleEl);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, _preact.createElement)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, _preact.createElement)(ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleEl,
            elTag: props.elTag || 'div',
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        if (this.el) (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
        else this.didMountMisfire = true;
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.el
        }));
    }
}
ContentContainer.contextType = RenderId;
function InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, _preact.createElement)(ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === 'string' ? [
        classNames
    ] : classNames;
}
class ViewContainer extends BaseComponent {
    render() {
        let { props, context } = this;
        let { options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, _preact.createElement)(ContentContainer, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: [
                ...buildViewClassNames(props.viewSpec),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }, ()=>props.children);
    }
}
function buildViewClassNames(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        'fc-view'
    ];
}
function parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start,
        end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort(compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function intersectRanges(range0, range1) {
    let { start, end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start,
        end
    };
    return newRange;
}
function rangesEqual(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function rangesIntersect(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function rangeContainsRange(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function rangeContainsMarker(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
    let start = startOfDay(timedRange.start);
    let end = addDays(start, dayCnt);
    return {
        start,
        end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function computeVisibleDayRange(timedRange, nextDayThreshold = createDuration(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = startOfDay(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) endDay = addDays(endDay, 1);
    }
    if (timedRange.start) {
        startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = addDays(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function isMultiDayRange(range) {
    let visibleRange = computeVisibleDayRange(range);
    return diffDays(visibleRange.start, visibleRange.end) > 1;
}
function diffDates(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') return createDuration(dateEnv.diffWholeYears(date0, date1), 'year');
    if (largeUnit === 'month') return createDuration(dateEnv.diffWholeMonths(date0, date1), 'month');
    return diffDayAndTime(date0, date1); // returns a duration
}
class DateProfileGenerator {
    constructor(props){
        this.props = props;
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = intersectRanges(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = intersectRanges(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = rangesIntersect(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!rangeContainsMarker(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate,
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = greatestDurationDenominator(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration,
            unit,
            range
        };
    }
    getFallbackDuration() {
        return createDuration({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv, usesMinMaxTime, slotMinTime, slotMaxTime } = this.props;
        let { start, end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if (asRoughDays(slotMinTime) < 0) {
                start = startOfDay(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if (asRoughDays(slotMaxTime) > 1) {
                end = startOfDay(end); // necessary?
                end = addDays(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start,
            end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv, dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if (asRoughMs(dateIncrement) < asRoughMs(duration)) dateAlignment = greatestDurationDenominator(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if (asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = startOfDay(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start,
                end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv, dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = startOfDay(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = addDays(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start,
            end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return createDuration(1, customAlignment);
        if (fallback) return fallback;
        return createDuration({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = parseRange(rangeInput, this.props.dateEnv);
            if (range) range = computeVisibleDayRange(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start, end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start,
            end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = addDays(date, inc);
        return date;
    }
}
function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: guid(),
        defId,
        range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function expandRecurring(eventStore, framingRange, context) {
    let { dateEnv, pluginHooks, options } = context;
    let { defs, instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = filterHash(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = createEventInstance(defId, {
                    start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs,
        instances
    };
}
/*
Event MUST have a recurringDef
*/ function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map(startOfDay);
    return markers;
}
const EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const EVENT_DATE_REFINERS = {
    start: identity,
    end: identity,
    date: identity,
    allDay: Boolean
};
const EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), {
    extendedProps: identity
});
function parseEvent(raw, eventSource, context, allowOpenRange, refiners = buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined, extra } = refineEventDef(raw, context, refiners);
    let defaultAllDay = computeIsDefaultAllDay(eventSource, context);
    let recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def,
            instance: null
        };
    }
    let singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = createEventInstance(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def,
            instance
        };
    }
    return null;
}
function refineEventDef(raw, context, refiners = buildEventRefiners(context)) {
    return refineProps(raw, refiners);
}
function buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || guid(),
        sourceId,
        allDay,
        hasEnd,
        interactive: refined.interactive,
        ui: createEventUi(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = startOfDay(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = startOfDay(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay,
        hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
function parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = createEmptyEventStore();
    let eventRefiners = buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) eventTupleToStore(tuple, eventStore);
    }
    return eventStore;
}
function eventTupleToStore(tuple, eventStore = createEmptyEventStore()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function getRelevantEvents(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = filterEventStoreDefs(eventStore, (lookDef)=>isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return createEmptyEventStore();
}
function isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function createEmptyEventStore() {
    return {
        defs: {},
        instances: {}
    };
}
function mergeEventStores(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function filterEventStoreDefs(eventStore, filterFunc) {
    let defs = filterHash(eventStore.defs, filterFunc);
    let instances = filterHash(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs,
        instances
    };
}
function excludeSubEventStore(master, sub) {
    let { defs, instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function normalizeConstraint(input, context) {
    if (Array.isArray(input)) return parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === 'object' && input) return parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function parseClassNames(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: identity,
    overlap: identity,
    allow: identity,
    className: parseClassNames,
    classNames: parseClassNames,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: []
};
function createEventUi(refined, context) {
    let constraint = normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function combineEventUis(uis) {
    return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
}
function combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: identity,
    eventDataTransform: identity,
    // for any network-related sources
    success: identity,
    failure: identity
};
function parseEventSource(raw, context, refiners = buildEventSourceRefiners(context)) {
    let rawObj;
    if (typeof raw === 'string') rawObj = {
        url: raw
    };
    else if (typeof raw === 'function' || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === 'object' && raw) rawObj = raw;
    if (rawObj) {
        let { refined, extra } = refineProps(rawObj, refiners);
        let metaRes = buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: '',
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || '',
            sourceId: guid(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: createEventUi(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function buildEventSourceRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta
        };
    }
    return null;
}
function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case 'RECEIVE_EVENTS':
            return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'RESET_RAW_EVENTS':
            return resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case 'ADD_EVENTS':
            return addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS':
            return mergeEventStores(eventStore, action.eventStore);
        case 'PREV':
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) return expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case 'REMOVE_EVENTS':
            return excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case 'REMOVE_ALL_EVENTS':
            return createEmptyEventStore();
        default:
            return eventStore;
    }
}
function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = expandRecurring(subset, fetchRange, context);
        return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap, instanceIdMap } = buildPublicIdMaps(existingEventStore);
    let newEventStore = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return expandRecurring(newEventStore, activeRange, context);
}
function transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = expandRecurring(subset, expandRange, context);
    return mergeEventStores(eventStore, subset);
}
function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
    let { defs } = eventStore;
    let instances = mapHash(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs,
        instances
    };
}
function excludeEventsBySourceId(eventStore, sourceId) {
    return filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: filterHash(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function buildPublicIdMaps(eventStore) {
    const { defs, instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap,
        instanceIdMap
    };
}
class Emitter {
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
}
function addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
const DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours'
};
/*
TODO: pass around as EventDefHash!!!
*/ function parseBusinessHours(input, context) {
    return parseEvents(refineInputs(input), null, context);
}
function refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === 'object' && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, DEF_DEFAULTS), rawDef));
    return rawDefs;
}
function triggerDateSelect(selection, pev, context) {
    context.emitter.trigger('select', Object.assign(Object.assign({}, buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function getDefaultEventEnd(allDay, marker, context) {
    let { dateEnv, options } = context;
    let end = marker;
    if (allDay) {
        end = startOfDay(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
    let dest = createEmptyEventStore();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: startOfDay(copy.range.start),
        end: startOfDay(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
    return copy;
}
class EventSourceImpl {
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    remove() {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
}
class EventImpl {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in EVENT_DATE_REFINERS) console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
        else if (name === 'id') {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in EVENT_NON_DATE_REFINERS) {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in EVENT_UI_REFINERS) {
            let ui = EVENT_UI_REFINERS[name](val);
            if (name === 'color') ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === 'editable') ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = computeAlignedDayRange(instanceRange);
            let startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);
                if (durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps
                });
                else this.mutate({
                    startDelta,
                    endDelta,
                    standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = createDuration(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = createDuration(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = createDuration(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay
        };
        let { maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv } = this._context;
        let instance = this._instance;
        let formatter = createFormatter(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore } = context.getCurrentData();
            let relevantEvents = getRelevantEvents(eventStore, instance.instanceId);
            let eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: []
                }
            };
            relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new EventImpl(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents
            });
            context.emitter.trigger('eventChange', {
                oldEvent,
                event: this,
                relatedEvents: buildEventApis(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId } = this._def;
        if (sourceId) return new EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return '';
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return '';
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || 'auto';
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui } = def;
        let { startStr, endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== 'auto') res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
}
function eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function buildEventApis(eventStore, context, excludeInstance) {
    let { defs, instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new EventImpl(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? computeVisibleDayRange(origRange, nextDayThreshold) : origRange;
        let slicedRange = intersectRanges(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== 'none') (ui.display === 'background' ? bgRanges : fgRanges).push({
                def,
                ui,
                instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def,
                ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function hasBgRendering(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function setElSeg(el, seg) {
    el.fcSeg = seg;
}
function getElSeg(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function compileEventUis(eventDefs, eventUiBases) {
    return mapHash(eventDefs, (eventDef)=>compileEventUi(eventDef, eventUiBases));
}
function compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases['']) uis.push(eventUiBases['']);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return combineEventUis(uis);
}
function sortEventSegs(segs, eventOrderSpecs) {
    let objs = segs.map(buildSegCompareObj);
    objs.sort((obj0, obj1)=>compareByFieldSpecs(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function buildSegCompareObj(seg) {
    let { eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start,
        end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function computeSegDraggable(seg, context) {
    let { pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def, ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv, options } = context;
    let { displayEventTime, displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
    let isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return '';
}
function getSegMeta(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end <= (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && rangeContainsMarker(todayRange, segRange.start)
    };
}
function getEventClassNames(props) {
    let classNames = [
        'fc-event'
    ];
    if (props.isMirror) classNames.push('fc-event-mirror');
    if (props.isDraggable) classNames.push('fc-event-draggable');
    if (props.isStartResizable || props.isEndResizable) classNames.push('fc-event-resizable');
    if (props.isDragging) classNames.push('fc-event-dragging');
    if (props.isResizing) classNames.push('fc-event-resizing');
    if (props.isSelected) classNames.push('fc-event-selected');
    if (props.isStart) classNames.push('fc-event-start');
    if (props.isEnd) classNames.push('fc-event-end');
    if (props.isPast) classNames.push('fc-event-past');
    if (props.isToday) classNames.push('fc-event-today');
    if (props.isFuture) classNames.push('fc-event-future');
    return classNames;
}
function buildEventRangeKey(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function getSegAnchorAttrs(seg, context) {
    let { def, instance } = seg.eventRange;
    let { url } = def;
    if (url) return {
        href: url
    };
    let { emitter, options } = context;
    let { eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return createAriaKeyboardAttrs((ev)=>{
        emitter.trigger('eventClick', {
            el: ev.target,
            event: new EventImpl(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const STANDARD_PROPS = {
    start: identity,
    end: identity,
    allDay: Boolean
};
function parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = parseOpenDateSpan(raw, dateEnv);
    let { range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra } = refineProps(raw, STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay
    }, extra);
}
function isDateSpansEqual(span0, span1) {
    return rangesEqual(span0.range, span1.range) && span0.allDay === span1.allDay && isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== 'range' && propName !== 'allDay') {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime
        })
    };
}
function fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = refineEventDef({
        editable: false
    }, context);
    let def = parseEventDef(res.refined, res.extra, '', dateSpan.allDay, true, context);
    return {
        def,
        ui: compileEventUi(def, eventUiBases),
        instance: createEventInstance(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function unpromisify(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') res.then(wrappedSuccess, wrappedFailure);
}
class JsonRequestError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function requestJson(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method
    };
    if (method === 'GET') url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new JsonRequestError('Failure parsing JSON', fetchRes);
        });
        else throw new JsonRequestError('Request failed', fetchRes);
    });
}
let canVGrowWithinCell;
function getCanVGrowWithinCell() {
    if (canVGrowWithinCell == null) canVGrowWithinCell = computeCanVGrowWithinCell();
    return canVGrowWithinCell;
}
function computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') return true;
    let el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    let div = el.querySelector('div');
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
class CalendarRoot extends BaseComponent {
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            flushSync(()=>{
                this.setState({
                    forPrint: true
                });
            });
        };
        this.handleAfterPrint = ()=>{
            flushSync(()=>{
                this.setState({
                    forPrint: false
                });
            });
        };
    }
    render() {
        let { props } = this;
        let { options } = props;
        let { forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        let height = !isHeightAuto && options.height != null ? options.height : '';
        let classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            `fc-direction-${options.direction}`,
            props.theme.getClass('root')
        ];
        if (!getCanVGrowWithinCell()) classNames.push('fc-liquid-hack');
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter } = this.props;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter } = this.props;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    }
}
class Interaction {
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    destroy() {}
}
function parseInteractionSettings(component, input) {
    return {
        component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function interactionSettingsToStore(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const interactionSettingsStore = {};
class NowTimer extends (0, _preact.Component) {
    constructor(props, context){
        super(props, context);
        this.handleRefresh = ()=>{
            let timing = this.computeTiming();
            if (timing.state.nowDate.valueOf() !== this.state.nowDate.valueOf()) this.setState(timing.state);
            this.clearTimeout();
            this.setTimeout(timing.waitMs);
        };
        this.handleVisibilityChange = ()=>{
            if (!document.hidden) this.handleRefresh();
        };
        this.state = this.computeTiming().state;
    }
    render() {
        let { props, state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
        this.context.nowManager.addResetListener(this.handleRefresh);
        // fired tab becomes visible after being hidden
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
        this.context.nowManager.removeResetListener(this.handleRefresh);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    computeTiming() {
        let { props, context } = this;
        let unroundedNow = context.nowManager.getDateMarker();
        let { nowIndicatorSnap } = context.options;
        if (nowIndicatorSnap === 'auto') nowIndicatorSnap = // large unit?
        /year|month|week|day/.test(props.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
        (props.unitValue || 1) === 1;
        let nowDate;
        let waitMs;
        if (nowIndicatorSnap) {
            nowDate = context.dateEnv.startOf(unroundedNow, props.unit); // aka currentUnitStart
            let nextUnitStart = context.dateEnv.add(nowDate, createDuration(1, props.unit));
            waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        } else {
            nowDate = unroundedNow;
            waitMs = 60000; // 1 minute
        }
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            state: {
                nowDate,
                todayRange: buildDayRange(nowDate)
            },
            waitMs
        };
    }
    setTimeout(waitMs = this.computeTiming().waitMs) {
        // NOTE: timeout could take longer than expected if tab sleeps,
        // which is why we listen to 'visibilitychange'
        this.timeoutId = setTimeout(()=>{
            // NOTE: timeout could also return *earlier* than expected, and we need to wait 2 ms more
            // This is why use use same waitMs from computeTiming, so we don't skip an interval while
            // .setState() is executing
            const timing = this.computeTiming();
            this.setState(timing.state, ()=>{
                this.setTimeout(timing.waitMs);
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
NowTimer.contextType = ViewContextType;
function buildDayRange(date) {
    let start = startOfDay(date);
    let end = addDays(start, 1);
    return {
        start,
        end
    };
}
class CalendarImpl {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger('_resize', true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType
                    });
                    this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: spec.type,
            dateMarker
        });
        else this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs, toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: 'PREV'
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: 'NEXT'
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.nowManager.getDateMarker()
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = createDuration(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: 'SELECT_DATES',
                selection
            });
            triggerDateSelect(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: 'UNSELECT_DATES'
            });
            triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof EventImpl) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: eventTupleToStore({
                        def,
                        instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) [eventSource] = hashValuesToArray(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new EventImpl(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: eventTupleToStore(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter } = this.getCurrentData();
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs, instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new EventImpl(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new EventImpl(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return buildEventApis(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENTS'
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = parseEventSource(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: 'ADD_EVENT_SOURCES',
                sources: [
                    eventSource
                ]
            });
            return new EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: 'REMOVE_ALL_EVENT_SOURCES'
        });
    }
    refetchEvents() {
        this.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = createDuration(timeInput);
        if (time) this.trigger('_scrollRequest', {
            time
        });
    }
}
function pointInsideRect(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function translateRect(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
const EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere
class Splitter {
    constructor(){
        this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
        this.splitDateSelection = memoize(this._splitDateSpan);
        this.splitEventStore = memoize(this._splitEventStore);
        this.splitIndividualUi = memoize(this._splitIndividualUi);
        this.splitEventDrag = memoize(this._splitInteraction);
        this.splitEventResize = memoize(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = mapHash(keyInfos, (info, key)=>this.eventUiBuilders[key] || memoize(buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return mapHash(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs, instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = createEmptyEventStore();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
}
function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        '': combineEventUis(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function getDateMeta(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && (!dateProfile.activeRange || !rangeContainsMarker(dateProfile.activeRange, date))),
        isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function getDayClassNames(meta, theme) {
    let classNames = [
        'fc-day',
        `fc-day-${DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-day-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-day-past');
        if (meta.isFuture) classNames.push('fc-day-future');
        if (meta.isOther) classNames.push('fc-day-other');
    }
    return classNames;
}
function getSlotClassNames(meta, theme) {
    let classNames = [
        'fc-slot',
        `fc-slot-${DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push('fc-slot-disabled');
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) classNames.push('fc-slot-past');
        if (meta.isFuture) classNames.push('fc-slot-future');
    }
    return classNames;
}
const DAY_FORMAT = createFormatter({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
});
const WEEK_FORMAT = createFormatter({
    week: 'long'
});
function buildNavLinkAttrs(context, dateMarker, viewType = 'day', isTabbable = true) {
    const { dateEnv, options, calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === 'week' ? WEEK_FORMAT : DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === 'string') viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: formatWithOrdinals(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            'data-navlink': ''
        }, isTabbable ? createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        'aria-label': dateStr
    };
}
let _isRtlScrollbarOnLeft = null;
function getIsRtlScrollbarOnLeft() {
    if (_isRtlScrollbarOnLeft === null) _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
    return _isRtlScrollbarOnLeft;
}
function computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement('div');
    applyStyle(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    removeElement(outerEl);
    return res;
}
let _scrollbarWidths;
function getScrollbarWidths() {
    if (!_scrollbarWidths) _scrollbarWidths = computeScrollbarWidths();
    return _scrollbarWidths;
}
function computeScrollbarWidths() {
    let el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    let res = computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function computeEdges(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft,
        borderRight,
        borderTop,
        borderBottom,
        scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if (getIsRtlScrollbarOnLeft() && computedStyle.direction === 'rtl') res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function computeInnerRect(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
    let edges = computeEdges(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function computeRect(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY
    };
}
function computeClippedClientRect(el) {
    let clippingParents = getClippingParents(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = intersectRects(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function getClippingParents(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class PositionCache {
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts, rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops, bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return similarNumArrays(this.tops || [], otherCache.tops || []) && similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && similarNumArrays(this.lefts || [], otherCache.lefts || []) && similarNumArrays(this.rights || [], otherCache.rights || []);
    }
}
function similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class ScrollController {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class ElementScrollController extends ScrollController {
    constructor(el){
        super();
        this.el = el;
    }
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
}
class WindowScrollController extends ScrollController {
    getScrollTop() {
        return window.scrollY;
    }
    getScrollLeft() {
        return window.scrollX;
    }
    setScrollTop(n) {
        window.scroll(window.scrollX, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.scrollY);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class DateComponent extends BaseComponent {
    constructor(){
        super(...arguments);
        this.uid = guid();
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !elementClosest(el, '.fc-event-mirror');
    }
    isValidDateDownEl(el) {
        return !elementClosest(el, '.fc-event:not(.fc-bg-event)') && !elementClosest(el, '.fc-more-link') && // a "more.." link
        !elementClosest(el, 'a[data-navlink]') && // a clickable nav link
        !elementClosest(el, '.fc-popover'); // hack
    }
}
class NamedTimeZoneImpl {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class SegHierarchy {
    constructor(getEntryThickness = (entry)=>{
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return entry.thickness || 1;
    }){
        this.getEntryThickness = getEntryThickness;
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) this.insertEntryAt(entry, insertion);
        else this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            const hiddenEntry = Object.assign(Object.assign({}, entry), {
                span: intersectSpans(entry.span, insertion.touchingEntry.span)
            });
            hiddenEntries.push(hiddenEntry);
            this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        } else hiddenEntries.push(entry);
    }
    /*
    Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
    */ splitEntry(entry, barrier, hiddenEntries) {
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, hiddenEntries);
        if (entrySpan.end > barrierSpan.end) this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, hiddenEntries);
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel, levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            insertAt(levelCoords, insertion.level, insertion.levelCoord);
            insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
    }
    /*
    does not care about limits
    */ findInsertion(newEntry) {
        let { levelCoords, entriesByLevel, strictOrder, stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            const trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry);
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
        return {
            touchingLevel,
            touchingLateral,
            touchingEntry,
            stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel, levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                thickness: this.getEntryThickness(entry),
                levelCoord
            }));
        }
        return rects;
    }
}
function getEntrySpanEnd(entry) {
    return entry.span.end;
}
function buildEntryKey(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function groupIntersectingEntries(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if (intersectSpans(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function intersectSpans(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start,
        end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function binarySearch(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class ElementDragging {
    constructor(el, selector){
        this.emitter = new Emitter();
    }
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const config = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const DRAG_META_REFINERS = {
    startTime: createDuration,
    duration: createDuration,
    create: Boolean,
    sourceId: String
};
function parseDragMeta(raw) {
    let { refined, extra } = refineProps(raw, DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return createFormatter({
        weekday: 'short'
    }); // "Sat"
    if (dayCnt > 1) return createFormatter({
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
    }); // "Sat 11/12"
    return createFormatter({
        weekday: 'long'
    }); // "Saturday"
}
const CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function renderInner$1(renderProps) {
    return renderProps.text;
}
// BAD name for this class now. used in the Header
class TableDateCell extends BaseComponent {
    render() {
        let { dateEnv, options, theme, viewApi } = this.context;
        let { props } = this;
        let { date, dateProfile } = props;
        let dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
        let classNames = [
            CLASS_NAME
        ].concat(getDayClassNames(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? buildNavLinkAttrs(this.context, date) : {};
        let publicDate = dateEnv.toDate(date);
        // workaround for Luxon (and maybe moment) returning prior-days when start-of-day
        // in DST gap: https://github.com/fullcalendar/fullcalendar/issues/7633
        if (dateEnv.namedTimeZoneImpl) publicDate = addMs(publicDate, 3600000); // add an hour
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: publicDate,
            view: viewApi
        }, props.extraRenderProps), {
            text
        }), dayMeta);
        return (0, _preact.createElement)(ContentContainer, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan,
                'data-date': !dayMeta.isDisabled ? formatDayString(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, _preact.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, _preact.createElement)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ]
            })));
    }
}
const WEEKDAY_FORMAT = createFormatter({
    weekday: 'long'
});
class TableDowCell extends BaseComponent {
    render() {
        let { props } = this;
        let { dateEnv, theme, viewApi, options } = this.context;
        let date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text
        });
        return (0, _preact.createElement)(ContentContainer, {
            elTag: "th",
            elClasses: [
                CLASS_NAME,
                ...getDayClassNames(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: 'columnheader',
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, _preact.createElement)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, _preact.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-col-header-cell-cushion',
                    props.isSticky && 'fc-sticky'
                ],
                elAttrs: {
                    'aria-label': dateEnv.format(date, WEEKDAY_FORMAT)
                }
            })));
    }
}
class DayHeader extends BaseComponent {
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
    }
    render() {
        let { context } = this;
        let { dates, dateProfile, datesRepDistinctDays, renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, _preact.createElement)(NowTimer, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, _preact.createElement)("tr", {
                role: "row"
            }, renderIntro && renderIntro('day'), dates.map((date)=>datesRepDistinctDays ? (0, _preact.createElement)(TableDateCell, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, _preact.createElement)(TableDowCell, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
}
function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
}
class DaySeriesModel {
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = addDays(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices } = this;
        let dayOffset = Math.floor(diffDays(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
}
class DayTableModel {
    constructor(daySeries, breakOnWeeks){
        let { dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex, lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
}
class Slicer {
    constructor(){
        this.sliceBusinessHours = memoize(this._sliceBusinessHours);
        this.sliceDateSelection = memoize(this._sliceDateSpan);
        this.sliceEventStore = memoize(this._sliceEventStore);
        this.sliceEventDrag = memoize(this._sliceInteraction);
        this.sliceEventResize = memoize(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: addMs(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore(expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = intersectRanges(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') dateRange = {
            start: dateRange.start,
            end: addDays(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
        end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionValid(interaction, dateProfile, context) {
    let { instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function isDateSelectionValid(dateSelection, dateProfile, context) {
    if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) return false;
    return isNewPropsValid({
        dateSelection
    }, context);
}
function isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: '',
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: '',
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
}
function isPropsValid(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        '': currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = mapHash(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if (rangesIntersect(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new EventImpl(context, otherDefs[otherInstance.defId], otherInstance), new EventImpl(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new EventImpl(context, origDef, origInstance);
            else eventApi = new EventImpl(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if (rangesIntersect(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new EventImpl(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === 'businessHours') return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === 'string') return eventStoreToRanges(filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === 'object' && constraint) return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function eventStoreToRanges(eventStore) {
    let { instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if (rangeContainsRange(outerRange, innerRange)) return true;
    }
    return false;
}
const VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class Scroller extends BaseComponent {
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            setRef(this.props.elRef, el);
        };
    }
    render() {
        let { props } = this;
        let { liquid, liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            'fc-scroller'
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push('fc-scroller-liquid-absolute');
            else className.push('fc-scroller-liquid');
        }
        return (0, _preact.createElement)("div", {
            ref: this.handleEl,
            className: className.join(' '),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || '',
                right: isAbsolute && -(props.overcomeRight || 0) || '',
                bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
                maxHeight: props.maxHeight || ''
            }
        }, props.children);
    }
    needsXScrolling() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class RefMap {
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths, currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return collectFromHash(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return hashValuesToArray(this.currentMap);
    }
}
function computeShrinkWidth(chunkEls) {
    let shrinkCells = findElements(chunkEls, '.fc-scrollgrid-shrink');
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function getSectionHasLiquidHeight(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function getAllowYScrolling(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function renderChunkContent(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows } = arg;
    let content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : (0, _preact.createElement)('table', {
        role: 'presentation',
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''
        ].join(' '),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ''
        }
    }, arg.tableColGroupNode, (0, _preact.createElement)(isHeader ? 'thead' : 'tbody', {
        role: 'presentation'
    }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function isColPropsEqual(cols0, cols1) {
    return isArraysEqual(cols0, cols1, isPropsEqual);
}
function renderMicroColGroup(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, _preact.createElement)("col", {
            style: {
                width: colProps.width === 'shrink' ? sanitizeShrinkWidth(shrinkWidth) : colProps.width || '',
                minWidth: colProps.minWidth || ''
            }
        }));
    }
    return (0, _preact.createElement)('colgroup', {}, ...colNodes);
}
function sanitizeShrinkWidth(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function hasShrinkWidth(cols) {
    for (let col of cols){
        if (col.width === 'shrink') return true;
    }
    return false;
}
function getScrollGridClassNames(liquid, context) {
    let classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table')
    ];
    if (liquid) classNames.push('fc-scrollgrid-liquid');
    return classNames;
}
function getSectionClassNames(sectionConfig, wholeTableVGrow) {
    let classNames = [
        'fc-scrollgrid-section',
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push('fc-scrollgrid-section-liquid');
    if (sectionConfig.isSticky) classNames.push('fc-scrollgrid-section-sticky');
    return classNames;
}
function renderScrollShim(arg) {
    return (0, _preact.createElement)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function getStickyHeaderDates(options) {
    let { stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyHeaderDates;
}
function getStickyFooterScrollbar(options) {
    let { stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    return stickyFooterScrollbar;
}
class SimpleScrollGrid extends BaseComponent {
    constructor(){
        super(...arguments);
        this.processCols = memoize((a)=>a, isColPropsEqual); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = memoize(renderMicroColGroup);
        this.scrollerRefs = new RefMap();
        this.scrollerElRefs = new RefMap(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
    render() {
        let { props, state, context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = getScrollGridClassNames(props.liquid, context);
        if (props.collapsibleWidth) classNames.push('fc-scrollgrid-collapsible');
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header'){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body'){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer'){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !getCanVGrowWithinCell();
        const roleAttrs = {
            role: 'rowgroup'
        };
        return (0, _preact.createElement)('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, _preact.createElement)('thead', roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, _preact.createElement)('tbody', roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, _preact.createElement)('tfoot', roleAttrs, ...footSectionNodes), isBuggy && (0, _preact.createElement)('tbody', roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) return (0, _preact.createElement)((0, _preact.Fragment), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, _preact.createElement)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: getSectionClassNames(sectionConfig, this.props.liquid).join(' ')
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) return chunkConfig.outerContent;
        let { props } = this;
        let { forceYScrollbars, scrollerClientWidths, scrollerClientHeights } = this.state;
        let needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = getSectionHasLiquidHeight(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
        let sectionKey = sectionConfig.key;
        let content = renderChunkContent(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, _preact.createElement)(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation'
        }, (0, _preact.createElement)("div", {
            className: `fc-scroller-harness${isLiquid ? ' fc-scroller-harness-liquid' : ''}`
        }, (0, _preact.createElement)(Scroller, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = getSectionByKey(this.props.sections, key);
        if (section) setRef(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return hasShrinkWidth(this.props.cols) ? computeShrinkWidth(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = getScrollbarWidths();
        let { scrollerRefs, scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars,
            scrollerClientWidths,
            scrollerClientHeights
        };
    }
}
SimpleScrollGrid.addStateEquality({
    scrollerClientWidths: isPropsEqual,
    scrollerClientHeights: isPropsEqual
});
function getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class EventContainer extends BaseComponent {
    constructor(){
        super(...arguments);
        // memo
        this.buildPublicEvent = memoize((context, eventDef, eventInstance)=>new EventImpl(context, eventDef, eventInstance));
        this.handleEl = (el)=>{
            this.el = el;
            setRef(this.props.elRef, el);
            if (el) setElSeg(el, this.props.seg);
        };
    }
    render() {
        const { props, context } = this;
        const { options } = context;
        const { seg } = props;
        const { eventRange } = seg;
        const { ui } = eventRange;
        const renderProps = {
            event: this.buildPublicEvent(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, _preact.createElement)(ContentContainer, {
            elRef: this.handleEl,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: [
                ...getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }, props.children);
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) setElSeg(this.el, this.props.seg);
    }
}
// should not be a purecomponent
class StandardEvent extends BaseComponent {
    render() {
        let { props, context } = this;
        let { options } = context;
        let { seg } = props;
        let { ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, _preact.createElement)(EventContainer, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: getSegAnchorAttrs(seg, context),
            defaultGenerator: renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, _preact.createElement)((0, _preact.Fragment), null, (0, _preact.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-event-main'
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, _preact.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, _preact.createElement)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
StandardEvent.addPropsEquality({
    seg: isPropsEqual
});
function renderInnerContent$1(innerProps) {
    return (0, _preact.createElement)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, _preact.createElement)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, _preact.createElement)("div", {
        className: "fc-event-title-container"
    }, (0, _preact.createElement)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, _preact.createElement)((0, _preact.Fragment), null, "\u00A0"))));
}
const NowIndicatorContainer = (props)=>(0, _preact.createElement)(ViewContextType.Consumer, null, (context)=>{
        let { options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, _preact.createElement)(ContentContainer, {
            elRef: props.elRef,
            elTag: props.elTag || 'div',
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }, props.children);
    });
const DAY_NUM_FORMAT = createFormatter({
    day: 'numeric'
});
class DayCellContainer extends BaseComponent {
    constructor(){
        super(...arguments);
        this.refineRenderProps = memoizeObjArg(refineRenderProps);
    }
    render() {
        let { props, context } = this;
        let { options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, _preact.createElement)(ContentContainer, {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                'data-date': formatDayString(props.date)
            }),
            elClasses: [
                ...getDayClassNames(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }, props.children);
    }
}
function hasCustomDayCellContent(options) {
    return Boolean(options.dayCellContent || hasCustomRenderingHandler('dayCellContent', options));
}
function refineRenderProps(raw) {
    let { date, dateEnv, dateProfile, isMonthStart } = raw;
    let dayMeta = getDateMeta(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : DAY_NUM_FORMAT) : '';
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart,
        dayNumberText
    }), raw.extraRenderProps);
}
class BgEvent extends BaseComponent {
    render() {
        let { props } = this;
        let { seg } = props;
        return (0, _preact.createElement)(EventContainer, {
            elTag: "div",
            elClasses: [
                'fc-bg-event'
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function renderInnerContent(props) {
    let { title } = props.event;
    return title && (0, _preact.createElement)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function renderFill(fillType) {
    return (0, _preact.createElement)("div", {
        className: `fc-${fillType}`
    });
}
const WeekNumberContainer = (props)=>(0, _preact.createElement)(ViewContextType.Consumer, null, (context)=>{
        let { dateEnv, options } = context;
        let { date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num,
            text,
            date
        };
        return (0, _preact.createElement)(ContentContainer // why isn't WeekNumberContentArg being auto-detected?
        , {
            elRef: props.elRef,
            elTag: props.elTag,
            elAttrs: props.elAttrs,
            elClasses: props.elClasses,
            elStyle: props.elStyle,
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }, props.children);
    });
function renderInner(innerProps) {
    return innerProps.text;
}
const PADDING_FROM_VIEWPORT = 10;
class Popover extends BaseComponent {
    constructor(){
        super(...arguments);
        this.state = {
            titleId: getUniqueDomId()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) setRef(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = getEventTargetViaRoot(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === 'Escape') this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose } = this.props;
            if (onClose) onClose();
        };
    }
    render() {
        let { theme, options } = this.context;
        let { props, state } = this;
        let classNames = [
            'fc-popover',
            theme.getClass('popover')
        ].concat(props.extraClassNames || []);
        return (0, _compat.createPortal)((0, _preact.createElement)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(' '),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, _preact.createElement)("div", {
            className: 'fc-popover-header ' + theme.getClass('popoverHeader')
        }, (0, _preact.createElement)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, _preact.createElement)("span", {
            className: 'fc-popover-close ' + theme.getIconClass('close'),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, _preact.createElement)("div", {
            className: 'fc-popover-body ' + theme.getClass('popoverContent')
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl } = this.context;
        let { alignmentEl, alignGridTop } = this.props;
        let { rootEl } = this;
        let alignmentRect = computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? elementClosest(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            applyStyle(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
}
class MorePopover extends DateComponent {
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
    render() {
        let { options, dateEnv } = this.context;
        let { props } = this;
        let { startDate, todayRange, dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, _preact.createElement)(DayCellContainer, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, _preact.createElement)(Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    'fc-more-popover'
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, hasCustomDayCellContent(options) && (0, _preact.createElement)(InnerContent, {
                elTag: "div",
                elClasses: [
                    'fc-more-popover-misc'
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl, props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
}
class MoreLinkContainer extends BaseComponent {
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: getUniqueDomId()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) setRef(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props, context } = this;
            let { moreLinkClick } = context.options;
            let date = computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def, instance, range } = seg.eventRange;
                return {
                    event: new EventImpl(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === 'function') moreLinkClick = moreLinkClick({
                date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === 'popover') this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === 'string') context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
    render() {
        let { props, state } = this;
        return (0, _preact.createElement)(ViewContextType.Consumer, null, (context)=>{
            let { viewApi, options, calendarApi } = context;
            let { moreLinkText } = options;
            let { moreCnt } = props;
            let range = computeRange(props);
            let text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = formatWithOrdinals(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text,
                view: viewApi
            };
            return (0, _preact.createElement)((0, _preact.Fragment), null, Boolean(props.moreCnt) && (0, _preact.createElement)(ContentContainer, {
                elTag: props.elTag || 'a',
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    'fc-more-link'
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    'aria-expanded': state.isPopoverOpen,
                    'aria-controls': state.isPopoverOpen ? state.popoverId : ''
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, _preact.createElement)(MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = elementClosest(this.linkEl, '.fc-view-harness');
    }
}
function renderMoreLinkInner(props) {
    return props.text;
}
function computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: addDays(props.allDayDate, 1)
    };
    let { hiddenSegs } = props;
    return {
        start: computeEarliestSegStart(hiddenSegs),
        end: computeLatestSegEnd(hiddenSegs)
    };
}
function computeEarliestSegStart(segs) {
    return segs.reduce(pickEarliestStart).eventRange.range.start;
}
function pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function computeLatestSegEnd(segs) {
    return segs.reduce(pickLatestEnd).eventRange.range.end;
}
function pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class Store {
    constructor(){
        this.handlers = [];
    }
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class CustomRenderingStore extends Store {
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
    // for consistent order
    handle(customRendering) {
        const { map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
}

},{"preact":"hvsRZ","preact/compat":"7Rky7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hvsRZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>x);
parcelHelpers.export(exports, "Fragment", ()=>_);
parcelHelpers.export(exports, "cloneElement", ()=>F);
parcelHelpers.export(exports, "createContext", ()=>G);
parcelHelpers.export(exports, "createElement", ()=>y);
parcelHelpers.export(exports, "createRef", ()=>d);
parcelHelpers.export(exports, "h", ()=>y);
parcelHelpers.export(exports, "hydrate", ()=>E);
parcelHelpers.export(exports, "isValidElement", ()=>i);
parcelHelpers.export(exports, "options", ()=>l);
parcelHelpers.export(exports, "render", ()=>D);
parcelHelpers.export(exports, "toChildArray", ()=>j);
var n, l, u, i, t, r, o, f, e, c = {}, s = [], a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function y(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return p(l, f, t, r, null);
}
function p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++u : o
    };
    return null == o && null != l.vnode && l.vnode(f), f;
}
function d() {
    return {
        current: null
    };
}
function _(n) {
    return n.children;
}
function k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || g(n, r, l[r], u[r], i);
}
function b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || a.test(l) ? u : u + "px";
}
function g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? w : m, r) : n.removeEventListener(l, r ? w : m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function m(n) {
    t = !0;
    try {
        return this.l[n.type + !1](l.event ? l.event(n) : n);
    } finally{
        t = !1;
    }
}
function w(n) {
    t = !0;
    try {
        return this.l[n.type + !0](l.event ? l.event(n) : n);
    } finally{
        t = !1;
    }
}
function x(n, l) {
    this.props = n, this.context = l;
}
function A(n, l) {
    if (null == l) return n.__ ? A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? A(n) : null;
}
function P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return P(n);
    }
}
function C(n) {
    t ? setTimeout(n) : f(n);
}
function T(n) {
    (!n.__d && (n.__d = !0) && r.push(n) && !$.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || C)($);
}
function $() {
    var n, l, u, i, t, o, f, e;
    for(r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = r.shift();)n.__d && (l = r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = h({}, o)).__v = o.__v + 1, M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? A(o) : f, o.__h), N(i, o), o.__e != f && P(o)), r.length > l && r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $.__r = 0;
}
function H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? p(null, d, null, null, d) : Array.isArray(d) ? p(_, {
        children: d
    }, null, null, null) : d.__b > 0 ? p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        M(n, d, y = y || c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = I(d, e, n) : e = z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = L(i).nextSibling), q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)S(g[h], g[++h], g[++h]);
}
function I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? I(i, l, u) : z(u, i, i, t, i.__e, l));
    return l;
}
function j(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        j(n, l);
    }) : l.push(n)), l;
}
function z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = L(u))) return i;
    }
    return null;
}
function M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = l.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new x(b, m), a.constructor = $, a.render = B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = h({}, a.__s)), h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = l.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = h(h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === _ && null == s.key ? s.props.children : s, H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = O(i.__e, u, i, t, r, o, f, c);
        (s = l.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), l.__e(n, u, i);
    }
}
function N(n, u) {
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l.__e(n, u.__v);
        }
    });
}
function O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && n.call(l.childNodes), a = (y = i.props || c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if (k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        l.__e(n, i);
    }
}
function q(n, u, i) {
    var t, r;
    if (l.unmount && l.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            l.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function B(n, l, u) {
    return this.constructor(n, u);
}
function D(u, i, t) {
    var r, o, f;
    l.__ && l.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], M(i, u = (!r && t || i).__k = y(_, null, [
        u
    ]), o || c, c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), N(f, u);
}
function E(n, l) {
    D(n, l, E);
}
function F(l, u, i) {
    var t, r, o, f = h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), p(l.type, f, t || l.key, r || l.ref, null);
}
function G(n, l) {
    var u = {
        __c: l = "__cC" + e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
n = s.slice, l = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u = 0, i = function(n) {
    return null != n && void 0 === n.constructor;
}, t = !1, x.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = h({}, this.state), "function" == typeof n && (n = n(h({}, u), this.props)), n && h(u, n), null != n && this.__v && (l && this._sb.push(l), T(this));
}, x.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), T(this));
}, x.prototype.render = _, r = [], f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $.__r = 0, e = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Rky7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>(0, _preact.Component));
parcelHelpers.export(exports, "Fragment", ()=>(0, _preact.Fragment));
parcelHelpers.export(exports, "createContext", ()=>(0, _preact.createContext));
parcelHelpers.export(exports, "createElement", ()=>(0, _preact.createElement));
parcelHelpers.export(exports, "createRef", ()=>(0, _preact.createRef));
parcelHelpers.export(exports, "Children", ()=>O);
parcelHelpers.export(exports, "PureComponent", ()=>w);
parcelHelpers.export(exports, "StrictMode", ()=>vn);
parcelHelpers.export(exports, "Suspense", ()=>D);
parcelHelpers.export(exports, "SuspenseList", ()=>V);
parcelHelpers.export(exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", ()=>rn);
parcelHelpers.export(exports, "cloneElement", ()=>cn);
parcelHelpers.export(exports, "createFactory", ()=>on);
parcelHelpers.export(exports, "createPortal", ()=>j);
parcelHelpers.export(exports, "default", ()=>bn);
parcelHelpers.export(exports, "findDOMNode", ()=>an);
parcelHelpers.export(exports, "flushSync", ()=>hn);
parcelHelpers.export(exports, "forwardRef", ()=>k);
parcelHelpers.export(exports, "hydrate", ()=>q);
parcelHelpers.export(exports, "isValidElement", ()=>ln);
parcelHelpers.export(exports, "lazy", ()=>M);
parcelHelpers.export(exports, "memo", ()=>R);
parcelHelpers.export(exports, "render", ()=>Y);
parcelHelpers.export(exports, "startTransition", ()=>dn);
parcelHelpers.export(exports, "unmountComponentAtNode", ()=>fn);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>sn);
parcelHelpers.export(exports, "useDeferredValue", ()=>pn);
parcelHelpers.export(exports, "useInsertionEffect", ()=>yn);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>_n);
parcelHelpers.export(exports, "useTransition", ()=>mn);
parcelHelpers.export(exports, "version", ()=>un);
var _preact = require("preact");
var _hooks = require("preact/hooks");
parcelHelpers.exportAll(_hooks, exports);
function g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function w(n) {
    this.props = n;
}
function R(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, _preact.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
(w.prototype = new (0, _preact.Component)).isPureReactComponent = !0, w.prototype.shouldComponentUpdate = function(n, t) {
    return C(this.props, n) || C(this.state, t);
};
var x = (0, _preact.options).__b;
(0, _preact.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), x && x(n);
};
var N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function k(n) {
    function t(t) {
        var e = g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var A = function(n, t) {
    return null == n ? null : (0, _preact.toChildArray)((0, _preact.toChildArray)(n).map(t));
}, O = {
    map: A,
    forEach: A,
    count: function(n) {
        return n ? (0, _preact.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, _preact.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, _preact.toChildArray)
}, T = (0, _preact.options).__e;
(0, _preact.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    T(n, t, e, r);
};
var I = (0, _preact.options).unmount;
function L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return L(n, t, e);
    })), n;
}
function U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function D() {
    this.__u = 0, this.t = null, this.__b = null;
}
function F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function M(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, _preact.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function V() {
    this.u = null, this.o = null;
}
(0, _preact.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), I && I(n);
}, (D.prototype = new (0, _preact.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, D.prototype.componentWillUnmount = function() {
    this.t = [];
}, D.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, _preact.createElement)((0, _preact.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, _preact.createElement)((0, _preact.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, _preact.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, _preact.render)((0, _preact.createElement)(P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function j(n, e) {
    var r = (0, _preact.createElement)($, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
(V.prototype = new (0, _preact.Component)).__a = function(n) {
    var t = this, e = F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, V.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, _preact.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, V.prototype.componentDidUpdate = V.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        W(n, e, t);
    });
};
var z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, H = "undefined" != typeof document, Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function Y(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, _preact.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function q(n, t, e) {
    return (0, _preact.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, _preact.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, _preact.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var G = (0, _preact.options).event;
function J() {}
function K() {
    return this.cancelBubble;
}
function Q() {
    return this.defaultPrevented;
}
(0, _preact.options).event = function(n) {
    return G && (n = G(n)), n.persist = J, n.isPropagationStopped = K, n.isDefaultPrevented = Q, n.nativeEvent = n;
};
var X, nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, tn = (0, _preact.options).vnode;
(0, _preact.options).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, _preact.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, _preact.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && (nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", nn));
    }
    n.$$typeof = z, tn && tn(n);
};
var en = (0, _preact.options).__r;
(0, _preact.options).__r = function(n) {
    en && en(n), X = n.__c;
};
var rn = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return X.__n[n.__c].props.value;
            }
        }
    }
}, un = "17.0.2";
function on(n) {
    return (0, _preact.createElement).bind(null, n);
}
function ln(n) {
    return !!n && n.$$typeof === z;
}
function cn(n) {
    return ln(n) ? (0, _preact.cloneElement).apply(null, arguments) : n;
}
function fn(n) {
    return !!n.__k && ((0, _preact.render)(null, n), !0);
}
function an(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var sn = function(n, t) {
    return n(t);
}, hn = function(n, t) {
    return n(t);
}, vn = (0, _preact.Fragment);
function dn(n) {
    n();
}
function pn(n) {
    return n;
}
function mn() {
    return [
        !1,
        dn
    ];
}
var yn = (0, _hooks.useLayoutEffect);
function _n(n, t) {
    var e = t(), r = (0, _hooks.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, _hooks.useLayoutEffect)(function() {
        u.__ = e, u.v = t, E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, _hooks.useEffect)(function() {
        return E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var bn = {
    useState: (0, _hooks.useState),
    useId: (0, _hooks.useId),
    useReducer: (0, _hooks.useReducer),
    useEffect: (0, _hooks.useEffect),
    useLayoutEffect: (0, _hooks.useLayoutEffect),
    useInsertionEffect: yn,
    useTransition: mn,
    useDeferredValue: pn,
    useSyncExternalStore: _n,
    startTransition: dn,
    useRef: (0, _hooks.useRef),
    useImperativeHandle: (0, _hooks.useImperativeHandle),
    useMemo: (0, _hooks.useMemo),
    useCallback: (0, _hooks.useCallback),
    useContext: (0, _hooks.useContext),
    useDebugValue: (0, _hooks.useDebugValue),
    version: "17.0.2",
    Children: O,
    render: Y,
    hydrate: q,
    unmountComponentAtNode: fn,
    createPortal: j,
    createElement: (0, _preact.createElement),
    createContext: (0, _preact.createContext),
    createFactory: on,
    cloneElement: cn,
    createRef: (0, _preact.createRef),
    Fragment: (0, _preact.Fragment),
    isValidElement: ln,
    findDOMNode: an,
    Component: (0, _preact.Component),
    PureComponent: w,
    memo: R,
    forwardRef: k,
    flushSync: hn,
    unstable_batchedUpdates: sn,
    StrictMode: vn,
    Suspense: D,
    SuspenseList: V,
    lazy: M,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: rn
};

},{"preact":"hvsRZ","preact/hooks":"2TRXI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TRXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>T);
parcelHelpers.export(exports, "useContext", ()=>q);
parcelHelpers.export(exports, "useDebugValue", ()=>x);
parcelHelpers.export(exports, "useEffect", ()=>h);
parcelHelpers.export(exports, "useErrorBoundary", ()=>P);
parcelHelpers.export(exports, "useId", ()=>V);
parcelHelpers.export(exports, "useImperativeHandle", ()=>A);
parcelHelpers.export(exports, "useLayoutEffect", ()=>s);
parcelHelpers.export(exports, "useMemo", ()=>F);
parcelHelpers.export(exports, "useReducer", ()=>y);
parcelHelpers.export(exports, "useRef", ()=>_);
parcelHelpers.export(exports, "useState", ()=>p);
var _preact = require("preact");
var t, r, u, i, o = 0, f = [], c = [], e = (0, _preact.options).__b, a = (0, _preact.options).__r, v = (0, _preact.options).diffed, l = (0, _preact.options).__c, m = (0, _preact.options).unmount;
function d(t, u) {
    (0, _preact.options).__h && (0, _preact.options).__h(r, t, o || u), o = 0;
    var i = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: c
    }), i.__[t];
}
function p(n) {
    return o = 1, y(B, n);
}
function y(n, u, i) {
    var o = d(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.u)) {
        r.u = !0;
        var f = r.shouldComponentUpdate;
        r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function h(u, i) {
    var o = d(t++, 3);
    !(0, _preact.options).__s && z(o.__H, i) && (o.__ = u, o.i = i, r.__H.__h.push(o));
}
function s(u, i) {
    var o = d(t++, 4);
    !(0, _preact.options).__s && z(o.__H, i) && (o.__ = u, o.i = i, r.__h.push(o));
}
function _(n) {
    return o = 5, F(function() {
        return {
            current: n
        };
    }, []);
}
function A(n, t, r) {
    o = 6, s(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function F(n, r) {
    var u = d(t++, 7);
    return z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function T(n, t) {
    return o = 8, F(function() {
        return n;
    }, t);
}
function q(n) {
    var u = r.context[n.__c], i = d(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function x(t, r) {
    (0, _preact.options).useDebugValue && (0, _preact.options).useDebugValue(r ? r(t) : t);
}
function P(n) {
    var u = d(t++, 10), i = p();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function V() {
    var n = d(t++, 11);
    if (!n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function b() {
    for(var t; t = f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach(k), t.__H.__h.forEach(w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, _preact.options).__e(r, t.__v);
    }
}
(0, _preact.options).__b = function(n) {
    r = null, e && e(n);
}, (0, _preact.options).__r = function(n) {
    a && a(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = c, n.__N = n.i = void 0;
    })) : (i.__h.forEach(k), i.__h.forEach(w), i.__h = [])), u = r;
}, (0, _preact.options).diffed = function(t) {
    v && v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== f.push(o) && i === (0, _preact.options).requestAnimationFrame || ((i = (0, _preact.options).requestAnimationFrame) || j)(b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== c && (n.__ = n.__V), n.i = void 0, n.__V = c;
    })), u = r = null;
}, (0, _preact.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach(k), t.__h = t.__h.filter(function(n) {
                return !n.__ || w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, _preact.options).__e(u, t.__v);
        }
    }), l && l(t, r);
}, (0, _preact.options).unmount = function(t) {
    m && m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, _preact.options).__e(r, u.__v));
};
var g = "function" == typeof requestAnimationFrame;
function j(n) {
    var t, r = function() {
        clearTimeout(u), g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    g && (t = requestAnimationFrame(r));
}
function k(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function w(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"hvsRZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fCef8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_OPTION_DEFAULTS", ()=>(0, _internalCommonJs.e));
parcelHelpers.export(exports, "BaseComponent", ()=>(0, _internalCommonJs.B));
parcelHelpers.export(exports, "BgEvent", ()=>(0, _internalCommonJs.cm));
parcelHelpers.export(exports, "CalendarImpl", ()=>(0, _internalCommonJs.a7));
parcelHelpers.export(exports, "CalendarRoot", ()=>(0, _internalCommonJs.a9));
parcelHelpers.export(exports, "ContentContainer", ()=>(0, _internalCommonJs.C));
parcelHelpers.export(exports, "CustomRenderingStore", ()=>(0, _internalCommonJs.cv));
parcelHelpers.export(exports, "DateComponent", ()=>(0, _internalCommonJs.bc));
parcelHelpers.export(exports, "DateEnv", ()=>(0, _internalCommonJs.Q));
parcelHelpers.export(exports, "DateProfileGenerator", ()=>(0, _internalCommonJs.R));
parcelHelpers.export(exports, "DayCellContainer", ()=>(0, _internalCommonJs.ci));
parcelHelpers.export(exports, "DayHeader", ()=>(0, _internalCommonJs.bI));
parcelHelpers.export(exports, "DaySeriesModel", ()=>(0, _internalCommonJs.bM));
parcelHelpers.export(exports, "DayTableModel", ()=>(0, _internalCommonJs.bT));
parcelHelpers.export(exports, "DelayedRunner", ()=>(0, _internalCommonJs.D));
parcelHelpers.export(exports, "ElementDragging", ()=>(0, _internalCommonJs.bF));
parcelHelpers.export(exports, "ElementScrollController", ()=>(0, _internalCommonJs.ba));
parcelHelpers.export(exports, "Emitter", ()=>(0, _internalCommonJs.F));
parcelHelpers.export(exports, "EventContainer", ()=>(0, _internalCommonJs.ck));
parcelHelpers.export(exports, "EventImpl", ()=>(0, _internalCommonJs._));
parcelHelpers.export(exports, "Interaction", ()=>(0, _internalCommonJs.X));
parcelHelpers.export(exports, "MoreLinkContainer", ()=>(0, _internalCommonJs.co));
parcelHelpers.export(exports, "NamedTimeZoneImpl", ()=>(0, _internalCommonJs.bw));
parcelHelpers.export(exports, "NowIndicatorContainer", ()=>(0, _internalCommonJs.ch));
parcelHelpers.export(exports, "NowTimer", ()=>(0, _internalCommonJs.a6));
parcelHelpers.export(exports, "PositionCache", ()=>(0, _internalCommonJs.b8));
parcelHelpers.export(exports, "RefMap", ()=>(0, _internalCommonJs.cd));
parcelHelpers.export(exports, "ScrollController", ()=>(0, _internalCommonJs.b9));
parcelHelpers.export(exports, "ScrollResponder", ()=>(0, _internalCommonJs.cf));
parcelHelpers.export(exports, "Scroller", ()=>(0, _internalCommonJs.cb));
parcelHelpers.export(exports, "SegHierarchy", ()=>(0, _internalCommonJs.by));
parcelHelpers.export(exports, "SimpleScrollGrid", ()=>(0, _internalCommonJs.bZ));
parcelHelpers.export(exports, "Slicer", ()=>(0, _internalCommonJs.bU));
parcelHelpers.export(exports, "Splitter", ()=>(0, _internalCommonJs.aW));
parcelHelpers.export(exports, "StandardEvent", ()=>(0, _internalCommonJs.cg));
parcelHelpers.export(exports, "TableDateCell", ()=>(0, _internalCommonJs.bK));
parcelHelpers.export(exports, "TableDowCell", ()=>(0, _internalCommonJs.bL));
parcelHelpers.export(exports, "Theme", ()=>(0, _internalCommonJs.T));
parcelHelpers.export(exports, "ViewContainer", ()=>(0, _internalCommonJs.cq));
parcelHelpers.export(exports, "ViewContextType", ()=>(0, _internalCommonJs.V));
parcelHelpers.export(exports, "WeekNumberContainer", ()=>(0, _internalCommonJs.cn));
parcelHelpers.export(exports, "WindowScrollController", ()=>(0, _internalCommonJs.bb));
parcelHelpers.export(exports, "addDays", ()=>(0, _internalCommonJs.t));
parcelHelpers.export(exports, "addDurations", ()=>(0, _internalCommonJs.bn));
parcelHelpers.export(exports, "addMs", ()=>(0, _internalCommonJs.be));
parcelHelpers.export(exports, "addWeeks", ()=>(0, _internalCommonJs.bf));
parcelHelpers.export(exports, "allowContextMenu", ()=>(0, _internalCommonJs.as));
parcelHelpers.export(exports, "allowSelection", ()=>(0, _internalCommonJs.aq));
parcelHelpers.export(exports, "applyMutationToEventStore", ()=>(0, _internalCommonJs.bV));
parcelHelpers.export(exports, "applyStyle", ()=>(0, _internalCommonJs.aN));
parcelHelpers.export(exports, "asCleanDays", ()=>(0, _internalCommonJs.bl));
parcelHelpers.export(exports, "asRoughMinutes", ()=>(0, _internalCommonJs.bo));
parcelHelpers.export(exports, "asRoughMs", ()=>(0, _internalCommonJs.bq));
parcelHelpers.export(exports, "asRoughSeconds", ()=>(0, _internalCommonJs.bp));
parcelHelpers.export(exports, "binarySearch", ()=>(0, _internalCommonJs.bB));
parcelHelpers.export(exports, "buildElAttrs", ()=>(0, _internalCommonJs.cu));
parcelHelpers.export(exports, "buildEntryKey", ()=>(0, _internalCommonJs.bz));
parcelHelpers.export(exports, "buildEventApis", ()=>(0, _internalCommonJs.w));
parcelHelpers.export(exports, "buildEventRangeKey", ()=>(0, _internalCommonJs.bR));
parcelHelpers.export(exports, "buildIsoString", ()=>(0, _internalCommonJs.bu));
parcelHelpers.export(exports, "buildNavLinkAttrs", ()=>(0, _internalCommonJs.a_));
parcelHelpers.export(exports, "buildSegTimeText", ()=>(0, _internalCommonJs.bO));
parcelHelpers.export(exports, "collectFromHash", ()=>(0, _internalCommonJs.aJ));
parcelHelpers.export(exports, "combineEventUis", ()=>(0, _internalCommonJs.aV));
parcelHelpers.export(exports, "compareByFieldSpecs", ()=>(0, _internalCommonJs.an));
parcelHelpers.export(exports, "compareNumbers", ()=>(0, _internalCommonJs.at));
parcelHelpers.export(exports, "compareObjs", ()=>(0, _internalCommonJs.aI));
parcelHelpers.export(exports, "computeEarliestSegStart", ()=>(0, _internalCommonJs.cp));
parcelHelpers.export(exports, "computeEdges", ()=>(0, _internalCommonJs.b2));
parcelHelpers.export(exports, "computeFallbackHeaderFormat", ()=>(0, _internalCommonJs.bJ));
parcelHelpers.export(exports, "computeInnerRect", ()=>(0, _internalCommonJs.b1));
parcelHelpers.export(exports, "computeRect", ()=>(0, _internalCommonJs.b4));
parcelHelpers.export(exports, "computeShrinkWidth", ()=>(0, _internalCommonJs.c5));
parcelHelpers.export(exports, "computeVisibleDayRange", ()=>(0, _internalCommonJs.aw));
parcelHelpers.export(exports, "config", ()=>(0, _internalCommonJs.bG));
parcelHelpers.export(exports, "constrainPoint", ()=>(0, _internalCommonJs.aE));
parcelHelpers.export(exports, "createDuration", ()=>(0, _internalCommonJs.d));
parcelHelpers.export(exports, "createEmptyEventStore", ()=>(0, _internalCommonJs.H));
parcelHelpers.export(exports, "createEventInstance", ()=>(0, _internalCommonJs.ah));
parcelHelpers.export(exports, "createEventUi", ()=>(0, _internalCommonJs.S));
parcelHelpers.export(exports, "createFormatter", ()=>(0, _internalCommonJs.x));
parcelHelpers.export(exports, "diffDates", ()=>(0, _internalCommonJs.ay));
parcelHelpers.export(exports, "diffDayAndTime", ()=>(0, _internalCommonJs.bi));
parcelHelpers.export(exports, "diffDays", ()=>(0, _internalCommonJs.bj));
parcelHelpers.export(exports, "diffPoints", ()=>(0, _internalCommonJs.aG));
parcelHelpers.export(exports, "diffWeeks", ()=>(0, _internalCommonJs.bg));
parcelHelpers.export(exports, "diffWholeDays", ()=>(0, _internalCommonJs.y));
parcelHelpers.export(exports, "diffWholeWeeks", ()=>(0, _internalCommonJs.bh));
parcelHelpers.export(exports, "disableCursor", ()=>(0, _internalCommonJs.av));
parcelHelpers.export(exports, "elementClosest", ()=>(0, _internalCommonJs.Z));
parcelHelpers.export(exports, "elementMatches", ()=>(0, _internalCommonJs.aO));
parcelHelpers.export(exports, "enableCursor", ()=>(0, _internalCommonJs.au));
parcelHelpers.export(exports, "eventTupleToStore", ()=>(0, _internalCommonJs.aU));
parcelHelpers.export(exports, "filterHash", ()=>(0, _internalCommonJs.h));
parcelHelpers.export(exports, "findDirectChildren", ()=>(0, _internalCommonJs.aL));
parcelHelpers.export(exports, "findElements", ()=>(0, _internalCommonJs.aK));
parcelHelpers.export(exports, "flexibleCompare", ()=>(0, _internalCommonJs.ao));
parcelHelpers.export(exports, "formatDayString", ()=>(0, _internalCommonJs.bt));
parcelHelpers.export(exports, "formatIsoMonthStr", ()=>(0, _internalCommonJs.bv));
parcelHelpers.export(exports, "formatIsoTimeString", ()=>(0, _internalCommonJs.bs));
parcelHelpers.export(exports, "getAllowYScrolling", ()=>(0, _internalCommonJs.c3));
parcelHelpers.export(exports, "getCanVGrowWithinCell", ()=>(0, _internalCommonJs.aR));
parcelHelpers.export(exports, "getClippingParents", ()=>(0, _internalCommonJs.b3));
parcelHelpers.export(exports, "getDateMeta", ()=>(0, _internalCommonJs.aY));
parcelHelpers.export(exports, "getDayClassNames", ()=>(0, _internalCommonJs.aX));
parcelHelpers.export(exports, "getDefaultEventEnd", ()=>(0, _internalCommonJs.cs));
parcelHelpers.export(exports, "getElSeg", ()=>(0, _internalCommonJs.Y));
parcelHelpers.export(exports, "getEntrySpanEnd", ()=>(0, _internalCommonJs.bA));
parcelHelpers.export(exports, "getEventTargetViaRoot", ()=>(0, _internalCommonJs.aP));
parcelHelpers.export(exports, "getIsRtlScrollbarOnLeft", ()=>(0, _internalCommonJs.ce));
parcelHelpers.export(exports, "getRectCenter", ()=>(0, _internalCommonJs.aF));
parcelHelpers.export(exports, "getRelevantEvents", ()=>(0, _internalCommonJs.aT));
parcelHelpers.export(exports, "getScrollGridClassNames", ()=>(0, _internalCommonJs.c0));
parcelHelpers.export(exports, "getScrollbarWidths", ()=>(0, _internalCommonJs.cc));
parcelHelpers.export(exports, "getSectionClassNames", ()=>(0, _internalCommonJs.c1));
parcelHelpers.export(exports, "getSectionHasLiquidHeight", ()=>(0, _internalCommonJs.c2));
parcelHelpers.export(exports, "getSegAnchorAttrs", ()=>(0, _internalCommonJs.bS));
parcelHelpers.export(exports, "getSegMeta", ()=>(0, _internalCommonJs.bQ));
parcelHelpers.export(exports, "getSlotClassNames", ()=>(0, _internalCommonJs.aZ));
parcelHelpers.export(exports, "getStickyFooterScrollbar", ()=>(0, _internalCommonJs.c9));
parcelHelpers.export(exports, "getStickyHeaderDates", ()=>(0, _internalCommonJs.ca));
parcelHelpers.export(exports, "getUniqueDomId", ()=>(0, _internalCommonJs.a3));
parcelHelpers.export(exports, "greatestDurationDenominator", ()=>(0, _internalCommonJs.c));
parcelHelpers.export(exports, "groupIntersectingEntries", ()=>(0, _internalCommonJs.bC));
parcelHelpers.export(exports, "guid", ()=>(0, _internalCommonJs.g));
parcelHelpers.export(exports, "hasBgRendering", ()=>(0, _internalCommonJs.bN));
parcelHelpers.export(exports, "hasCustomDayCellContent", ()=>(0, _internalCommonJs.cj));
parcelHelpers.export(exports, "hasShrinkWidth", ()=>(0, _internalCommonJs.b_));
parcelHelpers.export(exports, "identity", ()=>(0, _internalCommonJs.n));
parcelHelpers.export(exports, "injectStyles", ()=>(0, _internalCommonJs.ct));
parcelHelpers.export(exports, "interactionSettingsStore", ()=>(0, _internalCommonJs.a5));
parcelHelpers.export(exports, "interactionSettingsToStore", ()=>(0, _internalCommonJs.bE));
parcelHelpers.export(exports, "intersectRanges", ()=>(0, _internalCommonJs.o));
parcelHelpers.export(exports, "intersectRects", ()=>(0, _internalCommonJs.aC));
parcelHelpers.export(exports, "intersectSpans", ()=>(0, _internalCommonJs.bD));
parcelHelpers.export(exports, "isArraysEqual", ()=>(0, _internalCommonJs.i));
parcelHelpers.export(exports, "isColPropsEqual", ()=>(0, _internalCommonJs.c7));
parcelHelpers.export(exports, "isDateSelectionValid", ()=>(0, _internalCommonJs.bY));
parcelHelpers.export(exports, "isDateSpansEqual", ()=>(0, _internalCommonJs.bd));
parcelHelpers.export(exports, "isInt", ()=>(0, _internalCommonJs.al));
parcelHelpers.export(exports, "isInteractionValid", ()=>(0, _internalCommonJs.bX));
parcelHelpers.export(exports, "isMultiDayRange", ()=>(0, _internalCommonJs.ax));
parcelHelpers.export(exports, "isPropsEqual", ()=>(0, _internalCommonJs.E));
parcelHelpers.export(exports, "isPropsValid", ()=>(0, _internalCommonJs.bW));
parcelHelpers.export(exports, "isValidDate", ()=>(0, _internalCommonJs.bk));
parcelHelpers.export(exports, "mapHash", ()=>(0, _internalCommonJs.a));
parcelHelpers.export(exports, "memoize", ()=>(0, _internalCommonJs.z));
parcelHelpers.export(exports, "memoizeArraylike", ()=>(0, _internalCommonJs.aA));
parcelHelpers.export(exports, "memoizeHashlike", ()=>(0, _internalCommonJs.aB));
parcelHelpers.export(exports, "memoizeObjArg", ()=>(0, _internalCommonJs.A));
parcelHelpers.export(exports, "mergeEventStores", ()=>(0, _internalCommonJs.aS));
parcelHelpers.export(exports, "multiplyDuration", ()=>(0, _internalCommonJs.bm));
parcelHelpers.export(exports, "padStart", ()=>(0, _internalCommonJs.ak));
parcelHelpers.export(exports, "parseBusinessHours", ()=>(0, _internalCommonJs.U));
parcelHelpers.export(exports, "parseClassNames", ()=>(0, _internalCommonJs.aQ));
parcelHelpers.export(exports, "parseDragMeta", ()=>(0, _internalCommonJs.bH));
parcelHelpers.export(exports, "parseEventDef", ()=>(0, _internalCommonJs.ai));
parcelHelpers.export(exports, "parseFieldSpecs", ()=>(0, _internalCommonJs.am));
parcelHelpers.export(exports, "parseMarker", ()=>(0, _internalCommonJs.bx));
parcelHelpers.export(exports, "pointInsideRect", ()=>(0, _internalCommonJs.aD));
parcelHelpers.export(exports, "preventContextMenu", ()=>(0, _internalCommonJs.ar));
parcelHelpers.export(exports, "preventDefault", ()=>(0, _internalCommonJs.a$));
parcelHelpers.export(exports, "preventSelection", ()=>(0, _internalCommonJs.ap));
parcelHelpers.export(exports, "rangeContainsMarker", ()=>(0, _internalCommonJs.G));
parcelHelpers.export(exports, "rangeContainsRange", ()=>(0, _internalCommonJs.b7));
parcelHelpers.export(exports, "rangesEqual", ()=>(0, _internalCommonJs.b5));
parcelHelpers.export(exports, "rangesIntersect", ()=>(0, _internalCommonJs.b6));
parcelHelpers.export(exports, "refineEventDef", ()=>(0, _internalCommonJs.aj));
parcelHelpers.export(exports, "refineProps", ()=>(0, _internalCommonJs.ag));
parcelHelpers.export(exports, "removeElement", ()=>(0, _internalCommonJs.aM));
parcelHelpers.export(exports, "removeExact", ()=>(0, _internalCommonJs.az));
parcelHelpers.export(exports, "renderChunkContent", ()=>(0, _internalCommonJs.c4));
parcelHelpers.export(exports, "renderFill", ()=>(0, _internalCommonJs.cl));
parcelHelpers.export(exports, "renderMicroColGroup", ()=>(0, _internalCommonJs.b$));
parcelHelpers.export(exports, "renderScrollShim", ()=>(0, _internalCommonJs.c8));
parcelHelpers.export(exports, "requestJson", ()=>(0, _internalCommonJs.r));
parcelHelpers.export(exports, "sanitizeShrinkWidth", ()=>(0, _internalCommonJs.c6));
parcelHelpers.export(exports, "setRef", ()=>(0, _internalCommonJs.W));
parcelHelpers.export(exports, "sliceEventStore", ()=>(0, _internalCommonJs.ad));
parcelHelpers.export(exports, "sortEventSegs", ()=>(0, _internalCommonJs.bP));
parcelHelpers.export(exports, "startOfDay", ()=>(0, _internalCommonJs.q));
parcelHelpers.export(exports, "translateRect", ()=>(0, _internalCommonJs.aH));
parcelHelpers.export(exports, "triggerDateSelect", ()=>(0, _internalCommonJs.cr));
parcelHelpers.export(exports, "unpromisify", ()=>(0, _internalCommonJs.u));
parcelHelpers.export(exports, "whenTransitionDone", ()=>(0, _internalCommonJs.b0));
parcelHelpers.export(exports, "wholeDivideDurations", ()=>(0, _internalCommonJs.br));
var _internalCommonJs = require("./internal-common.js");
var _preact = require("preact");
var _compat = require("preact/compat");

},{"./internal-common.js":"cbu5L","preact":"hvsRZ","preact/compat":"7Rky7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9JFEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPTION_IS_COMPLEX", ()=>OPTION_IS_COMPLEX);
const OPTION_IS_COMPLEX = {
    headerToolbar: true,
    footerToolbar: true,
    events: true,
    eventSources: true,
    resources: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjjJm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _indexJs = require("@fullcalendar/core/index.js");
var _internalJs = require("./internal.js");
var _internalJs1 = require("@fullcalendar/core/internal.js");
var _preactJs = require("@fullcalendar/core/preact.js");
var index = (0, _indexJs.createPlugin)({
    name: '@fullcalendar/daygrid',
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: (0, _internalJs.DayGridView),
            dateProfileGeneratorClass: (0, _internalJs.TableDateProfileGenerator)
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: 'dayGrid',
            duration: {
                years: 1
            }
        }
    }
});

},{"@fullcalendar/core/index.js":"dYWMT","./internal.js":"5vhO4","@fullcalendar/core/internal.js":"fCef8","@fullcalendar/core/preact.js":"bMX44","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5vhO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayGridView", ()=>DayTableView);
parcelHelpers.export(exports, "DayTable", ()=>DayTable);
parcelHelpers.export(exports, "DayTableSlicer", ()=>DayTableSlicer);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableDateProfileGenerator", ()=>TableDateProfileGenerator);
parcelHelpers.export(exports, "TableRows", ()=>TableRows);
parcelHelpers.export(exports, "TableView", ()=>TableView);
parcelHelpers.export(exports, "buildDayTableModel", ()=>buildDayTableModel);
parcelHelpers.export(exports, "buildDayTableRenderRange", ()=>buildDayTableRenderRange);
var _internalJs = require("@fullcalendar/core/internal.js");
var _preactJs = require("@fullcalendar/core/preact.js");
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class TableView extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.headerElRef = (0, _preactJs.createRef)();
    }
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props, context } = this;
        let sections = [];
        let stickyHeaderDates = (0, _internalJs.getStickyHeaderDates)(context.options);
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: 'fc-col-header',
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, _preactJs.createElement)((0, _internalJs.ViewContainer), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, _preactJs.createElement)((0, _internalJs.SimpleScrollGrid), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error('No ScrollGrid implementation');
        let { props, context } = this;
        let stickyHeaderDates = !props.forPrint && (0, _internalJs.getStickyHeaderDates)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, _internalJs.getStickyFooterScrollbar)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: 'header',
            key: 'header',
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: 'main',
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [
                {
                    key: 'main',
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: 'footer',
            key: 'footer',
            isSticky: true,
            chunks: [
                {
                    key: 'main',
                    content: (0, _internalJs.renderScrollShim)
                }
            ]
        });
        return (0, _preactJs.createElement)((0, _internalJs.ViewContainer), {
            elClasses: [
                'fc-daygrid'
            ],
            viewSpec: context.viewSpec
        }, (0, _preactJs.createElement)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
}
function splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, _internalJs.createFormatter)({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow'
});
function hasListItemDisplay(seg) {
    let { display } = seg.eventRange.ui;
    return display === 'list-item' || display === 'auto' && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class TableBlockEvent extends (0, _internalJs.BaseComponent) {
    render() {
        let { props } = this;
        return (0, _preactJs.createElement)((0, _internalJs.StandardEvent), Object.assign({}, props, {
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-block-event',
                'fc-h-event'
            ],
            defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class TableListItemEvent extends (0, _internalJs.BaseComponent) {
    render() {
        let { props, context } = this;
        let { options } = context;
        let { seg } = props;
        let timeFormat = options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, _internalJs.buildSegTimeText)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, _preactJs.createElement)((0, _internalJs.EventContainer), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                'fc-daygrid-event',
                'fc-daygrid-dot-event'
            ],
            elAttrs: (0, _internalJs.getSegAnchorAttrs)(props.seg, context),
            defaultGenerator: renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function renderInnerContent(renderProps) {
    return (0, _preactJs.createElement)((0, _preactJs.Fragment), null, (0, _preactJs.createElement)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, _preactJs.createElement)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, _preactJs.createElement)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, _preactJs.createElement)((0, _preactJs.Fragment), null, "\u00A0")));
}
class TableCellMoreLink extends (0, _internalJs.BaseComponent) {
    constructor(){
        super(...arguments);
        this.compileSegs = (0, _internalJs.memoize)(compileSegs);
    }
    render() {
        let { props } = this;
        let { allSegs, invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, _preactJs.createElement)((0, _internalJs.MoreLinkContainer), {
            elClasses: [
                'fc-daygrid-more-link'
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, _preactJs.createElement)((0, _preactJs.Fragment), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, _preactJs.createElement)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : ''
                        }
                    }, hasListItemDisplay(seg) ? (0, _preactJs.createElement)(TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, _internalJs.getSegMeta)(seg, props.todayRange))) : (0, _preactJs.createElement)(TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, _internalJs.getSegMeta)(seg, props.todayRange))));
                }));
            }
        });
    }
}
function compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs,
        invisibleSegs
    };
}
const DEFAULT_WEEK_NUM_FORMAT = (0, _internalJs.createFormatter)({
    week: 'narrow'
});
class TableCell extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.rootElRef = (0, _preactJs.createRef)();
        this.state = {
            dayNumberId: (0, _internalJs.getUniqueDomId)()
        };
        this.handleRootEl = (el)=>{
            (0, _internalJs.setRef)(this.rootElRef, el);
            (0, _internalJs.setRef)(this.props.elRef, el);
        };
    }
    render() {
        let { context, props, state, rootElRef } = this;
        let { options, dateEnv } = context;
        let { date, dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, _preactJs.createElement)((0, _internalJs.DayCellContainer), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                'fc-daygrid-day',
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                'aria-labelledby': state.dayNumberId
            } : {}), {
                role: 'gridcell'
            }),
            defaultGenerator: renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, _preactJs.createElement)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, _preactJs.createElement)((0, _internalJs.WeekNumberContainer), {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-week-number'
                ],
                elAttrs: (0, _internalJs.buildNavLinkAttrs)(context, date, 'week'),
                date: date,
                defaultFormat: DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, _internalJs.hasCustomDayCellContent)(options) || props.forceDayTop) ? (0, _preactJs.createElement)("div", {
                className: "fc-daygrid-day-top"
            }, (0, _preactJs.createElement)(InnerContent, {
                elTag: "a",
                elClasses: [
                    'fc-daygrid-day-number',
                    isMonthStart && 'fc-daygrid-month-start'
                ],
                elAttrs: Object.assign(Object.assign({}, (0, _internalJs.buildNavLinkAttrs)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, _preactJs.createElement)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: 'hidden'
                }
            }, (0, _preactJs.createElement)("a", {
                className: "fc-daygrid-day-number"
            }, "\u00A0")) : undefined, (0, _preactJs.createElement)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, _preactJs.createElement)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, _preactJs.createElement)(TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, _preactJs.createElement)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
}
function renderTopInner(props) {
    return props.dayNumberText || (0, _preactJs.createElement)((0, _preactJs.Fragment), null, "\u00A0");
}
function shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, _internalJs.addMs)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function generateSegKey(seg) {
    return seg.eventRange.instance.instanceId + ':' + seg.firstCol;
}
function generateSegUid(seg) {
    return generateSegKey(seg) + ':' + seg.lastCol;
}
function computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, segHeights, maxContentHeight, cells) {
    let hierarchy = new DayGridSegHierarchy((segEntry)=>{
        // TODO: more DRY with generateSegUid
        let segUid = segs[segEntry.index].eventRange.instance.instanceId + ':' + segEntry.span.start + ':' + (segEntry.span.end - 1);
        // if no thickness known, assume 1 (if 0, so small it always fits)
        return segHeights[segUid] || 1;
    });
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === 'number') hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let segUid = generateSegUid(seg);
        let eventHeight = segHeights[segUid];
        if (eventHeight != null) segInputs.push({
            index: i,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements, multiColPlacements, leftoverMargins } = placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements,
        multiColPlacements,
        moreCnts,
        moreMarginTops
    };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    let rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements,
        multiColPlacements,
        leftoverMargins
    };
}
function groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, _internalJs.intersectRanges)(origRange, {
        start: cells[spanStart].date,
        end: (0, _internalJs.addDays)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class DayGridSegHierarchy extends (0, _internalJs.SegHierarchy) {
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, _internalJs.buildEntryKey)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel, forceHidden } = this;
        const { touchingEntry, touchingLevel, touchingLateral } = insertion;
        // the entry that the new insertion is touching must be hidden
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, _internalJs.buildEntryKey)(touchingEntry);
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    // split up the touchingEntry, reinsert it
                    const hiddenEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, _internalJs.intersectSpans)(touchingEntry.span, entry.span)
                    });
                    // reinsert the area that turned into a "more" link (so no other entries try to
                    // occupy the space) but mark it forced-hidden
                    const hiddenEntryId = (0, _internalJs.buildEntryKey)(hiddenEntry);
                    forceHidden[hiddenEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = hiddenEntry;
                    hiddenEntries.push(hiddenEntry);
                    this.splitEntry(touchingEntry, entry, hiddenEntries);
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        // will try to reslice...
        super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
}
class TableRow extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, _internalJs.RefMap)(); // the <td>
        this.frameElRefs = new (0, _internalJs.RefMap)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, _internalJs.RefMap)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, _internalJs.RefMap)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, _preactJs.createRef)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            segHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
    render() {
        let { props, state, context } = this;
        let { options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements, multiColPlacements, moreCnts, moreMarginTops } = computeFgSegPlacement((0, _internalJs.sortEventSegs)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.segHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, _preactJs.createElement)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, _preactJs.createElement)(TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, _preactJs.createElement)((0, _preactJs.Fragment), null, (0, _preactJs.createElement)((0, _preactJs.Fragment), null, normalFgNodes), (0, _preactJs.createElement)((0, _preactJs.Fragment), null, mirrorFgNodes)),
                bgContent: (0, _preactJs.createElement)((0, _preactJs.Fragment), null, this.renderFillSegs(highlightSegsByCol[col], 'highlight'), this.renderFillSegs(businessHoursByCol[col], 'non-business'), this.renderFillSegs(bgEventSegsByCol[col], 'bg-event')),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, _internalJs.isPropsEqual)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context } = this;
        let { eventSelection } = this.props;
        let { framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg } = placement;
            let { instanceId } = seg.eventRange.instance;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = '';
            let right = '';
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, _preactJs.createElement)("div", {
                className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''),
                key: generateSegKey(seg),
                ref: isMirror ? null : this.segHarnessRefs.createRef(generateSegUid(seg)),
                style: {
                    visibility: isVisible ? '' : 'hidden',
                    marginTop: isAbsolute ? '' : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : '',
                    left,
                    right
                }
            }, hasListItemDisplay(seg) ? (0, _preactJs.createElement)(TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, _internalJs.getSegMeta)(seg, todayRange))) : (0, _preactJs.createElement)(TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, _internalJs.getSegMeta)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl } = this.context;
        let { todayRange } = this.props;
        let { framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, _preactJs.createElement)("div", {
                key: (0, _internalJs.buildEventRangeKey)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === 'bg-event' ? (0, _preactJs.createElement)((0, _internalJs.BgEvent), Object.assign({
                seg: seg
            }, (0, _internalJs.getSegMeta)(seg, todayRange))) : (0, _internalJs.renderFill)(fillType)));
        }
        return (0, _preactJs.createElement)((0, _preactJs.Fragment), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props, state, frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, _internalJs.PositionCache)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, _internalJs.PositionCache)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldSegHeights = this.state.segHeights;
            const newSegHeights = this.querySegHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                segHeights: Object.assign(Object.assign({}, oldSegHeights), newSegHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    querySegHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let segHeights = {};
        // get the max height amongst instance segs
        for(let segUid in segElMap){
            let height = Math.round(segElMap[segUid].getBoundingClientRect().height);
            segHeights[segUid] = Math.max(segHeights[segUid] || 0, height);
        }
        return segHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
}
TableRow.addStateEquality({
    segHeights: (0, _internalJs.isPropsEqual)
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class TableRows extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, _internalJs.memoize)(splitSegsByRow);
        this.splitBgEventSegs = (0, _internalJs.memoize)(splitAllDaySegsByRow);
        this.splitFgEventSegs = (0, _internalJs.memoize)(splitSegsByRow);
        this.splitDateSelectionSegs = (0, _internalJs.memoize)(splitSegsByRow);
        this.splitEventDrag = (0, _internalJs.memoize)(splitInteractionByRow);
        this.splitEventResize = (0, _internalJs.memoize)(splitInteractionByRow);
        this.rowRefs = new (0, _internalJs.RefMap)();
    }
    render() {
        let { props, context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, _preactJs.createElement)((0, _internalJs.NowTimer), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, _preactJs.createElement)((0, _preactJs.Fragment), null, props.cells.map((cells, row)=>(0, _preactJs.createElement)(TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row],
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        this.registerInteractiveComponent();
    }
    componentDidUpdate() {
        // for if started with zero cells
        this.registerInteractiveComponent();
    }
    registerInteractiveComponent() {
        if (!this.rootEl) {
            // HACK: need a daygrid wrapper parent to do positioning
            // NOTE: a daygrid resource view w/o resources can have zero cells
            const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
            const rootEl = firstCellEl ? firstCellEl.closest('.fc-daygrid-body') : null;
            if (rootEl) {
                this.rootEl = rootEl;
                this.context.registerInteractiveComponent(this, {
                    el: rootEl,
                    isHitComboAllowed: this.props.isHitComboAllowed
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, _internalJs.PositionCache)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, _internalJs.PositionCache)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions, rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, _internalJs.addDays)(start, 1);
        return {
            start,
            end
        };
    }
}
function splitAllDaySegsByRow(segs, rowCnt) {
    return splitSegsByRow(segs.filter(isSegAllDay), rowCnt);
}
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class Table extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.elRef = (0, _preactJs.createRef)();
        this.needsScrollReset = false;
    }
    render() {
        let { props } = this;
        let { dayMaxEventRows, dayMaxEvents, expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural'
        ];
        return (0, _preactJs.createElement)("div", {
            ref: this.elRef,
            className: classNames.join(' '),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, _preactJs.createElement)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ''
            }
        }, props.colGroupNode, (0, _preactJs.createElement)("tbody", {
            role: "presentation"
        }, (0, _preactJs.createElement)(TableRows, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest('.fc-daygrid-body');
                const scrollEl = originEl.closest('.fc-scroller');
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
}
function getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, _internalJs.formatIsoMonthStr)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, _internalJs.formatDayString)(dateProfile.currentDate)}"]`);
    return el;
}
class DayTableSlicer extends (0, _internalJs.Slicer) {
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
}
class DayTable extends (0, _internalJs.DateComponent) {
    constructor(){
        super(...arguments);
        this.slicer = new DayTableSlicer();
        this.tableRef = (0, _preactJs.createRef)();
    }
    render() {
        let { props, context } = this;
        return (0, _preactJs.createElement)(Table, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
}
class DayTableView extends TableView {
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, _internalJs.memoize)(buildDayTableModel);
        this.headerRef = (0, _preactJs.createRef)();
        this.tableRef = (0, _preactJs.createRef)();
    // can't override any lifecycle methods from parent
    }
    render() {
        let { options, dateProfileGenerator } = this.context;
        let { props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, _preactJs.createElement)((0, _internalJs.DayHeader), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, _preactJs.createElement)(DayTable, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
}
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, _internalJs.DaySeriesModel)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, _internalJs.DayTableModel)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}
class TableDateProfileGenerator extends (0, _internalJs.DateProfileGenerator) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props } = this;
        return buildDayTableRenderRange({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function buildDayTableRenderRange(props) {
    let { dateEnv, currentRange } = props;
    let { start, end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, _internalJs.addWeeks)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, _internalJs.addDays)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, _internalJs.diffWeeks)(lastMonthRenderStart, end));
        end = (0, _internalJs.addWeeks)(end, 6 - rowCnt);
    }
    return {
        start,
        end
    };
}
var css_248z = ":root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:\"\";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}";
(0, _internalJs.injectStyles)(css_248z);

},{"@fullcalendar/core/internal.js":"fCef8","@fullcalendar/core/preact.js":"bMX44","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bMX44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPortal", ()=>(0, _compat.createPortal));
parcelHelpers.export(exports, "createContext", ()=>(0, _internalCommonJs.af));
parcelHelpers.export(exports, "flushSync", ()=>(0, _internalCommonJs.a8));
var _preact = require("preact");
parcelHelpers.exportAll(_preact, exports);
var _compat = require("preact/compat");
var _internalCommonJs = require("./internal-common.js");

},{"preact":"hvsRZ","preact/compat":"7Rky7","./internal-common.js":"cbu5L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vjy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Draggable", ()=>ExternalDraggable);
parcelHelpers.export(exports, "ThirdPartyDraggable", ()=>ThirdPartyDraggable);
parcelHelpers.export(exports, "default", ()=>index);
var _indexJs = require("@fullcalendar/core/index.js");
var _internalJs = require("@fullcalendar/core/internal.js");
(0, _internalJs.config).touchMouseIgnoreWait = 500;
let ignoreMouseDepth = 0;
let listenerCnt = 0;
let isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ class PointerDragging {
    constructor(containerEl){
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ''; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = '';
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = (ev)=>{
            if (!this.shouldIgnoreMouse() && isPrimaryMouseButton(ev) && this.tryStart(ev)) {
                let pev = this.createEventFromMouse(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                if (!this.shouldIgnoreMove) document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            }
        };
        this.handleMouseMove = (ev)=>{
            let pev = this.createEventFromMouse(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleMouseUp = (ev)=>{
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
            this.emitter.trigger('pointerup', this.createEventFromMouse(ev));
            this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = (ev)=>{
            if (this.tryStart(ev)) {
                this.isTouchDragging = true;
                let pev = this.createEventFromTouch(ev, true);
                this.emitter.trigger('pointerdown', pev);
                this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                let targetEl = ev.target;
                if (!this.shouldIgnoreMove) targetEl.addEventListener('touchmove', this.handleTouchMove);
                targetEl.addEventListener('touchend', this.handleTouchEnd);
                targetEl.addEventListener('touchcancel', this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener('scroll', this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = (ev)=>{
            let pev = this.createEventFromTouch(ev);
            this.recordCoords(pev);
            this.emitter.trigger('pointermove', pev);
        };
        this.handleTouchEnd = (ev)=>{
            if (this.isDragging) {
                let targetEl = ev.target;
                targetEl.removeEventListener('touchmove', this.handleTouchMove);
                targetEl.removeEventListener('touchend', this.handleTouchEnd);
                targetEl.removeEventListener('touchcancel', this.handleTouchEnd);
                window.removeEventListener('scroll', this.handleTouchScroll, true); // useCaptured=true
                this.emitter.trigger('pointerup', this.createEventFromTouch(ev));
                this.cleanup(); // call last so that pointerup has access to props
                this.isTouchDragging = false;
                startIgnoringMouse();
            }
        };
        this.handleTouchScroll = ()=>{
            this.wasTouchScroll = true;
        };
        this.handleScroll = (ev)=>{
            if (!this.shouldIgnoreMove) {
                let pageX = window.scrollX - this.prevScrollX + this.prevPageX;
                let pageY = window.scrollY - this.prevScrollY + this.prevPageY;
                this.emitter.trigger('pointermove', {
                    origEvent: ev,
                    isTouch: this.isTouchDragging,
                    subjectEl: this.subjectEl,
                    pageX,
                    pageY,
                    deltaX: pageX - this.origPageX,
                    deltaY: pageY - this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, _internalJs.Emitter)();
        containerEl.addEventListener('mousedown', this.handleMouseDown);
        containerEl.addEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        listenerCreated();
    }
    destroy() {
        this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
        this.containerEl.removeEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        listenerDestroyed();
    }
    tryStart(ev) {
        let subjectEl = this.querySubjectEl(ev);
        let downEl = ev.target;
        if (subjectEl && (!this.handleSelector || (0, _internalJs.elementClosest)(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    }
    cleanup() {
        isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    }
    querySubjectEl(ev) {
        if (this.selector) return (0, _internalJs.elementClosest)(ev.target, this.selector);
        return this.containerEl;
    }
    shouldIgnoreMouse() {
        return ignoreMouseDepth || this.isTouchDragging;
    }
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    cancelTouchScroll() {
        if (this.isDragging) isWindowTouchMoveCancelled = true;
    }
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    initScrollWatch(ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener('scroll', this.handleScroll, true); // useCapture=true
        }
    }
    recordCoords(ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.scrollX;
            this.prevScrollY = window.scrollY;
        }
    }
    destroyScrollWatch() {
        if (this.shouldWatchScroll) window.removeEventListener('scroll', this.handleScroll, true); // useCaptured=true
    }
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    createEventFromMouse(ev, isFirst) {
        let deltaX = 0;
        let deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        } else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX,
            deltaY
        };
    }
    createEventFromTouch(ev, isFirst) {
        let touches = ev.touches;
        let pageX;
        let pageY;
        let deltaX = 0;
        let deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        } else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        } else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX,
            pageY,
            deltaX,
            deltaY
        };
    }
}
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function startIgnoringMouse() {
    ignoreMouseDepth += 1;
    setTimeout(()=>{
        ignoreMouseDepth -= 1;
    }, (0, _internalJs.config).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function listenerCreated() {
    listenerCnt += 1;
    if (listenerCnt === 1) window.addEventListener('touchmove', onWindowTouchMove, {
        passive: false
    });
}
function listenerDestroyed() {
    listenerCnt -= 1;
    if (!listenerCnt) window.removeEventListener('touchmove', onWindowTouchMove, {
        passive: false
    });
}
function onWindowTouchMove(ev) {
    if (isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ class ElementMirror {
    constructor(){
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    start(sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.scrollX;
        this.origScreenY = pageY - window.scrollY;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    }
    handleMove(pageX, pageY) {
        this.deltaX = pageX - window.scrollX - this.origScreenX;
        this.deltaY = pageY - window.scrollY - this.origScreenY;
        this.updateElPosition();
    }
    // can be called before start
    setIsVisible(bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = '';
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        } else if (this.isVisible) {
            if (this.mirrorEl) this.mirrorEl.style.display = 'none';
            this.isVisible = bool;
        }
    }
    // always async
    stop(needsRevertAnimation, callback) {
        let done = ()=>{
            this.cleanup();
            callback();
        };
        if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
        (this.deltaX || this.deltaY // if same coords, transition won't work
        )) this.doRevertAnimation(done, this.revertDuration);
        else setTimeout(done, 0);
    }
    doRevertAnimation(callback, revertDuration) {
        let mirrorEl = this.mirrorEl;
        let finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition = 'top ' + revertDuration + 'ms,' + 'left ' + revertDuration + 'ms';
        (0, _internalJs.applyStyle)(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top
        });
        (0, _internalJs.whenTransitionDone)(mirrorEl, ()=>{
            mirrorEl.style.transition = '';
            callback();
        });
    }
    cleanup() {
        if (this.mirrorEl) {
            (0, _internalJs.removeElement)(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    }
    updateElPosition() {
        if (this.sourceEl && this.isVisible) (0, _internalJs.applyStyle)(this.getMirrorEl(), {
            left: this.sourceElRect.left + this.deltaX,
            top: this.sourceElRect.top + this.deltaY
        });
    }
    getMirrorEl() {
        let sourceElRect = this.sourceElRect;
        let mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.style.userSelect = 'none';
            mirrorEl.style.webkitUserSelect = 'none';
            mirrorEl.style.pointerEvents = 'none';
            mirrorEl.classList.add('fc-event-dragging');
            (0, _internalJs.applyStyle)(mirrorEl, {
                position: 'fixed',
                zIndex: this.zIndex,
                visibility: '',
                boxSizing: 'border-box',
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: 'auto',
                bottom: 'auto',
                margin: 0
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    }
}
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ class ScrollGeomCache extends (0, _internalJs.ScrollController) {
    constructor(scrollController, doesListening){
        super();
        this.handleScroll = ()=>{
            this.scrollTop = this.scrollController.getScrollTop();
            this.scrollLeft = this.scrollController.getScrollLeft();
            this.handleScrollChange();
        };
        this.scrollController = scrollController;
        this.doesListening = doesListening;
        this.scrollTop = this.origScrollTop = scrollController.getScrollTop();
        this.scrollLeft = this.origScrollLeft = scrollController.getScrollLeft();
        this.scrollWidth = scrollController.getScrollWidth();
        this.scrollHeight = scrollController.getScrollHeight();
        this.clientWidth = scrollController.getClientWidth();
        this.clientHeight = scrollController.getClientHeight();
        this.clientRect = this.computeClientRect(); // do last in case it needs cached values
        if (this.doesListening) this.getEventTarget().addEventListener('scroll', this.handleScroll);
    }
    destroy() {
        if (this.doesListening) this.getEventTarget().removeEventListener('scroll', this.handleScroll);
    }
    getScrollTop() {
        return this.scrollTop;
    }
    getScrollLeft() {
        return this.scrollLeft;
    }
    setScrollTop(top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    }
    setScrollLeft(top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    }
    getClientWidth() {
        return this.clientWidth;
    }
    getClientHeight() {
        return this.clientHeight;
    }
    getScrollWidth() {
        return this.scrollWidth;
    }
    getScrollHeight() {
        return this.scrollHeight;
    }
    handleScrollChange() {}
}
class ElementScrollGeomCache extends ScrollGeomCache {
    constructor(el, doesListening){
        super(new (0, _internalJs.ElementScrollController)(el), doesListening);
    }
    getEventTarget() {
        return this.scrollController.el;
    }
    computeClientRect() {
        return (0, _internalJs.computeInnerRect)(this.scrollController.el);
    }
}
class WindowScrollGeomCache extends ScrollGeomCache {
    constructor(doesListening){
        super(new (0, _internalJs.WindowScrollController)(), doesListening);
    }
    getEventTarget() {
        return window;
    }
    computeClientRect() {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight
        };
    }
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    handleScrollChange() {
        this.clientRect = this.computeClientRect();
    }
}
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
const getTime = typeof performance === 'function' ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ class AutoScroller {
    constructor(){
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            '.fc-scroller'
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = ()=>{
            if (this.isAnimating) {
                let edge = this.computeBestEdge(this.pointerScreenX + window.scrollX, this.pointerScreenY + window.scrollY);
                if (edge) {
                    let now = getTime();
                    this.handleSide(edge, (now - this.msSinceRequest) / 1000);
                    this.requestAnimation(now);
                } else this.isAnimating = false; // will stop animation
            }
        };
    }
    start(pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    }
    handleMove(pageX, pageY) {
        if (this.isEnabled) {
            let pointerScreenX = pageX - window.scrollX;
            let pointerScreenY = pageY - window.scrollY;
            let yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            let xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) this.everMovedUp = true;
            else if (yDelta > 0) this.everMovedDown = true;
            if (xDelta < 0) this.everMovedLeft = true;
            else if (xDelta > 0) this.everMovedRight = true;
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation(getTime());
            }
        }
    }
    stop() {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (let scrollCache of this.scrollCaches)scrollCache.destroy();
            this.scrollCaches = null;
        }
    }
    requestAnimation(now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    }
    handleSide(edge, seconds) {
        let { scrollCache } = edge;
        let { edgeThreshold } = this;
        let invDistance = edgeThreshold - edge.distance;
        let velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
        this.maxVelocity * seconds;
        let sign = 1;
        switch(edge.name){
            case 'left':
                sign = -1;
            // falls through
            case 'right':
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case 'top':
                sign = -1;
            // falls through
            case 'bottom':
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    }
    // left/top are relative to document topleft
    computeBestEdge(left, top) {
        let { edgeThreshold } = this;
        let bestSide = null;
        let scrollCaches = this.scrollCaches || [];
        for (let scrollCache of scrollCaches){
            let rect = scrollCache.clientRect;
            let leftDist = left - rect.left;
            let rightDist = rect.right - left;
            let topDist = top - rect.top;
            let bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                    scrollCache,
                    name: 'top',
                    distance: topDist
                };
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                    scrollCache,
                    name: 'bottom',
                    distance: bottomDist
                };
                /*
                TODO: fix broken RTL scrolling. canScrollLeft always returning false
                https://github.com/fullcalendar/fullcalendar/issues/4837
                */ if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                    scrollCache,
                    name: 'left',
                    distance: leftDist
                };
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                    scrollCache,
                    name: 'right',
                    distance: rightDist
                };
            }
        }
        return bestSide;
    }
    buildCaches(scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map((el)=>{
            if (el === window) return new WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            return new ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    }
    queryScrollEls(scrollStartEl) {
        let els = [];
        for (let query of this.scrollQuery)if (typeof query === 'object') els.push(query);
        else /*
                TODO: in the future, always have auto-scroll happen on element where current Hit came from
                Ticket: https://github.com/fullcalendar/fullcalendar/issues/4593
                */ els.push(...Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query)));
        return els;
    }
}
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ class FeaturefulElementDragging extends (0, _internalJs.ElementDragging) {
    constructor(containerEl, selector){
        super(containerEl);
        this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        this.delay = null;
        this.minDistance = 0;
        this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        this.mirrorNeedsRevert = false;
        this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        this.isDelayEnded = false;
        this.isDistanceSurpassed = false;
        this.delayTimeoutId = null;
        this.onPointerDown = (ev)=>{
            if (!this.isDragging) {
                this.isInteracting = true;
                this.isDelayEnded = false;
                this.isDistanceSurpassed = false;
                (0, _internalJs.preventSelection)(document.body);
                (0, _internalJs.preventContextMenu)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                this.emitter.trigger('pointerdown', ev);
                if (this.isInteracting && // not destroyed via pointerdown handler
                !this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    this.mirror.setIsVisible(false); // reset. caller must set-visible
                    this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    this.startDelay(ev);
                    if (!this.minDistance) this.handleDistanceSurpassed(ev);
                }
            }
        };
        this.onPointerMove = (ev)=>{
            if (this.isInteracting) {
                this.emitter.trigger('pointermove', ev);
                if (!this.isDistanceSurpassed) {
                    let minDistance = this.minDistance;
                    let distanceSq; // current distance from the origin, squared
                    let { deltaX, deltaY } = ev;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) this.handleDistanceSurpassed(ev);
                }
                if (this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== 'scroll') {
                        this.mirror.handleMove(ev.pageX, ev.pageY);
                        this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    this.emitter.trigger('dragmove', ev);
                }
            }
        };
        this.onPointerUp = (ev)=>{
            if (this.isInteracting) {
                this.isInteracting = false;
                (0, _internalJs.allowSelection)(document.body);
                (0, _internalJs.allowContextMenu)(document.body);
                this.emitter.trigger('pointerup', ev); // can potentially set mirrorNeedsRevert
                if (this.isDragging) {
                    this.autoScroller.stop();
                    this.tryStopDrag(ev); // which will stop the mirror
                }
                if (this.delayTimeoutId) {
                    clearTimeout(this.delayTimeoutId);
                    this.delayTimeoutId = null;
                }
            }
        };
        let pointer = this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.onPointerDown);
        pointer.emitter.on('pointermove', this.onPointerMove);
        pointer.emitter.on('pointerup', this.onPointerUp);
        if (selector) pointer.selector = selector;
        this.mirror = new ElementMirror();
        this.autoScroller = new AutoScroller();
    }
    destroy() {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    }
    startDelay(ev) {
        if (typeof this.delay === 'number') this.delayTimeoutId = setTimeout(()=>{
            this.delayTimeoutId = null;
            this.handleDelayEnd(ev);
        }, this.delay); // not assignable to number!
        else this.handleDelayEnd(ev);
    }
    handleDelayEnd(ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    }
    handleDistanceSurpassed(ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    }
    tryStartDrag(ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger('dragstart', ev);
                if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
            }
        }
    }
    tryStopDrag(ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    }
    stopDrag(ev) {
        this.isDragging = false;
        this.emitter.trigger('dragend', ev);
    }
    // fill in the implementations...
    setIgnoreMove(bool) {
        this.pointer.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        this.mirror.setIsVisible(bool);
    }
    setMirrorNeedsRevert(bool) {
        this.mirrorNeedsRevert = bool;
    }
    setAutoScrollEnabled(bool) {
        this.autoScroller.isEnabled = bool;
    }
}
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ class OffsetTracker {
    constructor(el){
        this.el = el;
        this.origRect = (0, _internalJs.computeRect)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, _internalJs.getClippingParents)(el).map((scrollEl)=>new ElementScrollGeomCache(scrollEl, true));
    }
    destroy() {
        for (let scrollCache of this.scrollCaches)scrollCache.destroy();
    }
    computeLeft() {
        let left = this.origRect.left;
        for (let scrollCache of this.scrollCaches)left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        return left;
    }
    computeTop() {
        let top = this.origRect.top;
        for (let scrollCache of this.scrollCaches)top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        return top;
    }
    isWithinClipping(pageX, pageY) {
        let point = {
            left: pageX,
            top: pageY
        };
        for (let scrollCache of this.scrollCaches){
            if (!isIgnoredClipping(scrollCache.getEventTarget()) && !(0, _internalJs.pointInsideRect)(point, scrollCache.clientRect)) return false;
        }
        return true;
    }
}
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function isIgnoredClipping(node) {
    let tagName = node.tagName;
    return tagName === 'HTML' || tagName === 'BODY';
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ class HitDragging {
    constructor(dragging, droppableStore){
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.disablePointCheck = false;
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = (ev)=>{
            let { dragging } = this;
            this.initialHit = null;
            this.movingHit = null;
            this.finalHit = null;
            this.prepareHits();
            this.processFirstCoord(ev);
            if (this.initialHit || !this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                this.emitter.trigger('pointerdown', ev);
            } else dragging.setIgnoreMove(true);
        };
        this.handleDragStart = (ev)=>{
            this.emitter.trigger('dragstart', ev);
            this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = (ev)=>{
            this.emitter.trigger('dragmove', ev);
            this.handleMove(ev);
        };
        this.handlePointerUp = (ev)=>{
            this.releaseHits();
            this.emitter.trigger('pointerup', ev);
        };
        this.handleDragEnd = (ev)=>{
            if (this.movingHit) this.emitter.trigger('hitupdate', null, true, ev);
            this.finalHit = this.movingHit;
            this.movingHit = null;
            this.emitter.trigger('dragend', ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        dragging.emitter.on('dragmove', this.handleDragMove);
        dragging.emitter.on('pointerup', this.handlePointerUp);
        dragging.emitter.on('dragend', this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, _internalJs.Emitter)();
    }
    // sets initialHit
    // sets coordAdjust
    processFirstCoord(ev) {
        let origPoint = {
            left: ev.pageX,
            top: ev.pageY
        };
        let adjustedPoint = origPoint;
        let subjectEl = ev.subjectEl;
        let subjectRect;
        if (subjectEl instanceof HTMLElement) {
            subjectRect = (0, _internalJs.computeRect)(subjectEl);
            adjustedPoint = (0, _internalJs.constrainPoint)(adjustedPoint, subjectRect);
        }
        let initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                let slicedSubjectRect = (0, _internalJs.intersectRects)(subjectRect, initialHit.rect);
                if (slicedSubjectRect) adjustedPoint = (0, _internalJs.getRectCenter)(slicedSubjectRect);
            }
            this.coordAdjust = (0, _internalJs.diffPoints)(adjustedPoint, origPoint);
        } else this.coordAdjust = {
            left: 0,
            top: 0
        };
    }
    handleMove(ev, forceHandle) {
        let hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger('hitupdate', hit, false, ev);
        }
    }
    prepareHits() {
        this.offsetTrackers = (0, _internalJs.mapHash)(this.droppableStore, (interactionSettings)=>{
            interactionSettings.component.prepareHits();
            return new OffsetTracker(interactionSettings.el);
        });
    }
    releaseHits() {
        let { offsetTrackers } = this;
        for(let id in offsetTrackers)offsetTrackers[id].destroy();
        this.offsetTrackers = {};
    }
    queryHitForOffset(offsetLeft, offsetTop) {
        let { droppableStore, offsetTrackers } = this;
        let bestHit = null;
        for(let id in droppableStore){
            let component = droppableStore[id].component;
            let offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
            offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                let originLeft = offsetTracker.computeLeft();
                let originTop = offsetTracker.computeTop();
                let positionLeft = offsetLeft - originLeft;
                let positionTop = offsetTop - originTop;
                let { origRect } = offsetTracker;
                let width = origRect.right - origRect.left;
                let height = origRect.bottom - origRect.top;
                if (// must be within the element's bounds
                positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                    let hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                    (0, _internalJs.rangeContainsRange)(hit.dateProfile.activeRange, hit.dateSpan.range) && // Ensure the component we are querying for the hit is accessibly my the pointer
                    // Prevents obscured calendars (ex: under a modal dialog) from accepting hit
                    // https://github.com/fullcalendar/fullcalendar/issues/5026
                    (this.disablePointCheck || offsetTracker.el.contains(offsetTracker.el.getRootNode().elementFromPoint(// add-back origins to get coordinate relative to top-left of window viewport
                    positionLeft + originLeft - window.scrollX, positionTop + originTop - window.scrollY))) && (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    }
}
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, _internalJs.isDateSpansEqual)(hit0.dateSpan, hit1.dateSpan);
}
function buildDatePointApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.datePointTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ class DateClicking extends (0, _internalJs.Interaction) {
    constructor(settings){
        super(settings);
        this.handlePointerDown = (pev)=>{
            let { dragging } = this;
            let downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        this.handleDragEnd = (ev)=>{
            let { component } = this;
            let { pointer } = this.dragging;
            if (!pointer.wasTouchScroll) {
                let { initialHit, finalHit } = this.hitDragging;
                if (initialHit && finalHit && isHitsEqual(initialHit, finalHit)) {
                    let { context } = component;
                    let arg = Object.assign(Object.assign({}, buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger('dateClick', arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        this.dragging = new FeaturefulElementDragging(settings.el);
        this.dragging.autoScroller.isEnabled = false;
        let hitDragging = this.hitDragging = new HitDragging(this.dragging, (0, _internalJs.interactionSettingsToStore)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ class DateSelecting extends (0, _internalJs.Interaction) {
    constructor(settings){
        super(settings);
        this.dragSelection = null;
        this.handlePointerDown = (ev)=>{
            let { component, dragging } = this;
            let { options } = component.context;
            let canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? getComponentTouchDelay$1(component) : null;
        };
        this.handleDragStart = (ev)=>{
            this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            let { context } = this.component;
            let dragSelection = null;
            let isInvalid = false;
            if (hit) {
                let initialHit = this.hitDragging.initialHit;
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, _internalJs.isDateSelectionValid)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: 'SELECT_DATES',
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: 'UNSELECT_DATES'
            });
            if (!isInvalid) (0, _internalJs.enableCursor)();
            else (0, _internalJs.disableCursor)();
            if (!isFinal) this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        this.handlePointerUp = (pev)=>{
            if (this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, _internalJs.triggerDateSelect)(this.dragSelection, pev, this.component.context);
                this.dragSelection = null;
            }
        };
        let { component } = settings;
        let { options } = component.context;
        let dragging = this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new HitDragging(this.dragging, (0, _internalJs.interactionSettingsToStore)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.dragging.destroy();
    }
}
function getComponentTouchDelay$1(component) {
    let { options } = component.context;
    let delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, _internalJs.compareNumbers));
    let props = {};
    for (let transformer of dateSelectionTransformers){
        let res = transformer(hit0, hit1);
        if (res === false) return null;
        if (res) Object.assign(props, res);
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
class EventDragging extends (0, _internalJs.Interaction) {
    constructor(settings){
        super(settings);
        // internal state
        this.subjectEl = null;
        this.subjectSeg = null; // the seg being selected/dragged
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null; // the events being dragged
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let origTarget = ev.origEvent.target;
            let { component, dragging } = this;
            let { mirror } = dragging;
            let { options } = component.context;
            let initialContext = component.context;
            this.subjectEl = ev.subjectEl;
            let subjectSeg = this.subjectSeg = (0, _internalJs.getElSeg)(ev.subjectEl);
            let eventRange = this.eventRange = subjectSeg.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            this.relevantEvents = (0, _internalJs.getRelevantEvents)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, _internalJs.elementClosest)(origTarget, '.fc');
            mirror.revertDuration = options.dragRevertDuration;
            let isValid = component.isValidSegDownEl(origTarget) && !(0, _internalJs.elementClosest)(origTarget, '.fc-event-resizer'); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            this.isDragging = isValid && ev.subjectEl.classList.contains('fc-event-draggable');
        };
        this.handleDragStart = (ev)=>{
            let initialContext = this.component.context;
            let eventRange = this.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== this.component.props.eventSelection) initialContext.dispatch({
                    type: 'SELECT_EVENT',
                    eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: 'UNSELECT_EVENT'
            });
            if (this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger('eventDragStart', {
                    el: this.subjectEl,
                    event: new (0, _internalJs.EventImpl)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            if (!this.isDragging) return;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let initialContext = this.component.context;
            // states based on new hit
            let receivingContext = null;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, _internalJs.createEmptyEventStore)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                let receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = computeEventMutation(initialHit, hit, this.eventRange.instance.range.start, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, _internalJs.applyMutationToEventStore)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, _internalJs.isInteractionValid)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, _internalJs.createEmptyEventStore)();
                        }
                    }
                } else receivingContext = null;
            }
            this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, _internalJs.enableCursor)();
            else (0, _internalJs.disableCursor)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                isHitsEqual(initialHit, hit)) mutation = null;
                this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                this.dragging.setMirrorIsVisible(!hit || !this.subjectEl.getRootNode().querySelector('.fc-event-mirror'));
                // assign states based on new hit
                this.receivingContext = receivingContext;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handlePointerUp = ()=>{
            if (!this.isDragging) this.cleanup(); // because handleDragEnd won't fire
        };
        this.handleDragEnd = (ev)=>{
            if (this.isDragging) {
                let initialContext = this.component.context;
                let initialView = initialContext.viewApi;
                let { receivingContext, validMutation } = this;
                let eventDef = this.eventRange.def;
                let eventInstance = this.eventRange.instance;
                let eventApi = new (0, _internalJs.EventImpl)(initialContext, eventDef, eventInstance);
                let relevantEvents = this.relevantEvents;
                let mutatedRelevantEvents = this.mutatedRelevantEvents;
                let { finalHit } = this.hitDragging;
                this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger('eventDragStop', {
                    el: this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        let updatedEventApi = new (0, _internalJs.EventImpl)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, _internalJs.buildEventApis)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        let transformed = {};
                        for (let transformer of initialContext.getCurrentData().pluginHooks.eventDropTransformers)Object.assign(transformed, transformer(validMutation, initialContext));
                        initialContext.emitter.trigger('eventDrop', Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger('eventChange', eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        let eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, _internalJs.buildEventApis)(relevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger('eventLeave', Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger('eventRemove', eventRemoveArg);
                        let addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        let addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        let addedEventApi = new (0, _internalJs.EventImpl)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents
                        });
                        let eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, _internalJs.buildEventApis)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert () {
                                receivingContext.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger('eventAdd', eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger('eventReceive', Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger('_noEventDrop');
            }
            this.cleanup();
        };
        let { component } = this;
        let { options } = component.context;
        let dragging = this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new HitDragging(this.dragging, (0, _internalJs.interactionSettingsStore));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', this.handlePointerUp);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    // render a drag state on the next receivingCalendar
    displayDrag(nextContext, state) {
        let initialContext = this.component.context;
        let prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) prevContext.dispatch({
                type: 'SET_EVENT_DRAG',
                state: {
                    affectedEvents: state.affectedEvents,
                    mutatedEvents: (0, _internalJs.createEmptyEventStore)(),
                    isEvent: true
                }
            });
            else prevContext.dispatch({
                type: 'UNSET_EVENT_DRAG'
            });
        }
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state
        });
    }
    clearDrag() {
        let initialCalendar = this.component.context;
        let { receivingContext } = this;
        if (receivingContext) receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) initialCalendar.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    cleanup() {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    }
}
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
function computeEventMutation(hit0, hit1, eventInstanceStart, massagers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let date0 = dateSpan0.range.start;
    let date1 = dateSpan1.range.start;
    let standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, _internalJs.startOfDay)(eventInstanceStart);
        else // Moving from allDate->timed
        // Doesn't matter where on the event the drag began, mutate the event's start-date to date1
        date0 = eventInstanceStart;
    }
    let delta = (0, _internalJs.diffDates)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    let mutation = {
        datesDelta: delta,
        standardProps
    };
    for (let massager of massagers)massager(mutation, hit0, hit1);
    return mutation;
}
function getComponentTouchDelay(component) {
    let { options } = component.context;
    let delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
class EventResizing extends (0, _internalJs.Interaction) {
    constructor(settings){
        super(settings);
        // internal state
        this.draggingSegEl = null;
        this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        this.eventRange = null;
        this.relevantEvents = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let { component } = this;
            let segEl = this.querySegEl(ev);
            let seg = (0, _internalJs.getElSeg)(segEl);
            let eventRange = this.eventRange = seg.eventRange;
            this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        this.handleDragStart = (ev)=>{
            let { context } = this.component;
            let eventRange = this.eventRange;
            this.relevantEvents = (0, _internalJs.getRelevantEvents)(context.getCurrentData().eventStore, this.eventRange.instance.instanceId);
            let segEl = this.querySegEl(ev);
            this.draggingSegEl = segEl;
            this.draggingSeg = (0, _internalJs.getElSeg)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger('eventResizeStart', {
                el: segEl,
                event: new (0, _internalJs.EventImpl)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { context } = this.component;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let eventInstance = this.eventRange.instance;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, _internalJs.createEmptyEventStore)(),
                isEvent: true
            };
            if (hit) {
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, _internalJs.applyMutationToEventStore)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, _internalJs.isInteractionValid)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: 'SET_EVENT_RESIZE',
                state: interaction
            });
            else context.dispatch({
                type: 'UNSET_EVENT_RESIZE'
            });
            if (!isInvalid) (0, _internalJs.enableCursor)();
            else (0, _internalJs.disableCursor)();
            if (!isFinal) {
                if (mutation && isHitsEqual(initialHit, hit)) mutation = null;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handleDragEnd = (ev)=>{
            let { context } = this.component;
            let eventDef = this.eventRange.def;
            let eventInstance = this.eventRange.instance;
            let eventApi = new (0, _internalJs.EventImpl)(context, eventDef, eventInstance);
            let relevantEvents = this.relevantEvents;
            let mutatedRelevantEvents = this.mutatedRelevantEvents;
            context.emitter.trigger('eventResizeStop', {
                el: this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (this.validMutation) {
                let updatedEventApi = new (0, _internalJs.EventImpl)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: mutatedRelevantEvents
                });
                let eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, _internalJs.buildEventApis)(mutatedRelevantEvents, context, eventInstance),
                    revert () {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger('eventResize', Object.assign(Object.assign({}, eventChangeArg), {
                    el: this.draggingSegEl,
                    startDelta: this.validMutation.startDelta || (0, _internalJs.createDuration)(0),
                    endDelta: this.validMutation.endDelta || (0, _internalJs.createDuration)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger('eventChange', eventChangeArg);
            } else context.emitter.trigger('_noEventResize');
            // reset all internal state
            this.draggingSeg = null;
            this.relevantEvents = null;
            this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        let { component } = settings;
        let dragging = this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = '.fc-event-resizer';
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        let hitDragging = this.hitDragging = new HitDragging(this.dragging, (0, _internalJs.interactionSettingsToStore)(settings));
        hitDragging.emitter.on('pointerdown', this.handlePointerDown);
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
    }
    destroy() {
        this.dragging.destroy();
    }
    querySegEl(ev) {
        return (0, _internalJs.elementClosest)(ev.subjectEl, '.fc-event');
    }
}
function computeMutation(hit0, hit1, isFromStart, instanceRange) {
    let dateEnv = hit0.context.dateEnv;
    let date0 = hit0.dateSpan.range.start;
    let date1 = hit1.dateSpan.range.start;
    let delta = (0, _internalJs.diffDates)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
class UnselectAuto {
    constructor(context){
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = (selectInfo)=>{
            if (selectInfo.jsEvent) this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = (pev)=>{
            let unselectCancel = this.context.options.unselectCancel;
            let downEl = (0, _internalJs.getEventTargetViaRoot)(pev.origEvent);
            this.matchesCancel = !!(0, _internalJs.elementClosest)(downEl, unselectCancel);
            this.matchesEvent = !!(0, _internalJs.elementClosest)(downEl, EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = (pev)=>{
            let { context } = this;
            let { documentPointer } = this;
            let calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    let unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !this.matchesCancel)) context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !this.matchesEvent // interaction DIDN'T start on an event
                ) context.dispatch({
                    type: 'UNSELECT_EVENT'
                });
            }
            this.isRecentPointerDateSelect = false;
        };
        let documentPointer = this.documentPointer = new PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
        documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on('select', this.onSelect);
    }
    destroy() {
        this.context.emitter.off('select', this.onSelect);
        this.documentPointer.destroy();
    }
}
const OPTION_REFINERS = {
    fixedMirrorParent: (0, _internalJs.identity)
};
const LISTENER_REFINERS = {
    dateClick: (0, _internalJs.identity),
    eventDragStart: (0, _internalJs.identity),
    eventDragStop: (0, _internalJs.identity),
    eventDrop: (0, _internalJs.identity),
    eventResizeStart: (0, _internalJs.identity),
    eventResizeStop: (0, _internalJs.identity),
    eventResize: (0, _internalJs.identity),
    drop: (0, _internalJs.identity),
    eventReceive: (0, _internalJs.identity),
    eventLeave: (0, _internalJs.identity)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ class ExternalElementDragging {
    constructor(dragging, suppliedDragMeta){
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = (ev)=>{
            this.dragMeta = this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { dragging } = this.hitDragging;
            let receivingContext = null;
            let droppableEvent = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: (0, _internalJs.createEmptyEventStore)(),
                mutatedEvents: (0, _internalJs.createEmptyEventStore)(),
                isEvent: this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = computeEventForDateSpan(hit.dateSpan, this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, _internalJs.eventTupleToStore)(droppableEvent);
                    isInvalid = !(0, _internalJs.isInteractionValid)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, _internalJs.createEmptyEventStore)();
                        droppableEvent = null;
                    }
                }
            }
            this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
            if (!isInvalid) (0, _internalJs.enableCursor)();
            else (0, _internalJs.disableCursor)();
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                this.receivingContext = receivingContext;
                this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = (pev)=>{
            let { receivingContext, droppableEvent } = this;
            this.clearDrag();
            if (receivingContext && droppableEvent) {
                let finalHit = this.hitDragging.finalHit;
                let finalView = finalHit.context.viewApi;
                let dragMeta = this.dragMeta;
                receivingContext.emitter.trigger('drop', Object.assign(Object.assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    let addingEvents = (0, _internalJs.eventTupleToStore)(droppableEvent);
                    receivingContext.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: 'SELECT_EVENT',
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger('eventReceive', {
                        event: new (0, _internalJs.EventImpl)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert () {
                            receivingContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            this.receivingContext = null;
            this.droppableEvent = null;
        };
        let hitDragging = this.hitDragging = new HitDragging(dragging, (0, _internalJs.interactionSettingsStore));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    buildDragMeta(subjectEl) {
        if (typeof this.suppliedDragMeta === 'object') return (0, _internalJs.parseDragMeta)(this.suppliedDragMeta);
        if (typeof this.suppliedDragMeta === 'function') return (0, _internalJs.parseDragMeta)(this.suppliedDragMeta(subjectEl));
        return getDragMetaFromEl(subjectEl);
    }
    displayDrag(nextContext, state) {
        let prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) prevContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
        if (nextContext) nextContext.dispatch({
            type: 'SET_EVENT_DRAG',
            state
        });
    }
    clearDrag() {
        if (this.receivingContext) this.receivingContext.dispatch({
            type: 'UNSET_EVENT_DRAG'
        });
    }
    canDropElOnCalendar(el, receivingContext) {
        let dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === 'function') return dropAccept.call(receivingContext.calendarApi, el);
        if (typeof dropAccept === 'string' && dropAccept) return Boolean((0, _internalJs.elementMatches)(el, dropAccept));
        return true;
    }
}
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function computeEventForDateSpan(dateSpan, dragMeta, context) {
    let defProps = Object.assign({}, dragMeta.leftoverProps);
    for (let transform of context.pluginHooks.externalDefTransforms)Object.assign(defProps, transform(dateSpan, dragMeta));
    let { refined, extra } = (0, _internalJs.refineEventDef)(defProps, context);
    let def = (0, _internalJs.parseEventDef)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    let start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    let end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, _internalJs.getDefaultEventEnd)(dateSpan.allDay, start, context);
    let instance = (0, _internalJs.createEventInstance)(def.defId, {
        start,
        end
    });
    return {
        def,
        instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function getDragMetaFromEl(el) {
    let str = getEmbeddedElData(el, 'event');
    let obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, _internalJs.parseDragMeta)(obj);
}
(0, _internalJs.config).dataAttrPrefix = '';
function getEmbeddedElData(el, name) {
    let prefix = (0, _internalJs.config).dataAttrPrefix;
    let prefixedName = (prefix ? prefix + '-' : '') + name;
    return el.getAttribute('data-' + prefixedName) || '';
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ class ExternalDraggable {
    constructor(el, settings = {}){
        this.handlePointerDown = (ev)=>{
            let { dragging } = this;
            let { minDistance, longPressDelay } = this.settings;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, _internalJs.BASE_OPTION_DEFAULTS).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, _internalJs.BASE_OPTION_DEFAULTS).longPressDelay : 0;
        };
        this.handleDragStart = (ev)=>{
            if (ev.isTouch && this.dragging.delay && ev.subjectEl.classList.contains('fc-event')) this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
        };
        this.settings = settings;
        let dragging = this.dragging = new FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        new ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    destroy() {
        this.dragging.destroy();
    }
}
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ class InferredElementDragging extends (0, _internalJs.ElementDragging) {
    constructor(containerEl){
        super(containerEl);
        this.shouldIgnoreMove = false;
        this.mirrorSelector = '';
        this.currentMirrorEl = null;
        this.handlePointerDown = (ev)=>{
            this.emitter.trigger('pointerdown', ev);
            if (!this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            this.emitter.trigger('dragstart', ev);
        };
        this.handlePointerMove = (ev)=>{
            if (!this.shouldIgnoreMove) this.emitter.trigger('dragmove', ev);
        };
        this.handlePointerUp = (ev)=>{
            this.emitter.trigger('pointerup', ev);
            if (!this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            this.emitter.trigger('dragend', ev);
        };
        let pointer = this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', this.handlePointerDown);
        pointer.emitter.on('pointermove', this.handlePointerMove);
        pointer.emitter.on('pointerup', this.handlePointerUp);
    }
    destroy() {
        this.pointer.destroy();
    }
    setIgnoreMove(bool) {
        this.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        if (bool) // restore a previously hidden element.
        // use the reference in case the selector class has already been removed.
        {
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = '';
                this.currentMirrorEl = null;
            }
        } else {
            let mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = 'hidden';
            }
        }
    }
}
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ class ThirdPartyDraggable {
    constructor(containerOrSettings, settings){
        let containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        let dragging = this.dragging = new InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === 'string') dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = '[data-event]';
        if (typeof settings.mirrorSelector === 'string') dragging.mirrorSelector = settings.mirrorSelector;
        let externalDragging = new ExternalElementDragging(dragging, settings.eventData);
        // The hit-detection system requires that the dnd-mirror-element be pointer-events:none,
        // but this can't be guaranteed for third-party draggables, so disable
        externalDragging.hitDragging.disablePointCheck = true;
    }
    destroy() {
        this.dragging.destroy();
    }
}
var index = (0, _indexJs.createPlugin)({
    name: '@fullcalendar/interaction',
    componentInteractions: [
        DateClicking,
        DateSelecting,
        EventDragging,
        EventResizing
    ],
    calendarInteractions: [
        UnselectAuto
    ],
    elementDraggingImpl: FeaturefulElementDragging,
    optionRefiners: OPTION_REFINERS,
    listenerRefiners: LISTENER_REFINERS
});

},{"@fullcalendar/core/index.js":"dYWMT","@fullcalendar/core/internal.js":"fCef8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6JqDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, _vue.createStaticVNode)("<div class=\"page-title\"><div class=\"row\"><div class=\"col-sm-6 col-12\"><h2> Shifts Calendar </h2></div><div class=\"col-sm-6 col-12 text-end\"><a class=\"btn btn-outline-primary align-items-center me-2\" href=\"/admin/shifts\"><i class=\"fas fa-table\"></i> Table View </a><a class=\"btn btn-primary align-items-center\" href=\"/admin/shifts/new\"><i class=\"fa-regular fa-square-plus\"></i> Add New </a></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createVNode)($setup["FullCalendar"], {
                        options: $setup.calendarOptions
                    }, null, 8, [
                        "options"
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yhIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zL5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("5bb681f3da91172d");
    if (script.__esModule) script = script.default;
    script.render = require("c321a7d94f764363").render;
    require("bc1cbe826c78f8cd").default(script);
    script.__scopeId = 'data-v-f7a1b9';
    script.__file = "TaxReserve.vue";
};
initialize();
exports.default = script;

},{"5bb681f3da91172d":"4ZjwD","c321a7d94f764363":"byMfd","bc1cbe826c78f8cd":"j0JpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ZjwD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'TaxReserve',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const summaryLoaded = (0, _vue.ref)(false);
        const summary = (0, _vue.ref)(null);
        const ledgerLoaded = (0, _vue.ref)(false);
        const reportLoading = (0, _vue.ref)(false);
        const report = (0, _vue.ref)(null);
        const remittanceSaving = (0, _vue.ref)(false);
        const remittanceMessage = (0, _vue.ref)('');
        const remittanceMessageClass = (0, _vue.ref)('');
        const periodFrom = (0, _vue.ref)('');
        const periodTo = (0, _vue.ref)('');
        const remittanceAmount = (0, _vue.ref)('');
        const remittancePeriodLabel = (0, _vue.ref)('');
        const remittanceReference = (0, _vue.ref)('');
        // Every reserve figure the API returns is a dollar BigDecimal already (Xxx, not XxxMinor) — see
        // TaxReserveSummaryDto/TaxRemittancePeriodReportDto's dollar getters. Minor units only ever reach the
        // browser on the ledger table (TaxReserveEntryDto has no dollar getter), which is why the DataTable
        // column below goes through minorToCurrency instead.
        function currency(value) {
            return (0, _datatableRenderer.currency)(value);
        }
        function minorToCurrency(value) {
            return (0, _datatableRenderer.currency)(value === null || value === undefined ? null : value / 100);
        }
        const summaryCards = (0, _vue.computed)(()=>{
            if (!summary.value) return [];
            return [
                {
                    label: 'Net payable',
                    value: currency(summary.value.netPayable)
                },
                {
                    label: 'Accrued (lifetime)',
                    value: currency(summary.value.accrued)
                },
                {
                    label: 'Swept (lifetime)',
                    value: currency(summary.value.swept)
                },
                {
                    label: 'Remitted (lifetime)',
                    value: currency(summary.value.remitted)
                },
                {
                    label: 'Not yet swept',
                    value: currency(summary.value.unswept)
                },
                {
                    label: 'Next filing date',
                    value: summary.value.nextFilingDate || 'N/A'
                }
            ];
        });
        const ledgerColumns = [
            {
                data: 'effectiveAt',
                title: 'Date',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'entryType',
                title: 'Type'
            },
            {
                data: 'remitter',
                title: 'Remitter'
            },
            {
                data: 'supplyCategory',
                title: 'Category'
            },
            {
                data: 'amountMinor',
                title: 'Amount',
                render: minorToCurrency
            },
            {
                data: 'entryStatus',
                title: 'Status'
            },
            {
                data: 'reviewReason',
                title: 'Review Reason'
            }
        ];
        async function loadSummary() {
            try {
                const response = await fetch('/api/admin/tax-reserve/summary');
                if (response.ok) summary.value = await response.json();
            } catch (error) {
                console.error('Error loading tax reserve summary:', error);
            } finally{
                summaryLoaded.value = true;
            }
        }
        async function loadReport() {
            if (!periodFrom.value || !periodTo.value) return;
            reportLoading.value = true;
            try {
                // The backend period is a half-open [from, to) window. periodTo is a date-only picker value
                // ("2026-01-31"), which parses to UTC midnight at the *start* of that day -- so passed straight
                // through, an admin picking "To: Jan 31" intending to include the 31st would silently get a window
                // excluding it entirely. Advance by one day so the exclusive bound lands after the selected day.
                const from = new Date(periodFrom.value).toISOString();
                const toExclusive = new Date(periodTo.value);
                toExclusive.setUTCDate(toExclusive.getUTCDate() + 1);
                const to = toExclusive.toISOString();
                const response = await fetch(`/api/admin/tax-reserve/remittance-report?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`);
                if (response.ok) report.value = await response.json();
                else report.value = null;
            } catch (error) {
                console.error('Error loading the tax reserve remittance-period report:', error);
                report.value = null;
            } finally{
                reportLoading.value = false;
            }
        }
        async function submitRemittance() {
            remittanceSaving.value = true;
            remittanceMessage.value = '';
            try {
                const response = await fetch('/api/admin/tax-reserve/remittance', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        amount: remittanceAmount.value,
                        periodLabel: remittancePeriodLabel.value,
                        reference: remittanceReference.value
                    })
                });
                if (response.ok) {
                    remittanceMessage.value = 'Remittance recorded.';
                    remittanceMessageClass.value = 'text-success';
                    remittanceAmount.value = '';
                    remittancePeriodLabel.value = '';
                    remittanceReference.value = '';
                    await loadSummary();
                } else {
                    remittanceMessage.value = await response.text() || 'Failed to record remittance.';
                    remittanceMessageClass.value = 'text-danger';
                }
            } catch (error) {
                remittanceMessage.value = 'Failed to record remittance.';
                remittanceMessageClass.value = 'text-danger';
                console.error('Error recording an HST remittance:', error);
            } finally{
                remittanceSaving.value = false;
            }
        }
        (0, _vue.onMounted)(async ()=>{
            await loadSummary();
            ledgerLoaded.value = true;
        });
        const __returned__ = {
            summaryLoaded,
            summary,
            ledgerLoaded,
            reportLoading,
            report,
            remittanceSaving,
            remittanceMessage,
            remittanceMessageClass,
            periodFrom,
            periodTo,
            remittanceAmount,
            remittancePeriodLabel,
            remittanceReference,
            currency,
            minorToCurrency,
            summaryCards,
            ledgerColumns,
            loadSummary,
            loadReport,
            submitRemittance,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            computed: (0, _vue.computed),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get currencyRenderer () {
                return 0, _datatableRenderer.currency;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byMfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12"
};
const _hoisted_3 = {
    key: 0,
    class: "row"
};
const _hoisted_4 = {
    class: "card mb-0"
};
const _hoisted_5 = {
    class: "card-body"
};
const _hoisted_6 = {
    class: "text-muted mb-1"
};
const _hoisted_7 = {
    class: "mb-0"
};
const _hoisted_8 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_9 = {
    key: 2,
    class: "alert alert-warning"
};
const _hoisted_10 = {
    class: "col-xl-12"
};
const _hoisted_11 = {
    class: "card"
};
const _hoisted_12 = {
    class: "card-body"
};
const _hoisted_13 = {
    class: "row g-2 align-items-end mb-3"
};
const _hoisted_14 = {
    class: "col-auto"
};
const _hoisted_15 = {
    class: "col-auto"
};
const _hoisted_16 = {
    class: "col-auto"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_19 = {
    key: 0
};
const _hoisted_20 = {
    class: "table table-bordered mb-0"
};
const _hoisted_21 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_22 = {
    key: 1,
    class: "badge bg-warning text-dark"
};
const _hoisted_23 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_24 = {
    class: "col-xl-6 col-12"
};
const _hoisted_25 = {
    class: "card"
};
const _hoisted_26 = {
    class: "card-body"
};
const _hoisted_27 = {
    class: "mb-2"
};
const _hoisted_28 = {
    class: "mb-2"
};
const _hoisted_29 = {
    class: "mb-2"
};
const _hoisted_30 = [
    "disabled"
];
const _hoisted_31 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_32 = {
    class: "col-xl-12"
};
const _hoisted_33 = {
    class: "card"
};
const _hoisted_34 = {
    class: "card-body"
};
const _hoisted_35 = {
    key: 0
};
const _hoisted_36 = {
    key: 1,
    class: "text-center py-4"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "HST Reserve")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.summaryLoaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.summaryCards, (card)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        class: "col-md-4 col-6 mb-3",
                        key: card.label
                    }, [
                        (0, _vue.createElementVNode)("div", _hoisted_4, [
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                (0, _vue.createElementVNode)("h6", _hoisted_6, (0, _vue.toDisplayString)(card.label), 1),
                                (0, _vue.createElementVNode)("h4", _hoisted_7, (0, _vue.toDisplayString)(card.value), 1)
                            ])
                        ])
                    ]);
                }), 128))
            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, _cache[5] || (_cache[5] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading summary... ")
            ]))),
            $setup.summaryLoaded && $setup.summary && $setup.summary.settledRidesMissingAccrualCount > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, (0, _vue.toDisplayString)($setup.summary.settledRidesMissingAccrualCount) + " settled ride(s) in the last 12 months have no HST accrual yet. ", 1)) : (0, _vue.createCommentVNode)("", true)
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_10, [
            (0, _vue.createElementVNode)("div", _hoisted_11, [
                _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h5", null, "Remittance-period report")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_12, [
                    (0, _vue.createElementVNode)("div", _hoisted_13, [
                        (0, _vue.createElementVNode)("div", _hoisted_14, [
                            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, "From", -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                type: "date",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.periodFrom = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.periodFrom
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                            _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, "To", -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                type: "date",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.periodTo = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.periodTo
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_16, [
                            (0, _vue.createElementVNode)("button", {
                                class: "btn btn-primary",
                                disabled: $setup.reportLoading || !$setup.periodFrom || !$setup.periodTo,
                                onClick: $setup.loadReport
                            }, [
                                $setup.reportLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_18)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.reportLoading ? 'Loading...' : 'Run report'), 1)
                            ], 8, _hoisted_17)
                        ])
                    ]),
                    $setup.report ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_19, [
                        (0, _vue.createElementVNode)("table", _hoisted_20, [
                            (0, _vue.createElementVNode)("tbody", null, [
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("th", null, "Platform fee collected", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.platformFeeCollected)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("th", null, "Account invoice collected", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.accountInvoiceCollected)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("th", null, "Total collected (payable)", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.totalCollected)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("th", null, "Driver fare memo (not payable, self-filed)", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.driverFareMemo)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("th", null, "Remitted in period", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.remittedInPeriod)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("th", null, "Entry count", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.report.entryCount), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("th", null, "Current net payable (as of now)", -1)),
                                    (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.report.netPayable)), 1)
                                ]),
                                (0, _vue.createElementVNode)("tr", null, [
                                    _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("th", null, "Reconciled", -1)),
                                    (0, _vue.createElementVNode)("td", null, [
                                        $setup.report.reconciled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_21, "Yes")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22, " No \u2014 " + (0, _vue.toDisplayString)($setup.report.missingAccrualCount) + " settled ride(s) missing an accrual ", 1))
                                    ])
                                ])
                            ])
                        ])
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_23, "Choose a period and run the report."))
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_24, [
            (0, _vue.createElementVNode)("div", _hoisted_25, [
                _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h5", null, "Record a remittance")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_26, [
                    (0, _vue.createElementVNode)("div", _hoisted_27, [
                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, "Amount", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            type: "number",
                            step: "0.01",
                            min: "0",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.remittanceAmount = $event)
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.remittanceAmount
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_28, [
                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, "Period label", -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.remittancePeriodLabel = $event),
                            placeholder: "e.g. 2026-Q1"
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.remittancePeriodLabel
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_29, [
                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, [
                            (0, _vue.createTextVNode)("Reference "),
                            (0, _vue.createElementVNode)("span", {
                                class: "text-muted"
                            }, "(required \u2014 CRA's payment confirmation or a bank wire reference; this is what keeps a resubmission from double-counting)")
                        ], -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.remittanceReference = $event)
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.remittanceReference
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-primary",
                        disabled: $setup.remittanceSaving || !$setup.remittanceAmount || !$setup.remittanceReference,
                        onClick: $setup.submitRemittance
                    }, [
                        $setup.remittanceSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_31)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.remittanceSaving ? 'Saving...' : 'Record remittance'), 1)
                    ], 8, _hoisted_30),
                    $setup.remittanceMessage ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 0,
                        class: (0, _vue.normalizeClass)([
                            "mt-2",
                            $setup.remittanceMessageClass
                        ])
                    }, (0, _vue.toDisplayString)($setup.remittanceMessage), 3)) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_32, [
            (0, _vue.createElementVNode)("div", _hoisted_33, [
                _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("div", {
                    class: "card-header"
                }, [
                    (0, _vue.createElementVNode)("h5", null, "Ledger")
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_34, [
                    $setup.ledgerLoaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_35, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: '/api/datatable/tax-reserve-entries'
                            },
                            ref: "ledgerDataTable",
                            class: "table-responsive display",
                            columns: $setup.ledgerColumns
                        }, null, 512)
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_36, _cache[21] || (_cache[21] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-2"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Loading... ")
                    ])))
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j0JpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aku6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("19325e9158a09906");
    if (script.__esModule) script = script.default;
    script.render = require("365d95be00bdcdbd").render;
    require("a70151c21281b7f3").default(script);
    script.__scopeId = 'data-v-424822';
    script.__file = "DriverTaxRegistrations.vue";
};
initialize();
exports.default = script;

},{"19325e9158a09906":"1w0Qk","365d95be00bdcdbd":"8Nu5v","a70151c21281b7f3":"2raRJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1w0Qk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _datatableRenderer = require("../utility/DatatableRenderer");
const queueUrl = `/api/datatable/driver-tax-registrations`;
exports.default = {
    __name: 'DriverTaxRegistrations',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const onboardingStatusBadge = (data)=>{
            if (!data) return '<span class="badge bg-secondary">Unknown</span>';
            const statusMap = {
                'NOT_STARTED': {
                    class: 'bg-secondary',
                    label: 'Not Started'
                },
                'IN_PROGRESS': {
                    class: 'bg-warning',
                    label: 'In Progress'
                },
                'PENDING_VERIFICATION': {
                    class: 'bg-info',
                    label: 'Pending Verification'
                },
                'COMPLETE': {
                    class: 'bg-success',
                    label: 'Complete'
                },
                'REJECTED': {
                    class: 'bg-danger',
                    label: 'Rejected'
                }
            };
            const status = statusMap[data] || {
                class: 'bg-secondary',
                label: data
            };
            return `<span class="badge ${status.class}">${status.label}</span>`;
        };
        const requestStatusBadge = (data)=>{
            if (!data) return '<span class="badge bg-secondary">None</span>';
            const statusMap = {
                'SUBMITTED': {
                    class: 'bg-warning',
                    label: 'Submitted'
                },
                'IN_PROGRESS': {
                    class: 'bg-info',
                    label: 'In Progress'
                },
                'COMPLETED': {
                    class: 'bg-success',
                    label: 'Completed'
                },
                'REJECTED': {
                    class: 'bg-danger',
                    label: 'Rejected'
                },
                'SUPERSEDED': {
                    class: 'bg-secondary',
                    label: 'Superseded'
                }
            };
            const status = statusMap[data] || {
                class: 'bg-secondary',
                label: data
            };
            return `<span class="badge ${status.class}">${status.label}</span>`;
        };
        const columnDefinition = [
            {
                data: "driverName",
                title: "Driver"
            },
            {
                data: "email",
                title: "Email"
            },
            {
                data: "onboardingStatus",
                title: "Onboarding",
                render: onboardingStatusBadge
            },
            {
                data: "requestStatus",
                title: "Registration Request",
                render: requestStatusBadge
            },
            {
                data: "submittedOn",
                title: "Submitted",
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: (data, type, row)=>{
                    return `<a class="btn btn-outline-primary" href="/admin/independent-driver/${row.driverId}">
        <i class="iconly-Info-Circle icbr"></i> View Driver </a>`;
                }
            }
        ];
        const __returned__ = {
            queueUrl,
            onboardingStatusBadge,
            requestStatusBadge,
            columnDefinition,
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nu5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card height-equal-2"
};
const _hoisted_2 = {
    class: "card-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "Driver Tax Registrations")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", _hoisted_2, [
                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("p", {
                    class: "text-muted"
                }, " Independent drivers with no GST/HST number on file, plus anyone with an open registration request. ", -1)),
                (0, _vue.createVNode)($setup["DataTable"], {
                    ajax: {
                        url: $setup.queueUrl
                    },
                    ref: "queueTable",
                    class: "table-responsive display custom-datatable",
                    columns: $setup.columnDefinition
                }, null, 8, [
                    "ajax"
                ])
            ])
        ])
    ], 64);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2raRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KLVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("cad70385e32efc05");
    if (script.__esModule) script = script.default;
    script.render = require("8242ccc95fdca13c").render;
    require("5035a1580d510a52").default(script);
    script.__scopeId = 'data-v-1edfc0';
    script.__file = "InsuranceExposureReport.vue";
};
initialize();
exports.default = script;

},{"cad70385e32efc05":"1zCEz","8242ccc95fdca13c":"1gdii","5035a1580d510a52":"hl3fr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zCEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
const PREVIEW_ROW_LIMIT = 25;
exports.default = {
    __name: 'InsuranceExposureReport',
    setup (__props, { expose: __expose }) {
        __expose();
        const month = (0, _vue.ref)(defaultMonth());
        const report = (0, _vue.ref)(null);
        const isLoading = (0, _vue.ref)(false);
        const isDownloading = (0, _vue.ref)(false);
        const error = (0, _vue.ref)('');
        function defaultMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const monthNumber = String(now.getMonth() + 1).padStart(2, '0');
            return `${year}-${monthNumber}`;
        }
        const previewRideRows = (0, _vue.computed)(()=>{
            if (!report.value || !report.value.rideRows) return [];
            return report.value.rideRows.slice(0, PREVIEW_ROW_LIMIT);
        });
        function formatMinor(minor) {
            if (minor === null || minor === undefined) return 'n/a';
            return (minor / 100).toLocaleString('en-CA', {
                style: 'currency',
                currency: 'CAD'
            });
        }
        function formatPercentage(value) {
            if (value === null || value === undefined) return 'n/a';
            return `${Number(value).toFixed(2)}%`;
        }
        function formatFactor(value) {
            if (value === null || value === undefined) return 'n/a';
            return Number(value).toFixed(4);
        }
        async function loadReport() {
            isLoading.value = true;
            error.value = '';
            try {
                const response = await fetch(`/api/admin/insurance/exposure-report?month=${encodeURIComponent(month.value)}`);
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Failed to load the report');
                }
                report.value = await response.json();
            } catch (err) {
                error.value = err.message || 'Failed to load the report';
                report.value = null;
            } finally{
                isLoading.value = false;
            }
        }
        async function downloadWorkbook() {
            isDownloading.value = true;
            try {
                const response = await fetch(`/api/admin/insurance/exposure-report/export?month=${encodeURIComponent(month.value)}`);
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(text || 'Failed to download the workbook');
                }
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `northbridge-exposure-${month.value}.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } catch (err) {
                error.value = err.message || 'Failed to download the workbook';
            } finally{
                isDownloading.value = false;
            }
        }
        (0, _vue.onMounted)(loadReport);
        const __returned__ = {
            PREVIEW_ROW_LIMIT,
            month,
            report,
            isLoading,
            isDownloading,
            error,
            defaultMonth,
            previewRideRows,
            formatMinor,
            formatPercentage,
            formatFactor,
            loadReport,
            downloadWorkbook,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted)
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1gdii":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "insurance-exposure-report"
};
const _hoisted_2 = {
    class: "row mb-3"
};
const _hoisted_3 = {
    class: "col-auto"
};
const _hoisted_4 = {
    class: "col-auto align-self-end"
};
const _hoisted_5 = [
    "disabled"
];
const _hoisted_6 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_7 = {
    class: "col-auto align-self-end"
};
const _hoisted_8 = [
    "disabled"
];
const _hoisted_9 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_10 = {
    key: 0,
    class: "alert alert-danger"
};
const _hoisted_11 = {
    key: 1
};
const _hoisted_12 = {
    class: "row mb-4"
};
const _hoisted_13 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_14 = {
    class: "card stats-card"
};
const _hoisted_15 = {
    class: "card-body"
};
const _hoisted_16 = {
    class: "mb-0"
};
const _hoisted_17 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_18 = {
    class: "card stats-card"
};
const _hoisted_19 = {
    class: "card-body"
};
const _hoisted_20 = {
    class: "mb-0"
};
const _hoisted_21 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_22 = {
    class: "card stats-card"
};
const _hoisted_23 = {
    class: "card-body"
};
const _hoisted_24 = {
    class: "mb-0"
};
const _hoisted_25 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_26 = {
    class: "card stats-card"
};
const _hoisted_27 = {
    class: "card-body"
};
const _hoisted_28 = {
    class: "mb-0"
};
const _hoisted_29 = {
    key: 0,
    class: "text-success"
};
const _hoisted_30 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_31 = {
    class: "card mb-4"
};
const _hoisted_32 = {
    class: "card-body"
};
const _hoisted_33 = {
    key: 0,
    class: "row"
};
const _hoisted_34 = {
    class: "col-md-3 col-sm-6 mb-2"
};
const _hoisted_35 = {
    class: "col-md-3 col-sm-6 mb-2"
};
const _hoisted_36 = {
    class: "col-md-3 col-sm-6 mb-2"
};
const _hoisted_37 = {
    class: "col-md-3 col-sm-6 mb-2"
};
const _hoisted_38 = {
    key: 0,
    class: "text-success"
};
const _hoisted_39 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_40 = {
    key: 0,
    class: "card mb-4"
};
const _hoisted_41 = {
    class: "card-body"
};
const _hoisted_42 = {
    class: "mb-0"
};
const _hoisted_43 = {
    class: "card"
};
const _hoisted_44 = {
    class: "card-body"
};
const _hoisted_45 = {
    class: "table-responsive"
};
const _hoisted_46 = {
    class: "table table-sm"
};
const _hoisted_47 = {
    key: 2,
    class: "text-center py-5"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "Northbridge Exposure Report")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("label", {
                    for: "report-month",
                    class: "form-label"
                }, "Month", -1)),
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                    id: "report-month",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.month = $event),
                    type: "month",
                    class: "form-control",
                    onChange: $setup.loadReport
                }, null, 544), [
                    [
                        (0, _vue.vModelText),
                        $setup.month
                    ]
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_4, [
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-primary",
                    disabled: $setup.isLoading,
                    onClick: $setup.loadReport
                }, [
                    $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_6)) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isLoading ? 'Loading...' : 'Refresh'), 1)
                ], 8, _hoisted_5)
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_7, [
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-primary",
                    disabled: $setup.isDownloading || !$setup.report,
                    onClick: $setup.downloadWorkbook
                }, [
                    $setup.isDownloading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_9)) : (0, _vue.createCommentVNode)("", true),
                    (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isDownloading ? 'Preparing...' : 'Download .xlsx workbook'), 1)
                ], 8, _hoisted_8)
            ])
        ]),
        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("div", {
            class: "alert alert-secondary"
        }, " Covering note: \"Exclusive\" is reported as rides with 4 or more passengers; \"Taxi?\" is reported as \"No\" for all vehicles. ", -1)),
        $setup.error ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, (0, _vue.toDisplayString)($setup.error), 1)) : $setup.report ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
            (0, _vue.createElementVNode)("div", _hoisted_12, [
                (0, _vue.createElementVNode)("div", _hoisted_13, [
                    (0, _vue.createElementVNode)("div", _hoisted_14, [
                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "IndividualRides rows", -1)),
                            (0, _vue.createElementVNode)("h3", _hoisted_16, (0, _vue.toDisplayString)($setup.report.rideRows ? $setup.report.rideRows.length : 0), 1)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_17, [
                    (0, _vue.createElementVNode)("div", _hoisted_18, [
                        (0, _vue.createElementVNode)("div", _hoisted_19, [
                            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "IndividualDrivers rows", -1)),
                            (0, _vue.createElementVNode)("h3", _hoisted_20, (0, _vue.toDisplayString)($setup.report.driverRows ? $setup.report.driverRows.length : 0), 1)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_21, [
                    (0, _vue.createElementVNode)("div", _hoisted_22, [
                        (0, _vue.createElementVNode)("div", _hoisted_23, [
                            _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Measured deadhead factor", -1)),
                            (0, _vue.createElementVNode)("h3", _hoisted_24, (0, _vue.toDisplayString)($setup.formatFactor($setup.report.measuredDeadheadFactor)), 1),
                            _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("small", {
                                class: "text-muted"
                            }, "Internal metric only -- not part of the insurer filing", -1))
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_25, [
                    (0, _vue.createElementVNode)("div", _hoisted_26, [
                        (0, _vue.createElementVNode)("div", _hoisted_27, [
                            _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Report status", -1)),
                            (0, _vue.createElementVNode)("h3", _hoisted_28, [
                                $setup.report.discrepancies && $setup.report.discrepancies.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_29, "Clean")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_30, (0, _vue.toDisplayString)($setup.report.discrepancies ? $setup.report.discrepancies.length : 0) + " finding(s)", 1))
                            ])
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_31, [
                (0, _vue.createElementVNode)("div", _hoisted_32, [
                    _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("h5", {
                        class: "card-title"
                    }, "Reserve ledger reconciliation", -1)),
                    _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("p", {
                        class: "text-muted"
                    }, " Measured exposure (this report) against #186's accrued ledger for the same window. A delta is expected by design -- the ledger accrues a modelled figure while this report measures actuals -- so this is never treated as an equality check. ", -1)),
                    $setup.report.reconciliation ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_33, [
                        (0, _vue.createElementVNode)("div", _hoisted_34, [
                            _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Measured", -1)),
                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.formatMinor($setup.report.reconciliation.measuredAmountMinor)), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_35, [
                            _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Accrued (ledger)", -1)),
                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.formatMinor($setup.report.reconciliation.accruedAmountMinor)), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_36, [
                            _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Delta", -1)),
                            (0, _vue.createElementVNode)("h5", null, (0, _vue.toDisplayString)($setup.formatMinor($setup.report.reconciliation.deltaMinor)) + " (" + (0, _vue.toDisplayString)($setup.formatPercentage($setup.report.reconciliation.deltaPercentage)) + ")", 1)
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_37, [
                            _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted mb-1"
                            }, "Within tolerance", -1)),
                            (0, _vue.createElementVNode)("h5", null, [
                                $setup.report.reconciliation.withinTolerance ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_38, "Yes")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_39, "No"))
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ]),
            $setup.report.discrepancies && $setup.report.discrepancies.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_40, [
                (0, _vue.createElementVNode)("div", _hoisted_41, [
                    _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("h5", {
                        class: "card-title"
                    }, "Findings", -1)),
                    (0, _vue.createElementVNode)("ul", _hoisted_42, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.report.discrepancies, (finding, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                                key: index,
                                class: (0, _vue.normalizeClass)(finding.severity === 'CRITICAL' ? 'text-danger' : 'text-warning')
                            }, " [" + (0, _vue.toDisplayString)(finding.severity) + "] " + (0, _vue.toDisplayString)(finding.detail), 3);
                        }), 128))
                    ])
                ])
            ])) : (0, _vue.createCommentVNode)("", true),
            (0, _vue.createElementVNode)("div", _hoisted_43, [
                (0, _vue.createElementVNode)("div", _hoisted_44, [
                    (0, _vue.createElementVNode)("h5", {
                        class: "card-title"
                    }, "IndividualRides preview (first " + (0, _vue.toDisplayString)($setup.PREVIEW_ROW_LIMIT) + " rows)"),
                    (0, _vue.createElementVNode)("div", _hoisted_45, [
                        (0, _vue.createElementVNode)("table", _hoisted_46, [
                            _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("thead", null, [
                                (0, _vue.createElementVNode)("tr", null, [
                                    (0, _vue.createElementVNode)("th", null, "#"),
                                    (0, _vue.createElementVNode)("th", null, "Pickup point"),
                                    (0, _vue.createElementVNode)("th", null, "Make"),
                                    (0, _vue.createElementVNode)("th", null, "Model"),
                                    (0, _vue.createElementVNode)("th", null, "Year"),
                                    (0, _vue.createElementVNode)("th", null, "Age"),
                                    (0, _vue.createElementVNode)("th", null, "Taxi?")
                                ])
                            ], -1)),
                            (0, _vue.createElementVNode)("tbody", null, [
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.previewRideRows, (row)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                        key: row.rideId
                                    }, [
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.sequentialNumber), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.pickupAddress), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.make), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.model), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.year), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.driverAgeYears), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.taxi), 1)
                                    ]);
                                }), 128))
                            ])
                        ])
                    ])
                ])
            ])
        ])) : $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_47, _cache[15] || (_cache[15] = [
            (0, _vue.createElementVNode)("div", {
                class: "spinner-border text-primary",
                role: "status"
            }, [
                (0, _vue.createElementVNode)("span", {
                    class: "visually-hidden"
                }, "Loading...")
            ], -1)
        ]))) : (0, _vue.createCommentVNode)("", true)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hl3fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPc6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b3b7450c3501a3e3");
    if (script.__esModule) script = script.default;
    script.render = require("994106dda0e0f178").render;
    require("4e776ab07963c4bc").default(script);
    script.__scopeId = 'data-v-abb447';
    script.__file = "ReserveDashboard.vue";
};
initialize();
exports.default = script;

},{"b3b7450c3501a3e3":"0NkxU","994106dda0e0f178":"jifuI","4e776ab07963c4bc":"7wv3G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0NkxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _reservePoolCardVue = require("./ReservePoolCard.vue");
var _reservePoolCardVueDefault = parcelHelpers.interopDefault(_reservePoolCardVue);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'ReserveDashboard',
    setup (__props, { expose: __expose }) {
        __expose();
        const dashboard = (0, _vue.ref)(null);
        const isLoading = (0, _vue.ref)(false);
        const acknowledging = (0, _vue.ref)(null);
        function currency(value) {
            return (0, _datatableRenderer.currency)(value);
        }
        function dateTime(value) {
            if (!value) return '';
            return new Date(value).toLocaleString();
        }
        function alertKindLabel(kind) {
            return ({
                RESERVE_COVERAGE: 'Reserve coverage',
                SWEEP_LAG: 'Sweep lag'
            })[kind] ?? kind;
        }
        const netPositionDisplay = (0, _vue.computed)(()=>{
            if (!dashboard.value || !dashboard.value.operatingBalance || !dashboard.value.operatingBalance.available || dashboard.value.netPositionGenuinelyOurs === null || dashboard.value.netPositionGenuinelyOurs === undefined) return "\u2014";
            return currency(dashboard.value.netPositionGenuinelyOurs);
        });
        const operatingTotalDisplay = (0, _vue.computed)(()=>{
            if (!dashboard.value || !dashboard.value.operatingBalance || !dashboard.value.operatingBalance.available) return "\u2014";
            return currency(dashboard.value.operatingBalance.total);
        });
        const netPositionClass = (0, _vue.computed)(()=>{
            if (!dashboard.value || dashboard.value.netPositionGenuinelyOurs === null || dashboard.value.netPositionGenuinelyOurs === undefined) return '';
            return Number(dashboard.value.netPositionGenuinelyOurs) < 0 ? 'text-danger' : 'text-success';
        });
        async function loadDashboard(refresh) {
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/reserves/summary${refresh ? '?refresh=true' : ''}`);
                if (response.ok) dashboard.value = await response.json();
            } catch (error) {
                console.error('Error loading the reserve dashboard:', error);
            } finally{
                isLoading.value = false;
            }
        }
        async function acknowledgeAlert(alert) {
            acknowledging.value = alert.id;
            try {
                const response = await fetch(`/api/admin/reserves/alerts/${alert.id}/acknowledge`, {
                    method: 'POST'
                });
                if (response.ok) await loadDashboard(true);
            } catch (error) {
                console.error('Error acknowledging reserve alert:', error);
            } finally{
                acknowledging.value = null;
            }
        }
        (0, _vue.onMounted)(()=>{
            loadDashboard(false);
        });
        const __returned__ = {
            dashboard,
            isLoading,
            acknowledging,
            currency,
            dateTime,
            alertKindLabel,
            netPositionDisplay,
            operatingTotalDisplay,
            netPositionClass,
            loadDashboard,
            acknowledgeAlert,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            ReservePoolCard: (0, _reservePoolCardVueDefault.default),
            get currencyRenderer () {
                return 0, _datatableRenderer.currency;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","./ReservePoolCard.vue":"dkl8h","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dkl8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("ef5be9d7dc58a39a");
    if (script.__esModule) script = script.default;
    script.render = require("92bd8a7d0d6080da").render;
    require("7ea525b00ae1bae6").default(script);
    script.__scopeId = 'data-v-221e77';
    script.__file = "ReservePoolCard.vue";
};
initialize();
exports.default = script;

},{"ef5be9d7dc58a39a":"5urlK","92bd8a7d0d6080da":"gTndb","7ea525b00ae1bae6":"gO1om","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5urlK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    __name: 'ReservePoolCard',
    props: {
        title: {
            type: String,
            required: true
        },
        available: {
            type: Boolean,
            default: true
        },
        unavailableReason: {
            type: String,
            default: ''
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTndb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card mb-3 h-100"
};
const _hoisted_2 = {
    class: "card-header"
};
const _hoisted_3 = {
    class: "mb-0"
};
const _hoisted_4 = {
    class: "card-body"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_7 = {
    key: 0,
    class: "text-muted small mb-0"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("h5", _hoisted_3, (0, _vue.toDisplayString)($props.title), 1)
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_4, [
            $props.available ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, [
                _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("p", {
                    class: "text-muted mb-1"
                }, "Not yet available", -1)),
                $props.unavailableReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_7, (0, _vue.toDisplayString)($props.unavailableReason), 1)) : (0, _vue.createCommentVNode)("", true)
            ]))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gO1om":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jifuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "page-title"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-12 d-flex justify-content-between align-items-center flex-wrap gap-2"
};
const _hoisted_5 = [
    "disabled"
];
const _hoisted_6 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_7 = {
    key: 0,
    class: "col-xl-12"
};
const _hoisted_8 = {
    class: "small"
};
const _hoisted_9 = [
    "disabled",
    "onClick"
];
const _hoisted_10 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_11 = {
    key: 1,
    class: "col-xl-12 text-center py-4"
};
const _hoisted_12 = {
    class: "col-xl-12"
};
const _hoisted_13 = {
    class: "card mb-3"
};
const _hoisted_14 = {
    class: "card-body"
};
const _hoisted_15 = {
    class: "text-muted small mb-0"
};
const _hoisted_16 = {
    key: 0
};
const _hoisted_17 = {
    key: 0,
    class: "text-muted small mb-0"
};
const _hoisted_18 = {
    key: 1,
    class: "text-danger small mb-0"
};
const _hoisted_19 = {
    key: 2,
    class: "text-muted small mb-0"
};
const _hoisted_20 = {
    class: "col-xl-4 col-md-6"
};
const _hoisted_21 = {
    class: "table table-sm mb-2"
};
const _hoisted_22 = {
    key: 0,
    class: "border-top pt-2"
};
const _hoisted_23 = {
    class: "mb-1"
};
const _hoisted_24 = {
    class: "text-muted small mb-0"
};
const _hoisted_25 = {
    key: 1,
    class: "border-top pt-2 text-muted small"
};
const _hoisted_26 = {
    class: "col-xl-4 col-md-6"
};
const _hoisted_27 = {
    class: "table table-sm mb-0"
};
const _hoisted_28 = {
    key: 0,
    class: "alert alert-warning mt-2 mb-0 py-1 px-2 small"
};
const _hoisted_29 = {
    class: "col-xl-4 col-md-6"
};
const _hoisted_30 = {
    class: "table table-sm mb-2"
};
const _hoisted_31 = {
    class: "table table-sm mb-0"
};
const _hoisted_32 = {
    key: 0,
    class: "alert alert-warning mt-2 mb-0 py-1 px-2 small"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("h2", null, "Reserves", -1)),
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-outline-primary btn-sm",
                        disabled: $setup.isLoading,
                        onClick: _cache[0] || (_cache[0] = ($event)=>$setup.loadDashboard(true))
                    }, [
                        $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_6)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isLoading ? 'Refreshing...' : 'Refresh'), 1)
                    ], 8, _hoisted_5)
                ])
            ])
        ]),
        $setup.dashboard && $setup.dashboard.activeAlerts && $setup.dashboard.activeAlerts.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.dashboard.activeAlerts, (alert)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: alert.id,
                    class: (0, _vue.normalizeClass)([
                        "alert d-flex justify-content-between align-items-center flex-wrap gap-2",
                        alert.severity === 'CRITICAL' ? 'alert-danger' : 'alert-warning'
                    ])
                }, [
                    (0, _vue.createElementVNode)("div", null, [
                        (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.alertKindLabel(alert.alertKind)) + " \u2014 " + (0, _vue.toDisplayString)(alert.severity), 1),
                        (0, _vue.createElementVNode)("div", _hoisted_8, (0, _vue.toDisplayString)(alert.detail), 1)
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-sm btn-light",
                        disabled: $setup.acknowledging === alert.id || alert.status === 'ACKNOWLEDGED',
                        onClick: ($event)=>$setup.acknowledgeAlert(alert)
                    }, [
                        $setup.acknowledging === alert.id ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_10)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)(alert.status === 'ACKNOWLEDGED' ? 'Acknowledged' : $setup.acknowledging === alert.id ? 'Acknowledging...' : 'Acknowledge'), 1)
                    ], 8, _hoisted_9)
                ], 2);
            }), 128))
        ])) : (0, _vue.createCommentVNode)("", true),
        !$setup.dashboard ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, _cache[2] || (_cache[2] = [
            (0, _vue.createElementVNode)("span", {
                class: "spinner-border spinner-border-sm me-2"
            }, null, -1),
            (0, _vue.createTextVNode)(" Loading reserves... ")
        ]))) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 2
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_12, [
                (0, _vue.createElementVNode)("div", _hoisted_13, [
                    (0, _vue.createElementVNode)("div", _hoisted_14, [
                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("h6", {
                            class: "text-muted mb-1"
                        }, "Net position genuinely ours", -1)),
                        (0, _vue.createElementVNode)("h2", {
                            class: (0, _vue.normalizeClass)([
                                "mb-1",
                                $setup.netPositionClass
                            ])
                        }, (0, _vue.toDisplayString)($setup.netPositionDisplay), 3),
                        (0, _vue.createElementVNode)("p", _hoisted_15, [
                            (0, _vue.createTextVNode)(" Operating balance (" + (0, _vue.toDisplayString)($setup.operatingTotalDisplay) + ") minus outstanding obligations (" + (0, _vue.toDisplayString)($setup.currency($setup.dashboard.totalOutstandingObligations)) + ") ", 1),
                            !$setup.dashboard.totalOutstandingObligationsComplete ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_16, " \u2014 excludes " + (0, _vue.toDisplayString)(($setup.dashboard.excludedPools || []).join(', ')) + " (unavailable) ", 1)) : (0, _vue.createCommentVNode)("", true)
                        ]),
                        $setup.dashboard.operatingBalance && $setup.dashboard.operatingBalance.available ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_17, " Stripe platform balance (available + pending), as of " + (0, _vue.toDisplayString)($setup.dateTime($setup.dashboard.operatingBalance.asOf)) + ". Excludes cash already paid out to Asher's bank. ", 1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_18, " Operating balance unavailable" + (0, _vue.toDisplayString)($setup.dashboard.operatingBalance && $setup.dashboard.operatingBalance.unavailableReason ? ': ' + $setup.dashboard.operatingBalance.unavailableReason : '') + " \u2014 alerts are skipped while this is the case. ", 1)),
                        $setup.dashboard.coverageRatio !== null && $setup.dashboard.coverageRatio !== undefined ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_19, " Coverage ratio: " + (0, _vue.toDisplayString)(Number($setup.dashboard.coverageRatio).toFixed(2)) + "x ", 1)) : (0, _vue.createCommentVNode)("", true)
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_20, [
                (0, _vue.createVNode)($setup["ReservePoolCard"], {
                    title: "Insurance reserve",
                    available: $setup.dashboard.insurance.available,
                    "unavailable-reason": $setup.dashboard.insurance.unavailableReason
                }, {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.createElementVNode)("table", _hoisted_21, [
                                (0, _vue.createElementVNode)("tbody", null, [
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("th", null, "Accrued", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.accrued)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("th", null, "Swept", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.swept)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("th", null, "Paid", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.paid)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[7] || (_cache[7] = (0, _vue.createElementVNode)("th", null, "At risk (unswept)", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.atRisk)), 1)
                                    ])
                                ])
                            ]),
                            $setup.dashboard.insurance.projectionAvailable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_22, [
                                _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("h6", {
                                    class: "text-muted mb-1"
                                }, [
                                    (0, _vue.createTextVNode)(" Projected true-up "),
                                    (0, _vue.createElementVNode)("span", {
                                        class: "badge bg-light text-dark"
                                    }, "projection, not a bill")
                                ], -1)),
                                (0, _vue.createElementVNode)("p", _hoisted_23, [
                                    (0, _vue.createElementVNode)("strong", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.projectedTrueUp)), 1)
                                ]),
                                (0, _vue.createElementVNode)("p", _hoisted_24, " Run rate " + (0, _vue.toDisplayString)($setup.currency($setup.dashboard.insurance.dailyRunRate)) + "/day over the trailing " + (0, _vue.toDisplayString)($setup.dashboard.insurance.trailingWindowDays) + " days, " + (0, _vue.toDisplayString)($setup.dashboard.insurance.daysRemainingInPolicyPeriod) + " day(s) remaining in the policy period (ends " + (0, _vue.toDisplayString)($setup.dashboard.insurance.policyPeriodEndDate) + "). ", 1)
                            ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_25, " Projected true-up not available" + (0, _vue.toDisplayString)($setup.dashboard.insurance.projectionUnavailableReason ? ': ' + $setup.dashboard.insurance.projectionUnavailableReason : '') + ". ", 1))
                        ]),
                    _: 1
                }, 8, [
                    "available",
                    "unavailable-reason"
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_26, [
                (0, _vue.createVNode)($setup["ReservePoolCard"], {
                    title: "HST reserve",
                    available: $setup.dashboard.tax.available,
                    "unavailable-reason": $setup.dashboard.tax.unavailableReason
                }, {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.createElementVNode)("table", _hoisted_27, [
                                (0, _vue.createElementVNode)("tbody", null, [
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("th", null, "Accrued", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.tax.accrued)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("th", null, "Swept", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.tax.swept)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("th", null, "Remitted", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.tax.remitted)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("th", null, "Net payable", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.tax.netPayable)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("th", null, "Not yet swept", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.tax.unswept)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("th", null, "Next filing date", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.dashboard.tax.nextFilingDate || 'N/A') + " (" + (0, _vue.toDisplayString)($setup.dashboard.tax.filingFrequency) + ")", 1)
                                    ])
                                ])
                            ]),
                            $setup.dashboard.tax.settledRidesMissingAccrualCount > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_28, (0, _vue.toDisplayString)($setup.dashboard.tax.settledRidesMissingAccrualCount) + " settled ride(s) missing an HST accrual. ", 1)) : (0, _vue.createCommentVNode)("", true)
                        ]),
                    _: 1
                }, 8, [
                    "available",
                    "unavailable-reason"
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_29, [
                (0, _vue.createVNode)($setup["ReservePoolCard"], {
                    title: "Wallet liability",
                    available: true
                }, {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.createElementVNode)("table", _hoisted_30, [
                                (0, _vue.createElementVNode)("tbody", null, [
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("th", null, "Rider funds (refundable)", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.riderFunds)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("th", null, "Promotional credit (not refundable)", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.promotionalCredit)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("th", null, "Total wallet liability", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.totalLiability)), 1)
                                    ])
                                ])
                            ]),
                            _cache[23] || (_cache[23] = (0, _vue.createElementVNode)("p", {
                                class: "text-muted small"
                            }, " Only rider funds count against the operating balance above \u2014 promotional credit is Asher's own promised discount, not cash owed back. ", -1)),
                            (0, _vue.createElementVNode)("table", _hoisted_31, [
                                (0, _vue.createElementVNode)("tbody", null, [
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("th", null, "Purchased funds", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.purchasedFunds)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("th", null, "Refund credit", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.refundCredit)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("th", null, "Promotional credit", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.promotionalCreditOnly)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[21] || (_cache[21] = (0, _vue.createElementVNode)("th", null, "Support credit", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.supportCredit)), 1)
                                    ]),
                                    (0, _vue.createElementVNode)("tr", null, [
                                        _cache[22] || (_cache[22] = (0, _vue.createElementVNode)("th", null, "Referral credit", -1)),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.referralCredit)), 1)
                                    ])
                                ])
                            ]),
                            $setup.dashboard.wallet.hasDrift ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_32, " Category totals disagree with the wallet ledger cross-check by " + (0, _vue.toDisplayString)($setup.currency($setup.dashboard.wallet.driftAmount)) + ". ", 1)) : (0, _vue.createCommentVNode)("", true)
                        ]),
                    _: 1
                })
            ])
        ], 64))
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wv3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tYXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("6682f8c7bd9648d1");
    if (script.__esModule) script = script.default;
    script.render = require("3a061a154f5b8b42").render;
    require("4351eb7d32bf47ec").default(script);
    script.__scopeId = 'data-v-c67a2d';
    script.__file = "Wallets.vue";
};
initialize();
exports.default = script;

},{"6682f8c7bd9648d1":"jICdv","3a061a154f5b8b42":"hk1VH","4351eb7d32bf47ec":"aRhWt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jICdv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'Wallets',
    setup (__props, { expose: __expose }) {
        __expose();
        const query = (0, _vue.ref)('');
        const status = (0, _vue.ref)(null);
        const rows = (0, _vue.ref)([]);
        const page = (0, _vue.ref)(1);
        const totalPages = (0, _vue.ref)(0);
        const totalRows = (0, _vue.ref)(0);
        const hasNext = (0, _vue.ref)(false);
        const isLoading = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleDateString() : '';
        // Server-searched, server-paged (the plan's deliberate departure from DataTables.net for this
        // surface — WalletDao has no unpaged finder, and the list becomes one row per rider at full
        // rollout). A query under three characters is sent as blank; the server treats it the same way and
        // WalletAdminValidator enforces the floor independently.
        const load = async (targetPage)=>{
            const trimmed = query.value.trim();
            if (trimmed.length > 0 && trimmed.length < 3) return;
            isLoading.value = true;
            try {
                const params = new URLSearchParams();
                if (trimmed.length >= 3) params.set('q', trimmed);
                if (status.value) params.set('status', status.value);
                params.set('page', String(targetPage));
                const response = await fetch(`/api/admin/wallets?${params.toString()}`);
                if (response.ok) {
                    const data = await response.json();
                    rows.value = data.items || [];
                    page.value = data.page || 1;
                    totalPages.value = data.totalPages || 0;
                    totalRows.value = data.totalRows || 0;
                    hasNext.value = !!data.hasNext;
                }
            } catch (error) {
                console.error('Error loading wallets:', error);
            } finally{
                isLoading.value = false;
            }
        };
        const onSearchInput = (0, _lodashDefault.default).debounce(()=>load(1), 350);
        (0, _vue.onMounted)(()=>load(1));
        const __returned__ = {
            query,
            status,
            rows,
            page,
            totalPages,
            totalRows,
            hasNext,
            isLoading,
            formatDate,
            load,
            onSearchInput,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get _ () {
                return 0, _lodashDefault.default;
            },
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            },
            get walletStatus () {
                return 0, _datatableRenderer.walletStatus;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","lodash":"3hMBK","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hk1VH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body social-list filter-cards-view"
};
const _hoisted_5 = {
    class: "row mb-3"
};
const _hoisted_6 = {
    class: "col-md-6"
};
const _hoisted_7 = {
    class: "col-md-3"
};
const _hoisted_8 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_9 = {
    key: 1,
    class: "text-muted text-center py-4"
};
const _hoisted_10 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_11 = {
    class: "table table-borderless"
};
const _hoisted_12 = [
    "innerHTML"
];
const _hoisted_13 = [
    "innerHTML"
];
const _hoisted_14 = [
    "innerHTML"
];
const _hoisted_15 = [
    "href"
];
const _hoisted_16 = {
    key: 3,
    class: "d-flex justify-content-between align-items-center mt-2"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    class: "text-muted small"
};
const _hoisted_19 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[10] || (_cache[10] = (0, _vue.createStaticVNode)("<div class=\"page-title\"><div class=\"row\"><div class=\"col-sm-6 col-12\"><h2>Wallets</h2></div><div class=\"col-sm-6 col-12 text-end\"><a class=\"btn btn-outline-primary\" href=\"/admin/wallets/approvals\"><i class=\"fa-solid fa-check-double\"></i> Approval Queue </a></div></div></div>", 1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                type: "search",
                                class: "form-control",
                                placeholder: "Search by rider name, email, phone or wallet id (min 3 characters)",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.query = $event),
                                onInput: _cache[1] || (_cache[1] = (...args)=>$setup.onSearchInput && $setup.onSearchInput(...args))
                            }, null, 544), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.query
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_7, [
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.status = $event),
                                onChange: _cache[3] || (_cache[3] = ()=>$setup.load(1))
                            }, _cache[6] || (_cache[6] = [
                                (0, _vue.createStaticVNode)("<option>All statuses</option><option value=\"ACTIVE\">Active</option><option value=\"FROZEN\">Frozen</option><option value=\"SUSPENDED\">Suspended</option><option value=\"CLOSED\">Closed</option>", 5)
                            ]), 544), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.status
                                ]
                            ])
                        ])
                    ]),
                    $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, _cache[7] || (_cache[7] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-2"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Loading... ")
                    ]))) : $setup.rows.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, "No wallets match this search.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, [
                        (0, _vue.createElementVNode)("table", _hoisted_11, [
                            _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("thead", null, [
                                (0, _vue.createElementVNode)("tr", null, [
                                    (0, _vue.createElementVNode)("th", null, "Rider"),
                                    (0, _vue.createElementVNode)("th", null, "Email"),
                                    (0, _vue.createElementVNode)("th", null, "Phone"),
                                    (0, _vue.createElementVNode)("th", null, "Status"),
                                    (0, _vue.createElementVNode)("th", null, "Available"),
                                    (0, _vue.createElementVNode)("th", null, "Total"),
                                    (0, _vue.createElementVNode)("th", null, "Provisioned"),
                                    (0, _vue.createElementVNode)("th")
                                ])
                            ], -1)),
                            (0, _vue.createElementVNode)("tbody", null, [
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.rows, (row)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                        key: row.walletId
                                    }, [
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.riderDisplayName || 'N/A'), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.maskedEmail || ''), 1),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.maskedPhone || ''), 1),
                                        (0, _vue.createElementVNode)("td", {
                                            innerHTML: $setup.walletStatus(row.status)
                                        }, null, 8, _hoisted_12),
                                        (0, _vue.createElementVNode)("td", {
                                            innerHTML: $setup.minorCurrency(row.availableBalanceMinor)
                                        }, null, 8, _hoisted_13),
                                        (0, _vue.createElementVNode)("td", {
                                            innerHTML: $setup.minorCurrency(row.totalBalanceMinor)
                                        }, null, 8, _hoisted_14),
                                        (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatDate(row.provisionedOn)), 1),
                                        (0, _vue.createElementVNode)("td", null, [
                                            (0, _vue.createElementVNode)("a", {
                                                class: "btn btn-sm btn-outline-primary",
                                                href: `/admin/wallets/${row.walletId}`
                                            }, _cache[8] || (_cache[8] = [
                                                (0, _vue.createElementVNode)("i", {
                                                    class: "fas fa-eye"
                                                }, null, -1),
                                                (0, _vue.createTextVNode)(" View ")
                                            ]), 8, _hoisted_15)
                                        ])
                                    ]);
                                }), 128))
                            ])
                        ])
                    ])),
                    $setup.totalPages > 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_16, [
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-secondary btn-sm",
                            disabled: $setup.page <= 1,
                            onClick: _cache[4] || (_cache[4] = ($event)=>$setup.load($setup.page - 1))
                        }, "Previous", 8, _hoisted_17),
                        (0, _vue.createElementVNode)("span", _hoisted_18, "Page " + (0, _vue.toDisplayString)($setup.page) + " of " + (0, _vue.toDisplayString)($setup.totalPages) + " (" + (0, _vue.toDisplayString)($setup.totalRows) + " wallets)", 1),
                        (0, _vue.createElementVNode)("button", {
                            class: "btn btn-outline-secondary btn-sm",
                            disabled: !$setup.hasNext,
                            onClick: _cache[5] || (_cache[5] = ($event)=>$setup.load($setup.page + 1))
                        }, "Next", 8, _hoisted_19)
                    ])) : (0, _vue.createCommentVNode)("", true)
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aRhWt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ki5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b0681370d953d10d");
    if (script.__esModule) script = script.default;
    script.render = require("4e9c45217b397e97").render;
    require("ccf6ca86cbb166d0").default(script);
    script.__scopeId = 'data-v-22ab28';
    script.__file = "WalletDetail.vue";
};
initialize();
exports.default = script;

},{"b0681370d953d10d":"kwnKS","4e9c45217b397e97":"1ISu7","ccf6ca86cbb166d0":"hhLsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kwnKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatableRenderer = require("../utility/DatatableRenderer");
var _walletFreezeModalVue = require("./WalletFreezeModal.vue");
var _walletFreezeModalVueDefault = parcelHelpers.interopDefault(_walletFreezeModalVue);
var _walletAdjustmentModalVue = require("./WalletAdjustmentModal.vue");
var _walletAdjustmentModalVueDefault = parcelHelpers.interopDefault(_walletAdjustmentModalVue);
var _walletLedgerTableVue = require("./WalletLedgerTable.vue");
var _walletLedgerTableVueDefault = parcelHelpers.interopDefault(_walletLedgerTableVue);
var _walletTopUpsPanelVue = require("./WalletTopUpsPanel.vue");
var _walletTopUpsPanelVueDefault = parcelHelpers.interopDefault(_walletTopUpsPanelVue);
var _walletRideLinksPanelVue = require("./WalletRideLinksPanel.vue");
var _walletRideLinksPanelVueDefault = parcelHelpers.interopDefault(_walletRideLinksPanelVue);
var _walletNotesPanelVue = require("./WalletNotesPanel.vue");
var _walletNotesPanelVueDefault = parcelHelpers.interopDefault(_walletNotesPanelVue);
var _walletAuditLogTableVue = require("./WalletAuditLogTable.vue");
var _walletAuditLogTableVueDefault = parcelHelpers.interopDefault(_walletAuditLogTableVue);
var _walletFinancePanelVue = require("./WalletFinancePanel.vue");
var _walletFinancePanelVueDefault = parcelHelpers.interopDefault(_walletFinancePanelVue);
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'WalletDetail',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const wallet = (0, _vue.ref)(null);
        const isLoading = (0, _vue.ref)(false);
        const loadWallet = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}`);
                if (response.ok) wallet.value = await response.json();
                else wallet.value = null;
            } catch (error) {
                console.error('Error loading wallet:', error);
                wallet.value = null;
            } finally{
                isLoading.value = false;
            }
        };
        const onWalletUpdated = (updated)=>{
            wallet.value = updated;
        };
        const onRequestCreated = ()=>{
            (0, _toastNotificationUtility.showToast)({
                title: 'Request submitted',
                body: 'Find it on the Wallet Approvals queue once a second admin is ready to act on it.',
                type: (0, _toastNotificationUtility.notificationType).SUCCESS
            });
        };
        (0, _vue.onMounted)(loadWallet);
        const __returned__ = {
            props,
            wallet,
            isLoading,
            loadWallet,
            onWalletUpdated,
            onRequestCreated,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            },
            get walletStatus () {
                return 0, _datatableRenderer.walletStatus;
            },
            WalletFreezeModal: (0, _walletFreezeModalVueDefault.default),
            WalletAdjustmentModal: (0, _walletAdjustmentModalVueDefault.default),
            WalletLedgerTable: (0, _walletLedgerTableVueDefault.default),
            WalletTopUpsPanel: (0, _walletTopUpsPanelVueDefault.default),
            WalletRideLinksPanel: (0, _walletRideLinksPanelVueDefault.default),
            WalletNotesPanel: (0, _walletNotesPanelVueDefault.default),
            WalletAuditLogTable: (0, _walletAuditLogTableVueDefault.default),
            WalletFinancePanel: (0, _walletFinancePanelVueDefault.default),
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/DatatableRenderer":"gfmyC","./WalletFreezeModal.vue":"8jnvf","./WalletAdjustmentModal.vue":"bZUJG","./WalletLedgerTable.vue":"4wPb3","./WalletTopUpsPanel.vue":"1ZdGq","./WalletRideLinksPanel.vue":"iIZxa","./WalletNotesPanel.vue":"6tqgy","./WalletAuditLogTable.vue":"ioIXy","./WalletFinancePanel.vue":"0210d","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8jnvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("1807e4629982a324");
    if (script.__esModule) script = script.default;
    script.render = require("ff67e3e5a8269a87").render;
    require("5c395d945a0fffbd").default(script);
    script.__scopeId = 'data-v-8925ab';
    script.__file = "WalletFreezeModal.vue";
};
initialize();
exports.default = script;

},{"1807e4629982a324":"5CKhG","ff67e3e5a8269a87":"4Obbx","5c395d945a0fffbd":"eHotl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5CKhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _bootstrap = require("bootstrap");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'WalletFreezeModal',
    props: {
        walletId: {
            type: String,
            required: true
        },
        status: {
            type: String,
            default: null
        }
    },
    emits: [
        'updated'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const modalId = (0, _vue.computed)(()=>`wallet-freeze-modal-${props.walletId}`);
        const isFreezing = (0, _vue.computed)(()=>props.status === 'ACTIVE');
        const reason = (0, _vue.ref)('');
        const isSaving = (0, _vue.ref)(false);
        const submit = async ()=>{
            if (!reason.value.trim() || isSaving.value) return;
            isSaving.value = true;
            try {
                const action = isFreezing.value ? 'freeze' : 'unfreeze';
                const response = await fetch(`/api/admin/wallets/${props.walletId}/${action}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        reason: reason.value.trim()
                    })
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || `Unable to ${action} wallet.`,
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 5000
                    });
                    return;
                }
                const updated = await response.json();
                reason.value = '';
                const modalEl = document.getElementById(modalId.value);
                const instance = (0, _bootstrap.Modal).getInstance(modalEl) || new (0, _bootstrap.Modal)(modalEl);
                instance.hide();
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: `Wallet ${isFreezing.value ? 'frozen' : 'unfrozen'}.`,
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
                emit('updated', updated);
            } catch (error) {
                console.error('Error changing wallet freeze state:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            } finally{
                isSaving.value = false;
            }
        };
        const __returned__ = {
            props,
            emit,
            modalId,
            isFreezing,
            reason,
            isSaving,
            submit,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            get Modal () {
                return 0, _bootstrap.Modal;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","bootstrap":"900Wv","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Obbx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = [
    "data-bs-target"
];
const _hoisted_2 = [
    "data-bs-target"
];
const _hoisted_3 = [
    "id"
];
const _hoisted_4 = {
    class: "modal-dialog modal-dialog-centered"
};
const _hoisted_5 = {
    class: "modal-content"
};
const _hoisted_6 = {
    class: "modal-header"
};
const _hoisted_7 = {
    class: "modal-title"
};
const _hoisted_8 = {
    class: "modal-body"
};
const _hoisted_9 = {
    class: "modal-footer"
};
const _hoisted_10 = [
    "disabled"
];
const _hoisted_11 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", null, [
        $props.status === 'ACTIVE' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
            key: 0,
            class: "btn btn-outline-warning",
            "data-bs-toggle": "modal",
            "data-bs-target": `#${$setup.modalId}`
        }, _cache[1] || (_cache[1] = [
            (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-lock"
            }, null, -1),
            (0, _vue.createTextVNode)(" Freeze ")
        ]), 8, _hoisted_1)) : $props.status === 'FROZEN' || $props.status === 'SUSPENDED' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
            key: 1,
            class: "btn btn-outline-success",
            "data-bs-toggle": "modal",
            "data-bs-target": `#${$setup.modalId}`
        }, _cache[2] || (_cache[2] = [
            (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-lock-open"
            }, null, -1),
            (0, _vue.createTextVNode)(" Unfreeze ")
        ]), 8, _hoisted_2)) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", {
            class: "modal fade",
            id: $setup.modalId,
            tabindex: "-1",
            "aria-hidden": "true"
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_4, [
                (0, _vue.createElementVNode)("div", _hoisted_5, [
                    (0, _vue.createElementVNode)("div", _hoisted_6, [
                        (0, _vue.createElementVNode)("h5", _hoisted_7, (0, _vue.toDisplayString)($setup.isFreezing ? 'Freeze' : 'Unfreeze') + " Wallet", 1),
                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_8, [
                        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("p", {
                            class: "text-muted small"
                        }, " A freeze blocks new credits and debits, but does not stop a ride already under way and does not block an approved refund from executing. ", -1)),
                        _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, [
                            (0, _vue.createTextVNode)("Reason "),
                            (0, _vue.createElementVNode)("span", {
                                class: "text-danger"
                            }, "*")
                        ], -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                            class: "form-control",
                            rows: "3",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.reason = $event),
                            required: ""
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.reason
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_9, [
                        _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Cancel", -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: (0, _vue.normalizeClass)([
                                "btn",
                                $setup.isFreezing ? 'btn-warning' : 'btn-success'
                            ]),
                            disabled: $setup.isSaving || !$setup.reason.trim(),
                            onClick: $setup.submit
                        }, [
                            $setup.isSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_11)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isSaving ? 'Saving...' : $setup.isFreezing ? 'Freeze Wallet' : 'Unfreeze Wallet'), 1)
                        ], 10, _hoisted_10)
                    ])
                ])
            ])
        ], 8, _hoisted_3)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHotl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bZUJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("56f4e5f35a7a6a32");
    if (script.__esModule) script = script.default;
    script.render = require("ddbae74413f11b8c").render;
    require("d61c2af41007d804").default(script);
    script.__scopeId = 'data-v-62b5f2';
    script.__file = "WalletAdjustmentModal.vue";
};
initialize();
exports.default = script;

},{"56f4e5f35a7a6a32":"4IuwW","ddbae74413f11b8c":"5LK7r","d61c2af41007d804":"9r73T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4IuwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _bootstrap = require("bootstrap");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'WalletAdjustmentModal',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    emits: [
        'created'
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const modalId = (0, _vue.computed)(()=>`wallet-adjustment-modal-${props.walletId}`);
        const kind = (0, _vue.ref)('SUPPORT_CREDIT');
        const amountDollars = (0, _vue.ref)(null);
        const reason = (0, _vue.ref)('');
        const notes = (0, _vue.ref)('');
        const sourceTopUpId = (0, _vue.ref)(null);
        const sourceRideId = (0, _vue.ref)(null);
        const isSaving = (0, _vue.ref)(false);
        const refundableTopUps = (0, _vue.ref)([]);
        const isLoadingTopUps = (0, _vue.ref)(false);
        const refundableRides = (0, _vue.ref)([]);
        const isLoadingRides = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const formatMinor = (value)=>`$${((value || 0) / 100).toFixed(2)}`;
        const isValid = (0, _vue.computed)(()=>{
            if (!reason.value.trim() || !amountDollars.value || amountDollars.value <= 0) return false;
            if (kind.value === 'TOP_UP_REFUND' && !sourceTopUpId.value) return false;
            if (kind.value === 'RIDE_REFUND' && !sourceRideId.value) return false;
            return true;
        });
        const reset = ()=>{
            kind.value = 'SUPPORT_CREDIT';
            amountDollars.value = null;
            reason.value = '';
            notes.value = '';
            sourceTopUpId.value = null;
            sourceRideId.value = null;
        };
        const onKindChange = async ()=>{
            sourceTopUpId.value = null;
            sourceRideId.value = null;
            if (kind.value === 'RIDE_REFUND') amountDollars.value = null;
            if (kind.value === 'TOP_UP_REFUND' && refundableTopUps.value.length === 0) {
                isLoadingTopUps.value = true;
                try {
                    const response = await fetch(`/api/admin/wallets/${props.walletId}/top-ups`);
                    if (response.ok) {
                        const all = await response.json();
                        refundableTopUps.value = all.filter((t)=>t.refundableRemainderMinor > 0);
                    }
                } catch (error) {
                    console.error('Error loading top-ups for refund selection:', error);
                } finally{
                    isLoadingTopUps.value = false;
                }
            }
            if (kind.value === 'RIDE_REFUND' && refundableRides.value.length === 0) {
                isLoadingRides.value = true;
                try {
                    const response = await fetch(`/api/admin/wallets/${props.walletId}/ride-links?page=1`);
                    if (response.ok) {
                        const data = await response.json();
                        refundableRides.value = data.items || [];
                    }
                } catch (error) {
                    console.error('Error loading rides for refund selection:', error);
                } finally{
                    isLoadingRides.value = false;
                }
            }
        };
        const onTopUpChange = ()=>{
            const selected = refundableTopUps.value.find((t)=>t.id === sourceTopUpId.value);
            if (selected) amountDollars.value = selected.refundableRemainderMinor / 100;
        };
        const onRideChange = ()=>{
            const selected = refundableRides.value.find((r)=>r.rideId === sourceRideId.value);
            if (selected) amountDollars.value = (selected.walletAmountMinor + selected.cardAmountMinor) / 100;
        };
        const submit = async ()=>{
            if (!isValid.value || isSaving.value) return;
            isSaving.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/adjustments`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        kind: kind.value,
                        amountMinor: Math.round(amountDollars.value * 100),
                        reason: reason.value.trim(),
                        notes: notes.value.trim() || null,
                        sourceTopUpId: sourceTopUpId.value,
                        sourceRideId: sourceRideId.value
                    })
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || 'Unable to submit the request.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 5000
                    });
                    return;
                }
                const created = await response.json();
                const modalEl = document.getElementById(modalId.value);
                const instance = (0, _bootstrap.Modal).getInstance(modalEl) || new (0, _bootstrap.Modal)(modalEl);
                instance.hide();
                reset();
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Request submitted for approval.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
                emit('created', created);
            } catch (error) {
                console.error('Error submitting wallet adjustment request:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            } finally{
                isSaving.value = false;
            }
        };
        const __returned__ = {
            props,
            emit,
            modalId,
            kind,
            amountDollars,
            reason,
            notes,
            sourceTopUpId,
            sourceRideId,
            isSaving,
            refundableTopUps,
            isLoadingTopUps,
            refundableRides,
            isLoadingRides,
            formatDate,
            formatMinor,
            isValid,
            reset,
            onKindChange,
            onTopUpChange,
            onRideChange,
            submit,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            get Modal () {
                return 0, _bootstrap.Modal;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","bootstrap":"900Wv","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LK7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = [
    "data-bs-target"
];
const _hoisted_2 = [
    "id"
];
const _hoisted_3 = {
    class: "modal-dialog modal-dialog-centered modal-lg"
};
const _hoisted_4 = {
    class: "modal-content"
};
const _hoisted_5 = {
    class: "modal-body"
};
const _hoisted_6 = {
    class: "mb-3"
};
const _hoisted_7 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_8 = [
    "value"
];
const _hoisted_9 = {
    key: 0,
    class: "text-muted small mt-1"
};
const _hoisted_10 = {
    key: 1,
    class: "text-muted small mt-1"
};
const _hoisted_11 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_12 = [
    "value"
];
const _hoisted_13 = {
    key: 0,
    class: "text-muted small mt-1"
};
const _hoisted_14 = {
    key: 1,
    class: "text-muted small mt-1"
};
const _hoisted_15 = {
    class: "mb-3"
};
const _hoisted_16 = {
    class: "input-group"
};
const _hoisted_17 = [
    "disabled"
];
const _hoisted_18 = {
    class: "mb-3"
};
const _hoisted_19 = {
    class: "mb-3"
};
const _hoisted_20 = {
    class: "modal-footer"
};
const _hoisted_21 = [
    "disabled"
];
const _hoisted_22 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", null, [
        (0, _vue.createElementVNode)("button", {
            class: "btn btn-primary",
            "data-bs-toggle": "modal",
            "data-bs-target": `#${$setup.modalId}`,
            onClick: $setup.reset
        }, _cache[6] || (_cache[6] = [
            (0, _vue.createElementVNode)("i", {
                class: "fa-regular fa-square-plus"
            }, null, -1),
            (0, _vue.createTextVNode)(" New Credit / Refund ")
        ]), 8, _hoisted_1),
        (0, _vue.createElementVNode)("div", {
            class: "modal fade",
            id: $setup.modalId,
            tabindex: "-1",
            "aria-hidden": "true"
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    _cache[20] || (_cache[20] = (0, _vue.createElementVNode)("div", {
                        class: "modal-header"
                    }, [
                        (0, _vue.createElementVNode)("h5", {
                            class: "modal-title"
                        }, "Request a Credit or Refund"),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_5, [
                        _cache[18] || (_cache[18] = (0, _vue.createElementVNode)("p", {
                            class: "text-muted small"
                        }, " This only captures a request. Nothing moves until a second admin approves it (or, below the configured threshold, you may approve your own request from the approval queue). ", -1)),
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            _cache[8] || (_cache[8] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, [
                                (0, _vue.createTextVNode)("Kind "),
                                (0, _vue.createElementVNode)("span", {
                                    class: "text-danger"
                                }, "*")
                            ], -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.kind = $event),
                                onChange: $setup.onKindChange
                            }, _cache[7] || (_cache[7] = [
                                (0, _vue.createStaticVNode)("<option value=\"SUPPORT_CREDIT\">Support credit</option><option value=\"PROMOTIONAL_CREDIT\">Promotional credit</option><option value=\"MANUAL_ADJUSTMENT\">Manual adjustment (credit-only)</option><option value=\"TOP_UP_REFUND\">Top-up refund</option><option value=\"RIDE_REFUND\">Ride refund</option>", 5)
                            ]), 544), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.kind
                                ]
                            ])
                        ]),
                        $setup.kind === 'TOP_UP_REFUND' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                            _cache[10] || (_cache[10] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, [
                                (0, _vue.createTextVNode)("Top-up "),
                                (0, _vue.createElementVNode)("span", {
                                    class: "text-danger"
                                }, "*")
                            ], -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.sourceTopUpId = $event),
                                onChange: $setup.onTopUpChange
                            }, [
                                _cache[9] || (_cache[9] = (0, _vue.createElementVNode)("option", {
                                    value: null
                                }, "-- Select a top-up --", -1)),
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.refundableTopUps, (topUp)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                        key: topUp.id,
                                        value: topUp.id
                                    }, (0, _vue.toDisplayString)($setup.formatDate(topUp.createdOn)) + " \u2014 " + (0, _vue.toDisplayString)($setup.formatMinor(topUp.amountMinor)) + " (refundable " + (0, _vue.toDisplayString)($setup.formatMinor(topUp.refundableRemainderMinor)) + ") ", 9, _hoisted_8);
                                }), 128))
                            ], 544), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.sourceTopUpId
                                ]
                            ]),
                            $setup.isLoadingTopUps ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, "Loading top-ups...")) : $setup.refundableTopUps.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_10, "No refundable top-ups found.")) : (0, _vue.createCommentVNode)("", true)
                        ])) : (0, _vue.createCommentVNode)("", true),
                        $setup.kind === 'RIDE_REFUND' ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_11, [
                            _cache[12] || (_cache[12] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, [
                                (0, _vue.createTextVNode)("Ride "),
                                (0, _vue.createElementVNode)("span", {
                                    class: "text-danger"
                                }, "*")
                            ], -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.sourceRideId = $event),
                                onChange: $setup.onRideChange
                            }, [
                                _cache[11] || (_cache[11] = (0, _vue.createElementVNode)("option", {
                                    value: null
                                }, "-- Select a settled ride --", -1)),
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.refundableRides, (ride)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                        key: ride.rideId,
                                        value: ride.rideId
                                    }, (0, _vue.toDisplayString)($setup.formatDate(ride.orderDateTime)) + " \u2014 " + (0, _vue.toDisplayString)($setup.formatMinor(ride.walletAmountMinor + ride.cardAmountMinor)), 9, _hoisted_12);
                                }), 128))
                            ], 544), [
                                [
                                    (0, _vue.vModelSelect),
                                    $setup.sourceRideId
                                ]
                            ]),
                            $setup.isLoadingRides ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_13, "Loading rides...")) : $setup.refundableRides.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, "No linked rides found.")) : (0, _vue.createCommentVNode)("", true),
                            _cache[13] || (_cache[13] = (0, _vue.createElementVNode)("small", {
                                class: "form-text text-muted"
                            }, "Ride refunds are all-or-nothing in v1 \u2014 the amount below is fixed.", -1))
                        ])) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createElementVNode)("div", _hoisted_15, [
                            _cache[15] || (_cache[15] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, [
                                (0, _vue.createTextVNode)("Amount (CAD) "),
                                (0, _vue.createElementVNode)("span", {
                                    class: "text-danger"
                                }, "*")
                            ], -1)),
                            (0, _vue.createElementVNode)("div", _hoisted_16, [
                                _cache[14] || (_cache[14] = (0, _vue.createElementVNode)("span", {
                                    class: "input-group-text"
                                }, "$", -1)),
                                (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                                    type: "number",
                                    class: "form-control",
                                    min: "0.01",
                                    step: "0.01",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.amountDollars = $event),
                                    disabled: $setup.kind === 'RIDE_REFUND'
                                }, null, 8, _hoisted_17), [
                                    [
                                        (0, _vue.vModelText),
                                        $setup.amountDollars,
                                        void 0,
                                        {
                                            number: true
                                        }
                                    ]
                                ])
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_18, [
                            _cache[16] || (_cache[16] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, [
                                (0, _vue.createTextVNode)("Reason "),
                                (0, _vue.createElementVNode)("span", {
                                    class: "text-danger"
                                }, "*")
                            ], -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                class: "form-control",
                                rows: "2",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.reason = $event),
                                required: ""
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.reason
                                ]
                            ])
                        ]),
                        (0, _vue.createElementVNode)("div", _hoisted_19, [
                            _cache[17] || (_cache[17] = (0, _vue.createElementVNode)("label", {
                                class: "form-label"
                            }, "Notes (optional)", -1)),
                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                                class: "form-control",
                                rows: "2",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.notes = $event)
                            }, null, 512), [
                                [
                                    (0, _vue.vModelText),
                                    $setup.notes
                                ]
                            ])
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_20, [
                        _cache[19] || (_cache[19] = (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Cancel", -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-primary",
                            disabled: $setup.isSaving || !$setup.isValid,
                            onClick: $setup.submit
                        }, [
                            $setup.isSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_22)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isSaving ? 'Submitting...' : 'Submit Request'), 1)
                        ], 8, _hoisted_21)
                    ])
                ])
            ])
        ], 8, _hoisted_2)
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9r73T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wPb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("1ae2297e60d7aa46");
    if (script.__esModule) script = script.default;
    script.render = require("657e77dafe1e34bc").render;
    require("1886956216b648f6").default(script);
    script.__scopeId = 'data-v-aea1ea';
    script.__file = "WalletLedgerTable.vue";
};
initialize();
exports.default = script;

},{"1ae2297e60d7aa46":"8lxW2","657e77dafe1e34bc":"7s3E4","1886956216b648f6":"lXcH5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lxW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'WalletLedgerTable',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        const props = __props;
        const lines = (0, _vue.ref)([]);
        const page = (0, _vue.ref)(1);
        const totalPages = (0, _vue.ref)(0);
        const totalRows = (0, _vue.ref)(0);
        const hasNext = (0, _vue.ref)(false);
        const isLoading = (0, _vue.ref)(false);
        const exportUrl = (0, _vue.computed)(()=>`/api/admin/wallets/${props.walletId}/statement.csv`);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const load = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/transactions?page=${page.value}`);
                if (response.ok) {
                    const data = await response.json();
                    lines.value = data.lines || [];
                    totalPages.value = data.totalPages || 0;
                    totalRows.value = data.totalRows || 0;
                    hasNext.value = !!data.hasNext;
                }
            } catch (error) {
                console.error('Error loading wallet ledger:', error);
            } finally{
                isLoading.value = false;
            }
        };
        const changePage = (next)=>{
            if (next < 1) return;
            page.value = next;
            load();
        };
        (0, _vue.onMounted)(load);
        __expose({
            load
        });
        const __returned__ = {
            props,
            lines,
            page,
            totalPages,
            totalRows,
            hasNext,
            isLoading,
            exportUrl,
            formatDate,
            load,
            changePage,
            ref: (0, _vue.ref),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            },
            get walletTransactionType () {
                return 0, _datatableRenderer.walletTransactionType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7s3E4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-header d-flex justify-content-between align-items-center"
};
const _hoisted_3 = [
    "href"
];
const _hoisted_4 = {
    class: "card-body"
};
const _hoisted_5 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_6 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_7 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_8 = {
    class: "table table-borderless"
};
const _hoisted_9 = [
    "innerHTML"
];
const _hoisted_10 = [
    "innerHTML"
];
const _hoisted_11 = [
    "innerHTML"
];
const _hoisted_12 = {
    class: "text-muted small"
};
const _hoisted_13 = {
    key: 3,
    class: "d-flex justify-content-between align-items-center mt-2"
};
const _hoisted_14 = [
    "disabled"
];
const _hoisted_15 = {
    class: "text-muted small"
};
const _hoisted_16 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("div", null, [
                (0, _vue.createElementVNode)("h3", {
                    class: "mb-0"
                }, "Ledger"),
                (0, _vue.createElementVNode)("small", {
                    class: "form-text text-muted"
                }, "Append-only. Every amount is already the all-in figure the rider was charged.")
            ], -1)),
            (0, _vue.createElementVNode)("a", {
                class: "btn btn-outline-primary btn-sm",
                href: $setup.exportUrl,
                target: "_blank",
                rel: "noopener"
            }, _cache[2] || (_cache[2] = [
                (0, _vue.createElementVNode)("i", {
                    class: "fa-solid fa-file-csv"
                }, null, -1),
                (0, _vue.createTextVNode)(" Export CSV ")
            ]), 8, _hoisted_3)
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_4, [
            $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, _cache[4] || (_cache[4] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading... ")
            ]))) : $setup.lines.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, "No ledger activity yet.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                (0, _vue.createElementVNode)("table", _hoisted_8, [
                    _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("thead", null, [
                        (0, _vue.createElementVNode)("tr", null, [
                            (0, _vue.createElementVNode)("th", null, "Date"),
                            (0, _vue.createElementVNode)("th", null, "Type"),
                            (0, _vue.createElementVNode)("th", null, "Category"),
                            (0, _vue.createElementVNode)("th", null, "Direction"),
                            (0, _vue.createElementVNode)("th", null, "Amount"),
                            (0, _vue.createElementVNode)("th", null, "Balance After"),
                            (0, _vue.createElementVNode)("th", null, "Description"),
                            (0, _vue.createElementVNode)("th", null, "Reference")
                        ])
                    ], -1)),
                    (0, _vue.createElementVNode)("tbody", null, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.lines, (line)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                key: line.id
                            }, [
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatDate(line.effectiveAt)), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.walletTransactionType(line.transactionType)
                                }, null, 8, _hoisted_9),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(line.accountType || "\u2014"), 1),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(line.direction), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(line.signedAmountMinor)
                                }, null, 8, _hoisted_10),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(line.balanceAfterMinor)
                                }, null, 8, _hoisted_11),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(line.description || ''), 1),
                                (0, _vue.createElementVNode)("td", _hoisted_12, (0, _vue.toDisplayString)(line.referenceType || '') + " " + (0, _vue.toDisplayString)(line.referenceId || ''), 1)
                            ]);
                        }), 128))
                    ])
                ])
            ])),
            $setup.totalPages > 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_13, [
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: $setup.page <= 1,
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.changePage($setup.page - 1))
                }, "Previous", 8, _hoisted_14),
                (0, _vue.createElementVNode)("span", _hoisted_15, "Page " + (0, _vue.toDisplayString)($setup.page) + " of " + (0, _vue.toDisplayString)($setup.totalPages) + " (" + (0, _vue.toDisplayString)($setup.totalRows) + " rows)", 1),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: !$setup.hasNext,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.changePage($setup.page + 1))
                }, "Next", 8, _hoisted_16)
            ])) : (0, _vue.createCommentVNode)("", true)
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lXcH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZdGq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("bd4e7820898327a1");
    if (script.__esModule) script = script.default;
    script.render = require("1acc74658ed10b86").render;
    require("ccf5a66c3c527a38").default(script);
    script.__scopeId = 'data-v-ba5da7';
    script.__file = "WalletTopUpsPanel.vue";
};
initialize();
exports.default = script;

},{"bd4e7820898327a1":"jsYSD","1acc74658ed10b86":"a5PFA","ccf5a66c3c527a38":"gMmli","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsYSD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'WalletTopUpsPanel',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        const props = __props;
        const topUps = (0, _vue.ref)([]);
        const isLoading = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const loadTopUps = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/top-ups`);
                if (response.ok) topUps.value = await response.json();
            } catch (error) {
                console.error('Error loading wallet top-ups:', error);
            } finally{
                isLoading.value = false;
            }
        };
        (0, _vue.onMounted)(loadTopUps);
        __expose({
            loadTopUps
        });
        const __returned__ = {
            props,
            topUps,
            isLoading,
            formatDate,
            loadTopUps,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            },
            get walletTopUpRefundState () {
                return 0, _datatableRenderer.walletTopUpRefundState;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5PFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_4 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_5 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_6 = {
    class: "table table-borderless"
};
const _hoisted_7 = [
    "innerHTML"
];
const _hoisted_8 = [
    "innerHTML"
];
const _hoisted_9 = [
    "innerHTML"
];
const _hoisted_10 = {
    class: "text-muted"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h3", null, "Top-up History"),
            (0, _vue.createElementVNode)("small", {
                class: "form-text text-muted"
            }, "Most recent 20 attempts, newest first.")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, _cache[0] || (_cache[0] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading... ")
            ]))) : $setup.topUps.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, "No top-up attempts yet.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("table", _hoisted_6, [
                    _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("thead", null, [
                        (0, _vue.createElementVNode)("tr", null, [
                            (0, _vue.createElementVNode)("th", null, "Date"),
                            (0, _vue.createElementVNode)("th", null, "Amount"),
                            (0, _vue.createElementVNode)("th", null, "Status"),
                            (0, _vue.createElementVNode)("th", null, "Refund"),
                            (0, _vue.createElementVNode)("th", null, "Refundable Remainder"),
                            (0, _vue.createElementVNode)("th", null, "Failure")
                        ])
                    ], -1)),
                    (0, _vue.createElementVNode)("tbody", null, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.topUps, (topUp)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                key: topUp.id
                            }, [
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatDate(topUp.createdOn)), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(topUp.amountMinor)
                                }, null, 8, _hoisted_7),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(topUp.status), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.walletTopUpRefundState(topUp.refundState)
                                }, null, 8, _hoisted_8),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(topUp.refundableRemainderMinor)
                                }, null, 8, _hoisted_9),
                                (0, _vue.createElementVNode)("td", _hoisted_10, (0, _vue.toDisplayString)(topUp.failureMessage || topUp.refundFailureMessage || ''), 1)
                            ]);
                        }), 128))
                    ])
                ])
            ]))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gMmli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iIZxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("a8213c23aecd19bf");
    if (script.__esModule) script = script.default;
    script.render = require("161f1eeaa312d763").render;
    require("b86528296716fd9a").default(script);
    script.__scopeId = 'data-v-4e6fa8';
    script.__file = "WalletRideLinksPanel.vue";
};
initialize();
exports.default = script;

},{"a8213c23aecd19bf":"3gUBu","161f1eeaa312d763":"iCKlh","b86528296716fd9a":"5vSwN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3gUBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'WalletRideLinksPanel',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        const props = __props;
        const rows = (0, _vue.ref)([]);
        const page = (0, _vue.ref)(1);
        const totalPages = (0, _vue.ref)(0);
        const totalRows = (0, _vue.ref)(0);
        const hasNext = (0, _vue.ref)(false);
        const isLoading = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const formatMinor = (value)=>value === null || value === undefined ? '$0.00' : `$${(value / 100).toFixed(2)}`;
        // NOT_APPLICABLE is a real, expected value here (every card-only ride), not an error state — the
        // #167 guide's mobile-only table omits it, but the admin viewer reads settlementStatus directly.
        const settlementLabel = (status)=>status === 'NOT_APPLICABLE' ? 'Card only' : status || "\u2014";
        const load = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/ride-links?page=${page.value}`);
                if (response.ok) {
                    const data = await response.json();
                    rows.value = data.items || [];
                    totalPages.value = data.totalPages || 0;
                    totalRows.value = data.totalRows || 0;
                    hasNext.value = !!data.hasNext;
                }
            } catch (error) {
                console.error('Error loading wallet ride links:', error);
            } finally{
                isLoading.value = false;
            }
        };
        const changePage = (next)=>{
            if (next < 1) return;
            page.value = next;
            load();
        };
        (0, _vue.onMounted)(load);
        __expose({
            load
        });
        const __returned__ = {
            props,
            rows,
            page,
            totalPages,
            totalRows,
            hasNext,
            isLoading,
            formatDate,
            formatMinor,
            settlementLabel,
            load,
            changePage,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCKlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_4 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_5 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_6 = {
    class: "table table-borderless"
};
const _hoisted_7 = [
    "innerHTML"
];
const _hoisted_8 = {
    class: "text-muted small"
};
const _hoisted_9 = [
    "innerHTML"
];
const _hoisted_10 = [
    "innerHTML"
];
const _hoisted_11 = [
    "innerHTML"
];
const _hoisted_12 = {
    key: 3,
    class: "d-flex justify-content-between align-items-center mt-2"
};
const _hoisted_13 = [
    "disabled"
];
const _hoisted_14 = {
    class: "text-muted small"
};
const _hoisted_15 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h3", null, "Linked Rides"),
            (0, _vue.createElementVNode)("small", {
                class: "form-text text-muted"
            }, ' "Fare charged" is always the all-in, tax-included figure the rider was actually charged \u2014 the pre-tax subtotal below it is an informational breakdown only, never the headline number. ')
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, _cache[2] || (_cache[2] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading... ")
            ]))) : $setup.rows.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, "No rides linked to this wallet yet.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("table", _hoisted_6, [
                    _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("thead", null, [
                        (0, _vue.createElementVNode)("tr", null, [
                            (0, _vue.createElementVNode)("th", null, "Date"),
                            (0, _vue.createElementVNode)("th", null, "Settlement"),
                            (0, _vue.createElementVNode)("th", null, "Fare Charged"),
                            (0, _vue.createElementVNode)("th", null, "Breakdown"),
                            (0, _vue.createElementVNode)("th", null, "Wallet"),
                            (0, _vue.createElementVNode)("th", null, "Card"),
                            (0, _vue.createElementVNode)("th", null, "Outstanding")
                        ])
                    ], -1)),
                    (0, _vue.createElementVNode)("tbody", null, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.rows, (row)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                key: row.rideId
                            }, [
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatDate(row.orderDateTime)), 1),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.settlementLabel(row.settlementStatus)), 1),
                                (0, _vue.createElementVNode)("td", {
                                    class: "fw-bold",
                                    innerHTML: $setup.minorCurrency(row.fareChargedMinor)
                                }, null, 8, _hoisted_7),
                                (0, _vue.createElementVNode)("td", _hoisted_8, " Subtotal (pre-tax): " + (0, _vue.toDisplayString)($setup.formatMinor(row.subtotalPreTaxMinor)) + " \xb7 " + (0, _vue.toDisplayString)(row.taxLabel || 'Tax') + ": " + (0, _vue.toDisplayString)($setup.formatMinor(row.taxMinor)), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(row.walletAmountMinor)
                                }, null, 8, _hoisted_9),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(row.cardAmountMinor)
                                }, null, 8, _hoisted_10),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: $setup.minorCurrency(row.outstandingMinor)
                                }, null, 8, _hoisted_11)
                            ]);
                        }), 128))
                    ])
                ])
            ])),
            $setup.totalPages > 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_12, [
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: $setup.page <= 1,
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.changePage($setup.page - 1))
                }, "Previous", 8, _hoisted_13),
                (0, _vue.createElementVNode)("span", _hoisted_14, "Page " + (0, _vue.toDisplayString)($setup.page) + " of " + (0, _vue.toDisplayString)($setup.totalPages) + " (" + (0, _vue.toDisplayString)($setup.totalRows) + " rides)", 1),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: !$setup.hasNext,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.changePage($setup.page + 1))
                }, "Next", 8, _hoisted_15)
            ])) : (0, _vue.createCommentVNode)("", true)
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5vSwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tqgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("32408821ff7ee01b");
    if (script.__esModule) script = script.default;
    script.render = require("a1ebc905beeb192b").render;
    require("f927b3d32a33f956").default(script);
    script.__scopeId = 'data-v-26e381';
    script.__file = "WalletNotesPanel.vue";
};
initialize();
exports.default = script;

},{"32408821ff7ee01b":"2m3kF","a1ebc905beeb192b":"cbdr2","f927b3d32a33f956":"cGVmV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2m3kF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'WalletNotesPanel',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const notes = (0, _vue.ref)([]);
        const body = (0, _vue.ref)('');
        const isLoading = (0, _vue.ref)(false);
        const isSaving = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const loadNotes = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/notes`);
                if (response.ok) notes.value = await response.json();
            } catch (error) {
                console.error('Error loading wallet notes:', error);
            } finally{
                isLoading.value = false;
            }
        };
        const addNote = async ()=>{
            if (!body.value.trim() || isSaving.value) return;
            isSaving.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/notes`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        body: body.value.trim()
                    })
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || 'Unable to add note.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 5000
                    });
                    return;
                }
                body.value = '';
                await loadNotes();
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Note added.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
            } catch (error) {
                console.error('Error adding wallet note:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            } finally{
                isSaving.value = false;
            }
        };
        (0, _vue.onMounted)(loadNotes);
        const __returned__ = {
            props,
            notes,
            body,
            isLoading,
            isSaving,
            formatDate,
            loadNotes,
            addNote,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbdr2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    class: "mb-3"
};
const _hoisted_4 = {
    class: "text-end mt-2"
};
const _hoisted_5 = [
    "disabled"
];
const _hoisted_6 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_7 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_8 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_9 = {
    key: 2,
    class: "list-group"
};
const _hoisted_10 = {
    class: "d-flex justify-content-between"
};
const _hoisted_11 = {
    class: "text-muted small"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h3", null, "Internal Notes"),
            (0, _vue.createElementVNode)("small", {
                class: "form-text text-muted"
            }, "Visible to staff only. Adding a note also writes a NOTE_ADDED audit row.")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                    class: "form-control",
                    rows: "2",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.body = $event),
                    placeholder: "Add an internal note..."
                }, null, 512), [
                    [
                        (0, _vue.vModelText),
                        $setup.body
                    ]
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    (0, _vue.createElementVNode)("button", {
                        class: "btn btn-primary btn-sm",
                        disabled: $setup.isSaving || !$setup.body.trim(),
                        onClick: $setup.addNote
                    }, [
                        $setup.isSaving ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_6)) : (0, _vue.createCommentVNode)("", true),
                        (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isSaving ? 'Saving...' : 'Add Note'), 1)
                    ], 8, _hoisted_5)
                ])
            ]),
            $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, _cache[1] || (_cache[1] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading... ")
            ]))) : $setup.notes.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, "No notes yet.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_9, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.notes, (note)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                        class: "list-group-item",
                        key: note.id
                    }, [
                        (0, _vue.createElementVNode)("div", _hoisted_10, [
                            (0, _vue.createElementVNode)("span", _hoisted_11, (0, _vue.toDisplayString)($setup.formatDate(note.createdOn)), 1)
                        ]),
                        (0, _vue.createElementVNode)("div", null, (0, _vue.toDisplayString)(note.body), 1)
                    ]);
                }), 128))
            ]))
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cGVmV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ioIXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("52064b7d21c00017");
    if (script.__esModule) script = script.default;
    script.render = require("fa0ba09623397679").render;
    require("7434b7aceb601109").default(script);
    script.__scopeId = 'data-v-62b5af';
    script.__file = "WalletAuditLogTable.vue";
};
initialize();
exports.default = script;

},{"52064b7d21c00017":"4xATW","fa0ba09623397679":"4EBrM","7434b7aceb601109":"kJY39","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xATW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatableRenderer = require("../utility/DatatableRenderer");
exports.default = {
    __name: 'WalletAuditLogTable',
    props: {
        walletId: {
            type: String,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        const props = __props;
        const rows = (0, _vue.ref)([]);
        const page = (0, _vue.ref)(1);
        const totalPages = (0, _vue.ref)(0);
        const totalRows = (0, _vue.ref)(0);
        const hasNext = (0, _vue.ref)(false);
        const isLoading = (0, _vue.ref)(false);
        const formatDate = (value)=>value ? new Date(value).toLocaleString() : '';
        const load = async ()=>{
            isLoading.value = true;
            try {
                const response = await fetch(`/api/admin/wallets/${props.walletId}/audit-log?page=${page.value}`);
                if (response.ok) {
                    const data = await response.json();
                    rows.value = data.items || [];
                    totalPages.value = data.totalPages || 0;
                    totalRows.value = data.totalRows || 0;
                    hasNext.value = !!data.hasNext;
                }
            } catch (error) {
                console.error('Error loading wallet audit log:', error);
            } finally{
                isLoading.value = false;
            }
        };
        const changePage = (next)=>{
            if (next < 1) return;
            page.value = next;
            load();
        };
        (0, _vue.onMounted)(load);
        __expose({
            load
        });
        const __returned__ = {
            props,
            rows,
            page,
            totalPages,
            totalRows,
            hasNext,
            isLoading,
            formatDate,
            load,
            changePage,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","../utility/DatatableRenderer":"gfmyC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4EBrM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
const _hoisted_2 = {
    class: "card-body"
};
const _hoisted_3 = {
    key: 0,
    class: "text-center py-3"
};
const _hoisted_4 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_5 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_6 = {
    class: "table table-borderless"
};
const _hoisted_7 = {
    class: "text-muted small"
};
const _hoisted_8 = {
    class: "text-muted small"
};
const _hoisted_9 = [
    "innerHTML"
];
const _hoisted_10 = {
    key: 3,
    class: "d-flex justify-content-between align-items-center mt-2"
};
const _hoisted_11 = [
    "disabled"
];
const _hoisted_12 = {
    class: "text-muted small"
};
const _hoisted_13 = [
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
            class: "card-header"
        }, [
            (0, _vue.createElementVNode)("h3", null, "Audit Log"),
            (0, _vue.createElementVNode)("small", {
                class: "form-text text-muted"
            }, "Immutable \u2014 every state-changing action on this wallet, written by #171a's audit service.")
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, _cache[2] || (_cache[2] = [
                (0, _vue.createElementVNode)("span", {
                    class: "spinner-border spinner-border-sm me-2"
                }, null, -1),
                (0, _vue.createTextVNode)(" Loading... ")
            ]))) : $setup.rows.length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, "No audit activity yet.")) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                (0, _vue.createElementVNode)("table", _hoisted_6, [
                    _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("thead", null, [
                        (0, _vue.createElementVNode)("tr", null, [
                            (0, _vue.createElementVNode)("th", null, "Date"),
                            (0, _vue.createElementVNode)("th", null, "Action"),
                            (0, _vue.createElementVNode)("th", null, "Actor"),
                            (0, _vue.createElementVNode)("th", null, "Approved By"),
                            (0, _vue.createElementVNode)("th", null, "Amount"),
                            (0, _vue.createElementVNode)("th", null, "Reason")
                        ])
                    ], -1)),
                    (0, _vue.createElementVNode)("tbody", null, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.rows, (row)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", {
                                key: row.id
                            }, [
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)($setup.formatDate(row.createdOn)), 1),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)((row.action || '').replaceAll('_', ' ')), 1),
                                (0, _vue.createElementVNode)("td", _hoisted_7, (0, _vue.toDisplayString)(row.actorType) + " " + (0, _vue.toDisplayString)(row.actorId ? '(' + row.actorId.slice(0, 8) + ')' : ''), 1),
                                (0, _vue.createElementVNode)("td", _hoisted_8, (0, _vue.toDisplayString)(row.approvedBy ? row.approvedBy.slice(0, 8) : "\u2014"), 1),
                                (0, _vue.createElementVNode)("td", {
                                    innerHTML: row.amountMinor !== null && row.amountMinor !== undefined ? $setup.minorCurrency(row.amountMinor) : "\u2014"
                                }, null, 8, _hoisted_9),
                                (0, _vue.createElementVNode)("td", null, (0, _vue.toDisplayString)(row.reason || ''), 1)
                            ]);
                        }), 128))
                    ])
                ])
            ])),
            $setup.totalPages > 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_10, [
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: $setup.page <= 1,
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.changePage($setup.page - 1))
                }, "Previous", 8, _hoisted_11),
                (0, _vue.createElementVNode)("span", _hoisted_12, "Page " + (0, _vue.toDisplayString)($setup.page) + " of " + (0, _vue.toDisplayString)($setup.totalPages) + " (" + (0, _vue.toDisplayString)($setup.totalRows) + " entries)", 1),
                (0, _vue.createElementVNode)("button", {
                    class: "btn btn-outline-secondary btn-sm",
                    disabled: !$setup.hasNext,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.changePage($setup.page + 1))
                }, "Next", 8, _hoisted_13)
            ])) : (0, _vue.createCommentVNode)("", true)
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJY39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0210d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("a709d053bacb43b6");
    if (script.__esModule) script = script.default;
    script.render = require("e29e91f98b643e27").render;
    require("90c2a26b53f52e15").default(script);
    script.__scopeId = 'data-v-7c5a64';
    script.__file = "WalletFinancePanel.vue";
};
initialize();
exports.default = script;

},{"a709d053bacb43b6":"uSJSD","e29e91f98b643e27":"gEnin","90c2a26b53f52e15":"hzI2P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"uSJSD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    __name: 'WalletFinancePanel',
    setup (__props, { expose: __expose }) {
        __expose();
        // Named seam only (epic #173, issue #169 plan, "Assumptions Taken" — the deferred finance panel).
        // #170-A has not landed, so there is no read model to render here yet; #169 kept the chargeback/
        // reconciliation views as a follow-on rather than guessing a data shape (epic re-plan addendum §5
        // item 4). This file is the one place to fill in once #170-A ships.
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEnin":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "card"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, _cache[0] || (_cache[0] = [
        (0, _vue.createElementVNode)("div", {
            class: "card-body text-center text-muted py-5"
        }, [
            (0, _vue.createElementVNode)("i", {
                class: "fa-solid fa-scale-balanced fa-2x mb-3"
            }),
            (0, _vue.createElementVNode)("p", {
                class: "mb-0"
            }, "Finance reconciliation data is not available yet (#170)."),
            (0, _vue.createElementVNode)("p", {
                class: "mb-0"
            }, "Chargeback register, GL postings and discrepancy reports land once issue #170-A ships.")
        ], -1)
    ]));
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hzI2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ISu7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "page-title"
};
const _hoisted_3 = {
    class: "row"
};
const _hoisted_4 = {
    class: "col-sm-6 col-12"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1,
    class: "text-muted mb-0"
};
const _hoisted_7 = {
    key: 0,
    class: "col-sm-6 col-12 text-end"
};
const _hoisted_8 = {
    class: "ms-2"
};
const _hoisted_9 = {
    key: 0,
    class: "col-12 text-center py-4"
};
const _hoisted_10 = {
    class: "row mb-3"
};
const _hoisted_11 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_12 = {
    class: "card"
};
const _hoisted_13 = {
    class: "card-body"
};
const _hoisted_14 = [
    "innerHTML"
];
const _hoisted_15 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_16 = {
    class: "card"
};
const _hoisted_17 = {
    class: "card-body"
};
const _hoisted_18 = [
    "innerHTML"
];
const _hoisted_19 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_20 = {
    class: "card"
};
const _hoisted_21 = {
    class: "card-body"
};
const _hoisted_22 = [
    "innerHTML"
];
const _hoisted_23 = {
    class: "col-md-3 col-sm-6 mb-3"
};
const _hoisted_24 = {
    class: "card"
};
const _hoisted_25 = {
    class: "card-body"
};
const _hoisted_26 = [
    "innerHTML"
];
const _hoisted_27 = {
    key: 0,
    class: "text-muted small mb-0 mt-1"
};
const _hoisted_28 = {
    class: "col-12 mb-3"
};
const _hoisted_29 = {
    class: "card"
};
const _hoisted_30 = {
    class: "card-body"
};
const _hoisted_31 = {
    class: "row"
};
const _hoisted_32 = {
    class: "text-muted small"
};
const _hoisted_33 = [
    "innerHTML"
];
const _hoisted_34 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_35 = {
    class: "col-12"
};
const _hoisted_36 = {
    class: "tab-content pt-3"
};
const _hoisted_37 = {
    class: "tab-pane fade show active",
    id: "wallet-ledger",
    role: "tabpanel"
};
const _hoisted_38 = {
    class: "tab-pane fade",
    id: "wallet-topups",
    role: "tabpanel"
};
const _hoisted_39 = {
    class: "tab-pane fade",
    id: "wallet-rides",
    role: "tabpanel"
};
const _hoisted_40 = {
    class: "tab-pane fade",
    id: "wallet-notes",
    role: "tabpanel"
};
const _hoisted_41 = {
    class: "tab-pane fade",
    id: "wallet-audit",
    role: "tabpanel"
};
const _hoisted_42 = {
    class: "tab-pane fade",
    id: "wallet-finance",
    role: "tabpanel"
};
const _hoisted_43 = {
    key: 2,
    class: "col-12"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    $setup.wallet ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("h2", _hoisted_5, (0, _vue.toDisplayString)($setup.wallet.riderDisplayName || 'Wallet'), 1)) : (0, _vue.createCommentVNode)("", true),
                    $setup.wallet ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_6, (0, _vue.toDisplayString)($setup.wallet.email) + " \xb7 " + (0, _vue.toDisplayString)($setup.wallet.phone), 1)) : (0, _vue.createCommentVNode)("", true)
                ]),
                $setup.wallet ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                    (0, _vue.createVNode)($setup["WalletFreezeModal"], {
                        "wallet-id": $props.walletId,
                        status: $setup.wallet.status,
                        onUpdated: $setup.onWalletUpdated
                    }, null, 8, [
                        "wallet-id",
                        "status"
                    ]),
                    (0, _vue.createElementVNode)("span", _hoisted_8, [
                        (0, _vue.createVNode)($setup["WalletAdjustmentModal"], {
                            "wallet-id": $props.walletId,
                            onCreated: $setup.onRequestCreated
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ])
                ])) : (0, _vue.createCommentVNode)("", true)
            ])
        ]),
        $setup.isLoading ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, _cache[0] || (_cache[0] = [
            (0, _vue.createElementVNode)("span", {
                class: "spinner-border spinner-border-sm me-2"
            }, null, -1),
            (0, _vue.createTextVNode)(" Loading... ")
        ]))) : $setup.wallet ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 1
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_10, [
                (0, _vue.createElementVNode)("div", _hoisted_11, [
                    (0, _vue.createElementVNode)("div", _hoisted_12, [
                        (0, _vue.createElementVNode)("div", _hoisted_13, [
                            _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("h6", {
                                class: "text-muted mb-1"
                            }, "Available Balance", -1)),
                            (0, _vue.createElementVNode)("h4", {
                                class: "mb-0",
                                innerHTML: $setup.minorCurrency($setup.wallet.availableBalanceMinor)
                            }, null, 8, _hoisted_14)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_15, [
                    (0, _vue.createElementVNode)("div", _hoisted_16, [
                        (0, _vue.createElementVNode)("div", _hoisted_17, [
                            _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("h6", {
                                class: "text-muted mb-1"
                            }, "Reserved", -1)),
                            (0, _vue.createElementVNode)("h4", {
                                class: "mb-0",
                                innerHTML: $setup.minorCurrency($setup.wallet.reservedBalanceMinor)
                            }, null, 8, _hoisted_18)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_19, [
                    (0, _vue.createElementVNode)("div", _hoisted_20, [
                        (0, _vue.createElementVNode)("div", _hoisted_21, [
                            _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("h6", {
                                class: "text-muted mb-1"
                            }, "Total", -1)),
                            (0, _vue.createElementVNode)("h4", {
                                class: "mb-0",
                                innerHTML: $setup.minorCurrency($setup.wallet.totalBalanceMinor)
                            }, null, 8, _hoisted_22)
                        ])
                    ])
                ]),
                (0, _vue.createElementVNode)("div", _hoisted_23, [
                    (0, _vue.createElementVNode)("div", _hoisted_24, [
                        (0, _vue.createElementVNode)("div", _hoisted_25, [
                            _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("h6", {
                                class: "text-muted mb-1"
                            }, "Status", -1)),
                            (0, _vue.createElementVNode)("h4", {
                                class: "mb-0",
                                innerHTML: $setup.walletStatus($setup.wallet.status)
                            }, null, 8, _hoisted_26),
                            $setup.wallet.statusReason ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_27, (0, _vue.toDisplayString)($setup.wallet.statusReason), 1)) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_28, [
                (0, _vue.createElementVNode)("div", _hoisted_29, [
                    _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
                        class: "card-header"
                    }, [
                        (0, _vue.createElementVNode)("h5", {
                            class: "mb-0"
                        }, "Fund Categories")
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_30, [
                        (0, _vue.createElementVNode)("div", _hoisted_31, [
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.wallet.categoryBalancesMinor, (minor, category)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                    class: "col-md-3 col-sm-6 mb-2",
                                    key: category
                                }, [
                                    (0, _vue.createElementVNode)("div", _hoisted_32, (0, _vue.toDisplayString)(category.replaceAll('_', ' ')), 1),
                                    (0, _vue.createElementVNode)("div", {
                                        class: "fw-bold",
                                        innerHTML: $setup.minorCurrency(minor)
                                    }, null, 8, _hoisted_33)
                                ]);
                            }), 128)),
                            !$setup.wallet.categoryBalancesMinor || Object.keys($setup.wallet.categoryBalancesMinor).length === 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_34, " No sub-account activity yet. ")) : (0, _vue.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ]),
            (0, _vue.createElementVNode)("div", _hoisted_35, [
                _cache[6] || (_cache[6] = (0, _vue.createElementVNode)("ul", {
                    class: "nav nav-tabs",
                    id: "wallet-detail-tab",
                    role: "tablist"
                }, [
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link active",
                            "data-bs-toggle": "tab",
                            href: "#wallet-ledger",
                            role: "tab"
                        }, "Ledger")
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            "data-bs-toggle": "tab",
                            href: "#wallet-topups",
                            role: "tab"
                        }, "Top-ups")
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            "data-bs-toggle": "tab",
                            href: "#wallet-rides",
                            role: "tab"
                        }, "Linked Rides")
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            "data-bs-toggle": "tab",
                            href: "#wallet-notes",
                            role: "tab"
                        }, "Notes")
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            "data-bs-toggle": "tab",
                            href: "#wallet-audit",
                            role: "tab"
                        }, "Audit Log")
                    ]),
                    (0, _vue.createElementVNode)("li", {
                        class: "nav-item"
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: "nav-link",
                            "data-bs-toggle": "tab",
                            href: "#wallet-finance",
                            role: "tab"
                        }, "Finance")
                    ])
                ], -1)),
                (0, _vue.createElementVNode)("div", _hoisted_36, [
                    (0, _vue.createElementVNode)("div", _hoisted_37, [
                        (0, _vue.createVNode)($setup["WalletLedgerTable"], {
                            "wallet-id": $props.walletId
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_38, [
                        (0, _vue.createVNode)($setup["WalletTopUpsPanel"], {
                            "wallet-id": $props.walletId
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_39, [
                        (0, _vue.createVNode)($setup["WalletRideLinksPanel"], {
                            "wallet-id": $props.walletId
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_40, [
                        (0, _vue.createVNode)($setup["WalletNotesPanel"], {
                            "wallet-id": $props.walletId
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_41, [
                        (0, _vue.createVNode)($setup["WalletAuditLogTable"], {
                            "wallet-id": $props.walletId
                        }, null, 8, [
                            "wallet-id"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_42, [
                        (0, _vue.createVNode)($setup["WalletFinancePanel"])
                    ])
                ])
            ])
        ], 64)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_43, _cache[7] || (_cache[7] = [
            (0, _vue.createElementVNode)("div", {
                class: "alert alert-danger"
            }, "Wallet not found.", -1)
        ])))
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hhLsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ft7SA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("f1d6edad5e80a12b");
    if (script.__esModule) script = script.default;
    script.render = require("b2aa938b73078e42").render;
    require("7550b43c263b6162").default(script);
    script.__scopeId = 'data-v-bbb47d';
    script.__file = "WalletApprovalQueue.vue";
};
initialize();
exports.default = script;

},{"f1d6edad5e80a12b":"dKMKX","b2aa938b73078e42":"gj6GH","7550b43c263b6162":"dp6Td","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dKMKX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _datatablesNetVue3 = require("datatables.net-vue3");
var _datatablesNetVue3Default = parcelHelpers.interopDefault(_datatablesNetVue3);
var _datatablesNetBs5 = require("datatables.net-bs5");
var _datatablesNetBs5Default = parcelHelpers.interopDefault(_datatablesNetBs5);
var _bootstrap = require("bootstrap");
var _datatableRenderer = require("../utility/DatatableRenderer");
var _toastNotificationUtility = require("../utility/toastNotificationUtility");
exports.default = {
    __name: 'WalletApprovalQueue',
    setup (__props, { expose: __expose }) {
        __expose();
        (0, _datatablesNetVue3Default.default).use((0, _datatablesNetBs5Default.default));
        const queueDataTable = (0, _vue.ref)(null);
        const dataLoaded = (0, _vue.ref)(false);
        const rejectReason = (0, _vue.ref)('');
        const rejectingRequestId = (0, _vue.ref)(null);
        const isSubmitting = (0, _vue.ref)(false);
        // Rows with an action in flight, keyed by request id. DataTables re-renders actionsRender's raw HTML
        // on every ajax reload rather than tracking real Vue elements per row, so double-submission is guarded
        // here (checked before the fetch, disabled via the DOM element clicked) instead of via a per-row
        // reactive ref the way the modal components in this feature do.
        const rowsInFlight = new Set();
        const reloadTable = ()=>{
            if (queueDataTable.value?.dt) queueDataTable.value.dt.ajax.reload(null, false);
        };
        const runRowAction = async (requestId, buttonEl, path, successMessage, failureMessage)=>{
            if (rowsInFlight.has(requestId)) return;
            rowsInFlight.add(requestId);
            const originalText = buttonEl ? buttonEl.textContent : null;
            if (buttonEl) {
                buttonEl.disabled = true;
                buttonEl.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            }
            try {
                const response = await fetch(`/api/admin/wallet-adjustments/${requestId}/${path}`, {
                    method: 'POST'
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || failureMessage,
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 6000
                    });
                    return;
                }
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: successMessage,
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
                reloadTable();
            } catch (error) {
                console.error(`Error on wallet adjustment request ${path}:`, error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            } finally{
                rowsInFlight.delete(requestId);
                if (buttonEl && document.body.contains(buttonEl)) {
                    buttonEl.disabled = false;
                    buttonEl.textContent = originalText;
                }
            }
        };
        const approve = (requestId, buttonEl)=>runRowAction(requestId, buttonEl, 'approve', 'Request approved and execution attempted.', 'Unable to approve this request.');
        const resume = (requestId, buttonEl)=>runRowAction(requestId, buttonEl, 'resume', 'Execution resumed.', 'Unable to resume this request.');
        const openReject = (requestId)=>{
            rejectingRequestId.value = requestId;
            rejectReason.value = '';
            const modalEl = document.getElementById('wallet-reject-modal');
            ((0, _bootstrap.Modal).getInstance(modalEl) || new (0, _bootstrap.Modal)(modalEl)).show();
        };
        const confirmReject = async ()=>{
            if (!rejectReason.value.trim() || isSubmitting.value || !rejectingRequestId.value) return;
            isSubmitting.value = true;
            try {
                const response = await fetch(`/api/admin/wallet-adjustments/${rejectingRequestId.value}/reject`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        reason: rejectReason.value.trim()
                    })
                });
                if (!response.ok) {
                    const message = await response.text();
                    (0, _toastNotificationUtility.showToast)({
                        title: 'Error',
                        body: message || 'Unable to reject this request.',
                        type: (0, _toastNotificationUtility.notificationType).ERROR,
                        delay: 6000
                    });
                    return;
                }
                const modalEl = document.getElementById('wallet-reject-modal');
                ((0, _bootstrap.Modal).getInstance(modalEl) || new (0, _bootstrap.Modal)(modalEl)).hide();
                (0, _toastNotificationUtility.showToast)({
                    title: 'Success',
                    body: 'Request rejected.',
                    type: (0, _toastNotificationUtility.notificationType).SUCCESS
                });
                reloadTable();
            } catch (error) {
                console.error('Error rejecting wallet adjustment request:', error);
                (0, _toastNotificationUtility.showToast)({
                    title: 'Oops..',
                    body: 'Encountered an internal error. Please contact support.',
                    type: (0, _toastNotificationUtility.notificationType).ERROR,
                    delay: 7000
                });
            } finally{
                isSubmitting.value = false;
            }
        };
        // Event delegation, matching the DatatableRenderer.js editAndDeleteCTA convention: DataTables
        // re-renders rows on every ajax reload, so listeners are bound once on the document rather than
        // per-render.
        $(document).on('click', '.wallet-approve-btn', function() {
            approve($(this).data('id'), this);
        });
        $(document).on('click', '.wallet-reject-btn', function() {
            openReject($(this).data('id'));
        });
        $(document).on('click', '.wallet-resume-btn', function() {
            resume($(this).data('id'), this);
        });
        const actionsRender = (data, type, row)=>{
            if (row.status === 'PENDING_APPROVAL') return `<button class="btn btn-sm btn-success wallet-approve-btn" data-id="${row.id}">Approve</button>
            <button class="btn btn-sm btn-outline-danger wallet-reject-btn" data-id="${row.id}">Reject</button>`;
            if (row.status === 'EXECUTING' || row.status === 'APPROVED') return `<span class="badge bg-danger me-2">Stranded</span>
            <button class="btn btn-sm btn-outline-warning wallet-resume-btn" data-id="${row.id}">Resume</button>`;
            return '';
        };
        const queueColumns = [
            {
                data: 'createdOn',
                title: 'Requested',
                render: (0, _datatableRenderer.zonedDateTime)
            },
            {
                data: 'kind',
                title: 'Kind'
            },
            {
                data: 'walletId',
                title: 'Wallet',
                render: (data)=>`<a href="/admin/wallets/${data}">${(data || '').slice(0, 8)}&hellip;</a>`
            },
            {
                data: 'amountMinor',
                title: 'Amount',
                render: (0, _datatableRenderer.minorCurrency)
            },
            {
                data: 'status',
                title: 'Status',
                render: (0, _datatableRenderer.walletAdjustmentRequestStatus)
            },
            {
                data: 'reason',
                title: 'Reason'
            },
            {
                title: 'Actions',
                orderable: false,
                searchable: false,
                render: actionsRender
            }
        ];
        (0, _vue.onMounted)(()=>{
            dataLoaded.value = true;
        });
        const __returned__ = {
            queueDataTable,
            dataLoaded,
            rejectReason,
            rejectingRequestId,
            isSubmitting,
            rowsInFlight,
            reloadTable,
            runRowAction,
            approve,
            resume,
            openReject,
            confirmReject,
            actionsRender,
            queueColumns,
            ref: (0, _vue.ref),
            onMounted: (0, _vue.onMounted),
            get DataTable () {
                return 0, _datatablesNetVue3Default.default;
            },
            get DataTablesCore () {
                return 0, _datatablesNetBs5Default.default;
            },
            get Modal () {
                return 0, _bootstrap.Modal;
            },
            get minorCurrency () {
                return 0, _datatableRenderer.minorCurrency;
            },
            get walletAdjustmentRequestStatus () {
                return 0, _datatableRenderer.walletAdjustmentRequestStatus;
            },
            get zonedDateTime () {
                return 0, _datatableRenderer.zonedDateTime;
            },
            get showToast () {
                return 0, _toastNotificationUtility.showToast;
            },
            get notificationType () {
                return 0, _toastNotificationUtility.notificationType;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"dylud","datatables.net-vue3":"cWw4N","datatables.net-bs5":"dvcko","bootstrap":"900Wv","../utility/DatatableRenderer":"gfmyC","../utility/toastNotificationUtility":"krOtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gj6GH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "row"
};
const _hoisted_2 = {
    class: "col-xl-12 xl-100 box-col-6"
};
const _hoisted_3 = {
    class: "card"
};
const _hoisted_4 = {
    class: "card-body social-list filter-cards-view"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_7 = {
    class: "modal fade",
    id: "wallet-reject-modal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_8 = {
    class: "modal-dialog modal-dialog-centered"
};
const _hoisted_9 = {
    class: "modal-content"
};
const _hoisted_10 = {
    class: "modal-body"
};
const _hoisted_11 = {
    class: "modal-footer"
};
const _hoisted_12 = [
    "disabled"
];
const _hoisted_13 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        _cache[5] || (_cache[5] = (0, _vue.createElementVNode)("div", {
            class: "page-title"
        }, [
            (0, _vue.createElementVNode)("div", {
                class: "row"
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "col-sm-6 col-12"
                }, [
                    (0, _vue.createElementVNode)("h2", null, "Wallet Approvals"),
                    (0, _vue.createElementVNode)("p", {
                        class: "text-muted mb-0"
                    }, " Pending credit and refund requests, oldest first, plus any request stranded in EXECUTING or APPROVED \u2014 a crash between the claim and the executor call, or between approval and the claim. Resuming is safe: every executor is idempotent on the request's own id, so it can never move money twice. ")
                ])
            ])
        ], -1)),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("div", _hoisted_3, [
                (0, _vue.createElementVNode)("div", _hoisted_4, [
                    $setup.dataLoaded ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                        (0, _vue.createVNode)($setup["DataTable"], {
                            ajax: {
                                url: `/api/datatable/wallet-adjustment-queue`
                            },
                            ref: "queueDataTable",
                            class: "table-responsive display",
                            columns: $setup.queueColumns
                        }, null, 512)
                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, _cache[1] || (_cache[1] = [
                        (0, _vue.createElementVNode)("span", {
                            class: "spinner-border spinner-border-sm me-2"
                        }, null, -1),
                        (0, _vue.createTextVNode)(" Loading... ")
                    ])))
                ])
            ])
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_7, [
            (0, _vue.createElementVNode)("div", _hoisted_8, [
                (0, _vue.createElementVNode)("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("div", {
                        class: "modal-header"
                    }, [
                        (0, _vue.createElementVNode)("h5", {
                            class: "modal-title"
                        }, "Reject Request"),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    (0, _vue.createElementVNode)("div", _hoisted_10, [
                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("label", {
                            class: "form-label"
                        }, [
                            (0, _vue.createTextVNode)("Reason "),
                            (0, _vue.createElementVNode)("span", {
                                class: "text-danger"
                            }, "*")
                        ], -1)),
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("textarea", {
                            class: "form-control",
                            rows: "3",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.rejectReason = $event),
                            required: ""
                        }, null, 512), [
                            [
                                (0, _vue.vModelText),
                                $setup.rejectReason
                            ]
                        ])
                    ]),
                    (0, _vue.createElementVNode)("div", _hoisted_11, [
                        _cache[3] || (_cache[3] = (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            "data-bs-dismiss": "modal"
                        }, "Cancel", -1)),
                        (0, _vue.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-danger",
                            disabled: $setup.isSubmitting || !$setup.rejectReason.trim(),
                            onClick: $setup.confirmReject
                        }, [
                            $setup.isSubmitting ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_13)) : (0, _vue.createCommentVNode)("", true),
                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($setup.isSubmitting ? 'Rejecting...' : 'Reject Request'), 1)
                        ], 8, _hoisted_12)
                    ])
                ])
            ])
        ])
    ]);
}

},{"vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dp6Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DQpv":[function(require,module,exports,__globalThis) {
document.addEventListener("DOMContentLoaded", function() {
    (function() {
        const body = document.querySelector("body");
        const wrapper = document.querySelector(".page-wrapper");
        wrapper.classList.toggle("sidebar-open");
        // active menu js
        let slideUp = (target, duration = 500)=>{
            if (target) {
                target.style.transitionProperty = "height, padding";
                target.style.transitionDuration = duration + "ms";
                target.style.boxSizing = "border-box";
                target.style.height = target.offsetHeight + "px";
                target.offsetHeight;
                target.style.overflow = "hidden";
                target.style.height = 0;
                target.style.paddingTop = 0;
                window.setTimeout(()=>{
                    target.style.display = "none";
                    target.style.removeProperty("height");
                    target.style.removeProperty("padding-top");
                    target.style.removeProperty("overflow");
                    target.style.removeProperty("transition-duration");
                    target.style.removeProperty("transition-property");
                }, duration);
            }
        };
        let slideDown = (target, duration = 500)=>{
            if (target) {
                target.style.removeProperty("display");
                let display = window.getComputedStyle(target).display;
                if (display === "none") display = "flex";
                target.style.display = display;
                let height = target.offsetHeight;
                target.style.overflow = "hidden";
                target.style.height = 0;
                target.style.paddingTop = 0;
                target.offsetHeight;
                target.style.boxSizing = "border-box";
                target.style.transitionProperty = "height, padding";
                target.style.transitionDuration = duration + "ms";
                target.style.height = height + "px";
                target.style.removeProperty("padding-top");
                window.setTimeout(()=>{
                    target.style.removeProperty("height");
                    target.style.removeProperty("overflow");
                    target.style.removeProperty("transition-duration");
                    target.style.removeProperty("transition-property");
                }, duration);
            }
        };
        const sidebarListItems = document.querySelectorAll(".sidebar-link");
        // Add onclick event listener to each sidebar-list item
        sidebarListItems.forEach((item)=>{
            item.addEventListener("click", ()=>{
                item.classList.toggle("active");
                const submenu = item.closest(".sidebar-list").querySelector(".sidebar-submenu");
                if (submenu) submenu.style.display = item.classList.contains("active") ? "block" : "none";
                sidebarListItems.forEach((otherList)=>{
                    if (otherList !== item) {
                        otherList.classList.remove("active");
                        const otherSubmenu = otherList.closest(".sidebar-list").querySelector(".sidebar-submenu");
                        if (otherSubmenu) otherSubmenu.style.display = "none";
                    }
                });
            });
        });
        // Sidebar toggle js
        const sidebarToggle = document.querySelector(".toggle-sidebar");
        sidebarToggle.addEventListener("click", function() {
            wrapper.classList.toggle("sidebar-open");
            const wrapperClose = wrapper.classList.contains("sidebar-open");
        });
    })();
    // scrollTop sidebar in active link in JS
    $(document).ready(function() {
        var activeLink = $(".simplebar-wrapper .simplebar-content-wrapper a.active");
        if (activeLink.length > 0 && $("#pageWrapper").hasClass("compact-wrapper")) {
            var scrollTop = activeLink.offset().top - 400;
            $(".simplebar-wrapper .simplebar-content-wrapper").animate({
                scrollTop: scrollTop
            }, 1000);
        }
    });
    const submenuTitles = document.querySelectorAll(".submenu-title");
    // Add onclick event listener to each submenu-title item
    submenuTitles.forEach((title)=>{
        title.addEventListener("click", ()=>{
            const parentLi = title.closest("li");
            parentLi.classList.toggle("active");
            const submenu = parentLi.querySelector(".according-submenu");
            if (submenu) submenu.style.display = submenu.style.display === "block" ? "none" : "block";
            submenuTitles.forEach((otherTitle)=>{
                if (otherTitle !== title) {
                    const otherParentLi = otherTitle.closest("li");
                    const otherSubmenu = otherParentLi.querySelector(".according-submenu");
                    if (otherSubmenu) otherSubmenu.style.display = "none";
                    otherParentLi.classList.remove("active");
                }
            });
        });
    });
    var url = window.location.href;
    const urlLink = url.includes("#") ? url.split("#")[0] : url;
    const submenuLinks = document.querySelectorAll(".sidebar-menu li a");
    submenuLinks.forEach((el)=>{
        var linkHref = el.href;
        if (urlLink === linkHref) {
            el.classList.add("active");
            const submenu = el.closest(".sidebar-submenu");
            if (submenu && submenu.previousElementSibling) submenu.previousElementSibling.classList.add("active");
            if (submenu) submenu.style.display = "block";
            const parentLi = el.closest(".sidebar-submenu > li");
            if (parentLi) {
                parentLi.classList.add("active");
                const submenu = parentLi.querySelector(".according-submenu");
                if (submenu) submenu.style.display = "block";
            }
        }
    });
    // RESPONSIVE SIDEBAR 1200<
    document.addEventListener("DOMContentLoaded", function() {
        "use strict";
        var pageWrapper = document.querySelector(".page-wrapper");
        var toggleSidebarButton = document.querySelector(".toggle-sidebar");
        var widthWindow = window.innerWidth;
        if (widthWindow <= 1199) {
            pageWrapper.classList.add("sidebar-open");
            toggleSidebarButton.classList.add("close");
        }
        window.addEventListener("resize", function() {
            var widthWindow = window.innerWidth;
            if (widthWindow <= 1199) {
                pageWrapper.classList.add("sidebar-open");
                toggleSidebarButton.classList.add("close");
            } else {
                pageWrapper.classList.remove("sidebar-open");
                toggleSidebarButton.classList.remove("close");
            }
        });
    });
});

},{}],"8MCnn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _simplebar = require("./simplebar");
var _simplebarDefault = parcelHelpers.interopDefault(_simplebar);
document.addEventListener("DOMContentLoaded", function() {
    (function() {
        var myElement = document.getElementById("simple-bar");
        new (0, _simplebarDefault.default)(myElement, {
            autoHide: true
        });
    })();
});

},{"./simplebar":"5bqLo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bqLo":[function(require,module,exports,__globalThis) {
var global = arguments[3];
/**
 * SimpleBar.js - v5.3.0
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var O = 'object';
    var check = function(it) {
        return it && it.Math == Math && it;
    };
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global_1 = // eslint-disable-next-line no-undef
    check(typeof globalThis == O && globalThis) || check(typeof window == O && window) || check(typeof self == O && self) || check(typeof commonjsGlobal == O && commonjsGlobal) || // eslint-disable-next-line no-new-func
    Function('return this')();
    var fails = function(exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };
    // Thank's IE8 for his funny defineProperty
    var descriptors = !fails(function() {
        return Object.defineProperty({}, 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
    var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
        1: 2
    }, 1);
    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
    var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
    } : nativePropertyIsEnumerable;
    var objectPropertyIsEnumerable = {
        f: f
    };
    var createPropertyDescriptor = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
    var toString = {}.toString;
    var classofRaw = function(it) {
        return toString.call(it).slice(8, -1);
    };
    var split = ''.split;
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var indexedObject = fails(function() {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins
        return !Object('z').propertyIsEnumerable(0);
    }) ? function(it) {
        return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
    } : Object;
    // `RequireObjectCoercible` abstract operation
    // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible = function(it) {
        if (it == undefined) throw TypeError("Can't call method on " + it);
        return it;
    };
    // toObject with fallback for non-array-like ES3 strings
    var toIndexedObject = function(it) {
        return indexedObject(requireObjectCoercible(it));
    };
    var isObject = function(it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };
    // `ToPrimitive` abstract operation
    // https://tc39.github.io/ecma262/#sec-toprimitive
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    var toPrimitive = function(input, PREFERRED_STRING) {
        if (!isObject(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
    var hasOwnProperty = {}.hasOwnProperty;
    var has = function(it, key) {
        return hasOwnProperty.call(it, key);
    };
    var document$1 = global_1.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS = isObject(document$1) && isObject(document$1.createElement);
    var documentCreateElement = function(it) {
        return EXISTS ? document$1.createElement(it) : {};
    };
    // Thank's IE8 for his funny defineProperty
    var ie8DomDefine = !descriptors && !fails(function() {
        return Object.defineProperty(documentCreateElement('div'), 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
    var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
    var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (ie8DomDefine) try {
            return nativeGetOwnPropertyDescriptor(O, P);
        } catch (error) {}
        if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };
    var objectGetOwnPropertyDescriptor = {
        f: f$1
    };
    var anObject = function(it) {
        if (!isObject(it)) throw TypeError(String(it) + ' is not an object');
        return it;
    };
    var nativeDefineProperty = Object.defineProperty;
    // `Object.defineProperty` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperty
    var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (ie8DomDefine) try {
            return nativeDefineProperty(O, P, Attributes);
        } catch (error) {}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
    var objectDefineProperty = {
        f: f$2
    };
    var hide = descriptors ? function(object, key, value) {
        return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
    var setGlobal = function(key, value) {
        try {
            hide(global_1, key, value);
        } catch (error) {
            global_1[key] = value;
        }
        return value;
    };
    var shared = createCommonjsModule(function(module1) {
        var SHARED = '__core-js_shared__';
        var store = global_1[SHARED] || setGlobal(SHARED, {});
        (module1.exports = function(key, value) {
            return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
            version: '3.2.1',
            mode: 'global',
            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
        });
    });
    var functionToString = shared('native-function-to-string', Function.toString);
    var WeakMap$1 = global_1.WeakMap;
    var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(functionToString.call(WeakMap$1));
    var id = 0;
    var postfix = Math.random();
    var uid = function(key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
    };
    var keys = shared('keys');
    var sharedKey = function(key) {
        return keys[key] || (keys[key] = uid(key));
    };
    var hiddenKeys = {};
    var WeakMap$2 = global_1.WeakMap;
    var set, get, has$1;
    var enforce = function(it) {
        return has$1(it) ? get(it) : set(it, {});
    };
    var getterFor = function(TYPE) {
        return function(it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required');
            return state;
        };
    };
    if (nativeWeakMap) {
        var store = new WeakMap$2();
        var wmget = store.get;
        var wmhas = store.has;
        var wmset = store.set;
        set = function(it, metadata) {
            wmset.call(store, it, metadata);
            return metadata;
        };
        get = function(it) {
            return wmget.call(store, it) || {};
        };
        has$1 = function(it) {
            return wmhas.call(store, it);
        };
    } else {
        var STATE = sharedKey('state');
        hiddenKeys[STATE] = true;
        set = function(it, metadata) {
            hide(it, STATE, metadata);
            return metadata;
        };
        get = function(it) {
            return has(it, STATE) ? it[STATE] : {};
        };
        has$1 = function(it) {
            return has(it, STATE);
        };
    }
    var internalState = {
        set: set,
        get: get,
        has: has$1,
        enforce: enforce,
        getterFor: getterFor
    };
    var redefine = createCommonjsModule(function(module1) {
        var getInternalState = internalState.get;
        var enforceInternalState = internalState.enforce;
        var TEMPLATE = String(functionToString).split('toString');
        shared('inspectSource', function(it) {
            return functionToString.call(it);
        });
        (module1.exports = function(O, key, value, options) {
            var unsafe = options ? !!options.unsafe : false;
            var simple = options ? !!options.enumerable : false;
            var noTargetGet = options ? !!options.noTargetGet : false;
            if (typeof value == 'function') {
                if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
                enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
            }
            if (O === global_1) {
                if (simple) O[key] = value;
                else setGlobal(key, value);
                return;
            } else if (!unsafe) delete O[key];
            else if (!noTargetGet && O[key]) simple = true;
            if (simple) O[key] = value;
            else hide(O, key, value);
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, 'toString', function toString() {
            return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
        });
    });
    var path = global_1;
    var aFunction = function(variable) {
        return typeof variable == 'function' ? variable : undefined;
    };
    var getBuiltIn = function(namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
    };
    var ceil = Math.ceil;
    var floor = Math.floor;
    // `ToInteger` abstract operation
    // https://tc39.github.io/ecma262/#sec-tointeger
    var toInteger = function(argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };
    var min = Math.min;
    // `ToLength` abstract operation
    // https://tc39.github.io/ecma262/#sec-tolength
    var toLength = function(argument) {
        return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };
    var max = Math.max;
    var min$1 = Math.min;
    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
    var toAbsoluteIndex = function(index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };
    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el) while(length > index){
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value) return true;
            // Array#indexOf ignores holes, Array#includes - not
            }
            else for(; length > index; index++){
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
    var arrayIncludes = {
        // `Array.prototype.includes` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.includes
        includes: createMethod(true),
        // `Array.prototype.indexOf` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod(false)
    };
    var indexOf = arrayIncludes.indexOf;
    var objectKeysInternal = function(object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)!has(hiddenKeys, key) && has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while(names.length > i)if (has(O, key = names[i++])) ~indexOf(result, key) || result.push(key);
        return result;
    };
    // IE8- don't enum bug keys
    var enumBugKeys = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf'
    ];
    var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');
    // `Object.getOwnPropertyNames` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
    var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return objectKeysInternal(O, hiddenKeys$1);
    };
    var objectGetOwnPropertyNames = {
        f: f$3
    };
    var f$4 = Object.getOwnPropertySymbols;
    var objectGetOwnPropertySymbols = {
        f: f$4
    };
    // all object keys, includes non-enumerable and symbols
    var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = objectGetOwnPropertyNames.f(anObject(it));
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
    };
    var copyConstructorProperties = function(target, source) {
        var keys = ownKeys(source);
        var defineProperty = objectDefineProperty.f;
        var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
    };
    var replacement = /#|\.prototype\./;
    var isForced = function(feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
    };
    var normalize = isForced.normalize = function(string) {
        return String(string).replace(replacement, '.').toLowerCase();
    };
    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';
    var isForced_1 = isForced;
    var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
    /*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/ var _export = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED, target, key, targetProperty, sourceProperty, descriptor;
        if (GLOBAL) target = global_1;
        else if (STATIC) target = global_1[TARGET] || setGlobal(TARGET, {});
        else target = (global_1[TARGET] || {}).prototype;
        if (target) for(key in source){
            sourceProperty = source[key];
            if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor$1(target, key);
                targetProperty = descriptor && descriptor.value;
            } else targetProperty = target[key];
            FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
            // contained in target
            if (!FORCED && targetProperty !== undefined) {
                if (typeof sourceProperty === typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
            }
            // add a flag to not completely full polyfills
            if (options.sham || targetProperty && targetProperty.sham) hide(sourceProperty, 'sham', true);
            // extend global
            redefine(target, key, sourceProperty, options);
        }
    };
    var aFunction$1 = function(it) {
        if (typeof it != 'function') throw TypeError(String(it) + ' is not a function');
        return it;
    };
    // optional / simple context binding
    var bindContext = function(fn, that, length) {
        aFunction$1(fn);
        if (that === undefined) return fn;
        switch(length){
            case 0:
                return function() {
                    return fn.call(that);
                };
            case 1:
                return function(a) {
                    return fn.call(that, a);
                };
            case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };
            case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
    // `ToObject` abstract operation
    // https://tc39.github.io/ecma262/#sec-toobject
    var toObject = function(argument) {
        return Object(requireObjectCoercible(argument));
    };
    // `IsArray` abstract operation
    // https://tc39.github.io/ecma262/#sec-isarray
    var isArray = Array.isArray || function isArray(arg) {
        return classofRaw(arg) == 'Array';
    };
    var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function() {
        // Chrome 38 Symbol has incorrect toString conversion
        // eslint-disable-next-line no-undef
        return !String(Symbol());
    });
    var Symbol$1 = global_1.Symbol;
    var store$1 = shared('wks');
    var wellKnownSymbol = function(name) {
        return store$1[name] || (store$1[name] = nativeSymbol && Symbol$1[name] || (nativeSymbol ? Symbol$1 : uid)('Symbol.' + name));
    };
    var SPECIES = wellKnownSymbol('species');
    // `ArraySpeciesCreate` abstract operation
    // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
    var arraySpeciesCreate = function(originalArray, length) {
        var C;
        if (isArray(originalArray)) {
            C = originalArray.constructor;
            // cross-realm fallback
            if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
            else if (isObject(C)) {
                C = C[SPECIES];
                if (C === null) C = undefined;
            }
        }
        return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };
    var push = [].push;
    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
    var createMethod$1 = function(TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        return function($this, callbackfn, that, specificCreate) {
            var O = toObject($this);
            var self1 = indexedObject(O);
            var boundFunction = bindContext(callbackfn, that, 3);
            var length = toLength(self1.length);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate;
            var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
            var value, result;
            for(; length > index; index++)if (NO_HOLES || index in self1) {
                value = self1[index];
                result = boundFunction(value, index, O);
                if (TYPE) {
                    if (IS_MAP) target[index] = result; // map
                    else if (result) switch(TYPE){
                        case 3:
                            return true; // some
                        case 5:
                            return value; // find
                        case 6:
                            return index; // findIndex
                        case 2:
                            push.call(target, value); // filter
                    }
                    else if (IS_EVERY) return false; // every
                }
            }
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
    };
    var arrayIteration = {
        // `Array.prototype.forEach` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
        forEach: createMethod$1(0),
        // `Array.prototype.map` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.map
        map: createMethod$1(1),
        // `Array.prototype.filter` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.filter
        filter: createMethod$1(2),
        // `Array.prototype.some` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.some
        some: createMethod$1(3),
        // `Array.prototype.every` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.every
        every: createMethod$1(4),
        // `Array.prototype.find` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.find
        find: createMethod$1(5),
        // `Array.prototype.findIndex` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod$1(6)
    };
    var sloppyArrayMethod = function(METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !method || !fails(function() {
            // eslint-disable-next-line no-useless-call,no-throw-literal
            method.call(null, argument || function() {
                throw 1;
            }, 1);
        });
    };
    var $forEach = arrayIteration.forEach;
    // `Array.prototype.forEach` method implementation
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    var arrayForEach = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */ ) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    } : [].forEach;
    // `Array.prototype.forEach` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    _export({
        target: 'Array',
        proto: true,
        forced: [].forEach != arrayForEach
    }, {
        forEach: arrayForEach
    });
    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };
    for(var COLLECTION_NAME in domIterables){
        var Collection = global_1[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
            hide(CollectionPrototype, 'forEach', arrayForEach);
        } catch (error) {
            CollectionPrototype.forEach = arrayForEach;
        }
    }
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var canUseDom = canUseDOM;
    var SPECIES$1 = wellKnownSymbol('species');
    var arrayMethodHasSpeciesSupport = function(METHOD_NAME) {
        return !fails(function() {
            var array = [];
            var constructor = array.constructor = {};
            constructor[SPECIES$1] = function() {
                return {
                    foo: 1
                };
            };
            return array[METHOD_NAME](Boolean).foo !== 1;
        });
    };
    var $filter = arrayIteration.filter;
    // `Array.prototype.filter` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.filter
    // with adding support of @@species
    _export({
        target: 'Array',
        proto: true,
        forced: !arrayMethodHasSpeciesSupport('filter')
    }, {
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    // `Object.keys` method
    // https://tc39.github.io/ecma262/#sec-object.keys
    var objectKeys = Object.keys || function keys(O) {
        return objectKeysInternal(O, enumBugKeys);
    };
    // `Object.defineProperties` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperties
    var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index = 0;
        var key;
        while(length > index)objectDefineProperty.f(O, key = keys[index++], Properties[key]);
        return O;
    };
    var html = getBuiltIn('document', 'documentElement');
    var IE_PROTO = sharedKey('IE_PROTO');
    var PROTOTYPE = 'prototype';
    var Empty = function() {};
    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var createDict = function() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe');
        var length = enumBugKeys.length;
        var lt = '<';
        var script = 'script';
        var gt = '>';
        var js = 'java' + script + ':';
        var iframeDocument;
        iframe.style.display = 'none';
        html.appendChild(iframe);
        iframe.src = String(js);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while(length--)delete createDict[PROTOTYPE][enumBugKeys[length]];
        return createDict();
    };
    // `Object.create` method
    // https://tc39.github.io/ecma262/#sec-object.create
    var objectCreate = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
        } else result = createDict();
        return Properties === undefined ? result : objectDefineProperties(result, Properties);
    };
    hiddenKeys[IE_PROTO] = true;
    var UNSCOPABLES = wellKnownSymbol('unscopables');
    var ArrayPrototype = Array.prototype;
    // Array.prototype[@@unscopables]
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    if (ArrayPrototype[UNSCOPABLES] == undefined) hide(ArrayPrototype, UNSCOPABLES, objectCreate(null));
    // add a key to Array.prototype[@@unscopables]
    var addToUnscopables = function(key) {
        ArrayPrototype[UNSCOPABLES][key] = true;
    };
    var iterators = {};
    var correctPrototypeGetter = !fails(function() {
        function F() {}
        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
    });
    var IE_PROTO$1 = sharedKey('IE_PROTO');
    var ObjectPrototype = Object.prototype;
    // `Object.getPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.getprototypeof
    var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function(O) {
        O = toObject(O);
        if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
        return O instanceof Object ? ObjectPrototype : null;
    };
    var ITERATOR = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS = false;
    var returnThis = function() {
        return this;
    };
    // `%IteratorPrototype%` object
    // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
    if ([].keys) {
        arrayIterator = [].keys();
        // Safari 8 has buggy iterators w/o `next`
        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
        else {
            PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
    }
    if (IteratorPrototype == undefined) IteratorPrototype = {};
    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    if (!has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
    };
    var defineProperty = objectDefineProperty.f;
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var setToStringTag = function(it, TAG, STATIC) {
        if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
    };
    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
    var returnThis$1 = function() {
        return this;
    };
    var createIteratorConstructor = function(IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
            next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
        iterators[TO_STRING_TAG] = returnThis$1;
        return IteratorConstructor;
    };
    var aPossiblePrototype = function(it) {
        if (!isObject(it) && it !== null) throw TypeError("Can't set " + String(it) + ' as a prototype');
        return it;
    };
    // `Object.setPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    /* eslint-disable no-proto */ var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
            setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
            setter.call(test, []);
            CORRECT_SETTER = test instanceof Array;
        } catch (error) {}
        return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter.call(O, proto);
            else O.__proto__ = proto;
            return O;
        };
    }() : undefined);
    var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$1 = wellKnownSymbol('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';
    var returnThis$2 = function() {
        return this;
    };
    var defineIterator = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);
        var getIterationMethod = function(KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
            switch(KIND){
                case KEYS:
                    return function keys() {
                        return new IteratorConstructor(this, KIND);
                    };
                case VALUES:
                    return function values() {
                        return new IteratorConstructor(this, KIND);
                    };
                case ENTRIES:
                    return function entries() {
                        return new IteratorConstructor(this, KIND);
                    };
            }
            return function() {
                return new IteratorConstructor(this);
            };
        };
        var TO_STRING_TAG = NAME + ' Iterator';
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
        // fix native
        if (anyNativeIterator) {
            CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
            if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
                if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
                    if (objectSetPrototypeOf) objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
                    else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') hide(CurrentIteratorPrototype, ITERATOR$1, returnThis$2);
                }
                // Set @@toStringTag to native iterators
                setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
            }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return nativeIterator.call(this);
            };
        }
        // define iterator
        if (IterablePrototype[ITERATOR$1] !== defaultIterator) hide(IterablePrototype, ITERATOR$1, defaultIterator);
        iterators[NAME] = defaultIterator;
        // export additional methods
        if (DEFAULT) {
            methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) {
                for(KEY in methods)if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
            } else _export({
                target: NAME,
                proto: true,
                forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
            }, methods);
        }
        return methods;
    };
    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState = internalState.set;
    var getInternalState = internalState.getterFor(ARRAY_ITERATOR);
    // `Array.prototype.entries` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.github.io/ecma262/#sec-createarrayiterator
    var es_array_iterator = defineIterator(Array, 'Array', function(iterated, kind) {
        setInternalState(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated),
            index: 0,
            kind: kind // kind
        });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
    }, function() {
        var state = getInternalState(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;
        if (!target || index >= target.length) {
            state.target = undefined;
            return {
                value: undefined,
                done: true
            };
        }
        if (kind == 'keys') return {
            value: index,
            done: false
        };
        if (kind == 'values') return {
            value: target[index],
            done: false
        };
        return {
            value: [
                index,
                target[index]
            ],
            done: false
        };
    }, 'values');
    // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
    iterators.Arguments = iterators.Array;
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');
    var nativeAssign = Object.assign;
    // `Object.assign` method
    // https://tc39.github.io/ecma262/#sec-object.assign
    // should work with symbols and should have deterministic property order (V8 bug)
    var objectAssign = !nativeAssign || fails(function() {
        var A = {};
        var B = {};
        // eslint-disable-next-line no-undef
        var symbol = Symbol();
        var alphabet = 'abcdefghijklmnopqrst';
        A[symbol] = 7;
        alphabet.split('').forEach(function(chr) {
            B[chr] = chr;
        });
        return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
    }) ? function assign(target, source) {
        var T = toObject(target);
        var argumentsLength = arguments.length;
        var index = 1;
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        var propertyIsEnumerable = objectPropertyIsEnumerable.f;
        while(argumentsLength > index){
            var S = indexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;
            while(length > j){
                key = keys[j++];
                if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
            }
        }
        return T;
    } : nativeAssign;
    // `Object.assign` method
    // https://tc39.github.io/ecma262/#sec-object.assign
    _export({
        target: 'Object',
        stat: true,
        forced: Object.assign !== objectAssign
    }, {
        assign: objectAssign
    });
    var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
    }()) == 'Arguments';
    // fallback for IE11 Script Access Denied error
    var tryGet = function(it, key) {
        try {
            return it[key];
        } catch (error) {}
    };
    // getting tag from ES6+ `Object.prototype.toString`
    var classof = function(it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
    };
    var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
    var test = {};
    test[TO_STRING_TAG$2] = 'z';
    // `Object.prototype.toString` method implementation
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    var objectToString = String(test) !== '[object z]' ? function toString() {
        return '[object ' + classof(this) + ']';
    } : test.toString;
    var ObjectPrototype$1 = Object.prototype;
    // `Object.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    if (objectToString !== ObjectPrototype$1.toString) redefine(ObjectPrototype$1, 'toString', objectToString, {
        unsafe: true
    });
    // a string of all valid unicode whitespaces
    // eslint-disable-next-line max-len
    var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
    var whitespace = '[' + whitespaces + ']';
    var ltrim = RegExp('^' + whitespace + whitespace + '*');
    var rtrim = RegExp(whitespace + whitespace + '*$');
    // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
    var createMethod$2 = function(TYPE) {
        return function($this) {
            var string = String(requireObjectCoercible($this));
            if (TYPE & 1) string = string.replace(ltrim, '');
            if (TYPE & 2) string = string.replace(rtrim, '');
            return string;
        };
    };
    var stringTrim = {
        // `String.prototype.{ trimLeft, trimStart }` methods
        // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
        start: createMethod$2(1),
        // `String.prototype.{ trimRight, trimEnd }` methods
        // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
        end: createMethod$2(2),
        // `String.prototype.trim` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.trim
        trim: createMethod$2(3)
    };
    var trim = stringTrim.trim;
    var nativeParseInt = global_1.parseInt;
    var hex = /^[+-]?0[Xx]/;
    var FORCED = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;
    // `parseInt` method
    // https://tc39.github.io/ecma262/#sec-parseint-string-radix
    var _parseInt = FORCED ? function parseInt1(string, radix) {
        var S = trim(String(string));
        return nativeParseInt(S, radix >>> 0 || (hex.test(S) ? 16 : 10));
    } : nativeParseInt;
    // `parseInt` method
    // https://tc39.github.io/ecma262/#sec-parseint-string-radix
    _export({
        global: true,
        forced: parseInt != _parseInt
    }, {
        parseInt: _parseInt
    });
    // `String.prototype.{ codePointAt, at }` methods implementation
    var createMethod$3 = function(CONVERT_TO_STRING) {
        return function($this, pos) {
            var S = String(requireObjectCoercible($this));
            var position = toInteger(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = S.charCodeAt(position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
        };
    };
    var stringMultibyte = {
        // `String.prototype.codePointAt` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod$3(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod$3(true)
    };
    var charAt = stringMultibyte.charAt;
    var STRING_ITERATOR = 'String Iterator';
    var setInternalState$1 = internalState.set;
    var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);
    // `String.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
    defineIterator(String, 'String', function(iterated) {
        setInternalState$1(this, {
            type: STRING_ITERATOR,
            string: String(iterated),
            index: 0
        });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
        var state = getInternalState$1(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return {
            value: undefined,
            done: true
        };
        point = charAt(string, index);
        state.index += point.length;
        return {
            value: point,
            done: false
        };
    });
    var redefineAll = function(target, src, options) {
        for(var key in src)redefine(target, key, src[key], options);
        return target;
    };
    var freezing = !fails(function() {
        return Object.isExtensible(Object.preventExtensions({}));
    });
    var internalMetadata = createCommonjsModule(function(module1) {
        var defineProperty = objectDefineProperty.f;
        var METADATA = uid('meta');
        var id = 0;
        var isExtensible = Object.isExtensible || function() {
            return true;
        };
        var setMetadata = function(it) {
            defineProperty(it, METADATA, {
                value: {
                    objectID: 'O' + ++id,
                    weakData: {} // weak collections IDs
                }
            });
        };
        var fastKey = function(it, create) {
            // return a primitive with prefix
            if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
            if (!has(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return 'F';
                // not necessary to add metadata
                if (!create) return 'E';
                // add missing metadata
                setMetadata(it);
            // return object ID
            }
            return it[METADATA].objectID;
        };
        var getWeakData = function(it, create) {
            if (!has(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return true;
                // not necessary to add metadata
                if (!create) return false;
                // add missing metadata
                setMetadata(it);
            // return the store of weak collections IDs
            }
            return it[METADATA].weakData;
        };
        // add metadata on freeze-family methods calling
        var onFreeze = function(it) {
            if (freezing && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
            return it;
        };
        var meta = module1.exports = {
            REQUIRED: false,
            fastKey: fastKey,
            getWeakData: getWeakData,
            onFreeze: onFreeze
        };
        hiddenKeys[METADATA] = true;
    });
    var internalMetadata_1 = internalMetadata.REQUIRED;
    var internalMetadata_2 = internalMetadata.fastKey;
    var internalMetadata_3 = internalMetadata.getWeakData;
    var internalMetadata_4 = internalMetadata.onFreeze;
    var ITERATOR$2 = wellKnownSymbol('iterator');
    var ArrayPrototype$1 = Array.prototype;
    // check on default Array iterator
    var isArrayIteratorMethod = function(it) {
        return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$2] === it);
    };
    var ITERATOR$3 = wellKnownSymbol('iterator');
    var getIteratorMethod = function(it) {
        if (it != undefined) return it[ITERATOR$3] || it['@@iterator'] || iterators[classof(it)];
    };
    // call something on iterator step with safe closing on error
    var callWithSafeIterationClosing = function(iterator, fn, value, ENTRIES) {
        try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
        } catch (error) {
            var returnMethod = iterator['return'];
            if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
            throw error;
        }
    };
    var iterate_1 = createCommonjsModule(function(module1) {
        var Result = function(stopped, result) {
            this.stopped = stopped;
            this.result = result;
        };
        var iterate = module1.exports = function(iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
            var boundFunction = bindContext(fn, that, AS_ENTRIES ? 2 : 1);
            var iterator, iterFn, index, length, result, step;
            if (IS_ITERATOR) iterator = iterable;
            else {
                iterFn = getIteratorMethod(iterable);
                if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
                // optimisation for array iterators
                if (isArrayIteratorMethod(iterFn)) {
                    for(index = 0, length = toLength(iterable.length); length > index; index++){
                        result = AS_ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
                        if (result && result instanceof Result) return result;
                    }
                    return new Result(false);
                }
                iterator = iterFn.call(iterable);
            }
            while(!(step = iterator.next()).done){
                result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
                if (result && result instanceof Result) return result;
            }
            return new Result(false);
        };
        iterate.stop = function(result) {
            return new Result(true, result);
        };
    });
    var anInstance = function(it, Constructor, name) {
        if (!(it instanceof Constructor)) throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
        return it;
    };
    var ITERATOR$4 = wellKnownSymbol('iterator');
    var SAFE_CLOSING = false;
    try {
        var called = 0;
        var iteratorWithReturn = {
            next: function() {
                return {
                    done: !!called++
                };
            },
            'return': function() {
                SAFE_CLOSING = true;
            }
        };
        iteratorWithReturn[ITERATOR$4] = function() {
            return this;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(iteratorWithReturn, function() {
            throw 2;
        });
    } catch (error) {}
    var checkCorrectnessOfIteration = function(exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        var ITERATION_SUPPORT = false;
        try {
            var object = {};
            object[ITERATOR$4] = function() {
                return {
                    next: function() {
                        return {
                            done: ITERATION_SUPPORT = true
                        };
                    }
                };
            };
            exec(object);
        } catch (error) {}
        return ITERATION_SUPPORT;
    };
    // makes subclassing work correct for wrapped built-ins
    var inheritIfRequired = function($this, dummy, Wrapper) {
        var NewTarget, NewTargetPrototype;
        if (// it can work only with native `setPrototypeOf`
        objectSetPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
        typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
        return $this;
    };
    var collection = function(CONSTRUCTOR_NAME, wrapper, common, IS_MAP, IS_WEAK) {
        var NativeConstructor = global_1[CONSTRUCTOR_NAME];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        var Constructor = NativeConstructor;
        var ADDER = IS_MAP ? 'set' : 'add';
        var exported = {};
        var fixMethod = function(KEY) {
            var nativeMethod = NativePrototype[KEY];
            redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
                nativeMethod.call(this, value === 0 ? 0 : value);
                return this;
            } : KEY == 'delete' ? function(key) {
                return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
            } : KEY == 'get' ? function get(key) {
                return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
            } : KEY == 'has' ? function has(key) {
                return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
            } : function set(key, value) {
                nativeMethod.call(this, key === 0 ? 0 : key, value);
                return this;
            });
        };
        // eslint-disable-next-line max-len
        if (isForced_1(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
            new NativeConstructor().entries().next();
        })))) {
            // create collection constructor
            Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
            internalMetadata.REQUIRED = true;
        } else if (isForced_1(CONSTRUCTOR_NAME, true)) {
            var instance = new Constructor();
            // early implementations not supports chaining
            var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
            // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
            var THROWS_ON_PRIMITIVES = fails(function() {
                instance.has(1);
            });
            // most early implementations doesn't supports iterables, most modern - not close it correctly
            // eslint-disable-next-line no-new
            var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
                new NativeConstructor(iterable);
            });
            // for early implementations -0 and +0 not the same
            var BUGGY_ZERO = !IS_WEAK && fails(function() {
                // V8 ~ Chromium 42- fails only with 5+ elements
                var $instance = new NativeConstructor();
                var index = 5;
                while(index--)$instance[ADDER](index, index);
                return !$instance.has(-0);
            });
            if (!ACCEPT_ITERABLES) {
                Constructor = wrapper(function(dummy, iterable) {
                    anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
                    var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                    if (iterable != undefined) iterate_1(iterable, that[ADDER], that, IS_MAP);
                    return that;
                });
                Constructor.prototype = NativePrototype;
                NativePrototype.constructor = Constructor;
            }
            if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                fixMethod('delete');
                fixMethod('has');
                IS_MAP && fixMethod('get');
            }
            if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
            // weak collections should not contains .clear method
            if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
        }
        exported[CONSTRUCTOR_NAME] = Constructor;
        _export({
            global: true,
            forced: Constructor != NativeConstructor
        }, exported);
        setToStringTag(Constructor, CONSTRUCTOR_NAME);
        if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
        return Constructor;
    };
    var getWeakData = internalMetadata.getWeakData;
    var setInternalState$2 = internalState.set;
    var internalStateGetterFor = internalState.getterFor;
    var find = arrayIteration.find;
    var findIndex = arrayIteration.findIndex;
    var id$1 = 0;
    // fallback for uncaught frozen keys
    var uncaughtFrozenStore = function(store) {
        return store.frozen || (store.frozen = new UncaughtFrozenStore());
    };
    var UncaughtFrozenStore = function() {
        this.entries = [];
    };
    var findUncaughtFrozen = function(store, key) {
        return find(store.entries, function(it) {
            return it[0] === key;
        });
    };
    UncaughtFrozenStore.prototype = {
        get: function(key) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) return entry[1];
        },
        has: function(key) {
            return !!findUncaughtFrozen(this, key);
        },
        set: function(key, value) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) entry[1] = value;
            else this.entries.push([
                key,
                value
            ]);
        },
        'delete': function(key) {
            var index = findIndex(this.entries, function(it) {
                return it[0] === key;
            });
            if (~index) this.entries.splice(index, 1);
            return !!~index;
        }
    };
    var collectionWeak = {
        getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var C = wrapper(function(that, iterable) {
                anInstance(that, C, CONSTRUCTOR_NAME);
                setInternalState$2(that, {
                    type: CONSTRUCTOR_NAME,
                    id: id$1++,
                    frozen: undefined
                });
                if (iterable != undefined) iterate_1(iterable, that[ADDER], that, IS_MAP);
            });
            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
            var define = function(that, key, value) {
                var state = getInternalState(that);
                var data = getWeakData(anObject(key), true);
                if (data === true) uncaughtFrozenStore(state).set(key, value);
                else data[state.id] = value;
                return that;
            };
            redefineAll(C.prototype, {
                // 23.3.3.2 WeakMap.prototype.delete(key)
                // 23.4.3.3 WeakSet.prototype.delete(value)
                'delete': function(key) {
                    var state = getInternalState(this);
                    if (!isObject(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state)['delete'](key);
                    return data && has(data, state.id) && delete data[state.id];
                },
                // 23.3.3.4 WeakMap.prototype.has(key)
                // 23.4.3.4 WeakSet.prototype.has(value)
                has: function has$1(key) {
                    var state = getInternalState(this);
                    if (!isObject(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).has(key);
                    return data && has(data, state.id);
                }
            });
            redefineAll(C.prototype, IS_MAP ? {
                // 23.3.3.3 WeakMap.prototype.get(key)
                get: function get(key) {
                    var state = getInternalState(this);
                    if (isObject(key)) {
                        var data = getWeakData(key);
                        if (data === true) return uncaughtFrozenStore(state).get(key);
                        return data ? data[state.id] : undefined;
                    }
                },
                // 23.3.3.5 WeakMap.prototype.set(key, value)
                set: function set(key, value) {
                    return define(this, key, value);
                }
            } : {
                // 23.4.3.1 WeakSet.prototype.add(value)
                add: function add(value) {
                    return define(this, value, true);
                }
            });
            return C;
        }
    };
    var es_weakMap = createCommonjsModule(function(module1) {
        var enforceIternalState = internalState.enforce;
        var IS_IE11 = !global_1.ActiveXObject && 'ActiveXObject' in global_1;
        var isExtensible = Object.isExtensible;
        var InternalWeakMap;
        var wrapper = function(get) {
            return function WeakMap1() {
                return get(this, arguments.length ? arguments[0] : undefined);
            };
        };
        // `WeakMap` constructor
        // https://tc39.github.io/ecma262/#sec-weakmap-constructor
        var $WeakMap = module1.exports = collection('WeakMap', wrapper, collectionWeak, true, true);
        // IE11 WeakMap frozen keys fix
        // We can't use feature detection because it crash some old IE builds
        // https://github.com/zloirock/core-js/issues/485
        if (nativeWeakMap && IS_IE11) {
            InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
            internalMetadata.REQUIRED = true;
            var WeakMapPrototype = $WeakMap.prototype;
            var nativeDelete = WeakMapPrototype['delete'];
            var nativeHas = WeakMapPrototype.has;
            var nativeGet = WeakMapPrototype.get;
            var nativeSet = WeakMapPrototype.set;
            redefineAll(WeakMapPrototype, {
                'delete': function(key) {
                    if (isObject(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeDelete.call(this, key) || state.frozen['delete'](key);
                    }
                    return nativeDelete.call(this, key);
                },
                has: function has(key) {
                    if (isObject(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) || state.frozen.has(key);
                    }
                    return nativeHas.call(this, key);
                },
                get: function get(key) {
                    if (isObject(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
                    }
                    return nativeGet.call(this, key);
                },
                set: function set(key, value) {
                    if (isObject(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
                    } else nativeSet.call(this, key, value);
                    return this;
                }
            });
        }
    });
    var ITERATOR$5 = wellKnownSymbol('iterator');
    var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
    var ArrayValues = es_array_iterator.values;
    for(var COLLECTION_NAME$1 in domIterables){
        var Collection$1 = global_1[COLLECTION_NAME$1];
        var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
        if (CollectionPrototype$1) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype$1[ITERATOR$5] !== ArrayValues) try {
                hide(CollectionPrototype$1, ITERATOR$5, ArrayValues);
            } catch (error) {
                CollectionPrototype$1[ITERATOR$5] = ArrayValues;
            }
            if (!CollectionPrototype$1[TO_STRING_TAG$3]) hide(CollectionPrototype$1, TO_STRING_TAG$3, COLLECTION_NAME$1);
            if (domIterables[COLLECTION_NAME$1]) for(var METHOD_NAME in es_array_iterator){
                // some Chrome versions have non-configurable methods on DOMTokenList
                if (CollectionPrototype$1[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
                    hide(CollectionPrototype$1, METHOD_NAME, es_array_iterator[METHOD_NAME]);
                } catch (error) {
                    CollectionPrototype$1[METHOD_NAME] = es_array_iterator[METHOD_NAME];
                }
            }
        }
    }
    /**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */ /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
    /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
    /** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var objectToString$1 = objectProto.toString;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now = function() {
        return root.Date.now();
    };
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        wait = toNumber(wait) || 0;
        if (isObject$1(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
            return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    /**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */ function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        if (isObject$1(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
        });
    }
    /**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */ function isObject$1(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
    }
    /**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */ function isObjectLike(value) {
        return !!value && typeof value == 'object';
    }
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && objectToString$1.call(value) == symbolTag;
    }
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber(value) {
        if (typeof value == 'number') return value;
        if (isSymbol(value)) return NAN;
        if (isObject$1(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject$1(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = value.replace(reTrim, '');
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    var lodash_throttle = throttle;
    /**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */ /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT$1 = 'Expected a function';
    /** Used as references for various `Number` constants. */ var NAN$1 = 0 / 0;
    /** `Object#toString` result references. */ var symbolTag$1 = '[object Symbol]';
    /** Used to match leading and trailing whitespace. */ var reTrim$1 = /^\s+|\s+$/g;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary$1 = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal$1 = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt$1 = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
    /** Used for built-in method references. */ var objectProto$1 = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var objectToString$2 = objectProto$1.toString;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax$1 = Math.max, nativeMin$1 = Math.min;
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now$1 = function() {
        return root$1.Date.now();
    };
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce$1(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT$1);
        wait = toNumber$1(wait) || 0;
        if (isObject$2(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
            return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now$1();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now$1());
        }
        function debounced() {
            var time = now$1(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    /**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */ function isObject$2(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
    }
    /**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */ function isObjectLike$1(value) {
        return !!value && typeof value == 'object';
    }
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol$1(value) {
        return typeof value == 'symbol' || isObjectLike$1(value) && objectToString$2.call(value) == symbolTag$1;
    }
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber$1(value) {
        if (typeof value == 'number') return value;
        if (isSymbol$1(value)) return NAN$1;
        if (isObject$2(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject$2(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = value.replace(reTrim$1, '');
        var isBinary = reIsBinary$1.test(value);
        return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
    }
    var lodash_debounce = debounce$1;
    /**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */ /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT$2 = 'Expected a function';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** `Object#toString` result references. */ var funcTag = '[object Function]', genTag = '[object GeneratorFunction]';
    /**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Detect free variable `global` from Node.js. */ var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root$2 = freeGlobal$2 || freeSelf$2 || Function('return this')();
    /**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */ function isHostObject(value) {
        // Many host objects are `Object` objects that can coerce to strings
        // despite having improperly defined `toString` methods.
        var result = false;
        if (value != null && typeof value.toString != 'function') try {
            result = !!(value + '');
        } catch (e) {}
        return result;
    }
    /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto$2 = Object.prototype;
    /** Used to detect overreaching core-js shims. */ var coreJsData = root$2['__core-js_shared__'];
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var objectToString$3 = objectProto$2.toString;
    /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /** Built-in value references. */ var splice = arrayProto.splice;
    /* Built-in method references that are verified to be native. */ var Map$1 = getNative(root$2, 'Map'), nativeCreate = getNative(Object, 'create');
    /**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function Hash(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    /**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function hashDelete(key) {
        return this.has(key) && delete this.__data__[key];
    }
    /**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
    }
    /**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
    }
    /**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */ function hashSet(key, value) {
        var data = this.__data__;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function ListCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */ function listCacheClear() {
        this.__data__ = [];
    }
    /**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        return true;
    }
    /**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    /**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    /**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) data.push([
            key,
            value
        ]);
        else data[index][1] = value;
        return this;
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function MapCache(entries) {
        var index = -1, length = entries ? entries.length : 0;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */ function mapCacheClear() {
        this.__data__ = {
            'hash': new Hash,
            'map': new (Map$1 || ListCache),
            'string': new Hash
        };
    }
    /**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function mapCacheDelete(key) {
        return getMapData(this, key)['delete'](key);
    }
    /**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    /**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    /**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */ function mapCacheSet(key, value) {
        getMapData(this, key).set(key, value);
        return this;
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    /**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */ function baseIsNative(value) {
        if (!isObject$3(value) || isMasked(value)) return false;
        var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    /**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    /**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    /**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */ function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    /**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    /**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + '';
            } catch (e) {}
        }
        return '';
    }
    /**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */ function memoize(func, resolver) {
        if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT$2);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result);
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;
    /**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */ function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    /**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */ function isFunction(value) {
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 8-9 which returns 'object' for typed array and other constructors.
        var tag = isObject$3(value) ? objectToString$3.call(value) : '';
        return tag == funcTag || tag == genTag;
    }
    /**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */ function isObject$3(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
    }
    var lodash_memoize = memoize;
    /**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var MapShim = function() {
        if (typeof Map !== 'undefined') return Map;
        /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */ function getIndex(arr, key) {
            var result = -1;
            arr.some(function(entry, index) {
                if (entry[0] === key) {
                    result = index;
                    return true;
                }
                return false;
            });
            return result;
        }
        return /** @class */ function() {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
	             * @returns {boolean}
	             */ get: function() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
	         * @param {*} key
	         * @returns {*}
	         */ class_1.prototype.get = function(key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */ class_1.prototype.set = function(key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) this.__entries__[index][1] = value;
                else this.__entries__.push([
                    key,
                    value
                ]);
            };
            /**
	         * @param {*} key
	         * @returns {void}
	         */ class_1.prototype.delete = function(key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) entries.splice(index, 1);
            };
            /**
	         * @param {*} key
	         * @returns {void}
	         */ class_1.prototype.has = function(key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
	         * @returns {void}
	         */ class_1.prototype.clear = function() {
                this.__entries__.splice(0);
            };
            /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */ class_1.prototype.forEach = function(callback, ctx) {
                if (ctx === void 0) ctx = null;
                for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }();
    }();
    /**
	 * Detects whether window and document objects are available in current environment.
	 */ var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
    // Returns global object of a current environment.
    var global$1 = function() {
        if (typeof global !== 'undefined' && global.Math === Math) return global;
        if (typeof self !== 'undefined' && self.Math === Math) return self;
        if (typeof window !== 'undefined' && window.Math === Math) return window;
        // eslint-disable-next-line no-new-func
        return Function('return this')();
    }();
    /**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */ var requestAnimationFrame$1 = function() {
        if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
        return function(callback) {
            return setTimeout(function() {
                return callback(Date.now());
            }, 1000 / 60);
        };
    }();
    // Defines minimum timeout before adding a trailing call.
    var trailingTimeout = 2;
    /**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */ function throttle$1(callback, delay) {
        var leadingCall = false, trailingCall = false, lastCallTime = 0;
        /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */ function resolvePending() {
            if (leadingCall) {
                leadingCall = false;
                callback();
            }
            if (trailingCall) proxy();
        }
        /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */ function timeoutCallback() {
            requestAnimationFrame$1(resolvePending);
        }
        /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */ function proxy() {
            var timeStamp = Date.now();
            if (leadingCall) {
                // Reject immediately following calls.
                if (timeStamp - lastCallTime < trailingTimeout) return;
                // Schedule new call to be in invoked when the pending one is resolved.
                // This is important for "transitions" which never actually start
                // immediately so there is a chance that we might miss one if change
                // happens amids the pending invocation.
                trailingCall = true;
            } else {
                leadingCall = true;
                trailingCall = false;
                setTimeout(timeoutCallback, delay);
            }
            lastCallTime = timeStamp;
        }
        return proxy;
    }
    // Minimum delay before invoking the update of observers.
    var REFRESH_DELAY = 20;
    // A list of substrings of CSS properties used to find transition events that
    // might affect dimensions of observed elements.
    var transitionKeys = [
        'top',
        'right',
        'bottom',
        'left',
        'width',
        'height',
        'size',
        'weight'
    ];
    // Check if MutationObserver is available.
    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
    /**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */ var ResizeObserverController = /** @class */ function() {
        /**
	     * Creates a new instance of ResizeObserverController.
	     *
	     * @private
	     */ function ResizeObserverController() {
            /**
	         * Indicates whether DOM listeners have been added.
	         *
	         * @private {boolean}
	         */ this.connected_ = false;
            /**
	         * Tells that controller has subscribed for Mutation Events.
	         *
	         * @private {boolean}
	         */ this.mutationEventsAdded_ = false;
            /**
	         * Keeps reference to the instance of MutationObserver.
	         *
	         * @private {MutationObserver}
	         */ this.mutationsObserver_ = null;
            /**
	         * A list of connected observers.
	         *
	         * @private {Array<ResizeObserverSPI>}
	         */ this.observers_ = [];
            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
            this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
        }
        /**
	     * Adds observer to observers list.
	     *
	     * @param {ResizeObserverSPI} observer - Observer to be added.
	     * @returns {void}
	     */ ResizeObserverController.prototype.addObserver = function(observer) {
            if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
            // Add listeners if they haven't been added yet.
            if (!this.connected_) this.connect_();
        };
        /**
	     * Removes observer from observers list.
	     *
	     * @param {ResizeObserverSPI} observer - Observer to be removed.
	     * @returns {void}
	     */ ResizeObserverController.prototype.removeObserver = function(observer) {
            var observers = this.observers_;
            var index = observers.indexOf(observer);
            // Remove observer if it's present in registry.
            if (~index) observers.splice(index, 1);
            // Remove listeners if controller has no connected observers.
            if (!observers.length && this.connected_) this.disconnect_();
        };
        /**
	     * Invokes the update of observers. It will continue running updates insofar
	     * it detects changes.
	     *
	     * @returns {void}
	     */ ResizeObserverController.prototype.refresh = function() {
            var changesDetected = this.updateObservers_();
            // Continue running updates if changes have been detected as there might
            // be future ones caused by CSS transitions.
            if (changesDetected) this.refresh();
        };
        /**
	     * Updates every observer from observers list and notifies them of queued
	     * entries.
	     *
	     * @private
	     * @returns {boolean} Returns "true" if any observer has detected changes in
	     *      dimensions of it's elements.
	     */ ResizeObserverController.prototype.updateObservers_ = function() {
            // Collect observers that have active observations.
            var activeObservers = this.observers_.filter(function(observer) {
                return observer.gatherActive(), observer.hasActive();
            });
            // Deliver notifications in a separate cycle in order to avoid any
            // collisions between observers, e.g. when multiple instances of
            // ResizeObserver are tracking the same element and the callback of one
            // of them changes content dimensions of the observed target. Sometimes
            // this may result in notifications being blocked for the rest of observers.
            activeObservers.forEach(function(observer) {
                return observer.broadcastActive();
            });
            return activeObservers.length > 0;
        };
        /**
	     * Initializes DOM listeners.
	     *
	     * @private
	     * @returns {void}
	     */ ResizeObserverController.prototype.connect_ = function() {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already added.
            if (!isBrowser || this.connected_) return;
            // Subscription to the "Transitionend" event is used as a workaround for
            // delayed transitions. This way it's possible to capture at least the
            // final state of an element.
            document.addEventListener('transitionend', this.onTransitionEnd_);
            window.addEventListener('resize', this.refresh);
            if (mutationObserverSupported) {
                this.mutationsObserver_ = new MutationObserver(this.refresh);
                this.mutationsObserver_.observe(document, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            } else {
                document.addEventListener('DOMSubtreeModified', this.refresh);
                this.mutationEventsAdded_ = true;
            }
            this.connected_ = true;
        };
        /**
	     * Removes DOM listeners.
	     *
	     * @private
	     * @returns {void}
	     */ ResizeObserverController.prototype.disconnect_ = function() {
            // Do nothing if running in a non-browser environment or if listeners
            // have been already removed.
            if (!isBrowser || !this.connected_) return;
            document.removeEventListener('transitionend', this.onTransitionEnd_);
            window.removeEventListener('resize', this.refresh);
            if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
            if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
            this.mutationsObserver_ = null;
            this.mutationEventsAdded_ = false;
            this.connected_ = false;
        };
        /**
	     * "Transitionend" event handler.
	     *
	     * @private
	     * @param {TransitionEvent} event
	     * @returns {void}
	     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
            // Detect whether transition may affect dimensions of an element.
            var isReflowProperty = transitionKeys.some(function(key) {
                return !!~propertyName.indexOf(key);
            });
            if (isReflowProperty) this.refresh();
        };
        /**
	     * Returns instance of the ResizeObserverController.
	     *
	     * @returns {ResizeObserverController}
	     */ ResizeObserverController.getInstance = function() {
            if (!this.instance_) this.instance_ = new ResizeObserverController();
            return this.instance_;
        };
        /**
	     * Holds reference to the controller's instance.
	     *
	     * @private {ResizeObserverController}
	     */ ResizeObserverController.instance_ = null;
        return ResizeObserverController;
    }();
    /**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */ var defineConfigurable = function(target, props) {
        for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
            var key = _a[_i];
            Object.defineProperty(target, key, {
                value: props[key],
                enumerable: false,
                writable: false,
                configurable: true
            });
        }
        return target;
    };
    /**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */ var getWindowOf = function(target) {
        // Assume that the element is an instance of Node, which means that it
        // has the "ownerDocument" property from which we can retrieve a
        // corresponding global object.
        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
        // Return the local global object if it's not possible extract one from
        // provided element.
        return ownerGlobal || global$1;
    };
    // Placeholder of an empty content rectangle.
    var emptyRect = createRectInit(0, 0, 0, 0);
    /**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */ function toFloat(value) {
        return parseFloat(value) || 0;
    }
    /**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */ function getBordersSize(styles) {
        var positions = [];
        for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
        return positions.reduce(function(size, position) {
            var value = styles['border-' + position + '-width'];
            return size + toFloat(value);
        }, 0);
    }
    /**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */ function getPaddings(styles) {
        var positions = [
            'top',
            'right',
            'bottom',
            'left'
        ];
        var paddings = {};
        for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
            var position = positions_1[_i];
            var value = styles['padding-' + position];
            paddings[position] = toFloat(value);
        }
        return paddings;
    }
    /**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */ function getSVGContentRect(target) {
        var bbox = target.getBBox();
        return createRectInit(0, 0, bbox.width, bbox.height);
    }
    /**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */ function getHTMLElementContentRect(target) {
        // Client width & height properties can't be
        // used exclusively as they provide rounded values.
        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
        // By this condition we can catch all non-replaced inline, hidden and
        // detached elements. Though elements with width & height properties less
        // than 0.5 will be discarded as well.
        //
        // Without it we would need to implement separate methods for each of
        // those cases and it's not possible to perform a precise and performance
        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
        // gives wrong results for elements with width & height less than 0.5.
        if (!clientWidth && !clientHeight) return emptyRect;
        var styles = getWindowOf(target).getComputedStyle(target);
        var paddings = getPaddings(styles);
        var horizPad = paddings.left + paddings.right;
        var vertPad = paddings.top + paddings.bottom;
        // Computed styles of width & height are being used because they are the
        // only dimensions available to JS that contain non-rounded values. It could
        // be possible to utilize the getBoundingClientRect if only it's data wasn't
        // affected by CSS transformations let alone paddings, borders and scroll bars.
        var width = toFloat(styles.width), height = toFloat(styles.height);
        // Width & height include paddings and borders when the 'border-box' box
        // model is applied (except for IE).
        if (styles.boxSizing === 'border-box') {
            // Following conditions are required to handle Internet Explorer which
            // doesn't include paddings and borders to computed CSS dimensions.
            //
            // We can say that if CSS dimensions + paddings are equal to the "client"
            // properties then it's either IE, and thus we don't need to subtract
            // anything, or an element merely doesn't have paddings/borders styles.
            if (Math.round(width + horizPad) !== clientWidth) width -= getBordersSize(styles, 'left', 'right') + horizPad;
            if (Math.round(height + vertPad) !== clientHeight) height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
        // Following steps can't be applied to the document's root element as its
        // client[Width/Height] properties represent viewport area of the window.
        // Besides, it's as well not necessary as the <html> itself neither has
        // rendered scroll bars nor it can be clipped.
        if (!isDocumentElement(target)) {
            // In some browsers (only in Firefox, actually) CSS width & height
            // include scroll bars size which can be removed at this step as scroll
            // bars are the only difference between rounded dimensions + paddings
            // and "client" properties, though that is not always true in Chrome.
            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
            // Chrome has a rather weird rounding of "client" properties.
            // E.g. for an element with content width of 314.2px it sometimes gives
            // the client width of 315px and for the width of 314.7px it may give
            // 314px. And it doesn't happen all the time. So just ignore this delta
            // as a non-relevant.
            if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
            if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
        }
        return createRectInit(paddings.left, paddings.top, width, height);
    }
    /**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */ var isSVGGraphicsElement = function() {
        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
        // interface.
        if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
        // If it's so, then check that element is at least an instance of the
        // SVGElement and that it has the "getBBox" method.
        // eslint-disable-next-line no-extra-parens
        return function(target) {
            return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
        };
    }();
    /**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */ function isDocumentElement(target) {
        return target === getWindowOf(target).document.documentElement;
    }
    /**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */ function getContentRect(target) {
        if (!isBrowser) return emptyRect;
        if (isSVGGraphicsElement(target)) return getSVGContentRect(target);
        return getHTMLElementContentRect(target);
    }
    /**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */ function createReadOnlyRect(_a) {
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
        var rect = Object.create(Constr.prototype);
        // Rectangle's properties are not writable and non-enumerable.
        defineConfigurable(rect, {
            x: x,
            y: y,
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: height + y,
            left: x
        });
        return rect;
    }
    /**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */ function createRectInit(x, y, width, height) {
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    /**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */ var ResizeObservation = /** @class */ function() {
        /**
	     * Creates an instance of ResizeObservation.
	     *
	     * @param {Element} target - Element to be observed.
	     */ function ResizeObservation(target) {
            /**
	         * Broadcasted width of content rectangle.
	         *
	         * @type {number}
	         */ this.broadcastWidth = 0;
            /**
	         * Broadcasted height of content rectangle.
	         *
	         * @type {number}
	         */ this.broadcastHeight = 0;
            /**
	         * Reference to the last observed content rectangle.
	         *
	         * @private {DOMRectInit}
	         */ this.contentRect_ = createRectInit(0, 0, 0, 0);
            this.target = target;
        }
        /**
	     * Updates content rectangle and tells whether it's width or height properties
	     * have changed since the last broadcast.
	     *
	     * @returns {boolean}
	     */ ResizeObservation.prototype.isActive = function() {
            var rect = getContentRect(this.target);
            this.contentRect_ = rect;
            return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
        };
        /**
	     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	     * from the corresponding properties of the last observed content rectangle.
	     *
	     * @returns {DOMRectInit} Last observed content rectangle.
	     */ ResizeObservation.prototype.broadcastRect = function() {
            var rect = this.contentRect_;
            this.broadcastWidth = rect.width;
            this.broadcastHeight = rect.height;
            return rect;
        };
        return ResizeObservation;
    }();
    var ResizeObserverEntry = /** @class */ function() {
        /**
	     * Creates an instance of ResizeObserverEntry.
	     *
	     * @param {Element} target - Element that is being observed.
	     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	     */ function ResizeObserverEntry(target, rectInit) {
            var contentRect = createReadOnlyRect(rectInit);
            // According to the specification following properties are not writable
            // and are also not enumerable in the native implementation.
            //
            // Property accessors are not being used as they'd require to define a
            // private WeakMap storage which may cause memory leaks in browsers that
            // don't support this type of collections.
            defineConfigurable(this, {
                target: target,
                contentRect: contentRect
            });
        }
        return ResizeObserverEntry;
    }();
    var ResizeObserverSPI = /** @class */ function() {
        /**
	     * Creates a new instance of ResizeObserver.
	     *
	     * @param {ResizeObserverCallback} callback - Callback function that is invoked
	     *      when one of the observed elements changes it's content dimensions.
	     * @param {ResizeObserverController} controller - Controller instance which
	     *      is responsible for the updates of observer.
	     * @param {ResizeObserver} callbackCtx - Reference to the public
	     *      ResizeObserver instance which will be passed to callback function.
	     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
            /**
	         * Collection of resize observations that have detected changes in dimensions
	         * of elements.
	         *
	         * @private {Array<ResizeObservation>}
	         */ this.activeObservations_ = [];
            /**
	         * Registry of the ResizeObservation instances.
	         *
	         * @private {Map<Element, ResizeObservation>}
	         */ this.observations_ = new MapShim();
            if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
            this.callback_ = callback;
            this.controller_ = controller;
            this.callbackCtx_ = callbackCtx;
        }
        /**
	     * Starts observing provided element.
	     *
	     * @param {Element} target - Element to be observed.
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.observe = function(target) {
            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
            // Do nothing if current environment doesn't have the Element interface.
            if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
            if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var observations = this.observations_;
            // Do nothing if element is already being observed.
            if (observations.has(target)) return;
            observations.set(target, new ResizeObservation(target));
            this.controller_.addObserver(this);
            // Force the update of observations.
            this.controller_.refresh();
        };
        /**
	     * Stops observing provided element.
	     *
	     * @param {Element} target - Element to stop observing.
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.unobserve = function(target) {
            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
            // Do nothing if current environment doesn't have the Element interface.
            if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
            if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var observations = this.observations_;
            // Do nothing if element is not being observed.
            if (!observations.has(target)) return;
            observations.delete(target);
            if (!observations.size) this.controller_.removeObserver(this);
        };
        /**
	     * Stops observing all elements.
	     *
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.disconnect = function() {
            this.clearActive();
            this.observations_.clear();
            this.controller_.removeObserver(this);
        };
        /**
	     * Collects observation instances the associated element of which has changed
	     * it's content rectangle.
	     *
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.gatherActive = function() {
            var _this = this;
            this.clearActive();
            this.observations_.forEach(function(observation) {
                if (observation.isActive()) _this.activeObservations_.push(observation);
            });
        };
        /**
	     * Invokes initial callback function with a list of ResizeObserverEntry
	     * instances collected from active resize observations.
	     *
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.broadcastActive = function() {
            // Do nothing if observer doesn't have active observations.
            if (!this.hasActive()) return;
            var ctx = this.callbackCtx_;
            // Create ResizeObserverEntry instance for every active observation.
            var entries = this.activeObservations_.map(function(observation) {
                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
            });
            this.callback_.call(ctx, entries, ctx);
            this.clearActive();
        };
        /**
	     * Clears the collection of active observations.
	     *
	     * @returns {void}
	     */ ResizeObserverSPI.prototype.clearActive = function() {
            this.activeObservations_.splice(0);
        };
        /**
	     * Tells whether observer has active observations.
	     *
	     * @returns {boolean}
	     */ ResizeObserverSPI.prototype.hasActive = function() {
            return this.activeObservations_.length > 0;
        };
        return ResizeObserverSPI;
    }();
    // Registry of internal observers. If WeakMap is not available use current shim
    // for the Map collection as it has all required methods and because WeakMap
    // can't be fully polyfilled anyway.
    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
    /**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */ var ResizeObserver = /** @class */ function() {
        /**
	     * Creates a new instance of ResizeObserver.
	     *
	     * @param {ResizeObserverCallback} callback - Callback that is invoked when
	     *      dimensions of the observed elements change.
	     */ function ResizeObserver(callback) {
            if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
            var controller = ResizeObserverController.getInstance();
            var observer = new ResizeObserverSPI(callback, controller, this);
            observers.set(this, observer);
        }
        return ResizeObserver;
    }();
    // Expose public methods of ResizeObserver.
    [
        'observe',
        'unobserve',
        'disconnect'
    ].forEach(function(method) {
        ResizeObserver.prototype[method] = function() {
            var _a;
            return (_a = observers.get(this))[method].apply(_a, arguments);
        };
    });
    var index = function() {
        // Export existing implementation if available.
        if (typeof global$1.ResizeObserver !== 'undefined') return global$1.ResizeObserver;
        return ResizeObserver;
    }();
    var cachedScrollbarWidth = null;
    var cachedDevicePixelRatio = null;
    if (canUseDom) window.addEventListener('resize', function() {
        if (cachedDevicePixelRatio !== window.devicePixelRatio) {
            cachedDevicePixelRatio = window.devicePixelRatio;
            cachedScrollbarWidth = null;
        }
    });
    function scrollbarWidth() {
        if (cachedScrollbarWidth === null) {
            if (typeof document === 'undefined') {
                cachedScrollbarWidth = 0;
                return cachedScrollbarWidth;
            }
            var body = document.body;
            var box = document.createElement('div');
            box.classList.add('simplebar-hide-scrollbar');
            body.appendChild(box);
            var width = box.getBoundingClientRect().right;
            body.removeChild(box);
            cachedScrollbarWidth = width;
        }
        return cachedScrollbarWidth;
    }
    // `Array.prototype.{ reduce, reduceRight }` methods implementation
    var createMethod$4 = function(IS_RIGHT) {
        return function(that, callbackfn, argumentsLength, memo) {
            aFunction$1(callbackfn);
            var O = toObject(that);
            var self1 = indexedObject(O);
            var length = toLength(O.length);
            var index = IS_RIGHT ? length - 1 : 0;
            var i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) while(true){
                if (index in self1) {
                    memo = self1[index];
                    index += i;
                    break;
                }
                index += i;
                if (IS_RIGHT ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
            }
            for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
            return memo;
        };
    };
    var arrayReduce = {
        // `Array.prototype.reduce` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
        left: createMethod$4(false),
        // `Array.prototype.reduceRight` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
        right: createMethod$4(true)
    };
    var $reduce = arrayReduce.left;
    // `Array.prototype.reduce` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
    _export({
        target: 'Array',
        proto: true,
        forced: sloppyArrayMethod('reduce')
    }, {
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
        }
    });
    var defineProperty$1 = objectDefineProperty.f;
    var FunctionPrototype = Function.prototype;
    var FunctionPrototypeToString = FunctionPrototype.toString;
    var nameRE = /^\s*function ([^ (]*)/;
    var NAME = 'name';
    // Function instances `.name` property
    // https://tc39.github.io/ecma262/#sec-function-instances-name
    if (descriptors && !(NAME in FunctionPrototype)) defineProperty$1(FunctionPrototype, NAME, {
        configurable: true,
        get: function() {
            try {
                return FunctionPrototypeToString.call(this).match(nameRE)[1];
            } catch (error) {
                return '';
            }
        }
    });
    // `RegExp.prototype.flags` getter implementation
    // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
    var regexpFlags = function() {
        var that = anObject(this);
        var result = '';
        if (that.global) result += 'g';
        if (that.ignoreCase) result += 'i';
        if (that.multiline) result += 'm';
        if (that.dotAll) result += 's';
        if (that.unicode) result += 'u';
        if (that.sticky) result += 'y';
        return result;
    };
    var nativeExec = RegExp.prototype.exec;
    // This always refers to the native implementation, because the
    // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
    // which loads this file before patching the method.
    var nativeReplace = String.prototype.replace;
    var patchedExec = nativeExec;
    var UPDATES_LAST_INDEX_WRONG = function() {
        var re1 = /a/;
        var re2 = /b*/g;
        nativeExec.call(re1, 'a');
        nativeExec.call(re2, 'a');
        return re1.lastIndex !== 0 || re2.lastIndex !== 0;
    }();
    // nonparticipating capturing group, copied from es5-shim's String#split patch.
    var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
    var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
    if (PATCH) patchedExec = function exec(str) {
        var re = this;
        var lastIndex, reCopy, match, i;
        if (NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
        if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
        match = nativeExec.call(re, str);
        if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
        if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
        nativeReplace.call(match[0], reCopy, function() {
            for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
        });
        return match;
    };
    var regexpExec = patchedExec;
    _export({
        target: 'RegExp',
        proto: true,
        forced: /./.exec !== regexpExec
    }, {
        exec: regexpExec
    });
    var SPECIES$2 = wellKnownSymbol('species');
    var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
        // #replace needs built-in support for named groups.
        // #match works fine because it just return the exec results, even if it has
        // a "grops" property.
        var re = /./;
        re.exec = function() {
            var result = [];
            result.groups = {
                a: '7'
            };
            return result;
        };
        return ''.replace(re, '$<a>') !== '7';
    });
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    // Weex JS has frozen built-in prototypes, so use try / catch wrapper
    var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
        var re = /(?:)/;
        var originalExec = re.exec;
        re.exec = function() {
            return originalExec.apply(this, arguments);
        };
        var result = 'ab'.split(re);
        return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
    });
    var fixRegexpWellKnownSymbolLogic = function(KEY, length, exec, sham) {
        var SYMBOL = wellKnownSymbol(KEY);
        var DELEGATES_TO_SYMBOL = !fails(function() {
            // String methods call symbol-named RegEp methods
            var O = {};
            O[SYMBOL] = function() {
                return 7;
            };
            return ''[KEY](O) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;
            re.exec = function() {
                execCalled = true;
                return null;
            };
            if (KEY === 'split') {
                // RegExp[@@split] doesn't call the regex's exec method, but first creates
                // a new one. We need to return the patched regex when creating the new one.
                re.constructor = {};
                re.constructor[SPECIES$2] = function() {
                    return re;
                };
            }
            re[SYMBOL]('');
            return !execCalled;
        });
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                if (regexp.exec === regexpExec) {
                    if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                    // polyfilled function), leasing to infinite recursion.
                    // We avoid it by directly calling the native @@method method.
                    return {
                        done: true,
                        value: nativeRegExpMethod.call(regexp, str, arg2)
                    };
                    return {
                        done: true,
                        value: nativeMethod.call(str, regexp, arg2)
                    };
                }
                return {
                    done: false
                };
            });
            var stringMethod = methods[0];
            var regexMethod = methods[1];
            redefine(String.prototype, KEY, stringMethod);
            redefine(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
                return regexMethod.call(string, this, arg);
            } : function(string) {
                return regexMethod.call(string, this);
            });
            if (sham) hide(RegExp.prototype[SYMBOL], 'sham', true);
        }
    };
    var charAt$1 = stringMultibyte.charAt;
    // `AdvanceStringIndex` abstract operation
    // https://tc39.github.io/ecma262/#sec-advancestringindex
    var advanceStringIndex = function(S, index, unicode) {
        return index + (unicode ? charAt$1(S, index).length : 1);
    };
    // `RegExpExec` abstract operation
    // https://tc39.github.io/ecma262/#sec-regexpexec
    var regexpExecAbstract = function(R, S) {
        var exec = R.exec;
        if (typeof exec === 'function') {
            var result = exec.call(R, S);
            if (typeof result !== 'object') throw TypeError('RegExp exec method returned something other than an Object or null');
            return result;
        }
        if (classofRaw(R) !== 'RegExp') throw TypeError('RegExp#exec called on incompatible receiver');
        return regexpExec.call(R, S);
    };
    // @@match logic
    fixRegexpWellKnownSymbolLogic('match', 1, function(MATCH, nativeMatch, maybeCallNative) {
        return [
            // `String.prototype.match` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.match
            function match(regexp) {
                var O = requireObjectCoercible(this);
                var matcher = regexp == undefined ? undefined : regexp[MATCH];
                return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
            },
            // `RegExp.prototype[@@match]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
            function(regexp) {
                var res = maybeCallNative(nativeMatch, regexp, this);
                if (res.done) return res.value;
                var rx = anObject(regexp);
                var S = String(this);
                if (!rx.global) return regexpExecAbstract(rx, S);
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
                var A = [];
                var n = 0;
                var result;
                while((result = regexpExecAbstract(rx, S)) !== null){
                    var matchStr = String(result[0]);
                    A[n] = matchStr;
                    if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                    n++;
                }
                return n === 0 ? null : A;
            }
        ];
    });
    var max$1 = Math.max;
    var min$2 = Math.min;
    var floor$1 = Math.floor;
    var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
    var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;
    var maybeToString = function(it) {
        return it === undefined ? it : String(it);
    };
    // @@replace logic
    fixRegexpWellKnownSymbolLogic('replace', 2, function(REPLACE, nativeReplace, maybeCallNative) {
        return [
            // `String.prototype.replace` method
            // https://tc39.github.io/ecma262/#sec-string.prototype.replace
            function replace(searchValue, replaceValue) {
                var O = requireObjectCoercible(this);
                var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
                return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
            },
            // `RegExp.prototype[@@replace]` method
            // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
            function(regexp, replaceValue) {
                var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
                if (res.done) return res.value;
                var rx = anObject(regexp);
                var S = String(this);
                var functionalReplace = typeof replaceValue === 'function';
                if (!functionalReplace) replaceValue = String(replaceValue);
                var global = rx.global;
                if (global) {
                    var fullUnicode = rx.unicode;
                    rx.lastIndex = 0;
                }
                var results = [];
                while(true){
                    var result = regexpExecAbstract(rx, S);
                    if (result === null) break;
                    results.push(result);
                    if (!global) break;
                    var matchStr = String(result[0]);
                    if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                }
                var accumulatedResult = '';
                var nextSourcePosition = 0;
                for(var i = 0; i < results.length; i++){
                    result = results[i];
                    var matched = String(result[0]);
                    var position = max$1(min$2(toInteger(result.index), S.length), 0);
                    var captures = [];
                    // NOTE: This is equivalent to
                    //   captures = result.slice(1).map(maybeToString)
                    // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                    // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                    // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                    for(var j = 1; j < result.length; j++)captures.push(maybeToString(result[j]));
                    var namedCaptures = result.groups;
                    if (functionalReplace) {
                        var replacerArgs = [
                            matched
                        ].concat(captures, position, S);
                        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                        var replacement = String(replaceValue.apply(undefined, replacerArgs));
                    } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                    if (position >= nextSourcePosition) {
                        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                        nextSourcePosition = position + matched.length;
                    }
                }
                return accumulatedResult + S.slice(nextSourcePosition);
            }
        ];
        // https://tc39.github.io/ecma262/#sec-getsubstitution
        function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
            if (namedCaptures !== undefined) {
                namedCaptures = toObject(namedCaptures);
                symbols = SUBSTITUTION_SYMBOLS;
            }
            return nativeReplace.call(replacement, symbols, function(match, ch) {
                var capture;
                switch(ch.charAt(0)){
                    case '$':
                        return '$';
                    case '&':
                        return matched;
                    case '`':
                        return str.slice(0, position);
                    case "'":
                        return str.slice(tailPos);
                    case '<':
                        capture = namedCaptures[ch.slice(1, -1)];
                        break;
                    default:
                        var n = +ch;
                        if (n === 0) return match;
                        if (n > m) {
                            var f = floor$1(n / 10);
                            if (f === 0) return match;
                            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                            return match;
                        }
                        capture = captures[n - 1];
                }
                return capture === undefined ? '' : capture;
            });
        }
    });
    // Helper function to retrieve options from element attributes
    var getOptions = function getOptions(obj) {
        var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
            var option = attribute.name.match(/data-simplebar-(.+)/);
            if (option) {
                var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                    return chr.toUpperCase();
                });
                switch(attribute.value){
                    case 'true':
                        acc[key] = true;
                        break;
                    case 'false':
                        acc[key] = false;
                        break;
                    case undefined:
                        acc[key] = true;
                        break;
                    default:
                        acc[key] = attribute.value;
                }
            }
            return acc;
        }, {});
        return options;
    };
    function getElementWindow(element) {
        if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
        return element.ownerDocument.defaultView;
    }
    function getElementDocument(element) {
        if (!element || !element.ownerDocument) return document;
        return element.ownerDocument;
    }
    var SimpleBar = /*#__PURE__*/ function() {
        function SimpleBar(element, options) {
            var _this = this;
            this.onScroll = function() {
                var elWindow = getElementWindow(_this.el);
                if (!_this.scrollXTicking) {
                    elWindow.requestAnimationFrame(_this.scrollX);
                    _this.scrollXTicking = true;
                }
                if (!_this.scrollYTicking) {
                    elWindow.requestAnimationFrame(_this.scrollY);
                    _this.scrollYTicking = true;
                }
            };
            this.scrollX = function() {
                if (_this.axis.x.isOverflowing) {
                    _this.showScrollbar('x');
                    _this.positionScrollbar('x');
                }
                _this.scrollXTicking = false;
            };
            this.scrollY = function() {
                if (_this.axis.y.isOverflowing) {
                    _this.showScrollbar('y');
                    _this.positionScrollbar('y');
                }
                _this.scrollYTicking = false;
            };
            this.onMouseEnter = function() {
                _this.showScrollbar('x');
                _this.showScrollbar('y');
            };
            this.onMouseMove = function(e) {
                _this.mouseX = e.clientX;
                _this.mouseY = e.clientY;
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis('x');
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis('y');
            };
            this.onMouseLeave = function() {
                _this.onMouseMove.cancel();
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis('x');
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis('y');
                _this.mouseX = -1;
                _this.mouseY = -1;
            };
            this.onWindowResize = function() {
                // Recalculate scrollbarWidth in case it's a zoom
                _this.scrollbarWidth = _this.getScrollbarWidth();
                _this.hideNativeScrollbar();
            };
            this.hideScrollbars = function() {
                _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
                _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
                if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                    _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                    _this.axis.y.isVisible = false;
                }
                if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                    _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                    _this.axis.x.isVisible = false;
                }
            };
            this.onPointerEvent = function(e) {
                var isWithinTrackXBounds, isWithinTrackYBounds;
                _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
                _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
                 // If any pointer event is called on the scrollbar
                if (isWithinTrackXBounds || isWithinTrackYBounds) {
                    // Preventing the event's default action stops text being
                    // selectable during the drag.
                    e.preventDefault(); // Prevent event leaking
                    e.stopPropagation();
                    if (e.type === 'mousedown') {
                        if (isWithinTrackXBounds) {
                            _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                            if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, 'x');
                            else _this.onTrackClick(e, 'x');
                        }
                        if (isWithinTrackYBounds) {
                            _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                            if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, 'y');
                            else _this.onTrackClick(e, 'y');
                        }
                    }
                }
            };
            this.drag = function(e) {
                var eventOffset;
                var track = _this.axis[_this.draggedAxis].track;
                var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
                var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
                var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
                var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
                e.preventDefault();
                e.stopPropagation();
                if (_this.draggedAxis === 'y') eventOffset = e.pageY;
                else eventOffset = e.pageX;
                 // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
                var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
                var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
                var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
                if (_this.draggedAxis === 'x') {
                    scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                    scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
                }
                _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
            };
            this.onEndDrag = function(e) {
                var elDocument = getElementDocument(_this.el);
                var elWindow = getElementWindow(_this.el);
                e.preventDefault();
                e.stopPropagation();
                _this.el.classList.remove(_this.classNames.dragging);
                elDocument.removeEventListener('mousemove', _this.drag, true);
                elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
                _this.removePreventClickId = elWindow.setTimeout(function() {
                    // Remove these asynchronously so we still suppress click events
                    // generated simultaneously with mouseup.
                    elDocument.removeEventListener('click', _this.preventClick, true);
                    elDocument.removeEventListener('dblclick', _this.preventClick, true);
                    _this.removePreventClickId = null;
                });
            };
            this.preventClick = function(e) {
                e.preventDefault();
                e.stopPropagation();
            };
            this.el = element;
            this.minScrollbarWidth = 20;
            this.options = Object.assign({}, SimpleBar.defaultOptions, {}, options);
            this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, {}, this.options.classNames);
            this.axis = {
                x: {
                    scrollOffsetAttr: 'scrollLeft',
                    sizeAttr: 'width',
                    scrollSizeAttr: 'scrollWidth',
                    offsetSizeAttr: 'offsetWidth',
                    offsetAttr: 'left',
                    overflowAttr: 'overflowX',
                    dragOffset: 0,
                    isOverflowing: true,
                    isVisible: false,
                    forceVisible: false,
                    track: {},
                    scrollbar: {}
                },
                y: {
                    scrollOffsetAttr: 'scrollTop',
                    sizeAttr: 'height',
                    scrollSizeAttr: 'scrollHeight',
                    offsetSizeAttr: 'offsetHeight',
                    offsetAttr: 'top',
                    overflowAttr: 'overflowY',
                    dragOffset: 0,
                    isOverflowing: true,
                    isVisible: false,
                    forceVisible: false,
                    track: {},
                    scrollbar: {}
                }
            };
            this.removePreventClickId = null; // Don't re-instantiate over an existing one
            if (SimpleBar.instances.has(this.el)) return;
            this.recalculate = lodash_throttle(this.recalculate.bind(this), 64);
            this.onMouseMove = lodash_throttle(this.onMouseMove.bind(this), 64);
            this.hideScrollbars = lodash_debounce(this.hideScrollbars.bind(this), this.options.timeout);
            this.onWindowResize = lodash_debounce(this.onWindowResize.bind(this), 64, {
                leading: true
            });
            SimpleBar.getRtlHelpers = lodash_memoize(SimpleBar.getRtlHelpers);
            this.init();
        }
        /**
	   * Static properties
	   */ /**
	   * Helper to fix browsers inconsistency on RTL:
	   *  - Firefox inverts the scrollbar initial position
	   *  - IE11 inverts both scrollbar position and scrolling offset
	   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
	   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
            var dummyDiv = document.createElement('div');
            dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
            var scrollbarDummyEl = dummyDiv.firstElementChild;
            document.body.appendChild(scrollbarDummyEl);
            var dummyContainerChild = scrollbarDummyEl.firstElementChild;
            scrollbarDummyEl.scrollLeft = 0;
            var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
            var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
            scrollbarDummyEl.scrollLeft = 999;
            var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
            return {
                // determines if the scrolling is responding with negative values
                isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
                // determines if the origin scrollbar position is inverted or not (positioned on left or right)
                isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
            };
        };
        SimpleBar.getOffset = function getOffset(el) {
            var rect = el.getBoundingClientRect();
            var elDocument = getElementDocument(el);
            var elWindow = getElementWindow(el);
            return {
                top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
                left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
            };
        };
        var _proto = SimpleBar.prototype;
        _proto.init = function init() {
            // Save a reference to the instance, so we know this DOM node has already been instancied
            SimpleBar.instances.set(this.el, this); // We stop here on server-side
            if (canUseDom) {
                this.initDOM();
                this.scrollbarWidth = this.getScrollbarWidth();
                this.recalculate();
                this.initListeners();
            }
        };
        _proto.initDOM = function initDOM() {
            var _this2 = this;
            // make sure this element doesn't have the elements yet
            if (Array.prototype.filter.call(this.el.children, function(child) {
                return child.classList.contains(_this2.classNames.wrapper);
            }).length) {
                // assume that element has his DOM already initiated
                this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
                this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
                this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
                this.offsetEl = this.el.querySelector("." + this.classNames.offset);
                this.maskEl = this.el.querySelector("." + this.classNames.mask);
                this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
                this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
                this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
                this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
                this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
            } else {
                // Prepare DOM
                this.wrapperEl = document.createElement('div');
                this.contentWrapperEl = document.createElement('div');
                this.offsetEl = document.createElement('div');
                this.maskEl = document.createElement('div');
                this.contentEl = document.createElement('div');
                this.placeholderEl = document.createElement('div');
                this.heightAutoObserverWrapperEl = document.createElement('div');
                this.heightAutoObserverEl = document.createElement('div');
                this.wrapperEl.classList.add(this.classNames.wrapper);
                this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
                this.offsetEl.classList.add(this.classNames.offset);
                this.maskEl.classList.add(this.classNames.mask);
                this.contentEl.classList.add(this.classNames.contentEl);
                this.placeholderEl.classList.add(this.classNames.placeholder);
                this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
                this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
                while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
                this.contentWrapperEl.appendChild(this.contentEl);
                this.offsetEl.appendChild(this.contentWrapperEl);
                this.maskEl.appendChild(this.offsetEl);
                this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
                this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
                this.wrapperEl.appendChild(this.maskEl);
                this.wrapperEl.appendChild(this.placeholderEl);
                this.el.appendChild(this.wrapperEl);
            }
            if (!this.axis.x.track.el || !this.axis.y.track.el) {
                var track = document.createElement('div');
                var scrollbar = document.createElement('div');
                track.classList.add(this.classNames.track);
                scrollbar.classList.add(this.classNames.scrollbar);
                track.appendChild(scrollbar);
                this.axis.x.track.el = track.cloneNode(true);
                this.axis.x.track.el.classList.add(this.classNames.horizontal);
                this.axis.y.track.el = track.cloneNode(true);
                this.axis.y.track.el.classList.add(this.classNames.vertical);
                this.el.appendChild(this.axis.x.track.el);
                this.el.appendChild(this.axis.y.track.el);
            }
            this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
            this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
            if (!this.options.autoHide) {
                this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
                this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
            }
            this.el.setAttribute('data-simplebar', 'init');
        };
        _proto.initListeners = function initListeners() {
            var _this3 = this;
            var elWindow = getElementWindow(this.el); // Event listeners
            if (this.options.autoHide) this.el.addEventListener('mouseenter', this.onMouseEnter);
            [
                'mousedown',
                'click',
                'dblclick'
            ].forEach(function(e) {
                _this3.el.addEventListener(e, _this3.onPointerEvent, true);
            });
            [
                'touchstart',
                'touchend',
                'touchmove'
            ].forEach(function(e) {
                _this3.el.addEventListener(e, _this3.onPointerEvent, {
                    capture: true,
                    passive: true
                });
            });
            this.el.addEventListener('mousemove', this.onMouseMove);
            this.el.addEventListener('mouseleave', this.onMouseLeave);
            this.contentWrapperEl.addEventListener('scroll', this.onScroll); // Browser zoom triggers a window resize
            elWindow.addEventListener('resize', this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
            var resizeObserverStarted = false;
            var resizeObserver = elWindow.ResizeObserver || index;
            this.resizeObserver = new resizeObserver(function() {
                if (!resizeObserverStarted) return;
                _this3.recalculate();
            });
            this.resizeObserver.observe(this.el);
            this.resizeObserver.observe(this.contentEl);
            elWindow.requestAnimationFrame(function() {
                resizeObserverStarted = true;
            }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
            this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
            this.mutationObserver.observe(this.contentEl, {
                childList: true,
                subtree: true,
                characterData: true
            });
        };
        _proto.recalculate = function recalculate() {
            var elWindow = getElementWindow(this.el);
            this.elStyles = elWindow.getComputedStyle(this.el);
            this.isRtl = this.elStyles.direction === 'rtl';
            var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
            var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
            var contentElOffsetWidth = this.contentEl.offsetWidth;
            var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
            var elOverflowX = this.elStyles.overflowX;
            var elOverflowY = this.elStyles.overflowY;
            this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
            this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
            var contentElScrollHeight = this.contentEl.scrollHeight;
            var contentElScrollWidth = this.contentEl.scrollWidth;
            this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%'; // Determine placeholder size
            this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : 'auto';
            this.placeholderEl.style.height = contentElScrollHeight + "px";
            var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
            this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
            this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
            this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
            this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
            this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
            this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
            this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
            var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
            var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
            this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
            this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
            this.axis.x.scrollbar.size = this.getScrollbarSize('x');
            this.axis.y.scrollbar.size = this.getScrollbarSize('y');
            this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
            this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
            this.positionScrollbar('x');
            this.positionScrollbar('y');
            this.toggleTrackVisibility('x');
            this.toggleTrackVisibility('y');
        };
        _proto.getScrollbarSize = function getScrollbarSize(axis) {
            if (axis === void 0) axis = 'y';
            if (!this.axis[axis].isOverflowing) return 0;
            var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
            var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
            var scrollbarSize;
            var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
            scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
            if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
            return scrollbarSize;
        };
        _proto.positionScrollbar = function positionScrollbar(axis) {
            if (axis === void 0) axis = 'y';
            if (!this.axis[axis].isOverflowing) return;
            var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
            var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
            var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
            var scrollbar = this.axis[axis].scrollbar;
            var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
            scrollOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
            var scrollPourcent = scrollOffset / (contentSize - hostSize);
            var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
            handleOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
            scrollbar.el.style.transform = axis === 'x' ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
        };
        _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
            if (axis === void 0) axis = 'y';
            var track = this.axis[axis].track.el;
            var scrollbar = this.axis[axis].scrollbar.el;
            if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
                track.style.visibility = 'visible';
                this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
            } else {
                track.style.visibility = 'hidden';
                this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
            } // Even if forceVisible is enabled, scrollbar itself should be hidden
            if (this.axis[axis].isOverflowing) scrollbar.style.display = 'block';
            else scrollbar.style.display = 'none';
        };
        _proto.hideNativeScrollbar = function hideNativeScrollbar() {
            this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
            this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        };
        _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
            if (axis === void 0) axis = 'y';
            this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
            this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
            var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
            if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
            else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
            if (this.isWithinBounds(this.axis[axis].track.rect)) {
                this.showScrollbar(axis);
                this.axis[axis].track.el.classList.add(this.classNames.hover);
            } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
        };
        _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
            if (axis === void 0) axis = 'y';
            this.axis[axis].track.el.classList.remove(this.classNames.hover);
            this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        };
        /**
	   * Show scrollbar
	   */ _proto.showScrollbar = function showScrollbar(axis) {
            if (axis === void 0) axis = 'y';
            var scrollbar = this.axis[axis].scrollbar.el;
            if (!this.axis[axis].isVisible) {
                scrollbar.classList.add(this.classNames.visible);
                this.axis[axis].isVisible = true;
            }
            if (this.options.autoHide) this.hideScrollbars();
        };
        /**
	   * on scrollbar handle drag movement starts
	   */ _proto.onDragStart = function onDragStart(e, axis) {
            if (axis === void 0) axis = 'y';
            var elDocument = getElementDocument(this.el);
            var elWindow = getElementWindow(this.el);
            var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
            var eventOffset = axis === 'y' ? e.pageY : e.pageX;
            this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
            this.draggedAxis = axis;
            this.el.classList.add(this.classNames.dragging);
            elDocument.addEventListener('mousemove', this.drag, true);
            elDocument.addEventListener('mouseup', this.onEndDrag, true);
            if (this.removePreventClickId === null) {
                elDocument.addEventListener('click', this.preventClick, true);
                elDocument.addEventListener('dblclick', this.preventClick, true);
            } else {
                elWindow.clearTimeout(this.removePreventClickId);
                this.removePreventClickId = null;
            }
        };
        _proto.onTrackClick = function onTrackClick(e, axis) {
            var _this4 = this;
            if (axis === void 0) axis = 'y';
            if (!this.options.clickOnTrack) return;
            var elWindow = getElementWindow(this.el);
            this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
            var scrollbar = this.axis[axis].scrollbar;
            var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
            var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
            var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
            var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
            var dir = t < 0 ? -1 : 1;
            var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
            var scrollTo = function scrollTo() {
                if (dir === -1) {
                    if (scrolled > scrollSize) {
                        var _this4$contentWrapper;
                        scrolled -= _this4.options.clickOnTrackSpeed;
                        _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                        elWindow.requestAnimationFrame(scrollTo);
                    }
                } else if (scrolled < scrollSize) {
                    var _this4$contentWrapper2;
                    scrolled += _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            };
            scrollTo();
        };
        _proto.getContentElement = function getContentElement() {
            return this.contentEl;
        };
        _proto.getScrollElement = function getScrollElement() {
            return this.contentWrapperEl;
        };
        _proto.getScrollbarWidth = function getScrollbarWidth() {
            // Try/catch for FF 56 throwing on undefined computedStyles
            try {
                // Detect browsers supporting CSS scrollbar styling and do not calculate
                if (getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) return 0;
                else return scrollbarWidth();
            } catch (e) {
                return scrollbarWidth();
            }
        };
        _proto.removeListeners = function removeListeners() {
            var _this5 = this;
            var elWindow = getElementWindow(this.el); // Event listeners
            if (this.options.autoHide) this.el.removeEventListener('mouseenter', this.onMouseEnter);
            [
                'mousedown',
                'click',
                'dblclick'
            ].forEach(function(e) {
                _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
            });
            [
                'touchstart',
                'touchend',
                'touchmove'
            ].forEach(function(e) {
                _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                    capture: true,
                    passive: true
                });
            });
            this.el.removeEventListener('mousemove', this.onMouseMove);
            this.el.removeEventListener('mouseleave', this.onMouseLeave);
            if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
            elWindow.removeEventListener('resize', this.onWindowResize);
            if (this.mutationObserver) this.mutationObserver.disconnect();
            if (this.resizeObserver) this.resizeObserver.disconnect();
             // Cancel all debounced functions
            this.recalculate.cancel();
            this.onMouseMove.cancel();
            this.hideScrollbars.cancel();
            this.onWindowResize.cancel();
        };
        _proto.unMount = function unMount() {
            this.removeListeners();
            SimpleBar.instances.delete(this.el);
        };
        _proto.isWithinBounds = function isWithinBounds(bbox) {
            return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
        };
        _proto.findChild = function findChild(el, query) {
            var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
            return Array.prototype.filter.call(el.children, function(child) {
                return matches.call(child, query);
            })[0];
        };
        return SimpleBar;
    }();
    SimpleBar.defaultOptions = {
        autoHide: true,
        forceVisible: false,
        clickOnTrack: true,
        clickOnTrackSpeed: 40,
        classNames: {
            contentEl: 'simplebar-content',
            contentWrapper: 'simplebar-content-wrapper',
            offset: 'simplebar-offset',
            mask: 'simplebar-mask',
            wrapper: 'simplebar-wrapper',
            placeholder: 'simplebar-placeholder',
            scrollbar: 'simplebar-scrollbar',
            track: 'simplebar-track',
            heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
            heightAutoObserverEl: 'simplebar-height-auto-observer',
            visible: 'simplebar-visible',
            horizontal: 'simplebar-horizontal',
            vertical: 'simplebar-vertical',
            hover: 'simplebar-hover',
            dragging: 'simplebar-dragging'
        },
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        timeout: 1000
    };
    SimpleBar.instances = new WeakMap();
    SimpleBar.initDOMLoadedElements = function() {
        document.removeEventListener('DOMContentLoaded', this.initDOMLoadedElements);
        window.removeEventListener('load', this.initDOMLoadedElements);
        Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]'), function(el) {
            if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el)) new SimpleBar(el, getOptions(el.attributes));
        });
    };
    SimpleBar.removeObserver = function() {
        this.globalObserver.disconnect();
    };
    SimpleBar.initHtmlApi = function() {
        this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this); // MutationObserver is IE11+
        if (typeof MutationObserver !== 'undefined') {
            // Mutation observer to observe dynamically added elements
            this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
            this.globalObserver.observe(document, {
                childList: true,
                subtree: true
            });
        } // Taken from jQuery `ready` function
        // Instantiate elements already present on the page
        if (document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
        window.setTimeout(this.initDOMLoadedElements);
        else {
            document.addEventListener('DOMContentLoaded', this.initDOMLoadedElements);
            window.addEventListener('load', this.initDOMLoadedElements);
        }
    };
    SimpleBar.handleMutations = function(mutations) {
        mutations.forEach(function(mutation) {
            Array.prototype.forEach.call(mutation.addedNodes, function(addedNode) {
                if (addedNode.nodeType === 1) {
                    if (addedNode.hasAttribute('data-simplebar')) !SimpleBar.instances.has(addedNode) && new SimpleBar(addedNode, getOptions(addedNode.attributes));
                    else Array.prototype.forEach.call(addedNode.querySelectorAll('[data-simplebar]'), function(el) {
                        if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el)) new SimpleBar(el, getOptions(el.attributes));
                    });
                }
            });
            Array.prototype.forEach.call(mutation.removedNodes, function(removedNode) {
                if (removedNode.nodeType === 1) {
                    if (removedNode.hasAttribute('[data-simplebar="init"]')) SimpleBar.instances.has(removedNode) && SimpleBar.instances.get(removedNode).unMount();
                    else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                        SimpleBar.instances.has(el) && SimpleBar.instances.get(el).unMount();
                    });
                }
            });
        });
    };
    SimpleBar.getOptions = getOptions;
    /**
	 * HTML API
	 * Called only in a browser env.
	 */ if (canUseDom) SimpleBar.initHtmlApi();
    return SimpleBar;
});

},{}],"9UxPA":[function(require,module,exports,__globalThis) {
"use strict";
function equalizer() {
    var max = -1;
    // Equalize .height-equal
    $(".height-equal").css("min-height", "auto");
    $(".height-equal").each(function() {
        var minHeight = $(this).outerHeight();
        max = minHeight > max ? minHeight : max;
    });
    $(".height-equal").css("min-height", max);
    if ($(window).width() <= 767) $(".height-equal").css("min-height", "auto");
    // Equalize .height-equal-2
    $(".height-equal-2").css("min-height", "auto");
    $(".height-equal-2").each(function() {
        var minHeight = $(this).outerHeight();
        max = minHeight > max ? minHeight : max;
    });
    $(".height-equal-2").css("min-height", max);
    if ($(window).width() <= 767) $(".height-equal-2").css("min-height", "auto");
}
// Use ResizeObserver for modern browsers
function setupResizeObserver() {
    if (typeof ResizeObserver !== "undefined") {
        const elementsToObserve = document.querySelectorAll(".height-equal, .height-equal-2");
        const observer = new ResizeObserver(()=>{
            equalizer();
        });
        elementsToObserve.forEach((element)=>{
            observer.observe(element);
        });
    } else console.warn("ResizeObserver is not supported in this browser.");
}
// Document Ready
document.addEventListener("DOMContentLoaded", function() {
    (function($1) {
        "use strict";
        // Initial equalizer
        equalizer();
        // Set up ResizeObserver
        setupResizeObserver();
        // Fallback: jQuery resize event
        $1(window).resize(function() {
            equalizer();
        });
    })(jQuery);
});

},{}],"ck5pf":[function(require,module,exports,__globalThis) {
document.addEventListener("DOMContentLoaded", function() {
    var showHideElements = document.querySelectorAll(".show-hide");
    var passwordInput = document.querySelector('input[name="login[password]"]');
    var showHideSpan = document.querySelector(".show-hide span");
    showHideElements.forEach(function(element) {
        element.style.display = "block";
    });
    if (showHideSpan) {
        showHideSpan.classList.add("show");
        showHideSpan.addEventListener("click", function() {
            if (showHideSpan.classList.contains("show")) {
                passwordInput.setAttribute("type", "text");
                showHideSpan.classList.remove("show");
            } else {
                passwordInput.setAttribute("type", "password");
                showHideSpan.classList.add("show");
            }
        });
    }
});

},{}],"s6sMc":[function(require,module,exports,__globalThis) {
/*-----------------------------------------------------------------------------------
 Template Name: Admiro
 Template URI: themes.pixelstrap.com/Admiro
 Description: This is Admin Template
 Author: Pixelstrap
 Author URI: https://themeforest.net/user/pixelstrap
 ----------------------------------------------------------------------------------- */ // 01. Loader js
// 02. Tap to top js
// 03. Header DropDown Toggle js
// 04. Full screen js
document.addEventListener("DOMContentLoaded", function() {
    const body = document.querySelector("body");
    const html = document.querySelector("html");
    /*=====================
        01 Loader Js
    ==========================*/ $(".loader-wrapper").css({
        opacity: 0,
        transition: "opacity 600ms ease"
    });
    setTimeout(()=>{
        $(".loader-wrapper").remove();
    }, 600);
    /*=====================
          02 Tap to top js
      ==========================*/ const button = document.querySelector(".tap-top");
    const displayButton = ()=>{
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > 100) button.style.display = "block";
            else button.style.display = "none";
        });
    };
    const scrollToTop = ()=>{
        button.addEventListener("click", ()=>{
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            console.log(event);
        });
    };
    displayButton();
    scrollToTop();
    /*=====================
        03 Header DropDown Toggle
    ==========================*/ body.addEventListener("click", function(event1) {
        const headerDropdownMenu = document.querySelectorAll(".custom-menu");
        const dropdownEl = event1.target.closest(".custom-dropdown");
        const visible = dropdownEl?.querySelector(".custom-menu").classList.contains("show");
        const dropdownMenuElement = event1.target.closest(".custom-menu");
        if (!dropdownMenuElement) headerDropdownMenu.forEach((item)=>{
            item.classList.remove("show");
        });
        if (!dropdownEl) return;
        const dropdownMenu = dropdownEl.querySelector(".custom-menu");
        if (!visible) dropdownMenu.classList.add("show");
    });
    /*=====================
        04 Full screen js
    ==========================*/ $(document).ready(function() {
        $(".full-screen").click(function(event1) {
            var elem = document.documentElement;
            if (document.fullScreenElement && document.fullScreenElement !== null || !document.mozFullScreen && !document.webkitIsFullScreen) {
                if (elem.requestFullScreen) elem.requestFullScreen();
                else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
                else if (elem.webkitRequestFullScreen) elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            } else {
                if (document.cancelFullScreen) document.cancelFullScreen();
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
                else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
            }
        });
    });
    /*=====================
         05. Dark Mode js
      ==========================*/ $(".dark-mode").on("click", function() {
        const bodyModeDark = $("body").hasClass("dark-only");
        if (!bodyModeDark) {
            // Activate dark mode
            $(".dark-mode").addClass("active");
            localStorage.setItem("mode", "dark-only");
            $("body").addClass("dark-only");
            $("body").removeClass("light");
            // Switch to dark logo
            $(".light-logo").hide();
            $(".dark-logo").show();
        } else {
            // Activate light mode
            $(".dark-mode").removeClass("active");
            localStorage.setItem("mode", "light");
            $("body").removeClass("dark-only");
            $("body").addClass("light");
            // Switch to light logo
            $(".dark-logo").hide();
            $(".light-logo").show();
        }
    });
    // Apply the saved mode and logo when the page loads
    $(document).ready(function() {
        const mode = localStorage.getItem("mode") ? localStorage.getItem("mode") : "light";
        $("body").addClass(mode);
        if (mode === "dark-only") {
            $(".light-logo").hide();
            $(".dark-logo").show();
        } else {
            $(".dark-logo").hide();
            $(".light-logo").show();
        }
    });
    /*=====================
      00. Background Image js
      ==========================*/ $(".bg-center").parent().addClass("b-center");
    $(".bg-img-cover").parent().addClass("bg-size");
    $(".bg-img-cover").each(function() {
        var el = $(this), src = el.attr("src"), parent = el.parent();
        parent.css({
            "background-image": "url(" + src + ")",
            "background-size": "cover",
            "background-position": "center",
            display: "block"
        });
        el.hide();
    });
});

},{}]},["lHxdD"], "lHxdD", "parcelRequire2cb9", {})

//# sourceMappingURL=main.js.map
